/*
 * angular-ui-bootstrap
 * http://angular-ui.github.io/bootstrap/

 * Version: 2.1.3 - 2016-08-25
 * License: MIT
 */angular.module("ui.bootstrap",["ui.bootstrap.tpls","ui.bootstrap.typeahead","ui.bootstrap.debounce","ui.bootstrap.position","ui.bootstrap.modal","ui.bootstrap.stackedMap","ui.bootstrap.datepickerPopup","ui.bootstrap.datepicker","ui.bootstrap.dateparser","ui.bootstrap.isClass","ui.bootstrap.timepicker"]),angular.module("ui.bootstrap.tpls",["uib/template/typeahead/typeahead-match.html","uib/template/typeahead/typeahead-popup.html","uib/template/modal/window.html","uib/template/datepickerPopup/popup.html","uib/template/datepicker/datepicker.html","uib/template/datepicker/day.html","uib/template/datepicker/month.html","uib/template/datepicker/year.html","uib/template/timepicker/timepicker.html"]),angular.module("ui.bootstrap.typeahead",["ui.bootstrap.debounce","ui.bootstrap.position"]).factory("uibTypeaheadParser",["$parse",function(e){var t=/^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;return{parse:function(n){var a=n.match(t);if(!a)throw new Error('Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_" but got "'+n+'".');return{itemName:a[3],source:e(a[4]),viewMapper:e(a[2]||a[1]),modelMapper:e(a[1])}}}}]).controller("UibTypeaheadController",["$scope","$element","$attrs","$compile","$parse","$q","$timeout","$document","$window","$rootScope","$$debounce","$uibPosition","uibTypeaheadParser",function(e,t,n,a,i,r,o,s,l,u,c,p,d){function h(){H.moveInProgress||(H.moveInProgress=!0,H.$digest()),Z()}function f(){H.position=E?p.offset(t):p.position(t),H.position.top+=t.prop("offsetHeight")}var m,g,b=[9,13,27,38,40],v=200,y=e.$eval(n.typeaheadMinLength);y||0===y||(y=1),e.$watch(n.typeaheadMinLength,function(e){y=e||0===e?e:1});var w=e.$eval(n.typeaheadWaitMs)||0,k=e.$eval(n.typeaheadEditable)!==!1;e.$watch(n.typeaheadEditable,function(e){k=e!==!1});var $,D,M=i(n.typeaheadLoading).assign||angular.noop,x=n.typeaheadShouldSelect?i(n.typeaheadShouldSelect):function(e,t){var n=t.$event;return 13===n.which||9===n.which},T=i(n.typeaheadOnSelect),O=angular.isDefined(n.typeaheadSelectOnBlur)?e.$eval(n.typeaheadSelectOnBlur):!1,S=i(n.typeaheadNoResults).assign||angular.noop,C=n.typeaheadInputFormatter?i(n.typeaheadInputFormatter):void 0,E=n.typeaheadAppendToBody?e.$eval(n.typeaheadAppendToBody):!1,F=n.typeaheadAppendTo?e.$eval(n.typeaheadAppendTo):null,I=e.$eval(n.typeaheadFocusFirst)!==!1,A=n.typeaheadSelectOnExact?e.$eval(n.typeaheadSelectOnExact):!1,P=i(n.typeaheadIsOpen).assign||angular.noop,N=e.$eval(n.typeaheadShowHint)||!1,U=i(n.ngModel),Y=i(n.ngModel+"($$$p)"),R=function(t,n){return angular.isFunction(U(e))&&g&&g.$options&&g.$options.getterSetter?Y(t,{$$$p:n}):U.assign(t,n)},z=d.parse(n.uibTypeahead),H=e.$new(),V=e.$on("$destroy",function(){H.$destroy()});H.$on("$destroy",V);var W="typeahead-"+H.$id+"-"+Math.floor(1e4*Math.random());t.attr({"aria-autocomplete":"list","aria-expanded":!1,"aria-owns":W});var q,B;N&&(q=angular.element("<div></div>"),q.css("position","relative"),t.after(q),B=t.clone(),B.attr("placeholder",""),B.attr("tabindex","-1"),B.val(""),B.css({position:"absolute",top:"0px",left:"0px","border-color":"transparent","box-shadow":"none",opacity:1,background:"none 0% 0% / auto repeat scroll padding-box border-box rgb(255, 255, 255)",color:"#999"}),t.css({position:"relative","vertical-align":"top","background-color":"transparent"}),B.attr("id")&&B.removeAttr("id"),q.append(B),B.after(t));var j=angular.element("<div uib-typeahead-popup></div>");j.attr({id:W,matches:"matches",active:"activeIdx",select:"select(activeIdx, evt)","move-in-progress":"moveInProgress",query:"query",position:"position","assign-is-open":"assignIsOpen(isOpen)",debounce:"debounceUpdate"}),angular.isDefined(n.typeaheadTemplateUrl)&&j.attr("template-url",n.typeaheadTemplateUrl),angular.isDefined(n.typeaheadPopupTemplateUrl)&&j.attr("popup-template-url",n.typeaheadPopupTemplateUrl);var _=function(){N&&B.val("")},L=function(){H.matches=[],H.activeIdx=-1,t.attr("aria-expanded",!1),_()},G=function(e){return W+"-option-"+e};H.$watch("activeIdx",function(e){0>e?t.removeAttr("aria-activedescendant"):t.attr("aria-activedescendant",G(e))});var K=function(e,t){return H.matches.length>t&&e?e.toUpperCase()===H.matches[t].label.toUpperCase():!1},X=function(n,a){var i={$viewValue:n};M(e,!0),S(e,!1),r.when(z.source(e,i)).then(function(r){var o=n===m.$viewValue;if(o&&$)if(r&&r.length>0){H.activeIdx=I?0:-1,S(e,!1),H.matches.length=0;for(var s=0;s<r.length;s++)i[z.itemName]=r[s],H.matches.push({id:G(s),label:z.viewMapper(H,i),model:r[s]});if(H.query=n,f(),t.attr("aria-expanded",!0),A&&1===H.matches.length&&K(n,0)&&(angular.isNumber(H.debounceUpdate)||angular.isObject(H.debounceUpdate)?c(function(){H.select(0,a)},angular.isNumber(H.debounceUpdate)?H.debounceUpdate:H.debounceUpdate["default"]):H.select(0,a)),N){var l=H.matches[0].label;B.val(angular.isString(n)&&n.length>0&&l.slice(0,n.length).toUpperCase()===n.toUpperCase()?n+l.slice(n.length):"")}}else L(),S(e,!0);o&&M(e,!1)},function(){L(),M(e,!1),S(e,!0)})};E&&(angular.element(l).on("resize",h),s.find("body").on("scroll",h));var Z=c(function(){H.matches.length&&f(),H.moveInProgress=!1},v);H.moveInProgress=!1,H.query=void 0;var J,Q=function(e){J=o(function(){X(e)},w)},et=function(){J&&o.cancel(J)};L(),H.assignIsOpen=function(t){P(e,t)},H.select=function(a,i){var r,s,l={};D=!0,l[z.itemName]=s=H.matches[a].model,r=z.modelMapper(e,l),R(e,r),m.$setValidity("editable",!0),m.$setValidity("parse",!0),T(e,{$item:s,$model:r,$label:z.viewMapper(e,l),$event:i}),L(),H.$eval(n.typeaheadFocusOnSelect)!==!1&&o(function(){t[0].focus()},0,!1)},t.on("keydown",function(t){if(0!==H.matches.length&&-1!==b.indexOf(t.which)){var n=x(e,{$event:t});if(-1===H.activeIdx&&n||9===t.which&&t.shiftKey)return L(),void H.$digest();t.preventDefault();var a;switch(t.which){case 27:t.stopPropagation(),L(),e.$digest();break;case 38:H.activeIdx=(H.activeIdx>0?H.activeIdx:H.matches.length)-1,H.$digest(),a=j[0].querySelectorAll(".uib-typeahead-match")[H.activeIdx],a.parentNode.scrollTop=a.offsetTop;break;case 40:H.activeIdx=(H.activeIdx+1)%H.matches.length,H.$digest(),a=j[0].querySelectorAll(".uib-typeahead-match")[H.activeIdx],a.parentNode.scrollTop=a.offsetTop;break;default:n&&H.$apply(function(){angular.isNumber(H.debounceUpdate)||angular.isObject(H.debounceUpdate)?c(function(){H.select(H.activeIdx,t)},angular.isNumber(H.debounceUpdate)?H.debounceUpdate:H.debounceUpdate["default"]):H.select(H.activeIdx,t)})}}}),t.bind("focus",function(e){$=!0,0!==y||m.$viewValue||o(function(){X(m.$viewValue,e)},0)}),t.bind("blur",function(e){O&&H.matches.length&&-1!==H.activeIdx&&!D&&(D=!0,H.$apply(function(){angular.isObject(H.debounceUpdate)&&angular.isNumber(H.debounceUpdate.blur)?c(function(){H.select(H.activeIdx,e)},H.debounceUpdate.blur):H.select(H.activeIdx,e)})),!k&&m.$error.editable&&(m.$setViewValue(),H.$apply(function(){m.$setValidity("editable",!0),m.$setValidity("parse",!0)}),t.val("")),$=!1,D=!1});var tt=function(n){t[0]!==n.target&&3!==n.which&&0!==H.matches.length&&(L(),u.$$phase||e.$digest())};s.on("click",tt),e.$on("$destroy",function(){s.off("click",tt),(E||F)&&nt.remove(),E&&(angular.element(l).off("resize",h),s.find("body").off("scroll",h)),j.remove(),N&&q.remove()});var nt=a(j)(H);E?s.find("body").append(nt):F?angular.element(F).eq(0).append(nt):t.after(nt),this.init=function(t,n){m=t,g=n,H.debounceUpdate=m.$options&&i(m.$options.debounce)(e),m.$parsers.unshift(function(t){return $=!0,0===y||t&&t.length>=y?w>0?(et(),Q(t)):X(t):(M(e,!1),et(),L()),k?t:t?void m.$setValidity("editable",!1):(m.$setValidity("editable",!0),null)}),m.$formatters.push(function(t){var n,a,i={};return k||m.$setValidity("editable",!0),C?(i.$model=t,C(e,i)):(i[z.itemName]=t,n=z.viewMapper(e,i),i[z.itemName]=void 0,a=z.viewMapper(e,i),n!==a?n:t)})}}]).directive("uibTypeahead",function(){return{controller:"UibTypeaheadController",require:["ngModel","^?ngModelOptions","uibTypeahead"],link:function(e,t,n,a){a[2].init(a[0],a[1])}}}).directive("uibTypeaheadPopup",["$$debounce",function(e){return{scope:{matches:"=",query:"=",active:"=",position:"&",moveInProgress:"=",select:"&",assignIsOpen:"&",debounce:"&"},replace:!0,templateUrl:function(e,t){return t.popupTemplateUrl||"uib/template/typeahead/typeahead-popup.html"},link:function(t,n,a){t.templateUrl=a.templateUrl,t.isOpen=function(){var e=t.matches.length>0;return t.assignIsOpen({isOpen:e}),e},t.isActive=function(e){return t.active===e},t.selectActive=function(e){t.active=e},t.selectMatch=function(n,a){var i=t.debounce();angular.isNumber(i)||angular.isObject(i)?e(function(){t.select({activeIdx:n,evt:a})},angular.isNumber(i)?i:i["default"]):t.select({activeIdx:n,evt:a})}}}}]).directive("uibTypeaheadMatch",["$templateRequest","$compile","$parse",function(e,t,n){return{scope:{index:"=",match:"=",query:"="},link:function(a,i,r){var o=n(r.templateUrl)(a.$parent)||"uib/template/typeahead/typeahead-match.html";e(o).then(function(e){var n=angular.element(e.trim());i.replaceWith(n),t(n)(a)})}}}]).filter("uibTypeaheadHighlight",["$sce","$injector","$log",function(e,t,n){function a(e){return e.replace(/([.?*+^$[\]\\(){}|-])/g,"\\$1")}function i(e){return/<.*>/g.test(e)}var r;return r=t.has("$sanitize"),function(t,o){return!r&&i(t)&&n.warn("Unsafe use of typeahead please use ngSanitize"),t=o?(""+t).replace(new RegExp(a(o),"gi"),"<strong>$&</strong>"):t,r||(t=e.trustAsHtml(t)),t}}]),angular.module("ui.bootstrap.debounce",[]).factory("$$debounce",["$timeout",function(e){return function(t,n){var a;return function(){var i=this,r=Array.prototype.slice.call(arguments);a&&e.cancel(a),a=e(function(){t.apply(i,r)},n)}}}]),angular.module("ui.bootstrap.position",[]).factory("$uibPosition",["$document","$window",function(e,t){var n,a,i={normal:/(auto|scroll)/,hidden:/(auto|scroll|hidden)/},r={auto:/\s?auto?\s?/i,primary:/^(top|bottom|left|right)$/,secondary:/^(top|bottom|left|right|center)$/,vertical:/^(top|bottom)$/},o=/(HTML|BODY)/;return{getRawNode:function(e){return e.nodeName?e:e[0]||e},parseStyle:function(e){return e=parseFloat(e),isFinite(e)?e:0},offsetParent:function(n){function a(e){return"static"===(t.getComputedStyle(e).position||"static")}n=this.getRawNode(n);for(var i=n.offsetParent||e[0].documentElement;i&&i!==e[0].documentElement&&a(i);)i=i.offsetParent;return i||e[0].documentElement},scrollbarWidth:function(i){if(i){if(angular.isUndefined(a)){var r=e.find("body");r.addClass("uib-position-body-scrollbar-measure"),a=t.innerWidth-r[0].clientWidth,a=isFinite(a)?a:0,r.removeClass("uib-position-body-scrollbar-measure")}return a}if(angular.isUndefined(n)){var o=angular.element('<div class="uib-position-scrollbar-measure"></div>');e.find("body").append(o),n=o[0].offsetWidth-o[0].clientWidth,n=isFinite(n)?n:0,o.remove()}return n},scrollbarPadding:function(e){e=this.getRawNode(e);var n=t.getComputedStyle(e),a=this.parseStyle(n.paddingRight),i=this.parseStyle(n.paddingBottom),r=this.scrollParent(e,!1,!0),s=this.scrollbarWidth(r,o.test(r.tagName));return{scrollbarWidth:s,widthOverflow:r.scrollWidth>r.clientWidth,right:a+s,originalRight:a,heightOverflow:r.scrollHeight>r.clientHeight,bottom:i+s,originalBottom:i}},isScrollable:function(e,n){e=this.getRawNode(e);var a=n?i.hidden:i.normal,r=t.getComputedStyle(e);return a.test(r.overflow+r.overflowY+r.overflowX)},scrollParent:function(n,a,r){n=this.getRawNode(n);var o=a?i.hidden:i.normal,s=e[0].documentElement,l=t.getComputedStyle(n);if(r&&o.test(l.overflow+l.overflowY+l.overflowX))return n;var u="absolute"===l.position,c=n.parentElement||s;if(c===s||"fixed"===l.position)return s;for(;c.parentElement&&c!==s;){var p=t.getComputedStyle(c);if(u&&"static"!==p.position&&(u=!1),!u&&o.test(p.overflow+p.overflowY+p.overflowX))break;c=c.parentElement}return c},position:function(n,a){n=this.getRawNode(n);var i=this.offset(n);if(a){var r=t.getComputedStyle(n);i.top-=this.parseStyle(r.marginTop),i.left-=this.parseStyle(r.marginLeft)}var o=this.offsetParent(n),s={top:0,left:0};return o!==e[0].documentElement&&(s=this.offset(o),s.top+=o.clientTop-o.scrollTop,s.left+=o.clientLeft-o.scrollLeft),{width:Math.round(angular.isNumber(i.width)?i.width:n.offsetWidth),height:Math.round(angular.isNumber(i.height)?i.height:n.offsetHeight),top:Math.round(i.top-s.top),left:Math.round(i.left-s.left)}},offset:function(n){n=this.getRawNode(n);var a=n.getBoundingClientRect();return{width:Math.round(angular.isNumber(a.width)?a.width:n.offsetWidth),height:Math.round(angular.isNumber(a.height)?a.height:n.offsetHeight),top:Math.round(a.top+(t.pageYOffset||e[0].documentElement.scrollTop)),left:Math.round(a.left+(t.pageXOffset||e[0].documentElement.scrollLeft))}},viewportOffset:function(n,a,i){n=this.getRawNode(n),i=i!==!1?!0:!1;var r=n.getBoundingClientRect(),o={top:0,left:0,bottom:0,right:0},s=a?e[0].documentElement:this.scrollParent(n),l=s.getBoundingClientRect();if(o.top=l.top+s.clientTop,o.left=l.left+s.clientLeft,s===e[0].documentElement&&(o.top+=t.pageYOffset,o.left+=t.pageXOffset),o.bottom=o.top+s.clientHeight,o.right=o.left+s.clientWidth,i){var u=t.getComputedStyle(s);o.top+=this.parseStyle(u.paddingTop),o.bottom-=this.parseStyle(u.paddingBottom),o.left+=this.parseStyle(u.paddingLeft),o.right-=this.parseStyle(u.paddingRight)}return{top:Math.round(r.top-o.top),bottom:Math.round(o.bottom-r.bottom),left:Math.round(r.left-o.left),right:Math.round(o.right-r.right)}},parsePlacement:function(e){var t=r.auto.test(e);return t&&(e=e.replace(r.auto,"")),e=e.split("-"),e[0]=e[0]||"top",r.primary.test(e[0])||(e[0]="top"),e[1]=e[1]||"center",r.secondary.test(e[1])||(e[1]="center"),e[2]=t?!0:!1,e},positionElements:function(e,n,a,i){e=this.getRawNode(e),n=this.getRawNode(n);var o=angular.isDefined(n.offsetWidth)?n.offsetWidth:n.prop("offsetWidth"),s=angular.isDefined(n.offsetHeight)?n.offsetHeight:n.prop("offsetHeight");a=this.parsePlacement(a);var l=i?this.offset(e):this.position(e),u={top:0,left:0,placement:""};if(a[2]){var c=this.viewportOffset(e,i),p=t.getComputedStyle(n),d={width:o+Math.round(Math.abs(this.parseStyle(p.marginLeft)+this.parseStyle(p.marginRight))),height:s+Math.round(Math.abs(this.parseStyle(p.marginTop)+this.parseStyle(p.marginBottom)))};if(a[0]="top"===a[0]&&d.height>c.top&&d.height<=c.bottom?"bottom":"bottom"===a[0]&&d.height>c.bottom&&d.height<=c.top?"top":"left"===a[0]&&d.width>c.left&&d.width<=c.right?"right":"right"===a[0]&&d.width>c.right&&d.width<=c.left?"left":a[0],a[1]="top"===a[1]&&d.height-l.height>c.bottom&&d.height-l.height<=c.top?"bottom":"bottom"===a[1]&&d.height-l.height>c.top&&d.height-l.height<=c.bottom?"top":"left"===a[1]&&d.width-l.width>c.right&&d.width-l.width<=c.left?"right":"right"===a[1]&&d.width-l.width>c.left&&d.width-l.width<=c.right?"left":a[1],"center"===a[1])if(r.vertical.test(a[0])){var h=l.width/2-o/2;c.left+h<0&&d.width-l.width<=c.right?a[1]="left":c.right+h<0&&d.width-l.width<=c.left&&(a[1]="right")}else{var f=l.height/2-d.height/2;c.top+f<0&&d.height-l.height<=c.bottom?a[1]="top":c.bottom+f<0&&d.height-l.height<=c.top&&(a[1]="bottom")}}switch(a[0]){case"top":u.top=l.top-s;break;case"bottom":u.top=l.top+l.height;break;case"left":u.left=l.left-o;break;case"right":u.left=l.left+l.width}switch(a[1]){case"top":u.top=l.top;break;case"bottom":u.top=l.top+l.height-s;break;case"left":u.left=l.left;break;case"right":u.left=l.left+l.width-o;break;case"center":r.vertical.test(a[0])?u.left=l.left+l.width/2-o/2:u.top=l.top+l.height/2-s/2}return u.top=Math.round(u.top),u.left=Math.round(u.left),u.placement="center"===a[1]?a[0]:a[0]+"-"+a[1],u},adjustTop:function(e,t,n,a){return-1!==e.indexOf("top")&&n!==a?{top:t.top-a+"px"}:void 0},positionArrow:function(e,n){e=this.getRawNode(e);var a=e.querySelector(".tooltip-inner, .popover-inner");if(a){var i=angular.element(a).hasClass("tooltip-inner"),o=e.querySelector(i?".tooltip-arrow":".arrow");if(o){var s={top:"",bottom:"",left:"",right:""};if(n=this.parsePlacement(n),"center"===n[1])return void angular.element(o).css(s);var l="border-"+n[0]+"-width",u=t.getComputedStyle(o)[l],c="border-";c+=r.vertical.test(n[0])?n[0]+"-"+n[1]:n[1]+"-"+n[0],c+="-radius";var p=t.getComputedStyle(i?a:e)[c];switch(n[0]){case"top":s.bottom=i?"0":"-"+u;break;case"bottom":s.top=i?"0":"-"+u;break;case"left":s.right=i?"0":"-"+u;break;case"right":s.left=i?"0":"-"+u}s[n[1]]=p,angular.element(o).css(s)}}}}}]),angular.module("ui.bootstrap.modal",["ui.bootstrap.stackedMap","ui.bootstrap.position"]).factory("$$multiMap",function(){return{createNew:function(){var e={};return{entries:function(){return Object.keys(e).map(function(t){return{key:t,value:e[t]}})},get:function(t){return e[t]},hasKey:function(t){return!!e[t]},keys:function(){return Object.keys(e)},put:function(t,n){e[t]||(e[t]=[]),e[t].push(n)},remove:function(t,n){var a=e[t];if(a){var i=a.indexOf(n);-1!==i&&a.splice(i,1),a.length||delete e[t]}}}}}}).provider("$uibResolve",function(){var e=this;this.resolver=null,this.setResolver=function(e){this.resolver=e},this.$get=["$injector","$q",function(t,n){var a=e.resolver?t.get(e.resolver):null;return{resolve:function(e,i,r,o){if(a)return a.resolve(e,i,r,o);var s=[];return angular.forEach(e,function(e){s.push(angular.isFunction(e)||angular.isArray(e)?n.resolve(t.invoke(e)):angular.isString(e)?n.resolve(t.get(e)):n.resolve(e))}),n.all(s).then(function(t){var n={},a=0;return angular.forEach(e,function(e,i){n[i]=t[a++]}),n})}}}]}).directive("uibModalBackdrop",["$animate","$injector","$uibModalStack",function(e,t,n){function a(t,a,i){i.modalInClass&&(e.addClass(a,i.modalInClass),t.$on(n.NOW_CLOSING_EVENT,function(n,r){var o=r();t.modalOptions.animation?e.removeClass(a,i.modalInClass).then(o):o()}))}return{restrict:"A",compile:function(e,t){return e.addClass(t.backdropClass),a}}}]).directive("uibModalWindow",["$uibModalStack","$q","$animateCss","$document",function(e,t,n,a){return{scope:{index:"@"},restrict:"A",transclude:!0,templateUrl:function(e,t){return t.templateUrl||"uib/template/modal/window.html"},link:function(i,r,o){r.addClass(o.windowTopClass||""),i.size=o.size,i.close=function(t){var n=e.getTop();n&&n.value.backdrop&&"static"!==n.value.backdrop&&t.target===t.currentTarget&&(t.preventDefault(),t.stopPropagation(),e.dismiss(n.key,"backdrop click"))},r.on("click",i.close),i.$isRendered=!0;var s=t.defer();i.$$postDigest(function(){s.resolve()}),s.promise.then(function(){var s=null;o.modalInClass&&(s=n(r,{addClass:o.modalInClass}).start(),i.$on(e.NOW_CLOSING_EVENT,function(e,t){var a=t();n(r,{removeClass:o.modalInClass}).start().then(a)})),t.when(s).then(function(){var t=e.getTop();if(t&&e.modalRendered(t.key),!a[0].activeElement||!r[0].contains(a[0].activeElement)){var n=r[0].querySelector("[autofocus]");n?n.focus():r[0].focus()}})})}}}]).directive("uibModalAnimationClass",function(){return{compile:function(e,t){t.modalAnimation&&e.addClass(t.uibModalAnimationClass)}}}).directive("uibModalTransclude",["$animate",function(e){return{link:function(t,n,a,i,r){r(t.$parent,function(t){n.empty(),e.enter(t,n)})}}}]).factory("$uibModalStack",["$animate","$animateCss","$document","$compile","$rootScope","$q","$$multiMap","$$stackedMap","$uibPosition",function(e,t,n,a,i,r,o,s,l){function u(e){var t="-";return e.replace(S,function(e,n){return(n?t:"")+e.toLowerCase()})}function c(e){return!!(e.offsetWidth||e.offsetHeight||e.getClientRects().length)}function p(){for(var e=-1,t=$.keys(),n=0;n<t.length;n++)$.get(t[n]).value.backdrop&&(e=n);return e>-1&&x>e&&(e=x),e}function d(e,t){var n=$.get(e).value,a=n.appendTo;$.remove(e),T=$.top(),T&&(x=parseInt(T.value.modalDomEl.attr("index"),10)),m(n.modalDomEl,n.modalScope,function(){var t=n.openedClass||k;D.remove(t,e);var i=D.hasKey(t);a.toggleClass(t,i),!i&&w&&w.heightOverflow&&w.scrollbarWidth&&(a.css(w.originalRight?{paddingRight:w.originalRight+"px"}:{paddingRight:""}),w=null),h(!0)},n.closedDeferred),f(),t&&t.focus?t.focus():a.focus&&a.focus()}function h(e){var t;$.length()>0&&(t=$.top().value,t.modalDomEl.toggleClass(t.windowTopClass||"",e))}function f(){if(v&&-1===p()){var e=y;m(v,y,function(){e=null}),v=void 0,y=void 0}}function m(t,n,a,i){function o(){o.done||(o.done=!0,e.leave(t).then(function(){a&&a(),t.remove(),i&&i.resolve()}),n.$destroy())}var s,l=null,u=function(){return s||(s=r.defer(),l=s.promise),function(){s.resolve()}};return n.$broadcast(M.NOW_CLOSING_EVENT,u),r.when(l).then(o)}function g(e){if(e.isDefaultPrevented())return e;var t=$.top();if(t)switch(e.which){case 27:t.value.keyboard&&(e.preventDefault(),i.$apply(function(){M.dismiss(t.key,"escape key press")}));break;case 9:var n=M.loadFocusElementList(t),a=!1;e.shiftKey?(M.isFocusInFirstItem(e,n)||M.isModalFocused(e,t))&&(a=M.focusLastFocusableElement(n)):M.isFocusInLastItem(e,n)&&(a=M.focusFirstFocusableElement(n)),a&&(e.preventDefault(),e.stopPropagation())}}function b(e,t,n){return!e.value.modalScope.$broadcast("modal.closing",t,n).defaultPrevented}var v,y,w,k="modal-open",$=s.createNew(),D=o.createNew(),M={NOW_CLOSING_EVENT:"modal.stack.now-closing"},x=0,T=null,O="a[href], area[href], input:not([disabled]):not([tabindex='-1']), button:not([disabled]):not([tabindex='-1']),select:not([disabled]):not([tabindex='-1']), textarea:not([disabled]):not([tabindex='-1']), iframe, object, embed, *[tabindex]:not([tabindex='-1']), *[contenteditable=true]",S=/[A-Z]/g;return i.$watch(p,function(e){y&&(y.index=e)}),n.on("keydown",g),i.$on("$destroy",function(){n.off("keydown",g)}),M.open=function(t,r){var o=n[0].activeElement,s=r.openedClass||k;h(!1),T=$.top(),$.add(t,{deferred:r.deferred,renderDeferred:r.renderDeferred,closedDeferred:r.closedDeferred,modalScope:r.scope,backdrop:r.backdrop,keyboard:r.keyboard,openedClass:r.openedClass,windowTopClass:r.windowTopClass,animation:r.animation,appendTo:r.appendTo}),D.put(s,t);var c=r.appendTo,d=p();if(!c.length)throw new Error("appendTo element not found. Make sure that the element passed is in DOM.");d>=0&&!v&&(y=i.$new(!0),y.modalOptions=r,y.index=d,v=angular.element('<div uib-modal-backdrop="modal-backdrop"></div>'),v.attr({"class":"modal-backdrop","ng-style":"{'z-index': 1040 + (index && 1 || 0) + index*10}","uib-modal-animation-class":"fade","modal-in-class":"in"}),r.backdropClass&&v.addClass(r.backdropClass),r.animation&&v.attr("modal-animation","true"),a(v)(y),e.enter(v,c),l.isScrollable(c)&&(w=l.scrollbarPadding(c),w.heightOverflow&&w.scrollbarWidth&&c.css({paddingRight:w.right+"px"})));var f;r.component?(f=document.createElement(u(r.component.name)),f=angular.element(f),f.attr({resolve:"$resolve","modal-instance":"$uibModalInstance",close:"$close($value)",dismiss:"$dismiss($value)"})):f=r.content,x=T?parseInt(T.value.modalDomEl.attr("index"),10)+1:0;var m=angular.element('<div uib-modal-window="modal-window"></div>');m.attr({"class":"modal","template-url":r.windowTemplateUrl,"window-top-class":r.windowTopClass,role:"dialog","aria-labelledby":r.ariaLabelledBy,"aria-describedby":r.ariaDescribedBy,size:r.size,index:x,animate:"animate","ng-style":"{'z-index': 1050 + $$topModalIndex*10, display: 'block'}",tabindex:-1,"uib-modal-animation-class":"fade","modal-in-class":"in"}).append(f),r.windowClass&&m.addClass(r.windowClass),r.animation&&m.attr("modal-animation","true"),c.addClass(s),r.scope&&(r.scope.$$topModalIndex=x),e.enter(a(m)(r.scope),c),$.top().value.modalDomEl=m,$.top().value.modalOpener=o},M.close=function(e,t){var n=$.get(e);return n&&b(n,t,!0)?(n.value.modalScope.$$uibDestructionScheduled=!0,n.value.deferred.resolve(t),d(e,n.value.modalOpener),!0):!n},M.dismiss=function(e,t){var n=$.get(e);return n&&b(n,t,!1)?(n.value.modalScope.$$uibDestructionScheduled=!0,n.value.deferred.reject(t),d(e,n.value.modalOpener),!0):!n},M.dismissAll=function(e){for(var t=this.getTop();t&&this.dismiss(t.key,e);)t=this.getTop()},M.getTop=function(){return $.top()},M.modalRendered=function(e){var t=$.get(e);t&&t.value.renderDeferred.resolve()},M.focusFirstFocusableElement=function(e){return e.length>0?(e[0].focus(),!0):!1},M.focusLastFocusableElement=function(e){return e.length>0?(e[e.length-1].focus(),!0):!1},M.isModalFocused=function(e,t){if(e&&t){var n=t.value.modalDomEl;if(n&&n.length)return(e.target||e.srcElement)===n[0]}return!1},M.isFocusInFirstItem=function(e,t){return t.length>0?(e.target||e.srcElement)===t[0]:!1},M.isFocusInLastItem=function(e,t){return t.length>0?(e.target||e.srcElement)===t[t.length-1]:!1},M.loadFocusElementList=function(e){if(e){var t=e.value.modalDomEl;if(t&&t.length){var n=t[0].querySelectorAll(O);return n?Array.prototype.filter.call(n,function(e){return c(e)}):n}}},M}]).provider("$uibModal",function(){var e={options:{animation:!0,backdrop:!0,keyboard:!0},$get:["$rootScope","$q","$document","$templateRequest","$controller","$uibResolve","$uibModalStack",function(t,n,a,i,r,o,s){function l(e){return e.template?n.when(e.template):i(angular.isFunction(e.templateUrl)?e.templateUrl():e.templateUrl)}var u={},c=null;return u.getPromiseChain=function(){return c},u.open=function(i){function u(){return g}var p=n.defer(),d=n.defer(),h=n.defer(),f=n.defer(),m={result:p.promise,opened:d.promise,closed:h.promise,rendered:f.promise,close:function(e){return s.close(m,e)},dismiss:function(e){return s.dismiss(m,e)}};if(i=angular.extend({},e.options,i),i.resolve=i.resolve||{},i.appendTo=i.appendTo||a.find("body").eq(0),!i.component&&!i.template&&!i.templateUrl)throw new Error("One of component or template or templateUrl options is required.");var g;g=i.component?n.when(o.resolve(i.resolve,{},null,null)):n.all([l(i),o.resolve(i.resolve,{},null,null)]);var b;return b=c=n.all([c]).then(u,u).then(function(e){function n(t,n,a,i){t.$scope=o,t.$scope.$resolve={},a?t.$scope.$uibModalInstance=m:t.$uibModalInstance=m;var r=n?e[1]:e;angular.forEach(r,function(e,n){i&&(t[n]=e),t.$scope.$resolve[n]=e})}var a=i.scope||t,o=a.$new();o.$close=m.close,o.$dismiss=m.dismiss,o.$on("$destroy",function(){o.$$uibDestructionScheduled||o.$dismiss("$uibUnscheduledDestruction")});var l,u,c={scope:o,deferred:p,renderDeferred:f,closedDeferred:h,animation:i.animation,backdrop:i.backdrop,keyboard:i.keyboard,backdropClass:i.backdropClass,windowTopClass:i.windowTopClass,windowClass:i.windowClass,windowTemplateUrl:i.windowTemplateUrl,ariaLabelledBy:i.ariaLabelledBy,ariaDescribedBy:i.ariaDescribedBy,size:i.size,openedClass:i.openedClass,appendTo:i.appendTo},g={},b={};i.component?(n(g,!1,!0,!1),g.name=i.component,c.component=g):i.controller&&(n(b,!0,!1,!0),u=r(i.controller,b,!0,i.controllerAs),i.controllerAs&&i.bindToController&&(l=u.instance,l.$close=o.$close,l.$dismiss=o.$dismiss,angular.extend(l,{$resolve:b.$scope.$resolve},a)),l=u(),angular.isFunction(l.$onInit)&&l.$onInit()),i.component||(c.content=e[0]),s.open(m,c),d.resolve(!0)},function(e){d.reject(e),p.reject(e)})["finally"](function(){c===b&&(c=null)}),m},u}]};return e}),angular.module("ui.bootstrap.stackedMap",[]).factory("$$stackedMap",function(){return{createNew:function(){var e=[];return{add:function(t,n){e.push({key:t,value:n})},get:function(t){for(var n=0;n<e.length;n++)if(t===e[n].key)return e[n]},keys:function(){for(var t=[],n=0;n<e.length;n++)t.push(e[n].key);return t},top:function(){return e[e.length-1]},remove:function(t){for(var n=-1,a=0;a<e.length;a++)if(t===e[a].key){n=a;break}return e.splice(n,1)[0]},removeTop:function(){return e.pop()},length:function(){return e.length}}}}}),angular.module("ui.bootstrap.datepickerPopup",["ui.bootstrap.datepicker","ui.bootstrap.position"]).value("$datepickerPopupLiteralWarning",!0).constant("uibDatepickerPopupConfig",{altInputFormats:[],appendToBody:!1,clearText:"Clear",closeOnDateSelection:!0,closeText:"Done",currentText:"Today",datepickerPopup:"yyyy-MM-dd",datepickerPopupTemplateUrl:"uib/template/datepickerPopup/popup.html",datepickerTemplateUrl:"uib/template/datepicker/datepicker.html",html5Types:{date:"yyyy-MM-dd","datetime-local":"yyyy-MM-ddTHH:mm:ss.sss",month:"yyyy-MM"},onOpenFocus:!0,showButtonBar:!0,placement:"auto bottom-left"}).controller("UibDatepickerPopupController",["$scope","$element","$attrs","$compile","$log","$parse","$window","$document","$rootScope","$uibPosition","dateFilter","uibDateParser","uibDatepickerPopupConfig","$timeout","uibDatepickerConfig","$datepickerPopupLiteralWarning",function(e,t,n,a,i,r,o,s,l,u,c,p,d,h,f,m){function g(t){var n=p.parse(t,$,e.date);if(isNaN(n))for(var a=0;a<P.length;a++)if(n=p.parse(t,P[a],e.date),!isNaN(n))return n;return n}function b(e){if(angular.isNumber(e)&&(e=new Date(e)),!e)return null;if(angular.isDate(e)&&!isNaN(e))return e;if(angular.isString(e)){var t=g(e);if(!isNaN(t))return p.fromTimezone(t,I.timezone)}return F.$options&&F.$options.allowInvalid?e:void 0}function v(e,t){var a=e||t;return n.ngRequired||a?(angular.isNumber(a)&&(a=new Date(a)),a?angular.isDate(a)&&!isNaN(a)?!0:angular.isString(a)?!isNaN(g(a)):!1:!0):!0}function y(n){if(e.isOpen||!e.disabled){var a=A[0],i=t[0].contains(n.target),r=void 0!==a.contains&&a.contains(n.target);!e.isOpen||i||r||e.$apply(function(){e.isOpen=!1})}}function w(n){27===n.which&&e.isOpen?(n.preventDefault(),n.stopPropagation(),e.$apply(function(){e.isOpen=!1}),t[0].focus()):40!==n.which||e.isOpen||(n.preventDefault(),n.stopPropagation(),e.$apply(function(){e.isOpen=!0}))}function k(){if(e.isOpen){var a=angular.element(A[0].querySelector(".uib-datepicker-popup")),i=n.popupPlacement?n.popupPlacement:d.placement,r=u.positionElements(t,a,i,M);a.css({top:r.top+"px",left:r.left+"px"}),a.hasClass("uib-position-measure")&&a.removeClass("uib-position-measure")}}var $,D,M,x,T,O,S,C,E,F,I,A,P,N=!1,U=[];this.init=function(i){if(F=i,I=angular.isObject(i.$options)?i.$options:{timezone:null},D=angular.isDefined(n.closeOnDateSelection)?e.$parent.$eval(n.closeOnDateSelection):d.closeOnDateSelection,M=angular.isDefined(n.datepickerAppendToBody)?e.$parent.$eval(n.datepickerAppendToBody):d.appendToBody,x=angular.isDefined(n.onOpenFocus)?e.$parent.$eval(n.onOpenFocus):d.onOpenFocus,T=angular.isDefined(n.datepickerPopupTemplateUrl)?n.datepickerPopupTemplateUrl:d.datepickerPopupTemplateUrl,O=angular.isDefined(n.datepickerTemplateUrl)?n.datepickerTemplateUrl:d.datepickerTemplateUrl,P=angular.isDefined(n.altInputFormats)?e.$parent.$eval(n.altInputFormats):d.altInputFormats,e.showButtonBar=angular.isDefined(n.showButtonBar)?e.$parent.$eval(n.showButtonBar):d.showButtonBar,d.html5Types[n.type]?($=d.html5Types[n.type],N=!0):($=n.uibDatepickerPopup||d.datepickerPopup,n.$observe("uibDatepickerPopup",function(e){var t=e||d.datepickerPopup;if(t!==$&&($=t,F.$modelValue=null,!$))throw new Error("uibDatepickerPopup must have a date format specified.")})),!$)throw new Error("uibDatepickerPopup must have a date format specified.");if(N&&n.uibDatepickerPopup)throw new Error("HTML5 date input types do not support custom formats.");S=angular.element("<div uib-datepicker-popup-wrap><div uib-datepicker></div></div>"),S.attr({"ng-model":"date","ng-change":"dateSelection(date)","template-url":T}),C=angular.element(S.children()[0]),C.attr("template-url",O),e.datepickerOptions||(e.datepickerOptions={}),N&&"month"===n.type&&(e.datepickerOptions.datepickerMode="month",e.datepickerOptions.minMode="month"),C.attr("datepicker-options","datepickerOptions"),N?F.$formatters.push(function(t){return e.date=p.fromTimezone(t,I.timezone),t}):(F.$$parserName="date",F.$validators.date=v,F.$parsers.unshift(b),F.$formatters.push(function(t){return F.$isEmpty(t)?(e.date=t,t):(angular.isNumber(t)&&(t=new Date(t)),e.date=p.fromTimezone(t,I.timezone),p.filter(e.date,$))})),F.$viewChangeListeners.push(function(){e.date=g(F.$viewValue)}),t.on("keydown",w),A=a(S)(e),S.remove(),M?s.find("body").append(A):t.after(A),e.$on("$destroy",function(){for(e.isOpen===!0&&(l.$$phase||e.$apply(function(){e.isOpen=!1})),A.remove(),t.off("keydown",w),s.off("click",y),E&&E.off("scroll",k),angular.element(o).off("resize",k);U.length;)U.shift()()})},e.getText=function(t){return e[t+"Text"]||d[t+"Text"]},e.isDisabled=function(t){"today"===t&&(t=p.fromTimezone(new Date,I.timezone));var n={};return angular.forEach(["minDate","maxDate"],function(t){e.datepickerOptions[t]?angular.isDate(e.datepickerOptions[t])?n[t]=new Date(e.datepickerOptions[t]):(m&&i.warn("Literal date support has been deprecated, please switch to date object usage"),n[t]=new Date(c(e.datepickerOptions[t],"medium"))):n[t]=null
}),e.datepickerOptions&&n.minDate&&e.compare(t,n.minDate)<0||n.maxDate&&e.compare(t,n.maxDate)>0},e.compare=function(e,t){return new Date(e.getFullYear(),e.getMonth(),e.getDate())-new Date(t.getFullYear(),t.getMonth(),t.getDate())},e.dateSelection=function(n){e.date=n;var a=e.date?p.filter(e.date,$):null;t.val(a),F.$setViewValue(a),D&&(e.isOpen=!1,t[0].focus())},e.keydown=function(n){27===n.which&&(n.stopPropagation(),e.isOpen=!1,t[0].focus())},e.select=function(t,n){if(n.stopPropagation(),"today"===t){var a=new Date;angular.isDate(e.date)?(t=new Date(e.date),t.setFullYear(a.getFullYear(),a.getMonth(),a.getDate())):(t=p.fromTimezone(a,I.timezone),t.setHours(0,0,0,0))}e.dateSelection(t)},e.close=function(n){n.stopPropagation(),e.isOpen=!1,t[0].focus()},e.disabled=angular.isDefined(n.disabled)||!1,n.ngDisabled&&U.push(e.$parent.$watch(r(n.ngDisabled),function(t){e.disabled=t})),e.$watch("isOpen",function(a){a?e.disabled?e.isOpen=!1:h(function(){k(),x&&e.$broadcast("uib:datepicker.focus"),s.on("click",y);var a=n.popupPlacement?n.popupPlacement:d.placement;M||u.parsePlacement(a)[2]?(E=E||angular.element(u.scrollParent(t)),E&&E.on("scroll",k)):E=null,angular.element(o).on("resize",k)},0,!1):(s.off("click",y),E&&E.off("scroll",k),angular.element(o).off("resize",k))}),e.$on("uib:datepicker.mode",function(){h(k,0,!1)})}]).directive("uibDatepickerPopup",function(){return{require:["ngModel","uibDatepickerPopup"],controller:"UibDatepickerPopupController",scope:{datepickerOptions:"=?",isOpen:"=?",currentText:"@",clearText:"@",closeText:"@"},link:function(e,t,n,a){var i=a[0],r=a[1];r.init(i)}}}).directive("uibDatepickerPopupWrap",function(){return{restrict:"A",transclude:!0,templateUrl:function(e,t){return t.templateUrl||"uib/template/datepickerPopup/popup.html"}}}),angular.module("ui.bootstrap.datepicker",["ui.bootstrap.dateparser","ui.bootstrap.isClass"]).value("$datepickerSuppressError",!1).value("$datepickerLiteralWarning",!0).constant("uibDatepickerConfig",{datepickerMode:"day",formatDay:"dd",formatMonth:"MMMM",formatYear:"yyyy",formatDayHeader:"EEE",formatDayTitle:"MMMM yyyy",formatMonthTitle:"yyyy",maxDate:null,maxMode:"year",minDate:null,minMode:"day",monthColumns:3,ngModelOptions:{},shortcutPropagation:!1,showWeeks:!0,yearColumns:5,yearRows:4}).controller("UibDatepickerController",["$scope","$element","$attrs","$parse","$interpolate","$locale","$log","dateFilter","uibDatepickerConfig","$datepickerLiteralWarning","$datepickerSuppressError","uibDateParser",function(e,t,n,a,i,r,o,s,l,u,c,p){function d(t){e.datepickerMode=t,e.datepickerOptions.datepickerMode=t}var h=this,f={$setViewValue:angular.noop},m={},g=[];t.addClass("uib-datepicker"),n.$set("role","application"),e.datepickerOptions||(e.datepickerOptions={}),this.modes=["day","month","year"],["customClass","dateDisabled","datepickerMode","formatDay","formatDayHeader","formatDayTitle","formatMonth","formatMonthTitle","formatYear","maxDate","maxMode","minDate","minMode","monthColumns","showWeeks","shortcutPropagation","startingDay","yearColumns","yearRows"].forEach(function(t){switch(t){case"customClass":case"dateDisabled":e[t]=e.datepickerOptions[t]||angular.noop;break;case"datepickerMode":e.datepickerMode=angular.isDefined(e.datepickerOptions.datepickerMode)?e.datepickerOptions.datepickerMode:l.datepickerMode;break;case"formatDay":case"formatDayHeader":case"formatDayTitle":case"formatMonth":case"formatMonthTitle":case"formatYear":h[t]=angular.isDefined(e.datepickerOptions[t])?i(e.datepickerOptions[t])(e.$parent):l[t];break;case"monthColumns":case"showWeeks":case"shortcutPropagation":case"yearColumns":case"yearRows":h[t]=angular.isDefined(e.datepickerOptions[t])?e.datepickerOptions[t]:l[t];break;case"startingDay":h.startingDay=angular.isDefined(e.datepickerOptions.startingDay)?e.datepickerOptions.startingDay:angular.isNumber(l.startingDay)?l.startingDay:(r.DATETIME_FORMATS.FIRSTDAYOFWEEK+8)%7;break;case"maxDate":case"minDate":e.$watch("datepickerOptions."+t,function(e){e?angular.isDate(e)?h[t]=p.fromTimezone(new Date(e),m.timezone):(u&&o.warn("Literal date support has been deprecated, please switch to date object usage"),h[t]=new Date(s(e,"medium"))):h[t]=l[t]?p.fromTimezone(new Date(l[t]),m.timezone):null,h.refreshView()});break;case"maxMode":case"minMode":e.datepickerOptions[t]?e.$watch(function(){return e.datepickerOptions[t]},function(n){h[t]=e[t]=angular.isDefined(n)?n:e.datepickerOptions[t],("minMode"===t&&h.modes.indexOf(e.datepickerOptions.datepickerMode)<h.modes.indexOf(h[t])||"maxMode"===t&&h.modes.indexOf(e.datepickerOptions.datepickerMode)>h.modes.indexOf(h[t]))&&(e.datepickerMode=h[t],e.datepickerOptions.datepickerMode=h[t])}):h[t]=e[t]=l[t]||null}}),e.uniqueId="datepicker-"+e.$id+"-"+Math.floor(1e4*Math.random()),e.disabled=angular.isDefined(n.disabled)||!1,angular.isDefined(n.ngDisabled)&&g.push(e.$parent.$watch(n.ngDisabled,function(t){e.disabled=t,h.refreshView()})),e.isActive=function(t){return 0===h.compare(t.date,h.activeDate)?(e.activeDateId=t.uid,!0):!1},this.init=function(t){f=t,m=t.$options||e.datepickerOptions.ngModelOptions||l.ngModelOptions,e.datepickerOptions.initDate?(h.activeDate=p.fromTimezone(e.datepickerOptions.initDate,m.timezone)||new Date,e.$watch("datepickerOptions.initDate",function(e){e&&(f.$isEmpty(f.$modelValue)||f.$invalid)&&(h.activeDate=p.fromTimezone(e,m.timezone),h.refreshView())})):h.activeDate=new Date;var n=f.$modelValue?new Date(f.$modelValue):new Date;this.activeDate=isNaN(n)?p.fromTimezone(new Date,m.timezone):p.fromTimezone(n,m.timezone),f.$render=function(){h.render()}},this.render=function(){if(f.$viewValue){var e=new Date(f.$viewValue),t=!isNaN(e);t?this.activeDate=p.fromTimezone(e,m.timezone):c||o.error('Datepicker directive: "ng-model" value must be a Date object')}this.refreshView()},this.refreshView=function(){if(this.element){e.selectedDt=null,this._refreshView(),e.activeDt&&(e.activeDateId=e.activeDt.uid);var t=f.$viewValue?new Date(f.$viewValue):null;t=p.fromTimezone(t,m.timezone),f.$setValidity("dateDisabled",!t||this.element&&!this.isDisabled(t))}},this.createDateObject=function(t,n){var a=f.$viewValue?new Date(f.$viewValue):null;a=p.fromTimezone(a,m.timezone);var i=new Date;i=p.fromTimezone(i,m.timezone);var r=this.compare(t,i),o={date:t,label:p.filter(t,n),selected:a&&0===this.compare(t,a),disabled:this.isDisabled(t),past:0>r,current:0===r,future:r>0,customClass:this.customClass(t)||null};return a&&0===this.compare(t,a)&&(e.selectedDt=o),h.activeDate&&0===this.compare(o.date,h.activeDate)&&(e.activeDt=o),o},this.isDisabled=function(t){return e.disabled||this.minDate&&this.compare(t,this.minDate)<0||this.maxDate&&this.compare(t,this.maxDate)>0||e.dateDisabled&&e.dateDisabled({date:t,mode:e.datepickerMode})},this.customClass=function(t){return e.customClass({date:t,mode:e.datepickerMode})},this.split=function(e,t){for(var n=[];e.length>0;)n.push(e.splice(0,t));return n},e.select=function(t){if(e.datepickerMode===h.minMode){var n=f.$viewValue?p.fromTimezone(new Date(f.$viewValue),m.timezone):new Date(0,0,0,0,0,0,0);n.setFullYear(t.getFullYear(),t.getMonth(),t.getDate()),n=p.toTimezone(n,m.timezone),f.$setViewValue(n),f.$render()}else h.activeDate=t,d(h.modes[h.modes.indexOf(e.datepickerMode)-1]),e.$emit("uib:datepicker.mode");e.$broadcast("uib:datepicker.focus")},e.move=function(e){var t=h.activeDate.getFullYear()+e*(h.step.years||0),n=h.activeDate.getMonth()+e*(h.step.months||0);h.activeDate.setFullYear(t,n,1),h.refreshView()},e.toggleMode=function(t){t=t||1,e.datepickerMode===h.maxMode&&1===t||e.datepickerMode===h.minMode&&-1===t||(d(h.modes[h.modes.indexOf(e.datepickerMode)+t]),e.$emit("uib:datepicker.mode"))},e.keys={13:"enter",32:"space",33:"pageup",34:"pagedown",35:"end",36:"home",37:"left",38:"up",39:"right",40:"down"};var b=function(){h.element[0].focus()};e.$on("uib:datepicker.focus",b),e.keydown=function(t){var n=e.keys[t.which];if(n&&!t.shiftKey&&!t.altKey&&!e.disabled)if(t.preventDefault(),h.shortcutPropagation||t.stopPropagation(),"enter"===n||"space"===n){if(h.isDisabled(h.activeDate))return;e.select(h.activeDate)}else!t.ctrlKey||"up"!==n&&"down"!==n?(h.handleKeyDown(n,t),h.refreshView()):e.toggleMode("up"===n?1:-1)},t.on("keydown",function(t){e.$apply(function(){e.keydown(t)})}),e.$on("$destroy",function(){for(;g.length;)g.shift()()})}]).controller("UibDaypickerController",["$scope","$element","dateFilter",function(e,t,n){function a(e,t){return 1!==t||e%4!==0||e%100===0&&e%400!==0?r[t]:29}function i(e){var t=new Date(e);t.setDate(t.getDate()+4-(t.getDay()||7));var n=t.getTime();return t.setMonth(0),t.setDate(1),Math.floor(Math.round((n-t)/864e5)/7)+1}var r=[31,28,31,30,31,30,31,31,30,31,30,31];this.step={months:1},this.element=t,this.init=function(t){angular.extend(t,this),e.showWeeks=t.showWeeks,t.refreshView()},this.getDates=function(e,t){for(var n,a=new Array(t),i=new Date(e),r=0;t>r;)n=new Date(i),a[r++]=n,i.setDate(i.getDate()+1);return a},this._refreshView=function(){var t=this.activeDate.getFullYear(),a=this.activeDate.getMonth(),r=new Date(this.activeDate);r.setFullYear(t,a,1);var o=this.startingDay-r.getDay(),s=o>0?7-o:-o,l=new Date(r);s>0&&l.setDate(-s+1);for(var u=this.getDates(l,42),c=0;42>c;c++)u[c]=angular.extend(this.createDateObject(u[c],this.formatDay),{secondary:u[c].getMonth()!==a,uid:e.uniqueId+"-"+c});e.labels=new Array(7);for(var p=0;7>p;p++)e.labels[p]={abbr:n(u[p].date,this.formatDayHeader),full:n(u[p].date,"EEEE")};if(e.title=n(this.activeDate,this.formatDayTitle),e.rows=this.split(u,7),e.showWeeks){e.weekNumbers=[];for(var d=(11-this.startingDay)%7,h=e.rows.length,f=0;h>f;f++)e.weekNumbers.push(i(e.rows[f][d].date))}},this.compare=function(e,t){var n=new Date(e.getFullYear(),e.getMonth(),e.getDate()),a=new Date(t.getFullYear(),t.getMonth(),t.getDate());return n.setFullYear(e.getFullYear()),a.setFullYear(t.getFullYear()),n-a},this.handleKeyDown=function(e){var t=this.activeDate.getDate();if("left"===e)t-=1;else if("up"===e)t-=7;else if("right"===e)t+=1;else if("down"===e)t+=7;else if("pageup"===e||"pagedown"===e){var n=this.activeDate.getMonth()+("pageup"===e?-1:1);this.activeDate.setMonth(n,1),t=Math.min(a(this.activeDate.getFullYear(),this.activeDate.getMonth()),t)}else"home"===e?t=1:"end"===e&&(t=a(this.activeDate.getFullYear(),this.activeDate.getMonth()));this.activeDate.setDate(t)}}]).controller("UibMonthpickerController",["$scope","$element","dateFilter",function(e,t,n){this.step={years:1},this.element=t,this.init=function(e){angular.extend(e,this),e.refreshView()},this._refreshView=function(){for(var t,a=new Array(12),i=this.activeDate.getFullYear(),r=0;12>r;r++)t=new Date(this.activeDate),t.setFullYear(i,r,1),a[r]=angular.extend(this.createDateObject(t,this.formatMonth),{uid:e.uniqueId+"-"+r});e.title=n(this.activeDate,this.formatMonthTitle),e.rows=this.split(a,this.monthColumns),e.yearHeaderColspan=this.monthColumns>3?this.monthColumns-2:1},this.compare=function(e,t){var n=new Date(e.getFullYear(),e.getMonth()),a=new Date(t.getFullYear(),t.getMonth());return n.setFullYear(e.getFullYear()),a.setFullYear(t.getFullYear()),n-a},this.handleKeyDown=function(e){var t=this.activeDate.getMonth();if("left"===e)t-=1;else if("up"===e)t-=this.monthColumns;else if("right"===e)t+=1;else if("down"===e)t+=this.monthColumns;else if("pageup"===e||"pagedown"===e){var n=this.activeDate.getFullYear()+("pageup"===e?-1:1);this.activeDate.setFullYear(n)}else"home"===e?t=0:"end"===e&&(t=11);this.activeDate.setMonth(t)}}]).controller("UibYearpickerController",["$scope","$element","dateFilter",function(e,t){function n(e){return parseInt((e-1)/i,10)*i+1}var a,i;this.element=t,this.yearpickerInit=function(){a=this.yearColumns,i=this.yearRows*a,this.step={years:i}},this._refreshView=function(){for(var t,r=new Array(i),o=0,s=n(this.activeDate.getFullYear());i>o;o++)t=new Date(this.activeDate),t.setFullYear(s+o,0,1),r[o]=angular.extend(this.createDateObject(t,this.formatYear),{uid:e.uniqueId+"-"+o});e.title=[r[0].label,r[i-1].label].join(" - "),e.rows=this.split(r,a),e.columns=a},this.compare=function(e,t){return e.getFullYear()-t.getFullYear()},this.handleKeyDown=function(e){var t=this.activeDate.getFullYear();"left"===e?t-=1:"up"===e?t-=a:"right"===e?t+=1:"down"===e?t+=a:"pageup"===e||"pagedown"===e?t+=("pageup"===e?-1:1)*i:"home"===e?t=n(this.activeDate.getFullYear()):"end"===e&&(t=n(this.activeDate.getFullYear())+i-1),this.activeDate.setFullYear(t)}}]).directive("uibDatepicker",function(){return{templateUrl:function(e,t){return t.templateUrl||"uib/template/datepicker/datepicker.html"},scope:{datepickerOptions:"=?"},require:["uibDatepicker","^ngModel"],restrict:"A",controller:"UibDatepickerController",controllerAs:"datepicker",link:function(e,t,n,a){var i=a[0],r=a[1];i.init(r)}}}).directive("uibDaypicker",function(){return{templateUrl:function(e,t){return t.templateUrl||"uib/template/datepicker/day.html"},require:["^uibDatepicker","uibDaypicker"],restrict:"A",controller:"UibDaypickerController",link:function(e,t,n,a){var i=a[0],r=a[1];r.init(i)}}}).directive("uibMonthpicker",function(){return{templateUrl:function(e,t){return t.templateUrl||"uib/template/datepicker/month.html"},require:["^uibDatepicker","uibMonthpicker"],restrict:"A",controller:"UibMonthpickerController",link:function(e,t,n,a){var i=a[0],r=a[1];r.init(i)}}}).directive("uibYearpicker",function(){return{templateUrl:function(e,t){return t.templateUrl||"uib/template/datepicker/year.html"},require:["^uibDatepicker","uibYearpicker"],restrict:"A",controller:"UibYearpickerController",link:function(e,t,n,a){var i=a[0];angular.extend(i,a[1]),i.yearpickerInit(),i.refreshView()}}}),angular.module("ui.bootstrap.dateparser",[]).service("uibDateParser",["$log","$locale","dateFilter","orderByFilter",function(e,t,n,a){function i(e){var t=[],n=e.split(""),i=e.indexOf("'");if(i>-1){var r=!1;e=e.split("");for(var o=i;o<e.length;o++)r?("'"===e[o]&&(o+1<e.length&&"'"===e[o+1]?(e[o+1]="$",n[o+1]=""):(n[o]="",r=!1)),e[o]="$"):"'"===e[o]&&(e[o]="$",n[o]="",r=!0);e=e.join("")}return angular.forEach(g,function(a){var i=e.indexOf(a.key);if(i>-1){e=e.split(""),n[i]="("+a.regex+")",e[i]="$";for(var r=i+1,o=i+a.key.length;o>r;r++)n[r]="",e[r]="$";e=e.join(""),t.push({index:i,key:a.key,apply:a.apply,matcher:a.regex})}}),{regex:new RegExp("^"+n.join("")+"$"),map:a(t,"index")}}function r(e){for(var t,n,a=[],i=0;i<e.length;)if(angular.isNumber(n)){if("'"===e.charAt(i))(i+1>=e.length||"'"!==e.charAt(i+1))&&(a.push(o(e,n,i)),n=null);else if(i===e.length)for(;n<e.length;)t=s(e,n),a.push(t),n=t.endIdx;i++}else"'"!==e.charAt(i)?(t=s(e,i),a.push(t.parser),i=t.endIdx):(n=i,i++);return a}function o(e,t,n){return function(){return e.substr(t+1,n-t-1)}}function s(e,t){for(var n=e.substr(t),a=0;a<g.length;a++)if(new RegExp("^"+g[a].key).test(n)){var i=g[a];return{endIdx:t+i.key.length,parser:i.formatter}}return{endIdx:t+1,parser:function(){return n.charAt(0)}}}function l(e,t,n){return 1>n?!1:1===t&&n>28?29===n&&(e%4===0&&e%100!==0||e%400===0):3===t||5===t||8===t||10===t?31>n:!0}function u(e){return parseInt(e,10)}function c(e,t){return e&&t?f(e,t):e}function p(e,t){return e&&t?f(e,t,!0):e}function d(e,t){e=e.replace(/:/g,"");var n=Date.parse("Jan 01, 1970 00:00:00 "+e)/6e4;return isNaN(n)?t:n}function h(e,t){return e=new Date(e.getTime()),e.setMinutes(e.getMinutes()+t),e}function f(e,t,n){n=n?-1:1;var a=e.getTimezoneOffset(),i=d(t,a);return h(e,n*(i-a))}var m,g,b=/[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;this.init=function(){m=t.id,this.parsers={},this.formatters={},g=[{key:"yyyy",regex:"\\d{4}",apply:function(e){this.year=+e},formatter:function(e){var t=new Date;return t.setFullYear(Math.abs(e.getFullYear())),n(t,"yyyy")}},{key:"yy",regex:"\\d{2}",apply:function(e){e=+e,this.year=69>e?e+2e3:e+1900},formatter:function(e){var t=new Date;return t.setFullYear(Math.abs(e.getFullYear())),n(t,"yy")}},{key:"y",regex:"\\d{1,4}",apply:function(e){this.year=+e},formatter:function(e){var t=new Date;return t.setFullYear(Math.abs(e.getFullYear())),n(t,"y")}},{key:"M!",regex:"0?[1-9]|1[0-2]",apply:function(e){this.month=e-1},formatter:function(e){var t=e.getMonth();return/^[0-9]$/.test(t)?n(e,"MM"):n(e,"M")}},{key:"MMMM",regex:t.DATETIME_FORMATS.MONTH.join("|"),apply:function(e){this.month=t.DATETIME_FORMATS.MONTH.indexOf(e)},formatter:function(e){return n(e,"MMMM")}},{key:"MMM",regex:t.DATETIME_FORMATS.SHORTMONTH.join("|"),apply:function(e){this.month=t.DATETIME_FORMATS.SHORTMONTH.indexOf(e)},formatter:function(e){return n(e,"MMM")}},{key:"MM",regex:"0[1-9]|1[0-2]",apply:function(e){this.month=e-1},formatter:function(e){return n(e,"MM")}},{key:"M",regex:"[1-9]|1[0-2]",apply:function(e){this.month=e-1},formatter:function(e){return n(e,"M")}},{key:"d!",regex:"[0-2]?[0-9]{1}|3[0-1]{1}",apply:function(e){this.date=+e},formatter:function(e){var t=e.getDate();return/^[1-9]$/.test(t)?n(e,"dd"):n(e,"d")}},{key:"dd",regex:"[0-2][0-9]{1}|3[0-1]{1}",apply:function(e){this.date=+e},formatter:function(e){return n(e,"dd")}},{key:"d",regex:"[1-2]?[0-9]{1}|3[0-1]{1}",apply:function(e){this.date=+e},formatter:function(e){return n(e,"d")}},{key:"EEEE",regex:t.DATETIME_FORMATS.DAY.join("|"),formatter:function(e){return n(e,"EEEE")}},{key:"EEE",regex:t.DATETIME_FORMATS.SHORTDAY.join("|"),formatter:function(e){return n(e,"EEE")}},{key:"HH",regex:"(?:0|1)[0-9]|2[0-3]",apply:function(e){this.hours=+e},formatter:function(e){return n(e,"HH")}},{key:"hh",regex:"0[0-9]|1[0-2]",apply:function(e){this.hours=+e},formatter:function(e){return n(e,"hh")}},{key:"H",regex:"1?[0-9]|2[0-3]",apply:function(e){this.hours=+e},formatter:function(e){return n(e,"H")}},{key:"h",regex:"[0-9]|1[0-2]",apply:function(e){this.hours=+e},formatter:function(e){return n(e,"h")}},{key:"mm",regex:"[0-5][0-9]",apply:function(e){this.minutes=+e},formatter:function(e){return n(e,"mm")}},{key:"m",regex:"[0-9]|[1-5][0-9]",apply:function(e){this.minutes=+e},formatter:function(e){return n(e,"m")}},{key:"sss",regex:"[0-9][0-9][0-9]",apply:function(e){this.milliseconds=+e},formatter:function(e){return n(e,"sss")}},{key:"ss",regex:"[0-5][0-9]",apply:function(e){this.seconds=+e},formatter:function(e){return n(e,"ss")}},{key:"s",regex:"[0-9]|[1-5][0-9]",apply:function(e){this.seconds=+e},formatter:function(e){return n(e,"s")}},{key:"a",regex:t.DATETIME_FORMATS.AMPMS.join("|"),apply:function(e){12===this.hours&&(this.hours=0),"PM"===e&&(this.hours+=12)},formatter:function(e){return n(e,"a")}},{key:"Z",regex:"[+-]\\d{4}",apply:function(e){var t=e.match(/([+-])(\d{2})(\d{2})/),n=t[1],a=t[2],i=t[3];this.hours+=u(n+a),this.minutes+=u(n+i)},formatter:function(e){return n(e,"Z")}},{key:"ww",regex:"[0-4][0-9]|5[0-3]",formatter:function(e){return n(e,"ww")}},{key:"w",regex:"[0-9]|[1-4][0-9]|5[0-3]",formatter:function(e){return n(e,"w")}},{key:"GGGG",regex:t.DATETIME_FORMATS.ERANAMES.join("|").replace(/\s/g,"\\s"),formatter:function(e){return n(e,"GGGG")}},{key:"GGG",regex:t.DATETIME_FORMATS.ERAS.join("|"),formatter:function(e){return n(e,"GGG")}},{key:"GG",regex:t.DATETIME_FORMATS.ERAS.join("|"),formatter:function(e){return n(e,"GG")}},{key:"G",regex:t.DATETIME_FORMATS.ERAS.join("|"),formatter:function(e){return n(e,"G")}}]},this.init(),this.filter=function(e,n){if(!angular.isDate(e)||isNaN(e)||!n)return"";n=t.DATETIME_FORMATS[n]||n,t.id!==m&&this.init(),this.formatters[n]||(this.formatters[n]=r(n));var a=this.formatters[n];return a.reduce(function(t,n){return t+n(e)},"")},this.parse=function(n,a,r){if(!angular.isString(n)||!a)return n;a=t.DATETIME_FORMATS[a]||a,a=a.replace(b,"\\$&"),t.id!==m&&this.init(),this.parsers[a]||(this.parsers[a]=i(a,"apply"));var o=this.parsers[a],s=o.regex,u=o.map,c=n.match(s),p=!1;if(c&&c.length){var d,h;angular.isDate(r)&&!isNaN(r.getTime())?d={year:r.getFullYear(),month:r.getMonth(),date:r.getDate(),hours:r.getHours(),minutes:r.getMinutes(),seconds:r.getSeconds(),milliseconds:r.getMilliseconds()}:(r&&e.warn("dateparser:","baseDate is not a valid date"),d={year:1900,month:0,date:1,hours:0,minutes:0,seconds:0,milliseconds:0});for(var f=1,g=c.length;g>f;f++){var v=u[f-1];"Z"===v.matcher&&(p=!0),v.apply&&v.apply.call(d,c[f])}var y=p?Date.prototype.setUTCFullYear:Date.prototype.setFullYear,w=p?Date.prototype.setUTCHours:Date.prototype.setHours;return l(d.year,d.month,d.date)&&(!angular.isDate(r)||isNaN(r.getTime())||p?(h=new Date(0),y.call(h,d.year,d.month,d.date),w.call(h,d.hours||0,d.minutes||0,d.seconds||0,d.milliseconds||0)):(h=new Date(r),y.call(h,d.year,d.month,d.date),w.call(h,d.hours,d.minutes,d.seconds,d.milliseconds))),h}},this.toTimezone=c,this.fromTimezone=p,this.timezoneToOffset=d,this.addDateMinutes=h,this.convertTimezoneToLocal=f}]),angular.module("ui.bootstrap.isClass",[]).directive("uibIsClass",["$animate",function(e){var t=/^\s*([\s\S]+?)\s+on\s+([\s\S]+?)\s*$/,n=/^\s*([\s\S]+?)\s+for\s+([\s\S]+?)\s*$/;return{restrict:"A",compile:function(a,i){function r(e,t){l.push(e),u.push({scope:e,element:t}),f.forEach(function(t){o(t,e)}),e.$on("$destroy",s)}function o(t,a){var i=t.match(n),r=a.$eval(i[1]),o=i[2],s=c[t];if(!s){var l=function(t){var n=null;u.some(function(e){var a=e.scope.$eval(d);return a===t?(n=e,!0):void 0}),s.lastActivated!==n&&(s.lastActivated&&e.removeClass(s.lastActivated.element,r),n&&e.addClass(n.element,r),s.lastActivated=n)};c[t]=s={lastActivated:null,scope:a,watchFn:l,compareWithExp:o,watcher:a.$watch(o,l)}}s.watchFn(a.$eval(o))}function s(e){var t=e.targetScope,n=l.indexOf(t);if(l.splice(n,1),u.splice(n,1),l.length){var a=l[0];angular.forEach(c,function(e){e.scope===t&&(e.watcher=a.$watch(e.compareWithExp,e.watchFn),e.scope=a)})}else c={}}var l=[],u=[],c={},p=i.uibIsClass.match(t),d=p[2],h=p[1],f=h.split(",");return r}}}]),angular.module("ui.bootstrap.timepicker",[]).constant("uibTimepickerConfig",{hourStep:1,minuteStep:1,secondStep:1,showMeridian:!0,showSeconds:!1,meridians:null,readonlyInput:!1,mousewheel:!0,arrowkeys:!0,showSpinners:!0,templateUrl:"uib/template/timepicker/timepicker.html"}).controller("UibTimepickerController",["$scope","$element","$attrs","$parse","$log","$locale","uibTimepickerConfig",function(e,t,n,a,i,r,o){function s(){var t=+e.hours,n=e.showMeridian?t>0&&13>t:t>=0&&24>t;return n&&""!==e.hours?(e.showMeridian&&(12===t&&(t=0),e.meridian===k[1]&&(t+=12)),t):void 0}function l(){var t=+e.minutes,n=t>=0&&60>t;return n&&""!==e.minutes?t:void 0}function u(){var t=+e.seconds;return t>=0&&60>t?t:void 0}function c(e,t){return null===e?"":angular.isDefined(e)&&e.toString().length<2&&!t?"0"+e:e.toString()}function p(e){d(),w.$setViewValue(new Date(v)),h(e)}function d(){w.$setValidity("time",!0),e.invalidHours=!1,e.invalidMinutes=!1,e.invalidSeconds=!1}function h(t){if(w.$modelValue){var n=v.getHours(),a=v.getMinutes(),i=v.getSeconds();e.showMeridian&&(n=0===n||12===n?12:n%12),e.hours="h"===t?n:c(n,!$),"m"!==t&&(e.minutes=c(a)),e.meridian=v.getHours()<12?k[0]:k[1],"s"!==t&&(e.seconds=c(i)),e.meridian=v.getHours()<12?k[0]:k[1]}else e.hours=null,e.minutes=null,e.seconds=null,e.meridian=k[0]}function f(e){v=g(v,e),p()}function m(e,t){return g(e,60*t)}function g(e,t){var n=new Date(e.getTime()+1e3*t),a=new Date(e);return a.setHours(n.getHours(),n.getMinutes(),n.getSeconds()),a}function b(){return!(null!==e.hours&&""!==e.hours||null!==e.minutes&&""!==e.minutes||e.showSeconds&&(!e.showSeconds||null!==e.seconds&&""!==e.seconds))}var v=new Date,y=[],w={$setViewValue:angular.noop},k=angular.isDefined(n.meridians)?e.$parent.$eval(n.meridians):o.meridians||r.DATETIME_FORMATS.AMPMS,$=angular.isDefined(n.padHours)?e.$parent.$eval(n.padHours):!0;e.tabindex=angular.isDefined(n.tabindex)?n.tabindex:0,t.removeAttr("tabindex"),this.init=function(t,a){w=t,w.$render=this.render,w.$formatters.unshift(function(e){return e?new Date(e):null});var i=a.eq(0),r=a.eq(1),s=a.eq(2),l=angular.isDefined(n.mousewheel)?e.$parent.$eval(n.mousewheel):o.mousewheel;l&&this.setupMousewheelEvents(i,r,s);var u=angular.isDefined(n.arrowkeys)?e.$parent.$eval(n.arrowkeys):o.arrowkeys;u&&this.setupArrowkeyEvents(i,r,s),e.readonlyInput=angular.isDefined(n.readonlyInput)?e.$parent.$eval(n.readonlyInput):o.readonlyInput,this.setupInputEvents(i,r,s)};var D=o.hourStep;n.hourStep&&y.push(e.$parent.$watch(a(n.hourStep),function(e){D=+e}));var M=o.minuteStep;n.minuteStep&&y.push(e.$parent.$watch(a(n.minuteStep),function(e){M=+e}));var x;y.push(e.$parent.$watch(a(n.min),function(e){var t=new Date(e);x=isNaN(t)?void 0:t}));var T;y.push(e.$parent.$watch(a(n.max),function(e){var t=new Date(e);T=isNaN(t)?void 0:t}));var O=!1;n.ngDisabled&&y.push(e.$parent.$watch(a(n.ngDisabled),function(e){O=e})),e.noIncrementHours=function(){var e=m(v,60*D);return O||e>T||v>e&&x>e},e.noDecrementHours=function(){var e=m(v,60*-D);return O||x>e||e>v&&e>T},e.noIncrementMinutes=function(){var e=m(v,M);return O||e>T||v>e&&x>e},e.noDecrementMinutes=function(){var e=m(v,-M);return O||x>e||e>v&&e>T},e.noIncrementSeconds=function(){var e=g(v,S);return O||e>T||v>e&&x>e},e.noDecrementSeconds=function(){var e=g(v,-S);return O||x>e||e>v&&e>T},e.noToggleMeridian=function(){return v.getHours()<12?O||m(v,720)>T:O||m(v,-720)<x};var S=o.secondStep;n.secondStep&&y.push(e.$parent.$watch(a(n.secondStep),function(e){S=+e})),e.showSeconds=o.showSeconds,n.showSeconds&&y.push(e.$parent.$watch(a(n.showSeconds),function(t){e.showSeconds=!!t})),e.showMeridian=o.showMeridian,n.showMeridian&&y.push(e.$parent.$watch(a(n.showMeridian),function(t){if(e.showMeridian=!!t,w.$error.time){var n=s(),a=l();angular.isDefined(n)&&angular.isDefined(a)&&(v.setHours(n),p())}else h()})),this.setupMousewheelEvents=function(t,n,a){var i=function(e){e.originalEvent&&(e=e.originalEvent);var t=e.wheelDelta?e.wheelDelta:-e.deltaY;return e.detail||t>0};t.bind("mousewheel wheel",function(t){O||e.$apply(i(t)?e.incrementHours():e.decrementHours()),t.preventDefault()}),n.bind("mousewheel wheel",function(t){O||e.$apply(i(t)?e.incrementMinutes():e.decrementMinutes()),t.preventDefault()}),a.bind("mousewheel wheel",function(t){O||e.$apply(i(t)?e.incrementSeconds():e.decrementSeconds()),t.preventDefault()})},this.setupArrowkeyEvents=function(t,n,a){t.bind("keydown",function(t){O||(38===t.which?(t.preventDefault(),e.incrementHours(),e.$apply()):40===t.which&&(t.preventDefault(),e.decrementHours(),e.$apply()))}),n.bind("keydown",function(t){O||(38===t.which?(t.preventDefault(),e.incrementMinutes(),e.$apply()):40===t.which&&(t.preventDefault(),e.decrementMinutes(),e.$apply()))}),a.bind("keydown",function(t){O||(38===t.which?(t.preventDefault(),e.incrementSeconds(),e.$apply()):40===t.which&&(t.preventDefault(),e.decrementSeconds(),e.$apply()))})},this.setupInputEvents=function(t,n,a){if(e.readonlyInput)return e.updateHours=angular.noop,e.updateMinutes=angular.noop,void(e.updateSeconds=angular.noop);var i=function(t,n,a){w.$setViewValue(null),w.$setValidity("time",!1),angular.isDefined(t)&&(e.invalidHours=t),angular.isDefined(n)&&(e.invalidMinutes=n),angular.isDefined(a)&&(e.invalidSeconds=a)};e.updateHours=function(){var e=s(),t=l();w.$setDirty(),angular.isDefined(e)&&angular.isDefined(t)?(v.setHours(e),v.setMinutes(t),x>v||v>T?i(!0):p("h")):i(!0)},t.bind("blur",function(){w.$setTouched(),b()?d():null===e.hours||""===e.hours?i(!0):!e.invalidHours&&e.hours<10&&e.$apply(function(){e.hours=c(e.hours,!$)})}),e.updateMinutes=function(){var e=l(),t=s();w.$setDirty(),angular.isDefined(e)&&angular.isDefined(t)?(v.setHours(t),v.setMinutes(e),x>v||v>T?i(void 0,!0):p("m")):i(void 0,!0)},n.bind("blur",function(){w.$setTouched(),b()?d():null===e.minutes?i(void 0,!0):!e.invalidMinutes&&e.minutes<10&&e.$apply(function(){e.minutes=c(e.minutes)})}),e.updateSeconds=function(){var e=u();w.$setDirty(),angular.isDefined(e)?(v.setSeconds(e),p("s")):i(void 0,void 0,!0)},a.bind("blur",function(){b()?d():!e.invalidSeconds&&e.seconds<10&&e.$apply(function(){e.seconds=c(e.seconds)})})},this.render=function(){var t=w.$viewValue;isNaN(t)?(w.$setValidity("time",!1),i.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.')):(t&&(v=t),x>v||v>T?(w.$setValidity("time",!1),e.invalidHours=!0,e.invalidMinutes=!0):d(),h())},e.showSpinners=angular.isDefined(n.showSpinners)?e.$parent.$eval(n.showSpinners):o.showSpinners,e.incrementHours=function(){e.noIncrementHours()||f(60*D*60)},e.decrementHours=function(){e.noDecrementHours()||f(60*-D*60)},e.incrementMinutes=function(){e.noIncrementMinutes()||f(60*M)},e.decrementMinutes=function(){e.noDecrementMinutes()||f(60*-M)},e.incrementSeconds=function(){e.noIncrementSeconds()||f(S)},e.decrementSeconds=function(){e.noDecrementSeconds()||f(-S)},e.toggleMeridian=function(){var t=l(),n=s();e.noToggleMeridian()||(angular.isDefined(t)&&angular.isDefined(n)?f(720*(v.getHours()<12?60:-60)):e.meridian=e.meridian===k[0]?k[1]:k[0])},e.blur=function(){w.$setTouched()},e.$on("$destroy",function(){for(;y.length;)y.shift()()})}]).directive("uibTimepicker",["uibTimepickerConfig",function(e){return{require:["uibTimepicker","?^ngModel"],restrict:"A",controller:"UibTimepickerController",controllerAs:"timepicker",scope:{},templateUrl:function(t,n){return n.templateUrl||e.templateUrl},link:function(e,t,n,a){var i=a[0],r=a[1];r&&i.init(r,t.find("input"))}}}]),angular.module("uib/template/typeahead/typeahead-match.html",[]).run(["$templateCache",function(e){e.put("uib/template/typeahead/typeahead-match.html",'<a href\n   tabindex="-1"\n   ng-bind-html="match.label | uibTypeaheadHighlight:query"\n   ng-attr-title="{{match.label}}"></a>\n')}]),angular.module("uib/template/typeahead/typeahead-popup.html",[]).run(["$templateCache",function(e){e.put("uib/template/typeahead/typeahead-popup.html",'<ul class="dropdown-menu" ng-show="isOpen() && !moveInProgress" ng-style="{top: position().top+\'px\', left: position().left+\'px\'}" role="listbox" aria-hidden="{{!isOpen()}}">\n    <li class="uib-typeahead-match" ng-repeat="match in matches track by $index" ng-class="{active: isActive($index) }" ng-mouseenter="selectActive($index)" ng-click="selectMatch($index, $event)" role="option" id="{{::match.id}}">\n        <div uib-typeahead-match index="$index" match="match" query="query" template-url="templateUrl"></div>\n    </li>\n</ul>\n')}]),angular.module("uib/template/modal/window.html",[]).run(["$templateCache",function(e){e.put("uib/template/modal/window.html","<div class=\"modal-dialog {{size ? 'modal-' + size : ''}}\"><div class=\"modal-content\" uib-modal-transclude></div></div>\n")}]),angular.module("uib/template/datepickerPopup/popup.html",[]).run(["$templateCache",function(e){e.put("uib/template/datepickerPopup/popup.html",'<ul class="uib-datepicker-popup dropdown-menu uib-position-measure" dropdown-nested ng-if="isOpen" ng-keydown="keydown($event)" ng-click="$event.stopPropagation()">\n  <li ng-transclude></li>\n  <li ng-if="showButtonBar" class="uib-button-bar">\n    <span class="btn-group pull-left">\n      <button type="button" class="btn btn-sm btn-info uib-datepicker-current" ng-click="select(\'today\', $event)" ng-disabled="isDisabled(\'today\')">{{ getText(\'current\') }}</button>\n      <button type="button" class="btn btn-sm btn-danger uib-clear" ng-click="select(null, $event)">{{ getText(\'clear\') }}</button>\n    </span>\n    <button type="button" class="btn btn-sm btn-success pull-right uib-close" ng-click="close($event)">{{ getText(\'close\') }}</button>\n  </li>\n</ul>\n')}]),angular.module("uib/template/datepicker/datepicker.html",[]).run(["$templateCache",function(e){e.put("uib/template/datepicker/datepicker.html",'<div ng-switch="datepickerMode">\n  <div uib-daypicker ng-switch-when="day" tabindex="0" class="uib-daypicker"></div>\n  <div uib-monthpicker ng-switch-when="month" tabindex="0" class="uib-monthpicker"></div>\n  <div uib-yearpicker ng-switch-when="year" tabindex="0" class="uib-yearpicker"></div>\n</div>\n')}]),angular.module("uib/template/datepicker/day.html",[]).run(["$templateCache",function(e){e.put("uib/template/datepicker/day.html",'<table role="grid" aria-labelledby="{{::uniqueId}}-title" aria-activedescendant="{{activeDateId}}">\n  <thead>\n    <tr>\n      <th><button type="button" class="btn btn-default btn-sm pull-left uib-left" ng-click="move(-1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-left"></i></button></th>\n      <th colspan="{{::5 + showWeeks}}"><button id="{{::uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" class="btn btn-default btn-sm uib-title" ng-click="toggleMode()" ng-disabled="datepickerMode === maxMode" tabindex="-1"><strong>{{title}}</strong></button></th>\n      <th><button type="button" class="btn btn-default btn-sm pull-right uib-right" ng-click="move(1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-right"></i></button></th>\n    </tr>\n    <tr>\n      <th ng-if="showWeeks" class="text-center"></th>\n      <th ng-repeat="label in ::labels track by $index" class="text-center"><small aria-label="{{::label.full}}">{{::label.abbr}}</small></th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr class="uib-weeks" ng-repeat="row in rows track by $index" role="row">\n      <td ng-if="showWeeks" class="text-center h6"><em>{{ weekNumbers[$index] }}</em></td>\n      <td ng-repeat="dt in row" class="uib-day text-center" role="gridcell"\n        id="{{::dt.uid}}"\n        ng-class="::dt.customClass">\n        <button type="button" class="btn btn-default btn-sm"\n          uib-is-class="\n            \'btn-info\' for selectedDt,\n            \'active\' for activeDt\n            on dt"\n          ng-click="select(dt.date)"\n          ng-disabled="::dt.disabled"\n          tabindex="-1"><span ng-class="::{\'text-muted\': dt.secondary, \'text-info\': dt.current}">{{::dt.label}}</span></button>\n      </td>\n    </tr>\n  </tbody>\n</table>\n')
}]),angular.module("uib/template/datepicker/month.html",[]).run(["$templateCache",function(e){e.put("uib/template/datepicker/month.html",'<table role="grid" aria-labelledby="{{::uniqueId}}-title" aria-activedescendant="{{activeDateId}}">\n  <thead>\n    <tr>\n      <th><button type="button" class="btn btn-default btn-sm pull-left uib-left" ng-click="move(-1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-left"></i></button></th>\n      <th colspan="{{::yearHeaderColspan}}"><button id="{{::uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" class="btn btn-default btn-sm uib-title" ng-click="toggleMode()" ng-disabled="datepickerMode === maxMode" tabindex="-1"><strong>{{title}}</strong></button></th>\n      <th><button type="button" class="btn btn-default btn-sm pull-right uib-right" ng-click="move(1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-right"></i></button></th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr class="uib-months" ng-repeat="row in rows track by $index" role="row">\n      <td ng-repeat="dt in row" class="uib-month text-center" role="gridcell"\n        id="{{::dt.uid}}"\n        ng-class="::dt.customClass">\n        <button type="button" class="btn btn-default"\n          uib-is-class="\n            \'btn-info\' for selectedDt,\n            \'active\' for activeDt\n            on dt"\n          ng-click="select(dt.date)"\n          ng-disabled="::dt.disabled"\n          tabindex="-1"><span ng-class="::{\'text-info\': dt.current}">{{::dt.label}}</span></button>\n      </td>\n    </tr>\n  </tbody>\n</table>\n')}]),angular.module("uib/template/datepicker/year.html",[]).run(["$templateCache",function(e){e.put("uib/template/datepicker/year.html",'<table role="grid" aria-labelledby="{{::uniqueId}}-title" aria-activedescendant="{{activeDateId}}">\n  <thead>\n    <tr>\n      <th><button type="button" class="btn btn-default btn-sm pull-left uib-left" ng-click="move(-1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-left"></i></button></th>\n      <th colspan="{{::columns - 2}}"><button id="{{::uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" class="btn btn-default btn-sm uib-title" ng-click="toggleMode()" ng-disabled="datepickerMode === maxMode" tabindex="-1"><strong>{{title}}</strong></button></th>\n      <th><button type="button" class="btn btn-default btn-sm pull-right uib-right" ng-click="move(1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-right"></i></button></th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr class="uib-years" ng-repeat="row in rows track by $index" role="row">\n      <td ng-repeat="dt in row" class="uib-year text-center" role="gridcell"\n        id="{{::dt.uid}}"\n        ng-class="::dt.customClass">\n        <button type="button" class="btn btn-default"\n          uib-is-class="\n            \'btn-info\' for selectedDt,\n            \'active\' for activeDt\n            on dt"\n          ng-click="select(dt.date)"\n          ng-disabled="::dt.disabled"\n          tabindex="-1"><span ng-class="::{\'text-info\': dt.current}">{{::dt.label}}</span></button>\n      </td>\n    </tr>\n  </tbody>\n</table>\n')}]),angular.module("uib/template/timepicker/timepicker.html",[]).run(["$templateCache",function(e){e.put("uib/template/timepicker/timepicker.html",'<table class="uib-timepicker">\n  <tbody>\n    <tr class="text-center" ng-show="::showSpinners">\n      <td class="uib-increment hours"><a ng-click="incrementHours()" ng-class="{disabled: noIncrementHours()}" class="btn btn-link" ng-disabled="noIncrementHours()" tabindex="-1"><span class="glyphicon glyphicon-chevron-up"></span></a></td>\n      <td>&nbsp;</td>\n      <td class="uib-increment minutes"><a ng-click="incrementMinutes()" ng-class="{disabled: noIncrementMinutes()}" class="btn btn-link" ng-disabled="noIncrementMinutes()" tabindex="-1"><span class="glyphicon glyphicon-chevron-up"></span></a></td>\n      <td ng-show="showSeconds">&nbsp;</td>\n      <td ng-show="showSeconds" class="uib-increment seconds"><a ng-click="incrementSeconds()" ng-class="{disabled: noIncrementSeconds()}" class="btn btn-link" ng-disabled="noIncrementSeconds()" tabindex="-1"><span class="glyphicon glyphicon-chevron-up"></span></a></td>\n      <td ng-show="showMeridian"></td>\n    </tr>\n    <tr>\n      <td class="form-group uib-time hours" ng-class="{\'has-error\': invalidHours}">\n        <input type="text" placeholder="HH" ng-model="hours" ng-change="updateHours()" class="form-control text-center" ng-readonly="::readonlyInput" maxlength="2" tabindex="{{::tabindex}}" ng-disabled="noIncrementHours()" ng-blur="blur()">\n      </td>\n      <td class="uib-separator">:</td>\n      <td class="form-group uib-time minutes" ng-class="{\'has-error\': invalidMinutes}">\n        <input type="text" placeholder="MM" ng-model="minutes" ng-change="updateMinutes()" class="form-control text-center" ng-readonly="::readonlyInput" maxlength="2" tabindex="{{::tabindex}}" ng-disabled="noIncrementMinutes()" ng-blur="blur()">\n      </td>\n      <td ng-show="showSeconds" class="uib-separator">:</td>\n      <td class="form-group uib-time seconds" ng-class="{\'has-error\': invalidSeconds}" ng-show="showSeconds">\n        <input type="text" placeholder="SS" ng-model="seconds" ng-change="updateSeconds()" class="form-control text-center" ng-readonly="readonlyInput" maxlength="2" tabindex="{{::tabindex}}" ng-disabled="noIncrementSeconds()" ng-blur="blur()">\n      </td>\n      <td ng-show="showMeridian" class="uib-time am-pm"><button type="button" ng-class="{disabled: noToggleMeridian()}" class="btn btn-default text-center" ng-click="toggleMeridian()" ng-disabled="noToggleMeridian()" tabindex="{{::tabindex}}">{{meridian}}</button></td>\n    </tr>\n    <tr class="text-center" ng-show="::showSpinners">\n      <td class="uib-decrement hours"><a ng-click="decrementHours()" ng-class="{disabled: noDecrementHours()}" class="btn btn-link" ng-disabled="noDecrementHours()" tabindex="-1"><span class="glyphicon glyphicon-chevron-down"></span></a></td>\n      <td>&nbsp;</td>\n      <td class="uib-decrement minutes"><a ng-click="decrementMinutes()" ng-class="{disabled: noDecrementMinutes()}" class="btn btn-link" ng-disabled="noDecrementMinutes()" tabindex="-1"><span class="glyphicon glyphicon-chevron-down"></span></a></td>\n      <td ng-show="showSeconds">&nbsp;</td>\n      <td ng-show="showSeconds" class="uib-decrement seconds"><a ng-click="decrementSeconds()" ng-class="{disabled: noDecrementSeconds()}" class="btn btn-link" ng-disabled="noDecrementSeconds()" tabindex="-1"><span class="glyphicon glyphicon-chevron-down"></span></a></td>\n      <td ng-show="showMeridian"></td>\n    </tr>\n  </tbody>\n</table>\n')}]),angular.module("ui.bootstrap.typeahead").run(function(){!angular.$$csp().noInlineStyle&&!angular.$$uibTypeaheadCss&&angular.element(document).find("head").prepend('<style type="text/css">[uib-typeahead-popup].dropdown-menu{display:block;}</style>'),angular.$$uibTypeaheadCss=!0}),angular.module("ui.bootstrap.position").run(function(){!angular.$$csp().noInlineStyle&&!angular.$$uibPositionCss&&angular.element(document).find("head").prepend('<style type="text/css">.uib-position-measure{display:block !important;visibility:hidden !important;position:absolute !important;top:-9999px !important;left:-9999px !important;}.uib-position-scrollbar-measure{position:absolute !important;top:-9999px !important;width:50px !important;height:50px !important;overflow:scroll !important;}.uib-position-body-scrollbar-measure{overflow:scroll !important;}</style>'),angular.$$uibPositionCss=!0}),angular.module("ui.bootstrap.datepickerPopup").run(function(){!angular.$$csp().noInlineStyle&&!angular.$$uibDatepickerpopupCss&&angular.element(document).find("head").prepend('<style type="text/css">.uib-datepicker-popup.dropdown-menu{display:block;float:none;margin:0;}.uib-button-bar{padding:10px 9px 2px;}</style>'),angular.$$uibDatepickerpopupCss=!0}),angular.module("ui.bootstrap.datepicker").run(function(){!angular.$$csp().noInlineStyle&&!angular.$$uibDatepickerCss&&angular.element(document).find("head").prepend('<style type="text/css">.uib-datepicker .uib-title{width:100%;}.uib-day button,.uib-month button,.uib-year button{min-width:100%;}.uib-left,.uib-right{width:100%}</style>'),angular.$$uibDatepickerCss=!0}),angular.module("ui.bootstrap.timepicker").run(function(){!angular.$$csp().noInlineStyle&&!angular.$$uibTimepickerCss&&angular.element(document).find("head").prepend('<style type="text/css">.uib-time input{width:50px;}</style>'),angular.$$uibTimepickerCss=!0});
(function () {
	'use strict';

	angular.module('services.upload',[]).factory('uploadService', uploadService);
	/** @ngInject */

	function uploadService(settings, base, storage, $rootScope, $http) {
		return {
			fileUpload: function (file, config, filename) {
				var fd = new FormData();
				fd.append('fileName', file, filename);
				return $http.post(settings.fileUpload.url, fd, config)
			},
			imgUpload: function (file, config) {
				var fd = new FormData();
				fd.append('fileName', file, settings.baseUploadConfig.name);
				return $http.post(settings.baseUploadConfig.url, fd, config)
			}
		}
	}
})();

(function () {
  'use strict';

  angular.module('services.storage', []).factory('storage', storage);
  /** @ngInject */
  function storage($q, $window) {
    var Deferrer = function () {
      this.defer = $q.defer();
      return this;
    };

    var storageReplacement = {};
    var hasStorageEnabled = hasStorageEnabled() && hasCookiesEnabled(); //this is called only once so is faster 

    function hasCookiesEnabled(){
        var cookieEnabled=(navigator.cookieEnabled)? true : false;
        if (typeof navigator.cookieEnabled=='undefined' && !cookieEnabled){ 
            document.cookie = 'testcookie';
            cookieEnabled = (document.cookie.indexOf('testcookie')!=-1)? true : false;
        }
        return cookieEnabled;
    }

    function hasStorageEnabled(){
        try {
        var testKey = 'test';
        var storage = window.sessionStorage;
            storage.setItem(testKey, '1');
        storage.removeItem(testKey);

        var local = window.localStorage;
            local.setItem(testKey, '1');
        local.removeItem(testKey);
        
            return true;
      }
      catch (error) {
            return false;
        }
    }

    function setToken(tkn) {
      if(!hasStorageEnabled){
        storageReplacement['__c3'] = tkn.b64encode();
      }else{
        $window.localStorage.setItem('__c3', tkn.b64encode());      
      }
    }

    function del(key, persist) {
      if(!hasStorageEnabled){
        delete storageReplacement[key];
      }else{
        persist ? $window.localStorage.removeItem(key) : $window.sessionStorage.removeItem(key);
      }
    }

    return {
      hasStorageEnabled: hasStorageEnabled,
      hasCookiesEnabled: hasCookiesEnabled,
      has: function (key, persist) {
        if(!hasStorageEnabled){
          return _.isObject(storageReplacement[key]) || _.isString(storageReplacement[key]);
        }else{
          return persist ? (_.isObject($window.localStorage.getItem(key)) || _.isString($window.localStorage.getItem(key))) : (_.isObject($window.sessionStorage.getItem(key)) || _.isString($window.sessionStorage.getItem(key)));
        }
      },
      set: function (key, value, persist) {
        if(!hasStorageEnabled){
          storageReplacement[key] = value;
        }else{
          persist ? $window.localStorage.setItem(key, angular.toJson(value)) : $window.sessionStorage.setItem(key, angular.toJson(value));
        }
      },
      get: function (key, persist, now) {
        if(!hasStorageEnabled){
          return storageReplacement[key];
        }else{
          var deferred = new Deferrer().defer, item;
          persist ? item = angular.fromJson(localStorage.getItem(key)) : item = angular.fromJson(sessionStorage.getItem(key));
          item !== null ? deferred.resolve(item) : deferred.reject();
          if (now) return item
          else return deferred.promise          
        }
      },
      setToken: setToken,
      getToken: function(){
        var memToken = '';

        var temp;

        if(!hasStorageEnabled) {
          temp = storageReplacement['__c3'];
          if (temp) {
            memToken = temp.b64decode();
          }
        } else {
          temp = $window.localStorage.getItem('__c3');
          if (temp){
            memToken = temp.b64decode();
          }
        }
        return memToken;
      },
      del: del
    }
  }

})();
(function () {
	"use strict";

	/**
	 * @ngdoc function
	 * @name error handler
	 * @description intercepts Javascript errors and reports
	 * #
	 */

	angular.module("services.introjs", []).factory("$introjs", introjs);
	/** @ngInject */
	function introjs($rootScope, storage, base, $http) {
		//make all definitions in this function by url...
    $rootScope.cues;
    var ijCue;
    var appCuesEnabled = true; // we can enable and disable appcues from here
    loadCueJson();

    if(appCuesEnabled){
      window.addEventListener('popstate', windowLocationChangeListener);
      function windowLocationChangeListener(e){
        //console.log("location changed");
        //we need to exit on page change
        if(ijCue){
          ijCue.exit(true);
        }
      }
    }
    

    

    function loadCueJson(){
      if(!$rootScope.cues && appCuesEnabled){
        $http.get('i8n/app-cue-journeys.json').then(function(data) {
          $rootScope.cues = data.data.journeys;
          //fix intro step values
          angular.forEach($rootScope.cues, function(cue,v){
            angular.forEach(cue.steps, function(step,v){
              angular.forEach(step.introSteps, function(introStep,v){
                
              });
            });
          });

          //check the values
          //console.log("cues",$rootScope.cues);
        });
      }
    }

    function getJourney(main){
      var cue;
      for(var i=0; i < $rootScope.cues.length; i++){
        if($rootScope.cues[i].id.toString() == main){
          return $rootScope.cues[i];
        }
      }
    }

    
		function getSteps(main,id) {
      var journey = getJourney(main);
      for(var i=0; i < journey.steps.length; i++){
        if(journey.steps[i].id == id){
          var _step = JSON.parse(JSON.stringify(journey.steps[i]));//clone the object
          for(var j=0; j < _step.introSteps.length;j++){
            if(_step.introSteps[j].hasOwnProperty('element')){
              //find dom element
              _step.introSteps[j].element = document.querySelector(_step.introSteps[j].element);
            }
            if(_step.introSteps[j].hasOwnProperty('intro')){
              _step.introSteps[j].intro = _step.introSteps[j].intro.replace("{{SCHOOL_NAME}}",$rootScope.active_school.name);
            }
          }
          return _step.introSteps;
        }
      }
      return null;
		}
    
    function getOptions(main,id) {
      var journey = getJourney(main);
      for(var i=0; i < journey.steps.length; i++){
        if(journey.steps[i].id == id){
          var _step = JSON.parse(JSON.stringify(journey.steps[i]));//clone the object
          return _step.options;
        }
      }
      return null;
    }

    function _startAppCue(main,id,delay,ignoreDismiss){
      $rootScope.showedCues = [];
      if(!ignoreDismiss){
          var todoRequestUrl = "shared/v1/todo/check/" + $rootScope.active_school.id + "/" + main;
          base.get(todoRequestUrl, { }, { 'headers': { 'ClasslistToken': storage.getToken() }}).then(function(response) {
            var result = response.data.payload.show;
            //result = true;
            if(result){
              storage.set("activeappcue", main, true);
              _setAppCue(main,id,delay);
            }
          }, function(error){
          }); 
      } else {
        storage.set("activeappcue", main, true);
        _setAppCue(main,id,delay);
      }
    }  

    function _setAppCue(main,id,delay){
      if(!appCuesEnabled){
        return;
      }

      if(!$rootScope.showedCues){
        $rootScope.showedCues = [];
      }
      
      if(storage.get("activeappcue", true, true) != main){
        //if the current request app cue is not the part of main app cue. just stop it.
        return;
      }

      if (!id) {
        return null;
      }

      var storageKey = "APPCUE_" + id;

      if($rootScope.showedCues.indexOf(id) > -1) {
        return;
      }

      if (!$rootScope.isDesktopView()) {
        //app cues defined only for desktop users.
        return;
      }

      var steps = getSteps(main,id);

      if (steps == null || !steps) {
        //if there is no step defined for this page, return
        return;
      }

      var options = getOptions(main,id);
    
      if (!delay) {
        delay = 0;
      }
      //if all looking good, call the intro js script
      //call the app cue with defined delay
      setTimeout(function () {
        //call the script when document is ready
        angular.element(document).ready(function () {
          ijCue = introJs();
          ijCue.setOption("dismissable", true);
          if (options) {
            ijCue.setOptions(options);
          }
          ijCue.ondismiss(function() {
            //dismiss this todo type
            storage.del("activeappcue", true);
            base.get("shared/v1/todo/dismiss/" + $rootScope.active_school.id + "/"  + main);
            ijCue.exit(true);
          });
          ijCue.oncomplete(function() {
            //cue completed
            //console.log("cue completed by clicking done button");
            //storage.del("activeappcue", true);
          });
          ijCue.onexit(function() {
            //cue completed
            //console.log("cue exited");
            //storage.del("activeappcue", true);
          });
          ijCue.setOptions({steps: steps,});
          ijCue.start();

        });
      }, delay);

      //so all went well, we have showed this app cue to the user, we have to set storage about this app cue has viewed
      $rootScope.showedCues.push(id);
      
  }

		return {
			setAppCue: function (main, id, delay) {
        if(!$rootScope.cues){
          setTimeout(function () {
            _setAppCue(main,id,delay);
          }, 500);
        } else {
          _setAppCue(main,id,delay);
        }
			},
			//we don't use this function for now.
			startAppCue: function (main, id, delay, ignoreDismiss) {
        if(!$rootScope.cues){
          setTimeout(function () {
            _startAppCue(main,id,delay,ignoreDismiss);
          }, 500);
        } else {
          _startAppCue(main,id,delay,ignoreDismiss);
        }
			},
		};
	}
})();

(function () {
	'use strict';

	/**
	 * @ngdoc function
	 * @name error handler
	 * @description intercepts $http errors and logs
	 * #
	 */
	angular.module('services.httpInterceptor', []).service('httpInterceptor', httpInterceptor);

	/** @ngInject */
	function httpInterceptor($q, $injector, $rootScope, storage, $cacheFactory, gaService) {
		var authService = function () { return $injector.get('authService') };
		var toastr = function () { return $injector.get('toastr') };
		var offlineShown = false;

		var retries = 0;
		var maxRetries = 3;
		var ignoreErrors = false;

		function err(message, name) {
			this.message = message;
			this.name = name;
		}

		function logError(res){
			var errorMessage;
			var status;

			try{
				errorMessage = res.data.error.message;
				status = res.status;
			}catch(exception){
				//meh
				errorMessage = "NO_MESSAGE";
				status = "NO_STATUS";
			}

			gaService.exception({
				exDescription: location.hash + ' '+ status + ' ' + errorMessage ,
				exFatal: true
			});
		}

		function cleanHttpCache() {
			var $httpDefaultCache = $cacheFactory.get('$http');
			$httpDefaultCache.removeAll();
		}

		return {
			request : function(config) {
				if (config.ignoreErrors) {
					ignoreErrors = config.ignoreErrors;
				}
				var xhr = config.xhr || false;
								
				if(_.isString(storage.getToken()) && xhr){
					config.headers['ClasslistToken'] = storage.getToken();

					if ($rootScope.active_user){
						config.headers['u'] = $rootScope.active_user.id;
					}

					if ($rootScope.active_school){
						config.headers['s'] = $rootScope.active_school.id;
					}

					config.headers['p'] = $rootScope.getOS() == "Flutter" ? "flutter-school" : "web-school";
					config.headers['v'] = getFrontendVersion();
					config.headers['x'] = (document.cookie.indexOf('X-Source=experiment') > -1);
				}
				return config
			},
			response : function(res) {
				if(res.config.method === 'POST' || res.config.method === 'PUT' || res.config.method === 'DELETE') {
					cleanHttpCache();
				}
				return res
			},
			requestError : function (error) {
				if(error){
					throw new err(error.statusText, error.status)
				}
				return error
			},
			responseError : function (res) {
				switch (res.status) {
					case -1: {
						if(!offlineShown) {
							toastr().info('Sorry something went wrong, please check your internet connection');
							offlineShown = true;

							setTimeout(function() {
								offlineShown = false;
							}, 3000);
						}

						break;
					}
					
					case 401: // Unauthorized
						// Viorel: ./base getContext param
						if (res.config.method === 'GET') {
							authService().logout(true);
						}
						// return;//it will return response ok, we need to handle this somehow in the logic, if we return error it will generate a toast error message
					break;
					case 403: // Forbidden
						if (!ignoreErrors) {
							logError(res);
							$rootScope.nonmemberurl = location.href;
							location.href = '/school/#/welcome';
						}
						break;
					case -1: // Internal server error
					case 500: // Internal server error
					case 503: // Service Unavailable
						if(res.config.method === 'POST' || res.config.method === 'PUT' || res.config.method === 'DELETE') {
							toastr().error('You are offline, please check your internet connection');
							logError(res);
						}else{
							if (retries < maxRetries) {
				                retries++;
				                var $http = $injector.get('$http');
	       						return $http(res.config);
				            }	
			       		 }
					break;
					//Viorel: 403 is handled internally
					case 404: // Not Found
					$rootScope.$broadcast('NOT_FOUND');
					logError(res);
					return;
				}
				logError(res);
				return $q.reject(res);

			}
		}

	}

})();


(function () {
	'use strict';

	angular.module('services.ganalytics',[]).factory('gaService', gaService);

	/** @ngInject */
	function gaService($window, settings) {

		$window.ga('create', settings.gaUserId, 'auto');
		$window.ga('set', 'forceSSL', true);

		return {
			send: function (page) {
				if (page === null || page === '/' || _.isUndefined(page)){
					var location = $window.location.hash;
					page = '/undefined error ' + location;
				}
				$window.ga('send', 'pageview', page);
			},
			exception: function (data) {
				 $window.ga('send', 'exception', data);
			}
		}
	}
})();

(function () {
  'use strict';

  /**
    * @ngdoc function
    * @name error handler
    * @description intercepts Javascript errors and reports
    * #
    */

  angular.module('services.errorHandler', []).factory('$exceptionHandler', exceptionHandler);
  /** @ngInject */
  function exceptionHandler($injector, $log, gaService) {
    return function (exception, cause) {
      var service = _.create($injector.get('base'), {}) || {};
			var toastr = _.create($injector.get('toastr'), {}) || {};

			exception.name === 401 ? toastr.error(exception.message) : '';
			exception.name === 400 ? service.notify(exception.message,'badrequest') : '';

			gaService.exception({
				exDescription: location.hash + ' - ' + exception.message,
				exFatal: true
			});
    }
  }
})();

(function () {
  'use strict';

  angular.module('services.base',[]).factory('base', base);

  /** @ngInject */
  function base($http, $log, $window, settings) {

    var notifications = {
      'js': [],
      'http':[],
			'badrequest':[]
    }, events = {};

    return {
      isReady: false,
      init: function () {

      },
      post:function (resource, payload, config) {
        var baseURL = settings.gae.url;
        if (resource.indexOf("payment/v1") > -1){
          baseURL = settings.gae.rootUrl;
        }
        return $http.post(baseURL + resource, angular.toJson(payload), _.assign(settings.http, config));
      },
			delete:function (resource, config) {
				return $http.delete(settings.gae.url+resource, _.assign(settings.http, config));
			},
      subscribe: function(target, callback_fn){
        events[target] = callback_fn;
      },
			unsubscribe: function(target){
				delete events[target]
			},
      get:function (resource, config) {
        var baseURL = settings.gae.url;
        if (resource.indexOf("payment/v1") > -1){
          baseURL = settings.gae.rootUrl;
        }
        return $http.get(baseURL + resource, _.assign(settings.http, config));
      },
			put:function (resource, payload, config) {
				return $http.put(settings.gae.url+resource, angular.toJson(payload), _.assign(settings.http, config));
			},
      notify: function (message, target) {
        events[target](message);
        notifications[target].push(message);
      },
      denotify: function (item, target) {
        notifications[target] = _.without(notifications[target], item);

      },
      flushNotifications: function (target) {
        notifications[target].length = 0;
      },
      flushAll: function(){
        notifications['js'].length = 0;
        notifications['http'].length = 0;
      },
      getNotifications: function(target){
        return notifications[target]
      },
      getPostImgBucketUrl: function(target){
        return settings.baseUploadConfig.url
      }
    }
  }
})();

(function () {
	'use strict';

	angular.module('services.auth',[]).factory('authService', authService);

	/** @ngInject */
	function authService($window, $rootScope, $location, settings, toastr, storage, base, $translate) {

		function flush(){
			try{
				// keep sunset and staff survey modal settings
				var dontShowPwaSunsetAgain = window.localStorage.getItem('dontShowPwaSunsetAgain');
				var sunsetModalAdminShow = window.localStorage.getItem('sunsetModalAdminShow');
				var dontShowStaffSurveyModalAgain = window.localStorage.getItem('dontShowStaffSurveyModalAgain');
				var staffSurveyModalAdminShow = window.localStorage.getItem('staffSurveyModalAdminShow');
				window.localStorage.clear();
				if (dontShowPwaSunsetAgain !== null) window.localStorage.setItem('dontShowPwaSunsetAgain', dontShowPwaSunsetAgain);
				if (sunsetModalAdminShow !== null) window.localStorage.setItem('sunsetModalAdminShow', sunsetModalAdminShow);
				if (dontShowStaffSurveyModalAgain !== null) window.localStorage.setItem('dontShowStaffSurveyModalAgain', dontShowStaffSurveyModalAgain);
				if (staffSurveyModalAdminShow !== null) window.localStorage.setItem('staffSurveyModalAdminShow', staffSurveyModalAdminShow);
			}catch(ex){
				window.localStorage.clear();
			}
		}

		function redirectToLogin() {
			flush();
			window.location = settings.conf.ssoAppURL + '/#/?unauthorized=school';
		}

		return {
			logout: function (isUnautorized) {
				if(!_.isNull(storage.getToken())) {
					var tkn = storage.getToken();
					base.post('sso/v1/signOut', { }, { 'headers': { 'ClasslistToken': tkn }}).then(function(response) {
						redirectToLogin();

					}, function(error){
						redirectToLogin();
					});
				} 
				else {
					redirectToLogin();
				}
			
			}
		}
	}
})();

(function () {

   'use strict';

   /**
    * @ngdoc filter
    * @name prefix:prefix
    * @description
    * <ul>
    * <li>Displays a group array</li>
    * </ul>
    */

   angular.module('filters.groupBy', []).filter('groupBy', function(){
      return function(items, groupSize) {
        var groups = [];

        if(items){
          var array = items.slice(0),
              inner, i,j;

          for(i=0, j=array.length; i<j; i+=groupSize) {
            inner = array.slice(i,i+groupSize);
            groups.push(inner);
          }
        }

        return groups;
      };
   });
})();
(function () {

	'use strict';
	/**
	 * @ngdoc directive
	 * @name zendesk:zendesk
	 * @description
	 * <ul>
	 * <li>Displays a Zendesk link based on the view user is looking at</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */
	angular.module('directives.zendesk', []).directive('zendesk', zendesk);
	/** @ngInject */
	function zendesk($state, zenLinks) {
		var directive =  {
			restrict: 'E',
			replace: true,
			template: '<a class="help-button"><span class="icon dripicons-question dripicons-font-size-x-1_5"></span><span class="text" translate="TOPNAV_TRAININGHELP"></span></a>',
			link: linkFunction
		};
		return directive;

		function linkFunction(scope, elem, attrs) {
			elem.bind('click', function() {
				var url = zenLinks[$state.current.name] || '';
				var _url;

				if($state.current.name !== '' && url.length > 0)
					_url = url;
				else
					_url = 'https://help.classlist.com';

				var win = window.open(_url, '_blank');
				win.focus();
			})

		}
	}

})();

(function () {

  'use strict';

  angular.module('directives.tooltip', []).directive('tooltip', function(){
      return {
          restrict: 'A',
          link: function(scope, elem, attrs) {
            var el = elem[0];

            el.addEventListener("mouseenter", function(e) {

              if(window.innerWidth > 990) {
                var t = el.getElementsByClassName('tltp')[0];
                if(t) {
                  t.style.display = "block";
                  t.style.marginLeft = '-' + ((t.offsetWidth / 2) - 10) + 'px';
                  //t.style.marginTop = (t.offsetHeight + 10) + 'px';
                }
              }
            }, false);

            el.addEventListener("mouseleave", function() {
                  var t = el.getElementsByClassName('tltp')[0];
                  if(t)
                    t.style.display = "none";

            }, false);
          }
      };
  })
  
})();

(function () {

	'use strict';

	angular.module('directives.timeago', [])
	.filter('timeago', function () {
		return function (time, local, raw) {
			if (!time) return "never";

			if (!local) {
					(local = Date.now())
			}

			if (angular.isDate(time)) {
					time = time.getTime();
			} else if (typeof time === "string") {
					time = new Date(time).getTime();
			}

			if (angular.isDate(local)) {
					local = local.getTime();
			}else if (typeof local === "string") {
					local = new Date(local).getTime();
			}

			if (typeof time !== 'number' || typeof local !== 'number') {
					return;
			}

			var offset = Math.abs((local - time) / 1000),
			span = [],
			MINUTE = 60,
			HOUR = 3600,
			DAY = 86400,
			WEEK = 604800,
			MONTH = 2629744,
			YEAR = 31556926;

			if (offset <= MINUTE)              span = [ '', 'just now' ];
			else if (offset < (MINUTE * 60))   span = [ Math.round(Math.abs(offset / MINUTE)), 'min' ];
			else if (offset < (HOUR * 24))     span = [ Math.round(Math.abs(offset / HOUR)), 'hr' ];
			else if (offset < (DAY * 7))       span = [ Math.round(Math.abs(offset / DAY)), 'day' ];
			else if (offset < (WEEK * 4))     span = [ Math.round(Math.abs(offset / WEEK)), 'week' ];
			else if (offset < (MONTH * 12))     span = [ Math.round(Math.abs(offset / MONTH)), 'month' ];
			else if (offset < (YEAR * 10))     span = [ Math.round(Math.abs(offset / YEAR)), 'year' ];
			else                               span = [ '', 'a long time' ];

			span[1] += (span[0] === 0 || span[0] > 1) ? 's' : '';
			span = span.join(' ');

			if (raw === true || offset <= MINUTE) {
				return span;
			}

			return (time <= local) ? span + ' ago' : 'in ' + span;
		}
	})
})();

(function () {

  'use strict';

  angular.module('directives.textEditor', [])

  .controller('SummernoteController', ['$scope', '$attrs', '$timeout', 'uploadService', 'storage', 'settings', 'toastr', '$translate',
		function($scope, $attrs, $timeout, uploadService, storage, settings, toastr, $translate) {
    'use strict';

    var currentElement,
        summernoteConfig = angular.copy($scope.summernoteConfig) || {};
   
    if (angular.isDefined($attrs.height)) { summernoteConfig.height = +$attrs.height; }
    if (angular.isDefined($attrs.minHeight)) { summernoteConfig.minHeight = +$attrs.minHeight; }
    if (angular.isDefined($attrs.maxHeight)) { summernoteConfig.maxHeight = +$attrs.maxHeight; }
    if (angular.isDefined($attrs.placeholder)) { summernoteConfig.placeholder = $attrs.placeholder; }
    if (angular.isDefined($attrs.focus)) { summernoteConfig.focus = true; }
    if (angular.isDefined($attrs.airmode)) { summernoteConfig.airMode = true; }
    if (angular.isDefined($attrs.dialogsinbody)) { summernoteConfig.dialogsInBody = true; }
    if (angular.isDefined($attrs.lang)) {
      if (!angular.isDefined($.summernote.lang[$attrs.lang])) {
        throw new Error('"' + $attrs.lang + '" lang file must be exist.');
      }
      summernoteConfig.lang = $attrs.lang;
    }

    summernoteConfig.callbacks = summernoteConfig.callbacks || {};

    summernoteConfig['onCreateLink'] = function(url) {
      var email = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i
			var phone = /^\+?[\d()-,.]+/
			var schemed = /^[a-z]+:/i
			url = url.trim();
			if (email.test(url)) {
				url = 'mailto:' + url;
			} else if (phone.test(url)) {
				url = 'tel:' + url.replace(/[ ().\-]/g,'');
			} else if (!schemed.test(url)) {
				url = 'http://' + url;
			}
			return url;
    }	

    if (angular.isDefined($attrs.onInit)) {
      summernoteConfig.callbacks.onInit = function(evt) {
        $scope.init({evt:evt});
      };
    }
    if (angular.isDefined($attrs.onEnter)) {
      summernoteConfig.callbacks.onEnter = function(evt) {
        $scope.enter({evt:evt});
      };
    }
    if (angular.isDefined($attrs.onFocus)) {
      summernoteConfig.callbacks.onFocus = function(evt) {
        $scope.focus({evt:evt});
      };
    }
    if (angular.isDefined($attrs.onPaste)) {
      summernoteConfig.callbacks.onPaste = function(evt) {
        $scope.paste({evt:evt});
      };
    }
    if (angular.isDefined($attrs.onKeyup)) {
      summernoteConfig.callbacks.onKeyup = function(evt) {
        $scope.keyup({evt:evt});
      };
    }
    if (angular.isDefined($attrs.onKeydown)) {
      summernoteConfig.callbacks.onKeydown = function(evt) {
        $scope.keydown({evt:evt});
      };
    }
    if (angular.isDefined($attrs.onImageUpload)) {
      summernoteConfig.callbacks.onImageUpload = function(files) {
        if (!files.length) return;
        if (files.length > 7) {
            toastr.error($translate.instant('TEXT_EDITOR_IMAGE_LIMIT'));
            return;
        }
    
    
        var uploadPromises = [];
        var imgElements = [];
    
        for (var i = 0; i < files.length; i++) {
            (function(file, i) {
    
                var reader = new FileReader();
                var uploadPromise = new Promise(function(resolve, reject) {
                    reader.onloadend = function() {
                        uploadService.fileUpload(dataURItoBlob(reader.result), {
                            headers: {
                                'Content-Type': undefined,
                                'ClasslistToken': storage.getToken() || '',
                                'ClasslistCfg': angular.toJson({
                                    'type': 'ANNOUNCEMENT_EDITOR'
                                })
                            }
                        }, file.name).then(function(response) {
    
                            var src = response.data;
                            if (src.indexOf('googleusercontent.com') > -1) {
                                src = src + '=s0';
                            }
    
                            var img = $('<img>').attr({
                                src: src,
                                width: '97%',
                                'onclick': "previewImages('" + src + "')"
                            });
    
                            imgElements[i] = img[0];  
                            resolve();  
                        }, function(error) {
                            reject(error);  
                        });
                    };
    
                    if (file) {
                        reader.readAsDataURL(file);
                    }
                });
    
                uploadPromises.push(uploadPromise);
    
            })(files[i], i);
        }
    
        Promise.all(uploadPromises).then(function() {
            imgElements.forEach(function(imgElement) {
                currentElement.summernote('insertNode', imgElement);
            });
        }).catch(function(error) {
          toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
        });
    
        $scope.imageUpload({files: files, editable: $scope.editable});
    };
    }
    if (angular.isDefined($attrs.onMediaDelete)) {
      summernoteConfig.callbacks.onMediaDelete = function(target) {
        // make new object that has information of target to avoid error:isecdom
        var removedMedia = {attrs: {}};
        removedMedia.tagName = target[0].tagName;
        angular.forEach(target[0].attributes, function(attr) {
          removedMedia.attrs[attr.name] = attr.value;
        });
        $scope.mediaDelete({target: removedMedia});
      };
    }

    this.activate = function(scope, element, ngModel) {
      var updateNgModel = function() {
        var newValue = element.summernote('code');
        if (element.summernote('isEmpty')) { newValue = ''; }
        if (ngModel && ngModel.$viewValue !== newValue) {
          $timeout(function() {
            ngModel.$setViewValue(newValue);
          }, 0);
        }
      };

      var originalOnChange = summernoteConfig.callbacks.onChange;
      summernoteConfig.callbacks.onChange = function (contents) {
        $timeout(function () {
          if (element.summernote('isEmpty')) {
            contents = '';
          }
          updateNgModel();
        }, 0);
        if (angular.isDefined($attrs.onChange)) {
          $scope.change({contents: contents, editable: $scope.editable});
        } else if (angular.isFunction(originalOnChange)) {
          originalOnChange.apply(this, arguments);
        }
        $timeout(function () {
          updateNgModel();
        }, 500);
      };
      if (angular.isDefined($attrs.onBlur)) {
        summernoteConfig.callbacks.onBlur = function (evt) {
          (!summernoteConfig.airMode) && element.blur();
          $scope.blur({evt: evt});
        };
      }
      element.summernote(summernoteConfig);

      var editor$ = element.next('.note-editor'),
          unwatchNgModel;
      var modalTitles = editor$.find('.modal-title');
      for(var i = 0; i < modalTitles.length; i++) {
        if (modalTitles[i].innerText === 'Insert Image') {

            var isFlutter = getMobileOperatingSystem() === "Flutter"

            // announcement editor image upload section updates for mobile 
            if(isFlutter){
              modalTitles[i].innerHTML = '<b style="font-size:24px;font-weight:600">Take or select a photo</b>';
              var editorImageTexts = $translate.instant('TEXT_EDITOR_IMAGE_MODAL_MOBILE_TEXT')
              if(editorImageTexts === 'TEXT_EDITOR_IMAGE_MODAL_MOBILE_TEXT') 
                editorImageTexts = "You can take a photo on your phone and attach it without saving the image on your device. <br>Add photos one by one. <br>Save the announcement as a draft or send in the moment.<br>Or, you can add up to 7 images in one go. There is no limit to the total number.";
              modalTitles[i].insertAdjacentHTML('afterend', '<span style="font-size:14px;display:flex;padding-top:10px">'+editorImageTexts+'</span>');
              var firstInsert = modalTitles[i].nextElementSibling;

              try {
                if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
                  firstInsert.insertAdjacentHTML('afterend', '<br><div class="contact-list" id="camera-permission-info-text"><span class="dripicons-information contact-icon icon"></span><span style="font-size:13px;font-weight:600; display:-webkit-box">Camera access is disabled. <br>Taking photos requires access to your camera. Allow Classlist access to your camera. <a onclick="openNotificationSettingsPage()">Open device settings</a></span></div>');
                  navigator.mediaDevices.getUserMedia({ video: true })
                    .then(function(stream) {
                      document.getElementById("camera-permission-info-text").style.display = 'none'
                    })
                    .catch(function(error) {
                    });
                }else{
                  firstInsert.insertAdjacentHTML('afterend', '<br><div class="contact-list"><span class="dripicons-information contact-icon icon"></span><span style="font-size:13px;font-weight:600; display:-webkit-box">If you do not see the camera option, please check your phone settings grant Classlist access to the camera for this purpose.</span></div>');
                }
              } catch (error) {
                firstInsert.insertAdjacentHTML('afterend', '<br><div class="contact-list"><span class="dripicons-information contact-icon icon"></span><span style="font-size:13px;font-weight:600; display:-webkit-box">If you do not see the camera option, please check your phone settings grant Classlist access to the camera for this purpose.</span></div>');
              }
            

              // remove image url section
              editor$.find('.note-group-image-url')[0].style.display = 'none'
              // remove image insert button
              editor$.find('.note-image-btn')[0].style.display = 'none'

              // update choose file button style
              var uploadFileDiv = editor$.find('.note-group-select-from-files')[0]
              uploadFileDiv.classList.add("custom-file-div-upload")
              var chooseFileBtnTitle = uploadFileDiv.childNodes[0];
              
              var editorImageText = $translate.instant('UPLOAD_EDITOR_IMAGE_BUTTON_TEXT')
              if(editorImageText === 'UPLOAD_EDITOR_IMAGE_BUTTON_TEXT') 
                editorImageText = "Take or select a photo";

              chooseFileBtnTitle.innerText = editorImageText;
              chooseFileBtnTitle.classList.add("custom-file-upload");
              var chooseFileBtn = uploadFileDiv.childNodes[1];
              chooseFileBtn.style.display = 'none'
            
          }else{
            modalTitles[i].innerText = 'Insert Images';
            var editorImageText = $translate.instant('TEXT_EDITOR_IMAGE_MODAL_TEXT')
            if(editorImageText === 'TEXT_EDITOR_IMAGE_MODAL_TEXT') 
              editorImageText = "You can add up to 7 images at once. There is no limit to the number of images in an announcement.";

            modalTitles[i].after(editorImageText);
          }
        }
      };
      editor$.find('.note-toolbar').click(function() {
        updateNgModel();

        // sync ngModel in codeview mode
        if (editor$.hasClass('codeview')) {
          editor$.on('keyup', updateNgModel);
          if (ngModel) {
            unwatchNgModel = scope.$watch(function () {
              return ngModel.$modelValue;
            }, function(newValue) {
              editor$.find('.note-codable').val(newValue);
            });
          }
        } else {
          editor$.off('keyup', updateNgModel);
          if (angular.isFunction(unwatchNgModel)) {
            unwatchNgModel();
          }
        }
      });

      if (ngModel) {
        ngModel.$render = function() {
          if (ngModel.$viewValue) {
            element.summernote('code', ngModel.$viewValue);
          } else {
            element.summernote('empty');
          }
        };
      }

      // set editable to avoid error:isecdom since Angular v1.3
      if (angular.isDefined($attrs.editable)) {
        $scope.editable = editor$.find('.note-editable');
      }
      if (angular.isDefined($attrs.editor)) {
        $scope.editor = element;
      }

      currentElement = element;
      // use jquery Event binding instead $on('$destroy') to preserve options data of DOM
      element.on('$destroy', function() {
        element.summernote('destroy');
        $scope.summernoteDestroyed = true;
      });
    };
  
    $scope.$on('$destroy', function () {
      // when destroying scope directly
      if (!$scope.summernoteDestroyed) {
        currentElement.summernote('destroy');
      }
    });
  }])
  .directive('summernote', [function() {
    'use strict';

    return {
      restrict: 'EA',
      transclude: 'element',
      replace: true,
      require: ['summernote', '?ngModel'],
      controller: 'SummernoteController',
      scope: {
        summernoteConfig: '=config',
        editable: '=',
        editor: '=',
        init: '&onInit',
        enter: '&onEnter',
        focus: '&onFocus',
        blur: '&onBlur',
        paste: '&onPaste',
        keyup: '&onKeyup',
        keydown: '&onKeydown',
        change: '&onChange',
        imageUpload: '&onImageUpload',
        mediaDelete: '&onMediaDelete'
      },
      template: '<div class="summernote"></div>',
      link: function(scope, element, attrs, ctrls, transclude) {
        var summernoteController = ctrls[0],
          ngModel = ctrls[1];
        if (!ngModel) {
            transclude(scope, function(clone, scope) {
              // to prevent binding to angular scope (It require `tranclude: 'element'`)
              element.append(clone.html());
            });
            summernoteController.activate(scope, element, ngModel);
          } else {
            var clearWatch = scope.$watch(function() { return ngModel.$viewValue; }, function(value) {
              clearWatch();
              element.append(value);
              summernoteController.activate(scope, element, ngModel);
            }, true);
          }
      }
    };
  }]);
})();

function dataURItoBlob(dataURI) {
  var byteString = atob(dataURI.split(',')[1]);
  var ab = new ArrayBuffer(byteString.length);
  var ia = new Uint8Array(ab);
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], { type: 'image/jpeg' });
}

(function () {

	'use strict';
	/**
	 * @ngdoc directive
	 * @name runmap:runmap
	 * @description
	 * <ul>
	 * <li>Displays a Google Maps</li>
	 * <li>Centers the map on parent</li>
	 * <li>Displays pins on the map from a parents array lat-long pairs</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */
	angular.module('directives.runmap', []).directive('runmap', runmap);
	/** @ngInject */
	function runmap(settings, $timeout) {

		var directive =  {
			restrict: 'EA',
			replace:true,
			scope:{
				config:'='
			},
			template:'<aside id="map"></aside>',
			link: linkFunction
		};

		return directive;

		function linkFunction(scope, elem, attrs) {

			var map;

			function addMarker(parent, isMe){
				if(parent.lat && parent.lng && parent.id){
					var marker = new google.maps.Marker({
						position: {'lat':parent.lat, 'lng':parent.lng},
						icon: (isMe ? 'assets/images/map-marker-me.svg' : 'assets/images/map-marker.svg'),
						animation: google.maps.Animation.DROP,
						map: map
					});
					marker.addListener('click', function(){
						scope.$emit('SHOW_MAP_PARENT', {'id':parent.id})
					})
				}
			}

			function init(config){
				var myPos = {'lat':parseFloat(config.currentParent.lat), 'lng':parseFloat(config.currentParent.lng)};
				map = new google.maps.Map(elem[0], {
					center: myPos || settings.runmap.default.london,
					zoom: settings.runmap.zoom
				});

				if(config.parents.length > 0){
					_.forEach(config.parents, function(parent){
						addMarker(parent, false)
					})
				}

				addMarker(config.currentParent, true)

				setTimeout(function() {
					google.maps.event.trigger(map, 'resize');
   					map.setCenter(myPos);
				}, 100);
			}

			scope.$watch('config', function(newVal){
				!_.isUndefined(newVal) && newVal.currentParent ? init(newVal) : _.noop()
			})

		}
	}

})();

(function () {

	'use strict';
	/**
	* @ngdoc directive
	* @name directives.charRemover:charRemover
	* @description
	* <ul>
	* <li>Watches the model and removes characters that doesn't pass the regex</li>
	* </ul>
	* @restrict E
	* @element
	*/

	angular.module('directives.removeChars',	[]).directive('removeChars', removeChars);
	/** @ngInject */
	function removeChars ($interpolate, $log, regexes) {
		var directive = {
			restrict:	'A',
			link:	linkFunction
		};
		return directive;

		function	linkFunction(scope,	elem,	attrs)	{
			var	regexp	=	new	RegExp(regexes[attrs.removeChars]);

			elem.on('paste', function(event){
				event.preventDefault();
			});

			elem.on('keypress', function(event)	{
				if(event && (event.keyCode === 8 || event.keyCode === 9)) {return}
				var char = String.fromCharCode(event.which),
					currentValue = elem.val(),
					target = event.target,
					type = target.getAttribute('type'),
					testString = elem.val() + char;

				if (type !== 'number'){
					var	selectionStart = target.selectionStart,
						selectionEnd = target.selectionEnd,
						startFraction = currentValue.substring(0, selectionStart),
						endFraction = currentValue.substring(selectionEnd);

					testString = startFraction + char + endFraction;
				}

				if (!regexp.test(testString)) {
					event.preventDefault();
				}
			});
		}
	}
})();

(function () {

	'use strict';
	/**
	 * @ngdoc directive
	 * @name prefix:prefix
	 * @description
	 * <ul>
	 * <li>Displays list of genders</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */
	angular.module('directives.preventScrolling', []).directive('preventScrolling', preventScrolling);
	/** @ngInject */
	function preventScrolling(base, $http) {

		var directive = {
			restrict: 'A',
			// scope: {
			// 	trigger : '@preventScrolling'
			// },
			link:linkFunction
		};
		return directive;

		function linkFunction(scope, element, attrs) {
			element.bind('mousewheel', function ( event ) {
			element[0].blur();
			} );
		}
	}

})();

(function () {

	'use strict';
	/**
	 * @ngdoc directive
	 * @name prefix:prefix
	 * @description
	 * <ul>
	 * <li>Displays list of country prefixes</li>
	 * <li>Flushes all notifications from the previous request</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */
	angular.module('directives.prefix', []).directive('prefix', prefix);
	/** @ngInject */
	function prefix(base, $http) {
		var directive = {
			restrict: 'EA',
			replace: true,
			scope:{
				ngModel: '='
			},
			template: [
				'<div class="prefix-picker svg">',
				'<button class="form-control prefix-button" ng-click="showDropdown = !showDropdown">',
				'<span translate="{{pholder}}" ng-hide="selectedCountry.shortName" class="pull-left"></span>',
				'<span ng-show="selectedCountry">',
				'{{selectedCountry.prefix }} {{selectedCountry.shortName}}',
				'</span>',
				'<span class="dripicons-chevron-down select-arrow"></span>',
				'</button>',
				'<ul class="dropdown-menu" ng-class=\"{\'show\':showDropdown}\">',
				'<li><input type="search" class="form-control" placeholder=\"{{ \'FILTER_TXT \'| translate }}\" ng-model="filterCountries"/></li>',
				'<li ng-repeat="country in countries | filter: filterCountries">',
				'<a ng-click="updateCountryCode(country)">',
				'<span>+{{::country.prefix }}</span> <span>{{::country.longName }}</span>',
				'</a>',
				'</li>',
				'</ul>',
				'</div>'
			].join(''),
			link: linkFunction
		}

		return directive

		function linkFunction(scope, elem, attrs) {
			scope.countries = [];
			scope.selectedCountry = {};
			scope.showDropdown = false;
			scope.isRequired = scope.$eval(attrs.isRequired);
			scope.pholder = '';
			if(scope.isRequired){
				scope.pholder = 'PREFIX_PHOLDER'
			} else {
				scope.pholder = 'PREFIX_PHOLDER_NON_REQ'
			}
			scope.updateCountryCode = function (country) {
				scope.ngModel = country.id;
				scope.selectedCountry = country;
				scope.showDropdown = false;
			};
			scope.$watch('ngModel', function (newVal, oldVal) {
				if(newVal !== -1){
					try {
						var country = _.find(scope.countries, {'id':newVal});
						scope.updateCountryCode(country)
					} catch(e){}
				}
			})

			$http.get('i8n/locale-metadata-en-GB.json?v=12').then(function(data) {
   				scope.countries = data.data.metadata.countries;
			});
		}

	}

})();

(function () {
	"use strict";

	angular
		.module("directives.postComments", ["directives.postAsset"])
		.directive("postComments", postComments);

	/** @ngInject */
	function postComments(
		postAssetService,
		toastr,
		$rootScope,
		$translate,
		regexes,
		settings,
		$sce,
		$uibModal,
		$compile,
		$state
	) {
		var directive = {
			restrict: "EA",
			replace: true,
			scope: {
				postContent: "@",
				postContext: "@",
				updateComments: "&updateComments",
				userAvatar: "@",
				userRole: "@",
				userName: "@",
				userId: "@",
				postUserId: "=",
				commentOnly: "=",
			},
			templateUrl: "app/base/directives/postComments.directive.html",
			link: linkFunction,
		};
		return directive;

		function linkFunction(scope, elem, attrs) {
			scope.post = angular.fromJson(attrs.postContent);
			scope.commentOnly = attrs.commentOnly;
			scope.postId = scope.post.id;
			scope.trustAsHtml = function (string) {
				return $sce.trustAsHtml(string);
			};

			setTimeout(function () {
				if ($rootScope.getQueryParam("cid")) {
					var found = false;
					for (var i = 0; i < scope.post.comments.length; i++) {
						var c = scope.post.comments[i];
						if (c.id === $rootScope.getQueryParam("cid")) {
							found = true;
							break;
						}
					}

					if (found) {
						var scroll_to_comment = document.getElementById(
							"comment_" + $rootScope.getQueryParam("cid")
						);
						if (scroll_to_comment) {
							scroll_to_comment.scrollIntoView();
							window.scrollBy(0, -130);
						}
					} else {
						toastr.info($translate.instant("COMMENT_BEEN_DELETED"));
					}
				}
			}, 600);

			scope.context = scope.postContext;
			var el = angular.element(elem);

			scope.isPostView = function () {
				return location.href.indexOf("#/post/") !== -1;
			};

			if (getMobileOperatingSystem() === "Android") {
				handlePDF(scope.post);
			}
			/*
			 * This function checks the attachment and if it's a PDF, change the url to open preview it in Google PDF Viewer.
			 */
			function handlePDF(post) {
				if (post.files && post.files.length > 0) {
					for (var i = 0; i < post.files.length; i++) {
						if (
							post.files[i].ext == "pdf" &&
							post.files[i].url.indexOf("viewerng") === -1
						) {
							post.files[i].url =
								"https://docs.google.com/viewerng/viewer?url=" +
								post.files[i].url;
						}
						continue;
					}
				} else {
					return;
				}
			}

            function validator() {

                if (scope.postContent) {
                    var p = angular.fromJson(scope.postContent),
                        valid = p.hasOwnProperty('postedBy') && !_.isEmpty(p.postedBy) &&
                        p.hasOwnProperty('postedOn') && !_.isEmpty(p.postedOn) &&
                        //p.hasOwnProperty('avatar') && !_.isEmpty(p.avatar) &&
                        p.hasOwnProperty('userId') && !_.isUndefined(p.userId) &&
                        p.hasOwnProperty('isOwn') && !_.isUndefined(p.isOwn) &&
                        p.hasOwnProperty('isLiked') && !_.isUndefined(p.isLiked) &&
                        p.hasOwnProperty('likeCount') && !_.isUndefined(p.likeCount) &&
                        p.hasOwnProperty('commentCount') && !_.isUndefined(p.commentCount) &&
                        p.hasOwnProperty('id') && !_.isUndefined(p.id);

                    if (valid) {
                        scope.post = p;

                        if (scope.post.type === 'classlist') {
                            scope.post.body = scope.post.body;
                        } else {
                            scope.post.body = $rootScope.parseMentionTags(scope.post.body);
                            scope.post.body = $rootScope.parseLinks(scope.post.body);
                        }

                        if (scope.post.comments) {
                            _.each(scope.post.comments, function(item, i) {
                                item.body = $rootScope.parseMentionTags(item.body);
                                item.body = $rootScope.parseLinks(item.body);
                                item.hasReply = item.totalReplyCount > 0;
                                if(item.totalReplyCount > 0){
                                    _.each(item.replies, function(reply, j) {
                                        reply.body = $rootScope.parseMentionTags(reply.body);
                                        reply.body = $rootScope.parseLinks(reply.body);
                                    });
                                }
                            });
                        }
                    } else {
                        el.remove();
                        console.error('something wrong with post: ', p)
                    }

                } else {
                    el.remove();
                }
            }

            if (!angular.fromJson(scope.postContent).hasOwnProperty('isAdv'))
                validator()
			scope.likeComment = function (comm) {
				if (comm.liked) {
					//remove yourself from the array
					if (comm.lastLike) {
						var index = comm.lastLike.indexOf(
							$rootScope.active_user.firstName +
								" " +
								$rootScope.active_user.lastName
						);
						if (index >= 0) {
							comm.lastLike.splice(index, 1);
						}
					}
					//then
					comm.liked = false;
					comm.likeCount--;
				} else {
					comm.liked = true;

					if (!comm.likeCount) comm.likeCount = 0;

					comm.likeCount++;

					if (!scope.post.isFollowed) scope.followPost();
				}

				postAssetService.put("post/v1/like/comment/" + comm.id, {}).then(
					function (res) {
						// post like response
						//there is no response
					},
					function () {
						comm.liked = false;
					}
				);
			};

			scope.showCommLikers = function (comm) {
				postAssetService
					.get("post/v1/likes/comment/" + comm.id, { cache: false })
					.then(function (response) {
						scope.likers = response.data.payload;
						//scope.likers.type = post.type;
						$rootScope.$broadcast("POST_LIKES", scope.likers);
					});
			};

			scope.openUserHome = function (id, post) {
				if (post) {
					if (post.type === "classlist") {
						return;
					}
				}

				$rootScope.$broadcast("ON_POST_VIEW_OPEN");
				location.href = "#/classlist/details/" + id + "/contact";
			};

			scope.openCommentImage = function (url) {
				if ($rootScope.isNative) {
					$rootScope.previewImage(url);
				} else {
					window.open(url + "=s0", "_blank");
				}
			};

			scope.getMoreComments = function (post) {
				post.hideMoreComm = true;

				postAssetService.get("post/v1/comment/" + scope.post.id, {}).then(
					function (response) {
						scope.post.comments = [];

						var cmmnts = response.data.payload.comments;
						_.each(cmmnts, function (item) {
							item.body = $rootScope.parseMentionTags(item.body);
							item.body = $rootScope.parseLinks(item.body);
							_.each(item.replies, function (reply) {
								reply.body = $rootScope.parseMentionTags(reply.body);
								reply.body = $rootScope.parseLinks(reply.body);
							});
						});

						scope.post.comments = cmmnts;
					},
					function (error) {
						console.log(error);
					}
				);
			};

			scope.getMoreReplies = function (comment) {
				//post.hideMoreComm = true;

				postAssetService.get("post/v1/commentReplies/" + comment.id, {}).then(
					function (response) {
						comment.replies = [];

						var cmmnts = response.data.payload.comments;
						_.each(cmmnts, function (item) {
							item.body = $rootScope.parseMentionTags(item.body);
							item.body = $rootScope.parseLinks(item.body);
						});

						comment.replies = cmmnts;
					},
					function (error) {
						console.log(error);
					}
				);
			};

			scope.deleteComment = function (commentId) {
				_.each(scope.post.comments, function (item, i) {
					if (item && item.id === commentId) {
						scope.post.comments.splice(i, 1);
						scope.post.commentCount--;
						if (scope.updateComments) {
							scope.updateComments({ post: scope.post });
						}
						return;
					}
				});
				postAssetService
					.delete(
						"post/v1/comment/" + scope.post.id + "/delete/" + commentId,
						{}
					)
					.then(
						function (response) {
							toastr.info($translate.instant("COMMENT_DELETED"));
						},
						function (error) {}
					);
			};

			scope.deleteReplyComment = function (commentId, replyId) {
				_.each(scope.post.comments, function (item, i) {
					if (item && item.id === commentId) {
						_.each(item.replies, function (itemReplies, j) {
							if (itemReplies && itemReplies.id === replyId) {
								item.replies.splice(j, 1);
								item.totalReplyCount--;
								return;
							}
						});
					}
				});

				postAssetService
					.delete("post/v1/comment/" + scope.post.id + "/delete/" + replyId, {})
					.then(
						function (response) {
							toastr.info($translate.instant("COMMENT_DELETED"));
						},
						function (error) {}
					);
			};

			scope.replyComment = function (comment, mentionUserId, mentionUserName) {
				var parent = document.getElementById("cmt_" + comment.id);

				var composer = document.getElementById("reply_" + comment.id);
				if (composer) {
					//if composer already defined..
					//remove it
					angular.element(composer).remove();
				}
				var elementHtml = "";
				if (mentionUserId && mentionUserName) {
					elementHtml =
						'<div id="reply_' +
						comment.id +
						'" class="vi-col-middle" style="width:90%; float: right; margin-right: 15px;"><div class="comment-composer"><comment-composer post-id="' +
						scope.post.id +
						'" reply-to-user-id="' +
						mentionUserId +
						'" reply-to-user-name="' +
						mentionUserName +
						'" comment-id="' +
						comment.id +
						'" user-avatar="userAvatar" events="events"></comment-composer></div></div>';
				} else {
					elementHtml =
						'<div id="reply_' +
						comment.id +
						'" class="vi-col-middle" style="width:90%; float: right; margin-right: 15px;"><div class="comment-composer"><comment-composer post-id="' +
						scope.post.id +
						'" comment-id="' +
						comment.id +
						'" user-avatar="userAvatar" events="events"></comment-composer></div></div>';
				}

				//directive is ready to compile
				var el = $compile(elementHtml)(scope);
				angular.element(parent).append(el);
			};
			scope.events = {
				commentCallback: function (comment) {
					if (!scope.post.comments) {
						scope.post.comments = [];
					}
					comment.avatar = $rootScope.active_user.avatar;
					comment.postedBy =
						$rootScope.active_user.firstName +
						" " +
						$rootScope.active_user.lastName;
					comment.body = $rootScope.parseMentionTags(comment.body);
					comment.body = $rootScope.parseLinks(comment.body);
					scope.post.comments.push(comment);
					scope.post.commentCount++;
					if (scope.updateComments) {
						scope.updateComments({ post: scope.post });
					}
					if (!scope.post.isFollowed) {
						scope.followPost();
					}
				},
				commentReplyCallback: function (comment, parentCommentId) {
					comment.avatar = $rootScope.active_user.avatar;
					comment.postedBy =
						$rootScope.active_user.firstName +
						" " +
						$rootScope.active_user.lastName;
					comment.body = $rootScope.parseMentionTags(comment.body);
					comment.body = $rootScope.parseLinks(comment.body);
					_.each(scope.post.comments, function (item, i) {
						if (item.id == parentCommentId) {
							if (!item.replies) {
								item.replies = [];
								item.totalReplyCount = 0;
							}
							item.replies.push(comment);
							item.totalReplyCount++;
							item.replying = false;
						}
					});

					if (!scope.post.isFollowed) {
						scope.followPost();
					}

					//hide reply section
					document.getElementById("reply_" + parentCommentId).remove();
				},
			};
		}
	}
})();

(function () {

	'use strict';

	/**
	 * @ngdoc directive
	 * @name avatar:avatar
	 * @description
	 * <ul>
	 * <li>Display a post nugget with avatar, likes, comments etc...</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */

	angular.module('directives.postAsset', []).factory('postAssetService', ['base', function (base) {
		return _.create(base, {});
	}]).directive('postAsset', postAsset);
	/** @ngInject */
	function postAsset(postAssetService, toastr, $rootScope, $translate, regexes, settings, $sce, $uibModal, $compile,  $state) {
		var directive = {
			restrict: 'EA',
			replace: true,
			scope: {
				postContent: '@',
                postContext: '@',
                updateComments: '&updateComments',
				userAvatar: '@',
				userRole: '@',
				userName: '@',
				postEvents: '=',
				userId: '@',
                postUserId: '=',
                commentOnly: '=',
                isCommentAndLikeDisabled: '=',
                isCommentDisabled: '=',
                onEditAnnouncement: '&',
                onDeleteAnnouncement: '&',
                onDuplicateAnnouncement: '&',
			},
			templateUrl: 'app/base/directives/postAsset.directive.html',
			link: linkFunction
		};
		return directive;

        function linkFunction(scope, elem, attrs) {
            var stripe;
            var card;
            scope.post = angular.fromJson(attrs.postContent);
            scope.commentOnly = attrs.commentOnly;
            scope.isCommentAndLikeDisabled = attrs.isCommentAndLikeDisabled;
            scope.postId = scope.post.id;
            scope.isCommentDisabled = attrs.isCommentDisabled;
            scope.trustAsHtml = function(string) {
                return $sce.trustAsHtml(string);
            };

            setTimeout(function() {
                if ($rootScope.getQueryParam('cid')) {

                    var found = false;
                    for (var i = 0; i < scope.post.comments.length; i++) {
                        var c = scope.post.comments[i]
                        if (c.id === $rootScope.getQueryParam('cid')) {
                            found = true;
                            break;
                        }
                    }

                    if (found) {
                        var scroll_to_comment = document.getElementById('comment_' + $rootScope.getQueryParam('cid'));
                        if (scroll_to_comment) {
                            scroll_to_comment.scrollIntoView();
                            window.scrollBy(0, -130);
                        }
                    } else {
                        toastr.info($translate.instant('COMMENT_BEEN_DELETED'));
                    }
                }
            }, 600);

            scope.context = scope.postContext;
            var el = angular.element(elem);

            scope.categories = [
                "general",
                "lost_found",
                "offer",
                "wanted",
                "free"
            ];

            scope.initStripe = function() {
                try {
                    //stripe = Stripe(settings.conf.stripeKey);
                    //var elements = stripe.elements();

                    var style = {
                        base: {
                            color: '#32325d',
                            lineHeight: '18px',
                            fontFamily: '"Nunito Sans", sans-serif',
                            fontSmoothing: 'antialiased',
                            fontSize: '16px',
                            '::placeholder': {
                                color: '#aab7c4'
                            }
                        },
                        invalid: {
                            color: '#fa755a',
                            iconColor: '#fa755a'
                        }
                    };

                    // Create an instance of the card Element.
                    card = elements.create('card', { style: style });

                    // Add an instance of the card Element into the `card-element` <div>.
                    card.mount('#card-element-1');

                    // Handle real-time validation errors from the card Element.
                    card.addEventListener('change', function(event) {
                        var displayError = document.getElementById('card-errors-1');

                        if (event.error) {
                            displayError.textContent = event.error.message;
                        } else {
                            displayError.textContent = '';
                        }
                    });
                } catch (ex) {
                    //Skip for now.
                }
            }

            scope.stripeSubmit = function(p) {
                scope.paymentConfirmed = false;

                var payload = {
                    id: p.id,
                    token: ''
                };

                if (scope.buingTickets)
                    return;

                scope.buingTickets = true;

                stripe.createPaymentMethod('card', card).then(function(result) {
                    if (result.error) {
                        scope.buingTickets = false;
                        var errorElement = document.getElementById('card-errors-1');
                        if (errorElement)
                            errorElement.textContent = result.error.message;

                        setTimeout(function() {
                            scope.$apply()
                        }, 1);
                    } else {
                        payload.token = result.paymentMethod.id;
                        postAssetService.post('payment/v1/marketplace/payment/stripe', payload, {
                                'cache': false,
                                'xhr': true
                            })
                            .then(function(response) {
                                    if (response && response.data) {
                                        if (response.data.requiresAction) {
                                            handleAction(response.data);
                                            return;
                                        }
                                    }

                                    if (response.data) {
                                        if (response.data.logId) {
                                            scope.paymentConfirmed = true;
                                        }
                                    }

                                    setTimeout(function() {
                                        scope.$apply()
                                    }, 2);
                                },
                                function(error) {
                                    scope.buingTickets = false;

                                    if (error.data.error.message) {
                                        toastr.info(error.data.error.message);
                                    } else {
                                        toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
                                    }

                                    setTimeout(function() {
                                        scope.$apply()
                                    }, 3);
                                });
                    }
                });
            }

            function handleAction(response) {
                stripe.handleCardAction(response.clientSecret).then(function(result) {
                    if (result.error) {
                        scope.buingTickets = false;
                        toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
                    } else {
                        postAssetService.post('payment/v1/marketplace/paymentIntent/confirm', {
                                logId: response.logId
                            }, {
                                'Content-Type': 'application/json',
                                'cache': false,
                                'xhr': true
                            })
                            .then(function(resp) {
                                    scope.buingTickets = false;

                                    if (response) {
                                        if (response.logId) {
                                            scope.paymentConfirmed = true;
                                        }
                                    }

                                    setTimeout(function() {
                                        scope.$apply()
                                    }, 4);
                                },
                                function(error) {
                                    scope.buingTickets = false;

                                    if (error.data.error.message) {
                                        toastr.info(error.data.error.message);
                                    } else {
                                        toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
                                    }
                                });
                    }
                });
            }

            scope.isPostView = function() {
                return location.href.indexOf('#/post/') !== -1;
            }

            if (scope.isPostView()) {
                scope.initStripe()
            }

            scope.getPostGroups = function(post) {

                var modalInstance = $uibModal.open({
                    animation: true,
                    backdropClass: 'backdrop-zindexed',
                    templateUrl: 'app/home/views/post-groups-modal.html',
                    controller: function($scope) {

                        postAssetService.get('post/v1/get/' + post.id + '/groups', {}).then(function(res) {
                                $scope._groups = res.data.items;
                            },
                            function(error) {

                            });

                        scope.openGroup = function(group) {
                            modalInstance.close();
                            location.href = '#/groups/view/' + group.id;
                        }

                        $scope.close = function() {
                            modalInstance.close();
                        };
                    }
                });
            }
            scope.openGroup = function(group) {
                location.href = '#/groups/view/' + group;
            }

            scope.getAnnHeight = function() {
                var h = document.querySelector('[post-id="' + scope.post.id + '"]');
                var height = h ? h.offsetHeight : 0;
                return height;
            }

            scope.openPicture = function(files, current) {
                if ($rootScope.isNative) {
                    var pictures = new Array()
                    pictures.push(current.url)

                    for (var i = 0; i < files.length; i++) {
                        var file = files[i];

                        if (file.name === current.name)
                            continue;

                        if (file.ext) {
                            if (file.ext.toLowerCase() !== 'png' &&
                                file.ext.toLowerCase() !== 'gif' &&
                                file.ext.toLowerCase() !== 'bmp' &&
                                file.ext.toLowerCase() !== 'jpg' &&
                                file.ext.toLowerCase() !== 'jpeg')
                                continue;
                        }

                        pictures.push(file.url)
                    }

                    $rootScope.previewImages(pictures)
                } else {
                    window.open(current.url + '=s0', '_blank')
                }
            }

            scope.getPostPictures = function(attachments) {
                var pictures = new Array()
                var cssclass = '';

                if (!attachments)
                    return {
                        cssclass: cssclass,
                        pictures: pictures
                    }

                for (var i = 0; i < attachments.length; i++) {
                    if (attachments[i].ext) {
                        if (attachments[i].ext.toLowerCase() === 'png' ||
                            attachments[i].ext.toLowerCase() === 'gif' ||
                            attachments[i].ext.toLowerCase() === 'bmp' ||
                            attachments[i].ext.toLowerCase() === 'jpg' ||
                            attachments[i].ext.toLowerCase() === 'jpeg') {
                            pictures.push(attachments[i])
                        }
                    } else {
                        pictures.push(attachments[i])
                    }
                }

                if (pictures.length === 1)
                    cssclass = 'single-picture';
                else if (pictures.length === 2)
                    cssclass = 'double-picture';
                else if (pictures.length === 3 || pictures.length > 3)
                    cssclass = 'multi-picture';

                return {
                    cssclass: cssclass,
                    pictures: pictures
                }
            }
            if (getMobileOperatingSystem() === 'Android') {
                handlePDF(scope.post);
            }
            /*
             * This function checks the attachment and if it's a PDF, change the url to open preview it in Google PDF Viewer.
             */
            function handlePDF(post) {
                if (post.files && post.files.length > 0) {
                    for (var i = 0; i < post.files.length; i++) {
                        if (post.files[i].ext == 'pdf' && post.files[i].url.indexOf("viewerng") === -1) {
                            post.files[i].url = 'https://docs.google.com/viewerng/viewer?url=' + post.files[i].url
                        }
                        continue;
                    }
                } else {
                    return;
                }
            }

            scope.getAttUrl = function() {
                return att.url;
            }

            scope.togglePostMenu = function(post) {
                if (post.menuOpened) {
                    post.menuOpened = false;
                } else {
                    post.menuOpened = true;
                }
            }

            scope.getPostPicture = function() {
                if (!scope.post || !scope.post.attachments)
                    return '';

                if (!scope.getPostPictures(scope.post.attachments))
                    return '';

                if (!scope.getPostPictures(scope.post.attachments).pictures || scope.getPostPictures(scope.post.attachments).pictures.length === 0)
                    return '';

                if (!scope.getPostPictures(scope.post.attachments).pictures[0])
                    return '';

                return scope.getPostPictures(scope.post.attachments).pictures[0].url + (!scope.post.event ? '=s0' : '');
            }

            scope.getEventDescription = function(descr) {
                descr = $rootScope.parseLinks(descr);
                descr = descr.replace(/\r?\n/g, '<br />');
                return descr;
            }

            scope.gotoListings = function(cat) {
                //Emese 19/09/17 - for callingwithout category
                if (_.isUndefined(cat)) {
                    location.href = '#/listings/list/'
                } else {
                    $rootScope.sListCategory = cat;
                    location.href = '#/listings/list/' + cat;
                }
            }

            scope.getDonationPrice = function() {
                if (scope.post.ptaPercentage === 0)
                    return 0;

                return ((scope.post.ptaPercentage) * hasPrice()).toFixed(2);
            }

            scope.hasPrice = function() {
                return scope.post.priceAsDouble;
            }

            function validator() {

                if (scope.postContent) {
                    var p = angular.fromJson(scope.postContent),
                        valid = p.hasOwnProperty('postedBy') && !_.isEmpty(p.postedBy) &&
                        p.hasOwnProperty('postedOn') && !_.isEmpty(p.postedOn) &&
                        //p.hasOwnProperty('avatar') && !_.isEmpty(p.avatar) &&
                        p.hasOwnProperty('userId') && !_.isUndefined(p.userId) &&
                        p.hasOwnProperty('isOwn') && !_.isUndefined(p.isOwn) &&
                        p.hasOwnProperty('isLiked') && !_.isUndefined(p.isLiked) &&
                        p.hasOwnProperty('likeCount') && !_.isUndefined(p.likeCount) &&
                        p.hasOwnProperty('commentCount') && !_.isUndefined(p.commentCount) &&
                        p.hasOwnProperty('id') && !_.isUndefined(p.id);

                    if (valid) {
                        scope.post = p;

                        if (scope.post.type === 'classlist') {
                            scope.post.body = scope.post.body;
                        } else {
                            scope.post.body = $rootScope.parseMentionTags(scope.post.body);
                            scope.post.body = $rootScope.parseLinks(scope.post.body);
                        }

                        if (scope.post.comments) {
                            _.each(scope.post.comments, function(item, i) {
                                item.body = $rootScope.parseMentionTags(item.body);
                                item.body = $rootScope.parseLinks(item.body);
                                item.hasReply = item.totalReplyCount > 0;
                                if(item.totalReplyCount > 0){
                                    _.each(item.replies, function(reply, j) {
                                        reply.body = $rootScope.parseMentionTags(reply.body);
                                        reply.body = $rootScope.parseLinks(reply.body);
                                    });
                                }
                            });
                        }
                    } else {
                        el.remove();
                        console.error('something wrong with post: ', p)
                    }

                } else {
                    el.remove();
                }
            }

            if (!angular.fromJson(scope.postContent).hasOwnProperty('isAdv'))
                validator()

            scope.likePost = function(post) {
                if (scope.post.isLiked) {
                    //remove yourself from the array
                    if (scope.post.lastLike) {
                        var index = scope.post.lastLike.indexOf($rootScope.active_user.firstName + ' ' + $rootScope.active_user.lastName);
                        if (index >= 0) {
                            scope.post.lastLike.splice(index, 1);
                        }
                    }
                    //then
                    scope.post.isLiked = false;
                    scope.post.likeCount--;
                } else {
                    scope.post.isLiked = true;
                    scope.post.likeCount++

                        if (!post.isFollowed)
                            scope.followPost()
                }

                postAssetService.put('post/v1/like/' + scope.post.id, {}).then(function(res) {
                        // post like response
                    },
                    function() {
                        scope.post.isLiked = false;
                    })
            }

            scope.thankPost = function(post) {

                if (!scope.post.thankCount)
                    scope.post.thankCount = 0;

                if (scope.post.isThanked) {
                    //remove yourself from the array
                    if (scope.post.lastThank) {
                        var index = scope.post.lastThank.indexOf($rootScope.active_user.firstName + ' ' + $rootScope.active_user.lastName);
                        if (index >= 0) {
                            scope.post.lastThank.splice(index, 1);
                        }
                    }
                    //then
                    scope.post.isThanked = false;
                    scope.post.thankCount--;
                } else {
                    scope.post.isThanked = true;
                    scope.post.thankCount++;
                }

                postAssetService.put('post/v1/thank/' + scope.post.id, {}).then(function(res) {
                        // post thank response
                    },
                    function() {
                        scope.post.isThank = false;
                    })
            }

            scope.likeComment = function(comm) {
                if (comm.liked) {
                    //remove yourself from the array
                    if (comm.lastLike) {
                        var index = comm.lastLike.indexOf($rootScope.active_user.firstName + ' ' + $rootScope.active_user.lastName);
                        if (index >= 0) {
                            comm.lastLike.splice(index, 1);
                        }
                    }
                    //then
                    comm.liked = false;
                    comm.likeCount--;
                } else {
                    comm.liked = true;

                    if (!comm.likeCount)
                        comm.likeCount = 0;

                    comm.likeCount++;

                    if (!scope.post.isFollowed)
                        scope.followPost()
                }

                postAssetService.put('post/v1/like/comment/' + comm.id, {}).then(function(res) {
                        // post like response
                        //there is no response
                    },
                    function() {
                        comm.liked = false;
                    })
            }

            scope.edit = function() {
                if (scope.post.type === 'listing') {
                    location.href = '#/marketplace/post/' + scope.post.id;
                } else {
                    location.href = '#/edit/' + scope.post.id;
                }
            };

            scope.gotoCategory = function(cat, groupid, isgroup) {
                    if (!isgroup) {
                        $rootScope.sListCategory = cat;
                        location.href = settings.conf.parentAppURL + '#/listings/list/' + cat;
                    } else {
                        location.href = settings.conf.parentAppURL + '#/groups/view/' + groupid;
                    }
                }
                //Take user to that group's stream.
            scope.onGroupTap = function(groupid) {
                scope.onGroupNameTap({ group: groupid });
            }

            scope.doInt = function(value) {
                if (!value)
                    return '';

                if (isNaN(value))
                    return '';

                return parseInt(value)
            }

            scope.previewPhoto = function(photo) {
                var photos = [photo];
                $rootScope.previewImages(photos);
            }

            scope.deletePost = function() {
                var modalInstance = $uibModal.open({
                    animation: true,
                    templateUrl: 'app/home/views/delete-post-modal.html',
                    backdropClass: 'backdrop-zindexed',
                    size: 'sm',
                    controller: function($scope) {

                        $scope.confirm = function() {
                            postAssetService.delete('post/v1/delete/' + scope.post.id, {}).then(function() {
                                toastr.info($translate.instant('POST_DELETED'));
                                el.remove();

                                if (location.href.includes('/post/')) {
                                    if (scope.post.type === 'listing') {
                                        location.href = '#/listings/list/';
                                    } else {
                                        location.href = '/#';
                                    }
                                }

                                if (location.href.includes('listings')) {
                                    $rootScope.$broadcast('REFRESH_MY_MARKETPLACE');
                                }

                                if (location.href.includes('home')) {
                                    scope.postEvents.removeFromPosts(scope.post.id);
                                }

                                modalInstance.close();
                            }, function(error) {

                            });
                        }

                        $scope.close = function() {
                            modalInstance.close();
                        }
                    }
                })
            }

            scope.lockComments = function() {

                var modalInstance = $uibModal.open({
                    animation: true,
                    templateUrl: 'app/announcements/views/lock-comment-modal.html',
                    backdropClass: 'backdrop-zindexed',
                    size: 'md',
                    controller: function($scope) {
                        $scope.isLocked = scope.post.commentLocked
                        $scope.confirm = function() {
                            postAssetService.put('post/v1/update/' + scope.post.id + '/commentLock', {}).then(function() {
                                if(scope.post.commentLocked){
                                    toastr.info($translate.instant('COMMENT_UNLOCKED'));
                                }
                                else toastr.info($translate.instant('COMMENT_LOCKED'));
                                
                                $state.reload();
                                modalInstance.close();
                            }, function(error) {

                            });
                        }

                        $scope.close = function() {
                            modalInstance.close();
                        }
                    }
                })

            } 

            scope.markSold = function() {
                var modalInstance = $uibModal.open({
                    animation: true,
                    templateUrl: 'app/home/views/mark-sold-modal.html',
                    backdropClass: 'backdrop-zindexed',
                    size: 'sm',
                    controller: function($scope) {

                        $scope.confirm = function() {
                            postAssetService.get('post/v1/mark/sold/' + scope.post.id, {}).then(function() {
                                    scope.post.sold = true;
                                    modalInstance.close();
                                },
                                function(error) {

                                });
                        }

                        $scope.close = function() {
                            modalInstance.close();
                        }
                    }
                })
            }

            scope.openMarketplace = function(post) {
                $rootScope.$broadcast('ON_POST_VIEW_OPEN');
                location.href = '#/post/' + post.id;
            }

            scope.composeTo = function(data) {
                $rootScope.composeTo(data)
            }

            scope.markUnsold = function() {
                postAssetService.get('post/v1/mark/sold/' + scope.post.id, {}).then(function() {
                        scope.post.sold = false;
                    },
                    function(error) {

                    });
            }

            scope.showLikers = function(post) {
                postAssetService.get('post/v1/likes/' + post.id, { 'cache': false }).then(function(response) {
                    scope.likers = response.data.payload;
                    scope.likers.type = post.type;
                    $rootScope.$broadcast('POST_LIKES', scope.likers);
                });
            }

            scope.showThankers = function(post) {
                postAssetService.get('post/v1/thanks/' + post.id, { 'cache': false }).then(function(response) {
                    scope.thanks = response.data.payload;
                    scope.thanks.type = 'thanks';
                    $rootScope.$broadcast('POST_LIKES', scope.thanks);
                });
            }

            scope.showCommLikers = function(comm) {
                postAssetService.get('post/v1/likes/comment/' + comm.id, { 'cache': false }).then(function(response) {
                    scope.likers = response.data.payload;
                    //scope.likers.type = post.type;
                    $rootScope.$broadcast('POST_LIKES', scope.likers);
                });
            }

            scope.sendMessage = function() {
                var name = scope.post.postedBy.split(' ');
                scope.$emit('COMPOSE_TO', {
                    'firstName': name[0] || '',
                    'lastName': name[1] || '',
                    'id': scope.post.userId,
                    'avatar': scope.post.avatar
                })
            }

            scope.openUserHome = function(id, post) {
                if (post) {
                    if (post.type === 'classlist') {
                        return;
                    }
                }

                $rootScope.$broadcast('ON_POST_VIEW_OPEN');
                location.href = '#/classlist/details/' + id + '/contact';
            }

            scope.openPost = function(post) {

                if (post.event) {
                    location.href = '#/events/view/' + post.event.id;
                    return;
                }

                if (post.type === 'listing') {
                    scope.openMarketplace(post)
                    return;
                }

                if (!post.attachments || post.attachments.length === 0)
                    return;

                if (post.attachments.length === 1) {
                    if ($rootScope.isNative) {
                        $rootScope.previewImage(post.attachments[0].url)
                    } else {
                        window.open(post.attachments[0].url + '=s0', '_blank')
                    }
                } else if (post.attachments.length > 1) {
                    $rootScope.$broadcast('ON_POST_VIEW_OPEN');
                    location.href = '#/post/' + post.id;
                }
            }
            scope.openCommentImage = function(url){
                if ($rootScope.isNative) {
                    $rootScope.previewImage(url)
                } else {
                    window.open(url + '=s0', '_blank')
                }
            }

            scope.openClasslistPost = function(post) {
                if (post.attachments.length > 0) {
                    if (post.attachments[0].redirection) {
                        window.open(post.attachments[0].redirection, '_blank')
                        return;
                    }
                }
            }

            scope.reportPost = function() {

                var modalInstance = $uibModal.open({
                    animation: true,
                    backdropClass: 'backdrop-zindexed',
                    templateUrl: 'app/base/directives/postAsset.confirmReportModal.directive.html',
                    controller: function($scope) {
                        $scope.viewState = {
                            isReady: true
                        };


                        $scope.close = function() {
                            modalInstance.close();
                        };

                        $scope.report = function() {
                            $scope.viewState.isReady = false;
                            postAssetService.put('post/v1/report/' + scope.post.id, {}).then(function() {
                                $scope.viewState.isReady = true;
                                toastr.info($translate.instant('REPORTED_POST'))
                                modalInstance.close();
                            }, function() {
                                $scope.viewState.isReady = true;
                            });
                        }

                    },
                    size: 'sm'
                });
            }

            scope.followPost = function(callapi) {
                if (!scope.post.isFollowed) {
                    scope.post.isFollowed = true;

                    if (callapi)
                        postAssetService.get('follow/v1/add/' + scope.post.id + '/follow/POST/' + $rootScope.active_school.id, {}).then(function(res) {

                        }, function() {});
                } else {
                    scope.post.isFollowed = false;

                    if (callapi)
                        postAssetService.delete('follow/v1/remove/' + scope.post.id + '/follow/POST/' + $rootScope.active_school.id, {}).then(function(res) {

                        }, function() {});
                }
            }

            scope.getMoreComments = function(post) {
                post.hideMoreComm = true;

                postAssetService.get('post/v1/comment/' + scope.post.id, {}).then(function(response) {
                    scope.post.comments = [];

                    var cmmnts = response.data.payload.comments;
                    _.each(cmmnts, function(item) {
                        item.body = $rootScope.parseMentionTags(item.body);
                        item.body = $rootScope.parseLinks(item.body);
                        _.each(item.replies, function(reply) {
                            reply.body = $rootScope.parseMentionTags(reply.body);
                            reply.body = $rootScope.parseLinks(reply.body);
                        });
                    });

                    scope.post.comments = cmmnts;
                }, function(error) {
                    console.log(error);
                })
            }

            scope.getMoreReplies = function(comment) {
                //post.hideMoreComm = true;

                postAssetService.get('post/v1/commentReplies/' + comment.id, {}).then(function(response) {
                    comment.replies = [];

                    var cmmnts = response.data.payload.comments;
                    _.each(cmmnts, function(item) {
                        item.body = $rootScope.parseMentionTags(item.body);
                        item.body = $rootScope.parseLinks(item.body);
                    });

                    comment.replies = cmmnts;
                }, function(error) {
                    console.log(error);
                })
            }

            scope.isCommentLinkVisible = function() {
                var totalNumReached = false;
                if (scope.post) {
                    if (scope.post.comments) {
                        totalNumReached = scope.post.comments.length === scope.post.commentCount;
                    }
                }
                return scope.post.commentCount > 2 && !totalNumReached && scope.postContext !== 'GROUP_LIST_VIEW';
            }

            scope.deleteComment = function(commentId) {
                _.each(scope.post.comments, function(item, i) {
                    if (item && item.id === commentId) {
                        scope.post.comments.splice(i, 1);
                        scope.post.commentCount--;
                        return;
                    }
                });
                postAssetService.delete('post/v1/comment/' + scope.post.id + '/delete/' + commentId, {}).then(function(response) {
                    toastr.info($translate.instant('COMMENT_DELETED'));

                }, function(error) {

                })
            }

            scope.deleteReplyComment = function(commentId, replyId) {
                _.each(scope.post.comments, function(item, i) {
                    if (item && item.id === commentId) {
                        _.each(item.replies, function(itemReplies, j) {
                            if (itemReplies && itemReplies.id === replyId) {
                                item.replies.splice(j, 1);
                                item.totalReplyCount--;
                                return;
                            }
                        });
                    }
                });

                postAssetService.delete('post/v1/comment/' + scope.post.id + '/delete/' + replyId, {}).then(function(response) {
                    toastr.info($translate.instant('COMMENT_DELETED'));

                }, function(error) {

                })
            }

            scope.replyComment = function(comment,mentionUserId,mentionUserName) {
                var parent = document.getElementById("cmt_"+comment.id);

                var composer = document.getElementById("reply_"+comment.id);
                if(composer){
                    //if composer already defined..
                    //remove it
                    angular.element(composer).remove();
                }
                var elementHtml = "";
                if(mentionUserId && mentionUserName){
                    elementHtml = '<div id="reply_'+comment.id+'" class="vi-col-middle" style="width:90%; float: right; margin-right: 15px;"><div class="comment-composer"><comment-composer post-id="'+scope.post.id+'" reply-to-user-id="'+mentionUserId+'" reply-to-user-name="'+mentionUserName+'" comment-id="'+comment.id+'" user-avatar="userAvatar" events="events"></comment-composer></div></div>';
                } else {
                    elementHtml = '<div id="reply_'+comment.id+'" class="vi-col-middle" style="width:90%; float: right; margin-right: 15px;"><div class="comment-composer"><comment-composer post-id="'+scope.post.id+'" comment-id="'+comment.id+'" user-avatar="userAvatar" events="events"></comment-composer></div></div>';
                }

                //directive is ready to compile
                var el = $compile( elementHtml )( scope );
                angular.element(parent).append(el);
            }

            scope.buyNow = function() {
                if (!$stateParams.id)
                    return;

                scope.stripeSubmit({ id: $stateParams.id })
            }

            scope.events = {
                commentCallback: function(comment) {
                    if (!scope.post.comments) {
                        scope.post.comments = [];
                    }
                    comment.avatar = $rootScope.active_user.avatar;
                    comment.postedBy = $rootScope.active_user.firstName + ' ' + $rootScope.active_user.lastName;
                    comment.body = $rootScope.parseMentionTags(comment.body);
                    comment.body = $rootScope.parseLinks(comment.body);
                    scope.post.comments.push(comment);
                    scope.post.commentCount++;
                    scope.updateComments({ post: scope.post })
                    if (!scope.post.isFollowed){
                        scope.followPost();
                    }
                },
                commentReplyCallback: function(comment, parentCommentId) {
                    comment.avatar = $rootScope.active_user.avatar;
                    comment.postedBy = $rootScope.active_user.firstName + ' ' + $rootScope.active_user.lastName;
                    comment.body = $rootScope.parseMentionTags(comment.body);
                    comment.body = $rootScope.parseLinks(comment.body);
                    _.each(scope.post.comments, function(item, i) {
                        if(item.id == parentCommentId){
                            if(!item.replies){
                                item.replies = [];
                                item.totalReplyCount = 0;
                            }
                            item.replies.push(comment);
                            item.totalReplyCount++;
                            item.replying = false;
                        }
                        
                    });
                    
                    if (!scope.post.isFollowed){
                        scope.followPost();
                    }

                    //hide reply section
                    document.getElementById('reply_'+parentCommentId).remove();
                }


            }
            scope.groups = $rootScope.active_user.groups;
        }
    }

})();
(function () {

	'use strict';

	/**
	 * @ngdoc directive
	 * @name avatar:avatar
	 * @description
	 * <ul>
	 * <li>Display a post nugget with avatar, likes, comments etc...</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */

	angular.module('directives.postAssetAdmin', []).factory('postAssetService', ['base', function (base) {
		return _.create(base, {});
	}]).directive('postAssetAdmin', postAssetAdmin);
	/** @ngInject */
	function postAssetAdmin(postAssetService, toastr, $rootScope, $translate, regexes, $sce, $uibModal) {
		var directive = {
			restrict: 'EA',
			replace: true,
			scope: {
				postContent: '@',
				postContext: '@',
				userAvatar: '=',
				userName: '=',
				disableGroupName: '=',
				postEvents: '=',
				userId: '=',
				postUserId: '='
			},
			templateUrl: 'app/base/directives/postAsset.admin.directive.html',
			link: linkFunction
		};
		return directive;

		function linkFunction(scope, elem, attrs) {

			scope.context = scope.postContext;
			var el = angular.element(elem);

			scope.isPostView = function () {
				return location.href.indexOf('#/post/') != -1
			}

			scope.trustAsHtml = function (string) {
				return $sce.trustAsHtml(string);
			};

			scope.openPicture = function (files, current) {
				if ($rootScope.isNative) {
					var pictures = new Array()
					pictures.push(current.url)

					for (var i = 0; i < files.length; i++) {
						var file = files[i];

						if (file.name == current.name)
							continue;

						if (file.ext.toLowerCase() != 'png' &&
							file.ext.toLowerCase() != 'gif' &&
							file.ext.toLowerCase() != 'bmp' &&
							file.ext.toLowerCase() != 'jpg' &&
							file.ext.toLowerCase() != 'jpeg')
							continue;

						pictures.push(file.url)
					}

					$rootScope.previewImages(pictures)
				} else {
					window.open(current.url + '=s0', '_blank')
				}
			}

			scope.openPost = function (post) {
				if (!post.attachments || post.attachments.length == 0)
					return;

				if (post.attachments.length == 1) {
					if ($rootScope.isNative) {
						$rootScope.previewImage(post.attachments[0].url)
					} else {
						window.open(post.attachments[0].url + '=s0', '_blank')
					}
				} else if (post.attachments.length > 1) {
					$rootScope.$broadcast('ON_POST_VIEW_OPEN');
					location.href = '/school/#/post/' + post.id;
				}
			}

			scope.openCommentImage = function(url){
				if ($rootScope.isNative) {
					$rootScope.previewImage(url)
				} else {
					window.open(url + '=s0', '_blank')
				}
			}

			scope.getPostPictures = function (attachments) {
				var pictures = new Array()
				var cssclass = '';

				if (!attachments)
					return {
						cssclass: cssclass,
						pictures: pictures
					}

				for (var i = 0; i < attachments.length; i++) {
					if (attachments[i].ext.toLowerCase() == 'png' ||
						attachments[i].ext.toLowerCase() == 'gif' ||
						attachments[i].ext.toLowerCase() == 'bmp' ||
						attachments[i].ext.toLowerCase() == 'jpg' ||
						attachments[i].ext.toLowerCase() == 'jpeg') {
						pictures.push(attachments[i])
					}
				}

				if (pictures.length == 1)
					cssclass = 'single-picture';
				else if (pictures.length == 2)
					cssclass = 'double-picture';
				else if (pictures.length == 3 || pictures.length > 3)
					cssclass = 'multi-picture';

				return {
					cssclass: cssclass,
					pictures: pictures
				}
			}

			function validator() {

				if (scope.postContent) {
					var p = angular.fromJson(scope.postContent),
						valid = p.hasOwnProperty('postedBy') && !_.isEmpty(p.postedBy) &&
						p.hasOwnProperty('postedOn') && !_.isEmpty(p.postedOn) &&
						//p.hasOwnProperty('avatar') && !_.isEmpty(p.avatar) &&
						p.hasOwnProperty('userId') && !_.isUndefined(p.userId) &&
						p.hasOwnProperty('isOwn') && !_.isUndefined(p.isOwn) &&
						p.hasOwnProperty('isLiked') && !_.isUndefined(p.isLiked) &&
						p.hasOwnProperty('likeCount') && !_.isUndefined(p.likeCount) &&
						p.hasOwnProperty('commentCount') && !_.isUndefined(p.commentCount) &&
						p.hasOwnProperty('id') && !_.isUndefined(p.id);
					if (valid) {
						scope.post = p;
						scope.post.body = $rootScope.parseMentionTags(scope.post.body);
						scope.post.body = $rootScope.parseLinks(scope.post.body);

						if (scope.post.comments) {
							_.each(scope.post.comments, function (item, i) {
								item.body = $rootScope.parseMentionTags(item.body);
								item.body = $rootScope.parseLinks(item.body);

								if (item.replies) {
									_.each(item.replies, function (reply, i) {
										reply.body = $rootScope.parseMentionTags(reply.body);
										reply.body = $rootScope.parseLinks(reply.body);
									});
								}
							});
						}
					} else {
						el.remove();
					}

				} else {
					el.remove();
				}
			}

			if (!angular.fromJson(scope.postContent).hasOwnProperty('isAdv'))
				validator()

			scope.likePost = function (post) {
				postAssetService.put('post/v1/like/' + scope.post.id, {}).then(function (res) {
						if (scope.post.isLiked) {
							scope.post.isLiked = false;
							scope.post.likeCount--
						} else {
							scope.post.isLiked = true;
							scope.post.likeCount++
						}
					},
					function () {
						scope.post.isLiked = false;
					})
			}

			scope.edit = function () {
				location.href = 'school/#/edit/' + scope.post.id;
			};

			scope.deletePost = function () {
				var modalInstance = $uibModal.open({
					animation: true,
					templateUrl: 'app/base/views/delete-post-modal.html',
					backdropClass: 'backdrop-zindexed',
					size: 'sm',
					controller: function ($scope) {

						$scope.confirm = function () {
							postAssetService.delete('post/v1/delete/' + scope.post.id, {}).then(function () {
									toastr.info($translate.instant('POST_DELETED'));
									scope.post.deleted = true;
									modalInstance.close();
								},
								function (error) {
									toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
								});
						}

						$scope.close = function () {
							modalInstance.close();
						}
					}
				})
			}

			scope.markSold = function () {
				var modalInstance = $uibModal.open({
					animation: true,
					templateUrl: 'app/home/views/mark-sold-modal.html',
					backdropClass: 'backdrop-zindexed',
					size: 'sm',
					controller: function ($scope) {

						$scope.confirm = function () {
							postAssetService.get('listing/v1/mark/sold/' + scope.post.id, {}).then(function () {
									scope.post.sold = true;
									modalInstance.close();
								},
								function (error) {
									toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
								});
						}

						$scope.close = function () {
							modalInstance.close();
						}
					}
				})
			}

			scope.showLikers = function (post) {
				postAssetService.get('post/v1/likes/' + post.id, {
					'cache': true
				}).then(function (response) {
					scope.likers = response.data.payload;
					scope.likers.type = post.type;
					$rootScope.$broadcast('POST_LIKES', scope.likers);
				});
			}

			scope.sendMessage = function () {
				var name = scope.post.postedBy.split(' ');
				scope.$emit('COMPOSE_TO', {
					'firstName': name[0] || '',
					'lastName': name[1] || '',
					'id': scope.post.userId,
					'avatar': scope.post.avatar
				})
			}

			scope.reportPost = function () {

				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/base/directives/postAsset.confirmReportModal.directive.html',
					controller: function ($scope) {
						$scope.viewState = {
							isReady: true
						};


						$scope.close = function () {
							modalInstance.close();
						};

						$scope.report = function () {
							$scope.viewState.isReady = false;
							postAssetService.put('post/v1/report/' + scope.post.id, {}).then(function () {
								$scope.viewState.isReady = true;
								scope.post.isReported = true;
								toastr.info($translate.instant('REPORTED_POST'))
								modalInstance.close();
							}, function () {
								scope.post.isReported = false;
								toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
								$scope.viewState.isReady = true;
							});
						}

					},
					size: 'sm'
				});
			}

            scope.getMoreReplies = function(comment) {
                postAssetService.get('post/v1/commentReplies/' + comment.id, {}).then(function(response) {
                    comment.replies = [];

                    var cmmnts = response.data.payload.comments;
                    _.each(cmmnts, function(item) {
                        item.body = $rootScope.parseMentionTags(item.body);
                        item.body = $rootScope.parseLinks(item.body);
                    });

                    comment.replies = cmmnts;
                }, function(error) {
                    console.log(error);
                })
            }

			scope.getMoreComments = function (post) {
				post.hideMoreComm = true;

				postAssetService.get('post/v1/comment/' + scope.post.id, {}).then(function (response) {
					scope.post.comments = [];

					var cmmnts = response.data.payload.comments;
					_.each(cmmnts, function (item) {
						item.body = $rootScope.parseMentionTags(item.body);
						item.body = $rootScope.parseLinks(item.body);

						if (item.replies) {
							_.each(item.replies, function (reply, i) {
								reply.body = $rootScope.parseMentionTags(reply.body);
								reply.body = $rootScope.parseLinks(reply.body);
							});
						}
					});

					scope.post.comments = cmmnts;
				}, function (error) {

				})
			}

			scope.isCommentLinkVisible = function () {
				var totalNumReached = false;
				if (scope.post) {
					if (scope.post.comments) {
						totalNumReached = scope.post.comments.length === scope.post.commentCount;
					}
				}
				return scope.post.commentCount > 2 && !totalNumReached && scope.postContext !== 'GROUP_LIST_VIEW';
			}

			scope.deleteComment = function (commentId, replyId) {
				var id = replyId ? replyId : commentId;
				postAssetService.delete('post/v1/comment/' + scope.post.id + '/delete/' + id, {}).then(function (response) {
					toastr.info($translate.instant('COMMENT_DELETED'));
					if (replyId) {
						_.each(scope.post.comments, function (item, i) {
							if (item.id === commentId) {
								_.each(scope.post.comments[i].replies, function (reply, index) {
									if (reply.id === replyId) {
										scope.post.comments[i].replies.splice(index, 1);
										return;
									}
								});
							}
						});
					} else {
						_.each(scope.post.comments, function (item, i) {
							if (item.id === commentId) {
								scope.post.comments.splice(i, 1);
								scope.post.commentCount--;
								return;
							}
						});
					}
				}, function (error) {
					toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
				})
			}

			scope.events = {
				commentCallback: function (comment) {
					if (!scope.post.comments) {
						scope.post.comments = [];
					}
					comment.avatar = scope.userAvatar;
					comment.postedBy = scope.userName;
					comment.body = $rootScope.parseLinks(comment.body);
					scope.post.comments.push(comment);
					scope.post.commentCount++;
				}
			}

			scope.decimalPrice = function (price) {
				if (!_.isUndefined(price)) {
					price = parseFloat(price);

					if (price % 1 != 0) {
						price = price.toFixed(2);
					}
				}

				return price;
			}
		}
	}

})();

(function () {
	/**
	 * @ngdoc directive
	 * @name prefix:prefix
	 * @description
	 * <ul>
	 * <li>Opens a modal with dropzone directive in it</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */

	angular.module('directives.photoUpload', []).directive('photoUpload', photoUpload);
	/** @ngInject */
	function photoUpload($uibModal, $timeout) {

		var directive = {
			restrict: 'EA',
			replace: true,
			scope:{
				ngModel: '='
			},
			link:linkFunction
		}

		return directive;
		function linkFunction(scope, elem, attrs) {
			scope.$on('UPLOAD_PHOTO', function(event, args) {

				function init() {
					var modalInstance = $uibModal.open({
						animation: true,
						backdropClass: 'backdrop-zindexed',
						backdrop:'static',
						templateUrl:'app/base/directives/photoUpload.directive.html',
						controller: function($scope) {

							$scope.saveDisabled = true;

							var translations = {
								'avatarUpload':{
									'title':'UPLOAD_PHOTO_TITLE',
									'help':'PHOTO_UPLOAD_HELPER'
								},
								'imgUpload':{
									'title':'UPLOAD_A_POST_PHOTO_TITLE',
									'help':'UPLOAD_A_POST_PHOTO_HELP'
								},
								'listingUpload':{
									'title':'UPLOAD_A_LISTING_PHOTO_TITLE',
									'help':'UPLOAD_A_LISTING_PHOTO_HELP'
								},
								'eventUpload':{
									'title':'UPLOAD_A_EVENT_PHOTO_TITLE',
									'help':'UPLOAD_A_EVENT_PHOTO_HELP_EVENT'
								},
								'coverUpload':{
									'title':'UPLOAD_COVER_TITLE'
								},
								'logoUpload':{
									'title':'UPLOAD_LOGO_TITLE'
								},
								'websiteEventUpload': {
									'title':'UPLOAD_A_EVENT_PHOTO_TITLE',
									'help':'UPLOAD_WEBSITE_HELP'
								},
								'websiteCoverUpload': {
									'title':'UPLOAD_COVER_TITLE',
									'help':'UPLOAD_WEBSITE_HELP'
								},
								'websiteLogoUpload': {
									'title':'UPLOAD_LOGO_TITLE',
									'help':'UPLOAD_WEBSITE_HELP'
								},
								'groupUpload':{
									'title':'UPLOAD_A_GROUP_PHOTO_TITLE',
									'help':'UPLOAD_A_GROUP_PHOTO_HELP',
									'tips':'UPLOAD_A_GROUP_PHOTO_TIPS'
								}
							}

							$scope.translations = translations[args.action];
							$scope.error = '';

							$scope.events = {
								args:args,
								save:'',
								chooseAgain:'',
								handleError:function(err){
									$scope.error = err
								},
								rotate:'',
								close:function () {
									modalInstance.close()
								},
								enableButton: function(){
									$timeout(function(){
										$scope.saveDisabled = false
									},0)
								},
								disableButton: function(){
									$timeout(function(){
										$scope.saveDisabled = true
									},0)
								},
								resetErrorMessage: function(){
									$scope.error = '';
								}
							};

							$scope.save = function () {
								$scope.events.save()
							};

							$scope.rotate = function () {
								$scope.events.rotate()
							};

							$scope.chooseAgain = function(){
								//$scope.events.chooseAgain()
								modalInstance.close()
								init();
							}

							$scope.close = function() {
								if($scope.events.args.on_close)
									$scope.events.args.on_close();
								modalInstance.close();
							};
						},
						size: 'md'
					})
				}

				init();
			})
		}
	}

})();

(function () {
	"use strict";
	/**
	 * @ngdoc directive
	 * @name prefix:prefix
	 * @description
	 * <ul>
	 * <li>Displays percentage graph with two color segments</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */
	angular
		.module("directives.percentageGraphTwoColors", [])
		.directive("percentageGraphTwoColors", percentageGraphTwoColors);
	/** @ngInject */
	function percentageGraphTwoColors(base, $http) {
		var directive = {
			restrict: "EA",
			replace: false,
			scope: true,
			percentage: "=", // here, using the same name as the attribute
			templateUrl:
				"app/base/directives/percentageGraphTwoColors.directive.html",
			link: linkFunction,
		};

		return directive;

		function linkFunction(scope, elem, attrs) {
			scope.$watch(
				function () {
					return elem.attr("percentage");
				},
				function (newValue) {
					scope.percentage = attrs["percentage"];
					scope.firstPercentage = attrs["firstPercentage"];
					scope.text = attrs["text"];
					scope.secondPercentage = attrs["secondPercentage"] || null;
				}
			);

			scope.$watch(
				function () {
					return elem.attr("secondPercentage");
				},
				function (newValue) {
					scope.secondPercentage = attrs["secondPercentage"] || null;
				}
			);
		}
	}
})();

(function () {

  'use strict';
  /**
   * @ngdoc directive
   * @name prefix:prefix
   * @description
   * <ul>
   * <li>Displays list of months</li>
   * </ul>
   * @restrict E
   * @element
   */
  angular.module('directives.percentageGraph', []).directive('percentageGraph', percentageGraph);
  /** @ngInject */
  function percentageGraph(base, $http) {

    var directive = {
      restrict: 'EA',
      replace: false,
      scope: true,
      percentage: '=',  // here, using the same name as the attribute
      templateUrl:'app/base/directives/percentageGraph.directive.html',
      link: linkFunction
    };

    return directive;

    function linkFunction(scope, elem, attrs) {

      scope.$watch(function() {return elem.attr('percentage'); }, function(newValue) { 
        scope.percentage = attrs['percentage'];
        scope.text = attrs['text'];
      });
    }
  }

})();


(function () {

	'use strict';
	/**
	* @ngdoc directive
	* @name directives.pasteStripHtml:pasteStripHtml
	* @description
	* <ul>
	* <li>Watches the model and strip html from pasted content</li>
	* </ul>
	* @restrict E
	* @element
	*/

	angular.module('directives.pasteStripHtml',	[]).directive('pasteStripHtml', pasteStripHtml);
	/** @ngInject */
	function pasteStripHtml ($interpolate, $log, regexes) {
		var directive = {
			restrict:	'A',
			link:	linkFunction
		};
		return directive;

		function linkFunction(scope, elem, attrs)	{

			elem.on('paste', function(event) {
				event.preventDefault();

				var clipboardData = event.clipboardData || window.clipboardData,
					pastedData = clipboardData.getData('Text');

				pastedData = pastedData.replace(/\n/ig, '<br>');
				pastedData = pastedData.replace(/<w:br\/>/ig, '<br>');
				pastedData = pastedData.replace(/<\/w:t><\/w:r><\/w:p>/ig, '<br>');
				pastedData = pastedData.replace(/<\/w:t>/ig, '<br>');
					
				//document.execCommand("insertHTML", false, pastedData);

				var html = pastedData;
				var sel, range;
				if (window.getSelection) {
					sel = window.getSelection();
					if (sel.getRangeAt && sel.rangeCount) {
						range = sel.getRangeAt(0);
						range.deleteContents();

						var el = document.createElement("mainedit");
						el.innerHTML = html;
						var frag = document.createDocumentFragment(), node, lastNode;
						while ( (node = el.firstChild) ) {
							lastNode = frag.appendChild(node);
						}
						range.insertNode(frag);

						if (lastNode) {
							range = range.cloneRange();
							range.setStartAfter(lastNode);
							range.collapse(true);
							sel.removeAllRanges();
							sel.addRange(range);
						}
					}
				} else if (document.selection && document.selection.type != "Control") {
					document.selection.createRange().pasteHTML(html);
				}
			});
		}
	}
})();
(function () {

	'use strict';
	/**
	* @ngdoc directive
	* @name directives.charRemover:charRemover
	* @description
	* <ul>
	* <li>Watches the model and removes characters that doesn't pass the regex</li>
	* </ul>
	* @restrict E
	* @element
	*/

	angular.module('directives.onlyNumberInput',	[]).directive('onlyNumberInput', onlyNumberInput);
	/** @ngInject */
	function onlyNumberInput ($interpolate, $log, regexes) {
		var directive = {
			restrict:	'A',
			link:	linkFunction
		};
		return directive;

		function	linkFunction(scope,	elem,	attrs)	{
			var	regexp	=	new	RegExp(regexes["number"]);

			elem.on('input', function () {
				var currentValue = elem.val();
				var cleanedValue = input.split('').filter(function(char) {
					return regexp.test(char);
				  }).join('');
		
				if (currentValue !== cleanedValue) {
					elem.val(cleanedValue);
				}
			});
		}
	}
})();

(function () {

	'use strict';
	/**
	 * @ngdoc directive
	 * @name notifications:notifications
	 * @description
	 * <ul>
	 * <li>Displays list of notifications</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */

	angular.module('directives.notifications', []).factory('notifService', ['base', function (base) {
		return _.create(base, { });
	}]).directive('notifications', notifications);
	/** @ngInject */
	function notifications(base, storage, $rootScope, notifService, $state, $timeout) {
		var directive =  {
			restrict: 'EA',
			replace: true,
			scope:{
				ngModel: '=',
				content: '='
			},
			templateUrl:'app/base/directives/notifications.directive.html',
			link: linkFunction
		};

		return directive;

		function linkFunction(scope, elem, attrs) {

			scope.status = storage.getStatus();
			scope.unreadNotifications = [];
			scope.notifications = scope.content.notifications;

			scope.viewState = {
				notificationCount:0,
				showUnreadNotifications:false,
				fetchingNotifications:false
			};

			scope.closeNotif = function () {
				scope.viewState.showUnreadNotifications = false;
			}

			scope.toggleNotif = function(){
				scope.viewState.showUnreadNotifications = !scope.viewState.showUnreadNotifications;
			}

			scope.getUnreadNotifications = function(){
				notifService.get('school/v1/get/context/' + $rootScope.active_school.id, {'cache': true}).then(function (response) {
					scope.notifications = scope.content.notifications;
					scope.unreadNotifications = [];
					scope.viewState.fetchingNotifications = true;
					scope.unreadNotifications = scope.notifications || [];
					scope.viewState.notificationCount = scope.unreadNotifications.length;
					scope.viewState.fetchingNotifications = false;
				});
			}

			scope.getNotificationCount = function(){
				scope.viewState.notificationCount = scope.notifications.length;
			}

			scope.notifRedirect = function(type){
				scope.closeNotif();
				if (type === 'PENDING_APPROVAL') {
					$state.go('users.approveparents');
				}
			}

			scope.$watch('content.notifications.length', function(newVal){
				if (newVal > 0) {
					scope.getUnreadNotifications();
				}
			});

			scope.$on('GET_UNREAD_COUNT', function(evt,args){
				scope.getUnreadNotifications();
			});

		}
	}

})();

(function () {

	'use strict';
	/**
	 * @ngdoc directive
	 * @name prefix:prefix
	 * @description
	 * <ul>
	 * <li>Displays list of months</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */
	angular.module('directives.months', []).directive('months', months);
	/** @ngInject */
	function months(base, $http) {

		var directive = {
			restrict: 'EA',
			replace: true,
			scope:{
				ngModel: '='
			},
			template: [
				'<div>',
				'<select class="form-control" ng-required="isRequired" ng-model="selection" ng-options="m.longName for m in months" ng-change="changeOption()">',
				'</select>',
				'</div>'
			].join(''),
			link: linkFunction
		};

		return directive;

		function linkFunction(scope, elem, attrs) {
			scope.months = [];
			scope.isRequired=scope.$eval(attrs.isRequired);

			scope.changeOption = function() {
				scope.ngModel = scope.selection.id
			}

			function setMonth() {
				if (!_.isUndefined(scope.ngModel)) {
					var id = scope.ngModel
					for (var i = 0; i < scope.months.length; i++) {
						if (scope.months[i].id === id) {
							scope.selection = scope.months[i];
						}
					}					
				} else {
					scope.selection = scope.months[0];
				}
			}

			$http.get('i8n/locale-metadata-en-GB.json?v=12').then(function(data) {
   				scope.months = data.data.metadata.months;
   				setMonth();
			});
		}
	}

})();

(function () {

	'use strict';
	/**
	* @ngdoc directive
	* @name loader:loader
	* @description
	* <ul>
	* <li>Watches for $http.pendingRequests and displays / hides a loader</li>
	* <li>Flushes all notifications from the previous request</li>
	* </ul>
	* @restrict E
	* @element
	*/
	angular.module('directives.loader', []).directive('loader', loader);
	/** @ngInject */
	function loader($http, base , $rootScope) {
		var directive =  {
			restrict: 'E',
			replace: true,
			template: '<div class="loader">'
						+ '<div class="load-bar loading"></div>'
					+ '</div>',
			link: linkFunction
		};
		return directive;

		function linkFunction(scope, elem, attrs) {
			scope.$watch(function () {
				return $http.pendingRequests.length > 0;
			},	function (hasPending) {
				if(hasPending && !$rootScope.disableLoader) {
					if(!$rootScope.isinitialised){
						angular.element(document.querySelector('.spinner-overlay')).addClass('spinning');
						angular.element(document.querySelector('body')).addClass('no-scroll');
						$rootScope.isinitialised = true;
					}else{
						angular.element(document.querySelector('.load-bar')).addClass('loading');
					}					
					base.flushAll();
				}else{
					angular.element(document.querySelector('.spinner-overlay')).removeClass('spinning');
					angular.element(document.querySelector('.load-bar')).removeClass('loading');
					angular.element(document.querySelector('body')).removeClass('no-scroll');
				}
			});
		}
	}

})();

(function () {

	'use strict';

	/**
	 * @ngdoc directive
	 * @name avatar:avatar
	 * @description
	 * <ul>
	 * <li>Display a post nugget with avatar, likes, comments etc...</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */

	angular.module('directives.listingItem', []).factory('listingItemService', ['base', function (base) {
		return _.create(base, {});
	}]).directive('listingItem', listingItem);
	/** @ngInject */
	function listingItem(listingItemService, toastr, $rootScope, $translate, $state, $uibModal, $http) {
		var directive = {
			restrict: 'EA',
			replace: true,
			scope: {
				post: '=',
			},
			templateUrl: 'app/base/directives/listingItem.directive.html',
			link: linkFunction
		};
		return directive;

		function linkFunction(scope, elem, attrs) {

			$http.get("i8n/locale-metadata-en-GB.json?v=12").then(function (data) {
				scope.marketplaceCategories = data.data.metadata.marketplaceCategories || [];
			});

			scope.isPostView = function () {
				return location.href.indexOf('marketplace/detail') != -1
			}	

			scope.openPost = function (post) {
				if (!post.photos || post.photos.length == 0) return;
	
				if (post.photos.length == 1) {
					if ($rootScope.isNative) {
						$rootScope.previewImage(post.photos[0].url)
					} else {
						window.open(post.photos[0].url + '=s0', '_blank')
					}
				} else {
					$rootScope.$broadcast('ON_POST_VIEW_OPEN');
					$state.go('marketplace.detail', {id: post.id});
				}
			}
	
			scope.deletePost = function (post) {
				var modalInstance = $uibModal.open({
					animation: true,
					templateUrl: 'app/base/views/delete-post-modal.html',
					backdropClass: 'backdrop-zindexed',
					size: 'sm',
					controller: function ($scope) {
	
						$scope.confirm = function () {
							listingItemService.delete('marketplace/v1/admin/delete/' + post.id, {}).then(function () {
									toastr.info($translate.instant('POST_DELETED'));
									post.deleted = true;
									modalInstance.close();
								},
								function (error) {
									toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
								});
						}
	
						$scope.close = function () {
							modalInstance.close();
						}
					}
				})
			}

			scope.openPicture = function (files, current) {
				if ($rootScope.isNative) {
					var pictures = new Array();

					for (var i = 0; i < files.length; i++) {
						pictures.push(files[i].url);
					}

					$rootScope.previewImages(pictures)
				} else {
					window.open(current.url + '=s0', '_blank')
				}
			}

			scope.getCategory = function(category) {
				var data = scope.marketplaceCategories.find(function(c) {
					return c.name === category;
				});
				if(data) return data.value;
			}
		}
	}

})();

(function () {
    
    angular.module('directives.inviteAccordionDirective', [ ])
    .directive('inviteAccordion',function($document, $translate, $rootScope) {
      return {
        restrict: 'E',
        scope: {
            invites: '=',       // The list of invites (either failedInvites or sentInvites)
            accordionParent: '=', // The accordion state object for each parent
            loadMoreFn: '&',    // The function to load more invites
            inviteParentFn: '&',    
            inviteLinkFn: '&',    
            toggleAccordionFn: '&',    // The function to load more invites
            cursor: '=',        // The cursor for pagination
        },
        templateUrl: 'app/base/directives/invite.accordion.directive.html',
        link: function(scope, element, attrs) {
        }
    };
    })
})();
(function () {

	'use strict';

	/**
	 * @ngdoc directive
	 * @name prefix:prefix
	 * @description
	 * <ul>
	 * <li>Displays a recursive list of tiers, with nested sub tiers</li>
	 * <li>Updates the model with selected tiers ID</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */

	angular.module('directives.googleMapsAutocomplete', []).factory('mapService', ['base', function (base) {
		return _.create(base, { });
		}]).directive('googleMapsAutocomplete', googleMapsAutocomplete);
	/** @ngInject */

	function googleMapsAutocomplete(base, $timeout, $translate, mapService){
		var directive = {
			restrict: 'E',
			replace: true,
			scope:{
				ngModel: '='
			},
			templateUrl:'app/base/directives/googleMapsAutocomplete.directive.html',
			link: linkFunction
		};
		return directive

		function linkFunction(scope, elem, attrs) {
			scope.isGettingaddresses = false;

			var pickedFromList = false;
			var placeId;

			scope.$on('setAddress', function(e, value){
		      scope.address = value;
		    });

			scope.getResults = function(queryString){
				scope.isGettingaddresses = true;

				queryString = queryString.replace(/\//g, '&#47;');
				
				return base.get('shared/v1/places/autocomplete/'+queryString).then(function(response){
					scope.isGettingaddresses = false;
					var json = JSON.parse(response.data.payload.result);
					return json.predictions;

				}, function(error)	{
					scope.isGettingaddresses = false;
				});


			};

			scope.onFocusOut = function(){

				if (!_.isUndefined(scope.address)) {

					var addressResponse = {
						isRealAddress : angular.copy(pickedFromList),
						fullAddress : angular.copy(scope.address),
						locationId : angular.copy(placeId)
					}

					//return the data
					scope.ngModel = addressResponse;
				}
			}

			scope.onChanged = function(){
				 pickedFromList = false;
				 scope.onFocusOut();
			}

			scope.pickAddress = function(item){
				if (!_.isUndefined(item)) {
					scope.address = item.description;
					placeId = item.place_id;
					pickedFromList = true;
				}
			}
		}
	}
})();


(function () {

	'use strict';
	/**
	 * @ngdoc directive
	 * @name prefix:prefix
	 * @description
	 * <ul>
	 * <li>Displays list of genders</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */
	angular.module('directives.genders', []).directive('genders', genders);
	/** @ngInject */
	function genders(base, $http) {

		var directive =  {
			restrict: 'EA',
			replace: true,
			scope:{
				ngModel: '='
			},
			template: [
				'<div>',
				'<select class="form-control" ng-required="isRequired" ng-model="selection" ng-options="g.longName for g in genders" ng-change="changeOption()">',
				'</select>',
				'</div>'
			].join(''),
			link: linkFunction
		};

		return directive;

		function linkFunction(scope, elem, attrs) {
			scope.genders = [];
			scope.isRequired=scope.$eval(attrs.isRequired);

			scope.changeOption = function() {
				scope.ngModel = scope.selection.id
			}

			scope.$on('SET_GENDER', function(e, value){
		      scope.ngModel = value;
		      setGender();
		    });

			function setGender() {
				if (!_.isUndefined(scope.ngModel)) {
					var id = scope.ngModel
					for (var i = 0; i < scope.genders.length; i++) {
						if (scope.genders[i].id === id) {
							scope.selection = scope.genders[i];
						}
					}					
				} else {
					scope.selection = scope.genders[0];
				}
			}

			$http.get('i8n/locale-metadata-en-GB.json?v=12').then(function(data) {
   				scope.genders = data.data.metadata.genders;
   				setGender();
			});
		}
	}

})();

(function () {
	/**
	 * @ngdoc directive
	 * @name prefix:prefix
	 * @description
	 * <ul>
	 * <li>Opens a modal with dropzone directive in it</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */

	angular.module('directives.galleryPicker', []).directive('galleryPicker', galleryPicker);
	/** @ngInject */
	function galleryPicker($uibModal, $timeout, settings) {

		var directive = {
			restrict: 'EA',
			replace: true,
			scope:{
				ngModel: '='
			},
			link:linkFunction
		}

		return directive;
		function linkFunction(scope, elem, attrs) {
			scope.$on('GALLERY_PICKER', function(event, args) {

				function init() {
					var modalInstance = $uibModal.open({
						animation: true,
						backdropClass: 'backdrop-zindexed',
						backdrop:'static',
						templateUrl:'app/base/directives/galleryPicker.directive.html',
						controller: function($scope) {
							$scope.def_gallery = settings.defaultGallery;

							$scope.add = function() {
								if(args.on_select)
									args.on_select($scope.selectedPic);
								
								modalInstance.close();
							};

							$scope.select = function(obj) {
								$scope.selectedPic = obj;
								$scope.add();
							}
							
							$scope.uploadImage = function() {
								if(args.on_upload)
									args.on_upload();
								modalInstance.close();
							}

							$scope.close = function() {
								modalInstance.close();
							};
						},
						size: 'md'
					})
				}

				init();
			})
		}
	}

})();

(function () {

	'use strict';

	/**
	 * @ngdoc directive
	 * @name prefix:prefix
	 * @description
	 * <ul>
	 * <li>Displays a recursive list of tiers, with nested sub tiers</li>
	 * <li>Updates the model with selected tiers ID</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */

	angular.module('directives.filterPicker', []).directive('filterPicker', filterPicker);
	/** @ngInject */

	function filterPicker(base, $timeout, $rootScope, $translate, $window) {
		var directive = {
			restrict: 'E',
			replace: true,
			scope: {
				ngModel: '=',
				useCache: '='
			},
			templateUrl: 'app/base/directives/filterPicker.directive.html',
			link: linkFunction
		};
		return directive

		function linkFunction(scope, elem, attrs) {
			scope.tier = {}
			scope.tiers = [];

			/*
			 * This function is responsible from checking the local storage to see if 
			 * user has already filter saved.
			 * If so, emit and mark that filter as selected in the list.
			 */
			function checkLocalStorageForFilter() {
				var parentFilterID = window.localStorage.getItem('parentFilterID');
				if (parentFilterID) {
					scope.$emit('FILTER_FROM_STORAGE', parentFilterID);
					scope.selectedTierId = parentFilterID;
					clearHint();
				} else {
					scope.selectTierId = -1;
				};
			}

			/*
			 * This function adds custom filters to markdown list. 
			 * List of all the custom filters.(id)
			 * All parents (-1)
			 * Parents with no pupils(-2)
			 * Joined in the last 4 months(-3)
			 * Activated Parents(-4)
			 * Deactivated Parents(-5)
			 */
			function addCustomFilters() {
				var allParents = {
					id: "-1",
					index: 0,
					locked: false,
					name: "All parents"
				};
				var noPupils = {
					id: "-2",
					index: 1,
					locked: false,
					name: "Parents with no pupils"
				};
				var lastFourMonths = {
					id: "-3",
					index: 2,
					locked: false,
					name: "Joined in the last 4 months"
				};
				var activatedParents = {
					id: "-4",
					index: 2,
					locked: false,
					name: "Activated Parents"
				};
				var deactivatedParents = {
					id: "-5",
					index: 2,
					locked: false,
					name: "Deactivated Parents"
				};
				scope.tiers.push(allParents);
				scope.tiers.push(noPupils);
				scope.tiers.push(lastFourMonths);
				scope.tiers.push(activatedParents);
				scope.tiers.push(deactivatedParents);
			}

			if (window.location.href.includes('structure')) {
				scope.pupilClassPlaceholder = $translate.instant('PUPIL_CLASS_PHOLDER');
			} else {
				scope.pupilClassPlaceholder = $translate.instant('PUPIL_ONLY_CLASS_PHOLDER');
			}
			setTimeout(function() {
				
			
			base.get('school/v1/getSchoolStructureCompact?schoolId=' + $rootScope.active_school.id + '&includeEntireSchool=false', {
				'cache': scope.useCache ? true : false
			}).then(function (response) {
				addCustomFilters();
				for (var i = 0; i < response.data.items.length; i++) {
					var item = response.data.items[i];
					item.selected = false;

					scope.tiers.push(item);
					if (item.children) {
						scope.tiers = scope.tiers.concat(item.children);

					}
				}

				checkLocalStorageForFilter();

			}, function (error) { });
		}, 1000);
			scope.selectTier = function (item) {
				clearHint();

				var c = elem[0].querySelector('.select-tier-directive');
				var id = c.options[c.selectedIndex].value;

				for (var i = 0; i < scope.tiers.length; i++) {
					if (scope.tiers[i].id !== id) {
						continue;
					}
					scope.ngModel = scope.tiers[i];
					scope.$emit('FILTER_ADDED', scope.ngModel);
					break;
				}
			};

			scope.onRemoveFilter = function () {
				window.localStorage.removeItem('parentFilterID');
				scope.selectedTierId = scope.tiers[0].id;
				scope.$emit('FILTER_ADDED', scope.tiers[0]);
			}

			var clearHint = function () {
				angular.element(elem[0].querySelector('.pupil_class_placeholder')).css('display', 'none')
			}
		}
	}
})();

(function () {

	'use strict';

	/**
	 * @ngdoc directive
	 * @name droppableItem:droppableItem
	 * @description
	 * <ul>
	 * <li>Creates a dropzone for dragged items</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */

	angular.module('directives.droppable', []).directive('droppable', droppable);
	/** @ngInject */
	function droppable($timeout){
		var directive = {
			link:linkFunction,
			scope:{
				events: '=',
				droptarget:'@'
			}
		};
		return directive;

		function linkFunction(scope, elem, attrs) {

			var el = elem[0];

			el.addEventListener('dragover', dragover, false);
			el.addEventListener('dragleave', dragleave, false);
			el.addEventListener('dragenter', dragenter, false);
			el.addEventListener('drop', drop, false);

			function dragover(event){
				cancel(event);
				angular.element(el).addClass('dragover');
			}

			function drop(event){
				var droppableId = event.dataTransfer.getData('Text');
				cancel(event)
				scope.events.drop(droppableId, scope.droptarget)
				angular.element(el).removeClass('dragover')
			}

			function dragleave(event){
				angular.element(el).removeClass('dragover')
				cancel(event)
			}

			function dragenter(event){
				scope.events.dragenter(scope.droptarget);
				cancel(event)
			}

			function cancel(event) {
				if (event.preventDefault) {
					event.preventDefault();
				}
				return false;
			}

		}
	}

})();

(function () {

	'use strict';

	/**
	 * @ngdoc directive
	 * @name draggable:draggable
	 * @description
	 * <ul>
	 * <li>Creates and binds draggable event handlers</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */

	angular.module('directives.draggable', []).directive('draggable', draggable);
	/** @ngInject */
	function draggable($rootScope, $timeout){
		var directive = {
			scope:{
				dragtarget:'@',
				dragname:'@',
				draggender:'@'
			},
			link:linkFunction
		};
		return directive;

		function linkFunction(scope, elem, attrs) {

			var el = elem[0], handler, isAdded = false;
			el.draggable = false;

			handler = angular.element(el);

			//var number = angular.element(handler[0].childNodes[5]);
			scope.$on('MULTI_SELECT_UP', function(evt,args){
				if(handler.hasClass('pupil-item')){
					var startX = elem[0].offsetLeft+58,
							startY = elem[0].offsetTop+160,
							endX = startX + elem[0].offsetWidth,
							endY = startY + 30,
							isCollision = false;

					isCollision = (startX >= args.startX && startY >= args.startY && endX <= args.endX && endY <= args.endY);

					if(isCollision){
						$rootScope.$broadcast('MUL_PUP_ADDED',scope.dragtarget);
						handler.addClass('selected');
						isAdded = true;
					}
				}
			});

			function handleClick(){
				if(isAdded){
					$rootScope.$broadcast('MUL_PUP_REMOVED',scope.dragtarget);
					handler.removeClass('selected');
					isAdded = false;
					handler[0].draggable = false;
				} else {
					$rootScope.$broadcast('MUL_PUP_ADDED',scope.dragtarget);
					handler.addClass('selected');
					isAdded = true;
					handler[0].draggable = true;
				}
			}

			el.addEventListener('click', handleClick)

			el.addEventListener('touchmove', function(event) {
				var touch = event.targetTouches[0];
				draggable.style.position = 'absolute';
				draggable.style.left = touch.pageX-25 + 'px';
				draggable.style.top = touch.pageY-25 + 'px';
				event.preventDefault();
			}, false);

			el.addEventListener('dragstart',function(e) {
					e.dataTransfer.effectAllowed = 'move';
					e.dataTransfer.setData('Text', scope.dragtarget);
					var genderImage = '';
					if(scope.draggender == 'F'){
						genderImage += '<img src="https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid.svg" alt="" width="20" draggable="false"/>';
					} else if (scope.draggender == 'M'){
						genderImage += '<img src="https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid.svg" width="20" alt="" draggable="false"/>';
					} else if (scope.draggender == 'N'){
						genderImage += '<img src="https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid.svg" width="20" alt="" draggable="false"/>';
					} else if (scope.draggender == 'P'){
						genderImage += '<img src="https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid.svg" width="20" alt="" draggable="false"/>';
					} else if (!p.gender && p.status == 'APPROVED') {
						genderImage += '<img src="https://storage.googleapis.com/classlist-branding/app-assets/icon-pupil-no-data.svg" alt="" width="20" draggable="false"/>';
					}
					genderImage += '';

					document.getElementById("dragImagePupilImage").innerHTML = genderImage;
					document.getElementById("dragImagePupilName").textContent = scope.dragname;
					var dragImage = document.getElementById("dragImage");

					e.dataTransfer.setDragImage(dragImage, 10,10);
					return false;
				}, false
			);

			el.addEventListener('drag',function(e) {
					return false;
				}, false
			);

			el.addEventListener('dragend',function(e) {
					handler.removeClass('dragging');
					return false;
				}, false
			);

		}
	}

})();

(function () {

  'use strict';
  /**
   * @ngdoc directive
   * @name prefix:prefix
   * @description
   * <ul>
   * <li>Displays list of months</li>
   * </ul>
   * @restrict E
   * @element
   */

angular.module('directives.datetimepickerNeutralTimezone', []).directive('datetimepickerNeutralTimezone', datetimepickerNeutralTimezone);
  /** @ngInject */
  function datetimepickerNeutralTimezone($http, $timeout, $compile){
    var directive = {
      restrict: 'A',
      priority: 1,
      require: 'ngModel',
      link:linkFunction
    };
    return directive;

    function linkFunction(scope, element, attr, ctrl) {
      ctrl.$formatters.push(function (value) {
          if (_.isUndefined(value)){
            return;
          }

          if(!value)
            return;
            
          var date = new Date(Date.parse(value));
          date = new Date(date.getTime() + (60000 * date.getTimezoneOffset()));
          return date;
        });

        ctrl.$parsers.push(function (value) {
          if (_.isUndefined(value)){
            return;
          }

          if(!value)
            return;

          var date = new Date(value.getTime() - (60000 * value.getTimezoneOffset()));
          return date;
        });
    }
  }

})();


(function () {
    
    angular.module('directives.datepickerDirective', [ ])
    .directive('datepicker',function($document, $translate, $rootScope) {
        return {
            restrict:'E',
            replace: true,
            scope: {
                bigBanner: "=",
                minDate: "=",
                defaultOpen: "=",
                action: "=",
                timePicker: "=",
                defaultDate: "=ngModel",
                format: "@",
                headerTitle: "@",
                callback: "&onDateSelect"
            },
			templateUrl:'app/base/directives/datepicker.directive.html',
            link: function(scope, elem, attr) {
                setTimeout(function() {
                    var body = $document.find('body').eq(0);
                    body.append(elem);
                }, 500);

                $rootScope.$on("$locationChangeSuccess", function(e, currentLocation, previousLocation) {
                    scope.popover = false;
                });

                scope._action = scope.action || { };
                scope._action.open = function(options) {
                    if(scope.defaultDate)
                        scope.myDate = $rootScope.getUTCDatetime(scope.defaultDate);

                    if(scope.minDate)
                        scope.myDate = $rootScope.getUTCDatetime(new Date(scope.minDate));

                    scope.generateDays();
                    scope.popover = true;
                }
                
                scope.cal_days_labels = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
                scope.cal_full_days_lables = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
                scope.cal_months_labels = ['January', 'February', 'March', 'April',
                                'May', 'June', 'July', 'August', 'September',
                                'October', 'November', 'December'];
                scope.cal_months_labels_short = ['JAN', 'FEB', 'MAR', 'APR',
                                    'MAY', 'JUN', 'JUL', 'AUG', 'SEP',
                                    'OCT', 'NOV', 'DEC'];
                
                scope.cal_days_in_month = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; 

                setTimeout(function() {  
                    scope.header = $translate.instant(scope.headerTitle);
                    scope.$apply();
                }, 1000);

                scope.myDate = scope.defaultDate 
                    ? $rootScope.getUTCDatetime(scope.defaultDate ? new Date(scope.defaultDate) : new Date())
                    : new Date(new Date());

                // TODO: check if it's useful
                // scope.myDate = new Date(scope.myDate.valueOf() + scope.myDate.getTimezoneOffset() * 60000);
                // scope.myDate.setHours(scope.myDate.getHours() + 1);
                // scope.myDate.setMinutes(0);

                scope.timeViewDate = $rootScope.getUTCDatetime(scope.myDate);
                scope.hourValue = 0;
                scope.minValue = 0;
                scope.timeViewMeridian = "";
                scope.timeView = false;

                if(scope.myDate.getHours() <= 11 ){
                    scope.hourValue = scope.myDate.getHours();
                    scope.timeViewMeridian = "AM";
                }
                else{
                    scope.hourValue = scope.myDate.getHours() - 12;
                    scope.timeViewMeridian = "PM";
                }

                if(scope.myDate.getHours() == 0 || scope.myDate.getHours() == 12){
                    scope.hourValue = 12;
                }

                scope.minValue = scope.myDate.getMinutes();
                scope.today = new Date();
                scope.monthDays = [];
                scope.yearsList = [];

                if(scope.defaultOpen == true) {
                    scope.popover = true;
                }
                else {
                    scope.popover = false;
                }

                scope.generateDays = function() {
                      scope.monthDays = [];
                    var year = scope.myDate.getFullYear(),
                        month = scope.myDate.getMonth(),
                        current_day = scope.myDate.getDate(),
                        today = new Date();
                    var firstDay = new Date(year, month, 1);
                    var startingDay = firstDay.getDay();
                    var monthLength = scope.getMonthLength(month,year);
                    var day = 1;
                    var dateArr = [];
                    var dateRow =[];
                    // this loop is for is weeks (rows)
                    for (var i = 0; i < 9; i++) {
                        // this loop is for weekdays (cells)
                        dateRow = [];
                        for (var j = 0; j <= 6; j++) { 
                            var dateCell = 0;
                        if (day <= monthLength && (i > 0 || j >= startingDay)) {
                            dateCell = day;
                        if(day == parseInt(current_day)){
                           // dateCell.classList.add('selected-day');
                        }
                        if(day == parseInt(today.getDate()) &&  scope.myDate.getMonth() == today.getMonth() &&  scope.myDate.getFullYear() == today.getFullYear()){
                           // dateCell.classList.add('today');
                        }
                            day++;
                        }
                        dateRow.push(dateCell);
                        }
                        // stop making rows if we've run out of days
                        if (day > monthLength) {
                            dateArr.push(dateRow);
                        break;
                        } else {
                            dateArr.push(dateRow);
                        }
                    }
                      scope.monthDays = dateArr;
                }
    
                scope.getMonthLength = function(month,year){
                    var monthLength = scope.cal_days_in_month[month];
                    
                    // compensate for leap year
                    if (month == 1) { // February only!
                        if((year % 4 == 0 && year % 100 != 0) || year % 400 == 0){
                        monthLength = 29;
                        }
                    }
                    return monthLength;
                }
                scope.generateDays();
    
                scope.prevMonth = function(e){
                    e.stopPropagation();
                    if(scope.myDate.getMonth() == 0){
                        scope.myDate.setMonth(11);
                        scope.myDate.setFullYear(scope.myDate.getFullYear() - 1);
                    }else{
                        var prevmonthLength = scope.getMonthLength(scope.myDate.getMonth() - 1, scope.myDate.getFullYear());
                        var currentDate = scope.myDate.getDate();
                        if(currentDate > prevmonthLength ){
                            scope.myDate.setDate(prevmonthLength);
                        }
                        scope.myDate.setMonth(scope.myDate.getMonth() - 1);
                    }
                     scope.generateDays();
                }
                scope.nextMonth = function(e) {
                    e.stopPropagation();
                    if(scope.myDate.getMonth() == 11) {
                        scope.myDate.setMonth(0);
                        scope.myDate.setFullYear(scope.myDate.getFullYear() + 1);
                    }
                    else {
                        var nextmonthLength = scope.getMonthLength(scope.myDate.getMonth() + 1, scope.myDate.getFullYear());
                        var currentDate = scope.myDate.getDate();
                        if(currentDate > nextmonthLength) {
                            scope.myDate.setDate(nextmonthLength);
                        }

                        scope.myDate.setMonth(scope.myDate.getMonth() + 1);
                    }

                    scope.generateDays();
                }
                scope.generateYearList = function(param) {
                    var startYear = null;
                    var currentYear = null;
                    if(param == "next"){
                        startYear = scope.yearsList[8] + 1;
                    }
                    else if(param == "prev") {
                        startYear = scope.yearsList[0] - 9;
                    }
                    else {
                        currentYear = scope.myDate.getFullYear();
                        startYear = currentYear - 4;
                        scope.yearView = !scope.yearView;
                        scope.monthsView = false;
                    }
                    for(var k=0; k< 9; k++) {
                        scope.yearsList[k] = startYear + k;
                    }
                }
                scope.setYear = function(evt) {
                    var selectedYear = parseInt(evt.target.getAttribute('value'));
                    scope.myDate.setYear(selectedYear);
                    scope.yearView = !scope.yearView;

                    scope.generateDays();
                }
                scope.setMonth = function(evt) {
                    if(evt.target.getAttribute('value')) {
                        var selectedMonth = parseInt(scope.cal_months_labels_short.indexOf(evt.target.getAttribute('value')));
                        scope.myDate.setDate(1);
                        scope.myDate.setMonth(selectedMonth);
                        scope.monthsView = !scope.monthsView;

                        scope.generateDays();
                    }
                }
                scope.setDay = function(evt){
                    if(evt.target.getAttribute('value')){
                      var selectedDay = parseInt(evt.target.getAttribute('value'));
                      scope.myDate.setDate(selectedDay);  
                      //scope.popover = false;
                      //scope.callback({"selectedDate":scope.myDate});
                    }
                }
                scope.toggleMonthView = function(){
                    scope.yearView = false;
                    scope.monthsView =  !scope.monthsView;
                }
                scope.getAmPm = function (date) {
                    var hours = date.getHours();
                    var ampm = hours >= 12 ? 'PM' : 'AM';
                    return ampm;
                }
                scope.updateHours = function(type){
                    if(type == "increment"){
                        var hours = scope.myDate.getHours() + 1;
                        scope.myDate.setHours(hours);
                    }
                    else{
                        scope.myDate.setHours(scope.myDate.getHours() - 1);
                    }
                }
                scope.updateMinutes = function(type){
                    if(type == "increment"){
                        var minutes = scope.myDate.getMinutes() + 1;
                        scope.myDate.setMinutes(minutes);
                    }
                    else{
                        scope.myDate.setMinutes(scope.myDate.getMinutes() - 1);
                    }
                }
                scope.setMeridian = function(type){
                    var hour = scope.myDate.getHours();
                    var hourstoSet;

                    if(type == "AM" && hour > 11){
                        hourstoSet = hour - 12;
                        scope.myDate.setHours(hourstoSet);
                    }
                    if(type == "PM"  && hour <= 11){
                        hourstoSet = hour + 12;
                        scope.myDate.setHours(hourstoSet);
                    }
                }
                scope.toggleTimeView = function(){
                  //  if(scope.timeView == false){
                    if(scope.myDate.getHours() <= 11 ){
                        scope.hourValue = scope.myDate.getHours();
                        scope.timeViewMeridian = "AM";
                    }
                    else{
                        scope.hourValue = scope.myDate.getHours() - 12;
                        scope.timeViewMeridian = "PM";
                    }
                    if(scope.myDate.getHours() == 0 || scope.myDate.getHours() == 12){
                        scope.hourValue = 12;
                    }
                    scope.minValue = scope.myDate.getMinutes();
                   // }
                    scope.timeView = !scope.timeView;

                    setTimeout(function() {
                        window.dispatchEvent(new Event('resize'));
                    });

                }
                scope.onHourUpdate = function(hour){
                    scope.hourValue = hour;
                    scope.timeViewDate.setHours(hour);
                };
                scope.onMinUpdate = function(minutes){
                    scope.minValue = minutes;
                    scope.timeViewDate.setMinutes(minutes);
                };
                scope.toggleMeridian = function(val){
                    scope.timeViewMeridian = val;
                }
                scope.setTimeView = function(){
                    if(scope.timeViewMeridian == "AM"){
                        if(scope.hourValue == 12){
                            scope.myDate.setHours(0);
                        }
                        else{
                            scope.myDate.setHours(scope.hourValue);
                        }
                        scope.myDate.setMinutes(scope.minValue);
                    }
                    else{
                        if(scope.hourValue == 12){
                            scope.myDate.setHours(scope.hourValue);
                        }
                        else{
                            scope.myDate.setHours(scope.hourValue + 12);
                        }
                        scope.myDate.setMinutes(scope.minValue);
                    }
                    scope.timeView = !scope.timeView;
                }

                scope.confirmDate = function() {
                    scope.popover = false; 
                    scope.callback({ "selectedDate": scope.myDate });
                }

                scope.cancel = function() {
                    scope.popover = false;
                }

                // $document.on('click',function(e){
                //     if(!angular.element(elem)[0].contains(e.target)){
                //         scope.popover = false;   
                //         scope.timeView = false; 
                //         scope.monthsView = false;
                //         scope.yearView = false;
                //         scope.$apply();  
                //     }
                // });
            }
        }
    })
    .directive('rangeSlider', ['$timeout', function($timeout){
    
        var modes = {
          single  : 'SINGLE',
          range   : 'RANGE'
        };
    
        var events = {
          mouse: {
            start: 'mousedown',
            move: 'mousemove',
            end: 'mouseup'
          },
          touch: {
            start: 'touchstart',
            move: 'touchmove',
            end: 'touchend'
          }
        };
    
        function roundStep(value, precision, step, floor) {
          var remainder = (value - floor) % step;
          var steppedValue = remainder > (step / 2) ? value + step - remainder : value - remainder;
          var decimals = Math.pow(10, precision);
          var roundedValue = steppedValue * decimals / decimals;
          return parseFloat(roundedValue.toFixed(precision));
        }
    
        function offset(element, position) {
          return element.css({
            left: position
          });
        }
    
        function pixelize(position) {
          return position + "px";
        }
    
        function contain(value) {
          if (isNaN(value)) return value;
          return Math.min(Math.max(0, value), 100);
        }
    
        return {
    
          restrict: 'EA',
    
          scope: {
            floor       : '@',
            ceiling     : '@',
            step        : '@',
            highlight   : '@',
            precision   : '@',
            buffer      : '@',
            dragstop    : '@',
            ngModel     : '=?',
            ngModelLow  : '=?',
            ngModelHigh : '=?',
            onChange    : '&'
          },
    
          link : function(scope, element, attrs) {
    
            element.addClass('angular-range-slider');
    
            var currentMode = (attrs.ngModel == null) && (attrs.ngModelLow != null) && (attrs.ngModelHigh != null) ? modes.range : modes.single;
    
            // Dom Components
            var children = element.children();
            var bar         = angular.element(children[0]),
                lowPointer  = angular.element(children[1]),
                highPointer = angular.element(children[2]),
                ceilBubble  = angular.element(children[4]),
                lowBubble   = angular.element(children[5]),
                highBubble  = angular.element(children[6]),
                highlight   = angular.element(bar.children()[0]),
                ngDocument  = angular.element(document);
    
            var low, high;
            if (currentMode === modes.single) {
              low = 'ngModel';
              highPointer.remove();
              highBubble.remove();
            } else {
              low = 'ngModelLow';
              high = 'ngModelHigh';
            }
    
            scope.local = {};
            scope.local[low] = scope[low];
            scope.local[high] = scope[high];
    
            // Control Dimensions Used for Calculations
            var handleHalfWidth = 0,
                barWidth = 0,
                minOffset = 0,
                maxOffset = 0,
                minValue = 0,
                maxValue = 0,
                valueRange = 0,
                offsetRange = 0;
    
            var bindingsSet = false;
    
            var updateCalculations = function() {
    
              if (scope.step === undefined) scope.step = 1;
              if (scope.floor === undefined) scope.floor = 0;
              if (scope.ceiling === undefined) scope.ceiling = 100; //TODO: Make this more intelligent
              if (scope.precision === undefined) scope.precision = 0;
    
              if (currentMode === modes.single) {
                scope.ngModelLow = scope.ngModel;
                scope.onChange({"val":scope.ngModelLow});
              }
    
              scope.local[low] = scope[low];
              scope.local[high] = scope[high];
    
              scope.floor = roundStep(parseFloat(scope.floor), parseInt(scope.precision), parseFloat(scope.step), parseFloat(scope.floor));
              scope.ceiling = roundStep(parseFloat(scope.ceiling), parseInt(scope.precision), parseFloat(scope.step), parseFloat(scope.floor));
    
              if (currentMode === modes.range) {
                scope.ngModelLow = roundStep(parseFloat(scope.ngModelLow), parseInt(scope.precision), parseFloat(scope.step), parseFloat(scope.floor));
                scope.ngModelHigh = roundStep(parseFloat(scope.ngModelHigh), parseInt(scope.precision), parseFloat(scope.step), parseFloat(scope.floor));
              } else {
                scope.ngModel = roundStep(parseFloat(scope.ngModel), parseInt(scope.precision), parseFloat(scope.step), parseFloat(scope.floor));
              }
    
              handleHalfWidth = lowPointer[0].offsetWidth / 2;
              barWidth = bar[0].offsetWidth;
              minOffset = 0;
              maxOffset = barWidth - lowPointer[0].offsetWidth;
              minValue = parseFloat(scope.floor);
              maxValue = parseFloat(scope.ceiling);
              valueRange = maxValue - minValue;
              offsetRange = maxOffset - minOffset;
    
            };
    
            var updateDOM = function () {
              updateCalculations();
    
              var percentOffset = function (offset) {
                return contain(((offset - minOffset) / offsetRange) * 100);
              };
    
              var percentValue = function (value) {
                return contain(((value - minValue) / valueRange) * 100);
              };
    
              var pixelsToOffset = function (percent) {
                return pixelize(percent * offsetRange / 100);
              };
    
              var setPointers = function () {
                offset(ceilBubble, pixelize(barWidth - ceilBubble[0].offsetWidth));
    
                var newLowValue, newHighValue;
                newLowValue = percentValue(scope.local[low]);
                offset(lowPointer, pixelsToOffset(newLowValue));
                offset(lowBubble, pixelize(lowPointer[0].offsetLeft - (lowBubble[0].offsetWidth / 2) + handleHalfWidth));
                offset(highlight, pixelize(lowPointer[0].offsetLeft + handleHalfWidth));
    
                if (currentMode === modes.range) {
                  newHighValue = percentValue(scope.local[high]);
                  offset(highPointer, pixelsToOffset(newHighValue));
                  offset(highBubble, pixelize(highPointer[0].offsetLeft - (highBubble[0].offsetWidth / 2) + handleHalfWidth));
    
                  highlight.css({
                    width: pixelsToOffset(newHighValue - newLowValue)
                  });
    
                } else if (scope.highlight === 'right') {
    
                  highlight.css({
                    width: pixelsToOffset(110 - newLowValue)
                  });
    
                }
                else if (scope.highlight === 'left') {
    
                  highlight.css({
                    width: pixelsToOffset(newLowValue)
                  });
    
                  offset(highlight, 0);
                }
    
              };
    
              var bind = function (handle, bubble, ref, events) {
    
                var currentRef = ref;
    
                var onEnd = function () {
                  bubble.removeClass('active');
                  handle.removeClass('active');
                  ngDocument.unbind(events.move);
                  ngDocument.unbind(events.end);
                  if (scope.dragstop) {
                    scope[high] = scope.local[high];
                    scope[low] = scope.local[low];
                  }
                  currentRef = ref;
                  scope.$apply();
                };
    
                var onMove = function (event) {
    
                  // Suss out which event type we are capturing and get the x value
                  var eventX = 0;
                  if (event.clientX !== undefined) {
                    eventX = event.clientX;
                  }
                  else if ( event.touches !== undefined && event.touches.length) {
                    eventX = event.touches[0].clientX;
                  }
                  else if ( event.originalEvent !== undefined &&
                            event.originalEvent.changedTouches !== undefined &&
                            event.originalEvent.changedTouches.length) {
                    eventX = event.originalEvent.changedTouches[0].clientX;
                  }
    
                  var newOffset = Math.max(Math.min((eventX - element[0].getBoundingClientRect().left - handleHalfWidth), maxOffset), minOffset),
                      newPercent = percentOffset(newOffset),
                      newValue = minValue + (valueRange * newPercent / 100.0);
    
                  if (currentMode === modes.range) {
                    switch (currentRef) {
                      case low:
                        if (newValue > scope.local[high]) {
                          currentRef = high;
                          lowPointer.removeClass('active');
                          lowBubble.removeClass('active');
                          highPointer.addClass('active');
                          highBubble.addClass('active');
                          setPointers();
                        } else if (scope.buffer > 0) {
                          newValue = Math.min(newValue, scope.local[high] - scope.buffer);
                        }
                        break;
                      case high:
                        if (newValue < scope.local[low]) {
                          currentRef = low;
                          highPointer.removeClass('active');
                          highBubble.removeClass('active');
                          lowPointer.addClass('active');
                          lowBubble.addClass('active');
                          setPointers();
                        } else if (scope.buffer > 0) {
                          newValue = Math.max(newValue, parseInt(scope.local[low]) + parseInt(scope.buffer));
                        }
                    }
                  }
    
                  newValue = roundStep(newValue, parseInt(scope.precision), parseFloat(scope.step), parseFloat(scope.floor));
                  scope.local[currentRef] = newValue;
    
                  if (!scope.dragstop) {
                    scope[currentRef] = newValue;
                  }
    
                  setPointers();
                  scope.$apply();
                };
    
                var onStart = function (event) {
                  updateCalculations();
                  bubble.addClass('active');
                  handle.addClass('active');
                  setPointers();
                  event.stopPropagation();
                  event.preventDefault();
                  ngDocument.bind(events.move, onMove);
                  return ngDocument.bind(events.end, onEnd);
                };
    
                handle.bind(events.start, onStart);
              };
    
              var setBindings = function () {
                var method, i;
                var inputTypes = ['touch', 'mouse'];
                for (i = 0; i < inputTypes.length; i++) {
                  method = inputTypes[i];
    
                  if (currentMode === modes.range) {
                    bind(lowPointer, lowBubble, low, events[method]);
                    bind(highPointer, highBubble, high, events[method]);
                  } else {
                    bind(lowPointer, lowBubble, low, events[method]);
                  }
                }
    
                bindingsSet = true;
              };
    
              if (!bindingsSet) {
                setBindings();
              }
    
              setPointers();
            };
    
            // Watch Models based on mode
            scope.$watch(low, updateDOM);
    
            if (currentMode === modes.range) {
              scope.$watch(high, updateDOM);
            }
    
            window.addEventListener('resize', updateDOM);
        },

        template :  '<div class="bar"><div class="selection"></div></div>' +
                      '<div class="handle low {{ floor == 1 ? \'timepicker-drag-hours\' : \'timepicker-drag-minutes\' }}"><span style="display: block;margin-top: 3px;" class="bubble value low">{{ ngModelLow }}</span></div>' +
                      '<div class="handle high"></div>' +
                      '<div class="bubble limit low">{{ floor }}</div>' +
                      '<div class="bubble limit high">{{ ceiling }}</div>' +
                      '<div class="bubble value high">{{ ngModelHigh }}</div>'
        }
    }])
    .filter('numberFixedLen', function () {
        return function (n, len) {
            var num = parseInt(n, 10);
            len = parseInt(len, 10);
            if (isNaN(num) || isNaN(len)) {
                return n;
            }
            num = ''+num;
            while (num.length < len) {
                num = '0'+num;
            }
            return num;
        };
    });
})();
(function () {

	'use strict';

	/**
	 * @ngdoc directive
	 * @name avatar:avatar
	 * @description
	 * <ul>
	 * <li>Display a post nugget with avatar, likes, comments etc...</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */

	angular.module('directives.csvUpload', []).factory('csvUploadService', ['base', function (base) {
		return _.create(base, {});
	}]).directive('csvUpload', csvUpload);
	/** @ngInject */
	function csvUpload(csvUploadService, toastr, $rootScope, $translate, $interval, $state, $timeout) {
		var directive = {
			restrict: 'EA',
			replace: true,
			scope: {

			},
			templateUrl: 'app/base/directives/csvUpload.directive.html',
			link: linkFunction
		};
		return directive;

        function linkFunction(scope, elem, attrs) {
			scope.message = $translate.instant('ADD_INDIVIDUALLY_PLACEHOLDER');
            var fileUploader = document.getElementById('fileUploaderCSV');
            scope.allResults;
            scope.step = 1;
            scope.header;
            scope.columns = ["First Name","Last Name","Year","Class","Email"];

            scope.selectedColumns = [];
            scope.selectionModel;
            scope.isSchoolTrial = function(){
             return $rootScope.active_school.status == "TRIAL";
            }
            fileUploader.onchange = function() {
				var file  = fileUploader.files[0];

				if (file) {
					if (file.size > 20000000){ //20mb
						toastr.info($translate.instant("FILE_SIZE_TOO_BIG"));
						return;
					}

                    scope.fileId = file.name;

                    Papa.parse(file, {
                        download: true,
                        header: false,
                        skipEmptyLines: true,
                        error: function(err, file, inputElem, reason) {
                            console.log(err);
                            console.log(reason);
                        },
                        complete: function(results) {
                            scope.allResults = results.data;
                            scope.header = scope.allResults[0];
                            scope.allResults.shift();
                            //set step
                            scope.step = 2;
                            setTimeout(function() {
                                scope.$apply()
                            }, 1);
                        }
                    });

				}
				else {
					//$scope.isUploading = false;
				}
			}

            scope.loadLibrary = function() {
                var node2 = document.createElement('script');
                node2.src = './papaparse.min.js';
                node2.type = 'text/javascript';
                node2.async = false;
                document.getElementsByTagName('head')[0].appendChild(node2);

            }

            scope.uploadBulkCSV = function() {
                fileUploader.click();
            }

            scope.csvConfigConfirm = function(){
                if(scope.selectedColumns.length != scope.columns.length){
                    toastr.info("please choose all related columns");
                    return;
                }
                scope.step = 3;
            }

            scope.onSelectionChange = function(item,index,value) {
                if(value == ''){
                    scope.cleanSelectedColumnIndex(index);
                } else {
                    if(scope.isColumnSelected(value)){
                        return;
                    } else {
                        scope.selectedColumns.push({index:index,value:value});
                    }
                }
            }

            scope.isColumnSelected = function(column){
                for(var i=0; i < scope.selectedColumns.length; i++){
                    if(scope.selectedColumns[i].value == column){
                       return true;
                    }
                }
                return false;
            }

            scope.cleanSelectedColumnIndex = function(index){
                for(var i=0; i < scope.selectedColumns.length; i++){
                    if(scope.selectedColumns[i].index == index){
                        scope.selectedColumns.splice(i,1);
                    }
                }
            }

            scope.scrollTo = function(source, target) {
                setTimeout(function() {
                    var elmnt = document.getElementById(target);
                    if(source) {
                        var elmntSrc = document.getElementById(source);
                        elmntSrc.scrollBy(0, elmnt.getBoundingClientRect().y-300);
                    } else {
                        window.scrollBy(0, elmnt.getBoundingClientRect().y-150);
                    }
                }, 100);
            }

            scope.saveUpload = function(){
                if(scope.selectedColumns.length != scope.columns.length){
                    toastr.info("please choose all related columns");
                }
                scope.step = 4;
								scope.scrollTo(null, 'progressBar');
                var payload = {
                    fileId: scope.fileId,
                    message: scope.message,
                }

                for(var i=0; i < scope.selectedColumns.length; i++){
                    if(scope.selectedColumns[i].value == 'First Name'){
                        firstNameIndex = i;
                    }
                    if(scope.selectedColumns[i].value == 'Last Name'){
                        lastnameIndex = i;
                    }
                    if(scope.selectedColumns[i].value == 'Year'){
                        yearIndex = i;
                    }
                    if(scope.selectedColumns[i].value == 'Class'){
                        classIndex = i;
                    }
                    if(scope.selectedColumns[i].value == 'Email'){
                        emailIndex = i;
                    }
                }

                payload.firstNameFieldName = scope.header[firstNameIndex];
                payload.lastNameFieldName = scope.header[lastnameIndex];
                payload.yearFieldName = scope.header[yearIndex];
                payload.classFieldName = scope.header[classIndex];
                payload.emailFieldName = scope.header[emailIndex];

                csvUploadService.post('school/v1/csvUpload/' + $rootScope.active_school.id + '/process/v2', payload, {'xhr':true}).then(function(response) {
                    queueId = response.data.payload.id;
                    index = 0;
                    myInterval = $interval(sendData, 300);
                },
                function(error) {
                    scope.step = 3;
                    if (error.data.error.message) {
						toastr.error(error.data.error.message);
					} else {
						toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
					}
                    return;
                });
            }

            var index = 0;
            var myInterval;
            var queueId;
            var firstNameIndex, lastnameIndex, yearIndex, classIndex, emailIndex;
            function sendData() {
                $rootScope.disableLoader = true;
                if(index >= scope.allResults.length) {
                    if(angular.isDefined(myInterval)) {
                        $interval.cancel(myInterval);
                        myInterval, firstNameIndex, lastnameIndex, yearIndex, classIndex, emailIndex = undefined;
                    }

                    csvUploadService.get('school/v1/csvUpload/' + $rootScope.active_school.id + '/' + queueId + '/process/finish').then(function(finishResponse) {
                        $timeout(function() {
                            $rootScope.disableLoader = true;
                            $state.go('invite.bulkuploadhistory');
                        }, 1000);
                    },
                    function(error) {
                    });
                    queueId = undefined;
                    index = 0;
                    return;
                }
                var line = scope.allResults[index];
                var data = {
                    firstName: line[firstNameIndex].trim(),
                    lastName: line[lastnameIndex].trim(),
                    yearName: line[yearIndex].trim(),
                    className: line[classIndex].trim(),
                    email: line[emailIndex].trim(),
                }
                var newIndex = angular.copy(index);
                csvUploadService.post('school/v1/csvUpload/' + $rootScope.active_school.id + '/' + queueId + '/process/line', data, {'xhr':true}).then(function(lineResponse) {
                    var html = "<span style='color: green'>" + lineResponse.data.payload.result + "</span>";
                    if(!lineResponse.data.payload.success) {
                        html = "<span style='color: red'>" + lineResponse.data.payload.result + "</span>";
                    }
                    document.getElementById('result_' + newIndex).innerHTML = html;
                    scope.lineIndex = index;
                    scope.scrollTo('table', 'result_' + newIndex);
                },
                function(error) {
                });
                index++;
            }

            scope.loadLibrary();
        }
    }

})();

(function () {

	'use strict';

	/**
	 * @ngdoc directive
	 * @name filereader:filereader
	 * @description
	 * <ul>
	 * <li>Uses HTML5 filereader API</li>
	 * <li>Attaches Cropper JS to the upload result</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */

	function dataURItoBlob(dataURI) {
		var byteString = atob(dataURI.split(',')[1]);
		var ab = new ArrayBuffer(byteString.length);
		var ia = new Uint8Array(ab);
		for (var i = 0; i < byteString.length; i++) {
			ia[i] = byteString.charCodeAt(i);
		}
		return new Blob([ab], { type: 'image/jpeg' });
	}

	angular.module('directives.cropper', []).directive('cropper', cropper);
	/** @ngInject */
	function cropper(settings, storage, toastr, $translate, $rootScope, uploadService, $timeout) {
		var directive = {
			restrict: 'EA',
			replace: true,
			scope:{
				events: '='
			},
			templateUrl:'app/base/directives/cropper.directive.html',
			link:linkFunction
		};

		return directive;

		function linkFunction(scope, elem, attrs) {
			var args = scope.events.args || { };
			scope.eventConfig = args.config;
			scope.viewState = {
				isReady:true
			};

			var imgUploader = document.getElementById('imgUploader'),
					imgPreviewer = document.getElementById('imgPreviewer'),
					imgPlaceholder = document.getElementById('imgPholder'),
					cropper;

			function handleLoad() {
				scope.viewState.isReady = false;
				
				$timeout(function() {
					var	file = imgUploader.files[0];
					var reader = new FileReader();

					reader.addEventListener('load', function () {
						handleImage(reader.result);
					}, false);

					if (file) {
						reader.readAsDataURL(file);
					}
				},100);
			}

			function showPholder() {
				imgPlaceholder.style.display = 'block';
			}

			function hidePholder() {
				imgPlaceholder.style.display = 'none';
			}

			function _base64ToArrayBuffer(base64) {
                var binary_string = window.atob(base64.split(",")[1]);
                var len = binary_string.length;
                var bytes = new Uint8Array(len);
                for (var i = 0; i < len; i++) {
                  bytes[i] = binary_string.charCodeAt(i);
                }
                return bytes.buffer;
            }

			function calculateAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight) {
				var ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
				return { width: srcWidth*ratio, height: srcHeight*ratio };
			 }

			function handleImage(blob) {
				var img = document.createElement('img');
				img.src = blob;

				img.addEventListener('load', function() {
					var exif = EXIF.readFromBinaryFile(_base64ToArrayBuffer(img.src));

					if(img.width > settings[args.action].maxWidth) {
						hidePholder();

						var canvas = document.createElement('canvas'),
							context;

						var aratio = calculateAspectRatioFit(
							img.width, 
							img.height, 
							settings[args.action].maxWidth, 
							settings[args.action].maxWidth);

						context = canvas.getContext('2d');
						canvas.width = aratio.width;
						canvas.height = aratio.height;
						
						var x = 0;
						var y = 0;

						if (exif.Orientation != 'undefined') {
							
							if (exif.Orientation > 4) {
								canvas.width = aratio.height;
								canvas.height = aratio.width;
							}

							switch (exif.Orientation) {
								case 2:
									context.translate(canvas.width, 0);
									context.scale(-1, 1);
									break;
								case 3:
									context.translate(canvas.width, canvas.height);
									context.rotate(Math.PI);
									break;
								case 4:
									context.translate(0, canvas.height);
									context.scale(1, -1);
									break;
								case 5:
									context.rotate(0.5 * Math.PI);
									context.scale(1, -1);
									break;
								case 6:
									context.rotate(0.5 * Math.PI);
									context.translate(0, -canvas.height);
									y = canvas.height-canvas.width;
									break;
								case 7:
									context.rotate(0.5 * Math.PI);
									context.translate(canvas.width, -canvas.height);
									context.scale(-1, 1);
									y = canvas.height-canvas.width;
									x = canvas.width-canvas.height;
									break;
								case 8:
									context.rotate(-0.5 * Math.PI);
									context.translate(-canvas.width, 0);
									x = canvas.width-canvas.height;
									break;
							}
				
							context.drawImage(img, x, y, aratio.width, aratio.height);
							context.restore();

							imgPreviewer.src = canvas.toDataURL('image/jpeg',settings[args.action].quality);
							attachCropper(imgPreviewer)
						}
						else {
							imgPreviewer.src = img.src;
							attachCropper(imgPreviewer)
						} 
					}
					else{
						hidePholder();
						imgPreviewer.src = blob;
						attachCropper(imgPreviewer);
					}
				});
			}

			function exporter() {
				var output = document.createElement('img'),
					canvas = document.createElement('canvas'),
					context = canvas.getContext('2d');

				output.src = cropper.getCroppedCanvas().toDataURL();

				output.onload = function() {

					canvas.width = output.width;
					canvas.height = output.height;

					context.drawImage(output, 0, 0, output.width, output.height);
					var optimized = canvas.toDataURL('image/jpeg',settings[args.action].quality);
					
					uploadService.imgUpload(dataURItoBlob(optimized),{
						headers: {
							'Content-Type': undefined,
							'ClasslistToken':storage.getToken() || '',
							'ClasslistCfg':angular.toJson({
								'type':settings[args.action].type,
								'id': (settings[args.action].type == 'PROFILE_PIC') ? $rootScope.active_user.id : $rootScope.active_school.id
							})
						}
					}).then(function(response) {
						response.file_blob = optimized;
						args.callback_fn(response);

						scope.viewState.isReady = true;
						scope.events.close();
					}, function(error){
						scope.viewState.isReady = true;
						scope.events.enableButton();
					})
				}
			}

			scope.events.rotate = function() {
				cropper.rotate(45)
			}

			scope.events.save = function() {
				scope.viewState.isReady = false;

				$timeout(function() {
					exporter();
				},100);
				
			}

			scope.events.chooseAgain = function() {
				scope.events.handleError('');
				cropper.destroy();
				imgPreviewer.src = '';
				scope.events.disableButton();
				showPholder()
			}

			scope.events.cropPicture = function() {
				scope.events.editingPicture = true;
				cropper.crop();
			}

			function attachCropper(image) {
				scope.events.enableButton();
				cropper ? cropper.destroy() : _.noop();
				cropper = new Cropper(image, _.assign(settings.cropper,settings[args.config]));
				scope.events.resetErrorMessage();

				setTimeout(function() {
					if(settings[args.config].autoCrop == undefined)
						scope.events.cropPicture()
					scope.$apply();
				}, 100);

				scope.viewState.isReady = true;	
			}

			imgUploader.onchange = function() {
				handleLoad()
				setTimeout(function() {
					imgUploader.value = '';
				}, 1000);
			}
			
			if(args.file_blob) {
				//handleImage(args.file_blob)
				
				hidePholder();
				imgPreviewer.src = args.file_blob;
				attachCropper(imgPreviewer)
				scope.events.hideChoose();
				
				setTimeout(function() {
					scope.$apply();
				}, 1);

				setTimeout(function() {
					scope.events.cropPicture()
					scope.$apply();
				}, 500);
			}
		}
	}

})();

(function () {

	'use strict';

	/**
	 * @ngdoc directive
	 * @name prefix:prefix
	 * @description
	 * <ul>
	 * <li>Displays list of country prefixes</li>
	 * <li>Flushes all notifications from the previous request</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */

	angular.module('directives.countries', []).directive('countries', countries);
	/** @ngInject */
	function countries(base, $http){
		var directive = {
			restrict: 'EA',
			replace: true,
			scope:{
				ngModel: '='
			},
			template: [
				'<select class="form-control" ng-required="isRequired">',
				'<option ng-repeat="c in countries" value="{{::c.id}}">{{::c.longName}}</option>',
				'</select>'
			].join(''),
			link:linkFunction
		};
		return directive;

		function linkFunction(scope, elem, attrs) {
			scope.countries = [];
			scope.isRequired=scope.$eval(attrs.isRequired);
			scope.ngModel === '' ? scope.ngModel = '826' : '';

			$http.get('i8n/locale-metadata-en-GB.json?v=12').then(function(data) {
   				scope.countries = data.data.metadata.countries;
			});
		}
	}

})();

(function () {

  'use strict';

  /**
   * @ngdoc directive
   * @name contenteditable:contenteditable
   * @description
   * <ul>
   * <li>Integrates HTML5 contentditable with ngModel</li>
   * <li></li>
   * </ul>
   * @restrict A
   * @element
   */

  angular.module('directives.contenteditable', ['ngSanitize']).directive('contenteditable', contenteditable);
  /** @ngInject */


  function contenteditable($sce){
    var directive = {
      restrict: 'A',
      require: '?ngModel',
      link: linkFunction
    };
    return directive

    function linkFunction(scope, element, attrs, ngModel) {
      
      if (!ngModel) return; // do nothing if no ng-model

      // Specify how UI should be updated
      ngModel.$render = function() {
        element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
      };

      // Listen for change events to enable binding
      element.on('blur keyup change', function() {
        scope.$evalAsync(read);
      });
      read(); // initialize

      // Write data to the model
      function read() {
        var html = element.html();
        // When we clear the content editable the browser leaves a <br> behind
        // If strip-br attribute is provided then we strip this out
        if ( attrs.stripBr && html == '<br>' ) {
          html = '';
        }
        ngModel.$setViewValue(html);
      }      
    }
  }

})();
(function () {

	'use strict';
	/**
	 * @ngdoc directive
	 * @name commentComposer:commentComposer
	 * @description
	 * <ul>
	 * <li>Creates a comment</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */
	angular.module('directives.commentComposerSchool', []).factory('commentService', ['base', function (base) {
		return _.create(base, { });
	}]).directive('commentComposerSchool', commentComposerSchool);
	/** @ngInject */
	function commentComposerSchool($rootScope, commentService, regexes, toastr, $translate, $timeout, baseService, uploadService, storage, $state) {

		var directive =  {
			restrict: 'EA',
			replace: true,
			scope:{
				events: '=',
				userAvatar: '=',
				postId: '=',
				commentId: '=',
				replyToUserId: '@',
				replyToUserName: '@',
			},
			templateUrl:'app/base/directives/commentComposer.directive.html',
			link: linkFunction
		};

		return directive;

		function linkFunction(scope, elem, attrs) {

			scope.height = '40'
			scope.groups = [];
			scope.regexes = regexes;
			var clean;
			$rootScope.activePostId = '';
			scope.replyingToComment = false;

			scope.commentPlaceHolderText = $translate.instant('WRITE_A_COMMENT');

			if(attrs.commentId){
				scope.replyingToComment = true;	
				scope.replyingCommentId = attrs.commentId;
				scope.commentPlaceHolderText = $translate.instant('WRITE_A_REPLY');
				if(attrs.replyToUserId){
					scope.commentPlaceHolderText = '';
					scope.replyToAnchor = "<a rel=\"userid\" alt=\""+attrs.replyToUserId+"\">@" + attrs.replyToUserName + "</a>";
				}
			}


			baseService.app_directive_initialized = function(evt, args) {
				scope.comment = {
					body:'',
					id:'',
					own: true,
					avatar: '',
					created: Date.now(),
					userId: $rootScope.active_user.id,
					postedBy: '',
					fileId: '',
				};
				scope.activeUser = $rootScope.active_user;
				
				clean = angular.copy(scope.comment);
				var fileUploader = document.getElementById('postUploader');
				var activePreviewWrapper;
				var activeAttachmentButtonsWrapper;
				

				scope.filesToSend = new Array();

				scope.setAttachmentURL=function(url, isImage, uniqueAttId) {
					
					if(url != '' ){
						scope.attachmentUrl = url;
						setTimeout(function() {
							activePreviewWrapper = document.getElementById($rootScope.activePostId)
							activeAttachmentButtonsWrapper = document.getElementById($rootScope.activePostId + 'icons')
							activePreviewWrapper.setAttribute("style","display:block")
							activeAttachmentButtonsWrapper.setAttribute("style","display:none")
							var imageWrapper = activePreviewWrapper.querySelector('#test-id')
							if(isImage){
								imageWrapper.setAttribute("style","display:block")
								activePreviewWrapper.querySelector('#att-name').textContent = ''
								imageWrapper.src = url
								imageWrapper.setAttribute("alt",uniqueAttId)
							} else {
								activePreviewWrapper.querySelector('#att-name').textContent = url
								activePreviewWrapper.querySelector('#att-name').setAttribute("alt",uniqueAttId)
								imageWrapper.setAttribute("style","display:none")
								imageWrapper.src = ''
							}
						}, 100);
					}
					
				}
				scope.onUploaderClicked = function(url, isImage,uniqueAttId){
					setTimeout(function()  {
						scope.setAttachmentURL(url, isImage,uniqueAttId)
					}, 100);
				}

				scope.onChange = function() {
					var length = 0;
				
					function recursiveLoad(files, success) {

						var reader = new FileReader();
						var file = files[length];
						if (file) {
							if (file.type.indexOf('image') > -1) {
								var _URL = window.URL || window.webkitURL;
								var img = new Image();
				
								img.onload = function() {
									window.EXIF.getData(img, function() {
											reader.readAsDataURL(file);
											reader.addEventListener('load', function(e) {
												scope.filesToSend = new Array();
												scope.filesToSend.push({
													name: file.name,
													ext: file.name.split('.').pop(),
													type: file.type,
													src: e.target.result,
													url: URL.createObjectURL(file),
													blob: dataURItoBlob(reader.result)
												})
				
												if (!scope.attachments)
													scope.attachments = new Array()
				
												scope.attachUpload(URL.createObjectURL(file), function(resp) {
													var url = commentService.getPostImgBucketUrl() + '/' + resp.data;
				
													scope.attachments.unshift({ url: url, blob: URL.createObjectURL(file), id: resp.data || '' });
													scope.onUploaderClicked(url, true, resp.data);	
				
													length += 1;
													scope.viewState.isReady = false;
													recursiveLoad(files, success)
												})
				
											}, false);
				
										}
									)
								};
								img.src = _URL.createObjectURL(file);
							} else {
								// Files
								reader.readAsDataURL(file);
				
								if (file.size > 8000000) {
									toastr.info($translate.instant('FILE_SIZE_TOO_BIG'));
									return;
								}
				
								reader.addEventListener('load', function(e) {
									scope.filesToSend = new Array();
									scope.filesToSend.push({
										name: file.name,
										ext: file.name.split('.').pop(),
										type: file.type,
										src: e.target.result,
										url: URL.createObjectURL(file),
										blob: dataURItoBlob(reader.result)
									})
				
									if (!scope.attachments)
										scope.attachments = new Array()
				
									scope.attachUpload(URL.createObjectURL(file), function(resp) {
										var url = commentService.getPostImgBucketUrl() + '/' + resp.data
										scope.attachments.unshift({ name: file.name, url: url, blob: URL.createObjectURL(file), id: resp.data || '' });

										scope.onUploaderClicked(file.name,false, resp.data);	
										length += 1;
				
										scope.viewState.isReady = false;
										recursiveLoad(files, success)
									})
				
								}, false);
							}
						} else {
							scope.viewState.isReady = true;
				
							if (success)
								success();
						}
					}
				
				
					recursiveLoad(fileUploader.files, function() {
						fileUploader.value = '';
					});
				};
				
				fileUploader.onchange = function() {
					scope.onChange();
				}

				scope.attachUpload = function(blob, success, fail) {
					uploadService.fileUpload(scope.filesToSend[0].blob, {
							headers: {
								'Content-Type': undefined,
								'ClasslistToken': storage.getToken() || '',
								'ClasslistCfg': angular.toJson({
									'type': 'ATTACHMENT'
								})
							}
						}, scope.filesToSend[0].name)
						.then(function(response) {
								scope.isUploading = false;
								scope.filesToSend[0].file_id = response.data;
				
								if (success)
									success(response)
							},
							function(error) {
								if (error.status === 403 || error.status === 409) {
									toastr.error($translate.instant(error.data));
								} else {
									//Skip for now.
								}
				
								if (fail)
									fail()
				
								scope.isUploading = false;
							});
				}

				scope.uploadImage = function(id) {
					$rootScope.activePostId = id;
					fileUploader.setAttribute('accept', 'image/x-png,image/png,image/gif,image/jpeg,image/jpg')
					fileUploader.click();
					scope.$root.nativeCamPerm();
				}

				scope.uploadAttachment = function(id) {
					$rootScope.activePostId = id;
					fileUploader.setAttribute('accept', '*')
					fileUploader.click();
					scope.$root.nativeCamPerm();
				}

				scope.getCommentBody = function(bodyWithTags){
					scope.comment.body = bodyWithTags;
				}
				scope.removeAttachment = function (id) {
					scope.attachmentUrl = '';
					document.getElementById(id).setAttribute("style","display:none")
					document.getElementById(id+'icons').setAttribute("style","display:inline")
				}
			}
	
			if($rootScope.active_school && $rootScope.app_base_ready) {
				baseService.app_directive_initialized();
			}

			scope.viewState = {
				isReady:true,
				previewActive:false,
				groupActive:false
			}
	
			scope.postComment = function(postId) {
				scope.viewState.isReady = false;

				var selectedDivWrapper = document.getElementById(postId)
				scope.attachmentExist = false;
				scope.attachmentUniqueId = '';
				if(selectedDivWrapper.querySelector('#test-id') && selectedDivWrapper.querySelector('#test-id').src && selectedDivWrapper.querySelector('#test-id').src != '' && selectedDivWrapper.querySelector('#att-name').textContent == ''){
					if(selectedDivWrapper.querySelector('#test-id').getAttribute("alt") && selectedDivWrapper.querySelector('#test-id').getAttribute("alt") != ''){
						scope.attachmentExist = true;
						scope.attachmentUniqueId = selectedDivWrapper.querySelector('#test-id').getAttribute("alt")
					}
				} else {
					if(selectedDivWrapper.querySelector('#att-name') && selectedDivWrapper.querySelector('#att-name').textContent && selectedDivWrapper.querySelector('#att-name').textContent != ''){
						if(selectedDivWrapper.querySelector('#att-name').getAttribute("alt") && selectedDivWrapper.querySelector('#att-name').getAttribute("alt") != ''){
							scope.attachmentExist = true;
							scope.attachmentUniqueId = selectedDivWrapper.querySelector('#att-name').getAttribute("alt")
						}
					}
				}
				if(!scope.comment.body && !scope.attachmentExist){
					return;
				}
				scope.sendingComment = true;
				
				if(scope.attachmentExist) {
					document.getElementById(postId).setAttribute("style","display:none")
				}

				scope.comment.body = parseLinks(scope.comment.body);
				scope.comment.fileId = scope.attachmentUniqueId;
				scope.commentPayloadObject = {
					'payload': {
						'commentText': scope.comment.body,
						'fileId': scope.comment.fileId
					}
				}
				var endpointUrl = 'post/v1/comment/' + scope.postId + '/create';
				
				if(scope.replyingToComment){
					endpointUrl = 'post/v1/commentReply/' + scope.commentId + '/create';
				}

				commentService.post(endpointUrl,scope.commentPayloadObject,{'xhr':true}).then(function(response){
					
					scope.sendingComment = false;
					scope.viewState.isReady = true;
					scope.comment.id = response.data.id;
					scope.comment.created = Date.now();
					if(response.data.attachment){
						scope.comment.attachment = {
							'id': response.data.attachment.id,
							'url': response.data.attachment.url,
							'fileName': response.data.attachment.fileName,
							'fileView': response.data.attachment.fileView
						}
					}
					
					if(scope.replyingToComment){
						scope.events.commentReplyCallback(scope.comment,scope.commentId);
					} else {
						scope.events.commentCallback(scope.comment);
					}

					scope.discardComment();
					scope.comment.fileId = '';
					selectedDivWrapper.querySelector('#test-id').setAttribute("alt","")
					selectedDivWrapper.querySelector('#att-name').setAttribute("alt","")
					scope.attachmentUniqueId = '';
					$rootScope.$broadcast('RESIZE_NOW', function(someVar) { });
					$rootScope.$broadcast('removeInput');
				}, 
				function(error){
					scope.sendingComment = false;
					scope.viewState.isReady = true;
					toastr.error($translate.instant('COMMENT_ERROR'));
					$rootScope.$broadcast('removeInput');
				})
			}

			scope.discardComment = function(){
				scope.comment = angular.copy(clean);
			}

			function parseLinks(cnt){
                if(!cnt || cnt.length == 0){
                    return "";
                }
                //create temp element
                var temp = document.createElement('div');
                //set temp element inner html with htmlContent
                temp.innerHTML = cnt;
                //find all links in the element
                Array.from(temp.querySelectorAll('a')).forEach(function(link) {
                    //if link has user-id attribute it mention. so replace with mention...
                    if(link.getAttribute('rel') && link.getAttribute('rel') == "userid"){
                        cnt = cnt.replace(link.outerHTML, "[MENTION userId=\"" + link.getAttribute('alt') + "\"]" + link.innerHTML + "[/MENTION]");
                    } else {
                        //all other cases will be processed as normal link
                        var linkWithTag = $rootScope.createEmailLinks(link.outerHTML)
                        cnt = cnt.replace(link.outerHTML, linkWithTag);
                    }
				});
				return cnt;
            }
		}
	}

})();

(function () {

	'use strict';
	/**
	 * @ngdoc directive
	 * @name commentComposer:commentComposer
	 * @description
	 * <ul>
	 * <li>Creates a comment</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */
	angular.module('directives.commentComposer', []).factory('commentService', ['base', function (base) {
		return _.create(base, { });
	}]).directive('commentComposer', commentComposer);
	/** @ngInject */
	function commentComposer($rootScope, commentService, regexes, toastr, $translate, $timeout) {

		var directive =  {
			restrict: 'EA',
			replace: true,
			scope:{
				events: '=',
				userAvatar: '=',
				postId: '@',
				commentId: '=',
				replyToUserId: '@',
				replyToUserName: '@',
			},
			templateUrl:'app/base/directives/commentComposer.directive.html',
			link: linkFunction
		};

		return directive;

		function linkFunction(scope, elem, attrs) {
			scope.height = '40'
			scope.groups = [];
			scope.commentPlaceHolderText = $translate.instant('COMMENT_COMPOSE_PHOLDER');
			if(attrs.commentId){
				scope.replyingToComment = true;	
				scope.replyingCommentId = attrs.commentId;
				scope.commentPlaceHolderText = $translate.instant('WRITE_A_REPLY');
				if(attrs.replyToUserId){
					//scope.commentPlaceHolderText = '';
					scope.replyToAnchor = "<a rel=\"userid\" alt=\""+attrs.replyToUserId+"\">@" + attrs.replyToUserName + "</a>";
				}
			}

			scope.comment = {
				body:'',
				id:'',
				own: true,
				avatar: '',
				created: Date.now(),
				userId: $rootScope.active_user.id,
				postedBy: ''
			};
			var clean = angular.copy(scope.comment);


			scope.viewState = {
				isReady:true,
				previewActive:false,
				groupActive:false
			}

			scope.postComment = function(){
				scope.viewState.isReady = false;
				scope.comment.body = $rootScope.createEmailLinks(scope.comment.body);

				var endpointUrl = 'post/v1/comment/school/' + attrs.postId + '/create';
				
				if(scope.replyingToComment){
					endpointUrl = 'post/v1/commentReply/' + scope.commentId + '/create';
				}
				
				commentService.post(endpointUrl,{'payload':{'commentText': scope.comment.body}},{'xhr':true}).then(function(response){
					
					scope.viewState.isReady = true;
					scope.comment.id = response.data.id;
					scope.comment.created = Date.now();
					
					if(scope.replyingToComment){
						scope.events.commentReplyCallback(scope.comment,scope.commentId);
					} else {
						scope.events.commentCallback(scope.comment);
					}

					
					scope.discardComment();
					
					scope.comment.fileId = '';
					selectedDivWrapper.querySelector('#test-id').setAttribute("alt","")
					selectedDivWrapper.querySelector('#att-name').setAttribute("alt","")
					scope.attachmentUniqueId = '';

					$rootScope.$broadcast('RESIZE_NOW', function(someVar) { });
					$rootScope.$broadcast('removeInput');

					$rootScope.$broadcast('RESIZE_NOW', function(someVar){			
					});
					

					//FIXME why we need this? (Adrian)
					// if(window.innerWidth < 350) {
					// 	var top  = window.pageYOffset || document.documentElement.scrollTop;
					// 	window.scrollTo(0, top - 120);
					// }
				}, 
				function(error){
					scope.viewState.isReady = true;
					toastr.error($translate.instant('COMMENT_ERROR'));
				})
			}

			scope.discardComment = function(){
				scope.comment = angular.copy(clean);
			}

			scope.clearDirt = function(){
				scope.cmm.$setPristine();
			}
		}
	}

})();

(function () {

	'use strict';

	/**
	 * @ngdoc directive
	 * @name prefix:prefix
	 * @description
	 * <ul>
	 * <li>Displays a recursive list of tiers, with nested sub tiers</li>
	 * <li>Updates the model with selected tiers ID</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */

	angular.module('directives.classPicker', []).directive('classPicker', classPicker);
	/** @ngInject */

	function classPicker(base, $timeout, $rootScope, $translate, $window) {
		var directive = {
			restrict: 'E',
			replace: true,
			scope: {
				ngModel: '=',
				useCache: '='
			},
			templateUrl: 'app/base/directives/classPicker.directive.html',
			link: linkFunction
		};
		return directive

		function linkFunction(scope, elem, attrs) {
			scope.tier = {}
			scope.tiers = [];


			if (window.location.href.includes('structure')) {
				scope.pupilClassPlaceholder = $translate.instant('PUPIL_CLASS_PHOLDER');
			} else {
				scope.pupilClassPlaceholder = $translate.instant('PUPIL_ONLY_CLASS_PHOLDER');
			}

			base.get('school/v1/getSchoolStructureCompact?schoolId=' + $rootScope.active_school.id + '&includeEntireSchool=false', {
				'cache': scope.useCache ? true : false
			}).then(function (response) {
				for (var i = 0; i < response.data.items.length; i++) {
					var item = response.data.items[i];
					item.selected = false;
					item.topTier = item.name;

					scope.tiers.push(item);
					if (item.children) {
						for (var j = 0; j < item.children.length; j++) {
							item.children[j].topTier = item.name;
						}
						scope.tiers = scope.tiers.concat(item.children);

					}
				}
			}, function (error) {});

			scope.selectTier = function (item) {
				clearHint();

				var c = elem[0].querySelector('.select-tier-directive');
				var id = c.options[c.selectedIndex].value;

				for (var i = 0; i < scope.tiers.length; i++) {
					if (scope.tiers[i].id !== id) {
						continue;
					}
					scope.ngModel = scope.tiers[i];
					break;
				}
			};

			var clearHint = function () {
				angular.element(elem[0].querySelector('.pupil_class_placeholder')).css('display', 'none')
			}
		}
	}
})();

(function () {

	'use strict';

	/**
	 * @ngdoc directive
	 * @name avatar:avatar
	 * @description
	 * <ul>
	 * <li>Display an avatar from given url and dimensions</li>
	 * <li>Listen to refresh event and pull the image again if image has changed</li>
	 * <li>Display default image if url returns no image</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */

	angular.module('directives.avatar', []).directive('avatar', avatar);
	/** @ngInject */
	function avatar($http, $timeout, $compile, $rootScope){
		var directive = {
			restrict: 'EA',
			replace: true,
			scope: {
				width: '@',
				height: '@',
				name: '@',
				source:'@'
			},
			templateUrl:'app/base/directives/avatar.directive.html',
			link:linkFunction
		};
		return directive;

		function linkFunction(scope, elem, attrs) {

			var interval = setInterval(function(){
				_.isEmpty(attrs.source) ? _.noop() : recompile()
			}, 300);

			scope.w = attrs.width || 40;
			scope.h = attrs.height ||40;
			scope.name = attrs.name ? attrs.name.toLowerCase() : '';

			scope.getInitials = function() {
				var result = '';

				if(scope.name) {
					if(scope.name.indexOf(' ') > -1) {
						var split = scope.name.split(/ (.+)/);

						if(split && split.length > 1) {
							if(split[0].length > 0)
								result = split[0].trim()[0];

							if(split[1].length > 0)
								result += split[1].trim()[0];
						}
					}
					else {
						if(scope.name && scope.name.length > 0)
							result = scope.name[0];
					}
				}

				return result;
			}

			scope.getInitial = function() {
				var result = '';
				
				if(scope.name && scope.name.length > 0)
					result = scope.name[0].toLowerCase();

				return result;
			}

			scope.rangomColor = function() {
				var num = Math.floor((Math.random() * 8) + 1)
				return num;
			}

			scope.color = scope.rangomColor()

			function recompile(){
				scope.src = attrs.source + '=s256-c';
				$timeout(function(){
					clearInterval(interval);
				},50)
			}

			scope.$watch('source', function(){
				scope.src = attrs.source;
			});

			if(attrs.my === 'true'){
				scope.$on('AVATAR_UPDATE', function(){
					scope.src = attrs.source;
					clearInterval(interval);
					$timeout(function(){
						scope.src = scope.src + '?t=' + new Date().getTime();
						$rootScope.active_user.avatar = scope.src;
						$rootScope.saveContextToCache();
					},50)
				})
			}

		}
	}

})();

(function () {
	'use strict';
	/**
	 * @ngdoc directive
	 * @name featureDetection:featureDetection
	 * @description
	 * <ul>
	 * <li>Autoresize textarea</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */
	angular.module('directives.autoresizeTextareaComment', []).directive('autoresizeTextareaComment', autoresizeTextareaComment);
	/** @ngInject */
	function autoresizeTextareaComment(base, $rootScope) {

		var directive =  {
			restrict: 'EA',
			replace: false,
			link: linkFunction
		};

		return directive;

		function linkFunction(scope, elem, attrs) {
			var a = elem[0];

			a.oninput = function() {
			  a.style.height = "auto";
			  a.style.height = Math.min(a.scrollHeight, 400) + "px";
			  a.style.overflowY = 'auto';
			};

			$rootScope.$on('RESIZE_NOW',function(evt,args){
				a.style.overflowY = 'hidden';
				a.style.height = "auto";
				a.style.height = "40px";
			})
			
		}
	}

})();

(function () {
	'use strict';
	/**
	 * @ngdoc directive
	 * @name featureDetection:featureDetection
	 * @description
	 * <ul>
	 * <li>Autoresize textarea</li>
	 * </ul>
	 * @restrict E
	 * @element
	 */
	angular.module('directives.autoresizeTextarea', []).directive('autoresizeTextarea', autoresizeTextarea);
	/** @ngInject */
	function autoresizeTextarea(base, $rootScope, $timeout) {

		var directive =  {
			restrict: 'EA',
			replace: false,
			link: linkFunction
		};

		return directive;

		function linkFunction(scope, elem, attrs) {
			var a = elem[0];
			var focused = 0;

			$rootScope.$on('RESIZE_TO_LARGE',function(evt,args){
				focused = 0;
				resizeUp();
			})

			a.oninput = function() {
			 	resizeUp();
			};

			a._focus = function() {
				$timeout(function () {
					resizeUp();
				},0);
			};

			function resizeUp(force) {

				$timeout(function () {
					if (focused  < 2){
						focused++;
						a._focus();
					}
				},100);

			  a.style.height = "auto";
			  a.style.height = Math.min(a.scrollHeight, 1000) + 2 + "px";
			  a.style.overflowY = 'auto';

			  a.focus();
			}
		
		}
	}

})();

(function () {
	"use strict";

	angular
		.module("modules.baseModule", [])
		.factory("baseService", [
			"base",
			function (base) {
				return _.create(base, {});
			},
		])
		.directive("formatprice", [
			"$filter",
			function ($filter) {
				return {
					require: "ngModel",
					link: function (scope, elem, attr, ctrl) {
						if (!ctrl) return;

						ctrl.$parsers.unshift(function (viewValue, modelValue) {
							var plainNumber = viewValue.replace(/[^-+0-9]/g, "");

							if (plainNumber) {
								var newVal = plainNumber.charAt(plainNumber.length - 1);
								var positive = plainNumber.charAt(0) != "-";
								if (isNaN(plainNumber.charAt(plainNumber.length - 1))) {
									plainNumber = plainNumber.substr(0, plainNumber.length - 1);
								}

								plainNumber = $filter("number")(plainNumber / 100, 2).replace(
									/,/g,
									""
								);
								if (positive && newVal == "-") {
									plainNumber = "-" + plainNumber;
								} else if (!positive && newVal == "+") {
									plainNumber = plainNumber.substr(1);
								}

								ctrl.$setViewValue(plainNumber);
								ctrl.$render();
							}
							return plainNumber;
						});
					},
				};
			},
		])
		.filter('filtercontacts', function($rootScope) {
            return function(list, keyword) {
                var out = [];

                if (!$rootScope.search_page || !$rootScope.search_page.simple) {
                    if (!keyword || keyword.length < 2) {
                        return list;
                    }
                }

                var searchKey = keyword ? keyword.replace(/\s/g, "") : '';
                searchKey = searchKey.toLowerCase();
                searchKey = searchKey.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

                if (searchKey) {
                    if (searchKey.indexOf('dad') > -1) {
                        searchKey = searchKey.replace('dad', '')
                    }

                    if (searchKey.indexOf('mum') > -1) {
                        searchKey = searchKey.replace('mum', '')
                    }

                    if (searchKey.indexOf('father') > -1) {
                        searchKey = searchKey.replace('father', '')
                    }

                    if (searchKey.indexOf('mother') > -1) {
                        searchKey = searchKey.replace('mother', '')
                    }

                    if (searchKey.indexOf("'s") > -1) {
                        searchKey = searchKey.replace("'s", '')
                    }

                    if (searchKey.indexOf("'") > -1) {
                        searchKey = searchKey.replace("'", '')
                    }
                }

                if (list) {
                    for (var i = 0; i < list.length; i++) {
                        var guest = list[i];
						var name = guest.name ? guest.name.replace(/\s/g, "") : '';
						name = name.toLowerCase();
						name = name.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

                        if (searchKey) {
							if ((name.indexOf(searchKey) > -1)) {
								out.push(guest)
							}
                        } else {
                            out.push(guest)
                        }
                    }
                }
                return out;
            }
        })
		
		.controller("baseController", baseController);

	/** @ngInject */
	function baseController(
		$scope,
		$rootScope,
		$window,
		$location,
		toastr,
		$state,
		$translate,
		$uibModal,
		authService,
		baseService,
		$timeout,
		storage,
		settings,
		gaService,
		$sce
	) {
		var socketLoadedFirstTime = false;
		$scope.processingUpdate = false;
		$scope.verifyEmailDismissed = false;

		$scope.remainingDaysToTurnOffMobileBrowser = Math.round(
			Math.abs((new Date() - new Date(2020, 10, 9)) / (24 * 60 * 60 * 1000))
		);

		$scope.os = getMobileOperatingSystem();

		$scope.dismissVerfiyEmail = function () {
			$scope.verifyEmailDismissed = true;
		};

		$scope.onDoneThisVerificationTapped = function () {
			location.reload();
		};

		$scope.frontend_v = getFrontendVersion();
		$scope.accordionMenu = {
			parents: {
				open: false,
			},
			school: {
				open: false,
			},
			community: {
				open: false,
			},
		};

		$rootScope.notifsContainer = {
			notifications: 0,
		};

		$rootScope.isNative = getIfNative();

		var htmlCorp = document.getElementById("CLRoot");

		$rootScope.trustAsHtml = function (string) {
			return $sce.trustAsHtml(string);
		};

		window.addEventListener("online", function (net) {
			if (navigator.onLine) {
				//init websocket
				WSS.init(settings.conf.wssURL + storage.getToken());

				if (!socketLoadedFirstTime) {
					refreshNotifications();
				} else {
					socketLoadedFirstTime = false;
				}
			}
		});

		window.addEventListener("offline", function (net) {
			toastr.info(
				"You are offline, please connect to the internet to be able to post"
			);

			if (!navigator.onLine) {
				WSS.close();
			}
		});

		$scope.getInviteLink = function (success) {
			baseService
				.get("school/v1/invite/link/" + $rootScope.active_school.id, {
					cache: false,
				})
				.then(
					function (response) {
						if (success) success(response.data.payload);
					},
					function (error) {
						return null;
					}
				);
		};

		function isParentContext() {
			var active_school = storage.get("__c1", true, true);
			if (active_school) {
				try {
					var currentActiveSchool = JSON.parse(window.atob(active_school));
					return currentActiveSchool.approved == true;
				} catch (ex) {}
			}
			return false;
		}

		function entryPoint() {
			var school = $rootScope.getQueryParam("s");

			if (!school || school == "") {
				school = $rootScope.getQueryParam("school");
			}
			if (!school) {
				school = 0;
			}

			var internalRedirectURL = $rootScope.getQueryParam("ReturnUrl");
			if (!internalRedirectURL) {
				internalRedirectURL = $rootScope.getQueryParam("url");
			}

			if (internalRedirectURL && internalRedirectURL !== "undefined") {
				window.location.href = internalRedirectURL;
			}

			var isFromRedirect = true;
			var queryToken = $rootScope.getQueryParam("t");

			if (!queryToken) {
				queryToken = storage.getToken();
				isFromRedirect = false;
			}

			if (!queryToken && document.cookie) {
				var parse = document.cookie.split(";");
				for (var index = 0; index < parse.length; index++) {
					var element = parse[index];
					if (element.includes("__c10")) {
						var tokenIndex = element.indexOf("=");
						var decodedToken = decodeURIComponent(element.substring(tokenIndex + 1));
						queryToken = decodedToken.b64decode();
						isFromRedirect = false;
					}
				}
			}

			if (!queryToken) {
				//FIXME REDIRECT
				window.location = settings.conf.ssoAppURL + "/#/?unauthorized=school";
				return;
			}
			var isNativeTemp = getIfNative() ? true : false;
			baseService
				.post("sso/v1/pusht", {
					c: queryToken,
					n: isNativeTemp,
				})
				.then(
					function (response) {
						if (!response || !response.data || !response.data.c) {
							//FIXME REDIRECT
							window.location =
								settings.conf.ssoAppURL + "/#/?unauthorized=school";
							return;
						}
						if (isFromRedirect || isParentContext()) {
							storage.del("__c1", true);
							storage.del("__c2", true);
						}

						storage.del("__c3", true);

						storage.del("tkn", true);
						storage.setToken(response.data.c);

						if (isNativeTemp) {
							if (getMobileOperatingSystem() == "iOS") {
								try {
									window.location =
										"classlistnativeschool://pusht/" + storage.getToken();
								} catch (ex) {
									console.log(ex);
								}
							} else if (getMobileOperatingSystem() == "Android") {
								if (window.AndroidBridge) {
									window.AndroidBridge.pusht(storage.getToken());
								}
							}
						}
						$scope.rootContext(false, school);
					},
					function (error) {
						console.log(error);
						//FIXME REDIRECT
						window.location =
							settings.conf.ssoAppURL + "/#/?unauthorized=school";
					}
				);
		}

		$rootScope.userTag = function (tag, extra) {
			baseService
				.post("shared/v1/add/userTag", {
					tagName: tag,
					referrer: extra ? extra : document.referrer,
					schoolId:
						$rootScope.active_school && $rootScope.active_school.id
							? $rootScope.active_school.id
							: -1,
					source: "SCHOOL",
				})
				.then(function (response) {});
		};

		function refreshRequired() {
			$uibModal.open({
				animation: true,
				templateUrl: "app/base/views/old-version-modal.html",
				backdropClass: "backdrop-zindexed",
				backdrop: "static",
				size: "sm",
				controller: function ($scope) {
					$scope.confirm = function () {
						location.reload(true);
					};
				},
			});
		}

		function refreshNotifications(checkUpdate) {
			baseService
				.get(
					"school/v1/" + $rootScope.active_school.id + "/notification/list/new",
					{
						cache: false,
					}
				)
				.then(function (resp) {
					if (resp && resp.data && resp.data.payload) {
						$rootScope.notifsContainer.notifications = resp.data.payload.s;
						$rootScope.notifsContainer.version = resp.data.payload.v;
						$rootScope.parentSideNotifications =
							resp.data.payload.n + resp.data.payload.m;
						$rootScope.unassignedPupilsCount = resp.data.payload.upc;

						var refreshRequested = false;
						if (
							getFrontendVersion() < resp.data.payload.v &&
							resp.data.payload.x == false
						) {
							refreshRequired();
							refreshRequested = true;
						}

						if (document.cookie.indexOf("X-Source=experiment") > -1) {
							if (resp.data.payload.x == false) {
								if (!refreshRequested) refreshRequired();
							}
						} else {
							if (resp.data.payload.x == true) {
								if (!refreshRequested) refreshRequired();
							}
						}

						// Set the 'experiment' flag for A/B testing
						//document.cookie = "X-Source=main; expires=Thu, 9 Dec 3000 12:00:00 UTC; path=/;";
						$rootScope.active_user.x = false;

						if (resp.data.payload.x == true) {
							//document.cookie = "X-Source=experiment; expires=Thu, 9 Dec 3000 12:00:00 UTC; path=/;";
							$rootScope.active_user.x = true;
						}

						//let the ui render
						$timeout(function () {
							pushContextToNative();
						}, 100);
					}
				});
		}

		function pushContextToNative() {
			var frontendVersion = storage.get("classlist_v", true, true);

			if (
				frontendVersion &&
				$rootScope.notifsContainer.version !== frontendVersion
			) {
				storage.set("classlist_v", $rootScope.notifsContainer.version, true);
				checkCache(true, $rootScope.notifsContainer.version);
			} else {
				if ($rootScope.notifsContainer.version !== frontendVersion) {
					storage.set("classlist_v", $rootScope.notifsContainer.version, true);
				}
			}

			if (!getIfNative()) {
				return;
			}

			var os = $rootScope.getOS();

			var nativeStr =
				"localNewNotification=0" +
				"&localNewMessage=0" +
				"&schoolId=" +
				$rootScope.active_school.id +
				"&isStaff=" +
				($rootScope.active_user.role === "STAFF");
			if (os == "iOS") {
				window.location = "classlistnativeschool://context?" + nativeStr;
			} else if (os == "Android") {
				if (window.AndroidBridge) {
					window.AndroidBridge.context(nativeStr);
				}
			}
		}

		$rootScope.context_loaded = false;

		$rootScope.resendEmail = function (id_school) {
			if ($scope.sending) return;

			$scope.sending = true;
			baseService
				.get("shared/v1/resend/emailValidation/" + id_school, {
					cache: false,
				})
				.then(
					function (resp) {
						$scope.sending = false;
						toastr.success($translate.instant("EMAIL_RESENT"));
					},
					function () {
						$scope.sending = false;
					}
				);
		};

		$rootScope.previewImage = function (url) {
			$rootScope.previewImages([url]);
		};

		$rootScope.previewImages = function (arrayOfImages) {
			if (!arrayOfImages) {
				return;
			}

			var isArray = Array.isArray(arrayOfImages);
			if (!$rootScope.isNative || getMobileOperatingSystem() == "Android") {
				if (isArray) {
					window.open(arrayOfImages[0] + "=s0", "_blank");
				} else {
					window.open(arrayOfImages, "_blank");
				}
				return;
			} else {
				if (getMobileOperatingSystem() === "iOS") {
					if (isArray) {
						window.location =
							"classlistnativeparent://images/" + arrayOfImages.join(",");
					} else {
						window.location = "classlistnativeparent://images/" + arrayOfImages;
					}
				}
			}
		};

		$scope.rootContext = function (stopPropagation, schoolId, force) {
			checkCacheForContext(schoolId);

			if (
				!$rootScope.active_school ||
				!$rootScope.active_user ||
				force ||
				!$rootScope.active_user.emailVerified
			) {
				baseService
					.get("school/v1/get/context/" + schoolId, {
						cache: false,
						headers: {
							"s": schoolId
						}
					})
					.then(function (resp) {
						$scope.contextReady = true;
						$rootScope.active_school = resp.data.school;
						// $rootScope.active_school.avatar + '?v=' + new Date().getTime();
						resp.data.user.avatar =
							resp.data.user.avatar + "?v=" + new Date().getTime();
						$rootScope.active_user = resp.data.user;
						if ($rootScope.active_school.firstAmbassador) {
							var switchQueryParam = $rootScope.getQueryParam("switch");
							if (!switchQueryParam && getMobileOperatingSystem() !== "Flutter") {
								window.location.href = "#/get-started";
							}
						}

						$rootScope.saveContextToCache();

						postContextWork(stopPropagation);
						if (resp.data.user.firstVisit) {
							showCustomAppcue("welcome-appcue", {});
							document.getElementById("welcomeappcuecontacts").src =
								"https://storage.googleapis.com/classlist-branding/app-assets/contacts.png";
							document.getElementById("welcomeappcueevents").src =
								"https://storage.googleapis.com/classlist-branding/app-assets/events.png";
							document.getElementById("welcomeappcuechat").src =
								"https://storage.googleapis.com/classlist-branding/app-assets/chat.png";

							baseService
								.post("shared/v1/add/userTag", {
									tagName: "FIRST_VISIT_SCHOOL_SIDE",
									referrer: document.referrer,
									schoolId: $rootScope.active_school.id,
									source: "SCHOOL",
								})
								.then(function (response) {});
						}
					});
			} else {
				postContextWork(stopPropagation);
			}
		};

		$rootScope.refreshContext = function (schoolId) {
			$scope.rootContext(true, schoolId || 0, true);
		};

		$rootScope.isStaffWithoutUserManagementPermission = function(){
			if($rootScope.active_user && $rootScope.active_user.role === 'STAFF' && $rootScope.active_user.userManagementPermission == false){
				return true;
			}
			
			return false;
		}

		$rootScope.adminHaveRoles = function() {
			var roles = Array.prototype.slice.call(arguments);

			return $rootScope.active_user && 
				   $rootScope.active_user.roles && 
				   $rootScope.active_user.roles.length > 0 && 
				   roles.some(function(role) {
					   return $rootScope.active_user.roles.includes(role);
				   });
		};

		$rootScope.showStaffWithoutUserManagementPermissionErrorMessage = function(){
			toastr.error($translate.instant("STAFF_USERMANAGEMENT_PERMISSION_ACCESS_ERROR"));
		}

		$rootScope.integrationEnabled = function(){
			var integrationEnabled  = false;
			if($rootScope.active_school && $rootScope.active_school.integrationEnabled){
				integrationEnabled = $rootScope.active_school.integrationEnabled;
			}
			return integrationEnabled
		}

		function checkCache(force, version) {
			if (!window.applicationCache) {
				return;
			}

			if (force) {
				clearCache(true, version);
				return;
			}

			//https://stackoverflow.com/questions/1715568/how-to-properly-invalidate-an-html5-cache-manifest-for-online-offline-web-apps
			var cacheStatusValues = [];
			cacheStatusValues[0] = "uncached";
			cacheStatusValues[1] = "idle";
			cacheStatusValues[2] = "checking";
			cacheStatusValues[3] = "downloading";
			cacheStatusValues[4] = "updateready";
			cacheStatusValues[5] = "obsolete";

			// Listeners for all possible events
			var cache = window.applicationCache;

			cache.addEventListener(
				"updateready",
				function (e) {
					if (cacheStatusValues[cache.status] != "idle") {
						clearCache(true, version);
					}
				},
				false
			);
		}

		function clearCache(forceReload, version) {
			try {
				window.applicationCache.swapCache();
				//we need to clean local storage for requests as well
				for (var i = 0, len = localStorage.length; i < len; ++i) {
					if (
						localStorage.key(i) &&
						localStorage.key(i).indexOf("aHR0cHM") > -1
					) {
						localStorage.removeItem(localStorage.key(i));
					}
				}
			} catch (ex) {
				//ignore
			}
		}

		function postContextWork(stopPropagation) {
			// trigger the get app cue
			setTimeout(function () {
				if (
					!getIfNative() &&
					isThisMobile() &&
					$rootScope.getOS() != "Flutter"
				) {
					showCustomAppcue("getapp-appcue", {});
				}
			}, 300);

			//analitics stuff
			//crete dimension
			//set the gaDimenstion as a global variable
			//send a page hit to analitics
			$rootScope.gaDimension =
				$rootScope.active_school.name + " - " + $rootScope.active_school.id;
			$window.ga("set", "dimension1", $rootScope.gaDimension);
			$window.ga("set", "dimension2", $rootScope.active_user.id);
			$window.ga("set", "dimension3", getFrontendVersion());
			$window.ga("set", "dimension4", isExperimentCookie());

			if (location.host.indexOf("app.classlist.com")) {
				$window.ga("set", "dimension5", "ps");
			}

			$window.ga("set", "dimension6", new Date().getTime());

			gaService.send($rootScope.gaLoadPage || "undefined");

			if (!stopPropagation) {
				$rootScope.app_base_ready = true;

				if (baseService.app_initialized) baseService.app_initialized();

				if (baseService.app_directive_initialized)
					baseService.app_directive_initialized();
			}

			$timeout(function () {
				$rootScope.context_loaded = true;
			}, 200);


			var timeoutPromise = null;
			var firstTime = true;
			// prevent notification request duplication
			function scheduleRefreshNotifications() {
				if (timeoutPromise) {
				  $timeout.cancel(timeoutPromise);
				}
			
				timeoutPromise = $timeout(function() {
				  refreshNotifications();
				  timeoutPromise = null; 
				  firstTime = false;
				}, firstTime ? 100 : 10000);
			  }

			//last thing
			$timeout(function () {
				//init websocket
				WSS.init(settings.conf.wssURL + storage.getToken());
				WSS.onConnected = function () {
					scheduleRefreshNotifications();

					// we removed this code, it causes issue of losing state of page on tab change.
					//It can create some issues on ticket creation page, please find detailed solution for that.
					// if (window.location.href.indexOf("/community-events/tickets/") > -1) {
					// 	$rootScope.$broadcast('UPDATE_EVENT_PAYMENT_PROVIDER');
					// }
				};
			}, 500);

			//register socket
			WSS.onPush = function (res) {
				if (res.indexOf("Connection Established") == -1) {
					//$rootScope.loader = false;
					scheduleRefreshNotifications();
				}
			};

			var user_role = $rootScope.active_user.role;

			($rootScope.qrCodeLink =
				settings.conf.api +
				"/generator/invitepdf?sid=" +
				$rootScope.active_school.id +
				"&zu=" +
				$rootScope.currentUserId()),
				"_blank";

			/*
			 * Redirect the user to the get started page
			 * if their role is Ambassador or Staff.
			 */

			// PWA-8270
			// only redirect if the created attribute is set and the school age is less than 8 weeks
			if ($rootScope.active_school.created) {
				dt1 = new Date($rootScope.active_school.created);

				var dt2 = new Date(new Date());
				var daysSinceSchoolCreated = Math.floor(
					(Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) -
						Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) /
						(1000 * 60 * 60 * 24)
				);

				if (
					daysSinceSchoolCreated < 56 &&
					(user_role == "AMBASSADOR" || user_role == "STAFF")
				) {
					location.href = "/#/get-started";
				}
			}
		}

		entryPoint();

		$rootScope.securityFired = false;
		$rootScope.$on("SECURITY_CHECK", function (evt, args) {
			var url =
				window.location.href.indexOf("?") > -1
					? window.location.href.split("?")[0]
					: window.location.href;
			location.href =
				settings.conf.ssoAppURL + "#/?ReturnUrl=" + encodeURIComponent(url);
		});

		$rootScope.$on("NOT_FOUND", function (evt, args) {
			$uibModal.open({
				animation: true,
				backdrop: "static",
				backdropClass: "backdrop-zindexed",
				templateUrl: "app/base/views/not-found-modal.html",
				size: "md",
				controller: function ($scope) {
					gaService.send("/notfound/school/view");

					$scope.confirm = function () {
						gaService.send("/notfound/school/confirm");

						location.href = settings.conf.schoolAppURL + "/#/dashboard/view";
						location.reload(true);
					};
				},
			});
		});

		$scope.showMobileMenu = false;

		$scope.toggleMenu = function () {
			$timeout(function () {
				$scope.showMobileMenu = !$scope.showMobileMenu;

				var container = document.getElementsByClassName("ui-view-container")[0],
					subContainer = document.getElementsByClassName("content-logged")[0];
				if ($scope.showMobileMenu) {
					container.className =
						container.className + " mobile-menu-open-container";
					subContainer.className = subContainer.className + " mobile-menu-open";
				} else {
					container.className = container.className.replace(
						" mobile-menu-open-container",
						""
					);
					subContainer.className = subContainer.className.replace(
						" mobile-menu-open",
						""
					);
				}
			}, 0);
		};

		$scope.toggleAccordion = function (accordion, section) {
			var currentState = accordion[section].open;

			$scope.closeAllAccordions(accordion);

			if (currentState) {
				accordion[section].open = false;
			} else {
				accordion[section].open = true;
			}
		};

		$scope.closeAllAccordions = function (accordion) {
			for (var key in accordion) {
				accordion[key].open = false;
			}
		};

		$scope.toggleProfileCard = function () {
			$timeout(function () {
				$scope.showProfileCard = !$scope.showProfileCard;
			}, 0);
		};

		$scope.uploadAvatar = function () {
			$scope.$broadcast("UPLOAD_PHOTO", {
				callback_fn: function (response) {
					$rootScope.$broadcast("AVATAR_UPDATE");
				},
				action: "avatarUpload",
				config: "avatarCropper",
			});
		};

		$scope.closeProfileCard = function () {
			$scope.showProfileCard = false;
		};

		$scope.switchApps = function (to) {
			$rootScope.switchingApps = true;

			var url = settings.conf.parentAppURL;
			var currentOS = $rootScope.getOS();

			if (currentOS.includes("unknown")) {
				url.replace("https", "http");
			}
			url =
				url +
				"/#/?t=" +
				storage.getToken() +
				"&school=" +
				$rootScope.active_school.id +
				"&switch=true";

			if (to != _.isUndefined(to)) {
				url = url + "&url=" + encodeURIComponent(to);
			}

			$rootScope.writeParamsToLocalStorage(url);

			// this will allow localhost to switch
			if (currentOS === "Flutter") {
				window.location.href = "classlistflutter://switchtoparent";
			} else if (settings.conf.type !== "local") {
				window.location.href = settings.conf.parentAppURL + "?switch=true";
			} else {
				window.location.href = url;
			}
		};

		$rootScope.switchApps = $scope.switchApps;

		$scope.changeLanguage = function (lang) {
			$translate.use(lang);
		};

		$scope.logout = function () {
			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				templateUrl: "app/profile/views/logout-confirm-modal.html",
				backdropClass: "backdrop-zindexed",
				size: "sm",
				controller: function ($scope) {
					$scope.vm = {};

					$scope.confirm = function () {
						var currentOS = $rootScope.getOS();
						if (currentOS === "Flutter") {
							window.location.href = "classlistflutter://schoollogout";
							return;
						}

						$scope.loggingOut = true;
						authService.logout();
					};

					$scope.close = function () {
						modalInstance.close();
					};
				},
			});
		};

		$scope.viewProfile = function (role) {
			if (role === "STAFF") {
				$state.go("profile.staff");
			} else {
				$state.go("profile.settings");
			}
		};

		$scope.menuPlus = function (e) {
			e.stopPropagation();
			$scope.showMenu = false;
			$scope.showPlus = !$scope.showPlus;
			document.body.classList.remove("overflow-hidden");
			htmlCorp.classList.remove("overflow-hidden");

			if ($scope.showPlus) {
				document.body.className += " overflow-hidden";
				htmlCorp.className += " overflow-hidden";
			}
		};

		$scope.menuMenu = function (e) {
			e.stopPropagation();
			$scope.showPlus = false;
			$scope.showMenu = !$scope.showMenu;
			document.body.classList.remove("overflow-hidden");
			htmlCorp.classList.remove("overflow-hidden");

			if ($scope.showMenu) {
				document.body.className += " overflow-hidden";
				htmlCorp.className += " overflow-hidden";
			}
		};

		$scope.closePlusMenu = function () {
			$scope.showPlus = false;
			$scope.showMenu = false;
			document.body.classList.remove("overflow-hidden");
			htmlCorp.classList.remove("overflow-hidden");
		};

		$scope.switchParentEvents = function () {
			$scope.switchApps("#/events/list");
		};

		$scope.switchParentGroups = function () {
			$scope.switchApps("#/home");
		};

		$scope.switchParentGroupsList = function () {
			$scope.switchApps("#/home");
		};

		$scope.help = function () {
			window.open("https://help.classlist.com", "_blank");
		};

		$scope.forum = function () {
			window.open("https://forum.classlist.com", "_blank");
		};

		$scope.downloadApp = function () {
			$rootScope.userTag("FORCE_APP_DOWNLOAD");

			$rootScope.onDownloadButtonClicked(false);
		};

		$scope.openApp = function () {
			window.open(window.location.href);
		};

		function checkCacheForContext(currentSchoolId) {
			var active_school = storage.get("__c1", true, true);
			var active_user = storage.get("__c2", true, true);

			if (active_user && active_school) {
				try {
					//there is a new school so we need to refresh PWA-3778
					var currentActiveSchool = JSON.parse(window.atob(active_school));
					if (
						currentSchoolId != 0 &&
						currentActiveSchool &&
						currentActiveSchool.id !== currentSchoolId
					) {
						return;
					}

					var _active_user = JSON.parse(window.atob(active_user));
					_active_user.avatar =
						_active_user.avatar + "?v=" + new Date().getTime();
					$rootScope.active_user = _active_user;

					currentActiveSchool.logo =
						currentActiveSchool.logo + "?v=" + new Date().getTime();
					$rootScope.active_school = currentActiveSchool;
				} catch (ex) {}
			}
		}

		$rootScope.isDevice = function () {
			var check = false;
			(function (a) {
				if (
					/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
						a
					) ||
					/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
						a.substr(0, 4)
					)
				)
					check = true;
			})(navigator.userAgent || navigator.vendor || window.opera);
			return check;
		};

		$rootScope.openWhatsappNative = function (whatToShare) {
			if (!$rootScope.isNative) {
				return;
			}

			var op = getMobileOperatingSystem();

			if (op == "iOS") {
				$window.location = "classlistnativeschool://whatsapp/" + whatToShare;
			} else if (op == "Android") {
				if (window.AndroidBridge) {
					window.AndroidBridge.share(whatToShare);
				}
			} else if (op == "Flutter") {
				window.location = "https://web.whatsapp.com/send?text=" + whatToShare;
			}
		};

		$rootScope.openFacebookNative = function (whatToShare) {
			if (!$rootScope.isNative) {
				return;
			}

			var op = getMobileOperatingSystem();

			if (op == "iOS") {
				window.location = "classlistnativeschool://facebook/" + whatToShare;
			} else if (op == "Android") {
				if (window.AndroidBridge) {
					window.AndroidBridge.share(whatToShare);
				}
			} else if (op == "Flutter") {
				window.location =
					"https://www.facebook.com/sharer/sharer.php?u=" + whatToShare;
			}
		};

		$rootScope.isObjectEmpty = function (obj) {
			for (var prop in obj) {
				if (obj.hasOwnProperty(prop)) return false;
			}

			return JSON.stringify(obj) === JSON.stringify({});
		};

		$rootScope.openShareNative = function (whatToShare) {
			if (!$rootScope.isNative) {
				return;
			}

			if (getMobileOperatingSystem() == "iOS") {
				window.location = "classlistnativeschool://share/" + whatToShare;
			} else if (getMobileOperatingSystem() == "Android") {
				if (window.AndroidBridge) {
					window.AndroidBridge.share(whatToShare);
				}
			}
		};

		$scope.openProfile = function () {
			if ($rootScope.active_user.role == "STAFF")
				location.href = "/school/#/profile/staff";
			else location.href = "/school/#/profile/settings";
		};

		//warning might be a loop
		$rootScope.saveContextToCache = function () {
			try {
				storage.set(
					"__c1",
					window.btoa(JSON.stringify($rootScope.active_school)),
					true
				);
				storage.set(
					"__c2",
					window.btoa(JSON.stringify($rootScope.active_user)),
					true
				);
			} catch (ex) {}
		};

		$rootScope.writeParamsToLocalStorage = function (url) {
			var urlParamsAsObject = $rootScope.getUrlParamsAsMap(url);
			for (var k in urlParamsAsObject) {
				if (urlParamsAsObject.hasOwnProperty(k)) {
					window.localStorage.setItem(k, urlParamsAsObject[k]);
				}
			}
		};

		/**
		 * Will return TRUE if the school is enrolled in the class budi
		 * It will check the context received from the server
		 */
		$rootScope.isFriendshipBetaSchool = function () {
			if (!$rootScope.active_school || !$rootScope.active_school.classBudi) {
				return false;
			}
			return $rootScope.active_school.classBudi;
		};

		/*
        * This function is responsible from handling the 
        * redirections from welcome to classlist page.

        	* If user is on desktop, 
        		* call sendAppDownloadLink endpoint,
        		* show 'check your inbox' message.

        	* If user is on native app,
        		* add 'nApp=true' to the url as postfix.
        	* If user is on mobile browser,
        		* take them to 
        		* respective store to download the app.

        * close the appcue.
        */
		$rootScope.onDownloadButtonClicked = function (dismissCue) {
			var isNativeTemp = getIfNative() ? true : false;
			var appRedirectURL;
			var userAgent = navigator.userAgent.toLowerCase();

			if (isThisMobile()) {
				if (!isNativeTemp) {
					if (/android/i.test(userAgent)) {
						appRedirectURL =
							"http://play.google.com/store/apps/details?id=com.classlist.parent";
					} else {
						//in case something happens or the users clicks very fast
						appRedirectURL =
							"http://itunes.apple.com/gb/app/classlist/id1058636226?mt=8";
					}
					window.open(appRedirectURL);
				} else location.href = '#/?nApp=true"';
			} else {
				baseService
					.get("school/v1/sendAppDownloadLink/" + $rootScope.active_school.id, {
						cache: false,
					})
					.then(
						function (response) {
							toastr.success($translate.instant("CHECK_INBOX"));
							dismissCustomAppcue();
						},
						function (error) {}
					);
			}
			if (dismissCue) dismissCustomAppcue();
		};

		$rootScope.isMobileAndNative = function () {
			if (isThisMobile() && getIfNative()) {
				return true;
			} else return false;
		};

		$rootScope.isDesktop = function () {
			var isMobileTmp = isThisMobile();
			return !isMobileTmp;
		};

		$rootScope.isDesktopView = function () {
			var vw = Math.max(
				document.documentElement.clientWidth || 0,
				window.innerWidth || 0
			);
			return vw > 991;
		};

		$rootScope.getUrlParamsAsMap = function (url) {
			// get query string from url (optional) or window
			var queryString = url
				? url.split("?")[1]
				: window.location.search.slice(1);

			// we'll store the parameters here
			var obj = {};

			// if query string exists
			if (queryString) {
				// stuff after # is not part of query string, so get rid of it
				queryString = queryString.split("#")[0];

				// split our query string into its component parts
				var arr = queryString.split("&");

				for (var i = 0; i < arr.length; i++) {
					// separate the keys and the values
					var a = arr[i].split("=");

					// set parameter name and value (use 'true' if empty)
					var paramName = a[0];
					var paramValue = typeof a[1] === "undefined" ? true : a[1];

					// (optional) keep case consistent
					if (typeof paramValue === "string") paramValue = paramValue;

					// if the paramName ends with square brackets, e.g. colors[] or colors[2]
					if (paramName.match(/\[(\d+)?\]$/)) {
						// create key if it doesn't exist
						var key = paramName.replace(/\[(\d+)?\]/, "");
						if (!obj[key]) obj[key] = [];

						// if it's an indexed array e.g. colors[2]
						if (paramName.match(/\[\d+\]$/)) {
							// get the index value and add the entry at the appropriate position
							var index = /\[(\d+)\]/.exec(paramName)[1];
							obj[key][index] = paramValue;
						} else {
							// otherwise add the value to the end of the array
							obj[key].push(paramValue);
						}
					} else {
						// we're dealing with a string
						if (!obj[paramName]) {
							// if it doesn't exist, create property
							obj[paramName] = paramValue;
						} else if (obj[paramName] && typeof obj[paramName] === "string") {
							// if property does exist and it's a string, convert it to an array
							obj[paramName] = [obj[paramName]];
							obj[paramName].push(paramValue);
						} else {
							// otherwise add the property
							obj[paramName].push(paramValue);
						}
					}
				}
			}
			return obj;
		};

		$rootScope.checkTodo = function (type) {
			return baseService.get(
				"shared/v1/todo/check/" + $rootScope.active_school.id + "/" + type
			);
		};

		$rootScope.dismissTodo = function (type) {
			return baseService.get(
				"shared/v1/todo/dismiss/" + $rootScope.active_school.id + "/" + type
			);
		};

		$rootScope.getServingURL = function (url, size, crop) {
			if (url && url.indexOf("googleusercontent") > -1) {
				var newURL = url.split("?")[0];
				newURL += "=s" + size;
				if (crop) {
					newURL += "-c";
				}
				return newURL;
			} else {
				return url;
			}
		};
		$scope.showAgainCheck = false;

		$scope.onTickBoxClicked = function () {
			$scope.showAgainCheck = !$scope.showAgainCheck;
		};

		$scope.goToSchoolStructure = function () {
			if ($scope.showAgainCheck) {
				$scope.dismissTodo("SCHOOL_REP_MOVE_UP_NUDGE").then(
					function (resp) {},
					function (error) {}
				);
			}
			window.location.href = $rootScope.integrationEnabled() ? "/school/#/school/integration-structure" : "/school/#/school/structure";
		};
		/*
		 * This function is responsible from whether displaying the move up dialog or not.
		 * Will Show the dialog until they dismiss it OR
		 * a year has been created or updated in last 3 months and != contains 'joiner'
		 */
		$scope.checkAndDisplayMoveUpDialog = function () {
			// if new school or integration dont show this. FMA-1613
			if (!$rootScope.active_school) {
				return;
			}
			if ($rootScope.active_school.integrationEnabled) {
				return;
			}
			try {
				var createdDate = new Date($rootScope.active_school.created);
				var currentYear = new Date().getFullYear();
				var month = createdDate.getMonth();
				// dont show if created in July, August, September this year
				if (createdDate.getFullYear() === currentYear && (month === 6 || month === 7 || month === 8)) {
					return;
				}
			} catch (error) {

			}
			
			$scope.checkTodo("SCHOOL_REP_MOVE_UP_NUDGE").then(function (resp) {
				if (resp.data.payload.show) {
					var modalInstance = $uibModal.open({
						animation: true,
						scope: $scope,
						backdropClass: "backdrop-zindexed",
						windowClass: "moveup-modal-window",
						templateUrl: "app/base/views/move-up-modal.html",
						size: "lg",
						controller: function ($scope) {
							$scope.close = function () {
								if ($scope.showAgainCheck) {
									$scope.dismissTodo("SCHOOL_REP_MOVE_UP_NUDGE").then(
										function (resp) {},
										function (error) {}
									);
								}
								modalInstance.close();
							};
							$scope.goToSchoolStructure = function () {
								modalInstance.close();
								$scope.$parent.goToSchoolStructure();
							};
						},
					});
				} else {
				}
			});
		};
		// Display move up dialog or not?
		setTimeout(function () {
			$scope.checkAndDisplayMoveUpDialog();
		}, 2000);
	}
})();

function copyToClipboard(text) {
	var copyElement = document.createElement("span");
	copyElement.appendChild(document.createTextNode(text));
	copyElement.id = "tempCopyToClipboard";
	angular.element(document.body.append(copyElement));

	var range = document.createRange();
	range.selectNode(copyElement);
	window.getSelection().removeAllRanges();
	window.getSelection().addRange(range);

	document.execCommand("copy");
	window.getSelection().removeAllRanges();
	copyElement.remove();
}

var WSS = {
    _socket: null,
    _server: null,

    init: function(server) {
        this._server = server;

        if (this._socket && this._socket.connected) {
            return;
        }

        this._socket = io(server, { upgrade: false, transports: ['websocket'] });

        var _this = this;

        this._socket.on('connect', function() {
			if (_this.onConnected) _this.onConnected();
        });

        this._socket.on('message', function(data) {
            if (_this.onPush) _this.onPush(data);
        });

        this._socket.on('disconnect', function() {
            if (_this.onClosed) _this.onClosed();
            setTimeout(function() {
                if (!document.hidden) {
                    _this.init(_this._server);
                }
            }, 5000);
        });

        if (document.addEventListener) {
            var tout;
            document.addEventListener("visibilitychange", function() {
                if (tout) clearTimeout(tout);
                if (document.hidden && _this._socket.connected) {
                    _this._socket.disconnect();
                }

                tout = setTimeout(function() {
                    if (!document.hidden && !_this._socket.connected) {
                        _this.init(_this._server);
                    }
                }, 5000);
            });
        }
    },

    send: function(object) {
        this._socket.emit('message', object);
    }
};

(function () {
	"use strict";

	var app = angular.module("CLSchool", [
		"ngSanitize",
		"ui.router",
		"ui.bootstrap",
		"toastr",
		"angular-flatpickr",
		"pascalprecht.translate",
		"angular-click-outside",
		"services.base",
		"services.errorHandler",
		"services.httpInterceptor",
		"services.introjs",
		"services.storage",
		"services.auth",
		"services.ganalytics",
		"services.upload",
		"directives.avatar",
		"directives.timeago",
		"directives.loader",
		"directives.autoresizeTextarea",
		"directives.autoresizeTextareaComment",
		"directives.draggable",
		"directives.droppable",
		"directives.classPicker",
		"directives.filterPicker",
		"directives.zendesk",
		"directives.countries",
		"directives.runmap",
		"directives.contenteditable",
		"directives.textEditor",
		"directives.postAssetAdmin",
		"directives.postAsset",
		"directives.postComments",
		"directives.csvUpload",
		"directives.listingItem",
		"directives.removeChars",
		"directives.onlyNumberInput",
		"directives.pasteStripHtml",
		"directives.notifications",
		"directives.photoUpload",
		"directives.cropper",
		"directives.months",
		"directives.genders",
		"directives.datepickerDirective",
		"directives.inviteAccordionDirective",
		"directives.percentageGraph",
		"directives.percentageGraphTwoColors",
		"directives.tooltip",
		"directives.galleryPicker",
		"directives.datetimepickerNeutralTimezone",
		"directives.googleMapsAutocomplete",
		"directives.preventScrolling",
		"directives.commentComposer",
		"filters.groupBy",
		"modules.pupilmanagement",
		"modules.baseModule",
		"modules.school",
		"modules.school.structure",
		"modules.school.integrationStructure",
		"modules.dashboard",
		"modules.dashboard.main",
		"modules.users",
		"modules.users.manageparents",
		"modules.users.approveparents",
		"modules.users.staffdetail",
		"modules.notifications",
		"modules.announcements",
		"modules.announcements.list",
		"modules.announcements.view",
		"modules.schoolpage",
		"modules.schooladmins",
		"modules.announcements.create",
		"modules.announcements.edit",
		"modules.users.parentdetail",
		"modules.users.nonparentdetail",
		"modules.schoolcontacts",
		"modules.events",
		"modules.events.create",
		"modules.events.start",
		"modules.events.list",
		"modules.events.view",
		"modules.events.tickets",
		"modules.events.guests",
		"modules.events.dashboard",
		"modules.events.owners",
		"modules.events.rota",
		"modules.events.rotadetails",
		"modules.raffle",
		"modules.raffle.list",
		"modules.raffle.create",
		"modules.raffle.setup",
		"modules.raffle.prizes",
		"modules.raffle.preview",
		"modules.raffle.dashboard",
		"modules.raffle.otherpreview",
		"modules.raffle.draft",
		"modules.raffle.owners",
		"modules.participants",
		"modules.groupparticipants",
		"modules.grouptags",
		"modules.parents",
		"modules.groups",
		"modules.groups.list",
		"modules.groups.interestGroups",
		"modules.groups.interestGroupsView",
		"modules.groups.view",
		"modules.groups.create",
		"modules.groups.members",
		"modules.monitor",
		"modules.marketplace",
		"modules.marketplace.list",
		"modules.marketplace.detail",
		"modules.post.likes",
		"modules.profile",
		"modules.invite.bulkemailupload",
		"modules.invite",
		"modules.invite.nonmemberlist",
		"modules.invite.integrationNonmemberlist",
		"modules.post",
		"modules.onboarding",
		"modules.nonmember",
		"modules.get-started",
		"modules.invite.bulkuploadhistory",
		"modules.website",
		"modules.website.settings",
		"modules.website.comingsoon",
	]);
})();

(function() {
    'use strict';

    angular.module('CLSchool').run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, regexes, $sce, storage, authService, gaService, $uibModalStack, $location, $window, $uibModal, $state, $timeout) {

        $rootScope.history = [];
        $rootScope.isDirty = false;

        $rootScope.getOS = function() {
            var userAgent = navigator.userAgent || navigator.vendor || window.opera;

            if(userAgent.includes('flutter-web-view')) {
                return "Flutter";
            }

            // Windows Phone must come first because its UA also contains "Android"
            if (/windows phone/i.test(userAgent)) {
                return "Windows Phone";
            }

            if (/android/i.test(userAgent)) {
                return "Android";
            }

            // iOS detection from: http://stackoverflow.com/a/9039885/177710
            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                return "iOS";
            }

            return "unknown";
        }

        //For turning off the scrollToTop if needed
        $rootScope.turnOnScrolling = true;

        $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {

            $rootScope.gaLoadPage = toState.params.gaPage;

            (toParams.needAuth && _.isNull(storage.getToken())) ? authService.logout(true): $rootScope.$broadcast('VIEW_CHANGED', { from: fromState, to: toState, toParams: toParams });

            processScrollToTop(toParams);

            if (!_.isUndefined($rootScope.gaDimension) && !_.isUndefined(gaService)) {
                gaService.send(toState.params.gaPage || 'undefined');
            }

            $uibModalStack.dismissAll();
            processBeforeunload(event, toState, toParams, fromState, fromParams);
        });

        $rootScope.$on('$stateChangeSuccess', function() {
            $rootScope.isDirty = false;
        });

        //track history
        if (!$rootScope.loadedHistory) {
            $rootScope.loadedHistory = true;
            $rootScope.$on("$locationChangeSuccess", function(e, currentLocation, previousLocation) {
                $rootScope.history.push(previousLocation);
                $timeout(function() {
                    checkDatePickers();
                }, 500); 
                $timeout(function() {
                    checkDatePickers();
                }, 2000); 
                $timeout(function() {
                    checkDatePickers();
                }, 4000); 
            });
        }

        function processScrollToTop(toParams) {
            if (toParams.scrollToTop) {
                $timeout(function() {
                    $window.scrollTo(0, 0);
                }, 100);
            }
        }

        function processBeforeunload(e, toState, toParams, fromState, fromParams) {
            $rootScope.$broadcast(fromState.name, {
                'e': e,
                'toState': toState,
                'toParams': toParams
            });
        }

        function checkDatePickers() {
            var eventDatePicker = document.querySelector(".event-start-date-input-container");
    
            if (!eventDatePicker) {
                return;
            }
    
            var flatpickrInputs = document.querySelectorAll('.flatpickr-input');
            if (flatpickrInputs.length > 0) {
                flatpickrInputs.forEach(function(input) {
                    input.setAttribute('readonly', true);
                });
            } 
        }

        $rootScope.currentUserId = function() {
            return $rootScope.active_user.id;
        }

        //Functions for link handling
        $rootScope.parseLinks = function(text) {
            if (!text)
                return text;

            if (!_.isUndefined(text)) {
                text = text.replace(regexes.openingTagStart, '<a');

                if (text.indexOf('_blank') > -1)
                    text = text.replace(regexes.openingTagEnd, ' target="_blank">');
                else
                    text = text.replace(regexes.openingTagEndNotBlank, '">');

                text = text.replace(regexes.closingTag, '</a>');
            }
            return text;
        }

        $rootScope.createEmailLinks = function(text) {
            if (!text)
                return text;

            return text.replace(regexes.url, function(url) {
                if (url.indexOf('http:') == -1 && url.indexOf('https:') == -1)
                    url = 'http://' + url;

                var addDot = false;
                if (url[url.length - 1] == '.') {
                    url = url.substring(0, url.length - 1);
                    addDot = true;
                }

                return '[URL href="' + url + '" target="_blank"]' + url + '[/URL]' + (addDot ? '.' : '');
            })
        }

        $rootScope.removeLinks = function(text) {
            if (!text)
                return text;

            var str = text.match(/"(https|http|www):?.*?"/gi);
            if (str !== null) {
                text = text.replace('[URL href=', '');
                text = text.replace(' target=\"_blank\"]', ' ');
                text = text.replace(regexes.closingTag, '');
                text = text.replace(str, '');
                for (var i = 0; i < str.length; i++) {
                    text = text.replace('[URL href=', '');
                    text = text.replace(' target=\"_blank\"]', ' ');
                    text = text.replace(regexes.closingTag, '');
                    text = text.replace(str[i], '');
                }
                return text;
            } else {
                return text;
            }
        }

        $rootScope.parseMentionTags = function(postBody) {
            if (!postBody) {
				return postBody;
			}

			var regexp = /\[MENTION(.+?)\](.+?)\[\/MENTION\]/g
			var regexp2 = /userId=\"(.*?)\"/
			
			var matches = window.searchString(postBody, regexp);
			for (var i = 0;i < matches.length; i++) {
				var match = matches[i];
				if (!match) {
					continue;
				}
				var all = match[0];
				var name = match[2];
				var userId = match[1];

				var umatches = window.searchString(userId, regexp2);

				for (var j = 0;j < umatches.length; j++) {
					var umatch = umatches[j];
					
					if (!umatch) {
						continue;
					}

					userId = umatch[1];
				}

				var MENTIONTEXT = "<a href=\"#/users/parent-detail/"+userId+"\">"+name+"</a>";
				postBody = postBody.replace(all, MENTIONTEXT);
			}
			return postBody;
        }

        $rootScope.evaluateBack = function(redirectPages) {
            var foundRedirect = false;
            for (var i = $rootScope.history.length - 1; i >= 0; i--) {
                var page = $rootScope.history[i];

                var matches = _.filter(redirectPages, function(s) {
                    return page.indexOf(s) !== -1;
                });

                if (!_.isUndefined(matches) && matches.length > 0) {
                    $window.location.href = page;
                    foundRedirect = true;
                    break;
                }
            }
            if (!foundRedirect) {
                if (redirectPages.length > 1) {
                    $window.location.href = redirectPages[1];
                } else {
                    $window.location.href = redirectPages[0];
                }
            }
        }
        $rootScope.parseTagsToLinks = function(text) {
			if(!text)
				return text;

			if (!_.isUndefined(text)) {
				text = text.replace(regexes.openingTagStart, '<a');

				if(text.indexOf('_blank') > -1)
					text = text.replace(regexes.openingTagEnd, ' target="_blank">');
				else
					if(!text.includes('[MENTION')){
						text = text.replace(regexes.openingTagEndNotBlank, '">');
					}
				text = text.replace(regexes.closingTag, '</a>');
			}
			
			return text;
		}
        $rootScope.getQueryParam = function(name, url) {
            var resultFromURL = readParamsFromURL(name, url);

            if (!resultFromURL || resultFromURL == null || resultFromURL == '') {

                var storageItem = $window.localStorage.getItem(name);

                if (storageItem == null || !storageItem || storageItem == '') {
                    return '';
                }

                $window.localStorage.removeItem(name);

                if (name == "url" || name == "ReturnUrl") {
                    storageItem = decodeURIComponent(storageItem);
                }

                return storageItem;
            }
            return resultFromURL;
        }

        function readParamsFromURL(name, url) {
            if (!url) {
                url = window.location.href;
            }
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        }

        $rootScope.getWithoutTimeZone = function(date) {
            var offset = timezone(date ? new Date(date) : new Date());
            var addHours = new Date(date ? new Date(date) : new Date()).getTime() + (offset * 3600000);
            return new Date(addHours);
        }

        $rootScope.getUTCDatetime = function(date) {
            var now = date ? new Date(date) : new Date();
            var now_utc = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds());
            return now_utc;
        }

        function timezone(date) {
            var offset = date.getTimezoneOffset();
            var minutes = Math.abs(offset);
            var hours = Math.floor(minutes / 60);
            var prefix = offset < 0 ? "+" : "-";
            return prefix + hours;
        }
    }
})();

function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

function validateLink(url){
    var re = new RegExp(
		"^" +
		  // protocol identifier (optional)
		  // short syntax // still required
		  "(?:(?:(?:https?|ftp):)?\\/\\/)" +
		  // user:pass BasicAuth (optional)
		  "(?:\\S+(?::\\S*)?@)?" +
		  "(?:" +
			// IP address exclusion
			// private & local networks
			"(?!(?:10|127)(?:\\.\\d{1,3}){3})" +
			"(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})" +
			"(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})" +
			// IP address dotted notation octets
			// excludes loopback network 0.0.0.0
			// excludes reserved space >= 224.0.0.0
			// excludes network & broadcast addresses
			// (first & last IP address of each class)
			"(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])" +
			"(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}" +
			"(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))" +
		  "|" +
			// host & domain names, may end with dot
			// can be replaced by a shortest alternative
			// (?![-_])(?:[-\\w\\u00a1-\\uffff]{0,63}[^-_]\\.)+
			"(?:" +
			  "(?:" +
				"[a-z0-9\\u00a1-\\uffff]" +
				"[a-z0-9\\u00a1-\\uffff_-]{0,62}" +
			  ")?" +
			  "[a-z0-9\\u00a1-\\uffff]\\." +
			")+" +
			// TLD identifier name, may end with dot
			"(?:[a-z\\u00a1-\\uffff]{2,}\\.?)" +
		  ")" +
		  // port number (optional)
		  "(?::\\d{2,5})?" +
		  // resource path (optional)
		  "(?:[/?#]\\S*)?" +
		"$", "i"
	  );
    return re.test(url);
}

function validateLinkSecureOnly(url){
    var re = new RegExp(
		"^" +
		  // protocol identifier (optional)
		  // short syntax // still required
		  "(?:(?:(?:https?|ftp):)?\\/\\/)" +
		  // user:pass BasicAuth (optional)
		  "(?:\\S+(?::\\S*)?@)?" +
		  "(?:" +
			// IP address exclusion
			// private & local networks
			"(?!(?:10|127)(?:\\.\\d{1,3}){3})" +
			"(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})" +
			"(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})" +
			// IP address dotted notation octets
			// excludes loopback network 0.0.0.0
			// excludes reserved space >= 224.0.0.0
			// excludes network & broadcast addresses
			// (first & last IP address of each class)
			"(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])" +
			"(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}" +
			"(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))" +
		  "|" +
			// host & domain names, may end with dot
			// can be replaced by a shortest alternative
			// (?![-_])(?:[-\\w\\u00a1-\\uffff]{0,63}[^-_]\\.)+
			"(?:" +
			  "(?:" +
				"[a-z0-9\\u00a1-\\uffff]" +
				"[a-z0-9\\u00a1-\\uffff_-]{0,62}" +
			  ")?" +
			  "[a-z0-9\\u00a1-\\uffff]\\." +
			")+" +
			// TLD identifier name, may end with dot
			"(?:[a-z\\u00a1-\\uffff]{2,}\\.?)" +
		  ")" +
		  // port number (optional)
		  "(?::\\d{2,5})?" +
		  // resource path (optional)
		  "(?:[/?#]\\S*)?" +
		"$", "i"
	  );
    if (url.startsWith('http:')) return false;
    return re.test(url);
}

function isThisMobile() {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4)))
        return true;

    return false;
}

function isURL(str) {
    if (!str || str == '') {
        return false;
    }
    str = str.toLowerCase();

    var pattern = new RegExp('(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9]\.[^\s]{2,})');
    return pattern.test(str);
}

function showCustomAppcue(item, options) {
    var canshow = false;

    if (options) {
        if (options.isMobile) {
            canshow = isThisMobile()
        } else if (options.isDesktop) {
            canshow = !isThisMobile()
        } else {
            canshow = true;
        }

        if (canshow) {
            //if(options.urlCondition) {
            // if(location.href.indexOf(options.urlCondition) > -1)
            // 	canshow = true;
            // else 
            // 	canshow = false;
            canshow = true;
            // }
            // else {
            // 	canshow = false;
            // }
        }
    }

    if (canshow) {
        var cappcues = document.getElementsByClassName(item)
        if (cappcues) {
            cappcues[0].classList.add('active-appcue')
        }
    }
}

function dismissCustomAppcue() {
    var cappcues = document.getElementsByClassName('custom-appcues')
    if (cappcues) {
        for (var i = 0; i < cappcues.length; i++) {
            cappcues[i].classList.remove('active-appcue');
        }
    }
}
(function() {
    "use strict";

    angular
        .module("CLSchool")
        .factory("routerService", [
            "base",
            "$http",
            function(base, $http) {
                return _.create(base, {});
            },
        ])
        .config(routerConfig);

    /** @ngInject */
    function routerConfig(
        $stateProvider,
        $qProvider,
        $locationProvider,
        $urlRouterProvider
    ) {
        $qProvider.errorOnUnhandledRejections(false);
        $locationProvider.hashPrefix("");
        var metadataFilePath = "i8n/locale-metadata-en-GB.json?v=12";

        $stateProvider
            .state("school", {
                url: "/school",
                templateUrl: "app/school/views/wrapper.html",
                params: {
                    gaPage: "school",
                    needAuth: true,
                },
                controller: "schoolController",
            })
            .state("school.structure", {
                url: "/structure",
                templateUrl: "app/school/views/school-structure.html",
                params: {
                    needAuth: true,
                    gaPage: "school/structure",
                    scrollToTop: true,
                },
                controller: "schoolStructureController",
            })
            .state("school.integrationStructure", {
                url: "/integration-structure",
                templateUrl: "app/school/views/school-integration-structure.html",
                params: {
                    needAuth: true,
                    gaPage: "school/integration-structure",
                    scrollToTop: true,
                },
                controller: "schoolIntegrationStructureController",
            })
            .state("school.page", {
                url: "/details",
                templateUrl: "app/schoolpage/views/school-page.html",
                params: {
                    needAuth: true,
                    gaPage: "school/details",
                    scrollToTop: true,
                },
                controller: "schoolPageController",
            })
            .state("school.admins", {
                url: "/admins",
                templateUrl: "app/schoolpage/views/school-admins.html",
                params: {
                    needAuth: true,
                    gaPage: "school/admins",
                    scrollToTop: true,
                },
                controller: "schoolAdminsController",
            })
            .state("school.contacts", {
                url: "/details/:type",
                templateUrl: "app/schoolpage/views/school-contacts-page.html",
                params: {
                    needAuth: true,
                    gaPage: "school/contacts",
                    scrollToTop: true,
                },
                controller: "schoolContactsController",
            })
            .state("onboarding", {
                url: "/onboarding",
                templateUrl: "app/onboarding/wrapper.html",
                params: {
                    gaPage: "onboarding",
                    scrollToTop: true,
                },
            })
            .state("onboarding.start", {
                url: "/start/:invited?",
                templateUrl: "app/onboarding/views/start.html",
                params: {
                    gaPage: "onboarding/start",
                },
                controller: "onboardingController",
            })
            .state("dashboard", {
                url: "/dashboard",
                templateUrl: "app/dashboard/wrapper.html",
                params: {
                    gaPage: "dashboard",
                },
                controller: "dashboardController",
            })
            .state("dashboard.main", {
                url: "/view",
                templateUrl: "app/dashboard/views/dashboard-main.html",
                params: {
                    gaPage: "dashboard/main",
                },
                controller: "dashmainController",
            })
            .state("invite", {
                url: "/invite",
                templateUrl: "app/invite/views/wrapper.html",
                params: {
                    needAuth: true,
                    gaPage: "invite",
                },
                controller: "inviteController",
            })
            .state("invite.nonmemberlist", {
                url: "/add-invite",
                templateUrl: "app/invite/views/add-invite.html",
                params: {
                    needAuth: true,
                    gaPage: "add/invite",
                },
                controller: "nonMemberListController",
            })
            .state("invite.integrationNonmemberlist", {
                url: "/add-invite-integration",
                templateUrl: "app/invite/views/add-invite-integration.html",
                params: {
                    needAuth: true,
                    gaPage: "add/invite-integration",
                },
                controller: "integrationNonMemberListController",
            })
            .state("invite.bulkemailupload", {
                url: "/bulk-email-upload",
                templateUrl: "app/invite/views/bulk-email-upload.html",
                params: {
                    needAuth: true,
                    gaPage: "bulk/email",
                    redirectPages: [
                        "/school/#/dashboard/view",
                        "/school/#/invite/add-invite",
                    ],
                    isDirty: false,
                },
                controller: "bulkEmailUploadController",
            })
            .state("users", {
                url: "/users",
                templateUrl: "app/users/views/wrapper.html",
                params: {
                    needAuth: true,
                    gaPage: "users",
                },
                controller: "usersController",
            })
            .state("users.manageparents", {
                url: "/manage-parents/:search?",
                templateUrl: "app/users/views/manage-parents.html",
                params: {
                    needAuth: true,
                    gaPage: "manage/parents",
                    scrollToTop: true,
                },
                controller: "parentManageController",
            })
            .state("users.parentdetail", {
                url: "/parent-detail/:id",
                templateUrl: "app/users/views/parent-detail.html",
                params: {
                    needAuth: true,
                    gaPage: "parent/detail",
                    scrollToTop: true,
                    redirectPages: [
                        "/school/#/users/manage-parents",
                        "/school/#/school/details",
                        "/school/#/users/approve-parents",
                    ],
                },
                controller: "parentDetailController",
                resolve: {
                    metadata: function(routerService, $http) {
                        return $http.get(metadataFilePath, { cache: true });
                    },
                },
            })
            .state("users.staffdetail", {
                url: "/staff-detail/:id",
                templateUrl: "app/users/views/staff-detail.html",
                params: {
                    needAuth: true,
                    gaPage: "staff/detail",
                    scrollToTop: true,
                    redirectPages: [
                        "/school/#/users/manage-parents",
                        "/school/#/school/admins",
                        "/school/#/users/approve-parents",
                    ],
                },
                controller: "staffDetailController",
                resolve: {
                    metadata: function(routerService, $http) {
                        return $http.get(metadataFilePath, { cache: true });
                    },
                },
            })
            .state("users.nonparentdetail", {
                url: "/non-member-detail/:id",
                templateUrl: "app/users/views/non-parent-detail.html",
                params: {
                    needAuth: true,
                    gaPage: "nonmember/detail",
                    scrollToTop: true,
                    redirectPages: ["/school/#/users/manage-parents"],
                },
                controller: "nonParentDetailController",
                resolve: {
                    metadata: function(routerService, $http) {
                        return $http.get(metadataFilePath, { cache: true });
                    },
                },
            })
            .state("users.approveparents", {
                url: "/approve-parents",
                templateUrl: "app/users/views/approve-parents.html",
                params: {
                    needAuth: true,
                    gaPage: "manage/approveparents",
                    scrollToTop: true,
                },
                controller: "approveParentsController",
            })
            .state("announcements", {
                url: "/announcements",
                templateUrl: "app/announcements/views/wrapper.html",
                controller: "announcementsController",
                params: {
                    needAuth: true,
                    gaPage: "announcements",
                },
            })
            .state("announcements.list", {
                url: "/list",
                templateUrl: "app/announcements/views/announcement-list.html",
                controller: "announcementsListController",
                params: {
                    needAuth: true,
                    gaPage: "announcements.list",
                    scrollToTop: true,
                },
            })
            .state("announcements.view", {
                url: "/view/:id",
                templateUrl: "app/announcements/views/announcement-view.html",
                controller: "announcementsViewController",
                params: {
                    needAuth: true,
                    gaPage: "announcements.view",
                },
            })
            .state("announcements.create", {
                url: "/create",
                templateUrl: "app/announcements/views/announcement-create.html",
                controller: "announcementsCreateController",
                params: {
                    needAuth: true,
                    gaPage: "announcements.create",
                    redirectPages: [
                        "/school/#/dashboard/view",
                        "/school/#/announcements/list",
                    ],
                    scrollToTop: true,
                },
            })
            .state("announcements.edit", {
                url: "/edit/:id",
                templateUrl: "app/announcements/views/announcement-edit.html",
                controller: "announcementsEditController",
                params: {
                    needAuth: true,
                    gaPage: "announcements.edit",
                    redirectPages: [
                        "/school/#/dashboard/view",
                        "/school/#/announcements/list",
                    ],
                    scrollToTop: true,
                },
            })
            .state("events", {
                url: "/community-events",
                templateUrl: "app/events/views/wrapper.html",
                controller: "eventsController",
                params: {
                    needAuth: true,
                    gaPage: "community-events",
                    scrollToTop: true,
                },
            })
            .state("events.list", {
                url: "/list",
                templateUrl: "app/events/views/list.html",
                controller: "eventsListController",
                params: {
                    needAuth: true,
                    gaPage: "events.list",
                    scrollToTop: true,
                },
            })
            .state("events.view", {
                url: "/view/:id",
                templateUrl: "app/events/views/view.html",
                controller: "eventsViewController",
                params: {
                    needAuth: true,
                    id: null,
                    gaPage: "events.view",
                    redirectPages: ["/school/#/events/list", "/school/#/notifications"],
                    scrollToTop: true,
                },
                reloadOnSearch: false,
            })
            .state("events.create", {
                url: "/create/:id?",
                templateUrl: "app/events/views/create.html",
                controller: "eventsCreateController",
                params: {
                    needAuth: true,
                    gaPage: "events.create",
                    scrollToTop: true,
                },
            })
            .state("events.start", {
                url: "/start",
                templateUrl: "app/events/views/start.html",
                controller: "eventsStartController",
                params: {
                    needAuth: true,
                    gaPage: "events.start",
                    scrollToTop: true,
                },
            })
            .state("events.tickets", {
                url: "/tickets/:id_event",
                templateUrl: "app/events/views/tickets.html",
                controller: "eventTicketsController",
                params: {
                    needAuth: true,
                    gaPage: "events.tickets",
                    scrollToTop: true,
                },
            })
            .state("events.dashboard", {
                url: "/dashboard/:id_event",
                templateUrl: "app/events/views/dashboard.html",
                controller: "eventDashboardController",
                params: {
                    needAuth: true,
                    gaPage: "events.dashboard",
                    scrollToTop: true,
                },
            })
            .state("events.guests", {
                url: "/guests/:id_event",
                templateUrl: "app/events/views/manage-guests.html",
                controller: "eventGuestsController",
                params: {
                    needAuth: true,
                    gaPage: "events.guests",
                    scrollToTop: true,
                },
            })
            .state("events.owners", {
                url: "/owners/:id_event",
                templateUrl: "app/events/views/owners.html",
                controller: "eventOwnersController",
                params: {
                    needAuth: true,
                    gaPage: "events.owners",
                    scrollToTop: true,
                },
            })
            .state("events.rota", {
                url: "/:id_event/signup/:id_rota?",
                templateUrl: "app/events/views/rota.html",
                controller: "eventRotaController",
                params: {
                    needAuth: true,
                    gaPage: "events.rota",
                    scrollToTop: true,
                },
            })
            .state("events.rotadetails", {
                url: "/:id_event/signup/:id_rota/view/:id_task",
                templateUrl: "app/events/views/rota-details.html",
                controller: "eventRotaDetailsController",
                params: {
                    needAuth: true,
                    gaPage: "events.rotadetails",
                    scrollToTop: true,
                },
            })
            .state("raffle", {
                url: "/raffle",
                templateUrl: "app/raffle/views/wrapper.html",
                controller: "raffleController",
                params: {
                    needAuth: true,
                    gaPage: "raffle",
                    scrollToTop: true,
                },
            })
            .state("raffle.list", {
                url: "/list",
                templateUrl: "app/raffle/views/raffle-list.html",
                controller: "raffleListController",
                params: {
                    needAuth: true,
                    gaPage: "raffle.list",
                    scrollToTop: true,
                },
            })
            .state("raffle.create", {
                url: "/create",
                templateUrl: "app/raffle/views/create-raffle.html",
                controller: "raffleCreateController",
                params: {
                    needAuth: true,
                    gaPage: "raffle.create",
                    scrollToTop: true,
                },
            })
            .state("raffle.dashboard", {
                url: "/:raffle_id/dashboard",
                templateUrl: "app/raffle/views/raffle-dashboard.html",
                controller: "raffleDashboardController",
                params: {
                    needAuth: true,
                    gaPage: "raffle.dashboard",
                    scrollToTop: true,
                    notify: false
                },
            })
            .state("raffle.otherpreview", {
                url: "/:raffle_id/otherpreview",
                templateUrl: "app/raffle/views/raffle-otherpreview.html",
                controller: "raffleOtherPreviewController",
                params: {
                    needAuth: true,
                    gaPage: "raffle.otherpreview",
                    scrollToTop: true,
                    notify: false
                },
            })
            .state("raffle.owners", {
                url: "/owners/:id_raffle",
                templateUrl: "app/raffle/views/owners.html",
                controller: "raffleOwnersController",
                params: {
                    needAuth: true,
                    gaPage: "raffle.owners",
                    scrollToTop: true,
                },
            })
            .state("raffle.draft", {
                url: "/:raffle_id/draft",
                templateUrl: "app/raffle/views/raffle-draft.html",
                controller: "raffleDraftController",
                params: {
                    needAuth: true,
                    gaPage: "raffle.draft",
                    scrollToTop: true,
                },
            })
            .state("raffle.preview", {
                url: "/:raffle_id/preview",
                templateUrl: "app/raffle/views/raffle-preview.html",
                controller: "rafflePreviewController",
                params: {
                    needAuth: true,
                    gaPage: "raffle.preview",
                    scrollToTop: true,
                },
            })
            .state("raffle.prizes", {
                url: "/:raffle_id/prizes",
                templateUrl: "app/raffle/views/raffle-prizes.html",
                controller: "rafflePrizesController",
                params: {
                    needAuth: true,
                    gaPage: "raffle.prizes",
                    scrollToTop: true
                },
            })
            .state("raffle.setup", {
                url: "/:raffle_id",
                templateUrl: "app/raffle/views/setup-raffle.html",
                controller: "raffleSetupController",
                params: {
                    needAuth: true,
                    gaPage: "raffle.setup",
                    scrollToTop: true,
                },
            })
            .state("groups", {
                url: "/groups",
                templateUrl: "app/groups/views/wrapper.html",
                controller: "groupsController",
                params: {
                    needApproval: true,
                    needAuth: true,
                    gaPage: "groups",
                    scrollToTop: true,
                },
            })
            .state("groups.list", {
                url: "/list",
                templateUrl: "app/groups/views/groups-list-lg.html",
                controller: "groupsListController",
                params: {
                    needApproval: true,
                    needAuth: true,
                    gaPage: "groups.list",
                    scrollToTop: true,
                },
            })
            .state("groups.interestGroups", {
                url: "/interestgroups",
                templateUrl: "app/groups/views/interest-groups-list-lg.html",
                controller: "interestGroupsListController",
                params: {
                    needApproval: true,
                    needAuth: true,
                    gaPage: "groups.interestGroups",
                    scrollToTop: true,
                },
            })
            .state("groups.interestGroupsView", {
                url: "/interestgroups/:id",
                templateUrl: "app/groups/views/interest-group-view.html",
                controller: "interestGroupsViewController",
                params: {
                    needApproval: true,
                    needAuth: true,
                    id: null,
                    scrollToTop: true,
                    gaPage: "groups.view",
                },
            })
            .state("groups.view", {
                url: "/view/:id",
                templateUrl: "app/groups/views/group-view.html",
                controller: "groupsViewController",
                params: {
                    needApproval: true,
                    needAuth: true,
                    id: null,
                    scrollToTop: true,
                    gaPage: "groups.view",
                },
            })
            .state("groups.create", {
                url: "/create",
                templateUrl: "app/groups/views/create-group.html",
                controller: "groupsCreateController",
                params: {
                    needApproval: true,
                    needAuth: true,
                    gaPage: "groups.create",
                    scrollToTop: true,
                },
            })
            .state("groups.members", {
                url: "/members/:id",
                templateUrl: "app/groups/views/group-members.html",
                controller: "groupsMembersController",
                params: {
                    needApproval: true,
                    needAuth: true,
                    id: null,
                    gaPage: "groups.members",
                    scrollToTop: true,
                },
            })
            .state("monitor", {
                url: "/monitor",
                templateUrl: "app/monitor/views/wrapper.html",
                controller: "monitorController",
                params: {
                    needApproval: true,
                    needAuth: true,
                    gaPage: "community/monitor",
                    scrollToTop: true,
                },
                resolve: {
                    metadata: function(routerService, $http) {
                        return $http.get("i8n/locale-metadata-en-GB.json?v=12");
                    },
                },
            })
            .state("marketplace", {
                url: "/marketplace",
                templateUrl: "app/marketplace/views/wrapper.html",
                controller: "marketplaceController",
                params: {
                    needApproval: true,
                    needAuth: true,
                    gaPage: "marketplace",
                    scrollToTop: true,
                },
            })
            .state("marketplace.list", {
                url: "/list",
                templateUrl: "app/marketplace/views/list.html",
                controller: "marketplaceListController",
                params: {
                    needApproval: true,
                    needAuth: true,
                    gaPage: "marketplace/list",
                    scrollToTop: true,
                },
            })
            .state("marketplace.detail", {
                url: "/detail/:id",
                templateUrl: "app/marketplace/views/detail.html",
                controller: "marketplaceDetailController",
                params: {
                    needApproval: true,
                    needAuth: true,
                    gaPage: "marketplace/detail",
                    scrollToTop: true,
                },
            })
            .state("profile", {
                url: "/profile",
                cache: false,
                templateUrl: "app/profile/views/wrapper.html",
                controller: "profileController",
                params: {
                    needApproval: true,
                    needAuth: true,
                    gaPage: "profile",
                    scrollToTop: true,
                },
                resolve: {
                    metadata: function(routerService, $http) {
                        return $http.get(metadataFilePath, { cache: true });
                    },
                },
            })
            .state("profile.settings", {
                url: "/settings",
                templateUrl: "app/profile/views/parent.html",
                cache: false,
                params: {
                    needApproval: true,
                    needAuth: true,
                    scrollToTop: true,
                    gaPage: "profile/settings",
                },
            })
            .state("profile.staff", {
                url: "/staff",
                templateUrl: "app/profile/views/staff.html",
                cache: false,
                params: {
                    needApproval: true,
                    needAuth: true,
                    scrollToTop: true,
                    gaPage: "profile/settings/staff",
                },
            })
            .state("notifications", {
                url: "/notifications",
                templateUrl: "app/notifications/views/wrapper.html",
                controller: "notificationsController",
                params: {
                    needAuth: true,
                    gaPage: "notifications",
                },
            })
            .state("view", {
                url: "/post/:id",
                templateUrl: "app/post/views/post.html",
                controller: "postController",
                params: {
                    needAuth: true,
                    gaPage: "post.details",
                },
            })
            .state("get-started", {
                url: "/get-started",
                templateUrl: "app/get-started/views/get-started.html",
                controller: "getStartedController",
                params: {
                    needAuth: true,
                    gaPage: "get-started",
                    scrollToTop: true,
                },
            })

        .state("invite.bulkuploadhistory", {
            url: "/bulk-email-history",
            templateUrl: "app/invite/views/bulk-upload-history.html",
            params: {
                needAuth: true,
                gaPage: "bulk/email",
                redirectPages: [
                    "/school/#/dashboard/view",
                    "/school/#/invite/add-invite",
                ],
                isDirty: false,
            },
            controller: "bulkuploadhistoryController",
        })

        .state("nonmember", {
                url: "/welcome",
                templateUrl: "app/nonmember/views/wrapper.html",
                controller: "nonmemberController",
                params: {
                    needAuth: true,
                    gaPage: "nonmember",
                },
            })
            .state("website", {
                url: "/website",
                templateUrl: "app/website/views/wrapper.html",
                controller: "websiteController",
                params: {
                    needAuth: true,
                    scrollToTop: true
                },
            })
            .state("website.settings", {
                url: "/settings",
                templateUrl: "app/website/views/settings.html",
                controller: "websiteSettingsController",
                params: {
                    needAuth: true,
                    scrollToTop: true
                },
            })
            .state("website.comingsoon", {
                url: "/comingsoon",
                templateUrl: "app/website/views/comingsoon.html",
                controller: "websiteComingsoonController",
                params: {
                    needAuth: true,
                    scrollToTop: true
                },
            });
        $urlRouterProvider.otherwise("/dashboard/view");
    }
})();

(function() {
	'use strict';

	var conf = {
		'local':{
			'api': 'https://dev-api.classlist.com',
			'parentAppURL': 'http://localhost:3021',
			'schoolAppURL': 'http://localhost:3020',
			'ssoAppURL': 'http://localhost:3022',
			'advertiserAppURL':'http://localhost:3024',
			'wssURL': 'wss://flwebsocket.classlist.com?env=dev&token=',
			'ptaWebsiteURL': 'http://localhost:4200'
		},
		'dev':{
			'api': 'https://dev-api.classlist.com',
			'parentAppURL': 'https://dev-parent.classlist.com',
			'schoolAppURL': 'https://dev-school.classlist.com',
			'ssoAppURL': 'https://dev-sso.classlist.com',
			'wssURL': 'wss://flwebsocket.classlist.com?env=dev&token=',

			'ssoFolderURL':'https://internal-dev.classlist.com/login',
			'parentFolderURL':'https://internal-dev.classlist.com/parent',
			'schoolFolderURL':'https://internal-dev.classlist.com/school',
			'ptaWebsiteURL': 'https://web-dev.classlist.com'
		}, 
		'test':{
			'api': 'https://test-api.classlist.com',
			'parentAppURL': 'https://test-parent.classlist.com',
			'schoolAppURL': 'https://test-school.classlist.com',
			'ssoAppURL': 'https://test-sso.classlist.com',
			'wssURL': 'wss://flwebsocket.classlist.com?env=test&token=',

			'ssoFolderURL':'https://internal-test.classlist.com/login',
			'parentFolderURL':'https://internal-test.classlist.com/parent',
			'schoolFolderURL':'https://internal-test.classlist.com/school',
			'ptaWebsiteURL': 'https://web-test.classlist.com'
		},
		'prod':{
			'api': 'https://api.classlist.com',
			'parentAppURL': 'https://parent.classlist.com',
			'schoolAppURL': 'https://school.classlist.com',
			'ssoAppURL': 'https://login.classlist.com',
			'wssURL': 'wss://flwebsocket.classlist.com?env=prod&token=',
			'ssoFolderURL':'https://app.classlist.com/login',
			'parentFolderURL':'https://app.classlist.com/parent',
			'schoolFolderURL':'https://app.classlist.com/school',
			'ptaWebsiteURL': 'https://web.classlist.com'
		},
		'preprod':{
			'api': 'https://preprod-api.classlist.com',
			'parentAppURL':'https://preprod-parent.classlist.com',
			'schoolAppURL': 'https://preprod-school.classlist.com',
			'ssoAppURL': 'https://preprod-sso.classlist.com',
			'wssURL': 'wss://flwebsocket.classlist.com?env=preprod&token=',
			'sponsorAppURL': 'http://classlist-preprod-sponsor.s3-website.eu-west-2.amazonaws.com',
			'onboardingAppURL': 'https://preprod-onboarding.classlist.com',
			'ssoFolderURL':'https://internal-preprod.classlist.com/login',
			'parentFolderURL':'https://internal-preprod.classlist.com/parent',
			'schoolFolderURL':'https://internal-preprod.classlist.com/school',
			'ptaWebsiteURL': 'https://web-preprod.classlist.com'
		}
	}, env = '';

	var default_gallery_url = 'https://storage.googleapis.com/test-europe-api/';
	var default_gallery = [
		{ id: 'event-sample/birthday', title: 'BIRTHDAY', url: default_gallery_url + 'event-sample/birthday' },
		{ id: 'event-sample/coffee_morning', title: 'COFFEE_MORNING', url: default_gallery_url + 'event-sample/coffee_morning' },
		{ id: 'event-sample/birthday_3', title: 'BIRTHDAY', url: default_gallery_url + 'event-sample/birthday_3' },
		{ id: 'event-sample/charity', title: 'CHARITY', url: default_gallery_url + 'event-sample/charity' },
		{ id: 'event-sample/christmas', title: 'CHRISTMAS', url: default_gallery_url + 'event-sample/christmas' },
		{ id: 'event-sample/concert', title: 'CONCERT', url: default_gallery_url + 'event-sample/concert' },
		{ id: 'event-sample/halloween', title: 'HALLOWEEN', url: default_gallery_url + 'event-sample/halloween' },
		{ id: 'event-sample/book_club', title: 'BOOK_CLUB', url: default_gallery_url + 'event-sample/book_club' },
		{ id: 'event-sample/school_fete', title: 'SCHOOL_FETE', url: default_gallery_url + 'event-sample/school_fete' },
		{ id: 'event-sample/school_sport', title: 'SCHOOL_SPORT', url: default_gallery_url + 'event-sample/school_sport' },
		{ id: 'event-sample/cake_sale', title: 'CAKE_SALE', url: default_gallery_url + 'event-sample/cake_sale' },
		{ id: 'event-sample/christmas_2', title: 'CHRISTMAS', url: default_gallery_url + 'event-sample/christmas_2' },
		{ id: 'event-sample/easter', title: 'EASTER', url: default_gallery_url + 'event-sample/easter' },
		{ id: 'event-sample/birthday_2', title: 'BIRTHDAY', url: default_gallery_url + 'event-sample/birthday_2' },
		{ id: 'event-sample/dinner', title: 'DINNER', url: default_gallery_url + 'event-sample/dinner' }
	];

	function getTrackerId(env) {
		if(env == 'prod') {
			if (getIfNative()){
				return "UA-79445442-7";
			}else{
				return "UA-79445442-3";
			}
		} else {
			return "";
		}
	}
	
	if (location.host.indexOf('192.168') > -1 || location.host.indexOf('localhost') > -1){ env = 'local' }

	else if(location.host.indexOf('internal-dev.classlist.com') > -1){
		env = 'dev'
	}
	else if(location.host.indexOf('internal-test.classlist.com') > -1){
		env = 'test'
	}
	else if(location.host.indexOf('internal-preprod.classlist.com') > -1){
		env = 'preprod'
	}
	else if(location.host.indexOf('app.classlist.com') > -1){
		env = 'prod'
	}

	var loadedEnv = conf[env];
	loadedEnv.type = env;

	if (window.location.href.indexOf("classlist.com/school") > -1){
		loadedEnv.onboardingAppURL = loadedEnv.onboardingFolderURL;
		loadedEnv.ssoAppURL = loadedEnv.ssoFolderURL;
		loadedEnv.parentAppURL = loadedEnv.parentFolderURL;
		loadedEnv.schoolAppURL = loadedEnv.schoolFolderURL;
	}

	angular.module('CLSchool').constant('settings', {
		defaultLang:'en-GB',
		conf:loadedEnv,
		defaultGallery: default_gallery,
		gae: {
			url:conf[env].api+'/_ah/api/',
			rootUrl:conf[env].api+'/'
		},
		gaUserId:getTrackerId(env),
		http:{
			timeout:50000,
			withCredentials: true,
			contentType:'application/json',
			xhr:true
		},
		runmap:{
			zoom:13,
			default:{
				london:{
					lat: 51.5053134, lng: -0.1141267
				}
			}
		},
		fileUpload: {
			url: conf[env].api+'/gcs'
		},
		baseUploadConfig: {
			url: conf[env].api+'/gcs',
			name:'file.jpg'
		},
		avatarUpload: {
			minWidth: 300,
			maxWidth: 300,
			quality: 100,
			type:'PROFILE_PIC',
		},
		avatarCropper: {
			minCropBoxWidth: 300,
			minCropBoxHeight: 300,
			aspectRatio: 1
		},
		coverUpload: {
			minWidth: 600,
			maxWidth: 1200,
			quality: 100,
			type:'SCHOOL_COVER',
		},
		coverCropper: {
			minCropBoxWidth: 500,
			minCropBoxHeight: 300,
			aspectRatio: 512/300
		},
		logoUpload: {
			minWidth: 300,
			maxWidth: 800,
			quality: 100,
			type:'SCHOOL_LOGO',
		},
		logoCropper: {
			minCropBoxWidth: 30,
			minCropBoxHeight: 30,
			aspectRatio: 1
		},
		postUpload: {
			url: conf[env].api+'/gcs',
			minWidth: 1242,
			maxWidth: 1242,
			quality: 100,
			type:'POST_IMG',
			name:'post-photo.jpg'
		},
		postCropper: {
			minCropBoxWidth: 1242,
			minCropBoxHeight: 937, 
			aspectRatio: 4/3
		},
		listingUpload: {
			url: conf[env].api+'/gcs',
			minWidth: 1242,
			maxWidth: 1242,
			quality: 100,
			type:'LISTING_IMG',
			name:'listing-photo.jpg'
		},
		groupUpload: {
            url: conf[env].api + '/gcs',
            minWidth: 600,
            maxWidth: 1200,
            quality: 100,
            type: 'GROUP_AVATAR',
            name: 'group-avatar.jpg'
        },
        groupCropper: {
            minCropBoxWidth: 40,
            minCropBoxHeight: 40,
            aspectRatio: 1 / 1
        },
		eventUpload: {
			url: conf[env].api+'/gcs',
			minWidth: 1242,
			maxWidth: 1242,
			quality: 100,
			type:'EVENT_IMG',
			name:'event-photo.jpg'
		},
		eventCropper: {
			minCropBoxWidth: 40,
			minCropBoxHeight: 40,
			aspectRatio: 1
		},
		raffleUpload: {
			url: conf[env].api+'/gcs',
			minWidth: 1242,
			maxWidth: 1242,
			quality: 100,
			type:'RAFFLE_IMG',
			name:'raffle-photo.jpg'
		},
		raffleCropper: {
			minCropBoxWidth: 40,
			minCropBoxHeight: 40,
			aspectRatio: 16/9
		},
		websiteEventUpload: {
			url: conf[env].api+'/gcs',
			minWidth: 1242,
			maxWidth: 1242,
			quality: 100,
			type:'PUBLIC_WEB_EVENT',
			name:'website-event-photo.jpg'
		},
		websiteEventCropper: {
			minCropBoxWidth: 40,
			minCropBoxHeight: 40,
			aspectRatio: 16/9
		},
		websiteCoverUpload: {
			url: conf[env].api+'/gcs',
			minWidth: 1242,
			maxWidth: 1242,
			quality: 100,
			type:'PUBLIC_WEB_SCHOOL_COVER',
			name:'website-event-photo.jpg'
		},
		websiteCoverCropper: {
			minCropBoxWidth: 40,
			minCropBoxHeight: 40,
			aspectRatio: 16/9
		},
		websiteLogoUpload: {
			minWidth: 300,
			maxWidth: 300,
			quality: 100,
			type:'PUBLIC_WEB_SCHOOL_LOGO',
		},
		websiteLogoCropper: {
			minCropBoxWidth: 300,
			minCropBoxHeight: 300,
			aspectRatio: 1
		},
		cropper: {
			guides:false,
			center:false,
			background:false,
			cropBoxMovable:true,
			zoomOnWheel:false,
			viewMode:1,
			rotatable:true,
			movable:false,
			responsive:true,
			zoomOnTouch:true,
			dragMode:'move'
		}
	}).constant('regexes', {
		username:'[a-zA-Z0-9@._]',
		number: '[0-9]$',
		money: /^\d+(\.\d{0,2})?$/,
		address:'[a-zA-Z0-9 ]$',
		nameField: "[a-zA-Z-' ]$",
		valCode: '[0-9]$',
		postcode: '[a-zA-Z0-9 ]$',
		memorable: '[a-zA-Z0-9]$',
		openingTagStart: /(\[URL)/g,
		openingTagEnd:/(target="_blank"])/g,
		openingTagEndNotBlank:/("])/g,
		closingTag: /(\[\/URL])/g,
		url: /(https|http|www):?.*?(?=(<div>|<\/div>|&nbsp|<br>|<\/br>|<b>|<\/b>|<i>|<\/i>|<h1>|<\/h1>|<h2>|<\/h2>|<h3>|<\/h3>|<strong>|<\/strong>|<u>|<\/u>|<em>|<\/em>)|\)|,|\s|$)/g,
		min: {
			userSearch:3,
			msgSubject:1,
			msgBody:1,
			name: 2,
			email: 5,
			postcode: 3,
			address: 5,
			phone: 3,
			username: 3,
			password: 8,
			valdcode: 4,
            groupTitle: 3
		},
		max: {
			userSearch:200,
			msgSubject:100,
			msgBody:499,
			name: 100,
			email: 100,
			postcode: 10,
			address: 50,
			fullAddress: 250,
			phone: 20,
			username: 50,
			password: 250,
			valdcode: 4,
			eventTitle: 500,
			eventDesc: 2000,
			eventLocDet: 100
		}
	}).constant('zenLinks',{
		'school.page':'https://help.classlist.com/hc/en-us/articles/213810385-Topic-6-Managing-Admin-Users',
		'notifications':'https://help.classlist.com/hc/en-us/articles/360000504671-Admin-notifications',
		'school.structure':'https://classlisthelp.zendesk.com/hc/en-us/articles/208434669-Lesson-1-Set-up-school-structure',
		'users.manageadmin':'https://help.classlist.com/hc/en-us/articles/213810385/',
		'users.manageparents': 'https://help.classlist.com/hc/en-us/articles/115001410731-The-All-Parents-page-managing-parents',
		'users.parentdetail': 'https://help.classlist.com/hc/en-us/articles/115001410731-The-All-Parents-page-managing-parents',
		'users.approveparents': 'https://help.classlist.com/hc/en-us/articles/208434629-Topic-3-Approve-parents',
		'invite.bulkemailupload': 'https://help.classlist.com/hc/en-us/articles/209890185-Topic-3-Invite-Parents',
		'users.addindividually': 'https://help.classlist.com/hc/en-us/articles/214285565-Adding-Parents-via-Add-Individually',
		'invite.nonmemberlist': 'https://help.classlist.com/hc/en-us/articles/209890185-Topic-3-Invite-Parents',
		'announcements': 'https://classlisthelp.zendesk.com/hc/en-us/articles/211591625-Topic-7-Announcements',
		'monitor': 'https://help.classlist.com/hc/en-us/articles/213809605/',
		'events.list': 'https://help.classlist.com/hc/en-us/articles/209776409-Events-overview',
		'events.guests': 'https://help.classlist.com/hc/en-us/articles/115002501231',
		'events.tickets': 'https://help.classlist.com/hc/en-us/articles/115002501231',
		'events.create': 'https://help.classlist.com/hc/en-us/articles/209776409-Events-overview',
		'dashboard.main': 'https://help.classlist.com/hc/en-us/articles/115001351485-The-Dashboard',
		'wizard': 'https://help.classlist.com/hc/en-us/articles/115001600005-Getting-Starting-The-Set-Up-Wizard',
		'profile.settings': 'https://help.classlist.com/hc/en-us/articles/208434989-Lesson-5-Personal-Profile',
		'profile.staff': 'https://help.classlist.com/hc/en-us/articles/115003312849-I-am-a-member-of-school-staff-setting-up-Classlist',
		'users.staffdetail': 'https://help.classlist.com/hc/en-us/articles/115003312849-I-am-a-member-of-school-staff-setting-up-Classlist',
		'announcements.list': 'https://help.classlist.com/hc/en-us/articles/211591625-Topic-10-Announcements',
		'announcements.create': 'https://help.classlist.com/hc/en-us/articles/211591625-Topic-10-Announcements',
		'groups.list':'https://help.classlist.com/hc/en-us/articles/210630869-Topic-14-My-Groups',
		'groups.view':'https://help.classlist.com/hc/en-us/articles/210630869-Topic-14-My-Groups'
	});
	
})();

function getIfNative() { 
	var standalone = window.navigator.standalone,
	userAgent = window.navigator.userAgent.toLowerCase(),
	safari = /safari/.test( userAgent ),
	ie = userAgent.indexOf("windows") > -1,
	firefox = userAgent.indexOf("firefox") > -1;

	return (!standalone && !safari && !ie && !firefox) || (window.AndroidBridge);
}
function isIosNative() { 
	var standalone = window.navigator.standalone,
	userAgent = window.navigator.userAgent.toLowerCase(),
	safari = /safari/.test( userAgent ),
	ie = userAgent.indexOf("windows") > -1,
	firefox = userAgent.indexOf("firefox") > -1;

	return !standalone && !safari && !ie && !firefox && !window.AndroidBridge;
}
function getMobileOperatingSystem() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

	if(userAgent.includes('flutter-web-view')) {
		return "Flutter";
	}

      // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
        return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
    }

    return "unknown";
}

function getFrontendVersion() { 
	if(window.CL_VERSION)
		return window.CL_VERSION.name;
	else
		return "default";
}

function isExperimentCookie() {
	return document.cookie.indexOf("X-Source=experiment") > -1;
}

(function() {
  'use strict';

  angular.module('CLSchool').config(config);

  /** @ngInject */
  function config($logProvider, $httpProvider, $translateProvider, toastrConfig, settings) {
    // Enable log
    $logProvider.debugEnabled(true);

    $translateProvider.useSanitizeValueStrategy('sanitize');

    $httpProvider.interceptors.push('httpInterceptor');
    
    $translateProvider.useStaticFilesLoader({
        prefix: './i8n/locales-',
        suffix: '.json?v=' + getFrontendVersion()
    });
    $translateProvider.preferredLanguage(settings.defaultLang);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 8000;
    toastrConfig.closeButton = true;
    toastrConfig.positionClass = 'toast-bottom-center';
    toastrConfig.preventDuplicates = false;
    toastrConfig.progressBar = true;
  }

})();

/*
* Fingerprintjs2 1.5.1 - Modern & flexible browser fingerprint library v2
* https://github.com/Valve/fingerprintjs2
* Copyright (c) 2015 Valentin Vasilyev (valentin.vasilyev@outlook.com)
* Licensed under the MIT (http://www.opensource.org/licenses/mit-license.php) license.
*
* THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
* AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
* IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
* ARE DISCLAIMED. IN NO EVENT SHALL VALENTIN VASILYEV BE LIABLE FOR ANY
* DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
* (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
* LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
* ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
* (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
* THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

(function (name, context, definition) {
  'use strict'
  if (typeof window.define === 'function' && window.define.amd) { window.define(definition) } else if (typeof module !== 'undefined' && module.exports) { module.exports = definition() } else if (context.exports) { context.exports = definition() } else { context[name] = definition() }
})('Fingerprint2', this, function () {
  'use strict'
  /**
   * @constructor
   * @param {Object=} options
   */
  var Fingerprint2 = function (options) {
    if (!(this instanceof Fingerprint2)) {
      return new Fingerprint2(options)
    }

    var defaultOptions = {
      swfContainerId: 'fingerprintjs2',
      swfPath: 'flash/compiled/FontList.swf',
      detectScreenOrientation: true,
      sortPluginsFor: [/palemoon/i],
      userDefinedFonts: []
    }
    this.options = this.extend(options, defaultOptions)
    this.nativeForEach = Array.prototype.forEach
    this.nativeMap = Array.prototype.map
  }
  Fingerprint2.prototype = {
    extend: function (source, target) {
      if (source == null) { return target }
      for (var k in source) {
        if (source[k] != null && target[k] !== source[k]) {
          target[k] = source[k]
        }
      }
      return target
    },
    get: function (done) {
      var that = this
      var keys = {
        data: [],
        addPreprocessedComponent: function (pair) {
          var componentValue = pair.value
          if (typeof that.options.preprocessor === 'function') {
            componentValue = that.options.preprocessor(pair.key, componentValue)
          }
          keys.data.push({key: pair.key, value: componentValue})
        }
      }
      keys = this.userAgentKey(keys)
      keys = this.languageKey(keys)
      keys = this.colorDepthKey(keys)
      keys = this.deviceMemoryKey(keys)
      keys = this.pixelRatioKey(keys)
      keys = this.hardwareConcurrencyKey(keys)
      keys = this.screenResolutionKey(keys)
      keys = this.availableScreenResolutionKey(keys)
      keys = this.timezoneOffsetKey(keys)
      keys = this.sessionStorageKey(keys)
      keys = this.localStorageKey(keys)
      keys = this.indexedDbKey(keys)
      keys = this.addBehaviorKey(keys)
      keys = this.openDatabaseKey(keys)
      keys = this.cpuClassKey(keys)
      keys = this.platformKey(keys)
      keys = this.doNotTrackKey(keys)
      keys = this.pluginsKey(keys)
      keys = this.canvasKey(keys)
      keys = this.webglKey(keys)
      keys = this.webglVendorAndRendererKey(keys)
      keys = this.adBlockKey(keys)
      keys = this.hasLiedLanguagesKey(keys)
      keys = this.hasLiedResolutionKey(keys)
      keys = this.hasLiedOsKey(keys)
      keys = this.hasLiedBrowserKey(keys)
      keys = this.touchSupportKey(keys)
      keys = this.customEntropyFunction(keys)
      this.fontsKey(keys, function (newKeys) {
        var values = []
        that.each(newKeys.data, function (pair) {
          var value = pair.value
          if (value && typeof value.join === 'function') {
            value = value.join(';')
          }
          values.push(value)
        })
        var murmur = that.x64hash128(values.join('~~~'), 31)
        return done(murmur, newKeys.data)
      })
    },
    customEntropyFunction: function (keys) {
      if (typeof this.options.customFunction === 'function') {
        keys.addPreprocessedComponent({key: 'custom', value: this.options.customFunction()})
      }
      return keys
    },
    userAgentKey: function (keys) {
      if (!this.options.excludeUserAgent) {
        keys.addPreprocessedComponent({key: 'user_agent', value: this.getUserAgent()})
      }
      return keys
    },
    // for tests
    getUserAgent: function () {
      return navigator.userAgent
    },
    languageKey: function (keys) {
      if (!this.options.excludeLanguage) {
        // IE 9,10 on Windows 10 does not have the `navigator.language` property any longer
        keys.addPreprocessedComponent({ key: 'language', value: navigator.language || navigator.userLanguage || navigator.browserLanguage || navigator.systemLanguage || '' })
      }
      return keys
    },
    colorDepthKey: function (keys) {
      if (!this.options.excludeColorDepth) {
        keys.addPreprocessedComponent({key: 'color_depth', value: window.screen.colorDepth || -1})
      }
      return keys
    },
    deviceMemoryKey: function (keys) {
      if (!this.options.excludeDeviceMemory) {
        keys.addPreprocessedComponent({key: 'device_memory', value: this.getDeviceMemory()})
      }
      return keys
    },
    getDeviceMemory: function () {
      return navigator.deviceMemory || -1
    },
    pixelRatioKey: function (keys) {
      if (!this.options.excludePixelRatio) {
        keys.addPreprocessedComponent({key: 'pixel_ratio', value: this.getPixelRatio()})
      }
      return keys
    },
    getPixelRatio: function () {
      return window.devicePixelRatio || ''
    },
    screenResolutionKey: function (keys) {
      if (!this.options.excludeScreenResolution) {
        return this.getScreenResolution(keys)
      }
      return keys
    },
    getScreenResolution: function (keys) {
      var resolution
      if (this.options.detectScreenOrientation) {
        resolution = (window.screen.height > window.screen.width) ? [window.screen.height, window.screen.width] : [window.screen.width, window.screen.height]
      } else {
        resolution = [window.screen.width, window.screen.height]
      }
      keys.addPreprocessedComponent({key: 'resolution', value: resolution})
      return keys
    },
    availableScreenResolutionKey: function (keys) {
      if (!this.options.excludeAvailableScreenResolution) {
        return this.getAvailableScreenResolution(keys)
      }
      return keys
    },
    getAvailableScreenResolution: function (keys) {
      var available
      if (window.screen.availWidth && window.screen.availHeight) {
        if (this.options.detectScreenOrientation) {
          available = (window.screen.availHeight > window.screen.availWidth) ? [window.screen.availHeight, window.screen.availWidth] : [window.screen.availWidth, window.screen.availHeight]
        } else {
          available = [window.screen.availHeight, window.screen.availWidth]
        }
      }
      if (typeof available !== 'undefined') { // headless browsers
        keys.addPreprocessedComponent({key: 'available_resolution', value: available})
      }
      return keys
    },
    timezoneOffsetKey: function (keys) {
      if (!this.options.excludeTimezoneOffset) {
        keys.addPreprocessedComponent({key: 'timezone_offset', value: new Date().getTimezoneOffset()})
      }
      return keys
    },
    sessionStorageKey: function (keys) {
      if (!this.options.excludeSessionStorage && this.hasSessionStorage()) {
        keys.addPreprocessedComponent({key: 'session_storage', value: 1})
      }
      return keys
    },
    localStorageKey: function (keys) {
      if (!this.options.excludeSessionStorage && this.hasLocalStorage()) {
        keys.addPreprocessedComponent({key: 'local_storage', value: 1})
      }
      return keys
    },
    indexedDbKey: function (keys) {
      if (!this.options.excludeIndexedDB && this.hasIndexedDB()) {
        keys.addPreprocessedComponent({key: 'indexed_db', value: 1})
      }
      return keys
    },
    addBehaviorKey: function (keys) {
      // body might not be defined at this point or removed programmatically
      if (!this.options.excludeAddBehavior && document.body && document.body.addBehavior) {
        keys.addPreprocessedComponent({key: 'add_behavior', value: 1})
      }
      return keys
    },
    openDatabaseKey: function (keys) {
      if (!this.options.excludeOpenDatabase && window.openDatabase) {
        keys.addPreprocessedComponent({key: 'open_database', value: 1})
      }
      return keys
    },
    cpuClassKey: function (keys) {
      if (!this.options.excludeCpuClass) {
        keys.addPreprocessedComponent({key: 'cpu_class', value: this.getNavigatorCpuClass()})
      }
      return keys
    },
    platformKey: function (keys) {
      if (!this.options.excludePlatform) {
        keys.addPreprocessedComponent({key: 'navigator_platform', value: this.getNavigatorPlatform()})
      }
      return keys
    },
    doNotTrackKey: function (keys) {
      if (!this.options.excludeDoNotTrack) {
        keys.addPreprocessedComponent({key: 'do_not_track', value: this.getDoNotTrack()})
      }
      return keys
    },
    canvasKey: function (keys) {
      if (!this.options.excludeCanvas && this.isCanvasSupported()) {
        keys.addPreprocessedComponent({key: 'canvas', value: this.getCanvasFp()})
      }
      return keys
    },
    webglKey: function (keys) {
      if (!this.options.excludeWebGL && this.isWebGlSupported()) {
        keys.addPreprocessedComponent({key: 'webgl', value: this.getWebglFp()})
      }
      return keys
    },
    webglVendorAndRendererKey: function (keys) {
      if (!this.options.excludeWebGLVendorAndRenderer && this.isWebGlSupported()) {
        keys.addPreprocessedComponent({key: 'webgl_vendor', value: this.getWebglVendorAndRenderer()})
      }
      return keys
    },
    adBlockKey: function (keys) {
      if (!this.options.excludeAdBlock) {
        keys.addPreprocessedComponent({key: 'adblock', value: this.getAdBlock()})
      }
      return keys
    },
    hasLiedLanguagesKey: function (keys) {
      if (!this.options.excludeHasLiedLanguages) {
        keys.addPreprocessedComponent({key: 'has_lied_languages', value: this.getHasLiedLanguages()})
      }
      return keys
    },
    hasLiedResolutionKey: function (keys) {
      if (!this.options.excludeHasLiedResolution) {
        keys.addPreprocessedComponent({key: 'has_lied_resolution', value: this.getHasLiedResolution()})
      }
      return keys
    },
    hasLiedOsKey: function (keys) {
      if (!this.options.excludeHasLiedOs) {
        keys.addPreprocessedComponent({key: 'has_lied_os', value: this.getHasLiedOs()})
      }
      return keys
    },
    hasLiedBrowserKey: function (keys) {
      if (!this.options.excludeHasLiedBrowser) {
        keys.addPreprocessedComponent({key: 'has_lied_browser', value: this.getHasLiedBrowser()})
      }
      return keys
    },
    fontsKey: function (keys, done) {
      if (this.options.excludeJsFonts) {
        return this.flashFontsKey(keys, done)
      }
      return this.jsFontsKey(keys, done)
    },
    // flash fonts (will increase fingerprinting time 20X to ~ 130-150ms)
    flashFontsKey: function (keys, done) {
      if (this.options.excludeFlashFonts) {
        return done(keys)
      }
      // we do flash if swfobject is loaded
      if (!this.hasSwfObjectLoaded()) {
        return done(keys)
      }
      if (!this.hasMinFlashInstalled()) {
        return done(keys)
      }
      if (typeof this.options.swfPath === 'undefined') {
        return done(keys)
      }
      this.loadSwfAndDetectFonts(function (fonts) {
        keys.addPreprocessedComponent({key: 'swf_fonts', value: fonts.join(';')})
        done(keys)
      })
    },
    // kudos to http://www.lalit.org/lab/javascript-css-font-detect/
    jsFontsKey: function (keys, done) {
      var that = this
      // doing js fonts detection in a pseudo-async fashion
      return setTimeout(function () {
        // a font will be compared against all the three default fonts.
        // and if it doesn't match all 3 then that font is not available.
        var baseFonts = ['monospace', 'sans-serif', 'serif']

        var fontList = [
          'Andale Mono', 'Arial', 'Arial Black', 'Arial Hebrew', 'Arial MT', 'Arial Narrow', 'Arial Rounded MT Bold', 'Arial Unicode MS',
          'Bitstream Vera Sans Mono', 'Book Antiqua', 'Bookman Old Style',
          'Calibri', 'Cambria', 'Cambria Math', 'Century', 'Century Gothic', 'Century Schoolbook', 'Comic Sans', 'Comic Sans MS', 'Consolas', 'Courier', 'Courier New',
          'Garamond', 'Geneva', 'Georgia',
          'Nunito Sans', 'Nunito Sans',
          'Impact',
          'Lucida Bright', 'Lucida Calligraphy', 'Lucida Console', 'Lucida Fax', 'LUCIDA GRANDE', 'Lucida Handwriting', 'Lucida Sans', 'Lucida Sans Typewriter', 'Lucida Sans Unicode',
          'Microsoft Sans Serif', 'Monaco', 'Monotype Corsiva', 'MS Gothic', 'MS Outlook', 'MS PGothic', 'MS Reference Sans Serif', 'MS Sans Serif', 'MS Serif', 'MYRIAD', 'MYRIAD PRO',
          'Palatino', 'Palatino Linotype',
          'Segoe Print', 'Segoe Script', 'Segoe UI', 'Segoe UI Light', 'Segoe UI Semibold', 'Segoe UI Symbol',
          'Tahoma', 'Times', 'Times New Roman', 'Times New Roman PS', 'Trebuchet MS',
          'Verdana', 'Wingdings', 'Wingdings 2', 'Wingdings 3'
        ]
        var extendedFontList = [
          'Abadi MT Condensed Light', 'Academy Engraved LET', 'ADOBE CASLON PRO', 'Adobe Garamond', 'ADOBE GARAMOND PRO', 'Agency FB', 'Aharoni', 'Albertus Extra Bold', 'Albertus Medium', 'Algerian', 'Amazone BT', 'American Typewriter',
          'American Typewriter Condensed', 'AmerType Md BT', 'Andalus', 'Angsana New', 'AngsanaUPC', 'Antique Olive', 'Aparajita', 'Apple Chancery', 'Apple Color Emoji', 'Apple SD Gothic Neo', 'Arabic Typesetting', 'ARCHER',
          'ARNO PRO', 'Arrus BT', 'Aurora Cn BT', 'AvantGarde Bk BT', 'AvantGarde Md BT', 'AVENIR', 'Ayuthaya', 'Bandy', 'Bangla Sangam MN', 'Bank Gothic', 'BankGothic Md BT', 'Baskerville',
          'Baskerville Old Face', 'Batang', 'BatangChe', 'Bauer Bodoni', 'Bauhaus 93', 'Bazooka', 'Bell MT', 'Bembo', 'Benguiat Bk BT', 'Berlin Sans FB', 'Berlin Sans FB Demi', 'Bernard MT Condensed', 'BernhardFashion BT', 'BernhardMod BT', 'Big Caslon', 'BinnerD',
          'Blackadder ITC', 'BlairMdITC TT', 'Bodoni 72', 'Bodoni 72 Oldstyle', 'Bodoni 72 Smallcaps', 'Bodoni MT', 'Bodoni MT Black', 'Bodoni MT Condensed', 'Bodoni MT Poster Compressed',
          'Bookshelf Symbol 7', 'Boulder', 'Bradley Hand', 'Bradley Hand ITC', 'Bremen Bd BT', 'Britannic Bold', 'Broadway', 'Browallia New', 'BrowalliaUPC', 'Brush Script MT', 'Californian FB', 'Calisto MT', 'Calligrapher', 'Candara',
          'CaslonOpnface BT', 'Castellar', 'Centaur', 'Cezanne', 'CG Omega', 'CG Times', 'Chalkboard', 'Chalkboard SE', 'Chalkduster', 'Charlesworth', 'Charter Bd BT', 'Charter BT', 'Chaucer',
          'ChelthmITC Bk BT', 'Chiller', 'Clarendon', 'Clarendon Condensed', 'CloisterBlack BT', 'Cochin', 'Colonna MT', 'Constantia', 'Cooper Black', 'Copperplate', 'Copperplate Gothic', 'Copperplate Gothic Bold',
          'Copperplate Gothic Light', 'CopperplGoth Bd BT', 'Corbel', 'Cordia New', 'CordiaUPC', 'Cornerstone', 'Coronet', 'Cuckoo', 'Curlz MT', 'DaunPenh', 'Dauphin', 'David', 'DB LCD Temp', 'DELICIOUS', 'Denmark',
          'DFKai-SB', 'Didot', 'DilleniaUPC', 'DIN', 'DokChampa', 'Dotum', 'DotumChe', 'Ebrima', 'Edwardian Script ITC', 'Elephant', 'English 111 Vivace BT', 'Engravers MT', 'EngraversGothic BT', 'Eras Bold ITC', 'Eras Demi ITC', 'Eras Light ITC', 'Eras Medium ITC',
          'EucrosiaUPC', 'Euphemia', 'Euphemia UCAS', 'EUROSTILE', 'Exotc350 Bd BT', 'FangSong', 'Felix Titling', 'Fixedsys', 'FONTIN', 'Footlight MT Light', 'Forte',
          'FrankRuehl', 'Fransiscan', 'Freefrm721 Blk BT', 'FreesiaUPC', 'Freestyle Script', 'French Script MT', 'FrnkGothITC Bk BT', 'Fruitger', 'FRUTIGER',
          'Futura', 'Futura Bk BT', 'Futura Lt BT', 'Futura Md BT', 'Futura ZBlk BT', 'FuturaBlack BT', 'Gabriola', 'Galliard BT', 'Gautami', 'Geeza Pro', 'Geometr231 BT', 'Geometr231 Hv BT', 'Geometr231 Lt BT', 'GeoSlab 703 Lt BT',
          'GeoSlab 703 XBd BT', 'Gigi', 'Gill Sans', 'Gill Sans MT', 'Gill Sans MT Condensed', 'Gill Sans MT Ext Condensed Bold', 'Gill Sans Ultra Bold', 'Gill Sans Ultra Bold Condensed', 'Gisha', 'Gloucester MT Extra Condensed', 'GOTHAM', 'GOTHAM BOLD',
          'Goudy Old Style', 'Goudy Stout', 'GoudyHandtooled BT', 'GoudyOLSt BT', 'Gujarati Sangam MN', 'Gulim', 'GulimChe', 'Gungsuh', 'GungsuhChe', 'Gurmukhi MN', 'Haettenschweiler', 'Harlow Solid Italic', 'Harrington', 'Heather', 'Heiti SC', 'Heiti TC', 'HELV',
          'Herald', 'High Tower Text', 'Hiragino Kaku Gothic ProN', 'Hiragino Mincho ProN', 'Hoefler Text', 'Humanst 521 Cn BT', 'Humanst521 BT', 'Humanst521 Lt BT', 'Imprint MT Shadow', 'Incised901 Bd BT', 'Incised901 BT',
          'Incised901 Lt BT', 'INCONSOLATA', 'Informal Roman', 'Informal011 BT', 'INTERSTATE', 'IrisUPC', 'Iskoola Pota', 'JasmineUPC', 'Jazz LET', 'Jenson', 'Jester', 'Jokerman', 'Juice ITC', 'Kabel Bk BT', 'Kabel Ult BT', 'Kailasa', 'KaiTi', 'Kalinga', 'Kannada Sangam MN',
          'Kartika', 'Kaufmann Bd BT', 'Kaufmann BT', 'Khmer UI', 'KodchiangUPC', 'Kokila', 'Korinna BT', 'Kristen ITC', 'Krungthep', 'Kunstler Script', 'Lao UI', 'Latha', 'Leelawadee', 'Letter Gothic', 'Levenim MT', 'LilyUPC', 'Lithograph', 'Lithograph Light', 'Long Island',
          'Lydian BT', 'Magneto', 'Maiandra GD', 'Malayalam Sangam MN', 'Malgun Gothic',
          'Mangal', 'Marigold', 'Marion', 'Marker Felt', 'Market', 'Marlett', 'Matisse ITC', 'Matura MT Script Capitals', 'Meiryo', 'Meiryo UI', 'Microsoft Himalaya', 'Microsoft JhengHei', 'Microsoft New Tai Lue', 'Microsoft PhagsPa', 'Microsoft Tai Le',
          'Microsoft Uighur', 'Microsoft YaHei', 'Microsoft Yi Baiti', 'MingLiU', 'MingLiU_HKSCS', 'MingLiU_HKSCS-ExtB', 'MingLiU-ExtB', 'Minion', 'Minion Pro', 'Miriam', 'Miriam Fixed', 'Mistral', 'Modern', 'Modern No. 20', 'Mona Lisa Solid ITC TT', 'Mongolian Baiti',
          'MONO', 'MoolBoran', 'Mrs Eaves', 'MS LineDraw', 'MS Mincho', 'MS PMincho', 'MS Reference Specialty', 'MS UI Gothic', 'MT Extra', 'MUSEO', 'MV Boli',
          'Nadeem', 'Narkisim', 'NEVIS', 'News Gothic', 'News GothicMT', 'NewsGoth BT', 'Niagara Engraved', 'Niagara Solid', 'Noteworthy', 'NSimSun', 'Nyala', 'OCR A Extended', 'Old Century', 'Old English Text MT', 'Onyx', 'Onyx BT', 'OPTIMA', 'Oriya Sangam MN',
          'OSAKA', 'OzHandicraft BT', 'Palace Script MT', 'Papyrus', 'Parchment', 'Party LET', 'Pegasus', 'Perpetua', 'Perpetua Titling MT', 'PetitaBold', 'Pickwick', 'Plantagenet Cherokee', 'Playbill', 'PMingLiU', 'PMingLiU-ExtB',
          'Poor Richard', 'Poster', 'PosterBodoni BT', 'PRINCETOWN LET', 'Pristina', 'PTBarnum BT', 'Pythagoras', 'Raavi', 'Rage Italic', 'Ravie', 'Ribbon131 Bd BT', 'Rockwell', 'Rockwell Condensed', 'Rockwell Extra Bold', 'Rod', 'Roman', 'Sakkal Majalla',
          'Santa Fe LET', 'Savoye LET', 'Sceptre', 'Script', 'Script MT Bold', 'SCRIPTINA', 'Serifa', 'Serifa BT', 'Serifa Th BT', 'ShelleyVolante BT', 'Sherwood',
          'Shonar Bangla', 'Showcard Gothic', 'Shruti', 'Signboard', 'SILKSCREEN', 'SimHei', 'Simplified Arabic', 'Simplified Arabic Fixed', 'SimSun', 'SimSun-ExtB', 'Sinhala Sangam MN', 'Sketch Rockwell', 'Skia', 'Small Fonts', 'Snap ITC', 'Snell Roundhand', 'Socket',
          'Souvenir Lt BT', 'Staccato222 BT', 'Steamer', 'Stencil', 'Storybook', 'Styllo', 'Subway', 'Swis721 BlkEx BT', 'Swiss911 XCm BT', 'Sylfaen', 'Synchro LET', 'System', 'Tamil Sangam MN', 'Technical', 'Teletype', 'Telugu Sangam MN', 'Tempus Sans ITC',
          'Terminal', 'Thonburi', 'Traditional Arabic', 'Trajan', 'TRAJAN PRO', 'Tristan', 'Tubular', 'Tunga', 'Tw Cen MT', 'Tw Cen MT Condensed', 'Tw Cen MT Condensed Extra Bold',
          'TypoUpright BT', 'Unicorn', 'Univers', 'Univers CE 55 Medium', 'Univers Condensed', 'Utsaah', 'Vagabond', 'Vani', 'Vijaya', 'Viner Hand ITC', 'VisualUI', 'Vivaldi', 'Vladimir Script', 'Vrinda', 'Westminster', 'WHITNEY', 'Wide Latin',
          'ZapfEllipt BT', 'ZapfHumnst BT', 'ZapfHumnst Dm BT', 'Zapfino', 'Zurich BlkEx BT', 'Zurich Ex BT', 'ZWAdobeF']

        if (that.options.extendedJsFonts) {
          fontList = fontList.concat(extendedFontList)
        }

        fontList = fontList.concat(that.options.userDefinedFonts)

        // we use m or w because these two characters take up the maximum width.
        // And we use a LLi so that the same matching fonts can get separated
        var testString = 'mmmmmmmmmmlli'

        // we test using 72px font size, we may use any size. I guess larger the better.
        var testSize = '72px'

        var h = document.getElementsByTagName('body')[0]

        // div to load spans for the base fonts
        var baseFontsDiv = document.createElement('div')

        // div to load spans for the fonts to detect
        var fontsDiv = document.createElement('div')

        var defaultWidth = {}
        var defaultHeight = {}

        // creates a span where the fonts will be loaded
        var createSpan = function () {
          var s = document.createElement('span')
            /*
             * We need this css as in some weird browser this
             * span elements shows up for a microSec which creates a
             * bad user experience
             */
          s.style.position = 'absolute'
          s.style.left = '-9999px'
          s.style.fontSize = testSize
          s.style.lineHeight = 'normal'
          s.innerHTML = testString
          return s
        }

        // creates a span and load the font to detect and a base font for fallback
        var createSpanWithFonts = function (fontToDetect, baseFont) {
          var s = createSpan()
          s.style.fontFamily = "'" + fontToDetect + "'," + baseFont
          return s
        }

        // creates spans for the base fonts and adds them to baseFontsDiv
        var initializeBaseFontsSpans = function () {
          var spans = []
          for (var index = 0, length = baseFonts.length; index < length; index++) {
            var s = createSpan()
            s.style.fontFamily = baseFonts[index]
            baseFontsDiv.appendChild(s)
            spans.push(s)
          }
          return spans
        }

        // creates spans for the fonts to detect and adds them to fontsDiv
        var initializeFontsSpans = function () {
          var spans = {}
          for (var i = 0, l = fontList.length; i < l; i++) {
            var fontSpans = []
            for (var j = 0, numDefaultFonts = baseFonts.length; j < numDefaultFonts; j++) {
              var s = createSpanWithFonts(fontList[i], baseFonts[j])
              fontsDiv.appendChild(s)
              fontSpans.push(s)
            }
            spans[fontList[i]] = fontSpans // Stores {fontName : [spans for that font]}
          }
          return spans
        }

        // checks if a font is available
        var isFontAvailable = function (fontSpans) {
          var detected = false
          for (var i = 0; i < baseFonts.length; i++) {
            detected = (fontSpans[i].offsetWidth !== defaultWidth[baseFonts[i]] || fontSpans[i].offsetHeight !== defaultHeight[baseFonts[i]])
            if (detected) {
              return detected
            }
          }
          return detected
        }

        // create spans for base fonts
        var baseFontsSpans = initializeBaseFontsSpans()

        // add the spans to the DOM
        h.appendChild(baseFontsDiv)

        // get the default width for the three base fonts
        for (var index = 0, length = baseFonts.length; index < length; index++) {
          defaultWidth[baseFonts[index]] = baseFontsSpans[index].offsetWidth // width for the default font
          defaultHeight[baseFonts[index]] = baseFontsSpans[index].offsetHeight // height for the default font
        }

        // create spans for fonts to detect
        var fontsSpans = initializeFontsSpans()

        // add all the spans to the DOM
        h.appendChild(fontsDiv)

        // check available fonts
        var available = []
        for (var i = 0, l = fontList.length; i < l; i++) {
          if (isFontAvailable(fontsSpans[fontList[i]])) {
            available.push(fontList[i])
          }
        }

        // remove spans from DOM
        h.removeChild(fontsDiv)
        h.removeChild(baseFontsDiv)

        keys.addPreprocessedComponent({key: 'js_fonts', value: available})
        done(keys)
      }, 1)
    },
    pluginsKey: function (keys) {
      if (!this.options.excludePlugins) {
        if (this.isIE()) {
          if (!this.options.excludeIEPlugins) {
            keys.addPreprocessedComponent({key: 'ie_plugins', value: this.getIEPlugins()})
          }
        } else {
          keys.addPreprocessedComponent({key: 'regular_plugins', value: this.getRegularPlugins()})
        }
      }
      return keys
    },
    getRegularPlugins: function () {
      var plugins = []
      if (navigator.plugins) {
        // plugins isn't defined in Node envs.
        for (var i = 0, l = navigator.plugins.length; i < l; i++) {
          if (navigator.plugins[i]) { plugins.push(navigator.plugins[i]) }
        }
      }
      // sorting plugins only for those user agents, that we know randomize the plugins
      // every time we try to enumerate them
      if (this.pluginsShouldBeSorted()) {
        plugins = plugins.sort(function (a, b) {
          if (a.name > b.name) { return 1 }
          if (a.name < b.name) { return -1 }
          return 0
        })
      }
      return this.map(plugins, function (p) {
        var mimeTypes = this.map(p, function (mt) {
          return [mt.type, mt.suffixes].join('~')
        }).join(',')
        return [p.name, p.description, mimeTypes].join('::')
      }, this)
    },
    getIEPlugins: function () {
      var result = []
      if ((Object.getOwnPropertyDescriptor && Object.getOwnPropertyDescriptor(window, 'ActiveXObject')) || ('ActiveXObject' in window)) {
        var names = [
          'AcroPDF.PDF', // Adobe PDF reader 7+
          'Adodb.Stream',
          'AgControl.AgControl', // Silverlight
          'DevalVRXCtrl.DevalVRXCtrl.1',
          'MacromediaFlashPaper.MacromediaFlashPaper',
          'Msxml2.DOMDocument',
          'Msxml2.XMLHTTP',
          'PDF.PdfCtrl', // Adobe PDF reader 6 and earlier, brrr
          'QuickTime.QuickTime', // QuickTime
          'QuickTimeCheckObject.QuickTimeCheck.1',
          'RealPlayer',
          'RealPlayer.RealPlayer(tm) ActiveX Control (32-bit)',
          'RealVideo.RealVideo(tm) ActiveX Control (32-bit)',
          'Scripting.Dictionary',
          'SWCtl.SWCtl', // ShockWave player
          'Shell.UIHelper',
          'ShockwaveFlash.ShockwaveFlash', // flash plugin
          'Skype.Detection',
          'TDCCtl.TDCCtl',
          'WMPlayer.OCX', // Windows media player
          'rmocx.RealPlayer G2 Control',
          'rmocx.RealPlayer G2 Control.1'
        ]
        // starting to detect plugins in IE
        result = this.map(names, function (name) {
          try {
            // eslint-disable-next-line no-new
            new window.ActiveXObject(name)
            return name
          } catch (e) {
            return null
          }
        })
      }
      if (navigator.plugins) {
        result = result.concat(this.getRegularPlugins())
      }
      return result
    },
    pluginsShouldBeSorted: function () {
      var should = false
      for (var i = 0, l = this.options.sortPluginsFor.length; i < l; i++) {
        var re = this.options.sortPluginsFor[i]
        if (navigator.userAgent.match(re)) {
          should = true
          break
        }
      }
      return should
    },
    touchSupportKey: function (keys) {
      if (!this.options.excludeTouchSupport) {
        keys.addPreprocessedComponent({key: 'touch_support', value: this.getTouchSupport()})
      }
      return keys
    },
    hardwareConcurrencyKey: function (keys) {
      if (!this.options.excludeHardwareConcurrency) {
        keys.addPreprocessedComponent({key: 'hardware_concurrency', value: this.getHardwareConcurrency()})
      }
      return keys
    },
    hasSessionStorage: function () {
      try {
        return !!window.sessionStorage
      } catch (e) {
        return true // SecurityError when referencing it means it exists
      }
    },
    // https://bugzilla.mozilla.org/show_bug.cgi?id=781447
    hasLocalStorage: function () {
      try {
        return !!window.localStorage
      } catch (e) {
        return true // SecurityError when referencing it means it exists
      }
    },
    hasIndexedDB: function () {
      try {
        return !!window.indexedDB
      } catch (e) {
        return true // SecurityError when referencing it means it exists
      }
    },
    getHardwareConcurrency: function () {
      if (navigator.hardwareConcurrency) {
        return navigator.hardwareConcurrency
      }
      return 'unknown'
    },
    getNavigatorCpuClass: function () {
      if (navigator.cpuClass) {
        return navigator.cpuClass
      } else {
        return 'unknown'
      }
    },
    getNavigatorPlatform: function () {
      if (navigator.platform) {
        return navigator.platform
      } else {
        return 'unknown'
      }
    },
    getDoNotTrack: function () {
      if (navigator.doNotTrack) {
        return navigator.doNotTrack
      } else if (navigator.msDoNotTrack) {
        return navigator.msDoNotTrack
      } else if (window.doNotTrack) {
        return window.doNotTrack
      } else {
        return 'unknown'
      }
    },
    // This is a crude and primitive touch screen detection.
    // It's not possible to currently reliably detect the  availability of a touch screen
    // with a JS, without actually subscribing to a touch event.
    // http://www.stucox.com/blog/you-cant-detect-a-touchscreen/
    // https://github.com/Modernizr/Modernizr/issues/548
    // method returns an array of 3 values:
    // maxTouchPoints, the success or failure of creating a TouchEvent,
    // and the availability of the 'ontouchstart' property
    getTouchSupport: function () {
      var maxTouchPoints = 0
      var touchEvent = false
      if (typeof navigator.maxTouchPoints !== 'undefined') {
        maxTouchPoints = navigator.maxTouchPoints
      } else if (typeof navigator.msMaxTouchPoints !== 'undefined') {
        maxTouchPoints = navigator.msMaxTouchPoints
      }
      try {
        document.createEvent('TouchEvent')
        touchEvent = true
      } catch (_) { /* squelch */ }
      var touchStart = 'ontouchstart' in window
      return [maxTouchPoints, touchEvent, touchStart]
    },
    // https://www.browserleaks.com/canvas#how-does-it-work
    getCanvasFp: function () {
      var result = []
      // Very simple now, need to make it more complex (geo shapes etc)
      var canvas = document.createElement('canvas')
      canvas.width = 2000
      canvas.height = 200
      canvas.style.display = 'inline'
      var ctx = canvas.getContext('2d')
      // detect browser support of canvas winding
      // http://blogs.adobe.com/webplatform/2013/01/30/winding-rules-in-canvas/
      // https://github.com/Modernizr/Modernizr/blob/master/feature-detects/canvas/winding.js
      ctx.rect(0, 0, 10, 10)
      ctx.rect(2, 2, 6, 6)
      result.push('canvas winding:' + ((ctx.isPointInPath(5, 5, 'evenodd') === false) ? 'yes' : 'no'))

      ctx.textBaseline = 'alphabetic'
      ctx.fillStyle = '#f60'
      ctx.fillRect(125, 1, 62, 20)
      ctx.fillStyle = '#069'
      // https://github.com/Valve/fingerprintjs2/issues/66
      if (this.options.dontUseFakeFontInCanvas) {
        ctx.font = '11pt Arial'
      } else {
        ctx.font = '11pt no-real-font-123'
      }
      ctx.fillText('Cwm fjordbank glyphs vext quiz, \ud83d\ude03', 2, 15)
      ctx.fillStyle = 'rgba(102, 204, 0, 0.2)'
      ctx.font = '18pt Arial'
      ctx.fillText('Cwm fjordbank glyphs vext quiz, \ud83d\ude03', 4, 45)

      // canvas blending
      // http://blogs.adobe.com/webplatform/2013/01/28/blending-features-in-canvas/
      // http://jsfiddle.net/NDYV8/16/
      ctx.globalCompositeOperation = 'multiply'
      ctx.fillStyle = 'rgb(255,0,255)'
      ctx.beginPath()
      ctx.arc(50, 50, 50, 0, Math.PI * 2, true)
      ctx.closePath()
      ctx.fill()
      ctx.fillStyle = 'rgb(0,255,255)'
      ctx.beginPath()
      ctx.arc(100, 50, 50, 0, Math.PI * 2, true)
      ctx.closePath()
      ctx.fill()
      ctx.fillStyle = 'rgb(255,255,0)'
      ctx.beginPath()
      ctx.arc(75, 100, 50, 0, Math.PI * 2, true)
      ctx.closePath()
      ctx.fill()
      ctx.fillStyle = 'rgb(255,0,255)'
      // canvas winding
      // http://blogs.adobe.com/webplatform/2013/01/30/winding-rules-in-canvas/
      // http://jsfiddle.net/NDYV8/19/
      ctx.arc(75, 75, 75, 0, Math.PI * 2, true)
      ctx.arc(75, 75, 25, 0, Math.PI * 2, true)
      ctx.fill('evenodd')

      if (canvas.toDataURL) { result.push('canvas fp:' + canvas.toDataURL()) }
      return result.join('~')
    },

    getWebglFp: function () {
      var gl
      var fa2s = function (fa) {
        gl.clearColor(0.0, 0.0, 0.0, 1.0)
        gl.enable(gl.DEPTH_TEST)
        gl.depthFunc(gl.LEQUAL)
        gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT)
        return '[' + fa[0] + ', ' + fa[1] + ']'
      }
      var maxAnisotropy = function (gl) {
        var ext = gl.getExtension('EXT_texture_filter_anisotropic') || gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic') || gl.getExtension('MOZ_EXT_texture_filter_anisotropic')
        if (ext) {
          var anisotropy = gl.getParameter(ext.MAX_TEXTURE_MAX_ANISOTROPY_EXT)
          if (anisotropy === 0) {
            anisotropy = 2
          }
          return anisotropy
        } else {
          return null
        }
      }
      gl = this.getWebglCanvas()
      if (!gl) { return null }
      // WebGL fingerprinting is a combination of techniques, found in MaxMind antifraud script & Augur fingerprinting.
      // First it draws a gradient object with shaders and convers the image to the Base64 string.
      // Then it enumerates all WebGL extensions & capabilities and appends them to the Base64 string, resulting in a huge WebGL string, potentially very unique on each device
      // Since iOS supports webgl starting from version 8.1 and 8.1 runs on several graphics chips, the results may be different across ios devices, but we need to verify it.
      var result = []
      var vShaderTemplate = 'attribute vec2 attrVertex;varying vec2 varyinTexCoordinate;uniform vec2 uniformOffset;void main(){varyinTexCoordinate=attrVertex+uniformOffset;gl_Position=vec4(attrVertex,0,1);}'
      var fShaderTemplate = 'precision mediump float;varying vec2 varyinTexCoordinate;void main() {gl_FragColor=vec4(varyinTexCoordinate,0,1);}'
      var vertexPosBuffer = gl.createBuffer()
      gl.bindBuffer(gl.ARRAY_BUFFER, vertexPosBuffer)
      var vertices = new Float32Array([-0.2, -0.9, 0, 0.4, -0.26, 0, 0, 0.732134444, 0])
      gl.bufferData(gl.ARRAY_BUFFER, vertices, gl.STATIC_DRAW)
      vertexPosBuffer.itemSize = 3
      vertexPosBuffer.numItems = 3
      var program = gl.createProgram()
      var vshader = gl.createShader(gl.VERTEX_SHADER)
      gl.shaderSource(vshader, vShaderTemplate)
      gl.compileShader(vshader)
      var fshader = gl.createShader(gl.FRAGMENT_SHADER)
      gl.shaderSource(fshader, fShaderTemplate)
      gl.compileShader(fshader)
      gl.attachShader(program, vshader)
      gl.attachShader(program, fshader)
      gl.linkProgram(program)
      gl.useProgram(program)
      program.vertexPosAttrib = gl.getAttribLocation(program, 'attrVertex')
      program.offsetUniform = gl.getUniformLocation(program, 'uniformOffset')
      gl.enableVertexAttribArray(program.vertexPosArray)
      gl.vertexAttribPointer(program.vertexPosAttrib, vertexPosBuffer.itemSize, gl.FLOAT, !1, 0, 0)
      gl.uniform2f(program.offsetUniform, 1, 1)
      gl.drawArrays(gl.TRIANGLE_STRIP, 0, vertexPosBuffer.numItems)
      try {
        result.push(gl.canvas.toDataURL())
      } catch (e) {
        /* .toDataURL may be absent or broken (blocked by extension) */
      }
      result.push('extensions:' + (gl.getSupportedExtensions() || []).join(';'))
      result.push('webgl aliased line width range:' + fa2s(gl.getParameter(gl.ALIASED_LINE_WIDTH_RANGE)))
      result.push('webgl aliased point size range:' + fa2s(gl.getParameter(gl.ALIASED_POINT_SIZE_RANGE)))
      result.push('webgl alpha bits:' + gl.getParameter(gl.ALPHA_BITS))
      result.push('webgl antialiasing:' + (gl.getContextAttributes().antialias ? 'yes' : 'no'))
      result.push('webgl blue bits:' + gl.getParameter(gl.BLUE_BITS))
      result.push('webgl depth bits:' + gl.getParameter(gl.DEPTH_BITS))
      result.push('webgl green bits:' + gl.getParameter(gl.GREEN_BITS))
      result.push('webgl max anisotropy:' + maxAnisotropy(gl))
      result.push('webgl max combined texture image units:' + gl.getParameter(gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS))
      result.push('webgl max cube map texture size:' + gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE))
      result.push('webgl max fragment uniform vectors:' + gl.getParameter(gl.MAX_FRAGMENT_UNIFORM_VECTORS))
      result.push('webgl max render buffer size:' + gl.getParameter(gl.MAX_RENDERBUFFER_SIZE))
      result.push('webgl max texture image units:' + gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS))
      result.push('webgl max texture size:' + gl.getParameter(gl.MAX_TEXTURE_SIZE))
      result.push('webgl max varying vectors:' + gl.getParameter(gl.MAX_VARYING_VECTORS))
      result.push('webgl max vertex attribs:' + gl.getParameter(gl.MAX_VERTEX_ATTRIBS))
      result.push('webgl max vertex texture image units:' + gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS))
      result.push('webgl max vertex uniform vectors:' + gl.getParameter(gl.MAX_VERTEX_UNIFORM_VECTORS))
      result.push('webgl max viewport dims:' + fa2s(gl.getParameter(gl.MAX_VIEWPORT_DIMS)))
      result.push('webgl red bits:' + gl.getParameter(gl.RED_BITS))
      result.push('webgl renderer:' + gl.getParameter(gl.RENDERER))
      result.push('webgl shading language version:' + gl.getParameter(gl.SHADING_LANGUAGE_VERSION))
      result.push('webgl stencil bits:' + gl.getParameter(gl.STENCIL_BITS))
      result.push('webgl vendor:' + gl.getParameter(gl.VENDOR))
      result.push('webgl version:' + gl.getParameter(gl.VERSION))

      try {
        // Add the unmasked vendor and unmasked renderer if the debug_renderer_info extension is available
        var extensionDebugRendererInfo = gl.getExtension('WEBGL_debug_renderer_info')
        if (extensionDebugRendererInfo) {
          result.push('webgl unmasked vendor:' + gl.getParameter(extensionDebugRendererInfo.UNMASKED_VENDOR_WEBGL))
          result.push('webgl unmasked renderer:' + gl.getParameter(extensionDebugRendererInfo.UNMASKED_RENDERER_WEBGL))
        }
      } catch (e) { /* squelch */ }

      if (!gl.getShaderPrecisionFormat) {
        return result.join('~')
      }

      result.push('webgl vertex shader high float precision:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_FLOAT).precision)
      result.push('webgl vertex shader high float precision rangeMin:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_FLOAT).rangeMin)
      result.push('webgl vertex shader high float precision rangeMax:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_FLOAT).rangeMax)
      result.push('webgl vertex shader medium float precision:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_FLOAT).precision)
      result.push('webgl vertex shader medium float precision rangeMin:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_FLOAT).rangeMin)
      result.push('webgl vertex shader medium float precision rangeMax:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_FLOAT).rangeMax)
      result.push('webgl vertex shader low float precision:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.LOW_FLOAT).precision)
      result.push('webgl vertex shader low float precision rangeMin:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.LOW_FLOAT).rangeMin)
      result.push('webgl vertex shader low float precision rangeMax:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.LOW_FLOAT).rangeMax)
      result.push('webgl fragment shader high float precision:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT).precision)
      result.push('webgl fragment shader high float precision rangeMin:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT).rangeMin)
      result.push('webgl fragment shader high float precision rangeMax:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT).rangeMax)
      result.push('webgl fragment shader medium float precision:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT).precision)
      result.push('webgl fragment shader medium float precision rangeMin:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT).rangeMin)
      result.push('webgl fragment shader medium float precision rangeMax:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT).rangeMax)
      result.push('webgl fragment shader low float precision:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.LOW_FLOAT).precision)
      result.push('webgl fragment shader low float precision rangeMin:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.LOW_FLOAT).rangeMin)
      result.push('webgl fragment shader low float precision rangeMax:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.LOW_FLOAT).rangeMax)
      result.push('webgl vertex shader high int precision:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_INT).precision)
      result.push('webgl vertex shader high int precision rangeMin:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_INT).rangeMin)
      result.push('webgl vertex shader high int precision rangeMax:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_INT).rangeMax)
      result.push('webgl vertex shader medium int precision:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_INT).precision)
      result.push('webgl vertex shader medium int precision rangeMin:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_INT).rangeMin)
      result.push('webgl vertex shader medium int precision rangeMax:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_INT).rangeMax)
      result.push('webgl vertex shader low int precision:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.LOW_INT).precision)
      result.push('webgl vertex shader low int precision rangeMin:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.LOW_INT).rangeMin)
      result.push('webgl vertex shader low int precision rangeMax:' + gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.LOW_INT).rangeMax)
      result.push('webgl fragment shader high int precision:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_INT).precision)
      result.push('webgl fragment shader high int precision rangeMin:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_INT).rangeMin)
      result.push('webgl fragment shader high int precision rangeMax:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_INT).rangeMax)
      result.push('webgl fragment shader medium int precision:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_INT).precision)
      result.push('webgl fragment shader medium int precision rangeMin:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_INT).rangeMin)
      result.push('webgl fragment shader medium int precision rangeMax:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_INT).rangeMax)
      result.push('webgl fragment shader low int precision:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.LOW_INT).precision)
      result.push('webgl fragment shader low int precision rangeMin:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.LOW_INT).rangeMin)
      result.push('webgl fragment shader low int precision rangeMax:' + gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.LOW_INT).rangeMax)
      return result.join('~')
    },
    getWebglVendorAndRenderer: function () {
      /* This a subset of the WebGL fingerprint with a lot of entropy, while being reasonably browser-independent */
      try {
        var glContext = this.getWebglCanvas()
        var extensionDebugRendererInfo = glContext.getExtension('WEBGL_debug_renderer_info')
        return glContext.getParameter(extensionDebugRendererInfo.UNMASKED_VENDOR_WEBGL) + '~' + glContext.getParameter(extensionDebugRendererInfo.UNMASKED_RENDERER_WEBGL)
      } catch (e) {
        return null
      }
    },
    getAdBlock: function () {
      var ads = document.createElement('div')
      ads.innerHTML = '&nbsp;'
      ads.className = 'adsbox'
      var result = false
      try {
        // body may not exist, that's why we need try/catch
        document.body.appendChild(ads)
        result = document.getElementsByClassName('adsbox')[0].offsetHeight === 0
        document.body.removeChild(ads)
      } catch (e) {
        result = false
      }
      return result
    },
    getHasLiedLanguages: function () {
      // We check if navigator.language is equal to the first language of navigator.languages
      if (typeof navigator.languages !== 'undefined') {
        try {
          var firstLanguages = navigator.languages[0].substr(0, 2)
          if (firstLanguages !== navigator.language.substr(0, 2)) {
            return true
          }
        } catch (err) {
          return true
        }
      }
      return false
    },
    getHasLiedResolution: function () {
      if (window.screen.width < window.screen.availWidth) {
        return true
      }
      if (window.screen.height < window.screen.availHeight) {
        return true
      }
      return false
    },
    getHasLiedOs: function () {
      var userAgent = navigator.userAgent.toLowerCase()
      var oscpu = navigator.oscpu
      var platform = navigator.platform.toLowerCase()
      var os
      // We extract the OS from the user agent (respect the order of the if else if statement)
      if (userAgent.indexOf('windows phone') >= 0) {
        os = 'Windows Phone'
      } else if (userAgent.indexOf('win') >= 0) {
        os = 'Windows'
      } else if (userAgent.indexOf('android') >= 0) {
        os = 'Android'
      } else if (userAgent.indexOf('linux') >= 0) {
        os = 'Linux'
      } else if (userAgent.indexOf('iphone') >= 0 || userAgent.indexOf('ipad') >= 0) {
        os = 'iOS'
      } else if (userAgent.indexOf('mac') >= 0) {
        os = 'Mac'
      } else {
        os = 'Other'
      }
      // We detect if the person uses a mobile device
      var mobileDevice
      if (('ontouchstart' in window) ||
           (navigator.maxTouchPoints > 0) ||
           (navigator.msMaxTouchPoints > 0)) {
        mobileDevice = true
      } else {
        mobileDevice = false
      }

      if (mobileDevice && os !== 'Windows Phone' && os !== 'Android' && os !== 'iOS' && os !== 'Other') {
        return true
      }

      // We compare oscpu with the OS extracted from the UA
      if (typeof oscpu !== 'undefined') {
        oscpu = oscpu.toLowerCase()
        if (oscpu.indexOf('win') >= 0 && os !== 'Windows' && os !== 'Windows Phone') {
          return true
        } else if (oscpu.indexOf('linux') >= 0 && os !== 'Linux' && os !== 'Android') {
          return true
        } else if (oscpu.indexOf('mac') >= 0 && os !== 'Mac' && os !== 'iOS') {
          return true
        } else if ((oscpu.indexOf('win') === -1 && oscpu.indexOf('linux') === -1 && oscpu.indexOf('mac') === -1) !== (os === 'Other')) {
          return true
        }
      }

      // We compare platform with the OS extracted from the UA
      if (platform.indexOf('win') >= 0 && os !== 'Windows' && os !== 'Windows Phone') {
        return true
      } else if ((platform.indexOf('linux') >= 0 || platform.indexOf('android') >= 0 || platform.indexOf('pike') >= 0) && os !== 'Linux' && os !== 'Android') {
        return true
      } else if ((platform.indexOf('mac') >= 0 || platform.indexOf('ipad') >= 0 || platform.indexOf('ipod') >= 0 || platform.indexOf('iphone') >= 0) && os !== 'Mac' && os !== 'iOS') {
        return true
      } else if ((platform.indexOf('win') === -1 && platform.indexOf('linux') === -1 && platform.indexOf('mac') === -1) !== (os === 'Other')) {
        return true
      }

      if (typeof navigator.plugins === 'undefined' && os !== 'Windows' && os !== 'Windows Phone') {
        // We are are in the case where the person uses ie, therefore we can infer that it's windows
        return true
      }

      return false
    },
    getHasLiedBrowser: function () {
      var userAgent = navigator.userAgent.toLowerCase()
      var productSub = navigator.productSub

      // we extract the browser from the user agent (respect the order of the tests)
      var browser
      if (userAgent.indexOf('firefox') >= 0) {
        browser = 'Firefox'
      } else if (userAgent.indexOf('opera') >= 0 || userAgent.indexOf('opr') >= 0) {
        browser = 'Opera'
      } else if (userAgent.indexOf('chrome') >= 0) {
        browser = 'Chrome'
      } else if (userAgent.indexOf('safari') >= 0) {
        browser = 'Safari'
      } else if (userAgent.indexOf('trident') >= 0) {
        browser = 'Internet Explorer'
      } else {
        browser = 'Other'
      }

      if ((browser === 'Chrome' || browser === 'Safari' || browser === 'Opera') && productSub !== '20030107') {
        return true
      }

      // eslint-disable-next-line no-eval
      var tempRes = eval.toString().length
      if (tempRes === 37 && browser !== 'Safari' && browser !== 'Firefox' && browser !== 'Other') {
        return true
      } else if (tempRes === 39 && browser !== 'Internet Explorer' && browser !== 'Other') {
        return true
      } else if (tempRes === 33 && browser !== 'Chrome' && browser !== 'Opera' && browser !== 'Other') {
        return true
      }

      // We create an error to see how it is handled
      var errFirefox
      try {
        // eslint-disable-next-line no-throw-literal
        throw 'a'
      } catch (err) {
        try {
          err.toSource()
          errFirefox = true
        } catch (errOfErr) {
          errFirefox = false
        }
      }
      if (errFirefox && browser !== 'Firefox' && browser !== 'Other') {
        return true
      }
      return false
    },
    isCanvasSupported: function () {
      var elem = document.createElement('canvas')
      return !!(elem.getContext && elem.getContext('2d'))
    },
    isWebGlSupported: function () {
      // code taken from Modernizr
      if (!this.isCanvasSupported()) {
        return false
      }

      var glContext = this.getWebglCanvas()
      return !!window.WebGLRenderingContext && !!glContext
    },
    isIE: function () {
      if (navigator.appName === 'Microsoft Internet Explorer') {
        return true
      } else if (navigator.appName === 'Netscape' && /Trident/.test(navigator.userAgent)) { // IE 11
        return true
      }
      return false
    },
    hasSwfObjectLoaded: function () {
      return typeof window.swfobject !== 'undefined'
    },
    hasMinFlashInstalled: function () {
      return window.swfobject.hasFlashPlayerVersion('9.0.0')
    },
    addFlashDivNode: function () {
      var node = document.createElement('div')
      node.setAttribute('id', this.options.swfContainerId)
      document.body.appendChild(node)
    },
    loadSwfAndDetectFonts: function (done) {
      var hiddenCallback = '___fp_swf_loaded'
      window[hiddenCallback] = function (fonts) {
        done(fonts)
      }
      var id = this.options.swfContainerId
      this.addFlashDivNode()
      var flashvars = { onReady: hiddenCallback }
      var flashparams = { allowScriptAccess: 'always', menu: 'false' }
      window.swfobject.embedSWF(this.options.swfPath, id, '1', '1', '9.0.0', false, flashvars, flashparams, {})
    },
    getWebglCanvas: function () {
      var canvas = document.createElement('canvas')
      var gl = null
      try {
        gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl')
      } catch (e) { /* squelch */ }
      if (!gl) { gl = null }
      return gl
    },

    /**
     * @template T
     * @param {T=} context
     */
    each: function (obj, iterator, context) {
      if (obj === null) {
        return
      }
      if (this.nativeForEach && obj.forEach === this.nativeForEach) {
        obj.forEach(iterator, context)
      } else if (obj.length === +obj.length) {
        for (var i = 0, l = obj.length; i < l; i++) {
          if (iterator.call(context, obj[i], i, obj) === {}) { return }
        }
      } else {
        for (var key in obj) {
          if (obj.hasOwnProperty(key)) {
            if (iterator.call(context, obj[key], key, obj) === {}) { return }
          }
        }
      }
    },

    /**
     * @template T,V
     * @param {T=} context
     * @param {function(this:T, ?, (string|number), T=):V} iterator
     * @return {V}
     */
    map: function (obj, iterator, context) {
      var results = []
      // Not using strict equality so that this acts as a
      // shortcut to checking for `null` and `undefined`.
      if (obj == null) { return results }
      if (this.nativeMap && obj.map === this.nativeMap) { return obj.map(iterator, context) }
      this.each(obj, function (value, index, list) {
        results[results.length] = iterator.call(context, value, index, list)
      })
      return results
    },

    /// MurmurHash3 related functions

    //
    // Given two 64bit ints (as an array of two 32bit ints) returns the two
    // added together as a 64bit int (as an array of two 32bit ints).
    //
    x64Add: function (m, n) {
      m = [m[0] >>> 16, m[0] & 0xffff, m[1] >>> 16, m[1] & 0xffff]
      n = [n[0] >>> 16, n[0] & 0xffff, n[1] >>> 16, n[1] & 0xffff]
      var o = [0, 0, 0, 0]
      o[3] += m[3] + n[3]
      o[2] += o[3] >>> 16
      o[3] &= 0xffff
      o[2] += m[2] + n[2]
      o[1] += o[2] >>> 16
      o[2] &= 0xffff
      o[1] += m[1] + n[1]
      o[0] += o[1] >>> 16
      o[1] &= 0xffff
      o[0] += m[0] + n[0]
      o[0] &= 0xffff
      return [(o[0] << 16) | o[1], (o[2] << 16) | o[3]]
    },

    //
    // Given two 64bit ints (as an array of two 32bit ints) returns the two
    // multiplied together as a 64bit int (as an array of two 32bit ints).
    //
    x64Multiply: function (m, n) {
      m = [m[0] >>> 16, m[0] & 0xffff, m[1] >>> 16, m[1] & 0xffff]
      n = [n[0] >>> 16, n[0] & 0xffff, n[1] >>> 16, n[1] & 0xffff]
      var o = [0, 0, 0, 0]
      o[3] += m[3] * n[3]
      o[2] += o[3] >>> 16
      o[3] &= 0xffff
      o[2] += m[2] * n[3]
      o[1] += o[2] >>> 16
      o[2] &= 0xffff
      o[2] += m[3] * n[2]
      o[1] += o[2] >>> 16
      o[2] &= 0xffff
      o[1] += m[1] * n[3]
      o[0] += o[1] >>> 16
      o[1] &= 0xffff
      o[1] += m[2] * n[2]
      o[0] += o[1] >>> 16
      o[1] &= 0xffff
      o[1] += m[3] * n[1]
      o[0] += o[1] >>> 16
      o[1] &= 0xffff
      o[0] += (m[0] * n[3]) + (m[1] * n[2]) + (m[2] * n[1]) + (m[3] * n[0])
      o[0] &= 0xffff
      return [(o[0] << 16) | o[1], (o[2] << 16) | o[3]]
    },
    //
    // Given a 64bit int (as an array of two 32bit ints) and an int
    // representing a number of bit positions, returns the 64bit int (as an
    // array of two 32bit ints) rotated left by that number of positions.
    //
    x64Rotl: function (m, n) {
      n %= 64
      if (n === 32) {
        return [m[1], m[0]]
      } else if (n < 32) {
        return [(m[0] << n) | (m[1] >>> (32 - n)), (m[1] << n) | (m[0] >>> (32 - n))]
      } else {
        n -= 32
        return [(m[1] << n) | (m[0] >>> (32 - n)), (m[0] << n) | (m[1] >>> (32 - n))]
      }
    },
    //
    // Given a 64bit int (as an array of two 32bit ints) and an int
    // representing a number of bit positions, returns the 64bit int (as an
    // array of two 32bit ints) shifted left by that number of positions.
    //
    x64LeftShift: function (m, n) {
      n %= 64
      if (n === 0) {
        return m
      } else if (n < 32) {
        return [(m[0] << n) | (m[1] >>> (32 - n)), m[1] << n]
      } else {
        return [m[1] << (n - 32), 0]
      }
    },
    //
    // Given two 64bit ints (as an array of two 32bit ints) returns the two
    // xored together as a 64bit int (as an array of two 32bit ints).
    //
    x64Xor: function (m, n) {
      return [m[0] ^ n[0], m[1] ^ n[1]]
    },
    //
    // Given a block, returns murmurHash3's final x64 mix of that block.
    // (`[0, h[0] >>> 1]` is a 33 bit unsigned right shift. This is the
    // only place where we need to right shift 64bit ints.)
    //
    x64Fmix: function (h) {
      h = this.x64Xor(h, [0, h[0] >>> 1])
      h = this.x64Multiply(h, [0xff51afd7, 0xed558ccd])
      h = this.x64Xor(h, [0, h[0] >>> 1])
      h = this.x64Multiply(h, [0xc4ceb9fe, 0x1a85ec53])
      h = this.x64Xor(h, [0, h[0] >>> 1])
      return h
    },

    //
    // Given a string and an optional seed as an int, returns a 128 bit
    // hash using the x64 flavor of MurmurHash3, as an unsigned hex.
    //
    x64hash128: function (key, seed) {
      key = key || ''
      seed = seed || 0
      var remainder = key.length % 16
      var bytes = key.length - remainder
      var h1 = [0, seed]
      var h2 = [0, seed]
      var k1 = [0, 0]
      var k2 = [0, 0]
      var c1 = [0x87c37b91, 0x114253d5]
      var c2 = [0x4cf5ad43, 0x2745937f]
      for (var i = 0; i < bytes; i = i + 16) {
        k1 = [((key.charCodeAt(i + 4) & 0xff)) | ((key.charCodeAt(i + 5) & 0xff) << 8) | ((key.charCodeAt(i + 6) & 0xff) << 16) | ((key.charCodeAt(i + 7) & 0xff) << 24), ((key.charCodeAt(i) & 0xff)) | ((key.charCodeAt(i + 1) & 0xff) << 8) | ((key.charCodeAt(i + 2) & 0xff) << 16) | ((key.charCodeAt(i + 3) & 0xff) << 24)]
        k2 = [((key.charCodeAt(i + 12) & 0xff)) | ((key.charCodeAt(i + 13) & 0xff) << 8) | ((key.charCodeAt(i + 14) & 0xff) << 16) | ((key.charCodeAt(i + 15) & 0xff) << 24), ((key.charCodeAt(i + 8) & 0xff)) | ((key.charCodeAt(i + 9) & 0xff) << 8) | ((key.charCodeAt(i + 10) & 0xff) << 16) | ((key.charCodeAt(i + 11) & 0xff) << 24)]
        k1 = this.x64Multiply(k1, c1)
        k1 = this.x64Rotl(k1, 31)
        k1 = this.x64Multiply(k1, c2)
        h1 = this.x64Xor(h1, k1)
        h1 = this.x64Rotl(h1, 27)
        h1 = this.x64Add(h1, h2)
        h1 = this.x64Add(this.x64Multiply(h1, [0, 5]), [0, 0x52dce729])
        k2 = this.x64Multiply(k2, c2)
        k2 = this.x64Rotl(k2, 33)
        k2 = this.x64Multiply(k2, c1)
        h2 = this.x64Xor(h2, k2)
        h2 = this.x64Rotl(h2, 31)
        h2 = this.x64Add(h2, h1)
        h2 = this.x64Add(this.x64Multiply(h2, [0, 5]), [0, 0x38495ab5])
      }
      k1 = [0, 0]
      k2 = [0, 0]
      switch (remainder) {
        case 15:
          k2 = this.x64Xor(k2, this.x64LeftShift([0, key.charCodeAt(i + 14)], 48))
          // fallthrough
        case 14:
          k2 = this.x64Xor(k2, this.x64LeftShift([0, key.charCodeAt(i + 13)], 40))
          // fallthrough
        case 13:
          k2 = this.x64Xor(k2, this.x64LeftShift([0, key.charCodeAt(i + 12)], 32))
          // fallthrough
        case 12:
          k2 = this.x64Xor(k2, this.x64LeftShift([0, key.charCodeAt(i + 11)], 24))
          // fallthrough
        case 11:
          k2 = this.x64Xor(k2, this.x64LeftShift([0, key.charCodeAt(i + 10)], 16))
          // fallthrough
        case 10:
          k2 = this.x64Xor(k2, this.x64LeftShift([0, key.charCodeAt(i + 9)], 8))
          // fallthrough
        case 9:
          k2 = this.x64Xor(k2, [0, key.charCodeAt(i + 8)])
          k2 = this.x64Multiply(k2, c2)
          k2 = this.x64Rotl(k2, 33)
          k2 = this.x64Multiply(k2, c1)
          h2 = this.x64Xor(h2, k2)
          // fallthrough
        case 8:
          k1 = this.x64Xor(k1, this.x64LeftShift([0, key.charCodeAt(i + 7)], 56))
          // fallthrough
        case 7:
          k1 = this.x64Xor(k1, this.x64LeftShift([0, key.charCodeAt(i + 6)], 48))
          // fallthrough
        case 6:
          k1 = this.x64Xor(k1, this.x64LeftShift([0, key.charCodeAt(i + 5)], 40))
          // fallthrough
        case 5:
          k1 = this.x64Xor(k1, this.x64LeftShift([0, key.charCodeAt(i + 4)], 32))
          // fallthrough
        case 4:
          k1 = this.x64Xor(k1, this.x64LeftShift([0, key.charCodeAt(i + 3)], 24))
          // fallthrough
        case 3:
          k1 = this.x64Xor(k1, this.x64LeftShift([0, key.charCodeAt(i + 2)], 16))
          // fallthrough
        case 2:
          k1 = this.x64Xor(k1, this.x64LeftShift([0, key.charCodeAt(i + 1)], 8))
          // fallthrough
        case 1:
          k1 = this.x64Xor(k1, [0, key.charCodeAt(i)])
          k1 = this.x64Multiply(k1, c1)
          k1 = this.x64Rotl(k1, 31)
          k1 = this.x64Multiply(k1, c2)
          h1 = this.x64Xor(h1, k1)
          // fallthrough
      }
      h1 = this.x64Xor(h1, [0, key.length])
      h2 = this.x64Xor(h2, [0, key.length])
      h1 = this.x64Add(h1, h2)
      h2 = this.x64Add(h2, h1)
      h1 = this.x64Fmix(h1)
      h2 = this.x64Fmix(h2)
      h1 = this.x64Add(h1, h2)
      h2 = this.x64Add(h2, h1)
      return ('00000000' + (h1[0] >>> 0).toString(16)).slice(-8) + ('00000000' + (h1[1] >>> 0).toString(16)).slice(-8) + ('00000000' + (h2[0] >>> 0).toString(16)).slice(-8) + ('00000000' + (h2[1] >>> 0).toString(16)).slice(-8)
    }
  }
  Fingerprint2.VERSION = '1.5.1'
  return Fingerprint2
})

var DTOS = {

	Map: function (object, type) {

		if (Object.prototype.toString.call(object) === '[object Array]') {

			if (object.length > 0) {
				var list = new Array();

				for (var i = 0; i < object.length; i++)
					list.push(eval('this._map_' + type + '(object[i])'));

				return list;
			}
		} else
			return eval('this._map_' + type + '(object)');
	},

	_map_notification: function (o) {

		this._validate(o, 'id', 'read', 'message', 'new', 'event');

		return {
			id: o.id,
			read: o.read,
			avatar: o.avatar,
			title: o.title,
			message: o.message,
			extra: o.extra,
			timestamp: o.timestamp,
			new: o.new,
			event: o.event,
			letters: o.letters
		}
	},

	_map_parents: function (o) {

		this._validate(o, 'id', 'name', 'disabled');

		return {
			id: o.id,
			name: o.name,
			disabled: o.disabled
		}
	},

	_map_founds_rised: function (o) {
		return {
			amount: o.payload.amount,
			currency: o.payload.currency
		}
	},

	_map_school: function (o) {

		//this._validate(o, 'id', 'name', 'status');

		return {
			id: o.schoolId,
			city: o.city,
			country: o.country,
			email: o.email,
			parentCount: o.parentCount,
			parentPercentage: o.parentPercentage,
			phoneNumber: o.phoneNumber,
			postCode: o.postCode,
			pupilCount: o.pupilCount,
			name: o.schoolName,
			descr: o.schoolAbout,
			size: o.schoolSize,
			address: o.streetAddress,
			helpTitle: o.helpTitle,
			helpDescription: o.helpDescription,
			links: o.helpfulLinks,
			yearRepCount: o.yearRepCount,
			classRepCount: o.classRepCount,
			ambassadors: o.ambassadors,
			countryId: o.countryId,
			schoolStuff: o.schoolStuff,
			classesCount: o.classesCount,
			yearsCount: o.yearsCount,
			cover: o.schoolCover,
			logo: o.schoolLogo,
			communityReps: o.communityReps,
			stateCounty: o.stateCounty,
			approvedByRole: o.approvedByRole,
			settings: o.settings,
			paymentProvider: o.paymentProvider,
			ambassadorMessage: o.ambassadorMessage,
			ambassadorMessageUpdatedByName: o.ambassadorMessageUpdatedByName,
			currency: o.currency
		}
	},

	_map_user_label: function (o) {

		this._validate(o, 'id', 'label');

		return {
			id: o.id,
			label: o.label
		}
	},

	_validate: function () {
		var o = arguments[0];

		for (var prop in o) {
			for (var i = 1; i < arguments.length; ++i) {
				if (!Object.prototype.hasOwnProperty.call(o, arguments[i])) {
					throw new Error('DTOS -> Missing object parameter: ' + arguments[i]);
				}
			}
		}
	}
};

(function() {
	'use strict';

	angular.module('modules.participants',[]).factory('participantsService', ['base', function (base) {
		return _.create(base, { });
	}]).directive('participants', participants);
	/** @ngInject */
	function participants( $translate, $rootScope, participantsService, toastr, $timeout) {

		var directive = {
			restrict: 'EA',
			replace: false,
			scope:{
				ngModel: '=',
				dataevent: '&'
			},
			templateUrl:'app/base/directives/participants.module.html',
			link: linkFunction
		};

		return directive;

		function linkFunction(scope, elem, attrs) {

			scope.participants = scope.ngModel || [];

			scope.$watch('participants', function(newVal, oldVal) {
				scope.ngModel = scope.participants;
			})

			scope.getParticipants = function (string) {
				return 	participantsService.get('search/v1/group/commevent/' + attrs.schoolId +
					'/' + encodeURIComponent(string), { }).then(function (response) {
					return response.data.items
				}, function (error) {
				})
			}

			scope.toggleGroup = function(className){
				var el = document.getElementsByClassName(className);
				_.forEach(el, function(item){
					var elm = angular.element(item);
					if(elm.hasClass('visible')){
						elm.removeClass('visible');
						return
					} else { elm.addClass('visible'); }
				})
			}

			scope.isCurrentUser = function(id){
				return id === $rootScope.active_user.id;
			}

			function getMembersByGroupId(group) {
				scope.participants.push({
							id:0,
							type: group.type,
							groupId: group.id,
							groupName: group.field1,
							groupSize: group.c
						})
			}

			//this is the autocomplete function called by the HTML
			scope.pickParticipant = function (autocompleteResult) {
				getMembersByGroupId(autocompleteResult);
				scope.participant = null;
			}

			scope.removeParticipant = function (participant) {
				var toBeRemoved = _.filter(scope.participants, function(obj) {return obj.groupId === participant.groupId;});

				for (var i = 0; i < toBeRemoved.length; i++) {
					scope.participants = _.without(scope.participants, toBeRemoved[i]);
				}

				if(scope.dataevent)
					scope.dataevent({data: scope.participants});

				$timeout(function(){
					$rootScope.$broadcast('AVATAR_UPDATE');
				},0)
			}
		}
	}
})();

(function() {
	'use strict';

	angular.module('modules.parents',[]).factory('parentsService', ['base', function (base) {
		return _.create(base, { });
	}]).directive('parents', parents);
	/** @ngInject */
	function parents( $translate, $rootScope, parentsService, toastr, $timeout) {

		var directive = {
			restrict: 'EA',
			replace: false,
			scope:{
				ngModel: '=?'
			},
			templateUrl:'app/base/directives/parents.module.html',
			link: linkFunction
		};

		return directive;

		function linkFunction(scope, elem, attrs) {
			scope.hasSelected = false;

			scope.parents = scope.ngModel || [];

			// scope.$watch('parents', function(newVal, oldVal) {
			// 	scope.ngModel = scope.parents;
			// })

			scope.getParents = function (string) {
				return 	parentsService.get('search/v1/rep/assign/' + attrs.schoolId +
					'/' + encodeURIComponent(string), { }).then(function (response) {
					return response.data.resultList
				}, 
				function (error) {

				})
			}
			
			scope.pickParent = function (autocompleteResult) {
				scope.selectedId = autocompleteResult.id;
				$rootScope.$broadcast('ADD_AMBA_PARENT', autocompleteResult);
			}
		}
	}
})();

(function() {
	'use strict';

	angular.module('modules.grouptags',[]).factory('groupTagsService', ['base', function (base) {
		return _.create(base, { });
	}]).directive('grouptags', grouptags);
	/** @ngInject */
	function grouptags( $translate, $rootScope, groupTagsService, toastr, $timeout) {

		var directive = {
			restrict: 'EA',
			replace: false,
			scope:{
				ngModel: '='
			},
			templateUrl:'app/base/directives/grouptags.module.html',
			link: linkFunction
		};

		return directive;

		function linkFunction(scope, elem, attrs) {
			scope.tags = scope.ngModel || [];
			scope.inputPlaceholder = $translate.instant('ADD_TAGS_PLACEHOLDER');

			scope.$watch('tags', function(newVal, oldVal){
				scope.ngModel = scope.tags;
			})

			scope.getTags = function (string) {
				return groupTagsService.get('group/v1/parent/' + attrs.schoolId +
					'/tags/' + encodeURIComponent(string)).then(function (response) {
					return response.data.tags
				}, function (error) {
				})
			}

			scope.pickTag = function (tag) {
				if(scope.tags.indexOf(tag) < 0) {
					scope.tags.push(tag);
				}
				scope.tag = null;
			}

			scope.keyUp = function (event) {
				if(event.which === 13) {
					if(!!scope.tag && scope.tag !== '') {
						scope.tags.push(scope.tag);
					}
					scope.tag = null;
				}
			}

			scope.removeTags = function (i) {
				scope.tags.splice(i, 1);
			}
		}
	}
})();

(function() {
	'use strict';

	angular.module('modules.groupparticipants',[]).factory('groupparticipantsService', ['base', function (base) {
		return _.create(base, { });
	}]).directive('groupparticipants', groupparticipants);
	/** @ngInject */
	function groupparticipants( $translate, $rootScope, groupparticipantsService, toastr, $timeout) {

		var directive = {
			restrict: 'EA',
			replace: false,
			scope:{
				ngModel: '='
			},
			templateUrl:'app/base/directives/groupparticipants.module.html',
			link: linkFunction
		};

		return directive;

		function linkFunction(scope, elem, attrs) {
			scope.participants = scope.ngModel || [];
			scope.members = [];
			scope.showMembers = false;

			scope.inputPlaceholder = $translate.instant('ADD_RECIPIENT_SEARCH_PHOLDER');
			
			if(attrs.eventContext === 'true')
				scope.inputPlaceholder = $translate.instant('ADD_GUEST_SEARCH_PHOLDER');

			scope.$watch('participants', function(newVal, oldVal){
				scope.ngModel = scope.participants;
			})

			scope.getParticipants = function (string) {
				return 	groupparticipantsService.get('group/v1/school/group/search/' + attrs.schoolId +
					'/' + encodeURIComponent(string) + '/' + attrs.showTiers, { }).then(function (response) {
					return response.data.items
				}, function (error) {
				})
			}

			scope.toggleGroup = function(className){
				var el = document.getElementsByClassName(className);
				_.forEach(el, function(item){
					var elm = angular.element(item);
					if(elm.hasClass('visible')){
						elm.removeClass('visible');
						return
					} else { elm.addClass('visible'); }
				})
			}

			function getMembersByGroupId(autocompleteResult) {
				groupparticipantsService.get('group/v1/school/private/group/members/'+autocompleteResult.id,{'cache':true}).then(function (response) {
				
					if (_.isUndefined(response.data.resultList)){
						toastr.info($translate.instant('GROUPS_NO_MEMBERS'));
						return;
					}
	
					_.forEach(response.data.resultList, function(iteratorItem){
						scope.participants.push({
							id:iteratorItem.id,
							type: autocompleteResult.type,
							groupId: autocompleteResult.id,
							groupName: autocompleteResult.field1,
							groupSize: response.data.resultList.length,
							firstName: iteratorItem.firstName,
							lastName: iteratorItem.lastName,
							avatar: iteratorItem.avatar,
							pupils: iteratorItem.pupils
						})
					})
					
				}, function (error) {
					
				})
			}

			scope.filterGroupMembers = function(participants, groupId) {

				var members = []
				for (var i = 0; i < participants.length; i++) {
					if (participants[i].groupId === groupId) {
						members.push({
							id:participants[i].userId,
							type: participants[i].type,
							groupId: groupId,
							firstName: participants[i].firstName,
							lastName: participants[i].lastName,
							avatar: participants[i].avatar
						})
					}
				}
				scope.members = members;
			}

			scope.pickParticipant = function (autocompleteResult) {
				if (autocompleteResult.type === 'user') {
					scope.participants.push({
						id:autocompleteResult.id,
						type: autocompleteResult.type ,
						firstName: autocompleteResult.field1,
						lastName: autocompleteResult.field2,
						avatar:autocompleteResult.avatar,
						groupName: ''
					})
				} else {
					getMembersByGroupId(autocompleteResult);
				}
				scope.participant = null;
			}

			scope.removeParticipant = function (participant) {
				$timeout(function(){
					scope.participants = _.without(scope.participants, participant)
				},0)
			}

			scope.removeMember = function (participant) {
				$timeout(function(){
					scope.members = _.without(scope.members, participant)
				},0)
			}
		}
	}
})();

(function () {
	"use strict";

	angular
		.module("modules.website.settings", [])
		.controller("websiteSettingsController", websiteSettingsController);

	/** @ngInject */
	function websiteSettingsController(baseService, $rootScope, $scope, websiteService, toastr, $translate, $uibModal, $http, settings) {
		$scope.loading = false;
		$scope.firstPanel = false;
		$scope.secondPanel = false;
		$scope.thirdPanel = false;
		$scope.fourthPanel = false;
		$scope.domain = "";
		$scope.domainEditing = true;
		$scope.validateLink = validateLinkSecureOnly;
		$scope.firstText = {title: "",body: "",linkLabel: "",linkAddress: ""};
		$scope.secondText = {title: "",body: "",linkLabel: "",linkAddress: ""};
		$scope.firstEvent = {title: "",body: "",linkLabel: "",linkAddress: ""};
		$scope.secondEvent = {title: "",body: "",linkLabel: "",linkAddress: ""};
		$scope.thirdEvent = {title: "",body: "",linkLabel: "",linkAddress: ""};
		$scope.event = {title: "",body: "",linkLabel: "",linkAddress: ""};
		$scope.events = [];
		$scope.links = [];
		$scope.link = {text: "",href: ""};
		$scope.logo = "";
		$scope.logoType = 'NO_LOGO';
		$scope.lastUploadedLogo = {};
		$scope.coverURL = "";
		$scope.coverType = 'NO_COVER';
		$scope.lastUploadedCover = {};
		$scope.ambassadors = [{},{},{},{}];
		$scope.ambassadorsTitle = '';

		baseService.app_initialized = function (evt, args) {
			$http.get('i8n/locale-metadata-en-GB.json?v=12').then(function (data) {
				$scope.countries = data.data.metadata.countries;
			});
			$scope.getSettings();
		};

		$scope.getSettings = function() {
			websiteService.get('schoolPublicWeb/v1/get/' + $rootScope.active_school.id, { 'xhr':true, cache: false })
			.then(function(response) {
				$scope.settings = response.data || {};
				$scope.websiteURL = settings.conf.ptaWebsiteURL + '/' + $scope.settings.domain;
				var activeEventIndex=0;
				if($scope.settings.events && $scope.settings.events.length > 0 && $scope.settings.events.length < 3){
					activeEventIndex = $scope.settings.events.length;
				}
				$scope.event.photo = $scope.settings.eventDefaultImageURLs[activeEventIndex].id;
				$scope.event.photoURL = $scope.settings.eventDefaultImageURLs[activeEventIndex].url;


				websiteService.get('schoolPublicWeb/v1/get/reps/' + $rootScope.active_school.id, { 'xhr':true, cache: false })
				.then(function(response) {
					$scope.ambassadorList = response.data.items || {};
					$scope.setData();
				}, 
				function(error) {
					toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
				});
			}, 
			function(error) {
				toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
			});
		}

		$scope.setData = function() {
			if ($scope.settings.section1.title) $scope.firstText = Object.assign({}, $scope.settings.section1);
			if ($scope.settings.section2.title) $scope.secondText = Object.assign({}, $scope.settings.section2);
			if ($scope.settings.links) $scope.links = Object.assign([], $scope.settings.links);
			if ($scope.settings.events) {
				$scope.events = $scope.settings.events;

				// if ($scope.settings.events[0].title) {
				// 	$scope.firstEvent = Object.assign({}, $scope.settings.events[0]);
				// } else {
				// 	$scope.firstEvent.photo = angular.copy($scope.settings.events[0].photo);
				// 	$scope.firstEvent.photoURL = angular.copy($scope.settings.events[0].photoURL);
				// }
				// if ($scope.settings.events[1].title) {
				// 	$scope.secondEvent = Object.assign({}, $scope.settings.events[1]);
				// } else {
				// 	$scope.secondEvent.photo = angular.copy($scope.settings.events[1].photo);
				// 	$scope.secondEvent.photoURL = angular.copy($scope.settings.events[1].photoURL);
				// }
				// if ($scope.settings.events[2].title) {
				// 	$scope.thirdEvent = Object.assign({}, $scope.settings.events[2]);
				// } else {
				// 	$scope.thirdEvent.photo = angular.copy($scope.settings.events[2].photo);
				// 	$scope.thirdEvent.photoURL = angular.copy($scope.settings.events[2].photoURL);
				// }
			}
			if ($scope.settings.domain) {
				$scope.domain =  angular.copy($scope.settings.domain);
				$scope.domainEditing = false;
			}
			if ($scope.settings.logoURL) {
				$scope.logo = angular.copy($scope.settings.logoURL);
			} else {
				$scope.settings.logoURL = "";
			}
			if ($scope.settings.logoType) $scope.logoType = angular.copy($scope.settings.logoType);
			if ($scope.settings.logoType === 'PUBLIC_SCHOOL_LOGO') $scope.lastUploadedLogo.url = angular.copy($scope.settings.logoURL);
			if ($scope.settings.coverURL) {
				$scope.coverURL = angular.copy($scope.settings.coverURL);
			} else {
				$scope.settings.coverURL = "";
			}
			if ($scope.settings.coverType) $scope.coverType = angular.copy($scope.settings.coverType);
			if ($scope.settings.coverType === 'PUBLIC_SCHOOL_COVER') $scope.lastUploadedCover.url = angular.copy($scope.settings.coverURL);
			if ($scope.settings.ambassadors.title) $scope.ambassadorsTitle = angular.copy($scope.settings.ambassadors.title);
			if ($scope.settings.ambassadors.repIds && $scope.settings.ambassadors.repIds.length !== 0) {
				for (var i = 0; i < $scope.settings.ambassadors.repIds.length; i++) {
					var amb = $scope.ambassadorList.find(function(ambassador){
						return ambassador.repId === $scope.settings.ambassadors.repIds[i];
					});
					$scope.ambassadors[i] = amb;
				}
			}
		}
		
		$scope.shallowEqual = function (object1, object2) {
			var keys = ['title', 'body', 'linkLabel', 'linkAddress', 'photo', 'photoURL'];
			for (var i = 0; i < keys.length; i++) {
				var key = keys[i];
			  if (object1[key] !== object2[key]) {
				return false;
			  }
			}
			return true;
		}

		$scope.toggleFirstPanel = function() {
			$scope.firstPanel = !$scope.firstPanel;
		}

		$scope.toggleSecondPanel = function() {
			$scope.secondPanel = !$scope.secondPanel;
		}

		$scope.toggleThirdPanel = function() {
			$scope.thirdPanel = !$scope.thirdPanel;
		}

		$scope.toggleFourthPanel = function() {
			$scope.fourthPanel = !$scope.fourthPanel;
		}

		$scope.addEventDisabled = function() {
			if ($scope.loading || $scope.event.title.length === 0 || $scope.event.body.length === 0) {
				return true;
			} else {
				if ($scope.event.linkAddress.length > 0) {
					return !$scope.validateLink($scope.event.linkAddress);
				} else {
					return false;
				}
			}
		}

		$scope.isSectionSaveDisabled = function(object1, object2) {
			if ($scope.loading || object1.title.length === 0 || object1.body.length === 0 || $scope.shallowEqual(object1, object2)) {
				return true;
			} else {
				if (object1.linkAddress.length > 0) {
					return !$scope.validateLink(object1.linkAddress);
				} else {
					return false;
				}
			}
		}

		$scope.eventRemove = function(index, event){
			$scope.loading = true;
			websiteService.delete('schoolPublicWeb/v1/update/deleteEvent/' + $rootScope.active_school.id + '/' + index)
			.then(function(response) {
				$scope.events.splice(index, 1);
				toastr.success($translate.instant('WEBSITE_SUCCESS_MESSAGE'));	
				$scope.loading = false;
				$scope.event.photo = $scope.settings.eventDefaultImageURLs[$scope.events.length].id;
				$scope.event.photoURL = $scope.settings.eventDefaultImageURLs[$scope.events.length].url;
			}, 
			function(error) {
				if(error.data.error.code == 400) {
					toastr.error($translate.instant(error.data.error.message));
				}
				else {
					toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
				}
				$scope.loading = false;
			});
		}

		$scope.eventSave = function(){
			if ($scope.event.linkLabel.length > 0 && $scope.event.linkAddress.length === 0) {
				$scope.event.linkAddressError = true;
				return;
			}
			if ($scope.event.linkLabel.length === 0 && $scope.event.linkAddress.length > 0) {
				$scope.event.linkLabelError = true;
				return;
			}
			$scope.loading = true;
			websiteService.post('schoolPublicWeb/v1/update/addEvent/' + $rootScope.active_school.id, $scope.event)
			.then(function(response) {
				$scope.events.push(response.data);
				toastr.success($translate.instant('WEBSITE_SUCCESS_MESSAGE'));	
				$scope.loading = false;
				$scope.event = {title: "",body: "",linkLabel: "",linkAddress: ""};
				$scope.event.photo = $scope.settings.eventDefaultImageURLs[$scope.events.length].id;
				$scope.event.photoURL = $scope.settings.eventDefaultImageURLs[$scope.events.length].url;
				$scope.scrollTo(response.data.photo);
			}, 
			function(error) {
				if(error.data.error.code == 400) {
					toastr.error($translate.instant(error.data.error.message));
				}
				else {
					toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
				}
				$scope.loading = false;
			});
		}

		$scope.sectionSave = function(index, section, payload) {
			if (section !== 'ambassadors') {
				if (payload.linkLabel.length > 0 && payload.linkAddress.length === 0) {
					payload.linkAddressError = true;
					return;
				}
				if (payload.linkLabel.length === 0 && payload.linkAddress.length > 0) {
					payload.linkLabelError = true;
					return;
				}
			}
			$scope.loading = true;
			websiteService.post('schoolPublicWeb/v1/update/' + index + '/' + section + '/' + $rootScope.active_school.id, payload)
			.then(function(response) {
				toastr.success($translate.instant('WEBSITE_SUCCESS_MESSAGE'));	
				$scope.loading = false;
				if (section === 'section1') {
					$scope.settings.section1 = Object.assign({}, payload);
				}
				if (section === 'section2') {
					$scope.settings.section2 = Object.assign({}, payload);
				}
			}, 
			function(error) {
				if(error.data.error.code == 400) {
					toastr.error($translate.instant(error.data.error.message));
				}
				else {
					toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
				}
				$scope.loading = false;
			});
		}

		$scope.disabledLink = function() {
			return $scope.loading || $scope.link.text === 0 || $scope.link.href === 0 || !$scope.validateLink($scope.link.href);
		}

		$scope.logoDisabled = function() {
			return $scope.loading || ($scope.logoType === $scope.settings.logoType && $scope.logo === $scope.settings.logoURL);
		}

		$scope.coverDisabled = function() {
			return $scope.loading || ($scope.coverType === $scope.settings.coverType && $scope.coverURL === $scope.settings.coverURL);
		}

		$scope.addLink = function() {
			$scope.loading = true;
			websiteService.post('schoolPublicWeb/v1/update/addLink/' + $rootScope.active_school.id, {"payload": $scope.link})
			.then(function(response) {
				$scope.links.push(response.data);
				$scope.link = {
					text: "",
					href: ""
				}
				toastr.success($translate.instant('WEBSITE_SUCCESS_MESSAGE'));
				$scope.loading = false;
			}, 
			function(error) {
				if(error.data.error.code == 400) {
					toastr.error($translate.instant(error.data.error.message));
				}
				else {
					toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
				}
				$scope.loading = false;
			});
		}

		$scope.deleteLink = function(link, index) {
			$scope.loading = true;
			websiteService.delete('schoolPublicWeb/v1/update/deleteLink/' + $rootScope.active_school.id + '/' + link.id)
			.then(function(response) {
				$scope.links.splice(index, 1);
				toastr.success($translate.instant('WEBSITE_SUCCESS_MESSAGE'));
				$scope.loading = false;
			}, 
			function(error) {
				if(error.data.error.code == 400) {
					toastr.error($translate.instant(error.data.error.message));
				}
				else {
					toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
				}
				$scope.loading = false;
			});
		}

		$scope.eventImageUpload = function() {
			$rootScope.$broadcast('UPLOAD_PHOTO', {
				'callback_fn': function (response) {
					$scope.event.photo = response.data.id;
					$scope.event.photoURL = response.data.url;
				},
				'action': 'websiteEventUpload',
				'config': 'websiteEventCropper',
				'on_close': function () {
				}
			});
		}

		$scope.logoUpload = function() {
			$rootScope.$broadcast('UPLOAD_PHOTO', {
				'callback_fn': function (response) {
					$scope.lastUploadedLogo = response.data;
					$scope.logo = response.data.url;
				},
				'action': 'websiteLogoUpload',
				'config': 'websiteLogoCropper',
				'on_close': function () {
				}
			});
		}

		$scope.coverUpload = function() {
			$rootScope.$broadcast('UPLOAD_PHOTO', {
				'callback_fn': function (response) {
					$scope.lastUploadedCover = response.data;
					$scope.coverURL = response.data.url;
				},
				'action': 'websiteCoverUpload',
				'config': 'websiteCoverCropper',
				'on_close': function () {
				}
			});
		}

		$scope.logoSave = function () {
			$scope.loading = true;
			var id = $scope.logoType;
			if ($scope.logoType === 'PUBLIC_SCHOOL_LOGO') {
				id = $scope.lastUploadedLogo.id;
			}
			var payload = {
				"payload": {
					"photo": id
				}
			}
			websiteService.post('schoolPublicWeb/v1/update/logo/' + $rootScope.active_school.id, payload)
			.then(function(response) {
				toastr.success($translate.instant('WEBSITE_SUCCESS_MESSAGE'));
				$scope.settings.logoType = angular.copy($scope.logoType);
				$scope.settings.logoURL = angular.copy($scope.logo);
				$scope.loading = false;
			}, 
			function(error) {
				if(error.data.error.code == 400) {
					toastr.error($translate.instant(error.data.error.message));
				}
				else {
					toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
				}
				$scope.loading = false;
			});
		}

		$scope.coverSave = function () {
			$scope.loading = true;
			var id = $scope.coverType;
			if ($scope.coverType === 'PUBLIC_SCHOOL_COVER') {
				id = $scope.lastUploadedCover.id;
			}
			var payload = {
				"payload": {
					"photo": id
				}
			}
			websiteService.post('schoolPublicWeb/v1/update/cover/' + $rootScope.active_school.id, payload)
			.then(function(response) {
				toastr.success($translate.instant('WEBSITE_SUCCESS_MESSAGE'));
				$scope.settings.coverType = angular.copy($scope.coverType);
				$scope.settings.coverURL = angular.copy($scope.coverURL);
				$scope.loading = false;
			}, 
			function(error) {
				if(error.data.error.code == 400) {
					toastr.error($translate.instant(error.data.error.message));
				}
				else {
					toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
				}
				$scope.loading = false;
			});
		}

		$scope.editLocation = function () {
			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/website/views/edit-address-modal.html',
				controller: function () {

					$scope.getCountryName = function (id) {
						if (id)
							return _.find($scope.countries, {
								'id': id
							}).longName;
						else
							return '';
					}

					$scope.cancel = function () {
						modalInstance.close();
					};

					$scope.continue = function () {
						$scope.loading = true;
						var payload = {
							'city': $scope.settings.address.city,
							'countryId': $scope.settings.address.countryId,
							'postCode': $scope.settings.address.postCode,
							'stateCounty': $scope.settings.address.stateCounty,
							'streetAddress': $scope.settings.address.streetAddress
						}
						websiteService.post('schoolPublicWeb/v1/update/address/' + $rootScope.active_school.id, payload)
						.then(function (response) {
								$scope.settings.address.plainAddress = response.data.plainAddress;
								modalInstance.close();
								toastr.success($translate.instant('WEBSITE_SUCCESS_MESSAGE'));
								$scope.loading = false;
							},
							function (error) {
								toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
								$scope.loading = false;
							});
					};
				},
				size: 'md'
			});
		}

		$scope.checkDomain = function () {
			$scope.domain = $scope.domain.replace(/[^a-z-]+/, '');
		}

		$scope.disabledSaveDomain = function () {
			return $scope.loading || !$scope.domain || $scope.domain.length < 4 || $scope.domain === $scope.settings.domain;
		}

		$scope.editDomain = function () {
			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/website/views/edit-domain-modal.html',
				controller: function () {

					$scope.cancel = function () {
						modalInstance.close();
					};

					$scope.continue = function () {
						modalInstance.close();
						$scope.domainEditing = true;
					};
				},
				size: 'sm'
			});
		}

		$scope.saveDomain = function() {
			$scope.loading = true;
			var payload = {
				"payload": {
					"domain": $scope.domain
				}
			}
			websiteService.post('schoolPublicWeb/v1/update/domain/' + $rootScope.active_school.id, payload)
			.then(function(response) {
				$scope.domainEditing = false;
				$scope.websiteURL = settings.conf.ptaWebsiteURL + '/' + $scope.domain;
				if (!$scope.settings.domain) {
					toastr.success($translate.instant('WEBSITE_SUCCESS_MESSAGE'));
				} else {
					toastr.success($translate.instant('WEBSITE_SUCCESS_MESSAGE_2'));
				}
				$scope.loading = false;
			}, 
			function(error) {
				if(error.data.error.code == 400) {
					toastr.error($translate.instant(error.data.error.message));
				}
				else {
					toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
				}
				$scope.loading = false;
			});
		}


		$scope.isAmbassadorSelected = function (ambassador) {
			return $scope.ambassadors.find(function(a){
				return a.id === ambassador.id;
			});
		}

		$scope.saveAmbassadors = function () {
			var payload = {
				title: $scope.ambassadorsTitle,
				repIds: []
			};
			for (var i = 0; i < 4; i++) {
				if ($scope.ambassadors[i].repId) {
					payload.repIds.push($scope.ambassadors[i].repId);
				}
			}
			$scope.sectionSave(0, 'ambassadors', payload);
		}

		$scope.disabledAmbassadors = function () {
			if ($scope.loading || $scope.ambassadorsTitle === '') {
				return true;
			} else {
				var repIds = [];
				for (var i = 0; i < 4; i++) {
					if ($scope.ambassadors[i].repId) {
						repIds.push($scope.ambassadors[i].repId);
					}
				}
				if (repIds.length === 0) {
					return true;
				} else if ($scope.settings.ambassadors.title === $scope.ambassadorsTitle && $scope.arraysMatch(repIds, $scope.settings.ambassadors.repIds)) {
					return true;
				} else {
					return false;
				}
			}
		}

		$scope.arraysMatch = function (arr1, arr2) {

			// Check if the arrays are the same length
			if (arr1.length !== arr2.length) return false;
		
			// Check if all items exist and are in the same order
			for (var i = 0; i < arr1.length; i++) {
				if (arr1[i] !== arr2[i]) return false;
			}
		
			// Otherwise, return true
			return true;
		
		};

		$scope.disabledPublish = function() {
			return $scope.loading || $scope.firstText.title.length === 0 || $scope.secondText.title.length === 0 || $scope.links.length === 0 || $scope.domain.length === 0;
		}

		$scope.disabledPublishReason = function() {
			var reason="";
			if($scope.firstText.title.length === 0){
				reason += "<br>Please add body text to Text 1.";
			} 
			if($scope.secondText.title.length === 0){
				reason += "<br>Please add body text to Text 2.";
			}
			if($scope.links.length === 0){
				reason += "<br>Please add at least one link before publishing.";
			}
			if($scope.domain.length === 0){
				reason += "<br>Please define a website address before publishing.";
			}
			return reason;
		}

		$scope.beforePublish = function() {
			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/website/views/publish-warning-modal.html',
				controller: function () {
					$scope.checked = false;
					$scope.cancel = function () {
						modalInstance.close();
					};
					$scope.continue = function () {
						modalInstance.close();
						$scope.publish();
					};
				},
				size: 'md'
			});
		}

		$scope.publish = function() {
			$scope.loading = true;
			websiteService.get('schoolPublicWeb/v1/publish/' + $rootScope.active_school.id, { 'xhr':true, cache: false })
			.then(function(response) {
				$scope.loading = false;
				$scope.settings.published = true;
				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/website/views/published-modal.html',
					controller: function ($scope) {
						$scope.cancel = function () {
							modalInstance.close();
						};
					},
					size: 'md'
				});
			}, 
			function(error) {
				if(error.data.error.code == 400) {
					toastr.error($translate.instant(error.data.error.message));
				}
				else {
					toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
				}
				$scope.loading = false;
			});
		}

		$scope.copyURL = function() {
			copyToClipboard($scope.websiteURL);
			toastr.success($translate.instant("LINK_COPIED"));
		}

		$scope.scrollTo = function(id) {
			setTimeout(function() {
				var elmnt = document.getElementById(id);
				window.scrollBy(0, elmnt.getBoundingClientRect().y-150);
			}, 200);
		}

		if ($rootScope.active_school && $rootScope.app_base_ready) {
			baseService.app_initialized();
		}
	}
})();

(function () {
	'use strict';

	angular.module('modules.website', [])
		.factory("websiteService", [
			"base",
			function (base) {
				return _.create(base, {});
			},
		])
		.controller('websiteController', websiteController);

	/** @ngInject */
	function websiteController(baseService, $rootScope) {

		baseService.app_initialized = function (evt, args) {
		}

		if ($rootScope.active_school && $rootScope.app_base_ready) {
			baseService.app_initialized();
		}
	}

})();

(function () {
	"use strict";

	angular
		.module("modules.website.comingsoon", [])
		.controller("websiteComingsoonController", websiteComingsoonController);

	/** @ngInject */
	function websiteComingsoonController(baseService, $rootScope, $scope) {
		baseService.app_initialized = function (evt, args) {};

		if ($rootScope.active_school && $rootScope.app_base_ready) {
			baseService.app_initialized();
		}
	}
})();

(function() {
	'use strict';

	angular.module('modules.users.staffdetail',[]).controller('staffDetailController', staffDetailController);

	/** @ngInject */
	function staffDetailController(baseService, $scope, $rootScope, usersService, metadata, $uibModal, toastr, $translate, $stateParams, $location, storage) {

		$scope.id = $stateParams.id;
		var relationships = [];
		$scope.parents = [];

		$scope.viewState = {
			isReady: false
		};

		baseService.app_initialized = function(evt, args) {

		$scope.nameRelation = function (_id) {
			return relationships[_id]
		}

		_.each(metadata.data.metadata.relationships, function (obj, index) {
			relationships[obj.id] = obj.longName;
		});

		var schoolId = $rootScope.active_school.id;
		$scope.role = $rootScope.active_user.role;
		$scope._user = $rootScope.active_user;

		function getUser() {
			$scope.viewState.isReady = false;

			usersService.get('school/v1/get/' + schoolId + '/staff/' + $scope.id, { 'cache':false }).then(function (response) {
				$scope.viewState.isReady = true;
				$scope.user = response.data;
			}, 
			function(error) {
				$scope.viewState.isReady = true;
			})

			if ($rootScope.active_user.role == "AMBASSADOR" && $rootScope.active_school.integrationEnabled) {
				$scope.isStaffInvitePermission = false;
			} else if ($rootScope.active_user.role == "STAFF" && $rootScope.isStaffWithoutUserManagementPermission()) {
				$scope.isStaffInvitePermission = false;
			} else {
				$scope.isStaffInvitePermission = true;
			}
		}

		getUser();

		$scope.approve = function () {
			$scope.approveButtonDisabled = true;

			usersService.put('school/v1/approve/' + schoolId + '/parent/' + $scope.id, { }, { 'xhr':true }).then(function (response) {
				getUser();
				$scope.approveButtonDisabled= false;
				//clean up the contacts cache
				storage.del('__c5', true);
			}, 
			function(error){
				$scope.approveButtonDisabled= false;
			})
		};

		$scope.disable = function () {
			usersService.put('school/v1/disable/' + schoolId + '/parent/' + $scope.id, { }, { 'xhr':true }).then(function (response) {
				$scope.user.access = false;
				//clean up the contacts cache
				storage.del('__c5', true);
			}, 
			function(error){
				toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
			})
		};

		$scope.enable = function () {
			usersService.put('school/v1/enable/' + schoolId + '/parent/' + $scope.id, { }, { 'xhr':true }).then(function (response) {
				$scope.user.access = true;
				//clean up the contacts cache
				storage.del('__c5', true);
			}, 
			function(error){
				toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
			})
		};

		$scope.deleteMember = function(id, name, isUser) {

			var modalInstance = $uibModal.open({
				animation: true,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/users/views/confirm-delete-parent.html',
				controller: function($scope) {
					$scope.viewState = {
						isReady:true
					};

					$scope.user = {
						name: name
					};

					$scope.close = function() {
						modalInstance.close();
					};
 
					$scope.delete = function() {
						$scope.viewState.isReady = false;

						usersService.delete('school/v1/delete/' + schoolId + '/schoolRep/' + id + '/' + (isUser ? 'user' : 'invite'), {'xhr':true}).then(function (response) {
							$scope.viewState.isReady = true;
							location.href = '/school/#/school/admins/';
							//clean up the contacts cache
							storage.del('__c5', true);
							modalInstance.close();
						}, 
						function(error) {
							if (error.status == 403) {
								toastr.error($translate.instant(error.data.error.message));
							}else{
								toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
							}
							
							$scope.viewState.isReady = true;
						});
					}
				},
				size: 'sm'
			});
		};
		$scope.updatePermission = function(value){
			$scope.user.userManagementPermission = value;
		}

		$scope.changeStaffPermission = function() {
			var user = $scope.user;
			var updateFnc = $scope.updatePermission;
			var modalInstance = $uibModal.open({
				animation: true,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/users/views/update-staff-permissions.html',
				controller: function($scope) {
					$scope.viewState = {
						isReady:true
					};
					$scope.hasUserManagementPermission = user.userManagementPermission;
					$scope.user = {
						id: user.id,
						name: user.name
					};

					$scope.close = function() {
						modalInstance.close();
					};
 
					$scope.changePermission = function() {
						$scope.viewState.isReady = false;
						var request = {userManagementPermission: $scope.hasUserManagementPermission}
						usersService.put('school/v1/update/' + schoolId + '/staff/' + user.id + '/permissions', request, { 'xhr':true }).then(function (response) {
							updateFnc($scope.hasUserManagementPermission);
							
							//clean up the contacts cache
							modalInstance.close();
						}, 
						function(error) {
							if (error.status == 403) {
								toastr.error($translate.instant(error.data.error.message));
							}else{
								toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
							}
							
							$scope.viewState.isReady = true;
						});
					}
				},
				size: 'md'
			});
		};

		$scope.editLabel = function(user) {
			var modalInstance = $uibModal.open({
				animation: true,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/users/views/add-label-modal.html',
				controller: function($scope) {
					$scope.hasSelected = false;

					$scope.viewState = {
						isReady:true
					};

					$scope.label = { 
						id: user.id,
						label: user.label
					};

					$scope.close = function() {
						modalInstance.close();
					};

					$scope.confirm = function () {
						$scope.viewState.isReady = false;

						usersService.put('school/v1/update/label', DTOS.Map($scope.label || { }, 'user_label'))
						.then(function(response) {
							modalInstance.close();
							user.label = $scope.label.label;
						}, 
						function(error) {
							toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
							$scope.viewState.isReady = true;
						});
					}
				},
				size: 'sm'
			});
		}

		$scope.changeMember = function(user) {

			var modalInstance = $uibModal.open({
				animation: true,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/users/views/change-admin-modal.html',
				controller: function($scope) {
					$scope.can_save = false;

					$scope.viewState = {
						isReady:true
					};

					$scope.getTiers = function (string) {
						return usersService.get('search/v1/tier/rolechange/'+schoolId+'/'+encodeURIComponent(string)
							,{})
						.then(function (response) {
							return response.data.resultList;
						}, 
						function (error) {

						})
					}

					$scope.user = {
						id: user.id,
						name: user.name
					};

					if(user.schoolReps) {
						if(user.schoolReps.length > 0) {
							$scope.user.role = user.schoolReps[0].role;
						}
					}

					$scope.$watch('user.role', function(value) {
				       if(value != 'CLASS_REP') {
							$scope.tier = null;
							$scope.can_save = true;
				       }
				       else {
				       		$scope.can_save = false;
				       }
					});

					$scope.pickTier = function (tier) {
						$scope.user.tierId = tier.id;
						$scope.user.role = 'CLASS_REP';
			       		$scope.can_save = true;
					}

					$scope.close = function() {
						modalInstance.close();
					};
 
					$scope.save = function() {
						if($scope.user.role == 'CLASS_REP') {
							if(!$scope.user.tierId) {
								return;
							}
						}

						$scope.viewState.isReady = false;

						usersService.put('school/v1/change/' + schoolId + '/role', $scope.user, { 'xhr':true }).then(function (response) {
							$scope.viewState.isReady = true;
							modalInstance.close();
							getUser();
						},
						function(error) {
							if (error.status == 403) {
								toastr.error($translate.instant(error.data.error.message));
							}
							else{
								toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
							}
							
							$scope.viewState.isReady = true;
						});
					}
				},
				size: 'md'
			});
		};

		if($location.search().inviteParents === 'true'){
			$scope.openAddNonMember();
		}

		$scope.back = function() {
			$rootScope.evaluateBack($stateParams.redirectPages);
		}
	}
		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}
	}

})();

(function() {
	'use strict';

	angular.module('modules.users.parentdetail',[]).controller('parentDetailController', parentDetailController);

	/** @ngInject */
	function parentDetailController(baseService, $scope, $window, $rootScope, usersService, metadata, $uibModal, toastr, $translate, $stateParams, $location, storage) {

		$scope.id = $stateParams.id;
		var relationships = [];
		$scope.parents = [];

		$scope.viewState = {
			isReady: false
		};

		baseService.app_initialized = function(evt, args) {
		$scope.nameRelation = function (_id) {
			return relationships[_id]
		};

		_.each(metadata.data.metadata.relationships, function (obj, index) {
			relationships[obj.id] = obj.longName;
		});

		var schoolId = $rootScope.active_school.id;
		$scope._user = $rootScope.active_user;
		$scope.role = $rootScope.active_user.role;
		$scope.integrationEnabled = $rootScope.active_school.integrationEnabled;

		function getParent() {
			$scope.viewState.isReady = false;

			usersService.get('school/v1/get/' + schoolId + '/parent/' + $scope.id, { 'cache':false }).then(function (response) {
				$scope.viewState.isReady = true;
				$scope.user = response.data;
			}, 
			function(error) {
				$scope.viewState.isReady = true;
			})
		}

		getParent();

		$scope.flatStructure = [];

		usersService.get('school/v1/getSchoolStructureCompact?schoolId='+$rootScope.active_school.id+'&includeEntireSchool=false', {'cache': true }).then(function (response) {
			$scope.schoolStructure = response.data.items;
			
			for (var i = 0; i < $scope.schoolStructure.length; i++) {
				var tier = $scope.schoolStructure[i];

				tier.hasClasses = tier.children && tier.children.length > 0;
				$scope.flatStructure.push(tier);

				if (!tier.children) {
					continue;
				}

				for (var j = 0; j < tier.children.length; j++) {
					var singleClass = tier.children[j];
					singleClass.hasClasses = false;
					singleClass.isClass = true;
					$scope.flatStructure.push(singleClass);
				}
			}
		}, 
		function (error) { });

		$scope.getTierFromId = function(id) {
			for (var i = 0; i < $scope.schoolStructure.length; i++) {
				var tier = $scope.schoolStructure[i];

				if(tier.id == id)
					return tier;

				if (!tier.children) {
					continue;
				}

				for (var j = 0; j < tier.children.length; j++) {
					if(tier.children[j].id == id)
						return tier.children[j];
				}
			}
		}

		$scope.approve = function (parent) {
			if($scope.approving)
				return;

			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/users/views/check-approve-modal.html',
				controller: function() {
					$scope.parent = $scope.user.waitingApproval;

					$scope.close = function() {
						modalInstance.close();
					};

					$scope.tierChange = function(pupil) {
						pupil.suggestion = false;
					}

					$scope.changeClass = function(pupil) {
						pupil.changeit = true;
					};

					$scope.confirm = function () {
						$scope.approving = true;
						
						var _pupils = []
						for(var i = 0; i < $scope.parent.pupils.length; i++) {
							_pupils.push({
								pupilId: $scope.parent.pupils[i].id,
								tierId: $scope.parent.pupils[i].tierId,
								suggestion: true
							})
						}
						
						usersService.put('school/v1/approve/parent', {
							schoolId: schoolId,
							userId: $scope.parent.id,
							pupils: _pupils

						}, {'xhr':true}).then(function (response) {
							$scope.approving = false;
							var status = response.data.payload.status;

							if (status === 'SUCCESS') {
								//clean up the contacts cache
								storage.del('__c5', true);
								toastr.info($translate.instant('APPROVAL_SUCCESS'));
							}
							if(status === 'ALREADY_APPROVED') {
								toastr.info($translate.instant('APPROVAL_ALREADY_APPROVED'));
							}	

							modalInstance.close();
							getParent();

						}, function(error) {
							$scope.approving = false;
							toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
							
						})
					}

				},
				size: 'md'
			});

			
		};

		$scope.disable = function () {

			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/users/views/confirm-disable-parent.html',
				controller: function($scope) {

					$scope.cancel = function() {
						modalInstance.close();
					};
 
					$scope.confirm = function() {
						$scope.disabling = true;
						usersService.put('school/v1/disable/' + schoolId + '/parent/' + $scope.id, { }, { 'xhr':true }).then(function (response) {
							$scope.disabling = false;
							$scope.user.access = false;
							modalInstance.close();
							//clean up the contacts cache
							storage.del('__c5', true);
						}, 
						function(error) {
							$scope.disabling = false;
							toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
						})
					}
				},
				size: 'sm'
			});
		};

		$scope.enable = function () {

			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/users/views/confirm-enable-parent.html',
				controller: function($scope) {

					$scope.cancel = function() {
						modalInstance.close();
					};
 
					$scope.confirm = function() {
						$scope.disabling = true;
						usersService.put('school/v1/enable/' + schoolId + '/parent/' + $scope.id, { }, { 'xhr':true }).then(function (response) {
							$scope.disabling = false;
							$scope.user.access = true;
							modalInstance.close();
							//clean up the contacts cache
							storage.del('__c5', true);
						}, 
						function(error){
							$scope.disabling = false;
							toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
						})
					}
				},
				size: 'sm'
			});
		};

		$scope.deleteMember = function(id, name, school) {

			var modalInstance = $uibModal.open({
				animation: true,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/users/views/confirm-delete-parent.html',
				controller: function($scope){
					$scope.viewState = {
						isReady:true
					};

					$scope.user = {
						name: name,
						school: school
					};

					$scope.close = function() {
						modalInstance.close();
					};
 
					$scope.delete = function() {
						$scope.viewState.isReady = false;

						usersService.delete('school/v1/delete/' + schoolId + '/parent/' + id, {'xhr':true}).then(function (response) {
							$scope.viewState.isReady = true;
							toastr.info($translate.instant('PARENT_DELETED'));
							location.href = '/school/#/users/manage-parents/';
							modalInstance.close();
						}, 
						function(error) {
							if (error.status == 403) {
								toastr.error($translate.instant(error.data.error.message));
							}else{
								toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
							}
							
							$scope.viewState.isReady = true;
						});
					}
				},
				size: 'sm'
			});
		};

		$scope.deleteParent = function(id, name, school, integrationEnabled) {

			var modalInstance = $uibModal.open({
				animation: true,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/users/views/confirm-delete-parent-v2.html',
				controller: function($scope){
					$scope.viewState = {
						isReady:true
					};

					$scope.user = {
						name: name,
						school: school,
						integrationEnabled: integrationEnabled
					};
					$scope.close = function() {
						modalInstance.close();
					};
 
					$scope.delete = function() {
						$scope.viewState.isReady = false;
						usersService.delete('school/v1/delete/' + schoolId + '/deactivated-parent/' + id, {'xhr':true}).then(function (response) {
							$scope.viewState.isReady = true;
							toastr.info($translate.instant('PARENT_DELETED'));
							location.href = '/school/#/users/manage-parents/';
							modalInstance.close();
						}, 
						function(error) {
							if (error.status == 403) {
								toastr.error($translate.instant(error.data.error.message));
							}else{
								toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
							}
							
							$scope.viewState.isReady = true;
						});
					}
				},
				size: 'sm'
			});
		};

		$scope.editLabel = function(object) {
			var modalInstance = $uibModal.open({
				animation: true,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/users/views/add-label-modal.html',
				controller: function($scope) {
					$scope.hasSelected = false;

					$scope.viewState = {
						isReady:true
					};

					$scope.label = { 
						id: object.id,
						label: object.label
					};

					$scope.close = function() {
						modalInstance.close();
					};

					$scope.confirm = function () {
						$scope.viewState.isReady = false;

						usersService.put('school/v1/update/label', DTOS.Map($scope.label || { }, 'user_label'))
						.then(function(response) {
							modalInstance.close();
							object.label = $scope.label.label;
						}, 
						function(error) {
							toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
							$scope.viewState.isReady = true;
						});
					}
				},
				size: 'sm'
			});
		}

		$scope.unassignRole = function(name, rep, roles) {
			var modalInstance = $uibModal.open({
				animation: true,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/users/views/confirm-unassign-role.html',
				controller: function($scope) {
					$scope.hasSelected = false;
					$scope.repType = rep.role;
					$scope.viewState = {
						isReady:true
					};

					$scope.user = { 
						name: name,
						tier: rep.tier
					};

					$scope.close = function() {
						modalInstance.close();
					};

					$scope.confirm = function () {
						$scope.viewState.isReady = false;
						usersService.delete('school/v1/delete/' + schoolId + '/schoolRep/' + rep.id + '/user', {'xhr':true}).then(function(response) {
							//virtual update
							if (roles){
								for(var i = 0; i <roles.length; i++) {
								    if(roles[i].id == rep.id) {
								       roles.splice(i, 1);
								    }
								}
							}
							modalInstance.close();
						}, 
						function(error) {
							toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
							$scope.viewState.isReady = true;
						});
					}
				},
				size: 'sm'
			});
		}

		$scope.changeMember = function(user, from) {

			var modalInstance = $uibModal.open({
				animation: true,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/users/views/change-admin-modal.html',
				controller: function($scope) {
					$scope.can_save = false;
					$scope.openedFrom = from;
					$scope.viewState = {
						isReady:true
					};

					$scope.getTiers = function (string) {
						return usersService.get('search/v1/tier/rolechange/'+schoolId+'/'+encodeURIComponent(string)
							,{})
						.then(function (response) {
							return response.data.resultList;
						}, 
						function (error) {

						})
					}

					$scope.user = {
						id: user.id,
						name: user.name
					};

					if(user.schoolReps) {
						if(user.schoolReps.length > 0) {
							$scope.user.role = user.schoolReps[0].role;
						}
					}

					$scope.$watch('user.role', function(value) {
				       if(value != 'CLASS_REP') {
							$scope.tier = null;
							$scope.can_save = true;
				       }
				       else {
				       		$scope.can_save = false;
				       }
					});

					$scope.pickTier = function (tier) {
						$scope.user.role = 'CLASS_REP';
						
						setTimeout(function() {
							$scope.user.tierId = tier.id;
				       		$scope.can_save = true;
				       		$scope.$apply();
						}, 1)
					}

					$scope.close = function() {
						modalInstance.close();
					};
 
					$scope.save = function() {
						if($scope.user.role == 'CLASS_REP') {
							if(!$scope.user.tierId) {
								return;
							}
						}

						$scope.viewState.isReady = false;

						usersService.put('school/v1/change/' + schoolId + '/role', $scope.user, { 'xhr':true }).then(function (response) {
							$scope.viewState.isReady = true;
							modalInstance.close();
							getParent();
						},
						function(error) {
							if (error.status == 400) {
								toastr.error($translate.instant(error.data.error.message));
							}
							else{
								toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
							}
							
							$scope.viewState.isReady = true;
						});
					}
				},
				size: 'md'
			});
		};

		$scope.deletePupils = function(id, name, index) {
			//we are not using the index

			var modalInstance = $uibModal.open({
				animation: true,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/users/views/confirm-delete-pupils.html',
				scope: $scope,
				controller: function($scope) {
					$scope.viewState = {
						isReady:true
					};

					$scope.user = {
						name: name,
						pupils: $scope.user.pupils
					};

					$scope.close = function() {
						modalInstance.close();
					};

					$scope.delete = function () {
						var pups = $scope.getSelectedPupils();

						usersService.put('school/v1/delete/pupils', { 'payload': { 'pupils': pups, 'schoolId': schoolId } }).then(function(response) {
							
							_.forEach($scope.user.pupils, function(r) {
								delete r.checked;
							});

							if (pups.length > 1) {								
								toastr.info($translate.instant('PUPILS_DELETED'));
							}
							else {
								toastr.info($translate.instant('PUPIL_DELETED'));
							}
							for (var i = 0; i < pups.length; i++) {
								for (var a = 0; a < $scope.user.pupils.length; a++) {
									if ($scope.user.pupils[a].id == pups[i]){
										$scope.user.pupils.splice(a, 1);
									}
								}
							}
							
							modalInstance.close();
						}, 
						function(error){
							toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
						});
					}

					$scope.getSelectedPupils = function() {
						var selectedPupils = [];

						for (var pupil in $scope.user.pupils) {
							if($scope.user.pupils[pupil].checked) {
								selectedPupils.push($scope.user.pupils[pupil].id);
							}
						}

						return selectedPupils.length > 0 ? selectedPupils : false;
					}
				},
				size: 'md'
			});
		};

		if($location.search().inviteParents === 'true'){
			$scope.openAddNonMember();
		}

		$scope.back = function(){
			//$rootScope.evaluateBack($stateParams.redirectPages);
			$window.history.back();
		}
	}
		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}
	}

})();

(function() {
	'use strict';

	angular.module('modules.users.nonparentdetail',[]).controller('nonParentDetailController', nonParentDetailController);

	/** @ngInject */
	function nonParentDetailController(baseService ,$scope, $rootScope, usersService, metadata, $uibModal, toastr, $translate, $stateParams, $location) {

		$scope.id = $stateParams.id;
		var relationships = [];
		$scope.parents = [];

		$scope.viewState = {
			isReady: false
		};

		baseService.app_initialized = function(evt, args) {

		$scope.nameRelation = function (_id) {
			return relationships[_id]
		};

		_.each(metadata.data.metadata.relationships, function (obj, index) {
			relationships[obj.id] = obj.longName;
		});

		var schoolId = $rootScope.active_school.id;

		function getParent() {
			$scope.viewState.isReady = false;

			usersService.get('school/v1/get/' + schoolId + '/nonmember/' + $scope.id, { 'cache':false }).then(function (response) {
				$scope.viewState.isReady = true;
				$scope.user = response.data;
			}, 
			function(error) {
				$scope.viewState.isReady = true;
			})
		}

		getParent();

		$scope.deleteNonMember = function(id) {
			usersService.delete('school/v1/nonMemberParent/' + schoolId + '/delete/' + id, { 'xhr':true }).then(function (response) {
				toastr.info($translate.instant('NON_MEMBER_DELETED'));
				location.href = '/school/#/users/manage-parents/';
			},
			function(error){
				toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
			})
		};

		function setDropdown() {
			$scope.hideDropdown = true;
		}

		$scope.openEdit = function(user) {
			$scope.hideDropdown = false;
			user._tier = { id: user.tierId, name: user.tier };

			var modalInstance = $uibModal.open({
				animation: true,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/users/views/add-nonmember-edit.html',
				controller: function($scope) {
					var lastNameLength, firstNameLength;
					$scope.user = user;
					$scope.id = user.id;
					$scope.tier = user._tier;
					$scope.email = user.mail;
					$scope.originalFirstName = user.firstName;
					$scope.originalLastName = user.lastName;

					if (user.firstName.includes('Invited')  && user.lastName.includes('Parent')) {
						$scope.firstName = '';
						$scope.lastName = '';
					}else {
						$scope.firstName = user.firstName;
						$scope.lastName = user.lastName;
					}

					$scope.close = function() {
						setDropdown();
						modalInstance.close();
					};

				    $scope.$watchGroup(['firstName.length','lastName'], function() {
				        checkFirstNameError();
				        checkLastNameError();
				        checkNamesError();			        
				    });

					function setNamesLength(){
						_.isUndefined($scope.lastName) ? lastNameLength = 0 : lastNameLength = $scope.lastName.length
						_.isUndefined($scope.firstName) ? firstNameLength = 0 : firstNameLength = $scope.firstName.length
					}

					function checkLastNameError(){
						setNamesLength()
						if (firstNameLength > 0  || lastNameLength === 0 && $scope.originalLastName.includes('Parent') ) {
							$scope.lastNameError = true;
						}else {
							$scope.lastNameError = false;
						}
					}

					function checkFirstNameError(){
						setNamesLength()
						if (lastNameLength > 0 || firstNameLength === 0 && $scope.originalFirstName.includes('Invited')) {
							$scope.firstNameError = true;
						}else {
							$scope.firstNameError = false;
						}
					}

					function checkNamesError(){
						setNamesLength();
						if ($scope.originalFirstName.includes('Invited') && $scope.originalLastName.includes('Parent')) {
							if (lastNameLength === 0 && firstNameLength === 0) {
								$scope.namesError = true;
							}else {
								$scope.namesError = false;
							}
						}else if (lastNameLength === 0 && firstNameLength === 0){
							$scope.namesError = true;
						}
					}

					$scope.save = function() {

						var payload = {
							'id': $scope.id,
							'tier':$scope.tier.id,
							'firstName': $scope.firstName,
							'lastName': $scope.lastName,
							'email' : $scope.email
						}

						if ($scope.firstName == '' && $scope.lastName == '') {
							payload.firstName = $scope.originalFirstName;
							payload.lastName = $scope.originalLastName;
						}
						usersService.put('school/v1/nonMemberParent/'+schoolId+'/update', payload,
						{'xhr':true})
						.then(function(response) {
							$scope.user.tierId = $scope.tier.id;
							$scope.user.tier = $scope.tier.name;
							getParent();

							$scope.close();
							toastr.info('Update successful');
							//$state.reload();
						}, 
						function(error){
							toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
						})
						setDropdown();
					}
				},
				size: 'sm'
			});
		}

		$scope.sendInvite = function(id) {
			usersService.get('school/v1/nonMemberParent/'+schoolId+'/invite/' + id, { }, {'xhr':true}).then(function (response) {
				toastr.info('Invitation sent to the non-member')
			}, 
			function(error){
				toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
			})
		};

		$scope.back = function(){
			$rootScope.evaluateBack($stateParams.redirectPages);
		}

		if($location.search().inviteParents === 'true'){
			$scope.openAddNonMember();
		}
	}
		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}
	}

})();

(function() {
	'use strict';

	angular.module('modules.users',[]).factory('usersService', ['base','$http', function (base, $http) {
		return _.create(base, { });
	}]).controller('usersController', usersController);

	/** @ngInject */
	function usersController(baseService, $scope, $rootScope, $location, $uibModal, usersService, toastr, $translate, $state, $http) {

		$scope.relationships = {};

		function getRelationships() { 
			$http.get('i8n/locale-metadata-en-GB.json?v=12').then(function(data) {
   				var rltnshps = data.data.metadata.relationships;
				for (var i = 0; i < rltnshps.length; i++) {
					$scope.relationships[rltnshps[i].id] = rltnshps[i].longName;
				}
			});
		}
		getRelationships();

		$scope.openAssignToAdmin = function(user){
			var modalInstance = $uibModal.open({
				animation: true,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/users/views/assign-parent-admin-modal.html',
				controller: function($scope){
					$scope.user = user;
					$scope.role = '';
					$scope.tier = {
						id:''
					};
					$scope.viewState = {
						isReady:true
					};
					$scope.$watch('role', function(){
						$scope.tier = {
							id:''
						}
					})
					$scope.close = function(){
						modalInstance.close();
					};

					$scope.save = function(){
						$scope.viewState.isReady = false;
						usersService.post('school/v1/assignSchoolRepProfile',{
							'schoolId':$rootScope.active_school.id,
							'tierId':$scope.tier.id || '',
							'userId':user.id,
							'role':$scope.role
						},{'xhr':true}).then(function(response){
							$scope.viewState.isReady = true;
							$scope.close();
							toastr.info('Update successful');
							$rootScope.$broadcast('UPDATE_USER_LIST');
							user.role = $scope.role;
						}, function(error){
							toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
							$scope.viewState.isReady = true;
						})
					}
				},
				size: 'sm'
			});
		}
	}

})();

(function () {
	'use strict';

	angular.module('modules.users.manageparents', []).controller('parentManageController', parentManageController);

	/** @ngInject */
	function parentManageController(baseService, $scope, $rootScope, usersService, $uibModal, toastr, $stateParams, $translate, $location) {
		if ($stateParams.search)
			$scope.keyword = $stateParams.search;

		$scope.parents = [];
		$scope.viewState = {
			isReady: false
		};
		$scope.selectedFilter = {};

		baseService.app_initialized = function (evt, args) {
			if($rootScope.isStaffWithoutUserManagementPermission()){
				$rootScope.showStaffWithoutUserManagementPermissionErrorMessage();
				window.location.href = '/school/#/dashboard/view';
				return;
			}
			var schoolId = $rootScope.active_school.id;
			var latestParam = $rootScope.getQueryParam("latest");
			if (latestParam === "true") {
				window.localStorage.setItem('parentFilterID', -3);
			}
			function getParents() {
				if ($scope.parents.length === 0) {
					$scope.viewState.isReady = false;
				}
				usersService.get('school/v1/get/' + schoolId + '/parents', {
					'cache': false
				}).then(function (response) {
					$scope.viewState.isReady = true;
					$scope.parents = DTOS.Map(response.data.items || [], 'parents');
				},
					function (error) {
						$scope.viewState.isReady = true;
					})
			}

			/*
			 * This function is responsible from getting the results for 
			 * the id of the filter passed as a parameter and
			 * updating the list.
			 */
			function callFilterEndpointAndUpdateParents(filterId) {
				if($scope.keyword && $scope.keyword.length >= 3){
					if(!filterId){
						filterId = -1;
					}
					usersService.get('school/v1/get/' + schoolId + '/parents/' + filterId + '/filter/' + $scope.keyword, {}, {
						'xhr': true
					}).then(function (response) {
						if (response && response.data && response.data.items && response.data.items.length > 0) {
							$scope.parents = DTOS.Map(response.data.items || [], 'parents');
						} else {
							// No parent found, make the list empty.
							$scope.parents = null;
						}
					},
						function (error) {
							if (error.data.error.code == 400) {
								$scope.errorMessage = error.data.error.message;
							} else {
								toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
							}
						});
				}else if ($scope.latestFilterId !== filterId){
					if(!filterId){
						filterId = -1;
					}
					$scope.latestFilterId = filterId;
					usersService.get('school/v1/get/' + schoolId + '/parents/' + filterId, {}, {
						'xhr': true
					}).then(function (response) {
						if (response && response.data && response.data.items && response.data.items.length > 0) {
							$scope.parents = DTOS.Map(response.data.items || [], 'parents');
						} else {
							// No parent found, make the list empty.
							$scope.parents = null;
						}
						$scope.allParents = $scope.parents;
					},
						function (error) {
							if (error.data.error.code == 400) {
								$scope.errorMessage = error.data.error.message;
							} else {
								toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
							}
						});
				}else{
					$scope.parents = $scope.allParents;
				}
			}
			$scope.openInfo = function (e, type) {
				if (e) {
					e.stopImmediatePropagation();
					e.stopPropagation();
				}
	
				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/info_modals/info-modal-19.html',
					controller: function ($scope) {
	
						$scope.close = function () {
							modalInstance.close();
						};
					},
					size: 'sm'
				});
			}
			// Invoked from ClassPicker directive, when user selects an filter in markdown
			$scope.$on('FILTER_ADDED', function (evt, args) {
				$scope.selectedFilter = args;
				window.localStorage.setItem('parentFilterID', $scope.selectedFilter.id);
				$scope.keyword = ''
				callFilterEndpointAndUpdateParents($scope.selectedFilter.id);
			})
			$scope.$watch('keyword', function(newValue, oldValue) {
				if (newValue !== oldValue) {
					callFilterEndpointAndUpdateParents($scope.selectedFilter.id);
				}
			});
			// Invoked from ClassPicker directive, when user has filter saved in local storage.
			$scope.$on('FILTER_FROM_STORAGE', function (evt, args) {
				$scope.selectedFilter = {id:args};
				callFilterEndpointAndUpdateParents(args);
			})

			$scope.gotoDetail = function (p) {
				if (p.status == 'nonmember')
					location.href = '/school/#/users/non-member-detail/' + p.id;
				else
					location.href = '/school/#/users/parent-detail/' + p.id;
			};

			$scope.sendInvite = function (id) {
				usersService.get('school/v1/nonMemberParent/invite/' + id, {}, {
					'xhr': true
				}).then(function (response) {
					toastr.info('Invitation sent to the non-member')
				}, function (error) {
					toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
				})
			};

			if ($location.search().inviteParents === 'true') {
				$scope.openAddNonMember();
			}
		}
		if ($rootScope.active_school && $rootScope.app_base_ready) {
			baseService.app_initialized();
		}
	}

})();

(function() {
	'use strict';

	angular.module('modules.users.approveparents',[]).controller('approveParentsController', approveParentsController);

	/** @ngInject */
	function approveParentsController(baseService, $scope, $rootScope, usersService, $uibModal, toastr, $translate, storage) {

		$scope.parents = [];
		$scope.recentlyApproved = [];
		$scope.noParents = false;
		$scope.viewState = {
			isReady:true
		};
		$scope.pendingRequest = false;
		
		baseService.app_initialized = function(evt, args) {
		if($rootScope.integrationEnabled()){
			window.location.href = '#/users/manage-parents/';
			return;
		}
		if($rootScope.isStaffWithoutUserManagementPermission()){
			$rootScope.showStaffWithoutUserManagementPermissionErrorMessage();
			window.location.href = '/school/#/dashboard/view';
			return;
		}
		$scope.user = $rootScope.active_user;
		var schoolId = $rootScope.active_school.id;

		$scope.accordionParent = {};
		$scope.accordionRecentlyApproved = {}
		
		function setParentAccordion(){
			for (var parent in $scope.parents){
				$scope.accordionParent[parent] = {
					open:  false
				}
			}
			
		}

		function setRecentlyApprovedAccordion(){
			for (var parent in $scope.recentlyApproved){
				$scope.accordionRecentlyApproved[parent] = {
					open:  false
				}
			}
			
		}

		function getParents(){
			$scope.viewState.isReady = false;
			usersService.get('school/v1/get/' + schoolId + '/parents/pendingApproval',{'cache':false}).then(function (response) {
				$scope.viewState.isReady = true;
				$scope.parents = response.data.parents || [];
				$scope.recentlyApproved = response.data.recentlyApproved || [];
				setParentAccordion();
				setRecentlyApprovedAccordion();
				if($scope.parents.length === 0) {
					$scope.noParents = true;
				}
			}, function(error){
				toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
				$scope.viewState.isReady = true;
			})
		}

		getParents();

		$scope.flatStructure = [];

		usersService.get('school/v1/getSchoolStructureCompact?schoolId='+$rootScope.active_school.id+'&includeEntireSchool=false', {'cache': true }).then(function (response) {
			$scope.schoolStructure = response.data.items;
			
			for (var i = 0; i < $scope.schoolStructure.length; i++) {
				var tier = $scope.schoolStructure[i];

				tier.hasClasses = tier.children && tier.children.length > 0;
				$scope.flatStructure.push(tier);

				if (!tier.children) {
					continue;
				}

				for (var j = 0; j < tier.children.length; j++) {
					var singleClass = tier.children[j];
					singleClass.hasClasses = false;
					singleClass.isClass = true;
					$scope.flatStructure.push(singleClass);
				}
			}
		}, 
		function (error) { });

		$scope.getTierFromId = function(id) {
			for (var i = 0; i < $scope.schoolStructure.length; i++) {
				var tier = $scope.schoolStructure[i];

				if(tier.id == id)
					return tier;

				if (!tier.children) {
					continue;
				}

				for (var j = 0; j < tier.children.length; j++) {
					if(tier.children[j].id == id)
						return tier.children[j];
				}
			}
		}

		$scope.approve = function (parent) {
			if($scope.pendingRequest)
				return;

			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/users/views/check-approve-modal.html',
				controller: function() {
					$scope.parent = parent;

					$scope.close = function() {
						modalInstance.close();
					};

					$scope.tierChange = function(pupil) {
						pupil.suggestion = false;
					}

					$scope.changeClass = function(pupil) {
						pupil.changeit = true;
					};

					$scope.confirm = function () {
						$scope.pendingRequest = true;
						
						var _pupils = []
						for(var i = 0; i < $scope.parent.pupils.length; i++) {
							_pupils.push({
								pupilId: $scope.parent.pupils[i].id,
								tierId: $scope.parent.pupils[i].tierId,
								suggestion: true
							})
						}
						
						usersService.put('school/v1/approve/parent', {
							schoolId: schoolId,
							userId: $scope.parent.id,
							pupils: _pupils

						}, {'xhr':true}).then(function (response) {
							$scope.pendingRequest = false;
							var status = response.data.payload.status;
							//clean up the contacts cache
							storage.del('__c5', true);

							if (status === 'SUCCESS') {
								toastr.info($translate.instant('APPROVAL_SUCCESS'));
							}
							if(status === 'ALREADY_APPROVED') {
								toastr.info($translate.instant('APPROVAL_ALREADY_APPROVED'));
							}	

							modalInstance.close();
							getParents();

						}, function(error) {
							$scope.pendingRequest = false;
							toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
							
						})
					}

				},
				size: 'md'
			});

			
		};

		$scope.deleteApplicantParent = function(id, name, surName){

			var modalInstance = $uibModal.open({
				animation: true,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/users/views/confirm-delete-parent.html',
				controller: function($scope){
					$scope.viewState = {
						isReady:true
					};

					$scope.user = {
						name:name + ' ' + surName
					};

					$scope.close = function(){
						modalInstance.close();
					};

					$scope.delete = function () {
						usersService.delete('school/v1/delete/'+schoolId+'/parent/'+id, {'xhr':true}).then(function (response) {
							toastr.info($translate.instant('PARENT_DELETED'));
							getParents();
							modalInstance.close();
						}, function(error){
							toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
						});
					}

				},
				size: 'sm'
			});

		};

		$scope.makeAdmin = function(user, from) {

			var modalInstance = $uibModal.open({
				animation: true,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/users/views/change-admin-modal.html',
				controller: function($scope) {
					$scope.can_save = false;
					$scope.openedFrom = from;
					$scope.viewState = {
						isReady:true
					};

					$scope.getTiers = function (string) {
						return usersService.get('search/v1/tier/rolechange/'+schoolId+'/'+encodeURIComponent(string)
							,{})
						.then(function (response) {
							return response.data.resultList;
						}, 
						function (error) {

						})
					}

					$scope.user = {
						id: user.id,
						name: user.firstName + ' ' + user.lastName
					};

					if(user.schoolReps) {
						if(user.schoolReps.length > 0) {
							$scope.user.role = user.schoolReps[0].role;
						}
					}

					$scope.$watch('user.role', function(value) {
				       if(value != 'CLASS_REP') {
							$scope.tier = null;
							$scope.can_save = true;
				       }
				       else {
				       		$scope.can_save = false;
				       }
					});

					$scope.pickTier = function (tier) {
						$scope.user.role = 'CLASS_REP';
						
						setTimeout(function() {
							$scope.user.tierId = tier.id;
				       		$scope.can_save = true;
				       		$scope.$apply();
						}, 1)
					}

					$scope.close = function() {
						modalInstance.close();
					};
 
					$scope.save = function() {
						if($scope.user.role == 'CLASS_REP') {
							if(!$scope.user.tierId) {
								return;
							}
						}

						$scope.viewState.isReady = false;

						usersService.put('school/v1/change/' + schoolId + '/role', $scope.user, { 'xhr':true }).then(function (response) {
							$scope.viewState.isReady = true;
							modalInstance.close();
							getParent();
						},
						function(error) {
							if (error.status == 403) {
								toastr.error($translate.instant(error.data.error.message));
							}
							else{
								toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
							}
							
							$scope.viewState.isReady = true;
						});
					}
				},
				size: 'md'
			});
		};

		$scope.deletePupils = function(id, name, surName, pupils){

			var modalInstance = $uibModal.open({
				animation: true,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/users/views/confirm-delete-pupils.html',
				scope: $scope,
				controller: function($scope){
					$scope.viewState = {
						isReady:true
					};

					$scope.user = {
						name: name + ' ' + surName,
						pupils: pupils
					};

					$scope.close = function(){
						modalInstance.close();
					};

					$scope.delete = function () {
						var pups = $scope.getSelectedPupils();


						usersService.put('school/v1/delete/pupils',{'payload':{'pupils': pups, 'schoolId': schoolId}}).then(function(response){
							//clear pupil model
							_.forEach($scope.user.pupils, function(r){
								delete r.checked;
							});

							if (pups.length > 1) {								
								toastr.info($translate.instant('PUPILS_DELETED'));
							}else{
								toastr.info($translate.instant('PUPIL_DELETED'));
							}

							var parentIndex = _.findIndex($scope.$parent.recentlyApproved, function(parent) { return parent.id == id });

							for (var i = 0; i < pups.length; i++) {
								var pupilIndex = _.findIndex($scope.$parent.recentlyApproved[parentIndex].pupils, function(pupil) { return pupil.id == pups[i] })
								$scope.$parent.recentlyApproved[parentIndex].pupils.splice(pupilIndex, 1);
							}

							modalInstance.close();
						}, function(error){
							toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
						});
					}

					$scope.getSelectedPupils = function() {
						var selectedPupils = [];

						for (var pupil in $scope.user.pupils) {
							if($scope.user.pupils[pupil].checked) {
								selectedPupils.push($scope.user.pupils[pupil].id);
							}
						}

						return selectedPupils.length > 0 ? selectedPupils : false;
					}

				},
				size: 'md'
			});

		};
	}
		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}
	}

})();

(function () {
	'use strict';

	angular.module('modules.schoolpage', [])
		.factory('schoolPageService', ['base', '$http', function (base, $http) {
			return _.create(base, {});
		}])
		.controller('schoolPageController', schoolPageController);

	/** @ngInject */
	function schoolPageController(baseService, $scope, $window, storage, settings, $rootScope, $location, $stateParams, $uibModal, schoolPageService, toastr, $translate, $state, $http) {
		var getSchool;
		$scope.newlink = {};
		$scope.viewState = {
			isReady: false
		};
		$scope.availableCurrencies = [];
		$scope.selectedCurrency = {
			text: "",
		};
		$scope.validateLink = validateLink;

		$scope.toggleWholeSchoolPost = function (e) {

			if ($scope.enablingWSP)
				return;

			$scope.enablingWSP = true;

			schoolPageService.post('school/v1/update/' + $scope.id_school + '/setting', {
					wholeSchoolPostEnabled: $scope._school.settings.wholeSchoolPostEnabled,
					autoApproveEnabled: $scope._school.settings.autoApproveEnabled,
					dailyDigestEnabled: $scope._school.settings.dailyDigestEnabled
				})
				.then(function (response) {
						$scope.enablingWSP = false;
						$scope.$apply()

						if ($scope._school.settings.wholeSchoolPostEnabled)
							$rootScope.userTag('WHOLE_SCHOOL_POST_ON')
						else
							$rootScope.userTag('WHOLE_SCHOOL_POST_OFF')
					},
					function (error) {
						$scope.enablingWSP = false;
						if (error.status != 401)
							toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
					})
		}

		$scope.toggleDailyDigest = function (e) {

			if ($scope.enablingWSP)
				return;

			$scope.enablingWSP = true;

			schoolPageService.post('school/v1/update/' + $scope.id_school + '/setting', {
					wholeSchoolPostEnabled: $scope._school.settings.wholeSchoolPostEnabled,
					autoApproveEnabled: $scope._school.settings.autoApproveEnabled,
					dailyDigestEnabled: $scope._school.settings.dailyDigestEnabled
				})
				.then(function (response) {
						$scope.enablingWSP = false;
						$scope.$apply()
					},
					function (error) {
						$scope.enablingWSP = false;
						if (error.status != 401)
							toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
					})
		}

		$scope.toggleRaffle = function (e) {

			if ($scope.enablingRaffle)
				return;

			$scope.enablingRaffle = true;

			schoolPageService.post('school/v1/update/' + $scope.id_school + '/setting', {
					raffleEnabled: $scope._school.settings.raffleEnabled
				})
				.then(function (response) {
						$scope.enablingRaffle = false;
						$rootScope.refreshContext($rootScope.active_school.id);
						$scope.$apply()
					},
					function (error) {
						$scope.enablingRaffle = false;
						if (error.status != 401)
							toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
					})
		}

		//FIXME REDIRECT
		$scope.redirectToStripe = function (type) {
			var url = settings.conf.api.replace('https', 'http');
			window.location.href = url + "/onboardstripesellerto?nd=true&too=school&t=" + storage.getToken() + "&sid=" + $scope.id_school + (type ? "&type=" + type : "");
		};

		$scope.getStripe = function () {
			$rootScope.userTag('SCHOOL_SIDE_MKP_INITIATED_STRIPE');
			$scope.redirectToStripe('signup');
		}

		baseService.app_initialized = function (evt, args) {

			$scope.id_school = $rootScope.active_school.id;
			var id_school = $scope.id_school;

			$http.get('i8n/locale-metadata-en-GB.json?v=12').then(function (data) {
				$scope.countries = data.data.metadata.countries;
			});

			if ($rootScope.active_user.role == "AMBASSADOR" || $rootScope.active_user.role == "STAFF") {
				$scope.editableSchool = true;
				$scope.editableComm = true;
			}

			if ($rootScope.active_user.role == "AMBASSADOR")
				$scope.welcomeMessageEnabled = true;

			$scope.getSchool = getSchool = function () {
				$scope.viewState.isReady = false;

				schoolPageService.get('school/v1/get/' + $scope.id_school + '/details', {
					'xhr': true,
					cache: false
				}).then(function (response) {
						$scope.viewState.isReady = true;
						$scope._school = DTOS.Map(response.data.payload || {}, 'school');
						$scope.isThereASampleContent = response.data.payload.sample;
						$scope._school.cover = $scope._school.cover + "?vi=" + new Date().getTime();
						// $scope._school.logo = $scope._school.logo + "?vi=" + new Date().getTime();
						// $rootScope.active_school.avatar = $scope._school.logo + '?v=' + new Date().getTime();
						if($scope._school.currency){
								$scope.selectedCurrency.text = $scope._school.currency;
						}
					},
					function (error) {
						if (error.status != 401)
							toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
					})
			}

			$scope.getReps = function (type) {
				schoolPageService.get('school/v1/get/' + $scope.id_school + '/reps/classes', {
					'xhr': true,
					cache: false
				}).then(function (response) {
						$scope.reps_list = response.data.items;
						var lockedItems = [];
						$scope.reps_list = $scope.reps_list.filter(function(item) {
							if (item && item.locked === true) {
								// if has reps
								if(item.reps && item.reps.length > 0){
									lockedItems.push(item);
								}
								return false;  
							}
							return true;  
						});
						// add locked unassigned class to bottom
						$scope.reps_list = $scope.reps_list.concat(lockedItems);

						// scroll to unassigned reps
						if(lockedItems.length > 0){
							setTimeout(function () {
								$scope.checkHash();
							}, 1000);
						}
					},
					function (error) {
						if (error.status != 401)
							toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
					})
			}
			$scope.openUnassignedGroupInfo = function (e, type) {
				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/info_modals/info-modal-16.html',
					controller: function ($scope) {
	
						$scope.close = function () {
							modalInstance.close();
						};
					},
					size: 'sm'
				});
			}
			$scope.checkHash = function() {
				var hash = $location.hash();
				
				if (hash === 'unassigned') {
				  var element = document.getElementById('unassigned');
				  if (element) {
					element.scrollIntoView({ behavior: 'smooth', block: 'start' });
				  }
				}
			  };
			$scope.addClassRep = function (object) {
				var s = $scope;

				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/schoolpage/views/add-classrep-modal.html',
					controller: function ($scope) {
						$scope.hasSelected = false;

						$scope.viewState = {
							isReady: true
						};

						$scope.id_school = id_school;
						$scope.parent = {};

						$scope.$on('ADD_AMBA_PARENT', function (evt, args) {
							$scope.hasSelected = true;
							$scope.parent.id = args.id;
						})

						$scope.close = function () {
							modalInstance.close();
						};

						$scope.confirm = function () {
							$scope.viewState.isReady = false;

							schoolPageService.post('school/v1/create/' + id_school + '/tierRep/' + object.id + '/' + $scope.parent.id, {
									label: $scope.parent.label
								})
								.then(function (response) {
										modalInstance.close();
										s.getReps($stateParams.type);
									},
									function (error) {
										if (error.data.error.code == 403)
											toastr.error($translate.instant(error.data.error.message));
										else
											toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));

										$scope.viewState.isReady = true;
									});
						}
					},
					size: 'sm'
				});
			}

			$scope.insertLink = function () {
				schoolPageService.post('school/v1/update/' + $scope.id_school + '/add/link', {
					'payload': $scope.newlink
				}).then(function (response) {

						if (!$scope._school.links)
							$scope._school.links = new Array();

						$scope._school.links.push({
							id: response.data.payload.id,
							text: $scope.newlink.text,
							href: $scope.newlink.href
						});

						$scope.newlink = {};
						$scope.showHelpfulLinkMessage = true;
					},
					function (error) {
						toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
						$scope.viewState.isReady = true;
					});
			}

			$scope.cleanSampleContents = function () {
				schoolPageService.get('school/v1/update/' + $scope.id_school + '/remove/sampleContent').then(function (response) {
						toastr.info($translate.instant('SAMPLE_CONTENT_CLEANUP_INPROGRESS'));
						$scope.isThereASampleContent = false;
					},
					function (error) {
						toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
						$scope.viewState.isReady = true;
					});
			}

			$scope.addLink = function () {
				$scope.linkPopup();
			}

			$scope.editLink = function (object, index) {
				$scope.linkPopup(object, index);
			}

			$scope.editStructure = function () {
				location.href = $rootScope.integrationEnabled() ? "/school/#/school/integration-structure" :'/school/#/school/structure';
			}

			$scope.openYearReps = function () {
				location.href = '/school/#/school/details/years';
			}

			$scope.openClassReps = function () {
				location.href = '/school/#/school/details/classes';
			}

			$scope.openUser = function (object, isStaff) {
				if (object.id != -1) {
					if (isStaff)
						location.href = '/school/#/users/staff-detail/' + object.id;
					else
						location.href = '/school/#/users/parent-detail/' + object.id;
				}
			}

			$scope.uploadCover = function () {

				$scope.$broadcast('UPLOAD_PHOTO', {
					'callback_fn': function (response) {
						getSchool();
					},
					'action': 'coverUpload',
					'config': 'coverCropper'
				});
			}

			$scope.uploadLogo = function () {

				$scope.$broadcast('UPLOAD_PHOTO', {
					'callback_fn': function (response) {
						getSchool();
					},
					'action': 'logoUpload',
					'config': 'logoCropper'
				});
			}

			$scope.editHelp = function (object) {
				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/schoolpage/views/help-modal.html',
					controller: function ($scope) {
						$scope.summernoteOptions = {
							minHeight: 300,
							toolbar: [
								['style', ['style']],
								['font', ['bold', 'underline', 'clear']],
								['color', ['color']],
								['para', ['ul', 'ol']],
								['insert', ['link']]
							]
						}

						$scope.viewState = {
							isReady: true
						};

						$scope.help = {
							canSave: false
						};

						$scope.help.helpTitle = object.helpTitle;
						$scope.help.helpDescription = object.helpDescription;
			

						if ($scope.help.helpTitle && $scope.help.helpDescription)
							$scope.help.canSave = true;

						$scope.onDescrKeyup = function () {
							var a = document.getElementById("textEditArea").innerHTML;
							if (a)
								$scope.help.canSave = true;
							else
								$scope.help.canSave = false;

							setTimeout(function () {
								$scope.$apply();
							}, 1)
						}

						$scope.close = function () {
							modalInstance.close();
						};

						$scope.confirm = function () {
							$scope.viewState.isReady = false;

							schoolPageService.post('school/v1/update/' + id_school + '/help', {
								'payload': $scope.help
							}).then(function (response) {
									object.helpTitle = $scope.help.helpTitle;
									object.helpDescription = $scope.help.helpDescription;
									modalInstance.close();
								},
								function (error) {
									toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
									$scope.viewState.isReady = true;
								});
						}
					},
					size: 'md'
				});
			}

			$scope.editPersonalMessage = function (object) {
				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/schoolpage/views/welcome-message-modal.html',
					controller: function ($scope) {
						$scope.summernoteOptions = {
							minHeight: 300,
							toolbar: [
								['style', ['style']],
								['font', ['bold', 'underline', 'clear']],
								['color', ['color']],
								['para', ['ul', 'ol']],
								['insert', ['link']]
							]
						}

						$scope.viewState = {
							isReady: true
						};


						$scope.message = {
							canSave: false
						}
						$scope.message.body = object.ambassadorMessage;
						if ($scope.message.body)
							$scope.message.canSave = true;

						$scope.onDescrKeyup = function () {
							var a = document.getElementById("textEditArea").innerHTML;
							if (a)
								$scope.message.canSave = true;
							else
								$scope.message.canSave = false;

							setTimeout(function () {
								$scope.$apply();
							}, 1)
						}

						$scope.close = function () {
							modalInstance.close();
						};

						$scope.confirm = function () {
							$scope.viewState.isReady = false;
							$scope.reqObject = {
								ambassadorMessage: $scope.message.body
							}

							schoolPageService.post('school/v1/update/' + id_school + '/ambassadorMessage', {
								'payload': $scope.reqObject
							}).then(function (response) {
									object.ambassadorMessage = $scope.message.body;
									getSchool();
									modalInstance.close();
								},
								function (error) {
									toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
									$scope.viewState.isReady = true;
								});
						}
					},
					size: 'md'
				});
			}

			$scope.editDetails = function (object) {
				var _countries = $scope.countries;

				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/schoolpage/views/details-modal.html',
					controller: function ($scope) {
						$scope.countries = _countries;
						$scope.viewState = {
							isReady: true
						};

						$scope.school = {};

						$scope.getCountryName = function (id) {
							if (id)
								return _.find($scope.countries, {
									'id': id
								}).longName;
							else
								return '';
						}

						setTimeout(function () {
							if (object) {
								$scope.school.streetAddress = object.address;
								$scope.school.countryId = object.countryId;
								$scope.school.postCode = object.postCode;
								$scope.school.city = object.city;
								$scope.school.phoneNumber = object.phoneNumber;
								$scope.school.pupilCount = object.pupilCount;
								$scope.school.email = object.email;
								$scope.school.stateCounty = object.stateCounty;
								$scope.school.logo = object.logo;
								$scope.school.name = object.name;
							}
							$scope.$apply();
						}, 10)

						$scope.close = function () {
							modalInstance.close();
						};

						$scope.confirm = function () {
							$scope.viewState.isReady = false;

							schoolPageService.post('school/v1/update/' + id_school + '/contact', {
								payload: $scope.school
							}).then(function (response) {
									modalInstance.close();
									getSchool();
								},
								function (error) {
									toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
									$scope.viewState.isReady = true;
								});
						}
					},
					size: 'md'
				});
			}

			$scope.editParentCount = function (object) {

				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/schoolpage/views/parents-count-modal.html',
					controller: function ($scope) {
						$scope.viewState = {
							isReady: true
						};

						$scope.school = {
							parentCount: object.parentCount
						};

						$scope.close = function () {
							modalInstance.close();
						};

						$scope.confirm = function () {
							$scope.viewState.isReady = false;

							schoolPageService.post('school/v1/update/' + id_school + '/size', {
								'payload': {
									'schoolSize': $scope.school.parentCount
								}
							}).then(function (response) {
									object.parentCount = $scope.school.parentCount;
									modalInstance.close();
								},
								function (error) {
									toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
									$scope.viewState.isReady = true;
								});
						}
					},
					size: 'sm'
				});
			}

			getSchool();
			getAndSetAvailableCurrencies();
			$scope.getReps();

			$scope.linkPopup = function (object, index) {
				var s = $scope._school;

				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/schoolpage/views/link-modal.html',
					controller: function ($scope) {
						$scope.viewState = {
							isReady: true
						};

						$scope.link = {};

						if (object) {
							$scope.link.id = object.id;
							$scope.link.text = object.text;
							$scope.link.href = object.href;
						}

						$scope.close = function () {
							modalInstance.close();
						};

						$scope.delete = function () {
							$scope.viewState.isReady = false;

							schoolPageService.get('school/v1/update/' + id_school + '/remove/link/' + object.id, {}).then(function (response) {
									s.links.splice(index, 1);
									modalInstance.close();
								},
								function (error) {
									toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
									$scope.viewState.isReady = true;
								});
						};

						$scope.confirm = function () {
							$scope.viewState.isReady = false;

							schoolPageService.post('school/v1/update/' + id_school + '/add/link', {
								'payload': $scope.link
							}).then(function (response) {

									if (!s.links)
										s.links = new Array();

									if (!object) {
										s.links.push({
											id: response.data.payload.id,
											text: $scope.link.text,
											href: $scope.link.href
										});
									} else {
										object.text = $scope.link.text;
										object.href = $scope.link.href;
									}

									modalInstance.close();
								},
								function (error) {
									toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
									$scope.viewState.isReady = true;
								});
						}
					},
					size: 'sm'
				});
			}

			$scope.editName = function (object) {
				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/schoolpage/views/name-modal.html',
					controller: function ($scope) {
						$scope.viewState = {
							isReady: true
						};

						$scope.school = {
							schoolName: object.name,
							schoolAbout: object.descr
						};

						$scope.close = function () {
							modalInstance.close();
						};

						$scope.confirm = function () {
							$scope.viewState.isReady = false;

							schoolPageService.post('school/v1/update/' + id_school + '/about', {
								'payload': $scope.school
							}).then(function (response) {
									object.name = $scope.school.schoolName;
									object.descr = $scope.school.schoolAbout;
									$rootScope.active_school.name = $scope.school.schoolName;
									modalInstance.close();
								},
								function (error) {
									toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
									$scope.viewState.isReady = true;
								});
						}
					},
					size: 'md'
				});
			}

			$scope.addAmbasador = function () {

				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/schoolpage/views/add-amba-modal.html',
					controller: function ($scope) {
						$scope.hasSelected = false;

						$scope.viewState = {
							isReady: true
						};

						$scope.ambassador = {};
						$scope.id_school = id_school;

						$scope.$on('ADD_AMBA_PARENT', function (evt, args) {
							$scope.hasSelected = true;
							$scope.ambassador.id = args.id;
						})

						$scope.close = function () {
							modalInstance.close();
						};

						$scope.confirm = function () {
							$scope.viewState.isReady = false;

							schoolPageService.post('school/v1/create/' + id_school + '/ambassador/' + $scope.ambassador.id, {
									label: $scope.ambassador.label
								})
								.then(function (response) {
										modalInstance.close();
										getSchool();
									},
									function (error) {
										if (error.data.error.code == 403)
											toastr.error($translate.instant(error.data.error.message));
										else
											toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));

										$scope.viewState.isReady = true;
									});
						}
					},
					size: 'sm'
				});
			}

			$scope.addCommunity = function () {

				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/schoolpage/views/add-community-modal.html',
					controller: function ($scope) {
						$scope.hasSelected = false;

						$scope.viewState = {
							isReady: true
						};

						$scope.parent = {};
						$scope.id_school = id_school;

						$scope.$on('ADD_AMBA_PARENT', function (evt, args) {
							$scope.hasSelected = true;
							$scope.parent.id = args.id;
						})

						$scope.close = function () {
							modalInstance.close();
						};

						$scope.confirm = function () {
							$scope.viewState.isReady = false;

							schoolPageService.post('school/v1/create/' + id_school + '/communityRep/' + $scope.parent.id, {
									label: $scope.parent.label
								})
								.then(function (response) {
										modalInstance.close();
										getSchool();
									},
									function (error) {
										if (error.data.error.code == 403)
											toastr.error($translate.instant(error.data.error.message));
										else
											toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));

										$scope.viewState.isReady = true;
									});
						}
					},
					size: 'sm'
				});
			}
			
			function getAndSetAvailableCurrencies(){
				schoolPageService.get('shared/v1/list/currencies/' + $rootScope.active_school.id, {'cache':false})
				.then(function(response) {
					$scope.availableCurrencies = response.data.items;
				});			
			}

			$scope.addStaff = function (object) {

				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/schoolpage/views/invite-staff-modal.html',
					controller: function ($scope) {
						$scope.viewState = {
							isReady: true
						};

						$scope.staff = {};

						$scope.close = function () {
							modalInstance.close();
						};

						$scope.confirm = function () {
							$scope.viewState.isReady = false;

							schoolPageService.post('school/v1/create/' + id_school + '/schoolStuff', $scope.staff).then(function (response) {
									modalInstance.close();
									getSchool();
								},
								function (error) {
									if (error.data.error.code == 409) {
										toastr.error($translate.instant("STAFF_INVITE_ALREADY_EXISTS"));
									} else if (error && error.data && error.data.error && error.data.error.message) {
										toastr.error(error.data.error.message);
									} else{
										toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
									}

									$scope.viewState.isReady = true;
								});
						}
					},
					size: 'md'
				});
			}

			$scope.openInfo = function (e, type) {
				if (e) {
					e.stopImmediatePropagation();
					e.stopPropagation();
				}

				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/info_modals/info-modal-' + type + '.html',
					controller: function ($scope) {

						$scope.close = function () {
							modalInstance.close();
						};
					},
					size: 'sm'
				});
			}

			$scope.onCurrencySelected = function () {
				var payloadRequestObject = {
					currency: $scope.selectedCurrency.text
				}
				schoolPageService.post('school/v1/update/' + id_school + '/currency', {
					payload: payloadRequestObject
				}).then(function (response) {
					toastr.success($translate.instant('CURRENCY_UPDATE_SUCCESS'));
					$rootScope.refreshContext($rootScope.active_school.id);
					},
					function (error) {
						toastr.error($translate.instant('CURRENCY_UPDATE_ERROR'));
						$scope.viewState.isReady = true;
					});

			}

			$scope.isExternalLink = function (link) {
				return (link.indexOf('classlist.com/parent') === -1) && (link.indexOf('classlist.com/school') === -1) && (link.indexOf('localhost') === -1);
			}

			$scope.createLink = function (link) {
				var newLink = (link.indexOf('https://') == -1 && link.indexOf('http://') == -1) ? 'http://'+link : link;
				if(!$scope.isExternalLink(link)) {
					newLink = newLink + '?s=' + $rootScope.active_school.id;
				}
				return newLink;
			}

			var inviteModal = $rootScope.getQueryParam('inviteModal');

			if (!!inviteModal && inviteModal === 'true') {
				$scope.addStaff();
			}
			
		}

		$scope.checkTitle = function () {
			$scope.noTitleError = !$scope.newlink.text;
		}

		$scope.checkValidLink = function () {
			$scope.linkNotValidError = !$scope.validateLink($scope.newlink.href);
		}

		if ($rootScope.active_school && $rootScope.app_base_ready) {
			baseService.app_initialized();
		}
	}

})();

(function() {
	'use strict';

	angular.module('modules.schoolcontacts',[])
	.factory('schoolPageService', ['base','$http', function (base, $http) {
		return _.create(base, { });
	}])
	.controller('schoolContactsController', schoolContactsController);

	/** @ngInject */
	function schoolContactsController(baseService, $scope, $rootScope, $location, $window, $stateParams, $uibModal, schoolPageService, toastr, $translate, $state, $http) {

		$scope.id_school = $rootScope.active_school.id;
		var id_school = $scope.id_school;
		$scope.type = $stateParams.type;

		baseService.app_initialized = function(evt, args) {

			if(!$scope.id_school) {
				location.href = '/school/#/dashboard/view';
				return;
			}

			if($stateParams.type != 'years' && $stateParams.type != 'classes') {
				location.href = '/school/#/school/details';
				return;
			}

			if($rootScope.active_user.role == "AMBASSADOR" || $rootScope.active_user.role == "STAFF")
				$scope.editableSchool = true;

			if($rootScope.active_user.role == "CLASS_REP")
				$scope.editableClassRep = true;

			$scope.getReps = function(type) {
				schoolPageService.get('school/v1/get/' + id_school + '/reps/' + $stateParams.type, { 'xhr':true, cache: false }).then(function (response) {
					$scope.list = response.data.items;
				},
				function(error){
					toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
				})
			}
			
			$scope.openUser = function(object) {
				if(object.id != -1)
					location.href = '/school/#/users/parent-detail/' + object.id;
			}

			$scope.getReps($stateParams.type);
			
			$scope.addClassRep = function(object) {
				var s = $scope;

				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/schoolpage/views/add-classrep-modal.html',
					controller: function($scope) {
						$scope.hasSelected = false;

						$scope.viewState = {
							isReady:true
						};

						$scope.id_school = id_school;
						$scope.parent = { };

						$scope.$on('ADD_AMBA_PARENT', function(evt, args) {
							$scope.hasSelected = true;
							$scope.parent.id = args.id;
						})

						$scope.close = function() {
							modalInstance.close();
						};

						$scope.confirm = function () {
							$scope.viewState.isReady = false;

							schoolPageService.post('school/v1/create/' + id_school + '/tierRep/' + object.id + '/' + $scope.parent.id + ($scope.parent.label ? ('/' + $scope.parent.label) : ''), { }).then(function(response) {
								modalInstance.close();
								s.getReps($stateParams.type);
							}, 
							function(error) {
								if(error.data.error.code == 403)
									toastr.error($translate.instant(error.data.error.message));
								else
									toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
								
								$scope.viewState.isReady = true;
							});
						}
					},
					size: 'sm'
				});
			}
		}
		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}
	}

})();

(function () {
	'use strict';

	angular.module('modules.schooladmins', [])
		.factory('schoolAdminsService', ['base', '$http', function (base, $http) {
			return _.create(base, {});
		}])
		.controller('schoolAdminsController', schoolAdminsController);

	/** @ngInject */
	function schoolAdminsController(baseService, $scope, $window, storage, settings, $rootScope, $location, $stateParams, $uibModal, schoolAdminsService, toastr, $translate, $state, $http) {
		var getSchool;
		$scope.newlink = {};
		$scope.viewState = {
			isReady: false
		};
		$scope.availableCurrencies = [];
		$scope.selectedCurrency = {
			text: "",
		};
		$scope.confirmUserManagementPermission = false;

		baseService.app_initialized = function (evt, args) {

			$scope.id_school = $rootScope.active_school.id;
			var id_school = $scope.id_school;

			if ($rootScope.active_user.role == "AMBASSADOR" || $rootScope.active_user.role == "STAFF") {
				$scope.editableSchool = true;
				$scope.editableComm = true;
				
				if ($rootScope.active_user.role == "AMBASSADOR" && $rootScope.active_school.integrationEnabled) {
					$scope.isStaffInvitePermission = false;
				} else if ($rootScope.active_user.role == "STAFF" && $rootScope.isStaffWithoutUserManagementPermission()) {
					$scope.isStaffInvitePermission = false;
				} else {
					$scope.isStaffInvitePermission = true;
				}
			}

			$scope.getSchool = getSchool = function () {
				$scope.viewState.isReady = false;

				schoolAdminsService.get('school/v1/get/' + $scope.id_school + '/details', {
					'xhr': true,
					cache: false
				}).then(function (response) {
						$scope.viewState.isReady = true;
						$scope._school = DTOS.Map(response.data.payload || {}, 'school');
						$scope.isThereASampleContent = response.data.payload.sample;
						$scope._school.cover = $scope._school.cover + "?vi=" + new Date().getTime();
						$scope._school.schoolStuffWithoutPermission = [];
						
						if($scope._school.schoolStuff){
							$scope._school.schoolStuffWithoutPermission = $scope._school.schoolStuff.filter(function(item) {
								return item.userManagementPermission === false;
							});
						
							$scope._school.schoolStuff = $scope._school.schoolStuff.filter(function(item) {
								return item.userManagementPermission === undefined || item.userManagementPermission === true;
							});
						}
					},
					function (error) {
						if (error.status != 401)
							toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
					})
			}

			$scope.getReps = function (type) {
				schoolAdminsService.get('school/v1/get/' + $scope.id_school + '/reps/classes', {
					'xhr': true,
					cache: false
				}).then(function (response) {
						$scope.reps_list = response.data.items;
						var lockedItems = [];
						$scope.reps_list = $scope.reps_list.filter(function(item) {
							if (item && item.locked === true) {
								// if has reps
								if(item.reps && item.reps.length > 0){
									lockedItems.push(item);
								}
								return false;  
							}
							return true;  
						});
						// add locked unassigned class to bottom
						$scope.reps_list = $scope.reps_list.concat(lockedItems);

						// scroll to unassigned reps
						if(lockedItems.length > 0){
							setTimeout(function () {
								$scope.checkHash();
							}, 1000);
						}
					},
					function (error) {
						if (error.status != 401)
							toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
					})
			}
			$scope.openUnassignedGroupInfo = function (e, type) {
				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/info_modals/info-modal-16.html',
					controller: function ($scope) {
	
						$scope.close = function () {
							modalInstance.close();
						};
					},
					size: 'sm'
				});
			}
			$scope.checkHash = function() {
				var hash = $location.hash();
				
				if (hash === 'unassigned') {
				  var element = document.getElementById('unassigned');
				  if (element) {
					element.scrollIntoView({ behavior: 'smooth', block: 'start' });
				  }
				}
			  };
			$scope.addClassRep = function (object) {
				var s = $scope;

				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/schoolpage/views/add-classrep-modal.html',
					controller: function ($scope) {
						$scope.hasSelected = false;

						$scope.viewState = {
							isReady: true
						};

						$scope.id_school = id_school;
						$scope.parent = {};

						$scope.$on('ADD_AMBA_PARENT', function (evt, args) {
							$scope.hasSelected = true;
							$scope.parent.id = args.id;
						})

						$scope.close = function () {
							modalInstance.close();
						};

						$scope.confirm = function () {
							$scope.viewState.isReady = false;

							schoolAdminsService.post('school/v1/create/' + id_school + '/tierRep/' + object.id + '/' + $scope.parent.id, {
									label: $scope.parent.label
								})
								.then(function (response) {
										modalInstance.close();
										s.getReps($stateParams.type);
									},
									function (error) {
										if (error.data.error.code == 403)
											toastr.error($translate.instant(error.data.error.message));
										else
											toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));

										$scope.viewState.isReady = true;
									});
						}
					},
					size: 'sm'
				});
			}
		
			$scope.openYearReps = function () {
				location.href = '/school/#/school/details/years';
			}

			$scope.openClassReps = function () {
				location.href = '/school/#/school/details/classes';
			}

			$scope.openUser = function (object, isStaff) {
				if (object.id != -1) {
					if (isStaff)
						location.href = '/school/#/users/staff-detail/' + object.id;
					else
						location.href = '/school/#/users/parent-detail/' + object.id;
				}
			}

			getSchool();
			$scope.getReps();

			$scope.addAmbasador = function () {

				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/schoolpage/views/add-amba-modal.html',
					controller: function ($scope) {
						$scope.hasSelected = false;

						$scope.viewState = {
							isReady: true
						};

						$scope.ambassador = {};
						$scope.id_school = id_school;

						$scope.$on('ADD_AMBA_PARENT', function (evt, args) {
							$scope.hasSelected = true;
							$scope.ambassador.id = args.id;
						})

						$scope.close = function () {
							modalInstance.close();
						};

						$scope.confirm = function () {
							$scope.viewState.isReady = false;

							schoolAdminsService.post('school/v1/create/' + id_school + '/ambassador/' + $scope.ambassador.id, {
									label: $scope.ambassador.label
								})
								.then(function (response) {
										modalInstance.close();
										getSchool();
									},
									function (error) {
										if (error.data.error.code == 403)
											toastr.error($translate.instant(error.data.error.message));
										else
											toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));

										$scope.viewState.isReady = true;
									});
						}
					},
					size: 'sm'
				});
			}

			$scope.addCommunity = function () {

				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/schoolpage/views/add-community-modal.html',
					controller: function ($scope) {
						$scope.hasSelected = false;

						$scope.viewState = {
							isReady: true
						};

						$scope.parent = {};
						$scope.id_school = id_school;

						$scope.$on('ADD_AMBA_PARENT', function (evt, args) {
							$scope.hasSelected = true;
							$scope.parent.id = args.id;
						})

						$scope.close = function () {
							modalInstance.close();
						};

						$scope.confirm = function () {
							$scope.viewState.isReady = false;

							schoolAdminsService.post('school/v1/create/' + id_school + '/communityRep/' + $scope.parent.id, {
									label: $scope.parent.label
								})
								.then(function (response) {
										modalInstance.close();
										getSchool();
									},
									function (error) {
										if (error.data.error.code == 403)
											toastr.error($translate.instant(error.data.error.message));
										else
											toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));

										$scope.viewState.isReady = true;
									});
						}
					},
					size: 'sm'
				});
			}

			$scope.addStaff = function (object) {

				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/schoolpage/views/invite-staff-modal.html',
					controller: function ($scope) {
						$scope.viewState = {
							isReady: true
						};

						$scope.staff = {};

						$scope.close = function () {
							modalInstance.close();
						};

						$scope.confirm = function () {
							$scope.viewState.isReady = false;
							
							schoolAdminsService.post('school/v1/create/' + id_school + '/schoolStuff', $scope.staff).then(function (response) {
									modalInstance.close();
									getSchool();
								},
								function (error) {
									if (error.data.error.code == 409) {
										toastr.error($translate.instant("STAFF_INVITE_ALREADY_EXISTS"));
									} else if (error && error.data && error.data.error && error.data.error.message) {
										toastr.error(error.data.error.message);
									} else{
										toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
									}

									$scope.viewState.isReady = true;
								});
						}
					},
					size: 'md'
				});
			}

			$scope.openInfo = function (e, type) {
				if (e) {
					e.stopImmediatePropagation();
					e.stopPropagation();
				}

				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/info_modals/info-modal-' + type + '.html',
					controller: function ($scope) {

						$scope.close = function () {
							modalInstance.close();
						};
					},
					size: 'md'
				});
			}

			var inviteModal = $rootScope.getQueryParam('inviteModal');

			if (!!inviteModal && inviteModal === 'true') {
				$scope.addStaff();
			}
			
		}

		if ($rootScope.active_school && $rootScope.app_base_ready) {
			baseService.app_initialized();
		}
	}

})();

(function() {
    "use strict";

    angular
        .module("modules.raffle.setup", [])
        .controller("raffleSetupController", raffleSetupController);

    /** @ngInject */
    function raffleSetupController(baseService, $rootScope, $scope, $state, $stateParams, $http, settings, storage, raffleService, toastr, $translate, $uibModal) {
        $scope.raffle_id = $stateParams.raffle_id;
        $scope.raffle = {};
        $scope.ticket1 = {};
        $scope.ticket2 = {};
        $scope.ticket3 = {};
        $scope.loading = false;
        $scope.time = "12:00";
        $scope.dateOptions = {
            minDate: new Date(),
            showWeeks: false
        }
        $scope.refresh = false;
        $http.get('i8n/locale-metadata-en-GB.json?v=12').then(function(data) {
            $scope.eventTimes = data.data.metadata.eventTimes
        });
        baseService.app_initialized = function(evt, args) {
            if ($scope.raffle_id) {
                $scope.getRaffle();
            } else {
                var nextWeek = new Date();
                nextWeek.setDate(nextWeek.getDate() + 7);
                $scope.date = $rootScope.getUTCDatetime(nextWeek);
                $scope.dateChange();
                $scope.raffle.raffleOwners = [$rootScope.active_user]
            }
        };



        $scope.getRaffle = function() {
            raffleService.get('raffleAdmin/v1/get/' + $scope.raffle_id, { 'xhr': true }).then(function(response) {
                    $scope.raffle = response.data || {};
                    $scope.raffleImage = $scope.raffle.imagePath || '';
                    $scope.ticket1 = $scope.raffle.tickets[0] || {};
                    $scope.ticket2 = $scope.raffle.tickets[1] || {};
                    $scope.ticket3 = $scope.raffle.tickets[2] || {};
                    $scope.date = $rootScope.getUTCDatetime($scope.raffle.drawDate);
                    $scope.time = ($scope.date.getHours() < 10 ? '0' : '') + $scope.date.getHours() + ':' + ($scope.date.getMinutes() < 10 ? '0' : '') + $scope.date.getMinutes();
                    $scope.raffle.description = $rootScope.removeLinks($scope.raffle.description);

                    $scope.beatuifyPriceView();

                    if ($rootScope.getQueryParam('stripe') === 'true') {
                        $scope.scrollTo('saveButton');
                    }

                },
                function(error) {
                    toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
                    $state.go('raffle.create');
                })
        }

        $scope.removeOwner = function (owner, index) {
			var id_raffle = $scope.raffle.id;
			var _raffleOwners = $scope.raffle.raffleOwners;
			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdrop: 'static',
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/raffle/views/remove-owner-modal.html',
				size: 'sm',
				controller: function ($scope) {
					$scope.fullname = owner.firstName;

					$scope.cancel = function () {
						modalInstance.close();
					}

					$scope.remove = function () {
						$scope.removing = true;

						raffleService.delete('raffleAdmin/v1/delete/' + id_raffle + '/owner/' + owner.id)
							.then(function (response) {
								_raffleOwners.splice(index, 1);
								modalInstance.close();
								$scope.removing = false;
								toastr.success('Successfully removed ' + rep.firstName + ' as raffle owner');
							},
								function (error) {
									$scope.removing = false;
								})
					};
				}
			})
		}

        $scope.gotoAddOwner = function () {
			location.href = '/school/#/raffle/owners/' + $scope.raffle.id;
		}

		$scope.getOwners = function () {
			eventsService.get('raffleAdmin/v1/list/' + $scope.raffle.id + '/owners')
				.then(function (response) {
					$scope.raffle.raffleOwners = [];

					if (!response || !response.data || !response.data.items)
						return;

						$scope.raffle.raffleOwners = response.data.items;
				},
					function (error) {

					})
		}
        $scope.save = function(draft) {

            if ($scope.raffle.price) {
                $scope.raffle.price = $scope.raffle.price.toString().replace(/,/g, '.')
            }

            if ($scope.hasErrors()) {
                $scope.scrollTo($scope.errorScrollId);
                $scope.errorScrollId = null;
                return;
            }
            $scope.loading = true;
            $scope.raffle.tickets = [$scope.ticket1, $scope.ticket2, $scope.ticket3];
            $scope.raffle.price = parseFloat($scope.raffle.price);
            $scope.raffle.description = $rootScope.createEmailLinks($scope.raffle.description);

            if (!$scope.raffle_id) {
                $scope.create(draft);
            } else {
                $scope.update(draft);
            }
        }

        $scope.create = function(draft) {
            raffleService.post('raffleAdmin/v1/create/' + $rootScope.active_school.id, $scope.raffle, { 'xhr': true }).then(function(response) {
                    $scope.created_id = response.data.payload.id || '';
                    if (!draft) {
                        $scope.redirectStripe('signup', $scope.created_id);
                    } else {
                        $scope.redirectList();
                    }
                },
                function(error) {
                    $scope.loading = false;
                    toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
                });
        }

        $scope.update = function(draft) {
            raffleService.post('raffleAdmin/v1/update/' + $scope.raffle_id, $scope.raffle, { 'xhr': true }).then(function() {
                    if (draft) {
                        $scope.redirectList();
                    } else {
                        if (!$scope.raffle.stripeDisplayName) {
                            $scope.redirectStripe('signup', $scope.raffle_id);
                        } else {
                            $scope.redirectPrizes();
                        }
                    }


                },
                function(error) {
                    $scope.loading = false;
                    toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
                });
        }

        $scope.redirectStripe = function(type, id) {
            if(!id){
                id = $scope.raffle_id || $scope.created_id;
            }
            $scope.refresh = true;
            var url = settings.conf.api.replace('https', 'http');
            window.location.href = url + "/payment/onboardstripesellerto?nd=true&t=" + storage.getToken() + "&rid=" + id + "&type=" + type + "&too=raffle";
        }

        $scope.redirectList = function() {
            $state.go('raffle.list');
        }

        $scope.redirectPrizes = function() {
            $state.go('raffle.prizes', { raffle_id: $scope.raffle_id });
        }

        $scope.refreshPage = function() {
            if (!$scope.raffle_id) {
                $state.go('raffle.setup', { raffle_id: $scope.created_id });
            } else {
                window.location.reload();
            }
        }

        $scope.hasErrors = function() {
            var errors = false;
            if (!$scope.raffle.title || $scope.raffle.title === '') {
                $scope.titleError = true;
                errors = true;
                $scope.setErrorId('title');
            }
            if (!$scope.date || $scope.date === '') {
                $scope.dateError = true;
                errors = true;
                $scope.setErrorId('date');
            }
            if (!$scope.raffle.price || $scope.raffle.price === '' || parseFloat($scope.raffle.price) < 1) {
                $scope.priceError = true;
                errors = true;
                $scope.setErrorId('price');
            }
            if (!$scope.ticket1.count || $scope.ticket1.count === '' || parseFloat($scope.ticket1.count) < 1) {
                $scope.count1Error = true;
                errors = true;
                $scope.setErrorId('count1');
            }
            if (!$scope.ticket2.count || $scope.ticket2.count === '' || parseFloat($scope.ticket1.count) < 1) {
                $scope.count2Error = true;
                errors = true;
                $scope.setErrorId('count2');
            }
            if (!$scope.ticket3.count || $scope.ticket3.count === '' || parseFloat($scope.ticket1.count) < 1) {
                $scope.count3Error = true;
                errors = true;
                $scope.setErrorId('count3');
            }
            if (!$scope.ticket1.price || $scope.ticket1.price === '' || parseFloat($scope.ticket1.price) < 1) {
                $scope.priceError = true;
                errors = true;
                $scope.setErrorId('price');
            }
            if (!$scope.ticket2.price || $scope.ticket2.price === '' || parseFloat($scope.ticket2.price) < 1) {
                $scope.priceError = true;
                errors = true;
                $scope.setErrorId('price');
            }
            if (!$scope.ticket3.price || $scope.ticket3.price === '' || parseFloat($scope.ticket3.price) < 1) {
                $scope.priceError = true;
                errors = true;
                $scope.setErrorId('price');
            }
            return errors;
        }

        $scope.setErrorId = function(id) {
            if (!$scope.errorScrollId) {
                $scope.errorScrollId = id;
            }
        }

        $scope.openCalendar = function() {
            $scope.calendarOpened = true;
        }

        $scope.dateChange = function() {
            if (!$scope.time) {
                $scope.time = '12:00';
            }
            if ($scope.time && $scope.time.indexOf(':') > -1) {
                $scope.date.setHours(parseInt($scope.time.split(':')[0]));
                $scope.date.setMinutes(parseInt($scope.time.split(':')[1]));
            }
            $scope.raffle.drawDate = $rootScope.getWithoutTimeZone($scope.date);
        }

        $scope.timeChange = function() {
            $scope.dateChange();
        }

        function IsNumeric(input) {
            return (input - 0) == input && ('' + input).trim().length > 0;
        }

        $scope.beatuifyPriceView = function() {
            $scope.ticket1.priceView = $scope.ticket1.price.toFixed(2);
            $scope.ticket2.priceView = $scope.ticket2.price.toFixed(2);
            $scope.ticket3.priceView = $scope.ticket3.price.toFixed(2);
        }

        $scope.countChanged = function() {
            if ($scope.raffle.price) {
                $scope.raffle.price = $scope.raffle.price.toString().replace(/,/g, '.')
            }

            if (!$scope.raffle.price || $scope.raffle.price === '' || parseFloat($scope.raffle.price) < 1 || !IsNumeric($scope.raffle.price)) {
                $scope.ticket1.price = 0;
                $scope.ticket2.price = 0;
                $scope.ticket3.price = 0;
                return;
            }

            if ($scope.ticket1.count) {
                try {
                    $scope.ticket1.price = parseFloat($scope.ticket1.count) * parseFloat($scope.raffle.price);
                } catch (err) {
                    $scope.ticket1.price = 0;
                }
            }

            if ($scope.ticket2.count) {
                try {
                    $scope.ticket2.price = parseFloat($scope.ticket2.count) * parseFloat($scope.raffle.price);

                } catch (err) {
                    $scope.ticket2.price = 0;
                }

            }

            if ($scope.ticket3.count) {
                try {
                    $scope.ticket3.price = parseFloat($scope.ticket3.count) * parseFloat($scope.raffle.price);
                } catch (err) {
                    $scope.ticket3.price = 0;
                }

            }
            $scope.beatuifyPriceView();

        }

        $scope.uploadImage = function() {
            $rootScope.$broadcast('UPLOAD_PHOTO', {
                'callback_fn': function(response) {
                    $scope.raffleImage = raffleService.getPostImgBucketUrl() + '/' + response.data;
                    $scope.raffle.image = response.data || '';
                },
                'action': 'raffleUpload',
                'config': 'raffleCropper',
                'on_close': function() {}
            });
        }

        $scope.scrollTo = function(id) {
            setTimeout(function() {
                var elmnt = document.getElementById(id);
                window.scrollBy(0, elmnt.getBoundingClientRect().y - 150);
            }, 100);
        }

        if ($rootScope.active_school && $rootScope.app_base_ready) {
            baseService.app_initialized();
        }
    }
})();
(function() {
    "use strict";

    angular
        .module("modules.raffle.prizes", [])
        .controller("rafflePrizesController", rafflePrizesController);

    /** @ngInject */
    function rafflePrizesController(baseService, $rootScope, $scope, $state, $stateParams, raffleService, toastr, $translate) {
        $scope.raffle_id = $stateParams.raffle_id;
        $scope.raffle = {};
        $scope.currentPrize = {};
        $scope.prizes = [];

        baseService.app_initialized = function(evt, args) {
            if ($scope.raffle_id) {
                $scope.getRaffle();
            } else {
                $state.go('raffle.create');
            }
        };

        $scope.getRaffle = function() {
            raffleService.get('raffleAdmin/v1/get/' + $scope.raffle_id, { 'xhr': true }).then(function(response) {
                    $scope.raffle = response.data || {};
                    $scope.prizes = response.data.prizes || [];
                    $scope.loading = false;

                    for (var i = 0; i < $scope.prizes.lenght; i++) {
                        $scope.prizes[i].description = $rootScope.removeLinks($scope.prizes[i].description);
                    }

                },
                function(error) {
                    toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
                })
        }

        $scope.uploadImage = function() {
            $rootScope.$broadcast('UPLOAD_PHOTO', {
                'callback_fn': function(response) {
                    $scope.currentPrize.imagePath = raffleService.getPostImgBucketUrl() + '/' + response.data;
                    $scope.currentPrize.image = response.data || '';
                },
                'action': 'raffleUpload',
                'config': 'raffleCropper',
                'on_close': function() {}
            });
        }

        $scope.savePrize = function() {
            for (var i = 0; i < $scope.prizes.lenght; i++) {
                if (!$scope.prizes[i].description) return;
                $scope.prizes[i].description = $rootScope.createEmailLinks($scope.prizes[i].description);
            }
            if ($scope.hasErrors()) return;
            $scope.editing ? $scope.updatePrize() : $scope.addPrize();
        }

        $scope.addPrize = function() {
            $scope.loading = true;
            raffleService.post('raffleAdmin/v1/prize/add/' + $scope.raffle_id, $scope.currentPrize, { 'xhr': true }).then(function(response) {
                    $scope.currentPrize.id = response.data.payload.id || '';
                    $scope.currentPrize.imagePath = response.data.payload.image || '';
                    $scope.scrollTo($scope.currentPrize.id);
                    $scope.loading = false;
                    $scope.prizes.push($scope.currentPrize);
                    $scope.currentPrize = {};

                },
                function(error) {
                    $scope.loading = false;
                    toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
                });
        }

        $scope.updatePrize = function() {
            $scope.loading = true;

            raffleService.post('raffleAdmin/v1/prize/update/' + $scope.raffle_id + '/' + $scope.currentPrize.id, $scope.currentPrize, { 'xhr': true }).then(function(response) {
                    $scope.scrollTo($scope.currentPrize.id);
                    $scope.loading = false;
                    $scope.currentPrize = {};
                    $scope.editing = false;

                },
                function(error) {
                    $scope.loading = false;
                    toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
                });
        }

        $scope.hasErrors = function() {
            var errors = false;
            if (!$scope.currentPrize.title || $scope.currentPrize.title === '') {
                $scope.titleError = true;
                errors = true;
            }
            return errors;
        }

        $scope.delete = function(index, id) {
            $scope.loading = true;

            raffleService.delete('raffleAdmin/v1/prize/delete/' + $scope.raffle_id + '/' + id, { 'xhr': true }).then(function() {
                    $scope.loading = false;
                    $scope.prizes.splice(index, 1);
                },
                function(error) {
                    $scope.loading = false;
                    toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
                });
        }

        $scope.edit = function(index) {
            $scope.editing = true;
            $scope.currentPrize = $scope.prizes[index];
            var elmnt = document.getElementById("form");
            elmnt.scrollIntoView();
        }

        $scope.cancel = function() {
            $scope.editing = false;
            $scope.currentPrize = {};
        }

        $scope.scrollTo = function(id) {
            setTimeout(function() {
                var elmnt = document.getElementById(id);
                //elmnt.scrollIntoView();
                window.scrollBy(0, elmnt.getBoundingClientRect().y - 150);
            }, 100);
        }

        if ($rootScope.active_school && $rootScope.app_base_ready) {
            baseService.app_initialized();
        }
    }
})();
(function() {
    "use strict";

    angular
        .module("modules.raffle.preview", [])
        .controller("rafflePreviewController", rafflePreviewController);

    /** @ngInject */
    function rafflePreviewController(
        baseService,
        $rootScope,
        $scope,
        $state,
        $stateParams,
        raffleService,
        toastr,
        $translate,
        $uibModal
    ) {
        $scope.raffle_id = $stateParams.raffle_id;
        $scope.raffle = {};
        $scope.commentsEnabled = true;

        baseService.app_initialized = function(evt, args) {
            if ($scope.raffle_id) {
                $scope.getRaffle();
            } else {
                $state.go("raffle.create");
            }
        };

        $scope.getRaffle = function() {
            raffleService
                .get("raffleAdmin/v1/get/" + $scope.raffle_id, { xhr: true })
                .then(
                    function(response) {
                        $scope.raffle = response.data || {};
                        //$scope.commentsEnabled = !$scope.raffle.postCommentsLocked || false;
                        $scope.loading = false;
                        //console.log(response.data);
                        $scope.beatuifyPriceView();
                    },
                    function(error) {
                        toastr.error($translate.instant("GENERIC_REQUEST_ERROR"));
                    }
                );
        };

        $scope.changeLinks = function(text) {

            text = $rootScope.removeLinks(text);
            return text;
        }

        $scope.publishRaffle = function() {
            var modalInstance = $uibModal.open({
                animation: true,
                scope: $scope,
                backdropClass: "backdrop-zindexed",
                templateUrl: "app/info_modals/info-modal-12.html",
                controller: function($scope) {
                    $scope.close = function() {
                        modalInstance.close();
                    };
                    $scope.publish = function() {
                        modalInstance.close();
                        $scope.save(true);
                    };
                },
                size: "sm",
            });
        };

        $scope.beatuifyPriceView = function() {

            $scope.raffle.tickets[0].priceView = $scope.raffle.tickets[0].price.toFixed(2);
            $scope.raffle.tickets[1].priceView = $scope.raffle.tickets[1].price.toFixed(2);
            $scope.raffle.tickets[2].priceView = $scope.raffle.tickets[2].price.toFixed(2);
        }

        $scope.moveUp = function(id) {
            if ($scope.loading) return;
            $scope.loading = true;
            raffleService
                .get("raffleAdmin/v1/prize/moveup/" + $scope.raffle_id + "/" + id, {
                    xhr: true,
                })
                .then(
                    function() {
                        $scope.getRaffle();
                    },
                    function(error) {
                        $scope.loading = false;
                        toastr.error($translate.instant("GENERIC_REQUEST_ERROR"));
                    }
                );
        };

        $scope.moveDown = function(id) {
            if ($scope.loading) return;
            $scope.loading = true;
            raffleService
                .get("raffleAdmin/v1/prize/movedown/" + $scope.raffle_id + "/" + id, {
                    xhr: true,
                })
                .then(
                    function() {
                        $scope.getRaffle();
                    },
                    function(error) {
                        $scope.loading = false;
                        toastr.error($translate.instant("GENERIC_REQUEST_ERROR"));
                    }
                );
        };

        $scope.save = function(publish) {
            if ($scope.loading) return;
            $scope.loading = true;
            var path = 'raffleAdmin/v1/';
            publish ? path += 'publish/' : path += 'update/';
            raffleService.get(path + $scope.raffle_id + '/' + $scope.commentsEnabled, { 'xhr': true }).then(function() {
                    $state.go('raffle.dashboard', { raffle_id: $scope.raffle_id, notify: true });
                },
                function(error) {
                    $scope.loading = false;
                    if (error.status === 400) {
                        toastr.error(error.data.error.message);
                    } else {
                        toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
                    }
                })
        }

        if ($rootScope.active_school && $rootScope.app_base_ready) {
            baseService.app_initialized();
        }
    }
})();

(function () {
	"use strict";

	angular
		.module("modules.raffle.owners", [])
		.factory("raffleOwnersService", [
			"base",
			function (base) {
				return _.create(base, {});
			},
		])
		.controller("raffleOwnersController", raffleOwnersController);

	/** @ngInject */
	function raffleOwnersController(
		baseService,
		$scope,
		$state,
		raffleOwnersService,
		$uibModal,
		$rootScope,
		$window,
		$stateParams
	) {
		$scope.id_raffle = $stateParams.id_raffle;

		$scope.back = function () {
			$window.history.back();
		};

		$scope.filterReps = function (rep) {
			if (!$scope.searchInput) return true;

			return (
				rep.name
					.toLowerCase()
					.indexOf($scope.searchInput.toString().toLowerCase()) > -1
			);
		};

		$scope.getReps = function () {
			raffleOwnersService
				.get("school/v1/get/all/" + $rootScope.active_school.id + "/reps")
				.then(
					function (response) {
						$scope.rep_list = [];

						if (!response || !response.data || !response.data.items) return;
						$scope.rep_list = response.data.items;
					},
					function (error) {}
				);
		};

		$scope.selectRep = function (rep) {
			var id_raffle = $scope.id_raffle;
			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: "backdrop-zindexed",
				templateUrl: "app/raffle/views/confirm-owner-modal.html",
				backdrop: "static",
				size: "sm",
				controller: function ($scope) {
					$scope.fullname = rep.name;

					$scope.cancel = function () {
						modalInstance.close();
					};

					$scope.add = function () {
						$scope.adding = true;

						raffleOwnersService
							.put("raffleAdmin/v1/create/" + id_raffle + "/owner/" + rep.id)
							.then(
								function (response) {
									modalInstance.close();
									$scope.adding = false;
									$scope.back();
									toastr.success(
										"Successfully added " + rep.name + " as raffle owner"
									);
								},
								function (error) {
									$scope.adding = false;
								}
							);
					};
				},
			});
		};

		baseService.app_initialized = function (evt, args) {
			$scope.getReps();
		};

		if ($rootScope.active_school && $rootScope.app_base_ready) {
			baseService.app_initialized();
		}
	}
})();

(function() {
    "use strict";

    angular
        .module("modules.raffle.otherpreview", [])
        .controller("raffleOtherPreviewController", raffleOtherPreviewController);

    /** @ngInject */
    function raffleOtherPreviewController(
        baseService,
        $rootScope,
        $scope,
        $state,
        $stateParams,
        raffleService,
        toastr,
        $translate,
        $uibModal,
        settings
    ) {
        $scope.raffle_id = $stateParams.raffle_id;
        $scope.notify = $stateParams.notify;
        $scope.raffle = {};
        $scope.ownerName = "";
        baseService.app_initialized = function(evt, args) {
            if ($scope.raffle_id) {
                $scope.getRaffle();
            } else {
                $state.go("raffle.list");
            }
        };

        $scope.viewRaffle = function() {
            window.location.href = settings.conf.parentFolderURL + "/#/raffle/" + $scope.raffle_id + "?s=" + $rootScope.active_school.id;
        };

        $scope.getRaffle = function() {
            $scope.posts = new Array();
			$scope.user = $rootScope.active_user;
			$scope.userName = $rootScope.active_user.firstName;
			$scope.userAvatar = $rootScope.active_user.avatar;
            raffleService
                .get("raffleAdmin/v1/get/preview/" + $scope.raffle_id, { xhr: true })
                .then(
                    function(response) {
                        $scope.raffle = response.data || {};
                        if($scope.raffle.raffleOwners && $scope.raffle.raffleOwners.length > 0){
                            $scope.ownerName = $scope.raffle.raffleOwners[0].firstName + ' ' + $scope.raffle.raffleOwners[0].lastName
                        }
                        if($scope.raffle.postDTO && $scope.raffle.postDTO.payload){
                            $scope.posts.push($scope.raffle.postDTO.payload.post);
                        }
                    },
                    function(error) {
                        toastr.error($translate.instant("GENERIC_REQUEST_ERROR"));
                    }
                );
        };

        if ($rootScope.active_school && $rootScope.app_base_ready) {
            baseService.app_initialized();
        }

        // public event start here
        $scope.shareWhatsapp = function() {
            if (!$scope.raffle.public) {
                return;
            }
            var toShare = encodeURIComponent($scope.raffle.publicRaffleLink);

            if (!$rootScope.isNative) {
                window.open("https://web.whatsapp.com/send?text=" + toShare, "_blank");
            } else {
                $rootScope.openWhatsappNative(toShare);
            }
        };

        $scope.shareFacebook = function() {
            if (!$scope.raffle.public) {
                return;
            }
			var toShare = encodeURIComponent($scope.raffle.publicRaffleLink);

            if (!$rootScope.isNative) {
                window.open(
                    "https://www.facebook.com/sharer/sharer.php?u=" + toShare,
                    "_blank"
                );
            } else {
                $rootScope.openFacebookNative(toShare);
            }
        };

        $scope.copyLink = function() {
            if (!$scope.raffle.public) {
                return;
            }
            copyToClipboard($scope.raffle.publicRaffleLink);
            toastr.success($translate.instant("LINK_COPIED"));
        };
     // public event start here
        $scope.sharePrivateWhatsapp = function() {
            var toShare = encodeURIComponent($scope.raffle.privateRaffleLink);

            if (!$rootScope.isNative) {
                window.open("https://web.whatsapp.com/send?text=" + toShare, "_blank");
            } else {
                $rootScope.openWhatsappNative(toShare);
            }
        };

        $scope.sharePrivateFacebook = function() {
			var toShare = encodeURIComponent($scope.raffle.privateRaffleLink);

            if (!$rootScope.isNative) {
                window.open(
                    "https://www.facebook.com/sharer/sharer.php?u=" + toShare,
                    "_blank"
                );
            } else {
                $rootScope.openFacebookNative(toShare);
            }
        };

        $scope.copyPrivateLink = function() {
            copyToClipboard($scope.raffle.privateRaffleLink);
            toastr.success($translate.instant("LINK_COPIED"));
        };

        $scope.isStaff = function() {
            return $rootScope.active_user && $rootScope.active_user.role == 'STAFF';
        }

        $scope.openInfo = function(e, type) {
            if (e) {
                e.stopImmediatePropagation();
                e.stopPropagation();
            }

            var modalInstance = $uibModal.open({
                animation: true,
                backdropClass: 'backdrop-zindexed',
                templateUrl: 'app/info_modals/info-modal-13.html',
                controller: function($scope) {

                    $scope.close = function() {
                        modalInstance.close();
                    };
                },
                size: 'sm'
            });
        }
    }
})();
(function () {
	"use strict";

	angular
		.module("modules.raffle", [])
		.factory("raffleService", [
			"base",
			function (base) {
				return _.create(base, {});
			},
		])
		.controller("raffleController", raffleController);

	/** @ngInject */
	function raffleController(
		baseService,
		$rootScope
	) {
		baseService.app_initialized = function (evt, args) {};

		if ($rootScope.active_school && $rootScope.app_base_ready) {
			baseService.app_initialized();
		}
	}
})();

(function () {
	"use strict";

	angular
		.module("modules.raffle.list", [])
		.controller("raffleListController", raffleListController);

	/** @ngInject */
	function raffleListController(baseService, $rootScope, $scope, $state, raffleService, toastr, $translate) {
		baseService.app_initialized = function (evt, args) {
			$scope.getRaffles();
		};

		$scope.getRaffles = function() {
			raffleService.get('raffleAdmin/v1/list/' + $rootScope.active_school.id, {'xhr':true}).then(function(response) {
				if(_.isEmpty(response.data)) {

					$state.go('raffle.create');
				} else {
					$scope.draftRaffles = response.data.draftRaffles || [];
					$scope.upcomingRaffles = response.data.ongoingRaffles || [];
					$scope.pastRaffles = response.data.pastRaffles || [];
				}
			},
			function(error) {
				toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
			});
		}

		if ($rootScope.active_school && $rootScope.app_base_ready) {
			baseService.app_initialized();
		}
	}
})();

(function () {
	"use strict";

	angular
		.module("modules.raffle.draft", [])
		.controller("raffleDraftController", raffleDraftController);

	/** @ngInject */
	function raffleDraftController(baseService, $rootScope, $scope, $state, $stateParams, raffleService, toastr, $translate, $uibModal) {
		$scope.raffle_id = $stateParams.raffle_id;
		$scope.raffle = {};

		baseService.app_initialized = function (evt, args) {
			if($scope.raffle_id) {
				$scope.getRaffle();
			} else {
				$state.go('raffle.create');
			}
		};

		$scope.getRaffle = function() {
			raffleService.get('raffleAdmin/v1/get/' + $scope.raffle_id, {'xhr':true}).then(function(response) {
				$scope.raffle = response.data || {};
				//console.log(response.data);
			},
			function(error) {
				toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
			});
		}

		$scope.deleteRaffle = function() {
			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: "backdrop-zindexed",
				templateUrl: "app/raffle/modals/delete-modal.html",
				size: "md",
				controller: function ($scope) {

					$scope.close = function () {
						modalInstance.close();
					};

					$scope.delete = function () {
						raffleService.delete('raffleAdmin/v1/delete/' + $scope.raffle_id, {'xhr':true}).then(function() {
							modalInstance.close();
							$state.go('raffle.list');
						},
						function() {
							toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
						})
					};
				},
			});
		}

		if ($rootScope.active_school && $rootScope.app_base_ready) {
			baseService.app_initialized();
		}
	}
})();

(function() {
    "use strict";

    angular
        .module("modules.raffle.dashboard", [])
        .controller("raffleDashboardController", raffleDashboardController);

    /** @ngInject */
    function raffleDashboardController(
        baseService,
        $rootScope,
        $scope,
        $state,
        $stateParams,
        raffleService,
        toastr,
        $translate,
        $uibModal,
        settings
    ) {
        $scope.raffle_id = $stateParams.raffle_id;
        $scope.notify = $stateParams.notify;
        $scope.raffle = {};

        baseService.app_initialized = function(evt, args) {
            if ($scope.raffle_id) {
                $scope.getRaffle();
            } else {
                $state.go("raffle.create");
            }
        };

        $scope.viewRaffle = function() {
            window.location.href = settings.conf.parentFolderURL + "/#/raffle/" + $scope.raffle_id + "?s=" + $rootScope.active_school.id;
        };

        $scope.getRaffle = function() {
            $scope.posts = new Array();
			$scope.user = $rootScope.active_user;
			$scope.userName = $rootScope.active_user.firstName;
			$scope.userAvatar = $rootScope.active_user.avatar;
            raffleService
                .get("raffleAdmin/v1/get/" + $scope.raffle_id, { xhr: true })
                .then(
                    function(response) {
                        $scope.raffle = response.data || {};
                        //console.log(response.data);
                        if($scope.raffle.postDTO && $scope.raffle.postDTO.payload){
                            $scope.posts.push($scope.raffle.postDTO.payload.post);
                        }
                    },
                    function(error) {
                        toastr.error($translate.instant("GENERIC_REQUEST_ERROR"));
                    }
                );
        };

        $scope.editRaffle = function() {
            $state.go('raffle.setup', { raffle_id: $scope.raffle_id });
        }

        $scope.cancelRaffle = function() {
            var modalInstance = $uibModal.open({
                animation: true,
                scope: $scope,
                backdropClass: "backdrop-zindexed",
                templateUrl: "app/raffle/modals/cancel-modal.html",
                size: "md",
                controller: function($scope) {
                    $scope.close = function() {
                        modalInstance.close();
                    };

                    $scope.cancel = function() {
                        raffleService
                            .get("raffleAdmin/v1/cancel/" + $scope.raffle_id, { xhr: true })
                            .then(
                                function() {
                                    modalInstance.close();
                                    $state.go("raffle.list");
                                },
                                function() {
                                    toastr.error($translate.instant("GENERIC_REQUEST_ERROR"));
                                }
                            );
                    };
                },
            });
        };

        $scope.downloadCSV = function(type) {
            var url = settings.gae.rootUrl + "attachment?&id=" + $scope.raffle_id;

            if (type === "winners") {
                url += "&type=raffleWinners";
            } else if (type === "users") {
                url += "&type=raffleUsers";
            } else {
                url += "&type=raffleTransactions";
            }
            //https://dev-api.classlist.com/attachment?id={{raffleId}}&type=raffleTransactions&zu={{currentUserId}}

            url = url + ("&zu=" + $rootScope.currentUserId());
            window.open(url, "_self");
        };

        if ($rootScope.active_school && $rootScope.app_base_ready) {
            baseService.app_initialized();
        }


        // public event start here
        $scope.shareWhatsapp = function() {
            if (!$scope.raffle.public || !$scope.canMakePublic()) {
                return;
            }
            var toShare = encodeURIComponent($scope.raffle.publicRaffleLink);

            if (!$rootScope.isNative) {
                window.open("https://web.whatsapp.com/send?text=" + toShare, "_blank");
            } else {
                $rootScope.openWhatsappNative(toShare);
            }
        };

        $scope.shareFacebook = function() {
            if (!$scope.raffle.public || !$scope.canMakePublic()) {
                return;
            }
			var toShare = encodeURIComponent($scope.raffle.publicRaffleLink);

            if (!$rootScope.isNative) {
                window.open(
                    "https://www.facebook.com/sharer/sharer.php?u=" + toShare,
                    "_blank"
                );
            } else {
                $rootScope.openFacebookNative(toShare);
            }
        };

        $scope.shareQrFlyer = function() {
            if (!$scope.raffle.public || !$scope.canMakePublic()) {
                return;
            }
            window.open($scope.raffle.publicRaffleLink, "_self");
        };

        $scope.canMakePublic = function() {
            return $scope.raffle && $scope.raffle.status == 'ACTIVE';
        };


        $scope.copyLink = function() {
            if (!$scope.raffle.public || !$scope.canMakePublic()) {
                return;
            }
            copyToClipboard($scope.raffle.publicRaffleLink);
            toastr.success($translate.instant("LINK_COPIED"));
        };

        $scope.switchPublicEvent = function() {
            if (!$scope.canMakePublic()) {
                return;
            }

            $scope.showLinkCopyDone = false;

            var requestPath = "raffleAdmin/v1/update/" + $scope.raffle.id + "/public/" + !$scope.raffle.public;

            if (!$scope.raffle.public) {

                var modalInstance = $uibModal.open({
                    animation: true,
                    scope: $scope,
                    backdrop: "static",
                    keyboard: false,
                    backdropClass: "backdrop-zindexed",
                    templateUrl: "app/events/views/open-raffle-modal.html",
                    size: "sm",
                    controller: function($scope) {
                        $scope.confirm = function() {
                            raffleService.get(requestPath).then(
                                function(response) {
                                    $scope.raffle.public = response.data.public;
                                    $scope.raffle.publicRaffleLink = response.data.publicRaffleLink;
                                },
                                function(error) {
                                    toastr.error($translate.instant("RAFFLE_CANT_BE_PUBLIC"));
                                    $scope.raffle.public = false;
                                }
                            );
                            modalInstance.close();
                        };
                        $scope.close = function() {
                            $scope.raffle.public = false;
                            modalInstance.close();
                        };
                    },
                });
            } else {
                raffleService.get(requestPath).then(
                    function(response) {
                        $scope.raffle.public = response.data.public;
                        $scope.raffle.publicRaffleLink = response.data.publicRaffleLink;
                    },
                    function(error) {
                        toastr.error($translate.instant("RAFFLE_CANT_BE_PUBLIC"));
                        $scope.raffle.public = true;
                    }
                );
            }

        };
        $scope.openInfo = function(e, type) {
            if (e) {
                e.stopImmediatePropagation();
                e.stopPropagation();
            }

            var modalInstance = $uibModal.open({
                animation: true,
                backdropClass: 'backdrop-zindexed',
                templateUrl: 'app/info_modals/info-modal-13.html',
                controller: function($scope) {

                    $scope.close = function() {
                        modalInstance.close();
                    };
                },
                size: 'sm'
            });
        }

    }
})();
(function () {
	"use strict";

	angular
		.module("modules.raffle.create", [])
		.controller("raffleCreateController", raffleCreateController);

	/** @ngInject */
	function raffleCreateController(baseService, $rootScope, $scope) {
		baseService.app_initialized = function (evt, args) {};

		if ($rootScope.active_school && $rootScope.app_base_ready) {
			baseService.app_initialized();
		}
	}
})();

(function () {
	//Emese - 05/06/17
	'use strict';

	angular.module('modules.school.structure', []).factory('schoolStructureService', ['base', function (base) {
		return _.create(base, {
			processTiers: function (_tiers) {
				var tiers = _tiers;
				_.forEach(tiers, function (tier1) {
					tier1.type = 'tier1';
					
					// remove disabled pupils in tier
					// if (tier1.pupils) {
					// 	tier1.pupils = tier1.pupils.filter(function (pupil) {
					// 		return pupil && pupil.status !== 'DISABLED';
					// 	});
					// }
					if (tier1.tiers) {
						_.forEach(tier1.tiers, function (tier2) {
							tier2.type = 'tier2';
							tier2.parent = tier1.id;
							if (_.isUndefined(tier2.pupils)) {
								tier2.pupils = []
							}
							// else{
							// 	tier2.pupils = tier2.pupils.filter(function (pupil) {
							// 		return pupil && pupil.status !== 'DISABLED';
							// 	});
							// }
						})
					} else if (_.isUndefined(tier1.tiers) && _.isUndefined(tier1.pupils)) {
						tier1.pupils = []
					};
				});
				return tiers
			}
		});
	}]).controller('schoolStructureController', schoolStructureController);

	/** @ngInject */
	function schoolStructureController(baseService, $scope, $window, $rootScope, $translate, $uibModal, $location, settings, regexes, schoolStructureService, $state, toastr, $timeout) {

		$scope.viewState = {
			isReady: false
		};

		$scope.selectAllDisabled = false;
		$scope.integrationEnabled = false;
		$scope.manualTipsOpen = false;

		$scope.redirectToIntegration = function () {
			window.location.href = "/integration/#/dashboard?s="+$rootScope.active_school.id
		}
		baseService.app_initialized = function (evt, args) {
			if($rootScope.integrationEnabled()){
				window.location.href = '/school/#/integration-structure';
				return;
			}
			if($rootScope.isStaffWithoutUserManagementPermission()){
				$rootScope.showStaffWithoutUserManagementPermissionErrorMessage();
				window.location.href = '/school/#/dashboard/view';
				return;
			}
			//Pupil's label
			$scope.topTierName = '';
			$scope.subTierName = '';
			$scope.showParents = true;
			$scope.showDeactivatedPupils = false;
			var schoolId = $rootScope.active_school.id;
			if($rootScope.active_school.integrationEnabled){
				$scope.integrationEnabled = $rootScope.active_school.integrationEnabled;
			}

			$scope.newYearName = '';
			$scope.newClassName = '';
			$scope.tiers = [];
			$scope.topTier = {};
			$scope.topActive = 0;
			$scope.subActive = 0;
			$scope.newPupil = {};

			//Functions handle drag and drop
			$scope.multipleDraggables = [];
			$scope.$on('MUL_PUP_ADDED', function (evt, args) {
				$timeout(function () {
					!_.includes($scope.multipleDraggables, args) ? $scope.multipleDraggables.push(args) : _.noop()
				}, 0)
			})

			$scope.$on('MUL_PUP_REMOVED', function (evt, args) {
				$timeout(function () {
					_.includes($scope.multipleDraggables, args) ? ($scope.multipleDraggables = _.without($scope.multipleDraggables, args)) : _.noop()
				}, 0)
			})

			$scope.showParent = function () {
				$scope.clearDraggables();
			}

			$scope.showDeactivated = function () {
				$scope.clearDraggables();
				if($scope.subActive && $scope.subActive !== '') {
					$scope.showPupils($scope.subTierData);
				} else {
					$scope.showSubTiers($scope.topTier);
				}
			}

			$scope.clearDraggables = function () {
				if ($scope.multipleDraggables.length != 0) {
					$scope.multipleDraggables.length = 0
					deselectPupils();
				}
			}

			$scope.getPupilsCount = function (pupils) {
				if (pupils) {
					if($scope.showDeactivatedPupils) {
						return pupils.length;
					} else {
						return pupils.filter(function (p) {
							return p.status !== 'DISABLED';
						}).length;
					}
				}
				return 0;
			}

			$scope.droppablevents = {
				drop: function (id, _target) {
					var target = angular.fromJson(_target) || {};
					if (_.isUndefined(target.tiers)) {
						movePupil(id, target)
					} else {
						toastr.warning($translate.instant('DROP_TO_CLASS'))
					}
				},
				dragenter: function (_tier) {
					var tier = angular.fromJson(_tier) || {};
					if (tier.type === 'tier1') {
						$scope.topTier = {}
					}
					_.isUndefined(tier.pupils) ? $scope.showSubTiers(tier) : $scope.showPupils(tier)
				}
			}

			$scope.showMoveDialog = function (pupilId, tier) {
				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/school/views/moving-pupils-question-modal.html',
					controller: function ($scope) {

						$scope.viewState = {
							isReady: true
						};

						$scope.close = function () {
							modalInstance.close();
							editTierFromDialog();
						};

						//Close modal with cross
						$scope.cross = function () {
							modalInstance.close();
						};

						$scope.confirm = function () {
							modalInstance.close();
							movePupil(pupilId, tier);
						}
					},
					size: 'md'
				});
			}

			/*
			 * This function is responsible from
			 * whether to display the move dialog
			 * or not.
			 * Show the dialog if and only if:
			 * top tier name is different.
			 */

			$scope.movePupils = function (pupilId, tier) {
				if ($scope.topTierName !== tier.topTier)
						$scope.showMoveDialog(pupilId, tier);
					else {
						movePupil(pupilId, tier);
					}
			}

			function movePupil(pupilId, tier) {
				$scope.viewState.isReady = false;
				var pupils = [];



				if ($scope.multipleDraggables.length > 0) {
					pupils = $scope.multipleDraggables;
					$scope.newPupil.tier = null;
				} else {
					if (pupilId)
						pupils.push(pupilId);
				}

				var _pupils = []
				if (pupils && pupils.length > 0) {
					for (var i = 0; i < pupils.length; i++) {
						if (pupils[i]) {
							_pupils.push(pupils[i])
						}
					}
				}

				schoolStructureService.post('school/v1/movePupilsToTier', {
					'pupils': _pupils,
					'schoolId': schoolId,
					'tierId': tier.id
				}, {}).then(function (response) {
						getStructure(tier.id);
						toastr.info($translate.instant('MOVEUP_MOVE_SUCCESS'));
						$scope.multipleDraggables = [];
						$scope.viewState.isReady = true;
						$scope.selectAllDisabled = false;
					},
					function (error) {
						$scope.viewState.isReady = true;
						$scope.selectAllDisabled = false;
					})
			}

			//Functions for select pupils
			function selectOnePupil(pupil) {
				var name = pupil.firstName + ' ' + pupil.lastName;
				var elems = document.querySelector('[dragname="' + name + '"]');
				fireEvent(elems, 'click');

				var el = angular.element(elems);
				el.addClass('selected')
			}

			function deselectPupils() {
				$scope.selectAllDisabled = false;
				if ($scope.pupils.length > 0) {
					var elems = document.querySelectorAll('.pupil-item');
					for (var i = 0; i < elems.length; i++) {
						elems[i].draggable = false;
					}

					angular.forEach(elems, function (k, v) {
						var elm = angular.element(k);
						elm.removeClass('selected')
					})

					var elems = document.querySelectorAll('.pupil-parent-item');
					for (var i = 0; i < elems.length; i++) {
						elems[i].draggable = false;
					}

					angular.forEach(elems, function (k, v) {
						var elm = angular.element(k);
						elm.removeClass('selected')
					})
				}
			}

			$scope.selectAllPupils = function () {
				$scope.selectAllDisabled = true;

				if ($scope.pupils.length > 0) {
					var elems = document.querySelectorAll('.pupil-item');
					for (var i = 0; i < elems.length; i++) {
						elems[i].draggable = true;
					}

					var elems2 = document.querySelectorAll('.pupil-parent-item');
					for (var i = 0; i < elems.length; i++) {
						elems[i].draggable = true;
					}
					var filteredPupils = $scope.pupils.filter(function (p) {
						return $scope.showDeactivatedPupils || p.status !== 'DISABLED';
					});
					var idArray = _.map(filteredPupils, 'id');
					angular.forEach(idArray, function (k, v) {
						$timeout(function () {
							!_.includes($scope.multipleDraggables, k) ? $scope.multipleDraggables.push(k) : _.noop();
						}, 0)
					})

					angular.forEach(elems, function (k, v) {
						var elm = angular.element(k);
						elm.addClass('selected')
					})

					angular.forEach(elems2, function (k, v) {
						var elm = angular.element(k);
						elm.addClass('selected')
					})
				}
			}

			function fireEvent(el, etype) {
				if (el.fireEvent) {
					el.fireEvent('on' + etype);
				} else {
					var evObj = document.createEvent('Events');
					evObj.initEvent(etype, true, false);
					el.dispatchEvent(evObj);
				}
			}

			function searchTier(array, tierId) {
				for (var i = 0; i < array.length; i++) {
					if (array[i].id == tierId) {
						return array[i];
					}
				}
			}

			//Function for showing tiers/pupils
			$scope.showPupils = function (tier) {
				$timeout(function () {
					$scope.subTierName = tier.name;
					$scope.pupilNumber = getPupilNumber(tier);

					$scope.subActive = tier.id;
					$scope.pupils = tier.pupils;
					$scope.subTierData = tier;
				}, 0)
			}

			$scope.showSubTiers = function (tier) {
				$timeout(function () {
					$scope.topTierName = tier.name;
					$scope.subTierName = '';
					$scope.subActive = '';
					$scope.pupilNumber = getPupilNumber(tier);

					$scope.topActive = tier.id;
					$scope.topTier = tier;

					if (_.isUndefined(tier.pupils)) {
						$scope.pupils = [];
						var arr = [];
						for (var i = 0; i < tier.tiers.length; i++) {
							for (var j = 0; j < tier.tiers[i].pupils.length; j++) {
								arr.push(tier.tiers[i].pupils[j])
							}
						}
						$scope.pupils = arr;
					} else {
						$scope.pupils = tier.pupils;
					}
				}, 0)
			}

			//Structure
			function getStructure(tierIdToSelect) {
				$scope.multipleDraggables = [];
				$scope.pupils = {};
				$scope.viewState.isReady = false;
				$scope.selectAllDisabled = false;

				schoolStructureService.get('school/v1/getSchoolStructure?schoolId=' + schoolId, {
					'cache': false
				}).then(function (response) {
						$scope.viewState.isReady = true;

						$timeout(function () {

							$scope.topTier = {};
							var processed = schoolStructureService.processTiers(response.data.tiers);
							$scope.tiers = processed;
							if ($scope.tiers) {
								$scope.showSubTiers($scope.tiers[0]);
							}
							var objectArr = createStudentsArray(processed);

							$scope.$watch('keyword', function (newVal, oldVal) {
								if (newVal != oldVal) {
									var arr = searchPupils(objectArr, newVal);
									$scope.queryPupils = arr;
									return arr;
								}
							});

							//Pick pupils from search
							$scope.pickPupil = function (pupil) {
								if (pupil.tier2Name == "") {
									var myTier = searchTier(processed, pupil.tier1Id);
									$scope.showSubTiers(myTier);
									$scope.clearDraggables();
								} else {
									//Pick top tier
									var myTopTier = searchTier(processed, pupil.tier1Id);
									$scope.showSubTiers(myTopTier);
									//Pick sub tier
									var mySubTier = searchTier(myTopTier.tiers, pupil.tier2Id);
									$scope.showPupils(mySubTier);
									$scope.clearDraggables();
								}
								$timeout(function () {
									selectOnePupil(pupil)
								}, 0)
								$scope.keyword = '';
							}

							//this is the case when year to year move is done
							if (!_.isUndefined(tierIdToSelect)) {
								var isYear = false;

								for (var itIndex in processed) {
									var iteratorTier = processed[itIndex];
									if (iteratorTier.id === tierIdToSelect) {
										$scope.showSubTiers(iteratorTier)
										isYear = true;
										break;
									}
								}

								//this is the case when year/class to class is done
								if (!isYear) {
									loop1: for (var yearIndex in processed) {
										var yearTier = processed[yearIndex];

										if (!_.isUndefined(yearTier.tiers)) {

											loop2: for (var classIndex in yearTier.tiers) {
												var classTier = yearTier.tiers[classIndex];
												if (classTier.id === tierIdToSelect) {

													$scope.showSubTiers(yearTier);
													$scope.showPupils(classTier)
													break loop1;
												}
											}
										}
									}
								}
							}
						}, 0)
					},
					function (error) {
						$scope.viewState.isReady = true;
					})
			}

			getStructure();

			//Count pupils
			function getPupilNumber(tier) {
				if (!_.isUndefined(tier.tiers)) {
					var sum = 0;
					for (var i = 0; i < tier.tiers.length; i++) {
						sum += tier.tiers[i].pupils.filter(function (p) {
							return $scope.showDeactivatedPupils || p.status !== 'DISABLED';
						}).length;
					}
					return sum;
				} else {
					return tier.pupils.filter(function (p) {
						return $scope.showDeactivatedPupils || p.status !== 'DISABLED';
					}).length;
				}
			}

			//Search for pupil by name/year/class
			function searchPupils(array, string) {
				string = string.toLowerCase();
				var resultArray = [];
				for (var i = 0; i < array.length; i++) {
					var allValues = array[i].firstName + ' ' + array[i].lastName + ' ' + array[i].tier1Name + ' ' + array[i].tier2Name;
					if (
						allValues.toLowerCase().includes(string) ||
						array[i].firstName.toLowerCase().includes(string) || array[i].lastName.toLowerCase().includes(string) ||
						array[i].tier1Name.toLowerCase().includes(string) || array[i].tier2Name.toLowerCase().includes(string)
					) {
						resultArray.push(array[i])
					}
				}
				return resultArray;
			}

			//Convert array of tier object to array of student object
			function createStudentsArray(array) {
				var studentArray = [];
				//Year objects
				for (var i = 0; i < array.length; i++) {
					//we have classs inside	
					if (!_.isUndefined(array[i].tiers)) {
						//Class onbjects
						for (var k = 0; k < array[i].tiers.length; k++) {
							//For every pupil in the class
							for (var j = 0; j < array[i].tiers[k].pupils.length; j++) {
								studentArray.push({
									firstName: array[i].tiers[k].pupils[j].firstName,
									lastName: array[i].tiers[k].pupils[j].lastName,
									id: array[i].tiers[k].pupils[j].id,
									tier2Name: array[i].tiers[k].name,
									tier2Id: array[i].tiers[k].id,
									tier1Name: array[i].name,
									tier1Id: array[i].id
								});
							}
						}
					} else {
						//For every pupil in the year
						for (var j = 0; j < array[i].pupils.length; j++) {
							studentArray.push({
								firstName: array[i].pupils[j].firstName,
								lastName: array[i].pupils[j].lastName,
								id: array[i].pupils[j].id,
								tier2Name: '',
								tier2Id: '',
								tier1Name: array[i].name,
								tier1Id: array[i].id
							});
						}
					}
				}
				return studentArray;
			}

			//For deleting pupils
			$scope.deletePupils = function (arr) {
				var tmp;
				if ($scope.subActive) {
					tmp = angular.copy($scope.subActive)
				} else {
					tmp = angular.copy($scope.topActive);
				}
				var modalInstance = $uibModal.open({
					animation: true,
					templateUrl: 'app/school/views/delete-pupils-modal.html',
					backdropClass: 'backdrop-zindexed',
					controller: function ($scope) {
						try {
							var incoming = Array.isArray(arr) ? arr : [];
							$scope.arr = incoming.filter(function (x) { return x !== null && x !== undefined; });
						} catch (error) {
							$scope.arr = arr;
						}

						$scope.cancel = function () {
							modalInstance.close();
						}

						$scope.delete = function () {
							schoolStructureService.put('school/v1/delete/pupils', {
								'payload': {
									'pupils': $scope.arr,
									'schoolId': schoolId
								}
							}).then(function (response) {
								deleteScopePupils($scope.arr);
								getStructure(tmp);
								tmp = null;
								$scope.close();
								toastr.info($translate.instant('TIER_DELETE'));
							}, function (error) {
								toastr.error($translate.instant(error.data.error.message))
							})
						}

						$scope.close = function () {
							modalInstance.close();
						};
					},
					size: 'sm'
				});
			}

			function deleteScopePupils(deletedArrayOfIds) {
				for (var pupilIndex in $scope.pupils) {
					for (var deletedPupilIndex in deletedArrayOfIds) {
						var pupildeletedId = deletedArrayOfIds[deletedPupilIndex];
						if (pupildeletedId === $scope.pupils[pupilIndex].id) {
							$scope.pupils.splice(pupilIndex, 1);
						}
					}
				}
			}

			//Functions for class/year: add, edit, delete 
			$scope.addYear = function (name) {
				$scope.clearDraggables();
				schoolStructureService.post('school/v1/createTier', {
					'index': 0,
					'name': name,
					'schoolId': schoolId
				}, {}).then(function (response) {
					getStructure(response.data.id);
					$scope.newYearName = '';
				}, function (error) {

				})
			}

			$scope.addClass = function (name) {
				$scope.clearDraggables();
				schoolStructureService.post('school/v1/createTier', {
					'index': 0,
					'name': name,
					'schoolId': schoolId,
					'parentTier': $scope.topTier.id
				}, {}).then(function (response) {
						$scope.newPupil.tier = null;
						getStructure(response.data.id);
						$scope.newClassName = '';
					},
					function (error) {
						toastr.info($translate.instant(error.data.error.message));
					})
			}

			//I need this because I dont know how to access scope from a dialog
			function editTierFromDialog() {
				$scope.editTier($scope.topTier);
			}

			$scope.editTier = function (tier) {
				var modalInstance = $uibModal.open({
					animation: true,
					templateUrl: 'app/school/views/edit-tier-modal.html',
					backdropClass: 'backdrop-zindexed',
					controller: function ($scope) {
						$scope.tier = tier;
						$scope.newName = '';
						$scope.cannotDelete = false;

						$scope.save = function () {
							schoolStructureService.post('school/v1/updateTier', {
								'tierId': tier.id,
								'name': $scope.newName,
								'schoolId': schoolId
							}, {}).then(function (response) {
								$scope.close();
								toastr.info($translate.instant('TIER_UPDATED'));
								getStructure(tier.id);
							}, function (error) {

							})
						}

						$scope.delete = function () {
							$scope.cannotDelete = false;

							schoolStructureService.delete('school/v1/deleteTier?tierId=' + tier.id + '&schoolId=' + schoolId, {}).then(function (response) {
								$scope.close();
								toastr.info($translate.instant('TIER_DELETE'));
								if (tier.parent) {
									getStructure(tier.parent);
								} else {
									getStructure();
								}

							}, function (error) {
								if (error.data.error.message == 'CANNOT_DEL_BECAUSE_PUPILS') {
									$scope.cannotDelete = true;
								} else {
									toastr.error($translate.instant(error.data.error.message), {
										timeOut: 40000
									})
								}
							})
						}

						$scope.close = function () {
							modalInstance.close();
						};
					},
					size: 'md'
				});
			}
		}
		if ($rootScope.active_school && $rootScope.app_base_ready) {
			baseService.app_initialized();
		}
	}
})();

(function() {
	'use strict';

	angular.module('modules.school',[]).factory('schoolService', ['base', function (base) {
		return _.create(base, { });
	}]).controller('schoolController', schoolController);

	/** @ngInject */
	function schoolController($scope, $uibModal, storage) {

	}

})();

(function () {
	//Emese - 05/06/17
	'use strict';

	angular.module('modules.school.integrationStructure', []).factory('schoolIntegrationStructureService', ['base', function (base) {
		return _.create(base, {
			processTiers: function (_tiers) {
				var tiers = _tiers;
				_.forEach(tiers, function (tier1) {
					tier1.type = 'tier1';
						
					// remove disabled pupils in tier
					// if (tier1.pupils) {
					// 	tier1.pupils = tier1.pupils.filter(function (pupil) {
					// 		return pupil && pupil.status !== 'DISABLED';
					// 	});
					// }
					if (tier1.tiers) {
						_.forEach(tier1.tiers, function (tier2) {
							tier2.type = 'tier2';
							tier2.parent = tier1.id;
							if (_.isUndefined(tier2.pupils)) {
								tier2.pupils = []
							}
							// else{
							// 	tier2.pupils = tier2.pupils.filter(function (pupil) {
							// 		return pupil && pupil.status !== 'DISABLED';
							// 	});
							// }
						})
					} else if (_.isUndefined(tier1.tiers) && _.isUndefined(tier1.pupils)) {
						tier1.pupils = []
					};
				});
				return tiers
			}
		});
	}]).controller('schoolIntegrationStructureController', schoolIntegrationStructureController);

	/** @ngInject */
	function schoolIntegrationStructureController(baseService, $scope, $window, $rootScope, $translate, $uibModal, $location, settings, regexes, schoolIntegrationStructureService, $state, toastr, $timeout) {

		$scope.viewState = {
			isReady: false
		};

		$scope.selectAllDisabled = false;
		$scope.integrationEnabled = false;

		$scope.redirectToIntegration = function () {
			window.location.href = "/integration/#/dashboard?s="+$rootScope.active_school.id
		}
		baseService.app_initialized = function (evt, args) {
			//Pupil's label
			$scope.topTierName = '';
			$scope.subTierName = '';
			$scope.showParents = true;
			$scope.showDeactivatedPupils = false;
			var schoolId = $rootScope.active_school.id;
			if($rootScope.active_school.integrationEnabled){
				$scope.integrationEnabled = $rootScope.active_school.integrationEnabled;
			}
			if($rootScope.isStaffWithoutUserManagementPermission()){
				$rootScope.showStaffWithoutUserManagementPermissionErrorMessage();
				window.location.href = '/school/#/dashboard/view';
				return;
			}
			$scope.newYearName = '';
			$scope.newClassName = '';
			$scope.tiers = [];
			$scope.topTier = {};
			$scope.topActive = 0;
			$scope.subActive = 0;
			$scope.newPupil = {};

			//Functions handle drag and drop
			$scope.multipleDraggables = [];
			$scope.$on('MUL_PUP_ADDED', function (evt, args) {
				$timeout(function () {
					!_.includes($scope.multipleDraggables, args) ? $scope.multipleDraggables.push(args) : _.noop()
				}, 0)
			})

			$scope.$on('MUL_PUP_REMOVED', function (evt, args) {
				$timeout(function () {
					_.includes($scope.multipleDraggables, args) ? ($scope.multipleDraggables = _.without($scope.multipleDraggables, args)) : _.noop()
				}, 0)
			})

			$scope.showParent = function () {
				$scope.clearDraggables();
			}

			$scope.showDeactivated = function () {
				$scope.clearDraggables();
				if($scope.subActive && $scope.subActive !== '') {
					$scope.showPupils($scope.subTierData);
				} else {
					$scope.showSubTiers($scope.topTier);
				}
			}

			$scope.clearDraggables = function () {
				if ($scope.multipleDraggables.length != 0) {
					$scope.multipleDraggables.length = 0
					deselectPupils();
				}
			}

			$scope.getPupilsCount = function (pupils) {
				if (pupils) {
					if($scope.showDeactivatedPupils) {
						return pupils.length;
					} else {
						return pupils.filter(function (p) {
							return p.status !== 'DISABLED';
						}).length;
					}
				}
				return 0;
			}

			$scope.droppablevents = {
				drop: function (id, _target) {
					var target = angular.fromJson(_target) || {};
					if (_.isUndefined(target.tiers)) {
						movePupil(id, target)
					} else {
						toastr.warning($translate.instant('DROP_TO_CLASS'))
					}
				},
				dragenter: function (_tier) {
					var tier = angular.fromJson(_tier) || {};
					if (tier.type === 'tier1') {
						$scope.topTier = {}
					}
					_.isUndefined(tier.pupils) ? $scope.showSubTiers(tier) : $scope.showPupils(tier)
				}
			}

			$scope.showMoveDialog = function (pupilId, tier) {
				return;
				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/school/views/moving-pupils-question-modal.html',
					controller: function ($scope) {

						$scope.viewState = {
							isReady: true
						};

						$scope.close = function () {
							modalInstance.close();
							editTierFromDialog();
						};

						//Close modal with cross
						$scope.cross = function () {
							modalInstance.close();
						};

						$scope.confirm = function () {
							modalInstance.close();
							movePupil(pupilId, tier);
						}
					},
					size: 'md'
				});
			}

			/*
			 * This function is responsible from
			 * whether to display the move dialog
			 * or not.
			 * Show the dialog if and only if:
			 * top tier name is different.
			 */

			$scope.movePupils = function (pupilId, tier) {
				return;
				if ($scope.topTierName !== tier.topTier)
						$scope.showMoveDialog(pupilId, tier);
					else {
						movePupil(pupilId, tier);
					}
			}

			function movePupil(pupilId, tier) {
				return;
				$scope.viewState.isReady = false;
				var pupils = [];



				if ($scope.multipleDraggables.length > 0) {
					pupils = $scope.multipleDraggables;
					$scope.newPupil.tier = null;
				} else {
					if (pupilId)
						pupils.push(pupilId);
				}

				var _pupils = []
				if (pupils && pupils.length > 0) {
					for (var i = 0; i < pupils.length; i++) {
						if (pupils[i]) {
							_pupils.push(pupils[i])
						}
					}
				}

				schoolIntegrationStructureService.post('school/v1/movePupilsToTier', {
					'pupils': _pupils,
					'schoolId': schoolId,
					'tierId': tier.id
				}, {}).then(function (response) {
						getStructure(tier.id);
						toastr.info($translate.instant('MOVEUP_MOVE_SUCCESS'));
						$scope.multipleDraggables = [];
						$scope.viewState.isReady = true;
						$scope.selectAllDisabled = false;
					},
					function (error) {
						$scope.viewState.isReady = true;
						$scope.selectAllDisabled = false;
					})
			}

			//Functions for select pupils
			function selectOnePupil(pupil) {
				var name = pupil.firstName + ' ' + pupil.lastName;
				var elems = document.querySelector('[dragname="' + name + '"]');
				fireEvent(elems, 'click');

				var el = angular.element(elems);
				el.addClass('selected')
			}

			function deselectPupils() {
				$scope.selectAllDisabled = false;
				if ($scope.pupils.length > 0) {
					var elems = document.querySelectorAll('.pupil-item');
					for (var i = 0; i < elems.length; i++) {
						elems[i].draggable = false;
					}

					angular.forEach(elems, function (k, v) {
						var elm = angular.element(k);
						elm.removeClass('selected')
					})

					var elems = document.querySelectorAll('.pupil-parent-item');
					for (var i = 0; i < elems.length; i++) {
						elems[i].draggable = false;
					}

					angular.forEach(elems, function (k, v) {
						var elm = angular.element(k);
						elm.removeClass('selected')
					})
				}
			}

			$scope.selectAllPupils = function () {
				$scope.selectAllDisabled = true;

				if ($scope.pupils.length > 0) {
					var elems = document.querySelectorAll('.pupil-item');
					for (var i = 0; i < elems.length; i++) {
						elems[i].draggable = true;
					}

					var elems2 = document.querySelectorAll('.pupil-parent-item');
					for (var i = 0; i < elems.length; i++) {
						elems[i].draggable = true;
					}

					var filteredPupils = $scope.pupils.filter(function (p) {
						return $scope.showDeactivatedPupils || p.status !== 'DISABLED';
					});
					var idArray = _.map(filteredPupils, 'id');
					angular.forEach(idArray, function (k, v) {
						$timeout(function () {
							!_.includes($scope.multipleDraggables, k) ? $scope.multipleDraggables.push(k) : _.noop();
						}, 0)
					})

					angular.forEach(elems, function (k, v) {
						var elm = angular.element(k);
						elm.addClass('selected')
					})

					angular.forEach(elems2, function (k, v) {
						var elm = angular.element(k);
						elm.addClass('selected')
					})
				}
			}

			function fireEvent(el, etype) {
				if (el.fireEvent) {
					el.fireEvent('on' + etype);
				} else {
					var evObj = document.createEvent('Events');
					evObj.initEvent(etype, true, false);
					el.dispatchEvent(evObj);
				}
			}

			function searchTier(array, tierId) {
				for (var i = 0; i < array.length; i++) {
					if (array[i].id == tierId) {
						return array[i];
					}
				}
			}

			//Function for showing tiers/pupils
			$scope.showPupils = function (tier) {
				$timeout(function () {
					$scope.subTierName = tier.name;
					$scope.pupilNumber = getPupilNumber(tier);

					$scope.subActive = tier.id;
					$scope.pupils = tier.pupils;
					$scope.subTierData = tier;
				}, 0)
			}

			$scope.showSubTiers = function (tier) {
				$timeout(function () {
					$scope.topTierName = tier.name;
					$scope.subTierName = '';
					$scope.subActive = '';
					$scope.pupilNumber = getPupilNumber(tier);

					$scope.topActive = tier.id;
					$scope.topTier = tier;

					if (_.isUndefined(tier.pupils)) {
						$scope.pupils = [];
						var arr = [];
						for (var i = 0; i < tier.tiers.length; i++) {
							for (var j = 0; j < tier.tiers[i].pupils.length; j++) {
								arr.push(tier.tiers[i].pupils[j])
							}
						}
						$scope.pupils = arr;
					} else {
						$scope.pupils = tier.pupils;
					}
				}, 0)
			}

			//Structure
			function getStructure(tierIdToSelect) {
				$scope.multipleDraggables = [];
				$scope.pupils = {};
				$scope.viewState.isReady = false;
				$scope.selectAllDisabled = false;

				schoolIntegrationStructureService.get('school/v1/getSchoolStructure?schoolId=' + schoolId, {
					'cache': false
				}).then(function (response) {
						$scope.viewState.isReady = true;

						$timeout(function () {

							$scope.topTier = {};
							var processed = schoolIntegrationStructureService.processTiers(response.data.tiers);
							$scope.tiers = processed;
							if ($scope.tiers) {
								$scope.showSubTiers($scope.tiers[0]);
							}
							var objectArr = createStudentsArray(processed);

							$scope.$watch('keyword', function (newVal, oldVal) {
								if (newVal != oldVal) {
									var arr = searchPupils(objectArr, newVal);
									$scope.queryPupils = arr;
									return arr;
								}
							});

							//Pick pupils from search
							$scope.pickPupil = function (pupil) {
								if (pupil.tier2Name == "") {
									var myTier = searchTier(processed, pupil.tier1Id);
									$scope.showSubTiers(myTier);
									$scope.clearDraggables();
								} else {
									//Pick top tier
									var myTopTier = searchTier(processed, pupil.tier1Id);
									$scope.showSubTiers(myTopTier);
									//Pick sub tier
									var mySubTier = searchTier(myTopTier.tiers, pupil.tier2Id);
									$scope.showPupils(mySubTier);
									$scope.clearDraggables();
								}
								$timeout(function () {
									selectOnePupil(pupil)
								}, 0)
								$scope.keyword = '';
							}

							//this is the case when year to year move is done
							if (!_.isUndefined(tierIdToSelect)) {
								var isYear = false;

								for (var itIndex in processed) {
									var iteratorTier = processed[itIndex];
									if (iteratorTier.id === tierIdToSelect) {
										$scope.showSubTiers(iteratorTier)
										isYear = true;
										break;
									}
								}

								//this is the case when year/class to class is done
								if (!isYear) {
									loop1: for (var yearIndex in processed) {
										var yearTier = processed[yearIndex];

										if (!_.isUndefined(yearTier.tiers)) {

											loop2: for (var classIndex in yearTier.tiers) {
												var classTier = yearTier.tiers[classIndex];
												if (classTier.id === tierIdToSelect) {

													$scope.showSubTiers(yearTier);
													$scope.showPupils(classTier)
													break loop1;
												}
											}
										}
									}
								}
							}
						}, 0)
					},
					function (error) {
						$scope.viewState.isReady = true;
					})
			}

			getStructure();

			//Count pupils
			function getPupilNumber(tier) {
				if (!_.isUndefined(tier.tiers)) {
					var sum = 0;
					for (var i = 0; i < tier.tiers.length; i++) {
						sum += tier.tiers[i].pupils.filter(function (p) {
							return $scope.showDeactivatedPupils || p.status !== 'DISABLED';
						}).length;
					}
					return sum;
				} else {
					return tier.pupils.filter(function (p) {
						return $scope.showDeactivatedPupils || p.status !== 'DISABLED';
					}).length;
				}
			}

			//Search for pupil by name/year/class
			function searchPupils(array, string) {
				string = string.toLowerCase();
				var resultArray = [];
				for (var i = 0; i < array.length; i++) {
					var allValues = array[i].firstName + ' ' + array[i].lastName + ' ' + array[i].tier1Name + ' ' + array[i].tier2Name;
					if (
						allValues.toLowerCase().includes(string) ||
						array[i].firstName.toLowerCase().includes(string) || array[i].lastName.toLowerCase().includes(string) ||
						array[i].tier1Name.toLowerCase().includes(string) || array[i].tier2Name.toLowerCase().includes(string)
					) {
						resultArray.push(array[i])
					}
				}
				return resultArray;
			}

			//Convert array of tier object to array of student object
			function createStudentsArray(array) {
				var studentArray = [];
				//Year objects
				for (var i = 0; i < array.length; i++) {
					//we have classs inside	
					if (!_.isUndefined(array[i].tiers)) {
						//Class onbjects
						for (var k = 0; k < array[i].tiers.length; k++) {
							//For every pupil in the class
							for (var j = 0; j < array[i].tiers[k].pupils.length; j++) {
								studentArray.push({
									firstName: array[i].tiers[k].pupils[j].firstName,
									lastName: array[i].tiers[k].pupils[j].lastName,
									id: array[i].tiers[k].pupils[j].id,
									tier2Name: array[i].tiers[k].name,
									tier2Id: array[i].tiers[k].id,
									tier1Name: array[i].name,
									tier1Id: array[i].id
								});
							}
						}
					} else {
						//For every pupil in the year
						for (var j = 0; j < array[i].pupils.length; j++) {
							studentArray.push({
								firstName: array[i].pupils[j].firstName,
								lastName: array[i].pupils[j].lastName,
								id: array[i].pupils[j].id,
								tier2Name: '',
								tier2Id: '',
								tier1Name: array[i].name,
								tier1Id: array[i].id
							});
						}
					}
				}
				return studentArray;
			}

			//For deleting pupils
			$scope.deletePupils = function (arr) {
				return;
				var tmp;
				if ($scope.subActive) {
					tmp = angular.copy($scope.subActive)
				} else {
					tmp = angular.copy($scope.topActive);
				}
				var modalInstance = $uibModal.open({
					animation: true,
					templateUrl: 'app/school/views/delete-pupils-modal.html',
					backdropClass: 'backdrop-zindexed',
					controller: function ($scope) {
						$scope.arr = arr;

						$scope.cancel = function () {
							modalInstance.close();
						}

						$scope.delete = function () {
							schoolIntegrationStructureService.put('school/v1/delete/pupils', {
								'payload': {
									'pupils': $scope.arr,
									'schoolId': schoolId
								}
							}).then(function (response) {
								deleteScopePupils($scope.arr);
								getStructure(tmp);
								tmp = null;
								$scope.close();
								toastr.info($translate.instant('TIER_DELETE'));
							}, function (error) {
								toastr.error($translate.instant(error.data.error.message))
							})
						}

						$scope.close = function () {
							modalInstance.close();
						};
					},
					size: 'sm'
				});
			}

			function deleteScopePupils(deletedArrayOfIds) {
				for (var pupilIndex in $scope.pupils) {
					for (var deletedPupilIndex in deletedArrayOfIds) {
						var pupildeletedId = deletedArrayOfIds[deletedPupilIndex];
						if (pupildeletedId === $scope.pupils[pupilIndex].id) {
							$scope.pupils.splice(pupilIndex, 1);
						}
					}
				}
			}

			//Functions for class/year: add, edit, delete 
			$scope.addYear = function (name) {
				return;
				$scope.clearDraggables();
				schoolIntegrationStructureService.post('school/v1/createTier', {
					'index': 0,
					'name': name,
					'schoolId': schoolId
				}, {}).then(function (response) {
					getStructure(response.data.id);
					$scope.newYearName = '';
				}, function (error) {

				})
			}

			$scope.addClass = function (name) {
				return;
				$scope.clearDraggables();
				schoolIntegrationStructureService.post('school/v1/createTier', {
					'index': 0,
					'name': name,
					'schoolId': schoolId,
					'parentTier': $scope.topTier.id
				}, {}).then(function (response) {
						$scope.newPupil.tier = null;
						getStructure(response.data.id);
						$scope.newClassName = '';
					},
					function (error) {
						toastr.info($translate.instant(error.data.error.message));
					})
			}

			//I need this because I dont know how to access scope from a dialog
			function editTierFromDialog() {
				$scope.editTier($scope.topTier);
			}

			$scope.editTier = function (tier) {
				return;
				var modalInstance = $uibModal.open({
					animation: true,
					templateUrl: 'app/school/views/edit-tier-modal.html',
					backdropClass: 'backdrop-zindexed',
					controller: function ($scope) {
						$scope.tier = tier;
						$scope.newName = '';
						$scope.cannotDelete = false;

						$scope.save = function () {
							schoolIntegrationStructureService.post('school/v1/updateTier', {
								'tierId': tier.id,
								'name': $scope.newName,
								'schoolId': schoolId
							}, {}).then(function (response) {
								$scope.close();
								toastr.info($translate.instant('TIER_UPDATED'));
								getStructure(tier.id);
							}, function (error) {

							})
						}

						$scope.delete = function () {
							$scope.cannotDelete = false;

							schoolIntegrationStructureService.delete('school/v1/deleteTier?tierId=' + tier.id + '&schoolId=' + schoolId, {}).then(function (response) {
								$scope.close();
								toastr.info($translate.instant('TIER_DELETE'));
								if (tier.parent) {
									getStructure(tier.parent);
								} else {
									getStructure();
								}

							}, function (error) {
								if (error.data.error.message == 'CANNOT_DEL_BECAUSE_PUPILS') {
									$scope.cannotDelete = true;
								} else {
									toastr.error($translate.instant(error.data.error.message), {
										timeOut: 40000
									})
								}
							})
						}

						$scope.close = function () {
							modalInstance.close();
						};
					},
					size: 'md'
				});
			}
		}
		if ($rootScope.active_school && $rootScope.app_base_ready) {
			baseService.app_initialized();
		}
	}
})();

(function() {
	'use strict';

	angular.module('modules.pupilmanagement',[]).factory('pmService', ['base', function (base)	{
		return _.create(base, { });
	}]).directive('editPupil', editPupil).directive('addPupil', addPupil);
	/** @ngInject */
	function addPupil($uibModal, toastr, regexes, pmService)	{
		var directive = {
			restrict: 'A',
			replace: true,
			link: linkFunction
		};
		return directive;
		function linkFunction(scope, elem, attrs)	{
			scope.$on('ADD_PUPIL', function(event,	callback_fn){
				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/pupil/views/add-pupil-modal.html',
					controller: function($scope){
						$scope.regexes = regexes;
						$scope.newPupil = {
							firstName:null,
							lastName:null,
							tier:null
						};

						$scope.save = function(){
							var firstNameLength, lastNameLength;
							if ($scope.newPupil.firstName === null) {
								firstNameLength = 0;
							} else {
								firstNameLength = $scope.newPupil.firstName.length;
							}

							if ($scope.newPupil.lastName === null) {
								lastNameLength = 0;
							} else {
								lastNameLength = $scope.newPupil.lastName.length;
							}

							if (!($scope.newPupil.firstName === null || firstNameLength < 3 
								|| $scope.newPupil.lastName === null || lastNameLength < 3 
								|| $scope.newPupil.tier === null)){ 
								callback_fn($scope.newPupil);
								$scope.newPupil = {};
								modalInstance.close();
							}
						};
						$scope.close = function(){
							modalInstance.close();
						};
					},
					size: 'md'
				});

			});

		}

	}

	function editPupil($uibModal,	toastr,	regexes, pmService)	{
		var directive = {
			restrict: 'A',
			replace: true,
			link: linkFunction
		};
		return directive;
		function linkFunction(scope,	elem,	attrs)	{
			scope.$on('EDIT_PUPIL', function(event,	pupil, callback_fn){
				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/pupil/views/edit-pupil-modal.html',
					controller: function($scope){
						$scope.regexes = regexes;
						$scope.newPupil = {
							firstName:pupil.firstName,
							lastName:pupil.lastName,
							genderId:pupil.genderId,
							monthId: pupil.monthId,
							id: pupil.id,
							tier: pupil.tier
						}

						$scope.save = function(){
							var firstNameLength, lastNameLength;
							if ($scope.newPupil.firstName === undefined) {
								firstNameLength = 0;
							} else {
								firstNameLength = $scope.newPupil.firstName.length;
							}

							if ($scope.newPupil.lastName === undefined) {
								lastNameLength = 0;
							} else {
								lastNameLength = $scope.newPupil.lastName.length;
							}

							if (!($scope.newPupil.firstName === undefined || firstNameLength < 3 
								|| $scope.newPupil.lastName === undefined || lastNameLength < 3 
								|| $scope.newPupil.tier === null)){ 
								callback_fn($scope.newPupil);
								$scope.newPupil = {};
								modalInstance.close();
							}
						};
						$scope.close = function(){
							modalInstance.close();
						};
					},
					size: 'md'
				});

			});

		}

	}

})();

(function() {
	'use strict';

	angular.module('modules.profile',[]).factory('profileService', ['base', function (base) {
		return _.create(base, { });
	}]).controller('profileController', profileController);

	/** @ngInject */
	function profileController(baseService, $scope, $rootScope, $translate, $uibModal, $location, settings, regexes, profileService, $state, toastr) {
		$scope.activeSlide = 0;
		$scope.regexes = regexes;
		$scope.myUser = {};

		$scope.viewState = {
			isReady: false
		}

		baseService.app_initialized = function(evt, args) {
			$scope.user = $rootScope.active_user

			if($location.path() == '/profile/staff' && $rootScope.active_user.role != 'STAFF') {
				location = settings.conf.schoolAppURL;
				return;
			}

			if($location.path() == '/profile/settings' && $rootScope.active_user.role == 'STAFF') {
				location = settings.conf.schoolAppURL;
				return;
			}

			$scope.pwd = {
				oldPassword:'',
				newPassword:''
			};

			$scope.gotoSlide = function(index) {
				$scope.activeSlide = index;
			}

			$scope.sections = [
				{
					'icon':'dripicons-user',
					'label':'EDIT_PROFILE',
					'visible': true
				},
				{
					'icon':'dripicons-user-id',
					'label':'MANAGE_PUPILS',
					'visible': false
				},
				{
					'icon':'dripicons-heart',
					'label':'FAMILY_CONTACTS',
					'visible': false
				},
				{
					'icon':'dripicons-lock',
					'label':'PRIVACY_SETTINGS',
					'visible': false
				},
				{
					'icon':'dripicons-bell',
					'label':'NOTIFICATIONS',
					'visible': false
				}
			];
			
			$scope.staffSections = [
				{
					'icon':'dripicons-user',
					'label':'NAV_EDIT_PROFILE',
					'url':'profile.settings'
				}
			];

			$scope.showDropdown = false;
			$scope.activeSection = $scope.sections[0];
			$scope.activeStaffSection = $scope.staffSections[0];
			

			$scope.chooseSection = function(sec){
				setFalse();
				setTrue(sec);
				$scope.showDropdown = false;
			}

			$scope.setActive = function(sec) {
				$scope.activeSection = sec;
				$scope.showDropdown = false;
			};

			$scope.mySwitch = function(label) {
				var to;
				switch(label) {
				    case 'EDIT_PROFILE':
				        to = '#/profile';
				        break;
				    case 'MANAGE_PUPILS':
				        to = '#/profile/pupils';
				        break;
				    case 'FAMILY_CONTACTS':
				    	to = '#/profile/family';
				    	break;
				    case 'PRIVACY_SETTINGS':
				    	to = '#/profile/privacy';
				    	break;
				    case 'NOTIFICATIONS':
				    	to = '#/profile/notifications';
				    	break;
				    default:
				        to = '#/profile';
				}
				$scope.switchApps(to);
			}

			$scope.toggleDropdown = function() {
				$scope.showDropdown = !$scope.showDropdown;
			}

			function setFalse() {
				for (var i = 0; i < $scope.sections.length; i++) {
					$scope.sections[i].visible= false;
				}
			}

			function setTrue(sec) {
				for (var i = 0; i < $scope.sections.length; i++) {
					if($scope.sections[i].label === sec.label) {
						$scope.sections[i].visible = true;
						$scope.activeSection = $scope.sections[i];
					}
				}
			}
			
			function getInfo() {
				$scope.viewState.isReady = false;
				
				profileService.get('school/v1/get/' + $rootScope.active_school.id + '/staff/' + $rootScope.active_user.id, { 'cache': false }).then(function (response) {
					$scope.viewState.isReady = true;
					$scope.myUser = response.data;
					$scope.myUser.email = response.data.mail;
					$scope.viewState.isReady = true;
				}, 
				function(error) {
					location.href = '/school/#/dashboard/view';
					$scope.viewState.isReady = true;
				})
			}
			
			if($rootScope.active_user.role == 'STAFF')
				getInfo()
			else
				$scope.viewState.isReady = true;

			$scope.update = function() {
				$scope.myUser.userId = $rootScope.active_user.id;
				
				profileService.put('school/v1/update/' + $rootScope.active_school.id + '/staff/' + $scope.myUser.id, $scope.myUser, { }).then(function(response){
					toastr.success($translate.instant('UPDATE_SUCCESSFUL'));
					$rootScope.refreshContext();
					$scope.bd.$setPristine();
				}, 
				function (error) {
					(error.status !== -1 ) ? toastr.error(error.data.error.message || $translate.instant('UPDATE_FAIL')) : _.noop();
					$scope.viewState.isReady = true;
				});
			}

			$scope.updatePassword = function(form) {
				profileService.post('school/v1/changePassword', $scope.pwd, { }).then(function(response) {
					toastr.success($translate.instant('UPDATE_SUCCESSFUL'));
					$scope.pwd = { };
					$scope.confirmPassword = '';
					document.getElementById('confirm-password').value = '';
					$scope.cp.$setPristine();
					$scope.cp.$setUntouched();
				}, 
				function (error) {
					toastr.error(error.data.error.message);
				});
			}

			$scope.uploadAvatar = function () {
				$scope.$broadcast('UPLOAD_PHOTO', {
					'callback_fn':function(response){
						$rootScope.$broadcast('AVATAR_UPDATE')
					},
					'action':'avatarUpload',
					'config':'avatarCropper'
				});
			}

			$scope.deleteAccount = function(form) {
				$scope.deletingAccount = false;
				$scope.deletingAccountError = false;
				var mail = $rootScope.active_user.email;
				var schoolId = $rootScope.active_school.id;

				var modalInstance = $uibModal.open({
					animation: true,
					templateUrl: 'app/profile/views/delete-account-modal.html',
					backdropClass: 'backdrop-zindexed',
					size:'sm',
					controller: function($scope) {
						$scope.vm = { };

						$scope.confirm = function() {
							$scope.deletingAccount = true;

							var values = navigator.platform + window.screen.height + window.screen.width + window.screen.colorDepth;
							$scope.vm.dvcsgn = values;
							$scope.vm.os = navigator.platform;
							$scope.vm.email = mail;
							$scope.vm.school = schoolId;
							
							profileService.put('school/v1/delete/account/schoolStaff', $scope.vm, {'ignoreErrors': true}).then(function(response) {
								location = settings.conf.ssoAppURL;
							}, 
							function (error) {
								$scope.deletingAccount = false;
								if (error.data.error.message === 'ONLY_AMBASSADOR_FOR_THE_SCHOOL') {
									modalInstance.close();
									$scope.openOnlyAmbassadorModal();
								} else {
									$scope.deletingAccountError = error.data.error.message;
								}
							});
						}

						$scope.close = function() {
							modalInstance.close();
						}

						$scope.openOnlyAmbassadorModal = function() {
							var modalInstance = $uibModal.open({
								animation: true,
								templateUrl: 'app/profile/views/only-ambassador-modal.html',
								backdropClass: 'backdrop-zindexed',
								size:'sm',
								controller: function($scope) {
									$scope.close = function() {
										modalInstance.close();
									}
								}
							})
						}
					}
				})
			}
		}
		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}
	}
})();

(function() {
	'use strict';

	angular.module('modules.post',[])
	.factory('homeService', ['base', function (base) {
		return _.create(base, { });
	}])
	.controller('postController', postController);

	/** @ngInject */
	function postController(baseService, $scope, homeService, $timeout, toastr, $translate, storage, $stateParams, $rootScope, $window) {

		baseService.app_initialized = function(evt, args) {
			var postId = $stateParams.id;
			var me = $rootScope.active_user,
				schoolId = $rootScope.active_user.id;
			var cursor = 'none';
			
			$scope.posts = [];
			$scope.userName = me.firstName+' '+me.lastName;

			$scope.viewState = {
				isReady:true,
				isInitiated:false
			}

			$scope.groups = $rootScope.active_user.groups;

			$scope.events = {
				postCallback : function (post) {
					var payload = {
						'postedBy':me.firstName+' '+me.lastName,
						'userId':me.id,
						'avatar':me.avatar,
						'postedOn':new Date(),
						'body':post.body,
						'photo':post.photo,
						'isOwn':true,
						'isLiked':false,
						'likeCount':post.likeCount,
						'commentCount':post.commentCount,
						'groupId':post.groupId,
						'groupName':post.groupName,
						'id':post.id,
						'price':post.price,
						'type':post.type
					};
					
					$scope.posts.unshift(payload);
				},
				removeFromPosts: function(id){
					$scope.posts = $scope.posts.filter(function(el) {
						return el.id !==  id;
					});
				}
			}

			$scope.getPost = function() {
				homeService.get('post/v1/get/'+ postId, { 'xhr': true, 'cache': false }).then(function(response) {
					$scope.viewState.isInitiated = true;
					
					var data = response.data.payload || [];
					angular.forEach(data.posts, function(k,v){
						$scope.posts.push(k)
					})
					$scope.posts = response.data.payload;
					cursor = data.cursor || 0;
				}, 
				function(error) {
					toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
					$scope.viewState.isInitiated = true;
				});
			}
			$scope.getPost();

			$scope.hasMorePosts = function(){
				return $scope.posts.length > 4 && cursor !== 0; 
			}

			$scope.back = function(){
				$window.history.back();
				$rootScope.backFromPost = true;
			}
		}
		
		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}
	}
})();

(function() {
	'use strict';

	angular.module('modules.notifications',[]).factory('notificationsService', ['base', function (base) {
		return _.create(base, { });
	}]).controller('notificationsController', notificationsController);

	/** @ngInject */
	function notificationsController(baseService, $scope, $rootScope, $location, $window, notificationsService, $timeout, toastr, $translate, storage, settings) {

		baseService.app_initialized = function(evt, args) {
			$scope.viewState = {
				isReady: true,
				isInitiated: false,
				adsLoaded: false
			}
			
			$scope.groups = $rootScope.active_user.groups || [];

			$scope.getNotifications = function() {
				notificationsService.get('school/v1/' + $rootScope.active_school.id + '/notification/list/-1', {'cache': false}).then(function (response) {
					$scope.notifications = DTOS.Map(response.data.items || [], 'notification');
					
					if (_.isUndefined($scope.notifications)) {
						$scope.notificationsLength = 0;
					}

					var oldSchoolBase = '';
					var oldParentBase = '';
					var newSchoolBase =  settings.conf.schoolAppURL;
					var newParentBase =  settings.conf.parentAppURL;

					if (settings.conf.type == 'prod'){
						oldSchoolBase = "https://school.classlist.com"
						oldParentBase = "https://parent.classlist.com"
					} else 
					if (settings.conf.type == 'preprod'){
						oldSchoolBase = "https://preprod-school.classlist.com"
						oldParentBase = "https://preprod-parent.classlist.com"
					} else 
					if (settings.conf.type == 'test'){
						oldSchoolBase = "https://test-school.classlist.com"
						oldParentBase = "https://test-parent.classlist.com"
					} else 
					if (settings.conf.type == 'dev'){
						oldSchoolBase = "https://dev-school.classlist.com"
						oldParentBase = "https://dev-parent.classlist.com"
					} else {
						oldSchoolBase = "https://school.classlist.com"
						oldParentBase = "https://parent.classlist.com"
					}

					if($scope.notifications) {
						for (var i = 0; i < $scope.notifications.length; i++) {
							// we dont show approve-parents page in integration
							if($rootScope.active_school.integrationEnabled && $scope.notifications[i].extra && $scope.notifications[i].extra.includes('/approve-parents')){
								// Remove the current item from the array
								$scope.notifications.splice(i, 1);

								// Decrease the index to account for the removed element
								i--;
								continue;
							}
							$scope.notifications[i].extra = $scope.notifications[i].extra.replace(oldSchoolBase, newSchoolBase);
							$scope.notifications[i].extra = $scope.notifications[i].extra.replace(oldParentBase, newParentBase);
						}
					}
		
					$rootScope.notifsContainer.notifications = 0;
					$scope.viewState.showNewNotifications = true;
				});
			}
				
			$scope.markAllRead = function() {
				notificationsService.get('school/v1/clear/notifications/' + $rootScope.active_school.id, { 'cache' : false }).then(function (response) {
					
				});

				$rootScope.notifsContainer.notifications = 0;
				for(var i = 0; i < $scope.notifications.length; i++)
					$scope.notifications[i].read = true;
			}

			$scope.notifRedirect = function(object) {
				notificationsService.get('school/v1/' + $rootScope.active_school.id + '/notification/read/' + object.id, {'cache':false}).then(function (response) {

					if (object.event == 'SCHOOL_SYSTEM_UPDATE') {
						if (object.extra.startsWith(settings.conf.parentAppURL)){
							$scope.$root.switchApps();
						} else {
							location.href = object.extra;	
						}
					}
					else {
						location.href = object.extra;
					}
				}, 
				function(error){
					
				})
			}

			$scope.getNotifications();
		}

		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}
	}
})();

(function() {
	'use strict';

	angular.module('modules.onboarding',[]).factory('onboardingService', ['base','$http', function (base, $http) {
		return _.create(base, { });
	}]).factory('sharedService', ['base', function (base) {
		return _.create(base, { })
	}]).controller('onboardingController', onboardingController);

	/** @ngInject */
	function onboardingController(baseService, $scope, $rootScope, $location, $uibModal, onboardingService, toastr, $translate, $state, $http, $stateParams) {
		$scope.invitedCount = $stateParams.invited;
		
		$scope.invite = function() {
			location.href = '/school/#/invite/add-invite';
		}
	}
})();

(function() {
	'use strict';

	angular.module('modules.nonmember',[]).factory('nonmemberService', ['base', function (base) {
		return _.create(base, { });
	}]).controller('nonmemberController', nonmemberController);

	/** @ngInject */
	function nonmemberController(settings, $rootScope) {
		localStorage.removeItem('redirect_type');
		setTimeout(function(){
			if($rootScope.active_user && $rootScope.active_user.role === 'STAFF'){
				location.href = '/school/#/dashboard/view';
				return;
			}
			location.href = settings.conf.parentAppURL;
		}, 5000);
	}
})();

(function() {
	'use strict';

	angular.module('modules.monitor',[]).factory('monitorService', ['base', function (base) {
		return _.create(base, { });
	}]).controller('monitorController', monitorController);

	/** @ngInject */
	function monitorController(baseService, $scope, $rootScope, $location, monitorService, $timeout, toastr, $translate) {
		var schoolId;
		var cursor = 'none';
		var moreloading = false;
		var spinnerHeight = 150;//extra

		$scope.viewState = {
			isReady:false
		}

		$scope.$on('$destroy', function () {
			if (window.viewpostListener)
				window.viewpostListener();
		});

		baseService.app_initialized = function(evt, args) {

			window.viewpostListener = $rootScope.$on('ON_POST_VIEW_OPEN', function(evt, args) {
				$rootScope.tempPosts = {
					scroll: document.documentElement.scrollTop || document.body.scrollTop,
					posts: $scope.posts,
					cursor: cursor
				};
			})
 
			if($rootScope.backFromPost && $rootScope.tempPosts && $rootScope.tempPosts.posts) {
				$rootScope.backFromPost = false;
				$scope.posts = $rootScope.tempPosts.posts;
				cursor = $rootScope.tempPosts.cursor;
				setTimeout(function() {
					window.scrollBy(0, $rootScope.tempPosts.scroll);
				}, 1);
			}
			else {
				$rootScope.tempPosts = null;
				$scope.posts = [];
			}

		    schoolId = $rootScope.active_school.id;
		    $scope.userName = $rootScope.active_user.firstName+' '+$rootScope.active_user.lastName;
			$scope.getPosts();
		}
			
		$scope.getPosts = function() {
			monitorService.get('post/v1/list/'+cursor+'/'+schoolId, {'xhr':true, 'cache':false}).then(function(response){
				var data = response.data.payload || [];
				
				angular.forEach(data.posts, function(k,v) {
					// TODO: remove next condition after test
					// if(k.type == 'announcement')
					// 	k.type = 'event';

					$scope.posts.push(k)
				})

				cursor = data.cursor || 0;
				$scope.viewState.isReady = true;
				moreloading = false;
				$scope.loadingMorePosts = false;
			}, 
			function(error) {
				toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
				$scope.viewState.isReady = true;

			})
		}

		$scope.hasMorePosts = function(){
			return cursor !== 0 && cursor !== 'none';
		}

		window.addEventListener("scroll", function() {

			if($location.path().indexOf('/monitor') > -1) {
				$scope.loadingMorePosts = true;
				
				if(!$scope.hasMorePosts())
					return;

				var doc = document.documentElement;

				if(window.pageYOffset >= doc.scrollHeight - window.innerHeight - spinnerHeight) {

					if(moreloading)
						return;

					moreloading = true;

					$scope.getPosts();
				}
			}
		});	
		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}	
	}
	
})();

(function() {
	'use strict';

	angular.module('modules.marketplace',[]).factory('marketplaceService', ['base', function (base) {
		return _.create(base, { });
	}]).controller('marketplaceController', marketplaceController);

	/** @ngInject */
	function marketplaceController(baseService, $rootScope) {

		
		baseService.app_initialized = function(evt, args) {}

		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}	
	}
	
})();

(function() {
	'use strict';

	angular.module('modules.marketplace.list',[])
		.controller('marketplaceListController', marketplaceListController);

	/** @ngInject */
	function marketplaceListController(baseService ,$scope, marketplaceService, $rootScope, $location) {
		var schoolId;
		var cursor = 'none';
		var moreloading = false;
		var spinnerHeight = 150;//extra
		$scope.posts = [];

		$scope.viewState = {
			isReady:false
		}

		$scope.$on('$destroy', function () {
			if (window.viewpostListener)
				window.viewpostListener();
		});

		baseService.app_initialized = function(evt, args) {

			window.viewpostListener = $rootScope.$on('ON_POST_VIEW_OPEN', function(evt, args) {
				$rootScope.tempMarketplacePosts = {
					scroll: document.documentElement.scrollTop || document.body.scrollTop,
					posts: $scope.posts,
					cursor: cursor
				};
			})
 
			if($rootScope.backFromPost && $rootScope.tempMarketplacePosts && $rootScope.tempMarketplacePosts.posts) {
				$rootScope.backFromPost = false;
				$scope.posts = $rootScope.tempMarketplacePosts.posts;
				cursor = $rootScope.tempMarketplacePosts.cursor;
				setTimeout(function() {
					window.scrollBy(0, $rootScope.tempMarketplacePosts.scroll);
				}, 1);
			}
			else {
				$rootScope.tempMarketplacePosts = null;
				$scope.posts = [];
			}

		    schoolId = $rootScope.active_school.id;
			$scope.getPosts();
		}
			
		$scope.getPosts = function() {
			marketplaceService.get('marketplace/v1/admin/' +schoolId + '/list/' + cursor, {'xhr':true, 'cache':false}).then(function(response){

				cursor = response.data.cursor || 0;
				
				angular.forEach(response.data.items, function(k,v) {
					$scope.posts.push(k);
				});

				$scope.viewState.isReady = true;
				moreloading = false;
			}, 
			function(error) {
				toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
				$scope.viewState.isReady = true;

			})
		}

		$scope.hasMorePosts = function(){
			return cursor !== 0 && cursor !== 'none';
		}

		window.addEventListener("scroll", function() {

			if($location.path().indexOf('/marketplace') > -1) {
				
				if(!$scope.hasMorePosts()) return;

				var doc = document.documentElement;

				if(window.pageYOffset >= doc.scrollHeight - window.innerHeight - spinnerHeight) {

					if(moreloading) return;

					moreloading = true;

					$scope.getPosts();
				}
			}
		});

		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}		
	}
})();
(function() {
	'use strict';

	angular.module('modules.marketplace.detail',[])
		.controller('marketplaceDetailController', marketplaceDetailController);

	/** @ngInject */
	function marketplaceDetailController(baseService ,$scope, marketplaceService, $rootScope, $stateParams, toastr, $translate) {
		var postId = $stateParams.id;

		$scope.viewState = {
			isReady:true
		}

		baseService.app_initialized = function(evt, args) {
			$scope.getPost();
			
		}
			
		$scope.getPost = function() {
			marketplaceService.get('marketplace/v1/admin/get/' + postId, {'xhr':true, 'cache':false}).then(function(response){
				$scope.post = response.data;
				$scope.viewState.isReady = true;
			}, 
			function(error) {
				toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
				$scope.viewState.isReady = true;

			})
		}

		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}		
	}
})();
(function() {
	'use strict';

	angular.module('modules.invite.nonmemberlist',[])
	.filter('filtermembers', function() {
	  return function(list, filter) {
		var out = [];

		if(!filter)
			return list;

		filter = { keyword: filter };

		if (!filter.keyword && !filter.type) {
			return list;
		}

		for(var i = 0; i < list.length; i++) {
			var guest = list[i];

			if (filter.keyword) {
				if ((guest.firstName
					&& guest.firstName.toLowerCase().indexOf(filter.keyword.toLowerCase()) > -1)
				|| (guest.lastName
					&& guest.lastName.toLowerCase().indexOf(filter.keyword.toLowerCase()) > -1)
				|| (guest.email
					&& guest.email.toLowerCase().indexOf(filter.keyword.toLowerCase()) > -1)
				|| (guest.yearClass
					&& guest.yearClass.toLowerCase().indexOf(filter.keyword.toLowerCase()) > -1)) {
					out.push(guest)
				}
			}
		}

		return out;
	  }
	})
	.controller('nonMemberListController', nonMemberListController);

	/** @ngInject */
	function nonMemberListController(baseService, $scope, settings, storage, $rootScope, inviteService, $uibModal, toastr, $translate, $location, $window, $http, $state) {

		$scope.validateEmail = validateEmail;
		$scope.cursor = 'none';
		$scope.inviteCount = 0;
		$scope.searching = false;

		$scope.parents = [];
		$scope.results = [];
		$scope.viewState = {
			isReady:false
		};
		$window.scrollTo(0, 0);
		//$scope.selectedSelectFilter = { };

		baseService.app_initialized = function(evt, args) {
		if($rootScope.integrationEnabled()){
			window.location.href = '/school/#/invite/add-invite-integration';
			return;
		}
		if($rootScope.isStaffWithoutUserManagementPermission()){
			$rootScope.showStaffWithoutUserManagementPermissionErrorMessage();
			window.location.href = '/school/#/dashboard/view';
			return;
		}
		
		var schoolId = $rootScope.active_school.id;
		$scope.user = $rootScope.active_user;
		$scope.flatStructure = [];

		inviteService.get('school/v1/getSchoolStructureCompact?schoolId='+$rootScope.active_school.id+'&includeEntireSchool=false', {'cache': true }).then(function (response) {
			$scope.schoolStructure = response.data.items;

			for (var i = 0; i < $scope.schoolStructure.length; i++) {
				var tier = $scope.schoolStructure[i];

				tier.hasClasses = tier.children && tier.children.length > 0;
				$scope.flatStructure.push(tier);

				if (!tier.children) {
					continue;
				}

				for (var j = 0; j < tier.children.length; j++) {
					var singleClass = tier.children[j];
					singleClass.hasClasses = false;
					singleClass.isClass = true;
					$scope.flatStructure.push(singleClass);
				}
			}

		},
		function (error) { });

		$http.get('i8n/locale-metadata-en-GB.json?v=12').then(function(data) {
			$scope.relationships = data.data.metadata.relationships;
			$scope.countries = data.data.metadata.countries;
	 	});

		function getParents() {
			$scope.viewState.isReady = false;
			inviteService.get('school/v1/nonMemberParent/' + $scope.cursor + '/list/' + schoolId, {cache:false}).then(function(response) {
				$scope.viewState.isReady = true;
				$scope.viewState.sending = response.data.sending;
				$scope.results = $scope.parents = response.data.invites || [];
				$scope.inviteCount = response.data.totalInvites || $scope.parents.length;
				if(response.data.cursor && response.data.cursor.length > 1){
					$scope.cursor = response.data.cursor;
				} else {
					//hide load more button
					$scope.cursor = '';
				}
			},
			function(error) {
				toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
				$scope.viewState.isReady = true;
			})
		}

		$scope.getAllParents = function() {
			$scope.viewState.isReady = false;
			inviteService.get('school/v1/nonMemberParent/' + $scope.cursor + '/list/' + schoolId, {cache:false}).then(function(response) {
				$scope.viewState.isReady = true;
				$scope.viewState.sending = response.data.sending;
				if (response.data.invites && response.data.invites.length > 0) {
					$scope.results = $scope.parents = $scope.parents.concat(response.data.invites);
				}

				if(response.data.cursor && response.data.cursor.length > 1){
					$scope.cursor = response.data.cursor;
				} else {
					//hide load more button
					$scope.cursor = '';
				}
			},
			function(error) {
				toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
				$scope.viewState.isReady = true;
			})
		}

		$scope.searchInvite = function() {
			if (!$scope.keyword || $scope.keyword.length === 0)
			{
				$scope.searching = false;
				$scope.results = $scope.parents;
			}
			else if ($scope.keyword.length < 3) {
				//$scope.searching = false;
				return;
			}
			else {
				$scope.searching = true;
				$scope.viewState.isReady = false;
				inviteService.get('search/v1/nonMemberParent/' + schoolId + '/' + $scope.keyword, {cache:false}).then(function(response) {
					$scope.viewState.isReady = true;
					if (response.data.invites && response.data.invites.length > 0) {
						$scope.results = response.data.invites;
					} else {
						$scope.results = [];
					}
				},
				function(error) {
					toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
					$scope.viewState.isReady = true;
				})
			}
		}

		$scope.getParents = getParents;

		$scope.editParent = function(parent) {
			parent.editing = true;
		}

		$scope.deleteParent = function(index, parent) {
			var _parents = $scope.parents;

			//if($scope.validateParent(parent)) {
				var modalInstance = $uibModal.open({
					animation: true,
					templateUrl: 'app/invite/views/delete-modal.html',
					backdropClass: 'backdrop-zindexed',
					size:'md',
					controller: function($scope) {

						$scope.confirm = function() {
							if(parent.id) {
								inviteService.delete('school/v1/nonMemberParent/' + schoolId + '/delete/' + parent.id).then(function(response) {
									_parents.splice(index, 1)
								},
								function(error) {

								})
							}
							else {
								_parents.splice(index, 1)
							}
							modalInstance.close();
						}

						$scope.close = function() {
							modalInstance.close();
						}
					}
				})
			// }
			// else {
			// 	_parents.splice(index, 1)
			// }
		}

		$scope.saveParent = function(index, parent) {
			if(!$scope.validateParent(parent))
				return;

			// if(parent.tier_object)
			// 	parent.tierId = parent.tier_object.id;

			if(parent.firstName || parent.lastName) {
				parent.realName = true;
			}

			if(parent.id) {
				inviteService.put('school/v1/nonMemberParent/' + schoolId + '/update', parent).then(function(response) {
					$scope.inviteAll(parent)
				},
				function(error) {
					parent.editing = true;
				})
			}
			// else {
			// 	inviteService.post('school/v1/nonMemberParent/' + schoolId + '/create', parent).then(function(response) {
			// 		parent.id = response.data.payload.id
			// 		$scope.inviteAll(parent)

			// 		//getParents()
			// 	},
			// 	function(error) {
			// 		parent.editing = true;
			// 	})
			// }

			parent.editing = false;
		}

		$scope.inviteAll = function(parent) {

			if(parent && !parent.email) {
				if(!$scope.validateParent(parent))
					return;

				$scope.inviteOne(parent);
				return;
			}

			var modalInstance = $uibModal.open({
				animation: true,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/invite/views/inviteall-modal.html',
				scope: $scope,
				controller: function($scope) {
					$scope.defaultText = $translate.instant('ADD_INDIVIDUALLY_PLACEHOLDER');

					if(parent) {
						$scope.parentEmail = parent.email;
					}

					$scope.send = function() {
						sendInvite(parent, $scope.message)
						modalInstance.close();

						if(parent)
							parent.invitationState = 'PROCESSING';
					}

					$scope.close = function() {
						modalInstance.close();
					}
				},
				size: 'md'
			});
		}
		$scope.onNavigateToUploadHistory = function (){
			$state.go('invite.bulkuploadhistory');
		}

		function sendInvite(parent, message) {

			if(parent){
				var emails = [parent.email];
			}

			var payload = {
				message: message
			}

			if(emails) {
				payload.email = emails;
			}

			inviteService.post('school/v1/nonMemberParent/' + schoolId + '/invite', payload)
			.then(function (response) {
				var modalInstance = $uibModal.open({

						animation: true,
						backdropClass: 'backdrop-zindexed',
						templateUrl: 'app/base/views/invite-success-modal.html',
						scope: $scope,
						controller: function($scope, $rootScope) {
							$scope.num = emails ? emails.length : $scope.inviteCount;

							$scope.close = function() {
								modalInstance.close();
							}
						},
						size: 'md'
				});
			},
			function(error) {
				toastr.error(error.data.error.message);
			})
		};

		function getParentsWithEmail() {
			var arr = []

			for(var i = 0; i < $scope.parents.length; i++)
				if($scope.parents[i].email)
					arr.push($scope.parents[i])

			return arr;
		}

		$scope.validateParent = function(parent) {
			// parent.invalidFirstname = false;
			// parent.invalidLastname = false;
			// parent.invalidRelationship = false;
			parent.invalidEmail = false;
			// parent.invalidTier = false;
			var valid = true;

			// if(!parent.firstName && parent.realName) {
			// 	parent.invalidFirstname = true;
			// 	valid = false;
			// }

			// if(!parent.lastName && parent.realName) {
			// 	parent.invalidLastname = true;
			// 	valid = false;
			// }

			//if(parent.email && parent.realName) {
				if(!$scope.validateEmail(parent.email)) {
					parent.invalidEmail = true;
					valid = false;
				}
			//}

			// if(!parent.realName) {
			// 	if(!$scope.validateEmail(parent.email)) {
			// 		parent.invalidEmail = true;
			// 		valid = false;
			// 	}
			// }

			if(!valid) {
				toastr.info('Please check all the required fileds');
				parent.editing = true;
			}

			return valid;
		}

		$scope.addParent = function() {
			for(var i = 0; i < $scope.parents.length; i++) {
				if(!$scope.validateParent($scope.parents[i])) {
					return;
				}
			}

			$scope.parents.push({
				"firstName": "",
				"lastName": "",
				"email": "",
				editing: true
			})
		}

		getParents();

		setTimeout(function(){
			if($scope.parents.length == 0) {
				getParents();
			}
		},2000);

	}

	$scope.inviteOne = function(parent) {
			var getInviteLink = $scope.getInviteLink;

			//without timeout is not working
				var modalInstance = $uibModal.open({
						animation: true,
						backdropClass: 'backdrop-zindexed',
						templateUrl: 'app/invite/views/invite-modal.html',
						controller: function($scope, $rootScope) {
							$scope.parent = parent;
							$scope.shareBoxVisible = false;
							$scope.showLinkCopyDone = false;

							if(!$scope.link) {
								getInviteLink(function(res) {
									$scope.link = res.url;
									$scope.link_message = res.message;
								})
							}

							$scope.select = function(index) {
								$state.go('invite.bulkemailupload');
							}

							$scope.copyLink = function() {
								copyToClipboard($scope.link);
								$scope.showLinkCopyDone = true;
								angular.element(document.getElementById('showLinkCopyDone')).show();
								$rootScope.userTag('PARENT_INVITED_V2', "LINK:" + $scope.link);
							}

							$scope.shareWhatsapp = function() {
								$rootScope.userTag('PARENT_INVITED_V2', "LINK:" + $scope.link);
								
								var toShare = encodeURIComponent($scope.link_message + ' ' + $scope.link);

								if (!$rootScope.isNative){
									window.open("https://web.whatsapp.com/send?text=" + toShare, "_blank");
								}else{
									$rootScope.openWhatsappNative(toShare);
								}
								return false;
							}

							$scope.shareFacebook = function() {
								modalInstance.close();
								$rootScope.userTag('PARENT_INVITED_V2', "LINK:" + $scope.link);

								var toShare = encodeURIComponent($scope.link);

								if (!$rootScope.isNative){
									window.open('https://www.facebook.com/sharer/sharer.php?u=' +toShare, '_blank');
								} else {
									$rootScope.openFacebookNative(toShare);
								}
								return false;
							}

							$scope.sharePrintable = function() {
								window.open(settings.conf.api + "/generator/invitepdf?sid=" + $rootScope.active_school.id, '_blank');
							}

							$scope.shareQrFlyer = function (printfriendly){
								var link;
								if (printfriendly) {
									link = settings.conf.api + "/generator/invitepdfprintoutgenerator?sid=" + $rootScope.active_school.id + "&zu=" + $rootScope.currentUserId();
								} else {
									link = settings.conf.api + "/generator/invitepdfdigitalgenerator?sid=" + $rootScope.active_school.id + "&zu=" + $rootScope.currentUserId();
								}
								window.open(link, '_self');
							}

							$scope.shareQrGreyFlyer = function (){
								var link = settings.conf.api + "/generator/invitepdfprintoutgreygenerator?sid=" + $rootScope.active_school.id + "&zu=" + $rootScope.currentUserId();
								window.open(link, '_self');
							}
							$scope.showLinkBox = function() {
								$scope.shareBoxVisible = true;
							}

							$scope.close = function() {
								modalInstance.close();
							}
							$scope.integrationEnabled = $rootScope.active_school.integrationEnabled;
							$scope.isTrial = $rootScope.active_school.status == "TRIAL";
						},
						size: 'md'
				});
		};

	if($rootScope.active_school && $rootScope.app_base_ready) {
		baseService.app_initialized();
	}
	}
})();

(function() {
	'use strict';

	angular.module('modules.invite',[]).factory('inviteService', ['base','$http', function (base, $http) {
		return _.create(base, { });
	}]).controller('inviteController', inviteController);

	/** @ngInject */
	function inviteController(baseService, $scope, $rootScope, $location, $uibModal, inviteService, toastr, $translate, $state, $http) {

		$scope.relationships = {};
		$scope.showInfo = true;

		$scope.closeInfo = function() {
			$scope.showInfo = false;
		}
		
		$scope.openDetails = function(user){
			user.relationship = $scope.relationships[user.relationshipToPupil];
			var modalInstance = $uibModal.open({
				animation: true,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/users/views/user-detail-modal.html',
				controller: function($scope){
					$scope.user = user;
					$scope.close = function(){
						modalInstance.close();
					};
				},
				size: 'sm'
			});
		}

		$scope.openEdit = function(user) {
			user.tier = {id: user.firstTierId, name: user.firstTier};
			var modalInstance = $uibModal.open({
				animation: true,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/users/views/add-nonmember-edit.html',
				controller: function($scope) {
					var lastNameLength, firstNameLength;
					$scope.user = user;
					$scope.id = user.id;
					$scope.tier = { id: user.secondTierId && user.secondTierId != '0' ? user.secondTierId : user.firstTierId };
					$scope.email = user.email;
					$scope.originalFirstName = user.firstName;
					$scope.originalLastName = user.lastName;

					if (user.firstName.includes('Invited')  && user.lastName.includes('Parent')) {
						$scope.firstName = '';
						$scope.lastName = '';
					}else {
						$scope.firstName = user.firstName;
						$scope.lastName = user.lastName;
					}

					checkFirstNameError();
			        checkLastNameError();
			        setNamesLength();

					$scope.close = function() {
						modalInstance.close();
					};

				    $scope.$watchGroup(['firstName.length','lastName'], function() {
				        checkFirstNameError();
				        checkLastNameError();
				        checkNamesError();			        
				    });

					function setNamesLength(){
						_.isUndefined($scope.lastName) ? lastNameLength = 0 : lastNameLength = $scope.lastName.length
						_.isUndefined($scope.firstName) ? firstNameLength = 0 : firstNameLength = $scope.firstName.length
					}

					function checkLastNameError(){
						setNamesLength()
						if (firstNameLength > 0  || lastNameLength === 0 && $scope.originalLastName.includes('Parent') ) {
							$scope.lastNameError = true;
						}else {
							$scope.lastNameError = false;
						}
					}

					function checkFirstNameError(){
						setNamesLength()
						if (lastNameLength > 0 || firstNameLength === 0 && $scope.originalFirstName.includes('Invited')) {
							$scope.firstNameError = true;
						}else {
							$scope.firstNameError = false;
						}
					}

					function checkNamesError(){
						setNamesLength();
						if ($scope.originalFirstName.includes('Invited') && $scope.originalLastName.includes('Parent')) {
							if (lastNameLength === 0 && firstNameLength === 0) {
								$scope.namesError = true;
							}else {
								$scope.namesError = false;
							}
						}else if (lastNameLength === 0 && firstNameLength === 0){
							$scope.namesError = true;
						}
					}

					$scope.save = function() {

						var payload = {
							'id': $scope.id,
							'tier':$scope.tier.id,
							'firstName': $scope.firstName,
							'lastName': $scope.lastName,
							'email' : $scope.email
						}

						if ($scope.firstName == '' && $scope.lastName == '') {
							payload.firstName = $scope.originalFirstName;
							payload.lastName = $scope.originalLastName;
						}

						inviteService.put('school/v1/nonMemberParent/'+ $rootScope.active_school.id +'/update', payload,
						{'xhr':true})
						.then(function(response) {
							$scope.close();
							toastr.info('Update successful');
							$state.reload();
						}, 
						function(error){
							toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
						})
					}
				},
				size: 'sm'
			});
		}
	}

})();

(function() {
	'use strict';

	angular.module('modules.invite.integrationNonmemberlist',[])
	.filter('filtermembers', function() {
	  return function(list, filter) {
		var out = [];

		if(!filter)
			return list;

		filter = { keyword: filter };

		if (!filter.keyword && !filter.type) {
			return list;
		}

		for(var i = 0; i < list.length; i++) {
			var guest = list[i];

			if (filter.keyword) {
				if ((guest.firstName
					&& guest.firstName.toLowerCase().indexOf(filter.keyword.toLowerCase()) > -1)
				|| (guest.lastName
					&& guest.lastName.toLowerCase().indexOf(filter.keyword.toLowerCase()) > -1)
				|| (guest.email
					&& guest.email.toLowerCase().indexOf(filter.keyword.toLowerCase()) > -1)
				|| (guest.yearClass
					&& guest.yearClass.toLowerCase().indexOf(filter.keyword.toLowerCase()) > -1)) {
					out.push(guest)
				}
			}
		}

		return out;
	  }
	})
	.controller('integrationNonMemberListController', integrationNonMemberListController);

	/** @ngInject */
	function integrationNonMemberListController(baseService, $scope, settings, storage, $rootScope, inviteService, $uibModal, toastr, $translate, $location, $window, $http, $state) {

		$scope.validateEmail = validateEmail;
		$scope.cursor = 'none';
		$scope.inviteCount = 0;
		$scope.searching = false;

		$scope.parents = [];
		$scope.results = [];
		$scope.viewState = {
			isReady:false
		};
		$window.scrollTo(0, 0);
		//$scope.selectedSelectFilter = { };

		baseService.app_initialized = function(evt, args) {
		if($rootScope.isStaffWithoutUserManagementPermission()){
			$rootScope.showStaffWithoutUserManagementPermissionErrorMessage();
			window.location.href = '/school/#/dashboard/view';
			return;
		}
		
		var schoolId = $rootScope.active_school.id;
		$scope.user = $rootScope.active_user;
		$scope.flatStructure = [];
		$scope.accordionParent = {};
		$scope.accordionSentInviteParent = {};
		$scope.accordionFailedInviteParent = {};
		$scope.accordionRecentlyApproved = {}
		
		function setParentAccordion(accordion, parents){
			for (var parent in parents){
				accordion[parent] = {
					open:  false
				}
			}
		}
		inviteService.get('school/v1/getSchoolStructureCompact?schoolId='+$rootScope.active_school.id+'&includeEntireSchool=false', {'cache': true }).then(function (response) {
			$scope.schoolStructure = response.data.items;

			for (var i = 0; i < $scope.schoolStructure.length; i++) {
				var tier = $scope.schoolStructure[i];

				tier.hasClasses = tier.children && tier.children.length > 0;
				$scope.flatStructure.push(tier);

				if (!tier.children) {
					continue;
				}

				for (var j = 0; j < tier.children.length; j++) {
					var singleClass = tier.children[j];
					singleClass.hasClasses = false;
					singleClass.isClass = true;
					$scope.flatStructure.push(singleClass);
				}
			}

		},
		function (error) { });

		$http.get('i8n/locale-metadata-en-GB.json?v=12').then(function(data) {
			$scope.relationships = data.data.metadata.relationships;
			$scope.countries = data.data.metadata.countries;
	 	});

		// Newly Added Variables for Failed and Sent Lists
		$scope.failedInvites = [];
		$scope.sentInvites = [];
		$scope.failedCursor = '';
		$scope.sentCursor = '';
		$scope.failedInviteCount = 0;
		$scope.sentInviteCount = 0;

		// Function to Get Failed Invites
		function getFailedInvites() {
			inviteService.get('school/v1/nonMemberParent/integration/' + $scope.failedCursor + '/list/' + $rootScope.active_school.id+'/emailStatus/false', { cache: false })
			.then(function(response) {
				$scope.viewState.isReady = true;
				if(response.data.invites && response.data.invites.length > 0){
					$scope.failedInvites = $scope.failedInvites.concat(response.data.invites);
					$scope.failedInviteCount = response.data.totalInvites;
				}
				$scope.failedCursor = response.data.cursor || '';
				setParentAccordion($scope.accordionFailedInviteParent, $scope.failedInvites)
			},
			function(error) {
				toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
				$scope.viewState.isReady = true;
			});
		}

		// Function to Get Sent Invites
		function getSentInvites() {
			inviteService.get('school/v1/nonMemberParent/integration/' + $scope.sentCursor + '/list/' + $rootScope.active_school.id+'/emailStatus/true', { cache: false })
			.then(function(response) {
				$scope.viewState.isReady = true;
				if(response.data.invites && response.data.invites.length > 0){
					$scope.sentInvites = $scope.sentInvites.concat(response.data.invites);
					$scope.sentInviteCount = response.data.totalInvites;
				}
				$scope.sentCursor = response.data.cursor || '';
				setParentAccordion($scope.accordionSentInviteParent, $scope.sentInvites)
			},
			function(error) {
				toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
				$scope.viewState.isReady = true;
			});
		}

		// Function to Load More Failed Invites
		$scope.loadMoreFailedInvites = function() {
			getFailedInvites();
		};

		// Function to Load More Sent Invites
		$scope.loadMoreSentInvites = function() {
			getSentInvites();
		};

		function getParents() {
			$scope.viewState.isReady = false;
			$scope.failedInvites = [];
			$scope.sentInvites = [];
			$scope.sentInviteCount = 0;
			$scope.failedInviteCount = 0;
			$scope.failedCursor = '';
			$scope.sentCursor = '';
			getFailedInvites();
			getSentInvites();
		}

		$scope.copyPrivateLink = function (parent) {
			copyToClipboard(parent.inviteLink);
			toastr.success($translate.instant("LINK_COPIED"));
		};

		$scope.integrationEnabled = function(){
			return $rootScope.integrationEnabled();
		}

		$scope.redirectToIntegration = function () {
			window.location.href = "/integration/#/dashboard?s="+$rootScope.active_school.id
		}

		$scope.searchInvite = function() {
			if (!$scope.keyword || $scope.keyword.length === 0)
			{
				$scope.searching = false;
				$scope.results = [];
			}
			else if ($scope.keyword.length < 3) {
				//$scope.searching = false;
				return;
			}
			else {
				$scope.searching = true;
				$scope.viewState.isReady = false;
				inviteService.get('search/v1/nonMemberParent/masked/' + schoolId + '/' + $scope.keyword, {cache:false}).then(function(response) {
					$scope.viewState.isReady = true;
					if (response.data.invites && response.data.invites.length > 0) {
						$scope.results = response.data.invites;
						setParentAccordion($scope.accordionParent, $scope.results)
					} else {
						$scope.results = [];
					}
				},
				function(error) {
					toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
					$scope.viewState.isReady = true;
				})
			}
		}

		$scope.getParents = getParents;

		$scope.editParent = function(parent) {
			parent.editing = true;
		}

		$scope.deleteParent = function(index, parent) {
			var _parents = $scope.parents;

			//if($scope.validateParent(parent)) {
				var modalInstance = $uibModal.open({
					animation: true,
					templateUrl: 'app/invite/views/delete-modal.html',
					backdropClass: 'backdrop-zindexed',
					size:'md',
					controller: function($scope) {

						$scope.confirm = function() {
							if(parent.id) {
								inviteService.delete('school/v1/nonMemberParent/' + schoolId + '/delete/' + parent.id).then(function(response) {
									_parents.splice(index, 1)
								},
								function(error) {

								})
							}
							else {
								_parents.splice(index, 1)
							}
							modalInstance.close();
						}

						$scope.close = function() {
							modalInstance.close();
						}
					}
				})
			// }
			// else {
			// 	_parents.splice(index, 1)
			// }
		}

		$scope.saveParent = function(index, parent) {
			if(!$scope.validateParent(parent))
				return;

			// if(parent.tier_object)
			// 	parent.tierId = parent.tier_object.id;

			if(parent.firstName || parent.lastName) {
				parent.realName = true;
			}

			if(parent.id) {
				inviteService.put('school/v1/nonMemberParent/' + schoolId + '/update', parent).then(function(response) {
					$scope.inviteAll(parent)
				},
				function(error) {
					parent.editing = true;
				})
			}
			// else {
			// 	inviteService.post('school/v1/nonMemberParent/' + schoolId + '/create', parent).then(function(response) {
			// 		parent.id = response.data.payload.id
			// 		$scope.inviteAll(parent)

			// 		//getParents()
			// 	},
			// 	function(error) {
			// 		parent.editing = true;
			// 	})
			// }

			parent.editing = false;
		}

		$scope.inviteAll = function(parent) {

			if(parent && !parent.email) {
				if(!$scope.validateParent(parent))
					return;

				$scope.inviteOne(parent);
				return;
			}
			
			var inviteCount = $scope.failedInviteCount + $scope.sentInviteCount;
			var modalInstance = $uibModal.open({
				animation: true,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/invite/views/inviteall-modal.html',
				scope: $scope,
				controller: function($scope) {
					$scope.defaultText = $translate.instant('ADD_INDIVIDUALLY_PLACEHOLDER');
					$scope.inviteCount = inviteCount;
					if(parent) {
						$scope.parentEmail = parent.email;
					}

					$scope.send = function() {
						sendInvite(parent, $scope.message)
						modalInstance.close();

						if(parent)
							parent.invitationState = 'PROCESSING';
					}

					$scope.close = function() {
						modalInstance.close();
					}
				},
				size: 'md'
			});
		}
		$scope.onNavigateToUploadHistory = function (){
			$state.go('invite.bulkuploadhistory');
		}

		function sendInvite(parent, message) {

			if(parent){
				var emails = [parent.email];
			}

			var payload = {
				message: message
			}

			if(emails) {
				payload.email = emails;
			}

			inviteService.post('school/v1/nonMemberParent/' + schoolId + '/invite', payload)
			.then(function (response) {
				var inviteCount = $scope.failedInviteCount + $scope.sentInviteCount;
				var modalInstance = $uibModal.open({

						animation: true,
						backdropClass: 'backdrop-zindexed',
						templateUrl: 'app/base/views/invite-success-modal.html',
						scope: $scope,
						controller: function($scope, $rootScope) {
							$scope.num = emails ? emails.length : inviteCount;

							$scope.close = function() {
								modalInstance.close();
							}
						},
						size: 'md'
				});
			},
			function(error) {
				toastr.error(error.data.error.message);
			})
		};

		function getParentsWithEmail() {
			var arr = []

			for(var i = 0; i < $scope.parents.length; i++)
				if($scope.parents[i].email)
					arr.push($scope.parents[i])

			return arr;
		}

		$scope.validateParent = function(parent) {
			// parent.invalidFirstname = false;
			// parent.invalidLastname = false;
			// parent.invalidRelationship = false;
			parent.invalidEmail = false;
			// parent.invalidTier = false;
			var valid = true;

			// if(!parent.firstName && parent.realName) {
			// 	parent.invalidFirstname = true;
			// 	valid = false;
			// }

			// if(!parent.lastName && parent.realName) {
			// 	parent.invalidLastname = true;
			// 	valid = false;
			// }

			//if(parent.email && parent.realName) {
				if(!$scope.validateEmail(parent.email)) {
					parent.invalidEmail = true;
					valid = false;
				}
			//}

			// if(!parent.realName) {
			// 	if(!$scope.validateEmail(parent.email)) {
			// 		parent.invalidEmail = true;
			// 		valid = false;
			// 	}
			// }

			if(!valid) {
				toastr.info('Please check all the required fileds');
				parent.editing = true;
			}

			return valid;
		}

		$scope.addParent = function() {
			for(var i = 0; i < $scope.parents.length; i++) {
				if(!$scope.validateParent($scope.parents[i])) {
					return;
				}
			}

			$scope.parents.push({
				"firstName": "",
				"lastName": "",
				"email": "",
				editing: true
			})
		}

		getParents();

		setTimeout(function(){
			if($scope.sentInviteCount == 0 && $scope.failedInviteCount == 0) {
				getParents();
			}
		},2000);

	}

	$scope.inviteOne = function(parent) {
			var getInviteLink = $scope.getInviteLink;

			//without timeout is not working
				var modalInstance = $uibModal.open({
						animation: true,
						backdropClass: 'backdrop-zindexed',
						templateUrl: 'app/invite/views/invite-modal.html',
						controller: function($scope, $rootScope) {
							$scope.parent = parent;
							$scope.shareBoxVisible = false;
							$scope.showLinkCopyDone = false;

							if(!$scope.link) {
								getInviteLink(function(res) {
									$scope.link = res.url;
									$scope.link_message = res.message;
								})
							}

							$scope.select = function(index) {
								$state.go('invite.bulkemailupload');
							}

							$scope.copyLink = function() {
								copyToClipboard($scope.link);
								$scope.showLinkCopyDone = true;
								angular.element(document.getElementById('showLinkCopyDone')).show();
								$rootScope.userTag('PARENT_INVITED_V2', "LINK:" + $scope.link);
							}

							$scope.shareWhatsapp = function() {
								$rootScope.userTag('PARENT_INVITED_V2', "LINK:" + $scope.link);

								var toShare = encodeURIComponent($scope.link_message + ' ' + $scope.link);

								if (!$rootScope.isNative){
									window.open("https://web.whatsapp.com/send?text=" + toShare, "_blank");
								}else{
									$rootScope.openWhatsappNative(toShare);
								}
								return false;
							}

							$scope.shareFacebook = function() {
								modalInstance.close();
								$rootScope.userTag('PARENT_INVITED_V2', "LINK:" + $scope.link);

								var toShare = encodeURIComponent($scope.link);

								if (!$rootScope.isNative){
									window.open('https://www.facebook.com/sharer/sharer.php?u=' +toShare, '_blank');
								} else {
									$rootScope.openFacebookNative(toShare);
								}
								return false;
							}

							$scope.sharePrintable = function() {
								window.open(settings.conf.api + "/generator/invitepdf?sid=" + $rootScope.active_school.id, '_blank');
							}

							$scope.shareQrFlyer = function (printfriendly){
								var link;
								if (printfriendly) {
									link = settings.conf.api + "/generator/invitepdfprintoutgenerator?sid=" + $rootScope.active_school.id + "&zu=" + $rootScope.currentUserId();
								} else {
									link = settings.conf.api + "/generator/invitepdfdigitalgenerator?sid=" + $rootScope.active_school.id + "&zu=" + $rootScope.currentUserId();
								}
								window.open(link, '_self');
							}

							$scope.shareQrGreyFlyer = function (){
								var link = settings.conf.api + "/generator/invitepdfprintoutgreygenerator?sid=" + $rootScope.active_school.id + "&zu=" + $rootScope.currentUserId();
								window.open(link, '_self');
							}
							$scope.showLinkBox = function() {
								$scope.shareBoxVisible = true;
							}

							$scope.close = function() {
								modalInstance.close();
							}
							$scope.integrationEnabled = $rootScope.active_school.integrationEnabled;
							$scope.isTrial = $rootScope.active_school.status == "TRIAL";
						},
						size: 'md'
				});
		};

	if($rootScope.active_school && $rootScope.app_base_ready) {
		baseService.app_initialized();
	}
	}
})();

(function() {
	'use strict';

	angular.module('modules.invite.bulkuploadhistory',[]).factory('inviteService', ['base', function (base) {
		return _.create(base, { });
	}]).controller('bulkuploadhistoryController', bulkuploadhistoryController);

	/** @ngInject */
	function bulkuploadhistoryController(baseService ,$scope, toastr, $translate, inviteService, $state, $uibModal, $window, $rootScope, $stateParams, storage, uploadService, settings) {
		$scope.uploads = [];
		$scope.accordionUpload = {};
		$scope.viewState = {
			isReady:false
		};

		$scope.redirectPages = $stateParams.redirectPages;

		baseService.app_initialized = function(evt, args) {
			if($rootScope.isStaffWithoutUserManagementPermission()){
				$rootScope.showStaffWithoutUserManagementPermissionErrorMessage();
				window.location.href = '/school/#/dashboard/view';
				return;
			}
			//Get list of CVS Files.
			inviteService.get('school/v1/csvUpload/'+$rootScope.active_school.id+'/list', {'cache': true }).then(function (response) {
				$scope.uploads = response.data.items;
				$scope.viewState.isReady  = true;
				$scope.setUploadAccordion();
			}, 
			function (error) { });
        
            $scope.setUploadAccordion = function (){
                for (var upload in $scope.uploads){
                    $scope.accordionUpload[upload] = {
                        open:  false
                    }
                }
                
			}
			$scope.onDownloadButtonClicked = function(group, index, isSuccess) {
				var attachmentId = group.id;
				var schoolId = $rootScope.active_school.id;
				var userId = $rootScope.active_user.id;
				var type = isSuccess ? 'SUCCESS' : 'ERROR'
				
				var url = settings.gae.rootUrl + 'attachment?id=' +attachmentId + '&sid='+schoolId+'&t='+type+'&type=nonMemberCsvUploadResult&zu=' + userId;
				window.open(url, "_blank");
				
			}
			$scope.openInfo = function () {
				window.open('https://help.classlist.com/hc/en-us/articles/209890185-Inviting-Parents-in-Admin-Mode', '_blank');
			}

			$scope.back = function(redirectPages){
				$rootScope.evaluateBack(redirectPages);
			}
	}
		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}		
	}
})();
(function() {
	'use strict';

	angular.module('modules.invite.bulkemailupload',[]).factory('inviteService', ['base', function (base) {
		return _.create(base, { });
	}]).controller('bulkEmailUploadController', bulkEmailUploadController);

	/** @ngInject */
	function bulkEmailUploadController(baseService ,$scope, toastr, $translate, inviteService, $state, $uibModal, $window, $rootScope, $stateParams, storage, uploadService) {
		var fileUploader;
		$scope.viewState = {
			isReady:false
		}
		$scope.isClicked = false;
		$scope.isInvalid = false;
		$scope.showInfo = false;
		$scope.flatStructure = [];
		
		$scope.roles = [
			{"text":"Parent","value":"PARENT"},
			{"text":"Ambassador","value":"AMBASSADOR"},
			{"text":"Class Rep","value":"CLASS_REP"},
			{"text":"Community Representative","value":"COMM_REP"}
		];
		$scope.isUploading = false;
		$scope.hasFileUploaded = false;
		$scope.classNotSelected = false;
		$scope.uploadedCSVFiles = [];
		$scope.columns = [];
		$scope.fileId = "";
		$scope.uploads = [];

		$scope.accordionUpload = {};

		$scope.openInfo = function() {
			$scope.showInfo = true;
		}

		$scope.closeInfo = function() {
			$scope.showInfo = false;
		}

		baseService.app_initialized = function(evt, args) {
			if($rootScope.isStaffWithoutUserManagementPermission()){
				$rootScope.showStaffWithoutUserManagementPermissionErrorMessage();
				window.location.href = '/school/#/dashboard/view';
				return;
			}
			$scope.canAssignRole = $rootScope.active_user && ($rootScope.active_user.role == "AMBASSADOR" || $rootScope.active_user.role == "STAFF");
			inviteService.get('school/v1/getSchoolStructureCompact?schoolId='+$rootScope.active_school.id+'&includeEntireSchool=false', {'cache': true }).then(function (response) {
				$scope.schoolStructure = response.data.items;
					$scope.viewState.isReady = true;

				for (var i = 0; i < $scope.schoolStructure.length; i++) {
					var tier = $scope.schoolStructure[i];

					tier.hasClasses = tier.children && tier.children.length > 0;
					$scope.flatStructure.push(tier);

					if (!tier.children) {
						continue;
					}

					for (var j = 0; j < tier.children.length; j++) {
						var singleClass = tier.children[j];
						singleClass.hasClasses = false;
						singleClass.isClass = true;
						$scope.flatStructure.push(singleClass);
					}
				}
			},
			function (error) { });


			//Get list of CVS Files.
			/*
			inviteService.get('school/v1/csvUpload/'+$rootScope.active_school.id+'/list', {'cache': true }).then(function (response) {
				$scope.uploads = response.data.items;
				$scope.setUploadAccordion();
			},
			function (error) { });
			 */

		$scope.redirectPages = $stateParams.redirectPages;

		var saveButtonDisabled = false;

		var schoolId = $rootScope.active_school.id;

		$scope.back = function(redirectPages){
			$rootScope.evaluateBack(redirectPages);
		}

		//watch if there is change on the email field
		$scope.$watch('emails', function() {
	        checkEmails()
		});

		$scope.uploadBulkCSV = function () {
			fileUploader.click();
		}

		$scope.saveUpload = function() {
			var errorMessage = $scope.validateUploadForm();
			if(errorMessage != ""){
				//there is an error
				toastr.error(errorMessage);
				return;
			}

			var requestObject = {
				"fileId": $scope.fileId,
				"message": $scope.message,
				"firstNameFieldName": $scope.firstNameSelection,
				"lastNameFieldName": $scope.lastNameSelection,
				"yearFieldName" : $scope.yearSelection,
				"classFieldName" : $scope.classSelection,
				"emailFieldName" : $scope.emailSelection
			};
			//all values are okay, so we can send values to server...
			inviteService.post('school/v1/csvUpload/' + schoolId + '/process',requestObject,{'xhr':true}).then(function(response) {
				toastr.info("Your file is being processed");
				$state.go('invite.bulkuploadhistory');

			},
			function(error) {
				toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));

			});

		}

		$scope.validateUploadForm = function() {

			var errorText = "";
			//validate the form
			if(!$scope.hasFileUploaded){
				errorText = "File is not uploaded yet";
				return errorText;
			}
			var values = [$scope.firstNameSelection,$scope.lastNameSelection,$scope.yearSelection,$scope.classSelection,$scope.emailSelection];
			var columnsCopy = $scope.columns.slice(0);

			for(var i=0;i < values.length;i++){
				var value = values[i];
				if(!value){
					errorText = "Selection column is missing.";
					return errorText;
				}
				var index = columnsCopy.indexOf(value);
				if(index > -1){
					columnsCopy.splice(index, 1);
				} else {
					errorText = "Duplicate column selection. Please check again."; //double selection
					return errorText;
				}
			}

			if(columnsCopy.length > 0){
				errorText = "Duplicate column selection. Please check again."; //double selection
				return errorText;
			}
			return errorText;
		}

		$scope.selectClass = function() {
			if($scope.tier) {
				$scope.classNotSelected = false;
			}
		}

		$scope.selectRole = function (item) {
			$scope.role = item.role
		}

		$scope.save = function() {
			$rootScope.isDirty = false;

			if (saveButtonDisabled) {
				return;
			}

			if ($scope.role === 'CLASS_REP' && !$scope.tier) {
				$scope.classNotSelected = true;
				return;
			}

			saveButtonDisabled = true;

			$scope.pendingRequest = true;
			$scope.isClicked = true;
			$scope.isInvalid = false;
			var sendtier = {
				"id" : null,
				"emails" : []
			}

			if (_.isUndefined($scope.tier)) {
				sendtier.id = -1;
			} else {
				sendtier.id = $scope.tier;
			}

			var splittedEmail = parseEmails($scope.emails);
			if (splittedEmail === null) {
				$scope.isInvalid = true;
				saveButtonDisabled = false;
			} else {
				splittedEmail = reduceDuplicates(splittedEmail);
			}


			// Add 'Invited Parent' name to every email address
			var invitedMembers = []
			if (!_.isUndefined(splittedEmail) && splittedEmail !== null) {
				for (var i = 0; i < splittedEmail.length; i++) {
					var info = {
						"email": splittedEmail[i],
						"firstName": $scope.defaultFirstName,
						"lastName": $scope.defaultLastName
					}
					invitedMembers.push(info)
				}
			}
			sendtier.emails = invitedMembers;

			var sendtiers = [];
			sendtiers.push(sendtier);
			if (sendtier.emails.length !== 0) {
				if(!$scope.role || $scope.role ==''){
					$scope.role = "PARENT";
				}
				var payload = {
					schoolId:schoolId,
					tiers: sendtiers,
					message: $scope.message,
					repRole:$scope.role
				};

				$scope.sending = true;

				inviteService.post('school/v1/nonMemberParent/create/bulk', payload)
				.then(function (response) {
					var modalInstance = $uibModal.open({
						animation: true,
						backdropClass: 'backdrop-zindexed',
						templateUrl: 'app/base/views/invite-success-modal.html',
						controller: function($scope, $rootScope) {
							$scope.num = sendtier.emails.length;

							$scope.close = function() {
								modalInstance.close();
							}
						},
						size: 'md'
					});

					$scope.isClicked = false;
					clear();
					saveButtonDisabled = false;
					$scope.sending = false;
					$state.go('invite.nonmemberlist');
				},
				function(error) {
					saveButtonDisabled = false;
					$scope.pendingRequest = false;
					$scope.viewState.isReady = true;
					toastr.error(error.data.error.message);
					$scope.sending = false;
				})
			}
		}

		$scope.cancel = function() {
			$state.go('invite.nonmemberlist');
		}

		$scope.switchTab = function(tabName){
			if(tabName == 'upload'){
				var removedContainer = angular.element(document.getElementById("manualTabPane"));
				removedContainer.removeClass('active');
				var container = angular.element(document.getElementById("uploadTabPane"));
				container.addClass('active');
			}

			if(tabName == 'manual'){
				var removedContainer = angular.element(document.getElementById("uploadTabPane"));
				removedContainer.removeClass('active');
				var container = angular.element(document.getElementById("manualTabPane"));
				container.addClass('active');
			}
		}
		$scope.switchTab('manual');

/*
		$scope.setUploadAccordion = function (){
			for (var upload in $scope.uploads){
				$scope.accordionUpload[upload] = {
					open:  false
				}
			}
		}*/

		$scope.openHelpdesk = function (x) {
			if (x === 1) {
				window.open('https://help.classlist.com/hc/en-us/articles/360013454978', '_blank');
			} else {
				window.open('https://help.classlist.com/hc/en-us/articles/213577865-Classlist-Roles-and-Functionality-summary-table', '_blank');
			}
		}

		function reduceDuplicates(array) {
			if (!_.isUndefined(array)) {
				var sortedEmail = array.sort();
				var results = [];
				for (var i = 0; i < array.length; i++) {
					if (sortedEmail[i+1] != sortedEmail[i]) {
						results.push(sortedEmail[i]);
					}
				}
				return results;
			}
		}

		function parseEmails(input) {
			if (!_.isUndefined(input)) {
				return input.match(/([a-zA-Z0-9+._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi);
			}
		}

		function clear(){
			$scope.pendingRequest = false;
			$scope.viewState.isReady = true;
			$scope.isClicked = false;
			$scope.tier  = '';
			$scope.emails = '';
		}

		function checkEmails() {
			var emailsLength;
			_.isUndefined($scope.emails) ? emailsLength = 0 : emailsLength = $scope.emails.length;
			emailsLength !== 0 ? $rootScope.isDirty = true : $rootScope.isDirty = false;
		}
		/*
		fileUploader = document.getElementById('fileUploader');
			fileUploader.onchange = function() {
				$scope.isUploading = true;

				var file  = fileUploader.files[0],
					reader = new FileReader();

				if (file) {
					if (file.size > 20000000){ //20mb
						toastr.info($translate.instant("FILE_SIZE_TOO_BIG"));
						$scope.isUploading = false;
						return;
					}

					reader.readAsDataURL(file);
				}
				else {
					$scope.isUploading = false;
				}

				reader.addEventListener('load', function () {
					$scope.isUploading = true;

					uploadService.fileUpload(dataURItoBlob(reader.result),
						{
						headers: {
							'Content-Type': undefined,
							'ClasslistToken':storage.getToken() || '',
							'ClasslistCfg':angular.toJson({
								'type':'SCHOOL_INVITE_CSV',
								'id': $rootScope.active_school.id
							})
						}
						},
						file.name).then(function(response) {

						toastr.info($translate.instant('ATTACHED_SUCCESSFULLY'));
						$scope.isUploading = false;
						$scope.hasFileUploaded = true;
						$scope.columns = response.data.payload.columns;
						$scope.fileId = response.data.payload.fileId;

						},
						function(error) {
						$scope.isUploading = false;

						if (error.status == -1){
							return;
						}

						if (error.status === 403 || error.status === 409 || error.status === 400) {
							var divError = document.createElement('html');
							divError.innerHTML = error.data;
							var arr = divError.getElementsByTagName("body");
							if(arr.length > 0){
								toastr.error($translate.instant(arr[0].innerText));
							} else {
								toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
							}
						}
						else {
							toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
						}

					});
				}, false);
			}
		 */

		$scope.defaultEmails = $translate.instant('START_TYPING_EMAILS');
		$scope.defaultTier = $translate.instant('START_TYPING_TIER_OPTIONAL_PHOLDER');
		$scope.defaultFirstName = $translate.instant('DEFAULT_FIRSTNAME_PLACEHOLDER');
		$scope.defaultLastName = $translate.instant('DEFAULT_LASTNAME_PLACEHOLDER');

		setTimeout(function() {
			$scope.message = $scope.defaultText = $translate.instant('ADD_INDIVIDUALLY_PLACEHOLDER');
			$scope.$apply();
		}, 100);
		
		$scope.isTrial = $rootScope.active_school.status == "TRIAL";
	}

		if($rootScope.active_school && $rootScope.app_base_ready) {
			baseService.app_initialized();
		}
	}
})();

(function() {
	'use strict';

	angular.module('modules.post.likes',[]).factory('pmService', ['base', function (base)	{
		return _.create(base, { });
	}]).directive('postLikes', postLikes);

	/** @ngInject */
	function postLikes($uibModal, $rootScope, toastr, regexes, pmService)	{
		var directive = {
			restrict: 'A',
			replace: true,
			link: linkFunction
		};
		return directive;

		function linkFunction(scope, elem, attrs)	{

			scope.$on('POST_LIKES', function(event,	object){
				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/groups/views/post-likes-modal.html',
					controller: function($scope){
						$scope.object = object;
						setTimeout(function() {
							angular.element(document.querySelector('.likes-modal'))
							.parent().parent().addClass('modal-likes-size');
						}, 1);

						$scope.openLiker = function(liker) {
							modalInstance.close();

							if($rootScope.active_user.id === liker.userId)
								location.href = '#/profile';
							else
								location.href = '#/classlist/details/' + liker.userId + '/contact';
						}

						$scope.close = function(){
							modalInstance.close();
						};
					}
				});

			});
		}
	}

})();

(function() {
	'use strict';

	angular.module('modules.groups.interestGroups',[])
	.controller('interestGroupsListController', interestGroupsListController);

	/** @ngInject */
	function interestGroupsListController($scope, groupsService, $filter, $uibModal, $rootScope, toastr, $translate, $state, baseService) {

		$scope.viewState = {
			isReady:false
		}
		
		$scope.groupFilter = function (group) {
			if(!$scope.keyword)
				return true;
				
			return group.name.toLowerCase().indexOf($scope.keyword.toString().toLowerCase()) > -1;
		}

		var schoolId;
		$scope.groups = [];
		$scope.archivedGroups = [];
		
		baseService.app_initialized = function(evt, args) {
			if($rootScope.active_user.role != 'STAFF'){
				window.location.href = '/school/#/dashboard/view'
			}
			schoolId = $rootScope.active_school.id;
			getGroups();
		}

		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}	

		function getGroups(){
			groupsService.get('group/v1/list/interest/' + schoolId, {'cache':false, 'xhr':true}).then(function(response){
				$scope.groups = $filter('groupBy')(response.data.payload.groups, response.data.payload.groups.length) || [];
				if($scope.groups.length > 0){
					$scope.archivedGroups = $scope.groups[0].filter(function(group){ return group.archived; });
					if($scope.archivedGroups.length > 0){
						$scope.archivedGroupsDate = $scope.archivedGroups[0].archivedAt;
					}
					$scope.groups[0] = $scope.groups[0].filter(function(group){ return !group.archived; });
				}

				$scope.viewState.isReady = true;
			}, function(error){
				toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
				$scope.viewState.isReady = true;
			})
		}

		$scope.createCommunityGroup = function(){
			window.location.href = '#/groups/create'
		}

	}
})();

(function() {
	'use strict';

	angular.module('modules.groups.interestGroupsView',[]).controller('interestGroupsViewController', interestGroupsViewController);

	/** @ngInject */
	function interestGroupsViewController(baseService, $scope, $rootScope, $sce, $stateParams, groupsService, toastr, $location, $translate, $state, $window,$uibModal, regexes, storage) {
		var membersType = $stateParams.type;

		$scope.firsttime = true;
		$scope.peditDescr = false;
		$scope.newTag = {
			"tag": ''
		};

		var groupId = $stateParams.id;

		$scope.viewState = {
			isReady: false,
			isInitiated: false
		}
		$scope.school = $rootScope.active_school;

		$scope.$on('$destroy', function () {
			if (window.viewpostListener)
				window.viewpostListener();
		});

		baseService.app_initialized = function(evt, args) {
			if(!$rootScope.adminHaveRoles('STAFF', 'AMBASSADOR')){
				window.location.href = '/school/#/dashboard/view'
				return;
			}
			$scope.regexes = regexes;
			var schoolId = $rootScope.active_school.id;
			var me = $rootScope.active_user;

			$scope.groupId = groupId;
			$scope.group = {};
			$scope.userName = me.firstName+' '+me.lastName;

			$scope.showPrivateInfo = function(){
				toastr.info($translate.instant('PRIVATE_GROUP_INFO_TEXT'))
			}

			$scope.showPublicInfo = function(){
				toastr.info($translate.instant('PUBLIC_GROUP_INFO_TEXT'))
			}

	

			$scope.openProfile = function () {
				location.href = '#/classlist/details/' + $rootScope.active_user.id + '/contact';
			}

			$scope.seeMore = function() {
				$rootScope.activityStreamTierId = $scope.group.id;
				$rootScope.postingFrom = 'groups';
				location.href = '#/stream';
			}

			$scope.getHtmlVersion = function(description) {
				if(description) {
					// convert description to html links
					return $sce.trustAsHtml($rootScope.parseTagsToLinks(description));
				}
				return '';
			}
			$scope.getGroup = function() {
				groupsService.get('group/v1/school/get/' + groupId, {' cache': false, 'xhr': true }).then(function(response) {
					$scope.group = response.data || [];
					if(!$scope.group.tags) {
						$scope.group.tags = [];
					}
					$scope.isGroupWithTags = $scope.group.type === 'PARENT_PUBLIC' || $scope.group.type === 'PARENT_PRIVATE';
					$scope.group.schoolId = schoolId;//we need this
					$scope.type = membersType ? membersType : 1;
					$scope.viewState.isInitiated = true;

					if($scope.firsttime) {
						$scope.visibleDetails = !$scope.group.member;
						$scope.firsttime = false;
					}

					setTimeout(function() {
						$scope.viewState.isReady = true;

						if($scope.group.owner
							&& $scope.group.type !== 'PARENT_PUBLIC'
							&& $scope.group.waitingApproval
							&& location.href.indexOf('?open')) {
							$scope.openMembers(3);
						}

						$scope.$apply();
					}, 100);

					var found = false;
					for (var i = 0; i < $rootScope.active_user.groups.length; i++) {
						if($rootScope.active_user.groups[i].id === groupId){
							found =true;
							break;
						}
					}

					if (!found) {
						var tmpGroup = angular.copy($scope.group)
						tmpGroup.name = tmpGroup.title;
						tmpGroup.memberCount = tmpGroup.members.length;
						$rootScope.active_user.groups.push(tmpGroup)
					}

					for (var i = 0; i < $rootScope.active_user.groups.length; i++) {
						$scope.groups.push($rootScope.active_user.groups[i])
					}
				},
				function(error){
					console.log(error)
				})
			};

			$scope.deleteGroups = function() {
				var name = $scope.group.title
				var modalInstance = $uibModal.open({
					animation: true,
					templateUrl: 'app/groups/views/delete-interest-group-modal.html',
					backdropClass: 'backdrop-zindexed',
					size:'sm',
					controller: function($scope) {
						$scope.currentGroupName = name;
						$scope.confirm = function() {

							$scope.deletingGroup = true;
							groupsService.get('group/v1/parent/remove/group/' + groupId).then(function(response) {
								modalInstance.close();
								$scope.deletingGroup = false;
								$window.location.href = "/school/#/groups/interestgroups";

							},
							function(error) {
								$scope.deletingGroup = false;
							});
						}

						$scope.close = function() {
							modalInstance.close();
						}
					}
				})
			}
			$scope.getGroup();
		}

		if($rootScope.active_school && $rootScope.app_base_ready) {
			baseService.app_initialized();
		}

		$scope.rejectRequest = function(type, request) {
			var membersType = type;
			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				templateUrl: 'app/groups/views/reject-request-modal.html',
				backdropClass: 'backdrop-zindexed',
				controller: function() {
					$scope.rejectMessage = '';
					$scope.type = membersType;

					$scope.save = function() {
						$scope.rejecting = true;
						var message = $scope.rejectMessage ? $scope.rejectMessage : '';
						groupsService.get('group/v1/parent/'+$scope.group.id+'/member/decline/'+request.id+'/'+ message).then(function (response) {
							$scope.rejecting = false;
							$scope.members = $scope.spliceArrMembers($scope.type, [request])
							toastr.info($translate.instant('USERS_REJECTED_INFO'))
							modalInstance.close();
							if($scope.type){
								$scope.openMembers($scope.type, true);
							}
						},
						function (error) {
							$scope.rejecting = false;
						})
					};

					$scope.close = function() {
						modalInstance.close();

						if($scope.type)
							$scope.openMembers($scope.type, false);
					};
				},
				size: 'sm'
			});
		}

		$scope.onDialogCallback = function(){
			$scope.getGroup();
		}

		$scope.pushArrMembers = function(type, arr) {
			switch(type) {
				case 1:
					if (_.isUndefined($scope.group.owners)) {
						$scope.group.owners = [];
					}
					for(var i = 0; i < arr.length; i++)
						$scope.group.owners.unshift(arr[i]);

					$scope.group.members = $scope.group.owners;
					return $scope.group.members;

				case 2:
					if (_.isUndefined($scope.group.members)) {
						$scope.group.members = [];
					}
					for(var i = 0; i < arr.length; i++) {
						$scope.group.members.unshift(arr[i]);
					}

					$scope.group.members = $scope.group.members;
					return $scope.group.members;

				case 3:
					if (_.isUndefined($scope.group.waitingApproval)) {
						$scope.group.waitingApproval = [];
					}
					for(var i = 0; i < arr.length; i++)
						$scope.group.waitingApproval.unshift(arr[i]);

					$scope.group.members = $scope.group.waitingApproval;
					return $scope.group.members;
			}
		}

		$scope.spliceArrMembers = function(type, arr) {
			switch(type) {
				case 1:
					for(var i = 0; i < arr.length; i++)
						$scope.group.owners = _.without($scope.group.owners, arr[i]);

					return $scope.group.owners;

				case 2:
					for(var i = 0; i < arr.length; i++)
						$scope.group.members = _.without($scope.group.members, arr[i]);

					return $scope.group.members;

				case 3:
					for(var i = 0; i < arr.length; i++)
						$scope.group.waitingApproval = _.without($scope.group.waitingApproval, arr[i]);

					return $scope.group.waitingApproval;
			}
		}

		$scope.openMembers = function(type, executed) {
			var openreject = $scope.rejectRequest;

			var membersType = type;
			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				templateUrl: 'app/groups/views/members-modal.html',
				backdropClass: 'backdrop-zindexed',
				controller: function() {
					$scope.type = membersType;

					setTimeout(function() {
						var max = document.getElementsByClassName('group-members-list-max')
						if(max && max[0]) {
							if(getIfNative()) {
								max[0].style.maxHeight = (window.innerHeight - 69) + 'px';
							}
							else {
								max[0].style.maxHeight = (window.innerHeight - 111) + 'px';
							}
						}
					}, 100);

					$scope.reject = function(member) {
						modalInstance.close();
						$scope.rejectRequest($scope.type, member);
					};

					$scope.accept = function(member) {
						groupsService.get('group/v1/parent/'+ $scope.group.id +'/member/accept/'+member.id).then(function (response) {
							toastr.info($translate.instant('USERS_APPROVED_INFO'))
							$scope.members = $scope.spliceArrMembers($scope.type, [member])

							$scope.group.members.push(member);
						},
						function (error) {

						})
					};

					$scope.close = function() {
						modalInstance.close();
					};
				},
				size: 'md'
			});
		}

		$scope.uploadImage = function() {
			$rootScope.$broadcast('UPLOAD_PHOTO', {'callback_fn':function(response) {
					var url = groupsService.getPostImgBucketUrl() + '/' + response.data;
					$scope.avatarURL = url;
					$scope.avatarId = response.data || '';
					$scope.group.avatar = $scope.avatarURL;

					//call the server now with the new image
					groupsService.get('group/v1/parent/update/'+$scope.group.id+'/avatar/'+$scope.avatarId,{}).then(function (response) {
						$scope.getGroup();
					}, function (error) {
						console.log(error);
					})

				},
				'action': 'groupUpload',
				'config': 'groupCropper'
			});
		}

		$scope.pickMember = function(participant) {

			if(participant.type === 'user') {
				push(participant, false)
				$scope.inviteMembers([participant.id]);
			}
			else if(participant.type === 'tier') {
				explode(participant.id, participant.field1)
			}

			$scope.participant = null;
			$scope.member = '';
		}

		$scope.removeMember = function(participant) {
			var toBeRemoved = _.filter($scope.group.members, function(obj) {return obj.id === participant.id;});
			for (var i = 0; i < toBeRemoved.length; i++) {
				$scope.spliceArrMembers($scope.membersType, [toBeRemoved[i]])

				groupsService.get('group/v1/parent/'+ $scope.group.id +'/remove/member/'+participant.id).then(function (response) {
					toastr.info($translate.instant('USERS_REMOVED_INFO'))
					$scope.getGroup();
				},
				function (error) {

				})
			}
		}

		function push(r, isBulk) {
			var includes = _.includes($scope.group.members, _.find($scope.group.members, {'id': r.id})),
				isMe = false;

			if(!includes && !isMe) {
				var toadd = {
					avatar: r.avatar || '',
					name: (r.firstName || r.field1) + ' ' + (r.lastName || r.field2),
					id: r.id,
					type: r.type || 'user',
					tierId: r.tierId || '',
					tierName: r.tierName || ''
				};

				$scope.pushArrMembers($scope.membersType, [toadd]);
				return;
			}
			if(includes && !isBulk) {
				toastr.info($translate.instant('ADD_RECIPIENT_ALREADY_EXIST'))
			}
		}

		function explode(tierId, tierName) {
			groupsService.get('group/v1/'+$rootScope.active_school.id+'/getTierParents/'+tierId,{'cache':true}).then(function (response) {
				var toadd = [];

				_.forEach(response.data.resultList, function(r) {
					r.type = 'tier';
					r.tierName = tierName;
					r.tierId = tierId;
					toadd.push(r.id)
					push(r, true)
				})

				$scope.inviteMembers(toadd);
			},
			function (error) {
				error.status === 403 ? toastr.error($translate.instant('CANT_SEE_PUPILS')) : _.noop()
			})
		}

		$scope.inviteMembers = function(arr) {
			if($scope.membersType === 2) {
				groupsService.post('group/v1/parent/invite', { invites : arr, id: groupId}, { }).then(function(response) {
					toastr.info($translate.instant('USERS_INVITED_INFO'))
				},
				function(error) {
					for(var i = 0; i < arr.length; i++) {
						$scope.group.members = $scope.group.members.splice(-1, 1)
						$scope.group.members = $scope.group.members;
					}
				})
			}
			else if($scope.membersType === 1) {
				groupsService.post('group/v1/parent/add/owners', { invites : arr , id: groupId}, { }).then(function(response) {
					toastr.info($translate.instant('OWNERS_INVITED_INFO'))
				},
				function(error) {

					for(var i = 0; i < arr.length; i++) {
						$scope.group.owners = $scope.group.owners.splice(-1, 1)
						$scope.group.members = $scope.group.owners;
					}
				})
			}
		}

		$scope.updateGroup = function(){
			toastr.info($translate.instant('OWNERS_INVITED_INFO'))
		}

		$scope.updateTitleModel = function(newValue) {
			$scope.peditTitleInput = newValue;
		};

		$scope.editTitle = function() {
			$scope.peditTitleInput = $scope.group.title;
			$scope.peditTitle = true;
		}

		$scope.updateOutsideTitle = function() {
			if(!isThisMobile())
				$scope.updateTitle()
		}

		$scope.updateTitle = function() {
			if($scope.group.title !== $scope.peditTitleInput) {
				if ($scope.peditTitleInput.length >= regexes.min.groupTitle) {

					$scope.group.title = $scope.peditTitleInput;

					groupsService.put('group/v1/parent/update/' + groupId + '/title',
					{ 'payload': {
						title: $scope.peditTitleInput
					}},
					{' cache': false, 'xhr': true }).then(function(response) {
						//virtual update
						for (var i = 0; i < $rootScope.active_user.groups.length; i++) {
							if ($rootScope.active_user.groups[i].id === groupId){
								$rootScope.active_user.groups[i].name = angular.copy($scope.peditTitleInput);
								break;
							}
						}

					},
					function(error) {
						console.log(error)
					})
				}else{
					toastr.info($translate.instant('ERR_GROUP_TITLE'))
				}
			}

			$scope.peditTitle = false;
		}

		$scope.cancelTitle = function() {
			$scope.peditTitleInput = $scope.group.title;
			$scope.peditTitle = false;
		}

		$scope.editDescr = function() {
			$rootScope.$broadcast('RESIZE_TO_LARGE');
			$scope.peditDescrInput = $rootScope.removeLinks($scope.group.description);
			$scope.peditDescr = true;
		}

		$scope.updateOutsideDescr = function() {
			if(!isThisMobile())
				$scope.updateDescr()
		}

		$scope.updateDescriptionModel = function(newValue) {
			$scope.peditDescrInput = newValue;
		};

		$scope.updateDescr = function() {
			if($scope.group.description !== $scope.peditDescrInput) {
				// convert description to classlist links
				var description = $scope.peditDescrInput;
				if(description && description.length > 0) {
					description = $rootScope.createEmailLinks(description);
					var s = String(description);
					s = s.replace(/(&nbsp;)+<\/div>/g, '</div>');
					s = s.replace(/(&nbsp;)+\[URL/g, '[URL');
					description = s;
				}
				$scope.group.description = description;
				groupsService.put('group/v1/parent/update/'+groupId+'/description',
				{ 'payload': {
					'description': description
				}},
				{' cache': false, 'xhr': true }).then(function(response) {

				},
				function(error) {
					console.log(error)
				})
			}
			$scope.peditDescr = false;
		}

		$scope.cancelDescr = function() {
			$scope.peditDescrInput = $scope.group.description;
			$scope.peditDescr = false;
		}

		$scope.joinGroup = function() {

			if($scope.joiningGroup)
				return;

			$scope.joiningGroup = true;
			groupsService.get('group/v1/parent/' + groupId + '/join/', {' cache': false, 'xhr': true }).then(function(response) {
				$scope.joiningGroup = false;

				toastr.success($translate.instant('GROUP_JOIN_SUCCESS'));
				location.reload();
			},
			function(error) {
				$scope.joiningGroup = false;
				console.log(error)
			})
		}
		$scope.back = function() {
			if($rootScope.adminHaveRoles('STAFF')){
				window.location.href = '#/groups/interestgroups'
			}else{
				window.location.href = '#/groups/list'
			}
		}
		$scope.copyParentLink = function() {
			if(!$scope.group.parentUrl){
				return;
			}
			copyToClipboard($scope.group.parentUrl);
			toastr.success($translate.instant("LINK_COPIED"));
		}
		$scope.addMembersToGroup = function(type, callback) {
			var currentGroupName = $scope.group.title;
			var group = $scope.group;
			
			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/groups/views/add-interest-members-group-modal.html',
				controller: function($scope){
					$scope.group = group;
					$scope.currentGroupName = currentGroupName;
					$scope.members = [];
					$scope.type = type;

					$scope.viewState = {
						isReady:true
					};

					$scope.close = function() {
						modalInstance.close();
					};

					$scope.add = function () {
						$scope.viewState.isReady = false;
						var memberArr = [];
						memberArr = _.map($scope.members,'id');
						inviteMembers(memberArr, type);
						modalInstance.close();
					}

					function inviteMembers(arr, type) {
						if(type === 2) {
							groupsService.post('group/v1/parent/invite', { invites : arr, id: group.id}, { }).then(function(response) {
								toastr.info($translate.instant('USERS_INVITED_INFO'));
								callback();
							},
							function(error) {

							})
						}
						else if(type === 1) {
							groupsService.post('group/v1/school/add/leaders', { invites : arr , id: group.id}, { }).then(function(response) {
								toastr.info($translate.instant('OWNERS_INVITED_INFO'))
								callback();

							},
							function(error) {

							})
						}
					}
				},
				size: 'md'
			});
		}

		$scope.removeMembersFromGroup = function(callback) {
			var group = angular.copy($scope.group);
			
			var ownerCount = group.owners.length;

			group.allMembers = group.members;

			if($scope.group.owners){
				for (var i = 0; i < group.owners.length; i++) {
					group.owners[i].isOwner = true;
					group.allMembers.push($scope.group.owners[i]);
				}
			}

			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/groups/views/remove-members-interest-group-modal.html',
				controller: function($scope){

					$scope.group = group;
					$scope.viewState = {
						isReady:true
					};

					$scope.close = function() {
						modalInstance.close();
					};

					$scope.remove = function () {
						$scope.viewState.isReady = false;
						var membersToBeRemoved = $scope.getSelectedMembers(group.allMembers);
						
						var ownerCountToBeRemoved = 0;

						for(var i=0; i < membersToBeRemoved.length; i++){
							if(membersToBeRemoved[i].isOwner){
								ownerCountToBeRemoved++;
							}
						}

						if(ownerCount == ownerCountToBeRemoved){
							toastr.info($translate.instant('MEMBERS_OWNER_CANT_DELETE'));
							modalInstance.close();
							callback();
							return;
						}

						groupsService.put('group/v1/parent/' + group.id +'/remove/members',{'members': membersToBeRemoved}).then(function(response){
							//clear members model
							_.forEach(group.allMembers, function(r){
								delete r.checked;
							});
							$scope.viewState.isReady = true;
							if (membersToBeRemoved.length > 1) {
								toastr.info($translate.instant('MEMBERS_REMOVED'));
							}else{
								toastr.info($translate.instant('MEMBER_REMOVED'));
							}
							modalInstance.close();

							callback();
						}, function(error){
							$scope.viewState.isReady = true;
						});

					}

					$scope.getSelectedMembers = function(members) {
						var selectedMembers = [];

						for (var member in members) {
							if(members[member].checked) {
								selectedMembers.push(members[member].id);
							}
						}

						return selectedMembers.length > 0 ? selectedMembers : false;
					}

					$scope.checkAllBoxes = function() {
						for(var member=0; member<$scope.group.members.length; member++){
							$scope.group.members[member].checked = true;
						}
					}

				},
				size: 'md'
			});
		}

		$scope.optInNotificaions = function(){
			groupsService.get('group/v1/parent/' + groupId +'/optin').then(function(response){
				if ($scope.group.optedIn ? toastr.info($translate.instant('GROUPS_OPT_OUT_INFO')) : toastr.info($translate.instant('GROUPS_OPT_IN_INFO')))
				$scope.getGroup();
			},
			function(error) {

			});
		}

		function removeCurrentUser(members){
			var temp = [];

			for (var i = 0; i < members.length; i++) {
				if (members[i].id !== $rootScope.active_user.id){
					temp.push(members[i]);
				}
			}
			return temp;
		}

		$scope.removeGroupTag = function(tag, i) {
			groupsService.delete('group/v1/parent/' + groupId +'/remove/tag/' + tag).then(function(){
				$scope.group.tags.splice(i, 1);
				return;
			}, function(error){
				console.log(error);
			});
			return;
		}

		$scope.searchTag = function(tag) {
			$rootScope.searchTerm = tag;
			location.href = '#/search';

		}

		$scope.addTag = function() {
			groupsService.post('group/v1/parent/' + groupId +'/add/tags', $scope.newTag).then(function(){
				$scope.group.tags.push($scope.newTag.tag);
				$scope.newTag.tag = '';
			}, function(error){
				console.log(error);
			});
		}

		$scope.pickTag = function(tag) {
			$scope.newTag.tag = tag;
			$scope.addTag();
		}

		$scope.tagKeyUp = function(event) {
			if(event.which === 13) {
				if(!!$scope.newTag.tag && $scope.newTag.tag !== '') {
					$scope.addTag();
				}
			}
		}

		$scope.getTags = function (string) {
			return groupsService.get('group/v1/parent/' + $scope.school.id +
				'/tags/' + encodeURIComponent(string)).then(function (response) {
				return response.data.tags
			}, function (error) {
			})
		}

		$scope.selectGroupVisibility = function(type) {
			if(type === 1) {
				if($scope.changingType || $scope.group.type === 'PARENT_PUBLIC') {
					return
				};
				var modalInstance = $uibModal.open({
					animation: true,
					scope: $scope,
					templateUrl: 'app/groups/views/group-type-change-modal.html',
					backdropClass: 'backdrop-zindexed',
					size:'sm',
					controller: function($scope) {
						$scope.confirm = function() {
							$scope.changingType = true;

							groupsService.put('group/v1/parent/update/' + groupId + '/type',
							{ 'payload': {
								type: 'PARENT_PUBLIC'
							}},
							{' cache': false, 'xhr': true }).then(function(response) {
								$scope.group.type = 'PARENT_PUBLIC';
								$scope.changingType = false;
								modalInstance.close();
							},
							function(error) {
								console.log(error);
								$scope.changingType = false;
								modalInstance.close();
							});
						}

						$scope.close = function() {
							modalInstance.close();
						}
					}
				});
			} else {
				if($scope.changingType || $scope.group.type === 'PARENT_PRIVATE') {
					return
				};

				$scope.changingType = true;

				groupsService.put('group/v1/parent/update/' + groupId + '/type',
				{ 'payload': {
					type: 'PARENT_PRIVATE'
				}},
				{' cache': false, 'xhr': true }).then(function(response) {
					$scope.group.type = 'PARENT_PRIVATE';
					$scope.changingType = false;
				},
				function(error) {
					console.log(error);
					$scope.changingType = false;
				});
			}
		}
	}
})();

(function() {
	'use strict';

	angular.module('modules.groups.view',[]).controller('groupsViewController', groupsViewController);

	/** @ngInject */
	function groupsViewController(baseService, $scope, $location, $stateParams, settings, groupsService, $uibModal, toastr, $translate, $rootScope, $state, $window) {

		var groupId = $stateParams.id;
		var schoolId;

		var me = $rootScope.active_user;
		var cursor = 'none';

		$scope.$on('$destroy', function () {
			if (window.viewpostListener)
				window.viewpostListener();
		});

		baseService.app_initialized = function(evt, args) {
			schoolId = $rootScope.active_school.id;
			$scope.groups = $rootScope.groups || [];
			$scope.groupId = groupId;
			$scope.group = {};
		    $scope.userName = $rootScope.active_user.firstName+' '+$rootScope.active_user.lastName;
			$scope.showAllMembers = false;

			window.viewpostListener = $rootScope.$on('ON_POST_VIEW_OPEN', function(evt, args) {
				$rootScope.tempPosts = {
					scroll: document.documentElement.scrollTop || document.body.scrollTop,
					posts: $scope.posts,
					cursor: cursor
				};
			})
 
			if($rootScope.backFromPost && $rootScope.tempPosts && $rootScope.tempPosts.posts) {
				$rootScope.backFromPost = false;
				$scope.posts = $rootScope.tempPosts.posts;
				cursor = $rootScope.tempPosts.cursor;
				setTimeout(function() {
					window.scrollBy(0, $rootScope.tempPosts.scroll);
				}, 1);
			}
			else {
				$rootScope.tempPosts = null;
				$scope.posts = [];
			}

			$scope.viewState = {
				isReady:true,
				isInitiated:false
			} 

			$scope.events = {
				postCallback : function (post) {
					var payload = {
						'postedBy':me.firstName+' '+me.lastName,
						'userId':me.id,
						'avatar':me.avatar,
						'postedOn':new Date(),
						'body':post.body,
						'photo':post.photo,
						'isOwn':true,
						'isLiked':false,
						'likeCount':post.likeCount,
						'commentCount':post.commentCount,
						'groupId':post.groupId,
						'groupName':post.groupName,
						'id':post.id
					};
					$scope.posts.unshift(payload);
				}
			}

			function getGroup() {
				groupsService.get('group/v1/get/'+groupId, {'cache':false, 'xhr':true}).then(function(response){
					$scope.group = response.data.payload || [];
					if(typeof $scope.group.groupMembers !== 'undefined'){
						if($scope.group.groupMembers.length > 0){
							for (var i = 0; i < $scope.group.groupMembers.length; i++) {
								$scope.group.groupMembers[i]['combinedName'] = $scope.group.groupMembers[i].firstName + ' ' + $scope.group.groupMembers[i].lastName;
							}
						}
					}
					$scope.viewState.isInitiated = true;
				}, function(error){
					toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
					$scope.viewState.isInitiated = true;
				})
			}

			getGroup();
					
			$scope.getPosts = function() {
				$scope.loadingPosts = true;

				groupsService.get('post/v1/list/'+ cursor +'/'+schoolId+'/'+groupId, {'xhr':true, 'cache':false}).then(function(response){
					var data = response.data.payload;
					angular.forEach(data.posts, function(k,v){
						$scope.posts.push(k)
					})
					cursor = data.cursor || 0;
					$scope.loadingPosts = false;
				}, 
				function(error){
					$scope.loadingPosts = false;

				})
			}

			if(!$rootScope.tempPosts || !$rootScope.tempPosts.posts)
				$scope.getPosts();

			$scope.toggleMembersCard = function () {
				$scope.showAllMembers = true;
			}

			$scope.closeMembersCard = function () {
				$scope.showAllMembers = false;
			}


			$scope.hasMorePosts = function() {
				return cursor !== 0 && cursor !== 'none'; 
			}

			$scope.editGroupName = function() {
				var modalInstance = $uibModal.open({
					animation: true,
					scope: $scope,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/groups/views/edit-group-name-modal.html',
					controller: function($scope){
						$scope.groupName = $scope.group.groupName;

						$scope.viewState = {
							isReady:true
						};

						$scope.close = function(){
							modalInstance.close();
						};

						$scope.save = function () {
							$scope.viewState.isReady = false;

							groupsService.get('group/v1/parent/update/' + groupId + '/title/' + $scope.groupName, { }).then(function(response){
								
								$scope.viewState.isReady = true;
								toastr.info($translate.instant('GROUP_NAME_UPDATED'));
								getGroup();
								modalInstance.close();
							}, function(error){
								toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
								$scope.viewState.isReady = true;
							});
						}

					},
					size: 'sm'
				});
			}

			$scope.addMembersToGroup = function() {
				var currentGroupName = $scope.group.groupName;
				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/groups/views/add-members-group-modal.html',
					controller: function($scope){

						$scope.currentGroupName = currentGroupName;
						$scope.members = [];

						$scope.viewState = {
							isReady:true
						};

						$scope.close = function(){
							modalInstance.close();
						};

						$scope.add = function () {
							$scope.viewState.isReady = false;
							var memberArr = [];

							memberArr = _.map($scope.members,'id');
							
							groupsService.put('group/v1/addMembers/' + groupId,{'payload':{'users': memberArr}}).then(function(response){
								
								$scope.viewState.isReady = true;
								toastr.info($translate.instant('MEMBERS_ADDED_TO_GROUP'));
								getGroup();
								modalInstance.close();
							}, function(error){
								toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
								$scope.viewState.isReady = true;
							});
						}

						$scope.getMembers = function (string) {
							return groupsService.get('group/v1/searchMember/'+schoolId+'/query/'+encodeURIComponent(string),{}).then(function (response) {
								return response.data.resultList
							}, function (error) {
							})
						}

						function push(r, isBulk) {
							var includes = _.includes($scope.members, _.find($scope.members, {'id':r.id})),
								isMe = false;
							if(!includes){
								$scope.members.push({
									avatar:r.avatar || '',
									firstName:r.firstName || r.field1,
									lastName:r.lastName || r.field2,
									id:r.id,
									type: r.type || 'user',
									tierId: r.tierId || '',
									tierName: r.tierName || ''
								})
								return
							}
							if(includes && !isBulk) {
								toastr.info($translate.instant('ADD_RECIPIENT_ALREADY_EXIST'))
							}
						}


						function explode(tierId, tierName){
							groupsService.get('group/v1/'+schoolId+'/getTierParents/'+tierId,{'cache':true}).then(function (response) {
								_.forEach(response.data.resultList, function(r){
									r.type = 'tier';
									r.tierName = tierName;
									r.tierId = tierId;
									push(r, true)
								})
							}, function (error) {
								error.status === 403 ? toastr.error($translate.instant('CANT_SEE_PUPILS')) : _.noop()
							})
						}

						$scope.pickMember = function (participant) {
							if(participant.type === 'user'){
								push(participant, false)
							} else if(participant.type === 'tier'){
								explode(participant.id, participant.field1)
							}
							$scope.participant = null;
							$scope.member = '';
						}

						$scope.removeMember = function (participant) {
							var toBeRemoved = _.filter($scope.members, function(obj) {return obj.tierId === participant.tierId && obj.id === participant.id;});
							for (var i = 0; i < toBeRemoved.length; i++) {
								$scope.members = _.without($scope.members, toBeRemoved[i]);
							}
						}


						$scope.toggleGroup = function(className){
							var el = document.getElementsByClassName(className);
							_.forEach(el, function(item){
								var elm = angular.element(item);
								if(elm.hasClass('visible')){
									elm.removeClass('visible');
									return
								} else { elm.addClass('visible'); }
							})
						}

					},
					size: 'sm'
				});
			}

			$scope.back = function() {
				$window.history.back();
			};

			$scope.removeMembersFromGroup = function() {
				var group = $scope.group;
				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/groups/views/remove-members-group-modal.html',
					controller: function($scope){

						$scope.group = group;
						$scope.viewState = {
							isReady:true
						};

						$scope.close = function(){
							modalInstance.close();
						};

						$scope.remove = function () {
							$scope.viewState.isReady = false;
							var membersToBeRemoved = $scope.getSelectedMembers();

							groupsService.put('group/v1/removeMembers/' + groupId,{'payload':{'users': membersToBeRemoved}}).then(function(response){
								//clear members model
								_.forEach($scope.group.groupMembers, function(r){
									delete r.checked;
								});
								$scope.viewState.isReady = true;
								if (membersToBeRemoved.length > 1) {								
									toastr.info($translate.instant('MEMBERS_REMOVED'));
								}else{
									toastr.info($translate.instant('MEMBER_REMOVED'));
								}
								getGroup();
								modalInstance.close();
							}, function(error){
								toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
								$scope.viewState.isReady = true;
							});

						}


						$scope.getSelectedMembers = function() {
							var selectedMembers = [];

							for (var member in $scope.group.groupMembers) {
								if($scope.group.groupMembers[member].checked) {
									selectedMembers.push($scope.group.groupMembers[member].userId);
								}
							}
							return selectedMembers.length > 0 ? selectedMembers : false;
						}

						$scope.checkAllBoxes = function() {
							for (var member in $scope.group.groupMembers) {
								$scope.group.groupMembers[member].checked = true;
							}
						}

					},
					size: 'sm'
				});
			}

			$scope.editGroup = function() {
				location.href = '#/groups/interestgroups/' + groupId;
			}

			$scope.deleteGroup = function(){
				
				var name = $scope.group.groupName;
				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/groups/views/delete-group-modal.html',
					controller: function($scope){

						$scope.currentGroupName = name;
						$scope.viewState = {
							isReady:true
						};

						$scope.close = function(){
							modalInstance.close();
						};

						$scope.delete = function () {
							$scope.viewState.isReady = false;						

							groupsService.delete('group/v1/remove/' + groupId,{}).then(function(response){
								
								$scope.viewState.isReady = true;
								toastr.info($translate.instant('GROUP_DELETED'));
								modalInstance.close();
								$state.go('groups.list');
							}, function(error){
								
								toastr.error($translate.instant(error.data.error.message));
								$scope.viewState.isReady = true;
							});
						}

					},
					size: 'sm'
				});
			}	

			window.addEventListener("scroll", function() {

				if($location.path().indexOf('/groups/view') > -1) {
					$scope.loadingMorePosts = true;

					if(!$scope.hasMorePosts())
						return;

					var doc = document.documentElement;
				    if(window.pageYOffset >= doc.scrollHeight - window.innerHeight) {
						$scope.getPosts();
				    }
				}
			});	
		}
		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}
	}
})();

(function() {
	'use strict';

	angular.module('modules.groups',[]).factory('groupsService', ['base', function (base) {
		return _.create(base, { });
	}])
	.controller('groupsController', groupsController);

	/** @ngInject */
	function groupsController($scope, groupsService) {



	}
})();

(function() {
	'use strict';

	angular.module('modules.groups.members',[]).controller('groupsMembersController', groupsMembersController);

	/** @ngInject */
	function groupsMembersController($scope, $stateParams, groupsService, $rootScope, $window) {

		var groupId = $stateParams.id;

		$scope.groupId = $stateParams.id;
		$scope.group = {};
		$scope.viewState = {
			isReady:false,
		}
		
		function getGroup(){
			groupsService.get('group/v1/get/'+groupId, {'cache':false, 'xhr':true}).then(function(response){
				$scope.group = response.data.payload || [];
				$scope.viewState.isReady = true;
			}, function(error){
				$scope.viewState.isReady = true;
			})
		}

		getGroup();

		$scope.toggleMembersCard = function () {
			$scope.showMembersCard = !$scope.showMembersCard
		}

		$scope.back = function(){
			$window.history.back();
		}

	}
})();

(function() {
	'use strict';

	angular.module('modules.groups.list',[])
	.controller('groupsListController', groupsListController);

	/** @ngInject */
	function groupsListController($scope, groupsService, $filter, $uibModal, $rootScope, toastr, $translate, $state, baseService) {

		$scope.viewState = {
			isReady:false
		}
		
		$scope.groupFilter = function (group) {
			if(!$scope.keyword)
				return true;
				
			return group.name.toLowerCase().indexOf($scope.keyword.toString().toLowerCase()) > -1;
		}

		var schoolId;
		$scope.groups = [];
		
		baseService.app_initialized = function(evt, args) {
			schoolId = $rootScope.active_school.id;
			getGroups();
		}

		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}	

		function getGroups(){
			groupsService.get('group/v1/list/school/' + schoolId, {'cache':false, 'xhr':true}).then(function(response){
				$scope.groups = $filter('groupBy')(response.data.payload.groups, response.data.payload.groups.length) || [];
				$scope.viewState.isReady = true;
			}, function(error){
				toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
				$scope.viewState.isReady = true;
			})
		}


		$scope.createCommunityGroup = function(){
			window.location.href = '#/groups/create'
		}
		// $scope.createCommunityGroup = function(){

		// 	var modalInstance = $uibModal.open({
		// 		animation: true,
		// 		backdropClass: 'backdrop-zindexed',
		// 		templateUrl: 'app/groups/views/create-group-modal.html',
		// 		controller: function($scope){
		// 			$scope.members = [];
		// 			$scope.groupName = '';
		// 			$scope.viewState = {
		// 				isReady:true
		// 			};

		// 			$scope.close = function(){
		// 				modalInstance.close();
		// 			};

		// 			$scope.create = function () {
		// 				$scope.viewState.isReady = false;
		// 				var memberArr = [];

		// 				memberArr = _.map($scope.members,'id');

		// 				groupsService.post('group/v1/create',{'payload':{'schoolId': schoolId, 'groupName': $scope.groupName, 'users': memberArr}}).then(function(response){
							
		// 					$scope.viewState.isReady = true;
		// 					toastr.info($translate.instant('GROUP_CREATED'));
		// 					modalInstance.close();
		// 					$state.reload();
		// 					getGroups();
		// 				}, function(error){
		// 					toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
		// 					$scope.viewState.isReady = true;
		// 				});
		// 			}

		// 			$scope.getMembers = function (string) {
		// 				return groupsService.get('group/v1/searchMember/'+schoolId+'/query/'+encodeURIComponent(string),{}).then(function (response) {
		// 					return response.data.resultList
		// 				}, function (error) {
		// 				})
		// 			}

		// 			function push(r, isBulk) {
		// 				var includes = _.includes($scope.members, _.find($scope.members, {'id':r.id})),
		// 					isMe = false;
		// 				if(!includes && !isMe){
		// 					$scope.members.push({
		// 						avatar:r.avatar || '',
		// 						firstName:r.firstName || r.field1,
		// 						lastName:r.lastName || r.field2,
		// 						id:r.id,
		// 						type: r.type || 'user',
		// 						tierId: r.tierId || '',
		// 						tierName: r.tierName || ''
		// 					})
		// 					return
		// 				}
		// 				if(includes && !isBulk) {
		// 					toastr.info($translate.instant('ADD_RECIPIENT_ALREADY_EXIST'))
		// 				}
		// 			}


		// 			function explode(tierId, tierName){
		// 				groupsService.get('group/v1/'+schoolId+'/getTierParents/'+tierId,{'cache':true}).then(function (response) {
		// 					_.forEach(response.data.resultList, function(r){
		// 						r.type = 'tier';
		// 						r.tierName = tierName;
		// 						r.tierId = tierId;
		// 						push(r, true)
		// 					})
		// 				}, function (error) {
		// 					error.status === 403 ? toastr.error($translate.instant('CANT_SEE_PUPILS')) : _.noop()
		// 				})
		// 			}

		// 			$scope.pickMember = function (participant) {
		// 				if(participant.type === 'user'){
		// 					push(participant, false)
		// 				} else if(participant.type === 'tier'){
		// 					explode(participant.id, participant.field1)
		// 				}
		// 				$scope.participant = null;
		// 				$scope.member = '';
		// 			}

		// 			$scope.removeMember = function (participant) {
		// 				var toBeRemoved = _.filter($scope.members, function(obj) {return obj.tierId === participant.tierId && obj.id === participant.id;});
		// 				for (var i = 0; i < toBeRemoved.length; i++) {
		// 					$scope.members = _.without($scope.members, toBeRemoved[i]);
		// 				}
		// 			}


		// 			$scope.toggleGroup = function(className){
		// 				var el = document.getElementsByClassName(className);
		// 				_.forEach(el, function(item){
		// 					var elm = angular.element(item);
		// 					if(elm.hasClass('visible')){
		// 						elm.removeClass('visible');
		// 						return
		// 					} else { elm.addClass('visible'); }
		// 				})
		// 			}

		// 		},
		// 		size: 'md'
		// 	});
		// }

	}
})();

(function() {
	'use strict';

	angular.module('modules.groups.create',[]).controller('groupsCreateController', groupsCreateController);

	/** @ngInject */
	function groupsCreateController($scope, groupsService, $filter, $uibModal, $rootScope, toastr, $translate, $state, $stateParams, baseService) {
		$scope.newgroup = { groupVisibility: 1, guests: new Array(),  leads: new Array() }

		baseService.app_initialized = function(evt, args) {
			if(!$rootScope.adminHaveRoles('STAFF', 'AMBASSADOR')){
				window.location.href = '/school/#/dashboard/view'
				return;
			}
			var appcueClicked = false;
			$scope.inlineAppcueDoLater = function(type) {
				switch(type) {
					case 'PARENT_PRODUCT_DISCOVERY_GROUPS':
						$scope.showAppcueGroupsInfo = false;
						$rootScope.userTag('PARENT_PRODUCT_DISCOVERY_GROUPS', 'LATER');
						break;
				}
			}

			$scope.inlineAppcueDontShowAgain = function(type) {
				if(appcueClicked)
					return;

				appcueClicked = true;
				$rootScope.dismissTodo(type).then(function(resp) { }, function(error) { });

				$rootScope.userTag('PARENT_PRODUCT_DISCOVERY_GROUPS', 'DONT_SHOW_AGAIN');

				switch(type) {
					case 'PARENT_PRODUCT_DISCOVERY_GROUPS':
						$scope.showAppcueGroupsInfo = false;
						localStorage.setItem('PARENT_PRODUCT_DISCOVERY_GROUPS', true);
						break;
				}
			}

            $scope.redirectPages = $stateParams.redirectPages;
			$rootScope.tempPosts = null;
			
			$rootScope.isOnWizard = false;
			$scope.members = [];

			$scope.viewState = {
				isReady:false
			}

			$scope.groups = [];

			$scope.groupFilter = function (group) {
				if(!$scope.keyword)
					return true;
					
				return group.title.toLowerCase().indexOf($scope.keyword.toString().toLowerCase()) > -1;
			}

		}

		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}

		$scope.back = function() {
			if($rootScope.adminHaveRoles('STAFF')){
				window.location.href = '#/groups/interestgroups'
			}else{
				window.location.href = '#/groups/list'
			}
		}
		
		$scope.selectGroupVisibility = function(index) {
			$scope.newgroup.groupVisibility = index;
		}
		
		$scope.uploadImage = function() {
			$rootScope.$broadcast('UPLOAD_PHOTO', {
				'callback_fn':function(response) {
					var url = groupsService.getPostImgBucketUrl() + '/' + response.data;
					$scope.newgroup.avatarURL = url;
					$scope.newgroup.avatarId = response.data || '';
				},
				'action': 'groupUpload',
				'config': 'groupCropper'
			});

		}

		$scope.saveGroup = function() {
			var guests = new Array();
			if (!_.isUndefined($scope.newgroup.guests)) {
				for(var i = 0; i < $scope.newgroup.guests.length; i++) {
					guests.push($scope.newgroup.guests[i].id)
				}
			}

			var leads = new Array();
			if (!_.isUndefined($scope.newgroup.leads)) {
				for(var i = 0; i < $scope.newgroup.leads.length; i++) {
					leads.push($scope.newgroup.leads[i].id)
				}
			}

			// convert description to classlist links
			var description = $scope.newgroup.groupDescr;
			if(description && description.length > 0) {
				description = $rootScope.createEmailLinks(description);
				var s = String(description);

				s = s.replace(/(&nbsp;)+<\/div>/g, '</div>');

				s = s.replace(/(&nbsp;)+\[URL/g, '[URL');

				description = s;
			}

			var group = {
				"avatar": $scope.newgroup.avatarId,
				"description": description,
				"members": guests,
				"groupLead": leads,
				"school": $rootScope.active_school.id,
				"title": $scope.newgroup.groupName,
				"type": $scope.newgroup.groupVisibility === 1 ? 'PARENT_PUBLIC' : 'PARENT_PRIVATE',
				"tags": $scope.newgroup.tags
			}

			$scope.saveingGroup = true;
			groupsService.post('group/v1/school/community/create', group).then(function(response) {
				$scope.saveingGroup = false;
				window.location.href = '#/groups/interestgroups/' + response.data.id;
			}, 
			function(error) {
				$scope.saveingGroup = false;
			})
		};

		$scope.splitDescription = function(descr) {
			if(!descr)
				return descr;

			if(descr.length > 180) {
				return descr.substring(0, 180) + '...';
			}
			else {
				return descr;
			}
		}
	}
})();



(function () {
	'use strict';

	angular.module('modules.get-started',[])
	.factory('getStartedPageService', ['base','$http', function (base, $http) {
		return _.create(base, { });
	}])
	.controller('getStartedController', getStartedController);

	/** @ngInject */
	function getStartedController(baseService, $scope, $rootScope, getStartedPageService, $uibModal, toastr, $translate, $timeout, settings,$introjs) {

		$scope.viewState = {
			isReady: false
		};

		baseService.app_initialized = function (evt, args) {

		if ($rootScope.active_user.role == "AMBASSADOR" || $rootScope.active_user.role == "STAFF") {
			$scope.editableSchool = true;
			$scope.editableComm = true;
		}
		if($rootScope.active_school){
			$scope.integrationEnabled = $rootScope.active_school.integrationEnabled;
			$scope.isStaff = $rootScope.active_user.role == "STAFF"
		}
		$scope.callUserTag = function (tagString) {
			var prefixAndTag = "GET_STARTED_" + tagString;
            $rootScope.userTag(prefixAndTag);
		}
		$scope.appCueCallFirstAmbassadorCreateEvent = function () {
			$introjs.startAppCue("SCHOOL_FIRST_AMBASSADOR_COMMUNITY_EVENT_TOUR","DASHBOARD_EVENT",500, true);
		}
		$scope.appCueCallEventJourney = function () {
			$introjs.startAppCue("SCHOOL_COMMUNITY_EVENT_TOUR","DASHBOARD_EVENT",500, true);
		}
		$scope.isNative = isThisMobile()
		$scope.inviteOne = function(parent) {
			if($rootScope.active_school.integrationEnabled){
				window.location.href = '#/invite/add-invite-integration';
				return;
			}
			var getInviteLink = $scope.getInviteLink;
			//without timeout is not working
				var modalInstance = $uibModal.open({
						animation: true,
						backdropClass: 'backdrop-zindexed',
						templateUrl: 'app/invite/views/invite-modal.html',
						controller: function($scope, $rootScope) {
							$scope.parent = parent;
							$scope.shareBoxVisible = false;
							$scope.showLinkCopyDone = false;
							$scope.qrCodeLink = settings.conf.api + "/generator/invitepdf?sid=" + $rootScope.active_school.id + "&zu=" + $rootScope.currentUserId(), '_blank';
							if(!$scope.link) {
								getInviteLink(function(res) {
									$scope.link = res.url;
									$scope.link_message = res.message;
								})
							}

							$scope.select = function(index) {
								location.href = '/school/#/invite/bulk-email-upload';
							}
							
							$scope.copyLink = function() {
								copyToClipboard($scope.link);
								$scope.showLinkCopyDone = true;
								angular.element(document.getElementById('showLinkCopyDone')).show();
								$rootScope.userTag('PARENT_INVITED_V2', "LINK:" + $scope.link);
							}

							$scope.shareWhatsapp = function() {
								$rootScope.userTag('PARENT_INVITED_V2', "LINK:" + $scope.link);

								var toShare = encodeURIComponent($scope.link_message + ' ' + $scope.link);

								if (!$rootScope.isNative){
									window.open("https://web.whatsapp.com/send?text=" + toShare, "_blank");
								}else{
									$rootScope.openWhatsappNative(toShare);
								}
							}

							$scope.shareFacebook = function() {
								$rootScope.userTag('PARENT_INVITED_V2', "LINK:" + $scope.link);
								
								var toShare = encodeURIComponent($scope.link);

								if (!$rootScope.isNative){
									window.open('https://www.facebook.com/sharer/sharer.php?u=' +toShare, '_blank');
								} else {
									$rootScope.openFacebookNative(toShare);
								}

							}

							$scope.sharePrintable = function() {
								window.open(settings.conf.api + "/generator/invitepdf?sid=" + $rootScope.active_school.id, '_blank');
							}

							$scope.showLinkBox = function() {
								$scope.shareBoxVisible = true;
							}

							$scope.close = function() {
								modalInstance.close();
							}
							$scope.integrationEnabled = $rootScope.active_school.integrationEnabled;
							$scope.isTrial = $rootScope.active_school.status == "TRIAL";
						},
						size: 'md'
				});
		};
		
		$scope.editPersonalMessage = function (object) {
			var modalInstance = $uibModal.open({
				animation: true,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/schoolpage/views/welcome-message-modal.html',
				controller: function ($scope) {
					$scope.summernoteOptions = {
						minHeight: 300,
						toolbar: [
							['style', ['style']],
							['font', ['bold', 'underline', 'clear']],
							['color', ['color']],
							['para', ['ul', 'ol']],
							['insert', ['link']]
						]
					}

					$scope.viewState = {
						isReady: true
					};


					$scope.message = {
						canSave: false
					}
					if ($scope.message.body)
						$scope.message.canSave = true;
					$scope.close = function () {
						modalInstance.close();
					};

					$scope.confirm = function () {
						$scope.viewState.isReady = false;
						$scope.reqObject = {
							ambassadorMessage: $scope.message.body
						}
						getStartedPageService.post('school/v1/update/' + $rootScope.active_school.id + '/ambassadorMessage', {
							'payload': $scope.reqObject
						}).then(function (response) {
							toastr.success('Success');
								modalInstance.close();
							},
							function (error) {
								toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
								$scope.viewState.isReady = true;
							});
					}
				},
				size: 'md'
			});
		}

		$scope.uploadLogo = function () {
			$timeout(function(){
				$scope.$broadcast('UPLOAD_PHOTO', {
					'callback_fn': function (response) {
					},
					'action': 'logoUpload',
					'config': 'logoCropper'
				});
			},100);
		}

		$scope.addAmbasador = function () {

			var modalInstance = $uibModal.open({
				animation: true,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/schoolpage/views/add-amba-modal.html',
				controller: function ($scope) {
					$scope.hasSelected = false;

					$scope.viewState = {
						isReady: true
					};

					$scope.ambassador = {};
					$scope.id_school = $rootScope.active_school.id;

					$scope.$on('ADD_AMBA_PARENT', function (evt, args) {
						$scope.hasSelected = true;
						$scope.ambassador.id = args.id;
					})

					$scope.close = function () {
						modalInstance.close();
					};

					$scope.confirm = function () {
						$scope.viewState.isReady = false;

						getStartedPageService.post('school/v1/create/' + $scope.id_school + '/ambassador/' + $scope.ambassador.id, {
								label: $scope.ambassador.label
							})
							.then(function (response) {
									toastr.success('Success!');
									modalInstance.close();
								},
								function (error) {
									if (error.data.error.code == 403)
										toastr.error($translate.instant(error.data.error.message));
									else
										toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));

									$scope.viewState.isReady = true;
								});
					}
				},
				size: 'sm'
			});
		}

		$scope.redirectTo = function(url){
			window.open(url, '_blank');
		}
		$scope.redirectToNormal = function(url){
			window.location.href = url
		}

		$scope.callUserTag('NAV_LINK');

		}
		if ($rootScope.active_school && $rootScope.app_base_ready) {
			baseService.app_initialized();
		}
	}

})();

(function() {
	'use strict';

	angular.module('modules.events.view',[]).controller('eventsViewController', eventsViewController);

	/** @ngInject */
	function eventsViewController(baseService, $http, $scope, $document, $stateParams, $rootScope, $sce, $state, regexes, $uibModal, eventsService, toastr, $translate, settings, storage, $location, $window, $interpolate) {
		$scope.event = { 
			id: $stateParams.id
		};
		$scope.posts = new Array();

		baseService.app_initialized = function(evt, args) {
			document.body.scrollTop = 0;
			document.documentElement.scrollTop = 0;

			$scope.userRole = $rootScope.active_user.role;
			$scope.redirectPages = $stateParams.redirectPages;
			$scope.viewState = {
				isReady: false
			}

			$scope.userId = $rootScope.active_user.id;

			$scope.getEvent();

			if($rootScope.getQueryParam('payPalReturn') == 'true') {
				$scope.succededPayment();
			}
			else if($rootScope.getQueryParam('payPalReturn') == 'false') {
				$scope.failedPayment();
			}
		}

		$scope.downloadEventImage = function() {
			var imageUrl = $scope.event.fileLibrary.image;
			var fileName = 'event-image.jpg';

			
		}
		  
		$scope.events = {
			commentCallback : function (comment) {
				if(!$scope.event.comments) {
					$scope.event.comments = [];
				}

				comment.avatar = $rootScope.active_user.avatar;
				comment.postedBy = $rootScope.active_user.firstName + ' ' + $rootScope.active_user.lastName;
				comment.body = $rootScope.parseLinks(comment.body);

				$scope.event.comments.push(comment);
				$scope.event.commentCount++;
			}
		}

		$scope.hideMReplyDropdown = function() {
			$scope.event.showMReplyDropdown = false;
		}

		$scope.hideDReplyDropdown = function() {
			$scope.event.showDReplyDropdown = false;
		}

		$scope.back = function() {
			// if ($scope.event.createdById === $rootScope.active_user.id){
			// 	location.href = '/school/#/community-events/create/' + $scope.event.id;
			// }else{
			// 	location.href = '/school/#/community-events/list'
			// }
			$window.history.back();
		}

		$scope.switchToView = function() {
			$scope.switchApps('#/events/view/' + $scope.event.id);
		}

		$scope.showTickets = function() {
			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/events/views/view-tickets-modal.html',
				size:'md',
				controller: function($scope) {

					$scope.close = function() {
						modalInstance.close();
					};
				}
			})
		}

		$scope.joinOnlineEvent = function () {
			if($scope.event.onlineEventType == 'EXTERNAL'){
				if($scope.event.onlineEventExternalLink && $scope.event.onlineEventExternalLink != ''){
					window.open($scope.event.onlineEventExternalLink, "_blank");
				}
				return;
			}
			// $scope.canJoinOnlineEvent = false;
			eventsService.get('bench/v1/get/redirectionLink/' + $scope.event.id, { 'cache': false, 'xhr': true }).then(function (response) {
				if (response && response.data.payload && response.data.payload.redirectionLink) {
					var url = response.data.payload.redirectionLink;
					if (url.indexOf('https://') > -1) {
						url = url.replace('https://', 'http://')
					}
					$window.location.href = url;
				} else {
					// $scope.canJoinOnlineEvent = true;
					// TODO handle this
				}
			},
			function (error) {
				// $scope.canJoinOnlineEvent = true;
			})

		
		}
	
		$scope.closeInfo = function() {
			$scope.showInfoPast = false;
		}

		$scope.dismissSample = function() {
			$scope.event.sample = false;
		}
		
		$scope.downloadList = function(isticketed) {
			var filter = "ALL_INVITED";
			
			var _api = settings.conf.api;
			if($rootScope.isNative) {
				if(_api.indexOf('https://') > -1)
					_api = _api.replace('https://', 'http://')
			}

			if(isticketed) {
				window.open(_api + '/generator/attachment?type=attendeeTicketed&id=' + $scope.event.id + '&listType=' + filter, '_self');
			}
			else {
				window.open(_api + '/generator/attachment?type=attendee&id=' + $scope.event.id + "&listType=" + filter, '_self');
			}
		}

		$scope.getEvent = function() {
			angular.element(document).ready(function() {
				eventsService.get('communityEvent/v2/get/' + $scope.event.id+"/preview", {'cache':false, 'xhr':true}).then(function(response) {
					$scope.event = response.data;

					// PWA-8277 get the locked status of the post
					$scope.isLocked = (angular.isDefined(response.data.postDTO.payload.post.commentLocked))?response.data.postDTO.payload.post.commentLocked:false;

					$scope.viewState.isReady = true;
					$scope.event.description = $scope.event.description.replace(/\r?\n/g, '<br />');
					$scope.event.description = $rootScope.parseLinks($scope.event.description);

					$scope.posts.push(response.data.postDTO.payload.post);

					// PWA-8214 check that the current user is an owner of the event
					$scope.isEventOwner = false;

					for(i=0;i<$scope.event.eventOwners.length;i++) {

						if($scope.event.eventOwners[i].id == $rootScope.active_user.id) {
							$scope.isEventOwner = true;
							break;
						}
					}

					for(var i = 0; i < $scope.event.comments.length; i++)
						$scope.event.comments[i].body = $rootScope.parseLinks($scope.event.comments[i].body)
						
					if($scope.isPastEvent($scope.event) && ($rootScope.active_user.id == $scope.event.createdById))
						$scope.showInfoPast = true;

	
				}, 
				function(error) {
					
				})			
			});
		}

		$scope.getTickets = function() {
			$scope.ticketList = { };

			eventsService.get('communityEvent/v1/list/' + $scope.event.id + '/tickets', {'cache':false, 'xhr':true})
			.then(function(response) {

				if(response.data)
					$scope.ticketList = response.data;
			},
			function(error) {
				
			})
		}

		$scope.getTotalTickets = function(list) {
			var tot = 0;

			if(!list)
				return tot;

			for(var i = 0; i < list.length; i++) {
				
				if(list[i].quantity) {
					tot += (list[i].quantity * list[i].ticketPrice)
				}
			}

			return tot;
		}

		$scope.buyTickets = function() {
			$scope.getTickets();

			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/events/views/buy-tickets-modal.html',
				size:'md',
				controller: function($scope) {

					$scope.save = function() {
						var payload = { 
							eventId: $scope.event.id,
							tickets: []
						};

						for(var i = 0; i < $scope.ticketList.tickets.length; i++) {
							
							if($scope.ticketList.tickets[i].quantity) {
								payload.tickets.push({
									ticketTypeId: $scope.ticketList.tickets[i].id,
									quantity: $scope.ticketList.tickets[i].quantity
								})
							}
						}

						if(payload.tickets.length == 0) {
							// TODO: show an error
							return false;
						}

						if(storage.hasStorageEnabled() && storage.hasCookiesEnabled()) {
							$scope.buingTickets = true;
							location.href = settings.conf.api + '/payment/pay?t=' + encodeURIComponent(JSON.stringify(payload))
						}
						else {
							toastr.warning($translate.instant('PAYPAL_COOKIE_WARNING'));
						}
					};
					$scope.close = function() {
						modalInstance.close();
					};
				}
			})
		}

		$scope.showGuests = function(type) {

			function openModal(participants){
				var modalInstance = $uibModal.open({
					animation: true,
					templateUrl: 'app/base/views/show-participants-modal.html',
					backdropClass: 'backdrop-zindexed',
					size:'sm',
					controller: function($scope){
						$scope.participants = participants;
						$scope.eventContext = true;
						$scope.addDisabled = true;
						$scope.viewState = {
							isReady: true
						}

						$scope.openAddParticipantsModal = function() {
							activateInviteGuests();
						}

						$scope.close = function() {
							modalInstance.close();
						}
					}
				})
			}
			
			eventsService.get('communityEvent/v1/get/' + $scope.event.id + '/attendees/' + type, { 'cache': false }).then(function (response) {
				if(response.data.items) {
					openModal(response.data.items)
				}
			}, 
			function(error) {
				toastr.error($translate.instant('GENERIC_REQUEST_ERROR'))
			})
		}

		$scope.failedPayment = function() {
			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/events/views/payment-fail-modal.html',
				size:'md',
				controller: function($scope) {

					$scope.close = function() {
						modalInstance.close();
					};
				}
			})
		}

		$scope.openCommentImage = function(url){
			if ($rootScope.isNative) {
				$rootScope.previewImage(url)
			} else {
				window.open(url + '=s0', '_blank')
			}
		}

		$scope.succededPayment = function() {

			eventsService.get('payment/v1/get/' + $rootScope.getQueryParam('lid'), { 'cache': false, 'xhr': true }).then(function(response) {
				$scope.cofirmed_tickets = response.data;
			}, 
			function(error) {
				
			})

			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/events/views/payment-success-modal.html',
				size:'md',
				controller: function($scope) {

					$scope.close = function() {
						modalInstance.close();
					};
				}
			})
		}

		$scope.getNumber = function(num) {
			return new Array(num);   
		}
		
		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}

		$scope.getTicketsCount = function(list) {
			var count = 0;

			if(!list)
				return count;

			for(var i = 0; i < list.length; i++)
				count += list[i].quantity;

			return count;
		}

		$scope.goToDashboard = function() {
			location.href = '/school/#/community-events/dashboard/' + $scope.event.id;
		}

		// PWA-8277 ability to lock comments
		$scope.lockComments = function (){
			var postId = $scope.event.postId;
			var isLocked = $scope.isLocked;

			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: 'app/events/views/lock-comment-modal.html',
				backdropClass: 'backdrop-zindexed',
				size:'md',
				controller: function($scope) {
					//$scope.isLocked = isLocked;
					$scope.confirmLockComments = function() {	
						eventsService.put('post/v1/update/'+postId+'/commentLock', {} ).then(function() {
							if(isLocked){
								toastr.info($translate.instant('COMMENT_UNLOCKED'));
							}
							else toastr.info($translate.instant('COMMENT_LOCKED'));
							
							$state.reload();
							modalInstance.close();
						}, 
						function(error) {
							toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
						});

						modalInstance.close();
					}

					$scope.cancelLockComments = function() {
						modalInstance.close();
					}
				}
			})
		}

	}
})();
(function () {
	"use strict";

	angular
		.module("modules.events.tickets", [])
		.factory("eventTicketsService", [
			"base",
			function (base) {
				return _.create(base, {});
			},
		])
		.controller("eventTicketsController", eventTicketsController);

	/** @ngInject */
	function eventTicketsController(
		baseService,
		$scope,
		$state,
		$uibModal,
		settings,
		toastr,
		$translate,
		eventTicketsService,
		$rootScope,
		$stateParams,
		storage
	) {
		$scope.id_event = $stateParams.id_event;
		$scope.questions = [];
		$scope.tickets = [];
		$scope.availableCurrencies = [];
		var getSchool;
		var schoolId;
		var isCurrencySet = false;
		$scope.newTicketType = "";
		$scope.addingTicket = false;
		$scope.editingTicket = false;
		$scope.ticketCurrency = "GBP";
		$scope.paypal = {};
		$scope.validateEmail = validateEmail;
		$scope.unsavedChanges = false;
		$scope.refresh = false;
		$scope.questionUpdated = false;
		$scope.event = {};
		$scope.viewState = {
			isReady: false,
		};

		$scope.isAddTicketFormValid = function () {
			var result = true;
			if (!$scope.newTicketName || $scope.newTicketName === "") {
				$scope.newTicketNameInvalid = true;
				result = false;
			}

			if ($scope.newTicketType === "PAID") {
				if (
					!$scope.newTicketPrice ||
					$scope.newTicketPrice === "" ||
					$scope.newTicketPrice < 1.0
				) {
					$scope.newTicketPriceInvalid = true;
					result = false;
				}
			}

			if ($scope.newTicketType === "DONATION") {
				if (!!$scope.newTicketPrice && $scope.newTicketPrice < 1.0) {
					$scope.newTicketPriceInvalid = true;
					result = false;
				}
			}

			if ($scope.newTicketType === "PAID" || $scope.newTicketType === "FREE") {
				if (
					!$scope.newTicketQuantity ||
					$scope.newTicketQuantity === "" ||
					$scope.newTicketQuantity < 1
				) {
					$scope.newTicketQuantityInvalid = true;
					result = false;
				}
			}
			return result;
		};
		$scope.getEvent = function () {
			eventTicketsService
				.get("communityEvent/v2/get/" + $scope.id_event + "/preview", {
					cache: false,
					xhr: true,
				})
				.then(
					function (response) {
						$scope.event = response.data;
					},
					function (error) {}
				);
		};

		$scope.isEditTicketFormValid = function () {
			var result = true;
			if (!$scope.editTicketName || $scope.editTicketName === "") {
				$scope.editTicketNameInvalid = true;
				result = false;
			}

			if ($scope.editTicketType === "PAID") {
				if (
					!$scope.editTicketPrice ||
					$scope.editTicketPrice === "" ||
					$scope.editTicketPrice < 1.0
				) {
					$scope.newTicketPriceInvalid = true;
					result = false;
				}
			}

			if ($scope.editTicketType === "DONATION") {
				if (!!$scope.editTicketPrice && $scope.editTicketPrice < 1.0) {
					$scope.newTicketPriceInvalid = true;
					result = false;
				}
			}

			if (
				$scope.editTicketType === "PAID" ||
				$scope.editTicketType === "FREE"
			) {
				if (
					!$scope.editTicketQuantity ||
					$scope.editTicketQuantity === "" ||
					$scope.editTicketQuantity < 1
				) {
					$scope.editTicketQuantityInvalid = true;
					result = false;
				}
			}
			return result;
		};

		$scope.checkNewTicketName = function () {
			$scope.newTicketNameInvalid = $scope.newTicketName === "";
		};

		$scope.checkNewTicketQuantity = function () {
			$scope.newTicketQuantityInvalid =
				$scope.newTicketQuantity === "" || $scope.newTicketQuantity < 1;
		};

		$scope.checkNewTicketPrice = function (isDonation) {
			if (isDonation) {
				$scope.newTicketPriceInvalid =
					!!$scope.newTicketPrice && $scope.newTicketPrice < 1.0;
			} else {
				$scope.newTicketPriceInvalid =
					$scope.newTicketPrice === "" || $scope.newTicketPrice < 1.0;
			}
		};

		$scope.checkEditTicketName = function () {
			$scope.editTicketNameInvalid = $scope.editTicketName === "";
		};

		$scope.checkEditTicketQuantity = function () {
			$scope.editTicketQuantityInvalid =
				$scope.editTicketQuantity === "" || $scope.editTicketQuantity < 1;
		};

		$scope.checkEditTicketPrice = function (isDonation) {
			if (isDonation) {
				$scope.editTicketPriceInvalid =
					!!$scope.editTicketPrice && $scope.editTicketPrice < 1.0;
			} else {
				$scope.editTicketPriceInvalid =
					$scope.editTicketPrice === "" || $scope.editTicketPrice < 1.0;
			}
		};

		$scope.toggleAddTicket = function () {
			if ($scope.addingTicket) {
				$scope.addingTicket = false;
			} else {
				$scope.clearNewTicket();
				$scope.addingTicket = true;
			}
		};

		$scope.toggleEditTicket = function () {
			if ($scope.editingTicket) {
				$scope.editingTicket = false;
				$scope.clearEditTicket();
			} else {
				$scope.editingTicket = true;
			}
		};

		$scope.setTicketType = function (type) {
			$scope.newTicketType = type;
		};

		$scope.clearNewTicket = function () {
			$scope.addingTicket = false;
			$scope.newTicketType = "";
			$scope.newTicketName = null;
			$scope.newTicketQuantity = null;
			$scope.newTicketPrice = null;
			$scope.newTicketNameInvalid = false;
			$scope.newTicketPriceInvalid = false;
			$scope.newTicketQuantityInvalid = false;
		};

		$scope.clearEditTicket = function () {
			$scope.editingTicket = false;
			$scope.editTicketName = null;
			$scope.editTicketQuantity = null;
			$scope.editTicketPrice = null;
			$scope.editTicketIndex = null;
			$scope.editTicketNameInvalid = false;
			$scope.editTicketPriceInvalid = false;
			$scope.editTicketQuantityInvalid = false;
		};

		$scope.addFreeTicket = function () {
			if ($scope.isAddTicketFormValid()) {
				var ticket = {
					ticketType: $scope.newTicketType,
					ticketName: $scope.newTicketName,
					availableTicket: $scope.newTicketQuantity,
				};
				$scope.tickets.push(ticket);
				$scope.unsavedChanges = true;
				$scope.clearNewTicket();
			}
		};

		$scope.addPaidTicket = function () {
			if ($scope.isAddTicketFormValid()) {
				var ticket = {
					ticketType: $scope.newTicketType,
					ticketName: $scope.newTicketName,
					availableTicket: $scope.newTicketQuantity,
					ticketPrice: $scope.newTicketPrice,
				};
				$scope.tickets.push(ticket);
				$scope.unsavedChanges = true;
				$scope.clearNewTicket();
			}
		};

		$scope.addDonationTicket = function () {
			if ($scope.isAddTicketFormValid()) {
				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: "backdrop-zindexed",
					templateUrl: "app/info_modals/info-modal-18.html",
					controller: function ($scope) {
						$scope.close = function () {
							modalInstance.close();
						};
					},
					size: "sm",
				});

				var ticket = {
					ticketType: $scope.newTicketType,
					ticketName: $scope.newTicketName,
					ticketPrice: $scope.newTicketPrice,
				};
				$scope.tickets.push(ticket);
				$scope.unsavedChanges = true;
				$scope.clearNewTicket();
			}
		};

		$scope.editFreeTicket = function () {
			if ($scope.isEditTicketFormValid()) {
				$scope.tickets[$scope.editTicketIndex].ticketName =
					$scope.editTicketName;
				$scope.tickets[$scope.editTicketIndex].availableTicket =
					$scope.editTicketQuantity;
				$scope.unsavedChanges = true;
				$scope.clearEditTicket();
			}
		};

		$scope.editPaidTicket = function () {
			if ($scope.isEditTicketFormValid()) {
				$scope.tickets[$scope.editTicketIndex].ticketName =
					$scope.editTicketName;
				$scope.tickets[$scope.editTicketIndex].availableTicket =
					$scope.editTicketQuantity;
				$scope.tickets[$scope.editTicketIndex].ticketPrice =
					$scope.editTicketPrice;
				$scope.unsavedChanges = true;
				$scope.clearEditTicket();
			}
		};

		$scope.editDonationTicket = function () {
			if ($scope.isEditTicketFormValid()) {
				$scope.tickets[$scope.editTicketIndex].ticketName =
					$scope.editTicketName;
				$scope.tickets[$scope.editTicketIndex].ticketPrice =
					$scope.editTicketPrice;
				$scope.unsavedChanges = true;
				$scope.clearEditTicket();
			}
		};

		$scope.editTicket = function (i) {
			$scope.addingTicket = false;
			$scope.setEditTicket(i);
			/*
			if($scope.tickets && !!$scope.tickets[i].sold && $scope.tickets[i].sold > 0) {
				var modalInstance = $uibModal.open({
					animation: true,
					scope: $scope,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/events/views/ticket-type-edit-warning-modal.html',
					size:'md',
					controller: function($scope) {
						$scope.cancel = function() {
							modalInstance.close();
						}
						$scope.addNewTicket = function() {
							$scope.toggleAddTicket();
							modalInstance.close();
						};
					}
				});
			} else {
				$scope.addingTicket = false;
				$scope.setEditTicket(i);
			}*/
		};
		$scope.isOrderChanged = false;
		$scope.ticketOrder = function (i, isUp) {
			if(!$scope.tickets || $scope.tickets.length == 0) return;

			if ((isUp && i === 0) || (!isUp && i === $scope.tickets.length - 1)) {
				return;
			}
			$scope.isOrderChanged = true;

			if (isUp && i > 0) {
				var temp = $scope.tickets[i - 1];
				$scope.tickets[i - 1] = $scope.tickets[i];
				$scope.tickets[i] = temp;
		
			} else if (!isUp && i < $scope.tickets.length - 1) {
				var temp = $scope.tickets[i + 1];
				$scope.tickets[i + 1] = $scope.tickets[i];
				$scope.tickets[i] = temp;
			}
		};

		$scope.setEditTicket = function (i) {
			$scope.editTicketIndex = i;
			$scope.editTicketType = $scope.tickets[i].ticketType || "FREE";
			$scope.editTicketName = $scope.tickets[i].ticketName || "";
			$scope.editTicketQuantity = $scope.tickets[i].availableTicket || 0;
			if ($scope.tickets[i].ticketPrice) {
				$scope.editTicketPrice =
					parseFloat($scope.tickets[i].ticketPrice).toFixed(2) || 0;
			}
			$scope.editTicketPriceDisabled =
				!!$scope.tickets &&
				$scope.tickets[i].sold != null &&
				$scope.tickets[i].sold > 0;
			$scope.editingTicket = true;
		};

		$scope.deleteTicket = function (i) {
			if (!!$scope.tickets[i].sold && $scope.tickets[i].sold > 0) {
				var modalInstance = $uibModal.open({
					animation: true,
					scope: $scope,
					backdropClass: "backdrop-zindexed",
					templateUrl: "app/events/views/remove-ticket-type-modal.html",
					size: "md",
					controller: function ($scope) {
						$scope.cancel = function () {
							modalInstance.close();
						};
						$scope.confirm = function () {
							$scope.tickets.splice(i, 1);
							$scope.unsavedChanges = true;
							modalInstance.close();
						};
					},
				});
			} else {
				$scope.tickets.splice(i, 1);
				$scope.unsavedChanges = true;
			}
		};

		//FIXME REDIRECT
		$scope.redirectToStripe = function (type) {
			if(type === "update"){
				window.localStorage.setItem("tickets", JSON.stringify($scope.tickets));
				window.localStorage.setItem("ticketCurrency", $scope.ticketCurrency);
			}
			var url = settings.conf.api.replace("https", "http");
			window.location.href =
				url +
				"/payment/onboardstripesellerto?nd=true&t=" +
				storage.getToken() +
				"&eid=" +
				$scope.id_event +
				(type ? "&type=" + type : "");
		};

		$scope.getStripe = function () {
			$scope.refresh = true;
			window.localStorage.setItem("tickets", JSON.stringify($scope.tickets));
			window.localStorage.setItem("ticketCurrency", $scope.ticketCurrency);
			baseService
				.post("shared/v1/add/userTag", {
					tagName: "EVENT_PAID_TICKET_INITIATED_STRIPE",
					referrer: document.referrer,
					schoolId:
						$rootScope.active_school && $rootScope.active_school.id
							? $rootScope.active_school.id
							: -1,
					source: "SCHOOL",
				})
				.then(
					function (response) {
						$scope.redirectToStripe("signup");
					},
					function (error) {
						$scope.redirectToStripe("signup");
					}
				);
		};

		$scope.setPaypal = function () {
			$rootScope.userTag("EVENT_PAID_TICKET_INITIATED_PAYPAL");

			$scope.paymentProvider = {
				provider: "paypal",
			};
		};

		$scope.connectPaypal = function () {
			if ($scope.publicEvent) {
				$scope.openPaypalWarningModal();
			} else {
				$scope.openPaypalInfoModal();
			}
		};

		$scope.openPaypalInfoModal = function () {
			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: "backdrop-zindexed",
				templateUrl: "app/events/views/getpaid-using-paypal-modal.html",
				size: "md",
				controller: function ($scope) {
					$scope.cancel = function () {
						$scope.setPaypal();
						modalInstance.close();
					};
				},
			});
		};

		$scope.openPaypalWarningModal = function () {
			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: "backdrop-zindexed",
				templateUrl: "app/events/views/shared-event-paypal-warning-modal.html",
				size: "md",
				controller: function ($scope) {
					$scope.cancel = function () {
						modalInstance.close();
					};
					$scope.continue = function () {
						$scope.setPaypal();
						modalInstance.close();
					};
				},
			});
		};

		$scope.cancelTickets = function () {
			if ($scope.tickets.length > 0) {
				var modalInstance = $uibModal.open({
					animation: true,
					scope: $scope,
					backdropClass: "backdrop-zindexed",
					templateUrl: "app/events/views/cancel-ticket-type-modal.html",
					size: "md",
					controller: function ($scope) {
						$scope.stay = function () {
							modalInstance.close();
						};
						$scope.leave = function () {
							$scope.unsavedChanges = false;
							modalInstance.close();
							$scope.decideGoBack();
						};
					},
				});
			} else {
				$scope.unsavedChanges = false;
				$scope.decideGoBack();
			}
		};

		$scope.toggleCreatingTickets = function () {
			$scope.creatingTickets = !$scope.creatingTickets;
		};
		$scope.questionUpdateFun = function (questionId) {
			if (questionId) {
				$scope.questionUpdated = true;
			}
		};
		$scope.validateQuestionsChangeAndSaveTickets = function (id) {
			if ($scope.event.status == "ACTIVE" && $scope.questionUpdated) {
				var modalInstance = $uibModal.open({
					animation: true,
					scope: $scope,
					backdropClass: "backdrop-zindexed",
					templateUrl: "app/events/views/ticket-question-update-warning.html",
					size: "md",
					controller: function ($scope) {
						$scope.continue = function () {
							modalInstance.close();
							$scope.saveTickets();
						};
						$scope.cancel = function () {
							modalInstance.close();
						};
					},
				});
			} else {
				$scope.saveTickets();
			}
		};
		$scope.validateQuestionsAndDelete = function (index, question) {
			if ($scope.event.status == "ACTIVE" && question && question.id) {
				var modalInstance = $uibModal.open({
					animation: true,
					scope: $scope,
					backdropClass: "backdrop-zindexed",
					templateUrl: "app/events/views/ticket-question-delete-warning.html",
					size: "md",
					controller: function ($scope) {
						$scope.continue = function () {
							modalInstance.close();
							$scope.removeQuestion(index, question);
						};
						$scope.cancel = function () {
							modalInstance.close();
						};
					},
				});
			} else {
				$scope.removeQuestion(index, question);
			}
		};
		$scope.saveTickets = function () {
			$scope.creatingTickets = true;

			var payload = {
				ticketCurrency: $scope.ticketCurrency,
				questions: $scope.questions,
			};

			if ($scope.tickets.length === 0) {
				$scope.toggleCreatingTickets();
				return false;
			}
			for (var i = 0; i < $scope.tickets.length; i++) {
				if (!$scope.tickets[i].order || $scope.tickets[i].order < 0) {
					$scope.tickets[i].order = i;
				}
			}
			if ($scope.hasPaidTickets() && !$scope.paymentProvider) {
				var modalInstance = $uibModal.open({
					animation: true,
					scope: $scope,
					backdropClass: "backdrop-zindexed",
					templateUrl: "app/events/views/ticket-type-no-provider-modal.html",
					size: "md",
					controller: function ($scope) {
						$scope.continue = function () {
							var freeTickets = [];
							for (var i = 0; i < $scope.tickets.length; i++) {
								if ($scope.tickets[i].ticketType === "FREE") {
									freeTickets.push($scope.tickets[i]);
								}
							}
							$scope.tickets = freeTickets;
							payload.tickets = freeTickets;
							modalInstance.close();
							if (freeTickets.length !== 0) {
								$scope.postTickets(payload);
							} else {
								$scope.toggleCreatingTickets();
								modalInstance.close();
							}
						};
						$scope.cancel = function () {
							$scope.toggleCreatingTickets();
							modalInstance.close();
						};
					},
				});
			} else if (
				$scope.hasPaidTickets() &&
				$scope.paymentProvider.provider === "paypal"
			) {
				if (
					!$scope.paypal.mail ||
					!$scope.paypal.repeat ||
					$scope.paypal.mail !== $scope.paypal.repeat ||
					!validateEmail($scope.paypal.mail)
				) {
					$scope.paypalMailInvalid = true;
					$scope.paypalRepeatInvalid = true;
					$scope.toggleCreatingTickets();
					return false;
				} else {
					payload.paypalEmail = $scope.paypal.mail;
					payload.tickets = $scope.tickets;
					$scope.postTickets(payload);
				}
			} else {
				payload.tickets = $scope.tickets;
				$scope.postTickets(payload);
			}
		};
		$scope.postTickets = function (payload) {
			eventTicketsService
				.post(
					"communityEvent/v2/update/" + $scope.id_event + "/tickets",
					payload
				)
				.then(
					function (response) {
						$scope.creatingTickets = false;
						$scope.unsavedChanges = false;
						$scope.decideGoBack();
					},
					function (error) {
						$scope.creatingTickets = false;

						if (error.data.error.code == 400) {
							toastr.error($translate.instant(error.data.error.message));
						} else {
							toastr.error($translate.instant("GENERIC_REQUEST_ERROR"));
						}
					}
				);
		};

		$scope.hasPaidTickets = function () {
			for (var i = 0; i < $scope.tickets.length; i++) {
				if ($scope.tickets[i].ticketType !== "FREE") {
					return true;
				}
			}
			return false;
		};

		// Init the beforeunlodpage on this page
		var onBeforeunload = $rootScope.$on("events.tickets", function (evt, args) {
			if ($scope.unsavedChanges) {
				var modalInstance = $uibModal.open({
					animation: true,
					scope: $scope,
					backdropClass: "backdrop-zindexed",
					templateUrl: "app/events/views/unsaved-changes-modal.html",
					size: "md",
					controller: function ($scope) {
						$scope.leave = function () {
							onBeforeunload();
							$state.go(args.toState.name, args.toParams);
						};
						$scope.stay = function () {
							modalInstance.close();
						};
					},
				});

				args.e.preventDefault();
			} else {
				onBeforeunload();
			}
		});

		$scope.openInfo = function (e, type) {
			if (e) {
				e.stopImmediatePropagation();
				e.stopPropagation();
			}

			var modalInstance = $uibModal.open({
				animation: true,
				backdropClass: "backdrop-zindexed",
				templateUrl: "app/info_modals/info-modal-8.html",
				controller: function ($scope) {
					$scope.close = function () {
						modalInstance.close();
					};
				},
				size: "sm",
			});
		};

		$scope.openStripeInfoModal = function (e, type) {
			if (e) {
				e.stopImmediatePropagation();
				e.stopPropagation();
			}

			var modalInstance = $uibModal.open({
				animation: true,
				backdropClass: "backdrop-zindexed",
				templateUrl: "app/events/views/stripe-connect-info-modal.html",
				controller: function ($scope) {
					$scope.close = function () {
						modalInstance.close();
					};
				},
				size: "md",
			});
		};
		getSchool = function () {
			eventTicketsService
				.get("school/v1/get/" + schoolId + "/details", {
					xhr: true,
					cache: false,
				})
				.then(
					function (response) {
						if (!isCurrencySet) {
							$scope.ticketCurrency = response.data.payload.currency || "GBP";
						}
					},
					function (error) {
						if (error.status != 401)
							toastr.error($translate.instant("GENERIC_REQUEST_ERROR"));
					}
				);
		};

		$scope.getTickets = function () {
			eventTicketsService
				.get("communityEvent/v2/list/" + $scope.id_event + "/tickets", {
					cache: false,
					xhr: true,
				})
				.then(
					function (response) {
						$scope.paymentProvider = response.data.paymentProvider;
						$scope.publicEvent = response.data.open || false;
						$scope.questions = [];
						if (response.data.paypalEmail) {
							$scope.paypal.mail = response.data.paypalEmail;
							$scope.paypal.repeat = response.data.paypalEmail;
						}

						if (response.data.questions) {
							for (var i = 0; i < response.data.questions.length; i++) {
								var q = response.data.questions[i];
								q.title = $rootScope.removeLinks(q.title);
								$scope.questions.push(q);
							}
						}

						if (response.data.ticketCurrency) {
							isCurrencySet = true;
							$scope.ticketCurrency = response.data.ticketCurrency;
						}

						if (response.data.tickets) {
							$scope.isUpdating = true;
							$scope.tickets = response.data.tickets;
						}

						var hasStripeError = $rootScope.getQueryParam("error");
						if (hasStripeError) {
							// TODO: check what to do if any error comes from stripe
						}
						var stripe = $rootScope.getQueryParam("stripe");
						if (stripe === "true") {
							if(window.localStorage.getItem("tickets") != null){
								$scope.tickets = JSON.parse(
									window.localStorage.getItem("tickets")
								);
								window.localStorage.removeItem("tickets");
							}
							if(window.localStorage.getItem("ticketCurrency") != null){
								$scope.ticketCurrency = window.localStorage.getItem("ticketCurrency");
								window.localStorage.removeItem("ticketCurrency");
							}
							
							isCurrencySet = true;
							$scope.unsavedChanges = true;
						}

						$scope.viewState.isReady = true;

						setTimeout(function () {
							var inputs = document.querySelectorAll("[autoresize-textarea]");
							if (inputs && inputs.length > 0) {
								for (var i = 0; i < inputs.length; i++)
									inputs[i].style.height =
										Math.min(inputs[i].scrollHeight, 1000) + 2 + "px";
							}
						});
					},
					function (error) {}
				);
		};

		baseService.app_initialized = function (evt, args) {
			$scope.getTickets();
			$scope.getEvent();
			getAndSetAvailableCurrencies();
			schoolId = $rootScope.active_school.id;
			getSchool();
		};
		
		$scope.addQuestion = function (e) {
			$scope.invalidQuaestionInfo = false;

			if (!$scope.checkQuestionValidation(e)) {
				$scope.invalidQuaestionInfo = true;
				return;
			}

			$scope.questions.push({ new: true, type: "PLAIN" });
		};

		$scope.removeQuestion = function (index, item) {
			$scope.questions.splice(index, 1);
		};

		$scope.checkQuestionValidation = function (e) {
			$scope.invalidQuestionInfo = false;

			for (var i = 0; i < this.questions.length; i++) {
				var t = this.questions[i];

				if (!t.title) {
					$scope.invalidQuestionInfo = true;
					focusListValidator(e);
					return false;
				}
			}

			return true;
		};
		$scope.goBack = function () {
			var eventId = $scope.id_event;
			if($scope.isOrderChanged){
				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: "backdrop-zindexed",
					templateUrl: "app/info_modals/confirm-savechanges.html",
					size: "md",
					controller: function ($scope) {
						$scope.review = function () {
							modalInstance.close();
							return;
						};
						$scope.leave = function () {
							if ($rootScope.history && $rootScope.history.length > 1) {
								window.location.href =
									$rootScope.history[$rootScope.history.length - 1];
							} else {
								window.location.href =
									"/school/#/community-events/create/" + eventId;
							}
						};
					},
				});
			}else{
				$scope.decideGoBack();
			}
		}

		$scope.decideGoBack = function () {
			
			if ($rootScope.history && $rootScope.history.length > 1) {
				window.location.href =
					$rootScope.history[$rootScope.history.length - 1];
			} else {
				//we know this is a problem
				//if you go to dashboard, manage tickets, switch stripe, then save
				//it will go back to create
				//to fix this we have to write to local storage.
				//we will leave it for now
				window.location.href =
					"/school/#/community-events/create/" + $scope.id_event;
			}
		};

		if ($rootScope.active_school && $rootScope.app_base_ready) {
			baseService.app_initialized();
		}

		function focusListValidator(e) {
			if (!e) return;

			var elem = angular.element(e.srcElement).parent().parent().parent();

			if (!elem[0]) return;

			setTimeout(function () {
				var inputs = elem[0].getElementsByTagName("input");

				if (inputs.length == 0) {
					inputs = elem[0].getElementsByTagName("textarea");
				}

				if (inputs.length == 0) {
					return;
				}

				for (var i = 0; i < inputs.length; i++) {
					if (!inputs[i].value) {
						inputs[i].focus();
						break;
					}
				}
			}, 100);
		}

		function getAndSetAvailableCurrencies() {
			$scope.viewState.isReady = false;
			try {
				eventTicketsService
					.get("shared/v1/list/currencies/" + $rootScope.active_school.id, {
						cache: false,
						xhr: true,
					})
					.then(function (response) {
						$scope.viewState.isReady = true;
						$scope.availableCurrencies = response.data.items;
					});
			} catch (ex) {}
		}

		$scope.refreshPage = function () {
			window.location.href = window.location.href + "?stripe=true";
			window.location.reload();
		};
	}
})();

(function() {
	'use strict';

	angular.module('modules.events.start',[]).factory('eventsStartService', ['base', function (base) {
		return _.create(base, { });
	}]).controller('eventsStartController', eventsStartController);

	/** @ngInject */
	function eventsStartController($rootScope, baseService, $http, $uibModal, eventsService, $scope, regexes,$introjs) {
		$scope.regexes = regexes;
		$scope.popupStartDate = { };
		$scope.popupEndDate = {};
		$scope.event = {
			date: { },
			invalid: { }
		}
		$scope.dateOptions = {
			showWeeks: false
		}

		$http.get('i8n/locale-metadata-en-GB.json?v=12').then(function(data) {
			$scope.eventTimes = data.data.metadata.eventTimes
		});

		$scope.back = function() {
			location.href = '/school/#/community-events/list';
		}
		
		$scope.pickStartDate = function() {
			$scope.popupStartDate.opened = true;
		}

		$scope.pickEndDate = function() {
			$scope.popupEndDate.opened = true;
		}


		$scope.startDateTime;
		$scope.startDateTimeInstance;
		$scope.startTimeOpts = {
			placeholder: 'Pick time',
			enableTime: true,
			noCalendar: true,
			altInput: true,  
            dateFormat: "H:i K", 
			altFormat: "H:i K", 
			allowInput: true,
			disableMobile: true,
			onChange: function(selectedDates, dateStr, instance){
			  $scope.eventStartDateOptions.onTimeSelect(selectedDates)
			},
		};

		$scope.endDateTime;
		$scope.endDateTimeInstance;
		$scope.endTimeOpts = {
			placeholder: 'Pick time',
			enableTime: true,
			noCalendar: true,
			altInput: true,  
            dateFormat: "H:i K", 
			altFormat: "H:i K", 
			allowInput: false,
			disableMobile: true,
			onChange: function(selectedDates, dateStr, instance){
			  $scope.eventEndDateOptions.onTimeSelect(selectedDates)
			},
		};

		$scope.startDateTimePostSetup = function(fpItem) {
			$scope.startDateTimeInstance = fpItem;
			$scope.setDefaultEventDates();
		}

		$scope.endDateTimePostSetup = function(fpItem) {
			$scope.endDateTimeInstance = fpItem;
			$scope.setDefaultEventDates();
		}

		$scope.setDefaultEventDates = function() {
			var now_date = new Date();
			now_date.setHours(now_date.getHours() + 1);
			now_date.setMinutes((Math.round(now_date.getMinutes() / 15) * 15) % 60)

			$scope.startDate = new Date(now_date.getFullYear(), now_date.getMonth(), now_date.getDate());
			if($scope.startDateTimeInstance){
				$scope.startDateTimeInstance.setTime(now_date.getHours(), now_date.getMinutes(), null);  
			}
			$scope.startDateTime = now_date;


			now_date = new Date();
			now_date.setHours(now_date.getHours() + 4);
			now_date.setMinutes((Math.round(now_date.getMinutes() / 15) * 15) % 60)
			$scope.endDate = new Date(now_date.getFullYear(), now_date.getMonth(), now_date.getDate());
			if($scope.endDateTimeInstance){
				$scope.endDateTimeInstance.setTime(now_date.getHours(), now_date.getMinutes(), null);  
			}
			$scope.endDateTime = now_date;


			setTimeout(function(){
				if(!$scope.startDateTimeInstance || !$scope.endDateTimeInstance){
					$scope.setDefaultEventDates();
				}
			}, 2000)
		}

		$scope.getNearestQuarter = function(minutes) {
			return (((minutes + 7.5)/15 | 0) * 15) % 60;
		}

		$scope.eventStartDateOptions = {
			onTimeSelect: function(time) {
				if($scope.event.date.startDate && time) {
					$scope.event.date.startDate.setHours(time.getHours())
					$scope.event.date.startDate.setMinutes(time.getMinutes());
				}

				$scope.errorMessage = null;
				$scope.eventStartDateOptions.onDateSelect($scope.event.date.startDate);
			},
			onDateSelect: function(date) {
				$scope.errorMessage = null;
				$scope.event.date.startDate = date;
			}
		}

		$scope.eventEndDateOptions = {
			onTimeSelect: function(time) {
				if($scope.event.date.endDate && time) {
					$scope.event.date.endDate.setHours(time.getHours())
					$scope.event.date.endDate.setMinutes(time.getMinutes());
				}

				$scope.errorMessage = null;
				$scope.eventEndDateOptions.onDateSelect($scope.event.date.endDate);
			},
			onDateSelect: function(date) {
				$scope.errorMessage = null;
				$scope.event.date.endDate = date;
			}
		}

		$scope.$watch('startDate', function(newValue, oldValue) {
			if(!newValue) {
				return;
			}

			if($scope.startDateTime) {
				newValue.setHours($scope.startDateTime.getHours())
				newValue.setMinutes($scope.startDateTime.getMinutes());
			}

			$scope.eventStartDateOptions.onDateSelect(newValue);
		});
		
		$scope.$watch('endDate', function(newValue, oldValue) {
			if(!newValue) {
				return;
			}

			if($scope.endDateTime) {
				newValue.setHours($scope.endDateTime.getHours())
				newValue.setMinutes($scope.endDateTime.getMinutes());
			}
			
			$scope.eventEndDateOptions.onDateSelect(newValue);
		});

		$scope.save = function() {
			$scope.saving = true;
			eventsService.put('communityEvent/v2/create/'+$rootScope.active_school.id, { 
				title: $scope.event.title,
				startDate: $rootScope.getWithoutTimeZone($scope.event.date.startDate),
				endDate: $rootScope.getWithoutTimeZone($scope.event.date.endDate)
			})
			.then(function(response) {
				$scope.saving = false;
				if(!response || !response.data || !response.data.id) {
					toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
					return;
				}
				
				location.href = '/school/#/community-events/create/' + response.data.id;
			},
			function(error) {
				$scope.saving = false;
				if(error.data.error.code == 400) {
					$scope.errorMessage = error.data.error.message;
				}
				else {
					toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
				}
			})
			
		}

		$scope.closeInfo = function() {
			$scope.showFromParentInfo = false;
		}

		$scope.dismissInfo = function() {
			$scope.showFromParentInfo = false;
			$rootScope.dismissTodo('SCHOOL_NEW_COMMUNITY_EVENT_INFO');
		}

		$scope.openHowToTryModal = function(){
			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/events/views/event-create-how-to-try-modal.html',
				size: 'md',
				controller: function ($scope) {
					$scope.close = function () {
						modalInstance.close();
					}
				}
			})
		}

		baseService.app_initialized = function(evt, args) {
			$introjs.setAppCue("SCHOOL_COMMUNITY_EVENT_TOUR","EVENT_CREATE",1000);
			$introjs.setAppCue("SCHOOL_FIRST_AMBASSADOR_COMMUNITY_EVENT_TOUR","EVENT_CREATE",1000);
			var from = $rootScope.getQueryParam('from');
			if(!!from && from === 'parent') {
				$rootScope.checkTodo('SCHOOL_NEW_COMMUNITY_EVENT_INFO').then(function (resp) {
					if (resp.data.payload.show) {
						$scope.showFromParentInfo = true;
					}
				});
			}
		}

		if($rootScope.active_school && $rootScope.app_base_ready) {
			baseService.app_initialized();
		}
		$scope.getDefaultDate = function(){
			var now_date = new Date();
			now_date.setHours(now_date.getHours());
			now_date.setMinutes((Math.round(now_date.getMinutes() / 15) * 15) % 60)
			return now_date;
		}
		
	}
})();

(function() {
	'use strict';

	angular.module('modules.events.rotadetails',[]).factory('eventRotaDetailsService', ['base', function (base) {
		return _.create(base, { });
	}]).controller('eventRotaDetailsController', eventRotaDetailsController);

	/** @ngInject */
	function eventRotaDetailsController(baseService, $scope, $state, eventRotaDetailsService, $uibModal, $rootScope, $window, $stateParams, $http, toastr, settings, storage, $translate) {
		$scope.id_event = $stateParams.id_event;
		$scope.id_rota = $stateParams.id_rota;
		$scope.id_task = $stateParams.id_task;
		$scope.taskList = [];
		
		$scope.viewState = {
			isReady: false
		}
		$scope.canSendMessage = true;
		$scope.getRota = function() {
			$scope.gettingrota = true;
			eventRotaDetailsService.get('rota/v1/' + $scope.id_rota, {'cache':false, 'xhr':true}).then(function(response) {
				$scope.gettingrota = false;

				if(!response || !response.data)
					return;

				$scope.rota = response.data;

				var startTime = $scope.rota.startDate ? new Date($scope.rota.startDate) : new Date();
				var endTime = $scope.rota.endDate ? new Date($scope.rota.endDate) : new Date();

				startTime = (startTime.getHours() > 9 ? startTime.getHours() : '0' + (startTime.getHours())) + ':' + (startTime.getMinutes() > 9 ? startTime.getMinutes() : '0' + (startTime.getMinutes()));

				endTime = (endTime.getHours() > 9 ? endTime.getHours() : '0' + (endTime.getHours())) + ':' + (endTime.getMinutes() > 9 ? endTime.getMinutes() : '0' + (endTime.getMinutes()));

				$scope.rota.startTime = startTime;
				$scope.rota.startTime = startTime;
				$scope.rota.endTime = endTime;
				$scope.rotaDate = new Date($scope.rota.startDate);

				if(!$scope.rota.slotLength)
					$scope.rota.slotLength = '30';
				else
					$scope.rota.slotLength = $scope.rota.slotLength.toString();

				$scope._rota = angular.copy($scope.rota);
			}, 
			function(error) {
				$scope.gettingrota = false;
			})
		}

		$scope.openRota = function (rota) {
			$rootScope.decideToRota =
				"/school/#/community-events/dashboard/" + $scope.id_event;
			location.href =
				"/school/#/community-events/" + $scope.id_event + "/signup/" + rota.id;
		};
		$scope.getTasks = function() {
			eventRotaDetailsService.get('rota/v1/' + $scope.id_rota + '/task/expanded', {'cache':false, 'xhr':true}).then(function(response) {
				if(!response || !response.data || !response.data.items)
					return;

				$scope.taskList = response.data.items;
				$scope.canSendMessage = false;

				$scope.taskList.forEach(function(item) {
					var hasVolunteer = item.slots.some(function(slot) {
						return slot.volunteers && slot.volunteers.length >= 1;
					});
					if(hasVolunteer){
						$scope.canSendMessage = true;
					}
				});
			}, 
			function(error) {
				
			})
			$scope.viewState.isReady = true;
		}

		$scope.getUTCDatetime = function(date) {
			if(!!date) {
				return $rootScope.getUTCDatetime(date);
			} else {
				return date;
			}
		}

		$scope.downloadCSV = function() {
			var url = settings.gae.rootUrl + "attachment?id="+$scope.id_event+"&type=rota";
			url = url + ("&zu=" + $rootScope.currentUserId());
			window.open(url, "_blank");
		}

		$scope.removeVolunteer = function(slot, volunteer, index) {
			var id_rota = $scope.id_rota;

			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/events/views/remove-parent-rota-modal.html',
				size:'sm',
				controller: function($scope) {

					$scope.save = function() {
						$scope.removingvolunteer = true;

						eventRotaDetailsService.delete('rota/v1/' + id_rota + '/school/' + slot.id + '/unbook/' + volunteer.userId, {'cache':false, 'xhr':true}).then(function(response) {
							$scope.removingvolunteer = false;
							slot.volunteers.splice(index, 1);
							modalInstance.close();
						}, 
						function(error) {
							$scope.removingvolunteer = false;
						})
					};
					$scope.close = function() {
						modalInstance.close();
					};
				}
			})
		}

		$scope.getTask = function(id_task) {
			eventRotaDetailsService.get('rota/v1/' + $scope.id_rota + '/task/' + id_task, {'cache':false, 'xhr':true}).then(function(response) {
				if(!response || !response.data || !response.data.items)
					return;

				$scope.taskList = response.data.items;
				$scope.viewState.isReady = true;
				}, 
			function(error) {
				
			})
		}

		$scope.decideGoBack = function() {
			if($rootScope.decideToRota) {
				window.location.href = $rootScope.decideToRota;
				return;
			}

			if ($rootScope.history && $rootScope.history.length > 1){
				window.location.href = $rootScope.history[$rootScope.history.length - 1];
			} else {
				window.location.href = '/school/#/community-events/' + $scope.id_event + '/signup/' + $scope.id_rota;
			}
		}
		
		baseService.app_initialized = function(evt, args) {
			//$scope.getEvent();

			if($scope.id_rota) {
				$scope.getRota();
				
				if(!$scope.id_task) {
					$scope.getTasks();
				}
				else {
					$scope.getTask($scope.id_task);
				}
			}
		}

		if($rootScope.active_school && $rootScope.app_base_ready) {
			baseService.app_initialized();
		}
		$scope.getAllActiveTasks = function (){
			var messageTaskList = [];
			$scope.taskList.forEach(function(item) {
				var hasVolunteer = item.slots.some(function(slot) {
					return slot.volunteers && slot.volunteers.length >= 1;
				});
				if(hasVolunteer){
					item.selected = true
					messageTaskList.push(item)
				}
			});
			return messageTaskList;
		}
		$scope.messageGuests = function() {
			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/events/views/send-signup-message-notification-modal.html',
				size:'md',
				controller: function($scope) {
					$scope.enableSelectList = false;
					$scope.messageTaskList = $scope.getAllActiveTasks()
					$scope.canSendMessage = $scope.messageTaskList && $scope.messageTaskList.length > 0;
					$scope.changeGuestType = function(value) {
						$scope.enableSelectList = value
						if(!value){
							$scope.messageTaskList.forEach(function(item) {
								item.selected = true;
							});
						}
					}
					$scope.changeTaskStatus = function(item) {
						item.selected = !item.selected;
						$scope.canSendMessage = $scope.messageTaskList.some(function(item) {
							return item.selected;
						});
					}
				
					$scope.send = function() {
						var taskIdList = []

						$scope.messageTaskList.forEach(function(item) {
							if(item.selected)
							taskIdList.push(item.id);
						});

						if(taskIdList.length == 0)
							return;

						$scope.sendingNotification = true;
						try {
							eventRotaDetailsService.post('communityEvent/v2/create/'+$scope.id_event+'/message/signup/'+$scope.id_rota, { 
								targets: taskIdList,
								message: $scope.notif_note
							})
							 .then(function(response) {
								toastr.info($translate.instant('NOTIFICATION_SENT_SIGNUP'))
								modalInstance.close();
								$scope.notif_note = null;
								$scope.sendingNotification = false;
								window.location.href = '/school/#/community-events/dashboard/' + $scope.id_event;
							}, 
							function(error) {
								alert(error)
								$scope.sendingNotification = false;
								toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
							})
						} catch (error2) {
						}
					
					};

					$scope.close = function() {
						modalInstance.close();
					};
				}
			})
		}
	}
})();

(function () {
	"use strict";

	angular
		.module("modules.events.rota", [])
		.factory("eventRotaService", [
			"base",
			function (base) {
				return _.create(base, {});
			},
		])
		.controller("eventRotaController", eventRotaController);

	/** @ngInject */
	function eventRotaController(
		baseService,
		$scope,
		$state,
		eventRotaService,
		$uibModal,
		$rootScope,
		$window,
		$stateParams,
		$http,
		toastr,
		storage,
		settings
	) {
		$scope.id_event = $stateParams.id_event;
		$scope.id_rota = $stateParams.id_rota;
		$scope.event = { id: $scope.id_event };
		$scope.popupRotaDate = {};
		$scope.rota = { timeBased: true };
		$scope._rota = { timeBased: true };
		$scope.taskList = [];

		$scope.viewState = {
			isReady: false,
		};

		$http.get("i8n/locale-metadata-en-GB.json?v=12").then(function (data) {
			$scope.eventTimes = data.data.metadata.eventTimes;
			$scope.slotTimes = data.data.metadata.rotaSlotTimes;
		});

		$scope.downloadCSV = function () {
			var url =
				settings.gae.rootUrl +
				"attachment?id=" +
				$scope.id_event +
				"&type=rota";
			url = url + ("&zu=" + $rootScope.currentUserId());
			window.open(url, "_blank");
		};

		$scope.pickRotaDate = function () {
			$scope.popupRotaDate.opened = true;
		};

		$scope.createTask = function () {
			if (!$scope.taskList) $scope.taskList = [];

			var emptyTasks = {};

			if ($scope._rota.timeBased) {
				emptyTasks.slotLength = $scope._rota.slotLength;
			}
			emptyTasks.volunteerCount = "2";
			$scope.taskList.push(emptyTasks);
		};

		$scope.taskDetails = function (task) {
			$rootScope.decideToRota =
				"/school/#/community-events/" +
				$scope.id_event +
				"/signup/" +
				$scope._rota.id;
			location.href =
				"/school/#/community-events/" +
				$scope.id_event +
				"/signup/" +
				$scope.id_rota +
				"/view/" +
				task.id;
		};

		$scope.taskDetailsAll = function () {
			$rootScope.decideToRota =
				"/school/#/community-events/" +
				$scope.id_event +
				"/signup/" +
				$scope._rota.id;
			location.href =
				"/school/#/community-events/" +
				$scope.id_event +
				"/signup/" +
				$scope.id_rota +
				"/view/";
		};

		$scope.saveTask = function (task) {
			task.touched = true;

			if (!task.title) {
				return;
			}

			if ($scope._rota.timeBased) {
				if (!task.slotLength) {
					return;
				}
			}

			if (!task.volunteerCount) {
				return;
			}

			var payload = {
				title: task.title,
				description: task.description,
				slotLength: task.slotLength,
				volunteerCount: task.volunteerCount,
			};

			task.saving = true;
			if (!task.id) {
				eventRotaService
					.post("rota/v1/" + $scope._rota.id + "/task", payload, {
						cache: false,
						xhr: true,
					})
					.then(
						function (response) {
							task.saving = false;

							if (!response || !response.data) return;

							task.id = response.data.id;
							toastr.success("Successfully created the task");
						},
						function (error) {
							task.saving = false;
						}
					);
			} else {
				eventRotaService
					.put("rota/v1/" + $scope._rota.id + "/task/" + task.id, payload, {
						cache: false,
						xhr: true,
					})
					.then(
						function (response) {
							task.saving = false;
							toastr.success("Successfully updated the task");
						},
						function (error) {
							var errorObject = error.data.error;
							if (
								errorObject.code == 400 &&
								errorObject.message == "_VOLUNTEER_FOUND_CANNOT_UPDATE"
							) {
								toastr.error(
									"You can't change the rota time since volunteers have already been assigned to one or more slots. "
								);
							}
							task.saving = false;
						}
					);
			}
		};

		$scope.removeTask = function (task) {
			var id_rota = $scope.id_rota;
			if (!task.id) {
				var index = $scope.taskList.indexOf(task);
				if (index >= 0) {
					$scope.taskList.splice(index, 1);
				}
				toastr.success("Successfully deleted the task");
				return;
			}
			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: "backdrop-zindexed",
				templateUrl: "app/events/views/delete-task-modal.html",
				size: "sm",
				controller: function ($scope) {
					$scope.save = function () {
						eventRotaService
							.delete("rota/v1/" + id_rota + "/task/" + task.id, {
								cache: false,
								xhr: true,
							})
							.then(
								function (response) {
									var index = $scope.taskList.indexOf(task);
									if (index >= 0) {
										$scope.taskList.splice(index, 1);
									}
									toastr.success("Successfully deleted the task");
									modalInstance.close();
								},
								function (error) {
									toastr.error($translate.instant("GENERIC_REQUEST_ERROR"));
									modalInstance.close();
								}
							);
					};
					$scope.close = function () {
						modalInstance.close();
					};
				},
			});
		};

		$scope.deleteTask = function (task, index) {
			if ($scope.taskList && $scope.taskList.length > 0)
				$scope.taskList.splice(index, 1);
		};

		$scope.saveRota = function (redirect) {
			$scope._rota.touched = true;

			if (!$scope._rota.title) {
				return;
			}

			if ($scope.rotaDate) {
				$scope._rota.startDate = new Date($scope.rotaDate);
				$scope._rota.endDate = new Date($scope.rotaDate);
			}

			if ($scope._rota.startTime && $scope._rota.startTime.indexOf(":") > -1) {
				var _time = $scope._rota.startTime.split(":");
				$scope._rota.startDate.setHours(_time[0]);
				$scope._rota.startDate.setMinutes(_time[1]);
			}

			if ($scope._rota.endTime && $scope._rota.endTime.indexOf(":") > -1) {
				var _time = $scope._rota.endTime.split(":");
				$scope._rota.endDate.setHours(_time[0]);
				$scope._rota.endDate.setMinutes(_time[1]);
			}

			var payload = {
				title: $scope._rota.title,
				description: $scope._rota.description,
				startDate: $rootScope.getWithoutTimeZone($scope._rota.startDate),
				endDate: $rootScope.getWithoutTimeZone($scope._rota.endDate),
				slotLength: $scope._rota.slotLength,
				timeBased: $scope._rota.timeBased,
			};

			$scope.savingrota = true;

			if (!$scope.id_rota) {
				eventRotaService
					.post("rota/v1/Event/" + $scope.id_event, payload, {
						cache: false,
						xhr: true,
					})
					.then(
						function (response) {
							$scope.savingrota = false;

							if (!response || !response.data) return;

							location.href =
								"/school/#/community-events/" +
								$scope.event.id +
								"/signup/" +
								response.data.id;
							toastr.success(
								"Your sign-up list has been saved as a draft. It is not visible to parents."
							);
							if (redirect) {
								window.location.href =
									"/school/#/community-events/dashboard/" + $scope.event.id;
							}
						},
						function (error) {
							$scope.savingrota = false;
						}
					);
			} else {
				eventRotaService
					.put("rota/v1/" + $scope.id_rota, payload, {
						cache: false,
						xhr: true,
					})
					.then(
						function (response) {
							$scope.savingrota = false;
							toastr.success("Sign-up list successfully updated");
							if (redirect) {
								window.location.href =
									"/school/#/community-events/dashboard/" + $scope.event.id;
							}
						},
						function (error) {
							var errorObject = error.data.error;
							if (
								errorObject.code == 400 &&
								errorObject.message == "_VOLUNTEER_FOUND_CANNOT_UPDATE"
							) {
								toastr.error(
									"You can't change the rota time since volunteers have already been assigned to one or more slots. "
								);
							}
							$scope.savingrota = false;
						}
					);
			}
		};

		$scope.deleteRota = function () {
			var id_rota = $scope.id_rota;
			var id_event = $scope.id_event;

			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: "backdrop-zindexed",
				templateUrl: "app/events/views/delete-rota-modal.html",
				size: "sm",
				controller: function ($scope) {
					$scope.save = function () {
						$scope.deletingrota = true;
						eventRotaService
							.delete("rota/v1/" + id_rota, { cache: false, xhr: true })
							.then(
								function (response) {
									$scope.deletingrota = false;
									window.location.href =
										"/school/#/community-events/dashboard/" + id_event;
									toastr.success("Successfully deleted the rota");
								},
								function (error) {
									$scope.deletingrota = false;
								}
							);
					};
					$scope.close = function () {
						modalInstance.close();
					};
				},
			});
		};

		$scope.publishRota = function () {
			var id_rota = $scope.id_rota;
			var _rota = $scope._rota;
			if (
				!$scope.taskList ||
				$scope.taskList.length == 0 ||
				!$scope.taskList[0].id
			) {
				var modalNoTasksInstance = $uibModal.open({
					animation: true,
					scope: $scope,
					backdropClass: "backdrop-zindexed",
					templateUrl: "app/events/views/publish-rota-no-tasks.html",
					size: "sm",
					controller: function ($scope) {
						$scope.close = function () {
							modalNoTasksInstance.close();
						};
					},
				});
				return;
			}
			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: "backdrop-zindexed",
				templateUrl: "app/events/views/publish-rota-modal.html",
				size: "sm",
				controller: function ($scope) {
					$scope.save = function () {
						_rota.enabled = true;

						$scope.publishingrota = true;
						eventRotaService
							.put(
								"rota/v1/" + id_rota + "/status",
								{
									enable: true,
								},
								{ cache: false, xhr: true }
							)
							.then(
								function (response) {
									$scope.publishingrota = false;
									modalInstance.close();
									if ($scope.event.status == "ACTIVE") {
										toastr.success(
											"Saved and published to your event. Parents can now sign up!"
										);
									} else {
										toastr.success(
											"Sign-up list saved and published to your draft event. Publish your event so parents can see this page and sign up."
										);
									}
									window.location.href =
										"/school/#/community-events/dashboard/" + $scope.event.id;
								},
								function (error) {
									$scope.publishingrota = false;
								}
							);
					};
					$scope.close = function () {
						modalInstance.close();
					};
				},
			});
		};

		$scope.unpublishRota = function () {
			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: "backdrop-zindexed",
				templateUrl: "app/events/views/unpublish-rota-modal.html",
				size: "sm",
				controller: function ($scope) {
					$scope.unpublishingrota = false;
					$scope.save = function () {
						$scope._rota.enabled = true;

						eventRotaService
							.put(
								"rota/v1/" + $scope.rota.id + "/status",
								{
									enable: false,
								},
								{ cache: false, xhr: true }
							)
							.then(
								function (response) {
									$scope._rota.enabled = false;
									$scope.unpublishingrota = false;
									modalInstance.close();
								},
								function (error) {
									$scope.unpublishingrota = false;
									toastr.error($translate.instant("GENERIC_REQUEST_ERROR"));
								}
							);
					};
					$scope.close = function () {
						modalInstance.close();
					};
				},
			});
		};

		$scope.getRota = function () {
			$scope.gettingrota = true;
			eventRotaService
				.get("rota/v1/" + $scope.id_rota, { cache: false, xhr: true })
				.then(
					function (response) {
						$scope.gettingrota = false;

						if (!response || !response.data) return;

						$scope.rota = response.data;

						var startTime = $scope.rota.startDate
							? new Date($scope.rota.startDate)
							: new Date();
						var endTime = $scope.rota.endDate
							? new Date($scope.rota.endDate)
							: new Date();

						startTime = $rootScope.getUTCDatetime(startTime);
						endTime = $rootScope.getUTCDatetime(endTime);

						startTime =
							(startTime.getHours() > 9
								? startTime.getHours()
								: "0" + startTime.getHours()) +
							":" +
							(startTime.getMinutes() > 9
								? startTime.getMinutes()
								: "0" + startTime.getMinutes());
						endTime =
							(endTime.getHours() > 9
								? endTime.getHours()
								: "0" + endTime.getHours()) +
							":" +
							(endTime.getMinutes() > 9
								? endTime.getMinutes()
								: "0" + endTime.getMinutes());

						$scope.rota.startTime = startTime;
						$scope.rota.endTime = endTime;
						$scope.rotaDate = new Date($scope.rota.startDate);

						if (!$scope.rota.slotLength) $scope.rota.slotLength = "30";
						else $scope.rota.slotLength = $scope.rota.slotLength.toString();

						$scope._rota = angular.copy($scope.rota);
						$scope.viewState.isReady = true;
					},
					function (error) {
						$scope.gettingrota = false;
					}
				);
		};

		$scope.getTasks = function () {
			eventRotaService
				.get("rota/v1/" + $scope.id_rota + "/task/compact", {
					cache: false,
					xhr: true,
				})
				.then(
					function (response) {
						if (!response || !response.data || !response.data.items) {
							$scope.createTask();
							return;
						}

						$scope.taskList = response.data.items;
						if ($scope.taskList.length == 0) {
							$scope.createTask();
						}
					},
					function (error) {}
				);
		};

		$scope.getEvent = function () {
			$scope.gettingevent = true;

			eventRotaService
				.get("communityEvent/v2/get/" + $scope.event.id, {
					cache: false,
					xhr: true,
				})
				.then(
					function (response) {
						$scope.gettingevent = false;
						$scope.event = response.data;

						if (!$scope.id_rota) {
							var startTime = $scope.event.date.startDate
								? new Date($scope.event.date.startDate)
								: new Date();
							var endTime = $scope.event.date.endDate
								? new Date($scope.event.date.endDate)
								: new Date();

							startTime = $rootScope.getUTCDatetime(startTime);
							endTime = $rootScope.getUTCDatetime(endTime);

							startTime =
								(startTime.getHours() > 9
									? startTime.getHours()
									: "0" + startTime.getHours()) +
								":" +
								(startTime.getMinutes() > 9
									? startTime.getMinutes()
									: "0" + startTime.getMinutes());

							endTime =
								(endTime.getHours() > 9
									? endTime.getHours()
									: "0" + endTime.getHours()) +
								":" +
								(endTime.getMinutes() > 9
									? endTime.getMinutes()
									: "0" + endTime.getMinutes());

							$scope.rotaDate = new Date($scope.event.date.startDate);
							$scope._rota.startTime = startTime;
							$scope._rota.endTime = endTime;
							// $scope._rota.title = $scope.event.title + ' sign up list';

							$scope._rota.slotLength = "30";

							if (!$scope.id_rota) $scope.viewState.isReady = true;
						}
					},
					function (error) {
						$scope.gettingevent = false;
					}
				);
		};

		$scope.canEditSwitch = function () {
			return $scope.rota.id ? false : true;
		};

		$scope.switchTimeBased = function () {
			if (!$scope.canEditSwitch()) {
				return;
			}

			$scope._rota.timeBased = !$scope._rota.timeBased;
		};

		$scope.decideGoBack = function () {
			if ($rootScope.decideToRota) {
				window.location.href = $rootScope.decideToRota;
				return;
			}

			if ($rootScope.history && $rootScope.history.length > 1) {
				window.location.href =
					$rootScope.history[$rootScope.history.length - 1];
			} else {
				window.location.href =
					"/school/#/community-events/dashboard/" + $scope.id_event;
			}
		};

		baseService.app_initialized = function (evt, args) {
			$scope.getEvent();

			if ($scope.id_rota) {
				$scope.getRota();
				$scope.getTasks();
			}
		};

		if ($rootScope.active_school && $rootScope.app_base_ready) {
			baseService.app_initialized();
		}
	}
})();

(function() {
	'use strict';

	angular.module('modules.events.owners',[]).factory('eventOwnersService', ['base', function (base) {
		return _.create(base, { });
	}]).controller('eventOwnersController', eventOwnersController);

	/** @ngInject */
	function eventOwnersController(baseService, $scope, $state, eventOwnersService, $uibModal, $rootScope, $window, $stateParams) {
		$scope.id_event = $stateParams.id_event;
		
		// Init the beforeunlodpage on this page
		var onBeforeunload = $rootScope.$on('events.tickets', function(evt, args) {
			var anychange = $scope.ticket.is_free ? $scope.ticket.hasAnyChangeFree() : $scope.ticket.hasAnyChangePaid()

			if(anychange) {
				var modalInstance = $uibModal.open({
					animation: true,
					scope: $scope,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/base/views/window-beforeleave-modal.html',
					size:'md',
					controller: function($scope) {
						$scope.leave = function() {
							onBeforeunload();
							$state.go(args.toState.name, args.toParams);
						}
						$scope.stay = function() {
							modalInstance.close();
						};
					}
				})

				args.e.preventDefault();
			}
			else {
				onBeforeunload();
			}
		});

		$scope.back = function() {
			$window.history.back();
		}

		$scope.filterReps = function (rep) {
			if(!$scope.searchInput)
				return true;
				
			return rep.name.toLowerCase().indexOf($scope.searchInput.toString().toLowerCase()) > -1;
		}

		$scope.getReps = function() {
			eventOwnersService.get('school/v1/get/all/' + $rootScope.active_school.id + '/reps')
			.then(function(response) {
				$scope.rep_list = [];
				
				if(!response || !response.data || !response.data.items)
					return;

				$scope.rep_list = response.data.items;
			},
			function(error) {
				
			})
		}

		$scope.selectRep = function(rep) {
			var id_event = $scope.id_event;
			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/events/views/confirm-owner-modal.html',
				backdrop: 'static',
				size:'sm',
				controller: function($scope) {
					$scope.fullname = rep.name;

					$scope.cancel = function() {
						modalInstance.close();
					}

					$scope.add = function() {
						$scope.adding = true;
						
						eventOwnersService.put('communityEvent/v2/create/'+id_event+'/owner/' + rep.id)
						.then(function(response) {
							modalInstance.close();
							$scope.adding = false;
							$scope.back();
							toastr.success('Successfully added '+rep.name+' as event owner');
						},
						function(error) {
							$scope.adding = false;
						})
					};
				}
			})
		};

		baseService.app_initialized = function(evt, args) {
			$scope.getReps();
		}

		if($rootScope.active_school && $rootScope.app_base_ready) {
			baseService.app_initialized();
		}
	}
})();

(function() {
	'use strict';

	angular.module('modules.events',[]).factory('eventsService', ['base', function (base) {
		return _.create(base, { });
	}]).controller('eventsController', eventsController);

	/** @ngInject */
	function eventsController(baseService, $scope, $rootScope, $state, $translate, $uibModal, toastr, eventsService, storage, settings) {
		
		baseService.app_initialized = function(evt, args) {
			
		}

		$scope.downloadTickets = function(id_event) {
			window.open(settings.conf.api + '/generator/pdfGenerator?id=' + id_event, '_self');
		}

		$scope.isPastEvent = function(event) {
			var now = $rootScope.getWithoutTimeZone(new Date());

			if(!event.date)
				return true;

			if(event.date.endDate) {
				return now > new Date(event.date.endDate);
			}

			if(event.date.startDate) {
				return now > new Date(event.date.startDate);
			}

			if(event.soldOut) {
				return true;
			}
			
			return false;
		}
		
		$scope.deleteComment = function(id_post, id_comment, comments, commentCount) {
			_.each(comments, function(item, i) {
				if(item) {
					if (item.id === id_comment) {
						comments.splice(i, 1);
						commentCount--;
						return;
					}
				}
			});

			eventsService.delete('post/v1/comment/' + id_post + '/delete/' + id_comment, { }).then(function(response) {
				toastr.info($translate.instant('COMMENT_DELETED'));

			}, function(error){
				console.log(error);
				toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
			})
		}

		$scope.updateAttendance = function(event, answer) {
			switch(event.userAnswer.userAnswer) {
				case 'GOING':
					if(parseInt(event.answerCount.going) > 0)
						event.answerCount.going = parseInt(event.answerCount.going) - 1;
					break;

				case 'MAYBE':
					if(parseInt(event.answerCount.going) > 0)
						event.answerCount.maybe = parseInt(event.answerCount.maybe) - 1;
					break;

				case 'NOT_GOING':
					if(parseInt(event.answerCount.going) > 0)
						event.answerCount.cantgo = parseInt(event.answerCount.cantgo) - 1;
					break;
			}

			var payload = {
				eventAnswerId: event.userAnswer.userAnswerId,
				answer: answer
			}
			
			event.eventAnswer = payload.answer;
			event.userAnswer.userAnswer = answer;
			eventsService.post('communityEvent/v1/update/' + event.id + '/answer', payload, { 'xhr': true }).then(function(response) {
				switch(event.userAnswer.userAnswer) {
					case 'GOING':
						if(parseInt(event.answerCount.going) > 0)
							event.answerCount.going = parseInt(event.answerCount.going) + 1;
						break;
	
					case 'MAYBE':
						if(parseInt(event.answerCount.going) > 0)
							event.answerCount.maybe = parseInt(event.answerCount.maybe) + 1;
						break;
	
					case 'NOT_GOING':
						if(parseInt(event.answerCount.going) > 0)
							event.answerCount.cantgo = parseInt(event.answerCount.cantgo) + 1;
						break;
				}
			}, 
			function(error) {
				event.userAnswer.userAnswer = null;
			})
		}
		
		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}
	}
})();

(function() {
    'use strict';

    angular.module('modules.events.list', []).controller('eventsListController', eventsListController);

    /** @ngInject */
    function eventsListController(baseService, $scope, $rootScope, eventsService, $translate, toastr, settings, $state, $uibModal, $introjs) {

        $scope.pastItemsLimit = 3;

        $scope.event = {};
        $scope.viewState = {
            isReady: false,
            isEmpty: false
        }

        $scope.togglePastMore = function() {
            $scope.pastItemsLimit = null;
        }

        $scope.createEvent = function() {;
            location.href = '/school/#/community-events/start';
        }

        $scope.getOrganiserNames = function(event) {
            if (!event.owners || event.owners.length === 0) {
                return '';
            }
            
            try {
                var activeUserId = $rootScope.active_user.id;
                var organisers = event.owners;
              
                var isUserOrganiser = organisers.some(function(owner) {
                    return owner.id === activeUserId;
                });
                
                var otherOrganisers = organisers.filter(function(owner) {
                    return owner.id !== activeUserId;
                });
            
                var decodeHtml = function(html) {
                    var txt = document.createElement('textarea');
                    txt.innerHTML = html;
                    return txt.value;
                };
                
                var result = '';
                
                if (isUserOrganiser) {
                    if (organisers.length === 1) {
                        result = $translate.instant('EVENT_LIST_OWNERS_TEXT_ALONE');
                    } else if (organisers.length === 2) {
                        result = $translate.instant('EVENT_LIST_OWNERS_TEXT_TWO', { ownerName: otherOrganisers[0].firstName + ' ' + otherOrganisers[0].lastName });
                    } else {
                        result = $translate.instant('EVENT_LIST_OWNERS_TEXT_MORE', { ownerCount: organisers.length - 1 });
                    }
                } else {
                    if (organisers.length === 1) {
                        result = $translate.instant('OTHER_EVENT_LIST_OWNERS_TEXT_ALONE', { ownerName: organisers[0].firstName + ' ' + organisers[0].lastName });
                    } else if (organisers.length === 2) {
                        result = $translate.instant('OTHER_EVENT_LIST_OWNERS_TEXT_TWO', { 
                            ownerName: organisers[0].firstName + ' ' + organisers[0].lastName, 
                            secondOwnerName: organisers[1].firstName + ' ' + organisers[1].lastName 
                        });
                    } else {
                        result = $translate.instant('OTHER_EVENT_LIST_OWNERS_TEXT_MORE', { 
                            ownerName: organisers[0].firstName + ' ' + organisers[0].lastName, 
                            ownerCount: organisers.length - 1 
                        });
                    }
                }
                
                return decodeHtml(result);
            } catch (error) {
                return '';
            }
            
        };

        $scope.openEvent = function(event, isdraft) {
            var goDashboard = '/school/#/community-events/dashboard/' + event.eventId;
            var goView = '/school/#/community-events/view/' + event.eventId;
            location.href = event.owner ? goDashboard : goView;
        }

        $scope.appCues = function() {
            $introjs.setAppCue("SCHOOL_COMMUNITY_EVENT_TOUR", "EVENT_LIST_CREATE", 1000);
            $introjs.setAppCue("SCHOOL_FIRST_AMBASSADOR_COMMUNITY_EVENT_TOUR", "EVENT_LIST_CREATE", 1000);
        }

        baseService.app_initialized = function(evt, args) {

            function getEvents() {
                $scope.draft_events = new Array();
                $scope.new_events = new Array();
                $scope.past_events = new Array();
                $scope.cancelled_events = new Array();

                eventsService.get('communityEvent/v2/list/' + $rootScope.active_school.id, { 'cache': false, 'xhr': true }).then(function(response) {
                        $scope.draft_events = response.data.draftEvents;
                        $scope.new_events = response.data.futureEvents;
                        $scope.past_events = response.data.pastEvents;
                        $scope.cancelled_events = response.data.cancelledEvents;

                        $scope.viewState.isReady = true;
                        if ((!$scope.draft_events && !$scope.new_events && !$scope.past_events && !$scope.cancelled_events) || (
                                $scope.draft_event.length === 0 && $scope.new_events.length === 0 && $scope.past_events.length === 0 && $scope.cancelled_events.length === 0)) {
                            $scope.viewState.isEmpty = true;
                        } else {
                            $scope.viewState.isEmpty = false;
                        }

                        $scope.appCues();

                    },
                    function(error) {
                        toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
                        $scope.viewState.isReady = true;
                    })


            }

            getEvents();
        }
        $scope.isFlutterApp = function () {
            return getMobileOperatingSystem() === "Flutter";

        }
        $scope.getStoreReviewUrl = function () {
            if(isIosNative()){
                window.open('https://itunes.apple.com/app/id1058636226?action=write-review', '_blank')
                return;
            }
            window.open('https://play.google.com/store/apps/details?id=com.classlist.parent&showAllReviews=true', '_blank')
        }

        if ($rootScope.active_school && $rootScope.app_base_ready) {
            baseService.app_initialized();
        }
    }




})();
(function() {
	'use strict';

	angular.module('modules.events.guests',[]).factory('eventGuestsService', ['base', function (base) {
		return _.create(base, { });
	}])
	.filter('filterguests', function() {
	  return function(list, filter) {
		var out = [];
		
		if (!filter.keyword && !filter.type) {
			return list;
		}
		
		if(list)
			for(var i = 0; i < list.length; i++) {
				var guest = list[i];

				if (filter.keyword) {
					if(filter.type) {
						filter.type = '';
					}

					if ((guest.keywords.toLowerCase().indexOf(filter.keyword.toLowerCase()) > -1) ) {
						out.push(guest)
					}
				}
				else if(filter.type) {
					if(guest.keywords && guest.keywords.indexOf(filter.type) > -1) {
						out.push(guest)
					}
					
					switch(filter.type) {
						case 'NOT_RESPONDED': 
							if(guest.answer == 'PENDING') {
								out.push(guest)
							}
							break;

						case 'GOING':
						case 'ALL_PURCHASED':
							if(guest.answer == 'GOING') {
								out.push(guest)
							}
							break;

						case 'NOT_GOING':
							if(guest.answer == 'NOT_GOING') {
								out.push(guest)
							}
							break;

						case 'HAVENT_PURCHASED':
							if(!guest.tickets) {
								out.push(guest)
							}
							break;
					}
				}
			}
		
		return out;
	  }
	})
	.controller('eventGuestsController', eventGuestsController);

	/** @ngInject */
	function eventGuestsController(baseService, $scope, $state, $uibModal, settings, toastr, $translate, eventGuestsService, $rootScope, $stateParams, storage) {
		$scope.id_event = $stateParams.id_event;
		$scope.event = { id: $scope.id_event };
		$scope.selectedSelectFilter = { };
		
		$scope.viewState = {
			isReady: false
		};

		$scope.tabFilter = function(type) {
			$scope.tabFiltered = type;
			$scope.selectedSelectFilter.keyword = '';
			$scope.selectedSelectFilter.type = type;
		}

		$scope.selectFilterChanged = function() {
			$scope.selectedSelectFilter.keyword = '';
		}

		$scope.expandGuest = function(guest) {
			if(!guest.expanded)
				guest.expanded = false;

			guest.expanded = !guest.expanded;
			
			if(guest.expanded) {
				eventGuestsService
				.get('communityEvent/v2/get/' + $scope.id_event + '/guest/' + guest.id + '/' + guest.type + '/detail', {'cache':false, 'xhr':true}).then(function(response) {

					if(!response || !response.data)
						return;

					guest.data  = response.data;
				}, 
				function(error) {
					
				})
			}
		}
		
		$scope.getEvent = function() {
			eventGuestsService.get('communityEvent/v2/get/' + $scope.id_event, {'cache':false, 'xhr':true}).then(function(response) {
				$scope.viewState.isReady = true;
				$scope.event = response.data;
			}, 
			function(error) {
				
			})
		}

		$scope.returnTicket = function(ticketId, guest, ticketIndex) {
			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/events/views/return-ticket-modal.html',
				size:'md',
				controller: function($scope) {
					$scope.continue = function() {
						eventGuestsService.get('communityEvent/v2/return/' + ticketId + '/ticket', {'cache':false, 'xhr':true}).then(function(response) {
							guest.data.tickets.splice(ticketIndex, 1);
							guest.ticketCount = guest.ticketCount - 1;
							if(guest.ticketCount === 0) {
								guest.answer = 'PENDING';
								$scope.expandGuest(guest);
							}
							modalInstance.close();
						}, function(error) {
							modalInstance.close();
						});
					}
					$scope.close = function() {
						modalInstance.close();
					};
				}
			})
		}

		$scope.getGuests = function() {
			$scope.gettingguests = true;
			eventGuestsService.get('communityEvent/v2/list/' + $scope.id_event + '/guests', { 'cache':false, 'xhr':true }).then(function(response) {
				$scope.gettingguests = false;
				$scope.guests = response.data.guests;
				$scope.groups = response.data.groups;
				$scope.ticketTypes = response.data.ticketTypes;
			}, 
			function(error) {
				$scope.gettingguests = false;
			})
		}
		
		$scope.openResendInvites = function() {
			var _event = $scope.event;
			var type = 'all';

			if($scope.selectedSelectFilter.type) {
				switch($scope.selectedSelectFilter.type) {
					case 'GOING':
						type = { type: 'answer', name: 'GOING', value: 'Going' };
						break;
					case 'NOT_GOING':
						type = { type: 'answer', name: 'NOT_GOING', value: "Can't go" };
						break;
					case 'NOT_GOING':
						type = { type: 'answer', name: 'NOT_GOING', value: "Can't go" };
						break;
					case 'NOT_RESPONDED':
						type = { type: 'not_responded', value: 'Not responded' };
						break;
					case 'ALL_PURCHASED':
						type = { type: 'all_purchased', value: 'Purchased' };
						break;
				}

				if($scope.selectedSelectFilter.type && $scope.selectedSelectFilter.type != 'all' && type == 'all') {
					if($scope.selectedSelectFilter.type.indexOf('g-') > -1) {
						if($scope.groups && $scope.groups.length > 0) {
							var type_id = $scope.selectedSelectFilter.type.split('-')[1];
							var type_value = '';

							for(var i = 0; i < $scope.groups.length; i++) {
								if($scope.groups[i].id == type_id)
									type_value = $scope.groups[i].name;
							}

							type = { type: 'group', id: type_id, value: type_value };
						}
					}
					else if($scope.selectedSelectFilter.type.indexOf('t-') > -1) {
						if($scope.ticketTypes && $scope.ticketTypes.length > 0) {
							var type_id = $scope.selectedSelectFilter.type.split('-')[1];
							var type_value = '';

							for(var i = 0; i < $scope.ticketTypes.length; i++) {
								if($scope.ticketTypes[i].id == type_id)
									type_value = $scope.ticketTypes[i].name;
							}
							
							type = { type: 'ticket', id: type_id, value: type_value };
						}
					}
				}
			}

			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/events/views/send-reminder-modal.html',
				size:'md',
				controller: function($scope) {
					$scope.groups = [];
 
					if(type == 'all') {
						if(_event.ticketed) {
							$scope.groups.push({ type: 'all_invited', value: 'All guests' });
							$scope.groups.push({ type: 'not_responded', value: 'Not responded' });
						}
						else {
							$scope.groups.push({ type: 'all_invited', value: 'All guests' });
							$scope.groups.push({ type: 'not_responded', value: 'Not responded' });
						}
					}
					else {
						if(type.name == 'NOT_GOING')
							type.value = "Can't go";

						$scope.groups.push(type);
					}

					$scope.removeGroup = function(item) {
						$scope.groups.splice($scope.groups.indexOf(item), 1);
					}

					$scope.send = function() {
						$scope.sendingNotification = true;
						eventGuestsService.post('communityEvent/v2/resend/'+$scope.event.id+'/invitation', { 
							targets: $scope.groups
						})
						 .then(function(response) {
							modalInstance.close();
							$scope.notif_note = null;
							$scope.sendingNotification = false;
							toastr.info($translate.instant('EVENT_ACTION_REMINDER_SUCCESS'));
						}, 
						function(error) {
							$scope.sendingNotification = false;
							// If the start date of the event has passed and invites tried to being sent, show a specific error message.
							if(error && error.data && error.data.error.code == 400 && ((error.data.error.message == "STARTDATE_CANNOT_BEFORE_TODAY") || (error.data.error.message == "RSVPDATE_CANNOT_BEFORE_TODAY")) ){
								toastr.error($translate.instant('INVITATION_DATE_PAST'));
							}
							else {
								toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
							}
						})
					};

					$scope.close = function() {
						modalInstance.close();
					};
				}
			})
		}

		$scope.messageGuests = function() {
			var _event = $scope.event;
			var type = 'all';

			if($scope.selectedSelectFilter.type) {
				switch($scope.selectedSelectFilter.type) {
					case 'GOING':
						type = { type: 'answer', name: 'GOING', value: 'Going' };
						break;
					case 'NOT_GOING':
						type = { type: 'answer', name: 'NOT_GOING', value: "Can't go" };
						break;
					case 'NOT_GOING':
						type = { type: 'answer', name: 'NOT_GOING', value: "Can't go" };
						break;
					case 'NOT_RESPONDED':
						type = { type: 'not_responded', value: 'Not responded' };
						break;
					case 'ALL_PURCHASED':
						type = { type: 'all_purchased', value: 'Purchased' };
						break;
				}

				if($scope.selectedSelectFilter.type && $scope.selectedSelectFilter.type != 'all' && type == 'all') {
					if($scope.selectedSelectFilter.type.indexOf('g-') > -1) {
						if($scope.groups && $scope.groups.length > 0) {
							var type_id = $scope.selectedSelectFilter.type.split('-')[1];
							var type_value = '';

							for(var i = 0; i < $scope.groups.length; i++) {
								if($scope.groups[i].id == type_id)
									type_value = $scope.groups[i].name;
							}

							type = { type: 'group', id: type_id, value: type_value };
						}
					}
					else if($scope.selectedSelectFilter.type.indexOf('t-') > -1) {
						if($scope.ticketTypes && $scope.ticketTypes.length > 0) {
							var type_id = $scope.selectedSelectFilter.type.split('-')[1];
							var type_value = '';

							for(var i = 0; i < $scope.ticketTypes.length; i++) {
								if($scope.ticketTypes[i].id == type_id)
									type_value = $scope.ticketTypes[i].name;
							}
							
							type = { type: 'ticket', id: type_id, value: type_value };
						}
					}
				}
			}

			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/events/views/send-notification-modal.html',
				size:'md',
				controller: function($scope) {
					$scope.groups = [];

					if(type == 'all') {
						if(_event.ticketed) {
							$scope.groups.push({ type: 'all_invited', value: 'All guests' });
							$scope.groups.push({ type: 'all_purchased', value: 'Purchased' });
							$scope.groups.push({ type: 'not_responded', value: 'Not responded' });
						}
						else {
							$scope.groups.push({ type: 'all_invited', value: 'All guests' });
							$scope.groups.push({ type: 'answer', name: 'GOING', value: 'Going' });
							$scope.groups.push({ type: 'answer', name: 'NOT_GOING', value: "Can't go" });
							$scope.groups.push({ type: 'not_responded', value: 'Not responded' });
						}
					}
					else {
						if(type.name == 'NOT_GOING')
							type.value = "Can't go";

						$scope.groups.push(type);
					}

					$scope.removeGroup = function(item) {
						$scope.groups.splice($scope.groups.indexOf(item), 1);
					}

					$scope.send = function() {
						$scope.sendingNotification = true;
						eventGuestsService.post('communityEvent/v2/create/'+$scope.event.id+'/message', { 
							targets: $scope.groups,
							message: $scope.notif_note
						})
						 .then(function(response) {
							modalInstance.close();
							$scope.notif_note = null;
							$scope.sendingNotification = false;
							toastr.info($translate.instant('NOTIFICATION_SENT_TO_SELECTED_LIST'))
						}, 
						function(error) {
							$scope.sendingNotification = false;
							toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
						})
					};

					$scope.close = function() {
						modalInstance.close();
					};
				}
			})
		}

		$scope.canDownload = function() {
			if($scope.selectedSelectFilter.type == 'GOING' || $scope.selectedSelectFilter.type == 'ALL_PURCHASED') {
				return true;
			}
			else if($scope.selectedSelectFilter.type && $scope.selectedSelectFilter.type.indexOf('t-') > -1) {
				return true;
			}

			return false;
		}

		$scope.downloadCSV = function() {
			var url = settings.gae.rootUrl + "attachment?id=" + $scope.event.id;
			var id = '';

			if($scope.selectedSelectFilter.type == 'GOING') {
				url += "&type=attendee&listType=GOING";
			}
			else if($scope.selectedSelectFilter.type == 'ALL_PURCHASED') {
				url += "&type=attendeeTicketed&listType=ALL_PURCHASED";
			}
			else if($scope.selectedSelectFilter.type && $scope.selectedSelectFilter.type.indexOf('t-') > -1) {
				id = $scope.selectedSelectFilter.type.split('-')[1];
				url += "&type=attendeeTicketed&listType=TICKET_TYPE&tid=" + id;
			}

			url = url + ("&zu=" + $rootScope.currentUserId());
			window.open(url, "_blank");
		}

		baseService.app_initialized = function(evt, args) {
			if($rootScope.guestsType) {
				$scope.tabFiltered = $rootScope.guestsType;
				$scope.selectedSelectFilter.type = $rootScope.guestsType;
				$rootScope.guestsType = null;
			}
			else {
				$scope.tabFiltered = '';
				$scope.selectedSelectFilter.type = '';
			}

			$scope.getEvent();
			$scope.getGuests();
		}

		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}
	}
})();

(function () {
	"use strict";

	angular
		.module("modules.events.dashboard", [])
		.factory("eventDashboardService", [
			"base",
			function (base) {
				return _.create(base, {});
			},
		])
		.controller("eventDashboardController", eventDashboardController);

	/** @ngInject */
	function eventDashboardController(
		baseService,
		$scope,
		$state,
		regexes,
		$uibModal,
		settings,
		toastr,
		$translate,
		eventsService,
		eventDashboardService,
		$location,
		$anchorScroll,
		$timeout,
		$rootScope,
		$window,
		$stateParams,
		storage,
		$http,
		$introjs
	) {
		$scope.id_event = $stateParams.id_event;
		$scope.event = { id: $scope.id_event };
		$scope.rotaList = [];
		//$scope.ambassadorInviteEmails;
		$scope.ambassadorInviteEmailsSending = false;

		$scope.viewState = {
			isReady: false,
		};

		var _timer = null;
		$scope.hasDonation = false;
		$scope.hasPaid = false;
		$scope.hasFree = false;
		$scope.isFlutterApp = false;
		$scope.toggleShow = function(index) {
			$scope.messageList[index].showFull = !$scope.messageList[index].showFull;
		};

		// line control js
		var checkLineCount = function(text) {
			var tempElement = document.createElement("div");
			tempElement.innerHTML = text;
			document.body.appendChild(tempElement);

			var lineCount = tempElement.clientHeight / parseInt(window.getComputedStyle(tempElement).lineHeight);

			document.body.removeChild(tempElement);

			if (lineCount > 3) {
			  return true;
			} else {
			  return false;
			}
	   };

		$scope.events = {
			commentCallback: function (comment) {
				if (!$scope.event.comments) {
					$scope.event.comments = [];
				}

				comment.avatar = $rootScope.active_user.avatar;
				comment.postedBy =
					$rootScope.active_user.firstName +
					" " +
					$rootScope.active_user.lastName;
				comment.body = $rootScope.parseLinks(comment.body);

				$scope.event.comments.push(comment);
				$scope.event.commentCount++;
			},
		};

		$scope.checkTodo = function (type) {
			$scope.viewState.isReady = false;
			return;
		};

		$scope.checkAndOpenAmbassadorInviteDialog = function () {
			//this dialog only for first ambassador

			if ($rootScope.active_user.role != "AMBASSADOR") {
				return;
			}

			var ambassadorGroupAdded = false;
			if ($scope.event.groups) {
				for (var i = 0; i < $scope.event.groups.length; i++) {
					if (
						$scope.event.groups[i].type &&
						$scope.event.groups[i].type == "ADMIN_GROUP"
					) {
						ambassadorGroupAdded = true;
						break;
					}
				}
			}

			if (!ambassadorGroupAdded) {
				if ($scope.event.groups && $scope.event.groups.length > 0) {
					$introjs.setAppCue("SCHOOL_FIRST_AMBASSADOR_COMMUNITY_EVENT_TOUR","EVENT_DASHBOARD_2", 2000);
				}
				return;
			}

			//check todo first
			var todoType = "SCHOOL_EVENT_AMBASSADOR_INVITE";
			var todoRequestUrl =
				"shared/v1/todo/check/" + $scope.event.schoolId + "/" + todoType;
			eventDashboardService
				.get(todoRequestUrl, { cache: false, xhr: true })
				.then(
					function (response) {
						var result = response.data.payload.show;
						if (result) {
							$introjs.setAppCue("SCHOOL_FIRST_AMBASSADOR_COMMUNITY_EVENT_TOUR","EVENT_DASHBOARD_INVITE_MODAL", 1000);
							var modalInstance = $uibModal.open({
								animation: true,
								scope: $scope,
								backdropClass: "backdrop-zindexed",
								templateUrl: "app/events/views/invite-ambassadors-modal.html",
								size: "md",
								controller: function ($scope) {
									$scope.close = function () {
										modalInstance.close();
										$introjs.setAppCue("SCHOOL_FIRST_AMBASSADOR_COMMUNITY_EVENT_TOUR","EVENT_DASHBOARD_2", 2000);
									};

									$scope.dismissTodo = function () {
										//dismiss todo here
										eventDashboardService.get(
											"shared/v1/todo/dismiss/" +
												$scope.event.schoolId +
												"/" +
												todoType
										);
										modalInstance.close();
										$introjs.setAppCue("SCHOOL_FIRST_AMBASSADOR_COMMUNITY_EVENT_TOUR","EVENT_DASHBOARD_2", 2000);
									};

									$scope.sendAmbassadorInvitations = function () {
										$scope.ambassadorInviteEmailsSending = true;
										//dismiss todo here
										eventDashboardService.get(
											"shared/v1/todo/dismiss/" +
												$scope.event.schoolId +
												"/" +
												todoType
										);

										//send invitations
										var splittedEmail = $scope.parseEmails(
											$scope.ambassadorInviteEmails
										);

										if (splittedEmail != null) {
											splittedEmail = $scope.reduceDuplicates(splittedEmail);

											// Add 'Invited Parent' name to every email address
											var invitedMembers = [];
											if (
												!_.isUndefined(splittedEmail) &&
												splittedEmail !== null
											) {
												for (var i = 0; i < splittedEmail.length; i++) {
													var info = {
														email: splittedEmail[i],
														firstName: "Invited",
														lastName: "Parent",
													};
													invitedMembers.push(info);
												}
											}

											var sendtier = {
												id: -1, //unassigned
												emails: invitedMembers,
											};

											if (sendtier.emails.length !== 0) {
												var sendtiers = [];
												sendtiers.push(sendtier);

												var payload = {
													schoolId: $scope.event.schoolId,
													tiers: sendtiers,
													message: $translate.instant(
														"ADD_INDIVIDUALLY_PLACEHOLDER"
													), //use default message
													repRole: "AMBASSADOR",
													eventId: $scope.event.id,
												};

												eventDashboardService
													.post(
														"school/v1/nonMemberParent/create/bulk",
														payload
													)
													.then(
														function (response) {
															//show success toast message
															toastr.info("Invites has been sent");
														},
														function (error) {
															//show error message
															toastr.error($translate.instant(error.data));
														}
													);
											}
										} else {
											//there is a problem
											toastr.error("Error happened, please try again");
										}

										modalInstance.close();
										$introjs.setAppCue("SCHOOL_FIRST_AMBASSADOR_COMMUNITY_EVENT_TOUR","EVENT_DASHBOARD_2", 2000);
										$scope.ambassadorInviteEmailsSending = false;
									};

									$scope.parseEmails = function (input) {
										if (!_.isUndefined(input)) {
											return input.match(
												/([a-zA-Z0-9+._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi
											);
										}
									};

									$scope.reduceDuplicates = function (array) {
										if (!_.isUndefined(array)) {
											var sortedEmail = array.sort();
											var results = [];
											for (var i = 0; i < array.length; i++) {
												if (sortedEmail[i + 1] != sortedEmail[i]) {
													results.push(sortedEmail[i]);
												}
											}
											return results;
										}
									};
								},
							});
						} else {
							//then call other step
							$introjs.setAppCue("SCHOOL_FIRST_AMBASSADOR_COMMUNITY_EVENT_TOUR","EVENT_DASHBOARD_2", 2000);
						}
					},
					function (error) {}
				);
		};
		$scope.getEventMessages = function () {
			eventDashboardService.get("communityEvent/v2/list/" + $scope.event.id+"/messages").then(
				function (response) {
					if (!response || !response.data || !response.data.items) return;

					$scope.messageList = response.data.items;
					$scope.messageList.forEach(function(item){
						item.hasReadMore = checkLineCount(item.message)
					})

				},
				function (error) {
				}
			);
		}
		$scope.getEvent = function () {
			$scope.posts = new Array();
			$scope.user = $rootScope.active_user;
			$scope.userName = $rootScope.active_user.firstName;
			$scope.userAvatar = $rootScope.active_user.avatar;
			$scope.gettingevent = true;
			eventDashboardService
				.get("communityEvent/v2/get/" + $scope.event.id, {
					cache: false,
					xhr: true,
				})
				.then(
					function (response) {
						$scope.gettingevent = false;
						$scope.event = response.data;
						$scope.viewState.isReady = true;

						if ($scope.event.ticketed) {
							$scope.getTickets();
						}

						$scope.getRotaList();
						if ($scope.event.answerCount.inviting) {
							if (_timer != null) {
								clearTimeout(_timer);
							}
							_time = setTimeout(function () {
								$scope.getEvent();
							}, 10000);
						}

						if ($scope.event.date.startDate) {
							$scope.startDate = $rootScope.getUTCDatetime(
								$scope.event.date.startDate
							);
							$scope.startTime =
								($scope.startDate.getHours() < 10 ? "0" : "") +
								$scope.startDate.getHours() +
								":" +
								($scope.startDate.getMinutes() < 10 ? "0" : "") +
								$scope.startDate.getMinutes();
						}

						if ($scope.event.date.endDate) {
							$scope.endDate = $rootScope.getUTCDatetime(
								$scope.event.date.endDate
							);
							$scope.endTime =
								($scope.endDate.getHours() < 10 ? "0" : "") +
								$scope.endDate.getHours() +
								":" +
								($scope.endDate.getMinutes() < 10 ? "0" : "") +
								$scope.endDate.getMinutes();
						}

						if ($scope.event.date.rsvpDate) {
							$scope.rsvpDate = $rootScope.getUTCDatetime(
								$scope.event.date.rsvpDate
							);
							$scope.rsvpTime =
								($scope.rsvpDate.getHours() < 10 ? "0" : "") +
								$scope.rsvpDate.getHours() +
								":" +
								($scope.rsvpDate.getMinutes() < 10 ? "0" : "") +
								$scope.rsvpDate.getMinutes();
						}

						$scope.checkAndOpenAmbassadorInviteDialog();

						if($scope.event.status && $scope.event.status == 'DRAFT' && (!$scope.event.groups || ($scope.event.groups && $scope.event.groups.length == 0))){
							$introjs.setAppCue("SCHOOL_COMMUNITY_EVENT_TOUR","EVENT_DASHBOARD_1", 1000);
							$introjs.setAppCue("SCHOOL_FIRST_AMBASSADOR_COMMUNITY_EVENT_TOUR","EVENT_DASHBOARD_1", 1000);
						}
						$scope.posts.push($scope.event.postDTO.payload.post);

					},
					function (error) {
						$scope.gettingevent = false;
					}
				);
		};
		$scope.isDefaultImage = function (res) {
			return !res || res.indexOf('no-events.svg') > -1;
		}
		$scope.uploadImage = function () {

			$rootScope.$broadcast('UPLOAD_PHOTO', {
				'callback_fn': function (response) {
					var url = eventsService.getPostImgBucketUrl() + '/' + response.data;
					$scope.event.fileLibrary.image = url;
					$scope.event.photoId = response.data || '';

					eventsService.put('communityEvent/v2/update/' + $scope.event.id + '/image', {
						image: $scope.event.photoId
					}).then(function (response) {

					},
						function (error) {
							toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
						})
				},
				'action': 'eventUpload',
				'config': 'eventCropper',
				'on_close': function () {
					//$scope.pickGallery();
				}
			});
		}
		$scope.createVolunteerRota = function () {
			$rootScope.decideToRota =
				"/school/#/community-events/dashboard/" + $scope.event.id;
			location.href =
				"/school/#/community-events/" + $scope.event.id + "/signup/";
		};

		$scope.getRotaList = function () {
			eventDashboardService.get("rota/v1/Event/" + $scope.event.id).then(
				function (response) {
					if (!response || !response.data || !response.data.items) return;

					$scope.rotaList = response.data.items;
				},
				function (error) {
					$scope.removing = false;
				}
			);
		};

		$scope.removeOwner = function (owner, index) {
			var id_event = $scope.event.id;
			var _eventOwners = $scope.event.eventOwners;
			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdrop: "static",
				backdropClass: "backdrop-zindexed",
				templateUrl: "app/events/views/remove-owner-modal.html",
				size: "sm",
				controller: function ($scope) {
					$scope.fullname = owner.firstName;

					$scope.cancel = function () {
						modalInstance.close();
					};

					$scope.remove = function () {
						$scope.removing = true;

						eventDashboardService
							.delete(
								"communityEvent/v2/delete/" + id_event + "/owner/" + owner.id
							)
							.then(
								function (response) {
									_eventOwners.splice(index, 1);
									modalInstance.close();
									$scope.removing = false;
									toastr.success(
										"Successfully removed " + rep.firstName + " as event owner"
									);
								},
								function (error) {
									$scope.removing = false;
								}
							);
					};
				},
			});
		};

		$scope.gotoAddOwner = function () {
			location.href = "/school/#/community-events/owners/" + $scope.event.id;
		};

		$scope.copyLink = function () {
			if (!$scope.event.open || !$scope.canMakePublic()) {
				return;
			}
			copyToClipboard($scope.event.openLink);
			toastr.success($translate.instant("CLASSLIST_PUBLIC_LINK_COPIED"));
		};

		// ---- private link

		$scope.copyPrivateLink = function () {
			copyToClipboard($scope.event.privateLink);
			toastr.success($translate.instant("CLASSLIST_LINK_COPIED"));
		};

		$scope.canMakePublic = function () {
			if ($scope.event.ticketed) {
				if (
					$scope.event.paymentProvider &&
					$scope.event.paymentProvider.provider == "paypal"
				) {
					return false;
				}
			}
			if(!$scope.event.groups || $scope.event.groups.length == 0){
				return false;
			}

			return true;
		};

		$scope.openRota = function (rota) {
			$rootScope.decideToRota =
				"/school/#/community-events/dashboard/" + $scope.event.id;
			location.href =
				"/school/#/community-events/" + $scope.event.id + "/signup/" + rota.id;
		};

		$scope.viewRota = function (rota) {
			$rootScope.decideToRota =
				"/school/#/community-events/dashboard/" + $scope.event.id;
			location.href =
				"/school/#/community-events/" +
				$scope.event.id +
				"/signup/" +
				rota.id +
				"/view/";
		};

		$scope.switchPublicEvent = function (forceUpdate) {
			if (!forceUpdate && !$scope.canMakePublic()) {
				return;
			}

			$scope.showLinkCopyDone = false;
			$scope.event.open = !$scope.event.open;

			if ($scope.event.open) {
				var _event_id = $scope.event.id;
				var modalInstance = $uibModal.open({
					animation: true,
					scope: $scope,
					backdrop: "static",
					keyboard: false,
					backdropClass: "backdrop-zindexed",
					templateUrl: "app/events/views/open-event-modal.html",
					size: "sm",
					controller: function ($scope) {
						$scope.confirm = function () {
							eventDashboardService
								.put(
									"communityEvent/v2/update/" + _event_id + "/PUBLIC_ACCESS",
									{
										open: $scope.event.open,
									}
								)
								.then(
									function (response) {
										$scope.getEvent();
									},
									function (error) {
										toastr.error($translate.instant("EVENT_CANT_BE_PUBLIC"));
										$scope.event.open = false;
									}
								);
							modalInstance.close();
						};
						$scope.close = function () {
							$scope.event.open = false;
							modalInstance.close();
						};
					},
				});
			} else {
				eventDashboardService
					.put(
						"communityEvent/v2/update/" + $scope.event.id + "/PUBLIC_ACCESS",
						{
							open: false,
						}
					)
					.then(
						function (response) {
							$scope.getEvent();
						},
						function (error) {
							$scope.event.open = false;
						}
					);
			}
		};

		$scope.openPublicCheckoutInfo = function (e, type) {
			if (e) {
				e.stopImmediatePropagation();
				e.stopPropagation();
			}

			var modalInstance = $uibModal.open({
				animation: true,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/info_modals/info-modal-17.html',
				controller: function ($scope) {

					$scope.close = function () {
						modalInstance.close();
					};
				},
				size: 'md'
			});
		}
		$scope.removeParticipantGroup = function (p, index) {
			$scope.removingguest = true;
			$scope.event.groups.splice(index, 1);

			eventDashboardService
				.get("communityEvent/v2/delete/" + $scope.event.id + "/group/" + p.id)
				.then(
					function () {
						if($scope.event.groups.length == 0 && $scope.event.open){
							$scope.switchPublicEvent(true)
						}
						$scope.removingguest = false;
						toastr.success("The group(s) has been removed from the event");
					},
					function (error) {
						$scope.removingguest = false;
						toastr.error($translate.instant("GENERIC_REQUEST_ERROR"));
					}
				);
		};

		$scope.publish = function () {
			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: "backdrop-zindexed",
				backdrop: "static",
				templateUrl: "app/events/views/publish-invites-modal.html",
				size: "md",
				controller: function ($scope) {
					$scope.close = function () {
						modalInstance.close();
					};

					$scope.puslishWithout = function () {
						$scope.publishing = true;
						eventDashboardService
							.get("communityEvent/v2/publish/" + $scope.event.id + "/false")
							.then(
								function (response) {
									$scope.publishing = false;
									$scope.getEvent();
									modalInstance.close();
									$introjs.setAppCue("SCHOOL_COMMUNITY_EVENT_TOUR","EVENT_DASHBOARD_3", 1000);
								},
								function (error) {
									$scope.publishing = false;

									// If the start date of the event has passed and invites tried to being sent, show a specific error message.
									if (
										error &&
										error.data &&
										error.data.error.code == 400 &&
										error.data.error.message == "STARTDATE_CANNOT_BEFORE_TODAY"
									) {
										toastr.error($translate.instant("INVITATION_DATE_PAST"));
									} else {
										toastr.error($translate.instant("GENERIC_REQUEST_ERROR"));
									}
								}
							);
					};

					$scope.publishWith = function () {
						$scope.publishing = true;
						var id_event = $scope.event.id;
						var _getEvent = $scope.getEvent;
						eventDashboardService
							.get("communityEvent/v2/publish/" + $scope.event.id + "/true")
							.then(
								function (response) {
									$scope.publishing = false;
									$scope.getEvent();
									modalInstance.close();

									var modalInstanceLive = $uibModal.open({
										animation: true,
										backdrop: "static",
										backdropClass: "backdrop-zindexed",
										templateUrl: "app/events/views/live-confirm-modal.html",
										size: "md",
										resolve: {
											event: function () {
												return $scope.event;
											},
										},
										controller: function ($scope, event) {
											$scope.event = event;

											$scope.copyLink = function () {
												copyToClipboard($scope.event.openLink);
												toastr.success($translate.instant("LINK_COPIED"));
											};

											$scope.shareWhatsapp = function () {
												var toShare = encodeURIComponent($scope.event.openLink);

												if (!$rootScope.isNative) {
													window.open(
														"https://web.whatsapp.com/send?text=" + toShare,
														"_blank"
													);
												} else {
													$rootScope.openWhatsappNative(toShare);
												}
											};

											$scope.shareFacebook = function () {
												var toShare = encodeURIComponent($scope.event.openLink);

												if (!$rootScope.isNative) {
													window.open(
														"https://www.facebook.com/sharer/sharer.php?u=" +
															toShare,
														"_blank"
													);
												} else {
													$rootScope.openFacebookNative(
														toShare
													);
												}
											};

											// private links

											$scope.copyPrivateLink = function () {
												copyToClipboard($scope.event.privateLink);
												toastr.success($translate.instant("LINK_COPIED"));
											};

											$scope.sharePrivateWhatsapp = function () {
												var toShare = encodeURIComponent($scope.event.privateLink);

												if (!$rootScope.isNative) {
													window.open(
														"https://web.whatsapp.com/send?text=" + toShare,
														"_blank"
													);
												} else {
													$rootScope.openWhatsappNative(toShare);
												}
											};

											$scope.sharePrivateFacebook = function () {
												var toShare = encodeURIComponent($scope.event.privateLink);

												if (!$rootScope.isNative) {
													window.open(
														"https://www.facebook.com/sharer/sharer.php?u=" +
															toShare,
														"_blank"
													);
												} else {
													$rootScope.openFacebookNative(
														toShare
													);
												}
											};


											$scope.close = function () {
												modalInstanceLive.close();
												$introjs.setAppCue("SCHOOL_COMMUNITY_EVENT_TOUR","EVENT_DASHBOARD_3", 1000);

												if (_hasDraftRotas()) {
													var modalInstanceRota = $uibModal.open({
														animation: true,
														backdropClass: "backdrop-zindexed",
														templateUrl:
															"app/events/views/invite-draft-rotas-modal.html",
														size: "sm",
														controller: function ($scope) {
															$scope.later = function () {
																modalInstanceRota.close();
															};

															$scope.doit = function () {
																$scope.publishingrotas = true;
																eventDashboardService
																	.put("rota/v1/" + id_event + "/publish")
																	.then(
																		function (response) {
																			_getEvent();
																			modalInstanceRota.close();
																			$scope.publishingrotas = false;
																		},
																		function (error) {
																			$scope.publishingrotas = false;
																			toastr.error(
																				$translate.instant(
																					"GENERIC_REQUEST_ERROR"
																				)
																			);
																		}
																	);
															};
														},
													});
												}
											};
										},
									});
								},
								function (error) {
									$scope.publishing = false;

									// If the start date of the event has passed and invites tried to being sent, show a specific error message.
									if (
										error &&
										error.data &&
										error.data.error.code == 400 &&
										error.data.error.message == "STARTDATE_CANNOT_BEFORE_TODAY"
									) {
										toastr.error($translate.instant("INVITATION_DATE_PAST"));
									} else {
										toastr.error($translate.instant("GENERIC_REQUEST_ERROR"));
									}
								}
							);
					};
				},
			});
		};

		$scope.deleteEvent = function () {
			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: "backdrop-zindexed",
				templateUrl: "app/events/views/delete-modal.html",
				size: "sm",
				controller: function ($scope) {
					$scope.save = function () {
						$scope.deletingEvent = true;

						eventDashboardService
							.get("communityEvent/v2/delete/" + $scope.event.id)
							.then(
								function (response) {
									$scope.deletingEvent = false;
									modalInstance.close();
									location.href = "/school/#/community-events/list";
									toastr.info($translate.instant("EVENT_DELETED_INFO"));
								},
								function (error) {
									$scope.deletingEvent = false;
									toastr.error($translate.instant("GENERIC_REQUEST_ERROR"));
								}
							);
					};
					$scope.close = function () {
						modalInstance.close();
					};
				},
			});
		};


		$scope.deleteCanceledEvent = function () {
			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: "backdrop-zindexed",
				templateUrl: "app/events/views/delete-canceled-modal.html",
				size: "md",
				controller: function ($scope) {
					$scope.save = function () {
						$scope.deletingEvent = true;

						eventDashboardService
							.get("communityEvent/v2/delete/" + $scope.event.id)
							.then(
								function (response) {
									$scope.deletingEvent = false;
									modalInstance.close();
									location.href = "/school/#/community-events/list";
									toastr.info($translate.instant("EVENT_DELETED_INFO"));
								},
								function (error) {
									$scope.deletingEvent = false;
									toastr.error($translate.instant("GENERIC_REQUEST_ERROR"));
								}
							);
					};
					$scope.hide = function () {
						$scope.deletingEvent = true;

						eventDashboardService
							.get("communityEvent/v2/hide/" + $scope.event.id)
							.then(
								function (response) {
									$scope.deletingEvent = false;
									modalInstance.close();
									location.href = "/school/#/community-events/list";
									toastr.info($translate.instant("EVENT_HIDED_INFO"));
								},
								function (error) {
									$scope.deletingEvent = false;
									toastr.error($translate.instant("GENERIC_REQUEST_ERROR"));
								}
							);
					};
					$scope.close = function () {
						modalInstance.close();
					};
				},
			});
		};

		$scope.hideEvent = function () {
			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: "backdrop-zindexed",
				templateUrl: "app/events/views/hide-modal.html",
				size: "md",
				controller: function ($scope) {
					$scope.save = function () {
						$scope.deletingEvent = true;

						eventDashboardService
							.get("communityEvent/v2/hide/" + $scope.event.id)
							.then(
								function (response) {
									$scope.deletingEvent = false;
									modalInstance.close();
									location.href = "/school/#/community-events/list";
									toastr.info($translate.instant("EVENT_HIDED_INFO"));
								},
								function (error) {
									$scope.deletingEvent = false;
									toastr.error($translate.instant("GENERIC_REQUEST_ERROR"));
								}
							);
					};
					$scope.close = function () {
						modalInstance.close();
					};
				},
			});
		};

		$scope.cancelEvent = function () {
			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: "backdrop-zindexed",
				templateUrl: "app/events/views/cancel-modal.html",
				size: "md",
				controller: function ($scope) {
					$scope.cancelMessage =
						$translate.instant("CANCEL_EVENT_DEFAULT_MESSAGE") +
						$rootScope.active_user.firstName;

					$scope.switchCancelNotification = function () {
						$scope.cancelNotification = !$scope.cancelNotification;
					};
					$scope.updateCancelMessage = function (event) {
						$scope.cancelMessage = event.cancelMessage
					};

					$scope.save = function () {
						$scope.cancellingEvent = true;
						eventDashboardService
							.post("communityEvent/v2/cancel/" + $scope.event.id, {
								notification: $scope.cancelNotification,
								message: $scope.cancelMessage,
							})
							.then(
								function (response) {
									$scope.cancellingEvent = false;
									modalInstance.close();
									location.href = "/school/#/community-events/list";
									toastr.info($translate.instant("EVENT_CANCELLED_INFO"));
								},
								function (error) {
									$scope.cancellingEvent = false;
									toastr.error($translate.instant("GENERIC_REQUEST_ERROR"));
								}
							);
					};

					$scope.close = function () {
						modalInstance.close();
					};
				},
			});
		};

		$scope.openInfo = function (e, type) {
			if (e) {
				e.stopImmediatePropagation();
				e.stopPropagation();
			}

			var modalInstance = $uibModal.open({
				animation: true,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/info_modals/info-modal-7.html',
				controller: function ($scope) {

					$scope.close = function () {
						modalInstance.close();
					};
				},
				size: 'sm'
			});
		}

		$scope.previewEvent = function () {
			location.href = "/school/#/community-events/view/" + $scope.event.id;
		};

		$scope.viewAllGuests = function () {
			location.href = "/school/#/community-events/guests/" + $scope.event.id;
		};

		$scope.openGuests = function (type) {
			$rootScope.guestsType = type;
			location.href = "/school/#/community-events/guests/" + $scope.event.id;
		};

		$scope.openResendInvites = function (type) {
			var _event = $scope.event;

			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: "backdrop-zindexed",
				templateUrl: "app/events/views/send-reminder-modal.html",
				size: "md",
				controller: function ($scope) {
					$scope.groups = [];

					if (type == "all") {
						if (_event.ticketed) {
							$scope.groups.push({ type: "all_invited", value: "All invited" });
							$scope.groups.push({
								type: "not_responded",
								value: "Not responded",
							});
						} else {
							$scope.groups.push({ type: "all_invited", value: "All invited" });
							$scope.groups.push({
								type: "not_responded",
								value: "Not responded",
							});
						}
					} else {
						if (type.name == "NOT_GOING") type.value = "Can't go";

						$scope.groups.push(type);
					}

					$scope.removeGroup = function (item) {
						$scope.groups.splice($scope.groups.indexOf(item), 1);
					};

					$scope.send = function () {
						$scope.sendingNotification = true;
						eventDashboardService
							.post(
								"communityEvent/v2/resend/" + $scope.event.id + "/invitation",
								{
									targets: $scope.groups,
								}
							)
							.then(
								function (response) {
									modalInstance.close();
									$scope.notif_note = null;
									$scope.sendingNotification = false;
									toastr.info(
										$translate.instant("EVENT_ACTION_REMINDER_SUCCESS")
									);
								},
								function (error) {
									$scope.sendingNotification = false;
									// If the start date of the event has passed and invites tried to being sent, show a specific error message.
									if (
										error &&
										error.data &&
										error.data.error.code == 400 &&
										(error.data.error.message ==
											"STARTDATE_CANNOT_BEFORE_TODAY" ||
											error.data.error.message ==
												"RSVPDATE_CANNOT_BEFORE_TODAY")
									) {
										toastr.error($translate.instant("INVITATION_DATE_PAST"));
									} else {
										toastr.error($translate.instant("GENERIC_REQUEST_ERROR"));
									}
								}
							);
					};

					$scope.close = function () {
						modalInstance.close();
					};
				},
			});
		};

		$scope.triggerAutosave = function (type) {
			if (!isThisMobile())
				return;

			if (type != 'createdBy' && $scope.editingCreatedby)
				$scope.saveCreatedby();
		}

		$scope.stopPropagation = function (e) {
			e.stopPropagation();
			e.stopImmediatePropagation();
		}

		$scope.editCreatedby = function (e) {
			$scope.triggerAutosave('createdBy');

			setTimeout(function () {
				$scope.editingCreatedby = true;
				$scope.valueCreatedby = $scope.event.createdByName;

				if (e)
					focusClickEditor(e);
				$scope.$apply();
			}, 1);
		}

		$scope.cancelCreatedby = function () {
			$scope.editingCreatedby = false;
		}

		$scope.saveOutsideCreatedby = function () {
			if (!isThisMobile() && $scope.editingCreatedby)
				$scope.saveCreatedby()
		}

		$scope.saveCreatedby = function () {
			$scope.event.createdByName = $scope.valueCreatedby ? $scope.valueCreatedby : $scope.event.createdByName;
			$scope.editingCreatedby = false;

			eventsService.put('communityEvent/v2/update/' + $scope.event.id + '/createdbyname', { createdByName: $scope.event.createdByName }).then(function (response) {
				$scope.event.date.updated = new Date();
			},
				function (error) {
					if (error.data.error.message) {
						toastr.error(error.data.error.message);
					} else {
						toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
					}
				})
		}

		$scope.messageGuests = function (type) {
			var _event = $scope.event;
			var _tickets = [];
			var _rota = $scope.rotaList || [];
			if($scope.ticketData) {
				_tickets = $scope.ticketData.tickets || [];
			}

			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: "backdrop-zindexed",
				templateUrl: "app/events/views/send-notification-modal.html",
				size: "md",
				controller: function ($scope) {
					$scope.groups = [];

					if (type == "all") {
						if (_event.ticketed) {
							$scope.groups.push({ type: "all_invited", id: -1, value: "All invited" });
							$scope.groups.push({ type: "all_purchased", id: -1, value: "Purchased" });
							$scope.groups.push({
								type: "not_responded",
								id: -1,
								value: "Not responded",
							});
							for(var i = 0; i < _tickets.length; i++ ) {
								$scope.groups.push({
									type: "ticket",
									id: _tickets[i].id,
									value: _tickets[i].name,
								});
							}
						} else {
							$scope.groups.push({ type: "all_invited", id: -1, value: "All invited" });
							$scope.groups.push({
								type: "answer",
								id: -1,
								name: "GOING",
								value: "Going",
							});
							$scope.groups.push({
								type: "answer",
								id: -1,
								name: "NOT_GOING",
								value: "Can't go",
							});
							$scope.groups.push({
								type: "answer",
								id: -1,
								name: "MAYBE",
								value: "Maybe",
							});
							$scope.groups.push({
								type: "not_responded",
								id: -1,
								value: "Not responded",
							});
						}
						if(_rota && _rota.length !== 0) {
							$scope.groups.push({
								type: "onsignup",
								id: -1,
								value: "On SignUp list",
							});
							$scope.groups.push({
								type: "notsignup",
								id: -1,
								value: "Not on SignUp list",
							});
						}
						$scope.groups.push({
							type: "public_checkout",
							id: -1,
							value: "Public checkout",
						});
						/*
						for(var i = 0; i < _rota.length; i++ ) {
							$scope.groups.push({
								type: "signup",
								id: _rota[i].id,
								value: _rota[i].title,
							});
						}*/
					} else {
						if (type.name == "NOT_GOING") type.value = "Can't go";

						$scope.groups.push(type);
					}

					$scope.removeGroup = function (item) {
						$scope.groups.splice($scope.groups.indexOf(item), 1);
					};

					$scope.send = function () {
						$scope.sendingNotification = true;
						eventDashboardService
							.post(
								"communityEvent/v2/create/" + $scope.event.id + "/message",
								{
									targets: $scope.groups,
									message: $scope.notif_note,
								}
							)
							.then(
								function (response) {
									modalInstance.close();
									$scope.notif_note = null;
									$scope.sendingNotification = false;
									$scope.getEventMessages()
									toastr.info(
										$translate.instant("NOTIFICATION_SENT_TO_SELECTED_LIST")
									);
								},
								function (error) {
									$scope.sendingNotification = false;
									toastr.error($translate.instant("GENERIC_REQUEST_ERROR"));
								}
							);
					};

					$scope.close = function () {
						modalInstance.close();
					};
				},
			});
		};

		$scope.getTicketsPercentage = function (tot, of) {
			return Math.floor((tot / of) * 100);
		};

		$scope.getTickets = function () {
			eventDashboardService
				.get("communityEvent/v2/dashboard/" + $scope.event.id + "/ticketList")
				.then(
					function (response) {
						$scope.ticketData = response.data;
						for(var i = 0; i < $scope.ticketData.tickets.length; i++ ) {
							if ($scope.ticketData.tickets[i].type === 'FREE') {
								$scope.hasFree = true;
							}
							if ($scope.ticketData.tickets[i].type === 'PAID') {
								$scope.hasPaid = true;
							}
							if ($scope.ticketData.tickets[i].type === 'DONATION') {
								$scope.hasDonation = true;
							}
						}
					},
					function (error) {
						$scope.invitingGuests = false;
						toastr.error($translate.instant("GENERIC_REQUEST_ERROR"));
					}
				);
		};
		$scope.switchToQRReader = function (to) {
			window.location.href = "classlistflutter://switchtoeventcheckin?eventId="+$scope.event.id;
		};

		$scope.sendInvites = function () {
			var _getEvent = $scope.getEvent;
			var missing_invitations = $scope.event.answerCount.missingInvitations;
			var id_event = $scope.event.id;
			var modalInstanceLive = $uibModal.open({
				animation: true,
				backdropClass: "backdrop-zindexed",
				templateUrl: "app/events/views/invite-invites-modal.html",
				size: "sm",
				controller: function ($scope) {
					$scope.count = missing_invitations;

					$scope.close = function () {
						modalInstanceLive.close();
					};

					$scope.continue = function () {
						modalInstanceLive.close();

						eventDashboardService
							.get("communityEvent/v2/send/" + id_event + "/invitation")
							.then(
								function (response) {
									_getEvent();

									if (_hasDraftRotas()) {
										var modalInstanceRota = $uibModal.open({
											animation: true,
											backdropClass: "backdrop-zindexed",
											templateUrl:
												"app/events/views/invite-draft-rotas-modal.html",
											size: "sm",
											controller: function ($scope) {
												$scope.later = function () {
													modalInstanceRota.close();
												};

												$scope.doit = function () {
													$scope.publishingrotas = true;
													eventDashboardService
														.put("rota/v1/" + id_event + "/publish")
														.then(
															function (response) {
																_getEvent();
																modalInstanceRota.close();
																$scope.publishingrotas = false;
															},
															function (error) {
																$scope.publishingrotas = false;
																toastr.error(
																	$translate.instant("GENERIC_REQUEST_ERROR")
																);
															}
														);
												};
											},
										});
									}
								},
								function (error) {
									$scope.invitingGuests = false;
									// If the start date of the event has passed and invites tried to being sent, show a specific error message.
									if (
										error &&
										error.data &&
										error.data.error.code == 400 &&
										error.data.error.message == "STARTDATE_CANNOT_BEFORE_TODAY"
									) {
										toastr.error($translate.instant("INVITATION_DATE_PAST"));
									} else
										toastr.error($translate.instant("GENERIC_REQUEST_ERROR"));
								}
							);
					};
				},
			});
		};

		function focusClickEditor(e) {
			var elem = angular.element(e.srcElement).parent()

			setTimeout(function () {
				if (elem.length > 0) {
					if (elem[0].getElementsByTagName('input').length > 0) {
						elem[0].getElementsByTagName('input')[0].focus();
					}
					else if (elem[0].getElementsByTagName('textarea').length > 0) {
						elem[0].getElementsByTagName('textarea')[0].focus();
					}
				}
			}, 1);
		}

		$scope.hasDraftRotas = function () {
			if (!$scope.rotaList || $scope.rotaList.length == 0) return false;

			for (var i = 0; i < $scope.rotaList.length; i++) {
				if (!$scope.rotaList[i].enabled) return true;
			}
		};

		var _hasDraftRotas = $scope.hasDraftRotas;

		$scope.gotoTickets = function () {
			if ($scope.event.answerCount.invited == 0 || $scope.event.ticketed) {
				setTimeout(function () {
					location.href =
						"/school/#/community-events/tickets/" + $scope.event.id;
				}, 100);
			} else {
				var modalInstance = $uibModal.open({
					animation: true,
					scope: $scope,
					backdropClass: "backdrop-zindexed",
					templateUrl: "app/events/views/before-ticketing-modal.html",
					size: "md",
					controller: function ($scope) {
						$scope.close = function () {
							modalInstance.close();
						};
						$scope.gotit = function () {
							location.href =
								"/school/#/community-events/tickets/" + $scope.event.id;
						};
					},
				});
			}
		};

		$scope.editEvent = function () {
			location.href = "/school/#/community-events/create/" + $scope.event.id;
		};

		$scope.inviteGuests = function () {
			if (!$scope.event.title || !$scope.event.date.startDate) {
				var modalInstance = $uibModal.open({
					animation: true,
					scope: $scope,
					backdropClass: "backdrop-zindexed",
					templateUrl: "app/events/views/before-invite-modal.html",
					size: "sm",
					controller: function ($scope) {
						$scope.close = function () {
							modalInstance.close();
						};
					},
				});
			} else {
				var id_event = $scope.event.id;
				var modalInstance = $uibModal.open({
					animation: true,
					scope: $scope,
					backdropClass: "backdrop-zindexed",
					backdrop: "static",
					templateUrl: "app/events/views/invite-modal.html",
					size: "md",
					controller: function ($scope) {
						$scope.members = new Array();
						$scope.isWholeSchool = false;

						$scope.switchWholeSchool = function () {
							$scope.isWholeSchool = !$scope.isWholeSchool;
						};

						$scope.dataEvent = function (data) {
							$scope.members = data;
						};

						$scope.save = function () {
							$scope.invitingGuests = true;
							var gsts = [];
							for (var i = 0; i < $scope.members.length; i++) {
								if (gsts.indexOf($scope.members[i].groupId) == -1)
									gsts.push($scope.members[i].groupId);
							}

							eventDashboardService
								.post("communityEvent/v2/create/" + id_event + "/group", {
									groups: gsts,
									wholeSchool: $scope.isWholeSchool,
								})
								.then(
									function (response) {
										$scope.invitingGuests = false;
										modalInstance.close();
										$scope.getEvent();
										toastr.success("The group(s) has been added to the event");
										if($scope.event.status && $scope.event.status == 'DRAFT' && (!$scope.event.groups || ($scope.event.groups && $scope.event.groups.length == 0))){
										$introjs.startAppCue("SCHOOL_COMMUNITY_EVENT_TOUR","EVENT_DASHBOARD_2", 2000);
										}
									},
									function (error) {
										$scope.invitingGuests = false;
										toastr.error($translate.instant("GENERIC_REQUEST_ERROR"));
									}
								);
						};

						$scope.close = function () {
							modalInstance.close();
						};
					},
				});
			}
		};

		$scope.downloadCSV = function (type, id) {
			var url = settings.gae.rootUrl + "attachment?&id=" + $scope.event.id;

			if (type == "GOING") {
				//type changed, listtype changed, we dont need tid (ticket id), ids removed
				url += "&type=attendee&listType=GOING";
			} else if (type == "ALL_PURCHASED") {
				//type changed,list type changed, we dont need tid
				url += "&type=attendeeTicketed&listType=ALL_PURCHASED";
			} else if (type == "TICKET_TYPE") {
				//type changed,list type changed, we dont need tid
				url += "&type=attendeeTicketed&listType=TICKET_TYPE&tid=" + id;
			}

			url = url + ("&zu=" + $rootScope.currentUserId());
			window.open(url, "_self");
		};

		$scope.decideGoBack = function () {
			// if ($rootScope.history && $rootScope.history.length > 1){
			// 	window.location.href = $rootScope.history[$rootScope.history.length - 1];
			// } else {
			// 	//we know this is a problem
			// 	//if you go to dashboard, manage tickets, switch stripe, then save
			// 	//it will go back to create
			// 	//to fix this we have to write to local storage.
			// 	//we will leave it for now
			// 	window.location.href = "/school/#/community-events/create/" + $scope.id_event;
			// }

			window.location.href = "/school/#/community-events/list";
		};

		baseService.app_initialized = function (evt, args) {
			if (!$scope.id_event) {
				location.href = "/school/#/community-events/list";
				return;
			}

			$scope.getEvent();
			$scope.getEventMessages();
			$scope.isFlutterApp = $rootScope.getOS() == "Flutter";
		};

		//duplicate event functions start
		$scope.duplicateEvent = function () {
			//set clone event object
			$scope.cloneEvent = {
				startDate: $scope.startDate,
				startTime: $scope.startTime,
				endDate: $scope.endDate,
				endTime: $scope.endTime,
				rsvpDate: $scope.rsvpDate,
				rsvpTime: $scope.rsvpTime,
				timezone: $scope.event.date.timezone,
			};

			//validate cloned event dates
			$scope.validateCloneEventDates();

			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: "backdrop-zindexed",
				templateUrl: "app/events/views/duplicate-modal.html",
				size: "md",
				controller: function ($scope) {
					$scope.save = function () {
						$scope.duplicatingEvent = true;
						var payload = {
							startDate: $rootScope.getWithoutTimeZone($scope.cloneEvent.startDate),
							endDate: $rootScope.getWithoutTimeZone($scope.cloneEvent.endDate),
						};
						if ($scope.cloneEvent.rsvpDate) {
							payload.rsvpDate = $rootScope.getWithoutTimeZone($scope.cloneEvent.rsvpDate);
						}
						eventDashboardService
							.post("communityEvent/v2/duplicate/" + $scope.event.id, payload)
							.then(
								function (response) {
									$scope.duplicatingEvent = false;
									modalInstance.close();

									location.href =
										"/school/#/community-events/dashboard/" +
										response.data.payload.eventId;
									toastr.info($translate.instant("EVENT_DUPLICATED_INFO"));
								},
								function (error) {
									$scope.duplicatingEvent = false;
									toastr.error($translate.instant("GENERIC_REQUEST_ERROR"));
								}
							);
					};

					$scope.close = function () {
						modalInstance.close();
					};
				},
			});
		};

		$scope.popupStartDate = {};
		$scope.popupEndDate = {};
		$scope.popupRsvpDate = {};
		$scope.dateOptions = {
			showWeeks: false,
		};
		$scope.dateErrors = [];

		$scope.pickStartDate = function () {
			$scope.popupStartDate.opened = true;
		};

		$scope.pickEndDate = function () {
			$scope.popupEndDate.opened = true;
		};

		$scope.pickRsvpDate = function () {
			$scope.popupRsvpDate.opened = true;
		};

		$http.get("i8n/locale-metadata-en-GB.json?v=12").then(function (data) {
			$scope.eventTimes = data.data.metadata.eventTimes;
		});

		$scope.hasDateError = function (value) {
			for (var i = 0; i < $scope.dateErrors.length; i++) {
				if ($scope.dateErrors[i] == value) {
					return $scope.dateErrors[i];
				}
			}
			return "";
		};

		$scope.validateCloneEventDates = function () {
			$scope.errorMessage = null;
			var payload = {
				startDate: $scope.cloneEvent.startDate,
				endDate: $scope.cloneEvent.endDate,
				timezone: $scope.cloneEvent.timezone,
			};

			if ($scope.cloneEvent.rsvpDate) {
				payload.rsvpDate = $scope.cloneEvent.rsvpDate;
			}

			eventDashboardService
				.put("communityEvent/v2/validate/eventDates", payload)
				.then(
					function (response) {
						$scope.dateErrors = [];
						if (
							response &&
							response.data &&
							response.data.items &&
							response.data.items.length > 0
						) {
							$scope.dateErrors = response.data.items;
						}
					},
					function (error) {
						if (error.data.error.code == 400) {
							$scope.errorMessage = error.data.error.message;
						} else {
							toastr.error($translate.instant("GENERIC_REQUEST_ERROR"));
						}
					}
				);
		};

		$scope.cloneEventStartDateOptions = {
			onTimeSelect: function (time) {
				if ($scope.cloneEvent.startDate && time && time.indexOf(":") > -1) {
					var _time = time.split(":");
					$scope.cloneEvent.startDate.setHours(parseInt(_time[0]));
					$scope.cloneEvent.startDate.setMinutes(parseInt(_time[1]));
					$scope.cloneEvent.startTime = time;
				}

				$scope.errorMessage = null;
				$scope.cloneEventStartDateOptions.onDateSelect(
					$scope.cloneEvent.startDate
				);
			},
			onDateSelect: function (date) {
				$scope.errorMessage = null;

				if (
					$scope.cloneEvent.startDate &&
					$scope.cloneEvent.startTime &&
					$scope.cloneEvent.startTime.indexOf(":") > -1
				) {
					var _time = $scope.cloneEvent.startTime.split(":");
					$scope.cloneEvent.startDate.setHours(parseInt(_time[0]));
					$scope.cloneEvent.startDate.setMinutes(parseInt(_time[1]));
				}

				$scope.validateCloneEventDates();
			},
		};

		$scope.cloneEventEndDateOptions = {
			onTimeSelect: function (time) {
				if ($scope.cloneEvent.endDate && time && time.indexOf(":") > -1) {
					var _time = time.split(":");
					$scope.cloneEvent.endDate.setHours(parseInt(_time[0]));
					$scope.cloneEvent.endDate.setMinutes(parseInt(_time[1]));
					$scope.cloneEvent.endTime = time;
				}

				$scope.errorMessage = null;
				$scope.cloneEventEndDateOptions.onDateSelect($scope.cloneEvent.endDate);
			},
			onDateSelect: function (date) {
				$scope.errorMessage = null;
				if (
					$scope.cloneEvent.endDate &&
					$scope.cloneEvent.endTime &&
					$scope.cloneEvent.endTime.indexOf(":") > -1
				) {
					var _time = $scope.cloneEvent.endTime.split(":");
					$scope.cloneEvent.endDate.setHours(parseInt(_time[0]));
					$scope.cloneEvent.endDate.setMinutes(parseInt(_time[1]));
				}
				$scope.validateCloneEventDates();
			},
		};

		$scope.cloneEventRsvpDateOptions = {
			onTimeSelect: function (time) {
				if ($scope.cloneEvent.rsvpDate && time && time.indexOf(":") > -1) {
					var _time = time.split(":");
					$scope.cloneEvent.rsvpDate.setHours(parseInt(_time[0]));
					$scope.cloneEvent.rsvpDate.setMinutes(parseInt(_time[1]));
					$scope.cloneEvent.rsvpTime = time;
				}

				$scope.errorMessage = null;
				$scope.cloneEventRsvpDateOptions.onDateSelect(
					$scope.cloneEvent.rsvpDate
				);
			},
			onDateSelect: function (date) {
				$scope.errorMessage = null;
				if (
					$scope.cloneEvent.rsvpDate &&
					$scope.cloneEvent.rsvpTime &&
					$scope.cloneEvent.rsvpTime.indexOf(":") > -1
				) {
					var _time = $scope.cloneEvent.rsvpTime.split(":");
					$scope.cloneEvent.rsvpDate.setHours(parseInt(_time[0]));
					$scope.cloneEvent.rsvpDate.setMinutes(parseInt(_time[1]));
				}
				$scope.validateCloneEventDates();
			},
			clear: function () {
				$scope.cloneEvent.rsvpDate = null;
				$scope.cloneEvent.rsvpTime = null;
				$scope.errorMessage = null;
				$scope.validateCloneEventDates();
			},
		};

		//duplicate event functions end

		if ($rootScope.active_school && $rootScope.app_base_ready) {
			baseService.app_initialized();
		}
	}
})();

(function () {
	'use strict';

	angular.module('modules.events.create', []).factory('eventsCreateService', ['base', function (base) {
		return _.create(base, {});
	}]).controller('eventsCreateController', eventsCreateController);

	/** @ngInject */
	function eventsCreateController(baseService, $scope, $state, regexes, $uibModal, settings, toastr, $translate, eventsService, uploadService, storage, $location, $anchorScroll, $timeout, $rootScope, $window, $stateParams, $http, $introjs) {
		$scope.regexes = regexes;
		$scope.routerState = $state;
		var schoolId;
		$scope.validContinue = true;
		$scope.members = new Array();
		$scope.saveAddressCheck = true;
		$scope.sendGuestNotification = true;
		$scope.atSchoolEvent = true;
		$scope.isOnlineEvent = true;
		$scope.budiSelection = {
			isBudiEvent: true
		};
		$scope.popupStartDate = {};
		$scope.popupEndDate = {};
		$scope.popupRsvpDate = {};
		var map;
		$scope.dateOptions = {
			showWeeks: false
		}
		$scope.dateErrors = [];
		$scope.rotaList = [];
		$scope.validateLink = validateLink;
		$scope.invalidOnlineLink = false;

		$http.get('i8n/locale-metadata-en-GB.json?v=12').then(function (data) {
			$scope.eventTimes = data.data.metadata.eventTimes
		});

		$scope.viewState = {
			isReady: false
		}

		$scope.event = {
			id: $stateParams.id
		}

		$scope.startDateTime;
		$scope.startDateTimeInstance;
		$scope.startTimeOpts = {
			placeholder: 'Pick time',
			enableTime: true,
			noCalendar: true,
			altInput: true,  
            dateFormat: "H:i K", 
			altFormat: "H:i K", 
			allowInput: true,
			disableMobile: true,
			onChange: function(selectedDates, dateStr, instance){
			  $scope.eventStartDateOptions.onTimeSelect(selectedDates)
			},
		};

		$scope.endDateTime;
		$scope.endDateTimeInstance;
		$scope.endTimeOpts = {
			placeholder: 'Pick time',
			enableTime: true,
			noCalendar: true,
			altInput: true,  
            dateFormat: "H:i K", 
			altFormat: "H:i K", 
			allowInput: false,
			disableMobile: true,
			onChange: function(selectedDates, dateStr, instance){
			  $scope.eventEndDateOptions.onTimeSelect(selectedDates)
			},
		};

		$scope.rsvpDateTime;
		$scope.rsvpDateTimeInstance;
		$scope.rsvpTimeOpts = {
			placeholder: 'Pick time',
			enableTime: true,
			noCalendar: true,
			altInput: true,  
            dateFormat: "H:i K", 
			altFormat: "H:i K", 
			allowInput: false,
			disableMobile: true,
			defaultDate: null,
			onChange: function(selectedDates, dateStr, instance){
			  $scope.eventRSVPDateOptions.onTimeSelect(selectedDates)
			},
		};

		$scope.startDateTimePostSetup = function(fpItem) {
			$scope.startDateTimeInstance = fpItem;
		}

		$scope.endDateTimePostSetup = function(fpItem) {
			$scope.endDateTimeInstance = fpItem;
		}

		$scope.rsvpDateTimePostSetup = function(fpItem) {
			$scope.rsvpDateTimeInstance = fpItem;
		}

		$scope.events = {
			commentCallback: function (comment) {
				if (!$scope.event.comments) {
					$scope.event.comments = [];
				}

				comment.avatar = $rootScope.active_user.avatar;
				comment.postedBy = $rootScope.active_user.firstName + ' ' + $rootScope.active_user.lastName;
				comment.body = $rootScope.parseLinks(comment.body);

				$scope.event.comments.push(comment);
				$scope.event.commentCount++;
			}
		}

		$rootScope.$on('$locationChangeStart', function (event, current, previous) {
			$rootScope.previous = previous;
		});

		$scope.isFriendshipBetaSchool = function() {
			return $rootScope.active_school.classBudi;
		}

		$scope.back = function () {

			if(!$scope.validateExternalOnlineLink()) return;

			$scope.triggerAutosave('');

			if ($rootScope.previous && $rootScope.previous.indexOf('community-events/dashboard') > -1) {
				history.back();
			}
			else {
				location.href = '/school/#/community-events/list';
			}
		}

		$scope.pickStartDate = function () {
			$scope.popupStartDate.opened = true;
		}

		$scope.pickEndDate = function () {
			$scope.popupEndDate.opened = true;
		}

		$scope.pickRsvpDate = function () {
			$scope.popupRsvpDate.opened = true;
		}

		$scope.removeOwner = function (owner, index) {
			var id_event = $scope.event.id;
			var _eventOwners = $scope.event.eventOwners;
			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdrop: 'static',
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/events/views/remove-owner-modal.html',
				size: 'sm',
				controller: function ($scope) {
					$scope.fullname = owner.firstName;

					$scope.cancel = function () {
						modalInstance.close();
					}

					$scope.remove = function () {
						$scope.removing = true;

						eventsService.delete('communityEvent/v2/delete/' + id_event + '/owner/' + owner.id)
							.then(function (response) {
								_eventOwners.splice(index, 1);
								modalInstance.close();
								$scope.removing = false;
								toastr.success('Successfully removed ' + rep.firstName + ' as event owner');
							},
								function (error) {
									$scope.removing = false;
								})
					};
				}
			})
		}

		$scope.gotoAddOwner = function () {
			location.href = '/school/#/community-events/owners/' + $scope.event.id;
		}

		$scope.getOwners = function () {
			eventsService.get('communityEvent/v2/list/' + $scope.event.id + '/owners')
				.then(function (response) {
					$scope.event.eventOwners = [];

					if (!response || !response.data || !response.data.items)
						return;

					$scope.event.eventOwners = response.data.items;
				},
					function (error) {

					})
		}

		$scope.getEvent = function () {
			angular.element(document).ready(function () {
				eventsService.get('communityEvent/v2/get/' + $scope.event.id, { 'cache': false, 'xhr': true }).then(function (response) {
					$scope.event = response.data;
					$scope.event_clone = angular.copy($scope.event);
					$scope.atSchoolEvent = $scope.event.eventAtSchool;
					$scope.isOnlineEvent = $scope.event.online;
					$scope.updateIsOnlineEvent($scope.event.online);
					if($scope.event.onlineEventType == 'EXTERNAL'){
						$scope.budiSelection.isBudiEvent = false;
						$scope.event.onlineLink = $scope.event.onlineEventExternalLink;
						$scope.event.onlineEventExternalUsername = $scope.event.onlineExternalEventUserName;
						$scope.event.onlineEventExternalPassword = $scope.event.onlineExternalEventPassword;
					} else $scope.budiSelection.isBudiEvent = true;

					$scope.hasTickets = $scope.event.ticketed;

					$scope.event.description = $rootScope.removeLinks($scope.event.description)
					$scope.publicEventCheck = $scope.event.open;

					$scope.viewState.isReady = true;

					try {
						if ($scope.event.date.startDate) {
							$scope.startDate = $rootScope.getUTCDatetime($scope.event.date.startDate);
							$scope.event.date.startDate = $scope.startDate;
							$scope.startDateTime = angular.copy($scope.startDate)
							if($scope.startDateTimeInstance){
								$scope.startDateTimeInstance.setTime($scope.startDateTime.getHours(), $scope.startDateTime.getMinutes(), null);  
							}
						}
						if ($scope.event.date.endDate) {
							$scope.endDate = $rootScope.getUTCDatetime($scope.event.date.endDate);
							$scope.event.date.endDate = $scope.endDate;
							$scope.endDateTime = angular.copy($scope.endDate)
							if($scope.endDateTimeInstance){
								$scope.endDateTimeInstance.setTime($scope.endDateTime.getHours(), $scope.endDateTime.getMinutes(), null);  
							}
						}
	
						if ($scope.event.date.rsvpDate) {
							$scope.rsvpDate = $rootScope.getUTCDatetime($scope.event.date.rsvpDate);
							$scope.event.date.rsvpDate = $scope.rsvpDate;
							$scope.rsvpDateTime = angular.copy($scope.rsvpDate)
							if($scope.rsvpDateTimeInstance){
								$scope.rsvpDateTimeInstance.setTime($scope.rsvpDateTime.getHours(), $scope.rsvpDateTime.getMinutes(), null);  
							}
						}else{
							if($scope.rsvpDateTimeInstance){
								$scope.clearDateTimePicker("eventRsvpDateTime")
							}
						}
					} catch (error) {
						alert(error)
					}
				

					$scope.getRotaList();

					setTimeout(function () {
						var input = document.querySelector('#event-description');
						if (input) {
							input.style.height = Math.min(input.scrollHeight, 1000) + 2 + "px";
						}

						var inputLoc = document.querySelector('#event-location-details');
						if (inputLoc) {
							inputLoc.style.height = Math.min(inputLoc.scrollHeight, 1000) + 2 + "px";
						}

						if ($scope.event.location
							&& $scope.event.location.locationLat
							&& $scope.event.location.locationLong) {
							$scope.event.location.locationLng = $scope.event.location.locationLong;
							$scope.initMap({
								lat: $scope.event.location.locationLat,
								lng: $scope.event.location.locationLong
							});
						}
					});

					$scope.appCues();			

				},
					function (error) {

					})
			});
	
		}
		$scope.clearDateTimePicker = function(id){
			var element = document.getElementById(id);
			if (element && element.nextElementSibling) {
				var nextElement = element.nextElementSibling;
				nextElement.value = '';
			}
		} 

		$scope.appCues = function(){
			$introjs.setAppCue("SCHOOL_COMMUNITY_EVENT_TOUR","EVENT_INIT",1000);
			$introjs.setAppCue("SCHOOL_FIRST_AMBASSADOR_COMMUNITY_EVENT_TOUR","EVENT_INIT",1000);
		}

		$scope.openRota = function (rota) {
			$rootScope.decideToRota = '/school/#/community-events/create/' + $scope.event.id;
			location.href = '/school/#/community-events/' + $scope.event.id + '/signup/' + rota.id;
		}

		$scope.viewRota = function (rota) {
			$rootScope.decideToRota = '/school/#/community-events/create/' + $scope.event.id;
			location.href = '/school/#/community-events/' + $scope.event.id + '/signup/' + rota.id + '/view/';
		}

		$scope.createVolunteerRota = function () {
			$rootScope.decideToRota = '/school/#/community-events/create/' + $scope.event.id;
			location.href = '/school/#/community-events/' + $scope.event.id + '/signup/';
		}

		$scope.getRotaList = function () {
			eventsService.get('rota/v1/Event/' + $scope.event.id)
				.then(function (response) {
					if (!response || !response.data || !response.data.items)
						return;

					$scope.rotaList = response.data.items;
				},
					function (error) {
						$scope.removing = false;
					})
		}

		baseService.app_initialized = function (evt, args) {
			schoolId = $rootScope.active_school.id;
			$scope.getEvent();
			$scope.getOwners();
			$window.scrollTo(0, 0);
		}

		if ($rootScope.active_school && $rootScope.app_base_ready) {
			baseService.app_initialized();
		}

		$scope.anyChange = function () {
			if ($scope.event.location.location != $scope.event_clone.location.location) {
				return true;
			}

			if ($scope.event.date.startDate) {
				if (new Date($scope.event.date.startDate) - new Date($scope.event_clone.date.startDate) != 0)
					return true;
			}

			if ($scope.event.date.endDate) {
				if (new Date($scope.event.date.endDate) - new Date($scope.event_clone.date.endDate) != 0)
					return true;
			}

			if ($scope.event.date.rsvpDate) {
				if (new Date($scope.event.date.rsvpDate) - new Date($scope.event_clone.date.rsvpDate) != 0)
					return true;
			}

			return false;
		}

		$scope.initMap = function (location) {
			if (!location || !location.lat || !location.lng || location.lat == 0 || location.lng == 0)
				return;

			var myPos = { 'lat': parseFloat(location.lat), 'lng': parseFloat(location.lng) };

			var mapDiv = document.getElementById('event-location-map');

			map = new google.maps.Map(mapDiv, {
				center: myPos,
				zoom: settings.runmap.zoom,
				zoomControl: true,
				mapTypeControl: false,
				scaleControl: false,
				streetViewControl: false,
				rotateControl: false,
				fullscreenControl: false
			});

			var marker = new google.maps.Marker({
				position: myPos,
				icon: 'assets/images/map-marker.svg',
				animation: google.maps.Animation.DROP,
				map: map
			});

			google.maps.event.trigger(map, 'resize');
			map.setCenter(myPos);
		}

		$scope.updateIsOnlineEvent = function (value) {
			$scope.isOnlineEvent = value;
			var payload = {
				online : value
			};

			eventsService.put('communityEvent/v2/update/' + $scope.event.id + '/ONLINE',payload).then(function (response) {

			}, function (error) {
				if (error.data.error.code == 400) {
					$scope.errorMessage = error.data.error.message;
				}
				else {
					toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
				}
			});
			setTimeout(function () {
				if(value){
					// PWA-8263 do not set the event as budi. Timeout value slightly extended as well to avoid error
					$scope.updateBudiEvent(false);
				} else {
					$scope.initMap({
						lat: $scope.event.location.locationLat,
						lng: $scope.event.location.locationLong
					});
				}
			}, 250);
		}
		$scope.updateBudiEvent = function(isBudi){
			// PWA-8263 simply prevent the type being set as EXTERNAL
			var payload = {
				onlineEventType : 'EXTERNAL'
			}

			$scope.budiSelection.isBudiEvent = isBudi;

			eventsService.put('communityEvent/v2/update/' + $scope.event.id + '/ONLINEEVENTTYPE', payload).then(function (response) {
				
			},
			function (error) {
				toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
			})
		}

		$scope.updateAtSchoolLocation = function (value) {
			$scope.atSchoolEvent = value;
			$scope.event.location = {};

			eventsService.put('communityEvent/v2/update/' + $scope.event.id + '/LOCATIONISSCHOOL', {
				eventAtSchool: value
			})
				.then(function (response) {
					if (!response
						|| !response.data
						|| !response.data.payload
						|| !response.data.payload.location
						|| !response.data.payload.location.locationLat
						|| !response.data.payload.location.locationLong)
						return;

					$scope.event.location = response.data.payload.location;
					$scope.event.location.locationLng = response.data.payload.location.locationLong;

					$scope.initMap({
						lat: $scope.event.location.locationLat,
						lng: $scope.event.location.locationLong
					});

					$scope.$apply();
				},
					function (error) {
						if (error.data.error.code == 400) {
							$scope.errorMessage = error.data.error.message;
						}
						else {
							toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
						}
					})
		}

		$scope.$watch('startDate', function(newValue, oldValue) {
			if(!newValue) {
				return;
			}

			if($scope.startDateTime) {
				newValue.setHours($scope.startDateTime.getHours())
				newValue.setMinutes($scope.startDateTime.getMinutes());
			}

			$scope.eventStartDateOptions.onDateSelect(newValue);
		});
		
		$scope.$watch('endDate', function(newValue, oldValue) {
			if(!newValue) {
				return;
			}

			if($scope.endDateTime) {
				newValue.setHours($scope.endDateTime.getHours())
				newValue.setMinutes($scope.endDateTime.getMinutes());
			}
			
			$scope.eventEndDateOptions.onDateSelect(newValue);
		});

		$scope.$watch('rsvpDate', function (newValue, oldValue) {
			if (!newValue) {
				return;
			}

			if($scope.rsvpDateTime) {
				newValue.setHours($scope.rsvpDateTime.getHours())
				newValue.setMinutes($scope.rsvpDateTime.getMinutes());
			}
			$scope.eventRSVPDateOptions.onDateSelect(newValue);
		});

		$scope.hasDateError = function (value) {
			for (var i = 0; i < $scope.dateErrors.length; i++) {
				if ($scope.dateErrors[i] == value)
					return $scope.dateErrors[i];
			}

			return '';
		}

		$scope.eventStartDateOptions = {
			onTimeSelect: function (time) {
				if(!$scope.event || !$scope.event.date) return;
				if($scope.event.date.startDate && time) {
					$scope.event.date.startDate.setHours(time.getHours())
					$scope.event.date.startDate.setMinutes(time.getMinutes());
				}

				$scope.errorMessage = null;
				$scope.eventStartDateOptions.onDateSelect($scope.event.date.startDate);
			},
			onDateSelect: function (date) {
				$scope.errorMessage = null;
				$scope.event.date.startDate = $rootScope.getWithoutTimeZone(date);

				var payload = {
					startDate: $rootScope.getWithoutTimeZone(date),
					endDate: $scope.event.date.endDate
				}

				if ($scope.event.date.rsvpDate) {
					payload.rsvpDate = $scope.event.date.rsvpDate;
				}

				eventsService.put('communityEvent/v2/update/' + $scope.event.id + '/dates', payload)
					.then(function (response) {
						$scope.dateErrors = [];

						if (response && response.data && response.data.items && response.data.items.length > 0) {
							$scope.dateErrors = response.data.items;
						}
					},
						function (error) {
							if (error.data.error.code == 400) {
								$scope.errorMessage = error.data.error.message;
							}
							else {
								toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
							}
						})
			}
		}

		$scope.eventEndDateOptions = {
			onTimeSelect: function (time) {
				if(!$scope.event || !$scope.event.date) return;
				if($scope.event.date.endDate && time) {
					$scope.event.date.endDate.setHours(time.getHours())
					$scope.event.date.endDate.setMinutes(time.getMinutes());
				}

				$scope.errorMessage = null;
				$scope.eventEndDateOptions.onDateSelect($scope.event.date.endDate);
			},
			onDateSelect: function (date) {
				$scope.errorMessage = null;
				$scope.event.date.endDate = $rootScope.getWithoutTimeZone(date);

				var payload = {
					startDate: $scope.event.date.startDate,
					endDate: $rootScope.getWithoutTimeZone(date)
				}

				if ($scope.event.date.rsvpDate) {
					payload.rsvpDate = $scope.event.date.rsvpDate;
				}

				eventsService.put('communityEvent/v2/update/' + $scope.event.id + '/dates', payload)
					.then(function (response) {
						$scope.dateErrors = [];

						if (response && response.data && response.data.items && response.data.items.length > 0) {
							$scope.dateErrors = response.data.items;
						}
					},
						function (error) {
							if (error.data.error.code == 400) {
								$scope.errorMessage = error.data.error.message;
							}
							else {
								toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
							}
						})
			}
		}

		$scope.eventRSVPDateOptions = {
			onTimeSelect: function (time) {
				if(!$scope.event || !$scope.event.date) return;
				if($scope.event.date.rsvpDate && time) {
					$scope.event.date.rsvpDate.setHours(time.getHours())
					$scope.event.date.rsvpDate.setMinutes(time.getMinutes());
				}

				if(!$scope.rsvpDate) return;

				$scope.errorMessage = null;
				$scope.eventRSVPDateOptions.onDateSelect($scope.event.date.rsvpDate);
			},
			onDateSelect: function (date) {
				$scope.errorMessage = null;
				if(!$scope.rsvpDateTime && date){
					date.setHours(12);
					date.setMinutes(0);
				}
				$scope.event.date.rsvpDate = $rootScope.getWithoutTimeZone(date);
				
				if(!$scope.rsvpDateTime){
					$scope.rsvpDateTime = angular.copy($scope.event.date.rsvpDate);
					$scope.rsvpDateTimeInstance.setDate($scope.rsvpDateTime, false);  
				}

				var payload = {
					startDate: $scope.event.date.startDate,
					endDate: $scope.event.date.endDate,
					rsvpDate: $rootScope.getWithoutTimeZone(date)
				}

				eventsService.put('communityEvent/v2/update/' + $scope.event.id + '/dates', payload)
					.then(function (response) {
						$scope.dateErrors = [];

						if (response && response.data && response.data.items && response.data.items.length > 0) {
							$scope.dateErrors = response.data.items;
						}
					},
						function (error) {
							if (error.data.error.code == 400) {
								$scope.errorMessage = error.data.error.message;
							}
							else {
								toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
							}
						})
			},
			clear: function () {
				$scope.event.date.rsvpDate = null;
				$scope.event.date.rsvpDate = null;
				$scope.rsvpDate = null;
				$scope.rsvpDateTime = null;
				$scope.event.date.updated = new Date();
				$scope.errorMessage = null;
				$scope.clearDateTimePicker("eventRsvpDateTime")
				var payload = {
					startDate: $scope.event.date.startDate,
					endDate: $scope.event.date.endDate,
					rsvpDate: null
				}

				eventsService.put('communityEvent/v2/update/' + $scope.event.id + '/dates', payload)
					.then(function (response) {
						$scope.dateErrors = [];

						if (response && response.data && response.data.items && response.data.items.length > 0) {
							$scope.dateErrors = response.data.items;
						}

					},
						function (error) {
							if (error.data.error.code == 400) {
								$scope.errorMessage = error.data.error.message;
							}
							else {
								toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
							}
						})

				// eventsService.put('communityEvent/v2/update/'+$scope.event.id+'/rsvpdate', {
				// 	date: null
				// })
				// .then(function(response) {
				// 	toastr.success('Successfully removed the RSVP date')


				// },
				// function(error) {
				// 	if(error.data.error.code == 400) {
				// 		toastr.error(error.data.error.message);
				// 	}
				// 	else {
				// 		toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
				// 	}
				// })
			}
		}

		var fileUploader = document.getElementById('fileUploader');

		$scope.fileUploadDialog = function () {
			fileUploader.click();
		}

		$scope.copyLink = function () {
			copyToClipboard($scope.event.openLink);
			$scope.showLinkCopyDone = true;
			//$rootScope.userTag('PARENT_INVITED_V2', "LINK:" + $scope.link);
		}

		$scope.canMakePublic = function () {
			if ($scope.event.ticketed) {
				if ($scope.event.paymentProvider && $scope.event.paymentProvider.provider == 'paypal') {
					return false;
				}
			}

			return true;
		}

		$scope.switchPublicEvent = function () {
			if (!$scope.canMakePublic()) {
				return;
			}

			$scope.showLinkCopyDone = false;

			$scope.triggerAutosave('');
			$scope.members = new Array();

			if (!$scope.event.title || !$scope.event.date.startDate) {
				var modalInstance = $uibModal.open({
					animation: true,
					scope: $scope,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/events/views/before-invite-modal.html',
					size: 'sm',
					controller: function ($scope) {
						$scope.close = function () {
							modalInstance.close();
						};
					}
				})

				return;
			}

			$scope.event.open = !$scope.event.open;

			if ($scope.event.open) {
				var _event_id = $scope.event.id;
				var modalInstance = $uibModal.open({
					animation: true,
					scope: $scope,
					backdrop: 'static',
					keyboard: false,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/events/views/open-event-modal.html',
					size: 'sm',
					controller: function ($scope) {
						$scope.confirm = function () {
							eventsService.put('communityEvent/v2/update/' + _event_id + '/PUBLIC_ACCESS', {
								open: $scope.event.open
							})
								.then(function (response) {

								},
									function (error) {
										$scope.event.open = false;
									})
							modalInstance.close();
						};
						$scope.close = function () {
							$scope.event.open = false;
							modalInstance.close();
						};
					}
				})
			}
			else {
				eventsService.put('communityEvent/v2/update/' + $scope.event.id + '/PUBLIC_ACCESS', {
					open: false
				})
					.then(function (response) {

					},
						function (error) {
							$scope.event.open = false;
						})
			}
		}

		$scope.isDefaultImage = function (res) {
			return !res || res.indexOf('no-events.svg') > -1;
		}

		$scope.closeInfo = function () {
			$scope.showInfo = false;
		}

		$scope.closeInfoRSVP = function () {
			$scope.showInfoRSVP = false;
		}

		$scope.openInfoRSVP = function () {
			$scope.showInfoRSVP = true;
		}

		$scope.uploadImage = function () {

			$rootScope.$broadcast('UPLOAD_PHOTO', {
				'callback_fn': function (response) {
					var url = eventsService.getPostImgBucketUrl() + '/' + response.data;

					eventsService.put('communityEvent/v2/update/' + $scope.event.id + '/image', {
						image: response.data || ''
					}).then(function (response) {
						$scope.event.fileLibrary.image = url;
						$scope.event.photoId = response.data || '';
					},
						function (error) {
							toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
						})
				},
				'action': 'eventUpload',
				'config': 'eventCropper',
				'on_close': function () {
					//$scope.pickGallery();
				}
			});
		}

		$scope.pickGallery = function () {
			$scope.$broadcast('GALLERY_PICKER', {
				'on_select': function (obj) {
					$scope.event.fileLibrary.image = obj.url;
					$scope.event.photoId = obj.id || '';

					eventsService.put('communityEvent/v2/update/' + $scope.event.id + '/image', {
						image: obj.id
					}).then(function (response) {

					},
						function (error) {
							if (error.data.error.message) {
								toastr.error(error.data.error.message);
							} else {
								toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
							}
						})
				},
				'on_upload': function () {
					$scope.uploadImage();
				}
			});
		}

		$scope.inviteGuests = function () {
			$scope.triggerAutosave('');
			$scope.members = new Array();

			if (!$scope.event.title || !$scope.event.date.startDate) {
				var modalInstance = $uibModal.open({
					animation: true,
					scope: $scope,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/events/views/before-invite-modal.html',
					size: 'sm',
					controller: function ($scope) {
						$scope.close = function () {
							modalInstance.close();
						};
					}
				})
			}
			else {
				var _event = $scope.event;
				var modalInstance = $uibModal.open({
					animation: true,
					scope: $scope,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/events/views/invite-modal.html',
					size: 'md',
					controller: function ($scope) {
						$scope.event = _event;

						$scope.save = function () {
							$scope.invitingGuests = true;

							var gsts = [];
							for (var i = 0; i < $scope.members.length; i++) {

								if (gsts.indexOf($scope.members[i].groupId) == -1)
									gsts.push($scope.members[i].groupId);
							}

							eventsService.post('communityEvent/v1/create/guest/' + $scope.event.id, {
								groups: gsts,
								sendNotifications: $scope.sendGuestNotification
							})
								.then(function (response) {
									$scope.invitingGuests = false;
									modalInstance.close();

									if ($scope.event.answerCount.invited == 0) {
										var id_event = $scope.event.id;
										var modalInstanceLive = $uibModal.open({
											animation: true,
											backdropClass: 'backdrop-zindexed',
											templateUrl: 'app/events/views/live-confirm-modal.html',
											size: 'md',
											controller: function ($scope) {
												$scope.id = id_event;
												$scope.close = function () {
													modalInstanceLive.close();
												};
											}
										})
									}

									setTimeout(function () {
										$scope.getEvent();
										$scope.$apply();
									}, 700);
								},
									function (error) {
										$scope.invitingGuests = false;

										if (error.data.error.code == 400) {
											toastr.info($translate.instant(error.data.error.message));
										}
										else {
											toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
										}
									})
						};

						$scope.close = function () {
							modalInstance.close();
						};
					}
				})
			}
		}

		$scope.showGuests = function (type) {
			function openModal(participants) {
				var modalInstance = $uibModal.open({
					animation: true,
					templateUrl: 'app/base/views/show-participants-modal.html',
					backdropClass: 'backdrop-zindexed',
					size: 'sm',
					controller: function ($scope) {
						$scope.participants = participants;
						$scope.eventContext = true;
						$scope.addDisabled = true;
						$scope.viewState = {
							isReady: true
						}

						$scope.openAddParticipantsModal = function () {
							activateInviteGuests();
						}

						$scope.close = function () {
							modalInstance.close();
						}
					}
				})
			}

			eventsService.get('communityEvent/v1/get/' + $scope.event.id + '/attendees/' + type, { 'cache': false }).then(function (response) {
				if (response.data.items) {
					openModal(response.data.items)
				}
			},
				function (error) {
					toastr.error($translate.instant('GENERIC_REQUEST_ERROR'))
				})
		}

		$scope.switchAddress = function (saved) {
			$scope.selectedAddress = null;
			$scope.tabNewAddress = saved;
		}

		$scope.selectAddress = function (addr, index) {
			addr.index = index;
			$scope.selectedAddress = addr;
		}

		$scope.deleteAddress = function (addr, index) {
			$scope.savedAddresses.splice(index, 1);

			eventsService.delete('location/v1/delete/location/' + addr.id, {}).then(function (response) {
				toastr.info($translate.instant('ADDRESS_DELETED'));
			},
				function (error) {
					if (error.data.error.message) {
						toastr.error(error.data.error.message);
					} else {
						toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
					}
				})
		}

		$scope.$watch('event.g_location', function (newValue, oldValue) {
			$scope.selectedAddress = null;

			if (newValue) {
				if (newValue.fullAddress) {
					$scope.selectedAddress = {
						placeId: newValue.isRealAddress ? newValue.locationId : null,
						location: newValue.fullAddress
					}
				}
			}
		});

		$scope.getSavedLocations = function () {
			eventsService.get('location/v1/list/location/' + $rootScope.active_school.id, {}).then(function (response) {
				$scope.savedAddresses = response.data.items;

				if ($scope.savedAddresses.length == 0)
					$scope.tabNewAddress = true;
			},
				function (error) {

				})
		}

		$scope.saveLocation = function (placeId, success) {
			eventsService.post('location/v1/create/location/' + $rootScope.active_school.id + '/place', { placeId: placeId }).then(function (response) {
				if (success)
					success();
			},
				function (error) {
					if (error.data.error.message) {
						toastr.error(error.data.error.message);
					} else {
						toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
					}
				})
		}

		$scope.addLocation = function () {
			$scope.tabNewAddress = false;
			$scope.selectedAddress = null;

			$scope.getSavedLocations();

			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/events/views/location-modal.html',
				size: 'md',
				controller: function ($scope) {

					$scope.save = function () {
						if (!$scope.selectedAddress)
							return;

						if ($scope.isPastEvent($scope.event)) {
							toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
							return;
						}

						var det = $scope.event.location.locationDetail;
						$scope.event.location = $scope.selectedAddress;
						$scope.event.location.locationDetail = det;

						if (!$scope.tabNewAddress) {
							if($scope.selectedAddress.schoolAddress === true){
								$scope.updateAtSchoolLocation(true);
								modalInstance.close();
								return;
							}
							if ($scope.selectedAddress.id == 0) {
								eventsService.put('communityEvent/v2/update/' + $scope.event.id + '/locationaddress', {
									plainAddress: $scope.selectedAddress.plainLocation
								})
									.then(function (response) {
										$scope.event.date.updated = new Date();

										if (!$scope.tabNewAddress)
											$scope.event.location.location = $scope.event.location.plainLocation;

										$scope.initMap({
											lat: $scope.event.location.locationLat,
											lng: $scope.event.location.locationLng
										});

										modalInstance.close();
									},
										function (error) {
											if (error.data.error.message) {
												toastr.error(error.data.error.message);
											} else {
												toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
											}
										})
							}
							else {
								eventsService.put('communityEvent/v2/update/' + $scope.event.id + '/location', {
									locationId: $scope.selectedAddress.id
								})
									.then(function (response) {
										$scope.event.date.updated = new Date();

										if (!$scope.tabNewAddress)
											$scope.event.location.location = $scope.event.location.plainLocation;

										$scope.initMap({
											lat: $scope.event.location.locationLat,
											lng: $scope.event.location.locationLng
										});

										modalInstance.close();
									},
										function (error) {
											if (error.data.error.message) {
												toastr.error(error.data.error.message);
											} else {
												toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
											}
										})
							}
						}
						else {
							$scope.addingLocation = true;
							eventsService.put('communityEvent/v2/update/' + $scope.event.id + '/locationplaceid', {
								placeId: $scope.event.location.placeId,
								plainAddress: $scope.event.location.location,
								save: $scope.saveAddressCheck

							}).then(function (response) {
								$scope.addingLocation = false;
								$scope.event.date.updated = new Date();
								modalInstance.close();

								if (!$scope.tabNewAddress)
									$scope.event.location.location = $scope.event.location.plainLocation;

								if (!response || !response.data || !response.data.payload || !response.data.payload.location) {
									$scope.event.location = {
										location: response.data.payload.location.location,
										locationLat: 0,
										locationLng: 0
									}
									$scope.event.location.location = $scope.selectedAddress.location;
								}
								else {
									$scope.event.location = {
										location: response.data.payload.location.location,
										locationLat: response.data.payload.location.locationLat,
										locationLng: response.data.payload.location.locationLong
									}

									$scope.initMap({
										lat: response.data.payload.location.locationLat,
										lng: response.data.payload.location.locationLong
									});
								}

								modalInstance.close();
							},
								function (error) {
									$scope.addingLocation = false;
									toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
								})
						}

					};
					$scope.close = function () {
						modalInstance.close();
					};
				}
			})
		}

		$scope.deleteEvent = function () {
			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/events/views/delete-modal.html',
				size: 'sm',
				controller: function ($scope) {

					$scope.save = function () {
						$scope.deletingEvent = true;

						eventsService.post('communityEvent/v1/update/' + $scope.event.id + '/cancel').then(function (response) {
							$scope.deletingEvent = false;
							modalInstance.close();
							location.href = '/school/#/community-events/list';
							toastr.info($translate.instant('EVENT_DELETED_INFO'));
						},
							function (error) {
								$scope.deletingEvent = false;
								toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
							})
					};
					$scope.close = function () {
						modalInstance.close();
					};
				}
			})
		}

		$scope.cancelEvent = function () {
			var modalInstance = $uibModal.open({
				animation: true,
				scope: $scope,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/events/views/cancel-modal.html',
				size: 'md',
				controller: function ($scope) {
					$scope.cancelMessage = $translate.instant('CANCEL_EVENT_DEFAULT_MESSAGE') + $rootScope.active_user.firstName;

					$scope.save = function () {
						$scope.cancellingEvent = true;

						eventsService.post('communityEvent/v1/update/' + $scope.event.id + '/cancel', {
							message: $scope.cancelMessage
						})
							.then(function (response) {
								$scope.cancellingEvent = false;
								modalInstance.close();
								location.href = '/school/#/community-events/list';
								toastr.info($translate.instant('EVENT_CANCELLED_INFO'));
							},
								function (error) {
									$scope.cancellingEvent = false;
									toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
								})
					};
					$scope.close = function () {
						modalInstance.close();
					};
				}
			})
		}

		$scope.validateExternalOnlineLink = function() {

			// PWA-8214 check that a link has been set for online external events
			if( $scope.isOnlineEvent && !$scope.budiSelection.isBudiEvent ){
				if( $scope.event.onlineLink === undefined || $scope.event.onlineLink.length == 0 ) {
					// the event is online but not budi, and the link is not defined
					toastr.error($translate.instant('NO_EXT_ONLINE_LINK_ERROR'));
					document.getElementById("event-ext-link").style.borderColor = 'red'; 
					document.getElementById("event-ext-link").style.borderStyle = 'solid'; 
					document.getElementById("event-ext-link").focus();
					return false;
				}
				if(!$scope.validateLink($scope.event.onlineLink)){
					document.getElementById("event-ext-link").style.borderColor = 'red'; 
					document.getElementById("event-ext-link").style.borderStyle = 'solid'; 
					document.getElementById("event-ext-link").focus();
					$scope.invalidOnlineLink = true;
					return false;
				}
				$scope.invalidOnlineLink = false;
				document.getElementById("event-ext-link").style.borderColor = 'black'; 
				document.getElementById("event-ext-link").style.borderStyle = 'solid';
			}

			return true;
		}

		$scope.continue = function () {

			if(!$scope.validateExternalOnlineLink()) return;

			if ($scope.hasTickets && !$scope.event.ticketed) {
				var modalInstance = $uibModal.open({
					animation: true,
					scope: $scope,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/events/views/ticketed-empty-modal.html',
					size: 'md',
					controller: function ($scope) {
						$scope._addTickets = function () {
							modalInstance.close();
							location.href = '/school/#/community-events/tickets/' + $scope.event.id;
						};
						$scope._continue = function () {
							location.href = '/school/#/community-events/dashboard/' + $scope.event.id;
						};
					}
				})
				return;
			}

			location.href = '/school/#/community-events/dashboard/' + $scope.event.id;
		}

		$scope.triggerAutosave = function (type) {
			if (!isThisMobile())
				return;

			if (type != 'createdBy' && $scope.editingCreatedby)
				$scope.saveCreatedby();
		}

		$scope.cancelTitle = function () {
			$scope.editingTitle = false;
		}

		$scope.stopPropagation = function (e) {
			e.stopPropagation();
			e.stopImmediatePropagation();
		}

		$scope.saveTitle = function () {
			$scope.editingTitle = false;

			eventsService.put('communityEvent/v2/update/' + $scope.event.id + '/title', { title: $scope.event.title }).then(function (response) {
				$scope.event.date.updated = new Date();
			},
				function (error) {
					if (error.data.error.code == 400) {
						$scope.errorMessage = error.data.error.message;
					}
					else {
						toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
					}
				})
		}

		$scope.saveDescr = function () {
			$scope.event._description = $rootScope.createEmailLinks($scope.event.description);

			eventsService.put('communityEvent/v2/update/' + $scope.event.id + '/description', { description: $scope.event._description }).then(function (response) {
				$scope.event.date.updated = new Date();
			},
				function (error) {
					if (error.data.error.message) {
						toastr.error(error.data.error.message);
					} else {
						toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
					}
				})
		}

		$scope.checkValidLink = function () {

			if(!$scope.validateExternalOnlineLink()) return;

		}
		$scope.saveOnlineLink = function() {
			if(!$scope.validateExternalOnlineLink()) return;

			var payload = {
				onlineEventExternalLink: $scope.event.onlineLink
			}
			eventsService.put('communityEvent/v2/update/' + $scope.event.id + '/ONLINEEVENTLINK', payload).then(function (response) {
			},
			function (error) {
				toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
			})
		}
		$scope.saveOnlineEventExternalUsername = function() {
			//if(!$scope.event.onlineEventExternalUsername) return;

			var payload = {
				onlineEventExternalUsername: $scope.event.onlineEventExternalUsername
			}
			eventsService.put('communityEvent/v2/update/' + $scope.event.id + '/ONLINEEVENTUSERNAME', payload).then(function (response) {
			},
			function (error) {
				toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
			})
		}
		$scope.saveOnlineEventExternalPassword = function() {
			//if(!$scope.event.onlineEventExternalPassword) return;

			var payload = {
				onlineEventExternalPassword: $scope.event.onlineEventExternalPassword
			}
			eventsService.put('communityEvent/v2/update/' + $scope.event.id + '/ONLINEEVENTPASSWORD', payload).then(function (response) {
			},
			function (error) {
				toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
			})
		}

		$scope.editCreatedby = function (e) {
			$scope.triggerAutosave('createdBy');

			setTimeout(function () {
				$scope.editingCreatedby = true;
				$scope.valueCreatedby = $scope.event.createdByName;

				if (e)
					focusClickEditor(e);
				$scope.$apply();
			}, 1);
		}

		$scope.cancelCreatedby = function () {
			$scope.editingCreatedby = false;
		}

		$scope.saveOutsideCreatedby = function () {
			if (!isThisMobile() && $scope.editingCreatedby)
				$scope.saveCreatedby()
		}

		$scope.saveOutsideCreatedby1 = function () {
			if (!isThisMobile() && $scope.editingCreatedby)
				$scope.saveCreatedby()
		}

		$scope.saveCreatedby = function () {
			$scope.event.createdByName = $scope.valueCreatedby ? $scope.valueCreatedby : $scope.event.createdByName;
			$scope.editingCreatedby = false;

			eventsService.put('communityEvent/v2/update/' + $scope.event.id + '/createdbyname', { createdByName: $scope.event.createdByName }).then(function (response) {
				$scope.event.date.updated = new Date();
			},
				function (error) {
					if (error.data.error.message) {
						toastr.error(error.data.error.message);
					} else {
						toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
					}
				})
		}

		$scope.saveLocationDetail = function () {
			eventsService.put('communityEvent/v2/update/' + $scope.event.id + '/locationdetail', { locationDetail: $scope.event.location.locationDetail }).then(function (response) {
				$scope.event.date.updated = new Date();
			},
				function (error) {
					toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
				})
		}

		$scope.addAttachment = function (id, filename) {

			eventsService.post('attachment/v1/create/attachment/' + $rootScope.active_school.id, {
				id: id,
				name: filename,
				reference: $scope.event.id,
				type: 'EVENT'

			}).then(function (response) {
				if (!$scope.event.fileLibrary.attachment)
					$scope.event.fileLibrary.attachment = new Array();

				$scope.event.date.updated = new Date();
				$scope.event.fileLibrary.attachment.push(response.data)
				toastr.info($translate.instant('ATTACHED_SUCCESSFULLY'));
			},
				function (error) {
					toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
				})
		}

		$scope.deleteAttachment = function (att, index) {
			$scope.event.fileLibrary.attachment.splice(index, 1);

			eventsService.delete('attachment/v1/delete/attachment/' + att.id, {}).then(function (response) {
				toastr.info($translate.instant('ATTACHMENT_DELETED'));
			},
				function (error) {
					toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
				})
		}

		$scope.gotoPreview = function () {
			$scope.triggerAutosave('');

			setTimeout(function () {
				location.href = '/school/#/community-events/view/' + $scope.event.id;
			}, 50);
		}

		$scope.gotoTickets = function () {
			$scope.triggerAutosave('');

			if ($scope.event.answerCount.invited == 0 || $scope.event.ticketed) {
				setTimeout(function () {
					location.href = '/school/#/community-events/tickets/' + $scope.event.id;
				}, 100);
			}
			else {
				var modalInstance = $uibModal.open({
					animation: true,
					scope: $scope,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/events/views/before-ticketing-modal.html',
					size: 'md',
					controller: function ($scope) {
						$scope.close = function () {
							modalInstance.close();
						};
						$scope.gotit = function () {
							location.href = '/school/#/community-events/tickets/' + $scope.event.id;
						};
					}
				})
			}
		}

		$scope.openBudiHelp = function () {
			window.open('https://help.classlist.com/hc/en-us/articles/360013553397', '_blank');
		}

		$scope.openInfo = function (e, type) {
			if (e) {
				e.stopImmediatePropagation();
				e.stopPropagation();
			}

			var modalInstance = $uibModal.open({
				animation: true,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/info_modals/info-modal-' + type + '.html',
				controller: function ($scope) {

					$scope.close = function () {
						modalInstance.close();
					};
				},
				size: 'sm'
			});
		}

		function focusClickEditor(e) {
			var elem = angular.element(e.srcElement).parent()

			setTimeout(function () {
				if (elem.length > 0) {
					if (elem[0].getElementsByTagName('input').length > 0) {
						elem[0].getElementsByTagName('input')[0].focus();
					}
					else if (elem[0].getElementsByTagName('textarea').length > 0) {
						elem[0].getElementsByTagName('textarea')[0].focus();
					}
				}
			}, 1);
		}

		fileUploader.onchange = function () {

			var file = fileUploader.files[0],
				reader = new FileReader();

			if (file) {
				reader.readAsDataURL(file);
			}

			if (file.size > 10000000) {
				toastr.info($translate.instant('FILE_SIZE_TOO_BIG_10'));
				return;
			}

			reader.addEventListener('load', function () {
				$scope.isUploading = true;

				uploadService.fileUpload(dataURItoBlob(reader.result), {
					headers: {
						'Content-Type': undefined,
						'ClasslistToken': storage.getToken() || '',
						'ClasslistCfg': angular.toJson({
							'type': 'ATTACHMENT'
						})
					}
				}, file.name)
					.then(function (response) {
						$scope.addAttachment(response.data, file.name);
						$scope.isUploading = false;
					},
						function (error) {
							if (error.status === 403 || error.status === 409) {
								toastr.error($translate.instant(error.data));
							}
							else {
								toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
							}

							$scope.isUploading = false;
						});
			}, false);
		}

		function dataURItoBlob(dataURI) {
			var byteString = atob(dataURI.split(',')[1]);
			var ab = new ArrayBuffer(byteString.length);
			var ia = new Uint8Array(ab);
			for (var i = 0; i < byteString.length; i++) {
				ia[i] = byteString.charCodeAt(i);
			}
			return new Blob([ab], { type: 'image/jpeg' });
		}
	}
})();

(function() {
	'use strict';

	angular.module('modules.dashboard',[])
	.factory('dashboardService', ['base','$http', function (base, $http) {
		return _.create(base, { });
	}])
	.controller('dashboardController', dashboardController);

	/** @ngInject */
	function dashboardController(baseService, $scope, $rootScope, $location, $uibModal, dashboardService, toastr, $translate, $state, $http) {

		baseService.app_initialized = function(evt, args) {
			
		}

		if($rootScope.active_school && $rootScope.app_base_ready) { 
			baseService.app_initialized();
		}
	}

})();

(function () {
	'use strict';

	angular.module('modules.dashboard.main', [])

		.factory('dashboardService', ['base', function (base) {
			return _.create(base, {})
		}])

		.controller('dashmainController', dashmainController);

	/** @ngInject */
	function dashmainController(baseService, $scope, $rootScope, $location, $translate, settings, $timeout, $uibModal, dashboardService, toastr, storage, $state, $introjs) {

		$scope.dashboard = {};
		$scope.viewState = {};
		$scope.tasks = [];
		$scope.integrationEnabled = false;
		$scope.dontShowPwaSunsetAgain = false;
		$scope.dontShowStaffSurveyModalAgain = false;
		baseService.app_initialized = function (evt, args) {
			
			//check and load app cue if it is defined...
			//$rootScope.active_school.firstAmbassador = false;
			if($rootScope.active_school.firstAmbassador){
				$introjs.startAppCue("SCHOOL_FIRST_AMBASSADOR_COMMUNITY_EVENT_TOUR","DASHBOARD_EVENT",500, false);
			} else {
				$introjs.startAppCue("SCHOOL_COMMUNITY_EVENT_TOUR","DASHBOARD_EVENT",500,false);
			}
			
			$scope.openedTranslated = $translate.instant('OPENED');
			$scope.onclasslistTranslated = $scope.onclasslistTranslated = "On Classlist";
			$scope.id_school = $rootScope.active_school.id;
			$scope.user = $rootScope.active_user;
			$scope.integrationEnabled = $rootScope.active_school.integrationEnabled;
			$scope.isTrialSchool = $rootScope.active_school.status === 'TRIAL';
			// if all roles just class rep
			$scope.isOnlyClassRep = !$rootScope.adminHaveRoles('STAFF', 'AMBASSADOR', 'COMM_REP');

			$scope.loadAnnouncements = function () {

				dashboardService.get('school/v1/dashboard/' + $scope.id_school + '/announcements', {
					'cache': false
				}).then(function (response) {
						$scope.announcements = response.data.payload;

					},
					function (error) {

					});
			}
			$scope.waitingInfoModal = function (e, type) {
				if (e) {
					e.stopImmediatePropagation();
					e.stopPropagation();
				}
	
				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/info_modals/info-modal-14.html',
					controller: function ($scope) {
	
						$scope.close = function () {
							modalInstance.close();
						};
					},
					size: 'md'
				});
			}
			$scope.notActivatedModal = function (e, type) {
				if (e) {
					e.stopImmediatePropagation();
					e.stopPropagation();
				}
	
				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/info_modals/info-modal-15.html',
					controller: function ($scope) {
	
						$scope.close = function () {
							modalInstance.close();
						};
					},
					size: 'md'
				});
			}
			
			$scope.getTasks = function () {

				dashboardService.get('school/v1/dashboard/' + $scope.id_school + '/task/list', {
					'cache': false
				}).then(function (response) {
						$scope.tasks = response.data.templates;
						$scope.enabledTasks = $scope.checkEnabledTasks();

						var checkedFirst = false;
						if (!_.isUndefined($scope.tasks)) {
							for (var i = 0; i < $scope.tasks.length; i++) {
								$scope.tasks[i].completed = $scope.isTaskCompleted($scope.tasks[i]);

								if ($scope.tasks[i].completed) {
									if ($scope.tasks[i + 1])
										$scope.tasks[i + 1].enabled = true;
								} else {
									if (!checkedFirst) {
										checkedFirst = true;
										$scope.selectTask(0, $scope.tasks[i]);
									}
								}
							}
						}

						if (!checkedFirst) {
							$scope.tasksEnded = true;
							$scope.selectTask(0, $scope.tasks[$scope.tasks.length - 1]);
						}
					},


					function (error) {

					});
					
					
			}

			$scope.setTask = function (child) {
				var task = $scope.selectedTask;

				dashboardService.put('school/v1/dashboard/' + $scope.id_school + '/task/' + child.id + '/' + !child.completed, {
					'cache': false
				}).then(function (response) {
						task.completed = $scope.isTaskCompleted(task);
					},
					function (error) {

					});

				child.completed = !child.completed;

				if (child.completed) {
					child.completedBy = $rootScope.active_user.firstName + " " + $rootScope.active_user.lastName;
				} else {
					child.completedBy = '';
				}

				for (var i = 0; i < $scope.tasks.length; i++) {
					$scope.tasks[i].completed = $scope.isTaskCompleted($scope.tasks[i]);

					if ($scope.tasks[i].completed) {
						if ($scope.tasks[i + 1])
							$scope.tasks[i + 1].enabled = true;
						else
							$scope.tasks[i + 1].enabled = false;
					} else
					if ($scope.tasks[i + 1])
						$scope.tasks[i + 1].enabled = false;
				}
			}

			$scope.isTaskCompleted = function (task) {
				var completed = true;

				for (var i = 0; i < task.children.length; i++) {
					if (!task.children[i].completed) {
						completed = false;
						break;
					}
				}

				return completed;
			}

			$scope.checkEnabledTasks = function () {
				var checked = false;

				for (var i = 0; i < $scope.tasks.length; i++) {
					for (var j = 0; j < $scope.tasks[i].children.length; j++) {
						if ($scope.tasks[i].children[j].completed) {
							checked = true;
							break;
						}
					}
				}

				return checked;
			}

			$scope.areTasksCompleted = function () {
				var completed = true;

				for (var i = 0; i < $scope.tasks.length; i++) {
					for (var j = 0; j < $scope.tasks[i].children.length; j++) {
						if (!$scope.tasks[i].children[j].completed) {
							completed = false;
							break;
						}
					}
				}

				return completed;
			}

			$scope.selectTask = function (index, task) {
				task.completed = $scope.isTaskCompleted(task);

				// if(index == 0) {
				// 	$scope.selectedTask = task;
				// 	return;
				// }

				// if(!$scope.tasks[index-1].completed)
				// 	return;

				$scope.selectedTask = task;
			}

			$scope.enableTasks = function () {
				$scope.enabledTasks = true;
			}

			$scope.loadGeneral = function () {
				$scope.viewState.isReady = false;

				dashboardService.get('school/v1/dashboard/' + $scope.id_school + '/general', {
					'cache': false
				}).then(function (response) {
					$scope.viewState.isReady = true;
					$scope.general = response.data.payload;

				}, function (error) {
					$scope.viewState.isReady = true;
				});
			}

			$scope.loadParents = function () {
				$scope.viewState.isReady = false;

				dashboardService.get('school/v1/dashboard/' + $scope.id_school + '/parent', {
					'cache': false
				}).then(function (response) {
					$scope.viewState.isReady = true;
					$scope.parents = response.data.payload;

				}, function (error) {
					$scope.viewState.isReady = true;
				});
			}


			// staffSurveyModalAdminShow for survey, use v2 with this key
			// PWA Sunset Modal Start
			$scope.isSunsetModalVisible = false;
			$scope.isSunsetModalVisible = function() {
				var dontShowPwaSunsetAgain = window.localStorage.getItem('dontShowPwaSunsetAgain');
				if(dontShowPwaSunsetAgain) {
					$scope.isSunsetModalVisible = false;
					return;
				}

				var storedDate = window.localStorage.getItem('sunsetModalAdminShow');
				if(!storedDate){
					$scope.isSunsetModalVisible = true;
					return;
				}

				// if the popup closed, show 7 days later
				var storedTimestamp = new Date(storedDate).getTime();
				$scope.isSunsetModalVisible = Date.now() >= storedTimestamp;
			};
		
			$scope.closeSunsetModal = function() {
				$scope.isSunsetModalVisible = false;
				var oneWeekLater = new Date();
				oneWeekLater.setDate(oneWeekLater.getDate() + 7);
			
				window.localStorage.setItem('sunsetModalAdminShow', oneWeekLater.toDateString());
			};
			$scope.isSunsetModalVisible();

			$scope.onPwaSunsetCheckboxChange = function(dontShowPwaSunsetAgain) {
				if(dontShowPwaSunsetAgain) {
					window.localStorage.setItem('dontShowPwaSunsetAgain', true);
				} else {
					window.localStorage.removeItem('dontShowPwaSunsetAgain');
				}
			}
			// PWA Sunset Modal End

			$scope.getNumber = function (num) {
				return new Array(num);
			}

			$scope.postsCountRedirect = function (role) {
				if ($rootScope.active_school.parent === true) {
					$scope.switchApps('#/home');
				}
			}

			$scope.createPostRedirect = function (role) {
				if ($rootScope.active_school.parent === false) {
					$state.go('announcements.list')
				} else {
					$scope.switchApps('#/home');
				}
			}

			$scope.replaceRedirectLinks = function (inputText) {
				try {
					inputText = inputText.replace("@token@", storage.getToken());
					inputText = inputText.replace("@school@", $rootScope.active_school.id);
					return inputText;
				} catch (ex) {
					return inputText;
				}
			}

			function getMonthName(index) {
				var months = $translate.instant('MONTH_NAMES').split(',');
				return months[index];
			}

			function getWeeklyParentTooltip(object) {
				var html = '';

				html += '<div class="graph-tooltip">';
				html += '<div class="tooltip-subtitle">';
				html += new Date(object.startDate).getDate() + ' ' + getMonthName(new Date(object.startDate).getMonth()) + ' - ' + new Date(object.endDate).getDate() + ' ' + getMonthName(new Date(object.endDate).getMonth());
				html += '</div>';
				html += '<div class="tooltip-title">';
				html += object.count + ' Active parents';
				html += '</div>';
				html += '</div>';

				return html;
			}
			$scope.loadAnnouncements();
			$scope.loadParents();
			$scope.loadGeneral();
			$scope.getTasks();



			$scope.os = getMobileOperatingSystem();

			// show admin menu on flutter
			if($scope.os == "Flutter"){
				$timeout(function() {
					try {
						var showMenu = $location.search().showMenu
						if(showMenu){
							document.getElementById('tab-menu').click()
							$location.search('showMenu', null); 
						}
					} catch (error) {
						console.log(error)
					}
				}, 500)
			}
		}

		if ($rootScope.active_school && $rootScope.app_base_ready) {
			baseService.app_initialized();
		}

		
	}
})();

(function() {
	'use strict';

	angular.module('modules.post.likes',[]).factory('pmService', ['base', function (base)	{
		return _.create(base, { });
	}]).directive('postLikes', postLikes);

	/** @ngInject */
	function postLikes($uibModal, $rootScope, toastr, regexes, pmService)	{
		var directive = {
			restrict: 'A',
			replace: true,
			link: linkFunction
		};
		return directive;

		function linkFunction(scope, elem, attrs)	{

			scope.$on('POST_LIKES', function(event,	object){
				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/groups/views/post-likes-modal.html',
					controller: function($scope){
						$scope.object = object;
						setTimeout(function() {
							angular.element(document.querySelector('.likes-modal'))
							.parent().parent().addClass('modal-likes-size');
						}, 1);

						$scope.openLiker = function(liker) {
							modalInstance.close();

							if($rootScope.active_user.id === liker.userId)
								location.href = '#/profile';
							else
								location.href = '#/classlist/details/' + liker.userId + '/contact';
						}

						$scope.close = function(){
							modalInstance.close();
						};
					}
				});

			});
		}
	}

})();

(function () {
	"use strict";

	angular
		.module("modules.announcements.view", [])
		.controller("announcementsViewController", announcementsViewController);

	/** @ngInject */
	function announcementsViewController(
		baseService,
		$scope,
		$stateParams,
		$uibModal,
		announcementsService,
		toastr,
		$translate,
		$state,
		$window,
		regexes,
		$sce,
		$rootScope
	) {
		baseService.app_initialized = function (evt, args) {
			var announcementId = $stateParams.id;
			var schoolId = $rootScope.active_school.id;
			$scope.redirectPages = $stateParams.redirectPages;
			$scope.user = $rootScope.active_user;
			$scope.posts = new Array();

			$scope.viewState = {
				isReady: true,
				isInitiated: true,
				sentToCount: 0,
				emailOpenedCount: 0,
				appOpenedCount: 0,
			};

			// Tabs: content / comments / insights
			$scope.activeTab = "content";
			$scope.setTab = function (tab) {
				if($scope.announcement.status !== 'DONE') return;

				$scope.activeTab = tab;
				if(tab === 'insights') {
					initializeInsightsData();
				}
			};

			// Meta information for insights / engagement UI
			$scope.postMeta = {
				views: 0,
				likeCount: 0,
				commentCount: 0,
				reactionTotal: 0,
				reactions: {
					LIKE: 0,
					THANK: 0,
					WAVE: 0,
					CELEBRATE: 0,
					LOVE: 0,
				},
			};

			// Insights data structure
			$scope.insightsData = {
				lastUpdated: null,
				reach: {
					recipients: {
						total: 0,
						registered: 0,
						invited: 0,
					},
					views: {
						total: 0,
						registered: 0,
						invited: 0,
					},
					viewPercentage: 0,
					groups: [],
				},
				engagement: {
					reactionList: [],
					reactions: {
						total: 0,
						LIKE: 0,
						THANK: 0,
						WAVE: 0,
						CELEBRATE: 0,
						LOVE: 0,
					},
					comments: {
						total: 0,
					},
				},
			};
			$scope.getPluralSuffix = function (count) {
				return count === 1 ? "" : "s";
			};
			$scope.totalTranslated = $translate.instant("VIEWED");
			$scope.hasComments = false;

			$scope.dismissSample = function () {
				$scope.announcement.sample = false;
			};
			$scope.tryCount = 1;
			function getAnnouncement() {
				$scope.viewState.isReady = false;

				announcementsService
					.get(
						"announcement/v1/school/" + schoolId + "/get/" + announcementId,
						{ xhr: true, cache: false }
					)
					.then(
						function (response) {
							$scope.announcement = response.data;
							$scope.posts = new Array();
							$scope.viewState.sentToCount = parseInt(response.data.totalSentCount || 0, 10);

							$scope.viewState.emailOpenedCount = parseInt(response.data.openInEmailCount || 0, 10);
							$scope.viewState.appOpenedCount = parseInt(response.data.openInAppCount || 0, 10);

							$scope.announcementPercentage = response.data.openPercentageCount;
							$scope.announcement.body = $rootScope.parseLinks(
								$scope.announcement.body
							);
							$scope.announcement.sentTo = $scope.announcement.sentTo
								? textToArray($scope.announcement.sentTo)
								: "";

							$scope.isStepOne = $scope.announcement.status === 'STEP1';
							if ($scope.announcement.post) {
								$scope.isLocked =
									$scope.announcement.post.payload.post.commentLocked;
								$scope.announcement.post.payload.post.isfull = true;
								$scope.posts.push($scope.announcement.post.payload.post);

								// Build post meta from post payload
								try {
									var post = $scope.announcement.post.payload.post;

									$scope.postMeta.likeCount = parseInt(post.likeCount || 0, 10);
									$scope.postMeta.commentCount = parseInt(
										post.commentCount || 0,
										10
									);
									$scope.hasComments = $scope.postMeta.commentCount > 0;

									$scope.postMeta.views = $scope.viewState.appOpenedCount + $scope.viewState.emailOpenedCount;

									var reactions = post.reactions || [];
									$scope.postMeta.reactionTotal = reactions.length || 0;

									reactions.forEach(function (r) {
										if ($scope.postMeta.reactions.hasOwnProperty(r.type)) {
											$scope.postMeta.reactions[r.type] =
												($scope.postMeta.reactions[r.type] || 0) + 1;
										}
									});
								} catch (e) {
									// fail silently – UI will just show zeros
								}
							}else if($scope.isStepOne && $scope.tryCount <= 3) {
								setTimeout(function() {
									getAnnouncement();
									$scope.tryCount += 1;
								}, $scope.tryCount * 1000);
							}

							$scope.isDraftOrScheduled =
								$scope.announcement.status === "DRAFT" ||
								$scope.announcement.status === "SCHEDULED";

							$scope.viewState.isReady = true;
						},
						function (error) {
							toastr.error($translate.instant("GENERIC_REQUEST_ERROR"));
							$scope.viewState.isReady = true;
						}
					);
			}

			$scope.openInfo = function (e, type) {
				if(!$scope.announcement.own) return;

				if (e) {
					e.stopImmediatePropagation();
					e.stopPropagation();
				}

				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: "backdrop-zindexed",
					windowClass: "info-modal-11-wrapper",
					templateUrl: "app/info_modals/info-modal-11.html",
					controller: function ($scope) {
						$scope.close = function () {
							modalInstance.close();
						};
					},
					size: "md",
				});
			};

			$scope.updateComments = function (post) {
				if (post && post.commentCount !== undefined) {
					$scope.postMeta.commentCount = parseInt(post.commentCount || 0, 10);
					$scope.hasComments = $scope.postMeta.commentCount > 0;
					$scope.insightsData.engagement.comments.total =
						$scope.postMeta.commentCount;

					// Update the post in the posts array
					if ($scope.posts && $scope.posts.length > 0) {
						var postIndex = $scope.posts.findIndex(function (p) {
							return p.id === post.id;
						});
						if (postIndex >= 0) {
							$scope.posts[postIndex] = post;
						}
					}
				}
			};

			$scope.isInsightLoaded = false;
			// Initialize insights data
			function initializeInsightsData() {
				if($scope.isInsightLoaded) return;
				announcementsService
					.get(
						"announcement/v1/school/" + schoolId + "/get/" + announcementId+'/insights',
						{ xhr: true, cache: false }
					)
					.then(
						function (response) {
							$scope.isInsightLoaded = true;
							$scope.insightsData.lastUpdated = response.data.lastUpdated;
							// Class data with participants
							$scope.insightsData.reach.groups = response.data.groupInsights;

							// Calculate totals from classes
							$scope.insightsData.reach.recipients.total = response.data.generalInsights.recipientCount;
							$scope.insightsData.reach.recipients.registered = response.data.generalInsights.recipientRegisteredMemberCount;
							$scope.insightsData.reach.recipients.invited = response.data.generalInsights.recipientNonMemberCount;
							//
							$scope.insightsData.reach.views.total = response.data.generalInsights.totalViews;
							$scope.insightsData.reach.views.registered = response.data.generalInsights.totalViewsByRegisteredMembers;
							$scope.insightsData.reach.views.invited = response.data.generalInsights.emailViewsByNonMembers ;//no app views for these members.

							$scope.insightsData.reach.groups.forEach(function (classItem) {
								classItem.recipientCount = classItem.recipientCount;
								classItem.viewCount = classItem.totalViews;
								classItem.memberViewsPercentage = $scope.getClassMemberViewsPercentage(classItem);
								classItem.invitedViewsPercentage = $scope.getClassInvitedViewsPercentage(classItem);
							});

							// Calculate view percentage
							if ($scope.insightsData.reach.recipients.total > 0) {
								$scope.insightsData.reach.viewPercentage = Math.round(
									($scope.insightsData.reach.views.total /
										$scope.insightsData.reach.recipients.total) *
										100
								);

								// Calculate views percentage for Members (registered views / total recipients)
								$scope.insightsData.reach.views.membersPercentage = Math.round(
									($scope.insightsData.reach.views.registered /
										$scope.insightsData.reach.recipients.total) *
										100
								);

								// Calculate views percentage for Invited (invited views / total recipients)
								$scope.insightsData.reach.views.invitedPercentage = Math.round(
									($scope.insightsData.reach.views.invited /
										$scope.insightsData.reach.recipients.total) *
										100
								);
							}


							if($scope.announcement.post && $scope.announcement.post.payload && $scope.announcement.post.payload.post && $scope.announcement.post.payload.post.reactions) {
								var reactions = $scope.announcement.post.payload.post.reactions;

								// Collect available reaction types
								var allTypes = ['LIKE', 'THANK', 'WAVE', 'CELEBRATE', 'LOVE'];
								// Build participants per reaction type
								var reactionList = allTypes.map(function(type) {
									// Find all reactions of this type
									var matchedReactions = reactions.filter(function(r) { return r.type === type; });
									return {
										type: type,
										participants: matchedReactions.map(function(r) { return r.user; })
									};
								});

								$scope.insightsData.engagement.reactionList = reactionList;

								// Engagement data matching the design
								$scope.insightsData.engagement.reactions.LIKE = $scope.getReactionCount('LIKE');
								$scope.insightsData.engagement.reactions.THANK = $scope.getReactionCount('THANK');
								$scope.insightsData.engagement.reactions.WAVE = $scope.getReactionCount('WAVE');
								$scope.insightsData.engagement.reactions.CELEBRATE = $scope.getReactionCount('CELEBRATE');
								$scope.insightsData.engagement.reactions.LOVE = $scope.getReactionCount('LOVE');
								$scope.insightsData.engagement.reactions.total =
									$scope.insightsData.engagement.reactions.LIKE +
									$scope.insightsData.engagement.reactions.THANK +
									$scope.insightsData.engagement.reactions.WAVE +
									$scope.insightsData.engagement.reactions.CELEBRATE +
									$scope.insightsData.engagement.reactions.LOVE;
							}

						},
						function (error) {
							toastr.error($translate.instant("GENERIC_REQUEST_ERROR"));
						}
					);
			}

			$scope.getReactionCount = function (type) {
				var reaction = $scope.insightsData.engagement.reactionList.find(function (r) {
					return r.type === type;
				});
				return reaction ? reaction.participants.length : 0;
			};

			// Calculate member views percentage
			$scope.getClassMemberViewsPercentage = function (classItem) {
				var recipientCount = classItem.recipientCount;
				if (recipientCount === 0) return 0;
				return Math.round((classItem.totalViewsByRegisteredMembers / recipientCount) * 100);
			};

			// Calculate invited views percentage
			$scope.getClassInvitedViewsPercentage = function (classItem) {
				var recipientCount = classItem.recipientCount;
				if (recipientCount === 0) return 0;
				return Math.round((classItem.emailViewsByNonMembers / recipientCount) * 100);
			};

			$scope.showParticipantsModal = function (participants) {
				// Make participants unique by 'id'
				if (participants && participants.length > 0) {
					var unique = {};
					participants = participants.filter(function(p) {
						if (!p.memberId) return true; // if no id, just keep it
						if (unique[p.memberId]) {
							return false;
						} else {
							unique[p.memberId] = true;
							return true;
						}
					});
				}

				if(participants.length === 0) return;

				var modalInstance = $uibModal.open({
					animation: true,
					templateUrl: "app/base/views/show-participants-modal.html",
					backdropClass: "backdrop-zindexed",
					size: "sm",
					controller: function ($scope) {
						$scope.participants = participants;
						$scope.eventContext = false;
						$scope.addDisabled = true;
						$scope.viewState = {
							isReady: true,
						};

						$scope.close = function () {
							modalInstance.close();
						};
					},
				});
			}
			// Open participants modal
			$scope.showParticipants = function (actionType, userType, groupId) {
				announcementsService
				.get(
					"announcement/v1/school/" + schoolId + "/get/" + announcementId+'/insights/'+actionType+'/'+userType+'/'+groupId,
					{ xhr: true, cache: false }
				)
				.then(
					function (response) 
					{
						var participants = response.data.items;
						$scope.showParticipantsModal(participants);
					},
				function (error) {
					toastr.error($translate.instant("GENERIC_REQUEST_ERROR"));
				});
				
			};
			// Navigate to comments tab
			$scope.goToComments = function () {
				$scope.setTab("comments");
			};

			getAnnouncement();

			function textToArray(arr) {
				if (arr instanceof Array) {
					return arr;
				}
				return arr.split(",");
			}

			$scope.back = function () {
				$window.history.back();
			};

			$scope.deleteAnnouncement = function () {
				var status = $scope.announcement.status;
				var modalInstance = $uibModal.open({
					animation: true,
					templateUrl: "app/announcements/views/delete-modal.html",
					backdropClass: "backdrop-zindexed",
					size: "md",
					controller: function ($scope) {
						$scope.status = status;
						$scope.confirm = function () {
							announcementsService
								.delete("announcement/v1/school/delete/" + announcementId, {})
								.then(
									function () {
										toastr.info($translate.instant("ANNOUNCEMENT_DELETED"));
										modalInstance.close();
										location.href = "/school/#/announcements/list";
									},
									function (error) {
										toastr.error($translate.instant("GENERIC_REQUEST_ERROR"));
									}
								);
						};

						$scope.close = function () {
							modalInstance.close();
						};
					},
				});
			};

			$scope.duplicateAnnouncement = function (announcement) {
				var modalInstance = $uibModal.open({
					animation: true,
					templateUrl: "app/announcements/views/duplicate-modal.html",
					backdropClass: "backdrop-zindexed",
					size: "md",
					controller: function ($scope) {
						$scope._announcement = angular.copy(announcement);
						$scope._announcement.subject = "Copy of " + announcement.subject;
						$scope._announcement.selectedGroups = [];
						if ($scope._announcement.sentToGroups) {
							try {
								for (var key in $scope._announcement.sentToGroups) {
									$scope._announcement.selectedGroups.push({
										id: key,
										field1: $scope._announcement.sentToGroups[key],
									});
								}
							} catch (error) {}
						}

						$scope.close = function () {
							modalInstance.close();
						};

						$scope.queryRecipients = function (string) {
							return announcementsService
								.get(
									"search/v1/group/announcement/" +
										schoolId +
										"/" +
										encodeURIComponent(string),
									{}
								)
								.then(
									function (response) {
										return response.data.items;
									},
									function (error) {}
								);
						};

						$scope.pickGroup = function (group) {
							$scope.push(group);
							$scope._announcement.group.id = "";
						};

						$scope.push = function (r) {
							var includes = _.includes(
								$scope._announcement.selectedGroups,
								_.find($scope._announcement.selectedGroups, { id: r.id })
							);
							if (!includes) {
								$scope._announcement.selectedGroups.push(r);
								return;
							} else {
								toastr.info($translate.instant("ADD_RECIPIENT_ALREADY_EXIST"));
							}
						};

						$scope.removeGroup = function (groupId) {
							_.remove($scope._announcement.selectedGroups, {
								id: groupId,
							});
						};

						$scope.confirm = function () {
							if (!$scope._announcement.subject) {
								$scope.subjectError = true;
								return;
							}
							if ($scope._announcement.selectedGroups.length === 0) {
								$scope.tierError = true;
								return;
							}

							var payload = {
								announcementId: $scope._announcement.id,
								subject: $scope._announcement.subject,
								groupList: [],
								schoolId: schoolId,
							};

							for (
								var i = 0;
								i < $scope._announcement.selectedGroups.length;
								i++
							) {
								payload.groupList.push(
									$scope._announcement.selectedGroups[i].id
								);
							}

							announcementsService
								.put(
									"announcement/v1/school/" + schoolId + "/duplicate",
									payload,
									{ xhr: true }
								)
								.then(
									function (response) {
										toastr.info($translate.instant("DUPLICATED_SUCCESSFULLY"));
										modalInstance.close();
										window.location.href =
											"/school/#/announcements/view/" + response.data.id;
									},
									function (error) {
										if (error.data.error.code == 400) {
											toastr.error($translate.instant("GROUPS_NO_MEMBERS"));
										} else {
											toastr.error($translate.instant("GENERIC_REQUEST_ERROR"));
										}
									}
								);
						};
					},
				});
			};

			$scope.lockComments = function () {
				var postId = $scope.announcement.post.payload.post.id;
				var isLocked = $scope.isLocked;

				var modalInstance = $uibModal.open({
					animation: true,
					templateUrl: "app/announcements/views/lock-comment-modal.html",
					backdropClass: "backdrop-zindexed",
					size: "md",
					controller: function ($scope) {
						$scope.isLocked = isLocked;
						$scope.confirm = function () {
							announcementsService
								.put("post/v1/update/" + postId + "/commentLock", {})
								.then(
									function () {
										if (isLocked) {
											toastr.info($translate.instant("COMMENT_UNLOCKED"));
										} else toastr.info($translate.instant("COMMENT_LOCKED"));

										$state.reload();
										modalInstance.close();
									},
									function (error) {
										toastr.error($translate.instant("GENERIC_REQUEST_ERROR"));
									}
								);

							modalInstance.close();
						};

						$scope.close = function () {
							modalInstance.close();
						};
					},
				});
			};

			$scope.onEditClicked = function (id) {
				var editId = id || announcementId;
				location.href = "/school/#/announcements/edit/" + editId;
			};
		};

		if ($rootScope.active_school && $rootScope.app_base_ready) {
			baseService.app_initialized();
		}
	}
})();

(function() {
	'use strict';

	angular.module('modules.announcements',[]).factory('announcementsService', ['base', function (base) {
		return _.create(base, { });
	}]).controller('announcementsController', announcementsController);

	/** @ngInject */
	function announcementsController(baseService ,$scope, $rootScope, $uibModal, announcementsService, toastr, $translate) {
	}

})();
(function() {
	'use strict';

	angular.module('modules.announcements.list',[]).controller('announcementsListController', announcementsListController);

	/** @ngInject */
	function announcementsListController(baseService, $scope, $uibModal, announcementsService, toastr, $translate, $rootScope, $stateParams) {

		$scope.sentAnnouncements = [];
		$scope.scheduledAnnouncements = [];
		$scope.draftAnnouncements = [];
		$scope.selectedTab = 'sent';
		$scope.showScheduleTab = window.location.href.includes('#scheduled')
		$scope.filter = {
			createdBy: '',
			createdByName: '',
			group: '',
			groupName: '',
		};
		$scope.dataCursor = {
			sent: '',
			scheduled: '',
			draft: ''
		}
		$scope.openInfo = function (e, type) {
			if (e) {
				e.stopImmediatePropagation();
				e.stopPropagation();
			}

			var modalInstance = $uibModal.open({
				animation: true,
				backdropClass: 'backdrop-zindexed',
				templateUrl: 'app/info_modals/info-modal-9.html',
				controller: function ($scope) {

					$scope.close = function () {
						modalInstance.close();
					};
				},
				size: 'sm'
			});
		}

		baseService.app_initialized = function(evt, args) {
			$scope.viewState = {
				isReady:true
			};

			var schoolId = $rootScope.active_school.id;

			function getAnnouncements(){
				$scope.viewState.isReady = false;
				announcementsService.get('announcement/v1/school/' + schoolId + '/list',{'xhr':true, 'cache':false}).then(function(response){
					if(response.data.items) {
						var announcements = response.data.items;
						$scope.sentAnnouncements = [];
						$scope.scheduledAnnouncements = [];
						$scope.draftAnnouncements = [];
						for(var i = 0; i < announcements.length; i++) {
							if(announcements[i].status === 'DRAFT') {
								$scope.draftAnnouncements.push(announcements[i]);
							} else if(announcements[i].status === 'SCHEDULED') {
								$scope.scheduledAnnouncements.push(announcements[i]);
							} else {
								$scope.sentAnnouncements.push(announcements[i]);
							}
						}
					}
					$scope.viewState.isReady = true;
					//console.log(announcements);
				},
				function(error){
					toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
					$scope.viewState.isReady = true;
				})
			}
			$scope.viewState.isReady = false;
			
			$scope.getAdvancedAnnouncements = function(status, resetList){
				var cursor = 'none';
				if(status === 'DONE' && $scope.dataCursor.sent){
					cursor = $scope.dataCursor.sent;
				}else if(status === 'SCHEDULED' && $scope.dataCursor.scheduled){
					cursor = $scope.dataCursor.scheduled;
				}else if(status === 'DRAFT' && $scope.dataCursor.draft){
					cursor = $scope.dataCursor.draft;
				}
				
				announcementsService.get('announcement/v1/school/' + schoolId + '/list/'+status+'/'+($scope.filter.createdBy ? $scope.filter.createdBy : '-1')+'/'+($scope.filter.group ? $scope.filter.group : '-1')+'/'+cursor,{'xhr':true, 'cache':false}).then(function(response){
					var data = response.status === 204 ? [] : response.data.payload.announcements;
					var cursor = response.status === 204 ? '' : response.data.payload.cursor;
					if(status === 'DRAFT') {
						Array.prototype.push.apply($scope.draftAnnouncements, data);
						$scope.dataCursor.draft = cursor;
					} else if(status === 'SCHEDULED') {
						if(resetList){
							$scope.scheduledAnnouncements = [];
						}
						Array.prototype.push.apply($scope.scheduledAnnouncements, data);
						$scope.dataCursor.scheduled = cursor;
					} else {
						if(resetList){
							$scope.sentAnnouncements = [];
						}
						Array.prototype.push.apply($scope.sentAnnouncements, data);
						$scope.dataCursor.sent = cursor;
					}
					
					$scope.viewState.isReady = true;
					//console.log(announcements);
				},
				function(error){
					toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
					$scope.viewState.isReady = true;
				})
			}

			$scope.editAnnouncement = function (id) {
				location.href = '/school/#/announcements/edit/' + id;
			}

			$scope.getTotalViews = function (announcement) {
				var inEmail = parseInt(announcement.openInEmailCount, 10) || 0;
				var inApp = parseInt(announcement.openInAppCount, 10) || 0;
				var total = inEmail + inApp;
				return total;
			}

			$scope.duplicateAnnouncement = function (announcement) {
				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/announcements/views/duplicate-modal.html',
					controller: function ($scope) {
						$scope._announcement = angular.copy(announcement);
						$scope._announcement.subject = "Copy of " + announcement.subject;
						$scope._announcement.selectedGroups = [];
						if($scope._announcement.sentToGroups){
							try {
								for (var key in $scope._announcement.sentToGroups) {
									$scope._announcement.selectedGroups.push({
										id: key,
										field1: $scope._announcement.sentToGroups[key]
									});
								}
							} catch (error) {
							}
						}
						$scope.close = function () {
							modalInstance.close();
						};

						$scope.queryRecipients = function (string) {
							return announcementsService.get('search/v1/group/announcement/'+schoolId+'/'+encodeURIComponent(string),{}).then(function (response) {
								// if user only has CLASS_REP right, can't send announcement to WHOLE SCHOOL - FMA-1362
								if(response.data.items && $rootScope.active_user && !$rootScope.adminHaveRoles('STAFF', 'AMBASSADOR', 'COMM_REP')){
									return response.data.items.filter(function(item) {
										return item.type !== "SCHOOL_GROUP";
									});
								}
								return response.data.items;
							}, function (error) {
							})
						}

						$scope.pickGroup = function (group) {
							$scope.push(group);
							$scope._announcement.group.id = '';
						}

						$scope.push = function (r) {
							var includes = _.includes($scope._announcement.selectedGroups, _.find($scope._announcement.selectedGroups, {'id':r.id}));
							if(!includes){
								$scope._announcement.selectedGroups.push(r);
								return;
							}else {
								toastr.info($translate.instant('ADD_RECIPIENT_ALREADY_EXIST'))
							}
						}

						$scope.removeGroup = function (groupId) {
							_.remove($scope._announcement.selectedGroups, {
								id: groupId
							});
						}

						$scope.confirm = function () {
							if(!$scope._announcement.subject) {
								$scope.subjectError = true;
								return;
							}
							if($scope._announcement.selectedGroups.length === 0) {
								$scope.tierError = true;
								return;
							}

							var payload = {
								announcementId: $scope._announcement.id,
								subject: $scope._announcement.subject,
								groupList: [],
								schoolId: schoolId
							}

							for (var i = 0; i < $scope._announcement.selectedGroups.length; i++) {
								payload.groupList.push($scope._announcement.selectedGroups[i].id);
							}

							announcementsService.put('announcement/v1/school/' + schoolId + '/duplicate', payload, {'xhr':true}).then(function(response) {
								toastr.info($translate.instant('DUPLICATED_SUCCESSFULLY'));
								modalInstance.close();
								window.location.href = '/school/#/announcements/view/' + response.data.id;
							},
							function(error) {
								if(error.data.error.code == 400) {
									toastr.error($translate.instant('GROUPS_NO_MEMBERS'));
								}
								else {
									toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
								}
							})
						};
					},
					size: 'md'
				});
			}
			$scope.removeAnnouncementFromList = function(id){
				for (var i = $scope.sentAnnouncements.length - 1; i >= 0; i--) {
					if ($scope.sentAnnouncements[i].id === id) {
						$scope.sentAnnouncements.splice(i, 1);
					}
				}
				for (var i = $scope.scheduledAnnouncements.length - 1; i >= 0; i--) {
					if ($scope.scheduledAnnouncements[i].id === id) {
						$scope.scheduledAnnouncements.splice(i, 1);
					}
				}
				for (var i = $scope.draftAnnouncements.length - 1; i >= 0; i--) {
					if ($scope.draftAnnouncements[i].id === id) {
						$scope.draftAnnouncements.splice(i, 1);
					}
				}
			}
			$scope.deleteAnnouncement = function (id, status) {
				var removeFunc = $scope.removeAnnouncementFromList;
				var modalInstance = $uibModal.open({
					animation: true,
					backdropClass: 'backdrop-zindexed',
					templateUrl: 'app/announcements/views/delete-modal.html',
					size: "md",
					controller: function ($scope) {
						$scope.status = status;
						$scope.confirm = function() {
							announcementsService.delete('announcement/v1/school/delete/' + id, {}).then(function() {
								toastr.info($translate.instant('ANNOUNCEMENT_DELETED'));
								modalInstance.close();
								removeFunc(id);
								
							},
							function(error) {
								toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
							});
						}

						$scope.close = function() {
							modalInstance.close();
						}
					},
				});
			}

			$scope.publishAnnouncement = function(id) {
				window.location.href = '/school/#/announcements/edit/' + id;
			}

			// getAnnouncements();
			$scope.getAdvancedAnnouncements('DONE');
			$scope.getAdvancedAnnouncements('SCHEDULED');
			$scope.getAdvancedAnnouncements('DRAFT');
		
			$scope.queryRecipients = function(string) {
				return announcementsService.get('search/v1/group/announcement/' + $rootScope.active_school.id + '/' + encodeURIComponent(string), {}).then(function(response) {
					return response.data.items;
				}, function(error) {})
			}
			
			$scope.createdByList = [];
			$scope.loadingCreatedByList = false;
			$scope.queryCreatedBys = function(string) {
				if($scope.loadingCreatedByList) {
					return [];
				}
				if($scope.createdByList.length > 0) {
					// Filter by string using includes
					if (string && string.trim().length > 0) {
						var lower = string.toLowerCase();
						var result = $scope.createdByList.filter(function(item) {
							return item.fullName && item.fullName.toLowerCase().includes(lower);
						});
						if(result.length == 0){
							result.push({id: -1})
						}
						return result;
					}
					return $scope.createdByList;
				}
				$scope.loadingCreatedByList = true;
				return announcementsService.get('announcement/v1/school/' + $rootScope.active_school.id + '/get/createdBy-list', {}).then(function(response) {
					$scope.createdByList = response.data && response.data.items ? response.data.items : [];
					if($scope.createdByList.length > 0) {
						$scope.createdByList.forEach(function(item) {
							item.fullName = item.firstName + ' ' + item.lastName + ($rootScope.currentUserId() == item.id ? ' (you)' : '');
						});
					}
					$scope.loadingCreatedByList = false;

					if (string && string.trim().length > 0) {
						var lower = string.toLowerCase();
						var result = $scope.createdByList.filter(function(item) {
							return item.fullName && item.fullName.toLowerCase().includes(lower);
						});
						if(result.length == 0){
							result.push({id: -1})
						}
						return result;
					}
					return $scope.createdByList;
				}, function(error) {
					$scope.loadingCreatedByList = false;
					return [];
				})
			}
			
			$scope.pickGroup = function(group) {
				$scope.filter.group = group.id;
				$scope.filter.groupName = group.field1;
			}
			$scope.pickCreatedBy = function(createdBy) {
				$scope.filter.createdBy = createdBy.id;
				$scope.filter.createdByName = createdBy.fullName;
			}
			$scope.filterEnabled = false;
			$scope.clearGroupFilter = function() {
				$scope.filter.group = '';
				$scope.filter.groupName = '';
			}
			$scope.clearCreatedByNameFilter = function() {
				$scope.filter.createdBy = '';
				$scope.filter.createdByName = '';
			}
			$scope.clearAnnouncementFilters = function(){
				$scope.clearGroupFilter();
				$scope.clearCreatedByNameFilter();
			}
			$scope.applyAnnouncementFilters = function(){
				if(!$scope.filterEnabled && !$scope.filter.createdBy && !$scope.filter.group){
					return;
				}
				$scope.filterEnabled = true;
				$scope.dataCursor.sent = '';
				$scope.dataCursor.scheduled = '';
				$scope.getAdvancedAnnouncements('DONE', true);
				$scope.getAdvancedAnnouncements('SCHEDULED', true);
				if(!$scope.filter.createdBy && !$scope.filter.group){
					$scope.filterEnabled = false;
				}
			}
		}
		if($rootScope.active_school && $rootScope.app_base_ready) {
			baseService.app_initialized();
		}
	}

})();

(function() {
	'use strict';

	angular.module('modules.announcements.edit',[]).controller('announcementsEditController', announcementsEditController);

	/** @ngInject */
	function announcementsEditController(baseService, $scope, $uibModal, announcementsService, toastr, $translate, $rootScope, $http, $stateParams,uploadService,storage) {

		$scope.popupStartDate = {};
		$scope.dateOptions = {
			showWeeks: false
		}

		$http.get('i8n/locale-metadata-en-GB.json?v=12').then(function (data) {
			$scope.eventTimes = data.data.metadata.eventTimes
		});

		$scope.summernoteOptions = {
			minHeight: 300,
			toolbar: [
				['style', ['style']],
				['font', ['bold', 'underline', 'clear']],
				['fontname', ['fontname']],
				['color', ['color']],
				['para', ['ul', 'ol', 'paragraph']],
				['insert', ['link', 'picture']],
				['table', ['table']],
				['view', ['fullscreen', 'codeview']],
			]
		}

		$scope.onSumernotePaste = function(e) {
            var bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text');
            e.preventDefault();
        
            var urlRegex = /(\b(https?:\/\/|www\.)\S+\b)/gi;
            var emailRegex = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/gi;

            var formattedText = bufferText.replace(urlRegex, function(url) {
                var href = url;
                if (url.indexOf('www.') === 0) {
                    href = 'https://' + url;
                }
                return '<a href="' + href + '" target="_blank">' + url + '</a>';
            });

            formattedText = formattedText.replace(emailRegex, function(email) {
                return '<a href="mailto:' + email + '" target="_blank">' + email + '</a>';
            });
            
            formattedText = formattedText.replace(/\n/g, "<br>");
        
            setTimeout(function() {
                document.execCommand('insertHTML', false, formattedText);
            }, 10);
        };

		$scope.eventStartDateOptions = {
			onTimeSelect: function (time) {
				if(!$scope.startDate) {
					$scope.startDate = new Date();
				}
				if ($scope.announcement.scheduledAt && time && time.indexOf(':') > -1) {
					var _time = time.split(':');
					$scope.announcement.scheduledAt.setHours(parseInt(_time[0]));
					$scope.announcement.scheduledAt.setMinutes(parseInt(_time[1]));
				}

				$scope.eventStartDateOptions.onDateSelect($scope.announcement.scheduledAt);
			},
			onDateSelect: function (date) {
				$scope.dateError = false;
				$scope.announcement.scheduledAt = $rootScope.getWithoutTimeZone(date);
			}
		}

		$scope.$watch('startDate', function (newValue, oldValue) {
			if (!newValue) {
				return;
			}

			if (!$scope.startTime) {
				$scope.startTime = '12:00';
			}

			if ($scope.startTime && $scope.startTime.indexOf(':') > -1) {
				newValue.setHours(parseInt($scope.startTime.split(':')[0]));
				newValue.setMinutes(parseInt($scope.startTime.split(':')[1]));
			}

			$scope.eventStartDateOptions.onDateSelect(newValue);
		});

		baseService.app_initialized = function(evt, args) {

			$scope.viewState = {
				isReady:true
            };
            var fileUploader;
            var schoolId = $rootScope.active_school.id;
            var announcementId = $stateParams.id;
            var userId = $rootScope.active_user.id;

            var requestBody = {
                attachmentList: [],
                body: '',
                subject: '',
				announcementId:  announcementId,
				schoolId: schoolId
            }
			$scope.redirectPages = $stateParams.redirectPages;

			$scope.back = function(redirectPages){
				$rootScope.evaluateBack(redirectPages);
			}

            $scope.addAttachment = function() {
				fileUploader.click();
			}

            var attachmentList = [];

            $scope.getNewFileName = function() {
				return $scope.fileName;
            }

            $scope.removeAttachment = function(id) {
				for (var i = 0; i < $scope.announcement.attachmentList.length; i++) {
					if($scope.announcement.attachmentList[i].id === id) {
						$scope.announcement.attachmentList.splice(i, 1);
					}
				}
            }

            $scope.save = function () {
				if ($scope.announcement.scheduled && !$scope.announcement.scheduledAt){
					$scope.dateError = true;
					return;
				}

				if ($scope.announcement.attachmentList){
					for (var j = 0; j < $scope.announcement.attachmentList.length; j++) {
						requestBody.attachmentList.push(
							$scope.announcement.attachmentList[j].id
						);
					}
				}
				requestBody.body = $scope.announcement.body;
				requestBody.subject = $scope.announcement.subject;

				if($scope.announcement.saveAsDraft) {
					requestBody.saveAsDraft = true;
				}

				if($scope.announcement.scheduled) {
					requestBody.scheduled = true;
					requestBody.scheduledAt = $scope.announcement.scheduledAt;
				}

				requestBody.groupList = [];
				for (var i = 0; i < $scope.announcement.selectedGroups.length; i++) {
					requestBody.groupList.push($scope.announcement.selectedGroups[i].id);
				}

				announcementsService.put('announcement/v1/school/' + schoolId + '/update',requestBody,{'xhr':true, 'cache':false})
				.then(function(response) {
					if(requestBody.saveAsDraft) {
						toastr.info($translate.instant('DRAFT_SAVED_SUCCESSFULLY'));
						window.location.href = '/school/#/announcements/view/' + announcementId;
					} else if(requestBody.scheduled) {
						toastr.info($translate.instant('SCHEDULED_SUCCESSFULLY'));
						window.location.href = '/school/#/announcements/view/' + announcementId;
					} else {
						toastr.info($translate.instant('EDITED_SUCCESSFULLY'));
						window.location.href = '/school/#/announcements/view/' + announcementId;
					}
					$scope.viewState.isReady = true;
				},
				function(error) {
					toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
					$scope.viewState.isReady = true;
				});
            }

            function dataURItoBlob(dataURI) {
				var byteString = atob(dataURI.split(',')[1]);
				var ab = new ArrayBuffer(byteString.length);
				var ia = new Uint8Array(ab);
				for (var i = 0; i < byteString.length; i++) {
				ia[i] = byteString.charCodeAt(i);
				}
				return new Blob([ab], { type: 'image/jpeg' });
			}

			fileUploader = document.getElementById('fileUploader');
			fileUploader.onchange = function() {
				$scope.isUploading = true;

				var file  = fileUploader.files[0],
					reader = new FileReader();

				if (file) {
					if (file.size > 20000000){ //20mb
						toastr.info($translate.instant("FILE_SIZE_TOO_BIG"));
						$scope.isUploading = false;
						return;
					}

					reader.readAsDataURL(file);
				}
				else {
					$scope.isUploading = false;
				}

				reader.addEventListener('load', function () {
					$scope.isUploading = true;

					uploadService.fileUpload(dataURItoBlob(reader.result),
						{
						headers: {
							'Content-Type': undefined,
							'ClasslistToken':storage.getToken() || '',
							'ClasslistCfg':angular.toJson({
								'type':'ANNOUNCEMENT'
							})
						}
						},
						file.name).then(function(response) {

						var attachmentObj = {
							'name': null,
							'id': null
						}
						attachmentObj.name = file.name
						attachmentObj.id = response.data

						$scope.announcement.attachmentList.push(attachmentObj);

						toastr.info($translate.instant('ATTACHED_SUCCESSFULLY'));
						$scope.isUploading = false;
						},
						function(error) {
						$scope.isUploading = false;

						if (error.status == -1){
							return;
						}

						if (error.status === 403 || error.status === 409) {
							toastr.error($translate.instant(error.data));
						}
						else {
							toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
						}

					});
				}, false);
			}

			function getAnnouncement() {
				$scope.viewState.isReady = false;

				announcementsService.get('announcement/v1/school/' + schoolId + '/get/' + announcementId,{'xhr':true, 'cache':false})
				.then(function(response) {
					$scope.announcement = response.data;
					if(!$scope.announcement.attachmentList){
						$scope.announcement.attachmentList = [];
					}
					$scope.announcement.selectedGroups = [];
					if($scope.announcement.sentToGroups){
						try {
							for (var key in $scope.announcement.sentToGroups) {
								$scope.announcement.selectedGroups.push({
									id: key,
									field1: $scope.announcement.sentToGroups[key]
								});
							}
						} catch (error) {
						}
					}


					if ($scope.announcement.status === 'SCHEDULED') {
						$scope.announcement.scheduled = true;
						$scope.startDate = $rootScope.getUTCDatetime($scope.announcement.scheduledOn);
						$scope.startTime = ($scope.startDate.getHours() < 10 ? '0' : '') + $scope.startDate.getHours() + ':' + ($scope.startDate.getMinutes() < 10 ? '0' : '') + $scope.startDate.getMinutes();
					}
					$scope.announcement.body = $rootScope.parseLinks($scope.announcement.body);
					// $scope.announcement.sentTo = $scope.announcement.sentTo ? textToArray($scope.announcement.sentTo) : '';
					$scope.isDraftOrScheduled = $scope.announcement.status === 'DRAFT' || $scope.announcement.status === 'SCHEDULED';
					$scope.viewState.isReady = true;
				},
				function(error) {
					toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
					$scope.viewState.isReady = true;
				});
			}
			getAnnouncement();
		}

		$scope.queryRecipients = function(string) {
			return announcementsService.get('search/v1/group/announcement/' + $rootScope.active_school.id + '/' + encodeURIComponent(string), {}).then(function(response) {
				// if user only has CLASS_REP right, can't send announcement to WHOLE SCHOOL - FMA-1362
				if(response.data.items && !$rootScope.adminHaveRoles('STAFF', 'AMBASSADOR', 'COMM_REP')){
					return response.data.items.filter(function(item) {
						return item.type !== "SCHOOL_GROUP";
					});
				}
				return response.data.items;
			}, function(error) {})
		}
		$scope.pickGroup = function(group) {
			push(group);
			$scope.announcement.group.id = '';
		}
		$scope.removeGroup = function(groupId) {
			_.remove($scope.announcement.selectedGroups, {
				id: groupId
			});
		}
		function push(r) {
			var includes = _.includes($scope.announcement.selectedGroups, _.find($scope.announcement.selectedGroups, { 'id': r.id }));
			if (!includes) {
				$scope.announcement.selectedGroups.push(r);
				return;
			} else {
				toastr.info($translate.instant('ADD_RECIPIENT_ALREADY_EXIST'))
			}
		}
		$scope.saveAsDraft = function() {
			$scope.announcement.saveAsDraft = true;
			$scope.save();
		}

		$scope.pickStartDate = function () {
			$scope.popupStartDate.opened = true;
		}
		// if user only has CLASS_REP right, can't send announcement to WHOLE SCHOOL - FMA-1362
		if (!$rootScope.adminHaveRoles('STAFF', 'AMBASSADOR', 'COMM_REP')) {
				
			$scope.isOnlyClassRep = true;
		}

		if($rootScope.active_school && $rootScope.app_base_ready) {
			baseService.app_initialized();
		}
	}

})();

(function() {
    'use strict';

    angular.module('modules.announcements.create', []).factory('announcementsService', ['base', function(base) {
        return _.create(base, {});
    }]).controller('announcementsCreateController', announcementsCreateController);

    /** @ngInject */
    function announcementsCreateController(baseService, $scope, $uibModal, announcementsService, toastr, $translate, $http, $timeout, regexes, $state, $stateParams, $rootScope, uploadService, storage) {
        var fileUploader;
        $scope.popupStartDate = {};
        $scope.isClicked = 0;
        $scope.isOnlyClassRep = false;
        $scope.dateOptions = {
            showWeeks: false
        }
        $http.get('i8n/locale-metadata-en-GB.json?v=12').then(function(data) {
            $scope.eventTimes = data.data.metadata.eventTimes
        });
        $scope.summernoteOptions = {
            minHeight: 300,
            toolbar: [
                ['style', ['style']],
                ['font', ['bold', 'underline', 'clear']],
                ['fontname', ['fontname']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['insert', ['link', 'picture']],
                ['table', ['table']],
                ['view', ['fullscreen', 'codeview']],
            ]
        }
        $scope.onSumernotePaste = function(e) {
            var bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text');
            e.preventDefault();
        
            var urlRegex = /(\b(https?:\/\/|www\.)\S+\b)/gi;
            var emailRegex = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/gi;

            var formattedText = bufferText.replace(urlRegex, function(url) {
                var href = url;
                if (url.indexOf('www.') === 0) {
                    href = 'https://' + url;
                }
                return '<a href="' + href + '" target="_blank">' + url + '</a>';
            });

            formattedText = formattedText.replace(emailRegex, function(email) {
                return '<a href="mailto:' + email + '" target="_blank">' + email + '</a>';
            });
            
            formattedText = formattedText.replace(/\n/g, "<br>");
        
            setTimeout(function() {
                document.execCommand('insertHTML', false, formattedText);
            }, 10);
        };

        $scope.onImageUpload = function(files) {

        }
        $scope.eventStartDateOptions = {
            onTimeSelect: function(time) {
                if (!$scope.startDate) {
                    $scope.startDate = new Date();
                }
                if ($scope.announcement.scheduledAt && time && time.indexOf(':') > -1) {
                    var _time = time.split(':');
                    $scope.announcement.scheduledAt.setHours(parseInt(_time[0]));
                    $scope.announcement.scheduledAt.setMinutes(parseInt(_time[1]));
                }
                $scope.eventStartDateOptions.onDateSelect($scope.announcement.scheduledAt);
            },
            onDateSelect: function(date) {
                $scope.dateError = false;
                $scope.announcement.scheduledAt = $rootScope.getWithoutTimeZone(date);
            }
        }
        $scope.$watch('startDate', function(newValue, oldValue) {
            if (!newValue) {
                return;
            }

            if (!$scope.startTime) {
                $scope.startTime = '12:00';
            }

            if ($scope.startTime && $scope.startTime.indexOf(':') > -1) {
                newValue.setHours(parseInt($scope.startTime.split(':')[0]));
                newValue.setMinutes(parseInt($scope.startTime.split(':')[1]));
            }

            $scope.eventStartDateOptions.onDateSelect(newValue);
        });
        $scope.showWhyScheduleModal = function () {
            var modalInstance = $uibModal.open({
                animation: true,
                scope: $scope,
                backdropClass: "backdrop-zindexed",
                templateUrl: "app/announcements/views/why-schedule-modal.html",
                size: "md",
                controller: function ($scope) {
                    $scope.close = function () {
                        modalInstance.close();
                    };
                },
            });
        }

        $scope.jumpback = false;
        // Init the beforeunlodpage on this page
        var onBeforeunload = $rootScope.$on("announcements.create", function (evt, args) {
            $scope.checkUnSavedChanges(args, false);
        });

        window.addEventListener('beforeunload', function (e) {
            if (!$scope.jumpback && $scope.checkAnyChangesForAnnouncement()) {
                e.preventDefault();
                e.returnValue = message;  // Eski tarayıcılar için gerekli
            }
        });
        $scope.checkAnyChangesForAnnouncement = function(){
            return  (document.getElementById("textEditArea") && document.getElementById("textEditArea").innerHTML.length > 0) ||
                    ($scope.announcement.subject && $scope.announcement.subject.length > 0) || 
                    ($scope.announcement.body && $scope.announcement.body.length > 0) || 
                    ($scope.announcement.attachmentList && $scope.announcement.attachmentList.length > 0) || 
                    ($scope.announcement.selectedGroups && $scope.announcement.selectedGroups.length > 0);
        }
        var changeJumBack = function(val){
            $scope.jumpback = val;
        }

        $scope.checkUnSavedChanges = function(args, isBackBtn) {
            var unsavedChanges = $scope.checkAnyChangesForAnnouncement();
                            
            if ($scope.jumpback)
                anychange = false;
            if (unsavedChanges) {
                var modalInstance = $uibModal.open({
                    animation: true,
                    scope: $scope,
                    backdropClass: "backdrop-zindexed",
                    templateUrl: "app/announcements/views/unsaved-changes-modal.html",
                    size: "md",
                    controller: function ($scope) {
                        $scope.leave = function () {
                            changeJumBack(true)
                            if(isBackBtn){
                                $rootScope.evaluateBack(args);
                                return;
                            }
                            onBeforeunload();
                            $state.go(args.toState.name, args.toParams);
                        };
                        $scope.stay = function () {
                            modalInstance.close();
                        };
                        $scope.saveDraftBtn = function () {
                            $scope.saveAsDraft();
                            modalInstance.close();
                        };
                    },
                });

                args.e.preventDefault();
            } else {
                if(isBackBtn){
                    $rootScope.evaluateBack(args);
                    return;
                }
                onBeforeunload();
            }
        }

        baseService.app_initialized = function(evt, args) {
            var schoolId = $rootScope.active_school.id,
                userId = $rootScope.active_user.id;
            $scope.showInfoBox = true;

            $timeout(function() {
                $scope.displaySummernote = true;
            }, 500);

            $scope.announcement = {
                group: {
                    id: ''
                },
                groupList: [],
                schoolId: schoolId,
                userId: userId,
                subject: '',
                body: '',
                selectedGroups: [],
                pendingRequest: false
            };
            $scope.addAttachment = function() {
                fileUploader.click();
            }
            var attachmentList = [];

            $scope.redirectPages = $stateParams.redirectPages;
            $scope.$watchGroup(['announcement.subject.length', 'announcement.body.length', 'announcement.selectedGroups.length'], function() {
                checkAnnouncements()
            });

            function checkAnnouncements() {
                if ($scope.announcement.subject.length !== 0 || $scope.announcement.selectedGroups.length !== 0 ||
                    $scope.announcement.body.length !== 0) {
                    $rootScope.isDirty = true;
                } else {
                    $rootScope.isDirty = false;
                }
            }

            $scope.back = function(redirectPages) {
                $scope.checkUnSavedChanges(redirectPages, true)
            }
            $scope.queryRecipients = function(string) {
                return announcementsService.get('search/v1/group/announcement/' + schoolId + '/' + encodeURIComponent(string), {}).then(function(response) {
                    // if user only has CLASS_REP right, can't send announcement to WHOLE SCHOOL - FMA-1362
                    if(response.data.items && !$rootScope.adminHaveRoles('STAFF', 'AMBASSADOR', 'COMM_REP')){
                        return response.data.items.filter(function(item) {
                            return item.type !== "SCHOOL_GROUP";
                        });
                    }
                    return response.data.items;
                }, function(error) {})
            }

            $scope.pickGroup = function(group) {
                push(group);
                $scope.announcement.group.id = '';
            }
            $scope.removeGroup = function(groupId) {
                _.remove($scope.announcement.selectedGroups, {
                    id: groupId
                });
            }
            $scope.getNewFileName = function() {
                return $scope.fileName;
            }
            $scope.removeAttachment = function(id) {
                for (var i = 0; i < $scope.fileName.length; i++) {
                    if ($scope.fileName[i].id === id) {
                        $scope.fileName.splice(i, 1);
                    }
                }
            }

            $scope.cancel = function() {
                $state.go('announcements.list');
            }

            $scope.dismissInfo = function() {
                $scope.showInfoBox = false;
            }


			// Suggest improvements for the announcement
			$scope.showSuggestionSection = false;
			$scope.suggestion = null;
			$scope.suggestionCounter = 0;
			$scope.suggestionLoading = false;

			$scope.showSuggestionPage = function (show) {
                if (show) {
                    $scope.suggestionCounter = 0;
                    $scope.suggestImprovements();
                }
                if(!show){
                    $scope.showSuggestionSection = false;
                }
			};
			$scope.suggestImprovements = function () {
				if (!$scope.isSuggestionVisible() || !$scope.isSuggestionEnabled()) {
					return;
				}
				if ($scope.suggestionCounter >= 3) {
					toastr.error("You have reached the maximum number of suggestions");
					return;
				}
				$scope.suggestionLoading = true;
				var requestBody = {
					body: $scope.announcement.body,
					subject: $scope.announcement.subject,
				};

                toastr.info("Please give us a moment");
				announcementsService
					.post(
						"announcement/v1/school/" + schoolId + "/get/ai/suggestion",
						requestBody,
						{ xhr: true }
					)
					.then(
						function (response) {
							$scope.suggestion = response.data;
							$scope.suggestionCounter++;
							$scope.suggestionLoading = false;
							$scope.showSuggestionSection = true;
						},
						function (error) {
							console.log(error);
							$scope.suggestionLoading = false;
							$toastr.error(
								"Error getting suggestions. Please try again later."
							);
						}
					);
			};
			$scope.isSuggestionVisible = function () {
                return $rootScope.active_school && $rootScope.active_school.aiAnnouncementEnabled === true;
			};
            $scope.isSuggestionEnabled = function () {
                return (
                    $scope.announcement.body.length > 0 &&
                    $scope.announcement.subject.length > 0 &&
                    $scope.announcement.selectedGroups.length > 0
                );
            }

			$scope.replaceAndEditWithSuggestion = function () {
				$scope.announcement.body = $scope.suggestion.suggestedBody;
				$scope.announcement.subject = $scope.suggestion.suggestedSubject;
				$scope.showSuggestionSection = false;
			};
            $scope.copyTextToClipboard = function (text) {
                if(!text) {
                    return;
                }
				copyToClipboard(text);
				toastr.success($translate.instant("TEXT_COPIED"));
			};

            $scope.save = function() {
                $scope.isClicked++;
                $rootScope.isDirty = false;
                if ($scope.announcement.pendingRequest) {
                    return;
                }

                if ($scope.announcement.scheduled && !$scope.announcement.scheduledAt) {
                    $scope.dateError = true;
                    return;
                }

                if ($scope.announcement.body.length > 0 && $scope.announcement.subject.length > 0 && $scope.announcement.selectedGroups.length > 0) {
                    $scope.announcement.pendingRequest = true;
                    var obj = angular.copy($scope.announcement);

                    for (var i = 0; i < obj.selectedGroups.length; i++) {
                        obj.groupList.push(obj.selectedGroups[i].id);
                    }

                    obj.attachmentList = [];
                    if ($scope.announcement.attachmentList) {
                        for (var j = 0; j < $scope.announcement.attachmentList.length; j++) {
                            obj.attachmentList.push($scope.announcement.attachmentList[j].id)
                        }
                    }

                    delete obj.group;
                    delete obj.attachmentName;
                    delete obj.selectedGroups;

                    announcementsService.post('announcement/v1/school/' + schoolId + '/create', obj, { 'xhr': true }).then(function(response) {
                            $scope.jumpback = true;
                            if (obj.saveAsDraft) {
                                toastr.info($translate.instant('DRAFT_SAVED_SUCCESSFULLY'));
                                window.location.href = '/school/#/announcements/view/' + response.data.id;
                            } else if (obj.scheduled) {
                                toastr.info($translate.instant('SCHEDULED_SUCCESSFULLY'));
                                window.location.href = '/school/#/announcements/list#scheduled';
                            } else {
                                toastr.info($translate.instant('PUBLISHED_SUCCESSFULLY'));
                                window.location.href = '/school/#/announcements/view/' + response.data.id;
                            }
                            clean();
                        },
                        function(error) {
                            $scope.jumpback = true;
                            $scope.announcement.pendingRequest = false;

                            if (error.data.error.code == 400) {
                                toastr.error($translate.instant('GROUPS_NO_MEMBERS'));
                            } else {
                                toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
                            }
                        })
                }
            }

            function clean() {
                $scope.announcement.subject = '';
                $scope.announcement.selectedGroups.length = 0;
                $scope.announcement.body = '';
                $rootScope.isDirty = false;
                document.getElementById("textEditArea").innerHTML = '';
            }

            function push(r) {
                var includes = _.includes($scope.announcement.selectedGroups, _.find($scope.announcement.selectedGroups, { 'id': r.id }));
                if (!includes) {
                    $scope.announcement.selectedGroups.push(r);
                    return;
                } else {
                    toastr.info($translate.instant('ADD_RECIPIENT_ALREADY_EXIST'))
                }
            }

            function dataURItoBlob(dataURI) {
                var byteString = atob(dataURI.split(',')[1]);
                var ab = new ArrayBuffer(byteString.length);
                var ia = new Uint8Array(ab);
                for (var i = 0; i < byteString.length; i++) {
                    ia[i] = byteString.charCodeAt(i);
                }
                return new Blob([ab], { type: 'image/jpeg' });
            }

            fileUploader = document.getElementById('fileUploader');
            fileUploader.onchange = function() {
                $scope.isUploading = true;

                var file = fileUploader.files[0],
                    reader = new FileReader();

                if (file) {
                    if (file.size > 20000000) { //20mb
                        toastr.info($translate.instant("FILE_SIZE_TOO_BIG"));
                        $scope.isUploading = false;
                        return;
                    }

                    reader.readAsDataURL(file);
                } else {
                    $scope.isUploading = false;
                }

                reader.addEventListener('load', function() {
                    $scope.isUploading = true;

                    uploadService.fileUpload(dataURItoBlob(reader.result), {
                            headers: {
                                'Content-Type': undefined,
                                'ClasslistToken': storage.getToken() || '',
                                'ClasslistCfg': angular.toJson({
                                    'type': 'ANNOUNCEMENT_ATTACHMENT'
                                })
                            }
                        },
                        file.name).then(function(response) {

                            var attachmentObj = {
                                'name': null,
                                'id': null
                            }
                            attachmentObj.name = file.name
                            attachmentObj.id = response.data
                            attachmentList.push(attachmentObj)

                            $scope.attachment = attachmentList;
                            $scope.attachmentFileName = attachmentList;
                            $scope.fileName = attachmentList;
                            $scope.announcement.attachmentList = attachmentList;

                            toastr.info($translate.instant('ATTACHED_SUCCESSFULLY'));
                            $scope.isUploading = false;
                        },
                        function(error) {
                            $scope.isUploading = false;

                            if (error.status == -1) {
                                return;
                            }

                            if (error.status === 403 || error.status === 409) {
                                toastr.error($translate.instant(error.data));
                            } else {
                                toastr.error($translate.instant('GENERIC_REQUEST_ERROR'));
                            }

                        });
                }, false);
            }

            $scope.saveAsDraft = function() {
                $scope.announcement.saveAsDraft = true;
                $scope.save();
            }

            $scope.pickStartDate = function() {
                $scope.popupStartDate.opened = true;
            }
            // if user only has CLASS_REP right, can't send announcement to WHOLE SCHOOL - FMA-1362
            if (!$rootScope.adminHaveRoles('STAFF', 'AMBASSADOR', 'COMM_REP')) {
                
                $scope.isOnlyClassRep = true;
            }
        }

        if ($rootScope.active_school && $rootScope.app_base_ready) {
            baseService.app_initialized();
        }
    }

})();
angular.module("CLSchool").run(["$templateCache", function($templateCache) {$templateCache.put("app/remove-members-group-modal.html","<div class=remove-members-groups ng-class=\"{\'not-ready\':!viewState.isReady}\"><div class=modal-header><h3 translate=REMOVE_MEMBERS_TITLE translate-values={name:user.name}></h3></div><div class=modal-body><p translate=REMOVE_MEMBERS_TEXT translate-values={name:user.name}></p><input type=search class=\"form-control input-lg\" placeholder=\"{{ \'START_TYPING_NAME_PHOLDER\' | translate }}\" ng-model=keyword> <button id=checkallBoxesForTest class=testing-only ng-click=checkAllBoxes()>check all</button><ul class=basket><li ng-repeat=\"member in group.groupMembers | filter: {combinedName:keyword}\"><div ng-click=\"member.checked=!member.checked\" ng-class=\"{selected: member.checked}\"><figure class=avatar><avatar source={{member.avatar}} name=\"{{ member.firstName + \' \' + member.lastName }}\" width=40 height=40></avatar></figure><strong>{{member.firstName}} {{member.lastName}}</strong> <input type=checkbox class=pull-right ng-checked=member.checked></div></li></ul></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary\" type=button ng-click=remove() ng-disabled=!getSelectedMembers()><span translate=REMOVE_BTN></span></button></div></div>");
$templateCache.put("app/dashboard/wrapper.html","<div class=\"content-logged dashboard\" style=padding-top:10px><div ui-view></div></div>");
$templateCache.put("app/info_modals/confirm-savechanges.html","<div style=\"padding: 15px\"><span ng-click=leave() class=dripicons-cross style=\"font-size: 20px;float: right\"></span><div class=modal-header style=margin-top:10px><h3 translate=LEAVE_HEADER_2></h3></div><div class=modal-body><div translate=LEAVE_TEXT_2></div></div><div class=modal-footer style=\"margin-top: 10px\"><button type=button class=\"btn btn-primary pull-right\" translate=LEAVE_BUTTON_REVIEW_CHANGES ng-click=review() style=\"margin-left: 10px\"><button type=button class=\"btn btn-ghost pull-right\" translate=LEAVE_BUTTON_LEAVE ng-click=leave() style=\"margin-left: 10px\"></div></div>");
$templateCache.put("app/info_modals/info-modal-1.html","<div class=\"assign-parent-admin info-modal\"><div class=modal-header><h3 translate=IM1_TITLE></h3></div><div class=modal-body><p><span translate=IM1_DESCR></span></p></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=OK_BTN></span></button></div></div>");
$templateCache.put("app/info_modals/info-modal-10.html","<div class=\"assign-parent-admin info-modal\"><div class=modal-header><h3 translate=ANNOUNCEMENT_TITLE></h3></div><div class=modal-body><div translate=DELETE_ANN_TEXT_1></div><br><div translate=DELETE_ANN_TEXT_2></div></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=OK_BTN></span></button></div></div>");
$templateCache.put("app/info_modals/info-modal-11.html","<div class=\"assign-parent-admin info-modal info-modal-11\" style=\"background: #ffffff; border-radius: 8px; position: relative\"><div class=modal-header style=\"position: relative;\n			padding: 20px 20px 16px 20px;\n			border-bottom: none\"><button type=button ng-click=close() style=\"position: absolute;\n				top: 20px;\n				right: 20px;\n				background: none;\n				border: none;\n				cursor: pointer;\n				padding: 0;\n				font-size: 24px;\n				color: #627293;\n				line-height: 1\"><svg width=24 height=27 viewBox=\"0 0 24 27\" fill=none xmlns=http://www.w3.org/2000/svg><path d=\"M20 4.491 4 22.458M20 22.458 4 4.49\" stroke=#627293 stroke-width=1.5 stroke-linecap=round stroke-linejoin=round /></svg></button><h3 translate=COMMENTING_INFO_TITLE style=\"font-size: 18px;\n				font-weight: 800;\n				color: #151515;\n				margin: 0;\n				padding-right: 30px;\n				padding-bottom: 10px\"></h3></div><div class=modal-body style=\"padding: 0 25px 20px 25px\"><p style=\"font-size: 13px;\n				font-weight: 600;\n				color: #151515;\n				margin: 0 0 12px 0;\n				line-height: 1.5;\n				padding-bottom: 5px\"><span translate=COMMENTING_INFO_TEXT_1></span></p><p style=\"font-size: 13px;\n				font-weight: 600;\n				color: #151515;\n				margin: 0 0 12px 0;\n				line-height: 1.5;\n				padding-bottom: 5px\"><span translate=COMMENTING_INFO_TEXT_2></span></p><p style=\"font-size: 13px;\n				font-weight: 600;\n				color: #151515;\n				margin: 0;\n				line-height: 1.5\"><span translate=COMMENTING_INFO_TEXT_3></span></p></div></div>");
$templateCache.put("app/info_modals/info-modal-12.html","<div style=\"padding: 15px\"><div class=modal-header><h3 translate=PUBLISH_ROTA></h3></div><div class=modal-body><div translate=RAFFLE_PUBLISH_MODAL></div></div><div class=modal-footer style=\"margin-top: 10px\"><button type=button class=\"btn btn-primary pull-right\" translate=PUBLISH_BTN ng-click=publish() style=\"margin-left: 10px\"><button type=button class=\"btn btn-ghost pull-right\" translate=BACK_BTN ng-click=close() style=\"margin-left: 10px\"></div></div>");
$templateCache.put("app/info_modals/info-modal-13.html","<div class=\"assign-parent-admin info-modal\"><div class=modal-header><h3>Raffle sharing</h3></div><div class=modal-body><p><span translate=RAFFLE_PUBLISH_MODAL2></span></p></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=OK_BTN></span></button></div></div>");
$templateCache.put("app/info_modals/info-modal-14.html","<div class=\"assign-parent-admin info-modal announcement-info-modal\"><div class=modal-header><h3 translate=DASHBOARD_ACCOUNT_REQUEST_MODAL_TITLE></h3></div><div class=modal-body><div style=\"font-weight: 700\" translate=DASHBOARD_ACCOUNT_REQUEST_MODAL_SUBJECT></div></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=OK_BTN></span></button></div></div>");
$templateCache.put("app/info_modals/info-modal-15.html","<div class=\"assign-parent-admin info-modal announcement-info-modal\"><div class=modal-header><h3 translate=DASHBOARD_ACCOUNT_REQUEST_NOT_ACTIVATED_MODAL_TITLE></h3></div><div class=modal-body><div style=\"font-weight: 700\" translate=DASHBOARD_ACCOUNT_REQUEST_NOT_ACTIVATED_MODAL_SUBJECT></div></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=OK_BTN></span></button></div></div>");
$templateCache.put("app/info_modals/info-modal-16.html","<div class=\"assign-parent-admin info-modal announcement-info-modal\"><div class=modal-header><h3 translate=UNASSIGNED_GROUP></h3></div><div class=modal-body><div style=\"font-weight: 700\" translate=UNASSIGNED_CLASS_REPS></div></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=OK_BTN></span></button></div></div>");
$templateCache.put("app/info_modals/info-modal-17.html","<div class=\"assign-parent-admin info-modal announcement-info-modal\" style=\"background-color: white\"><div class=modal-header><h3 translate=PUBLIC_GUEST_CHECKOUT_INFO_MODAL_TITLE></h3></div><div class=modal-body><div style=\"font-weight: 500\" translate=PUBLIC_GUEST_CHECKOUT_INFO_MODAL_DESC></div></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=OK_BTN></span></button></div></div>");
$templateCache.put("app/info_modals/info-modal-18.html","<div style=\"padding: 15px\"><div class=modal-header><h3 translate=DONATION_TOOLTIP_TITLE></h3></div><div class=modal-body><div translate=DONATION_GIFT_AID></div></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=GOTIT_BTN ng-click=close() style=\"margin-left: 10px\"></div></div>");
$templateCache.put("app/info_modals/info-modal-19.html","<div class=\"assign-parent-admin info-modal announcement-info-modal\"><div class=modal-header><h3 translate=MANAGE_PARENT_LIST_TITLE></h3></div><div class=modal-body><div style=\"font-weight: 700\" translate=MANAGE_PARENT_LIST_TITLE_DESCRIPTION></div></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=OK_BTN></span></button></div></div>");
$templateCache.put("app/info_modals/info-modal-2.html","<div class=\"assign-parent-admin info-modal\"><div class=modal-header><h3 translate=IM2_TITLE></h3></div><div class=modal-body><p><span translate=IM2_DESCR></span></p></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=OK_BTN></span></button></div></div>");
$templateCache.put("app/info_modals/info-modal-3.html","<div class=\"assign-parent-admin info-modal\"><div class=modal-header><h3 translate=IM3_TITLE></h3></div><div class=modal-body><p class=modal-info-lines><span translate=IM3_DESCR style=\"font-weight: 600\"></span></p></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=OK_BTN></span></button></div></div>");
$templateCache.put("app/info_modals/info-modal-4.html","<div class=\"assign-parent-admin info-modal\"><div class=modal-header><h3 translate=IM4_TITLE></h3></div><div class=modal-body><p><span translate=IM4_DESCR></span></p></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=OK_BTN></span></button></div></div>");
$templateCache.put("app/info_modals/info-modal-5.html","<div class=\"assign-parent-admin info-modal\"><div class=modal-header><h3 translate=IM5_TITLE style=\"font-weight: bold\"></h3></div><div class=modal-body><p><span translate=IM5_DESCR style=\"font-weight: 600\"></span></p></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=OK_BTN></span></button></div></div>");
$templateCache.put("app/info_modals/info-modal-6.html","<div class=\"assign-parent-admin info-modal\"><div class=modal-header><h3 translate=IM6_TITLE></h3></div><div class=modal-body><p><span translate=IM6_DESCR></span></p></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=OK_BTN></span></button></div></div>");
$templateCache.put("app/info_modals/info-modal-7.html","<div class=\"assign-parent-admin info-modal\"><div class=modal-header><h3 translate=PUBLIC_EVENT></h3></div><div class=modal-body><p><span translate=PUBLIC_EVENT_TOOLTIP></span></p></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=OK_BTN></span></button></div></div>");
$templateCache.put("app/info_modals/info-modal-8.html","<div class=\"assign-parent-admin info-modal\"><div class=modal-header><h3 translate=DONATION_TOOLTIP_TITLE></h3></div><div class=modal-body><div translate=DONATION_TOOLTIP_BODY></div></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=OK_BTN></span></button></div></div>");
$templateCache.put("app/info_modals/info-modal-9.html","<div class=\"assign-parent-admin info-modal announcement-info-modal\"><div class=modal-header><h3 translate=ANNOUNCEMENT_TITLE></h3></div><div class=modal-body><div style=\"font-weight: 700\" translate=ANNOUNCEMENTS_LIST_DESCRIPTION></div></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=OK_BTN></span></button></div></div>");
$templateCache.put("app/onboarding/wrapper.html","<div class=\"content-logged onboarding\"><div ui-view></div></div>");
$templateCache.put("app/schoolpage/wrapper.html","<div class=content-logged><div ui-view></div></div>");
$templateCache.put("app/announcements/views/announcement-create.html","<div class=\"page-view-header clearfix\"><div><a id=header-back-button class=page-view-header__back ng-click=back(redirectPages) style=\"float: left; margin-right: 10px; position: relative\"><span class=dripicons-arrow-thin-left></span></a><div class=page-view-header__text style=\"padding-left: 0\"><strong class=page-view-header__title translate=BACK_BTN></strong> <span class=pull-right style=\"font-size: 16px;\n					line-height: 48px;\n					max-width: 50%;\n					white-space: nowrap;\n					overflow: hidden;\n					text-overflow: ellipsis\" translate=SEND_ANNOUNCEMENT_TITLE></span></div></div></div><script type=text/ng-template id=selectionTemplate.html><a>\n	    <span ng-bind-html=\"match.model.field1 | uibTypeaheadHighlight:query\" ng-if=\"match.model.field1\"></span>\n	</a></script><div class=\"assign-parent-admin announcement-create\"><div ng-show=\"!suggestion || !showSuggestionSection\" style=\"padding: 20px; max-width: 700px; margin: auto\"><form novalidate name=sa><div class=form-group><div><p class=announcement-title translate=CREATE_ANNOUNCEMENT_HELP style=\"font-size:14px;font-weight: bold;margin-bottom:10px\"></p><div style=\"overflow: auto\"><!-- <label class=\"control-label announcement-to\" translate=\"TO_LABEL\" style=\"margin:10px 0 0 0;\"></label> --><div class=announcement-search><input id=announcement-group-id type=text ng-model=announcement.group.id placeholder=\"{{ (isOnlyClassRep ? \'CREATE_ANNOUNCEMENT_GROUP_HELP_FOR_CLASS_REP\' : \'CREATE_ANNOUNCEMENT_GROUP_HELP\') | translate }}\" uib-typeahead=\"r.field1 for r in queryRecipients($viewValue)\" typeahead-wait-ms=300 typeahead-min-length=2 typeahead-on-select=pickGroup($item) typeahead-template-url=selectionTemplate.html class=form-control ng-blur=\"announcement.group.id = \'\'\" autocomplete=off><div class=error-text-red ng-show=\"isClicked > 0 && announcement.selectedGroups.length === 0\"><span translate=ERR_START_TYPING_TIER></span></div></div></div><div><div class=announcement__selected-tiers><span ng-click=removeGroup(group.id) class=announcement__selected-tier ng-repeat=\"group in announcement.selectedGroups track by $index\">{{group.field1}} <a class=\"dripicons-cross announcement__remove-tier\"></a></span></div></div></div><div><div><div><input id=announcement-subject-id type=text placeholder=\"{{\'SUBJECT_PHOLDER\' | translate}}\" class=form-control ng-model=announcement.subject maxlength=50 autocomplete=off><div class=error-text-red ng-show=\"isClicked > 0 && !announcement.subject\"><span translate=ERR_SUBJECT></span></div></div></div></div></div><div style=\"height: 15px\"></div><div><div class=announcement__attachment-tier ng-show=getNewFileName() ng-repeat=\"f in fileName\" style=\"display: flex\"><span class=announcement__attachment-name style=\"margin: 0; word-break: break-all\">{{f.name}}</span> <span ng-click=removeAttachment(f.id)><a class=\"dripicons-cross announcement__remove-tier\"></a></span></div><div style=\"clear: both\"></div><div style=\"margin-top: 10px\"><a ng-click=addAttachment()>Add attachment</a></div></div><div style=\"height: 15px\"></div><div class=form-group style=\"visibility: visible\"><div><div ng-if=displaySummernote><summernote style=\"position: fixed\" config=summernoteOptions on-paste=onSumernotePaste(evt) editable=false on-image-upload=\"onImageUpload(files, editable)\" ng-model=announcement.body placeholder=\"Write announcement\"></summernote></div></div><div class=error-text-red ng-show=\"isClicked > 0 && !announcement.body\"><span translate=ERR_WRITE_ANNOUNCEMENT></span></div></div></form><!-- If it\'s a scheduled announcement we need to show this date form --><div class=schedule-suggest-wrapper><div class=schedule-sent><!-- If users click to the text, it will be checked --><div class=schedule-checkbox style=display:flex><input id=checkbox name=checkbox type=checkbox style=\"float: left\" ng-model=announcement.scheduled><div><label for=checkbox>Schedule send</label><br><a class=text-link ng-click=showWhyScheduleModal() style=margin-left:10px class=text-link><span style=\"text-decoration: underline\">Why schedule?</span><span style=\"vertical-align: middle\" class=\"icons dripicons-chevron-right\"></span></a></div></div><div class=\"schedule schedule-date-input {{ dateError ? \'invalid-input-label\' : \'\' }}\" ng-show=announcement.scheduled style=padding-top:10px><div class=is-relative style=\"width: 66%\"><input type=text class=ev-date-input uib-datepicker-popup=\"EEE, dd MMM yyyy\" ng-model=startDate show-button-bar=false is-open=popupStartDate.opened datepicker-options=dateOptions ng-required=true style=\"width: 100%\"> <span class=\"select-arrow date-picker-icon\"><button type=button class=\"btn btn-default\" ng-click=pickStartDate()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=is-relative style=\"width: 30%; margin-left: 3%; float: left\"><select ng-model=startTime ng-change=eventStartDateOptions.onTimeSelect(startTime) class=ev-time-input style=\"width: 100%\"><option ng-repeat=\"time in eventTimes\" value=\"{{ time.value }}\">{{ time.text }}</option></select><span class=\"dripicons-chevron-down select-arrow\"></span></div><div ng-if=dateError class=wrong-input translate=SCHEDULE_DATE_CANNOT_BE_NULL></div></div></div><!-- Suggest improvements button - schedule-sent\'in sağında --><div class=suggest-improvements-group ng-if=\"active_school && active_school.aiAnnouncementEnabled === true\"><button class=\"btn btn-suggest-improvements\" type=button ng-click=showSuggestionPage(true) ng-disabled=\"!isSuggestionEnabled() || suggestionLoading\" ng-style=\"{\n					\'background\': !isSuggestionEnabled() || suggestionLoading ? \'#dadada\' : \'#222\',\n					\'color\': \'#fff\',\n					\'padding\': \'0 28px\',\n					\'height\': \'44px\',\n					\'font-weight\': \'500\',\n					\'border-radius\': \'7px\',\n					\'border\': \'none\',\n					\'display\': \'inline-flex\',\n					\'align-items\': \'center\',\n					\'box-shadow\': \'none\'\n				}\"><span style=\"font-size:18px; margin-right:7px\">✨</span> Suggest improvements</button><div class=suggest-text-under>AI can help increase engagement</div></div></div><!-- flex wrapper end --><div class=\"modal-footer announcement-footer\" style=\"padding-top: 10px; padding-right: 0; max-width: 700px\"><div class=announcement-buttons-row><button ng-if=!announcement.scheduled id=cancel-button class=\"btn btn-default\" type=button ng-click=saveAsDraft() style=\"min-width:120px; height: 44px\"><span translate=SAVE_AS_DRAFT_BTN></span></button> <button ng-if=!announcement.scheduled ng-disabled=\"announcement.isAttachamentUploading || announcement.pendingRequest\" class=\"btn btn-primary\" type=button ng-click=save() style=\"background:#ff2350; border:none; min-width:100px; height: 44px\"><span translate=OK_ANNOUNCEMENT_BTN></span></button><!--- When users get scheduled the announcement ---> <button ng-if=announcement.scheduled ng-disabled=\"announcement.isAttachamentUploading || announcement.pendingRequest\" class=\"btn btn-primary\" type=button ng-click=save()><span translate=SCHEDULE_ANNOUNCEMENT_BTN></span></button><!--- When users get scheduled the announcement END ---></div></div></div><div ng-show=\"suggestion && showSuggestionSection\" style=\"padding: 20px 20px 20px 20px; max-width: 700px; margin: auto; background: #fff; border-radius: 12px; margin-top: 35px\"><div style=\"margin-bottom: 16px\"><div style=\"font-weight: 600\">Please check the AI suggestions</div><div style=\"font-size: 13px; color: #222\">This tool is designed to help boost your community engagement.</div></div><!-- Loading spinner --><div ng-if=suggestionLoading class=suggestion-loading><div class=suggestion-loading__spinner></div><span class=suggestion-loading__text>Getting AI suggestions...</span></div><!-- Suggested Subject --><div class=suggestion-block ng-if=!suggestionLoading><div class=suggestion-block__header><span class=suggestion-block__title>Suggested subject</span> <a ng-click=copyTextToClipboard(suggestion.suggestedSubject) class=suggestion-block__copy><img src=https://storage.googleapis.com/classlist-branding/app-assets/integration-copy.svg alt=Copy style=\"width: 16px; height: 16px; flex-shrink: 0\"></a></div><div class=suggestion-block__content>{{ suggestion.suggestedSubject }}</div><div class=suggestion-block__reason><span style=\"color:black; font-weight: 600\">AI Reasoning</span><br>{{ suggestion.whyThisSubjectIsBetter }}</div></div><!-- View original subject (block dışında, sol üstte) --><div class=suggestion-original-row ng-show=!suggestionLoading><a class=suggestion-original-row__toggle ng-click=\"showOriginalSubject = !showOriginalSubject\">{{ showOriginalSubject ? \'Hide original\' : \'View original\' }} <svg class=suggestion-original-row__arrow ng-class=\"{\'suggestion-original-row__arrow--up\': showOriginalSubject}\" width=14 height=14 viewBox=\"0 0 14 14\" fill=none xmlns=http://www.w3.org/2000/svg><path d=\"M2 5l5 5 5-5\" stroke=#222 stroke-width=1.8 stroke-linecap=round stroke-linejoin=round /></svg></a></div><div class=\"suggestion-block suggestion-block--original\" ng-if=\"!suggestionLoading && showOriginalSubject\" style=margin-top:-10px><div class=suggestion-block__header><span class=\"suggestion-block__title suggestion-block__title--original\">Original subject</span> <a ng-click=copyTextToClipboard(announcement.subject) class=suggestion-block__copy><img src=https://storage.googleapis.com/classlist-branding/app-assets/integration-copy.svg alt=Copy style=\"width: 16px; height: 16px; flex-shrink: 0\"></a></div><div class=suggestion-block__content>{{ announcement.subject }}</div></div><!-- Suggested Body --><div class=suggestion-block ng-if=!suggestionLoading><div class=suggestion-block__header><span class=suggestion-block__title>Suggested body</span> <a ng-click=copyTextToClipboard(suggestion.suggestedBody) class=suggestion-block__copy><img src=https://storage.googleapis.com/classlist-branding/app-assets/integration-copy.svg alt=Copy style=\"width: 16px; height: 16px; flex-shrink: 0\"></a></div><div class=suggestion-block__content ng-bind-html=suggestion.suggestedBody></div><div class=suggestion-block__reason><span style=\"color:black; font-weight: 600\">AI Reasoning</span><br>{{ suggestion.whyThisBodyIsBetter }}</div></div><!-- View original body (block dışında, sol üstte) --><div class=suggestion-original-row ng-show=!suggestionLoading><a class=suggestion-original-row__toggle ng-click=\"showOriginalBody = !showOriginalBody\">{{ showOriginalBody ? \'Hide original\' : \'View original\' }} <svg class=suggestion-original-row__arrow ng-class=\"{\'suggestion-original-row__arrow--up\': showOriginalBody}\" width=14 height=14 viewBox=\"0 0 14 14\" fill=none xmlns=http://www.w3.org/2000/svg><path d=\"M2 5l5 5 5-5\" stroke=#222 stroke-width=1.8 stroke-linecap=round stroke-linejoin=round /></svg></a></div><div class=\"suggestion-block suggestion-block--original\" ng-if=\"!suggestionLoading && showOriginalBody\" style=margin-top:-10px><div class=suggestion-block__header><span class=\"suggestion-block__title suggestion-block__title--original\">Original body</span> <a ng-click=copyTextToClipboard(announcement.body) class=suggestion-block__copy><img src=https://storage.googleapis.com/classlist-branding/app-assets/integration-copy.svg alt=Copy style=\"width: 16px; height: 16px; flex-shrink: 0\"></a></div><div class=suggestion-block__content ng-bind-html=announcement.body></div></div><!-- AI generated info warning message (between suggested content and buttons) --><div style=\"display: flex; align-items: center; background: #fff7d6; color: #8c6c05; border-radius: 6px; padding: 7px 14px; margin: 14px 0 18px 0; font-size: 12.7px; font-weight: 500; gap: 8px; min-height: 28px; box-shadow: 0 1px 3px rgba(246,201,69,0.08)\"><span style=\"display: flex; align-items: center; justify-content: center; width: 22px; height: 22px; min-width: 22px; min-height: 22px; background: #ffe082; border-radius: 50%\"><svg width=14 height=14 viewBox=\"0 0 20 20\" fill=none style=\"display:block; margin:auto\" xmlns=http://www.w3.org/2000/svg><circle cx=10 cy=10 r=9 stroke=#FFB300 stroke-width=2 fill=#FFFDE7 /><path d=\"M10 6V11\" stroke=#FFB300 stroke-width=1.7 stroke-linecap=round /><circle cx=10 cy=14 r=1 fill=#FFB300 /></svg> </span><span style=color:#676767>This version was AI-optimised for engagement. Carefully review and refine the content before publishing.</span></div><!-- Buttons --><div class=suggestion-action-buttons><button class=\"btn btn-default suggestion-action-buttons__back\" type=button ng-disabled=suggestionLoading ng-click=showSuggestionPage(false)>Back</button><div class=suggestion-action-buttons__right><button class=\"btn btn-default suggestion-action-buttons__another\" type=button ng-click=suggestImprovements() ng-disabled=\"suggestionLoading || suggestionCounter >= 3\">Try a different suggestion <span>({{3 - suggestionCounter}} left)</span></button> <button class=\"btn btn-primary suggestion-action-buttons__replace\" type=button ng-click=replaceAndEditWithSuggestion() ng-disabled=suggestionLoading>Replace &amp; Edit</button></div></div></div><input type=file id=fileUploader></div>");
$templateCache.put("app/announcements/views/announcement-details-modal.html","<div><div class=modal-body><h3>{{::announcement.subject}}</h3><br><p class=multiple-line-text ng-bind-html=::announcement.body></p></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=OK_BTN></span></button></div></div>");
$templateCache.put("app/announcements/views/announcement-edit.html","<div class=\"page-view-header clearfix\"><div><a id=header-back-button class=page-view-header__back ng-click=back(redirectPages) style=\"float: left; margin-right: 10px; position: relative\"><span class=dripicons-arrow-thin-left></span></a><div class=page-view-header__text style=\"padding-left: 0\"><strong class=page-view-header__title translate=BACK_BTN></strong> <span class=pull-right style=\"font-size: 16px;\n					line-height: 48px;\n					max-width: 50%;\n					white-space: nowrap;\n					overflow: hidden;\n					text-overflow: ellipsis\" translate=EDIT_ANNOUNCEMENT_TITLE></span></div></div></div><script type=text/ng-template id=selectionTemplate.html><a>\n		<span ng-bind-html=\"match.model.field1 | uibTypeaheadHighlight:query\" ng-if=\"match.model.field1\"></span>\n	</a></script><div class=\"assign-parent-admin announcement-create\"><div style=\"padding: 20px; max-width: 700px; margin: auto\"><form novalidate name=sa><div class=form-group><div ng-if=\"announcement.status && announcement.status !== \'DRAFT\'\"><p class=announcement-title translate=SEND_ANNOUNCEMENT_HELP style=margin-bottom:10px></p></div><div ng-if=\"announcement.status && announcement.status !== \'DRAFT\'\"><strong class=page-view-header__title><span translate=ANNOUNCEMENTS_RECIPIENTS></span>:</strong><div class=announcement-sent-to ng-repeat=\"a in announcement.sentTo\"><p></p><figure class=announcement-avatar><span class=dripicons-user-group></span></figure>{{a}}<p></p></div></div><div ng-if=\"announcement.status === \'DRAFT\'\"><p class=announcement-title translate=CREATE_ANNOUNCEMENT_HELP style=\"font-size:14px;font-weight: bold;margin-bottom:10px\"></p><div style=\"overflow: auto\"><!-- <label class=\"control-label announcement-to\" translate=\"TO_LABEL\" style=\"margin:10px 0 0 0;\"></label> --><div class=announcement-search><input id=announcement-group-id type=text ng-model=announcement.group.id placeholder=\"{{ (isOnlyClassRep ? \'CREATE_ANNOUNCEMENT_GROUP_HELP_FOR_CLASS_REP\' : \'CREATE_ANNOUNCEMENT_GROUP_HELP\') | translate }}\" uib-typeahead=\"r.field1 for r in queryRecipients($viewValue)\" typeahead-wait-ms=300 typeahead-min-length=2 typeahead-on-select=pickGroup($item) typeahead-template-url=selectionTemplate.html class=form-control ng-blur=\"announcement.group.id = \'\'\" autocomplete=off><div class=error-text-red ng-show=\"isClicked > 0 && announcement.selectedGroups.length === 0\"><span translate=ERR_START_TYPING_TIER></span></div></div></div><div><div class=announcement__selected-tiers><span ng-click=removeGroup(group.id) class=announcement__selected-tier ng-repeat=\"group in announcement.selectedGroups track by $index\">{{group.field1}} <a class=\"dripicons-cross announcement__remove-tier\"></a></span></div></div></div><br><div><div><div><input id=announcement-subject-id type=text placeholder=\"{{\'SUBJECT_PHOLDER\' | translate}}\" class=form-control ng-model=announcement.subject maxlength=50 autocomplete=off><div class=error-text-red ng-show=\"isClicked > 0 && !announcement.subject\"><span translate=ERR_SUBJECT></span></div></div></div></div></div><div style=\"height: 15px\"></div><div><!-- <div class=\"announcement__attachment\"  ng-repeat=\"f in fileName\">\n					<span class=\"announcement__attachment-name\" style=\"margin: 0; word-break: break-all;\">{{f.name}}</span>\n					<button class=\"btn btn-default\" ng-click=\"removeAttachment(f.id)\"><span class=\"dripicons-cross\" style=\"font-size: 20px;\"></span></button>\n                </div> --><div class=home-files-list style=\"padding: 0; margin: 0\"><div ng-if=\"announcement.attachmentList && announcement.attachmentList.length > 0\"><div ng-repeat=\"att in announcement.attachmentList track by $index\" style=\"display: flex; border-bottom: none\"><span class=announcement__attachment-tier style=\"margin: 0; word-break: break-all; display: flex\"><p class=cut-text-max>{{ att.name }}</p><p style=\"margin-left: auto !important\" ng-click=removeAttachment(att.id)><a class=\"dripicons-cross announcement__remove-tier\"></a></p></span></div></div></div><div style=\"clear: both\"></div><div style=\"margin-top: 10px\"><a ng-click=addAttachment()>Add attachment</a></div></div><div style=\"height: 15px\"></div><div class=form-group><div><div><summernote config=summernoteOptions on-paste=onSumernotePaste(evt) editable=false on-image-upload=\"onImageUpload(files, editable)\" ng-model=announcement.body placeholder=\"Write announcement\"></summernote></div></div><div class=error-text-red ng-show=\"isClicked > 0 && !announcement.body\"><span translate=ERR_WRITE_ANNOUNCEMENT></span></div></div></form><div class=schedule-sent ng-show=isDraftOrScheduled><!-- If users click to the text, it will be checked --><div class=schedule-checkbox><input id=checkbox name=checkbox type=checkbox style=\"float: left\" ng-model=announcement.scheduled><label for=checkbox>Schedule send</label></div><div class=\"schedule schedule-date-input {{ dateError ? \'invalid-input-label\' : \'\' }}\" ng-show=announcement.scheduled><div class=is-relative style=\"width: 66%\"><input type=text class=ev-date-input uib-datepicker-popup=\"EEE, dd MMM yyyy\" ng-model=startDate show-button-bar=false is-open=popupStartDate.opened datepicker-options=dateOptions ng-required=true style=\"width: 100%\"> <span class=\"select-arrow date-picker-icon\"><button type=button class=\"btn btn-default\" ng-click=pickStartDate()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=is-relative style=\"width: 30%; margin-left: 3%; float: left\"><select ng-model=startTime ng-change=eventStartDateOptions.onTimeSelect(startTime) class=ev-time-input style=\"width: 100%\"><option ng-repeat=\"time in eventTimes\" value=\"{{ time.value }}\">{{ time.text }}</option></select><span class=\"dripicons-chevron-down select-arrow\"></span></div><div ng-if=dateError class=wrong-input translate=SCHEDULE_DATE_CANNOT_BE_NULL></div></div></div><div class=\"modal-footer announcement-footer\" style=\"padding-top: 0; padding-right: 0; max-width: 700px\"><div class=announcement-buttons><button id=cancel-button class=\"btn btn-default\" type=button ng-click=back(redirectPages)><span translate=CANCEL_BTN></span></button> <button ng-if=\"!announcement.scheduled && isDraftOrScheduled\" id=cancel-button class=\"btn btn-default\" type=button ng-click=saveAsDraft()><span translate=UPDATE_AS_DRAFT_BTN></span></button> <button ng-if=\"!announcement.scheduled && isDraftOrScheduled\" ng-disabled=\"announcement.isAttachamentUploading || announcement.pendingRequest\" class=\"btn btn-primary\" type=button ng-click=\"save(); isClicked = isClicked + 1\" ng-init=\"isClicked = 0\"><span translate=OK_ANNOUNCEMENT_BTN></span></button> <button ng-if=\"!announcement.scheduled && !isDraftOrScheduled\" ng-disabled=\"announcement.isAttachamentUploading || announcement.pendingRequest\" class=\"btn btn-primary\" type=button ng-click=\"save(); isClicked = isClicked + 1\" ng-init=\"isClicked = 0\"><span translate=SAVE_CHANGES></span></button><!--- When users get scheduled the announcement ---> <button ng-if=announcement.scheduled ng-disabled=\"announcement.isAttachamentUploading || announcement.pendingRequest\" class=\"btn btn-primary\" type=button ng-click=\"save(); isClicked = isClicked + 1\" ng-init=\"isClicked = 0\"><span translate=SCHEDULE_ANNOUNCEMENT_BTN></span></button><!--- When users get scheduled the announcement END ---></div></div></div><input type=file id=fileUploader></div>");
$templateCache.put("app/announcements/views/announcement-list.html","<section class=announcements ng-class=\"{\'is-visible\': viewState.isReady}\"><div class=page-view-header><div><strong class=page-view-header__title translate=ANNOUNCEMENTS_TITLE></strong> <span ng-click=openInfo() class=\"icon dripicons-information\"></span> <a id=announcements-list-create-button type=button class=\"btn btn-primary page-view-header__button\" href=#/announcements/create><span translate=CREATE_BTN></span></a></div></div><div style=\"padding-left:15px; padding-top:15px\"><span translate=ANNOUNCEMENT_PAGE_INFO></span></div><!-- New Announcement Draft & Scheduled --><div style=\"margin-top: -25px\"><div class=warpper><input class=radio id=one name=group type=radio checked ng-click=\"selectedTab=\'sent\'\"> <input class=radio id=two name=group type=radio ng-checked=showScheduleTab ng-click=\"selectedTab=\'scheduled\'\"> <input class=radio id=three name=group type=radio ng-click=\"selectedTab=\'draft\'\"><div class=tabs style=\"border-bottom: 1px solid #b6c2db; padding-left:15px\"><label class=tab id=one-tab for=one>Sent</label><label class=tab id=two-tab for=two>Scheduled</label><label class=tab id=three-tab for=three>My drafts</label></div><!-- Filter Bar Start --><div ng-if=\"selectedTab !== \'draft\'\" class=\"announcement-filter-bar responsive-filter-bar\"><div ng-if=\"adminHaveRoles(\'STAFF\', \'AMBASSADOR\')\" class=filter-bar-left><label style=\"font-size: 14px; color: #627293; margin-left: 10px; font-family: \'Nunito Sans\', NunitoSans, sans-serif; font-weight: 600\">From</label><script type=text/ng-template id=createdByNameSelectionTemplate.html><a class=\"created-by-name-selection\" ng-style=\"{\'height\': match.model.id !== -1 ? \'60px\' : \'auto\', \'text-align\': match.model.id === -1 ? \'center\' : \'left\'}\">\n							\n							<span style=\"display: inline-flex; align-items: center; gap: 10px; padding-left:10px; padding-top:9px; padding-right:10px\" ng-if=\"match.model.id !== -1\">\n								<figure class=\"comment-item-avatar special-avatar\" style=\"width: 15px; height: 15px; display: flex; align-items: center; justify-content: center; margin: 0;\">\n									<avatar source=\"{{ match.model.avatar }}\" name=\"{{ match.model.fullName }}\" width=\"15\" height=\"15\" my=\"false\"></avatar>\n								</figure>\n								<span \n									ng-bind-html=\"match.model.fullName | uibTypeaheadHighlight:query\"\n									ng-if=\"match.model.fullName\">\n								</span>\n							</span>\n							<span ng-if=\"match.model.id === -1\" style=\"margin-left:-10px\">Sorry, no results found</span>\n						</a></script><div class=announcement-advanced-filter-search style=\"position: relative; display: flex; align-items: center;width: 22%\"><input id=announcement-group-id type=text ng-model=filter.createdByName placeholder=\"Type an admin’s name\" uib-typeahead=\"r.fullName for r in queryCreatedBys($viewValue)\" typeahead-wait-ms=300 typeahead-min-length=2 typeahead-on-select=pickCreatedBy($item) typeahead-template-url=createdByNameSelectionTemplate.html class=form-control autocomplete=off style=\"padding-right:30px !important;height: 32px; background-color: white; border: 1px solid #b6c2db;  padding: 0 10px; font-size: 14px; color: #627293; font-family: \'Nunito Sans\', NunitoSans, sans-serif; font-weight: 600\"> <span ng-if=filter.createdBy ng-click=clearCreatedByNameFilter() style=\"padding-top:5px;position: absolute; right: 8px; cursor: pointer; color: #627293; font-size: 16px; font-family: \'Nunito Sans\', NunitoSans, sans-serif; font-weight: 600\" aria-label=Clear><svg width=20 height=20 viewBox=\"0 0 20 20\" fill=none xmlns=http://www.w3.org/2000/svg><path d=\"M16.665 3.333 3.332 16.667M16.665 16.667 3.332 3.333\" stroke=#627293 stroke-width=1.5 stroke-linecap=round stroke-linejoin=round /></svg></span></div></div><div class=filter-bar-right><label style=\"font-size: 14px; color: #627293; margin-left: 16px; font-family: \'Nunito Sans\', NunitoSans, sans-serif; font-weight: 600\">To</label><script type=text/ng-template id=groupSelectionTemplate.html><a>\n						<span ng-bind-html=\"match.model.field1 | uibTypeaheadHighlight:query\" ng-if=\"match.model.field1\"></span>\n					</a></script><div class=announcement-advanced-filter-search style=\"position: relative; display: flex; align-items: center;width: 22%\"><input id=announcement-group-id type=text ng-model=filter.groupName placeholder=\"Type a group or class\" uib-typeahead=\"r.field1 for r in queryRecipients($viewValue)\" typeahead-wait-ms=300 typeahead-min-length=2 typeahead-on-select=pickGroup($item) typeahead-template-url=groupSelectionTemplate.html class=form-control autocomplete=off style=\"padding-right:30px !important;height: 32px; background-color: white; border: 1px solid #b6c2db;  padding: 0 10px; font-size: 14px; color: #627293; font-family: \'Nunito Sans\', NunitoSans, sans-serif; font-weight: 600\"> <span ng-if=filter.group ng-click=clearGroupFilter() style=\"padding-top:5px;position: absolute; right: 8px; cursor: pointer; color: #627293; font-size: 16px; font-family: \'Nunito Sans\', NunitoSans, sans-serif; font-weight: 600\" aria-label=Clear><svg width=20 height=20 viewBox=\"0 0 20 20\" fill=none xmlns=http://www.w3.org/2000/svg><path d=\"M16.665 3.333 3.332 16.667M16.665 16.667 3.332 3.333\" stroke=#627293 stroke-width=1.5 stroke-linecap=round stroke-linejoin=round /></svg></span></div></div><div class=clear-filter-btn><button class=\"btn btn-default\" ng-class=\"(filterEnabled || filter.createdBy || filter.group) ? \'filter-btn-active\' : \'filter-btn-inactive\'\" ng-click=applyAnnouncementFilters()>Filter</button> <a href=\"\" style=\"font-size: 14px; color: #627293; margin-left: 12px;  font-family: \'Nunito Sans\', NunitoSans, sans-serif; font-weight: 600\" ng-click=clearAnnouncementFilters()>Clear filters</a></div></div><!-- Filter Bar End --><div class=panels><!-- Sent Panel --><div class=panel-tab id=one-panel><div ng-if=\"sentAnnouncements.length == 0\" class=\"row no-announcements\"><div class=col-md-6><p ng-if=\"!filterEnabled && !filter.createdBy && !filter.group\" translate=NO_ANNOUNCEMENTS_TEXT></p><p ng-if=\"filterEnabled || filter.createdBy || filter.group\" translate=NO_ANNOUNCEMENTS_FILTER_TEXT style=\"width: 100%\"></p></div></div><div class=panel-content ng-repeat=\"a in sentAnnouncements | orderBy: \'-sendOn\'\"><!-- 3 dots menu dropdown--><nav ng-if=\"a.own || (active_user.role == \'AMBASSADOR\' || active_user.role == \'STAFF\')\" class=\"has-dropdown is-relative pull-right mobile-menu\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><circle fill=#8A94A2 cx=8 cy=32 r=6></circle><circle data-color=color-2 fill=#8A94A2 cx=32 cy=32 r=6></circle><circle fill=#8A94A2 cx=56 cy=32 r=6></circle></g></svg><ul class=dropdown-menu style=\"top: 7px; right: 24px; min-width: 120px\"><li ng-class=\"{ \'disabled-container\': !a.own }\"><a ng-click=editAnnouncement(a.id)><span translate=EDIT_BTN></span></a></li><li><a ng-click=duplicateAnnouncement(a)><span translate=DUPLICATE_BTN></span></a></li><li style=\"border-top: 1px solid #E1E1E1\"><a ng-click=\"deleteAnnouncement(a.id, a.status)\"><span translate=DELETE_BTN></span></a></li></ul></nav><div ng-if=\"a.duplicatedFrom !== \'0\'\" class=duplicated-label>Duplicated</div><h1 ui-sref=\"announcements.view({\'id\':a.id})\">{{ a.subject }}</h1><p ui-sref=\"announcements.view({\'id\':a.id})\">{{ a.body }}</p><div class=announcement-info style=\"display: flex; align-items: center; gap: 8px\"><span class=who-sent>{{ a.sentByFirstName }} {{ a.sentByLastName }}</span> <span class=dot style=margin-top:-2px>&#183;</span> <span class=date>{{a.sentOn | date:\'MMM dd, yyyy\'}} {{a.sentOn | date:\'h:mm a\' }}</span><!-- <span class=\"dot\" style=\"margin-top:-2px\">&#183;</span> --><!-- <span class=\"who-sent\">{{ getTotalViews(a) }} views</span> --></div></div><div ng-if=\"dataCursor.sent && dataCursor.sent.length > 0\" style=\"margin-top: 6px; text-align: center; background: #fff; padding: 10px; font-size: 22px; font-weight: 600; color: #001031\" ng-if=\"cursor.length > 1 && !searching\"><a ng-click=\"getAdvancedAnnouncements(\'DONE\')\" class=\"link ng-scope\" style=\"font-weight: normal; text-align: center; font-size: 15px; width: 100%\">Load more</a></div></div><!-- Scheduled Panel --><div class=panel-tab id=two-panel><div ng-if=\"scheduledAnnouncements.length == 0\" class=\"row no-announcements\"><div class=col-md-6><p ng-if=\"!filterEnabled && !filter.createdBy && !filter.group\" translate=NO_ANNOUNCEMENTS_TEXT_SCHEDULED></p><p ng-if=\"filterEnabled || filter.createdBy || filter.group\" translate=NO_ANNOUNCEMENTS_FILTER_TEXT style=\"width: 100%\"></p></div></div><div class=panel-content ng-repeat=\"a in scheduledAnnouncements | orderBy: \'-sendOn\'\"><!-- 3 dots menu dropdown--><nav ng-if=a.own class=\"has-dropdown is-relative pull-right mobile-menu\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><circle fill=#8A94A2 cx=8 cy=32 r=6></circle><circle data-color=color-2 fill=#8A94A2 cx=32 cy=32 r=6></circle><circle fill=#8A94A2 cx=56 cy=32 r=6></circle></g></svg><ul class=dropdown-menu style=\"top: 7px; right: 24px\"><li><a ng-click=editAnnouncement(a.id)><span translate=EDIT_BTN></span></a></li><li><a ng-click=duplicateAnnouncement(a)><span translate=DUPLICATE_BTN></span></a></li><li style=\"border-top: 1px solid #E1E1E1\"><a ng-click=\"deleteAnnouncement(a.id, a.status)\"><span translate=DELETE_BTN></span></a></li></ul></nav><!-- 3 dots menu dropdown for other users--><nav ng-if=\"!a.own && (active_user.role == \'AMBASSADOR\' || active_user.role == \'STAFF\')\" class=\"has-dropdown is-relative pull-right mobile-menu\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><circle fill=#8A94A2 cx=8 cy=32 r=6></circle><circle data-color=color-2 fill=#8A94A2 cx=32 cy=32 r=6></circle><circle fill=#8A94A2 cx=56 cy=32 r=6></circle></g></svg><ul class=dropdown-menu style=\"top: 7px; right: 24px\"><li style=\"background-color: white !important\"><a><span translate=EDIT_BTN style=color:#838383></span></a></li><li><a ng-click=duplicateAnnouncement(a)><span translate=DUPLICATE_BTN></span></a></li><li style=\"background-color: white !important;border-top: 1px solid #E1E1E1\"><a><span translate=DELETE_BTN style=color:#838383></span></a></li></ul></nav><div ng-if=\"a.duplicatedFrom !== \'0\'\" class=duplicated-label>Duplicated</div><h1 ui-sref=\"announcements.view({\'id\':a.id})\">{{ a.subject }}</h1><p ui-sref=\"announcements.view({\'id\':a.id})\">{{ a.body }}</p><div class=announcement-info><span class=who-sent>{{ a.sentByFirstName }} {{ a.sentByLastName }}</span> <span class=dot>&#183;</span><!--<span class=\"draft\">Scheduled for Mon, 24 May 2021</span>--> <span class=draft>Scheduled for {{a.scheduledOn | date:\'MMM dd, yyyy\' : \'GMT\'}} {{a.scheduledOn | date:\'h:mm a\' : \'GMT\' }}</span></div></div><div ng-if=\"dataCursor.scheduled && dataCursor.scheduled.length > 0\" style=\"margin-top: 6px; text-align: center; background: #fff; padding: 10px; font-size: 22px; font-weight: 600; color: #001031\" ng-if=\"cursor.length > 1 && !searching\"><a ng-click=\"getAdvancedAnnouncements(\'SCHEDULED\')\" class=\"link ng-scope\" style=\"font-weight: normal; text-align: center; font-size: 15px; width: 100%\">Load more</a></div></div><!-- Draft Panel --><div class=panel-tab id=three-panel><div ng-if=\"draftAnnouncements.length == 0\" class=\"row no-announcements\"><div class=col-md-6><p translate=NO_ANNOUNCEMENTS_TEXT_DRAFT></p></div></div><div class=panel-content ng-repeat=\"a in draftAnnouncements | orderBy: \'-sendOn\'\"><!-- 3 dots menu dropdown--><nav class=\"has-dropdown is-relative pull-right mobile-menu\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><circle fill=#8A94A2 cx=8 cy=32 r=6></circle><circle data-color=color-2 fill=#8A94A2 cx=32 cy=32 r=6></circle><circle fill=#8A94A2 cx=56 cy=32 r=6></circle></g></svg><ul class=dropdown-menu style=\"top: 7px; right: 24px\"><li><a ng-click=editAnnouncement(a.id)><span translate=EDIT_BTN></span></a></li><li><a ng-click=duplicateAnnouncement(a)><span translate=DUPLICATE_BTN></span></a></li><li><a ng-click=publishAnnouncement(a.id)><span translate=PUBLISH_BTN></span></a></li><li style=\"border-top: 1px solid #E1E1E1\"><a ng-click=\"deleteAnnouncement(a.id, a.status)\"><span translate=DELETE_BTN></span></a></li></ul></nav><div ng-if=\"a.duplicatedFrom !== \'0\'\" class=duplicated-label>Duplicated</div><h1 ui-sref=\"announcements.view({\'id\':a.id})\">{{ a.subject }}</h1><p ui-sref=\"announcements.view({\'id\':a.id})\">{{ a.body }}</p><div class=announcement-info><span class=who-sent>{{ a.sentByFirstName }} {{ a.sentByLastName }}</span> <span class=dot>&#183;</span> <span class=draft>Draft</span></div></div><div ng-if=\"dataCursor.draft && dataCursor.draft.length > 0\" style=\"margin-top: 6px; text-align: center; background: #fff; padding: 10px; font-size: 22px; font-weight: 600; color: #001031\" ng-if=\"cursor.length > 1 && !searching\"><a ng-click=\"getAdvancedAnnouncements(\'DRAFT\')\" class=\"link ng-scope\" style=\"font-weight: normal; text-align: center; font-size: 15px; width: 100%\">Load more</a></div></div></div></div><!-- New Announcement Draft & Scheduled END --></div></section><!-- Current Codes for Announcement List --><!-- <div class=\"page-container-header-from-top\">\n	<section class=\"announcements\" ng-class=\"{\'is-visible\':viewState.isReady}\">\n		<section class=\"announcements\" ng-class=\"{\'is-visible\':viewState.isReady}\">\n			<div ng-if=\"announcements.length == 0\" class=\"row no-announcements\">\n				<div class=\"col-md-6\">\n					<img src=\"assets/icons/no-announcements.svg\" alt=\"\" />\n				</div>\n				<div class=\"col-md-6\">\n					<p translate=\"NO_ANNOUNCEMENTS_TEXT_1\"></p>\n					<p translate=\"NO_ANNOUNCEMENTS_TEXT_2\"></p>\n				</div>\n			</div>\n		</section>\n		<div class=\"row announcements__row\" ng-repeat=\"a in announcements | orderBy: \'-sendOn\'\" ui-sref=\"announcements.view({\'id\':a.id})\" style=\"margin: 0;\">\n			<div class=\"col-sm-4 announcements__cell\">\n				<strong class=\"announcements__subject\">{{ a.subject }}</strong><a class=\"visible-sm visible-md visible-lg\"></a>\n			</div>\n			<div class=\"col-sm-4 announcements__cell send-to-cell-div\">\n				<span class=\"send-to-cell\">{{ a.sentByFirstName }} {{ a.sentByLastName }}</span>\n			</div>\n			<div class=\"col-sm-4 announcements__cell send-to-cell-div\">\n				<span class=\"announcements__date\">{{a.sentOn | date:\'MMM dd, yyyy\'}} {{a.sentOn | date:\'h:mm a\' }}</span>\n				<a class=\"visible-xs announcements__link\"></a>\n			</div>\n		</div>\n	</section>\n</div> --> <!-- Announcement List END -->");
$templateCache.put("app/announcements/views/announcement-view.html","<section class=announcement-view add-participants ng-class=\"{\'is-visible\':viewState.isReady}\"><div class=\"page-view-header clearfix announcement-view__header\"><div><a id=header-back-button class=page-view-header__back ng-click=back() style=\"float: left; margin-right: 10px; position: relative\"><span class=dripicons-arrow-thin-left></span></a><div class=\"page-view-header__text announcement-view__header-text\" style=\"padding-left: 0\"><strong class=page-view-header__title style=\"padding-top: 5px\" translate=BACK_BTN></strong> <span class=announcement-view__subject>{{::announcement.subject}}</span></div></div></div><!-- Top tabs (Content / Comments / Insights) --><div class=announcement-view-tabs><button type=button class=announcement-view-tabs__tab ng-class=\"{\'announcement-view-tabs__tab--active\': activeTab === \'content\'}\" ng-click=\"setTab(\'content\')\">Content</button> <button type=button class=announcement-view-tabs__tab ng-class=\"{\'announcement-view-tabs__tab--active\': activeTab === \'comments\'}\" ng-click=\"setTab(\'comments\')\" ng-if=\"announcement.status === \'DONE\'\">Comments<span ng-if=isLocked> (off)</span></button> <button type=button class=announcement-view-tabs__tab ng-class=\"{\'announcement-view-tabs__tab--active\': activeTab === \'insights\'}\" ng-click=\"setTab(\'insights\')\" ng-if=\"announcement.status === \'DONE\'\">Insights</button></div><!-- Mobile engagement row --><div class=announcement-view-metrics-mobile ng-if=\"!isDraftOrScheduled && postMeta && activeTab === \'content\'\"><!-- <div\n			class=\"announcement-view-metrics-mobile__item\"\n			ng-click=\"setTab(\'insights\')\"\n		>\n			<span class=\"announcement-view-metrics-mobile__icon\">\n				<svg\n					width=\"24\"\n					height=\"24\"\n					viewBox=\"0 0 24 24\"\n					fill=\"none\"\n					xmlns=\"http://www.w3.org/2000/svg\"\n				>\n					<path\n						d=\"M2.339 13.075a1.877 1.877 0 0 1 0-2.15C3.769 8.9 7.289 4.726 12 4.726c4.71 0 8.231 4.173 9.661 6.197a1.877 1.877 0 0 1 0 2.152c-1.43 2.024-4.95 6.197-9.661 6.197-4.71 0-8.231-4.173-9.661-6.197z\"\n						stroke=\"#627293\"\n						stroke-width=\"1.5\"\n						stroke-miterlimit=\"10\"\n						stroke-linecap=\"square\"\n					/>\n					<path\n						d=\"M12.004 15.636a3.637 3.637 0 1 0 0-7.273 3.637 3.637 0 0 0 0 7.274z\"\n						stroke=\"#627293\"\n						stroke-width=\"1.5\"\n						stroke-miterlimit=\"10\"\n						stroke-linecap=\"square\"\n					/>\n				</svg>\n			</span>\n			<span class=\"announcement-view-metrics-mobile__value\"\n				>{{postMeta.views}}</span\n			>\n		</div> --><!-- <div class=\"announcement-view-metrics-mobile__divider\"></div> --><div class=announcement-view-metrics-mobile__item ng-click=\"setTab(\'insights\')\"><span class=announcement-view-metrics-mobile__icon><svg width=24 height=24 viewBox=\"0 0 24 24\" fill=none xmlns=http://www.w3.org/2000/svg><path d=\"M7.241 22.5H3V11.896h4.241\" stroke=#627293 stroke-width=1.5 stroke-miterlimit=10 /><path d=\"M7.242 11.897 10.07 2h.707a2.12 2.12 0 0 1 2.12 2.12v7.07h6.362a2.12 2.12 0 0 1 2.121 2.12v.707l-1.254 6.749a2.12 2.12 0 0 1-2.082 1.734H7.242V11.897z\" stroke=#627293 stroke-width=1.5 stroke-miterlimit=10 stroke-linecap=square /></svg> </span><span class=announcement-view-metrics-mobile__value>{{postMeta.likeCount}}</span></div><div class=announcement-view-metrics-mobile__divider></div><div class=\"announcement-view-metrics-mobile__item announcement-view-metrics-mobile__item--comments\" ng-click=\"setTab(\'comments\')\"><span class=announcement-view-metrics-mobile__icon><svg width=24 height=24 viewBox=\"0 0 24 24\" fill=none xmlns=http://www.w3.org/2000/svg><path clip-rule=evenodd d=\"M20.03 2.4H3.966c-.986 0-1.785.86-1.785 1.92v10.56c0 1.06.799 1.92 1.785 1.92h4.463l3.57 4.8 3.57-4.8h4.463c.986 0 1.785-.86 1.785-1.92V4.32c0-1.06-.8-1.92-1.785-1.92z\" stroke=#627293 stroke-width=1.5 stroke-linecap=round stroke-linejoin=round /></svg> </span><span class=announcement-view-metrics-mobile__value>{{postMeta.commentCount}}</span></div></div><!-- CONTENT TAB --><div class=announcement-view-layout ng-if=\"activeTab === \'content\'\"><div class=announcement-view-layout__main><!-- Scheduled Announcement Info --><div class=scheduled-info-box ng-if=\"announcement.status === \'SCHEDULED\' && announcement.own\"><div><span translate=SCHEDULED_ANNOUNCEMENT_INFO></span> <span>{{announcement.scheduledOn | date:\'MMM dd, yyyy\' : \'GMT\'}} {{announcement.scheduledOn | date:\'h:mm a\' : \'GMT\' }}</span></div></div><!-- Scheduled Draft Info --><div class=scheduled-info-box ng-if=\"announcement.status === \'DRAFT\'\"><div translate=SCHEDULED_DRAFT_INFO></div></div><post-asset ng-if=isDraftOrScheduled ng-repeat=\"p in posts\" post-content={{p}} post-context=HOME_VIEW class=enter user-avatar=user.avatar user-id=user.id user-role=user.role user-name=userName post-events=events is-comment-and-like-disabled=true></post-asset><div ng-if=\"!isDraftOrScheduled && posts.length > 0\"><aside class=group-posts><post-asset ng-repeat=\"p in posts\" post-content={{p}} post-context=ANNOUNCEMENT_DETAIL_VIEW class=enter user-avatar=user.avatar user-id=user.id user-role=user.role user-name=userName post-events=events is-comment-and-like-disabled=false is-comment-disabled=true on-edit-announcement=onEditClicked(announcement.id) on-delete-announcement=deleteAnnouncement() on-duplicate-announcement=duplicateAnnouncement(announcement)></post-asset></aside></div></div><!-- Right side column --><div class=announcement-view-layout__side><!-- Sent to card --><div class=ann-sent-to-wrapper><div class=ann-sent-to-header><span class=ann-sent-to-title>Sent to:</span></div><div class=ann-sent-to-body><div class=ann-sent-to-item ng-repeat=\"a in announcement.sentTo\"><div class=ann-sent-to-icon><svg width=24 height=24 viewBox=\"0 0 20 20\" fill=none xmlns=http://www.w3.org/2000/svg><circle cx=10 cy=10 r=10 fill=#005CB8 /><path d=\"m10.25 15.247-.144-.2c-.317-.437-.7-.55-1.399-.757-.367-.11-.823-.244-1.387-.462a2.304 2.304 0 0 1-1.415-1.577c-.224-.812-.063-1.783.393-2.413.666-.916.409-1.772.267-2.098a1.92 1.92 0 0 0-.09-.165c-.179-.307-.55-.945.052-1.391.355-.263.624-.162.935-.044.31.13.639.2.972.209.96.017 1.67-.88 1.676-.89l.142-.181.14.182c.007.008.718.909 1.676.889.334-.008.663-.079.972-.209.311-.117.58-.22.935.044.602.446.231 1.084.053 1.39a1.914 1.914 0 0 0-.09.166c-.142.326-.4 1.182.267 2.098.458.63.617 1.6.393 2.413a2.304 2.304 0 0 1-1.416 1.577 16.85 16.85 0 0 1-1.387.462c-.696.206-1.084.32-1.398.757l-.146.2z\" stroke=#fff stroke-width=.5 /></svg></div><span class=ann-sent-to-text>{{a}}</span></div></div></div><!-- Engagement card --><div class=ann-engagement-wrapper ng-if=\"!isDraftOrScheduled && postMeta\"><div class=ann-engagement-header><span class=ann-engagement-title>Engagement</span></div><div class=ann-engagement-body><!-- <div class=\"ann-engagement-row\">\n						<span class=\"ann-engagement-icon\">\n							<svg\n								width=\"24\"\n								height=\"24\"\n								viewBox=\"0 0 24 24\"\n								fill=\"none\"\n								xmlns=\"http://www.w3.org/2000/svg\"\n							>\n								<path\n									d=\"M2.339 13.075a1.877 1.877 0 0 1 0-2.15C3.769 8.9 7.289 4.726 12 4.726c4.71 0 8.231 4.173 9.661 6.197a1.877 1.877 0 0 1 0 2.152c-1.43 2.024-4.95 6.197-9.661 6.197-4.71 0-8.231-4.173-9.661-6.197z\"\n									stroke=\"#627293\"\n									stroke-width=\"1.5\"\n									stroke-miterlimit=\"10\"\n									stroke-linecap=\"square\"\n								/>\n								<path\n									d=\"M12.004 15.636a3.637 3.637 0 1 0 0-7.273 3.637 3.637 0 0 0 0 7.274z\"\n									stroke=\"#627293\"\n									stroke-width=\"1.5\"\n									stroke-miterlimit=\"10\"\n									stroke-linecap=\"square\"\n								/>\n							</svg>\n						</span>\n						<span class=\"ann-engagement-number\">{{postMeta.views}}</span>\n					</div> --><div class=ann-engagement-row><span class=ann-engagement-icon><svg width=24 height=24 viewBox=\"0 0 24 24\" fill=none xmlns=http://www.w3.org/2000/svg><path d=\"M7.241 22.5H3V11.896h4.241\" stroke=#627293 stroke-width=1.5 stroke-miterlimit=10 /><path d=\"M7.242 11.897 10.07 2h.707a2.12 2.12 0 0 1 2.12 2.12v7.07h6.362a2.12 2.12 0 0 1 2.121 2.12v.707l-1.254 6.749a2.12 2.12 0 0 1-2.082 1.734H7.242V11.897z\" stroke=#627293 stroke-width=1.5 stroke-miterlimit=10 stroke-linecap=square /></svg> </span><span class=ann-engagement-number>{{postMeta.likeCount}}</span></div><div class=\"ann-engagement-row ann-engagement-row-comments\" ng-click=\"setTab(\'comments\')\"><span class=ann-engagement-icon><svg width=24 height=24 viewBox=\"0 0 24 24\" fill=none xmlns=http://www.w3.org/2000/svg><path clip-rule=evenodd d=\"M20.03 2.4H3.966c-.986 0-1.785.86-1.785 1.92v10.56c0 1.06.799 1.92 1.785 1.92h4.463l3.57 4.8 3.57-4.8h4.463c.986 0 1.785-.86 1.785-1.92V4.32c0-1.06-.8-1.92-1.785-1.92z\" stroke=#627293 stroke-width=1.5 stroke-linecap=round stroke-linejoin=round /></svg> </span><span class=ann-engagement-number ng-class=\"{\'ann-engagement-number-comments\': announcement.status === \'DONE\'}\">{{postMeta.commentCount}}</span></div></div></div><!-- Actions card --><div class=\"announcement-view-card announcement-view-card--actions\"><div class=announcement-view-card__header><span class=announcement-view-card__title>Actions</span></div><div class=announcement-view-card__body><div class=announcement-view-action-row ng-class=\"{\'announcement-view-action-row--disabled\': !announcement.own}\" ng-click=\"announcement.own && onEditClicked()\"><span class=announcement-view-action-row__icon><svg width=24 height=24 viewBox=\"0 0 24 24\" fill=none xmlns=http://www.w3.org/2000/svg><path d=\"M9 5H2v17h17v-7\" stroke=#005CB8 stroke-width=1.5 stroke-linecap=square /><path d=\"m16 5 3 3\" stroke=#005CB8 stroke-width=1.5 /><path clip-rule=evenodd d=\"m11 16-4 1 1-4L19 2l3 3-11 11v0z\" stroke=#005CB8 stroke-width=1.5 stroke-linecap=square /></svg> </span><span class=announcement-view-action-row__link translate=EDIT_BTN></span></div><div class=announcement-view-action-row ng-click=duplicateAnnouncement(announcement)><span class=announcement-view-action-row__icon><svg width=24 height=24 viewBox=\"0 0 24 24\" fill=none xmlns=http://www.w3.org/2000/svg><path d=\"M9.125 20h-5.25a.863.863 0 0 1-.619-.264A.913.913 0 0 1 3 19.1V2.9c0-.239.092-.468.256-.636A.863.863 0 0 1 3.875 2h12.25c.232 0 .455.095.619.264A.913.913 0 0 1 17 2.9V10\" stroke=#005CB8 stroke-width=1.5 stroke-miterlimit=10 stroke-linecap=square /><path d=\"M21.09 10h-8.18a.916.916 0 0 0-.91.923v10.154c0 .51.407.923.91.923h8.18c.503 0 .91-.413.91-.923V10.923a.916.916 0 0 0-.91-.923z\" stroke=#005CB8 stroke-width=1.5 stroke-miterlimit=10 stroke-linecap=square /></svg> </span><span class=announcement-view-action-row__link translate=DUPLICATE_BTN></span> <span class=announcement-view-action-row__info-icon><svg width=22 height=22 viewBox=\"0 0 24 24\" fill=none xmlns=http://www.w3.org/2000/svg><circle cx=12 cy=12 r=9.25 stroke=#005CB8 stroke-width=1.5 /><path d=\"M12 11v5\" stroke=#005CB8 stroke-width=1.5 stroke-linecap=round /><path d=\"M12 8h.01\" stroke=#005CB8 stroke-width=1.5 stroke-linecap=round /></svg></span></div><div class=announcement-view-action-row ng-click=deleteAnnouncement() style=\"padding-top: 20px\"><span class=announcement-view-action-row__icon><svg width=24 height=24 viewBox=\"0 0 24 24\" fill=none xmlns=http://www.w3.org/2000/svg><path d=\"M17.795 9.72v8.811c0 .812-.657 1.469-1.468 1.469H7.515a1.469 1.469 0 0 1-1.468-1.469v-8.81M3.844 6.783h16.154M8.984 6.783V3.846h5.874v2.937M14.124 11.912 9.72 16.318M14.124 16.318 9.72 11.912\" stroke=#005CB8 stroke-width=1.5 stroke-linecap=round stroke-linejoin=round /></svg> </span><span class=announcement-view-action-row__link translate=DELETE_BTN></span></div></div></div></div></div><!-- COMMENTS TAB --><div class=\"announcement-view-layout announcement-view-layout--comments\" ng-if=\"activeTab === \'comments\'\"><div class=announcement-view-layout__comment-main><div class=announcement-comments-card><div class=announcement-comments-card__header><span ng-if=hasComments style=\"font-weight: 800; font-size: 13px\">Anybody who received the announcement can view and comment if commenting is turned on. </span><span ng-if=!hasComments style=\"font-size: 14px\">There are no comments.</span></div><div class=announcement-comments-card__body ng-if=\"posts.length > 0\"><aside class=group-posts><post-comments ng-repeat=\"p in posts\" post-content={{p}} post-context=HOME_VIEW class=enter user-avatar=user.avatar user-id=user.id user-role=user.role user-name=userName comment-only=true update-comments=updateComments(post)></post-comments></aside></div></div></div><div class=announcement-view-layout__comment-side><div class=\"announcement-view-card announcement-view-card--actions\"><div class=announcement-view-card__header><span class=announcement-view-card__title>Actions</span></div><div class=announcement-view-card__body><div class=announcement-view-comments-toggle><div class=announcement-view-comments-toggle__label><span class=announcement-view-comments-toggle__icon><svg width=24 height=24 viewBox=\"0 0 24 24\" fill=none xmlns=http://www.w3.org/2000/svg><path clip-rule=evenodd d=\"M20.03 2.4H3.966c-.986 0-1.785.86-1.785 1.92v10.56c0 1.06.799 1.92 1.785 1.92h4.463l3.57 4.8 3.57-4.8h4.463c.986 0 1.785-.86 1.785-1.92V4.32c0-1.06-.8-1.92-1.785-1.92z\" stroke=#005CB8 stroke-width=1.5 stroke-linecap=round stroke-linejoin=round /></svg> </span><span class=announcement-view-comments-toggle__text>Turn commenting on or off <button type=button class=announcement-view-comments-toggle__info ng-click=\"openInfo($event, \'comments\')\"><svg width=24 height=24 viewBox=\"0 0 24 24\" fill=none xmlns=http://www.w3.org/2000/svg><circle cx=9 cy=9 r=9 transform=\"matrix(1 0 0 -1 3 21)\" stroke=#627293 stroke-width=1.5 stroke-linecap=round stroke-linejoin=round /><path d=\"M12.001 16.545v-5.454\" stroke=#627293 stroke-width=1.5 stroke-linecap=round stroke-linejoin=round /><circle cx=.909 cy=.909 r=.909 transform=\"matrix(1 0 0 -1 11.094 8.364)\" fill=#627293 /></svg></button></span></div><label class=announcement-view-switch ng-class=\"{\'announcement-view-switch--disabled\': !announcement.own}\"><input type=checkbox ng-checked=!isLocked ng-disabled=!announcement.own ng-click=lockComments()> <span class=announcement-view-switch__slider ng-style=\"{\'background-color\': !announcement.own ? \'#B0B8C1\' : \'\'}\"></span></label></div></div></div></div></div><div class=sample-popup ng-if=announcement.sample style=\"top: 30%; left: 25%\"><span class=dripicons-cross ng-click=dismissSample()></span><div class=sample-padding><div class=sample-container><span translate=SAMPLE_ANN_DESCR_1></span></div><br><div class=sample-container-big><span translate=SAMPLE_ANN_DESCR_2></span></div><br><div class=sample-container><span translate=SAMPLE_ANN_DESCR_3></span></div><br><div class=sample-container><span translate=SAMPLE_ANN_DESCR_4></span></div></div><div class=arrow></div></div><!-- INSIGHTS TAB --><div class=\"announcement-view-layout announcement-view-layout--insights\" ng-if=\"activeTab === \'insights\' && !isDraftOrScheduled\"><div class=announcement-view-layout__main><!-- Combined Reach and Engagement Section --><div class=\"announcement-view-card announcement-view-card--insights\"><div class=announcement-view-card__header style=\"padding-top: 20px; padding-left: 20px\"><span class=announcement-view-card__title>Reach</span> <span class=announcement-view-card__subtitle ng-if=insightsData.lastUpdated style=\"float: right\">Updated: {{insightsData.lastUpdated | date:\'MMM dd, yyyy\' }} {{insightsData.lastUpdated | date:\'h:mm a\' }}</span></div><div class=announcement-view-card__body style=\"padding-bottom: 10%\"><div class=announcement-insights-reach><!-- Donut Chart --><div class=announcement-insights-reach__chart><percentage-graph-two-colors percentage={{insightsData.reach.viewPercentage}} first-percentage={{insightsData.reach.views.membersPercentage}} second-percentage={{insightsData.reach.views.invitedPercentage}} text=Viewed></percentage-graph-two-colors></div><!-- Stats --><div class=announcement-insights-reach__stats><!-- Recipients Column --><div class=announcement-insights-reach__stat-column><div class=announcement-insights-reach__stat-value style=\"color: #005cb8; cursor: pointer\" ng-click=\"showParticipants(\'R\', \'A\', -1)\"><span style=\"color: #005cb8\">{{insightsData.reach.recipients.total}} </span><span style=\"color: #151515\">recipient{{getPluralSuffix(insightsData.reach.recipients.total)}}</span></div><div class=announcement-insights-reach__stat-breakdown><div class=announcement-insights-reach__breakdown-item><span class=announcement-insights-reach__breakdown-square style=\"background-color: #005cb8\"></span> <span><span style=\"color: #005cb8; cursor: pointer\" ng-click=\"showParticipants(\'R\', \'U\', -1)\">{{insightsData.reach.recipients.registered}}</span> Registered member{{getPluralSuffix(insightsData.reach.recipients.registered)}}</span></div><div class=announcement-insights-reach__breakdown-item><span class=announcement-insights-reach__breakdown-square style=\"background-color: #627293\"></span> <span><span style=\"color: #005cb8; cursor: pointer\" ng-click=\"showParticipants(\'R\', \'N\', -1)\">{{insightsData.reach.recipients.invited}}</span> Invited parent{{getPluralSuffix(insightsData.reach.recipients.invited)}}</span></div></div></div><!-- Views Column --><div class=announcement-insights-reach__stat-column><div class=announcement-insights-reach__class-stats style=\"cursor: pointer;\n										font-size: 16px;\n										font-weight: 600;\n										gap: 8px\" ng-click=\"showParticipants(\'V\', \'A\', -1)\"><span class=announcement-insights-reach__class-recipients style=\"min-width: 50px; color: #005cb8\">{{insightsData.reach.views.total}}</span> view{{getPluralSuffix(insightsData.reach.views.total)}}</div><div class=announcement-insights-reach__stat-breakdown><div class=announcement-insights-reach__class-stats style=\"gap: 8px; font-size: 12px; font-weight: 600\"><span class=announcement-insights-reach__class-recipients style=\"min-width: 50px; color: #005cb8; cursor: pointer\" ng-click=\"showParticipants(\'V\', \'U\', -1)\">{{insightsData.reach.views.registered}} </span>Member{{getPluralSuffix(insightsData.reach.views.registered)}}</div><div class=announcement-insights-reach__class-stats style=\"gap: 8px; font-size: 12px; font-weight: 600\"><span class=announcement-insights-reach__class-recipients style=\"min-width: 50px; color: #005cb8; cursor: pointer\" ng-click=\"showParticipants(\'V\', \'N\', -1)\">{{insightsData.reach.views.invited}}</span> Invited</div></div></div></div></div><!-- Class Breakdown --><div class=announcement-insights-reach__classes><div class=announcement-insights-reach__class-item ng-repeat=\"classItem in insightsData.reach.groups\"><div class=announcement-insights-reach__class-row><div class=announcement-insights-reach__class-left><div class=announcement-insights-reach__class-icon><svg width=20 height=20 viewBox=\"0 0 20 20\" fill=none xmlns=http://www.w3.org/2000/svg><circle cx=10 cy=10 r=10 fill=#005CB8 /><path d=\"m10.25 15.247-.144-.2c-.317-.437-.7-.55-1.399-.757-.367-.11-.823-.244-1.387-.462a2.304 2.304 0 0 1-1.415-1.577c-.224-.812-.063-1.783.393-2.413.666-.916.409-1.772.267-2.098a1.92 1.92 0 0 0-.09-.165c-.179-.307-.55-.945.052-1.391.355-.263.624-.162.935-.044.31.13.639.2.972.209.96.017 1.67-.88 1.676-.89l.142-.181.14.182c.007.008.718.909 1.676.889.334-.008.663-.079.972-.209.311-.117.58-.22.935.044.602.446.231 1.084.053 1.39a1.914 1.914 0 0 0-.09.166c-.142.326-.4 1.182.267 2.098.458.63.617 1.6.393 2.413a2.304 2.304 0 0 1-1.416 1.577 16.85 16.85 0 0 1-1.387.462c-.696.206-1.084.32-1.398.757l-.146.2z\" stroke=#fff stroke-width=.5 /></svg></div><div class=announcement-insights-reach__class-info><div class=announcement-insights-reach__class-name title={{classItem.groupName}}>{{classItem.groupName}}</div><div class=announcement-insights-reach__class-stats><span class=announcement-insights-reach__class-recipients>{{classItem.recipientCount}} recipient{{getPluralSuffix(classItem.recipientCount)}} </span><span class=announcement-insights-reach__class-views ng-click=\"showParticipants(\'V\', \'A\', classItem.groupId)\">{{classItem.viewCount}} view{{getPluralSuffix(classItem.viewCount)}}</span></div></div></div><div class=announcement-insights-reach__class-bar><div class=announcement-insights-reach__class-bar-fill style=\"width: {{classItem.memberViewsPercentage}}%\"></div><div class=announcement-insights-reach__class-bar-grey style=\"width: {{classItem.invitedViewsPercentage}}%\"></div></div></div></div></div><!-- Engagement Section --><div class=announcement-insights-engagement><div class=announcement-insights-engagement__header><span class=announcement-insights-engagement__title>Engagement</span></div><div class=announcement-insights-engagement__summary><span class=announcement-insights-engagement__summary-item><span class=announcement-insights-engagement__summary-number style=\"color: #005cb8; cursor: pointer\" ng-click=\"showParticipants(\'RX_ALL\', \'none\', -1)\">{{insightsData.engagement.reactions.total}} </span><span class=announcement-insights-engagement__summary-text>reaction{{getPluralSuffix(insightsData.engagement.reactions.total)}}</span> </span><span class=announcement-insights-engagement__summary-item style=\"color: #005cb8;\n									text-decoration: underline;\n									cursor: pointer;\n									margin-left: 16px\" ng-click=goToComments()>{{postMeta.commentCount}} comment{{getPluralSuffix(postMeta.commentCount)}}</span></div><!-- Reaction Icons --><div class=announcement-insights-engagement__reactions><div class=announcement-insights-engagement__reaction-item ng-click=\"insightsData.engagement.reactions.LIKE > 0 && showParticipants(\'RX_LIKE\', \'none\', -1)\" ng-class=\"{\'announcement-insights-engagement__reaction-item--disabled\': insightsData.engagement.reactions.LIKE === 0}\"><div><img src=https://storage.googleapis.com/classlist-branding/app-assets/announcement_view_like.svg alt=Like></div><div style=\"margin-top: -15px\" class=announcement-insights-engagement__reaction-count ng-class=\"{\'announcement-insights-engagement__reaction-count--zero\': insightsData.engagement.reactions.LIKE === 0}\">{{insightsData.engagement.reactions.LIKE}}</div></div><div class=announcement-insights-engagement__reaction-item ng-click=\"insightsData.engagement.reactions.THANK > 0 && showParticipants(\'RX_THANK\', \'none\', -1)\" ng-class=\"{\'announcement-insights-engagement__reaction-item--disabled\': insightsData.engagement.reactions.THANK === 0}\"><div><img src=https://storage.googleapis.com/classlist-branding/app-assets/announcement_view_thank.svg alt=Thank></div><div style=\"margin-top: -15px\" class=announcement-insights-engagement__reaction-count ng-class=\"{\'announcement-insights-engagement__reaction-count--zero\': insightsData.engagement.reactions.THANK === 0}\">{{insightsData.engagement.reactions.THANK}}</div></div><div class=announcement-insights-engagement__reaction-item ng-click=\"insightsData.engagement.reactions.WAVE > 0 && showParticipants(\'RX_WAVE\', \'none\', -1)\" ng-class=\"{\'announcement-insights-engagement__reaction-item--disabled\': insightsData.engagement.reactions.WAVE === 0}\"><div class=announcement-insights-engagement__reaction-icon><img src=https://storage.googleapis.com/classlist-branding/app-assets/announcement_view_wave.svg alt=Wave></div><div style=\"margin-top: -15px\" class=announcement-insights-engagement__reaction-count ng-class=\"{\'announcement-insights-engagement__reaction-count--zero\': insightsData.engagement.reactions.WAVE === 0}\">{{insightsData.engagement.reactions.WAVE}}</div></div><div class=announcement-insights-engagement__reaction-item ng-click=\"insightsData.engagement.reactions.CELEBRATE > 0 && showParticipants(\'RX_CELEBRATE\', \'none\', -1)\" ng-class=\"{\'announcement-insights-engagement__reaction-item--disabled\': insightsData.engagement.reactions.CELEBRATE === 0}\"><div class=announcement-insights-engagement__reaction-icon><img src=https://storage.googleapis.com/classlist-branding/app-assets/announcement_view_celebrate.svg alt=Celebrate></div><div style=\"margin-top: -15px\" class=announcement-insights-engagement__reaction-count ng-class=\"{\'announcement-insights-engagement__reaction-count--zero\': insightsData.engagement.reactions.CELEBRATE === 0}\">{{insightsData.engagement.reactions.CELEBRATE}}</div></div><div class=announcement-insights-engagement__reaction-item ng-click=\"insightsData.engagement.reactions.LOVE > 0 && showParticipants(\'RX_LOVE\', \'none\', -1)\" ng-class=\"{\'announcement-insights-engagement__reaction-item--disabled\': insightsData.engagement.reactions.LOVE === 0}\"><div class=announcement-insights-engagement__reaction-icon><img src=https://storage.googleapis.com/classlist-branding/app-assets/announcement_view_love.svg alt=Love></div><div style=\"margin-top: -15px\" class=announcement-insights-engagement__reaction-count ng-class=\"{\'announcement-insights-engagement__reaction-count--zero\': insightsData.engagement.reactions.LOVE === 0}\">{{insightsData.engagement.reactions.LOVE}}</div></div></div></div></div></div></div><!-- Right Sidebar - Actions --></div></section>");
$templateCache.put("app/announcements/views/cancel-announcement-modal.html","<div><div class=modal-header><h3 translate=CANCEL_ANNOUNCEMENT_HEADER></h3></div><div class=modal-body><p translate=CANCEL_ANNOUNCEMENT_TEXT></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=OK_BTN ng-click=confirm()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/announcements/views/delete-modal.html","<div><div class=modal-header><h3 translate=ANNOUNCEMENT_POST_HEADER></h3></div><div class=modal-body ng-if=\"status === \'DRAFT\'\"><p translate=ANNOUNCEMENT_DRAFT_POST_TEXT></p></div><div class=modal-body ng-if=\"status !== \'DRAFT\'\"><p translate=ANNOUNCEMENT_POST_TEXT_1></p><p translate=ANNOUNCEMENT_POST_TEXT_2></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=DELETE_BTN ng-click=confirm()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/announcements/views/duplicate-modal.html","<div><div class=modal-header><h3 translate=DUPLICATE_MODAL_HEADER></h3></div><div class=modal-body style=\"padding: 20px\"><p translate=DUPLICATE_MODAL_INFO></p><div class=form-group style=\"padding-top: 10px\"><div><div style=\"overflow: auto\"><!-- <label class=\"control-label announcement-to\" translate=\"TO_LABEL\" style=\"margin:10px 0 0 0;\"></label> --><div class=announcement-search><input id=announcement-group-id type=text ng-model=_announcement.group.id placeholder=\"{{ \'START_TYPING_TIER_PHOLDER\' | translate }}\" uib-typeahead=\"r.field1 for r in queryRecipients($viewValue)\" typeahead-wait-ms=300 typeahead-min-length=2 typeahead-on-select=pickGroup($item) typeahead-template-url=selectionTemplate.html class=form-control ng-focus=\"tierError = false\" ng-blur=\"_announcement.group.id = \'\'\" autocomplete=off><div class=error-text-red ng-show=tierError><span translate=ERR_START_TYPING_TIER></span></div></div></div><div><div class=announcement__selected-tiers><span ng-click=removeGroup(group.id) class=announcement__selected-tier ng-repeat=\"group in _announcement.selectedGroups track by $index\">{{group.field1}} <a class=\"dripicons-cross announcement__remove-tier\"></a></span></div></div></div><div><div><div><input id=announcement-subject-id type=text placeholder=\"{{\'SUBJECT_PHOLDER\' | translate}}\" class=form-control ng-model=_announcement.subject maxlength=50 autocomplete=off ng-focus=\"subjectError = false\"><div class=error-text-red ng-show=subjectError><span translate=ERR_SUBJECT></span></div></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=DUPLICATE_BTN ng-click=confirm()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></button></button></div></div><script type=text/ng-template id=selectionTemplate.html><a>\n		<span ng-bind-html=\"match.model.field1 | uibTypeaheadHighlight:query\" ng-if=\"match.model.field1\"></span>\n	</a></script>");
$templateCache.put("app/announcements/views/lock-comment-modal.html","<div><div class=modal-header><h3 translate=\"{{isLocked ? \'UNLOCK_COMMENT_HEADER\' : \'LOCK_COMMENT_HEADER\'}}\"></h3></div><div class=modal-body><p translate=\"{{isLocked ? \'UNLOCK_COMMENT_TEXT\' : \'LOCK_COMMENT_TEXT\'}}\"></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=OK_BTN ng-click=confirm()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/announcements/views/send-announcement-modal.html","<script type=text/ng-template id=selectionTemplate.html><a>\n		<span ng-bind-html=\"match.model.n | uibTypeaheadHighlight:query\" ng-if=\"match.model.n\"></span>\n	</a></script><div class=\"assign-parent-admin announcement\" ng-class=\"{\'not-ready\':!viewState.isReady}\"><div class=modal-header><h3 translate=SEND_ANNOUNCEMENT_TITLE></h3></div><div class=modal-body><p translate=SEND_ANNOUNCEMENT_HELP></p><form novalidate name=sa><div class=form-group><div class=row><div class=col-xs-1><label class=control-label translate=TO_LABEL style=\"margin:10px 0 0 0\"></label></div><div class=col-xs-11><div class=search><input type=text ng-model=announcement.group.id placeholder=\"{{ \'START_TYPING_TIER_PHOLDER\' | translate }}\" uib-typeahead=\"r.n for r in queryRecipients($viewValue)\" typeahead-wait-ms=300 typeahead-min-length=2 typeahead-on-select=pickGroup($item) typeahead-template-url=selectionTemplate.html class=form-control ng-blur=\"announcement.group.id = \'\'\"></div></div><div class=col-xs-12><div class=announcement__selected-tiers><span ng-click=removeGroup(group.id) class=announcement__selected-tier ng-repeat=\"group in announcement.selectedGroups track by $index\">{{group.n}} <a class=\"dripicons-cross announcement__remove-tier\"></a></span></div></div></div></div><div class=form-group><div class=row><div class=col-md-12><input type=text placeholder=\"{{\'SUBJECT_PHOLDER\' | translate}}\" class=form-control ng-model=announcement.subject required maxlength=50></div></div></div><div class=form-group><div class=row><div class=col-md-12><text-editor ng-model=announcement.body required maxlength=9999 placeholder=\"{{\'WRITE_ANNOUNCEMENT_PHOLDER\' | translate}}\" attachment=announcement.attachmentName attachment-file-name=fileName></text-editor><div class=announcement__attachment ng-show=getNewFileName()><span class=announcement__attachment-name style=\"word-break: break-all\">{{getNewFileName()}}</span> <button class=\"btn btn-default\" ng-click=removeAttachment()><span class=dripicons-cross></span></button></div></div></div></div></form></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-default\" type=button ng-click=save() ng-disabled=\"sa.$invalid || announcement.selectedGroups.length === 0 || announcement.pendingRequest === true\"><span translate=OK_ANNOUNCEMENT_BTN></span></button></div></div>");
$templateCache.put("app/announcements/views/unsaved-changes-modal.html","<div style=padding:20px><span class=\"icons dripicons-cross\" ng-click=stay() style=\"float: right; cursor: pointer; font-size: 28px\"></span><div class=modal-body style=\"margin-top: 40px\"><h3 translate=ANNOUNCEMENT_UNSAVED_CHANGES_TITLE></h3><br><p translate=ANNOUNCEMENT_UNSAVED_CHANGES_DESCRIPTION></p></div><div class=modal-footer><button type=button class=\"btn btn-ghost\" translate=DISCARD_BTN ng-click=leave()><button type=button class=\"btn btn-primary\" translate=SAVE_BTN ng-click=saveDraftBtn()></button></button></div></div>");
$templateCache.put("app/announcements/views/why-schedule-modal.html","<div style=\"padding: 15px\"><div class=modal-header><h3 translate=SCHEDULE_ANNOUNCEMENT_HEADER></h3></div><div class=modal-body><p translate=SCHEDULE_ANNOUNCEMENT_BODY></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=OK_BTN ng-click=close()></div></div>");
$templateCache.put("app/announcements/views/wrapper.html","<div class=\"content-logged announcements-wrapper\"><div ui-view autoscroll=false></div></div>");
$templateCache.put("app/base/appcues/getapp.html","<div class=\"custom-appcues getapp-appcue\"><div><div class=on-fullscreen-content><div><br><br><div class=use-app-logo><img style=width:180px alt=\"\" src=https://www.classlist.com/hubfs/_images/logos/classlist/Classlist%20-%20Brand%20blue@1x.svg></div><br><div class=use-app-text><span style=\"display: inline\">To use Classlist on your mobile,<br>download the app.</span><p style=\"margin-top: 10px\">Find out the latest and customise your notifications easily.</p></div><div style=\"margin-bottom: 15px\" class=btn-primary><div ng-click=downloadApp() translate=GET_THE_APP class=text></div></div><br><p style=\"margin-top: 10px\" class=use-app-text>Installed it already?</p><div class=btn-get-app style=\"margin-bottom: 15px\"><div class=text-2 ng-click=\"openApp() \">Open in the app</div></div><div class=store-btn><div ng-if=\"os==\'iOS\' \" ng-click=\"downloadApp() \" class=btn-appstore><img src=https://storage.googleapis.com/classlist-branding/email-template/ios-store-link.png></div><div ng-if=\"os==\'Android\' \" ng-click=\"downloadApp() \" class=btn-googleplay><img src=https://storage.googleapis.com/classlist-branding/email-template/android-store-link.png></div></div></div></div></div></div>");
$templateCache.put("app/base/appcues/welcome.html","<div class=\"custom-appcues welcome-appcue\" style=width:100%><div><div class=on-fullscreen-content><div><div class=welcome-logo><img alt=\"\" src=https://start.classlist.com/classlist-logo-icon-blue.2c417856d821c2c735fd.svg style=\"width: 64px\"></div><h2 class=school-name>{{ active_school.name }}</h2><div class=welcome-name><div><span translate=APPCUE_WELCOME_TEXT_1></span> {{ active_user.firstName }}</div><div translate=APPCUE_WELCOME_TEXT_2></div></div><div class=box-wrapper><figure class=box><img class=image-box alt=\"\" id=welcomeappcuecontacts src=assets/icons/default-avatar.png></figure><figure class=box><img class=image-box alt=\"\" id=welcomeappcueevents src=assets/icons/default-avatar.png></figure><figure class=box><img class=image-box alt=\"\" id=welcomeappcuechat src=assets/icons/default-avatar.png></figure></div><div style=\"text-align:center; margin-top: 30px\"><a ng-click=onDownloadButtonClicked() class=btn-continue translate=\"{{ isMobileAndNative()  ? \'APPCUE_WELCOME_TEXT_8\' : isDesktop() ? \'APPCUE_WELCOME_TEXT_9\' : \'APPCUE_WELCOME_TEXT_7\'}}\"></a></div></div></div></div></div>");
$templateCache.put("app/base/directives/_OLD_postAsset.directive.html","<div class=post-item mw=\"{{ userId == postUserId ? true : false }}\"><div class=post-item-details><div class=padding-post><div class=row><div class=\"col-xs-2 col-sm-2 left-col-post\"><figure class=post-item-avatar ng-if=\"post.type != \'announcement\'\" ui-sref=\"users.parentdetail({\'id\':post.userId })\"><avatar class=\"visible-xs visible-sm\" source={{post.avatar}} name=\"{{ post.postedBy }}\" width=40 height=40 my=false></avatar><avatar class=\"visible-md visible-lg\" source={{post.avatar}} name=\"{{ post.postedBy }}\" width=60 height=60 my=false></avatar></figure><figure class=post-item-avatar ng-if=\"post.type === \'announcement\'\"><avatar class=\"visible-xs visible-sm\" source={{post.avatar}} name=\"{{ post.postedBy }}\" width=40 height=40 my=false></avatar><avatar class=\"visible-md visible-lg\" source={{post.avatar}} name=\"{{ post.postedBy }}\" width=60 height=60 my=false></avatar></figure></div><div class=\"col-xs-9 col-sm-9 padding-left-zero\"><div class=post-item-head><h4><a ng-show=\"post.type != \'announcement\'\" href=\"#/users/parent-detail/{{ post.userId }}\">{{ post.postedBy }}</a> <strong class=strong-noclick ng-show=\"post.type === \'announcement\'\">{{post.postedBy || user.firstName}}</strong> <span><span ng-show=\"post.type === \'welcome\'\" translate=JOINED_IN class=posted-in></span> <span ng-show=\"post.type === \'group\'\" translate=POSTED_IN class=posted-in></span> <span ng-show=\"post.type === \'announcement\'\" translate=ANNOUNCEMENT_IN_GROUPS class=posted-in></span> <span ng-show=\"post.type == \'listing\'\" translate=POSTED_A_LISTING_IN class=posted-in></span> <a ng-if=\"post.type !== \'announcement\'\" ng-click=\"gotoCategory(post.listingCategory, post.groupId, post.type === \'announcement\' || post.type === \'group\' || post.type === \'welcome\')\"><strong ng-show=\"post.type === \'announcement\' || post.type === \'group\'\">{{ post.groupName }}</strong> <span class=listing-post__type-header ng-show=\"post.type === \'listing\'\" translate=LISTING_CAT_{{post.listingCategory}}></span> <strong ng-show=\"post.type === \'welcome\'\">{{ post.groupName }}</strong> </a><span ng-if=\"post.type === \'announcement\'\" class=\"{{ userRole == \'STAFF\' || userRole == \'COMMUNITY_REP\' ? \'non-clickable\' : \'\' }}\"><strong ng-show=\"post.type === \'announcement\' || post.type === \'group\'\" class=no-link>{{ post.groupName }}</strong> <span class=listing-post__type-header ng-show=\"post.type === \'listing\'\" translate=LISTING_CAT_{{post.listingCategory}}></span> <strong ng-show=\"post.type === \'welcome\'\">{{ post.groupName }}</strong></span></span></h4><time><span translate=AT></span>{{post.postedOn | date:\' h:mm a\' }}, {{post.postedOn | date:\'MMM dd\'}}</time><p count-chars ng-bind-html=post.body class=\"multiple-line-text post-text\" ng-show=\"post.type === \'group\'\"></p></div></div></div><div ng-show=\"post.type === \'listing\'\" class=\"listing-post {{ post.photo !== undefined && post.type === \'listing\' && post.listingPrice ? \'listing-margin-picture\' : \'\' }}\"><div class=row><div class=\"col-xs-2 col-sm-2 left-col-post\"><div class=\"listing-type listing-type-{{post.listingCategory.toLowerCase()}}\"><span class=dripicons-web></span> <span class=dripicons-star></span> <span class=drip-gift><img src=assets/icons/gift.svg alt=\"\"> </span><span class=dripicons-suitcase></span> <span class=dripicons-flashlight></span> <span class=dripicons-tag></span></div></div><div class=\"col-xs-9 col-sm-9 padding-left-zero\"><div class=text><span ng-if=\"post.sold && post.listingCategory == \'FREE\'\" class=claimed-label translate=CLAIMED></span> <span ng-if=\"post.sold && post.listingCategory == \'FOR_SALE\'\" class=claimed-label translate=SOLD></span> <span ng-if=\"post.sold && post.listingCategory == \'OFFER\'\" class=claimed-label translate=SOLD></span> <span ng-if=\"post.sold && post.listingCategory == \'LOST_FOUND\'\" class=claimed-label translate=FOUND></span> <span ng-if=\"post.sold && post.listingCategory == \'WANTED\'\" class=claimed-label translate=FOUND></span> <span ng-if=\"post.sold && post.listingCategory != \'FREE\' && post.listingCategory != \'FOR_SALE\' && post.listingCategory != \'OFFER\' && post.listingCategory != \'LOST_FOUND\' && post.listingCategory != \'WANTED\'\" class=claimed-label translate=SOLD></span> <span count-chars ng-bind-html=post.body class=multiple-line-text></span><br><div ng-if=post.listingPrice class=free-price><div class=listing-type-{{post.listingCategory.toLowerCase()}}>{{post.listingPrice}}</div></div></div></div></div></div><div class=\"padding-post photo-padding\"><div ng-if=!isPostView() class=\"multiple-pictures-template {{ ::getPostPictures(post.attachments).cssclass }}\" ng-click=openPost(post)><div ng-repeat=\"att in ::getPostPictures(post.attachments).pictures | limitTo: 3\" class=picture-box style=\"background-image: url(\'{{ ::att.url }}=s600-c\')\"><div class=more-items-circle ng-if=\"::getPostPictures(post.attachments).pictures.length > 3 && $last\"><div><div>+{{ ::(getPostPictures(post.attachments).pictures.length - 3) }}</div></div></div></div></div><div ng-if=isPostView() class=view-post-pictures-separator><div ng-repeat=\"att in getPostPictures(post.attachments).pictures\" style=\"text-align: center\"><img ng-click=\"openPicture(post.attachments, att)\" src=\"{{ att.url }}=s900\" style=\"max-width: 100%; cursor: pointer\" alt=\"\"></div></div></div><div ng-show=\"post.type === \'announcement\'\" class=listing-post><div class=text><span count-chars data-ng-bind-html=trustAsHtml(post.body) class=multiple-line-text></span></div><div class=home-files-list style=\"padding: 0; margin: 0\"><div ng-if=\"post.attachments && post.attachments.length > 0\"><div ng-repeat=\"att in post.attachments track by $index\" style=\"border-bottom: none\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 48 48\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><path fill=none stroke=#8a94a2 stroke-width=4 stroke-linecap=round stroke-miterlimit=10 d=\"M36,8v25 c0,7.2-5.8,13-13,13h0c-7.2,0-13-5.8-13-13V11c0-5,4-9,9-9h0c5,0,9,4,9,9v20c0,2.8-2.2,5-5,5h0c-2.8,0-5-2.2-5-5V14\" stroke-linejoin=round></path></g></svg> <a href=\"{{ att.path }}\" target=_blank style=\"word-break: break-all\">{{ att.name }}</a></div></div></div></div><div ng-show=\"post.type === \'classlist\'\" class=listing-post><div class=row><div class=\"col-xs-2 col-sm-2 left-col-post\"><div></div></div><div class=\"col-xs-9 col-sm-9 padding-left-zero\"><div class=text><p ng-bind-html=post.body class=multiple-line-text></p></div></div></div></div><figure class=post-item-photo ng-if=\"post.photo !== undefined && post.type === \'announcement\'\"><img ng-src={{post.photo}} alt=\"\"></figure><figure class=post-item-photo ng-if=\"post.photo !== undefined && post.type !== \'announcement\' && post.type !== \'listing\'\"><img ng-src={{post.photo}} alt=\"\"></figure></div></div><div class=\"vi-row who-likes\" ng-if=\"post.likeCount > 0\"><div class=\"vi-col-left row-force-fleft like-button-col left-col-post\"></div><div ng-click=showLikers(post) class=\"vi-col-middle padding-left-zero\" style=\"cursor: pointer\"><div ng-if=\"post.type != \'welcome\'\"><span ng-if=!post.isLiked class=likes-text><span>{{ post.lastLike[0] }}</span> <span ng-if=\"post.likeCount > 1\" translate=NUM_LIKES translate-values=\"{\'num\':post.likeCount-1}\"></span> <span ng-if=\"post.likeCount == 1\" translate=LIKES_THIS></span> </span><span ng-if=\"post.isLiked && post.likeCount > 1\" class=likes-text translate=NUM_OTHER_LIKES translate-values=\"{\'num\':post.likeCount-1}\"></span> <span ng-if=\"post.isLiked && post.likeCount <= 1\" translate=NUM_MY_LIKE class=likes-text></span></div><div ng-if=\"post.type == \'welcome\'\"><span ng-if=!post.isLiked class=likes-text><span ng-if=\"post.likeCount > 1\" translate=OTHERS_WELCOMED translate-values=\"{\'name\':post.lastLike[0], \'num\':post.likeCount-1}\"></span> <span ng-if=\"post.likeCount == 1\" translate=SOMEONE_WELCOMED translate-values=\"{\'name\':post.lastLike[0]}\"></span> </span><span ng-if=\"post.isLiked && post.likeCount > 1\" class=likes-text translate=ME_OTHERS_WELCOMED translate-values=\"{\'num\':post.likeCount-1}\"></span> <span ng-if=\"post.isLiked && post.likeCount <= 1\" translate=ME_WELCOMED class=likes-text></span></div></div></div><div class=\"post-item-likes clearfix\"><div class=vi-row><div class=\"vi-col-left row-force-fleft like-button-col left-col-post\" style=\"width: 40px\"><a id=like-post-id ng-click=likePost(post)><span ng-if=\"post.type != \'welcome\'\" class=\"icon {{ post.isLiked ? \'like-active\' : \'\' }} dripicons-thumbs-up\"></span> <span ng-if=\"post.type == \'welcome\'\" class=\"icon {{ post.isLiked ? \'like-active\' : \'\' }} dripicons-smiley-face\"></a></div><div id=like-post-button ng-click=likePost(post) class=\"vi-col-middle padding-left-zero\" style=\"cursor: pointer\"><span class=\"text {{ post.isLiked ? \'like-active\' : \'\' }}\" translate=LIKE ng-if=\"post.type != \'welcome\'\"></span> <span class=\"text {{ post.isLiked ? \'like-active\' : \'\' }}\" translate=WELCOME ng-if=\"post.type == \'welcome\'\"></span></div></div></div><div class=post-item-comment ng-show=\"post.commentCount > 0\"><div class=comment-item ng-repeat=\"cmm in post.comments\" style=\"margin-bottom: 0\"><div class=vi-row><div class=vi-col-left><figure class=comment-item-avatar ng-if=\"post.type != \'announcement\'\" ui-sref=\"users.parentdetail({\'id\':cmm.userId })\"><avatar source={{cmm.avatar}} name=\"{{ cmm.postedBy || user.fullName }}\" width=60 height=60 my=false></avatar></figure><figure class=comment-item-avatar ng-if=\"post.type === \'announcement\'\"><avatar source={{cmm.avatar}} name=\"{{ cmm.postedBy || user.fullName }}\" width=60 height=60 my=false></avatar></figure></div><div class=\"vi-col-middle padding-left-zero\"><div class=comment-text-section><div class=\"multiple-line-text comment-text\"><strong class=strong-noclick>{{cmm.postedBy || user.fullName}}</strong> <span ng-bind-html=cmm.body></span></div><div ng-if=\"cmm.attachment && cmm.attachment.url != \'\' && !cmm.attachment.fileView\" style=\"overflow: auto; width: 100%; height: 100%; margin-top: 10px;max-width: 250px; max-height: 250px; cursor: pointer\" id=image-preview-wrapper><div ng-click=openCommentImage(cmm.attachment.url) style=\"margin-bottom: 3px;text-align: center\"><img ng-src={{cmm.attachment.url}} style=\"height: 100%; width: 100%\"></div></div><br><div class=home-files-list ng-if=\"cmm.attachment && cmm.attachment.url != \'\' && cmm.attachment.fileView\" style=\"padding-left: 2px; margin-top: 0px !important\"><div><div style=\"border-bottom: none\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 48 48\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><path fill=none stroke=#8a94a2 stroke-width=4 stroke-linecap=round stroke-miterlimit=10 d=\"M36,8v25 c0,7.2-5.8,13-13,13h0c-7.2,0-13-5.8-13-13V11c0-5,4-9,9-9h0c5,0,9,4,9,9v20c0,2.8-2.2,5-5,5h0c-2.8,0-5-2.2-5-5V14\" stroke-linejoin=round></path></g></svg> <a href=\"{{ cmm.attachment.url }}\" target=_blank style=\"word-break: break-word\">{{ cmm.attachment.fileName }}</a></div></div></div><div><time><span translate=AT></span>{{cmm.created | date:\' h:mm a\' }}, {{cmm.created | date:\'MMM dd\'}} </time><a id=delete-comment-id class=\"icon dripicons-cross\" ng-click=deleteComment(cmm.id) ng-if=cmm.own></a></div></div></div></div></div><div class=vi-row><div class=\"vi-col-left padding-left-zero\" ng-if=\"post.comments.length < post.commentCount\"><div ng-hide=post.hideMoreComm><a class=view-previous-comments ng-click=getMoreComments(post) translate=VIEW_MORE_COMMENTS></a></div></div><div class=vi-col-middle ng-if=\"post.comments.length < post.commentCount\"><span class=comment-num ng-show=!post.hideMoreComm><span>{{ post.comments.length }} <span translate=OF></span></span> {{ post.commentCount }}</span></div></div></div><div class=post-item-add-comment ng-hide=post.commentLocked ng-show=\"postContext !== \'GROUP_LIST_VIEW\'\"><div class=comment-composer><comment-composer post-id={{post.id}} user-avatar=userAvatar events=events></comment-composer></div></div></div>");
$templateCache.put("app/base/directives/avatar.directive.html","<div style=\"width: 100%; height: 100%; min-width: 40px; min-height: 40px; border-radius: 50%\"><div class=\"letter-avatar letter-color-{{ getInitial() }}\"><div style=\"position: relative\"><div>{{ getInitials() }}</div><div class=avatar-picture style=\"background-image: url(\'{{ src }}\')\"></div></div></div></div>");
$templateCache.put("app/base/directives/classPicker.directive.html","<div class=is-relative><div class=is-relative><select class=\"form-control class-list select-tier-directive\" ng-model=selectedTierId ng-change=selectTier()><option ng-repeat=\"option in tiers\" ng-disabled=option.children value={{option.id}}>{{option.name}}</option></select><span translate={{pupilClassPlaceholder}} class=\"select-placeholder pupil_class_placeholder\"></span> <span class=\"dripicons-chevron-down select-arrow\"></span></div></div>");
$templateCache.put("app/base/directives/commentComposer.directive.html","<div class=comment-composer-inner><form name=cmm novalidate><div style=\"position: relative\"><textarea style=\"float: none; background: #f5f8ff; border-radius: 5px; border: 1px solid #b6c2db !important\" id=comment-body-id class=\"comment-body form-control\" ng-attr-placeholder={{commentPlaceHolderText}} ng-model=comment.body autoresize-textarea-comment required ng-minlength=regexes.min.commentBody></textarea><div ng-if=\"comment.body != null && (comment.body.length > regexes.max.commentBody)\" class=error-text-stripe><span class=error-text-stripe_text translate=ERR_COMMENT_CHAR_LIMIT translate-values=\"{actual:comment.body.length, max: regexes.max.commentBody}\"></span></div><div style=\"overflow: auto; position: absolute; bottom: 7px; right: 0\"><div ng-if=!cmm.$invalid class=\"mobile-send-but {{ cmm.$invalid ? \'mobile-send-diabled\' : \'\' }}\" ng-click=postComment() style=\"cursor: pointer; padding-top: 11px; padding-right: 10px;     padding-bottom: 5px\"><svg xmlns=http://www.w3.org/2000/svg xmlns:sketch=http://www.bohemiancoding.com/sketch/ns xmlns:xlink=http://www.w3.org/1999/xlink height=18px version=1.1 viewBox=\"0 0 23 18\" width=23px><g fill=none fill-rule=evenodd id=Page-1 stroke=none stroke-width=1><g fill=#eb004e id=Core transform=\"translate(-421.000000, -381.000000)\"><g id=send transform=\"translate(421.500000, 381.000000)\"><path d=\"M0,18 L21,9 L0,0 L0,7 L15,9 L0,11 L0,18 Z\" id=Shape /></g></g></g></svg></div></div></div></form></div>");
$templateCache.put("app/base/directives/commentComposer.school.directive.html","<div class=comment-composer-inner><form name=cmm novalidate><div class=vi-row><div class=vi-col-left style=\"width: 50px; margin-top: 4px\"><figure style=\"position: inherit\" class=comment-item-avatar><avatar source=\"{{ activeUser.avatar }}\" name=\"{{ activeUser.firstName + \' \' + activeUser.lastName }}\" width=32 height=32></avatar></figure></div><div class=vi-col-middle><div><mentionsuggestor commentbody=getCommentBody(bodyWithTags) replyto={{replyToAnchor}} id=comment-body-id class=\"comment-body form-control\" placeholder=\"{{ commentPlaceHolderText }}\" autoresize-textarea-comment required ng-minlength=regexes.min.commentBody></mentionsuggestor><div ng-if=\"comment.body != null && (comment.body.length > regexes.max.commentBody)\" class=error-text-stripe><span class=error-text-stripe_text translate=ERR_COMMENT_CHAR_LIMIT translate-values=\"{actual:comment.body.length, max: regexes.max.commentBody}\"></span></div><div style=\"overflow: auto; position: absolute; top: 3px; right: 8px\"><div ng-if=\"!cmm.$invalid && !sendingComment\" class=\"mobile-send-but {{ cmm.$invalid ? \'mobile-send-diabled\' : \'\' }}\" style=\"cursor: pointer\"><div class=post-links style=\"cursor: pointer\"><span id={{postId}}icons class=\"icon-link photo-icon\" style=\"margin-left: 5px\"><span ng-click=uploadImage(postId) style=\"float: left\"><svg style=\"width: 22px; height: 36px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><path fill=#4a9fef d=\"M58,13h-8.546l-6.701-7.659C42.562,5.125,42.288,5,42,5H28c-0.288,0-0.562,0.125-0.753,0.341L20.546,13H6 c-2.757,0-5,2.243-5,5v36c0,2.757,2.243,5,5,5h52c2.757,0,5-2.243,5-5V18C63,15.243,60.757,13,58,13z M13,26c-1.103,0-2-0.897-2-2 s0.897-2,2-2s2,0.897,2,2S14.103,26,13,26z M35,50c-7.732,0-14-6.268-14-14s6.268-14,14-14s14,6.268,14,14S42.732,50,35,50z\"></path></g></svg> </span><span ng-if=!isNativeAndroid() ng-click=uploadAttachment(postId) style=\"float: left; margin-left: 15px\"><svg style=\"width: 22px; height: 36px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=32px height=32px viewBox=\"0 0 32 32\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><path fill=none stroke=#4a9fef stroke-width=2 stroke-linecap=square stroke-miterlimit=10 d=\"M27.8,16.5l-9.9,9.9 c-3.1,3.1-8.2,3.1-11.3,0l0,0c-3.1-3.1-3.1-8.2,0-11.3L16.8,4.9c2.1-2.1,5.6-2.1,7.8,0l0,0c2.1,2.1,2.1,5.6,0,7.8l-9.5,9.5 c-1.2,1.2-3.1,1.2-4.2,0l0,0c-1.2-1.2-1.2-3.1,0-4.2L20,8.7\" stroke-linejoin=miter></path></g></svg> </span></span><span ng-click=postComment(postId) style=\"float: left; margin-left: 15px;padding-top: 8px\"><svg xmlns=http://www.w3.org/2000/svg xmlns:sketch=http://www.bohemiancoding.com/sketch/ns xmlns:xlink=http://www.w3.org/1999/xlink height=18px version=1.1 viewBox=\"0 0 23 18\" width=23px><g fill=none fill-rule=evenodd id=Page-1 stroke=none stroke-width=1><g fill=#FF5D92 id=Core transform=\"translate(-421.000000, -381.000000)\"><g id=send transform=\"translate(421.500000, 381.000000)\"><path d=\"M0,18 L21,9 L0,0 L0,7 L15,9 L0,11 L0,18 Z\" id=Shape /></g></g></g></svg></span></div></div></div></div><div style=\"display: none; overflow: auto; min-height: 100px; min-width: 100px; max-height: 250px; max-width: 250px\" id={{postId}}><div id=img-preview-wrapper class=post-img-preview style=\"margin-bottom: 3px;text-align: center; min-height: 35px\"><img id=test-id src=\"\"><span id=att-name style=\"color: #4a9fef; float: left;border-bottom: 1px solid #ddd; line-height: 26px\"></span> <span class=delete-button-wrap ng-click=removeAttachment(postId)><span class=delete-pic-button><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><polygon fill=#ffffff points=\"44,17.171 32,29.171 20,17.171 17.171,20 29.171,32 17.171,44 20,46.829 32,34.829 44,46.829 46.829,44 34.829,32 46.829,20 \"></polygon></g></svg></span></span></div><!-- <div id=\"att-preview-wrapper\">\n						<span id=\"att-name\" style=\"color: #4a9fef;\"></span>\n                        <span ng-click=\"removeFile(postId)\" class=\"delete-pic-button\">\n							<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"64px\" height=\"64px\" viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><polygon fill=\"#ffffff\" points=\"44,17.171 32,29.171 20,17.171 17.171,20 29.171,32 17.171,44 20,46.829 32,34.829 44,46.829 46.829,44 34.829,32 46.829,20 \"></polygon></g></svg>\n						</span>\n					</div> --></div></div></div></form></div>");
$templateCache.put("app/base/directives/cropper.directive.html","<div class=cropper ng-class=\"{\'not-ready\':!viewState.isReady}\"><img id=imgPreviewer alt=\"\"><div class=cropper-pholder id=imgPholder><input type=file id=imgUploader accept=image/*><div class=cz-message><span class=\"hidden-sm hidden-xs icon dripicons-upload\"></span><p class=\"hidden-sm hidden-xs\" translate=DRAG_A_PHOTO_HERE></p><p class=\"hidden-sm hidden-xs\" translate=_OR_></p><button type=button class=\"btn btn-primary\" translate=CHOOSE_PHOTO></button><p translate=MAX_FILE_SIZE ng-if=\"eventConfig !== \'eventCropper\'\"></p><p translate=MAX_FILE_SIZE_EVENT ng-if=\"eventConfig === \'eventCropper\'\"></p></div></div></div>");
$templateCache.put("app/base/directives/csvUpload.directive.html","<div><div style=\"font-size: 14px; margin-bottom: 15px\"><span translate=BULK_EMAIL_CSV_TITLE></span> <span class=\"dripicons-question icon\" ng-click=openHelpdesk(1) style=\"color: #777; cursor: pointer\"></span></div><div><div ng-show=\"step == 1\"><div><input type=file id=fileUploaderCSV style=\"display: none\"><div><button ng-click=uploadBulkCSV() type=button class=\"btn btn-ghost\" translate=UPLOAD_BULK_TITLE ng-disabled=isSchoolTrial()></button><p></p><p translate=MAX_CSV_SIZE></p></div></div></div><div style=\"clear: both\"></div><div ng-show=\"step != 1\" style=\"padding-bottom: 10px\"><p ng-show=\"step != 4\">Your file has uploaded succesfully</p><p ng-show=\"step != 4\">Please match the title of each column to its content</p><div class=row ng-show=\"step == 4\" id=progressBar><div class=\"col-md-12 schoolpage\"><div class=progress-bar-blue style=\"width: 100% !important; height: 20px\"><div style=\"height: 20px; background-color: #4caf50; width: {{(100 * lineIndex) / allResults.length}}%\"></div></div><span style=\"font-weight: bold\">Invited {{lineIndex || 0}} of {{allResults.length}} parents. Please wait until the process is over. You will be automatically redirected to the report page at the end of the proccess.</span></div></div><div style=\"max-height: 500px; overflow: auto; width: 95%; margin-top: 10px\" id=table><table style=\"border-spacing: 10px; border-collapse: separate; width: 95%\"><tr><td style=\"text-align: center; vertical-align: middle\" ng-repeat=\"r in columns\"><div class=\"is-relative select-form\"><select class=form-control ng-model=selectionModel ng-change=\"onSelectionChange(this, $index, selectionModel)\" ng-disabled=\"step != 2\"><option value=\"\" selected>Choose</option><option ng-repeat=\"column in columns\" ng-value=column ng-show=!isColumnSelected(column)>{{ column }}</option></select><span class=\"dripicons-chevron-down select-arrow\"></span></div></td><td style=\"text-align: center; vertical-align: middle\">Status</td></tr><tr ng-repeat=\"r in allResults\"><td style=\"text-align: center; vertical-align: middle\" ng-repeat=\"item in r\">{{item}}</td><td style=\"text-align: center; vertical-align: middle\" id=result_{{$index}}><div ng-show=\"step == 4\" class=vi-loader><div style=\"width: 20px; height: 20px\"><svg class=circular viewBox=\"25 25 50 50\"><circle class=path cx=50 cy=50 r=20 fill=none stroke-width=4 stroke-miterlimit=10></circle></svg></div></div></td></tr></table></div></div><div ng-show=\"step == 2\" style=\"float: right\"><button ng-click=csvConfigConfirm() ng-disabled=\"selectedColumns.length != columns.length\" type=button class=\"btn btn-ghost\" translate=DONE_BTN></button></div><div style=\"clear: both\"></div><div ng-show=\"step == 3\"><div><textarea class=\"form-control message-body\" ng-model=message maxlength=5000 required noresize></textarea><small ng-if=\"message != defaultText\" class=list-members-counter>{{ message.length }}/5000</small></div><div class=\"modal-footer bulk-footer\"><button class=\"btn btn-default cancel\" type=button ng-click=cancel()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary\" type=button ng-click=saveUpload()><span translate=SEND_BTN></span></button></div></div></div></div>");
$templateCache.put("app/base/directives/datepicker.directive.html","<div class=winkel-calendar><input type=hidden class=wc-input value=\"{{myDate | date: format}}\"><div ng-show=popover><div class=popover-background></div><div class=wc-date-popover ng-class=\"{\'banner-true\': bigBanner == true}\"><div class=wc-banner ng-if=bigBanner ng-class=\"{\'timepicker-true\': timePicker == true}\"><div class=\"wc-day-row calendar-header\"><span>{{ header }}</span></div></div><div class=\"wc-details wc-hover-opacity\" ng-click=toggleMonthView()><i class=\"wc-prev fa fa-angle-left\" ng-click=prevMonth($event)></i><div class=month-year ng-if=bigBanner>{{myDate | date: \'MMMM\'}}</div><div class=month-year ng-if=!bigBanner>{{myDate | date: \'MMMM\'}} &nbsp</div><i class=\"wc-next fa fa-angle-right\" ng-click=nextMonth($event)></i></div><div class=\"year-title wc-hover-opacity\" ng-click=generateYearList()><div class=year-dropdown>{{myDate | date: \'yyyy\'}} <i ng-show=!yearView class=\"fa fa-angle-down\"></i> <i ng-show=yearView class=\"fa fa-angle-up\"></i></div></div><table class=calendar-header><tr><td class=calendar-header-day>Su</td><td class=calendar-header-day>Mo</td><td class=calendar-header-day>Tu</td><td class=calendar-header-day>We</td><td class=calendar-header-day>Th</td><td class=calendar-header-day>Fr</td><td class=calendar-header-day>Sa</td></tr></table><div class=months-view ng-show=monthsView ng-click=setMonth($event)><span ng-repeat=\"month in cal_months_labels_short\" value={{month}} ng-class=\"{\'current-month\': month == cal_months_labels_short[myDate.getMonth()]}\">{{month}}</span></div><div class=years-view ng-show=yearView><div class=\"fa fa-angle-left prev\" ng-click=\"generateYearList(\'prev\')\"></div><div class=\"fa fa-angle-right next\" ng-click=\"generateYearList(\'next\')\"></div><div class=years-list-view ng-click=setYear($event)><span ng-repeat=\"year in yearsList\" value={{year}} ng-class=\"{\'current-year\': year == myDate.getFullYear()}\">{{year}}</span></div></div><div class=time-view ng-show=timeView><div class=time style=\"width: 160px; margin-right: -32px\"><div class=hour style=\"width: 60px\"><input type=text value=\"{{hourValue | numberFixedLen:2}}\" autofocus disabled style=\"padding: 5px 0!important; opacity: 1!important\"></div><div class=time-divider style=\"width: 10px\">:</div><div class=minutes style=\"width: 60px\"><input type=text value=\"{{minValue  | numberFixedLen:2}}\" disabled style=\"padding: 5px 0!important; opacity: 1!important\"></div><div style=\"font-size: 19px; margin-top: 21px; float: right; width: 29px\"><span ng-if=\"timeViewMeridian == \'AM\'\">AM</span> <span ng-if=\"timeViewMeridian == \'PM\'\">PM</span></div></div><div><div class=cuppa-btn-group><button ng-class=\"{\'active\': timeViewMeridian == \'AM\'}\" class=button ng-model=timeViewMeridian ng-click=\"toggleMeridian(\'AM\')\">AM</button> <button ng-class=\"{\'active\': timeViewMeridian == \'PM\'}\" class=button id=timepicker-pm-select ng-model=timeViewMeridian ng-click=\"toggleMeridian(\'PM\')\">PM</button></div></div><h5>Hours</h5><div range-slider floor=1 ceiling=12 step=1 precision=5 highlight=left ng-model=hourValue on-change=onHourUpdate(val)></div><h5>Minutes</h5><div range-slider floor=0 ceiling=55 step=5 precision=5 highlight=left ng-model=minValue on-change=onMinUpdate(val)></div><div class=time-view-btn><button class=\"button button-sm\" ng-click=setTimeView()>Set Time</button></div></div><table class=calendar-days ng-click=setDay($event);><tr ng-repeat=\"week in monthDays\"><td class=calendar-day ng-class=\"{\'today\': day == today.getDate() && myDate.getMonth() == today.getMonth() && myDate.getFullYear() == today.getFullYear(),\'selected-day\': day == myDate.getDate()}\" ng-repeat=\"day in week track by $index\"><span ng-if=\"day != 0\" value={{day}} class=disabled>{{day}}</span></td></tr></table><div class=wc-banner ng-if=bigBanner ng-class=\"{\'timepicker-true\': timePicker == true}\"><div class=wc-date-row>{{myDate | date: \'dd\'}}</div><div class=wc-my-sec><div class=wc-month-row><div>{{myDate | date: \'MMM\'}}</div></div><div class=wc-year-row><div>{{myDate | date: \'yyyy\'}}</div></div></div><div class=wc-time-sec ng-if=timePicker ng-click=toggleTimeView()><div class=time><div class=hour><div class=datepicker-input>{{myDate | date: \'hh\'}}</div></div><div class=time-divider>:</div><div class=minutes><div class=datepicker-input>{{myDate | date: \'mm\'}}</div></div></div><div class=timestate><span>{{myDate | date: \'a\'}}</span></div></div></div><div ng-if=!bigBanner><i class=\"fa fa-clock-o\" aria-hidden=true ng-click=toggleTimeView()></i></div><div class=cal-util><div class=cancel ng-click=cancel()><i class=\"fa fa-check\"></i>Cancel</div><div class=ok ng-click=confirmDate()><i class=\"fa fa-check\"></i>Done</div></div></div></div></div>");
$templateCache.put("app/base/directives/filterPicker.directive.html","<div class=is-relative><div class=is-relative><select class=\"form-control class-list select-tier-directive\" ng-model=selectedTierId ng-change=selectTier()><option ng-repeat=\"option in tiers\" value={{option.id}}>{{option.name}}</option></select><span translate={{pupilClassPlaceholder}} class=\"select-placeholder pupil_class_placeholder\"></span> <span class=\"dripicons-chevron-down select-arrow\"></span> <a translate=REMOVE_FILTER style=\"float: right; margin-top: 5px\" ng-click=onRemoveFilter()></a></div></div>");
$templateCache.put("app/base/directives/galleryPicker.directive.html","<div class=gallery-picker><div class=modal-header><h3 class=modal-title><a ng-click=close() style=\"float: left; margin-right: 10px; position: relative; text-decoration: none!important; font-size: 30px\"><span class=dripicons-arrow-thin-left></span></a> <span translate=UPLOAD_A_EVENT_PHOTO_TITLE style=\"font-size: 20px\"></span></h3></div><div class=modal-body style=\"padding-top: 0\"><div translate=UPLOAD_A_EVENT_PHOTO_HELP></div><div translate=MAX_FILE_SIZE></div><div class=gallery-picker><div class=dev-pick ng-click=uploadImage()><div><div style=\"position: absolute; top: 0; left: 50%; margin-left: -45px\"><div class=\"dripicons-monitor icon\"></div><br><div translate=CHOOSE_FROM_DEVICE></div></div></div><span></span></div><div ng-repeat=\"def in def_gallery\" ng-click=select(def) class=\"{{ selectedPic.id == def.id ? \'selected\' : \'\' }}\"><div style=\"background-image: url(\'{{def.url}}\')\"></div><span translate=\"{{ def.title }}\"></span></div></div></div><div class=modal-footer style=\"padding-bottom: 55px\"></div></div>");
$templateCache.put("app/base/directives/googleMapsAutocomplete.directive.html","<div class=\"autocomplete col-md-12 col-sm-12 col-xs-12\"><script type=text/ng-template id=autocompleteTemplate.html><div class=\"autocomplete-address-item\">\n			<p class=\"autocomplete-address-name\" ng-bind-html=\"match.label | uibTypeaheadHighlight:query\"></p>\n		</div></script><div class=address-autocomplete><input type=text ng-model=address click-outside=onFocusOut() ng-change=onChanged() placeholder=\"{{ \'START_TYPING_PLACEHOLDER\' | translate }}\" uib-typeahead=\"address.description for address in getResults($viewValue)\" typeahead-wait-ms=100 typeahead-min-length=3 typeahead-on-select=pickAddress($item) typeahead-loading=isGettingaddresses typeahead-template-url=autocompleteTemplate.html class=autocomplete-map-address id=typeaheader autocomplete=off></div></div>");
$templateCache.put("app/base/directives/groupparticipants.module.html","<script type=text/ng-template id=participantTemplate.html><div class=\"match-container\">	\n		<div class=\"match-container-parentname\">\n			<span ng-bind-html=\"match.model.field1 | uibTypeaheadHighlight:query\" ng-if=\"match.model.field1\"></span>\n			<span ng-bind-html=\"match.model.field2 | uibTypeaheadHighlight:query\" ng-if=\"match.model.field2\"></span>\n		</div>\n		<div>\n			<span translate=\"PARENTHESES_OPEN\" ng-if=\"match.model.field3\"></span><span ng-bind-html=\"(m | uibTypeaheadHighlight:query) + ($last ? \'\' : \', \')\" ng-repeat=\"m in match.model.field3 track by $index\"></span><span translate=\"PARENTHESES_CLOSE\" ng-if=\"match.model.field3\"></span>\n		</div>\n	</div></script><div class=manage-participants2><div class=search><input type=text autocorrect=off autocapitalize=off spellcheck=false ng-model=participant placeholder=\"{{ inputPlaceholder }}\" uib-typeahead=\"r.field1 for r in getParticipants($viewValue)\" typeahead-wait-ms=300 typeahead-min-length=2 typeahead-on-select=pickParticipant($item) typeahead-template-url=participantTemplate.html class=form-control></div><ul class=basket2 style=padding-top:0px><li ng-repeat=\"(key, item) in participants track by $index\" style=\"margin:9px 0\"><header class=tier-header ng-if=\"item.type !== \'user\' && item.groupId !== participants[key-1].groupId\"><figure class=avatar><span class=dripicons-user-group></span></figure>{{ item.groupName }} <a ng-click=toggleGroup(item.groupId)><span class=dripicons-chevron-down></span></a></header><div ng-class=\"{\'group\':item.type !== \'user\'}\" class=\"{{ item.groupId }}\"><div class=participant><figure class=avatar><avatar source={{item.avatar}} name=\"{{ item.firstName + \' \' + item.lastName }}\" width=40 height=40></avatar></figure>{{item.firstName}} {{item.lastName}} <span translate=PARENTHESES_OPEN ng-if=item.pupils></span><span ng-bind-html=\"(p.firstName | uibTypeaheadHighlight:query) + ($last ? \'\' : \', \')\" ng-repeat=\"p in item.pupils track by $index\"></span><span translate=PARENTHESES_CLOSE ng-if=item.pupils></span> <a ng-click=removeParticipant(item)><span class=dripicons-cross></span></a></div></div></li></ul></div>");
$templateCache.put("app/base/directives/grouptags.module.html","<script type=text/ng-template id=grouptagsTemplate.html><div class=\"match-container\">\n		<span ng-bind-html=\"match.model | uibTypeaheadHighlight:query\" ng-if=\"match.model\"></span>\n	</div></script><div class=group-tags><div><input type=text ng-model=tag placeholder=\"{{ inputPlaceholder }}\" uib-typeahead=\"r for r in getTags($viewValue)\" typeahead-focus-first=false typeahead-wait-ms=300 typeahead-min-length=2 typeahead-on-select=pickTag($item) ng-keyup=keyUp($event) typeahead-template-url=grouptagsTemplate.html class=tags-input style=\"color: #627293 !important\"></div><div class=tags-area><div class=tags><ul><li ng-repeat=\"tag in tags track by $index\">{{tag}} <span ng-click=removeTags($index) class=\"icon dripicons-cross\"></span></li></ul></div></div></div>");
$templateCache.put("app/base/directives/invite.accordion.directive.html","<div class=\"integration-invite-list user-list\" style=\"padding-top:10px; display: contents\"><div class=accordion ng-class=\"{active: accordionParent[$index].open}\" ng-repeat=\"p in invites\"><div ui-sref-active=active class=accordion__trigger ng-click=\"toggleAccordionFn({accordionList: accordionParent, index: $index})\"><strong style=\"word-wrap: break-word\">{{::p.firstName}} {{::p.lastName}} <span ng-if=p.misId>(Mis: {{::p.misId}})</span> - {{::p.email}} <span ng-if=p.invitationState>- </span><span ng-if=p.invitationState translate=\"{{ p.invitationState }}\"></span> <span ng-if=p.unsubscribed translate=UNSUBSCRIBED_USER></span> </strong><span class=\"dripicons-chevron-down pull-right accordion__chevron\" ng-show=!accordionParent[$index].open></span> <span class=\"dripicons-chevron-up pull-right accordion__chevron\" ng-show=accordionParent[$index].open></span></div><div class=\"accordion__content row\" style=\"margin: 0\"><div class=\"parent-accordion-item clearfix col-sm-6\"><table><thead><tr><th><div style=\"line-height: 30px; border-bottom: 1px solid #ccc; margin-bottom: 8px\"><span translate=MANAGE_USERS_PUPILS_TITLE_MOBILE></span></div></th><th><div style=\"line-height: 30px; border-bottom: 1px solid #ccc; margin-bottom: 8px; padding-left: 10px\">&nbsp;</div></th></tr></thead><tbody><tr ng-repeat=\"pupil in p.pupils\"><td style=\"padding-top: 10px\"><span>{{pupil.firstName}} {{pupil.lastName}} (Mis: {{pupil.misId}})</span></td><td style=\"font-style: italic; padding-left: 10px; line-height: 14px; padding-top: 10px\"><span>{{pupil.firstTier}} {{pupil.secondTier}}</span> <span ng-show=pupil.yearClass><b>{{pupil.yearClass}}</b></span></td></tr></tbody></table></div><div class=\"parent-accordion-item clearfix col-sm-6\"><strong style=\"line-height: 30px; border-bottom: 1px solid #ccc; margin-bottom: 8px\" class=sign-up-mobile translate=MANAGE_USERS_INVITE_TITLE></strong><p ng-hide=\"active_user.role == \'CLASS_REP\'\" class=telephone ng-if=p.email style=\"word-wrap: break-word\"><span class=\"dripicons-mail icon\"></span> {{::p.email}}</p></div><div class=\"parent-accordion-item clearfix col-sm-6\"><strong style=\"line-height: 30px; border-bottom: 1px solid #ccc; margin-bottom: 8px\" class=sign-up-mobile translate=MANAGE_USERS_SIGN_UP_TITLE></strong> <strong ng-if=p.created translate=MANAGE_USERS_NON_MEMBER></strong> <span ng-if=p.created translate=MANAGE_USERS_INVITED_ON></span> <span ng-if=p.created class=\"invite-date nonMember-date\">{{::p.created | date:\'dd/MM/yyyy\'}}</span><br><a ng-if=p.inviteLink ng-click=\"inviteLinkFn({parent: p})\" style=\"margin-top:10px;display: inline-flex\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 48 48\"><g transform=\"translate(0, 0)\"><path d=M19,37H14a13,13,0,0,1,0-26h5a2,2,0,0,1,0,4H14a9,9,0,0,0,0,18h5a2,2,0,0,1,0,4Z fill=#eb004e></path><path d=M34,37H29a2,2,0,0,1,0-4h5a9,9,0,0,0,0-18H29a2,2,0,0,1,0-4h5a13,13,0,0,1,0,26Z fill=#eb004e></path><path data-color=color-2 d=M34,26H14a2,2,0,0,1,0-4H34a2,2,0,0,1,0,4Z fill=#eb004e></path></g></svg> <span style=padding-left:5px translate=COPY_PRIVATE_LINK></span></a></div><div class=\"parent-accordion-item clearfix col-xs-12\"><div class=\"pull-right parent-approve-button\"><button type=button class=\"btn btn-primary\" translate=REMIND_BUTTON ng-click=\"inviteParentFn({parent: p})\"></button></div></div></div></div></div><div style=\"margin-top: 6px; text-align: center; background: #fff; padding: 10px; font-size: 22px; font-weight: 600; color: #001031\" ng-if=\"cursor.length > 1 && !searching\"><a ng-click=loadMoreFn() class=\"link ng-scope\" style=\"font-weight: normal; text-align: center; font-size: 15px; width: 100%\">Load more</a></div>");
$templateCache.put("app/base/directives/listingItem.directive.html","<div class=post-item-admin><div class=post-item-details><div class=padding-post><div class=row><div class=\"col-xs-2 col-sm-2 left-col-post\"><figure class=post-item-avatar ui-sref=\"users.parentdetail({\'id\':post.createdBy })\"><avatar class=\"visible-xs visible-sm\" source={{post.createdByAvatar}} name=\"{{ post.createdByName }}\" width=40 height=40 my=false></avatar><avatar class=\"visible-md visible-lg\" source={{post.createdByAvatar}} name=\"{{ post.createdByName }}\" width=60 height=60 my=false></avatar></figure></div><div class=\"col-xs-9 col-sm-9 padding-left-zero\"><div class=post-item-head><h4><a ui-sref=\"users.parentdetail({\'id\':post.createdBy })\">{{ post.createdByName }}</a> <span><span translate=POSTED_A_LISTING_IN class=posted-in></span> <a class=disabled-link><span class=listing-post__type-header translate=LISTING_CAT_{{post.type}}></span></a></span></h4><time><span translate=AT></span>{{post.postedAt | date:\' h:mm a\' }}, {{post.postedAt | date:\'MMM dd\'}}</time></div></div></div><div class=listing-post><div class=row><div class=\"col-xs-2 col-sm-2 left-col-post\"><div class=\"listing-type listing-type-{{post.type.toLowerCase()}}\"><span class=dripicons-web></span> <span class=dripicons-star></span> <span class=drip-gift><img src=assets/icons/gift.svg alt=\"\"> </span><span class=dripicons-pin></span> <span class=dripicons-flashlight></span> <span class=dripicons-tag></span></div></div><div class=\"col-xs-9 col-sm-9 padding-left-zero\"><div class=text><span ng-if=\"post.sold && (post.type == \'WANTED\' || post.type == \'LOST\')\" class=claimed-label translate=CLAIMED></span> <span ng-if=\"post.sold && post.type != \'WANTED\' && post.type != \'LOST\'\" class=claimed-label translate=SOLD></span> <span class=claimed-label>{{getCategory(post.category)}} </span><span ng-if=post.charitable class=claimed-label translate=CHARITY_LISTING></span><br><br><br><strong count-chars ng-bind-html=post.title class=multiple-line-text></strong><div count-chars ng-bind-html=post.description class=multiple-line-text></div><br><div ng-if=\"post.type == \'FOR_SALE\'\" class=free-price><div class=listing-type-{{post.type.toLowerCase()}}>{{post.price}}</div></div></div></div></div></div><div class=\"padding-post photo-padding\"><div ng-if=!isPostView() class=multiple-pictures-template ng-class=\"{\'single-forced\': post.photos.length == 1, \'single-picture\': post.photos.length == 1, \'double-picture\': post.photos.length == 2, \'multi-picture\': post.photos.length > 2}\" ng-click=openPost(post)><div ng-if=\"post.photos.length == 1\" class=\"picture-box single-picture-box\"><img ng-src=\"{{ post.photos[0].url }}\" alt=\"\"></div><div ng-if=\"post.photos.length > 1\" ng-repeat=\"att in post.photos | limitTo: 3\" class=picture-box style=\"background-image: url(\'{{ ::att.url }}=s0\')\"><div class=more-items-circle ng-if=\"post.photos.length > 3 && $last\"><div><div>+{{ post.photos.length - 3 }}</div></div></div></div></div><div ng-if=isPostView() class=view-post-pictures-separator><div ng-repeat=\"att in post.photos\" style=\"text-align: center\"><img ng-click=\"openPicture(post.photos, att)\" ng-src=\"{{ att.url }}=s900\" style=\"max-width: 100%; cursor: pointer\" alt=\"\"></div></div></div></div></div><div class=\"post-item-likes clearfix\"><div class=row><div class=col-md-12><nav style=\"overflow: auto\"><div style=\"float: right\"><a ng-if=!post.deleted translate=DELETE_POST ng-click=deletePost(post) style=\"color: #f06292\"></a> <span ng-if=post.deleted translate=POST_DELETED_BY_HOST style=\"color: #838383\"></span></div></nav></div></div></div></div>");
$templateCache.put("app/base/directives/notifications.directive.html","<nav class=notifications role=navigation id=notifications-component click-outside=closeNotif()><ul class=\"clearfix menu\"><li><a ng-click=\"getUnreadNotifications(); toggleNotif()\" class=top><span class=dripicons-bell></span> <span class=notification-number ng-show=\"viewState.notificationCount > 0\">{{viewState.notificationCount}}</span></a></li></ul><div class=notifications-dropdown-menu ng-class=\"{\'show\':viewState.showUnreadNotifications}\"><div class=\"notifications-header clearfix\"><strong class=pull-left translate=NOTIFICATIONS_WNUM translate-values=\"{\'n\':viewState.notificationCount}\"></strong></div><ul class=notification-items><li ng-repeat=\"m in unreadNotifications\" class=clearfix ng-click=notifRedirect(m.type)><div class=thread><div class=detail><strong>{{m.message}}</strong></div></div></li></ul><p class=loading ng-show=viewState.fetchingNotifications translate=LOADING_TXT></p><p class=loading ng-show=\"!viewState.fetchingNotifications && unreadNotifications.length === 0\" translate=NO_NEW_NOTIFICATIONS_TXT></p></div></nav>");
$templateCache.put("app/base/directives/parents.module.html","<script type=text/ng-template id=parentTemplate.html><a>\n		<span ng-bind-html=\"match.model.field1 | uibTypeaheadHighlight:query\" ng-if=\"match.model.field1\"></span>\n		<span ng-bind-html=\"match.model.field2 | uibTypeaheadHighlight:query\" ng-if=\"match.model.field2\"></span>\n	</a></script><div class=manage-parents><div class=search><input type=text ng-model=parent placeholder=\"{{ \'AMBASSADOR_PARENT_PHOLDER\' | translate }}\" uib-typeahead=\"(r.field1 + \' \' + r.field2) for r in getParents($viewValue)\" typeahead-wait-ms=300 typeahead-min-length=2 typeahead-on-select=pickParent($item) typeahead-template-url=parentTemplate.html class=form-control></div></div>");
$templateCache.put("app/base/directives/participants.module.html","<script type=text/ng-template id=participantTemplate.html><a>\n		<span ng-bind-html=\"match.model.field1 | uibTypeaheadHighlight:query\" ng-if=\"match.model.field1\"></span>\n		<span ng-bind-html=\"match.model.field2 | uibTypeaheadHighlight:query\" ng-if=\"match.model.field2\"></span>\n	</a></script><div class=manage-participants><div class=search><input type=text autocomplete=off autocorrect=off autocapitalize=off spellcheck=false ng-model=participant placeholder=\"{{ \'SEARCH_CLASS_OR_GROUP\' | translate }}\" uib-typeahead=\"r.field1 for r in getParticipants($viewValue)\" typeahead-wait-ms=300 typeahead-min-length=2 typeahead-on-select=pickParticipant($item) typeahead-template-url=participantTemplate.html class=form-control></div><ul class=basket><li ng-repeat=\"(key, item) in participants track by $index\"><header class=tier-header ng-if=\"item.type !== \'user\' && item.groupId !== participants[key-1].groupId\">{{ item.groupName }} {{ item.groupSize > 0 ? (\'(\'+item.groupSize + \')\') : \'\' }} <a ng-click=removeParticipant(item)><span class=dripicons-cross></span></a></header></li></ul></div>");
$templateCache.put("app/base/directives/percentageGraph.directive.html","<div class=\"c100 p0 p{{ percentage }} circle-graph\"><span>{{percentage}}%</span><div class=p>{{ text }}</div><div class=slice><div class=bar></div><div class=fill></div></div></div>");
$templateCache.put("app/base/directives/percentageGraphTwoColors.directive.html","<div class=circle-graph style=\"position: relative;\n		width: 130px;\n		height: 140px;\n		border-radius: 50%;\n		display: flex;\n		justify-content: center;\n		align-items: center;\n		font-family: Arial, sans-serif;\n		border: none\"><style>.circle-graph__svg {\n			width: 100%;\n			height: 100%;\n		}\n\n		.circle-graph > span {\n			position: absolute;\n			font-weight: 500 !important;\n			color: #20406b;\n			z-index: 5;\n		}\n\n		.circle-graph .p {\n			position: absolute;\n			font-size: 14px;\n			color: #7a7a7a;\n			text-align: center;\n			width: 100%;\n			z-index: 5;\n			margin-left: -2px;\n		}</style><svg class=circle-graph__svg viewBox=\"0 0 120 120\"><g transform=\"rotate(-90 60 60)\"><circle cx=60 cy=60 r=50 fill=none stroke=#d7dde9 stroke-width=10></circle><circle cx=60 cy=60 r=50 fill=none stroke=#1f5fbf stroke-width=10 stroke-linecap=round stroke-dasharray=314 ng-attr-stroke-dashoffset=\"{{ 314 - (314 * firstPercentage / 100) }}\"></circle><circle cx=60 cy=60 r=50 fill=none stroke=#6b768a stroke-width=10 stroke-linecap=round stroke-dasharray=314 ng-attr-stroke-dashoffset=\"{{ 314 - (314 * secondPercentage / 100) }}\" ng-attr-transform=\"rotate({{ firstPercentage * 3.6 }}, 60, 60)\"></circle></g></svg> <span style=\"color: #005cb8; font-size: 24px !important; margin-right: -5px\">{{percentage}}%</span><div class=p style=\"padding-top: 85px !important;\n			font-size: 10px !important;\n			margin-right: -5px;\n			padding-left: 5px\">{{ text }}</div></div>");
$templateCache.put("app/base/directives/photoUpload.directive.html","<div class=photo-uploader><div class=modal-header><h3 class=modal-title translate={{translations.title}}></h3></div><div class=modal-body><cropper events=events></cropper><a class=rotate-button ng-class=\"{\'visible\':saveDisabled === false}\" ng-click=rotate()><span class=dripicons-clockwise></span></a></div><div class=modal-helper><a ng-class=\"{\'visible\':saveDisabled === false}\" translate=CHOOSE_DIFFERENT_PHOTO ng-click=chooseAgain()></a><p translate={{translations.help}} ng-hide=\"saveDisabled === false\"></p><div ng-show=\"error.length > 0\" class=\"alert alert-error\"><p>{{ error }}</p></div></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary\" type=button ng-click=save() ng-disabled=saveDisabled><span translate=SAVE_BTN></span></button></div></div>");
$templateCache.put("app/base/directives/postAsset.admin.directive.html","<div class=post-item-admin mw=\"{{ userId == postUserId ? true : false }}\"><div class=post-item-details><div class=padding-post><div class=row><div class=\"col-xs-2 col-sm-2 left-col-post\"><figure class=post-item-avatar ui-sref=\"users.parentdetail.contact({\'id\':post.userId })\"><avatar class=\"visible-xs visible-sm\" source={{post.avatar}} name=\"{{ post.postedBy }}\" width=40 height=40 my=false></avatar><avatar class=\"visible-md visible-lg\" source={{post.avatar}} name=\"{{ post.postedBy }}\" width=60 height=60 my=false></avatar></figure></div><div class=\"col-xs-9 col-sm-9 padding-left-zero\"><div class=post-item-head><h4><a ng-show=\"post.type != \'classlist\'\" ui-sref=\"users.parentdetail({\'id\':post.userId })\">{{ post.postedBy }}</a> <strong class=strong-noclick ng-show=\"post.type === \'classlist\'\">{{ post.postedBy }}</strong> <span><span ng-show=\"post.type === \'welcome\'\" translate=JOINED_IN class=posted-in></span> <span ng-show=\"post.type === \'group\'\" translate=POSTED_IN class=posted-in></span> <span ng-show=\"post.type === \'announcement\'\" translate=ANNOUNCEMENT_IN_GROUPS class=posted-in></span> <span ng-show=\"post.type === \'event\'\" translate=CREATED_PRIVATE_EVENT class=posted-in></span> <span ng-show=\"post.type === \'raffle\'\" translate=MONITOR_CREATED_RAFFLE class=posted-in></span> <span ng-show=\"post.type == \'listing\'\" translate=POSTED_A_LISTING_IN class=posted-in></span> <a class=disabled-link><strong ng-show=\"post.type === \'announcement\' || post.type === \'event\' || post.type === \'raffle\' || post.type === \'group\'\">{{ post.groupName }}</strong> <span class=listing-post__type-header ng-show=\"post.type === \'listing\'\" translate=LISTING_CAT_{{post.listingCategory}}></span> <strong ng-show=\"post.type === \'welcome\'\">{{ post.groupName }}</strong></a></span></h4><time><span translate=AT></span>{{post.postedOn | date:\' h:mm a\' }}, {{post.postedOn | date:\'MMM dd\'}}</time><p count-chars ng-bind-html=post.body class=\"multiple-line-text post-text\" ng-show=\"post.type === \'group\'\"></p></div></div></div><div ng-show=\"post.type === \'listing\'\" class=\"listing-post {{ post.photo !== undefined && post.type === \'listing\' && post.listingPrice ? \'listing-margin-picture\' : \'\' }}\"><div class=row><div class=\"col-xs-2 col-sm-2 left-col-post\"><div class=\"listing-type listing-type-{{post.listingCategory.toLowerCase()}}\"><span class=dripicons-web></span> <span class=dripicons-star></span> <span class=drip-gift><img src=assets/icons/gift.svg alt=\"\"> </span><span class=dripicons-suitcase></span> <span class=dripicons-flashlight></span> <span class=dripicons-tag></span></div></div><div class=\"col-xs-9 col-sm-9 padding-left-zero\"><div class=text><span ng-if=\"post.sold && post.listingCategory == \'FREE\'\" class=claimed-label translate=CLAIMED></span> <span ng-if=\"post.sold && post.listingCategory == \'FOR_SALE\'\" class=claimed-label translate=SOLD></span> <span ng-if=\"post.sold && post.listingCategory == \'OFFER\'\" class=claimed-label translate=SOLD></span> <span ng-if=\"post.sold && post.listingCategory == \'LOST_FOUND\'\" class=claimed-label translate=FOUND></span> <span ng-if=\"post.sold && post.listingCategory == \'WANTED\'\" class=claimed-label translate=FOUND></span> <span ng-if=\"post.sold && post.listingCategory != \'FREE\' && post.listingCategory != \'FOR_SALE\' && post.listingCategory != \'OFFER\' && post.listingCategory != \'LOST_FOUND\' && post.listingCategory != \'WANTED\'\" class=claimed-label translate=SOLD></span> <span count-chars ng-bind-html=post.title class=multiple-line-text></span> <strong count-chars ng-bind-html=post.body class=multiple-line-text></strong><br><div ng-if=post.listingPrice class=free-price><div class=listing-type-{{post.listingCategory.toLowerCase()}}>{{post.listingPrice}}</div></div></div></div></div></div><div ng-if=post.attachments class=\"padding-post photo-padding\"><div ng-if=!isPostView() class=\"multiple-pictures-template {{ getPostPictures(post.attachments).pictures.length == 1 ? \'single-forced\' : \'\' }} {{ ::getPostPictures(post.attachments).cssclass }}\" ng-click=openPost(post)><div ng-if=\"getPostPictures(post.attachments).pictures.length == 1\" class=\"picture-box single-picture-box\"><img ng-src=\"{{ ::getPostPictures(post.attachments).pictures[0].url }}\" alt=\"\"></div><div ng-if=\"getPostPictures(post.attachments).pictures.length > 1\" ng-repeat=\"att in ::getPostPictures(post.attachments).pictures | limitTo: 3\" class=picture-box style=\"background-image: url(\'{{ ::att.url }}=s0\')\"><div class=more-items-circle ng-if=\"::getPostPictures(post.attachments).pictures.length > 3 && $last\"><div><div>+{{ ::(getPostPictures(post.attachments).pictures.length - 3) }}</div></div></div></div></div><div ng-if=isPostView() class=view-post-pictures-separator><div ng-repeat=\"att in getPostPictures(post.attachments).pictures\" style=\"text-align: center\"><img ng-click=\"openPicture(post.attachments, att)\" ng-src=\"{{ att.url }}=s900\" style=\"max-width: 100%; cursor: pointer\" alt=\"\"></div></div></div><div class=home-files-list><div ng-if=\"post.files && post.files.length > 0\"><div ng-repeat=\"att in post.files track by $index\" style=\"border-bottom: none\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 48 48\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><path fill=none stroke=#8a94a2 stroke-width=4 stroke-linecap=round stroke-miterlimit=10 d=\"M36,8v25 c0,7.2-5.8,13-13,13h0c-7.2,0-13-5.8-13-13V11c0-5,4-9,9-9h0c5,0,9,4,9,9v20c0,2.8-2.2,5-5,5h0c-2.8,0-5-2.2-5-5V14\" stroke-linejoin=round></path></g></svg> <a href=\"{{ att.url }}\" target=_blank>{{ att.name }}</a></div></div></div><div ng-show=\"post.type === \'announcement\'\" class=listing-post><div class=row><div class=\"col-xs-2 col-sm-2 left-col-post\"><div class=\"listing-type listing-type-announcement\"><span class=drip-ann style=\"display: block\"><img src=assets/icons/announcement_pin.png alt=\"\" style=\"width: 20px\"></span></div></div><div class=\"col-xs-8 col-sm-8 padding-left-zero\"><div class=text><strong count-chars data-ng-bind-html=trustAsHtml(post.body) class=multiple-line-text></strong></div></div></div></div><div ng-show=\"post.type === \'event\'\" class=listing-post><div class=row><div class=\"col-xs-2 col-sm-2 left-col-post\"><div class=\"listing-type listing-type-announcement\"><span class=\"dripicons-calendar icon\" style=\"display: block; font-size: 17px; margin-top: 2px\"></span></div></div><div class=\"col-xs-8 col-sm-8 padding-left-zero\"><div class=text><strong count-chars ng-bind-html=post.body class=multiple-line-text></strong></div></div></div></div><div ng-show=\"post.type === \'raffle\'\" class=listing-post><div class=row><div class=\"col-xs-2 col-sm-2 left-col-post\"><div class=\"listing-type listing-type-announcement\"><svg style=\"margin-top: 3px;margin-left: 3px\" width=25px height=18px viewBox=\"0 0 37 27\" version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink><title>Group 5</title><g id=Parents stroke=none stroke-width=1 fill=none fill-rule=evenodd stroke-linecap=square><g id=Group-5 transform=\"translate(1.000000, 2.000000)\" stroke=currentColor stroke-width=2><path d=\"M19.3454545,16 C19.3454545,14.343 20.7128727,13 22.4,13 L22.4,8 L0,8 L0,13 C1.68712727,13 3.05454545,14.343 3.05454545,16 C3.05454545,17.657 1.68712727,19 0,19 L0,24 L22.4,24 L22.4,19 C20.7128727,19 19.3454545,17.657 19.3454545,16 Z\" id=Path></path><line x1=7.2 y1=14 x2=15.2 y2=14 id=Path></line><line x1=7.2 y1=18 x2=15.2 y2=18 id=Path></line><polyline id=Path points=\"22.3146769 5.79372273 25.1384615 0 25.1384615 0 27.9622462 5.79372273 34.2769231 6.722717 29.7076923 11.2321329 30.7864877 17.6 25.1384615 14.5937227\"></polyline></g></g></svg></div></div><div class=\"col-xs-8 col-sm-8 padding-left-zero\"><div class=text><strong count-chars ng-bind-html=post.body class=multiple-line-text></strong></div></div></div></div><div ng-show=\"post.type === \'classlist\'\" class=listing-post><div class=row><div class=\"col-xs-2 col-sm-2 left-col-post\"><div></div></div><div class=\"col-xs-9 col-sm-9 padding-left-zero\"><div class=text><p ng-bind-html=post.body class=multiple-line-text></p></div></div></div></div></div></div><div class=\"row who-likes\" ng-if=\"post.likeCount > 0\"><div class=\"col-xs-2 col-sm-2 row-force-fleft like-button-col left-col-post\"></div><div ng-click=showLikers(post) class=\"col-xs-9 col-sm-9 padding-left-zero\" style=\"cursor: pointer\"><div ng-if=\"post.type != \'welcome\'\"><span ng-if=!post.isLiked class=likes-text><span>{{ post.lastLike[0] }}</span> <span ng-if=\"post.likeCount > 1\" translate=NUM_LIKES translate-values=\"{\'num\':post.likeCount-1}\"></span> <span ng-if=\"post.likeCount == 1\" translate=LIKES_THIS></span> </span><span ng-if=\"post.isLiked && post.likeCount > 1\" class=likes-text translate=NUM_OTHER_LIKES translate-values=\"{\'num\':post.likeCount-1}\"></span> <span ng-if=\"post.isLiked && post.likeCount <= 1\" translate=NUM_MY_LIKE class=likes-text></span></div><div ng-if=\"post.type == \'welcome\'\"><span ng-if=!post.isLiked class=likes-text><span ng-if=\"post.likeCount > 1\" translate=OTHERS_WELCOMED translate-values=\"{\'name\':post.lastLike[0], \'num\':post.likeCount-1}\"></span> <span ng-if=\"post.likeCount == 1\" translate=SOMEONE_WELCOMED translate-values=\"{\'name\':post.lastLike[0]}\"></span> </span><span ng-if=\"post.isLiked && post.likeCount > 1\" class=likes-text translate=ME_OTHERS_WELCOMED translate-values=\"{\'num\':post.likeCount-1}\"></span> <span ng-if=\"post.isLiked && post.likeCount <= 1\" translate=ME_WELCOMED class=likes-text></span></div></div></div><div class=\"post-item-likes clearfix\"><div class=row><div class=col-md-12><nav style=\"overflow: auto\"><div style=\"float: right\"><a ng-if=\"!post.deleted && post.type !== \'event\' && post.type !== \'raffle\'\" translate=DELETE_POST ng-click=deletePost() style=\"color: #f06292\"></a> <span ng-if=post.deleted translate=POST_DELETED_BY_HOST style=\"color: #838383\"></span></div></nav></div></div></div><div class=post-item-comment ng-show=\"post.commentCount > 0\" style=\"background: #fff\"><div class=vi-row ng-if=\"post.comments.length < post.commentCount\"><div class=vi-col-right><span class=comment-num style=\"margin-top: 0; margin-bottom: 10px; font-size: 14px\"><span>{{ post.comments.length }} <span translate=OF></span></span> {{ post.commentCount }}</span></div><div class=vi-col-middle style=\"padding-left: 5px\"><div ng-hide=post.hideMoreComm><a class=view-previous-comments ng-click=getMoreComments(post) style=\"margin-top: 0; margin-bottom: 10px; font-size: 14px; padding-left: 2px\" translate=VIEW_PREV_COMMENTS></a></div></div></div><div class=comment-item ng-repeat=\"cmm in post.comments\" style=\"margin-bottom: 0\"><div class=row><div class=\"col-xs-2 col-sm-2 left-col-post\"><figure class=comment-item-avatar ui-sref=\"users.parentdetail({\'id\':cmm.userId })\"><avatar source={{cmm.avatar}} name=\"{{ cmm.postedBy }}\" width=60 height=60 my=false></avatar></figure></div><div class=\"col-xs-9 col-sm-9 padding-left-zero\"><div class=comment-text-section style=\"overflow: auto; background: #eff1f3; border-radius: 10px; padding: 6px 8px\"><div class=\"multiple-line-text comment-text\"><a ui-sref=\"users.parentdetail({\'id\':cmm.userId })\">{{cmm.postedBy}}</a> <span ng-bind-html=cmm.body></span></div><div ng-if=\"cmm.attachment && cmm.attachment.url != \'\' && !cmm.attachment.fileView\" style=\"overflow: auto; width: 100%; height: 100%; margin-top: 10px;max-width: 250px; max-height: 250px; cursor: pointer\" id=image-preview-wrapper><div ng-click=openCommentImage(cmm.attachment.url) style=\"margin-bottom: 3px;text-align: center\"><img ng-src={{cmm.attachment.url}} style=\"height: 100%; width: 100%\"></div></div><br><div class=home-files-list ng-if=\"cmm.attachment && cmm.attachment.url != \'\' && cmm.attachment.fileView\" style=\"padding-left: 2px; margin-top: 0px !important\"><div><div style=\"border-bottom: none\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 48 48\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><path fill=none stroke=#8a94a2 stroke-width=4 stroke-linecap=round stroke-miterlimit=10 d=\"M36,8v25 c0,7.2-5.8,13-13,13h0c-7.2,0-13-5.8-13-13V11c0-5,4-9,9-9h0c5,0,9,4,9,9v20c0,2.8-2.2,5-5,5h0c-2.8,0-5-2.2-5-5V14\" stroke-linejoin=round></path></g></svg> <a href=\"{{ cmm.attachment.url }}\" target=_blank style=\"word-break: break-word\">{{ cmm.attachment.fileName }}</a></div></div></div><div><time><span translate=AT></span>{{cmm.created | date:\'HH:mm\' }}, {{cmm.created | date:\'MMM dd\'}} </time><a data-icon=9 class=icon ng-click=deleteComment(cmm.id)></a></div></div><div ng-show=\"cmm.totalReplyCount > 2\"><a class=view-previous-comments ng-click=getMoreReplies(cmm) style=\"margin: 10px 0px 20px; padding-left: 2px; font-size: 14px\" translate=VIEW_PREV_REPLIES translate-values=\"{ \'moreReplyCount\': cmm.totalReplyCount - cmm.replies.length}\"></a></div><div class=row ng-if=\"cmm.totalReplyCount > 0\" ng-repeat=\"r in cmm.replies\"><div class=\"col-xs-2 col-sm-2 left-col-post\" style=\"margin-top: 15px\"><figure class=comment-item-avatar ui-sref=\"users.parentdetail({\'id\':r.userId })\"><avatar source={{r.avatar}} name=\"{{ r.postedBy }}\" width=60 height=60 my=false></avatar></figure></div><div class=\"col-xs-9 col-sm-9 padding-left-zero\"><div class=comment-text-section style=\"overflow: auto; background: #eff1f3; border-radius: 10px; padding: 6px 8px; float: left; margin-top: 15px\"><div class=\"multiple-line-text comment-text\"><a ui-sref=\"users.parentdetail({\'id\':r.userId })\">{{r.postedBy}}</a> <span ng-bind-html=r.body></span></div><div ng-if=\"r.attachment && r.attachment.url != \'\' && !r.attachment.fileView\" style=\"overflow: auto; width: 100%; height: 100%; margin-top: 10px;max-width: 250px; max-height: 250px; cursor: pointer\" id=image-preview-wrapper><div ng-click=openCommentImage(r.attachment.url) style=\"margin-bottom: 3px;text-align: center\"><img ng-src={{r.attachment.url}} style=\"height: 100%; width: 100%\"></div></div><br><div class=home-files-list ng-if=\"r.attachment && r.attachment.url != \'\' && r.attachment.fileView\" style=\"padding-left: 2px; margin-top: 0px !important\"><div><div style=\"border-bottom: none\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 48 48\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><path fill=none stroke=#8a94a2 stroke-width=4 stroke-linecap=round stroke-miterlimit=10 d=\"M36,8v25 c0,7.2-5.8,13-13,13h0c-7.2,0-13-5.8-13-13V11c0-5,4-9,9-9h0c5,0,9,4,9,9v20c0,2.8-2.2,5-5,5h0c-2.8,0-5-2.2-5-5V14\" stroke-linejoin=round></path></g></svg> <a href=\"{{ r.attachment.url }}\" target=_blank style=\"word-break: break-word\">{{ r.attachment.fileName }}</a></div></div></div><div><time><span translate=AT></span>{{r.created | date:\'HH:mm\' }}, {{r.created | date:\'MMM dd\'}} </time><a data-icon=9 class=icon ng-click=\"deleteComment(cmm.id, r.id)\"></a></div></div></div></div></div></div></div><br></div></div>");
$templateCache.put("app/base/directives/postAsset.confirmReportModal.directive.html","<div class=assign-parent-admin ng-class=\"{\'not-ready\':!viewState.isReady}\"><div class=modal-header><h3 translate=REPORT_POST_DIALOG_TITLE translate-values={name:user.name}></h3></div><div class=modal-body><p translate=REPORT_POST_DIALOG_TEXT></p></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-default\" type=button ng-click=report()><span translate=REPORT_BTN></span></button></div></div>");
$templateCache.put("app/base/directives/postAsset.directive.confirm-delete-comment.html","<div class=\"assign-parent-admin delete-comment\" ng-class=\"{\'not-ready\':!viewState.isReady}\"><div class=modal-header><h3 translate=DELETE_COMMENT_TITLE></h3></div><div class=modal-body><p translate=DELETE_COMMENT_TEXT></p></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-default\" type=button ng-click=delete()><span translate=DELETE_BTN></span></button></div></div>");
$templateCache.put("app/base/directives/postAsset.directive.confirm-delete-post.html","<div class=\"assign-parent-admin delete-post\" ng-class=\"{\'not-ready\':!viewState.isReady}\"><div class=modal-header><h3 translate=DELETE_POST_TITLE></h3></div><div class=modal-body><p translate=DELETE_POST_TEXT></p></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-default\" type=button ng-click=delete()><span translate=DELETE_BTN></span></button></div></div>");
$templateCache.put("app/base/directives/postAsset.directive.html","<div class=post-item mw=\"{{ userId == postUserId ? true : false }}\" style=\"{{ commentOnly ? \'width:100%; border: none !important;\' : \'\' }}\"><div class=post-container style=\"{{ isPostView() ? \'border: solid 1px #d8d8d8;\' : \'\' }}{{ commentOnly ? \'width:100%; border: none !important;\' : \'\' }}\"><div class=post-item-details ng-show=\"post.isOwn && post.type == \'event\'\"><!-- Need to add section header for comments here --><nav ng-hide=commentOnly class=\"has-dropdown-click is-relative more-dots\" style=\"margin-top: 0; position: absolute; top: 1px; right: 0px; z-index: 11; height: 20px\"><ul ng-if=post.menuOpened class=dropdown-menu style=\"right: 15px!important; background: #fff!important\"><li ng-if=\"post.isOwn && post.type != \'welcome\'\"><a translate=\"{{ post.commentLocked ? \'UNLOCK_COMMENTS\' : \'LOCK_COMMENTS\'}}\" ng-click=lockComments()></a></li></ul><svg ng-click=togglePostMenu(post) style=\"transform: rotate(90deg); height: 45px; margin-top: 0; margin-right: 15px; position: relative; padding: 1px 1px; width: 18px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=32px height=32px viewBox=\"0 0 32 32\"><g transform=\"translate(0, 0)\"><circle fill=#4a9fef cx=4 cy=16 r=3></circle><circle data-color=color-2 fill=#4a9fef cx=16 cy=16 r=3></circle><circle fill=#4a9fef cx=28 cy=16 r=3></circle></g></svg></nav></div><div class=post-item-details ng-hide=commentOnly><div class=padding-post style=\"padding-bottom: 0\"><nav ng-if=post.isOwn ng-show=\"post.type !== \'NEW_GROUP\' && post.type !== \'welcome\' && !post.event\" class=\"has-dropdown-click is-relative more-dots\" style=\"margin-top: 0; position: absolute; top: 1px; right: 2px; z-index: 11; height: 50px\"><ul ng-if=post.menuOpened class=dropdown-menu style=\"right: 1px!important; background: #fff!important\"><li ng-if=\"post.isOwn && post.type != \'welcome\' && !readonly && post.type != \'announcement\' && !post.event\"><a translate=EDIT_POST ng-click=edit()></a></li><li ng-if=\"post.isOwn && post.type != \'welcome\'\"><a translate=\"{{ post.commentLocked ? \'UNLOCK_COMMENTS\' : \'LOCK_COMMENTS\'}}\" ng-click=lockComments()></a></li><li ng-if=\"post.isOwn && post.type==\'listing\' && !post.sold\"><a ng-if=\"post.listingCategory ==\'OFFER\'\" translate=LISTING_SOLD ng-click=markSold()></a> <a ng-if=\"post.listingCategory ==\'WANTED\'\" translate=LISTING_CLAIMED ng-click=markSold()></a> <a ng-if=\"post.listingCategory ==\'LOST_FOUND\'\" translate=LISTING_FOUND ng-click=markSold()></a></li><li ng-if=\"post.isOwn && post.type==\'listing\' && post.sold\"><a ng-if=\"post.listingCategory ==\'OFFER\'\" translate=LISTING_UNSOLD ng-click=markUnsold()></a> <a ng-if=\"post.listingCategory ==\'WANTED\'\" translate=LISTING_UNCLAIMED ng-click=markUnsold()></a> <a ng-if=\"post.listingCategory ==\'LOST_FOUND\'\" translate=LISTING_NOTFOUND ng-click=markUnsold()></a></li></ul><svg ng-click=togglePostMenu(post) style=\"transform: rotate(90deg); height: 45px; margin-top: 0; position: relative; padding: 1px 15px; width: 48px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=32px height=32px viewBox=\"0 0 32 32\"><g transform=\"translate(0, 0)\"><circle fill=#4a9fef cx=4 cy=16 r=3></circle><circle data-color=color-2 fill=#4a9fef cx=16 cy=16 r=3></circle><circle fill=#4a9fef cx=28 cy=16 r=3></circle></g></svg></nav><div class=vi-row ng-class=\"{\'mobile-announcement-detail-view\': postContext == \'ANNOUNCEMENT_DETAIL_VIEW\'}\"><div class=vi-col-left><figure ng-show=!post.sample class=post-item-avatar ng-click=\"openUserHome(post.userId, post)\"><avatar class=\"visible-xs visible-sm\" source=\"{{ ::post.avatar }}\" name=\"{{ ::post.postedBy }}\" width=40 height=40 my=false></avatar><avatar class=\"visible-md visible-lg\" source=\"{{ ::post.avatar }}\" name=\"{{ ::post.postedBy }}\" width=60 height=60 my=false></avatar></figure><figure ng-show=post.sample class=post-item-avatar><avatar class=\"visible-xs visible-sm\" source=\"{{ ::post.avatar }}\" name=\"{{ ::post.postedBy }}\" width=40 height=40 my=false></avatar><avatar class=\"visible-md visible-lg\" source=\"{{ ::post.avatar }}\" name=\"{{ ::post.postedBy }}\" width=60 height=60 my=false></avatar></figure></div><div class=vi-col-middle><div><h4 style=\"margin-right: 30px; display: block; {{ (post.type == \'announcement\' || post.event) ? \'margin-top: 0;\' : \'\' }}\"><a ng-show=!post.sample ng-click=\"openUserHome(post.userId, post)\" style=\"line-height: 20px\" class=\"HEADER2 post-username {{ post.sample ? \'disabled\' : \'\' }}\">{{ ::post.postedBy }}</a> <span ng-show=post.sample><a class=\"disabled HEADER2\">{{ ::post.postedBy }}</a></span><div style=\"line-height: 24px; position: relative\"><span ng-show=\"::post.type == \'welcome\'\" class=posted-in>{{ ::post.body }}</span> <span ng-show=\"::post.type == \'NEW_GROUP\'\" translate=CREATED_GROUP class=posted-in></span> <span ng-show=\"::post.type == \'welcome\'\" translate=JOINED_IN class=posted-in></span> <span ng-show=\"::post.type == \'announcement\' && isCommentAndLikeDisabled != true\" translate=ANNOUNCEMENT_IN_GROUPS class=posted-in></span> <span ng-show=\"::post.type == \'announcement\' && isCommentAndLikeDisabled == true\" translate=SCHEDULED_ANNOUNCEMENT_IN_GROUPS class=posted-in></span> <span ng-show=\"::post.event && post.event.type != \'PARENT\'\" translate=CREATED_COMMUNITY_EVENT class=posted-in></span> <span ng-show=\"::post.event && post.event.type == \'PARENT\'\" translate=CREATED_PRIVATE_EVENT class=posted-in></span> <a ng-if=\"post.type != \'group\' && post.type != \'announcement\' && !post.event\"><strong ng-show=\"post.type === \'announcement\' || post.type === \'group\'\">{{ post.groupName }}</strong> </a><span ng-show=\"post.type == \'welcome\'\"><a ng-click=onGroupTap(post.groupId)><strong style=\"color: #4a9fef\">{{ post.groupName }}</strong></a></span></div></h4><div ng-show=\"!(post.type != \'classlist\' && post.type != \'NEW_GROUP\' && post.type != \'announcement\' && post.type != \'listing\' && !post.event)\" style=\"display: inline-block\"><time><span translate=AT></span>{{post.postedOn | date:\'h:mm a\' }}, {{post.postedOn | date:\'MMM dd\'}}</time></div><div ng-show=\"post.type != \'classlist\' && post.type != \'NEW_GROUP\' && post.type != \'announcement\' && post.type != \'listing\' && !post.event\" style=\"display: inline-block\"><time ng-if=\"post.type != \'announcement\'\">{{ post.postedOn | timeago }}: </time><span><a ng-click=onGroupTap(post.groupId) class=drip-group><span style=\"line-height: 22px\">{{post.groupName}} </span><svg style=\"position: relative; top: 4px; left: -3px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polygon fill=#4a9fef points=\"6,13.4 4.6,12 8.6,8 4.6,4 6,2.6 11.4,8 \"></polygon></g></svg></a></span></div></div></div><!-- Mobile 3-dot menu for announcements --><nav ng-if=\"postContext == \'ANNOUNCEMENT_DETAIL_VIEW\' && post.type == \'announcement\' && (post.isOwn || (userRole == \'AMBASSADOR\' || userRole == \'STAFF\'))\" class=\"has-dropdown is-relative pull-right mobile-menu post-asset-mobile-menu\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=40px height=40px viewBox=\"0 0 64 64\" style=\"width: 40px !important; height: 40px !important\"><g transform=\"translate(0, 0)\"><circle fill=#8A94A2 cx=8 cy=32 r=6></circle><circle data-color=color-2 fill=#8A94A2 cx=32 cy=32 r=6></circle><circle fill=#8A94A2 cx=56 cy=32 r=6></circle></g></svg><ul class=dropdown-menu style=\"top: 7px; right: 24px; min-width: 120px\"><li ng-class=\"{ \'disabled-container\': !post.isOwn }\"><a ng-click=onEditAnnouncement()><span translate=EDIT_BTN></span></a></li><li><a ng-click=onDuplicateAnnouncement()><span translate=DUPLICATE_BTN></span></a></li><li style=\"border-top: 1px solid #E1E1E1\"><a ng-click=onDeleteAnnouncement()><span translate=DELETE_BTN></span></a></li></ul></nav></div><div ng-if=\"post.type == \'announcement\' || post.event\" style=\"height: 10px\"></div><p count-chars ng-bind-html=post.body class=\"multiple-line-text post-text\" ng-show=\"post.type == \'group\'\" style=\"margin-bottom: 8px\"></p><div ng-if=post.linkPreview><linkpreview url={{post.linkPreview}}></linkpreview></div></div><div class=mkp-spacer></div><div ng-show=\"post.type == \'listing\'\" class=listing-labels-container style=\"{{ post.attachments.length > 0 ? \'height: 0\' : \'\' }}\" ng-click=openPost(post)><div class=\"listing-post listing-labels {{ post.attachments.length > 0 ? \'active\' : \'\' }} {{ post.photo !== undefined && post.type === \'listing\' && hasPrice() ? \'listing-margin-picture\' : \'\' }}\"><div style=\"z-index: 1; position: relative\"><div><div ng-repeat=\"c in categories\"><div style=\"{{ post.sold ? \'background: #ff5a5a;\' : \'\' }} margin-left: 10px\" ng-show=\"post.listingCategory == c.toUpperCase()\" is-selected=\"{{post.category === c}}\" id={{c}} ng-class=\"{\'category-item-post category-item-post_{{c}}\': post.category === c || post.category !== c}\"><span class=category-name style=\"color: #fff\" ng-if=\"post.sold && post.listingCategory == \'OFFER\'\" translate=LABEL_SOLD></span> <span class=category-name style=\"color: #fff\" ng-if=\"post.sold && post.listingCategory == \'WANTED\'\" translate=LABEL_CLAIMED></span> <span class=category-name style=\"color: #fff\" ng-if=\"post.sold && post.listingCategory == \'LOST_FOUND\'\" translate=LABEL_FOUND></span><div ng-show=\"!post.sold && post.listingCategory == c.toUpperCase()\" is-selected=\"{{post.category === c}}\" id={{c}} ng-class=\"{\'category-item-post category-item-post_{{c}}\': post.category === c || post.category !== c}\"><span class=category-name translate=\"POST_CAT_{{c | uppercase}}\"></span></div></div></div><div ng-if=\"post.type == \'listing\' && hasPrice()\" style=\"float: left; margin-left: 6px\"><div class=\"price-without-photo listing-type-{{post.listingCategory.toLowerCase()}}\" style=\"height: auto\"><span class=price-without-photo_text><span style=\"float: left\" translate=\"{{ post.currency }}_SHORT\"></span> {{ hasPrice() }}</span></div></div><div ng-if=\"post.type === \'listing\' && hasPrice() && post.ptaPercentage\"><div class=\"price-without-photo donation-offer listing-type-{{post.listingCategory.toLowerCase()}}\" style=\"height: auto\"><span class=price-without-photo_text>{{ doInt(post.ptaPercentage*100) }}% {{post.sold ? \"raised\" : \"donation\"}}</span></div></div></div></div></div></div><div ng-show=\"post.type != \'classlist\'\" class=\"padding-post photo-padding\"><div ng-if=!isPostView() class=\"multiple-pictures-template {{ getPostPictures(post.attachments).pictures.length == 1 || (post.type == \'listing\' || post.event) ? \'single-forced\' : \'\' }} {{ ::getPostPictures(post.attachments).cssclass }}\" ng-click=openPost(post)><div ng-if=\"(post.type == \'listing\' || post.event) && getPostPictures(post.attachments).pictures.length > 0\" class=\"picture-box single-picture-box\"><div style=\"background-size: cover; background-position: center; position: relative; padding-bottom: 50%; background-image: url({{ ::getPostPicture() }})\"></div></div><div ng-if=\"post.type != \'listing\' && !post.event && getPostPictures(post.attachments).pictures.length == 1\" class=\"picture-box single-picture-box\"><img alt=\"\" ng-src=\"{{ ::(getPostPictures(post.attachments).pictures[0].url + (!post.event ? \'=s0\' : \'\')) }}\"></div><div ng-if=\"post.type != \'listing\' && !post.event && getPostPictures(post.attachments).pictures.length > 1\" ng-repeat=\"att in getPostPictures(post.attachments).pictures | limitTo: 3\" class=picture-box style=\"background-image: url(\'{{ att.url }}=s0\')\"><div class=more-items-circle ng-if=\"getPostPictures(post.attachments).pictures.length > 3 && $last\"><div><div>+{{ (getPostPictures(post.attachments).pictures.length - 3) }}</div></div></div></div></div><div ng-if=isPostView() class=view-post-pictures-separator><div ng-repeat=\"att in getPostPictures(post.attachments).pictures\" style=\"text-align: center\"><img alt=\"\" ng-click=\"openPicture(post.attachments, att)\" ng-src=\"{{ att.url }}=s0\" style=\"max-width: 100%; cursor: pointer; width: 100%\"></div></div></div><div ng-show=\"post.type == \'classlist\'\" class=\"padding-post photo-padding\" style=\"margin-top: 10px\"><div ng-if=!isPostView() class=\"multiple-pictures-template {{ getPostPictures(post.attachments).pictures.length == 1 ? \'single-forced\' : \'\' }} {{ ::getPostPictures(post.attachments).cssclass }}\" ng-click=openClasslistPost(post)><div ng-if=\"getPostPictures(post.attachments).pictures.length == 1\" class=\"picture-box single-picture-box\"><img alt=\"\" ng-src=\"{{ ::(getPostPictures(post.attachments).pictures[0].url + \'=s0\') }}\"></div><div ng-if=\"getPostPictures(post.attachments).pictures.length > 1\" ng-repeat=\"att in getPostPictures(post.attachments).pictures | limitTo: 3\" class=picture-box style=\"background-image: url(\'{{ att.url }}=s0\')\"><div class=more-items-circle ng-if=\"::getPostPictures(post.attachments).pictures.length > 3 && $last\"><div><div>+{{ ::(getPostPictures(post.attachments).pictures.length - 3) }}</div></div></div></div></div></div><div ng-click=openPost(post) ng-if=\"!isPostView() && post.type == \'listing\'\" class=\"padding-post post-text {{ getPostPictures(post.attachments).pictures.length > 0 ? \'mkp-body-picture1\' : \'\' }}\" style=\"padding-bottom: 6px; padding-top: 5px\"><div><div style=\"overflow: auto\" class=\"text mkp-body\"><div class=mkp-title>{{ post.title }}</div><div ng-if=post.body class=mkp-descr ng-bind-html=post.body></div></div></div></div><div ng-click=openPost(post) ng-if=\"!isPostView() && post.event\" class=\"padding-post post-text {{ getPostPictures(post.attachments).pictures.length > 0 ? \'mkp-body-picture1\' : \'\' }}\" style=\"padding-bottom: 6px; padding-top: 5px\"><div><div style=\"overflow: auto\" class=\"text mkp-body\"><div class=mkp-title>{{ post.event.title }}</div><div ng-if=post.event.description class=mkp-descr ng-bind-html=getEventDescription(post.event.description)></div></div></div><div ng-if=post.event class=details-attachment-list><ul class=details-attachment-list style=\"font-size: 14px; font-weight: normal\"><li style=\"color: #FF5D92; text-transform: uppercase; line-height: 25px; font-size: 16px\"><span>{{ post.event.date.startDate | date:\'EEE,\' : \'GMT\' }} <span>{{ post.event.date.startDate | date:\'MMM dd\' : \'GMT\' }}</span> <span><span translate=AT></span> <span>{{ post.event.date.startDate | date:\'h:mm a\' : \'GMT\' }}</span></span></span></li><!-- IF EVENT IS TICKETED --><li ng-if=\"post.event.status == \'ACTIVE\' && post.event.ticketed && post.event.answerCount.going > 0\"><time style=\"margin-right: 7px\"><span>{{ post.event.answerCount.sold }} going</span></time></li><!-- IF EVENT IS NOT TICKETED --><li ng-if=\"post.event.status == \'ACTIVE\' && !post.event.ticketed && post.event.answerCount.going > 0\"><time style=\"margin-right: 7px\"><span>{{ post.event.answerCount.going }} going</span></time></li></ul><div style=\"margin-top: 10px\"><div ng-if=post.event.ticketed><button ng-if=\"!post.event.past && post.event.status != \'CANCELLED\'\" ng-click=openPost(post) type=button class=\"btn btn-primary btn-primary-pink\" style=\"margin-top: 3px\"><span translate=GET_TICKETS></span></button></div><div ng-if=!post.event.ticketed><button ng-if=\"!post.event.past && post.event.status != \'CANCELLED\'\" ng-click=openPost(post) type=button class=\"btn btn-primary btn-primary-pink\" style=\"margin-top: 3px\"><span translate=RSVP_LABEL></span></button></div></div></div></div><div class=home-files-list ng-if=\"post.files && post.files.length > 0\"><div><div ng-repeat=\"att in post.files track by $index\" style=\"border-bottom: none\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 48 48\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><path fill=none stroke=#8a94a2 stroke-width=4 stroke-linecap=round stroke-miterlimit=10 d=\"M36,8v25 c0,7.2-5.8,13-13,13h0c-7.2,0-13-5.8-13-13V11c0-5,4-9,9-9h0c5,0,9,4,9,9v20c0,2.8-2.2,5-5,5h0c-2.8,0-5-2.2-5-5V14\" stroke-linejoin=round></path></g></svg> <a href=\"{{ att.url }}\" target=_blank style=\"word-break: break-word\">{{ att.name }}</a></div></div></div><div ng-if=\"isPostView() && post.type == \'listing\' && (post.body || post.title)\" class=padding-post><div style=\"overflow: auto\" class=text><div style=\"font-size: 16px; color: #6d7279; font-weight: 600; margin-bottom: 5px; word-break: break-word\">{{ post.title }}</div><span count-chars ng-bind-html=post.body class=multiple-line-text style=\"word-break: break-word\"></span></div></div><div class=\"padding-post padding-top-zero\" style=\"padding-bottom: 0\"><div ng-show=\"post.type === \'announcement\'\" class=\"announcement-stream {{ !isPostView() ? \'announcement-stream-cut\' : \'\' }}\"><div class=text><div post-id=\"{{ post.id }}\" count-chars data-ng-bind-html=trustAsHtml(post.body) style=\"margin: 0; color: #333\"></div><div ng-if=\"::getAnnHeight() > 600\"><div ui-sref=\"view({ \'id\': post.id })\" ng-if=!isPostView() class=announcement-bottom-shadow><a class=btn-default translate=READ_MORE_BTN></a></div></div></div><div class=home-files-list style=\"padding: 0\"><div ng-if=\"post.attachments && post.attachments.length > 0\"><div ng-repeat=\"att in post.attachments\" style=\"border-bottom: none\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 48 48\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><path fill=none stroke=#8a94a2 stroke-width=4 stroke-linecap=round stroke-miterlimit=10 d=\"M36,8v25 c0,7.2-5.8,13-13,13h0c-7.2,0-13-5.8-13-13V11c0-5,4-9,9-9h0c5,0,9,4,9,9v20c0,2.8-2.2,5-5,5h0c-2.8,0-5-2.2-5-5V14\" stroke-linejoin=round></path></g></svg> <a href=\"{{ att.path }}\" target=_blank style=\"word-break: break-word\">{{ att.name }}</a></div></div></div></div><div ng-if=\"!isPostView() && post.attachmentCount > 0\" style=\"margin-top: 15px; font-size: 14px\"><a ui-sref=\"view({ \'id\': post.id })\">This announcement has {{ post.attachmentCount }} attachment(s)</a></div><div ng-show=\"post.type == \'classlist\'\"><div class=vi-row><div class=vi-col-middle><div class=text><div ng-bind-html=\"post.body | to_trusted\" class=\"multiple-line-text multiple-line-article\" style=\"margin-right: 0\"></div></div></div></div></div><div ng-show=\"!post.sold && !paymentConfirmed\"><div ng-show=\"post.buyItem && post.onlinePayment && isPostView()\"><div class=mkp_pay_text><h1 translate=DONT_LET_AWAY></h1><br></div><form id=payment-form><div class=form-row style=\"border-radius: 10px; box-shadow: 0 2px 6px #ccc; padding: 10px\"><label for=card-element-1>Credit or debit card</label><div id=card-element-1></div><div id=card-errors-1 role=alert></div></div></form><div class=gray-but style=\"text-align: center; margin-top: 20px; margin-bottom: 15px\"><a id=post-button-id class=\"btn btn-primary btn-primary-pink mobile-post-button ng-scope\" ng-click=buyNow() ng-disabled=buingTickets style=\"position: relative; min-width: 130px; max-width: 200px; margin-top: 0\" translate=PAY_NOW></a> <a id=post-button-id class=\"btn btn-default btn-default-gray mobile-post-button ng-scope\" ng-click=\"composeTo({ id: post.userId })\" ng-disabled=buingTickets style=\"position: relative; max-width: 200px; margin-top: 0;color: #768F9B!important; min-width: 130px\"><span translate=CONTACT_SELLER></span> {{ post.postedByFirstName }}</a></div><div><p>Please read</p><div class=mkp-small-text><p>By selecting “Pay now” you acknowledge that this payment is final and irreversible. Classlist cannot accept any financial or other liability related to this purchase. <a target=_blank href=https://help.classlist.com/hc/en-us/articles/360026405312>Find out more</a></p><br></div></div></div></div><div ng-show=paymentConfirmed class=mkp-payment-confirmed><h4 translate=MKP_CONGRATS></h4><p translate=MKP_CONGRATS_TEXT style=\"margin-bottom: 20px\"></p><h4 translate=MKP_NOW_WHAT></h4><p translate=MKP_NOW_WHAT_TEXT></p><a id=post-button-id class=\"btn btn-default btn-default-gray mobile-post-button ng-scope\" ng-click=\"composeTo({ id: post.userId })\" ng-disabled=buingTickets style=\"position: relative; max-width: 200px; margin-top: 0;color: #768F9B!important; min-width: 130px; margin-bottom: 15px\"><span translate=CONTACT_SELLER></span> {{ post.postedByFirstName }}</a></div><div ng-show=\"isPostView() && post.type == \'listing\' && !post.onlinePayment\" style=\"text-align: center\"><a id=post-button-id class=\"btn btn-default btn-default-gray mobile-post-button ng-scope\" ng-click=\"composeTo({ id: post.userId })\" ng-disabled=buingTickets style=\"position: relative; max-width: 200px; margin-top: 0;color: #768F9B!important; min-width: 130px; margin-bottom: 15px\"><span translate=CONTACT_SELLER></span> {{ post.postedByFirstName }}</a></div><div ng-show=\"post.type != \'listing\'\"><div class=likes-container style=\"margin-bottom: -12px; overflow: auto\"><div class=who-likes ng-if=\"post.likeCount > 0\"><div ng-click=showLikers(post) style=\"cursor: pointer\"><div ng-if=\"post.type != \'welcome\'\"><span ng-if=!post.isLiked class=likes-text><span>{{ post.lastLike[0] }}</span> <span ng-if=\"post.likeCount > 1\" translate=\"{{ (post.likeCount-1 > 1)? \'NUM_LIKES\' : \'NUM_LIKE\' }}\" translate-values=\"{\'num\':post.likeCount-1}\"></span> <span ng-if=\"post.likeCount == 1\" translate=LIKES_THIS></span> </span><span ng-if=\"post.isLiked && post.likeCount > 1\" class=likes-text translate=\"{{ (post.likeCount-1 > 1)? \'NUM_OTHER_LIKES\' : \'NUM_OTHER_LIKE\' }}\" translate-values=\"{\'num\':post.likeCount-1}\"></span> <span ng-if=\"post.isLiked && post.likeCount <= 1\" translate=NUM_MY_LIKE class=likes-text></span></div><div ng-if=\"post.type == \'welcome\'\"><span ng-if=!post.isLiked class=likes-text><span ng-if=\"post.likeCount > 1\" translate=OTHERS_WELCOMED translate-values=\"{\'name\':post.lastLike[0], \'num\':post.likeCount-1}\"></span> <span ng-if=\"post.likeCount == 1\" translate=SOMEONE_WELCOMED translate-values=\"{\'name\':post.lastLike[0]}\"></span> </span><span ng-if=\"post.isLiked && post.likeCount > 1\" class=likes-text translate=ME_OTHERS_WELCOMED translate-values=\"{\'num\':post.likeCount-1}\"></span> <span ng-if=\"post.isLiked && post.likeCount <= 1\" translate=ME_WELCOMED class=likes-text></span></div></div></div></div></div></div></div><div ng-show=\"isCommentAndLikeDisabled != true && (post.type != \'listing\' || isPostView())\"><div class=\"post-item-likes clearfix\" style=\"border-top: 0px !important\" ng-hide=commentOnly><div class=like-container style=\"cursor: pointer; min-width: 65px\"><a id=like-post-id ng-click=likePost(post) style=\"line-height: initial\"><svg ng-if=!post.isLiked style=\"width: 24px; height: 27px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\" stroke-width=3><g stroke-width=3 transform=\"translate(0.5, 0.5)\"><path data-cap=butt fill=none stroke=#8a94a2 stroke-width=3 stroke-miterlimit=10 d=\"M14,56l6.7,3.4 C24.2,61.1,28.1,62,32,62h20c3.3,0,6.4-2.4,7-6l3-24c0-3.3-2.7-6-6-6H40V16c0-5.7-3.5-11.9-9.4-13.6C29.3,2.1,28,3,28,4.3V16L14,34\" stroke-linejoin=miter stroke-linecap=butt></path><rect data-color=color-2 x=2 y=28 fill=none stroke=#8a94a2 stroke-width=3 stroke-linecap=square stroke-miterlimit=10 width=12 height=34 stroke-linejoin=miter></rect></g></svg> <svg ng-if=post.isLiked style=\"width: 24px; height: 27px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><path data-color=color-2 fill=#3677d9 d=\"M12,27H2c-0.6,0-1,0.4-1,1v34c0,0.6,0.4,1,1,1h10c0.6,0,1-0.4,1-1V28C13,27.4,12.6,27,12,27z \"></path><path fill=#3677d9 d=\"M56,25H41v-9c0-5.8-3.5-12.6-10.1-14.5c-0.3-0.1-0.6-0.1-0.9-0.1c-1.7,0-3,1.3-3,3v11.3L15,31.1v26.5 l5.3,2.6C23.9,62,28,63,32,63h20c3.9,0,7.3-2.9,8-6.9l3-24c0,0,0-0.1,0-0.1C63,28.1,59.9,25,56,25z\"></path></g></svg> </a><span ng-click=showLikers(post) class=text style=\"font-size: 14px; float: left; line-height: 31px; padding: 0px 10px; font-weight: bold; {{ post.isLiked ? \'color: #3677d9;\' : \'\' }}\" ng-if=\"post.likeCount > 0\">{{ post.likeCount }} </span><span class=text ng-click=likePost() ng-if=!post.likeCount style=\"font-size: 13px; float: left; line-height: 31px; padding: 0px 10px\"></span></div><div ng-if=\"!post.isOwn && post.type != \'welcome\' && !readonly\" class=\"like-container follow-container\" style=\"cursor: pointer\"><a id=follow-post-id ng-click=followPost(true) style=\"line-height: initial; float: left\"><svg ng-if=post.isFollowed style=\"width: 23px; height: 29px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 48 48\"><g transform=\"translate(0, 0)\"><path data-color=color-2 d=M24,47a6.006,6.006,0,0,0,5.91-5H18.09A6.006,6.006,0,0,0,24,47Z fill=#3677d9></path><path d=M43.814,38.419C43.766,38.352,39,31.6,39,26V16A15,15,0,1,0,9,16V26c0,5.6-4.766,12.352-4.814,12.419A1,1,0,0,0,5,40H43a1,1,0,0,0,.814-1.581Z fill=#3677d9></path></g></svg> <svg ng-if=!post.isFollowed style=\"width: 23px; height: 29px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><path d=M38,55a6,6,0,0,1-12,0 fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></path><path d=M52.262,42A22.711,22.711,0,0,1,50,33V21A18,18,0,0,0,32,3h0A17.95,17.95,0,0,0,18.584,9 fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></path><path data-cap=butt d=M15.018,15.019A17.97,17.97,0,0,0,14,21V33c0,8-7,17-7,17H50 fill=none stroke=#444444 stroke-miterlimit=10 stroke-width=2 stroke-linecap=butt stroke-linejoin=miter></path><line data-color=color-2 x1=4 y1=4 x2=60 y2=60 fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></line></g></svg></a></div></div><div ng-hide=isCommentDisabled class=post-item-comment ng-if=\"post.commentCount > 0\" style=\"background:#fff; padding-left: 12px\"><div class=vi-row ng-if=\"post.comments.length < post.commentCount\"><div class=vi-col-right><span class=comment-num style=\"margin-top: 0; margin-bottom: 10px; font-size: 14px\"><span>{{ post.comments.length }} <span translate=OF></span></span> {{ post.commentCount }}</span></div><div class=vi-col-middle style=\"padding-left: 5px\"><div ng-hide=post.hideMoreComm><a class=view-previous-comments ng-click=getMoreComments(post) style=\"margin-top: 0; margin-bottom: 10px; font-size: 14px; padding-left: 2px\" translate=VIEW_PREV_COMMENTS></a></div></div></div><div class=comment-item id=\"comment_{{ cmm.id }}\" ng-repeat=\"cmm in post.comments\" style=\"margin-bottom: 0\"><div class=vi-row id=\"cmt_{{ cmm.id }}\"><div class=vi-col-left style=\"width: 46px; padding-right: 10px\"><figure ng-if=!cmm.sample class=comment-item-avatar ng-click=openUserHome(cmm.userId)><avatar source={{cmm.avatar}} name=\"{{ cmm.postedBy }}\" width=60 height=60 my=false></avatar></figure><figure ng-show=cmm.sample class=comment-item-avatar><avatar source={{cmm.avatar}} name=\"{{ cmm.postedBy }}\" width=60 height=60 my=false></avatar></figure></div><div class=vi-col-middle style=\"overflow: auto\"><div style=\"margin-right: 30px; border-radius: 10px; position: relative; min-width: 180px\"><div style=\"overflow: auto; background: #f1f3f5; border-radius: 10px\"><div class=comment-text-section style=\"overflow: auto; padding: 6px 8px; float: left; max-width: 100%\"><div class=\"multiple-line-text comment-text\" style=\"margin: 0\"><a ng-if=!cmm.sample ng-click=openUserHome(cmm.userId) style=\"margin-right: 36px\" class=HEADER2>{{cmm.postedBy}}</a><a ng-if=cmm.sample class=\"disabled HEADER2\" style=\"margin-right: 36px\">{{cmm.postedBy}}</a><br><span ng-bind-html=cmm.body style=\"color: #000; margin-right: 36px; word-break: break-word\"></span></div></div><br><div ng-if=\"cmm.attachment && cmm.attachment.url != \'\' && !cmm.attachment.fileView\" style=\"overflow: auto; width: 100%; height: 100%; padding: 10px;max-width: 100%; max-height: 250px; cursor: pointer\" id=image-preview-wrapper><div ng-click=openCommentImage(cmm.attachment.url) style=\"margin-bottom: 3px;text-align: center\"><img ng-src={{cmm.attachment.url}} style=\"height: 100%; width: 100%\"></div></div><br><div class=home-files-list ng-if=\"cmm.attachment && cmm.attachment.url != \'\' && cmm.attachment.fileView\" style=\"float: left; padding-left: 2px; margin-top: 0px !important\"><div><div style=\"border-bottom: none\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 48 48\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><path fill=none stroke=#8a94a2 stroke-width=4 stroke-linecap=round stroke-miterlimit=10 d=\"M36,8v25 c0,7.2-5.8,13-13,13h0c-7.2,0-13-5.8-13-13V11c0-5,4-9,9-9h0c5,0,9,4,9,9v20c0,2.8-2.2,5-5,5h0c-2.8,0-5-2.2-5-5V14\" stroke-linejoin=round></path></g></svg> <a href=\"{{ cmm.attachment.url }}\" target=_blank style=\"word-break: break-word\">{{ cmm.attachment.fileName }}</a></div></div></div></div><nav ng-show=\"post.type !== \'NEW_GROUP\' && cmm.own\" class=\"has-dropdown is-relative more-dots\" style=\"margin-top: 0; position: absolute; top: 10px; right: 0px; width: 26px; z-index: 99; padding-bottom: 7px\"><svg style=\"transform: rotate(90deg)\" ng-if=\"post.type !== \'welcome\'\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=32px height=32px viewBox=\"0 0 32 32\"><g transform=\"translate(0, 0)\"><circle fill=#8a94a2 cx=4 cy=16 r=3></circle><circle data-color=color-2 fill=#8a94a2 cx=16 cy=16 r=3></circle><circle fill=#8a94a2 cx=28 cy=16 r=3></circle></g></svg><ul class=dropdown-menu style=\"right: 1px!important; top:100%!important\"><li ng-if=cmm.own><a ng-click=deleteComment(cmm.id)>Delete</a></li></ul></nav><div class=comment-box style=\"padding-left:0px !important\" ng-if=\"cmm.userId > 10\"><div style=\"float:left; width:100%\"><ng-container><time style=\"float: left; margin: 0px 10px 0px 5px; line-height: 23px\">{{ cmm.created | timeago }}</time><div style=\"width: 50px; float:left; margin: 2px 0 0 20px\"><!--like comment--> <a ng-click=likeComment(cmm) style=\"{{ cmm.liked ? \'color: #3677d9; font-weight: bold;\' : \'color:grey;\' }}\">Like</a></div><div ng-hide=post.commentLocked style=\"width: 50px; float:left; margin-top:2px\"><!--reply comment--> <a ng-click=replyComment(cmm) style=color:grey>Reply</a></div><div ng-if=\"cmm.likeCount > 0\" ng-click=showCommLikers(cmm) style=\"float:right; color: #969696; margin: 2px 0 0 20px\"><!--reply comment--> <svg style=\"width: 16px; height: 20px; vertical-align: bottom\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\" stroke-width=3><g stroke-width=3 transform=\"translate(0.5, 0.5)\"><path data-cap=butt fill=none stroke=#FE5D92 stroke-width=3 stroke-miterlimit=10 d=\"M14,56l6.7,3.4 C24.2,61.1,28.1,62,32,62h20c3.3,0,6.4-2.4,7-6l3-24c0-3.3-2.7-6-6-6H40V16c0-5.7-3.5-11.9-9.4-13.6C29.3,2.1,28,3,28,4.3V16L14,34\" stroke-linejoin=miter stroke-linecap=butt></path><rect data-color=color-2 x=2 y=28 fill=#FE5D92 stroke=#FE5D92 stroke-width=3 stroke-linecap=square stroke-miterlimit=10 width=12 height=34 stroke-linejoin=miter></rect></g></svg> {{ cmm.likeCount }}</div></ng-container></div></div></div></div><!--REPLIES START--><div ng-if=\"cmm.totalReplyCount > 0\" id=replies_{{cmm.id}} class=vi-col-middle style=\"width:93%; float: right\"><div class=vi-col-middle style=\"padding-left: 5px\"><div ng-show=\"cmm.replies.length != cmm.totalReplyCount\"><a class=view-previous-comments ng-click=getMoreReplies(cmm) ] style=\"margin: 10px 14px 20px; padding-left: 2px; font-size: 14px\" translate=VIEW_PREV_REPLIES translate-values=\"{ \'moreReplyCount\': cmm.totalReplyCount - cmm.replies.length}\"></a></div></div><div class=comment-item id=\"comment_{{ reply.id }}\" ng-repeat=\"reply in cmm.replies\" style=\"margin-bottom: 0\"><div class=vi-row id=\"cmt_{{ reply.id }}\"><div class=vi-col-left style=\"width: 46px; padding-right: 10px\"><figure ng-if=!reply.sample class=comment-item-avatar ng-click=openUserHome(reply.userId)><avatar source={{reply.avatar}} name=\"{{ reply.postedBy }}\" width=60 height=60 my=false></avatar></figure><figure ng-show=reply.sample class=comment-item-avatar><avatar source={{reply.avatar}} name=\"{{ reply.postedBy }}\" width=60 height=60 my=false></avatar></figure></div><div class=vi-col-middle style=\"overflow: auto\"><div style=\"margin-right: 30px; border-radius: 10px; position: relative; min-width: 180px\"><div style=\"overflow: auto; background: #f1f3f5; border-radius: 10px\"><div class=comment-text-section style=\"overflow: auto; padding: 6px 8px; float: left; max-width: 100%\"><div class=\"multiple-line-text comment-text\" style=\"margin: 0\"><a ng-if=!reply.sample ng-click=openUserHome(reply.userId) style=\"margin-right: 36px\" class=HEADER2>{{reply.postedBy}}</a><a ng-if=reply.sample class=\"disabled HEADER2\" style=\"margin-right: 36px\">{{reply.postedBy}}</a><br><span ng-bind-html=reply.body style=\"color: #000; margin-right: 36px; word-break: break-word\"></span></div></div><br><div ng-if=\"reply.attachment && reply.attachment.url != \'\' && !reply.attachment.fileView\" style=\"overflow: auto; width: 100%; height: 100%; padding: 10px;max-width: 100%; max-height: 250px; cursor: pointer\" id=image-preview-wrapper><div ng-click=openCommentImage(reply.attachment.url) style=\"margin-bottom: 3px;text-align: center\"><img ng-src={{reply.attachment.url}} style=\"height: 100%; width: 100%\"></div></div><br><div class=home-files-list ng-if=\"reply.attachment && reply.attachment.url != \'\' && reply.attachment.fileView\" style=\"float: left; padding-left: 2px; margin-top: 0px !important\"><div><div style=\"border-bottom: none\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 48 48\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><path fill=none stroke=#8a94a2 stroke-width=4 stroke-linecap=round stroke-miterlimit=10 d=\"M36,8v25 c0,7.2-5.8,13-13,13h0c-7.2,0-13-5.8-13-13V11c0-5,4-9,9-9h0c5,0,9,4,9,9v20c0,2.8-2.2,5-5,5h0c-2.8,0-5-2.2-5-5V14\" stroke-linejoin=round></path></g></svg> <a href=\"{{ reply.attachment.url }}\" target=_blank style=\"word-break: break-word\">{{ reply.attachment.fileName }}</a></div></div></div></div><nav ng-show=\"post.type !== \'NEW_GROUP\' && reply.own\" class=\"has-dropdown is-relative more-dots\" style=\"margin-top: 0; position: absolute; top: 10px; right: 0px; width: 26px; padding-top: 0px; z-index: 99; padding-bottom: 7px\"><svg style=\"transform: rotate(90deg)\" ng-if=\"post.type !== \'welcome\'\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=32px height=32px viewBox=\"0 0 32 32\"><g transform=\"translate(0, 0)\"><circle fill=#8a94a2 cx=4 cy=16 r=3></circle><circle data-color=color-2 fill=#8a94a2 cx=16 cy=16 r=3></circle><circle fill=#8a94a2 cx=28 cy=16 r=3></circle></g></svg><ul class=dropdown-menu style=\"right: 1px!important; top:100%!important\"><li ng-if=reply.own><a ng-click=\"deleteReplyComment(cmm.id, reply.id)\">Delete</a></li></ul></nav><div class=comment-box style=\"padding-left:0px !important\"><div style=\"float:left; width: 100%\"><ng-container><time style=\"float: left; margin: 0px 10px 0px 5px; line-height: 23px\">{{ reply.created | timeago }}</time><div style=\"width: 50px; float:left; margin: 2px 0 0 20px\"><!--like comment--> <a ng-click=likeComment(reply) style=\"{{ reply.liked ? \'color: #3677d9; font-weight: bold;\' : \'color:grey;\' }}\">Like</a></div><div ng-hide=post.commentLocked style=\"width: 50px; float:left; margin-top: 2px\"><!--reply comment--> <a ng-click=replyComment(cmm,reply.userId,reply.postedBy) style=color:grey>Reply</a></div><div ng-if=\"reply.likeCount > 0\" ng-click=showCommLikers(cmm) style=\"float:right; color:#969696; margin: 2px 0 0 20px\"><!--reply comment--> <svg style=\"width: 18px; height: 22px; vertical-align: bottom; color:#969696\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\" stroke-width=3><g stroke-width=3 transform=\"translate(0.5, 0.5)\"><path data-cap=butt fill=none stroke=#FE5D92 stroke-width=3 stroke-miterlimit=10 d=\"M14,56l6.7,3.4 C24.2,61.1,28.1,62,32,62h20c3.3,0,6.4-2.4,7-6l3-24c0-3.3-2.7-6-6-6H40V16c0-5.7-3.5-11.9-9.4-13.6C29.3,2.1,28,3,28,4.3V16L14,34\" stroke-linejoin=miter stroke-linecap=butt></path><rect data-color=color-2 x=2 y=28 fill=#FE5D92 stroke=#FE5D92 stroke-width=3 stroke-linecap=square stroke-miterlimit=10 width=12 height=34 stroke-linejoin=miter></rect></g></svg> {{ reply.likeCount }}</div></ng-container></div></div></div></div></div></div></div><!--REPLIES END--></div></div></div><div class=post-item-add-comment ng-hide=\"post.commentLocked || isCommentDisabled\" ng-show=\"postContext !== null && postContext !== \'GROUP_LIST_VIEW\'\" style=\"background: #fff; padding-left: 12px\"><div class=comment-composer><comment-composer post-id={{postId}} user-avatar=userAvatar events=events></comment-composer></div></div></div></div><div ng-if=\"readonlyPost && post.type === \'announcement\'\" class=post-container style=\"background: transparent; border: none\"><div style=\"padding: 0 10px\"><strong class=page-view-header__title style=\"padding: 6px 0\"><span translate=ANNOUNCEMENTS_TO></span>:</strong><div class=announcement-sent-to ng-repeat=\"a in post.sentTo track by $index\"><p></p><figure class=avatar><span class=dripicons-user-group></span></figure>{{a}}<p></p></div></div></div></div>");
$templateCache.put("app/base/directives/postComments.directive.html","<div class=post-item mw=\"{{ userId == postUserId ? true : false }}\" style=\"{{ commentOnly ? \'width:100%; border: none !important;\' : \'\' }}\"><div class=post-container style=\"{{ isPostView() ? \'border: solid 1px #d8d8d8;\' : \'\' }}{{ commentOnly ? \'width:100%; border: none !important;\' : \'\' }}\"><div class=post-item-comment ng-if=\"post.commentCount > 0\" style=\"background:#fff; padding-left: 12px\"><div class=vi-row ng-if=\"post.comments.length < post.commentCount\"><div class=vi-col-right><span class=comment-num style=\"margin-top: 0; margin-bottom: 10px; font-size: 14px\"><span>{{ post.comments.length }} <span translate=OF></span></span> {{ post.commentCount }}</span></div><div class=vi-col-middle style=\"padding-left: 5px\"><div ng-hide=post.hideMoreComm><a class=view-previous-comments ng-click=getMoreComments(post) style=\"margin-top: 0; margin-bottom: 10px; font-size: 14px; padding-left: 2px\" translate=VIEW_PREV_COMMENTS></a></div></div></div><div class=comment-item id=\"comment_{{ cmm.id }}\" ng-repeat=\"cmm in post.comments\" style=\"margin-bottom: 0\"><div class=vi-row id=\"cmt_{{ cmm.id }}\"><div class=vi-col-left style=\"width: 46px; padding-right: 10px\"><figure ng-if=!cmm.sample class=comment-item-avatar ng-click=openUserHome(cmm.userId)><avatar source={{cmm.avatar}} name=\"{{ cmm.postedBy }}\" width=60 height=60 my=false></avatar></figure><figure ng-show=cmm.sample class=comment-item-avatar><avatar source={{cmm.avatar}} name=\"{{ cmm.postedBy }}\" width=60 height=60 my=false></avatar></figure></div><div class=vi-col-middle style=\"overflow: auto\"><div style=\"margin-right: 30px; border-radius: 10px; position: relative; min-width: 180px\"><div style=\"overflow: auto; background: #f1f3f5; border-radius: 10px\"><div class=comment-text-section style=\"overflow: auto; padding: 6px 8px; float: left; max-width: 100%\"><div class=\"multiple-line-text comment-text\" style=\"margin: 0\"><a ng-if=!cmm.sample ng-click=openUserHome(cmm.userId) style=\"margin-right: 36px\" class=HEADER2>{{cmm.postedBy}}</a><a ng-if=cmm.sample class=\"disabled HEADER2\" style=\"margin-right: 36px\">{{cmm.postedBy}}</a><br><span ng-bind-html=cmm.body style=\"color: #000; margin-right: 36px; word-break: break-word\"></span></div></div><br><div ng-if=\"cmm.attachment && cmm.attachment.url != \'\' && !cmm.attachment.fileView\" style=\"overflow: auto; width: 100%; height: 100%; padding: 10px;max-width: 100%; max-height: 250px; cursor: pointer\" id=image-preview-wrapper><div ng-click=openCommentImage(cmm.attachment.url) style=\"margin-bottom: 3px;text-align: center\"><img ng-src={{cmm.attachment.url}} style=\"height: 100%; width: 100%\"></div></div><br><div class=home-files-list ng-if=\"cmm.attachment && cmm.attachment.url != \'\' && cmm.attachment.fileView\" style=\"float: left; padding-left: 2px; margin-top: 0px !important\"><div><div style=\"border-bottom: none\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 48 48\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><path fill=none stroke=#8a94a2 stroke-width=4 stroke-linecap=round stroke-miterlimit=10 d=\"M36,8v25 c0,7.2-5.8,13-13,13h0c-7.2,0-13-5.8-13-13V11c0-5,4-9,9-9h0c5,0,9,4,9,9v20c0,2.8-2.2,5-5,5h0c-2.8,0-5-2.2-5-5V14\" stroke-linejoin=round></path></g></svg> <a href=\"{{ cmm.attachment.url }}\" target=_blank style=\"word-break: break-word\">{{ cmm.attachment.fileName }}</a></div></div></div></div><nav ng-show=cmm.own class=\"has-dropdown is-relative more-dots\" style=\"display: block; margin-top: 0; position: absolute; top: 10px; right: 0px; width: 26px; z-index: 9999; padding-bottom: 7px\"><svg style=\"transform: rotate(90deg)\" ng-if=\"post.type !== \'welcome\'\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=32px height=32px viewBox=\"0 0 32 32\"><g transform=\"translate(0, 0)\"><circle fill=#8a94a2 cx=4 cy=16 r=3></circle><circle data-color=color-2 fill=#8a94a2 cx=16 cy=16 r=3></circle><circle fill=#8a94a2 cx=28 cy=16 r=3></circle></g></svg><ul class=dropdown-menu style=\"right: 1px!important; top:100%!important; position:absolute; z-index:10000; background-color:#ffffff; min-width: 120px\"><li ng-if=cmm.own><a ng-click=deleteComment(cmm.id)>Delete</a></li></ul></nav><div class=comment-box style=\"padding-left:0px !important\" ng-if=\"cmm.userId > 10\"><div style=\"float:left; width:100%\"><ng-container><time style=\"float: left; margin: 0px 10px 0px 5px; line-height: 23px\">{{ cmm.created | timeago }}</time><div style=\"width: 50px; float:left; margin: 2px 0 0 20px\"><!--like comment--> <a ng-click=likeComment(cmm) style=\"{{ cmm.liked ? \'color: #3677d9; font-weight: bold;\' : \'color:grey;\' }}\">Like</a></div><div ng-hide=post.commentLocked style=\"width: 50px; float:left; margin-top:2px\"><!--reply comment--> <a ng-click=replyComment(cmm) style=color:grey>Reply</a></div><div ng-if=\"cmm.likeCount > 0\" ng-click=showCommLikers(cmm) style=\"float:right; color: #969696; margin: 2px 0 0 20px\"><!--reply comment--> <svg style=\"width: 16px; height: 20px; vertical-align: bottom\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\" stroke-width=3><g stroke-width=3 transform=\"translate(0.5, 0.5)\"><path data-cap=butt fill=none stroke=#FE5D92 stroke-width=3 stroke-miterlimit=10 d=\"M14,56l6.7,3.4 C24.2,61.1,28.1,62,32,62h20c3.3,0,6.4-2.4,7-6l3-24c0-3.3-2.7-6-6-6H40V16c0-5.7-3.5-11.9-9.4-13.6C29.3,2.1,28,3,28,4.3V16L14,34\" stroke-linejoin=miter stroke-linecap=butt></path><rect data-color=color-2 x=2 y=28 fill=#FE5D92 stroke=#FE5D92 stroke-width=3 stroke-linecap=square stroke-miterlimit=10 width=12 height=34 stroke-linejoin=miter></rect></g></svg> {{ cmm.likeCount }}</div></ng-container></div></div></div></div><!--REPLIES START--><div ng-if=\"cmm.totalReplyCount > 0\" id=replies_{{cmm.id}} class=vi-col-middle style=\"width:93%; float: right\"><div class=vi-col-middle style=\"padding-left: 5px\"><div ng-show=\"cmm.replies.length != cmm.totalReplyCount\"><a class=view-previous-comments ng-click=getMoreReplies(cmm) ] style=\"margin: 10px 14px 20px; padding-left: 2px; font-size: 14px\" translate=VIEW_PREV_REPLIES translate-values=\"{ \'moreReplyCount\': cmm.totalReplyCount - cmm.replies.length}\"></a></div></div><div class=comment-item id=\"comment_{{ reply.id }}\" ng-repeat=\"reply in cmm.replies\" style=\"margin-bottom: 0\"><div class=vi-row id=\"cmt_{{ reply.id }}\"><div class=vi-col-left style=\"width: 46px; padding-right: 10px\"><figure ng-if=!reply.sample class=comment-item-avatar ng-click=openUserHome(reply.userId)><avatar source={{reply.avatar}} name=\"{{ reply.postedBy }}\" width=60 height=60 my=false></avatar></figure><figure ng-show=reply.sample class=comment-item-avatar><avatar source={{reply.avatar}} name=\"{{ reply.postedBy }}\" width=60 height=60 my=false></avatar></figure></div><div class=vi-col-middle style=\"overflow: auto\"><div style=\"margin-right: 30px; border-radius: 10px; position: relative; min-width: 180px\"><div style=\"overflow: auto; background: #f1f3f5; border-radius: 10px\"><div class=comment-text-section style=\"overflow: auto; padding: 6px 8px; float: left; max-width: 100%\"><div class=\"multiple-line-text comment-text\" style=\"margin: 0\"><a ng-if=!reply.sample ng-click=openUserHome(reply.userId) style=\"margin-right: 36px\" class=HEADER2>{{reply.postedBy}}</a><a ng-if=reply.sample class=\"disabled HEADER2\" style=\"margin-right: 36px\">{{reply.postedBy}}</a><br><span ng-bind-html=reply.body style=\"color: #000; margin-right: 36px; word-break: break-word\"></span></div></div><br><div ng-if=\"reply.attachment && reply.attachment.url != \'\' && !reply.attachment.fileView\" style=\"overflow: auto; width: 100%; height: 100%; padding: 10px;max-width: 100%; max-height: 250px; cursor: pointer\" id=image-preview-wrapper><div ng-click=openCommentImage(reply.attachment.url) style=\"margin-bottom: 3px;text-align: center\"><img ng-src={{reply.attachment.url}} style=\"height: 100%; width: 100%\"></div></div><br><div class=home-files-list ng-if=\"reply.attachment && reply.attachment.url != \'\' && reply.attachment.fileView\" style=\"float: left; padding-left: 2px; margin-top: 0px !important\"><div><div style=\"border-bottom: none\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 48 48\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><path fill=none stroke=#8a94a2 stroke-width=4 stroke-linecap=round stroke-miterlimit=10 d=\"M36,8v25 c0,7.2-5.8,13-13,13h0c-7.2,0-13-5.8-13-13V11c0-5,4-9,9-9h0c5,0,9,4,9,9v20c0,2.8-2.2,5-5,5h0c-2.8,0-5-2.2-5-5V14\" stroke-linejoin=round></path></g></svg> <a href=\"{{ reply.attachment.url }}\" target=_blank style=\"word-break: break-word\">{{ reply.attachment.fileName }}</a></div></div></div></div><nav ng-show=reply.own class=\"has-dropdown is-relative more-dots\" style=\"display: block; margin-top: 0; position: absolute; top: 10px; right: 0px; width: 26px; padding-top: 0px; z-index: 99; padding-bottom: 7px\"><svg style=\"transform: rotate(90deg)\" ng-if=\"post.type !== \'welcome\'\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=32px height=32px viewBox=\"0 0 32 32\"><g transform=\"translate(0, 0)\"><circle fill=#8a94a2 cx=4 cy=16 r=3></circle><circle data-color=color-2 fill=#8a94a2 cx=16 cy=16 r=3></circle><circle fill=#8a94a2 cx=28 cy=16 r=3></circle></g></svg><ul class=dropdown-menu style=\"right: 1px!important; top:100%!important\"><li ng-if=reply.own><a ng-click=\"deleteReplyComment(cmm.id, reply.id)\">Delete</a></li></ul></nav><div class=comment-box style=\"padding-left:0px !important\"><div style=\"float:left; width: 100%\"><ng-container><time style=\"float: left; margin: 0px 10px 0px 5px; line-height: 23px\">{{ reply.created | timeago }}</time><div style=\"width: 50px; float:left; margin: 2px 0 0 20px\"><!--like comment--> <a ng-click=likeComment(reply) style=\"{{ reply.liked ? \'color: #3677d9; font-weight: bold;\' : \'color:grey;\' }}\">Like</a></div><div ng-hide=post.commentLocked style=\"width: 50px; float:left; margin-top: 2px\"><!--reply comment--> <a ng-click=replyComment(cmm,reply.userId,reply.postedBy) style=color:grey>Reply</a></div><div ng-if=\"reply.likeCount > 0\" ng-click=showCommLikers(cmm) style=\"float:right; color:#969696; margin: 2px 0 0 20px\"><!--reply comment--> <svg style=\"width: 18px; height: 22px; vertical-align: bottom; color:#969696\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\" stroke-width=3><g stroke-width=3 transform=\"translate(0.5, 0.5)\"><path data-cap=butt fill=none stroke=#FE5D92 stroke-width=3 stroke-miterlimit=10 d=\"M14,56l6.7,3.4 C24.2,61.1,28.1,62,32,62h20c3.3,0,6.4-2.4,7-6l3-24c0-3.3-2.7-6-6-6H40V16c0-5.7-3.5-11.9-9.4-13.6C29.3,2.1,28,3,28,4.3V16L14,34\" stroke-linejoin=miter stroke-linecap=butt></path><rect data-color=color-2 x=2 y=28 fill=#FE5D92 stroke=#FE5D92 stroke-width=3 stroke-linecap=square stroke-miterlimit=10 width=12 height=34 stroke-linejoin=miter></rect></g></svg> {{ reply.likeCount }}</div></ng-container></div></div></div></div></div></div></div><!--REPLIES END--></div></div></div><div class=post-item-add-comment ng-hide=post.commentLocked ng-show=\"postContext !== null && postContext !== \'GROUP_LIST_VIEW\'\" style=\"background: #fff; padding-left: 12px\"><div class=comment-composer><comment-composer post-id={{postId}} user-avatar=userAvatar events=events></comment-composer></div></div></div></div>");
$templateCache.put("app/base/views/delete-post-modal.html","<div><div class=modal-header><h3 translate=DELETE_POST_HEADER></h3></div><div class=modal-body><p translate=DELETE_POST_TEXT></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=OK_BTN ng-click=confirm()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/base/views/footer.html","<footer class=\"footer center-text\"><img src=assets/images/classlist-footer-logo.svg width=150 height=32 alt=\"\"> <small translate=REG_FOOTER></small></footer>");
$templateCache.put("app/base/views/header.html","<header class=header-logged><div class=container><div class=wrapper><figure ng-if=active_school.name class=\"school-selector clearfix\"><div class=\"school-logo pull-left hidden-xs\"><img ng-src=\"{{ getServingURL(active_school.avatar, 40, true) }}\" width=40 height=40 onerror=\"this.src=\'assets/images/transparent.png\'\" alt=\"\"></div><figcaption class=\"school-name pull-left\"><div>{{active_school.name}}</div></figcaption></figure><div class=\"top-nav top-nav--right\"><ul><li ng-if=active_school.parent class=\"{{ switchingApps ? \'switching-apps-disabled\' : \'\' }}\"><a id=desktop-switch-button ng-click=switchApps() class=small-switch><div><div ng-if=\"parentSideNotifications > 0\">{{parentSideNotifications}}</div><div class=switch-admin-circle><svg class=switch-admin-svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=22px height=22px viewBox=\"0 0 24 24\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><polygon fill=none stroke=#6d7279 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 points=\"22,7 15,2 15,5 3,5 3,9 15,9 15,12 \" stroke-linejoin=miter></polygon><polygon data-color=color-2 fill=none stroke=#6d7279 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 points=\" 2,17 9,22 9,19 21,19 21,15 9,15 9,12 \" stroke-linejoin=miter></polygon></g></svg></div></div><span translate=TOPNAV_SWITCH_PARENT></span></a></li></ul></div></div></div><loader></loader></header><div class=fixed-box ng-if=\"active_school.status == \'TRIAL\'\">Welcome! Trial mode activated for 20 members. <a href=https://info.classlist.com/trial target=_blank>Contact us</a> anytime to book training and select a plan to grow your community.</div><ng-include src=\"\'app/base/views/white-screen.html\'\"></ng-include>");
$templateCache.put("app/base/views/invite-success-modal.html","<div><div class=modal-body style=\"padding: 20px\"><div translate=INVITE_SUCCESS_TEXT_1 translate-values=\"{ \'num\': num }\"></div><br><ul><li translate=INVITE_SUCCESS_TEXT_2></li><li translate=INVITE_SUCCESS_TEXT_3></li></ul><br><div translate=INVITE_SUCCESS_TEXT_4></div></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=OK_BTN ng-click=close()></div></div>");
$templateCache.put("app/base/views/leave-page-modal.html","<div><div class=modal-header><h3 translate=LEAVE_HEADER></h3></div><div class=modal-body><p translate=LEAVE_TEXT></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=OK_BTN ng-click=confirm()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/base/views/move-up-modal.html","<style>.moveup-modal-window .modal-dialog {\n        width: 790px;\n        max-width: 790px;\n    }\n    .moveup-modal .moveup-row { display: flex; align-items: flex-start; gap: 24px; flex-wrap: nowrap; }\n    .moveup-modal .moveup-image-wrap { flex: 0 0 240px; }\n    .moveup-modal .moveup-image-wrap img { width: 240px; height: 240px; border-radius: 50%; object-fit: cover; display: block; }\n    .moveup-modal .moveup-content { flex: 1 1 auto; min-width: 0; }\n    @media (max-width: 991px) {\n        .moveup-modal-window .modal-dialog { width: auto; max-width: 95%; margin: 30px auto; }\n    }\n    @media (max-width: 640px) {\n        .moveup-modal { padding: 16px !important; }\n        .moveup-modal-window .modal-dialog { max-width: 100%; margin: 10px; }\n        .moveup-modal .moveup-row { flex-direction: column; align-items: center; gap: 16px; }\n        .moveup-modal .moveup-image-wrap { flex: 0 0 auto; }\n        .moveup-modal .moveup-image-wrap img { width: 160px; height: 160px; }\n        .moveup-modal .moveup-content { width: 100%; text-align: left; }\n        .moveup-modal .moveup-footer { text-align: center !important; }\n        .moveup-modal .moveup-footer .btn { display: block; width: 100%; margin: 8px 0 0 !important; }\n    }</style><div class=moveup-modal style=\"padding: 24px\"><div class=modal-body style=\"padding: 0\"><div class=moveup-row><div class=moveup-image-wrap><img src=https://storage.googleapis.com/classlist-branding/app-assets/Moveup-Banner-Image.png alt=\"\"></div><div class=moveup-content><h3 style=\"margin: 0 0 12px; font-weight: 700\" translate=MOVEUP_HEADER></h3><div style=\"margin-bottom: 16px\" translate=MOVEUP_DESCRIPTION></div><div style=\"margin-bottom: 20px\"><a href=https://www.classlist.com/classlist-school-mis-integration-overview target=_blank style=\"color: #eb004e; text-decoration: underline; font-weight: 600\" translate=MOVEUP_FIND_OUT_MORE></a> <span translate=MOVEUP_OR_TEXT></span> <a href=https://help.classlist.com/hc/en-us/requests/new target=_blank style=\"color: #eb004e; text-decoration: underline; font-weight: 600\" translate=MOVEUP_ASK_QUESTION></a> <span translate=MOVEUP_HELPDESK_TEXT></span></div><div ng-click=onTickBoxClicked() style=\"cursor: pointer; display: flex; align-items: center; gap: 8px\"><input ng-model=showAgainCheck type=checkbox style=\"margin: 0\"> <span translate=\"DON\'T_SHOW_AGAIN\"></span></div></div></div></div><div class=\"modal-footer moveup-footer\" style=\"border-top: none; padding: 24px 0 0; text-align: right\"><button type=button class=btn ng-click=close() style=\"background: #fff; color: #eb004e; border: 1px solid #eb004e; border-radius: 6px; padding: 10px 28px; font-weight: 600; margin-right: 8px\" translate=DISMISS_BTN></button> <button type=button class=btn ng-click=goToSchoolStructure() style=\"background: #eb004e; color: #fff; border: 1px solid #eb004e; border-radius: 6px; padding: 10px 28px; font-weight: 600\" translate=GOTO_SCHOOL_STRUCTURE_BTN></button></div></div>");
$templateCache.put("app/base/views/not-found-modal.html","<div><div class=modal-body style=\"padding: 40px\"><img src=assets/images/whoops.svg alt=\"\"><p translate=NOT_FOUND_TEXT style=\"margin: 20px 0\"></p><div style=\"height: 40px\"><button type=button class=\"btn btn-ghost pull-right\" translate=HOMEPAGE_BUTTON ng-click=confirm()></div></div></div>");
$templateCache.put("app/base/views/old-version-modal.html","<div><div class=modal-body style=\"padding: 22px 22px\"><p style=\"margin: 20px 0\">We\'ve been busy updating and improving Classlist! Press OK to get the latest version.<br>Thanks for using Classlist.</p><div><div style=text-align:right><button type=button class=\"btn btn-ghost\" ng-click=confirm()>OK</button></div></div></div></div>");
$templateCache.put("app/base/views/show-participants-modal.html","<div class=\"messages show-participants\" add-participants ng-class=\"{\'is-visible\':viewState.isReady}\"><ul class=basket><li ng-repeat=\"p in participants track by $index\" style=\"overflow: auto; width: 100%\"><div class=participant><figure class=avatar><avatar source={{p.avatar}} name=\"{{ p.firstName + \' \' + p.lastName }}\" width=40 height=40></avatar></figure><div class=\"{{ p.tickets ? \'two-lines-height\' : \'\' }}\"><div>{{ p.firstName }} {{ p.lastName }} <span ng-if=\"p.memberType === \'N\'\" style=padding-left:5px>(Invited member)</span></div><span ng-if=p.tickets><span class=dripicons-ticket></span> {{ p.tickets }} <span translate=TICKETS_LABEL></span></span></div></div></li></ul><a class=add-participant ng-click=\"close(); openAddParticipantsModal()\" ng-if=!addDisabled><span class=dripicons-plus></span> <span translate=ADD_RECIPIENT_BTN ng-if=!eventContext></span> <span translate=ADD_GUESTS_BTN ng-if=eventContext></span></a></div>");
$templateCache.put("app/base/views/stripe-login-modal.html","<div style=\"padding: 10px\"><div class=modal-header><h3 translate=SRIPE_CHOOSE_LOGIN style=\"font-weight: bold\"></h3></div><div class=modal-body style=\"text-align: center\"><p translate=SRIPE_CHOOSE_LOGIN_TEXT style=\"text-align: left\"></p><br><div><button type=button class=\"btn btn-primary\" ng-click=login() style=\"width: 100%; max-width: 300px; margin: auto\"><span>Login to Stripe</span></button></div><h3 translate=SRIPE_SIGNUP_HEADER style=\"font-size: 18px; margin-top: 30px; font-weight: bold\"></h3><div style=\"margin-top: 10px\"><button type=button class=\"btn btn-primary\" ng-click=signup() style=\"width: 100%; max-width: 300px; margin: auto\"><span>Create Stripe account</span></button></div><br></div><div class=modal-footer><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/base/views/tab-menu.html","<div ng-click=closePlusMenu() tab-menu-container class=\"visible-sm visible-xs hidden-md hidden-lg {{ showPlus || showMenu ? \'absolute-top\' : \'\' }}\"><div plus-menu class=\"{{ showPlus ? \'active\' : \'\' }}\"><div><div class=title translate=CREATE_NEW></div><ul><li ui-sref=announcements.create><span class=\"dripicons-broadcast icon\"></span><div><span translate=ANNOUNCEMENT_TITLE></span><p translate=PLUS_DESCR_1></p></div></li><li ui-sref=events.start><span class=\"dripicons-calendar icon\"></span><div><span translate=TAG_PRIVATE_EVENT></span><p translate=PLUS_DESCR_2></p></div></li><li ui-sref=invite.nonmemberlist ng-if=\"!integrationEnabled() && !isStaffWithoutUserManagementPermission()\"><svg width=22 height=22 viewBox=\"0 0 24 24\" fill=none style=\"float: left; margin: 0 10px 0 10px\" xmlns=http://www.w3.org/2000/svg><path fill-rule=evenodd clip-rule=evenodd d=\"M8 11C10.2091 11 12 9.20914 12 7C12 4.79086 10.2091 3 8 3C5.79086 3 4 4.79086 4 7C4 9.20914 5.79086 11 8 11ZM8 9C9.10457 9 10 8.10457 10 7C10 5.89543 9.10457 5 8 5C6.89543 5 6 5.89543 6 7C6 8.10457 6.89543 9 8 9Z\" fill=#627293 /><path d=\"M11 14C11.5523 14 12 14.4477 12 15V21H14V15C14 13.3431 12.6569 12 11 12H5C3.34315 12 2 13.3431 2 15V21H4V15C4 14.4477 4.44772 14 5 14H11Z\" fill=#627293 /><path d=\"M18 7H20V9H22V11H20V13H18V11H16V9H18V7Z\" fill=#627293 /></svg><div><span translate=ADD_AND_INVITE_PARENTS></span><p translate=PLUS_DESCR_3></p></div></li><li ui-sref=invite.integrationNonmemberlist ng-if=\"integrationEnabled() && !isStaffWithoutUserManagementPermission()\"><svg width=22 height=22 viewBox=\"0 0 24 24\" fill=none style=\"float: left; margin: 0 10px 0 10px\" xmlns=http://www.w3.org/2000/svg><path fill-rule=evenodd clip-rule=evenodd d=\"M8 11C10.2091 11 12 9.20914 12 7C12 4.79086 10.2091 3 8 3C5.79086 3 4 4.79086 4 7C4 9.20914 5.79086 11 8 11ZM8 9C9.10457 9 10 8.10457 10 7C10 5.89543 9.10457 5 8 5C6.89543 5 6 5.89543 6 7C6 8.10457 6.89543 9 8 9Z\" fill=#627293 /><path d=\"M11 14C11.5523 14 12 14.4477 12 15V21H14V15C14 13.3431 12.6569 12 11 12H5C3.34315 12 2 13.3431 2 15V21H4V15C4 14.4477 4.44772 14 5 14H11Z\" fill=#627293 /><path d=\"M18 7H20V9H22V11H20V13H18V11H16V9H18V7Z\" fill=#627293 /></svg><div><span translate=ADD_AND_INVITE_PARENTS></span><p translate=PLUS_DESCR_3></p></div></li><li ng-if=\"active_user.role !== \'STAFF\'\"><span class=\"dripicons-calendar icon\"></span><div ng-click=switchParentEvents()><span translate=PRIVATE_EVENT style=\"color: #3f51b5\"></span><p translate=PLUS_DESCR_4></p></div></li><!-- raffle start here --><div class=raffle-icon ui-sref=raffle.create ng-show=\"active_school.raffle && adminHaveRoles(\'STAFF\', \'AMBASSADOR\', \'COMM_REP\')\"><span><svg width=31px height=22px viewBox=\"0 0 37 27\" version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink style=\"margin: 0 4px 0 7px\"><g id=Parents stroke=none stroke-width=1 fill=none fill-rule=evenodd stroke-linecap=square><g id=Group-5 transform=\"translate(1.000000, 2.000000)\" stroke=#627293 stroke-width=2><path d=\"M19.3454545,16 C19.3454545,14.343 20.7128727,13 22.4,13 L22.4,8 L0,8 L0,13 C1.68712727,13 3.05454545,14.343 3.05454545,16 C3.05454545,17.657 1.68712727,19 0,19 L0,24 L22.4,24 L22.4,19 C20.7128727,19 19.3454545,17.657 19.3454545,16 Z\" id=Path></path><line x1=7.2 y1=14 x2=15.2 y2=14 id=Path></line><line x1=7.2 y1=18 x2=15.2 y2=18 id=Path></line><polyline id=Path points=\"22.3146769 5.79372273 25.1384615 0 25.1384615 0 27.9622462 5.79372273 34.2769231 6.722717 29.7076923 11.2321329 30.7864877 17.6 25.1384615 14.5937227\"></polyline></g></g></svg></span><div class=text-raffle><div translate=RAFFLE_MENU style=\"color: #627293; font-size: 14px\"></div><div translate=RAFFLE_SENTENCE style=\"color: #999; font-size: 12px\"></div></div></div><!-- raffle end here --><li ng-if=\"active_user.role !== \'STAFF\'\"><span class=\"dripicons-user-group icon\"></span><div ng-click=switchParentGroups()><span translate=TOPNAV_COMMUNITY_GROUP style=\"color: #3f51b5\"></span><p translate=PLUS_DESCR_5></p></div></li></ul><div><div class=cancel-button translate=CANCEL_BTN></div></div></div></div><div list-menu class=\"{{ showMenu ? \'active\' : \'\' }}\"><div><div style=\"height: 10px\"></div><ul><li ui-sref=get-started ng-hide=\"active_user.role == \'COMM_REP\' || active_user.role == \'CLASS_REP\'\"><span class=icon><svg xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 140.45 149.43\" width=20px height=20px stroke=currentColor viewBox=\"0 0 92 92\" enable-background=\"new 0 0 92 92\" xml:space=preserve><path class=cls-1 d=M182.3,447.58l-2.29-3c-5-6.54-11.06-8.25-22.09-11.35-5.79-1.63-13-3.65-21.9-6.92a35.24,35.24,0,0,1-22.35-23.63c-3.54-12.18-1-26.73,6.2-36.18,10.52-13.73,6.46-26.56,4.22-31.44a28.37,28.37,0,0,0-1.42-2.48c-2.82-4.6-8.68-14.16.83-20.85,5.6-3.94,9.84-2.42,14.76-.65a44.21,44.21,0,0,0,15.35,3.12c15.16,0.26,26.36-13.19,26.47-13.32l2.23-2.73,2.23,2.73C184.64,301,195.87,314.5,211,314.2a44.21,44.21,0,0,0,15.35-3.12c4.91-1.76,9.15-3.29,14.76.65,9.51,6.69,3.65,16.25.83,20.85a28.37,28.37,0,0,0-1.42,2.48c-2.24,4.88-6.3,17.71,4.22,31.44,7.24,9.46,9.74,24,6.2,36.18a35.24,35.24,0,0,1-22.35,23.63c-8.91,3.27-16.12,5.3-21.9,6.92-11,3.1-17.12,4.81-22.09,11.35ZM130.66,315a6.48,6.48,0,0,0-3.87,1.42c-4.33,3-3.2,6.66.77,13.13a30.92,30.92,0,0,1,1.75,3.09c2.08,4.54,7.88,20.67-4.89,37.34-6.19,8.08-8.29,20.57-5.24,31.08,1.92,6.6,6.74,15.4,18.81,19.83,8.7,3.19,15.79,5.19,21.48,6.79,10.39,2.92,17.17,4.83,22.82,10.72,5.66-5.89,12.43-7.8,22.82-10.72,5.69-1.6,12.77-3.59,21.48-6.79,12.07-4.43,16.89-13.23,18.81-19.83,3.05-10.51.95-23-5.24-31.08h0c-12.77-16.67-7-32.79-4.89-37.34a30.93,30.93,0,0,1,1.75-3.09c4-6.47,5.1-10.09.77-13.13-3.16-2.22-5-1.56-9.51.06A49.87,49.87,0,0,1,211.12,320c-13.82.32-24.4-8.58-28.82-13-4.42,4.43-15,13.33-28.82,13a49.87,49.87,0,0,1-17.18-3.46C133.85,315.61,132.19,315,130.66,315Z transform=\"translate(-112.08 -298.15)\" fill=currentColor /><path class=cls-1 d=M187.55,396c-10.67,0-20.65-7.6-20.65-23.15S178.43,350,188.41,350s13.08,2.55,13.08,2.55v6.24c0,1.27,1.39,2.3,3.1,2.3h4.88V344.76s-6.78-5.12-21.75-5.12S154,351.19,154,371.37s14.28,34.74,30.63,34.74a38.19,38.19,0,0,0,26-10l-6.54-6.39S198.22,396,187.55,396Z transform=\"translate(-112.08 -298.15)\" fill=currentColor /></svg></span><div><span translate=TOPNAV_GETSTARTED></span></div></li><li ng-click=openProfile()><span class=\"dripicons-user icon\"></span><div><span translate=PROFILE_BTN></span></div></li><li ui-sref=notifications ng-hide=isStaffWithoutUserManagementPermission()><span class=\"dripicons-bell icon\"></span><div class=badge ng-if=\"notifsContainer.notifications > 0\" style=\"left: 10px\">{{ notifsContainer.notifications }}</div><div><span translate=NAV_NOTIFICATIONS></span></div></li><li ui-sref=invite.nonmemberlist ng-if=!integrationEnabled() ng-hide=isStaffWithoutUserManagementPermission()><svg width=22 height=22 viewBox=\"0 0 24 24\" fill=none style=\"float: left; margin: 0 10px 0 10px\" xmlns=http://www.w3.org/2000/svg><path fill-rule=evenodd clip-rule=evenodd d=\"M8 11C10.2091 11 12 9.20914 12 7C12 4.79086 10.2091 3 8 3C5.79086 3 4 4.79086 4 7C4 9.20914 5.79086 11 8 11ZM8 9C9.10457 9 10 8.10457 10 7C10 5.89543 9.10457 5 8 5C6.89543 5 6 5.89543 6 7C6 8.10457 6.89543 9 8 9Z\" fill=#627293 /><path d=\"M11 14C11.5523 14 12 14.4477 12 15V21H14V15C14 13.3431 12.6569 12 11 12H5C3.34315 12 2 13.3431 2 15V21H4V15C4 14.4477 4.44772 14 5 14H11Z\" fill=#627293 /><path d=\"M18 7H20V9H22V11H20V13H18V11H16V9H18V7Z\" fill=#627293 /></svg><div style=\"margin-bottom: 5px\"><span translate=ADD_A_NONMEMBER_TO_THE_PARENT_LIST_TITLE></span></div></li><li ui-sref=invite.integrationNonmemberlist ng-if=integrationEnabled() ng-hide=isStaffWithoutUserManagementPermission()><svg width=22 height=22 viewBox=\"0 0 24 24\" fill=none style=\"float: left; margin: 0 10px 0 10px\" xmlns=http://www.w3.org/2000/svg><path fill-rule=evenodd clip-rule=evenodd d=\"M8 11C10.2091 11 12 9.20914 12 7C12 4.79086 10.2091 3 8 3C5.79086 3 4 4.79086 4 7C4 9.20914 5.79086 11 8 11ZM8 9C9.10457 9 10 8.10457 10 7C10 5.89543 9.10457 5 8 5C6.89543 5 6 5.89543 6 7C6 8.10457 6.89543 9 8 9Z\" fill=#627293 /><path d=\"M11 14C11.5523 14 12 14.4477 12 15V21H14V15C14 13.3431 12.6569 12 11 12H5C3.34315 12 2 13.3431 2 15V21H4V15C4 14.4477 4.44772 14 5 14H11Z\" fill=#627293 /><path d=\"M18 7H20V9H22V11H20V13H18V11H16V9H18V7Z\" fill=#627293 /></svg><div style=\"margin-bottom: 5px\"><span translate=ADD_A_NONMEMBER_TO_THE_PARENT_LIST_TITLE></span></div></li><li ui-sref=school.structure ng-hide=\"active_user.role == \'COMM_REP\' || active_user.role == \'CLASS_REP\' || integrationEnabled() || isStaffWithoutUserManagementPermission()\"><span class=\"dripicons-network-3 icon\"></span><div><span translate=SCHOOL_STRUCTURE></span></div></li><li ui-sref=school.integrationStructure ng-hide=\"active_user.role == \'COMM_REP\' || active_user.role == \'CLASS_REP\' || !integrationEnabled() || isStaffWithoutUserManagementPermission()\"><span class=\"dripicons-network-3 icon\"></span><div><span translate=SCHOOL_STRUCTURE></span></div></li><li ui-sref=events.list ng-hide=isStaffWithoutUserManagementPermission() style=\"{{ active_user.role == \'COMM_REP\' ? \'\' : \'\' }}\"><span class=\"dripicons-calendar icon\"></span><div><span translate=COMMUNITY_EVENTS></span></div></li><li ui-sref=raffle.list ng-show=\"active_school.raffle && adminHaveRoles(\'STAFF\', \'AMBASSADOR\', \'COMM_REP\')\"><svg width=31px height=22px viewBox=\"0 0 37 27\" version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink style=\"margin: 0 4px 0 7px\"><title>Group 5</title><g id=Parents stroke=none stroke-width=1 fill=none fill-rule=evenodd stroke-linecap=square><g id=Group-5 transform=\"translate(1.000000, 2.000000)\" stroke=#627293 stroke-width=2><path d=\"M19.3454545,16 C19.3454545,14.343 20.7128727,13 22.4,13 L22.4,8 L0,8 L0,13 C1.68712727,13 3.05454545,14.343 3.05454545,16 C3.05454545,17.657 1.68712727,19 0,19 L0,24 L22.4,24 L22.4,19 C20.7128727,19 19.3454545,17.657 19.3454545,16 Z\" id=Path></path><line x1=7.2 y1=14 x2=15.2 y2=14 id=Path></line><line x1=7.2 y1=18 x2=15.2 y2=18 id=Path></line><polyline id=Path points=\"22.3146769 5.79372273 25.1384615 0 25.1384615 0 27.9622462 5.79372273 34.2769231 6.722717 29.7076923 11.2321329 30.7864877 17.6 25.1384615 14.5937227\"></polyline></g></g></svg><div><div class=new-badge-space><div class=new-badge-mobile>New</div></div><span translate=RAFFLE></span></div></li><li ui-sref=groups.list ng-if=\"active_user.role === \'AMBASSADOR\'\"><span class=\"dripicons-user-group icon\"></span><div><span translate=TOPNAV_COMMUNITY_GROUPS></span></div></li><li ui-sref=groups.interestGroups ng-if=\"active_user.role === \'STAFF\'\"><span class=\"dripicons-user-group icon\"></span><div><span translate=TOPNAV_COMMUNITY_GROUPS></span></div></li><li ui-sref=announcements.list><span class=\"dripicons-broadcast icon\"></span><div><span translate=TOPNAV_ANNOUNCEMENTS></span></div></li><li ui-sref=school.admins style=\"{{ active_user.role == \'COMM_REP\' || active_user.role == \'CLASS_REP\' ? \'\' : \'\' }}\"><svg class=\"dripicons-graduation icon\" style=\"padding-right: 5px;margin-left:7px;margin-right:3px\" width=24 height=24 viewBox=\"0 0 24 24\" fill=none xmlns=http://www.w3.org/2000/svg><path d=\"M10.661 13.488c-2.66 0-5.02.6-6.572 1.123a2.818 2.818 0 0 0-1.907 2.675v3.739h9.421\" stroke=#627293 stroke-width=1.5 /><path clip-rule=evenodd d=\"M10.662 13.488v0c-2.601 0-4.71-3.052-4.71-5.653v-.942c0-2.602 2.109-4.711 4.71-4.711v0c2.601 0 4.71 2.11 4.71 4.71v.943c0 2.601-2.109 5.653-4.71 5.653z\" stroke=#627293 stroke-width=1.5 stroke-linecap=square /><path d=\"m18.199 12.545 1.456 2.95 3.255.473-2.356 2.296.556 3.242-2.911-1.53-2.911 1.53.556-3.242-2.356-2.296 3.255-.473 1.456-2.95z\" fill=#627293 /></svg><div><span translate=REPS_AND_ADMINS style=margin-top:3px></span></div></li><li ui-sref=school.page style=\"{{ active_user.role == \'COMM_REP\' || active_user.role == \'CLASS_REP\' ? \'\' : \'\' }}\"><span class=\"dripicons-graduation icon\"></span><div><span translate=SCHOOL_AND_ADMIN_PROFILE></span></div></li><li ui-sref=website.settings><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink width=16px height=16px stroke=currentColor viewBox=\"0 0 92 92\" enable-background=\"new 0 0 92 92\" xml:space=preserve fill=#627293 style=\"float: left; margin: 0px 18px 0 10px\"><path fill=#627293 id=XMLID_1666_ d=\"M46,0C20.6,0,0,20.6,0,46s20.6,46,46,46s46-20.6,46-46S71.4,0,46,0z M49.7,83.8c-0.2,0-0.4,0-0.7,0.1V62.2\n							c5.2-0.1,9.9-0.2,14.2-0.5C59.4,73.4,52.3,81.2,49.7,83.8z M42.3,83.8c-2.7-2.7-9.7-10.5-13.5-22.1c4.2,0.3,9,0.5,14.2,0.5v21.7\n							C42.8,83.9,42.6,83.8,42.3,83.8z M8,46c0-2.5,0.3-5,0.7-7.4c2.2-0.4,6.4-1,12.3-1.6c-0.5,2.9-0.8,5.9-0.8,9.1c0,3.2,0.3,6.2,0.7,9\n							c-5.8-0.6-10.1-1.2-12.3-1.6C8.3,51,8,48.5,8,46z M26.3,46c0-3.4,0.4-6.6,1-9.6c4.6-0.3,9.8-0.6,15.7-0.6v20.4\n							c-5.8-0.1-11.1-0.3-15.8-0.7C26.7,52.6,26.3,49.4,26.3,46z M49.6,8.2c2.7,2.7,9.6,10.7,13.5,22.1c-4.2-0.3-8.9-0.5-14.1-0.5V8.1\n							C49.2,8.1,49.4,8.2,49.6,8.2z M43,8.1v21.7c-5.2,0.1-9.9,0.2-14.1,0.5c3.8-11.4,10.8-19.4,13.4-22.1C42.6,8.2,42.8,8.1,43,8.1z\n							M49,56.2V35.8c5.8,0.1,11.1,0.3,15.7,0.6c0.6,3,1,6.2,1,9.6c0,3.4-0.3,6.6-0.9,9.6C60.2,55.9,54.9,56.1,49,56.2z M70.9,37\n							c5.9,0.6,10.1,1.2,12.3,1.6C83.7,41,84,43.5,84,46c0,2.5-0.3,5-0.7,7.4c-2.2,0.4-6.4,1-12.3,1.6c0.5-2.9,0.7-5.9,0.7-9.1\n							C71.7,42.9,71.4,39.8,70.9,37z M81.4,32.2c-2.8-0.4-6.8-0.9-11.9-1.4c-2.4-8.6-6.6-15.5-10.1-20.4C69.5,14.2,77.5,22.2,81.4,32.2z\n							M32.6,10.4c-3.6,4.8-7.7,11.7-10.1,20.3c-5,0.4-9,1-11.9,1.4C14.5,22.2,22.6,14.2,32.6,10.4z M10.6,59.8c2.8,0.4,6.8,0.9,11.8,1.4\n							c2.4,8.6,6.4,15.5,10,20.3C22.4,77.6,14.5,69.7,10.6,59.8z M59.6,81.5c3.6-4.8,7.6-11.6,10-20.2c5-0.4,9-1,11.8-1.4\n							C77.5,69.7,69.6,77.6,59.6,81.5z\" fill=currentColor /></svg><div><div class=new-badge-space><div class=new-badge-mobile>New</div></div><span translate=WEBSITE></span></div></li><li ui-sref=monitor ng-if=\"active_user.role === \'AMBASSADOR\' && active_school.parent\"><svg width=27 height=27 viewBox=\"0 0 24 24\" fill=#627293 style=\"float: left; margin: 0px 8px 0 8px\" xmlns=http://www.w3.org/2000/svg><path d=\"M15 6H3V8H15V6Z\" fill=#627293 /><path d=\"M15 10H3V12H15V10Z\" fill=#627293 /><path d=\"M3 14H11V16H3V14Z\" fill=#627293 /><path d=\"M11.9905 15.025L13.4049 13.6106L15.526 15.7321L19.7687 11.4895L21.1829 12.9037L15.526 18.5606L11.9905 15.025Z\" fill=#627293 /></svg><div><span translate=MONITOR_COMMUNITY_TITLE></span></div></li><li ui-sref=marketplace.list ng-if=\"active_user.role === \'AMBASSADOR\' && active_school.parent\"><svg width=27 height=27 viewBox=\"0 0 24 24\" fill=#627293 style=\"float: left; margin: 0px 8px 0 8px\" xmlns=http://www.w3.org/2000/svg><path d=\"M15 6H3V8H15V6Z\" fill=#627293 /><path d=\"M15 10H3V12H15V10Z\" fill=#627293 /><path d=\"M3 14H11V16H3V14Z\" fill=#627293 /><path d=\"M11.9905 15.025L13.4049 13.6106L15.526 15.7321L19.7687 11.4895L21.1829 12.9037L15.526 18.5606L11.9905 15.025Z\" fill=#627293 /></svg><div><span translate=MONITOR_MARKETPLACE_TITLE></span></div></li><li><a href=https://help.classlist.com target=_blank><span class=\"dripicons-question icon\" style=\"color: #627293\"></span><div><span style=\"color: #627293 !important\" translate=TOPNAV_TRAININGHELP></span></div></a></li><li ng-click=logout()><span class=\"dripicons-export icon\" style=\"color: #627293 !important\"></span><div><span translate=SIGNOUT_BTN></span></div></li></ul><div style=\"height: 20px\"></div></div></div><div tab-menu ng-if=\"!isOnWizard && active_school\"><ul><li ui-sref=dashboard.main ui-sref-active=active id=tab-dashboard class=\"{{ showPlus || showMenu ? \'force-inactive\' : \'\' }}\"><span class=dripicons-home></span> <span class=tab-label translate=TAB_DASHBOARD></span></li><li ui-sref=users.manageparents ng-hide=isStaffWithoutUserManagementPermission() ui-sref-active=active id=tab-classlist class=\"{{ showPlus || showMenu ? \'force-inactive\' : \'\' }} {{ active_user.role == \'COMM_REP\' ? \'vis-hidden\' : \'\' }}\"><span class=dripicons-user-id></span> <span class=tab-label translate=TAB_PARENTS></span></li><li class=\"{{ showPlus || showMenu ? \'force-inactive\' : \'\' }}\" ui-sref=notifications ui-sref-active=active id=tab-classlist ng-hide=!isStaffWithoutUserManagementPermission()><span class=dripicons-bell></span><div class=badge ng-if=\"notifsContainer.notifications > 0\">{{ notifsContainer.notifications }}</div><div><span class=tab-label translate=NAV_NOTIFICATIONS></span></div></li><li ng-click=menuPlus($event) id=tab-plus class=\"{{ showPlus ? \'active\' : \'\' }}\"><span class=\"icons dripicons-plus\"></span> <span class=tab-label translate=TAB_ADD></span></li><li class=\"{{ showPlus || showMenu ? \'force-inactive\' : \'\' }}\" ui-sref=events.list ui-sref-active=active id=tab-classlist ng-hide=!isStaffWithoutUserManagementPermission()><span class=dripicons-calendar></span> <span class=tab-label translate=COMMUNITY_EVENTS></span></li><li ui-sref=users.approveparents ng-hide=isStaffWithoutUserManagementPermission() ui-sref-active=active id=tab-classlist class=\"{{ showPlus || showMenu ? \'force-inactive\' : \'\' }} {{ active_user.role == \'COMM_REP\' ? \'vis-hidden\' : \'\' }}\" style=\"text-align: center\"><svg width=18 height=18 viewBox=\"0 0 24 24\" fill=none class=approved-icon xmlns=http://www.w3.org/2000/svg><path d=\"M10.2426 16.3137L6 12.071L7.41421 10.6568L10.2426 13.4853L15.8995 7.8284L17.3137 9.24262L10.2426 16.3137Z\" fill=#627293 /><path fill-rule=evenodd clip-rule=evenodd d=\"M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21Z\" fill=#627293></path></svg> <span class=tab-label translate=TAB_APPROVE></span></li><li ng-click=menuMenu($event) id=tab-menu class=\"{{ showMenu ? \'active\' : \'\' }}\"><span class=dripicons-menu></span> <span class=tab-label translate=TAB_MORE></span><div class=badge ng-if=\"notifsContainer.notifications > 0\">{{ notifsContainer.notifications }}</div></li></ul></div></div><div ng-if=\"showPlus || showMenu\" class=\"mobile-menu-background visible-sm visible-xs hidden-md hidden-lg\"></div>");
$templateCache.put("app/base/views/white-screen.html","<div id=white-screen></div>");
$templateCache.put("app/base/views/window-beforeleave-modal.html","<div style=\"padding: 15px\"><div class=modal-header><h3 translate=BEFORE_LEAVEPAGE_TITLE></h3></div><div class=modal-footer><button type=button class=\"btn btn-default pull-right\" translate=STAY_PAGE_BTN ng-click=stay() style=\"margin-left: 10px\"><button type=button class=\"btn btn-default pull-right\" translate=LEAVE_PAGE_BTN ng-click=leave()></div></div>");
$templateCache.put("app/dashboard/views/dashboard-main.html","<div class=\"content-logged dashboard-main\"><div><section class=row><div class=\"col-md-12 dashboard-feedback\" style=\"text-align: right; padding-bottom: 5px\"><a href=https://forms.gle/AsaQFpz3mw6frCYV8 target=_blank style=\"text-decoration: underline; font-size: 16px;padding-bottom: 5px\">Give feedback</a></div><!-- PWA Sunset Modal Start --><div class=\"col-md-12 dashboard-sunset-announcement-container\" style=\"padding-bottom: 5px\" ng-if=\"active_user.role !== \'STAFF\' && isSunsetModalVisible && !isThisMobile() && getOS() !== \'Flutter\'\"><div class=announcement-container><div class=content-wrapper><div class=announcement-image-container><img src=https://storage.googleapis.com/classlist-branding/app-assets/pwa-sunset-phone-3.png alt=\"QR and Phone\"></div><div class=announcement-text-container><p class=announcement-title translate=PWA_SUNSET_TITLE></p><p class=announcement-description translate=PWA_SUNSET_TITLE_DESC style=\"padding-bottom: 5px\"></p><p class=announcement-learn-more translate=PWA_SUNSET_TITLE_DESC_2 style=\"margin-bottom: 10px\"></p><div class=announcement-download-buttons style=\"padding-bottom: 20px\"><div class=announcement-button><a title=\"apple store\" ng-click=gotoAppStore() target=_blank><img src=https://storage.googleapis.com/classlist-branding/email-template/ios-store-link.png alt=\"Apple Store\"></a></div><div class=announcement-button><a title=\"play store\" ng-click=gotoGooglePlay() target=_blank><img src=https://storage.googleapis.com/classlist-branding/email-template/android-store-link.png alt=\"Google Play\"></a></div></div><div style=\"display: flex; align-items: center; margin-left: auto;margin-bottom:10px\"><label class=structure-show-parents-checkbox style=\"cursor:pointer; display: flex; align-items: center; margin-bottom: 0\"><input type=checkbox ng-model=dontShowPwaSunsetAgain ng-change=onPwaSunsetCheckboxChange(dontShowPwaSunsetAgain) style=\"margin-right:7px; width:20px; height:20px\"> <span translate=PWA_SUNSET_TITLE_DESC_3 style=\"font-size: 13px\"></span></label></div></div><button class=announcement-close-button ng-click=closeSunsetModal()><svg width=24 height=24 viewBox=\"0 0 24 24\" fill=none xmlns=http://www.w3.org/2000/svg><path d=\"M20 4 4 20M20 20 4 4\" stroke=#627293 stroke-width=1.5 stroke-linecap=round stroke-linejoin=round /></svg></button></div></div></div><!-- PWA Sunset Modal End--><div class=\"col-md-6 tablet-view-margins section-bottom-margin\"><div class=\"margin stat-cards\" ng-if=\"!integrationEnabled && !isTrialSchool && !isStaffWithoutUserManagementPermission()\"><div class=\"content big\" style=\"min-height: auto\"><p class=title translate=DASHBOARD_AWAITING_APPROVAL style=margin-bottom:15px></p><div class=\"row tablet-view graph-cols\"><section class=tablet-view_parents><div class=graph-list><div class=dashboard-stat-circle style=\"display: flex;padding-left:30px\"><span style=\"font-weight: bold;padding-right:8px;padding-top:5px;text-align: center;min-width: 40px\">{{ parents.waitingApprovalCount }}</span><div><span translate=DASHBOARD_AWAITING_APPROVAL_ACCOUNT_REQUESTS></span> <span ng-click=waitingInfoModal() class=\"icon dripicons-information\"></span><br><span translate=DASHBOARD_AWAITING_APPROVAL_NO_PENDING ng-if=\"!parents.waitingApprovalCount || parents.waitingApprovalCount == 0\"></span> <span translate=DASHBOARD_AWAITING_APPROVAL_PENDING ng-if=\"parents.waitingApprovalCount && parents.waitingApprovalCount > 0\"></span></div></div><a class=\"btn btn-primary graph-list_button\" translate=APPROVE_PARENTS_BTN href=#/users/approve-parents style=margin-top:15px;margin-bottom:10px;margin-left:13px ng-if=\"parents.waitingApprovalCount && parents.waitingApprovalCount > 0 && !isOnlyClassRep\"></a></div></section></div></div></div><div class=\"margin stat-cards\"><div class=\"content big\" style=\"min-height: auto\"><p class=title translate=DASHBOARD_REACH_TITLE style=margin-bottom:6px></p><p class=title style=\"font-size: 18px;margin-bottom: 12px; font-weight: 600\" ng-if=parents translate=DASHBOARD_REACH_TOTAL_PARENT translate-values=\"{ count:parents.memberCount + parents.nonMemberCount }\"></p><span translate=BY_STATUS style=\"color:#627293; font-size:14px\"></span><div class=\"row tablet-view graph-cols\"><section class=tablet-view_parents style=padding-top:10px><div class=graph-list style=padding-left:30px><div class=dashboard-stat-circle style=\"display: flex\"><span style=\"font-weight: bold;padding-right:8px;text-align: center;min-width: 40px\">{{ parents.memberCount }}</span><div><span translate=DASHBOARD_REACH_ACCOUNT_ACTIVATED></span><br><span translate=DASHBOARD_REACH_ACCOUNT_ACTIVATED_DESCRIPTION style=\"font-size: 12px\"></span></div></div><div class=dashboard-stat-circle style=\"display: flex\"><span style=\"font-weight: bold;padding-right:8px;padding-top:5px;text-align: center;min-width: 40px\">{{ parents.nonMemberCount }}</span><div><span translate=DASHBOARD_REACH_NOT_ACTIVATED></span> <span ng-click=notActivatedModal() class=\"icon dripicons-information\"></span><br><span translate=DASHBOARD_REACH_NOT_ACTIVATED_DESCRIPTION style=\"font-size: 12px\"></span></div></div></div><a ng-if=!isStaffWithoutUserManagementPermission() class=\"btn btn-primary graph-list_button\" translate=INVITE_PARENTS_BTN href=#/invite/add-invite style=margin-top:15px;margin-bottom:10px;margin-left:13px></a></section></div></div></div><div class=\"content stat-cards\"><section class=tablet-view-margins><div class=row><section class=\"col-md-6 tablet-view_cards\"><div class=\"content small stat-cards\" style=\"border: none; padding: 0; min-height: 40px\"><a ng-click=postsCountRedirect() ng-if=!isStaffWithoutUserManagementPermission()><div class=row><section class=col-md-4><div class=icon-content><div class=\"icon dripicons-document\"></div></div></section><section class=col-md-8><div><h2>{{ general.postCount }}</h2><p translate=POSTS_THIS_MONTH></p><p class=lead translate=THIS_MONTH></p></div></section></div></a><a ng-if=isStaffWithoutUserManagementPermission() style=\"cursor: auto\"><div class=row><section class=col-md-4><div class=icon-content><div class=\"icon dripicons-document\" style=\"color: #b6c2db\"></div></div></section><section class=col-md-8><div><h2 style=color:#627293>{{ general.postCount }}</h2><p translate=POSTS_THIS_MONTH style=\"color: black\"></p><p class=lead translate=THIS_MONTH></p></div></section></div></a></div></section><section class=\"col-md-6 tablet-view_cards\"><div class=\"content small stat-cards\" style=\"border: none; padding: 0; min-height: 40px\"><a href=#/users/approve-parents ng-if=\"!integrationEnabled  && !isStaffWithoutUserManagementPermission()\"><div class=row><section class=col-md-4><div class=icon-content><div class=\"icon dripicons-user\"></div></div></section><section class=col-md-8><div><h2>{{ general.newMemberCount }}</h2><p translate=NEW_MEMBERS></p><p class=lead translate=THIS_MONTH></p></div></section></div></a><a ng-if=\"!integrationEnabled  && isStaffWithoutUserManagementPermission()\" style=\"cursor: auto\"><div class=row><section class=col-md-4><div class=icon-content><div class=\"icon dripicons-user\" style=\"color: #b6c2db\"></div></div></section><section class=col-md-8><div><h2 style=color:#627293>{{ general.newMemberCount }}</h2><p translate=NEW_MEMBERS style=\"color: black\"></p><p class=lead translate=THIS_MONTH></p></div></section></div></a><a href=\"#/users/manage-parents/?latest=true\" ng-if=\"integrationEnabled  && !isStaffWithoutUserManagementPermission()\"><div class=row><section class=col-md-4><div class=icon-content><div class=\"icon dripicons-user\"></div></div></section><section class=col-md-8><div><h2>{{ general.newMemberCount }}</h2><p translate=NEW_MEMBERS></p><p class=lead translate=THIS_MONTH></p></div></section></div></a><a ng-if=\"integrationEnabled && isStaffWithoutUserManagementPermission()\" style=\"cursor: auto\"><div class=row><section class=col-md-4><div class=icon-content><div class=\"icon dripicons-user\" style=\"color: #b6c2db\"></div></div></section><section class=col-md-8><div><h2 style=color:#627293>{{ general.newMemberCount }}</h2><p translate=NEW_MEMBERS style=\"color: black\"></p><p class=lead translate=THIS_MONTH></p></div></section></div></a></div></section></div><div class=row><section class=\"col-md-6 tablet-view_cards\"><div class=\"content small green stat-cards\" style=\"border: none; padding: 0; min-height: 40px\"><a href=#/community-events/list><div class=row><section class=col-md-4><div class=icon-content><div class=\"icon dripicons-calendar\"></div></div></section><section class=col-md-8><div><h2>{{ general.upcomingEventCount }}</h2><p translate=COMMUNITY_EVENTS></p></div></section></div></a></div></section><section class=\"col-md-6 tablet-view_cards\"><div class=\"content small green\" style=\"border: none; padding: 0; min-height: 40px\"><a href=#/school/details/ ><div class=row><section class=col-md-4><div class=icon-content><div class=\"icon dripicons-gear\"></div></div></section><section class=col-md-8><div><h2>{{ general.adminCount }}</h2><p translate=ADMIN_MEMBERS></p></div></section></div></a></div></section></div></section></div></div><div class=\"col-md-6 tablet-view-margins section-bottom-margin\"><div class=margin><div class=\"content big\"><span class=title translate=TOPNAV_ANNOUNCEMENTS></span> <span class=title-label translate=THIS_MONTH></span><div class=row style=\"margin-top: 25px\"><section class=\"col-md-6 tablet-view_graph\"><a ui-sref=announcements.list ui-sref-active=active href=#/announcements/list><div percentage-graph percentage=\"{{ announcements.totalOpenedPercentageNow }}\" text=\"{{ openedTranslated }}\" class=dashboard-percentage></div></a></section><section class=\"col-md-6 tablet-view_parents\"><div class=graph-list><div class=dashboard-stat-circle><p>{{ announcements.totalAnnouncementCount }} <span translate=ANNOUNCEMENTS_SENT></span></p></div><div class=dashboard-stat-circle><p>{{ announcements.totalOpenedPercentageLastMonth }}<span translate=OPENED_LAST_MONTH></span></p></div><div class=separator></div><div class=star-text><span translate=ANNOUNCEMENTS_YOU_SENT translate-values=\"{\'count\': announcements.announcementsSentByUser}\"></span></div><a id=announcements-create-button class=\"btn btn-ghost graph-list_button\" style=\"line-height: normal !important\" ui-sref=announcements.create><span translate=CREATE_ANNOUNCEMENT_BTN></span></a></div></section></div></div><!-- Follow us on social media--><div class=\"content big\" style=\"margin-top: 16px; min-height: 0\"><span class=title translate=FOLLOW_US></span><br><span class=title-social translate=FOLLOW_US_DETAIL></span><div class=row style=\"margin-top: 25px; margin-left: 0px\"><a href=https://www.facebook.com/schoolclasslist/ target=_blank class=\"icon-button facebook\"><i class=icon-facebook><svg width=36px viewBox=\"0 0 512 512\"><path d=\"M211.9 197.4h-36.7v59.9h36.7V433.1h70.5V256.5h49.2l5.2-59.1h-54.4c0 0 0-22.1 0-33.7 0-13.9 2.8-19.5 16.3-19.5 10.9 0 38.2 0 38.2 0V82.9c0 0-40.2 0-48.8 0 -52.5 0-76.1 23.1-76.1 67.3C211.9 188.8 211.9 197.4 211.9 197.4z\"/></svg> </i><span></span></a> <a href=https://www.linkedin.com/company/schoolclasslist/ target=_blank class=\"icon-button linkedin\"><i class=icon-linkedin><svg width=36px viewBox=\"0 0 512 512\"><path d=\"M186.4 142.4c0 19-15.3 34.5-34.2 34.5 -18.9 0-34.2-15.4-34.2-34.5 0-19 15.3-34.5 34.2-34.5C171.1 107.9 186.4 123.4 186.4 142.4zM181.4 201.3h-57.8V388.1h57.8V201.3zM273.8 201.3h-55.4V388.1h55.4c0 0 0-69.3 0-98 0-26.3 12.1-41.9 35.2-41.9 21.3 0 31.5 15 31.5 41.9 0 26.9 0 98 0 98h57.5c0 0 0-68.2 0-118.3 0-50-28.3-74.2-68-74.2 -39.6 0-56.3 30.9-56.3 30.9v-25.2H273.8z\"/></svg> </i><span></span></a> <a href=https://www.instagram.com/classlist/ target=_blank class=\"icon-button instagram\"><i class=icon-instagram><svg width=36px viewBox=\"0 0 512 512\"><g><path d=\"M256 109.3c47.8 0 53.4 0.2 72.3 1 17.4 0.8 26.9 3.7 33.2 6.2 8.4 3.2 14.3 7.1 20.6 13.4 6.3 6.3 10.1 12.2 13.4 20.6 2.5 6.3 5.4 15.8 6.2 33.2 0.9 18.9 1 24.5 1 72.3s-0.2 53.4-1 72.3c-0.8 17.4-3.7 26.9-6.2 33.2 -3.2 8.4-7.1 14.3-13.4 20.6 -6.3 6.3-12.2 10.1-20.6 13.4 -6.3 2.5-15.8 5.4-33.2 6.2 -18.9 0.9-24.5 1-72.3 1s-53.4-0.2-72.3-1c-17.4-0.8-26.9-3.7-33.2-6.2 -8.4-3.2-14.3-7.1-20.6-13.4 -6.3-6.3-10.1-12.2-13.4-20.6 -2.5-6.3-5.4-15.8-6.2-33.2 -0.9-18.9-1-24.5-1-72.3s0.2-53.4 1-72.3c0.8-17.4 3.7-26.9 6.2-33.2 3.2-8.4 7.1-14.3 13.4-20.6 6.3-6.3 12.2-10.1 20.6-13.4 6.3-2.5 15.8-5.4 33.2-6.2C202.6 109.5 208.2 109.3 256 109.3M256 77.1c-48.6 0-54.7 0.2-73.8 1.1 -19 0.9-32.1 3.9-43.4 8.3 -11.8 4.6-21.7 10.7-31.7 20.6 -9.9 9.9-16.1 19.9-20.6 31.7 -4.4 11.4-7.4 24.4-8.3 43.4 -0.9 19.1-1.1 25.2-1.1 73.8 0 48.6 0.2 54.7 1.1 73.8 0.9 19 3.9 32.1 8.3 43.4 4.6 11.8 10.7 21.7 20.6 31.7 9.9 9.9 19.9 16.1 31.7 20.6 11.4 4.4 24.4 7.4 43.4 8.3 19.1 0.9 25.2 1.1 73.8 1.1s54.7-0.2 73.8-1.1c19-0.9 32.1-3.9 43.4-8.3 11.8-4.6 21.7-10.7 31.7-20.6 9.9-9.9 16.1-19.9 20.6-31.7 4.4-11.4 7.4-24.4 8.3-43.4 0.9-19.1 1.1-25.2 1.1-73.8s-0.2-54.7-1.1-73.8c-0.9-19-3.9-32.1-8.3-43.4 -4.6-11.8-10.7-21.7-20.6-31.7 -9.9-9.9-19.9-16.1-31.7-20.6 -11.4-4.4-24.4-7.4-43.4-8.3C310.7 77.3 304.6 77.1 256 77.1L256 77.1z\"/><path d=\"M256 164.1c-50.7 0-91.9 41.1-91.9 91.9s41.1 91.9 91.9 91.9 91.9-41.1 91.9-91.9S306.7 164.1 256 164.1zM256 315.6c-32.9 0-59.6-26.7-59.6-59.6s26.7-59.6 59.6-59.6 59.6 26.7 59.6 59.6S288.9 315.6 256 315.6z\"/><circle cx=351.5 cy=160.5 r=21.5 /></g></svg> </i><span></span></a></div></div></div></div></section></div></div>");
$templateCache.put("app/events/views/before-create-modal.html","<div style=\"padding: 15px\"><div class=modal-header><h3 translate=BEFORE_CREATE_TITLE></h3></div><div class=modal-body><p translate=BEFORE_CREATE_TEXT translate-values=\"{ \'href\': switchHref }\"></p></div><div class=modal-footer><button type=button class=\"btn btn-ghost pull-right\" translate=CONTINUE_PRIVATE_EVENT_BTN ng-click=close()></div></div>");
$templateCache.put("app/events/views/before-invite-modal.html","<div style=\"padding: 15px\"><div class=modal-header><h3 translate=LET_GUESTS_KNOW_MORE_HEADER></h3></div><div class=modal-body><p translate=LET_GUESTS_KNOW_MORE_TEXT></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=GOTIT_BTN ng-click=close()></div></div>");
$templateCache.put("app/events/views/before-ticketing-modal.html","<div style=\"padding: 15px\"><div class=modal-header><h3 translate=BEFORE_TICKETING_HEADER></h3></div><div class=modal-body><p translate=BEFORE_TICKETING_TEXT></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=GOTIT_BTN ng-click=gotit() style=\"margin-left: 10px\"><button type=button class=\"btn btn-ghost pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/events/views/buy-tickets-modal.html","<div class=event-buytickets-modal style=\"padding: 15px\"><div class=modal-header><h3 ng-show=\"ticketList.paidEventType && ticketList.paidEventType != \'FREE\'\" translate=BUY_TICKETS_HEADER translate-values=\"{ \'eventName\': event.title }\"></h3><h3 ng-show=\"ticketList.paidEventType && ticketList.paidEventType == \'FREE\'\" translate=GET_TICKETS_HEADER translate-values=\"{ \'eventName\': event.title }\"></h3></div><div class=modal-body><div class=tickets-list-modal ng-show=ticketList><div class=\"row header\"><div class=\"col-md-6 col-xs-12 col-sm-12\"><span translate=TYPE></span></div><div class=\"col-md-2 col-xs-4 col-sm-4\"><span translate=PRICE></span></div><div class=\"col-md-2 col-xs-4 col-sm-4\"><span translate=QUANTITY></span></div><div class=\"col-md-2 col-xs-4 col-sm-4 align-right\"><span translate=TOTAL></span></div></div><div class=row ng-repeat=\"ticket in ticketList.tickets\"><div class=\"col-md-6 col-xs-12 col-sm-12\"><span>{{ ticket.ticketName }}</span></div><div class=\"col-md-2 col-xs-4 col-sm-4\"><span ng-show=ticketList.ticketCurrency translate=\"{{ ticketList.ticketCurrency }}_SHORT\"></span><span>{{ ticket.ticketPrice | currency: \"\" }}</span></div><div class=\"col-md-2 col-xs-4 col-sm-4\"><div class=is-relative><select ng-model=ticket.quantity class=form-control ng-disabled=\"ticket.availableTicket == 0\"><option ng-if=\"ticket.availableTicket == 0\" translate=SOLD_OUT></option><option ng-repeat=\"i in getNumber(ticket.availableTicket) track by $index\" value=\"{{ $index+1 }}\">{{ $index+1 }}</option></select><span class=\"dripicons-chevron-down select-arrow\" style=\"right: -2px\"></span></div></div><div class=\"col-md-2 col-xs-4 col-sm-4 align-right\"><span ng-if=\"(ticket.quantity * ticket.ticketPrice) && ticketList.ticketCurrency\" translate=\"{{ ticketList.ticketCurrency }}_SHORT\"></span><span>{{ (ticket.quantity * ticket.ticketPrice) | currency: \"\" }}</span></div></div><div class=total-label><div class=align-right><span ng-show=ticketList.ticketCurrency translate=\"{{ ticketList.ticketCurrency }}_SHORT\"></span><span>{{ getTotalTickets(ticketList.tickets) | currency: \"\" }}</span></div></div></div></div><div class=modal-footer><span ng-show=\"ticketList.paidEventType && ticketList.paidEventType != \'FREE\'\" class=pull-right><button type=button class=\"btn btn-primary btn-paypal\" ng-click=save() ng-disabled=buingTickets></button> </span><span ng-show=\"ticketList.paidEventType && ticketList.paidEventType == \'FREE\'\" class=pull-right><button type=button class=\"btn btn-primary\" ng-click=save() ng-disabled=buingTickets translate=GET_TICKETS></button> </span><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></button></div></div>");
$templateCache.put("app/events/views/cancel-modal.html","<div><div class=modal-header><h3 translate=CANCEL_EVENT_HEADER></h3></div><div class=modal-body><p class=multiple-line-text translate=CANCEL_EVENT_BODY style=\"font-size: 14px;\n        line-height: 1.42857143;\n        color: #333\"></p><div style=\"overflow: auto; margin-top: 15px\"><span translate=NOTIFY_GUESTS style=\"float: left; margin-right: 16px; font-size: 16px; color: #4D5055; font-weight: 600\"></span><div class=pull-left><div ng-click=switchCancelNotification() ng-model=cancelNotification class=\"mobile-checkmark {{ cancelNotification ? \'enabled\' : \'\' }}\"><div></div></div></div></div><div ng-if=cancelNotification><br><textarea ng-change=updateCancelMessage(this) placeholder=\"Type your message here\" class=\"form-control bordered\" maxlength=500 autoresize-textarea style=\"min-height: 100px\" ng-model=cancelMessage>{{cancelMessage}}</textarea></div><br></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=YES_CANCEL_EVENT ng-click=save() ng-disabled=\"cancellingEvent || !cancelMessage\"><button type=button class=\"btn btn-default pull-right\" translate=NO_GO_BACK ng-click=close()></div></div>");
$templateCache.put("app/events/views/cancel-ticket-type-modal.html","<div style=\"padding: 15px\"><div class=modal-body><p translate=CANCEL_TICKET_TYPE></p></div><div class=modal-footer><button type=button class=\"btn btn-ghost pull-right\" translate=DONT_CANCEL_BTN ng-click=stay()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=leave()></button></button></div></div>");
$templateCache.put("app/events/views/confirm-owner-modal.html","<div><div class=modal-header><h3 translate=ADD_OWNER_HEADER></h3></div><div class=modal-body><p translate=ADD_OWNER_TEXT translate-values=\"{\'name\':fullname}\"></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=OK_BTN ng-disabled=adding ng-click=add()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=cancel()></div></div>");
$templateCache.put("app/events/views/create.html","<section class=\"event-view event-create\" add-guests gallery-picker ng-class=\"{\'is-visible\': viewState.isReady }\"><div class=\"page-view-header clearfix\"><div><div><div><a ng-click=back() id=header-back-button style=\"float: left; margin-right: 10px; position: relative\" class=page-view-header__back><span class=dripicons-arrow-thin-left></span></a></div></div></div></div><div class=page-container-header-from-top style=\"margin-top: 0 !important\"><div class=mobile-row-fix><section class=\"event-section event-create-container\" style=\"padding-right:0 !important\"><h1 style=font-size:26px;font-weight:500 translate=EVENT_COVER_IMAGE>Event cover image</h1><br><div class=event-image-wrapper><div class=event-preview-fixed><div class=event-picture style=\"width: 100%; height: 160px; border-radius: 12px; overflow: hidden\"><div ng-if=!isDefaultImage(event.fileLibrary.image) class=img style=\"width: 100%; height: 100%; background-size: cover; background-position: center; background-image: url(\'{{ event.fileLibrary.image }}\')\"></div><div ng-if=isDefaultImage(event.fileLibrary.image) style=\"width: 100%; height: 100%; background-color: #008fa1; display: flex; align-items: center; justify-content: center\"><svg width=43 height=45 viewBox=\"0 0 43 45\" fill=none xmlns=http://www.w3.org/2000/svg><path d=\"M30.59 29.866v3.828h3.637\" stroke=#fff stroke-width=2 stroke-linecap=square /><ellipse cx=30.591 cy=33.694 rx=9.091 ry=9.569 stroke=#fff stroke-width=2 stroke-linecap=square /><path d=\"M16.046 41.35H1.5V6.9h40v13.397M12.41 1.158v5.741M30.591 1.158v5.741\" stroke=#fff stroke-width=2 stroke-linecap=square /><path d=\"M1.5 14.555h40\" stroke=#fff stroke-width=2 /></svg></div></div></div><div class=event-info-area><div class=event-text-row><div class=event-text><p translate=EVENT_IMAGE_DESCR></p></div><div class=event-samples style=\"padding-right: 10%\"><img width=80 height=50 src=https://storage.googleapis.com/classlist-branding/app-assets/image-crop.png style=\"display: block; margin-bottom: 8px; margin-top: 13px\"> <svg width=52 height=80 viewBox=\"0 0 52 80\" fill=none xmlns=http://www.w3.org/2000/svg style=\"display: block\"><rect x=2.55078 y=77.4482 width=74.8974 height=46.1795 rx=1.55128 transform=\"rotate(-90 2.55078 77.4482)\" stroke=#627293 stroke-linejoin=round /><rect x=2.80078 y=60.7885 width=45.6795 height=45.6795 transform=\"rotate(-90 2.80078 60.7885)\" fill=white /><rect x=2.80078 y=60.7885 width=45.6795 height=45.6795 transform=\"rotate(-90 2.80078 60.7885)\" stroke=#627293 stroke-width=1.5 stroke-dasharray=\"3.33 1.67\"/><path fill-rule=evenodd clip-rule=evenodd d=\"M3.64062 68.3588L14.5027 31.8882L22.2613 46.4764L34.6751 6.35876L48.6406 68.3588L3.64062 68.3588V68.3588Z\" stroke=#627293 stroke-width=1.5 stroke-linecap=round stroke-linejoin=round /><rect x=2.88411 y=60.7051 width=45.5128 height=45.5128 transform=\"rotate(-90 2.88411 60.7051)\" stroke=#EB004E stroke-width=1.66667 stroke-dasharray=\"3.33 1.67\"/><circle cx=21.7432 cy=21.4613 r=4.10256 transform=\"rotate(-90 21.7432 21.4613)\" stroke=#627293 stroke-width=1.5 stroke-linejoin=round /></svg></div></div><div class=event-buttons><button class=\"btn btn-ghost\" type=button ng-click=uploadImage()>Upload an image</button> <button class=\"btn btn-ghost\" type=button ng-click=pickGallery()>Choose from our library</button></div></div></div><div class=event-buttons2 style=\"display: none\"><button class=\"btn btn-ghost\" type=button ng-click=uploadImage() style=margin-right:10px>Upload an image</button> <button class=\"btn btn-ghost\" type=button ng-click=pickGallery()>Choose from our library</button></div></section></div><div><section class=event-section><h1 translate=BASIC_INFO></h1><p translate=BASIC_INFO_DESCR></p><br><div><div class=\"event-input {{ (errorMessage == \'TITLE_CANNOT_BE_NULL\' || errorMessage == \'TITLE_LENGTH_ERROR\') ? \'invalid-input-label\' : \'\' }}\"><label translate=EVENT_NAME></label><input ng-model=event.title ng-keydown=\"errorMessage = false;\" ng-blur=saveTitle() maxlength=200 type=text placeholder=\"{{\'CLEAR_EVENT_NAME\' | translate }}\"><div class=event-wrong-input translate=\"{{ errorMessage }}\"></div></div></div><br><div class=\"create-event-dates event-start-date-input-container\"><div class=\"{{ (hasDateError(\'STARTDATE_CANNOT_BE_NULL\') || hasDateError(\'STARTDATE_CANNOT_BEFORE_TODAY\') || hasDateError(\'STARTDATE_CANNOT_AFTER_ENDDATE\')) ? \'invalid-input-label\' : \'\' }}\"><div class=\"event-input event-date-input\" style=\"margin-right: 5%\"><label translate=EVENT_STARTS></label><div class=is-relative style=\"width: 60%\"><input readonly type=text class=ev-date-input uib-datepicker-popup=\"EEE, dd MMM yyyy\" ng-model=startDate show-button-bar=false is-open=popupStartDate.opened datepicker-options=dateOptions ng-required=true style=\"width: 100%\"> <span class=\"select-arrow date-picker-icon\"><button type=button class=\"btn btn-default\" ng-click=pickStartDate()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=is-relative style=\"width: 35%; float: left\"><input ng-flatpickr fp-opts=startTimeOpts fp-on-setup=startDateTimePostSetup(fpItem) ng-model=startDateTime id=eventStartDateTime></div></div><div class=event-wrong-input translate=\"{{ hasDateError(\'STARTDATE_CANNOT_BE_NULL\') }}\"></div><div class=event-wrong-input translate=\"{{ hasDateError(\'STARTDATE_CANNOT_BEFORE_TODAY\') }}\"></div><div class=event-wrong-input translate=\"{{ hasDateError(\'STARTDATE_CANNOT_AFTER_ENDDATE\') }}\"></div></div><div class=\"{{ (hasDateError(\'ENDDATE_CANNOT_BE_NULL\') || hasDateError(\'ENDDATE_CANNOT_BEFORE_TODAY\') || hasDateError(\'ENDDATE_CANNOT_BEFORE_STARTDATE\')) ? \'invalid-input-label\' : \'\' }}\"><div class=\"event-input event-date-input\"><label translate=EVENT_ENDS></label><div class=is-relative style=\"width: 60%\"><input readonly type=text class=ev-date-input uib-datepicker-popup=\"EEE, dd MMM yyyy\" ng-model=endDate show-button-bar=false is-open=popupEndDate.opened datepicker-options=dateOptions ng-required=true style=\"width: 100%\"> <span class=\"select-arrow date-picker-icon\"><button type=button class=\"btn btn-default\" ng-click=pickEndDate()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=is-relative style=\"width: 35%; float: left\"><input ng-flatpickr fp-opts=endTimeOpts fp-on-setup=endDateTimePostSetup(fpItem) ng-model=endDateTime id=eventEndDateTime></div></div><div class=event-wrong-input translate=\"{{ hasDateError(\'ENDDATE_CANNOT_BE_NULL\') }}\"></div><div class=event-wrong-input translate=\"{{ hasDateError(\'ENDDATE_CANNOT_BEFORE_TODAY\') }}\"></div><div class=event-wrong-input translate=\"{{ hasDateError(\'ENDDATE_CANNOT_BEFORE_STARTDATE\') }}\"></div></div></div><br><div class=create-event-dates id=cue-rsvp-date><div class=\"{{ (hasDateError(\'RSVPDATE_CANNOT_BEFORE_TODAY\') || hasDateError(\'RSVPDATE_CANNOT_BEFORE_STARTDATE\') || hasDateError(\'RSVPDATE_CANNOT_AFTER_ENDDATE\')) ? \'invalid-input-label\' : \'\' }}\"><div class=\"event-input event-date-input\"><label translate=EVENT_RSVP></label><div class=is-relative style=\"width: 60%\"><input readonly type=text class=ev-date-input uib-datepicker-popup=\"EEE, dd MMM yyyy\" ng-model=rsvpDate show-button-bar=false is-open=popupRsvpDate.opened datepicker-options=dateOptions ng-required=true style=\"width: 100%\"> <span class=\"select-arrow date-picker-icon\"><button type=button class=\"btn btn-default\" ng-click=pickRsvpDate()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=is-relative style=\"width: 35%; float: left\"><input ng-flatpickr fp-opts=rsvpTimeOpts fp-on-setup=rsvpDateTimePostSetup(fpItem) ng-model=rsvpDateTime id=eventRsvpDateTime></div></div><div class=event-wrong-input translate=\"{{ hasDateError(\'RSVPDATE_CANNOT_BEFORE_TODAY\') }}\"></div><div class=event-wrong-input translate=\"{{ hasDateError(\'RSVPDATE_CANNOT_BEFORE_STARTDATE\') }}\"></div><div class=event-wrong-input translate=\"{{ hasDateError(\'RSVPDATE_CANNOT_AFTER_ENDDATE\') }}\"></div></div><div style=\"min-height: auto\"><svg ng-if=\"rsvpDate || rsvpDateTime\" class=clear-rsvp-date-icon ng-click=eventRSVPDateOptions.clear() xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=12px height=12px viewBox=\"0 0 12 12\"><g transform=\"translate(0, 0)\"><path d=M10.707,1.293a1,1,0,0,0-1.414,0L6,4.586,2.707,1.293A1,1,0,0,0,1.293,2.707L4.586,6,1.293,9.293a1,1,0,1,0,1.414,1.414L6,7.414l3.293,3.293a1,1,0,0,0,1.414-1.414L7.414,6l3.293-3.293A1,1,0,0,0,10.707,1.293Z fill=#444444></path></g></svg></div></div><br><div><div class=event-input><label translate=EVENT_DESCR></label><textarea id=event-description ng-model=event.description ng-blur=saveDescr() maxlength=10000 autoresize-textarea placeholder=\"{{\'EVENT_DESCRIPTION\' | translate }}\"></textarea></div></div></section><section class=event-section id=cue-online-event><h1 translate=EVENT_ONLINE></h1><p><span class=badge style=\"left: 10px;\n								background-color: red;\n								padding: 3px 7px !important\">NEW!</span> <span translate=EVENT_ONLINE_DESC></span> <span class=\"icon dripicons-information\" ng-click=openBudiHelp() style=\"color: #777; cursor: pointer; margin-left: 4px\"><a href=https://help.classlist.com/hc/en-us/articles/360013553397 target=_blank></a></span></p><br><div class=location-checkboxes><p style=\"margin-top: 3px; font-weight: bold\" translate=IS_EVENT_ONLINE></p><label style=\"margin-right: 15px\"><span translate=YES></span> <input ng-model=isOnlineEvent ng-click=\"isOnlineEvent = true; updateIsOnlineEvent(true)\" type=checkbox checked style=\"float: right\"></label><label><span translate=NO></span> <input ng-model=!isOnlineEvent ng-click=\"isOnlineEvent = false; updateIsOnlineEvent(false)\" type=checkbox style=\"float: right\"></label><div style=\"clear: both\"></div><div ng-if=isOnlineEvent><div ng-if=isFriendshipBetaSchool()><label style=\"margin-right: 25px\"><input ng-model=budiSelection.isBudiEvent ng-click=\"budiSelection.isBudiEvent = true; updateBudiEvent(true)\" type=checkbox> <span translate=BUDI_DESCRIPTION></span> <span ng-if=isFriendshipBetaSchool() class=\"dripicons-question icon\" ng-click=openBudiHelp() style=\"color: #777; cursor: pointer\"></span></label></div><div><label style=\"margin-right: 25px; margin-top: 15px\"><!-- <input class=\"online-event-label\" ng-model=\"!budiSelection.isBudiEvent\" ng-click=\"budiSelection.isBudiEvent = false; updateBudiEvent(false)\" style=\"margin-right: 10px;\" type=\"checkbox\" /> --> <span class=online-event-label translate=ADD_YOUR_VIDEO_LINK></span></label><input class=online-event-input id=event-ext-link ng-model=event.onlineLink ng-if=!budiSelection.isBudiEvent ng-keyup=checkValidLink() ng-blur=saveOnlineLink() style=\"width: 82%; padding: 10px\" type=text placeholder=\"{{ \'ADD_YOUR_VIDEO_LINK\' | translate }}\"><div class=event-wrong-online-link ng-if=invalidOnlineLink class=invalid-label translate=NOT_VALID_ONLINE_LINK></div></div><div><label style=\"margin-right: 25px; margin-top: 25px\"><!-- <input ng-model=\"!budiSelection.isBudiEvent\" ng-click=\"budiSelection.isBudiEvent = false; updateBudiEvent(false)\" style=\"margin-right: 10px;\" type=\"checkbox\" /> --> <span class=online-event-label translate=ADD_ID_PASSWORD></span></label><div style=\"clear: both\"></div><input class=online-event-input id=event-ext-link ng-model=event.onlineEventExternalUsername ng-blur=saveOnlineEventExternalUsername() style=\"width: 40%; padding: 10px\" type=text placeholder=\"{{ \'ADD_ID\' | translate }}\"> <input class=online-event-input id=event-ext-link ng-model=event.onlineEventExternalPassword ng-blur=saveOnlineEventExternalPassword() style=\"width: 40%; padding: 10px; margin-left: 10px\" type=text placeholder=\"{{ \'ADD_PASSWORD\' | translate }}\"></div></div></div></section><section class=event-section><h1 translate=EVENT_LOCATION></h1><p translate=EVENT_LOCATION_DESCR></p><br><div class=location-checkboxes><p translate=IS_EVENT_AT_SCHOOL></p><label style=\"margin-right: 25px\"><span translate=YES></span> <input ng-model=atSchoolEvent ng-click=\"atSchoolEvent = true; updateAtSchoolLocation(true)\" type=checkbox checked style=\"float: right\"></label><label><span translate=NO></span> <input ng-model=!atSchoolEvent ng-click=\"atSchoolEvent = false; updateAtSchoolLocation(false)\" type=checkbox style=\"float: right\"></label></div><div ng-if=!atSchoolEvent><br><div ng-if=\"!event.location || !event.location.location\"><button type=button class=\"btn btn-ghost\" ng-click=addLocation()><span translate=SELECT_LOCATION></span></button></div><div ng-if=\"event.location && event.location.location\" class=event-location-picker><div style=\"width: 70%\"><h4>{{ event.location.location }}</h4></div><div style=\"width: 30%\"><button type=button class=\"btn btn-ghost\" ng-click=addLocation()><span translate=EDIT_BTN></span></button></div></div></div><div ng-if=atSchoolEvent><br><div ng-if=\"event.location && event.location.location\" class=event-location-picker><div><h4>{{ event.location.location }}</h4></div></div></div><br><div><div class=event-input><label translate=EVENT_LOCATION_DETAILS></label><textarea id=event-location-details ng-model=event.location.locationDetail ng-blur=saveLocationDetail() maxlength=500 autoresize-textarea placeholder=\"{{\'EVENT_LOCATION_DETAILS_INPUT\' | translate }}\"></textarea></div></div><br><div ng-show=\"event.location && event.location.locationLat && event.location.locationLng\"><div id=event-location-map></div></div></section><section class=event-section><h2 translate=EVENT_ATTACHMENTS></h2><p translate=EVENT_ATTACHMENTS_DESCR></p><br><div ng-if=\"event.fileLibrary.attachment && event.fileLibrary.attachment.length > 0\" style=\"margin-bottom: 15px\"><span class=attachment-item ng-repeat=\"att in event.fileLibrary.attachment\"><a href=\"{{ att.path }}\" target=_self>{{ att.name }}</a> <span class=\"icon dripicons-cross\" ng-click=\"deleteAttachment(att, $index)\"></span></span></div><div ng-hide=\"event.fileLibrary.attachment.length > 5\"><button type=button class=\"btn btn-ghost\" ng-click=fileUploadDialog()><span translate=UPLOAD_AN_ATTACHMENT></span></button></div></section><section id=cue-input-rsvp class=event-section><h1 translate=EVENT_TICKETS></h1><p translate=EVENT_TICKETS_DESCR></p><br><div class=location-checkboxes><label style=\"margin-right: 25px\"><span translate=RSVP></span> <input ng-disabled=event.ticketed ng-model=!hasTickets ng-click=\"hasTickets = false;\" type=checkbox checked style=\"float: right\"></label><label><span translate=TICKETS></span> <input ng-disabled=event.ticketed ng-model=hasTickets ng-click=\"hasTickets = true;\" type=checkbox style=\"float: right\"></label></div><br><div ng-if=hasTickets style=\"padding-bottom: 20px\"><button type=button class=\"btn btn-ghost\" ng-click=gotoTickets()><span ng-show=!event.ticketed translate=ADD_TICKET_BTN></span> <span ng-show=event.ticketed translate=EDIT_TICKET_BTN></span></button></div><div><p translate=QR_CODE_INFORMATION_TEXT></p><a href=https://help.classlist.com/hc/en-us/articles/14629672284445-QR-codes-for-Event-Tickets translate=QR_CODE_INFORMATION_FIND_MORE_TEXT style=\"font-size: 16px\"></a></div></section><section class=event-section id=cue-firstamb-signup-list><h1 translate=EVENT_VOLUNTEERS></h1><p translate=EVENT_VOLUNTEERS_DESC_2></p><div ng-if=\"rotaList && rotaList.length > 0\" class=dash-rota-list><br><div ng-repeat=\"rota in rotaList\"><div><div class=dash-rota-status><div ng-click=viewRota(rota)>{{ rota.title }}</div><label ng-if=rota.enabled class=event-live-label translate=PUBLISHED></label><label ng-if=!rota.enabled class=event-live-label translate=DRAFT style=\"background-color: #ccc\"></label></div><div class=pull-right><button ng-click=viewRota(rota) type=button class=\"btn btn-ghost\"><span>View</span></button> <button ng-click=openRota(rota) type=button class=\"btn btn-ghost\"><span>Edit</span></button></div></div></div></div><br><div><button ng-click=createVolunteerRota() type=button class=\"btn btn-ghost\"><span translate=CREATE_VOLUNTEER_ROTA></span></button></div></section><section class=event-section><h1 translate=EVENT_OWNERS></h1><p translate=EVENT_OWNERS_DESCR></p><br><div><div class=event-owner-list><div ng-repeat=\"owner in event.eventOwners\"><div class=own-picture><figure style=\"float: left;\n											width: 46px;\n											height: 46px;\n											margin-right: 10px\"><avatar source={{owner.avatar}} name=\"{{ owner.firstName }} {{ owner.lastName }}\" width=46 height=46 my=false></avatar></figure><div ng-if=\"owner.id != active_user.id\" ng-click=\"removeOwner(owner, $index)\" class=own-remove><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=24px height=24px viewBox=\"0 0 24 24\"><g transform=\"translate(0, 0)\"><polygon points=\"16.95 8.464 15.536 7.05 12 10.586 8.464 7.05 7.05 8.464 10.586 12 7.05 15.536 8.464 16.95 12 13.414 15.536 16.95 16.95 15.536 13.414 12 16.95 8.464\" fill=#444444></polygon></g></svg></div></div><div class=own-name><div>{{ owner.firstName }}</div><div>{{ owner.lastName }}</div></div></div></div><br><div><button ng-click=gotoAddOwner() type=button class=\"btn btn-ghost\"><span translate=ADD_ANOTHER_OWNER></span></button></div><br><div style=\"font-size: 16px\"><span translate=PRIVATE_EVENT_CREATED_BY></span> <a ui-sref=\"classlist.details.contact({\'id\': event.createdById })\">{{event.createdByName}}</a> <span ng-if=!editingCreatedby class=\"icon dripicons-pencil\" ng-click=editCreatedby($event)></span><div class=click-editor ng-show=editingCreatedby click-outside=saveOutsideCreatedby() ng-click=stopPropagation($event)><input ng-model=valueCreatedby type=text placeholder=\"{{\'EVENT_CREATED_BY\' | translate }}\"><div><span class=\"icon dripicons-checkmark\" ng-click=saveCreatedby()></span> <span class=\"icon dripicons-cross\" ng-click=cancelCreatedby()></span></div></div></div></div></section><section class=event-section><div style=\"text-align: right\"><button ng-click=continue() type=button class=\"btn btn-primary\" id=cue-save-event-button><span translate=SAVE_AND_CONTINUE></span></button></div></section><!-- we will use these buttons if parents come to dashboard for editing the event \n				<section class=\"event-section\">\n					<div style=\"text-align: right;\">\n						<button type=\"button\" class=\"btn btn-ghost\">\n							<span translate=\"WITHOUT_SAVING_CHANGES\"></span>\n						</button>\n						<button ng-click=\"continue()\" type=\"button\" class=\"btn btn-primary edit-save-button \">\n							<span translate=\"SAVE_CHANGES\"></span>\n						</button>\n					</div>\n				</section>--></div></div><input type=file id=fileUploader></section>");
$templateCache.put("app/events/views/dashboard.html","<section class=\"event-dashboard event-guests\" ng-class=\"{\'is-visible\': viewState.isReady}\"><div class=\"page-view-header clearfix\" style=\"margin-bottom: -1px\"><div><div><div><a id=header-back-button style=\"float: left; margin-right: 10px; position: relative\" class=page-view-header__back ng-click=decideGoBack()><span class=dripicons-arrow-thin-left></span></a></div></div></div></div><div class=page-container-header-from-top style=\"margin-top: 0!important\"><div ng-if=\"event.status == \'DRAFT\'\" class=\"event-status-container event-draft\"><div style=\"float: left\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><circle fill=none stroke=#ffffff stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 cx=8.5 cy=8.5 r=7></circle><circle data-color=color-2 data-stroke=none fill=#ffffff cx=8.5 cy=12 r=1></circle><line data-color=color-2 fill=none stroke=#ffffff stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 x1=8.5 y1=4.5 x2=8.5 y2=9></line></g></svg></div><div style=\"float: left\"><h4 translate=EVENT_IS_DRAFT></h4><p translate=EVENT_IS_DRAFT_AND_EMPTY_TEXT ng-if=\"!event.groups || event.groups.length == 0\"></p><p translate=EVENT_IS_DRAFT_TEXT ng-if=\"event.groups && event.groups.length > 0\"></p></div><div id=cue-publish-button class=publish-btn><button ng-if=\"event.groups && event.groups.length > 0\" ng-click=publish() type=button class=\"btn btn-primary\"><span translate=PUBLISH_THIS_EVENT></span></button></div></div><div ng-if=\"event.status == \'ACTIVE\' && !event.invitationSent && !event.answerCount.inviting\" class=\"event-status-container event-draft\"><div style=\"float: left\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><circle fill=none stroke=#ffffff stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 cx=8.5 cy=8.5 r=7></circle><circle data-color=color-2 data-stroke=none fill=#ffffff cx=8.5 cy=12 r=1></circle><line data-color=color-2 fill=none stroke=#ffffff stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 x1=8.5 y1=4.5 x2=8.5 y2=9></line></g></svg></div><div style=\"float: left\"><h4 translate=INVITES_NOT_SENT></h4><p translate=INVITES_NOT_SENT_TEXT></p></div><button ng-click=sendInvites() type=button class=\"btn btn-primary\" style=\"float: right\"><span translate=SEND_INVITES_NOW></span></button></div><div ng-if=\"event.status == \'CANCELLED\'\" class=\"event-status-container event-draft\"><div style=\"float: left\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><circle fill=none stroke=#ffffff stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 cx=8.5 cy=8.5 r=7></circle><circle data-color=color-2 data-stroke=none fill=#ffffff cx=8.5 cy=12 r=1></circle><line data-color=color-2 fill=none stroke=#ffffff stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 x1=8.5 y1=4.5 x2=8.5 y2=9></line></g></svg></div><div style=\"float: left\"><h4 style=\"line-height: 40px\" translate=EVENT_IS_CANCELED></h4></div></div><div class=\"event-section event-dashboard-container\" style=\"padding:15px !important\"><div class=event-image-wrapper><div class=event-preview-fixed><div class=event-picture style=\"width: 100%; height: 160px; border-radius: 12px; overflow: hidden; position: relative\"><div ng-if=!isDefaultImage(event.fileLibrary.image) class=img style=\"width: 100%; height: 100%; background-size: cover; background-position: center; background-image: url(\'{{ event.fileLibrary.image }}\')\"></div><div ng-if=isDefaultImage(event.fileLibrary.image) style=\"width: 100%; height: 100%; background-color: #008fa1; display: flex; align-items: center; justify-content: center\"><svg width=43 height=45 viewBox=\"0 0 43 45\" fill=none xmlns=http://www.w3.org/2000/svg><path d=\"M30.59 29.866v3.828h3.637\" stroke=#fff stroke-width=2 stroke-linecap=square /><ellipse cx=30.591 cy=33.694 rx=9.091 ry=9.569 stroke=#fff stroke-width=2 stroke-linecap=square /><path d=\"M16.046 41.35H1.5V6.9h40v13.397M12.41 1.158v5.741M30.591 1.158v5.741\" stroke=#fff stroke-width=2 stroke-linecap=square /><path d=\"M1.5 14.555h40\" stroke=#fff stroke-width=2 /></svg></div><button class=event-upload-image-btn type=button ng-click=uploadImage() style=\"position: absolute;\n                            right: 12px;\n                            bottom: 12px;\n                            background: #fff;\n                            border: none;\n                            border-radius: 50%;\n                            width: 36px;\n                            height: 36px;\n                            display: flex;\n                            align-items: center;\n                            justify-content: center;\n                            box-shadow: 0 2px 8px rgba(0,0,0,0.10);\n                            padding: 0;\n                            cursor: pointer\" aria-label=\"Upload event image\"><svg width=20 height=19 viewBox=\"0 0 18 17\" fill=none xmlns=http://www.w3.org/2000/svg><circle cx=9 cy=9 r=3.75 stroke=#DB006A stroke-width=1.5 stroke-linecap=round stroke-linejoin=round /><path clip-rule=evenodd d=\"M15.75 15.75H2.25a1.5 1.5 0 0 1-1.5-1.5V4.5A1.5 1.5 0 0 1 2.25 3h3L6.75.75h4.5L12.75 3h3a1.5 1.5 0 0 1 1.5 1.5v9.75a1.5 1.5 0 0 1-1.5 1.5z\" stroke=#DB006A stroke-width=1.5 stroke-linecap=round stroke-linejoin=round /><circle cx=3 cy=5.25 r=.75 fill=#DB006A /></svg></button></div></div><div class=event-info-area><div class=event-text-row><div class=event-text><h2 class=dash-event-title style=margin:0><span>{{ event.title }}</span></h2><p style=\"margin: 0;display: flex\"><span>{{ event.date.startDate | date: \'EEE, dd MMM, yyyy\':\'GMT\' }}</span> <span ng-if=\"event.status == \'ACTIVE\'\" class=event-live-label translate=PUBLISHED></span></p></div></div><div class=event-buttons><div class=share-event-container style=\"width: 100%; display: flex; align-items: center\"><div ng-if=\"event.status == \'ACTIVE\'\" style=\"display: flex; align-items: center; gap: 5px; flex-wrap: wrap\"><p style=\"font-weight: 600; color: black; font-size: 14px; margin-bottom: 0; white-space: nowrap;padding-right: 15px\">Share this event</p><div style=\"display: inline-flex\"><a ng-if=event.open ng-click=copyLink() style=\"color: #EB004E; cursor: pointer; display: flex; align-items: center; gap: 5px;  white-space: nowrap\"><svg width=16 height=16 viewBox=\"0 0 24 24\" fill=none xmlns=http://www.w3.org/2000/svg style=\"flex-shrink: 0\"><path d=\"M12 2v20M2 12h20\" stroke=#EB004E stroke-width=1.5 stroke-miterlimit=10 /><path d=\"M12 22c2.761 0 5-4.477 5-10S14.761 2 12 2 7 6.477 7 12s2.239 10 5 10z\" stroke=#EB004E stroke-width=1.5 stroke-miterlimit=10 stroke-linecap=square /><path d=\"M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z\" stroke=#EB004E stroke-width=1.5 stroke-miterlimit=10 stroke-linecap=square /></svg> <span style=\"overflow: hidden; text-overflow: ellipsis\">Copy public webpage</span> </a><a ng-click=copyPrivateLink() style=\"color: #EB004E; cursor: pointer; display: flex; align-items: center; gap: 5px; padding-left: 15px; white-space: nowrap\"><img src=https://storage.googleapis.com/classlist-branding/app-assets/integration-copy.svg alt=\"Copy App Link Icon\" style=\"width: 16px; height: 16px; flex-shrink: 0\"> <span style=\"overflow: hidden; text-overflow: ellipsis\">Copy Classlist app link</span></a></div></div><div class=container-menu-btn style=\"margin-left: auto; display: flex; justify-content: flex-end; align-items: center\"><nav class=\"has-dropdown mobile-menu\" style=\"position: relative; width:80px; margin-right:10px\"><button translate=MENU type=button class=\"btn btn-ghost\" style=\"padding: 0 12px !important;min-height: 42px !important\"><!-- <svg style=\"float: left; transform: rotate(90deg); width: 34px; height: 38px; padding: 7px 7px;\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"48px\" height=\"48px\" viewBox=\"0 0 48 48\"><g transform=\"translate(0, 0)\"><circle data-color=\"color-2\" fill=\"#444444\" cx=\"24\" cy=\"24\" r=\"4\"></circle> <circle fill=\"#444444\" cx=\"6\" cy=\"24\" r=\"4\"></circle> <circle fill=\"#444444\" cx=\"42\" cy=\"24\" r=\"4\"></circle></g></svg> --></button><ul class=\"dropdown-menu dropdown-location\" style=position:absolute;right:0;top:100%><li><a ng-click=previewEvent()><span translate=PREVIEW></span></a></li><li><a ng-click=editEvent()><span translate=EDIT></span></a></li><li ng-if=\"event.status == \'ACTIVE\'\"><a ng-click=cancelEvent()><span translate=CANCEL_BTN></span></a></li><li ng-if=\"event.status == \'ACTIVE\' || event.status == \'CANCELLED\'\"><a ng-click=duplicateEvent()><span translate=DUPLICATE_BTN></span></a></li><li ng-if=\"event.status == \'DRAFT\'\"><a ng-click=deleteEvent()><span translate=DELETE_BTN></span></a></li><li ng-if=\"event.status == \'CANCELLED\'\"><a ng-click=deleteCanceledEvent()><span translate=DELETE_BTN></span></a></li><li ng-if=\"event.status == \'CANCELLED\'\"><a ng-click=hideEvent()><span translate=HIDE_BTN></span></a></li></ul></nav></div></div></div></div></div><div class=event-buttons2 style=display:none><div class=share-event-container style=\"width: 100%; display: flex; align-items: center\"><div ng-if=\"event.status == \'ACTIVE\'\" class=event-buttons-link2 style=\"display: flex; align-items: center; gap: 12px; flex-wrap: wrap\"><p style=\"font-weight: 600; color: black; font-size: 14px; margin-bottom: 0; white-space: nowrap;padding-right: 15px\">Share this event</p><div class=event-buttons-link2 style=\"display: inline-flex\"><a ng-if=event.open ng-click=copyLink() style=\"color: #EB004E; cursor: pointer; display: flex; align-items: center; gap: 5px;padding-right: 15px;  white-space: nowrap\"><svg width=16 height=16 viewBox=\"0 0 24 24\" fill=none xmlns=http://www.w3.org/2000/svg style=\"flex-shrink: 0\"><path d=\"M12 2v20M2 12h20\" stroke=#EB004E stroke-width=1.5 stroke-miterlimit=10 /><path d=\"M12 22c2.761 0 5-4.477 5-10S14.761 2 12 2 7 6.477 7 12s2.239 10 5 10z\" stroke=#EB004E stroke-width=1.5 stroke-miterlimit=10 stroke-linecap=square /><path d=\"M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z\" stroke=#EB004E stroke-width=1.5 stroke-miterlimit=10 stroke-linecap=square /></svg> <span style=\"overflow: hidden; text-overflow: ellipsis\">Copy public webpage</span> </a><a ng-click=copyPrivateLink() style=\"color: #EB004E; cursor: pointer; display: flex; align-items: center; gap: 5px;  white-space: nowrap\"><img src=https://storage.googleapis.com/classlist-branding/app-assets/integration-copy.svg alt=\"Copy App Link Icon\" style=\"width: 16px; height: 16px; flex-shrink: 0\"> <span style=\"overflow: hidden; text-overflow: ellipsis\">Copy Classlist app link</span></a></div></div><div class=container-menu-btn style=\"margin-left: auto; display: flex; justify-content: flex-end; align-items: center\"><nav class=\"has-dropdown mobile-menu\" style=\"position: relative; width:80px; margin-right:10px\"><button translate=MENU type=button class=\"btn btn-ghost\" style=\"padding: 0 12px !important;min-height: 42px !important\"><!-- <svg style=\"float: left; transform: rotate(90deg); width: 34px; height: 38px; padding: 7px 7px;\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"48px\" height=\"48px\" viewBox=\"0 0 48 48\"><g transform=\"translate(0, 0)\"><circle data-color=\"color-2\" fill=\"#444444\" cx=\"24\" cy=\"24\" r=\"4\"></circle> <circle fill=\"#444444\" cx=\"6\" cy=\"24\" r=\"4\"></circle> <circle fill=\"#444444\" cx=\"42\" cy=\"24\" r=\"4\"></circle></g></svg> --></button><ul class=\"dropdown-menu dropdown-location\" style=position:absolute;right:0;top:100%><li><a ng-click=previewEvent()><span translate=PREVIEW></span></a></li><li><a ng-click=editEvent()><span translate=EDIT></span></a></li><li ng-if=\"event.status == \'ACTIVE\'\"><a ng-click=cancelEvent()><span translate=CANCEL_BTN></span></a></li><li ng-if=\"event.status == \'ACTIVE\' || event.status == \'CANCELLED\'\"><a ng-click=duplicateEvent()><span translate=DUPLICATE_BTN></span></a></li><li ng-if=\"event.status == \'DRAFT\'\"><a ng-click=deleteEvent()><span translate=DELETE_BTN></span></a></li><li ng-if=\"event.status == \'CANCELLED\'\"><a ng-click=deleteCanceledEvent()><span translate=DELETE_BTN></span></a></li><li ng-if=\"event.status == \'CANCELLED\'\"><a ng-click=hideEvent()><span translate=HIDE_BTN></span></a></li></ul></nav></div></div></div></div><section class=event-section><div style=\"display: flex; justify-content: space-between; align-items: center\"><h1 translate=EVENTS_GUEST_LIST></h1><div style=\"cursor: pointer\" ng-if=\"isFlutterApp && event.ticketed && event.status == \'ACTIVE\'\" ng-click=switchToQRReader()><svg width=20 height=20 viewBox=\"0 0 20 20\" fill=none xmlns=http://www.w3.org/2000/svg><g clip-path=url(#clip0_223_116041)><path d=\"M6.66634 0.833008H3.33301C2.66997 0.833008 2.03408 1.0964 1.56524 1.56524C1.0964 2.03408 0.833008 2.66997 0.833008 3.33301V6.66634C0.833008 6.88736 0.920805 7.09932 1.07709 7.2556C1.23337 7.41188 1.44533 7.49967 1.66634 7.49967C1.88735 7.49967 2.09932 7.41188 2.2556 7.2556C2.41188 7.09932 2.49967 6.88736 2.49967 6.66634V3.33301C2.49967 3.11199 2.58747 2.90003 2.74375 2.74375C2.90003 2.58747 3.11199 2.49967 3.33301 2.49967H6.66634C6.88736 2.49967 7.09932 2.41188 7.2556 2.2556C7.41188 2.09932 7.49967 1.88735 7.49967 1.66634C7.49967 1.44533 7.41188 1.23337 7.2556 1.07709C7.09932 0.920805 6.88736 0.833008 6.66634 0.833008Z\" fill=#DB006A /><path d=\"M16.6667 0.833008H13.3333C13.1123 0.833008 12.9004 0.920805 12.7441 1.07709C12.5878 1.23337 12.5 1.44533 12.5 1.66634C12.5 1.88735 12.5878 2.09932 12.7441 2.2556C12.9004 2.41188 13.1123 2.49967 13.3333 2.49967H16.6667C16.8877 2.49967 17.0996 2.58747 17.2559 2.74375C17.4122 2.90003 17.5 3.11199 17.5 3.33301V6.66634C17.5 6.88736 17.5878 7.09932 17.7441 7.2556C17.9004 7.41188 18.1123 7.49967 18.3333 7.49967C18.5543 7.49967 18.7663 7.41188 18.9226 7.2556C19.0789 7.09932 19.1667 6.88736 19.1667 6.66634V3.33301C19.1667 2.66997 18.9033 2.03408 18.4344 1.56524C17.9656 1.0964 17.3297 0.833008 16.6667 0.833008Z\" fill=#DB006A /><path d=\"M18.3333 12.5C18.1123 12.5 17.9004 12.5878 17.7441 12.7441C17.5878 12.9004 17.5 13.1123 17.5 13.3333V16.6667C17.5 16.8877 17.4122 17.0996 17.2559 17.2559C17.0996 17.4122 16.8877 17.5 16.6667 17.5H13.3333C13.1123 17.5 12.9004 17.5878 12.7441 17.7441C12.5878 17.9004 12.5 18.1123 12.5 18.3333C12.5 18.5543 12.5878 18.7663 12.7441 18.9226C12.9004 19.0789 13.1123 19.1667 13.3333 19.1667H16.6667C17.3297 19.1667 17.9656 18.9033 18.4344 18.4344C18.9033 17.9656 19.1667 17.3297 19.1667 16.6667V13.3333C19.1667 13.1123 19.0789 12.9004 18.9226 12.7441C18.7663 12.5878 18.5543 12.5 18.3333 12.5Z\" fill=#DB006A /><path d=\"M6.66634 17.5H3.33301C3.11199 17.5 2.90003 17.4122 2.74375 17.2559C2.58747 17.0996 2.49967 16.8877 2.49967 16.6667V13.3333C2.49967 13.1123 2.41188 12.9004 2.2556 12.7441C2.09932 12.5878 1.88735 12.5 1.66634 12.5C1.44533 12.5 1.23337 12.5878 1.07709 12.7441C0.920805 12.9004 0.833008 13.1123 0.833008 13.3333V16.6667C0.833008 17.3297 1.0964 17.9656 1.56524 18.4344C2.03408 18.9033 2.66997 19.1667 3.33301 19.1667H6.66634C6.88736 19.1667 7.09932 19.0789 7.2556 18.9226C7.41188 18.7663 7.49967 18.5543 7.49967 18.3333C7.49967 18.1123 7.41188 17.9004 7.2556 17.7441C7.09932 17.5878 6.88736 17.5 6.66634 17.5Z\" fill=#DB006A /></g><defs><clipPath id=clip0_223_116041><rect width=20 height=20 fill=white /></clipPath></defs></svg> <span translate=CHECK_IN style=\"vertical-align: super; text-decoration: underline; color:#eb004e; font-weight: bold; padding-right:5px; padding-left:5px\"></span></div></div><div ng-if=\"event.status == \'ACTIVE\' && !event.invitationSent && !event.answerCount.inviting\">Published to {{ event.answerCount.notResponded || 0 }} members. <a ng-click=viewAllGuests()>View all</a></div><p ng-if=\"event.status == \'DRAFT\'\" translate=EVENTS_GUEST_LIST_DESCR></p><br><div ng-if=event.answerCount.inviting class=event-invitations-progress><div><div><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 48 48\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><g class=nc-loop_circle-02-48 transform=\"rotate(201.79000000000087 24 24)\" stroke-width=2><circle opacity=0.4 fill=none stroke=#f06292 stroke-width=2 stroke-linecap=square stroke-miterlimit=10 cx=24 cy=24 r=22 stroke-linejoin=miter></circle><path data-cap=butt data-color=color-2 fill=none stroke=#f06292 stroke-width=2 stroke-miterlimit=10 d=M24,2c12.2,0,22,9.8,22,22 stroke-linecap=butt stroke-linejoin=miter></path></g><script stroke-width=2>!function () { function t(t) { this.element = t, this.animationId, this.start = null, this.init() } if (!window.requestAnimationFrame) { var i = null; window.requestAnimationFrame = function (t, n) { var e = (new Date).getTime(); i || (i = e); var a = Math.max(0, 16 - (e - i)), o = window.setTimeout(function () { t(e + a) }, a); return i = e + a, o } } t.prototype.init = function () { var t = this; this.animationId = window.requestAnimationFrame(t.triggerAnimation.bind(t)) }, t.prototype.reset = function () { var t = this; window.cancelAnimationFrame(t.animationId) }, t.prototype.triggerAnimation = function (t) { var i = this; this.start || (this.start = t); var n = t - this.start; 504 > n || (this.start = this.start + 504), this.element.setAttribute(\"transform\", \"rotate(\" + Math.min(n / 1.4, 360) + \" 24 24)\"); if (document.documentElement.contains(this.element)) window.requestAnimationFrame(i.triggerAnimation.bind(i)) }; var n = document.getElementsByClassName(\"nc-loop_circle-02-48\"), e = []; if (n) for (var a = 0; n.length > a; a++)!function (i) { e.push(new t(n[i])) }(a); document.addEventListener(\"visibilitychange\", function () { \"hidden\" == document.visibilityState ? e.forEach(function (t) { t.reset() }) : e.forEach(function (t) { t.init() }) }) }();</script></g></svg></div><div style=\"margin-top: 10px\"><p><span>In progress...</span> <a ng-if=!gettingevent ng-click=getEvent()>Refresh</a></p></div></div></div><div ng-if=\"!event.ticketed && event.status != \'DRAFT\'\" class=\"event-guests-box event-nonticketed-boxes\"><div><p><span translate=INVITES_SENT></span><nav class=\"has-dropdown is-relative pull-right mobile-menu\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><circle fill=#8A94A2 cx=8 cy=32 r=6></circle><circle data-color=color-2 fill=#8A94A2 cx=32 cy=32 r=6></circle><circle fill=#8A94A2 cx=56 cy=32 r=6></circle></g></svg><ul class=dropdown-menu style=\"right: 0px; min-width: 170px\"><li><a ng-click=\"openGuests(\'\')\"><span translate=VIEW_GUESTS></span></a></li><li ng-if=\"event.answerCount.invited > 0\"><a ng-click=\"messageGuests({type:\'all_invited\', value:\'Invites sent\'})\"><span translate=SEND_A_NOTE></span></a></li><li ng-if=\"event.answerCount.invited > 0\"><a ng-click=\"openResendInvites({type:\'all_invited\', value:\'Invites sent\'})\"><span translate=RESEND_INVITE></span></a></li></ul></nav></p><h4>{{ event.answerCount.invited }}</h4></div><div><p><span translate=GOING></span><nav class=\"has-dropdown is-relative pull-right mobile-menu\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><circle fill=#8A94A2 cx=8 cy=32 r=6></circle><circle data-color=color-2 fill=#8A94A2 cx=32 cy=32 r=6></circle><circle fill=#8A94A2 cx=56 cy=32 r=6></circle></g></svg><ul class=dropdown-menu style=\"right: 0px; min-width: 170px\"><li><a ng-click=\"openGuests(\'GOING\')\"><span translate=VIEW_GUESTS></span></a></li><li ng-if=\"event.answerCount.going > 0\"><a ng-click=\"messageGuests({type:\'answer\',name:\'GOING\', value:\'Going\'})\"><span translate=SEND_A_NOTE></span></a></li><li ng-if=\"event.answerCount.going > 0\"><a ng-click=\"downloadCSV(\'GOING\')\"><span translate=DOWNLOAD_CSV_LIST></span></a></li></ul></nav></p><h4>{{ event.answerCount.going }}</h4></div><div><p><span translate=CAN_NOT_GO></span><nav class=\"has-dropdown is-relative pull-right mobile-menu\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><circle fill=#8A94A2 cx=8 cy=32 r=6></circle><circle data-color=color-2 fill=#8A94A2 cx=32 cy=32 r=6></circle><circle fill=#8A94A2 cx=56 cy=32 r=6></circle></g></svg><ul class=dropdown-menu style=\"right: 0px; min-width: 170px\"><li><a ng-click=\"openGuests(\'NOT_GOING\')\"><span translate=VIEW_GUESTS></span></a></li><li ng-if=\"event.answerCount.cantgo > 0\"><a ng-click=\"messageGuests({type:\'answer\',name:\'NOT_GOING\'})\"><span translate=SEND_A_NOTE></span></a></li></ul></nav></p><h4>{{ event.answerCount.cantgo }}</h4></div><div><p><span translate=NOT_RESPONDED></span><nav class=\"has-dropdown is-relative pull-right mobile-menu\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><circle fill=#8A94A2 cx=8 cy=32 r=6></circle><circle data-color=color-2 fill=#8A94A2 cx=32 cy=32 r=6></circle><circle fill=#8A94A2 cx=56 cy=32 r=6></circle></g></svg><ul class=dropdown-menu style=\"right: 0px; min-width: 170px\"><li><a ng-click=\"openGuests(\'NOT_RESPONDED\')\"><span translate=VIEW_GUESTS></span></a></li><li ng-if=\"event.answerCount.notResponded > 0\"><a ng-click=\"messageGuests({type:\'not_responded\', value:\'Not responded\'})\"><span translate=SEND_A_NOTE></span></a></li><li ng-if=\"event.answerCount.notResponded > 0\"><a ng-click=\"openResendInvites({type:\'not_responded\', value:\'Not responded\'})\"><span translate=RESEND_INVITE></span></a></li></ul></nav></p><h4>{{ event.answerCount.notResponded || 0 }}</h4></div></div><div ng-if=\"event.ticketed && event.status != \'DRAFT\'\" class=\"event-guests-box event-ticketed-boxes\"><div><p><span translate=INVITES_SENT></span><nav class=\"has-dropdown is-relative pull-right mobile-menu\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><circle fill=#8A94A2 cx=8 cy=32 r=6></circle><circle data-color=color-2 fill=#8A94A2 cx=32 cy=32 r=6></circle><circle fill=#8A94A2 cx=56 cy=32 r=6></circle></g></svg><ul class=dropdown-menu style=\"right: 0px; min-width: 170px\"><li><a ng-click=\"openGuests(\'INVITES_SENT\')\"><span translate=VIEW_GUESTS></span></a></li><li ng-if=\"event.answerCount.invited > 0\"><a ng-click=\"messageGuests({type:\'all_invited\',value:\'Invites sent\'})\"><span translate=SEND_A_NOTE></span></a></li><li ng-if=\"event.answerCount.invited > 0\"><a ng-click=\"openResendInvites({type:\'all_invited\',value:\'Invites sent\'})\"><span translate=RESEND_INVITE></span></a></li></ul></nav></p><h4>{{ event.answerCount.invited }}</h4></div><div><p><span translate=PURCHASED></span><nav class=\"has-dropdown is-relative pull-right mobile-menu\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><circle fill=#8A94A2 cx=8 cy=32 r=6></circle><circle data-color=color-2 fill=#8A94A2 cx=32 cy=32 r=6></circle><circle fill=#8A94A2 cx=56 cy=32 r=6></circle></g></svg><ul class=dropdown-menu style=\"right: 0px; min-width: 170px\"><li><a ng-click=\"openGuests(\'ALL_PURCHASED\')\"><span translate=VIEW_GUESTS></span></a></li><li ng-if=\"event.answerCount.sold > 0\"><a ng-click=\"messageGuests({type:\'all_purchased\',value:\'Purchased\'})\"><span translate=SEND_A_NOTE></span></a></li><li ng-if=\"event.answerCount.sold > 0\"><a ng-click=\"downloadCSV(\'ALL_PURCHASED\')\"><span translate=DOWNLOAD_CSV_LIST></span></a></li></ul></nav></p><h4>{{ event.answerCount.sold }}</h4></div><div><p><span translate=NOT_RESPONDED></span><nav class=\"has-dropdown is-relative pull-right mobile-menu\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><circle fill=#8A94A2 cx=8 cy=32 r=6></circle><circle data-color=color-2 fill=#8A94A2 cx=32 cy=32 r=6></circle><circle fill=#8A94A2 cx=56 cy=32 r=6></circle></g></svg><ul class=dropdown-menu style=\"right: 0px; min-width: 170px\"><li><a ng-click=\"openGuests(\'NOT_RESPONDED\')\"><span translate=VIEW_GUESTS></span></a></li><li><a ng-click=\"messageGuests({type:\'not_responded\',value:\'Not responded\'})\"><span translate=SEND_A_NOTE></span></a></li><li><a ng-click=\"openResendInvites({type:\'not_responded\',value:\'Not responded\'})\"><span translate=RESEND_INVITE></span></a></li></ul></nav></p><h4>{{ event.answerCount.notResponded || 0 }}</h4></div></div><div ng-if=\"event.groups && event.groups.length > 0 && event.status == \'DRAFT\'\" class=manage-participants><ul class=basket style=\"margin-bottom: 0\"><li ng-repeat=\"item in event.groups\"><header class=tier-header>{{ item.name }} <a ng-click=\"removeParticipantGroup(item, $index)\"><span class=dripicons-cross></span></a></header></li></ul></div><div ng-if=!event.answerCount.inviting><div ng-if=\"(!event.groups || event.groups.length == 0) && event.status == \'DRAFT\'\" style=\"height: 40px; width: 168px\" id=cue-guests-button class=cue-guests-button_amb><button ng-click=inviteGuests() type=button class=\"btn btn-primary\"><span translate=ADD_SOME_GUESTS></span></button></div><button ng-if=\"(event.groups && event.groups.length > 0) && event.status === \'DRAFT\'\" ng-click=inviteGuests() type=button class=\"btn btn-ghost\" style=\"margin-left: 6px; margin-top: 10px\"><span translate=ADD_MORE_GUESTS></span></button><div class=guest-checkout-checkbox style=\"display:flex; margin-top:30px\"><input id=checkbox name=checkbox type=checkbox ng-disabled=!canMakePublic() style=\"float: left\" ng-checked=event.open ng-click=switchPublicEvent()><div style=\"margin-left:15px; margin-top:3px\"><span style=\"display: flex\"><label style=\"display: inline-flex; margin-bottom:0px;font-size:14px;font-weight: 500\">Also enable public guest checkout</label><span ng-click=openPublicCheckoutInfo() class=\"icon dripicons-information\" style=\"margin-top:-3px; color:#627293\"></span> </span><span style=\"display: block; font-size: 14px;font-weight: 500;color:#666666\">Ideal for grandparents, school staff, or the local community.</span></div></div><div style=\"margin-top: 20px\"><button ng-if=\"(event.groups && event.groups.length > 0) && event.status != \'DRAFT\'\" ng-click=inviteGuests() type=button class=\"btn btn-ghost\" style=\"margin-left: 6px; margin-top: 10px\"><span translate=ADD_MORE_GUESTS></span></button> <button ng-if=\"event.status != \'DRAFT\'\" ng-click=viewAllGuests() type=button class=\"btn btn-ghost\" style=\"margin-left: 6px; margin-top: 10px\"><span>View all</span></button> <button ng-if=\"event.status != \'DRAFT\'\" ng-click=\"messageGuests(\'all\')\" type=button class=\"btn btn-ghost\" style=\"margin-left: 6px; margin-top: 10px\"><span translate=SEND_A_NOTE></span></button></div></div></section><section ng-if=event.ticketed class=event-section style=\"{{ event.ticketed && ticketData.paymentProviderDTO && ticketData.paymentProviderDTO.provider ? \'margin-bottom: 0;\' : \'\'}}\"><h1 translate=EVENTS_TICKET_SALES></h1><div class=ticket-sales-header ng-if=\"ticketData.paidEventType === \'FREE\'\"><div><span translate=TOTAL_TAKEN>:</span> <span class=ticket-sale-value>{{ ticketData.totalSoldTicket }} / {{ ticketData.totalTicketCount }}</span></div></div><div class=ticket-sales-header ng-if=\"ticketData.paidEventType === \'PAID\'\"><div ng-if=\"hasPaid || hasFree\"><span translate=TOTAL_SOLD>:</span> <span class=ticket-sale-value>{{ ticketData.totalSoldTicket }} / {{ ticketData.totalTicketCount }}</span></div><div ng-if=hasPaid><span translate=TOTAL_TAKEN>:</span> <span class=ticket-sale-value><span translate=\"{{ ticketData.ticketCurrency ? ticketData.ticketCurrency : \'GBP\' }}_SHORT\"></span>{{ ticketData.totalSaleAmount | currency: \"\" }}</span></div><div ng-if=hasDonation><span translate=TOTAL_DONATION>:</span> <span class=ticket-sale-value><span translate=\"{{ ticketData.ticketCurrency ? ticketData.ticketCurrency : \'GBP\' }}_SHORT\"></span>{{ ticketData.totalDonationAmount | currency: \"\" }}</span></div></div><br><div class=ticket-sales-list><div ng-repeat=\"ticket in ticketData.tickets\"><div class=vi-row><div class=vi-col-left><span>{{ ticket.name }}</span></div><div class=vi-col-right><span ng-if=\"ticket.type === \'PAID\'\" translate=SOLD></span> <span ng-if=\"ticket.type === \'FREE\'\" translate=TAKEN></span> <span ng-if=\"ticket.type !== \'DONATION\'\">{{ ticket.totalSoldTicket }} / {{ ticket.totalTicketCount }}</span></div><div class=vi-col-middle><div ng-if=\"ticket.type !== \'DONATION\'\" class=tickets-sales-progress><div style=\"width: {{ getTicketsPercentage(ticket.totalSoldTicket, ticket.totalTicketCount) }}%\"></div></div><div ng-if=\"ticket.type === \'DONATION\'\" class=donationtext><span class=\"ticket-sale-value donationamount\">{{ ticket.totalSoldTicket }} </span><span translate=DONATIONS_TEXT_1></span><span ng-if=\"ticket.totalSoldTicket !== 1\" translate=DONATIONS_TEXT_2></span> <span translate=DONATIONS_TEXT_3></span> <span class=\"ticket-sale-value donationamount\"><span translate=\"{{ ticketData.ticketCurrency ? ticketData.ticketCurrency : \'GBP\' }}_SHORT\"></span>{{ ticket.totalSoldAmount | currency: \"\" }}</span></div></div></div><nav class=\"has-dropdown is-relative pull-right mobile-menu\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><circle fill=#8A94A2 cx=8 cy=32 r=6></circle><circle data-color=color-2 fill=#8A94A2 cx=32 cy=32 r=6></circle><circle fill=#8A94A2 cx=56 cy=32 r=6></circle></g></svg><ul class=dropdown-menu style=\"right: 0px; min-width: 170px\"><li><a ng-click=\"openGuests(\'t-\'+ticket.id)\"><span translate=VIEW_GUESTS></span></a></li><li ng-if=\"ticket.type !== \'DONATION\' && ticket.totalSoldTicket > 0\"><a ng-click=\"downloadCSV(\'TICKET_TYPE\', ticket.id)\"><span translate=DOWNLOAD_CSV_LIST></span></a></li></ul></nav></div></div><br><div><button type=button class=\"btn btn-ghost\" ng-click=gotoTickets()><span translate=ADD_MORE_TICKETS></span></button> <button type=button class=\"btn btn-ghost\" ng-click=gotoTickets() style=\"margin-left: 6px\"><span translate=EDIT_TICKET_BTN></span></button></div><br><div><p translate=QR_CODE_INFORMATION_TEXT></p><a href=https://help.classlist.com/hc/en-us/articles/14629672284445-QR-codes-for-Event-Tickets translate=QR_CODE_INFORMATION_FIND_MORE_TEXT style=font-size:16px></a></div></section><section ng-if=\"event.ticketed && ticketData.paymentProviderDTO && ticketData.paymentProviderDTO.provider\" style=\"margin-top: -1px; padding: 16px 36px !important\" class=event-section><div style=\"color:#8A94A2; font-size: 14px\">You\'re using <b>{{ticketData.paymentProviderDTO.provider.charAt(0).toUpperCase() + ticketData.paymentProviderDTO.provider.slice(1)}}</b> to collect payments. <a ng-click=gotoTickets();>Edit</a> payment settings</div></section><section ng-if=!event.ticketed class=event-section><h1 translate=TICKETS_AND_GUESTS></h1><p translate=TICKETS_DESCR></p><br><div><button type=button class=\"btn btn-ghost\" ng-click=gotoTickets()><span translate=ADD_TICKET_TO_EVENT></span></button><div style=padding-top:20px><p translate=QR_CODE_INFORMATION_TEXT></p><a href=https://help.classlist.com/hc/en-us/articles/14629672284445-QR-codes-for-Event-Tickets translate=QR_CODE_INFORMATION_FIND_MORE_TEXT style=font-size:16px></a></div></div></section><section class=event-section><h1 translate=EVENT_MESSAGES_TITLE></h1><p translate=EVENT_MESSAGES_DESC></p><br><p ng-if=\"messageList.length == 0\" translate=EVENT_MESSAGES_NO_MESSAGE></p><br><div><button type=button ng-disabled=\"event.status == \'DRAFT\'\" class=\"btn btn-ghost\" ng-click=\"messageGuests(\'all\')\"><span translate=SEND_A_NOTE></span></button></div><br><br><div ng-repeat=\"message in messageList\" class=dash-message-list><div><div class=message><div class=user-profile><a href=\"#/users/parent-detail/{{ message.userId }}\"><img class=user-image ng-src={{message.avatar}} alt=\"User Image\"></a><div><a href=\"#/users/parent-detail/{{ message.userId }}\"><h4 class=user-name>{{message.postedBy}}</h4></a><span style=\"line-height: 22px\">{{ message.createdAt | date:\'dd MMM yyyy \\\'at\\\' h:mm a\' }}</span></div></div><br><div ng-if=message.hasReadMore><div ng-if=!message.showFull><span class=clamped ng-bind-html=message.message></span> <a ng-click=toggleShow($index) class=show-btn><span style=\"text-decoration: underline\">Show More</span> <span class=dripicons-chevron-down style=\"font-size:18px;vertical-align: middle\"></span></a></div><div ng-if=message.showFull><span ng-bind-html=message.message></span><br><a ng-click=toggleShow($index) class=show-btn><span style=\"text-decoration: underline\">Hide</span> <span class=dripicons-chevron-up style=\"font-size:18px;vertical-align: middle\"></span></a></div></div><div ng-if=!message.hasReadMore ng-bind-html=message.message></div><div class=sent-to>Sent to: {{message.sentTo}}</div></div></div></div></section><section class=event-section><h1 translate=EVENT_OWNERS></h1><p ng-if=\"event.eventOwners && event.eventOwners.length == 1\" translate=EVENT_OWNERS_TEXT_ALONE></p><p ng-if=\"event.eventOwners && event.eventOwners.length > 1\" translate=EVENT_OWNERS_TEXT_MORE translate-values=\"{ ownerCount: event.eventOwners.length - 1 }\"></p><br><div><div><div class=event-owner-list><div ng-repeat=\"owner in event.eventOwners\"><div class=own-picture><figure style=\"float: left; width: 46px; height: 46px; margin-right: 10px\"><avatar source={{owner.avatar}} name=\"{{ owner.firstName }} {{ owner.lastName }}\" width=46 height=46 my=false></avatar></figure><div ng-if=\"owner.id != active_user.id\" ng-click=\"removeOwner(owner, $index)\" class=own-remove><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=24px height=24px viewBox=\"0 0 24 24\"><g transform=\"translate(0, 0)\"><polygon points=\"16.95 8.464 15.536 7.05 12 10.586 8.464 7.05 7.05 8.464 10.586 12 7.05 15.536 8.464 16.95 12 13.414 15.536 16.95 16.95 15.536 13.414 12 16.95 8.464\" fill=#444444></polygon></g></svg></div></div><div class=own-name><div>{{ owner.firstName }}</div><div>{{ owner.lastName }}</div></div></div></div></div><br><div><button ng-click=gotoAddOwner() type=button class=\"btn btn-ghost\"><span translate=ADD_ANOTHER_OWNER></span></button></div></div><br><div class=event-dashboard><span translate=PRIVATE_EVENT_CREATED_BY></span> <a ui-sref=\"classlist.details.contact({\'id\': event.createdById })\">{{event.createdByName}}</a> <span ng-if=!editingCreatedby class=\"icon dripicons-pencil\" ng-click=editCreatedby($event) style=\"float: revert; font-size: 15px\"></span><div class=click-editor ng-show=editingCreatedby click-outside=saveOutsideCreatedby() ng-click=stopPropagation($event)><input ng-model=valueCreatedby type=text placeholder=\"{{\'EVENT_CREATED_BY\' | translate }}\"><div><span class=\"icon dripicons-checkmark\" ng-click=saveCreatedby()></span> <span class=\"icon dripicons-cross\" ng-click=cancelCreatedby()></span></div></div></div></section><section class=event-section><div><span style=\"float: left\"><h1 translate=EVENT_VOLUNTEERS></h1></span><span style=\"float: left\" class=beta-label translate=BETA></span></div><div style=\"clear: both\"></div><p translate=EVENT_VOLUNTEERS_DESC_2 ng-if=\"!rotaList || rotaList.length == 0\"></p><p translate=EVENT_VOLUNTEERS_DESC_SIGNUP ng-if=\"rotaList && rotaList.length > 0\"></p><div ng-if=\"rotaList && rotaList.length > 0\" class=dash-rota-list><br><div ng-repeat=\"rota in rotaList\"><div><div class=dash-rota-status><div ng-click=viewRota(rota)>{{ rota.title }}</div><label ng-if=rota.enabled class=event-live-label translate=LIVE></label><label ng-if=!rota.enabled class=event-live-label translate=DRAFT style=\"background-color: #ccc\"></label></div><div class=pull-right><button ng-click=viewRota(rota) type=button class=\"btn btn-ghost\"><span>View</span></button></div></div></div></div><br><div><button ng-click=createVolunteerRota() type=button class=\"btn btn-ghost\"><span translate=CREATE_VOLUNTEER_ROTA></span></button></div></section><section class=event-section><h1 translate=EVENT_ACTIVITY></h1><p translate=EVENT_ACTIVITY_DESC></p><br><div><post-asset ng-repeat=\"p in posts\" post-content={{p}} post-context=HOME_VIEW class=enter user-avatar={{userAvatar}} comment-only=true user-id={{user.id}} user-role=user.role user-name={{userName}} post-events=events></post-asset></div></section></div></section>");
$templateCache.put("app/events/views/delete-canceled-modal.html","<div><div class=modal-header><p ng-if=!event.hasSoldTicket translate=DELETE_CANCELED_EVENT_HEADER></p><p ng-if=event.hasSoldTicket translate=DELETE_CANCELED_SOLD_EVENT_HEADER></p></div><div class=modal-footer><button ng-if=event.hasSoldTicket type=button class=\"btn btn-primary pull-right\" translate=DELETE_ANYWAY_BTN ng-click=save()><button ng-if=event.hasSoldTicket type=button class=\"btn btn-primary pull-right\" translate=HIDE_BTN style=\"margin-right: 10px\" ng-click=hide()><button ng-if=!event.hasSoldTicket type=button class=\"btn btn-primary pull-right\" translate=DELETE_BTN ng-click=save()><button type=button class=\"btn btn-default pull-right\" translate=BACK_BTN ng-click=close()></div></div>");
$templateCache.put("app/events/views/delete-modal.html","<div><div class=modal-header><h3 translate=DELETE_EVENT_HEADER></h3></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=OK_BTN ng-click=save()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/events/views/delete-rota-modal.html","<div><div class=modal-header><h3 translate=DELETE_ROTA_HEADER></h3></div><div class=modal-body><p translate=DELETE_ROTA_TEXT></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" ng-disabled=deletingrota translate=YES_DELETE ng-click=save()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/events/views/delete-task-modal.html","<div><div class=modal-header><h3 translate=DELETE_TASK_HEADER></h3></div><div class=modal-body><p translate=DELETE_TASK_TEXT></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" ng-disabled=deletingrota translate=YES_DELETE ng-click=save()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/events/views/duplicate-modal.html","<div><div class=modal-header><h3 translate=DUPLICATE_EVENT_HEADER></h3></div><div class=modal-body><p class=multiple-line-text translate=DUPLICATE_EVENT_BODY style=\"font-size: 14px;\n        line-height: 1.42857143;\n        color: #333\"></p><div class=create-event-dates><div class=\"{{ (hasDateError(\'STARTDATE_CANNOT_BE_NULL\') || hasDateError(\'STARTDATE_CANNOT_BEFORE_TODAY\') || hasDateError(\'STARTDATE_CANNOT_AFTER_ENDDATE\')) ? \'invalid-input-label\' : \'\' }}\"><div class=\"event-input event-date-input\" style=\"margin-right: 5%\"><label translate=EVENT_STARTS></label><div class=is-relative style=\"width: 60%\"><input type=text class=ev-date-input uib-datepicker-popup=\"EEE, dd MMM yyyy\" ng-model=cloneEvent.startDate ng-change=cloneEventStartDateOptions.onDateSelect(cloneEvent.startDate) show-button-bar=false is-open=popupStartDate.opened datepicker-options=dateOptions ng-required=true style=\"width: 100%\"> <span class=\"select-arrow date-picker-icon\"><button type=button class=\"btn btn-default\" style=\"padding-right:10px !important\" ng-click=pickStartDate()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=is-relative style=\"width: 35%; float: left\"><select ng-model=cloneEvent.startTime ng-change=cloneEventStartDateOptions.onTimeSelect(cloneEvent.startTime) class=ev-time-input style=\"width: 100%\"><option ng-repeat=\"time in eventTimes\" value=\"{{ time.value }}\">{{ time.text }}</option></select><span class=\"dripicons-chevron-down select-arrow\" style=\"margin-right: 0px !important\"></span></div></div><div class=event-wrong-input translate=\"{{ hasDateError(\'STARTDATE_CANNOT_BE_NULL\') }}\"></div><div class=event-wrong-input translate=\"{{ hasDateError(\'STARTDATE_CANNOT_BEFORE_TODAY\') }}\"></div><div class=event-wrong-input translate=\"{{ hasDateError(\'STARTDATE_CANNOT_AFTER_ENDDATE\') }}\"></div></div><div class=\"{{ (hasDateError(\'ENDDATE_CANNOT_BE_NULL\') || hasDateError(\'ENDDATE_CANNOT_BEFORE_TODAY\') || hasDateError(\'ENDDATE_CANNOT_BEFORE_STARTDATE\')) ? \'invalid-input-label\' : \'\' }}\"><div class=\"event-input event-date-input\"><label translate=EVENT_ENDS></label><div class=is-relative style=\"width: 60%\"><input type=text class=ev-date-input uib-datepicker-popup=\"EEE, dd MMM yyyy\" ng-model=cloneEvent.endDate ng-change=cloneEventEndDateOptions.onDateSelect(cloneEvent.endDate) show-button-bar=false is-open=popupEndDate.opened datepicker-options=dateOptions ng-required=true style=\"width: 100%\"> <span class=\"select-arrow date-picker-icon\"><button type=button class=\"btn btn-default\" style=\"padding-right:10px !important\" ng-click=pickEndDate()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=is-relative style=\"width: 35%; float: left\"><select ng-model=cloneEvent.endTime ng-change=cloneEventEndDateOptions.onTimeSelect(cloneEvent.endTime) class=ev-time-input style=\"width: 100%\"><option ng-repeat=\"time in eventTimes\" value=\"{{ time.value }}\">{{ time.text }}</option></select><span class=\"dripicons-chevron-down select-arrow\" style=\"margin-right: 0px !important\"></span></div></div><div class=event-wrong-input translate=\"{{ hasDateError(\'ENDDATE_CANNOT_BE_NULL\') }}\"></div><div class=event-wrong-input translate=\"{{ hasDateError(\'ENDDATE_CANNOT_BEFORE_TODAY\') }}\"></div><div class=event-wrong-input translate=\"{{ hasDateError(\'ENDDATE_CANNOT_BEFORE_STARTDATE\') }}\"></div></div></div><br><div class=create-event-dates><div class=\"{{ (hasDateError(\'RSVPDATE_CANNOT_BEFORE_TODAY\') || hasDateError(\'RSVPDATE_CANNOT_BEFORE_STARTDATE\') || hasDateError(\'RSVPDATE_CANNOT_AFTER_ENDDATE\')) ? \'invalid-input-label\' : \'\' }}\"><div class=\"event-input event-date-input\" style=\"margin-right: 5%\"><label translate=EVENT_RSVP></label><div class=is-relative style=\"width: 60%\"><input type=text class=ev-date-input uib-datepicker-popup=\"EEE, dd MMM yyyy\" ng-model=cloneEvent.rsvpDate ng-change=cloneEventRsvpDateOptions.onDateSelect(cloneEvent.rsvpDate) show-button-bar=false is-open=popupRsvpDate.opened datepicker-options=dateOptions ng-required=true style=\"width: 100%\"> <span class=\"select-arrow date-picker-icon\"><button type=button class=\"btn btn-default\" style=\"padding-right:10px !important\" ng-click=pickRsvpDate()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=is-relative style=\"width: 35%; float: left\"><select ng-model=cloneEvent.rsvpTime ng-change=cloneEventRsvpDateOptions.onTimeSelect(cloneEvent.rsvpTime) class=ev-time-input style=\"width: 100%\"><option ng-repeat=\"time in eventTimes\" value=\"{{ time.value }}\">{{ time.text }}</option></select><span class=\"dripicons-chevron-down select-arrow\" style=\"margin-right: 0px !important\"></span></div></div><div class=event-wrong-input translate=\"{{ hasDateError(\'RSVPDATE_CANNOT_BEFORE_TODAY\') }}\"></div><div class=event-wrong-input translate=\"{{ hasDateError(\'RSVPDATE_CANNOT_BEFORE_STARTDATE\') }}\"></div><div class=event-wrong-input translate=\"{{ hasDateError(\'RSVPDATE_CANNOT_AFTER_ENDDATE\') }}\"></div></div><div style=\"min-height: auto\"><svg ng-if=\"cloneEvent.rsvpDate || cloneEvent.rsvpTime\" class=clear-rsvp-date-icon ng-click=cloneEventRsvpDateOptions.clear() xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=12px height=12px viewBox=\"0 0 12 12\"><g transform=\"translate(0, 0)\"><path d=M10.707,1.293a1,1,0,0,0-1.414,0L6,4.586,2.707,1.293A1,1,0,0,0,1.293,2.707L4.586,6,1.293,9.293a1,1,0,1,0,1.414,1.414L6,7.414l3.293,3.293a1,1,0,0,0,1.414-1.414L7.414,6l3.293-3.293A1,1,0,0,0,10.707,1.293Z fill=#444444></path></g></svg></div></div><br></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=YES_DUPLICATE_EVENT ng-click=save() ng-disabled=\"duplicatingEvent || dateErrors.length > 0\"><button type=button class=\"btn btn-default pull-right\" translate=NO_GO_BACK ng-click=close()></div></div>");
$templateCache.put("app/events/views/event-create-how-to-try-modal.html","<div style=\"padding: 15px\"><div class=modal-header><h3 translate=EVENT_HOW_TO_TRY_MODAL_TITLE></h3></div><div class=modal-body><p translate=EVENT_HOW_TO_TRY_MODAL_DESCRIPTION style=color:#001031 class=event-howto-try-description></p></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=OK_BTN></span></button></div></div>");
$templateCache.put("app/events/views/getpaid-using-paypal-modal.html","<div style=\"padding: 15px\"><div class=modal-header><h3 translate=GETPAID_PAYPAL_HEADER></h3></div><div class=modal-body><p translate=GETPAID_PAYPAL_CONTENT></p></div><div class=modal-footer><button type=button class=\"btn btn-ghost pull-right\" translate=OK_BTN ng-click=cancel()></button></div></div>");
$templateCache.put("app/events/views/hide-modal.html","<div><div class=modal-header><p translate=HIDE_EVENT_HEADER></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=HIDE_BTN ng-click=save()><button type=button class=\"btn btn-default pull-right\" translate=BACK_BTN ng-click=close()></div></div>");
$templateCache.put("app/events/views/invite-ambassadors-modal.html","<div class=\"modal-dialog modal-md\" style=\"padding: 10px\" id=cue-firstamb-invite-modal><div class=modal-header><h3 translate=SEND_AMBASSADOR_INVITE_HEADER></h3></div><div class=modal-body><p translate=SEND_AMBASSADOR_INVITE_BODY></p><div style=\"margin-top: 25px\"><textarea ng-model=ambassadorInviteEmails autoresize-textarea placeholder=\"Enter emails seperated by a comma\" style=\"border: 1px solid #838383; padding: 10px; padding: 15px; width: 100%\"></textarea></div></div><div class=modal-footer style=\"margin-top: 15px\"><a ng-click=dismissTodo() class=pull-left style=padding-top:10px>Don\'t show this again</a> <button type=button class=\"btn btn-primary pull-right\" translate=INVITE_MY_TEAM ng-click=sendAmbassadorInvitations() ng-disabled=\"!ambassadorInviteEmails || ambassadorInviteEmails.length == 0 || ambassadorInviteEmailsSending\"><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/events/views/invite-draft-rotas-modal.html","<div><div class=modal-header><h3 translate=INVITES_DRAFT_ROTA_HEADER></h3></div><div class=modal-body><p translate=INVITES_DRAFT_ROTA_TEXT></p></div><div class=modal-footer><button type=button ng-disabled=publishingrotas class=\"btn btn-primary pull-right\" translate=PUBLISH_NOW ng-click=doit() style=\"margin-left: 10px; margin-bottom: 10px\"><button type=later ng-disabled=publishingrotas class=\"btn btn-ghost pull-right\" translate=LATER ng-disabled=adding ng-click=close() style=\"margin-bottom: 10px\"></div></div>");
$templateCache.put("app/events/views/invite-invites-modal.html","<div><div class=modal-header><h3 translate=SEND_INVITES></h3></div><div class=modal-body><p translate=SEND_INVITES_TEXT translate-values=\"{\'count\':count}\"></p></div><div class=modal-footer><button type=button ng-disabled=publishing class=\"btn btn-primary pull-right\" translate=SEND_INVITES ng-click=continue() style=\"margin-left: 10px; margin-bottom: 10px\"><button type=button ng-disabled=publishing class=\"btn btn-ghost pull-right\" translate=CANCEL_BTN ng-disabled=adding ng-click=close() style=\"margin-bottom: 10px\"></div></div>");
$templateCache.put("app/events/views/invite-modal.html","<script type=text/ng-template id=memberTemplate.html><div class=\"match-container\">	\n		<div class=\"match-container-parentname\">\n			<span ng-bind-html=\"match.model.field1 | uibTypeaheadHighlight:query\" ng-if=\"match.model.field1\"></span>\n			<span ng-bind-html=\"match.model.field2 | uibTypeaheadHighlight:query\" ng-if=\"match.model.field2\"></span>\n		</div>\n		<div>\n            <span translate=\"PARENTHESES_OPEN\" ng-if=\"match.model.field3\"></span><span ng-bind-html=\"(m | uibTypeaheadHighlight:query) + ($last ? \'\' : \', \')\" ng-repeat=\"m in match.model.field3 track by $index\"></span><span translate=\"PARENTHESES_CLOSE\" ng-if=\"match.model.field3\"></span>\n		</div>\n	</div></script><div class=invite-modal style=\"padding: 10px; padding-right: 5px\"><div class=modal-header><h3 translate=ADD_GUESTS></h3><div translate=EVENT_INVITE_TEXT_3 style=\"margin-top: 10px\"></div></div><div class=modal-body style=\"padding: 15px; padding-bottom: 0\"><div style=\"overflow: auto\"><span translate=INVITE_THE_WHOLE_SCHOOL style=\"float: left; margin-right: 16px; font-size: 18px; font-weight: bold\"></span><div class=pull-left><div ng-click=switchWholeSchool() ng-model=isWholeSchool class=\"mobile-checkmark {{ isWholeSchool ? \'enabled\' : \'\' }}\"><div></div></div></div></div><div ng-if=!isWholeSchool><br><participants ng-model=members dataevent=dataEvent(data) event-context=true show-tiers=true school-id={{active_school.id}} allow-host-invite=true></participants></div></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=ADD_GUESTS ng-disabled=\"(members.length == 0 && !event.open && !isWholeSchool) || invitingGuests\" ng-click=save()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/events/views/list.html","<div class=event-list-container><div class=\"page-view-header clearfix\"><div><strong class=page-view-header__title translate=EVENTS_HEADER></strong> <button type=button class=\"btn btn-primary page-view-header__button\" id=cue-button-create ng-click=createEvent()><span translate=CREATE_COMMUNITY_EVENT_BTN class=hidden-xs></span> <span translate=CREATE_BTN class=visible-xs></span></button></div></div><div class=page-container-header-from-top><div style=\"padding: 0 15px\"><div class=\"dashboard-main feedback-container\" ng-if=isFlutterApp()><section class=row><div class=\"col-md-12 tablet-view-margins section-bottom-margin\"><div class=\"margin stat-cards\"><div class=\"content feed-back-container\"><p>Loving Classlist? <a ng-click=getStoreReviewUrl() style=\"text-decoration: underline\">Rate us now</a> and help us grow	<span style=\"font-size: 12px\">❤️</span></p><span style=color:grey>Not so satisfied? We\'re listening.</span><br><span style=color:grey><a href=https://help.classlist.com/hc/en-us/requests/new style=\"text-decoration: underline\">Our helpdesk</a> is the place to share constructive feedback.</span></div></div></div></section></div><div><div class=event-empty-state-parent ng-if=viewState.isEmpty><!--Start emoji--> <svg class=emoji xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\" stroke-width=4><g stroke-width=4 transform=\"translate(0, 0)\"><line data-color=color-2 x1=20 y1=44 x2=44 y2=44 fill=none stroke=#4aa0f0 stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></line><circle data-color=color-2 cx=19.5 cy=29.5 r=2.5 fill=none stroke=#4aa0f0 stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></circle><circle data-color=color-2 cx=44.5 cy=29.5 r=2.5 fill=none stroke=#4aa0f0 stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></circle><circle cx=32 cy=32 r=28 fill=none stroke=#4aa0f0 stroke-linecap=square stroke-miterlimit=10 stroke-width=4 stroke-linejoin=miter></circle><circle data-color=color-2 data-stroke=none cx=19.5 cy=29.5 r=2.5 fill=#4aa0f0></circle><circle data-color=color-2 data-stroke=none cx=44.5 cy=29.5 r=2.5 fill=#4aa0f0></circle></g></svg><!--End emoji--><h4 class=empty-events translate=EMPTY_TITLE_EVENTS></h4><p class=empty-events-descr translate=EMPTY_DESCR_EVENTS></p></div><div class=event-list><!--Draft events--><div><div ng-show=\"draft_events.length > 0\" translate=DRAFT_EVENTS style=\"color:#627293;font-size: 16px; font-weight: 600; padding-bottom: 15px\"></div><div class=event-items><div class=event-item ng-if=\"draft_events.length > 0\" ng-repeat=\"e in draft_events\" ng-click=\"openEvent(e, true)\"><aside class=\"event-item event-aside\"><time class=event-datetime style=\"background-image:url(\'{{e.imageURL}}\')\"></time><div class=event-info><a class=event-title style=\"color:#001031;font-weight: bold;font-size: 16px; margin-bottom: 5px\" ng-style=\"{\'text-decoration\': e.owner ? \'none\' : \'\'}\"><span ng-if=e.title>{{::e.title }}</span> <span ng-if=!e.title translate=NO_TITLE></span></a><p translate=EVENT_PAGE_DRAFT style=\"color:#001031; font-weight: 600; font-size: 14px; margin-bottom: 5px\"></p><p style=\"color:#627293; font-weight: 600; font-size: 14px; margin-bottom: 5px\">{{ ::e.startDate | date:\'EEE, dd MMM yyyy\':\'GMT\' }} at {{ ::e.startDate | date:\'h:mm a\':\'GMT\' }}</p><p style=\"color:#001031; font-weight: 600; font-size: 14px; margin-bottom: 5px\">{{getOrganiserNames(e)}}</p><!-- <div class=\"event-tag\" ng-if=\"e.type === \'COMMUNITY\'\">\n                                            <span class=\"circle-tag community-tag\"></span>\n                                            <span class=\"event-tag-txt\" translate=\"TAG_COMMUNITY_EVENT\"></span>\n                                        </div> --></div></aside></div></div></div><!--Upcoming events--><div><div ng-show=\"new_events.length > 0\" translate=COMING_UP_EVENTS style=\"color:#627293;font-size: 16px; font-weight: 600; padding-bottom: 15px\"></div><div class=event-items><div class=event-item ng-if=\"new_events.length > 0\" ng-repeat=\"e in new_events\" ng-click=openEvent(e)><aside class=\"event-item event-aside\"><time class=event-datetime style=\"background-image:url(\'{{e.imageURL}}\')\"></time><div class=event-info><a class=event-title style=\"color:#001031;font-weight: bold;font-size: 16px; margin-bottom: 5px\" ng-style=\"{\'text-decoration\': e.owner ? \'none\' : \'\'}\"><span ng-if=e.title>{{::e.title }}</span> <span ng-if=!e.title translate=NO_TITLE></span></a><p translate=EVENT_PAGE_UPCOMING style=\"color:#001031; font-weight: 600; font-size: 14px; margin-bottom: 5px\"></p><p style=\"color:#627293; font-weight: 600; font-size: 14px; margin-bottom: 5px\">{{ ::e.startDate | date:\'EEE, dd MMM yyyy\':\'GMT\' }} at {{ ::e.startDate | date:\'h:mm a\':\'GMT\' }}</p><p style=\"color:#001031; font-weight: 600; font-size: 14px; margin-bottom: 5px\">{{getOrganiserNames(e)}}</p><a ng-if=e.owner ng-click=\"openEvent(e, true)\" style=\"display: inline-flex\"><svg width=24 height=24 viewBox=\"0 0 24 24\" fill=none xmlns=http://www.w3.org/2000/svg><path d=\"M9 5H2v17h17v-7\" stroke=#EB004E stroke-width=1.5 stroke-linecap=square /><path d=\"m16 5 3 3\" stroke=#EB004E stroke-width=1.5 /><path clip-rule=evenodd d=\"m11 16-4 1 1-4L19 2l3 3-11 11v0z\" stroke=#EB004E stroke-width=1.5 stroke-linecap=square /></svg> <span translate=EVENT_MANAGE_EVENT style=\"font-weight: 700; color:#eb004e; font-size: 14px; padding-top:5px; padding-left:10px\"></span></a></div></aside></div></div></div><!--Past events--><div><div ng-if=\"past_events.length > 0\"><span ng-if=\"past_events.length > pastItemsLimit\" style=\"float: right\">{{ pastItemsLimit ? pastItemsLimit : past_events.length }} <span translate=of></span> {{ past_events.length }} <span ng-show=pastItemsLimit style=\"margin-left: 10px\"><a ng-click=togglePastMore() translate=SHOW_ALL></a></span></span><div translate=PAST_EVENTS style=\"color:#627293;font-size: 16px; font-weight: 600; padding-bottom: 15px\"></div></div><div class=event-items><div class=event-item ng-if=\"past_events.length > 0\" ng-repeat=\"e in past_events | limitTo: pastItemsLimit\" ng-click=openEvent(e)><aside class=\"event-item event-aside\"><time class=event-datetime style=\"background-image:url(\'{{e.imageURL}}\')\"></time><div class=event-info><a class=event-title style=\"color:#001031;font-weight: bold;font-size: 16px; margin-bottom: 5px\" ng-style=\"{\'text-decoration\': e.owner ? \'none\' : \'\'}\"><span ng-if=e.title>{{::e.title }}</span> <span ng-if=!e.title translate=NO_TITLE></span></a><p translate=EVENT_PAGE_PAST style=\"color:#001031; font-weight: 600; font-size: 14px; margin-bottom: 5px\"></p><p style=\"color:#627293; font-weight: 600; font-size: 14px; margin-bottom: 5px\">{{ ::e.startDate | date:\'EEE, dd MMM yyyy\':\'GMT\' }} at {{ ::e.startDate | date:\'h:mm a\':\'GMT\' }}</p><p style=\"color:#001031; font-weight: 600; font-size: 14px; margin-bottom: 5px\">{{getOrganiserNames(e)}}</p></div></aside></div></div></div><!--Cancelled events--><div><div ng-if=\"cancelled_events.length > 0\"><span ng-if=\"cancelled_events.length > pastItemsLimit\" style=\"float: right\">{{ pastItemsLimit ? pastItemsLimit : cancelled_events.length }} <span translate=of></span> {{ cancelled_events.length }} <span ng-show=pastItemsLimit style=\"margin-left: 10px\"><a ng-click=togglePastMore() translate=SHOW_ALL></a></span></span><div translate=CANCELLED_EVENTS style=\"color:#627293;font-size: 16px; font-weight: 600; padding-bottom: 15px\"></div></div><div class=event-items><div class=event-item ng-if=\"cancelled_events.length > 0\" ng-repeat=\"e in cancelled_events | limitTo: pastItemsLimit\" ng-click=openEvent(e)><aside class=\"event-item event-aside\"><time class=event-datetime style=\"background-image:url(\'{{e.imageURL}}\')\"></time><div class=event-info><a class=event-title style=\"color:#001031;font-weight: bold;font-size: 16px; margin-bottom: 5px\" ng-style=\"{\'text-decoration\': e.owner ? \'none\' : \'\'}\"><span ng-if=e.title>{{::e.title }}</span> <span ng-if=!e.title translate=NO_TITLE></span></a><p translate=EVENT_PAGE_CANCELLED style=\"color:#001031; font-weight: 600; font-size: 14px; margin-bottom: 5px\"></p><p style=\"color:#627293; font-weight: 600; font-size: 14px; margin-bottom: 5px\">{{ ::e.startDate | date:\'EEE, dd MMM yyyy\':\'GMT\' }} at {{ ::e.startDate | date:\'h:mm a\':\'GMT\' }}</p><p style=\"color:#001031; font-weight: 600; font-size: 14px; margin-bottom: 5px\">{{getOrganiserNames(e)}}</p></div></aside></div></div></div><aside ng-if=\"new_events.length === 0 && past_events.length === 0 && viewState.isReady\"><div class=col-sm-2></div><div class=\"col-sm-4 no-events-image\"><img src=assets/images/no-events.svg alt=\"\"></div><div class=\"col-sm-4 no-events-text\"><p translate=NO_EVENTS_TEXT></p></div><div class=col-sm-2></div></aside></div></div></div></div></div>");
$templateCache.put("app/events/views/live-confirm-modal.html","<div style=\"padding: 25px\"><div class=modal-body style=\"text-align: center\"><h3 translate=CONGRATULATIONS style=\"font-size: 27px; margin-bottom: 10px\"></h3><p translate=CONGRATULATIONS_TEXT style=\"font-size: 16px; max-width: 340px; color: #8A94A2; margin: auto; margin-bottom: 20px\"></p><img src=assets/images/events-invites-sent.svg alt=\"\"><div class=\"row event-dashboard\" ng-if=event.open><div class=col-md-4><div class=share-event ng-click=shareWhatsapp()><div style=\"background-color: #00a69d\" class=circle><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 48 48\"><g transform=\"translate(0, 0)\"><path fill=#ffffff d=\"M0.10739,48l3.37542-12.32542c-2.08204-3.60688-3.17763-7.69894-3.17592-11.89098 C0.31215,10.66928,10.98554,0,24.09976,0c6.36475,0.00253,12.33865,2.47971,16.83067,6.97547 c4.49214,4.49575,6.96465,10.47174,6.96218,16.82712c-0.00531,13.11432-10.67966,23.785-23.79253,23.785h-0.00006h-0.00974 c-3.98213-0.00164-7.89481-1.00024-11.36995-2.89505L0.10739,48z M13.30466,40.38635l0.72215,0.42849 c3.03621,1.80129,6.51666,2.7542,10.06511,2.75559h0.0081c10.89973,0,19.77101-8.8685,19.77545-19.76937 c0.00202-5.28238-2.053-10.2494-5.78667-13.98611c-3.73368-3.73672-8.69893-5.79578-13.98092-5.79781 c-10.90811,0-19.77946,8.86787-19.78382,19.76797c-0.00152,3.73532,1.04402,7.37333,3.02355,10.52097l0.47026,0.7479 l-1.99782,7.29512L13.30466,40.38635z\"></path><path data-color=color-2 fill-rule=evenodd clip-rule=evenodd fill=#ffffff d=\"M18.15336,13.84087 c-0.48253-1.1589-0.97266-1.0021-1.33759-1.02027c-0.34636-0.01724-0.74309-0.02088-1.13941-0.02088 s-1.04036,0.14873-1.5853,0.74366c-0.54492,0.59496-2.08067,2.03281-2.08067,4.958c0,2.92519,2.13022,5.7512,2.42748,6.14787 c0.29723,0.39667,4.19204,6.39961,10.15569,8.97392c1.41836,0.6123,2.52578,0.9779,3.38909,1.25194 c1.42423,0.45222,2.72022,0.38844,3.74456,0.23544c1.14216-0.17059,3.51729-1.43777,4.01272-2.82601 c0.49537-1.38824,0.49537-2.57817,0.34674-2.82608c-0.14856-0.24784-0.54491-0.3966-1.13937-0.69412 c-0.59452-0.29745-3.51734-1.73529-4.06233-1.93359c-0.54491-0.19831-0.9412-0.29746-1.33755,0.29751 c-0.39628,0.59491-1.5356,1.9336-1.88241,2.3302c-0.34674,0.39667-0.69355,0.44627-1.28801,0.14876 c-0.59453-0.29745-2.51008-0.92506-4.7808-2.94978c-1.76725-1.57578-2.96047-3.52215-3.30725-4.11712 c-0.34677-0.59496-0.03689-0.91665,0.26073-1.2129c0.26739-0.26626,0.59446-0.69412,0.89172-1.04118 c0.29723-0.34706,0.39632-0.59497,0.59446-0.99157c0.19818-0.39667,0.09909-0.74372-0.04955-1.04121 C19.83772,17.956,18.64879,15.03077,18.15336,13.84087z\"></path></g></svg></div><span class=title translate=SHARE_BY_WHAAPP></span></div></div><div class=col-md-4><div class=share-event ng-click=shareFacebook()><div style=\"background-color: #3b5998\" class=circle><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 48 48\"><g transform=\"translate(0, 0)\"><path fill=#ffffff d=\"M19.32924,46V25.92955h-6.75413v-7.82187h6.75413v-5.76839C19.32924,5.64511,23.41782,2,29.38949,2 c2.86049,0,5.31894,0.21297,6.03539,0.30816v6.99581l-4.14167,0.00188c-3.24773,0-3.87657,1.54327-3.87657,3.80792v4.99391h7.74553 l-1.0085,7.82187h-6.73704V46H19.32924z\"></path></g></svg></div><span class=title translate=SHARE_BY_FACEBOOK></span></div></div><!-- disabled until the endpoint ready for downloading qr flyer\n            <div class=\"col-md-3\">\n                <div class=\"share-event\" ng-click=\"shareQrFlyer()\">\n                    <div style=\"background-color: #8A94A2;\" class=\"circle\">\n                        <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"48px\" height=\"48px\" viewBox=\"0 0 48 48\"><g transform=\"translate(0, 0)\"><path fill=\"#ffffff\" d=\"M5,43v3c0,0.552,0.447,1,1,1h36c0.553,0,1-0.448,1-1v-3H5z\"></path> <path fill=\"#ffffff\" d=\"M43,21v-7H31c-0.553,0-1-0.448-1-1V1H6C5.447,1,5,1.448,5,2v19H43z\"></path> <polygon data-color=\"color-2\" fill=\"#ffffff\" points=\"32,2.586 32,12 41.414,12 \"></polygon> <path data-color=\"color-2\" fill=\"#ffffff\" d=\"M17.042,29.861h-0.548v1.805h0.387c0.319,0,0.572-0.09,0.76-0.27 c0.188-0.179,0.282-0.426,0.282-0.74C17.922,30.126,17.629,29.861,17.042,29.861z\"></path> <path data-color=\"color-2\" fill=\"#ffffff\" d=\"M24.062,29.861h-0.618v4.398h0.473c0.645,0,1.117-0.188,1.418-0.562s0.451-0.946,0.451-1.716 c0-0.72-0.142-1.253-0.427-1.601C25.074,30.034,24.642,29.861,24.062,29.861z\"></path> <path data-color=\"color-2\" fill=\"#ffffff\" d=\"M46,23H2c-0.552,0-1,0.448-1,1v16c0,0.552,0.448,1,1,1h44c0.552,0,1-0.448,1-1V24 C47,23.448,46.552,23,46,23z M19.295,32.678c-0.518,0.479-1.252,0.717-2.205,0.717h-0.596V36h-2.122v-7.853h2.718 c0.992,0,1.737,0.217,2.234,0.649c0.498,0.434,0.747,1.05,0.747,1.848C20.071,31.522,19.812,32.2,19.295,32.678z M26.905,34.937 C26.184,35.646,25.17,36,23.863,36h-2.541v-7.853h2.718c1.26,0,2.233,0.322,2.919,0.967c0.686,0.645,1.029,1.575,1.029,2.793 C27.988,33.218,27.627,34.228,26.905,34.937z M34.036,29.85h-2.551v1.499h2.353v1.702h-2.353V36h-2.089v-7.853h4.641V29.85z\"></path></g></svg>\n                    </div>\n                    <span class=\"title\" translate=\"SHARE_BY_QR_CODE\"></span>\n                </div>\n            </div>\n            --><div class=col-md-4><div class=share-event ng-click=copyLink();><div style=\"background-color: #cfc4ff\" class=circle><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 48 48\"><g transform=\"translate(0, 0)\"><path d=M19,37H14a13,13,0,0,1,0-26h5a2,2,0,0,1,0,4H14a9,9,0,0,0,0,18h5a2,2,0,0,1,0,4Z fill=#ffffff></path><path d=M34,37H29a2,2,0,0,1,0-4h5a9,9,0,0,0,0-18H29a2,2,0,0,1,0-4h5a13,13,0,0,1,0,26Z fill=#ffffff></path><path data-color=color-2 d=M34,26H14a2,2,0,0,1,0-4H34a2,2,0,0,1,0,4Z fill=#ffffff></path></g></svg></div><span class=title translate=SHARE_BY_LINK></span></div></div></div></div><div class=modal-footer style=\"text-align: center\"><button type=button class=\"btn btn-primary\" translate=OK_GOT_IT ng-click=close()></div></div>");
$templateCache.put("app/events/views/location-modal.html","<div class=event-addlocation-modal style=\"padding: 10px; padding-right: 0\"><div class=modal-header><h3 translate=ADD_LOCATION></h3></div><div class=modal-body><div class=location-tabs><div translate=USE_SAVED_ADDRESS ng-click=switchAddress(false) class=\"{{ !tabNewAddress ? \'selected\' : \'\' }}\" ng-show=!tabNewAddress></div><div translate=ENTER_NEW_ADDRESS ng-click=switchAddress(true) class=\"{{ tabNewAddress ? \'selected\' : \'\' }}\"></div><div translate=USE_SAVED_ADDRESS ng-click=switchAddress(false) class=\"{{ !tabNewAddress ? \'selected\' : \'\' }}\" ng-show=tabNewAddress></div></div><div ng-show=!tabNewAddress><br><div class=saved-addresses><div ng-repeat=\"addr in savedAddresses\"><div class=vi-row ng-click=\"selectAddress(addr, $index)\"><div class=vi-col-left style=\"width: 40px\"><label><input type=checkbox ng-checked=\"$index == selectedAddress.index\" style=\"float: left\"></label></div><div class=vi-col-right><span ng-if=\"addr.id != 0\" ng-click=\"deleteAddress(addr, $index)\" class=\"icon dripicons-cross\"></span></div><div class=vi-col-middle><div>{{ addr.plainLocation }}</div></div></div></div></div></div><div ng-show=tabNewAddress><div><google-maps-autocomplete ng-model=event.g_location></div><br><div><label><input ng-model=saveAddressCheck type=checkbox checked style=\"float: left\"> <span style=\"margin-left: 10px; line-height: 28px\" translate=SAVE_FOR_LATER></span></label></div><div translate=EVENT_LOCATION_TEXT_1></div></div></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=ADD_BTN ng-click=save() ng-disabled=\"!selectedAddress || addingLocation\"><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/events/views/lock-comment-modal.html","<div><div class=modal-header><h3 translate=\"{{isLocked ? \'UNLOCK_COMMENT_HEADER\' : \'LOCK_COMMENT_HEADER\'}}\"></h3></div><div class=modal-body><p translate=\"{{isLocked ? \'UNLOCK_COMMENT_TEXT\' : \'LOCK_COMMENT_TEXT\'}}\"></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=OK_BTN ng-click=confirmLockComments()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=cancelLockComments()></div></div>");
$templateCache.put("app/events/views/manage-guests.html","<section class=event-guests ng-class=\"{\'is-visible\': viewState.isReady }\"><div class=\"page-view-header clearfix\"><div><div class=row><div class=col-md-12><a ui-sref=\"events.dashboard({\'id_event\': id_event})\" id=header-back-button style=\"float: left; margin-right: 10px; position: relative\" class=page-view-header__back><span class=dripicons-arrow-thin-left></span></a></div></div></div></div><div><section class=event-section><h1 translate=EVENTS_GUESTS></h1><p translate=EVENTS_GUESTS_DESCR></p><br><div><div class=\"event-input event-input-icon\"><input type=text placeholder=\"{{ \'SEARCH_BY_PARENT_TXT\' | translate }}\" ng-model=selectedSelectFilter.keyword ng-keyup=keywordKeyup()> <svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=24px height=24px viewBox=\"0 0 24 24\"><g transform=\"translate(0, 0)\"><path d=M23.061,20.939l-5.733-5.733a9.028,9.028,0,1,0-2.122,2.122l5.733,5.733ZM3,10a7,7,0,1,1,7,7A7.008,7.008,0,0,1,3,10Z fill=#444444></path></g></svg></div><!-- <br>\n                <div class=\"guest-tabs {{ event.ticketed ? \'tabs-ticketed\' : \'tabs-nonticketed\' }}\">\n                    <div class=\"{{ !selectedSelectFilter.keyword && selectedSelectFilter.type == \'\' ? \'active\' : \'\' }}\" ng-click=\"tabFilter(\'\')\">\n                        <span>All guests</span>\n                    </div>\n                    <div class=\"{{ selectedSelectFilter.type == \'ALL_PURCHASED\' ? \'active\' : \'\' }} show-if-ticketed\" ng-click=\"tabFilter(\'ALL_PURCHASED\')\">\n                        <span>Purchased</span>\n                    </div>\n                    <div class=\"{{ selectedSelectFilter.type == \'GOING\' ? \'active\' : \'\' }} show-if-nonticketed\" ng-click=\"tabFilter(\'GOING\')\">\n                        <span>Going</span>\n                    </div>\n                    <div class=\"{{ selectedSelectFilter.type == \'NOT_GOING\' ? \'active\' : \'\' }} show-if-nonticketed\" ng-click=\"tabFilter(\'NOT_GOING\')\">\n                        <span>Can\'t go</span>\n                    </div>\n                    <div class=\"{{ selectedSelectFilter.type == \'NOT_RESPONDED\' ? \'active\' : \'\' }}\" ng-click=\"tabFilter(\'NOT_RESPONDED\')\">\n                        <span>Not responded</span>\n                    </div>\n                </div> --><br><div class=guests-filter-buttons><div class=\"event-input event-date-input\"><label ng-if=event.ticketed>Filter list</label><label ng-if=!event.ticketed>Filter groups and classes</label><div class=is-relative><select ng-model=selectedSelectFilter.type ng-change=selectFilterChanged(selectedSelectFilter.type)><option value=\"\">All guests</option><option value=ALL_PURCHASED ng-if=event.ticketed>Purchased</option><option value=GOING ng-if=!event.ticketed>Going</option><option value=NOT_GOING ng-if=!event.ticketed>Can\'t go</option><option value=NOT_RESPONDED>Not responded</option><option ng-repeat=\"type in groups\" ng-if=\"type.id != -9\" value=\"g-{{ type.id }}\">{{ type.name }}</option><option ng-repeat=\"type in ticketTypes\" value=\"t-{{ type.id }}\">{{ type.name }}</option></select><span class=\"dripicons-chevron-down select-arrow\"></span></div></div><div ng-if=\"filteredItems && filteredItems.length > 0\" class=filter-buttons><button ng-if=canDownload() ng-click=downloadCSV() type=button class=\"btn btn-ghost\" style=\"margin-right: 6px\"><span translate=DOWNLOAD_LIST></span></button> <button ng-click=messageGuests() type=button class=\"btn btn-ghost\" style=\"margin-right: 6px\"><span translate=MESSAGE_GUESTS></span></button> <button ng-if=\"selectedSelectFilter.type == \'\' || selectedSelectFilter.type == \'NOT_RESPONDED\'\" ng-click=openResendInvites() type=button class=\"btn btn-ghost\"><span translate=RESEND_INVITE></span></button></div></div><div ng-if=\"groups && groups.length > 0 && selectedSelectFilter.type == \'\'\"><br><div class=manage-participants><ul class=basket style=margin:0><li ng-repeat=\"item in groups\"><header class=tier-header style=\"padding-right: 16px\">{{ item.name }}</header></li></ul></div></div><br><div class=guest-list><div ng-if=\"!gettingguests && !filteredItems || filteredItems.length == 0\" class=empty-guests-list><span translate=NO_GUESTS_FOUND></span></div><div ng-repeat=\"guest in (filteredItems = (guests | filterguests:selectedSelectFilter)) track by guest.id\"><div class=vi-row><div class=vi-col-left><figure style=\"float: left; width: 36px; height: 36px; margin-right: 10px\"><avatar source={{guest.avatar}} name=\"{{ guest.fullName }}\" width=36 height=36 my=false></avatar></figure></div><div class=vi-col-right><svg ng-click=expandGuest(guest) class=guest-item-arrow xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=24px height=24px viewBox=\"0 0 24 24\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><polyline data-cap=butt fill=none stroke=#444444 stroke-width=2 stroke-miterlimit=10 points=\"1,8 12,16 23,8 \" stroke-linejoin=miter stroke-linecap=butt></polyline></g></svg></div><div class=vi-col-middle><h4>{{ ::guest.fullName }}</h4><p ng-if=event.ticketed>{{ guest.ticketCount }} <span>tickets</span> <span ng-if=\"guest.totalAmount && guest.totalAmount != 0.0\">| <span translate=\"{{ guest.ticketCurrency }}_SHORT\"></span>{{ ::guest.totalAmount | currency: \"\" }}</span></p><p ng-if=!event.ticketed><span ng-if=guest.answer translate=\"LABEL_{{ guest.answer }}\" style=\"color: #777\"></span>&nbsp;</p></div></div><div ng-if=guest.expanded class=guest-details-container><label ng-if=!guest.data>Please wait...</label><div ng-if=guest.data><div class=details-pupils ng-if=\"guest.data && guest.data.pupils\"><div ng-repeat=\"p in guest.data.pupils\" class=vi-row style=\"overflow: auto\"><div class=vi-col-left style=\"width: 30px; padding-right: 7px\"><figure class=\"avatar {{p.gender}}\"><img src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid.svg alt=\"\" width=9 ng-if=\"p.gender === \'F\'\" draggable=false> <img src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid.svg alt=\"\" width=9 ng-if=\"p.gender === \'M\'\" draggable=false> <img src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid.svg alt=\"\" width=9 ng-if=\"p.gender === \'N\'\" draggable=false> <img src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid.svg alt=\"\" width=9 ng-if=\"p.gender === \'P\'\" draggable=false> <span class=nodata><img src=https://storage.googleapis.com/classlist-branding/app-assets/icon-pupil-no-data.svg alt=\"\" width=9 ng-if=\"!p.gender || p.genderId == 0\" draggable=false></span></figure></div><div class=vi-col-middle><p>{{ ::p.firstName }} {{ ::p.lastName }}<span ng-if=p.firstTierName>, {{ ::p.firstTierName }}</span><span ng-if=p.secondTierName>, {{ ::p.secondTierName }}</span></p></div></div></div><div class=details-pupils ng-if=\"guest.data && guest.data.publicGuest\"><div class=vi-row style=\"overflow: auto\"><div class=vi-col-left style=\"width: 30px; padding-right: 7px\"><svg style=\"opacity: .4; width: 23px; height: 16px; float: left\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><path fill=#444444 d=\"M15,1H1C0.448,1,0,1.447,0,2v12c0,0.553,0.448,1,1,1h14c0.552,0,1-0.447,1-1V2C16,1.447,15.552,1,15,1z M14,13H2V6.723l5.504,3.145c0.308,0.176,0.685,0.176,0.992,0L14,6.723V13z M14,4.42L8,7.849L2,4.42V3h12V4.42z\"></path></g></svg></div><div class=vi-col-middle><p style=\"margin-top: 0\">{{ ::guest.data.publicGuest.email }}</p></div></div><div ng-if=guest.data.publicGuest.phone class=vi-row style=\"overflow: auto\"><div class=vi-col-left style=\"width: 30px; padding-right: 7px\"><svg style=\"opacity: .4; width: 23px; height: 16px; float: left\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=24px height=24px viewBox=\"0 0 24 24\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><path d=M12,1A15.929,15.929,0,0,0,1,5.4V10H7V6H17v4h6V5.4A15.929,15.929,0,0,0,12,1Z fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></path><rect x=2 y=15 width=2 height=2 fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 data-color=color-2 stroke-linejoin=miter></rect><rect x=8 y=15 width=2 height=2 fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 data-color=color-2 stroke-linejoin=miter></rect><rect x=14 y=15 width=2 height=2 fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 data-color=color-2 stroke-linejoin=miter></rect><rect x=20 y=15 width=2 height=2 fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 data-color=color-2 stroke-linejoin=miter></rect><rect x=5 y=21 width=2 height=2 fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 data-color=color-2 stroke-linejoin=miter></rect><rect x=17 y=21 width=2 height=2 fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 data-color=color-2 stroke-linejoin=miter></rect><rect x=11 y=21 width=2 height=2 fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 data-color=color-2 stroke-linejoin=miter></rect></g></svg></div><div class=vi-col-middle><p style=\"margin-top: 0\">{{ ::guest.data.publicGuest.phone }}</p></div></div></div><div ng-if=\"guest && guest.data && guest.data.tickets\" style=\"padding-left: 2px\"><h4>Tickets</h4><div ng-repeat=\"ticket in guest.data.tickets track by $index\"><div class=ticket-header><span>1 x {{ ::ticket.name }}</span> <span ng-if=\"ticket.price && ticket.price > 0\">| <span translate=\"{{ ticket.currency }}_SHORT\"></span>{{ ::ticket.price | currency: \"\" }}</span> <span>| {{ ::ticket.purchaseDate | date: \'MMM d\' }}</span><div style=\"clear: both\"></div><div ng-if=\"ticket.price == 0\" ng-click=\"returnTicket(ticket.id, guest, $index)\" style=\"margin-top: 5px; text-align: left; margin-left: -8px\"><span class=\"icon dripicons-return\" style=\"color: #f06292; font-size: 14px\"></span><span translate=RETURN_TICKET style=\"font-size: 12px; margin-left: 5px; font-weight: bold; cursor: pointer; color: #f06292\"></span></div></div><div style=\"clear: both\"></div><div ng-if=ticket.questions><div class=ticket-questions style=\"margin-top: 10px\"><div ng-repeat=\"q in ticket.questions\" class=vi-row><div class=vi-col-middle><div><i>{{ ::q.title }}</i><b ng-if=q.deleted translate=DELETED></b></div><div ng-if=\"q.answer && q.answer.title\"><b>{{ ::q.answer.title }}</b> <span ng-if=q.answer.updatedOn style=\"float: left; width: 100%; color: #000; font-weight: bold; font-size: 12px\"><span translate=ANSWER_EDITED_ON></span><pan>{{ q.answer.updatedOn | date: \'h:mm a, MMM dd\' }}</pan></span></div></div></div></div></div></div></div></div></div></div></div></div></section></div></section>");
$templateCache.put("app/events/views/open-event-modal.html","<div><div class=modal-header><h3></h3></div><div class=modal-body><p translate=PUBLIC_EVENT_MODAL_TEXT_1></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=PUBLIC_EVENT_MODAL_TEXT_2 ng-click=confirm()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/events/views/open-raffle-modal.html","<div><div class=modal-header><h3></h3></div><div class=modal-body><p translate=PUBLIC_EVENT_MODAL_TEXT_3></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=PUBLIC_EVENT_MODAL_TEXT_2 ng-click=confirm()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/events/views/owners.html","<section class=\"event-tickets event-view event-create is-visible\"><div class=\"page-view-header clearfix\"><div><div class=row><div class=col-md-12><a id=header-back-button style=\"left: 10px!important\" class=page-view-header__back ng-click=back()><span class=dripicons-arrow-thin-left></span></a><div class=\"page-view-header__text pull-left\"><strong class=page-view-header__title translate=ADD_OWNERS_TITLE></strong></div></div></div></div></div><div class=body-container><div class=page-container-header-from-top style=\"margin-top: 0!important\"><div class=mobile-row-fix><section class=event-section><h1 translate=ADD_OWNERS_TITLE></h1><p translate=ADD_OWNERS_TEXT></p><br><div><div class=event-input><label translate=SEARCH_REP_LABEL></label><input ng-model=searchInput type=text placeholder=\"{{\'CLEAR_REP_NAME\' | translate }}\"></div></div><br><div class=rep-list><div ng-repeat=\"rep in rep_list | filter:filterReps\" ng-click=selectRep(rep)><div class=vi-row><div class=vi-col-left style=\"width: 55px\"><figure ui-sref=\"classlist.details.contact({ \'id\': guest.userId })\" style=\"float: left; height: 40px; margin-right: 10px\"><avatar source={{rep.avatar}} name=\"{{ rep.name }}\" width=40 height=40 my=false></avatar></figure></div><div class=vi-col-middle><h4>{{ rep.name }}</h4></div></div></div></div></section></div></div></div></section>");
$templateCache.put("app/events/views/payment-fail-modal.html","<div style=\"padding: 20px\"><div class=modal-header><h3 translate=PAYMENT_FAIL_HEADER></h3></div><div class=modal-body><p translate=PAYMENT_FAIL_TEXT></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=TRY_AGAIN_BTN ng-click=close()></div></div>");
$templateCache.put("app/events/views/payment-success-modal.html","<div style=\"padding: 20px\"><div class=modal-header><h3 translate=PAYMENT_SUCCESS_HEADER></h3></div><div class=modal-body><p translate=YOU_PURCHASED_TICKETS_FOR translate-values=\"{ \'eventName\': event.title, \'ticketsCount\': getTicketsCount(cofirmed_tickets.tickets) }\"></p><div class=tickets-list-modal ng-show=cofirmed_tickets.tickets><div class=\"row header\"><div class=\"col-md-6 col-xs-12 col-sm-12\"><span translate=TYPE></span></div><div class=\"col-md-2 col-xs-4 col-sm-4\"><span translate=PRICE></span></div><div class=\"col-md-2 col-xs-4 col-sm-4\"><span translate=QUANTITY></span></div><div class=\"col-md-2 col-xs-4 col-sm-4 align-right\"><span translate=TOTAL></span></div></div><div class=row ng-repeat=\"ticket in cofirmed_tickets.tickets\"><div class=\"col-md-6 col-xs-12 col-sm-12\"><span>{{ ticket.ticketTypeName }}</span></div><div class=\"col-md-2 col-xs-4 col-sm-4\"><span ng-show=cofirmed_tickets.currency translate={{cofirmed_tickets.currency}}_SHORT></span><span>{{ ticket.price | currency: \"\" }}</span></div><div class=\"col-md-2 col-xs-4 col-sm-4\"><span>{{ ticket.quantity }}</span></div><div class=\"col-md-2 col-xs-4 col-sm-4 align-right\"><span ng-show=cofirmed_tickets.currency translate={{cofirmed_tickets.currency}}_SHORT></span><span>{{ ticket.total | currency: \"\" }}</span></div></div><div class=total-label><div class=align-right><span ng-show=cofirmed_tickets.currency translate={{cofirmed_tickets.currency}}_SHORT></span><span>{{ cofirmed_tickets.total | currency: \"\" }}</span></div></div></div><br><div><a class=downtickets-link ng-click=downloadTickets(event.id)><span class=\"icon dripicons-download\"></span> <span translate=DOWNLOAD_TICKETS></span></a></div><br><br><div translate=PAYMENT_SUCCESS_TEXT_1></div></div><div class=modal-footer><button type=button class=\"btn btn-default pull-right\" translate=OK_BTN ng-click=close()></div></div>");
$templateCache.put("app/events/views/publish-invites-modal.html","<div><div class=modal-header><svg ng-click=close() class=close-modal-icon xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><path fill=#444444 d=\"M14.7,1.3c-0.4-0.4-1-0.4-1.4,0L8,6.6L2.7,1.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4L6.6,8l-5.3,5.3 c-0.4,0.4-0.4,1,0,1.4C1.5,14.9,1.7,15,2,15s0.5-0.1,0.7-0.3L8,9.4l5.3,5.3c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3 c0.4-0.4,0.4-1,0-1.4L9.4,8l5.3-5.3C15.1,2.3,15.1,1.7,14.7,1.3z\"></path></g></svg><h3 translate=PUBLISH_AND_SEND_INVITES></h3></div><div class=modal-body><p translate=PUBLISH_AND_SEND_INVITES_TEXT translate-values=\"{\'name\':fullname}\"></p></div><div class=modal-footer><button type=button ng-disabled=publishing class=\"btn btn-primary pull-right\" translate=PUBLISH_AND_SEND_INVITES_TEXT_2 ng-click=publishWith() style=\"margin-left: 10px; margin-bottom: 10px\"><button type=button ng-disabled=publishing class=\"btn btn-ghost pull-right\" translate=PUBLISH_AND_SEND_INVITES_TEXT_1 ng-disabled=adding ng-click=puslishWithout() style=\"margin-bottom: 10px\"></div></div>");
$templateCache.put("app/events/views/publish-rota-modal.html","<div><div class=modal-header><h3 translate=PUBLISH_ROTA_HEADER></h3></div><div class=modal-body><p translate=PUBLISH_ROTA_TEXT></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" ng-disabled=publishingrota translate=PUBLISH_BTN ng-click=save()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/events/views/publish-rota-no-tasks.html","<div><br><div class=modal-body><p translate=ROTA_PUBLISH_NO_TASKS></p></div><div class=modal-footer><button type=button class=\"btn btn-default pull-right\" translate=BACK_BTN ng-click=close()></div></div>");
$templateCache.put("app/events/views/remove-owner-modal.html","<div><div class=modal-header><h3 translate=REMOVE_OWNER_HEADER></h3></div><div class=modal-body><p translate=REMOVE_OWNER_TEXT translate-values=\"{\'name\':fullname}\"></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=OK_BTN ng-disabled=removing ng-click=remove()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=cancel()></div></div>");
$templateCache.put("app/events/views/remove-parent-rota-modal.html","<div><div class=modal-header><h3 translate=REMOVE_VOLUNTEER_HEADER></h3></div><div class=modal-body><p translate=REMOVE_VOLUNTEER_TEXT></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" ng-disabled=removingvolunteer translate=YES_REMOVE ng-click=save()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/events/views/remove-ticket-type-modal.html","<div style=\"padding: 15px\"><div class=modal-header><h3 translate=CONFIRM_REMOVE_TICKET_TYPE_HEADER></h3></div><div class=modal-body><p translate=CONFIRM_REMOVE_TICKET_TYPE_TEXT></p></div><div class=modal-footer><button type=button class=\"btn btn-ghost pull-right\" translate=REMOVE_BTN ng-click=confirm()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=cancel()></div></div>");
$templateCache.put("app/events/views/return-ticket-modal.html","<div style=padding:20px><div class=modal-header><h3 translate=RETURN_TICKET_HEADER></h3></div><div class=modal-body><p translate=RETURN_TICKET_CONTENT></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=YES_CANCEL_BTN ng-click=continue()><button type=button class=\"btn btn-default pull-right\" translate=NO_THANKS_BTN ng-click=close()></button></button></div></div>");
$templateCache.put("app/events/views/rota-details.html","<section class=\"rota-container event-view event-create\" ng-class=\"{\'is-visible\': viewState.isReady}\"><div class=\"page-view-header clearfix\" style=\"margin-bottom: -1px\"><div><div><div><a id=header-back-button style=\"float: left; margin-right: 10px; position: relative\" class=page-view-header__back ng-click=decideGoBack()><span class=dripicons-arrow-thin-left></span></a></div></div></div></div><div class=body-container><div class=page-container-header-from-top style=\"margin-top: 0!important\"><div class=mobile-row-fix><section class=event-section><div class=body-container><h1 style=\"float: left;padding-top:15px\">{{ rota.title }}</h1><button ng-click=openRota(rota) type=button class=\"btn btn-ghost\" style=\"float: right\"><span>Edit</span></button></div><br><br><br><p ng-if=rota.description>{{ rota.description }}</p><br><div ng-if=\"taskList && taskList.length > 0 && taskList[0].id\"><div><button ng-click=downloadCSV() type=button ng-disabled=\"!rota.enabled || !canSendMessage\" class=\"btn btn-ghost\"><span translate=DOWNLOAD_CSV_LIST></span></button> <button ng-if=\"event.status != \'DRAFT\'\" ng-disabled=\"!rota.enabled || !canSendMessage\" ng-click=\"messageGuests(\'all\')\" type=button class=\"btn btn-ghost\" style=\"margin-left: 6px\"><span translate=SEND_A_NOTE></span></button></div><br></div><h4 translate=TASKS_AND_SLOTS></h4><div ng-if=\"!taskList || taskList.length == 0\"><span style=\"font-size: 16px; opacity: .6; padding: 10px 0\" translate=NO_TASKS_AVAILABLE></span></div><div ng-if=\"taskList && taskList.length > 0\" class=rota-tasks-list><div ng-repeat=\"task in taskList\"><div><h2>{{ task.title }}</h2><p ng-if=task.description>{{ task.description }}</p></div><div class=\"rota-slots-list expanded {{ task.expanded ? \'expanded\' : \'\' }}\"><div ng-repeat=\"slot in task.slots\" style=\"{{ slot.volunteers && slot.volunteers.length > 0 ? \'margin-bottom: 14px;\' : \'\' }}\"><div class=\"slot-item {{ slot.slotVolunteerCount == (slot.volunteers.length || 0) ? \'full\' : \'available\' }} {{ slot.volunteers && slot.volunteers.length > 0 ? \'slot-booked\' : \'\' }}\"><div class=vi-row><div class=\"vi-col-left rota-slot-timer\"><div><p><span ng-if=\"task.slotLength != 0\">{{ getUTCDatetime(slot.startDate) | date: \'HH:mm\' }}</span> <span ng-if=\"task.slotLength == 0\">-- : --</span></p><p><span ng-if=\"task.slotLength != 0\">{{ getUTCDatetime(slot.endDate) | date: \'HH:mm\' }}</span> <span ng-if=\"task.slotLength == 0\">-- : --</span></p></div></div><div class=vi-col-middle><div style=\"padding-left: 3px\"><div style=\"display: inline-block\"><div class=available-slots-count><p>{{ (slot.slotVolunteerCount - (slot.volunteers.length || 0)) }} / {{ ::slot.slotVolunteerCount }}</p><label translate=SPACES></label></div><div class=full-slots-count><p translate=FULL></p></div></div></div></div></div></div><div class=slot-volunteer><div ng-repeat=\"volunteer in slot.volunteers\" class=vi-row><div class=vi-col-left style=\"width: 40px; padding-right: 0\"><figure style=\"float: left; width: 30px; height: 30px; margin-right: 10px\"><avatar source={{volunteer.avatar}} name=\"{{ volunteer.firstName }} {{ volunteer.lastName }}\" width=30 height=30 my=false></avatar></figure></div><div class=vi-col-right><svg class=remove-volunteer-icon ng-click=\"removeVolunteer(slot, volunteer, $index)\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=16px height=16px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><path fill=#444444 d=\"M14.7,1.3c-0.4-0.4-1-0.4-1.4,0L8,6.6L2.7,1.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4L6.6,8l-5.3,5.3 c-0.4,0.4-0.4,1,0,1.4C1.5,14.9,1.7,15,2,15s0.5-0.1,0.7-0.3L8,9.4l5.3,5.3c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3 c0.4-0.4,0.4-1,0-1.4L9.4,8l5.3-5.3C15.1,2.3,15.1,1.7,14.7,1.3z\"></path></g></svg></div><div class=vi-col-middle><div style=\"padding-left: 3px; {{ volunteer.comment ? \'line-height: 20px;\' : \'\' }}\"><b><a href=\"#/users/parent-detail/{{ volunteer.userId }}\">{{ ::volunteer.firstName }} {{ ::volunteer.lastName }}</a></b></div><div style=\"line-height: 20px\"><i>{{ ::volunteer.comment }}</i></div></div></div></div><div ng-if=slot.booked class=slot-comment><div class=event-input><!-- <label>Add a comment</label> --><textarea id=event-description ng-model=slot.comment maxlength=200 autoresize-textarea placeholder=\"Add a comment\"></textarea></div></div></div></div></div><br></div></section></div></div></div></section>");
$templateCache.put("app/events/views/rota.html","<section class=\"rota-container event-view event-create\" ng-class=\"{\'is-visible\': viewState.isReady}\"><div class=\"page-view-header clearfix\" style=\"margin-bottom: -1px\"><div><div><div><a id=header-back-button style=\"float: left; margin-right: 10px; position: relative\" class=page-view-header__back ng-click=decideGoBack()><span class=dripicons-arrow-thin-left></span></a></div></div></div></div><div class=body-container><div class=page-container-header-from-top style=\"margin-top: 0!important\"><div class=mobile-row-fix><section class=event-section><div class=rota-header><div style=\"float: left\"><h1 ng-if=!_rota.id translate=CREATE_NEW_ROTA></h1><h1 ng-if=_rota.id class=rota-title-status style=\"overflow: hidden\"><span translate=VOLUNTEER_ROTA></span> <span ng-if=_rota.enabled class=event-live-label translate=LIVE></span> <span ng-if=\"!_rota || !_rota.enabled\" class=event-live-label style=\"background-color: #b6c2db\" translate=DRAFT></span></h1><p translate=CREATE_NEW_ROTA_DESCR></p></div></div><div ng-if=_rota.id><div ng-click=deleteRota() style=\"float: right\"><span class=\"dripicons-trash icon\"></span></div></div><div><div class=\"event-input {{ (!_rota.title && _rota.touched) ? \'invalid-input-label\' : \'\' }}\"><label translate=ROTA_TITLE></label><input ng-model=_rota.title maxlength=200 type=text placeholder=\"{{\'ROTA_TITLE_INPUT\' | translate }}\"><div class=event-wrong-input>Please add a title to your sign-up list.</div></div></div><br><div><div class=event-input><label translate=ROTA_DESCR></label><textarea id=event-description maxlength=1500 ng-model=_rota.description autoresize-textarea placeholder=\"{{\'ROTA_DESCR_INPUT\' | translate }}\"></textarea></div></div><br><div class=create-event-dates><div><div class=\"event-input event-date-input\"><label translate=ROTA_DATE></label><div class=is-relative style=\"width: 100%\"><input type=text class=ev-date-input uib-datepicker-popup=\"EEE, dd MMM yyyy\" ng-model=rotaDate show-button-bar=false is-open=popupRotaDate.opened datepicker-options=dateOptions ng-required=true style=\"width: 100%\"> <span class=\"select-arrow date-picker-icon\"><button type=button class=\"btn btn-default\" ng-click=pickRotaDate()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=event-wrong-input translate=\"{{ hasDateError(\'RSVPDATE_CANNOT_BEFORE_TODAY\') }}\"></div><div class=event-wrong-input translate=\"{{ hasDateError(\'RSVPDATE_CANNOT_BEFORE_STARTDATE\') }}\"></div><div class=event-wrong-input translate=\"{{ hasDateError(\'RSVPDATE_CANNOT_AFTER_ENDDATE\') }}\"></div></div></div><br><div><h1 style=\"overflow: auto; font-size: 16px; line-height: 24px\"><span translate=ROTA_TIME_BASED style=\"float: left; margin-right: 10px\"></span><div class=pull-left><div ng-click=switchTimeBased() ng-model=_rota.timeBased class=\"mobile-checkmark {{ _rota.timeBased ? \'enabled\' : \'\' }}\" style=\"{{ _rota.id ? \'opacity: .3\' : \'\' }}\"><div></div></div></div></h1></div><br><div ng-if=_rota.timeBased>Tasks will be repeated between your start and end times.</div><div ng-if=_rota.timeBased class=create-event-dates style=\"margin-top: 20px\"><div><div class=\"event-input event-date-input\"><div class=\"is-relative rota-input\"><label translate=ROTA_START_TIME></label></div><div class=\"is-relative rota-input-right\"><label translate=ROTA_END_TIME></label></div></div><div class=\"event-input event-date-input\"><div class=\"is-relative rota-input\"><select ng-model=_rota.startTime class=ev-time-input style=\"width: 100%\"><option ng-repeat=\"time in eventTimes\" value=\"{{ time.value }}\">{{ time.text }}</option></select><span class=\"dripicons-chevron-down select-arrow\"></span></div><div class=\"is-relative rota-input-right\"><select ng-model=_rota.endTime class=ev-time-input style=\"width: 100%\"><option ng-repeat=\"time in eventTimes\" value=\"{{ time.value }}\">{{ time.text }}</option></select><span class=\"dripicons-chevron-down select-arrow\"></span></div></div></div></div><div style=\"clear: both\"></div><div ng-if=_rota.timeBased class=create-event-dates style=\"margin-top: 20px\"><div><div class=\"event-input event-date-input\"><label translate=ROTA_HOW_LONG_IS_SLOT></label><div class=is-relative style=\"width: 100%; float: left\"><select ng-model=_rota.slotLength class=ev-time-input style=\"width: 100%\"><option ng-repeat=\"time in slotTimes\" value=\"{{ time.value }}\">{{ time.text }}</option></select><span class=\"dripicons-chevron-down select-arrow\"></span></div></div></div></div><div><h1 style=\"overflow: auto; font-size: 18px; line-height: 24px; margin-top: 20px\"><span translate=ROTA_HOW_LONG_IS_SLOT_BELOW style=\"float: left; margin-right: 16px\"></span></h1></div><div style=\"text-align: right; border-top: 1px solid #e5e5e5; margin-top: 30px; padding-top: 30px\"><button ng-click=saveRota(false) ng-disabled=savingrota type=button class=\"btn btn-primary\"><span ng-if=\"_rota && !_rota.id\" translate=NEXT_BTN></span> <span ng-if=\"_rota && _rota.id > 1\" translate=UPDATE_BTN></span></button></div></section><section ng-if=_rota.id class=event-section><h1 translate=ROTA_TASKS></h1><p translate=ROTA_TASKS_DESCR></p><br><div ng-if=\"taskList && taskList.length > 0 && taskList[0].id\"><div><button ng-click=downloadCSV() type=button class=\"btn btn-ghost\"><span>Download list</span></button> <button ng-click=taskDetailsAll() type=button class=\"btn btn-ghost\" style=\"margin-left: 6px\"><span>Expand all</span></button></div><br></div><div ng-if=\"taskList && taskList.length > 0\" class=rota-tasks-list><div ng-repeat=\"task in taskList\"><div ng-if=!task.id><h2 translate=ROTA_NEW_TASK></h2><br></div><div ng-click=removeTask(task) style=\"float: right\"><span class=\"dripicons-trash icon\"></span></div><div><div class=\"event-input {{ (!task.title && task.touched) ? \'invalid-input-label\' : \'\' }}\"><label translate=ROTA_TASK_TITLE></label><input ng-model=task.title maxlength=200 ng-keypress=\"task.touched = false;\" type=text placeholder=\"{{\'ROTA_TASK_TITLE_INPUT\' | translate }}\"><div class=event-wrong-input>Task title can not be empty</div></div></div><br><div><div class=event-input><label translate=ROTA_TASK_DESCR></label><textarea id=event-description maxlength=1500 ng-model=task.description autoresize-textarea placeholder=\"{{\'ROTA_TASK_DESCR_INPUT\' | translate }}\"></textarea></div></div><div ng-if=_rota.timeBased style=\"overflow: auto\"><br><div class=\"event-input event-date-input {{ (!task.slotLength && task.touched) ? \'invalid-input-label\' : \'\' }}\"><label translate=ROTA_HOW_LONG_IS_SLOT></label><div class=is-relative style=\"width: 30%; float: left\"><select ng-model=task.slotLength class=ev-time-input style=\"width: 100%\"><option ng-repeat=\"time in slotTimes\" value=\"{{ time.value }}\">{{ time.text }}</option></select><span class=\"dripicons-chevron-down select-arrow\"></span></div><br><div class=event-wrong-input style=\"width: 100%\">Select time per slot</div></div></div><br><div style=\"overflow: auto\"><div class=\"event-input {{ (!task.volunteerCount && task.touched) ? \'invalid-input-label\' : \'\' }}\"><label translate=ROTA_HOW_MANY_VOLUNTEERS></label><div class=is-relative style=\"width: 30%; float: left; padding-bottom: 5px\"><select ng-model=task.volunteerCount class=ev-time-input style=\"width: 100%\"><option ng-repeat=\"x in [].constructor(50) track by $index\" value=\"{{$index + 1}}\">{{$index + 1}}</option></select><span class=\"dripicons-chevron-down select-arrow\"></span></div><br><div><label translate=ROTA_HOW_MANY_VOLUNTEERS_DESC style=color:grey></label></div><br><div class=event-wrong-input style=\"width: 100%\">Select the volunteers count</div></div></div><br><div style=\"text-align: right\"><button ng-if=task.id ng-click=taskDetails(task) type=button class=\"btn btn-ghost\" style=\"margin-right: 6px\"><span>Details</span></button> <button ng-disabled=task.saving ng-if=task.id ng-click=saveTask(task) type=button class=\"btn btn-primary\"><span>Update</span></button> <button ng-if=!task.id ng-click=\"deleteTask(task, $index)\" type=button class=\"btn btn-ghost\" style=\"margin-right: 6px\"><span>Delete</span></button> <button ng-disabled=task.saving ng-if=!task.id ng-click=saveTask(task) type=button class=\"btn btn-primary\"><span>Save</span></button></div></div><br></div><div><button ng-click=createTask() type=button class=\"btn btn-ghost\"><span translate=CREATE_NEW_TASK></span></button></div></section><div ng-if=_rota.id class=\"event-main-buttons event-publish-button\" style=\"margin-top: 22px;text-align:right\"><button ng-if=!_rota.enabled ng-click=saveRota(true) ng-disabled=savingrota type=button class=\"btn btn-ghost\" style=\"margin-right: 6px\"><span>Save draft</span></button> <button ng-if=!_rota.enabled ng-click=publishRota() type=button class=\"btn btn-primary\"><span translate=PUBLISH_ROTA></span></button> <button ng-if=_rota.enabled ng-click=unpublishRota() type=button class=\"btn btn-ghost\"><span translate=UNPUBLISH_ROTA></span></button></div><div ng-if=\"(event.status == \'ACTIVE\' || event.status == \'DRAFT\') && id_rota && _rota && !_rota.enabled\" class=\"event-main-buttons event-publish-button\" style=\"margin-top: 10px; padding-bottom:15px; display: inline-flex;text-align:left; float:right;max-width: 255px\"><span class=\"icon dripicons-information\" style=\"padding-right: 10px\"></span><div ng-if=\"event.status == \'ACTIVE\'\"><span translate=ACTIVE_EVENT_NEW_ROTA_TITLE style=\"font-weight: bold\"></span><br><span translate=ACTIVE_EVENT_NEW_ROTA_INFO></span></div><div ng-if=\"event.status == \'DRAFT\'\"><span translate=DRAFT_EVENT_NEW_ROTA_TITLE style=\"font-weight: bold\"></span><br><span translate=DRAFT_EVENT_NEW_ROTA_INFO></span></div></div></div></div></div></section>");
$templateCache.put("app/events/views/send-notification-modal.html","<div><div class=modal-header><h3 translate=SEND_NOTIFICATION_HEADER></h3></div><div class=modal-body><div><textarea ng-model=notif_note autoresize-textarea placeholder=\"Type your message here\" style=\"border: 1px solid #838383; padding: 10px; width: 100%\" maxlength=2000></textarea><div class=counter>{{ 2000 - notif_note.length }} / 2000</div></div><br><p translate=SEND_GUEST_NOTIFICATION_TEXT></p><div class=manage-participants><ul class=basket><li ng-repeat=\"item in groups\"><header class=tier-header style=\"padding-right: 16px\">{{ item.value }} <a ng-if=\"groups.length > 1\" ng-click=removeGroup(item) style=\"margin-right: -16px\"><span class=dripicons-cross></span></a></header></li></ul></div></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=SEND_BTN ng-click=send() ng-disabled=\"!notif_note || sendingNotification\"><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/events/views/send-reminder-modal.html","<div style=\"padding: 15px\"><div class=modal-header><h3 translate=SEND_REMINDER_TITLE></h3></div><div class=modal-body><p translate=SEND_REMINDER_DESCR></p><div class=manage-participants><ul class=basket><li ng-repeat=\"item in groups\"><header class=tier-header style=\"padding-right: 16px\">{{ item.value }} <a ng-if=\"groups.length > 1\" ng-click=removeGroup(item) style=\"margin-right: -16px\"><span class=dripicons-cross></span></a></header></li></ul></div></div><div class=modal-footer style=\"padding-top: 0\"><button type=button class=\"btn btn-primary pull-right\" translate=SEND_BTN ng-click=send()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/events/views/send-signup-message-notification-modal.html","<div><div class=modal-header><h3 translate=SEND_YOUR_NOTE_TO_GUESTS></h3></div><div class=modal-body><div><textarea ng-model=notif_note autoresize-textarea placeholder=\"Type your message here\" style=\"border: 1px solid #838383; padding: 10px; width: 100%\" maxlength=2000></textarea><div class=counter>{{ 2000 - notif_note.length }} / 2000</div></div><br><p ng-if=\"messageTaskList.length == 1\" translate=SEND_SIGNUP_GUEST_NOTIFICATION_TEXT translate-values=\"{\'name\':rota.title}\"></p><div ng-if=\"messageTaskList.length > 1\" class=\"manage-participants message-box\"><label><input type=radio name=recipients ng-value=false ng-model=enableSelectList ng-change=changeGuestType(enableSelectList)> <span translate=ALL_ON_THIS_SIGNUP></span></label><br><label style=padding-top:5px><input type=radio name=recipients ng-value=true ng-model=enableSelectList ng-change=changeGuestType(enableSelectList)> <span translate=SELECT_RECIPIENTS></span></label><br><br><span translate=BY_TASK style=\"font-weight: bold\"></span><div class=tasks><div ng-repeat=\"item in messageTaskList\" class=checked-border><input id=task-{{item.id}} name=task-{{item.id}} type=checkbox value={{item.id}} ng-disabled=!enableSelectList ng-checked=item.selected ng-click=changeTaskStatus(item)><label for=task-{{item.id}}>{{ item.title }}</label></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=SEND_BTN ng-click=send() ng-disabled=\"!notif_note || sendingNotification || !canSendMessage\"><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/events/views/shared-event-paypal-warning-modal.html","<div style=\"padding: 15px\"><div class=modal-body><p translate=SHARING_TURN_OFF></p></div><div class=modal-footer><button type=button class=\"btn btn-ghost pull-right\" translate=USE_PAYPAL ng-click=continue()><button type=button class=\"btn btn-default pull-right\" translate=USE_STRIPE ng-click=cancel()></button></button></div></div>");
$templateCache.put("app/events/views/start.html","<section class=\"event-view event-create is-visible\"><div class=\"page-view-header clearfix\"><div><div class=pull-left><a id=header-back-button class=page-view-header__back ng-click=back(redirectPages) style=\"float: left; margin-right: 10px; position: relative\"><span class=dripicons-arrow-thin-left></span></a> <strong class=page-view-header__title>Create new community event</strong></div></div></div><div class=page-container-header-from-top><div class=mobile-row-fix><div><div ng-if=showFromParentInfo style=\"margin-top: 20px\"><div class=yellow-tooltip style=\"margin-bottom: 0\"><span ng-click=closeInfo() class=dripicons-cross></span><div><span translate=EVENTS_FROM_PARENT_INFO_1></span><br><span><a target=_blank href=https://help.classlist.com/hc/en-us/articles/211635749-Community-Events-overview translate=EVENTS_FROM_PARENT_INFO_2></a> <a ng-click=dismissInfo() translate=EVENTS_FROM_PARENT_INFO_3 style=\"float: right\"></a></span></div></div><br></div><section class=event-section><h1 translate=EVENT_DETAILS></h1><p translate=EVENT_DETAILS_DESCR></p><ul class=event-start-desc><li style=\"color:#4D5055 !important; font-size: 16px\"><span translate=EVENT_DETAILS_DESCR_OPTION_TEXT></span> <a ng-click=openHowToTryModal() translate=EVENT_DETAILS_DESCR_OPTION_TEXT_LINK></a></li></ul><br><div><div id=cue-event-name class=\"event-input {{ (errorMessage == \'TITLE_CANNOT_BE_NULL\' || errorMessage == \'TITLE_LENGTH_ERROR\') ? \'invalid-input-label\' : \'\' }}\"><label translate=EVENT_NAME></label><input ng-model=event.title ng-keydown=\"errorMessage = false;\" maxlength=200 type=text placeholder=\"{{\'CLEAR_EVENT_NAME\' | translate }}\"><div class=event-wrong-input translate=\"{{ errorMessage }}\"></div></div></div><br><div id=cue-event-date class=create-event-dates><div class=\"event-start-date-input-container {{ (errorMessage == \'STARTDATE_CANNOT_BE_NULL\' || errorMessage == \'STARTDATE_CANNOT_BEFORE_TODAY\' || errorMessage == \'STARTDATE_CANNOT_AFTER_ENDDATE\') ? \'invalid-input-label\' : \'\' }}\"><div class=\"event-input event-date-input\"><label translate=EVENT_STARTS></label><div class=is-relative style=\"width: 60%\"><input readonly type=text class=ev-date-input uib-datepicker-popup=\"EEE, dd MMM yyyy\" ng-model=startDate show-button-bar=false is-open=popupStartDate.opened datepicker-options=dateOptions ng-required=true style=\"width: 100%\"> <span class=\"select-arrow date-picker-icon\"><button type=button class=\"btn btn-default\" ng-click=pickStartDate()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=is-relative style=\"width: 35%; float: left\"><input ng-flatpickr fp-opts=startTimeOpts fp-on-setup=startDateTimePostSetup(fpItem) ng-model=startDateTime id=eventStartDateTime></div></div><div class=event-wrong-input translate=\"{{ errorMessage }}\"></div></div><div class=\"event-end-date-input-container {{ (errorMessage == \'ENDDATE_CANNOT_BE_NULL\' || errorMessage == \'ENDDATE_CANNOT_BEFORE_TODAY\' || errorMessage == \'ENDDATE_CANNOT_BEFORE_STARTDATE\') ? \'invalid-input-label\' : \'\' }}\"><div class=\"event-input event-date-input\"><label translate=EVENT_ENDS></label><div class=is-relative style=\"width: 60%\"><input readonly type=text class=ev-date-input uib-datepicker-popup=\"EEE, dd MMM yyyy\" ng-model=endDate show-button-bar=false is-open=popupEndDate.opened datepicker-options=dateOptions ng-required=true style=\"width: 100%\"> <span class=\"select-arrow date-picker-icon\"><button type=button class=\"btn btn-default\" ng-click=pickEndDate()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=is-relative style=\"width: 35%; float: left\"><input ng-flatpickr fp-opts=endTimeOpts fp-on-setup=endDateTimePostSetup(fpItem) ng-model=endDateTime id=eventEndDateTime></div></div><div class=event-wrong-input translate=\"{{ errorMessage }}\"></div></div></div><br><br><div style=\"text-align: right\"><button ng-click=back() type=button class=\"btn btn-ghost\" style=\"margin-right: 10px\"><span translate=CANCEL_BTN></span></button> <button ng-disabled=saving type=button class=\"btn btn-primary\" ng-click=save()><span translate=SAVE_AND_CONTINUE></span></button></div><br><div class=empty-space-container><p translate=\" EVENT_EDIT \"></p></div></section></div></div></div></section>");
$templateCache.put("app/events/views/stopdownload-modal.html","<div><br><div class=modal-body><p translate=STOPDOWNLOAD_GUESTS_TEXT_1></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=OK_BTN ng-click=close()></div></div>");
$templateCache.put("app/events/views/stripe-connect-info-modal.html","<div style=\"padding: 15px\"><div class=modal-header><h3 translate=HOW_TO_CONNECT_STRIPE_MODAL_TITLE></h3></div><div class=modal-body><p translate=HOW_TO_CONNECT_STRIPE_MODAL_DESCRIPTION style=color:#001031 class=event-stripe-howto-try-description></p></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=OK_BTN></span></button></div></div>");
$templateCache.put("app/events/views/ticket-question-delete-warning.html","<div style=\"padding: 15px\"><div class=modal-header><h3 translate=EVENTS_QUESTION_DELETE_MODAL_TITLE></h3></div><div class=modal-body><p translate=EVENTS_QUESTION_DELETE_MODAL_TITLE_DESC></p></div><div class=modal-footer><button type=button class=\"btn btn-ghost pull-right\" translate=DELETE_BTN ng-click=continue()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=cancel()></button></button></div></div>");
$templateCache.put("app/events/views/ticket-question-update-warning.html","<div style=\"padding: 15px\"><div class=modal-header><h3 translate=EVENTS_QUESTION_UPDATE_MODAL_TITLE></h3></div><div class=modal-body><p translate=EVENTS_QUESTION_UPDATE_MODAL_TITLE_DESC></p></div><div class=modal-footer><button type=button class=\"btn btn-ghost pull-right\" translate=CONTINUE_BTN_3 ng-click=continue()><button type=button class=\"btn btn-default pull-right\" translate=NO_GO_BACK ng-click=cancel()></button></button></div></div>");
$templateCache.put("app/events/views/ticket-type-edit-warning-modal.html","<div style=\"padding: 15px\"><div class=modal-body><p translate=EDIT_TICKET_TYPE_WARNING></p></div><div class=modal-footer><button type=button class=\"btn btn-ghost pull-right\" translate=ADD_NEW_TICKET_BTN ng-click=addNewTicket()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=cancel()></button></button></div></div>");
$templateCache.put("app/events/views/ticket-type-no-provider-modal.html","<div style=\"padding: 15px\"><div class=modal-body><p translate=TICKET_TYPE_NO_PROVIDER></p></div><div class=modal-footer><button type=button class=\"btn btn-ghost pull-right\" translate=CONTINUE_ANYWAY ng-click=continue()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=cancel()></button></button></div></div>");
$templateCache.put("app/events/views/ticketed-empty-modal.html","<div style=\"padding: 15px\"><div class=modal-header><h3 translate=TICKETED_EMPTY_HEADER></h3></div><div class=modal-body><p translate=TICKETED_EMPTY_TEXT></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=TICKETED_EMPTY_TEXT_2 ng-click=_continue() style=\"margin-left: 10px\"><button type=button class=\"btn btn-ghost pull-right\" translate=TICKETED_EMPTY_TEXT_1 ng-click=_addTickets()></div></div>");
$templateCache.put("app/events/views/tickets.html","<section class=\"event-tickets event-view event-create\" ng-class=\"{\'is-visible\': viewState.isReady }\"><div class=\"page-view-header clearfix\"><div><div class=row><div class=col-md-12><a id=header-back-button style=\"left: 10px!important\" class=page-view-header__back ng-click=goBack()><span class=dripicons-arrow-thin-left></span></a></div></div></div></div><div class=body-container><div class=page-container-header-from-top style=\"margin-top: 0!important\"><div class=mobile-row-fix><section class=event-section><h1 translate=EVENTS_ADD_TICKETS></h1><p translate=EVENTS_ADD_TICKETS_DESCR></p><br><div class=row><div class=col-md-12><label translate=TICKET_CURRENCY class=\"ng-scope ticketlabel\"></label><div class=\"is-relative select-form left currencyselect\"><select ng-disabled=isUpdating ng-model=ticketCurrency class=form-control required><option ng-repeat=\"option in availableCurrencies\" value={{option.id}}>{{option.id}} ({{option.asciiSymbol}})</option></select><span class=\"dripicons-chevron-down select-arrow\"></span></div><div class=event-wrong-input translate=SELECT_TICKET_CURRENCY></div></div></div><div class=\"row mt20\"><div class=col-md-12 ng-show=\"tickets.length !== 0\"><div class=ticket-container><div class=ticket-name><span class=text translate=DESCRIPTION></span></div><div class=quantity><span translate=QUANTITY></span></div><div class=price><span translate=PRICE></span></div><div class=order></div><div class=dotsmenu><nav class=\"has-dropdown is-relative pull-right mobile-menu\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\"></svg></nav></div></div><div class=ticket-container ng-repeat=\"t in tickets track by $index\"><div class=ticket-name><span class=text>{{t.ticketName}}</span></div><div class=quantity ng-if=\"t.ticketType !== \'DONATION\'\"><span>{{t.sold || \'0\'}}/{{t.availableTicket}}</span></div><div class=quantity ng-if=\"t.ticketType === \'DONATION\'\"><span>Unlimited</span></div><div class=price ng-if=\"t.ticketType !== \'FREE\'\"><span ng-show=\"ticketCurrency && !!t.ticketPrice\" translate=\"{{ ticketCurrency }}_SHORT\"></span><span>{{t.ticketPrice | currency: \'\'}}</span></div><div class=price ng-if=\"t.ticketType === \'FREE\'\"><span>Free</span></div><div class=order style=\"text-align: center\"><nav class=\"is-relative order-menu\"><svg ng-click=\"ticketOrder($index, true)\" ng-disabled=\"$index == 0\" ng-class=\"{\'disabled-order\': $index == 0}\" class=order-color width=17 height=12 viewBox=\"0 0 17 12\" fill=none xmlns=http://www.w3.org/2000/svg style=\"cursor: pointer\"><path d=\"M14.5 9 8.869 2.857a.5.5 0 0 0-.738 0L2.5 9\" stroke-width=2 stroke-linecap=round /></svg> <svg ng-click=\"ticketOrder($index, false)\" ng-disabled=\"$index == tickets.length - 1\" ng-class=\"{\'disabled-order\': $index == tickets.length - 1}\" style=\"margin-left:20%; cursor: pointer\" class=order-color width=17 height=12 viewBox=\"0 0 17 12\" fill=none xmlns=http://www.w3.org/2000/svg><path d=\"m2.5 3 5.631 6.143a.5.5 0 0 0 .738 0L14.5 3\" stroke-width=2 stroke-linecap=round /></svg></nav></div><div class=dotsmenu style=\"display: inline-flex\"><div style=\"width: 50px\"></div><nav class=\"has-dropdown is-relative pull-right mobile-menu\" style=\"width: 50px\"><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><circle fill=#8A94A2 cx=8 cy=32 r=6></circle><circle data-color=color-2 fill=#8A94A2 cx=32 cy=32 r=6></circle><circle fill=#8A94A2 cx=56 cy=32 r=6></circle></g></svg><ul class=dropdown-menu style=\"right: 10px; min-width: 90px; top:20px\"><li><a ng-click=editTicket($index)><span translate=EDIT_BTN class=ng-scope>Edit</span></a></li><li class=ng-scope><a ng-click=deleteTicket($index)><span translate=DELETE_BTN class=ng-scope>Delete</span></a></li></ul></nav></div></div><!--\n							<div class=\"ticket-container\">\n								<div class=\"ticket-name\"><span class=\"text\">Kids</span></div>\n								<div class=\"quantity\"><span>0/100</span></div>\n								<div class=\"price\"><span>Free</span></div>\n								<div class=\"dotsmenu\">\n									<nav class=\"has-dropdown is-relative pull-right mobile-menu\">\n										<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"64px\" height=\"64px\" viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><circle fill=\"#8A94A2\" cx=\"8\" cy=\"32\" r=\"6\"></circle><circle data-color=\"color-2\" fill=\"#8A94A2\" cx=\"32\" cy=\"32\" r=\"6\"></circle><circle fill=\"#8A94A2\" cx=\"56\" cy=\"32\" r=\"6\"></circle></g></svg>\n										<ul class=\"dropdown-menu\" style=\"right: 10px; min-width: 90px; top:20px;\">\n											<li><a ng-click=\"\"><span translate=\"EDIT_BTN\" class=\"ng-scope\">Edit</span></a></li>\n											<li class=\"ng-scope\"><a ng-click=\"\"><span translate=\"DELETE_BTN\" class=\"ng-scope\">Delete</span></a></li>\n										</ul>\n									</nav>\n								</div>\n							</div>\n							<div class=\"ticket-container\">\n								<div class=\"ticket-name\"><span class=\"text\">Family package</span></div>\n								<div class=\"quantity\"><span>0/200</span></div>\n								<div class=\"price\"><span>Paid</span></div>\n								<div class=\"dotsmenu\">\n									<nav class=\"has-dropdown is-relative pull-right mobile-menu\">\n										<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"64px\" height=\"64px\" viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><circle fill=\"#8A94A2\" cx=\"8\" cy=\"32\" r=\"6\"></circle><circle data-color=\"color-2\" fill=\"#8A94A2\" cx=\"32\" cy=\"32\" r=\"6\"></circle><circle fill=\"#8A94A2\" cx=\"56\" cy=\"32\" r=\"6\"></circle></g></svg>\n										<ul class=\"dropdown-menu\" style=\"right: 10px; min-width: 90px; top:20px;\">\n											<li><a ng-click=\"\"><span translate=\"EDIT_BTN\" class=\"ng-scope\">Edit</span></a></li>\n											<li class=\"ng-scope\"><a ng-click=\"\"><span translate=\"DELETE_BTN\" class=\"ng-scope\">Delete</span></a></li>\n										</ul>\n									</nav>\n								</div>\n							</div>\n							<div class=\"ticket-container\">\n								<div class=\"ticket-name\"><span class=\"text\">School renovation</span></div>\n								<div class=\"quantity\"><span>Unlimited</span></div>\n								<div class=\"price\"><span>£20.00</span></div>\n								<div class=\"dotsmenu\">\n									<nav class=\"has-dropdown is-relative pull-right mobile-menu\">\n										<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"64px\" height=\"64px\" viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><circle fill=\"#8A94A2\" cx=\"8\" cy=\"32\" r=\"6\"></circle><circle data-color=\"color-2\" fill=\"#8A94A2\" cx=\"32\" cy=\"32\" r=\"6\"></circle><circle fill=\"#8A94A2\" cx=\"56\" cy=\"32\" r=\"6\"></circle></g></svg>\n										<ul class=\"dropdown-menu\" style=\"right: 10px; min-width: 90px; top:20px;\">\n											<li><a ng-click=\"\"><span translate=\"EDIT_BTN\" class=\"ng-scope\">Edit</span></a></li>\n											<li class=\"ng-scope\"><a ng-click=\"\"><span translate=\"DELETE_BTN\" class=\"ng-scope\">Delete</span></a></li>\n										</ul>\n									</nav>\n								</div>\n							</div>--></div><div class=\"col-md-12 ml0 mt20\" ng-show=\"!addingTicket && !editingTicket\"><button translate=ADD_ITEM type=button class=\"btn anothertickets\" ng-click=toggleAddTicket()></button></div></div><div ng-show=addingTicket><div class=row><div class=\"col-md-12 mt20\"><label translate=SELECT_TICKET_TYPE class=ng-scope></label><div class=mt5><button class=\"tickettype {{newTicketType === \'FREE\' ? \'selected\' : \'\'}}\" ng-click=\"setTicketType(\'FREE\')\">Free</button> <button class=\"tickettype {{newTicketType === \'PAID\' ? \'selected\' : \'\'}}\" ng-click=\"setTicketType(\'PAID\')\">Paid</button> <button class=\"tickettype {{newTicketType === \'DONATION\' ? \'selected\' : \'\'}}\" ng-click=\"setTicketType(\'DONATION\')\">Donation</button></div></div></div><!-- FREE TICKET --><div class=\"row mt10\" ng-show=\"newTicketType === \'FREE\'\"><div class=\"col-md-6 col-xs-7\"><div class=tickets-header><span translate=TICKET_NAME class=ng-scope>Description</span></div><div class=\"event-input {{ newTicketNameInvalid ? \'invalid-input-label\' : \'\' }}\"><input class=mt5 maxlength=200 ng-model=newTicketName type=text placeholder=\"{{\'EG_ADULT_FAMILY\' | translate }}\" ng-keyup=checkNewTicketName()><div class=event-wrong-input translate=ENTER_VALID_TICKET_NAME></div></div></div><div class=\"col-md-4 col-xs-4\"><div class=tickets-header><span translate=QUANTITY class=ng-scope>Quantity</span></div><div class=\"event-input {{ newTicketQuantityInvalid ? \'invalid-input-label\' : \'\' }}\"><input class=mt5 type=text ng-model=newTicketQuantity maxlength=4 remove-chars=number autocomplete=off placeholder=\"{{ \'EG_QUANTITY_OF_TICKETS\' | translate }}\" ng-keyup=checkNewTicketQuantity()><div class=event-wrong-input translate=ENTER_VALID_TICKET_AMOUNT></div></div></div><div class=clearfix></div><div class=\"col-md-12 ml0 mt20\"><button type=button class=\"btn btn-ghost\" ng-click=toggleAddTicket() translate=CANCEL_BTN></button> <button type=button class=\"btn btn-primary\" style=\"margin-left: 10px\" translate=SAVE_TICKETS ng-click=addFreeTicket()>Save ticket</button></div></div><!-- PAID TICKET --><div class=\"row mt10\" ng-show=\"newTicketType === \'PAID\'\"><div class=\"col-md-6 col-xs-7\"><div class=tickets-header><span translate=TICKET_NAME class=ng-scope>Description</span></div><div class=\"event-input {{ newTicketNameInvalid ? \'invalid-input-label\' : \'\' }}\"><input class=mt5 maxlength=200 ng-model=newTicketName type=text placeholder=\"{{\'EG_ADULT_FAMILY\' | translate }}\" ng-keyup=checkNewTicketName()><div class=\"event-wrong-input ng-scope\" translate=ENTER_VALID_TICKET_NAME>Enter a valid ticket name</div></div></div><div class=\"col-md-4 col-xs-4\"><div class=tickets-header><span translate=QUANTITY class=ng-scope>Quantity</span></div><div class=\"event-input {{ newTicketQuantityInvalid ? \'invalid-input-label\' : \'\' }}\"><input class=mt5 type=text ng-model=newTicketQuantity maxlength=4 remove-chars=number min=0 autocomplete=off placeholder=\"{{ \'EG_QUANTITY_OF_TICKETS\' | translate }}\" ng-keyup=checkNewTicketQuantity()><div class=\"event-wrong-input ng-scope\" translate=ENTER_VALID_TICKET_AMOUNT>Enter a valid amount</div></div></div><div class=\"col-md-6 col-xs-7\"><div class=tickets-header><span translate=EVENT_PRICE_PER_TICKET class=ng-scope>Price</span></div><div class=\"event-input {{ newTicketPriceInvalid ? \'invalid-input-label\' : \'\' }}\"><input class=mt5 formatprice=number type=text ng-model=newTicketPrice remove-chars=number maxlength=7 autocomplete=off placeholder=\"e.g. 5.00\" ng-keyup=checkNewTicketPrice()><div class=\"event-wrong-input ng-scope\" translate=ENTER_VALID_TICKET_PRICE>Enter a valid price</div></div></div><div class=clearfix></div><div class=\"col-md-12 ml0 mt20\"><button type=button class=\"btn btn-ghost\" ng-click=toggleAddTicket()>Cancel</button> <button type=button class=\"btn btn-primary\" style=\"margin-left: 10px\" translate=SAVE_TICKETS ng-click=addPaidTicket()>Save ticket</button></div></div><!-- DONATION TICKET --><div class=\"row mt10\" ng-show=\"newTicketType === \'DONATION\'\"><div class=col-md-12><div class=donationText><span translate=ADD_OPTIONAL_DONATION></span> <span ng-click=openInfo() class=\"icon dripicons-information\"></span><br><span translate=DONATION_GIFT_AID_LINK></span></div></div><div class=clear></div><div class=\"col-md-6 col-xs-7\"><div class=tickets-header><span translate=TICKET_NAME class=ng-scope>Description</span></div><div class=\"event-input {{ newTicketNameInvalid ? \'invalid-input-label\' : \'\' }}\"><input class=mt5 maxlength=200 ng-model=newTicketName type=text placeholder=\"{{\'ASK_DONATION\' | translate }}\" ng-keyup=checkNewTicketName()><div class=\"event-wrong-input ng-scope\" translate=ENTER_VALID_TICKET_NAME>Enter a valid ticket name</div></div></div><div class=\"col-md-4 col-xs-4\"><div class=tickets-header><span translate=SUGGESTED_AMOUNT class=ng-scope>Suggested Amount</span></div><div class=\"event-input {{ newTicketPriceInvalid ? \'invalid-input-label\' : \'\' }}\"><input class=mt5 formatprice=number type=text ng-model=newTicketPrice remove-chars=number maxlength=7 autocomplete=off placeholder=\"e.g. 5.00\" ng-keyup=checkNewTicketPrice(true)><div class=\"event-wrong-input ng-scope\" translate=ENTER_VALID_TICKET_AMOUNT>Enter a valid amount</div></div></div><div class=clearfix></div><div class=\"col-md-12 ml0 mt20\"><button type=button class=\"btn btn-ghost\" ng-click=toggleAddTicket()>Cancel</button> <button type=button class=\"btn btn-primary\" style=\"margin-left: 10px\" translate=SAVE_TICKETS ng-click=addDonationTicket()>Save ticket</button></div></div></div><div ng-show=editingTicket><div class=row><div class=\"col-md-12 mt20\"><label translate=SELECT_TICKET_TYPE class=ng-scope></label><div class=mt5><button class=\"tickettype {{editTicketType === \'FREE\' ? \'selected\' : \'\'}}\" disabled>Free</button> <button class=\"tickettype {{editTicketType === \'PAID\' ? \'selected\' : \'\'}}\" disabled>Paid</button> <button class=\"tickettype {{editTicketType === \'DONATION\' ? \'selected\' : \'\'}}\" disabled>Donation</button></div></div></div><!-- FREE TICKET --><div class=\"row mt10\" ng-show=\"editTicketType === \'FREE\'\"><div class=\"col-md-6 col-xs-7\"><div class=tickets-header><span translate=TICKET_NAME class=ng-scope>Description</span></div><div class=\"event-input {{ editTicketNameInvalid ? \'invalid-input-label\' : \'\' }}\"><input class=mt5 maxlength=200 ng-model=editTicketName type=text placeholder=\"{{\'EG_ADULT_FAMILY\' | translate }}\" ng-keyup=checkEditTicketName()><div class=event-wrong-input translate=ENTER_VALID_TICKET_NAME></div></div></div><div class=\"col-md-4 col-xs-4\"><div class=tickets-header><span translate=QUANTITY class=ng-scope>Quantity</span></div><div class=\"event-input {{ editTicketQuantityInvalid ? \'invalid-input-label\' : \'\' }}\"><input class=mt5 type=text ng-model=editTicketQuantity maxlength=4 remove-chars=number autocomplete=off placeholder=\"{{ \'EG_QUANTITY_OF_TICKETS\' | translate }}\" ng-keyup=checkEditTicketQuantity()><div class=event-wrong-input translate=ENTER_VALID_TICKET_AMOUNT></div></div></div><div class=clearfix></div><div class=\"col-md-12 ml0 mt20\"><button type=button class=\"btn btn-ghost\" ng-click=toggleEditTicket()>Cancel</button> <button type=button class=\"btn btn-primary\" style=\"margin-left: 10px\" translate=SAVE_TICKETS ng-click=editFreeTicket()>Save ticket</button></div></div><!-- PAID TICKET --><div class=\"row mt10\" ng-show=\"editTicketType === \'PAID\'\"><div class=\"col-md-6 col-xs-7\"><div class=tickets-header><span translate=TICKET_NAME class=ng-scope>Description</span></div><div class=\"event-input {{ editTicketNameInvalid ? \'invalid-input-label\' : \'\' }}\"><input class=mt5 maxlength=200 ng-model=editTicketName type=text placeholder=\"{{\'EG_ADULT_FAMILY\' | translate }}\" ng-keyup=checkEditTicketName()><div class=\"event-wrong-input ng-scope\" translate=ENTER_VALID_TICKET_NAME>Enter a valid ticket name</div></div></div><div class=\"col-md-4 col-xs-4\"><div class=tickets-header><span translate=QUANTITY class=ng-scope>Quantity</span></div><div class=\"event-input {{ editTicketQuantityInvalid ? \'invalid-input-label\' : \'\' }}\"><input class=mt5 type=text ng-model=editTicketQuantity maxlength=4 remove-chars=number min=0 autocomplete=off placeholder=\"e.g. 10\" ng-keyup=checkEditTicketQuantity()><div class=\"event-wrong-input ng-scope\" translate=ENTER_VALID_TICKET_AMOUNT>Enter a valid amount</div></div></div><div class=clearfix></div><div class=\"col-md-6 col-xs-7\"><div class=tickets-header><span translate=EVENT_PRICE_PER_TICKET class=ng-scope>Price</span></div><div class=\"event-input {{ editTicketPriceInvalid ? \'invalid-input-label\' : \'\' }}\"><input class=mt5 formatprice=number type=text ng-model=editTicketPrice remove-chars=number maxlength=7 autocomplete=off ng-disabled=editTicketPriceDisabled placeholder=\"e.g. 5.00\" ng-keyup=checkEditTicketPrice()><div class=\"event-wrong-input ng-scope\" translate=ENTER_VALID_TICKET_PRICE>Enter a valid price</div></div></div><div class=clearfix></div><div class=\"col-md-12 ml0 mt20\"><button type=button class=\"btn btn-ghost\" ng-click=toggleEditTicket()>Cancel</button> <button type=button class=\"btn btn-primary\" style=\"margin-left: 10px\" translate=SAVE_TICKETS ng-click=editPaidTicket()>Save ticket</button></div></div><!-- DONATION TICKET --><div class=\"row mt10\" ng-show=\"editTicketType === \'DONATION\'\"><div class=col-md-12><div class=donationText><span translate=ADD_OPTIONAL_DONATION></span> <span ng-click=openInfo() class=\"icon dripicons-information\"></span><br><span translate=DONATION_GIFT_AID_LINK></span></div></div><div class=clear></div><div class=\"col-md-6 col-xs-7\"><div class=tickets-header><span translate=TICKET_NAME class=ng-scope>Description</span></div><div class=\"event-input {{ editTicketQuantityInvalid ? \'invalid-input-label\' : \'\' }}\"><input class=mt5 maxlength=200 ng-model=editTicketName type=text placeholder=\"{{\'ASK_DONATION\' | translate }}\" ng-keyup=checkEditTicketName()><div class=\"event-wrong-input ng-scope\" translate=ENTER_VALID_TICKET_NAME>Enter a valid ticket name</div></div></div><div class=\"col-md-4 col-xs-4\"><div class=tickets-header><span translate=SUGGESTED_AMOUNT class=ng-scope>Suggested Amount</span></div><div class=\"event-input {{ editTicketPriceInvalid ? \'invalid-input-label\' : \'\' }}\"><input class=mt5 formatprice=number type=text ng-model=editTicketPrice remove-chars=number maxlength=7 autocomplete=off placeholder=\"e.g. 5.00\" ng-keyup=checkEditTicketPrice(true)><div class=\"event-wrong-input ng-scope\" translate=ENTER_VALID_TICKET_AMOUNT>Enter a valid amount</div></div></div><div class=clearfix></div><div class=\"col-md-12 ml0 mt20\"><button type=button class=\"btn btn-ghost\" ng-click=toggleEditTicket()>Cancel</button> <button type=button class=\"btn btn-primary\" style=\"margin-left: 10px\" translate=SAVE_TICKETS ng-click=editDonationTicket()>Save ticket</button></div></div></div><!-- PAYMENT SECTION START --><div class=row ng-if=hasPaidTickets() style=\"margin-top:40px; margin-left:0px;margin-right:0px\"><div><h1 class=ticketseparator translate=SELECT_PAYMENT_GATEWAY></h1></div><div ng-show=!paymentProvider><div class=\"body-container alpha-container ml15 mt10\" style=\"padding-top: 0; padding-bottom: 0; margin-left:0px; margin-bottom:15px\"><div class=\"tickets-list-modal pick-tickets-section\"><div style=\"display: inline-flex\"><span style=\"font-size: 14px\" class=gateway-tickets-subtitle2 translate=SELECT_PAYMENT_GATEWAY2></span><span ng-click=openStripeInfoModal() class=\"icon dripicons-information\"></span></div><div class=payment-container style=\"display: block\"><div class=stripe><button class=\"btn btn-primary first-button\" style=\"display: flex\" ng-click=getStripe()>Connect your Stripe account<span class=\"icons dripicons-exit\" style=padding-left:20px;font-size:20px></span></button></div></div><br><div class=gateway-tickets-subtitle style=\"font-size: 14px; display: inline-block; margin-top:20px;margin-left:0px\" translate=SELECT_PAYMENT_GATEWAY_TEXT></div></div></div></div><!-- PAYMENT SECTION END --><!--STRIPE UPDATE SECTION START --><div class=row ng-if=\"!!paymentProvider && paymentProvider.provider == \'stripe\'\" style=\"margin-bottom: 15px; margin-left:0px; margin-top:20px\"><div class=body-container><div class=\"tickets-list-modal pick-tickets-section\" style=\"margin-top: 2px\"><div class=linkedStripe><div style=\"margin-bottom: 10px\"><h1 translate=LINKED_STRIPE_ACCOUNT style=\"font-size:18px; font-weight: bold\"></h1></div><div style=\"margin-bottom: 3px\"><span translate=NAME_LABEL></span><span><span> : </span>{{ paymentProvider.displayName }}</span></div><div style=\"margin-top: 6px\"><a href=http://dashboard.stripe.com target=_blank type=button class=\"btn stripe-manage-account\" style=\"padding-left: 0!important; display: inline-flex\"><span translate=MANAGE_STRIPE_ACCOUNT></span> <span class=\"icons dripicons-exit\" style=\"padding-left:10px;font-size:20px; color:#627293\"></span></a><br><button type=button class=\"btn stripe-manage-account\" ng-click=\"redirectToStripe(\'update\')\" style=\"padding-left: 0!important; display: inline-flex\"><span translate=SWITCH_STRIPE_ACCOUNT></span> <span class=\"icons dripicons-exit\" style=\"padding-left:10px;font-size:20px; color:#627293\"></span></button></div></div><br><span translate=SELLING_TICKETS style=\"margin-bottom: 0\"></span></div></div></div><!--STRIPE UPDATE SECTION END --></div><div class=row><div class=\"tickets-list-modal pick-tickets-section\" style=\"margin-top: 2px\"><div><div class=\"pick-tickets-item ml15 mr15\"><div style=\"overflow: auto\"><div><br><h1 translate=EVENTS_ASK_QUESTIONS class=separator></h1><p translate=EVENTS_ASK_QUESTIONS_DESCR></p><p translate=EVENTS_ASK_QUESTIONS_DESCR_IMPORTANT></p><br></div></div><div class=questions-container style=\"box-shadow: none; background: #fff; padding: 0px\"><div class=vi-row ng-repeat=\"q in questions\" style=\"padding: 3px 0\"><div class=vi-col-left><span>Q{{$index+1}}</span></div><div class=vi-col-right style=\"width: 50px; text-align: right\"><div ng-click=\"validateQuestionsAndDelete($index, q)\" style=\"padding-top: 4px\" class=ng-scope><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=24px height=24px viewBox=\"0 0 24 24\" stroke-width=2><g stroke-width=2 transform=\"translate(0, 0)\"><polyline points=\"8 5 8 1 16 1 16 5\" fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></polyline><path d=M20,12v9a2,2,0,0,1-2,2H6a2,2,0,0,1-2-2V12 fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></path><line data-color=color-2 x1=12 y1=14 x2=12 y2=18 fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></line><line data-color=color-2 x1=8 y1=14 x2=8 y2=18 fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></line><line data-color=color-2 x1=16 y1=14 x2=16 y2=18 fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></line><rect x=1 y=5 width=22 height=4 fill=none stroke=#444444 stroke-linecap=square stroke-miterlimit=10 stroke-width=2 stroke-linejoin=miter></rect></g></svg></div></div><div class=vi-col-middle><div class=\"event-input {{ (invalidQuestionInfo && !q.title) ? \'invalid-input-label\' : \'\' }}\"><textarea autoresize-textarea ng-model=q.title ng-trim=false ng-change=questionUpdateFun(q.id) placeholder=\"Type a question or request\" maxlength=500></textarea><div class=counter style=\"font-size:14px; color:#627293; text-align: right\">{{ q.title ? q.title.length : 0 }} / 500</div><div class=event-wrong-input>Enter a valid question</div></div></div></div><div style=\"margin-top: 10px\"><button type=button ng-click=addQuestion($event) class=\"btn anothertickets\"><span ng-if=\"!questions || questions.length == 0\">Add a question</span> <span ng-if=\"questions && questions.length > 0\">Add another question</span></button></div></div></div></div></div></div><div class=\"row ml5 mr5\"><div style=\"text-align: right\"><div class=setion-separator></div><div style=\"margin-bottom: 10px; margin-top: 10px\"><button type=button class=\"btn btn-default\" ng-click=cancelTickets()><span translate=CANCEL_BTN></span></button> <button type=button class=\"btn btn-primary auto-create-paid\" ng-disabled=creatingTickets ng-click=validateQuestionsChangeAndSaveTickets() style=\"margin-left: 10px\"><span translate=CONTINUE_BTN></span></button></div></div></div></section></div></div></div></section>");
$templateCache.put("app/events/views/unpublish-rota-modal.html","<div><div class=modal-header><h3 translate=UNPUBLISH_ROTA_HEADER></h3></div><div class=modal-body><p translate=UNPUBLISH_ROTA_TEXT></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" ng-disabled=unpublishingrota translate=UNPUBLISH_BTN ng-click=save()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/events/views/unsaved-changes-modal.html","<div style=padding:20px><span class=\"icons dripicons-cross\" ng-click=stay() style=\"float: right; cursor: pointer; font-size: 28px\"></span><div class=modal-body style=\"margin-top: 40px\"><h3 translate=EVENT_TICKET_UNSAVED_CHANGES></h3></div><div class=modal-footer><button type=button class=\"btn btn-ghost\" translate=LEAVE_ANYWAY_BTN ng-click=leave()><button type=button class=\"btn btn-primary\" translate=REVIEW_CHANGES_BTN ng-click=stay()></button></button></div></div>");
$templateCache.put("app/events/views/view-tickets-modal.html","<div class=event-buytickets-modal style=\"padding: 15px\"><div class=modal-header><h3 translate=YOUR_TICKETS_HEADER translate-values=\"{ \'eventName\': event.title }\"></h3></div><div class=modal-body><p translate=YOU_PURCHASED_TICKETS_FOR translate-values=\"{ \'eventName\': event.title, \'ticketsCount\': getTicketsCount(event.tickets) }\"></p><div class=tickets-list-modal><div class=\"row header\"><div class=\"col-md-6 col-xs-12 col-sm-12\"><span translate=TYPE></span></div><div class=\"col-md-2 col-xs-4 col-sm-4\"><span translate=PRICE></span></div><div class=\"col-md-2 col-xs-4 col-sm-4\"><span translate=QUANTITY></span></div><div class=\"col-md-2 col-xs-4 col-sm-4 align-right\"><span translate=TOTAL></span></div></div><div class=row ng-repeat=\"ticket in event.tickets\"><div class=\"col-md-6 col-xs-12 col-sm-12\"><span>{{ ticket.ticketName }}</span></div><div class=\"col-md-2 col-xs-4 col-sm-4\"><span ng-show=ticket.ticketCurrency translate=\"{{ ticket.ticketCurrency }}_SHORT\"></span><span>{{ ticket.ticketPrice | currency:\"\" }}</span></div><div class=\"col-md-2 col-xs-4 col-sm-4\"><span>{{ ticket.quantity }}</span></div><div class=\"col-md-2 col-xs-4 col-sm-4 align-right\"><span ng-show=ticket.ticketCurrency translate=\"{{ ticket.ticketCurrency }}_SHORT\"></span><span>{{ (ticket.quantity * ticket.ticketPrice) | currency: \"\" }}</span></div></div><div class=total-label><div class=align-right><span ng-show=event.tickets[0].ticketCurrency translate=\"{{ event.tickets[0].ticketCurrency }}_SHORT\"></span><span>{{ getTotalTickets(event.tickets) | currency: \"\" }}</span></div></div></div><div><a class=downtickets-link ng-click=downloadTickets(event.id)><span class=\"icon dripicons-download\"></span> <span translate=DOWNLOAD_TICKETS></span></a></div><br><br><div translate=PAYMENT_SUCCESS_TEXT_1></div></div><div class=modal-footer><button type=button class=\"btn btn-default pull-right\" translate=OK_BTN ng-click=close()></div></div>");
$templateCache.put("app/events/views/view.html","<section class=event-view add-guests ng-class=\"{ \'is-visible\': viewState.isReady }\"><div class=\"page-view-header clearfix\"><div style=\"display: flex; padding-bottom: 5px\"><a id=header-back-button class=page-view-header__back ng-click=back() style=\"float: left; margin-right: 10px; position: relative\"><span class=dripicons-arrow-thin-left></span></a><div class=page-view-header__text style=\"padding-left: 0\"><strong class=page-view-header__title>{{ event.title }}</strong></div></div></div><div><div ng-if=showInfoPast class=\"yellow-tooltip hidden-md hidden-lg\" style=\"margin-bottom: 0\"><span ng-click=closeInfo() class=dripicons-cross></span><div><span translate=PAST_EVENT_INFO></span></div></div><div ng-if=!event.userAnswer class=page-view-subheader style=\"margin-top: -1px; min-height: 50px\"><div class=\"visible-md visible-lg\" style=\"align-self: center\"><span translate=AS_ADMIN_VIEW_ALL_EVENTS style=\"line-height: 27px\"></span></div><div class=\"hidden-md hidden-lg\" style=\"text-align: center\"><span translate=AS_ADMIN_VIEW_ALL_EVENTS style=\"line-height: 27px\"></span></div><div><button ng-if=isEventOwner ng-click=goToDashboard() type=button class=\"btn btn-ghost\" style=margin-right:5px><span translate=GO_TO_DASHBOARD></span></button> <button ng-if=\"userRole != \'STAFF\' && event.status == \'ACTIVE\'\" ng-click=switchToView() type=button class=\"btn btn-primary\"><span translate=GO_TO_PARENT_APP></span></button></div></div><div style=\"height: 10px\"></div><div><div><section style=\"padding: 16px; margin-bottom: 0; border-bottom: none; background: #fff; text-align: center\"><h1 style=\"font-size: 20px; font-weight: normal; margin: 0; color: #404040; margin-bottom: 7px; color: #00a69d; font-size: 18px; font-weight: bold\">{{ event.title }}</h1><ul class=details-attachment-list><li style=\"padding: 5px 0\"><span style=\"line-height: 22px\">{{ event.date.startDate | date:\'EEEE,\' : \'GMT\' }} <span style=\"font-weight: bold\">{{ event.date.startDate | date:\'MMM dd\' : \'GMT\' }}</span> <span translate=AT></span> <span style=\"font-weight: bold\">{{ event.date.startDate | date:\'h:mm a\' : \'GMT\' }}</span> <span ng-show=\"event.date.endDate && event.date.startDate !== event.date.endDate && event.date.sameDay\"><span>-</span> {{ event.date.endDate | date:\'h:mm a\' : \'GMT\' }}</span></span></li></ul><div ng-if=\"event.fileLibrary && event.fileLibrary.image\" style=\"text-align: center; background-color: white; margin-bottom: 20px\"><div style=\"width: 100%;\n								max-width: 500px;\n								margin: 0 auto;\n								position: relative;\n								aspect-ratio: 1 / 1;\n								background-image: url(\'{{ event.fileLibrary.image }}\');\n								background-size: cover;\n								background-position: center\"><a ng-href=\"{{ event.fileLibrary.image }}\" download=event-image.jpg target=_blank style=\"position: absolute;\n									bottom: 10px;\n									right: 10px;\n									background: #fff;\n									border: none;\n									border-radius: 50%;\n									padding: 6px;\n									box-shadow: 0 2px 6px rgba(0,0,0,0.15);\n									cursor: pointer;\n									display: flex;\n									align-items: center;\n									justify-content: center\"><svg xmlns=http://www.w3.org/2000/svg width=20 height=20 fill=#DB006A viewBox=\"0 0 24 24\"><path d=\"M12 16l6-6h-4V2h-4v8H6z\"/><path d=\"M5 18h14v2H5z\"/></svg></a></div></div><p ng-if=event.description style=\"word-break: break-word; padding: 0px; text-align: center; margin-top: 0px; font-size: 16px; color: rgb(98, 114, 147)\" ng-bind-html=event.description></p></section></div></div><!-- <div ng-show=\"event.description\" style=\"padding: 16px; background: #fff; width: 100%; max-width: 480px;\">\n			<p\n			  style=\"padding: 0; text-align: left; margin-top: 0; font-size: 14px; color: #404040; word-break: break-word;\"\n			  ng-bind-html=\"event.description\"\n			></p>\n		</div> --><section><!-- Budi --><div ng-if=\"userRole != \'STAFF\' && event.online && event.onlineEventType == \'CLASSLIST\' \" style=\"width: 100%; text-align: center\"><button class=\"btn btn-primary btn-primary-pink plus-button btn-primary-subheader\" ng-click=joinOnlineEvent()><span style=\"margin-top: 0px; float: left\" translate=JOIN_ONLINE_EVENT></span></button></div><!-- External --><div ng-if=\"event.online && event.onlineEventType == \'EXTERNAL\' \" style=\"width: 100%; text-align: center\"><button class=\"btn btn-primary btn-primary-pink plus-button btn-primary-subheader\" ng-click=joinOnlineEvent()><span style=\"margin-top: 0px; float: left\" translate=JOIN_ONLINE_EVENT></span></button><br><br><span class=event-tag-txt style=\"font-weight: 600;color: #8a94a2\">Link:</span> <a href=\"{{ event.onlineEventExternalLink }}\" target=_blank style=\"word-break: break-word\">{{ event.onlineEventExternalLink }}</a></div><div class=hosted-by-label style=\"overflow: auto; padding-left:8px\"><span class=event-tag ng-if=\"event.type == \'COMMUNITY\'\"><span class=\"circle-tag community-tag\"></span> <span class=event-tag-txt translate=TAG_COMMUNITY_EVENT></span> </span><span class=event-tag ng-if=\"event.type == \'PARENT\'\"><span class=\"circle-tag private-tag\"></span> <span class=event-tag-txt translate=TAG_PRIVATE_EVENT></span> </span><span ng-if=event.createdByName translate=CREATED_BY style=\"margin-left: 6px\"></span> <a ui-sref=\"users.parentdetail({\'id\': event.createdById })\">{{ ::event.createdByName }}</a></div><div><div><ul class=details-attachment-list><li><span class=\"icon dripicons-clock\" style=\"float: left\"></span> <span style=\"line-height: 22px\">{{ event.date.startDate | date:\'EEEE,\' : \'GMT\' }} <span style=\"font-weight: bold\">{{ event.date.startDate | date:\'MMM dd\' : \'GMT\' }}</span> <span translate=AT></span> <span style=\"font-weight: bold\">{{ event.date.startDate | date:\'h:mm a\' : \'GMT\' }}</span> <span ng-show=\"event.date.endDate && event.date.startDate !== event.date.endDate && event.date.sameDay\"><span>-</span> {{ event.date.endDate | date:\'h:mm a\' : \'GMT\' }}</span></span></li><li class=indented ng-show=\"event.date.endDate && event.date.startDate !== event.date.endDate && !event.date.sameDay\" style=\"padding-left: 37px\"><span translate=UNTIL></span> {{ event.date.endDate | date:\'EEEE,\' : \'GMT\' }} <span style=\"font-weight: bold\">{{ event.date.endDate | date:\'MMM dd\' : \'GMT\' }}</span> <span translate=AT></span> <span style=\"font-weight: bold\">{{ event.date.endDate | date:\'h:mm a\' : \'GMT\' }}</span></li><li ng-show=\"event.date.rsvpDate && !isPastViewEventEvent(event)\"><div style=\"overflow: auto\"><span class=\"icon dripicons-stopwatch\" style=\"float: left\"></span> <span style=\"line-height: 22px; float: left\"><span translate=RSVP_BY></span> {{ event.date.rsvpDate | date:\'EEEE,\' : \'GMT\' }} <span style=\"font-weight: bold\">{{ event.date.rsvpDate | date:\'MMM dd\' : \'GMT\' }}</span> <span style=\"font-weight: bold\">{{ event.date.rsvpDate | date:\'h:mm a\' : \'GMT\' }}</span></span></div></li><li ng-show=\"event.date.rsvpDate && isPastViewEventEvent(event)\"><span class=\"icon dripicons-stopwatch\" style=\"float: left\"></span> <span style=\"line-height: 22px\"><span translate=RSVP_BY_PAST></span></span></li><li ng-if=\"event.location.location && !event.online\"><span class=\"icon dripicons-location\" style=\"float: left\"></span> <span style=\"margin-right: 7px\">{{ event.location.location }} <span ng-if=event.location.locationDetail>({{ event.location.locationDetail }})</span></span> <a ng-if=\"event.location.locationLat != 0.0 && event.location.locationLong != 0.0\" translate=MAP_VIEW href=\"http://maps.google.com/?q={{ event.location.location }}\" target=_blank style=\"white-space: nowrap\"></a></li></ul><div><ul class=details-attachment-list><li ng-if=event.fileLibrary.attachment><span class=\"icon dripicons-paperclip\"></span> <span ng-repeat=\"att in event.fileLibrary.attachment\"><a href=\"{{ att.path }}\" target=_self style=\"word-wrap: break-word\">{{ att.name }}</a><br></span></li></ul></div></div></div></section><section ng-if=\"!isPastEvent(event) && event.userAnswer && event.status != \'CANCELLED\'\" class=\"page-view-subheader mobile-fix-dates\" style=\"min-height: 50px\"><div><a class=switch-app-button ng-click=switchToView()><div><img src=assets/icons/switchtoparent.png alt=\"\"></div><span ng-if=event.ticketed translate=SWITCH_TO_VIEW_OR_TICKETS></span> <span ng-if=!event.ticketed translate=SWITCH_TO_REPLY></span></a></div></section><section style=\"padding: 16px 0\"><div ng-if=\"active_user.id == event.createdById && event.answerCount.inviting\" style=\"margin-bottom: 20px; margin-left:19px\"><span translate=INVITATIONS_ARE_BEING_SENT></span></div><div class=\"row d-flex justify-content-between align-items-center flex-wrap\"><div class=\"col-md-6 col-sm-6 col-12\"><div class=\"col-md-12 small-invitation-resume {{ event.ticketed ? \'ticketed\' : \'\' }}\" style=\"display: block\"><div ng-click=\"showGuests(\'ALL\')\"><h1>{{event.answerCount.invited}}</h1><span translate=EVENT_TXT_INVITED></span></div><div ng-if=!event.ticketed ng-click=\"showGuests(\'GOING\')\"><h1>{{event.answerCount.going}}</h1><span translate=EVENT_TXT_GOING></span></div><div ng-if=!event.ticketed ng-click=\"showGuests(\'MAYBE\')\"><h1>{{event.answerCount.maybe}}</h1><span translate=EVENT_TXT_MAYBE></span></div><div ng-if=!event.ticketed ng-click=\"showGuests(\'NOT_GOING\')\"><h1>{{event.answerCount.cantgo}}</h1><span translate=EVENT_TXT_CANTGO></span></div><div ng-if=event.ticketed ng-click=\"showGuests(\'GOING\')\"><h1>{{event.answerCount.sold}}</h1><span translate=EVENT_TXT_SOLD></span></div></div><div class=col-md-12 style=padding-top:20px><div class=invited-group-list style=margin-top:0><div ng-repeat=\"group in event.groups\" style=\"padding-left: 15px\"><span class=\"icon dripicons-user-group groups-icon\"></span> <span>{{ group.name }}</span></div></div></div></div><div class=\"col-md-3 col-sm-4 col-12 staff-public-event-link-div\"><div class=staff-public-event-link ng-if=\"active_user.role === \'STAFF\'\"><a ng-if=event.open href={{event.openLink}} target=_blank style=\"color: #EB004E; cursor: pointer; display: flex; align-items: center; gap: 10px\" class=ng-scope><svg width=16 height=16 viewBox=\"0 0 24 24\" fill=none xmlns=http://www.w3.org/2000/svg><path d=\"M12 2v20M2 12h20\" stroke=#EB004E stroke-width=1.5 stroke-miterlimit=10></path><path d=\"M12 22c2.761 0 5-4.477 5-10S14.761 2 12 2 7 6.477 7 12s2.239 10 5 10z\" stroke=#EB004E stroke-width=1.5 stroke-miterlimit=10 stroke-linecap=square></path><path d=\"M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z\" stroke=#EB004E stroke-width=1.5 stroke-miterlimit=10 stroke-linecap=square></path></svg> <span translate=EVENT_PUBLIC_CHECKOUT_ENABLED></span> </a><span ng-if=!event.open style=\"color: #627293; display: flex; align-items: center; gap: 5px\" class=ng-scope><svg width=24 height=24 viewBox=\"0 0 24 24\" fill=none xmlns=http://www.w3.org/2000/svg><path d=\"M12 2v20M2 12h20\" stroke=#627293 stroke-width=1.5 stroke-miterlimit=10 /><path d=\"M12 22c2.761 0 5-4.477 5-10S14.761 2 12 2 7 6.477 7 12s2.239 10 5 10z\" stroke=#627293 stroke-width=1.5 stroke-miterlimit=10 stroke-linecap=square /><path d=\"M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z\" stroke=#627293 stroke-width=1.5 stroke-miterlimit=10 stroke-linecap=square /></svg> <span translate=EVENT_PUBLIC_CHECKOUT_DISABLED></span></span></div></div></div></section><!-- <section class=\"mobile-fix-dates\" ng-if=\"isPastEvent(event) && (active_user.id == event.createdById)\">\n			<a translate=\"DOWNLOAD_SELECTED_GUESTS_LIST\" ng-click=\"downloadList(event.ticketed)\" style=\"font-weight: bold;\"></a>\n		</section> --><section class=mobile-fix-dates ng-if=event.rotaLink><div><strong style=\"color: #838383\">Volunteer rota link</strong></div><div><a href=\"{{ event.rotaLink }}\" target=_blank>{{ event.rotaLink }}</a></div></section><section><div ng-if=isEventOwner><div><button class=\"btn btn-ghost pull-right\" translate=\"{{ isLocked ? \'UNLOCK_COMMENTS\' : \'LOCK_COMMENTS\'}}\" ng-click=lockComments()></button><br></div></div><div class=sample-popup ng-if=event.sample style=\"top: 35%; left: 40%\"><span class=dripicons-cross ng-click=dismissSample()></span><div class=sample-padding><div class=sample-header><span translate=SAMPLE_EVENT_TITLE></span></div><div class=sample-container><span translate=SAMPLE_EVENT_DESCR></span></div></div><div class=arrow></div></div><br></section><section><div ng-if=\"posts.length > 0\"><post-asset comment-only=true ng-repeat=\"p in posts\" post-content={{p}} post-context=HOME_VIEW class=enter user-avatar=user.avatar user-id=user.id user-role=user.role user-name=userName post-events=events></post-asset></div></section></div></section>");
$templateCache.put("app/events/views/wrapper.html","<div class=\"content-logged events\" photo-upload><div ui-view autoscroll=false></div></div>");
$templateCache.put("app/get-started/views/get-started.html","<section photo-upload class=get-started-section><div style=\"color: #001031\"><h2 style=\"font-weight: bold; font-size: 24px\" translate=GET_STARTED_HEADER></h2><div class=box-wrapper-getstarted style=\"display: -webkit-box\"><figure class=box-getstarted><a href=https://help.classlist.com/hc/en-us/articles/25773133470365-Video-Demo-of-Classlist target=_blank><img class=image-box alt=\"\" ng-src=https://storage.googleapis.com/classlist-branding/app-assets/classlist-get-started-video-thumbnail.jpeg></a><div class=button-area><div><a translate=WATCH_A_VIDEO class=\"btn btn-primary\" ng-click=\"redirectTo(\'https://help.classlist.com/hc/en-us/articles/25773133470365-Video-Demo-of-Classlist\', \'_blank\')\"></a></div><div><a translate=BOOK_LIVE_DEMO class=\"btn btn-secondary\" ng-click=\"redirectTo(\'https://calendly.com/classlist\',\'_blank\')\"></a></div></div></figure></div><!-- App Cue Journey --><h3 class=sub-header translate=APPCUE-JOURNEY-HEADER></h3><div class=get-started-list-item><div><p translate=APPCUE-JOURNEY-SCHOOL-COMMUNITY class=title></p></div><a ng-if=!isNative translate=TAKE_A_TOUR ng-click=appCueCallEventJourney() class=\"btn btn-primary-tour\"></a></div><!-- this will be enabled only for first ambassador--><div class=get-started-list-item ng-if=$root.active_school.firstAmbassador><div><p translate=APPCUE-JOURNEY-FIRST-AMBASSADOR class=title></p></div><a ng-if=!isNative translate=TAKE_A_TOUR ng-click=appCueCallFirstAmbassadorCreateEvent() class=\"btn btn-primary-tour\"></a></div><div class=get-started-list-item><a translate=SET_UP_FIRST_EVENT class=text-link ng-click=\"callUserTag(\'SET_UP_FIRST_EVENT\')\" class=text-link href=#/community-events/start>Set up your first community event</a></div><!-- Personalise Your School --><div ng-hide=isStaffWithoutUserManagementPermission()><h3 class=sub-header translate=GET_STARTED_SUB_HEADER></h3><p class=sub-body translate=GET_STARTED_SUB_BODY></p><div class=get-started-list-item><div><p translate=ADD_A_WELCOME_MESSAGE class=title></p><p></p></div><a translate=ADD_BTN ng-click=\"callUserTag(\'ADD_A_WELCOME_MESSAGE\'); editPersonalMessage()\" class=\"btn btn-primary\"></a></div><div class=get-started-list-item><div><p translate=ADD_A_LOGO class=title></p><p></p></div><a translate=ADD_BTN ng-click=\"callUserTag(\'ADD_A_LOGO\'); uploadLogo()\" class=\"btn btn-primary\"></a></div><div class=get-started-list-item-link ng-if=!integrationEnabled><p translate=EDIT_SCHOOL_STRUCTURE class=title></p><a translate=GO_TO_SCHOOL_STRUCTURE ng-click=\"callUserTag(\'EDIT_SCHOOL_STRUCTURE\')\" class=text-link href=#/school/structure>Go to School structure page</a></div><div class=clearfix ng-if=!integrationEnabled><br></div><div class=get-started-list-item-link><p translate=ADD_A_BANNER_INTEGRATION class=title ng-if=integrationEnabled></p><p translate=ADD_A_BANNER class=title ng-if=!integrationEnabled></p><a translate=GO_TO_SCHOOL_PROFILE ng-click=\"callUserTag(\'GO_TO_SCHOOL_PROFILE\')\" class=text-link href=#/school/details>Go to School profile page</a></div></div><!-- Build your community--><h3 class=sub-header translate=GET_STARTED_SUB_HEADER2></h3><p class=sub-body translate=GET_STARTED_SUB_BODY2></p><div class=get-started-list-item ng-if=\"!integrationEnabled || (integrationEnabled && active_user.role === \'STAFF\')\" ng-hide=isStaffWithoutUserManagementPermission()><div><p translate=INVITE_PARENTS_TO_HELP class=\"title ng-scope\">Invite some parents to help</p><p translate=INVITE_SUB_TEXT class=\"subtitle ng-scope\">Grow your community by inviting parents to join</p></div><a translate=GO ng-click=\"callUserTag(\'INVITE_PARENTS_TO_HELP\'); inviteOne()\" class=\"btn btn-secondary\"></a></div><div class=get-started-list-item ng-hide=isStaffWithoutUserManagementPermission()><div><p translate=CREATE_AMBASSADORS_TEAM class=title>Create your team of Ambassadors</p><p translate=CREATE_AMBASSADORS_SUB_TEXT class=subtitle>Assign some admins to help you manage and grow your community</p></div><a ng-if=!integrationEnabled translate=GO ng-click=\"callUserTag(\'CREATE_AMBASSADORS_TEAM\'); addAmbasador();\" class=\"btn btn-secondary\"></a> <a ng-if=integrationEnabled translate=GO ng-click=\"callUserTag(\'CREATE_AMBASSADORS_TEAM\'); redirectToNormal(\'#/school/admins\')\" class=\"btn btn-secondary\"></a></div><div class=get-started-list-item ng-if=!isStaff><div><p translate=POST_TO_YOUR_CLASS class=title>Post to your class or ambassador groups</p><p translate=START_CONVERSATION_SUB_TEXT class=subtitle>Start a conversation by writing a group post on the parent side</p></div><a translate=GO ng-click=\"callUserTag(\'POST_TO_YOUR_CLASS\'); switchApps(\'#/home\');\" class=\"btn btn-secondary\"></a></div><div class=get-started-list-item><div><p translate=ADD_YOUR_FIRST_ANNOUNCEMENT class=title>Add your first announcement</p><p translate=SEND_MESSAGE_TO_WHOLE class=subtitle>Send a message to the whole school or certain groups</p></div><a translate=GO ng-click=\"callUserTag(\'ADD_YOUR_FIRST_ANNOUNCEMENT\')\" class=\"btn btn-secondary\" href=#/announcements/create></a></div><div class=get-started-list-item><div><p translate=ADD_YOUR_FIRST_EVENT_TO_CAL class=title>Add some events to the calendar</p><p translate=ADD_YOUR_FIRST_EVENT_TO_CAL_HELP class=subtitle>Create a simple meet-up to welcome new families and add events such as your next fair.</p></div><a translate=GO ng-click=\"callUserTag(\'ADD_YOUR_FIRST_EVENT\')\" class=\"btn btn-secondary\" href=#/community-events/list></a></div><div class=get-started-list-item><div><p translate=ADD_YOUR_FIRST_ABOUT_MARKETPLACE class=title>Spread the word about the marketplace for parent-parent listings</p><p translate=ADD_YOUR_FIRST_ABOUT_MARKETPLACE_HELP class=subtitle>Encourage parents to swap, trade or request items; ideal for reducing our collective carbon footprint.</p></div><a translate=GO ng-click=\"callUserTag(\'ADD_YOUR_FIRST_ABOUT_MARKETPLACE\')\" class=\"btn btn-secondary\" href=#/announcements/create></a></div><div class=get-started-list-item><div><p translate=ADD_YOUR_FIRST_INTEREST_GROUPS class=title>Set up some interest groups to foster community</p><p translate=ADD_YOUR_FIRST_INTEREST_GROUPS_HELP class=subtitle>New families, nationality groups or houses are popular options.</p></div><a translate=GO ng-if=isStaff ng-click=\"callUserTag(\'ADD_YOUR_FIRST_INTEREST_GROUPS\')\" class=\"btn btn-secondary\" href=#/groups/interestgroups></a> <a translate=GO ng-if=!isStaff ng-click=\"callUserTag(\'ADD_YOUR_FIRST_INTEREST_GROUPS\')\" class=\"btn btn-secondary\" href=#/groups/list></a></div><!-- Spread the word--><h3 class=sub-header translate=GET_STARTED_SUB_HEADER3></h3><div class=get-started-list-content><li ng-if=integrationEnabled>Download a <a class=text-link target=_blank href=https://help.classlist.com/hc/en-us/articles/210479025-Classlist-Flyers-to-Print-or-Share>flyer</a> and send to parents</li><li ng-if=!integrationEnabled>Download a <a class=text-link ng-click=\"callUserTag(\'DOWNLOAD_BOOKLET\')\" ng-click=\"callUserTag(\'GET_QR_CODE\')\" target=_self href={{qrCodeLink}}>flyer with a QR code</a> and send to parents</li><li translate=SHARE_TWO_MIN_VIDEO_WITH_PARENTS></li><li translate=SHARE_FIVE_MIN_VIDEO_WITH_REPS></li><li translate=CLASSLIST_MEMBER_CODE></li></div><!-- Help & Support--><h3 class=sub-header translate=LEARN_MORE></h3><div class=get-started-list-content><div><img style=\"width: 12%; border-radius: 12px\" src=https://storage.googleapis.com/classlist-branding/app-assets/tips_helpdesk_2.png> <a style=\"margin-left: 16px\" translate=VIEW_OUR_HELPDESK class=\"text-link ng-scope\" ng-click=\"redirectTo(\'https://help.classlist.com/hc/en-us\', \'_blank\')\">View our help desk guides <span class=\"icons dripicons-chevron-right\"></span></a></div></div></div></section>");
$templateCache.put("app/groups/views/add-interest-members-group-modal.html","<script type=text/ng-template id=memberTemplate.html><div class=\"match-container\">\n		<div class=\"match-container-parentname\">\n			<span ng-bind-html=\"match.model.field1 | uibTypeaheadHighlight:query\" ng-if=\"match.model.field1\"></span>\n			<span ng-bind-html=\"match.model.field2 | uibTypeaheadHighlight:query\" ng-if=\"match.model.field2\"></span>\n		</div>\n		<div>\n			<span translate=\"PARENTHESES_OPEN\" ng-if=\"match.model.field3\"></span><span ng-bind-html=\"(m | uibTypeaheadHighlight:query) + ($last ? \'\' : \', \')\" ng-repeat=\"m in match.model.field3 track by $index\"></span><span translate=\"PARENTHESES_CLOSE\" ng-if=\"match.model.field3\"></span>\n		</div>\n	</div></script><div class=create-group><form name=amg novalidate ng-class=\"{\'not-ready\':!viewState.isReady}\"><div class=modal-header><h3 ng-if=\"type == 1\" translate=ASSIGN_GROUP_LEADS2></h3><h3 ng-if=\"type == 2\" translate=ADD_MEMBERS></h3></div><div class=modal-body><div ng-if=\"type == 1\" style=padding-bottom:20px><span translate=ASSIGN_GROUP_LEADS_DESC></span></div><div ng-if=\"type == 2\"><p class=add-members-text translate=ADD_INTEREST_MEMBERS_TEXT translate-values=\"{\'groupName\':currentGroupName}\"></p></div><p ng-if=\"type == 2\" class=create-groups-text translate=ADD_MEMBERS></p><groupparticipants ng-model=members event-context=true show-tiers=true school-id={{active_school.id}} allow-host-invite=true></groupparticipants><p ng-if=\"type == 1 && members.length > 5\" style=padding-top:20px translate=ASSIGN_GROUP_LEADS_MORE_THAN_FIVE_ERROR translate-values={count:members.length}></p></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary\" type=button ng-click=add() ng-disabled=\"members.length === 0\"><span translate=ADD_BTN></span></button></div></form></div>");
$templateCache.put("app/groups/views/add-members-group-modal.html","<script type=text/ng-template id=memberTemplate.html><div class=\"match-container\">	\n		<div class=\"match-container-parentname\">\n			<span ng-bind-html=\"match.model.field1 | uibTypeaheadHighlight:query\" ng-if=\"match.model.field1\"></span>\n			<span ng-bind-html=\"match.model.field2 | uibTypeaheadHighlight:query\" ng-if=\"match.model.field2\"></span>\n		</div>\n		<div>\n			<span translate=\"PARENTHESES_OPEN\" ng-if=\"match.model.field3\"></span><span  ng-bind-html=\"(m | uibTypeaheadHighlight:query) + ($last ? \'\' : \', \')\"  ng-repeat=\"m in match.model.field3\" ng-if=\"match.model.field3\"></span><span translate=\"PARENTHESES_CLOSE\" ng-if=\"match.model.field3\">\n		</div>\n	</div></script><div class=create-group><form name=amg novalidate ng-class=\"{\'not-ready\':!viewState.isReady}\"><div class=modal-header><h3 translate=ADD_MEMBERS></h3></div><div class=modal-body><p class=add-members-text translate=ADD_MEMBERS_TEXT translate-values=\"{\'groupName\':currentGroupName}\"></p><div class=search><input type=text ng-model=member placeholder=\"{{ \'ADD_GROUPMEMBER_SEARCH_PHOLDER\' | translate }}\" uib-typeahead=\"r.field1 for r in getMembers($viewValue)\" typeahead-wait-ms=300 typeahead-min-length=2 typeahead-on-select=pickMember($item) typeahead-template-url=memberTemplate.html class=form-control></div><ul class=basket><li ng-repeat=\"(key, item) in members track by $index\"><header class=tier-header ng-if=\"item.type !== \'user\' && item.tierId !== members[key-1].tierId\"><figure class=avatar><span class=dripicons-user-id></span></figure>{{ item.tierName }} <a ng-click=toggleGroup(item.tierId)><span class=dripicons-chevron-down></span></a></header><div ng-class=\"{\'group\':item.type !== \'user\'}\" class=\"{{ item.tierId }}\"><div class=participant><figure class=avatar><avatar source={{item.avatar}} name=\"{{ item.firstName + \' \' + item.lastName }}\" width=40 height=40></avatar></figure>{{item.firstName}} {{item.lastName}} <a ng-click=removeMember(item)><span class=dripicons-cross></span></a></div></div></li></ul></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary\" type=button ng-click=add() ng-disabled=\"members.length === 0\"><span translate=ADD_BTN></span></button></div></form></div>");
$templateCache.put("app/groups/views/create-group-modal.html","<script type=text/ng-template id=memberTemplate.html><div class=\"match-container\">	\n		<div class=\"match-container-parentname\">\n			<span ng-bind-html=\"match.model.field1 | uibTypeaheadHighlight:query\" ng-if=\"match.model.field1\"></span>\n			<span ng-bind-html=\"match.model.field2 | uibTypeaheadHighlight:query\" ng-if=\"match.model.field2\"></span>\n		</div>\n		<div>\n			<span translate=\"PARENTHESES_OPEN\" ng-if=\"match.model.field3\"></span><span  ng-bind-html=\"(m | uibTypeaheadHighlight:query) + ($last ? \'\' : \', \')\"  ng-repeat=\"m in match.model.field3\" ng-if=\"match.model.field3\"></span><span translate=\"PARENTHESES_CLOSE\" ng-if=\"match.model.field3\">\n		</div>\n	</div></script><div class=create-group><form name=crg novalidate ng-class=\"{\'not-ready\':!viewState.isReady}\"><div class=modal-header><h3 translate=CREATE_GROUP_TITLE></h3></div><div class=modal-body><input type=text required ng-minlength=3 ng-maxlength=32 required maxlength=32 ng-model=groupName class=form-control placeholder=\"{{ \'GROUPNAME_PHOLDER\' | translate }}\" autocomplete=off><p class=create-groups-text translate=ADD_MEMBERS></p><div class=search><input type=text ng-model=member placeholder=\"{{ \'ADD_GROUPMEMBER_SEARCH_PHOLDER\' | translate }}\" uib-typeahead=\"r.field1 for r in getMembers($viewValue)\" typeahead-wait-ms=300 typeahead-min-length=2 typeahead-on-select=pickMember($item) typeahead-template-url=memberTemplate.html class=form-control></div><ul class=basket><li ng-repeat=\"(key, item) in members track by $index\"><header class=tier-header ng-if=\"item.type !== \'user\' && item.tierId !== members[key-1].tierId\"><figure class=avatar><span class=dripicons-user-id></span></figure>{{ item.tierName }} <a ng-click=toggleGroup(item.tierId)><span class=dripicons-chevron-down></span></a></header><div ng-class=\"{\'group\':item.type !== \'user\'}\" class=\"{{ item.tierId }}\"><div class=participant><figure class=avatar><avatar source={{item.avatar}} name=\"{{ item.firstName + \' \' + item.lastName }}\" width=40 height=40></avatar></figure>{{item.firstName}} {{item.lastName}} <a ng-click=removeMember(item)><span class=dripicons-cross></span></a></div></div></li></ul></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary\" type=button ng-click=create() ng-disabled=\"crg.$invalid || members.length === 0\"><span translate=CREATE_BTN></span></button></div></form></div>");
$templateCache.put("app/groups/views/create-group.html","<div class=\"content-logged page-create-group\" photo-upload><div class=\"page-view-header clearfix\"><div><a id=header-back-button class=page-view-header__back ng-click=back() style=\"float: left; margin-right: 10px; position: relative\"><span class=dripicons-arrow-thin-left></span></a><div class=page-view-header__text style=\"padding-left: 0\"><strong class=page-view-header__title translate=CREATE_PARENT_GROUP_BTN></strong> <span class=pull-right style=\"font-size: 16px;\n                        line-height: 48px;\n                        max-width: 50%;\n                        white-space: nowrap;\n                        overflow: hidden;\n                        text-overflow: ellipsis\" translate=COMMUNITY_GROUPS></span></div></div></div><div style=\"padding: 0 20px\"><br><input type=text required maxlength=100 ng-model=newgroup.groupName class=form-control placeholder=\"{{ \'GROUPNAME_PHOLDER\' | translate }}\" style=\"border: 1px solid #b6c2db; background-color: #fff; padding: 10px; border-radius: 12px\"><div style=\"margin-top: 20px; margin-bottom: 20px\"><textarea autoresize-textarea ng-model=newgroup.groupDescr class=\"form-control form-control-border\" maxlength=4000 placeholder=\"{{ \'GROUPDESCR_PHOLDER\' | translate }}\" style=\"border: 1px solid #b6c2db; background-color: #fff; padding: 10px; border-radius: 12px\"></textarea></div><div class=group-add-photo ng-click=uploadImage()><img alt=\"\" src={{newgroup.avatarURL}} style=\"max-width: 100%\"><div ng-if=!newgroup.avatarURL><span style=\"cursor: pointer\"><div><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><path fill=#eb004e d=\"M58,13h-8.546l-6.701-7.659C42.562,5.125,42.288,5,42,5H28c-0.288,0-0.562,0.125-0.753,0.341L20.546,13H6 c-2.757,0-5,2.243-5,5v36c0,2.757,2.243,5,5,5h52c2.757,0,5-2.243,5-5V18C63,15.243,60.757,13,58,13z M13,26c-1.103,0-2-0.897-2-2 s0.897-2,2-2s2,0.897,2,2S14.103,26,13,26z M35,50c-7.732,0-14-6.268-14-14s6.268-14,14-14s14,6.268,14,14S42.732,50,35,50z\"></path></g></svg></div><span translate=GROUP_PHOTO style=\"line-height: 36px\"></span></span></div></div><div ng-if=newgroup.avatarURL ng-click=uploadImage()><svg style=\"width: 20px; height: 20px; float: left; margin-top: 7px; margin-right: 10px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=64px height=64px viewBox=\"0 0 64 64\"><g transform=\"translate(0, 0)\"><path fill=#4a9fef d=\"M58,13h-8.546l-6.701-7.659C42.562,5.125,42.288,5,42,5H28c-0.288,0-0.562,0.125-0.753,0.341L20.546,13H6 c-2.757,0-5,2.243-5,5v36c0,2.757,2.243,5,5,5h52c2.757,0,5-2.243,5-5V18C63,15.243,60.757,13,58,13z M13,26c-1.103,0-2-0.897-2-2 s0.897-2,2-2s2,0.897,2,2S14.103,26,13,26z M35,50c-7.732,0-14-6.268-14-14s6.268-14,14-14s14,6.268,14,14S42.732,50,35,50z\"></path></g></svg> <a translate=CHANGE_PHOTO style=\"line-height: 36px\"></a></div><br><div class=group-radio-container style=\"margin-top: 10px\"><div class=\"{{ newgroup.groupVisibility == \'1\' ? \'active\' : \'\' }}\" ng-click=selectGroupVisibility(1)><div class=checkbox></div><span translate=PUBLIC_GROUP></span></div><div class=\"{{ newgroup.groupVisibility == \'2\' ? \'active\' : \'\' }}\" ng-click=selectGroupVisibility(2) v><div class=checkbox></div><span translate=PRIVATE_GROUP></span></div></div><br><div><strong style=\"font-size: medium\" translate=WHO_CAN_SEE_GROUP></strong></div><p translate=CREATE_GROUP_VISIBILITY_LABEL></p><br><div><strong style=\"font-size: medium\" translate=DO_I_NEED_GROUP></strong></div><p style=\"padding-top: 10px\" translate=DO_I_NEED_GROUP_DESC></p><p class=create-groups-text translate=ASSIGN_GROUP_LEADS style=\"margin-top:20px !important;margin-bottom:10px !important\"></p><groupparticipants ng-model=newgroup.leads event-context=true show-tiers=true school-id={{active_school.id}} allow-host-invite=true></groupparticipants><p class=create-groups-text translate=ADD_MEMBER_OPTIONAL style=\"margin-top:0px !important;margin-bottom:10px !important\"></p><groupparticipants ng-model=newgroup.guests event-context=true show-tiers=true school-id={{active_school.id}} allow-host-invite=true></groupparticipants><p class=create-groups-text translate=ADD_TAGS style=\"margin-top:0px !important;margin-bottom:10px !important\"></p><grouptags ng-model=newgroup.tags school-id={{active_school.id}}></grouptags></div><div class=modal-footer><button class=\"btn btn-default\" type=button ui-sref=home><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary btn-primary-pink\" ng-disabled=\"saveingGroup || !newgroup.groupName || !newgroup.leads || newgroup.leads.length == 0\" type=button ng-click=\"saveGroup() \"><span translate=CREATE_BTN></span></button></div></div>");
$templateCache.put("app/groups/views/delete-group-modal.html","<script type=text/ng-template id=memberTemplate.html><a>\n		<span ng-bind-html=\"match.model.field1 | uibTypeaheadHighlight:query\" ng-if=\"match.model.field1\"></span>\n		<span ng-bind-html=\"match.model.field2 | uibTypeaheadHighlight:query\" ng-if=\"match.model.field2\"></span>\n	</a></script><div class=delete-group><div class=modal-header><h3 translate=DELETE_GROUPS_HEADER translate-values=\"{\'groupName\':currentGroupName}\"></h3></div><div class=modal-body><p class=add-members-text translate=DELETE_GROUPS_TEXT></p></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary\" type=button ng-click=delete()><span translate=DELETE_BTN></span></button></div></div>");
$templateCache.put("app/groups/views/delete-interest-group-modal.html","<div><div class=modal-header><h3 translate=DELETE_INTEREST_GROUPS_HEADER translate-values=\"{\'groupName\':currentGroupName}\"></h3></div><div class=modal-body><p class=add-members-text translate=DELETE_GROUPS_TEXT></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=DELETE_BTN ng-click=confirm() ng-disabled=deletingGroup><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/groups/views/delete-post-modal.html","<div><div class=modal-header><h3 translate=DELETE_POST_HEADER></h3></div><div class=modal-body><p translate=DELETE_POST_TEXT></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=OK_BTN ng-click=confirm()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/groups/views/edit-group-name-modal.html","<script type=text/ng-template id=memberTemplate.html><div class=\"match-container\">	\n		<div class=\"match-container-parentname\">\n			<span ng-bind-html=\"match.model.field1 | uibTypeaheadHighlight:query\" ng-if=\"match.model.field1\"></span>\n			<span ng-bind-html=\"match.model.field2 | uibTypeaheadHighlight:query\" ng-if=\"match.model.field2\"></span>\n		</div>\n		<div>\n			<span translate=\"PARENTHESES_OPEN\" ng-if=\"match.model.field3\"></span><span  ng-bind-html=\"(m | uibTypeaheadHighlight:query) + ($last ? \'\' : \', \')\"  ng-repeat=\"m in match.model.field3\" ng-if=\"match.model.field3\"></span><span translate=\"PARENTHESES_CLOSE\" ng-if=\"match.model.field3\">\n		</div>\n	</div></script><div class=edit-group-name><form name=egn novalidate ng-class=\"{\'not-ready\':!viewState.isReady}\"><div class=modal-header><h3 translate=EDIT_GROUP_NAME_TITLE></h3></div><div class=modal-body><input type=text required ng-minlength=5 ng-maxlength=100 maxlength=100 ng-model=groupName class=form-control placeholder=\"{{ \'UPDATE_GROUP_NAME_PHOLDER\' | translate }}\"></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary\" type=button ng-click=save() ng-disabled=egn.$invalid><span translate=SAVE_BTN></span></button></div></form></div>");
$templateCache.put("app/groups/views/group-members.html","<section class=\"group-members group-view\" ng-class=\"{\'is-visible\':viewState.isReady}\"><div class=\"page-view-header clearfix\"><div><a id=header-back-button class=page-view-header__back ng-click=back() style=\"float: left; margin-right: 10px; position: relative\"><span class=dripicons-arrow-thin-left></span></a><div class=page-view-header__text style=\"padding-left: 0\"><strong class=page-view-header__title translate=BACK_BTN></strong> <span class=pull-right style=\"font-size: 16px; line-height: 48px; max-width: 50%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis\">{{group.groupName}}</span></div></div></div><div><div><div><div class=members-card><div class=member ng-repeat=\"m in group.groupMembers\" ui-sref=users.manageparents><figure class=group-member-avatar title=\"{{::m.firstName }} {{::m.lastName }}\"><avatar source={{m.avatar}} name=\"{{ m.firstName + \' \' + m.lastName }}\" width=40 height=40 my=false title=\"{{m.firstName}} {{m.lastName}}\"></avatar></figure><span class=member-name>{{m.firstName}} {{m.lastName}} {{m.userRole == \'Pending\' ? \'(Pending)\' : \'\'}}</span></div></div></div></div></div></section>");
$templateCache.put("app/groups/views/group-type-change-modal.html","<div><div class=modal-body style=padding-top:10px><p class=add-members-text translate=CHANGE_GROUP_TYPE_TEXT></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=I_AM_OK_WITH_THAT ng-click=confirm() ng-disabled=deletingGroup><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></button></button></div></div>");
$templateCache.put("app/groups/views/group-view.html","<section class=group-view add-participants ng-class=\"{\'is-visible\':viewState.isInitiated}\" post-likes><div class=\"page-view-header clearfix\"><div><a id=header-back-button class=page-view-header__back ng-click=back() style=\"float: left; margin-right: 10px; position: relative\"><span class=dripicons-arrow-thin-left></span></a><div class=page-view-header__text style=\"padding-left: 0\"><strong class=page-view-header__title translate=BACK_BTN></strong><nav class=\"has-dropdown is-relative pull-right mobile-menu\" ng-if=\"(group.type === \'TIER_GROUP\' && adminHaveRoles(\'AMBASSADOR\')) || group.type === \'PARENT_PUBLIC\' || group.type === \'PARENT_PRIVATE\' || group.type === \'ADMIN_GROUP\'\" style=\"margin-top: 15px\"><a translate=MENU></a><ul class=dropdown-menu><li><a ui-sref=\"groups.members({\'id\': groupId})\"><span translate=GROUPS_VIEW_MEMBERS></span></a></li><li ng-if=\"me.role === AMBASSADOR\"><a ng-click=editGroup()><span translate=EDIT_GROUP_DETAILS></span></a></li><li ng-if=\"group.type === \'PARENT_PUBLIC\' || group.type === \'PARENT_PRIVATE\'\"><a ng-click=deleteGroup()><span translate=DELETE_GROUP></span></a></li></ul></nav></div></div></div><div class=page-container-header-from-top><div class=row><div class=col-md-7><aside class=group-posts><post-asset-admin ng-repeat=\"p in posts\" post-content={{p}} post-context=GROUP_VIEW user-avatar=active_user.avatar user-name=userName disable-group-name=true></post-asset-admin></aside><p ng-show=\"posts.length === 0 && !loadingPosts\" translate=NO_POSTS></p><div ng-show=hasMorePosts() class=vi-loader><div><svg class=circular viewBox=\"25 25 50 50\"><circle class=path cx=50 cy=50 r=20 fill=none stroke-width=4 stroke-miterlimit=10></circle></svg></div></div><p></p></div><div class=col-md-2></div><div class=col-md-4></div></div></div></section>");
$templateCache.put("app/groups/views/groups-list-lg.html","<div class=groups-list-lg ng-class=\"{\'is-visible\':viewState.isReady}\"><div class=\"page-view-header clearfix\"><div><strong class=page-view-header__title translate=GROUPS_HEADER class=pull-left></strong> <button class=\"btn btn-primary btn-sm pull-right\" ng-click=createCommunityGroup() type=button class=\"btn btn-primary\" translate=CREATE_INTEREST_GROUP style=margin-top:5px></button></div></div><div class=page-container-header-from-top style=\"margin-top: 0 !important\"><div class=page-view-subheader><div class=row><div class=col-md-6><div class=\"is-relative page-view-header__search\"><input type=search class=form-control placeholder=\"{{ \'SEARCH_PHOLDER\' | translate }}\" ng-model=keyword style=\"border: 1px solid; padding-left: 10px\"> <span class=\"icon dripicons-search\" style=\"position: absolute; right: 10px; top: 10px\"></span></div></div><div class=col-md-6><div></div></div></div></div><div style=\"margin-bottom: 10px; padding-left: 15px\"><span translate=INTEREST_GROUP_LIST_TOOLTIP></span></div><div style=\"padding: 0 15px; margin-top: 20px\"><div><!-- School groups && Admin groups --><section class=\"groups-list row\" ng-repeat=\"groupCluster in groups track by $index\"><div class=\"col-md-6 col-sm-6 col-xs-12\" ng-if=\"g.type === \'SCHOOL_GROUP\' || g.type === \'ADMIN_GROUP\'\" ng-repeat=\"g in groupCluster | filter:groupFilter track by $index\"><div><div class=group-item-lg ui-sref=\"groups.view({\'id\':g.id})\"><div ng-class=\"{ \'group-info group-school clearfix\': g.type === \'SCHOOL_GROUP\', \'group-info group-admin clearfix\': g.type === \'ADMIN_GROUP\' }\"><div class=group-member-count><figure class=clearfix><span class=\"icon dripicons-user\"></span> <span class=group-number>{{g.memberCount }}</span></figure></div></div></div><div class=group-lock-names><div class=group-lock><span class=dripicons-lock></span></div><div class=group-names style=margin-top:0><div class=group-names-child><div class=group-name ui-sref=\"groups.view({\'id\':g.id})\">{{g.name}}</div><div translate={{g.type}} class=group-type>{{g.type}}</div><div class=group-type><span ng-if=g.lastActivity translate=LAST_ACTIVITY></span>{{g.lastActivity | date:\'dd.MM.yyyy\'}} <span ng-if=!g.lastActivity translate=NO_ACTIVITY></span></div></div></div></div></div></div></section><!-- Tier groups  --><section class=\"groups-list row\" ng-repeat=\"groupCluster in groups track by $index\"><div class=\"col-md-6 col-sm-6 col-xs-12\" ng-if=\"g.type === \'TIER_GROUP\'\" ng-repeat=\"g in groupCluster | filter:groupFilter | orderBy:\'name\' track by $index\"><div><div class=group-item-lg ui-sref=\"groups.view({\'id\':g.id})\"><div class=\"group-info group-tier clearfix\"><div class=group-member-count><figure class=clearfix><span class=\"icon dripicons-user\"></span> <span class=group-number>{{g.memberCount }}</span></figure></div></div></div><div class=group-lock-names><div class=group-lock><span class=dripicons-lock></span></div><div class=group-names style=margin-top:0><div class=group-names-child><div class=group-name ui-sref=\"groups.view({\'id\':g.id})\">{{g.name}}</div><div translate=TIER_GROUP class=group-type>{{g.type}}</div><div class=group-type><span ng-if=g.lastActivity translate=LAST_ACTIVITY></span>{{g.lastActivity | date:\'dd.MM.yyyy\'}} <span ng-if=!g.lastActivity translate=NO_ACTIVITY></span></div></div></div></div></div></div></section><!-- Parent groups --><!-- Closed groups --><!-- Public groups --><section class=\"groups-list row\" ng-repeat=\"groupCluster in groups track by $index\"><div ng-repeat=\"g in groupCluster | filter:groupFilter | orderBy:\'name\' track by $index\"><div class=\"col-md-6 col-sm-6 col-xs-12\" ng-if=\"g.type === \'PARENT_PRIVATE\'\" style=\"min-height:110px; margin-bottom:10px\"><div style=\"display: inline-flex; width:100%\"><div class=group-item-lg ui-sref=\"groups.view({\'id\':g.id})\" style=\"cursor: pointer; padding-top:10px\"><div class=\"group-info group-comm clearfix\" ng-class=\"{\'group-tier-archived\': g.archived}\"><div class=group-member-count><figure class=clearfix><span class=\"icon dripicons-user\"></span> <span class=group-number>{{g.memberCount }}</span></figure></div></div></div><div class=group-lock-names style=\"height:100%; display:inline-flex; width:70%\"><div class=group-lock style=\"margin-right:5px; padding-top:15px\"><svg width=18 height=18 viewBox=\"0 0 24 24\" fill=none xmlns=http://www.w3.org/2000/svg><rect x=4 y=11.117 width=16 height=10.597 rx=2 stroke=#627293 stroke-width=1.5 stroke-linecap=square /><path d=\"M16.444 7.585v-.883c.025-2.415-1.925-4.391-4.355-4.416H12c-2.43-.024-4.42 1.913-4.444 4.327v.972\" stroke=#627293 stroke-width=1.5 stroke-linecap=square /><circle cx=11.75 cy=16.399 r=1.75 stroke=#627293 stroke-width=1.5 stroke-linecap=square /></svg></div><div class=group-names style=margin-top:0><div class=group-names-child style=\"display: grid; width:auto\"><div class=group-name ui-sref=\"groups.view({\'id\':g.id})\" style=\"text-decoration: underline; cursor: pointer; width:auto\"><span ng-if=g.archived>Archived -</span>	{{g.name}}</div><div translate=PARENT_PRIVATE class=group-type>{{g.type}}</div><div class=group-type><span ng-if=g.lastActivity translate=LAST_ACTIVITY></span>{{g.lastActivity | date:\'dd.MM.yyyy\'}} <span ng-if=!g.lastActivity translate=NO_ACTIVITY></span></div><div class=group-type ng-if=g.groupLeadText>{{g.groupLeadText}}</div></div></div></div></div></div><div class=\"col-md-6 col-sm-6 col-xs-12\" ng-if=\"g.type === \'PARENT_PUBLIC\'\" style=\"min-height:110px; margin-bottom:10px\"><div style=\"display: inline-flex; width:100%\"><div class=group-item-lg ui-sref=\"groups.view({\'id\':g.id})\" style=\"cursor: pointer; padding-top:10px\"><div class=\"group-info group-comm clearfix\"><div class=group-member-count><figure class=clearfix><span class=\"icon dripicons-user\"></span> <span class=group-number>{{g.memberCount }}</span></figure></div></div></div><div class=group-lock-names style=\"height:100%; display:inline-flex; width:70%\"><div class=group-lock style=\"margin-right:5px; padding-top:15px\"><svg width=18 height=18 viewBox=\"0 0 24 24\" fill=none xmlns=http://www.w3.org/2000/svg><path d=\"M18.417 11.083H5.583c-1.012 0-1.833.821-1.833 1.834v7.333c0 1.013.82 1.833 1.833 1.833h12.834c1.012 0 1.833-.82 1.833-1.833v-7.333c0-1.013-.82-1.834-1.833-1.834z\" stroke=#627293 stroke-width=1.5 stroke-miterlimit=10 stroke-linecap=square /><path d=\"M12 18.417a1.833 1.833 0 1 0 0-3.667 1.833 1.833 0 0 0 0 3.667zM15.667 3.72a4.533 4.533 0 0 0-3.575-1.803H12a4.538 4.538 0 0 0-4.583 4.491v1.009\" stroke=#627293 stroke-width=1.5 stroke-miterlimit=10 stroke-linecap=square /></svg></div><div class=group-names style=margin-top:0><div class=group-names-child style=\"display: grid; width:auto\"><div class=group-name ui-sref=\"groups.view({\'id\':g.id})\" style=\"text-decoration: underline; cursor: pointer; width:auto\">{{g.name}}</div><div translate=PARENT_PUBLIC class=group-type>{{g.type}}</div><div class=group-type><span ng-if=g.lastActivity translate=LAST_ACTIVITY></span>{{g.lastActivity | date:\'dd.MM.yyyy\'}} <span ng-if=!g.lastActivity translate=NO_ACTIVITY></span></div><div class=group-type ng-if=g.groupLeadText>{{g.groupLeadText}}</div></div></div></div></div></div></div></section></div></div></div></div>");
$templateCache.put("app/groups/views/groups-list.html","<div ng-class=\"{\'not-ready\':!viewState.isReady}\"><div><div class=\"groups-header clearfix\"><strong translate=GROUPS_HEADER class=pull-left></strong></div></div><div><section class=\"groups-list row\"><div class=\"col-md-6 col-sm-6 col-xs-12\" ng-repeat=\"g in groups\"><div class=group-item ui-sref=\"groups.view({\'id\':g.groupId})\"><div class=group-member-count><figure class=clearfix><span class=\"icon dripicons-user\"></span> <span class=number>{{::g.memberCount }}</span></figure></div><div class=group-info><h4>{{::g.name }}</h4><p translate=GROUP_CREATED_BY translate-values=\"{\'fullName\':g.createdBy}\"></p></div></div></div></section></div></div>");
$templateCache.put("app/groups/views/interest-group-view.html","<section class=group-view add-participants post-likes ng-show=viewState.isReady photo-upload><div class=\"page-view-header post-header {{ premium_ad ? \'premium-ad-header\' : \'\' }}\"><div style=\"padding: 0\"><div class=premium-ad-clear style=\"padding: 0 15px\"><div premium-ad></div></div><div style=\"position: relative; display: flex\"><div class=pull-left style=\"width: 80%\"><a id=header-back-button class=page-view-header__back ng-click=back() style=\"float: left; margin-right: 10px; position: relative\"><span class=dripicons-arrow-thin-left></span></a> <strong class=\"page-view-header__title elipsis-text\" style=\"max-width: 100%; overflow: hidden\">{{group.title}}</strong></div><div class=pull-right><nav class=\"has-dropdown is-relative\" style=\"line-height: 25px; margin-top:5px\"><svg ng-if=\"(group.type == \'PARENT_PRIVATE\' || group.type == \'PARENT_PUBLIC\')\" style=\"height: 43px; width: 44px; padding: 14px 10px; padding-bottom: 3px\" xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=32px height=32px viewBox=\"0 0 32 32\"><g transform=\"translate(0, 0)\"><circle fill=#51a8f9 cx=4 cy=16 r=3></circle><circle data-color=color-2 fill=#51a8f9 cx=16 cy=16 r=3></circle><circle fill=#51a8f9 cx=28 cy=16 r=3></circle></g></svg><ul class=dropdown-menu style=\"right: 41px; top: 22px; left: auto\"><li><a ng-click=\"addMembersToGroup(2, onDialogCallback)\" translate=GROUP_VIEW_MEMBERS></a></li><li><a ng-click=\"addMembersToGroup(1, onDialogCallback)\"><span translate=GROUPS_LEADS></span></a></li><li ng-if=\"group.members && group.members.length > 0\"><a ng-click=removeMembersFromGroup(onDialogCallback)><span translate=GROUPS_REMOVE_MEMBERS></span></a></li><li ng-click=deleteGroups()><a><span translate=GROUPS_DELETE></span></a></li><li ng-click=copyParentLink() ng-if=group.parentUrl><a><span translate=GROUP_COPY_PARENT_LINK></span></a></li></ul></nav></div></div></div></div><div class=page-container-header-from-top style=\"min-height: 400px; margin-top: 0!important\"><div><div class=\"main-right-col active\" ng-show=viewState.isInitiated><div class=\"right-section picture-section\"><div><div ng-class=\"{\'show-for-owner\': true}\" class=\"edit-button ng-scope\" ng-click=uploadImage()><span class=\"icon dripicons-camera\" style=margin-left:2px></span></div><div class=img style=\"background-image: url(\'{{ group.avatarURL }}\')\"></div></div></div><div class=group-title-blue><h4><div ng-class=\"{\'show-for-owner\': true}\" ng-show=!peditTitle class=\"edit-button title-holder ng-scope\" ng-mouseup=editTitle() style=border:none;margin:0;padding-left:0px ng-if=\"(group.type == \'PARENT_PUBLIC\' || group.type == \'PARENT_PRIVATE\')\"><span ng-class=\"{\'show-for-owner\': true}\" class=\"icon dripicons-pencil\" style=\"font-size: 18px\"></span></div><span ng-if=!peditTitle style=\"word-break: break-word\"><span ng-if=group.archived>Archived -</span>	{{group.title}}</span><div class=click-editor ng-if=peditTitle click-outside=updateOutsideTitle()><input ng-model=peditTitleInput type=text maxlength=100 ng-change=updateTitleModel(peditTitleInput)><div><span class=\"icon dripicons-checkmark\" ng-click=updateTitle()></span> <span class=\"icon dripicons-cross\" ng-click=cancelTitle()></span></div></div></h4></div><div class=\"group-view-members right-section\" style=\"margin-bottom: 0; border-top: none\"><div class=group-radio-container ng-if=\"(group.type == \'PARENT_PUBLIC\' || group.type == \'PARENT_PRIVATE\')\"><div class=\"{{ group.type == \'PARENT_PUBLIC\' ? \'active\' : \'\' }}\" ng-click=selectGroupVisibility(1)><div class=checkbox></div><span translate=PUBLIC_GROUP></span></div><div class=\"{{ group.type == \'PARENT_PRIVATE\' ? \'active\' : \'\' }}\" ng-click=selectGroupVisibility(2) v><div class=checkbox></div><span translate=PRIVATE_GROUP></span></div></div><!-- Group Info for Ambassadors & Reps --><div ng-if=\"group.type == \'ADMIN_GROUP\'\" style=\"margin: 10px 0 15px\"><span class=\"icons dripicons-information\"></span> You’re in this group because you’re an ambassador or rep. <a href=#/school/details>See school profile</a></div><!-- Group Info for Ambassadors & Reps End --><!-- Group Info Year Groups --><div ng-if=\"group.type == \'TIER_GROUP\'\" style=\"margin: 10px 0 15px\"><div><span class=\"icons dripicons-information\"></span> This is your child’s year group. If you think you should be in a different group,</div><div style=\"cursor: pointer; color: #eb004e; font-weight: 600; text-decoration: none\" ng-click=openProfile()>update your profile</div></div><!-- Group Info Year Groups End --><div class=users-list><span class=visibility-info><span ng-if=\"group.type == \'PARENT_PRIVATE\'\" translate=PRIVATE_GROUP></span> <span ng-if=\"group.type == \'PARENT_PUBLIC\'\" translate=PUBLIC_GROUP></span> </span><span ng-if=\"group.type == \'PARENT_PRIVATE\' || group.type == \'PARENT_PUBLIC\'\">-</span> <span ng-if=group.processingMembers>Processing new members... </span><span ng-if=!group.processingMembers>{{ group.owners.length + group.members.length }} member(s) </span><a ng-if=\"group.type != \'SCHOOL_GROUP\'\" translate=GROUPS_VIEW_ALL ng-click=openMembers(2) style=\"margin-left: 5px\"></a></div><div ng-if=\"group.type != \'SCHOOL_GROUP\'\" style=\"overflow: auto\"><div ng-click=openMembers(2) ng-if=\"group.owners || group.members || group.waitingApproval\" class=\"group-view-member-avatars clearfix\"><div ng-repeat=\"m in group.owners | limitTo: 3\"><figure class=group-member-avatar title=\"{{m.name }}\"><avatar source={{m.avatar}} name=\"{{ m.name }}\" width=40 height=40 my=false title={{m.name}}></avatar></figure></div><div ng-repeat=\"m in group.members | limitTo: 3\"><figure class=group-member-avatar title=\"{{m.name }}\"><avatar source={{m.avatar}} name=\"{{ m.name }}\" width=40 height=40 my=false title={{m.name}}></avatar></figure></div></div><span ng-if=\"(group.type == \'PARENT_PUBLIC\' || group.type == \'PARENT_PRIVATE\')\"><button ng-click=\"addMembersToGroup(2, onDialogCallback)\" type=button class=\"btn btn-primary add-join-button\">+ Add members</button></span></div><div class=users-list-separator></div><div><!------------ Group Tags Start -----------><div class=group-tags ng-if=isGroupWithTags><div class=group-view-member-nums>Group tags</div><div class=tags-area><div class=tags><ul><li ng-repeat=\"tag in group.tags track by $index\">{{tag}} <span ng-click=\"removeGroupTag(tag, $index)\" class=\"icon dripicons-cross\"></span></li></ul></div></div><div><span><input type=text ng-model=newTag.tag placeholder=\"{{ \'ADD_TAGS_PLACEHOLDER\' | translate }}\" uib-typeahead=\"r for r in getTags($viewValue)\" typeahead-focus-first=false typeahead-wait-ms=300 typeahead-min-length=2 typeahead-on-select=pickTag($item) ng-keyup=tagKeyUp($event) typeahead-template-url=grouptagsTemplate.html class=tags-input></span></div><div class=clear></div></div><!------------ Group Tags End -----------><div class=users-list-separator ng-if=isGroupWithTags></div><div><div class=group-view-member-nums>About this group</div><time><span translate=CREATED_AT></span> {{group.created | date:\'h:mm a, MMM dd\'}}</time><div style=\"margin-top: 4px\"><span ng-if=\"!group.description && !peditDescr\" translate=GROUP_DESCRIPTION></span><div ng-class=\"{\'show-for-owner\': true}\" ng-show=!peditDescr class=\"edit-button description-holder ng-scope\" ng-mouseup=editDescr() style=border:none;margin:0><span class=\"icon dripicons-pencil\" style=\"font-size: 18px\"></span></div><p ng-show=!peditDescr class=multiple-line-text style=\"font-size: 15px\" ng-bind-html=getHtmlVersion(group.description)></p></div><div class=click-editor ng-if=peditDescr click-outside=updateOutsideDescr()><textarea ng-model=peditDescrInput ng-change=updateDescriptionModel(peditDescrInput) autoresize-textarea placeholder=\"Write a description...\" style=\"padding-bottom: 13px !important; overflow-y: scroll !important\" maxlength=4000>\n						</textarea><div style=\"padding-top:0px !important\"><span class=\"icon dripicons-checkmark\" ng-click=updateDescr()></span> <span class=\"icon dripicons-cross\" ng-click=cancelDescr()></span></div></div><time ng-if=group.archived><span translate=GROUP_ARCHIVED></span> <span style=color:black>{{group.archivedAt | date:\'dd MMM yyyy h:mm a\'}}</span></time></div></div></div></div></div></div></section><script type=text/ng-template id=grouptagsTemplate.html><div class=\"match-container\">\n		<span ng-bind-html=\"match.model | uibTypeaheadHighlight:query\" ng-if=\"match.model\"></span>\n	</div></script>");
$templateCache.put("app/groups/views/interest-groups-list-lg.html","<div class=groups-list-lg ng-class=\"{\'is-visible\':viewState.isReady}\"><div class=\"page-view-header clearfix\"><div><strong class=page-view-header__title translate=INTEREST_GROUPS_HEADER class=pull-left></strong> <button class=\"btn btn-primary btn-sm pull-right\" ng-click=createCommunityGroup() type=button class=\"btn btn-primary\" translate=CREATE_INTEREST_GROUP style=margin-top:5px></button></div></div><div class=page-container-header-from-top style=\"margin-top: 0 !important\"><div class=page-view-subheader><div class=row><div class=col-md-6><div class=\"is-relative page-view-header__search\"><input type=search class=form-control placeholder=\"{{ \'SEARCH_PHOLDER\' | translate }}\" ng-model=keyword style=\"border: 1px solid; padding-left: 10px\"> <span class=\"icon dripicons-search\" style=\"position: absolute; right: 10px; top: 10px\"></span></div></div><div class=col-md-6><div></div></div></div></div><div style=\"margin-bottom: 10px; padding-left: 15px; font-weight:600\"><span translate=INTEREST_GROUP_LIST_TOOLTIP_STAFF ng-if=!integrationEnabled()></span> <span translate=INTEREST_GROUP_LIST_TOOLTIP_INTEGRATED_STAFF ng-if=\"adminHaveRoles(\'STAFF\') && integrationEnabled()\"></span></div><div style=\"padding: 0 15px\"><div><!-- Archived groups --><section class=\"groups-list row\" style=\"margin-top:20px; margin-bottom:20px\" ng-if=\"archivedGroups && archivedGroups.length > 0\"><p translate=INTEREST_GROUPS_ARCHIVED_HEADER style=\"font-size:18px; font-weight:600; padding-left:15px; margin-bottom:0px\"></p><p ng-if=archivedGroupsDate style=\"font-size:14px; font-weight:600; padding-left:15px; margin-top:5px; margin-bottom:0px\"><span translate=INTEREST_GROUPS_ARCHIVED_DATE></span> {{archivedGroupsDate | date:\'dd.MM.yyyy\'}}</p><div style=margin-top:10px class=\"col-md-6 col-sm-6 col-xs-12\" ng-repeat=\"g in archivedGroups | filter:groupFilter | orderBy:\'name\' track by $index\"><div style=\"display: inline-flex; width:100%\"><div class=group-item-lg ui-sref=\"groups.interestGroupsView({\'id\':g.id})\" style=\"cursor: pointer\"><div class=\"group-info group-school clearfix\" ng-style=\"!g.archived && {\'background-color\': \'#FFC4A0\'}\" ng-class=\"{\'group-tier-archived\': g.archived}\"><div class=group-member-count><figure class=clearfix style=\"display: inline-flex;margin-top:3px\"><span><svg width=24 height=24 viewBox=\"0 0 24 24\" fill=none xmlns=http://www.w3.org/2000/svg><path d=\"M7.35246 12.6608C4.83749 13.9048 3.25 16.5007 3.25 19.333H4.75C4.75 17.0593 6.02451 14.9912 8.01754 14.0052L7.35246 12.6608ZM4 19.333C3.46447 19.8581 3.46477 19.8584 3.46508 19.8587C3.4652 19.8588 3.46552 19.8591 3.46575 19.8594C3.46622 19.8599 3.46673 19.8604 3.46727 19.8609C3.46837 19.862 3.46963 19.8633 3.47106 19.8647C3.47391 19.8676 3.47743 19.8711 3.4816 19.8752C3.48995 19.8834 3.50094 19.8941 3.51461 19.907C3.54194 19.933 3.57995 19.9681 3.62882 20.011C3.72654 20.0969 3.86774 20.2141 4.05376 20.3521C4.42582 20.6281 4.9773 20.9869 5.71864 21.3427C7.20435 22.0557 9.43983 22.75 12.5 22.75V21.25C9.67517 21.25 7.66065 20.6108 6.36761 19.9903C5.71958 19.6793 5.24949 19.3714 4.94734 19.1473C4.79624 19.0353 4.68717 18.9442 4.6189 18.8842C4.58477 18.8542 4.56085 18.832 4.547 18.8189C4.54007 18.8123 4.53567 18.808 4.53376 18.8061C4.53281 18.8052 4.53248 18.8048 4.53277 18.8051C4.53292 18.8053 4.53322 18.8056 4.53368 18.806C4.53391 18.8063 4.53418 18.8065 4.53449 18.8069C4.53464 18.807 4.5349 18.8073 4.53498 18.8074C4.53525 18.8076 4.53553 18.8079 4 19.333ZM12.5 22.75C15.5602 22.75 17.7957 22.0557 19.2814 21.3427C20.0227 20.9869 20.5742 20.6281 20.9462 20.3521C21.1323 20.2141 21.2735 20.0969 21.3712 20.011C21.42 19.9681 21.4581 19.933 21.4854 19.907C21.4991 19.8941 21.5101 19.8834 21.5184 19.8752C21.5226 19.8711 21.5261 19.8676 21.5289 19.8647C21.5304 19.8633 21.5316 19.862 21.5327 19.8609C21.5333 19.8604 21.5338 19.8599 21.5342 19.8594C21.5345 19.8591 21.5348 19.8588 21.5349 19.8587C21.5352 19.8584 21.5355 19.8581 21 19.333C20.4645 18.8079 20.4648 18.8076 20.465 18.8074C20.4651 18.8073 20.4654 18.807 20.4655 18.8069C20.4658 18.8065 20.4661 18.8063 20.4663 18.806C20.4668 18.8056 20.4671 18.8053 20.4672 18.8051C20.4675 18.8048 20.4672 18.8052 20.4662 18.8061C20.4643 18.808 20.4599 18.8123 20.453 18.8189C20.4391 18.832 20.4152 18.8542 20.3811 18.8842C20.3128 18.9442 20.2038 19.0353 20.0527 19.1473C19.7505 19.3714 19.2804 19.6793 18.6324 19.9903C17.3393 20.6108 15.3248 21.25 12.5 21.25V22.75ZM21.75 19.333C21.75 16.4986 20.1623 13.9047 17.6464 12.6607L16.9816 14.0053C18.9757 14.9913 20.25 17.0574 20.25 19.333H21.75ZM16.327 6.667C16.327 7.78033 15.8749 9.13229 15.1226 10.2019C14.3606 11.2856 13.4139 11.917 12.5 11.917V13.417C14.1131 13.417 15.4549 12.3369 16.3496 11.0648C17.2541 9.77871 17.827 8.13067 17.827 6.667H16.327ZM12.5 11.917C11.5855 11.917 10.6389 11.2855 9.87701 10.202C9.12491 9.13239 8.673 7.78041 8.673 6.667H7.173C7.173 8.13059 7.74559 9.77861 8.64999 11.0648C9.54459 12.337 10.8865 13.417 12.5 13.417V11.917ZM8.673 6.667C8.673 4.48952 10.4008 2.75 12.5 2.75V1.25C9.54522 1.25 7.173 3.68848 7.173 6.667H8.673ZM12.5 2.75C14.6 2.75 16.327 4.4903 16.327 6.667H17.827C17.827 3.6897 15.456 1.25 12.5 1.25V2.75Z\" fill=#627293 /></svg> </span><span class=group-number style=\"margin-top:7px;margin-left: -4px\">{{g.memberCount }}</span></figure></div></div></div><div class=group-lock-names style=\"height:100%; display:inline-flex; width:70%\"><div class=group-lock style=margin-right:5px><svg width=18 height=18 viewBox=\"0 0 24 24\" fill=none xmlns=http://www.w3.org/2000/svg><rect x=4 y=11.117 width=16 height=10.597 rx=2 stroke=#627293 stroke-width=1.5 stroke-linecap=square /><path d=\"M16.444 7.585v-.883c.025-2.415-1.925-4.391-4.355-4.416H12c-2.43-.024-4.42 1.913-4.444 4.327v.972\" stroke=#627293 stroke-width=1.5 stroke-linecap=square /><circle cx=11.75 cy=16.399 r=1.75 stroke=#627293 stroke-width=1.5 stroke-linecap=square /></svg></div><div class=group-names style=margin-top:0><div class=group-names-child style=\"display:grid; width:auto\"><div class=group-name ui-sref=\"groups.interestGroupsView({\'id\':g.id})\" style=\"text-decoration: underline; cursor: pointer; width:auto\"><span ng-if=g.archived>Archived -</span>	{{g.name}}</div><div translate=SCHOOL_GROUP class=group-type>{{g.type}}</div><div class=group-type><span ng-if=g.lastActivity translate=LAST_ACTIVITY></span>{{g.lastActivity | date:\'dd.MM.yyyy\'}} <span ng-if=!g.lastActivity translate=NO_ACTIVITY></span></div></div></div></div></div></div></section><!-- Parent groups --><!-- Closed groups --><section class=\"groups-list row\" style=margin-top:20px ng-repeat=\"groupCluster in groups track by $index\"><p ng-if=\"archivedGroups && archivedGroups.length > 0\" translate=INTEREST_GROUPS_NORMAL_HEADER style=\"font-size:18px; font-weight:600; padding-left:15px;margin-bottom:20px\"></p><div class=\"col-md-6 col-sm-6 col-xs-12\" style=\"min-height:110px; margin-bottom:10px\" ng-repeat=\"g in groupCluster | filter:groupFilter | orderBy:\'name\' track by $index\"><div ng-if=\"g.type === \'PARENT_PRIVATE\'\" style=\"display: inline-flex; width:100%\"><div class=group-item-lg ui-sref=\"groups.interestGroupsView({\'id\':g.id})\" style=\"cursor: pointer; padding-top:10px\"><div class=\"group-info group-comm clearfix\" ng-style=\"!g.archived && {\'background-color\': \'#FFC4A0\'}\" ng-class=\"{\'group-tier-archived\': g.archived}\"><div class=group-member-count><figure class=clearfix style=\"display: inline-flex;margin-top:3px\"><span><svg width=24 height=24 viewBox=\"0 0 24 24\" fill=none xmlns=http://www.w3.org/2000/svg><path d=\"M7.35246 12.6608C4.83749 13.9048 3.25 16.5007 3.25 19.333H4.75C4.75 17.0593 6.02451 14.9912 8.01754 14.0052L7.35246 12.6608ZM4 19.333C3.46447 19.8581 3.46477 19.8584 3.46508 19.8587C3.4652 19.8588 3.46552 19.8591 3.46575 19.8594C3.46622 19.8599 3.46673 19.8604 3.46727 19.8609C3.46837 19.862 3.46963 19.8633 3.47106 19.8647C3.47391 19.8676 3.47743 19.8711 3.4816 19.8752C3.48995 19.8834 3.50094 19.8941 3.51461 19.907C3.54194 19.933 3.57995 19.9681 3.62882 20.011C3.72654 20.0969 3.86774 20.2141 4.05376 20.3521C4.42582 20.6281 4.9773 20.9869 5.71864 21.3427C7.20435 22.0557 9.43983 22.75 12.5 22.75V21.25C9.67517 21.25 7.66065 20.6108 6.36761 19.9903C5.71958 19.6793 5.24949 19.3714 4.94734 19.1473C4.79624 19.0353 4.68717 18.9442 4.6189 18.8842C4.58477 18.8542 4.56085 18.832 4.547 18.8189C4.54007 18.8123 4.53567 18.808 4.53376 18.8061C4.53281 18.8052 4.53248 18.8048 4.53277 18.8051C4.53292 18.8053 4.53322 18.8056 4.53368 18.806C4.53391 18.8063 4.53418 18.8065 4.53449 18.8069C4.53464 18.807 4.5349 18.8073 4.53498 18.8074C4.53525 18.8076 4.53553 18.8079 4 19.333ZM12.5 22.75C15.5602 22.75 17.7957 22.0557 19.2814 21.3427C20.0227 20.9869 20.5742 20.6281 20.9462 20.3521C21.1323 20.2141 21.2735 20.0969 21.3712 20.011C21.42 19.9681 21.4581 19.933 21.4854 19.907C21.4991 19.8941 21.5101 19.8834 21.5184 19.8752C21.5226 19.8711 21.5261 19.8676 21.5289 19.8647C21.5304 19.8633 21.5316 19.862 21.5327 19.8609C21.5333 19.8604 21.5338 19.8599 21.5342 19.8594C21.5345 19.8591 21.5348 19.8588 21.5349 19.8587C21.5352 19.8584 21.5355 19.8581 21 19.333C20.4645 18.8079 20.4648 18.8076 20.465 18.8074C20.4651 18.8073 20.4654 18.807 20.4655 18.8069C20.4658 18.8065 20.4661 18.8063 20.4663 18.806C20.4668 18.8056 20.4671 18.8053 20.4672 18.8051C20.4675 18.8048 20.4672 18.8052 20.4662 18.8061C20.4643 18.808 20.4599 18.8123 20.453 18.8189C20.4391 18.832 20.4152 18.8542 20.3811 18.8842C20.3128 18.9442 20.2038 19.0353 20.0527 19.1473C19.7505 19.3714 19.2804 19.6793 18.6324 19.9903C17.3393 20.6108 15.3248 21.25 12.5 21.25V22.75ZM21.75 19.333C21.75 16.4986 20.1623 13.9047 17.6464 12.6607L16.9816 14.0053C18.9757 14.9913 20.25 17.0574 20.25 19.333H21.75ZM16.327 6.667C16.327 7.78033 15.8749 9.13229 15.1226 10.2019C14.3606 11.2856 13.4139 11.917 12.5 11.917V13.417C14.1131 13.417 15.4549 12.3369 16.3496 11.0648C17.2541 9.77871 17.827 8.13067 17.827 6.667H16.327ZM12.5 11.917C11.5855 11.917 10.6389 11.2855 9.87701 10.202C9.12491 9.13239 8.673 7.78041 8.673 6.667H7.173C7.173 8.13059 7.74559 9.77861 8.64999 11.0648C9.54459 12.337 10.8865 13.417 12.5 13.417V11.917ZM8.673 6.667C8.673 4.48952 10.4008 2.75 12.5 2.75V1.25C9.54522 1.25 7.173 3.68848 7.173 6.667H8.673ZM12.5 2.75C14.6 2.75 16.327 4.4903 16.327 6.667H17.827C17.827 3.6897 15.456 1.25 12.5 1.25V2.75Z\" fill=#627293 /></svg> </span><span class=group-number style=\"margin-top:7px;margin-left: -4px\">{{g.memberCount }}</span></figure></div></div></div><div class=group-lock-names style=\"height:100%; display:inline-flex; width:70%\"><div class=group-lock style=\"margin-right:5px; padding-top:15px\"><svg width=18 height=18 viewBox=\"0 0 24 24\" fill=none xmlns=http://www.w3.org/2000/svg><rect x=4 y=11.117 width=16 height=10.597 rx=2 stroke=#627293 stroke-width=1.5 stroke-linecap=square /><path d=\"M16.444 7.585v-.883c.025-2.415-1.925-4.391-4.355-4.416H12c-2.43-.024-4.42 1.913-4.444 4.327v.972\" stroke=#627293 stroke-width=1.5 stroke-linecap=square /><circle cx=11.75 cy=16.399 r=1.75 stroke=#627293 stroke-width=1.5 stroke-linecap=square /></svg></div><div class=group-names style=margin-top:0><div class=group-names-child style=\"display: grid; width:auto\"><div class=group-name ui-sref=\"groups.interestGroupsView({\'id\':g.id})\" style=\"text-decoration: underline; cursor: pointer; width:auto\">{{g.name}}</div><div translate=PARENT_PRIVATE class=group-type>{{g.type}}</div><div class=group-type><span ng-if=g.lastActivity translate=LAST_ACTIVITY></span>{{g.lastActivity | date:\'dd.MM.yyyy\'}} <span ng-if=!g.lastActivity translate=NO_ACTIVITY></span></div><div class=group-type ng-if=g.groupLeadText>{{g.groupLeadText}}</div></div></div></div></div><div ng-if=\"g.type === \'PARENT_PUBLIC\'\" style=\"display: inline-flex; width:100%\"><div class=group-item-lg ui-sref=\"groups.interestGroupsView({\'id\':g.id})\" style=padding-top:10px><div class=\"group-info group-comm clearfix\" style=\"background-color:#FFC4A0 !important\"><div class=group-member-count><figure class=clearfix style=\"display: inline-flex;margin-top:3px\"><span><svg width=24 height=24 viewBox=\"0 0 24 24\" fill=none xmlns=http://www.w3.org/2000/svg><path d=\"M7.35246 12.6608C4.83749 13.9048 3.25 16.5007 3.25 19.333H4.75C4.75 17.0593 6.02451 14.9912 8.01754 14.0052L7.35246 12.6608ZM4 19.333C3.46447 19.8581 3.46477 19.8584 3.46508 19.8587C3.4652 19.8588 3.46552 19.8591 3.46575 19.8594C3.46622 19.8599 3.46673 19.8604 3.46727 19.8609C3.46837 19.862 3.46963 19.8633 3.47106 19.8647C3.47391 19.8676 3.47743 19.8711 3.4816 19.8752C3.48995 19.8834 3.50094 19.8941 3.51461 19.907C3.54194 19.933 3.57995 19.9681 3.62882 20.011C3.72654 20.0969 3.86774 20.2141 4.05376 20.3521C4.42582 20.6281 4.9773 20.9869 5.71864 21.3427C7.20435 22.0557 9.43983 22.75 12.5 22.75V21.25C9.67517 21.25 7.66065 20.6108 6.36761 19.9903C5.71958 19.6793 5.24949 19.3714 4.94734 19.1473C4.79624 19.0353 4.68717 18.9442 4.6189 18.8842C4.58477 18.8542 4.56085 18.832 4.547 18.8189C4.54007 18.8123 4.53567 18.808 4.53376 18.8061C4.53281 18.8052 4.53248 18.8048 4.53277 18.8051C4.53292 18.8053 4.53322 18.8056 4.53368 18.806C4.53391 18.8063 4.53418 18.8065 4.53449 18.8069C4.53464 18.807 4.5349 18.8073 4.53498 18.8074C4.53525 18.8076 4.53553 18.8079 4 19.333ZM12.5 22.75C15.5602 22.75 17.7957 22.0557 19.2814 21.3427C20.0227 20.9869 20.5742 20.6281 20.9462 20.3521C21.1323 20.2141 21.2735 20.0969 21.3712 20.011C21.42 19.9681 21.4581 19.933 21.4854 19.907C21.4991 19.8941 21.5101 19.8834 21.5184 19.8752C21.5226 19.8711 21.5261 19.8676 21.5289 19.8647C21.5304 19.8633 21.5316 19.862 21.5327 19.8609C21.5333 19.8604 21.5338 19.8599 21.5342 19.8594C21.5345 19.8591 21.5348 19.8588 21.5349 19.8587C21.5352 19.8584 21.5355 19.8581 21 19.333C20.4645 18.8079 20.4648 18.8076 20.465 18.8074C20.4651 18.8073 20.4654 18.807 20.4655 18.8069C20.4658 18.8065 20.4661 18.8063 20.4663 18.806C20.4668 18.8056 20.4671 18.8053 20.4672 18.8051C20.4675 18.8048 20.4672 18.8052 20.4662 18.8061C20.4643 18.808 20.4599 18.8123 20.453 18.8189C20.4391 18.832 20.4152 18.8542 20.3811 18.8842C20.3128 18.9442 20.2038 19.0353 20.0527 19.1473C19.7505 19.3714 19.2804 19.6793 18.6324 19.9903C17.3393 20.6108 15.3248 21.25 12.5 21.25V22.75ZM21.75 19.333C21.75 16.4986 20.1623 13.9047 17.6464 12.6607L16.9816 14.0053C18.9757 14.9913 20.25 17.0574 20.25 19.333H21.75ZM16.327 6.667C16.327 7.78033 15.8749 9.13229 15.1226 10.2019C14.3606 11.2856 13.4139 11.917 12.5 11.917V13.417C14.1131 13.417 15.4549 12.3369 16.3496 11.0648C17.2541 9.77871 17.827 8.13067 17.827 6.667H16.327ZM12.5 11.917C11.5855 11.917 10.6389 11.2855 9.87701 10.202C9.12491 9.13239 8.673 7.78041 8.673 6.667H7.173C7.173 8.13059 7.74559 9.77861 8.64999 11.0648C9.54459 12.337 10.8865 13.417 12.5 13.417V11.917ZM8.673 6.667C8.673 4.48952 10.4008 2.75 12.5 2.75V1.25C9.54522 1.25 7.173 3.68848 7.173 6.667H8.673ZM12.5 2.75C14.6 2.75 16.327 4.4903 16.327 6.667H17.827C17.827 3.6897 15.456 1.25 12.5 1.25V2.75Z\" fill=#627293 /></svg> </span><span class=group-number style=\"margin-top:7px;margin-left: -4px\">{{g.memberCount }}</span></figure></div></div></div><div class=group-lock-names style=\"height:100%; display:inline-flex; width:70%\"><div class=group-lock style=\"margin-right:5px; padding-top:15px\"><svg width=18 height=18 viewBox=\"0 0 24 24\" fill=none xmlns=http://www.w3.org/2000/svg><path d=\"M18.417 11.083H5.583c-1.012 0-1.833.821-1.833 1.834v7.333c0 1.013.82 1.833 1.833 1.833h12.834c1.012 0 1.833-.82 1.833-1.833v-7.333c0-1.013-.82-1.834-1.833-1.834z\" stroke=#627293 stroke-width=1.5 stroke-miterlimit=10 stroke-linecap=square /><path d=\"M12 18.417a1.833 1.833 0 1 0 0-3.667 1.833 1.833 0 0 0 0 3.667zM15.667 3.72a4.533 4.533 0 0 0-3.575-1.803H12a4.538 4.538 0 0 0-4.583 4.491v1.009\" stroke=#627293 stroke-width=1.5 stroke-miterlimit=10 stroke-linecap=square /></svg></div><div class=group-names style=margin-top:0><div class=group-names-child style=\"display:grid; width:auto\"><div class=group-name ui-sref=\"groups.interestGroupsView({\'id\':g.id})\" style=\"text-decoration: underline; cursor: pointer; width:auto\">{{g.name}}</div><div translate=PARENT_PUBLIC class=group-type>{{g.type}}</div><div class=group-type><span ng-if=g.lastActivity translate=LAST_ACTIVITY></span>{{g.lastActivity | date:\'dd.MM.yyyy\'}} <span ng-if=!g.lastActivity translate=NO_ACTIVITY></span></div><div class=group-type ng-if=g.groupLeadText>{{g.groupLeadText}}</div></div></div></div></div></div></section></div></div></div></div>");
$templateCache.put("app/groups/views/members-modal.html","<script type=text/ng-template id=memberTemplate.html><div class=\"match-container\">	\n		<div class=\"match-container-parentname\">\n			<span ng-bind-html=\"match.model.field1 | uibTypeaheadHighlight:query\" ng-if=\"match.model.field1\"></span>\n			<span ng-bind-html=\"match.model.field2 | uibTypeaheadHighlight:query\" ng-if=\"match.model.field2\"></span>\n		</div>\n		<div>\n            <span translate=\"PARENTHESES_OPEN\" ng-if=\"match.model.field3\"></span><span ng-bind-html=\"(m | uibTypeaheadHighlight:query) + ($last ? \'\' : \', \')\" ng-repeat=\"m in match.model.field3 track by $index\"></span><span translate=\"PARENTHESES_CLOSE\" ng-if=\"match.model.field3\"></span>\n		</div>\n	</div></script><div class=members-container><div class=modal-header><h3 ng-if=\"type == 1\" class=modal-title style=\"display: inline-flex\"><svg style=\"top: 4px\" ng-click=close() class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=26px height=26px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg> <span translate=MEMBERS_OWNERS style=\"float: left; margin-left: 10px; font-size: 20px\"></span></h3><h3 ng-if=\"type == 2\" class=modal-title style=\"display: inline-flex\"><svg style=\"top: 4px\" ng-click=close() class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=26px height=26px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg> <span translate=MEMBERS_GROUP style=\"float: left; margin-left: 10px; font-size: 20px\"></span></h3><h3 ng-if=\"type == 3\" class=modal-title style=\"display: inline-flex\"><svg style=\"top: 4px\" ng-click=close() class=dripicons-arrow-thin-left2 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=26px height=26px viewBox=\"0 0 16 16\"><g transform=\"translate(0, 0)\"><polyline fill=none stroke=#91969d stroke-linecap=round stroke-linejoin=round stroke-miterlimit=10 points=\"9.5,3.5 5,8 9.5,12.5 \"></polyline></g></svg> <span translate=MEMBERS_WAITING_APPROVAL style=\"float: left; margin-left: 10px; font-size: 20px\"></span></h3></div><div ng-if=\"type == 3\" class=modal-body><p translate=MEMBERS_WAITING_APPROVAL_TEXT_1></p></div><div class=group-members-list><div class=group-members-list-max style=\"padding: 0\"><div ng-if=group.waitingApproval class=members-list-header ng-if=\"group.owners && group.owners.length > 0\"><span>Waiting approval</span></div><div class=member ng-repeat=\"m in group.waitingApproval\" style=\"padding: 0 15px\"><div ui-sref=\"classlist.details.contact({\'id\':m.id })\"><figure class=avatar title=\"{{::m.name }}\" style=\"margin-right: 5px\"><avatar source={{m.avatar}} name=\"{{ m.name }}\" width=40 height=40 my=false title=\"{{ m.name }}\"></avatar></figure><span class=name style=\"margin-top: 0\"><div>{{m.name}}</div><div ng-if=m.pupils style=\"font-size: 12px; line-height: 18px\">{{ m.pupils }}</div></span></div><span ng-click=reject(m) class=\"dripicons-cross icon\" style=\"padding-top: 6px\"></span> <span ng-click=accept(m) class=\"dripicons-checkmark icon\" style=\"padding-top: 6px\"></span></div><div class=members-list-header ng-if=\"group.owners && group.owners.length > 0\">Group leads</div><div class=member ng-repeat=\"m in group.owners\" style=\"padding: 0 15px\"><div ui-sref=\"classlist.details.contact({\'id\':m.id })\"><figure class=avatar title=\"{{::m.name }}\" style=\"margin-right: 5px\"><avatar source={{m.avatar}} name=\"{{ m.name }}\" width=40 height=40 my=false title=\"{{ m.name }}\"></avatar></figure><span class=name style=\"margin-top: 0\"><div>{{m.name}}</div><div ng-if=m.pupils style=\"font-size: 12px; line-height: 18px\">{{ m.pupils }}</div></span></div></div><div class=members-list-header>Members</div><div class=member ng-repeat=\"m in group.members\" style=\"padding: 0 15px\"><div ui-sref=\"classlist.details.contact({\'id\':m.id })\"><figure class=avatar title=\"{{::m.name }}\" style=\"margin-right: 5px\"><avatar source={{m.avatar}} name=\"{{ m.name }}\" width=40 height=40 my=false title=\"{{ m.name }}\"></avatar></figure><span class=name style=\"margin-top: 0\"><div>{{m.name}}</div><div ng-if=m.pupils style=\"font-size: 12px; line-height: 18px\">{{ m.pupils }}</div></span></div></div></div></div></div>");
$templateCache.put("app/groups/views/post-likes-modal.html","<div class=likes-modal><div class=modal-header><h3><span>{{ object.likes.length }}</span> <span ng-if=\"object.type != \'welcome\'\" translate=LIKES></span> <span ng-if=\"object.type == \'welcome\'\" translate=WELCOMES></span></h3></div><div class=show-participants><ul class=basket><li ng-repeat=\"item in object.likes track by $index\"><div class=participant><figure class=avatar><avatar source={{item.avatar}} name=\"{{ item.firstName + \' \' + item.lastName }}\" width=40 height=40></avatar></figure>{{item.firstName}} {{item.lastName}}</div></li></ul></div><div class=modal-footer><button class=\"btn btn-ghost\" type=button ng-click=\"close(); isClicked = isClicked + 1\" ng-init=\"isClicked = 0\"><span translate=DONE_BTN></span></button></div></div>");
$templateCache.put("app/groups/views/remove-members-group-modal.html","<div class=remove-members-groups ng-class=\"{\'not-ready\':!viewState.isReady}\"><div class=modal-header><h3 translate=REMOVE_MEMBERS_TITLE translate-values={name:user.name}></h3></div><div class=modal-body><p translate=REMOVE_MEMBERS_TEXT translate-values={name:user.name}></p><input type=search class=\"form-control input-lg\" placeholder=\"{{ \'START_TYPING_NAME_PHOLDER\' | translate }}\" ng-model=keyword> <button id=checkallBoxesForTest class=testing-only ng-click=checkAllBoxes()>check all</button><ul class=basket><li ng-repeat=\"member in group.groupMembers | filter: {combinedName:keyword}\"><div ng-click=\"member.checked=!member.checked\" ng-class=\"{selected: member.checked}\"><figure class=avatar><avatar source={{member.avatar}} name=\"{{ member.firstName + \' \' + member.lastName }}\" width=40 height=40></avatar></figure><strong>{{member.firstName}} {{member.lastName}}</strong> <input type=checkbox class=pull-right ng-checked=member.checked></div></li></ul></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary\" type=button ng-click=remove() ng-disabled=!getSelectedMembers()><span translate=REMOVE_BTN></span></button></div></div>");
$templateCache.put("app/groups/views/remove-members-interest-group-modal.html","<div class=remove-members-groups ng-class=\"{\'not-ready\':!viewState.isReady}\"><div class=modal-header><h3 translate=REMOVE_MEMBERS_TITLE translate-values={name:user.name}></h3></div><div class=modal-body><p translate=REMOVE_MEMBERS_TEXT translate-values={name:user.name}></p><input ng-show=\"{{group.members && group.members.length>0}}\" type=search class=\"form-control input-lg\" placeholder=\"{{ \'START_TYPING_NAME_PHOLDER\' | translate }}\" ng-model=keyword> <button id=checkallBoxesForTest class=testing-only ng-click=checkAllBoxes()>check all</button><ul class=basket2><li ng-repeat=\"member in group.members |filter: keyword track by $index\"><div ng-click=\"member.checked=!member.checked\" ng-class=\"{selected: member.checked}\"><figure class=avatar><avatar source={{member.avatar}} name=\"{{ member.name }}\" width=40 height=40></avatar></figure><strong>{{member.name}}</strong> <input type=checkbox class=pull-right ng-checked=member.checked></div></li></ul></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary\" type=button ng-click=remove() ng-disabled=!getSelectedMembers(group.allMembers)><span translate=REMOVE_BTN></span></button></div></div>");
$templateCache.put("app/groups/views/wrapper.html","<div class=\"content-logged groups\"><div ui-view autoscroll=false></div></div>");
$templateCache.put("app/invite/views/add-invite-integration.html","<div ng-if=\"!viewState.isReady && !searching\" style=\"width: 100%; height: 100%; position: absolute; text-align: center; margin-top: 200px\">We are retrieving the invite list.<br>It will take just a moment...</div><section class=add-invite-nonmembers ng-class=\"{\'is-visible\':viewState.isReady}\"><div class=\"page-view-header clearfix\"><div><strong class=page-view-header__title translate=ADD_A_NONMEMBER_TO_THE_PARENT_LIST_TITLE></strong></div></div><div class=page-view-subheader style=\"margin-top: -1px; min-height: 62px\"><div class=row><div class=col-md-6><div class=\"is-relative page-view-header__search\"><input type=search class=form-control placeholder=\"{{ \'SEARCH_PHOLDER\' | translate }}\" ng-model=keyword ng-keyup=searchInvite() style=\"border: 1px solid; padding-left: 10px\"> <span class=\"icon dripicons-search\" style=\"right: 5px; position: absolute; top: 9px\"></span></div></div></div></div><div class=page-container-header-from-top><div style=\"padding: 15px\"><div><button id=invite-one-button ng-click=redirectToIntegration() type=button class=\"btn btn-primary\" translate=SWITCH_TO_SYNC style=\"float: left\" ng-hide=\"active_user.role !== \'STAFF\' || isStaffWithoutUserManagementPermission()\"></button> <button id=invite-remind-button ng-disabled=\"failedInviteCount === 0 && sentInviteCount === 0\" ng-click=inviteAll() type=button class=\"btn btn-ghost send-invitations-btn\" translate=INTEGRATION_SEND_INVITATIONS style=margin-left:3px></button> <a class=integration-flyer-text href=https://help.classlist.com/hc/en-us/articles/210479025-Classlist-Flyers-to-Print-or-Share target=_blank style=\"color:#eb004e; float:right;margin-top:10px\"><img src=https://storage.googleapis.com/classlist-branding/email-template/pink-printer.svg width=24 height=24 style=margin-right:10px> <span translate=PRINTABLE_FLY_INFO></span></a></div><div style=\"clear: both;padding-top: 15px\"></div><div ng-if=\"failedInviteCount === 0 && sentInviteCount === 0\" style=\"margin-bottom: 0px; overflow: auto; padding: 1px 0; font-weight: bold\" translate=INVITE_PAGE_NO_INVITATIONS></div><div ng-if=\"sentInviteCount !== 0 && failedInviteCount !== 0\" style=\"margin-bottom: 0px; overflow: auto; padding: 1px 0; font-weight: bold\" translate=INVITE_PAGE_INVITATION_COUNT translate-values=\"{\'sentInviteCount\':sentInviteCount, \'failedInviteCount\':failedInviteCount}\"></div><div ng-if=\"sentInviteCount !== 0 && failedInviteCount === 0\" style=\"margin-bottom: 0px; overflow: auto; padding: 1px 0; font-weight: bold\" translate=INVITE_PAGE_INVITATION_COUNT_WITH_NO_FAILED translate-values=\"{\'sentInviteCount\':sentInviteCount}\"></div><div class=integration-add-invite-info-container style=margin-top:10px><p class=integration-add-invite-info-container-text translate=INTEGRATION_MANAGE_PARENT_DESCRIPTION_TEXT></p></div><div class=\"warpper integration-invite-container\" ng-hide=searching><input class=radio id=one name=group type=radio checked> <input class=radio id=two name=group type=radio><div class=tabs><label class=tab id=one-tab for=one translate=FAILED_COUNT translate-values=\"{\'failedInviteCount\':failedInviteCount}\"></label><label class=tab id=two-tab for=two translate=SENT_COUNT></label></div><div class=panels><div class=panel-tab id=one-panel><span style=\"display: inline-flex; font-size: 13px; font-weight: 600\"><span class=\"icon dripicons-information\" style=\"padding-right: 15px\"></span> <span translate=INTEGRATION_INVITE_PAGE_FAILED_DESC></span> </span><span style=padding-left:40px ng-if=\"failedInviteCount === 0\" translate=INTEGRATION_INVITE_PAGE_NO_FAILED_DESC></span><invite-accordion ng-if=\"failedInvites && failedInvites.length > 0\" invites=failedInvites accordion-parent=accordionFailedInviteParent load-more-fn=loadMoreFailedInvites() invite-parent-fn=inviteAll(parent) invite-link-fn=copyPrivateLink(parent) toggle-accordion-fn=\"toggleAccordion(accordionFailedInviteParent, index)\" cursor=failedCursor></invite-accordion></div><div class=panel-tab id=two-panel><invite-accordion ng-if=\"sentInvites && sentInvites.length > 0\" invites=sentInvites accordion-parent=accordionSentInviteParent load-more-fn=loadMoreSentInvites() invite-parent-fn=inviteAll(parent) invite-link-fn=copyPrivateLink(parent) toggle-accordion-fn=\"toggleAccordion(accordionSentInviteParent, index)\" cursor=sentCursor></invite-accordion></div></div></div><br><div class=user-list style=\"padding-top:10px;display: contents\" ng-hide=!searching><invite-accordion ng-if=\"results && results.length > 0\" invites=results accordion-parent=accordionParent invite-parent-fn=inviteAll(parent) invite-link-fn=copyPrivateLink(parent) toggle-accordion-fn=\"toggleAccordion(accordionParent, index)\" cursor=\"\"></invite-accordion></div><br><div><div class=invite-parents-top-section><div class=invite-tips style=\"margin-bottom: 15px\"><a href=https://help.classlist.com/hc/en-us/articles/209890185-Topic-3-Invite-Parents target=_blank><span class=\"dripicons-lightbulb icons-invite\"></span><p translate=INVITE_TIPS></p></a><a href=https://help.classlist.com/hc/en-us/articles/210479025-Printable-Classlist-flyers target=_blank><span class=\"dripicons-print icons-invite\"></span><p translate=PRINTABLE_FLYERS></p></a></div></div></div></div></div></section>");
$templateCache.put("app/invite/views/add-invite.html","<div ng-if=\"!viewState.isReady && !searching\" style=\"width: 100%; height: 100%; position: absolute; text-align: center; margin-top: 200px\">We are retrieving the invite list.<br>It will take just a moment...</div><section class=add-invite-nonmembers ng-class=\"{\'is-visible\':viewState.isReady}\"><div class=\"page-view-header clearfix\"><div><strong class=page-view-header__title translate=ADD_A_NONMEMBER_TO_THE_PARENT_LIST_TITLE></strong></div></div><div class=page-view-subheader style=\"margin-top: -1px; min-height: 62px\"><div class=row><div class=col-md-6><div class=\"is-relative page-view-header__search\"><input type=search class=form-control placeholder=\"{{ \'SEARCH_PHOLDER\' | translate }}\" ng-model=keyword ng-keyup=searchInvite() style=\"border: 1px solid;\n					padding-left: 10px\"> <span class=\"icon dripicons-search\" style=\"right: 5px; position: absolute; top: 9px\"></span></div></div><div class=col-md-6></div></div></div><div class=page-container-header-from-top><div><div style=\"padding: 15px\"><div class=invites-list><div><button id=invite-one-button ng-click=inviteOne() type=button class=\"btn btn-primary\" translate=INVITE_NEW_PARENTS style=\"float: left\"></button> <button id=invite-remind-button ng-if=\"parents.length > 0\" ng-click=inviteAll() type=button class=\"btn btn-ghost send-invitations-btn\" translate=SEND_INVITATIONS></button> <button ng-click=onNavigateToUploadHistory() type=button class=\"btn btn-ghost send-invitations-btn\" translate=UPLOAD_HISTORY></button></div><div ng-if=\"inviteCount === 0\" style=\"margin-bottom: 0px; overflow: auto; padding: 1px 0\">You have no invitations</div><div ng-if=\"inviteCount !== 0\" style=\"margin-bottom: 0px; overflow: auto; padding: 1px 0\">You have a total of {{inviteCount}} invitations</div><div><p translate=MANAGE_PARENT_DESCRIPTION_TEXT></p></div><div class=invite-item ng-repeat=\"parent in results\"><div class=invite-header><p><span ng-click=editParent(parent) style=\"cursor: pointer\"><span ng-if=!parent.realName class=invite-name translate=PARENT_LABEL></span> <span ng-if=parent.realName class=invite-name>{{ parent.firstName }} {{ parent.lastName }}</span> <span ng-if=!parent.editing class=\"icon dripicons-pencil\"></span> </span><span ng-click=inviteAll(parent) class=\"button-link invite-remind-br-right\" translate=INVITE_REMIND></span></p><p ng-if=parent.email>{{ parent.email }} <span translate=CREATED_ON_LABEL></span> <span>{{ parent.created | date:\'dd/MM/yy\' }}</span></p><p ng-if=parent.lastInvitation>{{ parent.lastInvitation }}</p><p ng-if=parent.invitationState><span translate=\"{{ parent.invitationState }}\"></span></p><p ng-if=parent.note>{{ parent.note }}</p><p ng-if=parent.createdByName>Invited by {{ parent.createdByName }}</p><span ng-click=inviteAll(parent) class=\"button-link invite-remind-br-bottom\" translate=INVITE_REMIND></span></div><div ng-if=parent.editing class=invite-form><div style=\"margin-bottom: 15px\"><div class=is-relative><div class=is-relative><select ng-model=parent.tierId class=form-control><option></option><option ng-repeat=\"year in flatStructure\" ng-value=year.id>{{ year.isClass == true ? \'&nbsp;&nbsp;\' : \'\' }} {{ year.name }}</option></select><span class=\"dripicons-chevron-down select-arrow\"></span></div></div><p ng-if=parent.invalidTier class=invalid-label translate=PARENT_TIER_INVALID></p></div><div style=\"margin-bottom: 15px\"><input ng-model=parent.firstName maxlength=50 class=\"form-control {{ parent.invalidFirstname ? \'invalid-input\' : \'\' }}\" type=text placeholder=\"{{\'HOLDER_PARENT_FIRSTNAME\' | translate }}\"><p ng-if=parent.invalidFirstname class=invalid-label translate=PARENT_FIRSTNAME_REQUIRED></p></div><div style=\"margin-bottom: 15px\"><input ng-model=parent.lastName maxlength=50 class=\"form-control {{ parent.invalidLastname ? \'invalid-input\' : \'\' }}\" type=text placeholder=\"{{\'HOLDER_PARENT_LASTNAME\' | translate }}\"><p ng-if=parent.invalidLastname class=invalid-label translate=PARENT_LASTNAME_REQUIRED></p></div><div style=\"margin-bottom: 8px\"><input ng-model=parent.email maxlength=50 class=\"form-control {{ parent.invalidEmail ? \'invalid-input\' : \'\' }}\" type=text placeholder=\"{{\'HOLDER_PARENT_EMAIL\' | translate }}\"><p ng-if=parent.invalidEmail class=invalid-label translate=PARENT_EMAIL_INVALID></p></div><div style=\"text-align: right; margin-top: 30px\"><span ng-click=\"deleteParent($index, parent)\" class=button-link translate=DELETE_BTN style=\"padding: 20px\"></span> <span ng-click=\"saveParent($index, parent)\" class=button-link translate=SAVE_BTN style=\"padding: 20px\"></span></div></div><div ng-if=parent.unsubscribed><span style=\"display: inline-block; background: #888; color: #fff; padding: 3px 10px; border-radius: 10px; padding-top: 4px; margin-bottom: 15px; font-weight: normal\">Unsubscribed</span></div></div><br><div style=\"margin-top: 6px; text-align: center; background: #fff; padding: 10px; font-size: 22px; font-weight: 600; color: #001031\" ng-if=\"cursor.length > 1 && !searching\"><a ng-click=getAllParents() class=\"link ng-scope\" style=\"font-weight: normal; text-align: center; font-size: 15px; width: 100%\">Load more</a></div><br><div><div class=invite-parents-top-section><div class=invite-tips style=\"margin-bottom: 15px\"><a href=https://help.classlist.com/hc/en-us/articles/209890185-Topic-3-Invite-Parents target=_blank><span class=\"dripicons-lightbulb icons-invite\"></span><p translate=INVITE_TIPS></p></a><a href=https://help.classlist.com/hc/en-us/articles/210479025-Printable-Classlist-flyers target=_blank><span class=\"dripicons-print icons-invite\"></span><p translate=PRINTABLE_FLYERS></p></a></div></div></div></div></div></div></div></section>");
$templateCache.put("app/invite/views/bulk-email-edit.html","<div><div class=modal-header><h3 class=modal-title translate=EDIT_NON_MEMBER_TITLE></h3></div><div class=modal-body><form novalidate name=aa><div class=form-group><div class=row><div class=col-md-12><class-picker ng-model=tier is-include=false></class-picker></div></div></div><div class=form-group><div class=row><div class=\"col-md-6 col-sm-6 col-xs-6\"><input type=text placeholder=\"{{\'DEFAULT_FIRSTNAME_PLACEHOLDER\' | translate}}\" class=form-control ng-model=firstName required></div><div class=\"col-md-6 col-sm-6 col-xs-6\"><input type=text placeholder=\"{{\'DEFAULT_LASTNAME_PLACEHOLDER\' | translate}}\" class=form-control ng-model=lastName required></div></div></div><div class=form-group><div class=row><div class=col-md-12><input type=email ng-pattern=/^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$/ placeholder=\"{{\'EMAIL_PHOLDER\' | translate}}\" class=form-control ng-model=email required></div></div></div></form></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary\" type=button ng-click=save() ng-disabled=\"ap.$invalid || newPupil.tier === null\"><span translate=SAVE_BTN></span></button></div></div>");
$templateCache.put("app/invite/views/bulk-email-upload.html","<section class=bulk-email ng-class=\"{\'is-visible\':viewState.isReady}\" autoscroll=true><div class=\"page-view-header clearfix\"><div><div><a id=header-back-button class=page-view-header__back ng-click=back(redirectPages) style=\"float: left; margin-right: 10px; position: relative\"><span class=dripicons-arrow-thin-left></span></a><div class=page-view-header__text><strong class=page-view-header__title translate=BACK_BTN></strong> <strong class=\"page-view-header__title elipsis-text pull-right\"><span translate=ADD_INVITE_HEADER></span></strong></div></div></div></div><div class=page-container-header-from-top style=\"padding: 15px\"><div><div><!-- Nav tabs --><ul class=\"nav nav-tabs\" role=tablist><li role=presentation class=active><a ng-click=\"switchTab(\'manual\')\" aria-controls=home role=tab data-toggle=tab>Manual</a></li><li role=presentation ng-class=\"{ \'disabled-container\': isTrial }\"><a ng-click=\"switchTab(\'upload\')\" aria-controls=profile role=tab data-toggle=tab>Upload</a></li></ul><!-- Tab panes --><div class=tab-content><div role=tabpanel class=\"tab-pane active\" id=manualTabPane><div class=col-md-6 style=\"margin-top: 15px\"><div class=succesful-invite-text ng-if=\"successMessage && !isInvalid\"><span ng-model=successMessage>{{successMessage}}</span></div><div style=\"font-size: 14px; margin-bottom: 15px\"><p translate=BULK_EMAIL_TITLE></p><p><span translate=BULK_EMAIL_PARAGRAPH></span> <span class=\"dripicons-question icon\" ng-click=openHelpdesk(1) style=\"color: #777; cursor: pointer\"></span></p><p><span translate=BULK_EMAIL_PARAGRAPH_2></span> <span class=\"dripicons-question icon\" ng-click=openHelpdesk(2) style=\"color: #777; cursor: pointer\"></span></p><p><span translate=BULK_EMAIL_PARAGRAPH_3></span></p></div><div ng-if=showInfo><div class=yellow-tooltip style=\"margin-bottom: 0\"><span ng-click=closeInfo() class=dripicons-cross></span><div><span translate=ADD_INVITE_TOOLTIP_TEXT_5></span></div></div><br></div><div class=form-group ng-if=canAssignRole><div><div class=is-relative>{{}}<select ng-model=role class=form-control ng-change=selectRole(this)><option ng-repeat=\"r in roles\" ng-value=r.value>{{ r.text }}</option></select><span ng-show=!role translate=PUPIL_ONLY_CLASS_ASSIGN_PHOLDER_REP class=\"select-placeholder pupil_class_placeholder\"></span> <span class=\"dripicons-chevron-down select-arrow\"></span></div></div></div><div class=form-group><div><div class=is-relative><select ng-model=tier class=form-control ng-change=selectClass()><option ng-repeat=\"year in flatStructure\" ng-value=year.id>{{ year.isClass == true ? \'&nbsp;&nbsp;\' : \'\' }} {{ year.name }}</option></select><span ng-show=!tier translate=PUPIL_ONLY_CLASS_PHOLDER class=\"select-placeholder pupil_class_placeholder\"></span> <span class=\"dripicons-chevron-down select-arrow\"></span></div><div class=error-text-red ng-if=classNotSelected><span translate=ERR_BULK_EMAIL_UPLOAD_CLASS></span></div></div></div><form novalidate name=ip><div class=email-addresses><textarea ng-model=emails name=emails class=\"form-control message-body\" placeholder=\"{{ \'START_TYPING_EMAILS\' | translate }}\" ng-change=checkEmails() required name=emails></textarea><div class=error-text-red ng-if=\"!emails && isClicked\"><span translate=ERR_BULK_EMAIL_UPLOAD_NO_EMAIL></span></div><div class=error-text-red ng-if=\"emails && isInvalid && isClicked\"><span translate=ERR_BULK_EMAIL_UPLOAD_INVALID_EMAIL></span></div></div></form><span class=enter-email translate=ADD_INDIVIDUALLY_TEXTAREA></span><div><textarea class=\"form-control message-body\" ng-model=message maxlength=5000 required noresize></textarea><small ng-if=\"message!= defaultText\" class=list-members-counter>{{ message.length }}/5000</small></div><div class=\"modal-footer bulk-footer\"><button class=\"btn btn-default cancel\" type=button ng-click=cancel()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary\" type=button ng-disabled=sending ng-click=save() ng-init=\"pendingRequest = false\"><span translate=SEND_BTN></span></button></div></div></div><!--\n				  <div role=\"tabpanel\" class=\"tab-pane\" id=\"uploadTabPane\">\n					<div class=\"cropper col-md-6\" ng-class=\"{\'not-ready\':!viewState.isReady}\">\n					<img id=\"imgPreviewer\" alt=\"\"/>\n					<div style=\"font-size: 14px; margin-bottom: 15px;\">\n						<span translate=\"BULK_EMAIL_CSV_TITLE\"></span>\n						<span class=\"dripicons-question icon\" ng-click=\"openHelpdesk(1)\" style=\"color: #777; cursor: pointer;\"></span>\n					</div>\n					<div class=\"cropper-pholder\" id=\"imgPholder\">\n						<div ng-show=\"!hasFileUploaded\">\n							<input type=\"file\" id=\"fileUploader\" >\n							<div class=\"cz-message\">\n								<button ng-click=\"uploadBulkCSV()\" type=\"button\" class=\"btn btn-ghost\" translate=\"UPLOAD_BULK_TITLE\"></button>\n								<p translate=\"MAX_CSV_SIZE\"></p>\n							</div>\n						</div>\n						<div ng-show=\"hasFileUploaded\">\n\n							<div class=\"cz-message\">\n								<p>Your file has uploaded succesfully</p>\n								<p>Please match the columns</p>\n								<table style=\"margin: 0 auto;\">\n									<tbody>\n										<tr class=\"list-item-wrapper\">\n											<td>\n												<div class=\"list-item-upload\">First Name :\n												</div>\n											</td>\n											<td class=\"list-item-upload\">\n												<select ng-model=\"firstNameSelection\" ng-change=\"fieldSelection(this)\">\n													<option value=\"\" selected=\"selected\">Choose</option>\n													<option ng-repeat=\"column in columns\" ng-value=\"column\">\n														 {{ column }}\n													</option>\n												</select>\n											</td>\n										</tr>\n										<tr class=\"list-item-wrapper\">\n											<td>\n\n									<div class=\"list-item-upload\">Last Name :\n									</div>\n											</td>\n											<td class=\"list-item-upload\">\n												<select ng-model=\"lastNameSelection\" ng-change=\"fieldSelection(this)\">\n													<option value=\"\" selected=\"selected\">Choose</option>\n													<option ng-repeat=\"column in columns\" ng-value=\"column\">\n														 {{ column }}\n													</option>\n												</select>\n											</td>\n										</tr>\n										<tr class=\"list-item-wrapper\">\n											<td>\n												<div class=\"list-item-upload\">Year :\n\n												</div>\n											</td>\n											<td class=\"list-item-upload\">\n												<select ng-model=\"yearSelection\" ng-change=\"fieldSelection(this)\">\n													<option value=\"\" selected=\"selected\">Choose</option>\n													<option ng-repeat=\"column in columns\" ng-value=\"column\">\n														 {{ column }}\n													</option>\n												</select>\n											</td>\n										</tr>\n										<tr class=\"list-item-wrapper\">\n											<td>\n												<div class=\"list-item-upload\">Class :\n\n												</div>\n											</td>\n											<td class=\"list-item-upload\">\n												<select ng-model=\"classSelection\" ng-change=\"fieldSelection(this)\">\n													<option value=\"\" selected=\"selected\">Choose</option>\n													<option ng-repeat=\"column in columns\" ng-value=\"column\">\n														 {{ column }}\n													</option>\n												</select>\n											</td>\n										</tr>\n										<tr class=\"list-item-wrapper\">\n											<td>\n												<div class=\"list-item-upload\">Email :\n\n												</div>\n											</td>\n											<td class=\"list-item-upload\">\n												<select ng-model=\"emailSelection\" ng-change=\"fieldSelection(this)\">\n													<option value=\"\" selected=\"selected\">Choose</option>\n													<option ng-repeat=\"column in columns\" ng-value=\"column\">\n														 {{ column }}\n													</option>\n												</select>\n											</td>\n										</tr>\n									</tbody>\n								</table>\n\n							</div>\n						</div>\n						<span class=\"enter-email\" translate=\"ADD_INDIVIDUALLY_TEXTAREA\"></span>\n						<div>\n							<textarea class=\"form-control message-body\" ng-model=\"message\"\n								maxlength=\"5000\" required noresize></textarea>\n							<small ng-if=\"message!= defaultText\" class=\"list-members-counter\">{{ message.length }}/5000</small>\n						</div>\n						<div class=\"modal-footer bulk-footer\">\n							<button class=\"btn btn-default cancel\" type=\"button\" ng-click=\"cancel()\"><span translate=\"CANCEL_BTN\"></span></button>\n							<button class=\"btn btn-primary\" type=\"button\" ng-click=\"saveUpload()\"  ng-init=\"pendingRequest = false\">	<span translate=\"SEND_BTN\"></span></button>\n						</div>\n					</div>\n					</div>\n				  </div>\n				  --><div role=tabpanel class=tab-pane id=uploadTabPane><csv-upload></csv-upload></div></div></div></div></div></section>");
$templateCache.put("app/invite/views/bulk-upload-history.html","<section class=user-list style=\"display: unset !important\" ng-class=\"{\'is-visible\': viewState.isReady}\"><div class=header-content-separator></div><div class=\"page-view-header clearfix\"><div><div><a id=header-back-button class=page-view-header__back ng-click=back(redirectPages) style=\"float: left; margin-right: 10px; position: relative\"><span class=dripicons-arrow-thin-left></span></a><div class=page-view-header__text><strong class=page-view-header__title translate=BACK_BTN></strong> <strong class=\"page-view-header__title elipsis-text pull-right\"><span translate=UPLOAD_HISTORY></span></strong></div></div></div></div><div><div class=page-view-header__description style=\"margin-top: 0px; padding: 5px\"><span style=\"margin: 0px\" translate=UPLOAD_HISTORY_DESCRIPTION></span> <span class=\"dripicons-question icon\" ng-click=openInfo() style=\"color: #777; cursor: pointer\"></span></div></div><div style=\"padding: 0 10px\"><div><div><div><div class=accordion ng-class=\"{active: accordionUpload[$index].open}\" ng-repeat=\"u in uploads\"><div ui-sref-active=active class=accordion__trigger ng-click=\"toggleAccordion(accordionUpload, $index)\"><strong>{{::u.fileName}} - <span style=\"font-style: italic; line-height: 14px\" translate={{u.status}}></span></strong> <span class=\"dripicons-chevron-down pull-right accordion__chevron\" ng-show=!accordionParent[$index].open></span> <span class=\"dripicons-chevron-up pull-right accordion__chevron\" ng-show=accordionParent[$index].open></span></div><div class=\"accordion__content row\" style=\"margin: 0\"><div class=\"parent-accordion-item clearfix col-sm-6\"><table><tbody><tr><td><span>{{::u.lineCount}} lines processed</span></td><td><span><a ng-click=\"onDownloadButtonClicked(u, $index, true)\" class=btn-continue translate=SUCCESS_REPORT></a> </span><span class=dripicons-download style=\"color: #eb004e\"></span></td><td><span><a ng-click=\"onDownloadButtonClicked(u, $index, false)\" class=btn-continue translate=ERROR_REPORT></a> </span><span class=dripicons-download style=\"color: #eb004e\"></span></td></tr></tbody></table></div></div></div></div></div></div><!-- <div class=\"row no-parents visible-md visible-lg visible-sm\" ng-if=\"noParents\">\n			<div class=\"col-xs-12\">\n				<h4 class=\"no-parent-title\" translate=\"NO_PARENTS_TO_APPROVE_TITLE\"></h4>\n				<p class=\"no-parent-title\" translate=\"NO_PARENTS_TO_APPROVE_TEXT\"></p>\n				<a ui-sref=\"invite.nonmemberlist\">\n					<span class=\"dripicons-open-envelope icons-tips\"></span>\n					<p class=\"no-parent-tips\" translate=\"NO_PARENTS_TO_APPROVE_INVITE\"></p>\n				</a>\n				<a href=\"https://help.classlist.com/hc/en-us/articles/209890185-Topic-3-Invite-Parents\"  target=\"_blank\">\n					<span class=\"dripicons-lightbulb icons-tips\"></span>\n					<p class=\"no-parent-tips\" translate=\"NO_PARENTS_TO_APPROVE_TIPS\"></p>\n				</a>\n				<a href=\"https://help.classlist.com/hc/en-us/articles/210479025-Printable-Classlist-flyers\"  target=\"_blank\">\n					<span class=\"dripicons-print icons-tips\"></span>\n					<p class=\"no-parent-tips\" translate=\"NO_PARENTS_TO_APPROVE_PRINTABLE\"></p>\n				</a>\n			</div>\n			<div class=\"col-sm-2 no-parent-bottom\"></div>\n		</div>\n		<div class=\"row no-parents visible-xs\" ng-if=\"noParents\">\n			<div class=\"col-xs-12\">\n				<h4 translate=\"NO_PARENTS_TO_APPROVE_TITLE\"></h4>\n			</div>\n		</div> --></div><br><!-- <div class=\"page-sub-header\" ng-if=\"recentlyApproved.length > 0\" style=\"padding: 0 10px;\">\n		<div>\n			<div>\n				<div>\n					<strong class=\"page-sub-header__title\" translate=\"RECENTLY_APPROVED_TITLE\"></strong>\n				</div>\n			</div>\n		</div>\n	</div>\n	<div ng-if=\"recentlyApproved.length > 0\" style=\"padding: 0 10px;\">\n		<div>\n			<div>\n				<div>\n					<div class=\"accordion\" ng-class=\"{active: accordionRecentlyApproved[$index].open}\" ng-repeat=\"p in recentlyApproved\">\n						<div ui-sref-active=\"active\" class=\"accordion__trigger\" ng-click=\"toggleAccordion(accordionRecentlyApproved, $index)\">\n							<span ui-sref=\"users.parentdetail({\'id\':p.id })\">\n								<a ui-sref=\"users.parentdetail({\'id\':p.id })\">{{::p.firstName}} {{::p.lastName}}</a> <span>({{::p.relationship}})</span>\n							</span> 			\n							<span class=\"dripicons-chevron-down pull-right accordion__chevron\" ng-show=\"!accordionRecentlyApproved[$index].open\"></span>\n							<span class=\"dripicons-chevron-up pull-right accordion__chevron\" ng-show=\"accordionRecentlyApproved[$index].open\"></span>\n						</div>\n						<div class=\"accordion__content row\" style=\"margin: 0;\">\n							<div class=\"parent-accordion-item clearfix col-sm-6\">\n								<table>\n									<thead>\n										<tr>\n											<th><span class=\"sign-up-mobile\" translate=\"MANAGE_USERS_PUPILS_TITLE\"></span></th>\n											<th><span class=\"sign-up-mobile\" translate=\"MANAGE_USERS_Y_C_TITLE\"></span></th>\n										</tr>\n									</thead>\n									<tbody>\n										<tr ng-repeat=\"pupil in p.pupils\">\n											<td>\n												<span>{{::pupil.firstName}} {{::pupil.lastName}}</span>\n											</td>\n											<td>\n												<span>{{::pupil.firstTier}} {{::pupil.secondTier}}</span>\n												<span ng-show=\"p.firstTier || p.secondTier\">{{::p.firstTier}} {{::p.secondTier}}</span>\n											</td>\n										</tr>\n									</tbody>\n								</table>\n							</div>\n							<div class=\"parent-accordion-item clearfix col-sm-6\">\n								<strong class=\"sign-up-mobile\" translate=\"MANAGE_USERS_CONTACT_TITLE\"></strong>\n								<p ng-hide=\"active_user.role == \'CLASS_REP\'\" class=\"telephone\" ng-if=\"p.email\"><span class=\"dripicons-mail icon\"></span>{{::p.email}}</p>\n								<p class=\"address\"><span class=\"dripicons-location icon\" ng-if=\"p.address.streetAddress\"></span>{{::p.address.streetAddress}}<span ng-if=\"p.address.postCode\">, {{::p.address.postCode}}</span><span ng-if=\"p.adress.city\">, {{::p.adress.city}}</span></p>\n							</div>\n							<div class=\"parent-accordion-item clearfix col-sm-6\">\n								<p ng-if=\"user.role !== \'CLASS_REP\'\" ng-click=\"makeAdmin(p, \'APPROVE_PARENTS\')\">\n									<a><span class=\"dripicons-gear icon\" style=\"font-size: 120%; margin: 0 5px 0 0;\"></span><span translate=\"MAKE_ADMIN\"></span></a>\n								</p>\n							</div>\n							<div class=\"parent-accordion-item clearfix col-xs-4\">\n								<strong class=\"sign-up-mobile\" class=\"join-date\" translate=\"JOINED_TITLE\"></strong>\n                                <p> {{::p.joinedDate | date:\'dd/MM/yyyy\'}}</p>\n                            </div>\n							<div class=\"parent-accordion-item clearfix col-xs-4\">\n								<strong class=\"sign-up-mobile\" translate=\"APPROVED_BY_TITLE\"></strong>\n								<p>{{::p.approvedBy}}</p>\n							</div>\n							<div class=\"parent-accordion-item clearfix col-xs-4\">\n								\n							</div>\n						</div>\n					</div>\n				</div>\n			</div>\n		</div>\n	</div> --></section>");
$templateCache.put("app/invite/views/delete-modal.html","<div><div class=modal-header><h3 translate=DELETE_PARENT_MODAL_TITLE></h3></div><div class=modal-body><p translate=DELETE_PARENT_MODAL_TEXT></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=OK_BTN ng-click=confirm()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/invite/views/invite-modal.html","<div class=invitation-type-modal><div class=modal-body style=\"padding: 30px; padding-bottom:0px\"><span class=dripicons-cross id=closeButton ng-click=close() style=\"float: right;\n				font-size: 25px;\n				color: #777;\n				cursor: pointer;\n				padding: 20px;\n				margin-top: -30px;\n				margin-right: -30px;\n				padding-bottom: 10px\"></span><div class=\"title-and-subtitle font-extrabold\" style=\"font-size: 22px\" translate=SHARE_TITLE></div><div class=title-and-subtitle style=\"font-size: 14px; text-align: left; margin-bottom: 0px\"><span translate=SHARE_SUBTITLE_1></span><br><span translate=SHARE_SUBTITLE_2 style=\"display: block; padding-top:12px\"></span></div><div class=invite-selection-list><div style=\"margin-top: 0\"><div class=\"select-share-provider invite-modal-container\"><div class=container ng-click=select(2) style=margin-bottom:6px><div class=list-item><svg width=30 height=30 viewBox=\"0 0 30 30\" fill=none xmlns=http://www.w3.org/2000/svg><path d=\"m5.087 7.374 9.54 8.879 9.758-9.473\" stroke=#627293 stroke-width=1.875 stroke-linecap=round stroke-linejoin=round /><rect x=3.001 y=5.833 width=23.25 height=19.375 rx=3.75 stroke=#627293 stroke-width=1.875 stroke-linecap=round stroke-linejoin=round /></svg></div><div class=\"list-item invite-list-item second\"><div class=title><span class=\"font-semibold font-underline\" style=\"color: #eb004e !important;\n										font-size: 16px !important\" translate=SHARE_BY_EMAIL_INVITE></span> <span class=font-extrabold style=\"font-size: 16px !important\" translate=SHARE_BY_EMAIL></span></div><div style=font-size:14px translate=SHARE_BY_EMAIL_SUBTITLE></div></div></div><div class=container style=\"cursor: auto !important; opacity: 1\"><div class=list-item style=margin-bottom:6px><svg width=30 height=30 viewBox=\"0 0 30 30\" fill=none xmlns=http://www.w3.org/2000/svg><path d=\"M18.413 24.645v-3.636h3.635l-3.635 3.636z\" fill=#627293 stroke=#627293 stroke-width=1.25 /><path d=\"M23.557 20.384h-5.769v5.77\" stroke=#627293 stroke-width=1.875 stroke-miterlimit=10 /><path d=\"M23.558 20.385V5H6.25v21.154h11.538l5.77-5.77z\" stroke=#627293 stroke-width=1.875 stroke-miterlimit=10 stroke-linecap=square /></svg></div><div class=\"list-item invite-list-item second\"><div class=title translate=SHARE_BY_QR_CODE_FLYER></div><div><span translate=SHARE_BY_QR_CODE_FLYER_SUBTITLE_1></span><br><span translate=SHARE_BY_QR_CODE_FLYER_SUBTITLE_1_2 style=\"display: block; padding-top:5px\"></span> <span ng-if=isTrial translate=SHARE_BY_QR_CODE_FLYER_SUBTITLE_1_4 style=\"display: block; padding-top:5px; text-align: center\"></span> <span ng-if=isTrial translate=SHARE_BY_QR_CODE_FLYER_SUBTITLE_1_5 style=\"display: block; padding-top:5px\"></span> <span style=\"display: block; padding-top:5px\"><span class=font-semibold translate=SHARE_BY_QR_CODE_FLYER_SUBTITLE_1_3></span> <a class=invite-link ng-click=shareQrFlyer(false) translate=SHARE_BY_QR_CODE_FLYER_SUBTITLE_2></a> <span translate=SHARE_BY_QR_CODE_FLYER_SUBTITLE_3></span> <a class=invite-link ng-click=shareQrFlyer(true) translate=SHARE_BY_QR_CODE_FLYER_SUBTITLE_4></a> <span translate=SHARE_BY_QR_CODE_FLYER_SUBTITLE_5></span> <a class=invite-link ng-click=shareQrGreyFlyer() translate=SHARE_BY_QR_CODE_FLYER_SUBTITLE_6></a></span></div></div></div><div class=list-item style=\"margin-bottom:6px; text-align: center\" ng-if=isTrial><div class=horizontal-line></div><span translate=SHARE_BY_TRIAL_INFO></span></div><div class=container ng-click=\"showLinkBox(); copyLink();\" ng-class=\"{ \'disabled-container\': isTrial }\" style=\"margin-bottom: 5px;opacity: 1\"><div class=list-item><svg width=30 height=30 viewBox=\"0 0 30 30\" fill=none xmlns=http://www.w3.org/2000/svg><path d=\"M16.657 23.46V18.08c-7.53 0-9.041 1.48-12.907 6.454 0-10.54 6.884-12.907 12.907-12.907V6.25l10.218 8.605-10.218 8.604z\" stroke=#627293 stroke-width=1.875 stroke-miterlimit=10 stroke-linecap=square /></svg></div><div class=\"list-item invite-list-item second\"><div class=title translate=SHARE_BY_SOCIAL></div><div><span class=invite-link style=\"text-decoration: underline\" translate=SHARE_BY_SOCIAL_SUBTITLE_LINK></span> <span translate=SHARE_BY_SOCIAL_SUBTITLE></span></div></div></div><div style=\"margin-bottom: 0px\" ng-if=isTrial><div class=horizontal-line></div></div><div><span translate=SHARE_BY_BOTTOM_INFO></span></div></div><div ng-if=\"shareBoxVisible == true\" class=select-link style=\"margin-top: 5px; position: relative\"><input id=select-link-url-input type=text value=\"{{ link }}\" disabled> <a ng-click=copyLink() translate=COPY></a><div ng-if=\"showLinkCopyDone == true\" translate=LINK_COPIED style=\"color: #777\"></div></div></div></div></div></div>");
$templateCache.put("app/invite/views/inviteall-modal.html","<div class=invitation-type-modal><div class=modal-body style=\"padding: 30px\"><span class=dripicons-cross ng-click=close() style=\"float: right; font-size: 25px; color: #777; cursor: pointer; padding: 20px; margin-top: -30px; margin-right: -30px; padding-bottom: 10px\"></span><p ng-if=!parentEmail translate=INVITE_MODAL_TEXT_4 translate-values=\"{ count: inviteCount }\"></p><p ng-if=parentEmail translate=INVITE_MODAL_TEXT_4_1 translate-values=\"{ mail: parentEmail }\"></p><br><div style=\"text-align: center\"><button type=button ng-click=send() class=\"btn btn-primary\" translate=SEND_BTN></button></div><br><p translate=INVITE_MODAL_TEXT_5></p><br><p translate=INVITE_MODAL_TEXT_6></p><div style=\"margin-top: 10px\"><textarea class=\"form-control message-body\" ng-model=message ng-init=\"message = defaultText\" maxlength=1999 required noresize style=\"min-height: 105px\"></textarea><small ng-if=\"message!= defaultText\" class=list-members-counter>{{ message.length }}/1999</small></div></div></div>");
$templateCache.put("app/invite/views/nonmember-reminder-modal.html","<div class=nonmember-reminder><div class=modal-header><h3 translate=NON_MEMBER_REMINDER_TITLE translate-values=\"{\'number\': nonmemberCount}\"></h3></div><div class=modal-body><form novalidate name=aa><div class=form-group><div class=reminder-text-holder><textarea class=\"form-control reminder-text\" ng-model=message ng-init=\" message = \'You are already invited to Classlist and getting emails about school announcements and community events.&#x0a;&#x0a;But there is so much more on Classlist!&#x0a;&#x0a;Activate your account today to see daily posts and comments from other parents, to create events like birthday parties in seconds and to connect easily with your school community.\'\" maxlength=1999 required noresize></textarea><small ng-if=\"message!= defaultText\" class=reminder-text-counter>{{ message.length }}/1999</small></div></div></form></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary\" type=button ng-click=sendReminder()><span translate=SEND_BTN></span></button></div></div>");
$templateCache.put("app/invite/views/wrapper.html","<div class=\"content-logged invite\"><div ui-view></div></div>");
$templateCache.put("app/marketplace/views/detail.html","<section class=monitor-view add-participants ng-class=\"{\'is-visible\':viewState.isReady}\"><div class=page-view-header><div class=row><div class=col-xs-12><strong class=page-view-header__title translate=MONITOR_MARKETPLACE_TITLE></strong></div></div></div><div class=page-view-header__description></div><div class=row><div class=col-md-7><aside class=group-posts><listing-item ng-show=post post=post></listing-item></aside></div></div></section>");
$templateCache.put("app/marketplace/views/list.html","<section class=monitor-view add-participants ng-class=\"{\'is-visible\':viewState.isReady}\"><div class=page-view-header><div><div class=row><div class=col-xs-12><strong class=page-view-header__title translate=MONITOR_MARKETPLACE_TITLE></strong></div></div></div></div><div class=page-view-header__description><p translate=MONITOR_MARKETPLACE_DESCRIPTION></p></div><div><div class=row><div class=col-md-7><aside class=group-posts><div ng-repeat=\"post in posts\"><listing-item post=post></listing-item></div><div ng-show=hasMorePosts() class=vi-loader><div><svg class=circular viewBox=\"25 25 50 50\"><circle class=path cx=50 cy=50 r=20 fill=none stroke-width=4 stroke-miterlimit=10></circle></svg></div></div></aside></div></div></div></section>");
$templateCache.put("app/marketplace/views/wrapper.html","<div class=\"content-logged home\"><div ui-view autoscroll=false></div></div>");
$templateCache.put("app/monitor/views/posts.html","<section class=monitor-view add-participants ng-class=\"{\'is-visible\':viewState.isReady}\"><div class=page-view-header><div><div class=row><div class=col-xs-12><strong class=page-view-header__title translate=MONITOR_COMMUNITY_TITLE></strong></div></div></div></div><div class=page-view-header__description><p translate=MONITOR_COMMUNITY_DESCRIPTION></p></div><div><div class=row><div class=col-md-7><aside class=group-posts><div ng-repeat=\"p in posts\"><post-asset-admin post-content={{p}} post-context=HOME_VIEW class=enter user-avatar=active_user.avatar user-role=active_user.role user-name=userName></post-asset-admin></div><div ng-show=hasMorePosts() class=vi-loader><div><svg class=circular viewBox=\"25 25 50 50\"><circle class=path cx=50 cy=50 r=20 fill=none stroke-width=4 stroke-miterlimit=10></circle></svg></div></div></aside></div><div ng-if=!hasMorePosts() class=\"col-md-5 hidden-xs hidden-sm hidden-md hidden-lg\"><nav class=my-groups-list ng-if=\"groups.length > 0\"><h4 translate=GROUPS_MY_GROUPS></h4><ul><li ng-repeat=\"g in groups\"><a ui-sref=\"groups.view({\'id\':g.id})\">{{g.name}}</a></li></ul></nav></div></div></div></section>");
$templateCache.put("app/monitor/views/wrapper.html","<div class=\"content-logged home\"><div autoscroll=false><ng-include src=\"\'app/monitor/views/posts.html\'\"></ng-include></div></div>");
$templateCache.put("app/nonmember/views/wrapper.html","<section><p class=not-admin-warning translate=NOT_ADMIN_WARNING></p><section class=demo-view><div class=demo-post-list><div><div class=demo-header><div></div><div></div></div><div class=demo-picture></div></div><div><div class=demo-header><div></div><div></div></div><div class=demo-picture></div></div></div></section></section>");
$templateCache.put("app/notifications/views/notifications.html","<section class=notifications-view add-participants ng-class=\"{\'is-visible\':viewState.isInitiated}\"><div class=\"page-view-header clearfix\"><div><strong class=page-view-header__title translate=NAV_MANAGE_NOTIFICATIONS></strong> <a class=\"pull-right mark-all-read\" translate=MARK_ALL_READ ng-click=markAllRead()></a></div></div><div class=\"page-container-header-from-top notifications-list\" ng-class=\"{\'show\':viewState.showNewNotifications}\"><p class=no-notifications ng-show=\"!viewState.fetchingNotifications && notificationsLength == 0\" translate=NO_NEW_NOTIFICATIONS_TXT></p><ul class=notification-items><li ng-repeat=\"m in notifications\" class=clearfix notify={{$index}}><div ng-if=\"m.event !== \'SYSTEM\'\" class=\"thread {{ !m.read ? \'active\' : \'\' }}\" ng-click=notifRedirect(m)><figure class=classlist-item-avatar style=\"width: 40px; height: 40px; float: left; margin-right: 12px\"><avatar source=\"{{ m.avatar }}\" width=40 height=40 name=\"{{ m.letters }}\" my=false></avatar></figure><div class=detail><div ng-if=m.title><span class=user-name ng-bind-html=m.title></span><br></div><strong style=\"font-weight: normal\"><span ng-bind-html=m.message></span></strong> <time>{{ m.timestamp | date:\'h:mm a, MMM dd\' }}</time></div></div><a ng-if=\"m.event === \'SYSTEM\'\" class=notifications-a href={{m.extra}} target=_blank><div class=\"thread {{ !m.read ? \'active\' : \'\' }}\"><img width=60 height=60 class=avatar alt=avatar onerror=\"this.src=\'assets/icons/default-avatar.png\'\" ng-src={{m.avatar}} alt=\"\"><div class=detail><strong>{{m.message}}</strong> <time>{{ m.timestamp | date:\'h:mm a, MMM dd\' }}</time></div></div></a></li></ul><p class=loading ng-show=viewState.fetchingNotifications translate=LOADING_TXT></p></div></section>");
$templateCache.put("app/notifications/views/wrapper.html","<div class=notifications-background><div class=\"content-logged notifications-page\"><div autoscroll=false><ng-include src=\"\'app/notifications/views/notifications.html\'\"></ng-include></div></div></div>");
$templateCache.put("app/onboarding/views/start.html","<div class=content-logged><div class=on-slider><div class=on-slide><div style=\"margin-bottom: 30px\"><span translate=ONBOARDING_START_TEXT_4 translate-values=\"{ \'name\': active_school.name }\"></span></div><div style=\"text-align: center\"><img src=assets/icons/Wizard-High-five.svg alt=\"\" style=\"max-width: 250px\"></div><br><br><div><span ng-if=\"invitedCount > 1\" translate=ONBOARDING_START_TEXT_2 translate-values=\"{ \'count\': invitedCount }\"></span> <span ng-if=\"invitedCount == 1\" translate=ONBOARDING_START_TEXT_2_B translate-values=\"{ \'count\': invitedCount }\"></span> <span ng-if=\"!invitedCount || invitedCount == 0\" translate=ONBOARDING_START_TEXT_2_1></span></div><br><div style=\"text-align: center\"><button ng-click=invite() type=button class=\"btn btn-primary\"><span ng-if=\"invitedCount > 0\" translate=VIEW_LIST></span> <span ng-if=\"invitedCount == 0\" translate=INVITE_PARENTS></span></button></div></div></div></div>");
$templateCache.put("app/post/views/post.html","<div post-likes><div class=\"page-view-header clearfix\"><div><div class=row><div class=col-md-12><a class=page-view-header__back ng-click=back()><span class=dripicons-arrow-thin-left></span></a> <strong class=\"page-view-header__title header-text\" translate=BACK_BTN></strong></div></div></div></div><div class=page-container-header-from-top><section class=\"group-view group-view--post\" add-participants ng-class=\"{\'is-visible\':viewState.isInitiated }\"><div class=post-top><div><aside class=group-posts><div ng-repeat=\"p in posts\"><post-asset-admin post-content={{p}} post-context=HOME_VIEW class=enter user-avatar=active_user.avatar user-role=active_user.role user-name=userName></post-asset-admin></div></aside></div></div></section></div></div>");
$templateCache.put("app/post/views/wrapper.html","<div class=\"content-logged post\"><div autoscroll=false><div ui-view autoscroll=false></div></div></div>");
$templateCache.put("app/profile/views/delete-account-modal.html","<div><div class=modal-header><h3 translate=DELETE_ACCOUNT_HEADER translate-values=\"{\'school\': active_school.name }\"></h3></div><div class=modal-body><p translate=DELETE_ACCOUNT_TEXT translate-values=\"{\'school\': active_school.name }\"></p><p translate=INSERT_PASSWORD></p><input id=delete-pwd-id type=password class=form-control placeholder=Password ng-model=vm.password ng-minlength=2 ng-maxlength=250 maxlength=250 required><div translate=\"{{ deletingAccountError }}\" class=\"alert alert-error\" ng-show=deletingAccountError></div></div><div class=modal-footer><button id=delete-account-btn-id type=button class=\"btn btn-primary pull-right\" ng-disabled=\"!vm.password || deletingAccount\" translate=DELETE_BTN_MODAL ng-click=confirm()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/profile/views/logout-confirm-modal.html","<div><div class=modal-header><h3 translate-values=\"{\'school\': active_school.name }\">Sign out</h3></div><div class=modal-body>Are you sure you want to sign out?</div><div class=modal-footer><button id=delete-account-btn-id type=button class=\"btn btn-primary pull-right\" ng-disabled=loggingOut ng-click=confirm()>Sign out</button> <button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/profile/views/only-ambassador-modal.html","<div><div class=modal-header><h3>Warning</h3></div><div class=modal-body><p translate=DELETE_ACCOUNT_ONLY_AMBASSADOR></p></div><div class=modal-footer><button type=button class=\"btn btn-default\" translate=OK_BTN ng-click=close()></button></div></div>");
$templateCache.put("app/profile/views/parent.html","<div class=\"content-logged off profile\" ng-show=viewState.isReady><div><div class=profile><div class=profile-card><div class=\"profile-info clearfix\"><figure class=\"avatar pull-left\"><avatar source={{user.avatar}} name=\"{{ user.firstName + \' \' + user.lastName }}\" width=80 height=80 my=true></avatar></figure><div class=\"staff-name pull-left\" profile-updater><p>{{user.firstName}} {{user.lastName}}</p><p class=staff-label translate={{user.role}}></p></div></div></div><div class=parent-settings ng-repeat=\"sec in sections\" ng-show=sec.visible style=\"padding: 0 20px\"><div class=parent-text><span translate=PROFILE_{{sec.label}}_TEXT></span></div><button type=button class=\"btn btn-ghost pull-left\" translate=GO_TO_PARENT_PROFILE_BTN ng-click=mySwitch(sec.label)></div></div></div></div>");
$templateCache.put("app/profile/views/staff.html","<div class=\"content-logged off profile\" photo-upload ng-show=viewState.isReady><div><div><div class=profile-card><div class=\"profile-info clearfix\"><figure class=\"avatar pull-left\"><avatar source=\"{{ active_user.avatar + Date().getTime() }}\" width=80 height=80 my=true></avatar><a ng-click=uploadAvatar() style=z-index:2><br><span translate=CHANGE_PHOTO></span></a></figure><div class=\"staff-name pull-left\" profile-updater><p>{{active_user.firstName}} {{active_user.lastName}}</p><p class=staff-label translate=SCHOOL_STAFF></p></div></div></div></div><div style=\"padding: 0 15px; max-width: 700px\"><div><div class=profile-settings-basic ng-class=\"{\'is-visible\':viewState.isReady}\"><form name=bd novalidate autocomplete=off><br><div class=\"row form-group\"><div class=\"col-md-6 col-sm-6 col-xs-6\"><div class=with-icon><input type=text class=form-control placeholder=\"{{ \'FIRSTNAME_PHOLDER\' | translate }}\" ng-model=myUser.firstName name=firstName ng-minlength=regexes.min.name ng-maxlength=regexes.max.name maxlength={{::regexes.max.name}} remove-chars=nameField required><validation-icons is-valid=bd.firstName.$valid is-dirty=bd.firstName.$dirty></validation-icons></div></div><div class=\"col-md-6 col-sm-6 col-xs-6\"><div class=with-icon><input type=text class=form-control placeholder=\"{{ \'LASTNAME_PHOLDER\' | translate }}\" ng-model=myUser.lastName name=lastName ng-minlength=regexes.min.name ng-maxlength=regexes.max.name maxlength={{::regexes.max.name}} remove-chars=nameField required><validation-icons is-valid=bd.lastName.$valid is-dirty=bd.lastName.$dirty></validation-icons></div></div></div><div class=\"row form-group\"><div class=\"col-md-6 col-sm-6 col-xs-6\"><div class=is-relative><input type=text name=label class=form-control ng-model=myUser.label placeholder=\"{{ \'PROFILE_LABEL\' | translate }}\"></div></div><div class=\"col-md-6 col-sm-6 col-xs-6\"></div></div><br><br><legend translate=CONTACT_INFO_TITLE class=col-md-12></legend><div class=\"row form-group\"><div class=col-md-12><div class=with-icon><input type=email class=form-control placeholder=\"{{ \'EMAIL_PHOLDER\' | translate }}\" ng-model=myUser.email name=email ng-minlength=regexes.min.email ng-maxlength=regexes.max.email maxlength={{::regexes.max.email}} remove-space required><validation-icons is-valid=bd.email.$valid is-dirty=bd.email.$dirty></validation-icons></div></div></div><br><div class=\"row buttons\"><div class=col-md-12><button type=button class=\"btn btn-primary pull-right\" ng-disabled=\"bd.$invalid || bd.$pristine\" ng-click=update()><span translate=SAVE_BTN></span></button></div></div></form><div class=row><div class=col-md-12><validation-errors></validation-errors></div></div><br><br><form name=cp novalidate autocomplete=off><legend translate=CHANGE_PASSWORD_TITLE class=col-md-12></legend><div class=\"row form-group\"><div class=col-md-12><div class=with-icon><input type=password class=form-control placeholder=\"{{ \'OLD_PWD_PHOLDER\' | translate }}\" ng-model=pwd.oldPassword name=oldPassword required ng-maxlength=regexes.max.password maxlength={{::regexes.max.password}} remove-space required autocomplete=new-password><validation-icons is-valid=cp.oldPassword.$valid is-dirty=cp.oldPassword.$dirty></validation-icons></div></div></div><div class=\"row form-group\"><div class=col-md-12><div class=with-icon><input type=password class=form-control placeholder=\"{{ \'NEW_PWD_PHOLDER\' | translate }}\" ng-model=pwd.newPassword name=newPassword required ng-minlength=regexes.min.password ng-maxlength=regexes.max.password maxlength={{::regexes.max.password}} remove-space required autocomplete=off><validation-icons is-valid=cp.newPassword.$valid is-dirty=cp.newPassword.$dirty></validation-icons></div></div></div><div class=\"row form-group\"><div class=col-md-12><div class=with-icon><input type=password id=confirm-password class=form-control placeholder=\"{{ \'CONF_NEW_PWD_PHOLDER\' | translate }}\" ng-model=confirmPassword name=confirmPassword ng-minlength=regexes.min.password ng-maxlength=regexes.max.password maxlength={{regexes.max.password}} remove-space required autocomplete=off><validation-icons is-valid=cp.confirmPassword.$valid is-dirty=cp.confirmPassword.$dirty></validation-icons></div></div></div><div class=row ng-show=\"(confirmPassword != pwd.newPassword) && confirmPassword && pwd.newPassword\"><div class=col-md-12><p class=text-danger translate=ERR_PWD_MISMATCH></p></div></div><div style=\"font-size: 12px; color: #888; font-weight: bold\">Your password needs to be at least 8 characters</div><div class=row><div class=col-md-12><button type=button class=\"btn btn-primary pull-right\" ng-disabled=\"cp.$invalid || (confirmPassword != pwd.newPassword) || !confirmPassword || !pwd.newPassword\" ng-click=updatePassword()><span translate=SAVE_BTN></span></button></div></div></form><br><br><form name=cp novalidate autocomplete=off><legend translate=CLASSLIST_ACCOUNT class=col-md-12></legend><div style=\"margin-bottom: 10px\"><b translate=DELETE></b></div><div class=\"row form-group\"><div class=col-md-6><p translate=DELETE_ACCOUNT_TEXT_1></p></div><div class=col-md-6><button type=button class=\"btn btn-ghost pull-right\" ng-click=deleteAccount()><span translate=DELETE_BTN></span></button></div></div></form></div></div></div></div></div>");
$templateCache.put("app/profile/views/wrapper.html","<div class=content-logged><div ui-view autoscroll=false></div></div>");
$templateCache.put("app/pupil/views/add-pupil-modal.html","<div><div class=modal-header><h3 class=modal-title translate=ADD_PUPIL_TITLE></h3></div><div class=modal-body><form novalidate name=ap><div class=form-group><input class=form-control type=text name=firstName placeholder=\"{{\'PUPIL_FIRSTNAME_PHOLDER\' | translate }}\" ng-model=newPupil.firstName ng-minlength=regexes.min.name ng-maxlength=regexes.max.name maxlength={{::regexes.max.name}} remove-chars=nameField required><div class=error-text-red ng-show=\"(newPupil.firstName.length === 0 || newPupil.firstName.length === undefined) && isClicked >= 1\"><p translate=ERR_PUPIL_FIRSTNAME></p></div><div class=error-text-red ng-show=\"(newPupil.firstName.length < 3) && isClicked >= 1\"><p translate=ERR_PUPIL_FIRSTNAME_SHORT></p></div></div><div class=form-group><input class=form-control type=text name=lastName placeholder=\"{{\'PUPIL_LASTNAME_PHOLDER\' | translate }}\" ng-model=newPupil.lastName ng-minlength=regexes.min.name ng-maxlength=regexes.max.name maxlength={{::regexes.max.name}} remove-chars=nameField required><div class=error-text-red ng-show=\"(newPupil.lastName.length === 0 || newPupil.lastName.length === undefined) && isClicked >= 1\"><p translate=ERR_PUPIL_LASTNAME></p></div><div class=error-text-red ng-show=\"(newPupil.lastName.length < 3) && isClicked >= 1\"><p translate=ERR_PUPIL_LASTNAME_SHORT></p></div></div><div class=\"row form-group\"><div class=\"col-md-6 col-sm-6 col-xs-6\"><div class=is-relative><months ng-model=newPupil.monthId is-required=false></months><label class=select-placeholder translate=PUPIL_DOB_MONTH_PHOLDER ng-hide=\"newPupil.monthId.length > 0\"></label><span class=\"dripicons-chevron-down select-arrow\"></span></div></div><div class=\"col-md-6 col-sm-6 col-xs-6\"><div class=is-relative><genders ng-model=newPupil.genderId is-required=false></genders><label class=select-placeholder translate=PUPIL_GENDER_PHOLDER ng-hide=\"newPupil.genderId.length > 0\"></label><span class=\"dripicons-chevron-down select-arrow\"></span></div></div></div><div class=form-group><class-picker ng-model=newPupil.tier></class-picker><div class=error-text-red ng-show=\"newPupil.tier === null && isClicked >= 1\"><p translate=ERR_PUPIL_TIER></p></div></div></form></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary\" type=button ng-click=\"save(); isClicked = isClicked + 1\" ng-init=\"isClicked = 0\"><span translate=SAVE_BTN></span></button></div></div>");
$templateCache.put("app/pupil/views/edit-pupil-modal.html","<div><div class=modal-header><h3 class=modal-title translate=EDIT_PUPIL_TITLE></h3></div><div class=modal-body><form novalidate name=ap><div class=form-group><input class=form-control type=text name=firstName placeholder=\"{{\'PUPIL_FIRSTNAME_PHOLDER\' | translate }}\" ng-model=newPupil.firstName ng-minlength=regexes.min.name ng-maxlength=regexes.max.name maxlength={{::regexes.max.name}} remove-chars=nameField required><div class=error-text-red ng-show=\"(newPupil.firstName.length === 0 || newPupil.firstName.length === undefined) && isClicked >= 1\"><p translate=ERR_PUPIL_FIRSTNAME></p></div><div class=error-text-red ng-show=\"(newPupil.firstName.length < 3) && isClicked >= 1\"><p translate=ERR_PUPIL_FIRSTNAME_SHORT></p></div></div><div class=form-group><input class=form-control type=text name=lastName placeholder=\"{{\'PUPIL_LASTNAME_PHOLDER\' | translate }}\" ng-model=newPupil.lastName ng-minlength=regexes.min.name ng-maxlength=regexes.max.name maxlength={{::regexes.max.name}} remove-chars=nameField required><div class=error-text-red ng-show=\"(newPupil.lastName.length === 0 || newPupil.lastName.length === undefined) && isClicked >= 1\"><p translate=ERR_PUPIL_LASTNAME></p></div><div class=error-text-red ng-show=\"(newPupil.lastName.length < 3) && isClicked >= 1\"><p translate=ERR_PUPIL_LASTNAME_SHORT></p></div></div><div class=\"row form-group\"><div class=\"col-md-6 col-sm-6 col-xs-6\"><div class=is-relative><months ng-model=newPupil.monthId is-required=false></months><label class=select-placeholder translate=PUPIL_DOB_MONTH_PHOLDER ng-hide=\"newPupil.monthId.length > 0\"></label><span class=\"dripicons-chevron-down select-arrow\"></span></div></div><div class=\"col-md-6 col-sm-6 col-xs-6\"><div class=is-relative><genders ng-model=newPupil.genderId is-required=false></genders><label class=select-placeholder translate=PUPIL_GENDER_PHOLDER ng-hide=\"newPupil.genderId.length > 0\"></label><span class=\"dripicons-chevron-down select-arrow\"></span></div></div></div><div class=form-group><class-picker ng-model=newPupil.tier></class-picker><div class=error-text-red ng-show=\"newPupil.tier === null && isClicked >= 1\"><p translate=ERR_PUPIL_TIER></p></div></div></form></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary\" type=button ng-click=\"save(); isClicked = isClicked + 1\" ng-init=\"isClicked = 0\"><span translate=SAVE_BTN></span></button></div></div>");
$templateCache.put("app/raffle/modals/cancel-modal.html","<div style=\"padding: 15px\"><div class=modal-body><p translate=CANCEL_RAFFLE_CONFIRMATION></p></div><div class=modal-footer><button type=button class=\"btn btn-ghost pull-right\" translate=YES ng-click=cancel()><button type=button class=\"btn btn-default pull-right\" translate=NO ng-click=close()></button></button></div></div>");
$templateCache.put("app/raffle/modals/delete-modal.html","<div style=\"padding: 15px\"><div class=modal-body><p translate=DELETE_RAFFLE_CONFIRMATION></p></div><div class=modal-footer><button type=button class=\"btn btn-ghost pull-right\" translate=DELETE_BTN ng-click=delete()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></button></button></div></div>");
$templateCache.put("app/raffle/views/confirm-owner-modal.html","<div><div class=modal-header><h3 translate=ADD_RAFFLE_OWNER_HEADER></h3></div><div class=modal-body><p translate=ADD_RAFFLE_OWNER_TEXT translate-values=\"{\'name\':fullname}\"></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=OK_BTN ng-disabled=adding ng-click=add()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=cancel()></div></div>");
$templateCache.put("app/raffle/views/create-raffle.html","<section class=\"raffle-view raffle-create\" add-guests gallery-picker ng-class=\"{\'is-visible\': viewState.isReady }\"><div class=\"page-view-header clearfix\"><div><div><div class=pull-left><a id=header-back-button class=page-view-header__back ui-sref=raffle.list><div class=dripicons-arrow-thin-left style=\"float: left\"></div><span class=page-view-header__title translate=CREATE_RAFFLE style=\"color: #333; margin-left: 15px; float: left; padding-top: 12px\">Create a raffle</span></a></div></div></div></div><div class=create-raffle-container><div class=title translate=CREATE_RAFFLE></div><div style=\"margin: 20px 0 20px 0\"><img class=responsive src=https://storage.googleapis.com/classlist-branding/app-assets/raffle-header-img.png></div><div style=\"padding: 15px\"><div class=create-title translate=CREATE_RAFFLE_TITLE></div><p translate=CREATE_RAFFLE_DESC></p></div><div class=raffle-btn-area><button type=button ng-disabled=\"!adminHaveRoles(\'STAFF\', \'AMBASSADOR\', \'COMM_REP\')\" class=\"btn btn-primary raffle-button\" ui-sref=\"raffle.setup({path: \'setup-raffle\'})\"><span translate=CREATE_RAFFLE_BTN>Create a raffle</span></button></div><div style=\"padding-top: 15px\" ng-if=\"!adminHaveRoles(\'STAFF\', \'AMBASSADOR\', \'COMM_REP\')\"><div class=create-title>Unlock this feature</div><div class=how-it-works style=\"padding-bottom:15px !important\"><p>To create a fundraising raffle for your school community, <a ui-sref=school.page target=_blank style=\"font-weight: 700;text-decoration: underline\">contact an Ambassador</a> or Staff Admin about becoming a Community Rep or Ambassador.</p></div></div><div><div class=create-title>How it works</div><div class=how-it-works><p>Give the raffle a title, choose a time and date for the automated draw, set the ticket price, bundle options and add at least one prize. Parents or local businesses are often happy to donate prizes. Start selling tickets to parents in no time.</p><ul><li>Parents buy tickets quickly and easily through their Classlist accounts.</li><li>It is necessary to pay by <b>debit card</b> for raffle tickets on Classlist due to regulations about online payments. Credit card payments are not available for raffles.</li><li>Ticket sales close 15 minutes before the draw.</li><li>Automatic reminders are sent to your Classlist members who have not yet purchased tickets 24 hours, and 1 hour 15 minutes before the draw.</li></ul><div class=create-second-title>Draw</div><p>The draw is randomised and fully automated. The list of winners will appear on the admin Raffle page shortly after the draw takes place.</p><p>All participants will be informed of the result of their entries by email 15 minutes after the draw. This allows you time to announce the winners if you would like to do so.</p><div class=create-second-title>Ticket pricing</div><p>Set the ticket price and three ticket bundle options to suit your fundraising goals and to allow for different budgets. e.g. 5 for £5, 25 for £25 and 80 for £80 etc.</p><p><strong>Note:</strong> Classlist Raffles require you to connect to Stripe to collect payments. You may choose to contact Stripe to confirm your charitable status and that raffle prizes are not in restricted categories.</p><div class=create-second-title>Fees</div><p>Classlist Raffle service charge is 4.5%. This helps us bring you more time-saving community engagement tools. Note also that no ads are shown on the raffle page and you don’t need to spend on ticket books!</p><p>Stripe payment processing fees will apply. See their website for your location for details.</p><div class=create-second-title>Regulations</div><p>It is your PTA or school, and not Classlist, which is operating the raffle. We cannot provide you with legal guidance. Classlist serves an international community. Please consult the laws in your region regarding raffle licences, classification, and the legality of raffles for your location.</p><p><a href=https://www.classlist.com/terms target=_blank style=\"font-weight: 700\">Please see our Terms & Conditions</a></p><p>Our aim is to help you bring your community together and raise funds without the labour-intensive hours of traditional paper raffles. <a href=https://help.classlist.com/hc/en-us/articles/360013424238-Running-a-raffle-using-Classlist target=_blank style=\"font-weight: 700\">Read more about running a raffle using Classlist.</a></p><p>Don’t forget to share your raffle stories on Classlist Facebook and Instagram pages!</p></div></div></div></section>");
$templateCache.put("app/raffle/views/owners.html","<section class=\"event-tickets event-view event-create is-visible\"><div class=\"page-view-header clearfix\"><div><div class=row><div class=col-md-12><a id=header-back-button style=\"left: 10px!important\" class=page-view-header__back ng-click=back()><span class=dripicons-arrow-thin-left></span></a><div class=\"page-view-header__text pull-left\"><strong class=page-view-header__title translate=ADD_RAFFLE_OWNERS_TITLE></strong></div></div></div></div></div><div class=body-container><div class=page-container-header-from-top style=\"margin-top: 0!important\"><div class=mobile-row-fix><section class=event-section><h1 translate=ADD_RAFFLE_OWNERS_TITLE></h1><p translate=ADD_RAFFLE_OWNERS_TEXT></p><br><div><div class=event-input><label translate=SEARCH_REP_LABEL></label><input ng-model=searchInput type=text placeholder=\"{{\'CLEAR_REP_NAME\' | translate }}\"></div></div><br><div class=rep-list><div ng-repeat=\"rep in rep_list | filter:filterReps\" ng-click=selectRep(rep)><div class=vi-row><div class=vi-col-left style=\"width: 55px\"><figure ui-sref=\"classlist.details.contact({ \'id\': guest.userId })\" style=\"float: left; height: 40px; margin-right: 10px\"><avatar source={{rep.avatar}} name=\"{{ rep.name }}\" width=40 height=40 my=false></avatar></figure></div><div class=vi-col-middle><h4>{{ rep.name }}</h4></div></div></div></div></section></div></div></div></section>");
$templateCache.put("app/raffle/views/raffle-dashboard.html","<section class=raffle-dashboard><div class=\"page-view-header clearfix\" style=\"margin-bottom: -1px\"><div><div><div><a id=header-back-button style=\"float: left; margin-right: 10px; position: relative\" class=page-view-header__back ui-sref=raffle.list><span class=dripicons-arrow-thin-left></span></a></div></div></div></div><div><!--HEADER--><div class=page-container-header-from-top style=\"margin-top: 0 !important\"><div class=raffle-status-container><div><svg viewBox=\"0 0 37 27\" version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink><g id=Parents stroke=none stroke-width=1 fill=none fill-rule=evenodd stroke-linecap=square><g transform=\"translate(1.000000, 2.000000)\" stroke=#FFFFFF stroke-width=1.5><path d=\"M19.3454545,16 C19.3454545,14.343 20.7128727,13 22.4,13 L22.4,8 L0,8 L0,13 C1.68712727,13 3.05454545,14.343 3.05454545,16 C3.05454545,17.657 1.68712727,19 0,19 L0,24 L22.4,24 L22.4,19 C20.7128727,19 19.3454545,17.657 19.3454545,16 Z\" id=Path></path><line x1=7.2 y1=14 x2=15.2 y2=14 id=Path></line><line x1=7.2 y1=18 x2=15.2 y2=18 id=Path></line><polyline id=Path points=\"22.3146769 5.79372273 25.1384615 0 25.1384615 0 27.9622462 5.79372273 34.2769231 6.722717 29.7076923 11.2321329 30.7864877 17.6 25.1384615 14.5937227\"></polyline></g></g></svg></div><div><h4 translate=RAFFLE_IS_PUBLISHED ng-if=\"raffle.status === \'ACTIVE\'\"></h4><h4 translate=RAFFLE_IS_ENDED ng-if=\"raffle.status === \'COMPLETED\'\"></h4><h4 translate=RAFFLE_IS_CANCELLED ng-if=\"raffle.status === \'CANCELLED\'\"></h4><p style=\"margin-top: 5px; float: left\" ng-if=notify>A post has been published to the whole school newsfeed and notifications have been sent.</p></div></div></div><div class=raffle-dashboard-section><div class=raffle-menu-section><div class=raffle-main-buttons ng-if=\"raffle.status !== \'CANCELLED\' && raffle.status== \'ACTIVE\'\"><nav class=\"has-dropdown is-relative pull-right mobile-menu dropdown-new-btn\"><button translate=\" MENU \" type=\"button \" class=\"btn btn-ghost\" style=\"padding: 0 12px !important; min-height: 42px !important\"></button><ul class=\"dropdown-menu dropdown-location\"><li ng-if=\"raffle.status===\'ACTIVE\'\"><a ng-click=editRaffle()><span translate=\"EDIT \"></span></a></li><li ng-if=\"raffle.status===\'ACTIVE\'\"><a ng-click=cancelRaffle()><span translate=\"CANCEL_BTN \"></span></a></li></ul></nav></div><!-- Raffle Info --><div class=raffle-info-section><div class=star><svg xmlns=\"http://www.w3.org/2000/svg \" width=\"20 \" height=\"20 \" viewBox=\"0 0 24 24 \" fill=\"#E55700 \"><path d=\"M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z \"/></svg></div><div class=title>{{raffle.title}}</div></div></div><div class=clear></div><div class=raffle-detail-section><div class=raffle-summary><div><div class=raffle-icon><svg style=margin-top:-10px viewBox=\"0 0 37 27 \" version=\"1.1 \" xmlns=\"http://www.w3.org/2000/svg \" xmlns:xlink=\"http://www.w3.org/1999/xlink \"><g id=\"Parents \" stroke=\"none \" stroke-width=\"1 \" fill=\"none \" fill-rule=\"evenodd \" stroke-linecap=\"square \"><g transform=\"translate(1.000000, 2.000000) \" stroke=\"#FFFFFF \" stroke-width=\"1.5 \"><path d=\"M19.3454545,16 C19.3454545,14.343 20.7128727,13 22.4,13 L22.4,8 L0,8 L0,13 C1.68712727,13 3.05454545,14.343 3.05454545,16 C3.05454545,17.657 1.68712727,19 0,19 L0,24 L22.4,24 L22.4,19 C20.7128727,19 19.3454545,17.657\n                            19.3454545,16 Z \" id=\"Path \"></path><line x1=\"7.2 \" y1=\"14 \" x2=\"15.2 \" y2=\"14 \" id=\"Path \"></line><line x1=\"7.2 \" y1=\"18 \" x2=\"15.2 \" y2=\"18 \" id=\"Path \"></line><polyline id=\"Path \" points=\"22.3146769 5.79372273 25.1384615 0 25.1384615 0 27.9622462 5.79372273 34.2769231 6.722717 29.7076923 11.2321329 30.7864877 17.6 25.1384615 14.5937227 \"></polyline></g></g></svg></div></div><div><h2>Raffle summary</h2><p ng-if=\"raffle.statistics.usersJoined <=0 \">You haven’t sold any tickets yet.</p><div style=\"margin-top: 10px\"><a ng-click=\"viewRaffle() \">View your live raffle page from the events section on the parent side</a><svg style=\"margin-left: 10px\" width=\"6px \" height=\"10px \" viewBox=\"0 0 6 10 \" version=\"1.1 \" xmlns=\"http://www.w3.org/2000/svg \" xmlns:xlink=\"http://www.w3.org/1999/xlink \"><g id=\"Admins \" stroke=\"none \" stroke-width=\"1 \" fill=\"none \" fill-rule=\"evenodd \" stroke-linecap=\"round \"><g id=\"Group \" transform=\"translate(-1.000000, -0.818182) \" stroke=\"#DB006A \" stroke-width=\"1.5 \"><g id=\"arrow-copy-5 \" transform=\"translate(4.000000, 6.000000) scale(-1, 1) rotate(-180.000000) translate(-4.000000, -6.000000) \"><path d=\"M0.181818182,3.81818182 L3.81324111,7.77973411 C3.99983732,7.9832936 4.316121,7.99704506 4.5196805,7.81044886 C4.53035885,7.80066037 4.54060677,7.79041245 4.55039525,7.77973411 L8.18181818,3.81818182\n                            L8.18181818,3.81818182 \" id=\"Path-2 \" transform=\"translate(4.181818, 6.000000) scale(-1, 1) rotate(90.000000) translate(-4.181818, -6.000000) \"></path></g></g></g></svg></div><div class=download-link ng-if=\"raffle.statistics.usersJoined> 0\"><a ng-click=\"downloadCSV(\'users\')\">Download list </a><span> <?xml version=\"1.0\" encoding=\"UTF-8\"?> <svg width=10px height=7px viewBox=\"0 0 10 7\" version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink><g id=Admins stroke=none stroke-width=1 fill=none fill-rule=evenodd stroke-linecap=round><g id=PreviewAndPublish transform=\"translate(-232.000000, -797.000000)\" stroke=#DB006A stroke-width=1.5><g id=Group transform=\"translate(233.000000, 794.181818)\"><g id=arrow-copy-3 transform=\"translate(4.000000, 6.000000) scale(1, -1) rotate(-90.000000) translate(-4.000000, -6.000000) \"><path d=\"M0.181818182,3.81818182 L3.81324111,7.77973411 C3.99983732,7.9832936 4.316121,7.99704506 4.5196805,7.81044886 C4.53035885,7.80066037 4.54060677,7.79041245 4.55039525,7.77973411 L8.18181818,3.81818182 L8.18181818,3.81818182\" id=Path-2 transform=\"translate(4.181818, 6.000000) scale(-1, 1) rotate(90.000000) translate(-4.181818, -6.000000) \"></path></g></g></g></g></svg></span></div></div></div><div class=clear></div><div class=purchased-tickets ng-if=\"raffle.statistics.usersJoined > 0\"><h2>How many people purchased tickets?</h2><h3>{{raffle.statistics.usersJoined}}</h3></div><!-- start public share --><div class=sold-tickets><section class=event-section id=cue-event-sharing><h1 style=\"overflow: hidden !important\"><span style=\"float: left; margin-right: 7px;  margin-left:0px; line-height: 30px\">Raffle sharing</span> <span style=\"float: left\" ng-click=openInfo() class=\"icon dripicons-information\"></span><div ng-if=canMakePublic() class=pull-left style=\"overflow: auto; margin-left: 18px; margin-top: 1px\"><div ng-click=switchPublicEvent() ng-model=raffle.public class=\"mobile-checkmark {{ raffle.public ? \'enabled\' : \'\' }}\"><div></div></div></div></h1><p>Enable a public web link to share this raffle externally. Use it as a ‘guest checkout’ page for the public or to share with parents who haven\'t joined Classlist yet.</p><div class=row style=\"overflow: auto; margin-top:10px; {{!raffle.public || !canMakePublic() ? \'opacity: .4;\' : \'\'}}\"><div class=col-md-4><div class=share-event ng-click=shareWhatsapp()><div style=\"background-color: #00a69d\" class=circle><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 48 48\"><g transform=\"translate(0, 0)\"><path fill=#ffffff d=\"M0.10739,48l3.37542-12.32542c-2.08204-3.60688-3.17763-7.69894-3.17592-11.89098 C0.31215,10.66928,10.98554,0,24.09976,0c6.36475,0.00253,12.33865,2.47971,16.83067,6.97547 c4.49214,4.49575,6.96465,10.47174,6.96218,16.82712c-0.00531,13.11432-10.67966,23.785-23.79253,23.785h-0.00006h-0.00974 c-3.98213-0.00164-7.89481-1.00024-11.36995-2.89505L0.10739,48z M13.30466,40.38635l0.72215,0.42849 c3.03621,1.80129,6.51666,2.7542,10.06511,2.75559h0.0081c10.89973,0,19.77101-8.8685,19.77545-19.76937 c0.00202-5.28238-2.053-10.2494-5.78667-13.98611c-3.73368-3.73672-8.69893-5.79578-13.98092-5.79781 c-10.90811,0-19.77946,8.86787-19.78382,19.76797c-0.00152,3.73532,1.04402,7.37333,3.02355,10.52097l0.47026,0.7479 l-1.99782,7.29512L13.30466,40.38635z\"></path><path data-color=color-2 fill-rule=evenodd clip-rule=evenodd fill=#ffffff d=\"M18.15336,13.84087 c-0.48253-1.1589-0.97266-1.0021-1.33759-1.02027c-0.34636-0.01724-0.74309-0.02088-1.13941-0.02088 s-1.04036,0.14873-1.5853,0.74366c-0.54492,0.59496-2.08067,2.03281-2.08067,4.958c0,2.92519,2.13022,5.7512,2.42748,6.14787 c0.29723,0.39667,4.19204,6.39961,10.15569,8.97392c1.41836,0.6123,2.52578,0.9779,3.38909,1.25194 c1.42423,0.45222,2.72022,0.38844,3.74456,0.23544c1.14216-0.17059,3.51729-1.43777,4.01272-2.82601 c0.49537-1.38824,0.49537-2.57817,0.34674-2.82608c-0.14856-0.24784-0.54491-0.3966-1.13937-0.69412 c-0.59452-0.29745-3.51734-1.73529-4.06233-1.93359c-0.54491-0.19831-0.9412-0.29746-1.33755,0.29751 c-0.39628,0.59491-1.5356,1.9336-1.88241,2.3302c-0.34674,0.39667-0.69355,0.44627-1.28801,0.14876 c-0.59453-0.29745-2.51008-0.92506-4.7808-2.94978c-1.76725-1.57578-2.96047-3.52215-3.30725-4.11712 c-0.34677-0.59496-0.03689-0.91665,0.26073-1.2129c0.26739-0.26626,0.59446-0.69412,0.89172-1.04118 c0.29723-0.34706,0.39632-0.59497,0.59446-0.99157c0.19818-0.39667,0.09909-0.74372-0.04955-1.04121 C19.83772,17.956,18.64879,15.03077,18.15336,13.84087z\"></path></g></svg></div><span class=title translate=SHARE_BY_WHAAPP></span></div></div><div class=col-md-4><div class=share-event ng-click=shareFacebook()><div style=\"background-color: #3b5998\" class=circle><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 48 48\"><g transform=\"translate(0, 0)\"><path fill=#ffffff d=\"M19.32924,46V25.92955h-6.75413v-7.82187h6.75413v-5.76839C19.32924,5.64511,23.41782,2,29.38949,2 c2.86049,0,5.31894,0.21297,6.03539,0.30816v6.99581l-4.14167,0.00188c-3.24773,0-3.87657,1.54327-3.87657,3.80792v4.99391h7.74553 l-1.0085,7.82187h-6.73704V46H19.32924z\"></path></g></svg></div><span class=title translate=SHARE_BY_FACEBOOK></span></div></div><div class=col-md-4><div class=share-event ng-click=copyLink();><div style=\"background-color: #cfc4ff\" class=circle><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 48 48\"><g transform=\"translate(0, 0)\"><path d=M19,37H14a13,13,0,0,1,0-26h5a2,2,0,0,1,0,4H14a9,9,0,0,0,0,18h5a2,2,0,0,1,0,4Z fill=#ffffff></path><path d=M34,37H29a2,2,0,0,1,0-4h5a9,9,0,0,0,0-18H29a2,2,0,0,1,0-4h5a13,13,0,0,1,0,26Z fill=#ffffff></path><path data-color=color-2 d=M34,26H14a2,2,0,0,1,0-4H34a2,2,0,0,1,0,4Z fill=#ffffff></path></g></svg></div><span class=title translate=SHARE_BY_LINK></span></div></div></div></section></div><!-- end --><div class=sold-tickets ng-if=\"raffle.statistics.usersJoined > 0\"><h2>Which ticket bundle options have sold the most?</h2><h3>We hope this helps you identify great pricing options for your next raffle.</h3><div class=download-link><a ng-click=downloadCSV()>Download transaction list </a><span> <?xml version=\"1.0\" encoding=\"UTF-8\"?> <svg width=10px height=7px viewBox=\"0 0 10 7\" version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink><g id=Admins stroke=none stroke-width=1 fill=none fill-rule=evenodd stroke-linecap=round><g id=PreviewAndPublish transform=\"translate(-232.000000, -797.000000)\" stroke=#DB006A stroke-width=1.5><g id=Group transform=\"translate(233.000000, 794.181818)\"><g id=arrow-copy-3 transform=\"translate(4.000000, 6.000000) scale(1, -1) rotate(-90.000000) translate(-4.000000, -6.000000) \"><path d=\"M0.181818182,3.81818182 L3.81324111,7.77973411 C3.99983732,7.9832936 4.316121,7.99704506 4.5196805,7.81044886 C4.53035885,7.80066037 4.54060677,7.79041245 4.55039525,7.77973411 L8.18181818,3.81818182 L8.18181818,3.81818182\" id=Path-2 transform=\"translate(4.181818, 6.000000) scale(-1, 1) rotate(90.000000) translate(-4.181818, -6.000000) \"></path></g></g></g></g></svg></span></div><div class=bundle-container-preview style=\"margin-top: 25px\"><div class=\"bundles-sold first-bundle\">{{raffle.tickets[0].soldCount}}<br><div class=sold>bundles sold</div><span class=\"icons dripicons-arrow-down\"></span></div><div class=\"bundles-sold second-bundle\">{{raffle.tickets[1].soldCount}}<br><div class=sold>bundles sold</div><span class=\"icons dripicons-arrow-down\"></span></div><div class=\"bundles-sold third-bundle\">{{raffle.tickets[2].soldCount}}<br><div class=sold>bundles sold</div><span class=\"icons dripicons-arrow-down\"></span></div><div class=\"bundles-sold fourth-bundle\">{{raffle.customTicket ? raffle.customTicket.soldCount : 0}}<br><div class=sold>bundles sold</div><span class=\"icons dripicons-arrow-down\"></span></div></div><div class=bundle-container-preview><div class=\"first-bundle bundles-preview\"><div class=box><div>{{raffle.tickets[0].count}}</div><div>TICKET{{raffle.tickets[0].count !== 1 ? \'S\' : \'\'}}</div></div><span ng-bind-html=\"raffle.tickets[0].currency + raffle.tickets[0].price\">£1</span></div><div class=\"second-bundle bundles-preview\"><div class=box><div>{{raffle.tickets[1].count}}</div><div>TICKET{{raffle.tickets[1].count !== 1 ? \'S\' : \'\'}}</div></div><span ng-bind-html=\"raffle.tickets[1].currency + raffle.tickets[1].price\">£10</span></div><div class=\"third-bundle bundles-preview\"><div class=box><div>{{raffle.tickets[2].count}}</div><div>TICKET{{raffle.tickets[2].count !== 1 ? \'S\' : \'\'}}</div></div><span ng-bind-html=\"raffle.tickets[2].currency + raffle.tickets[2].price\">£50</span></div><div class=\"fourth-bundle bundles-preview\"><div class=box style=padding-bottom:5px><div>Custom big bundle</div></div><span ng-if=\"raffle.customTicket && raffle.customTicket.price\" ng-bind-html=\"raffle.customTicket.currency + raffle.customTicket.price +\' - \' + raffle.customTicket.currency + raffle.customTicket.maxPrice\"></span> <span ng-if=\"!raffle.customTicket || !raffle.customTicket.price\" ng-bind-html=\"raffle.customTicket.currency + 0\"></span></div></div></div><div ng-if=\"raffle.winners && raffle.winners.length !== 0\"><div class=raffle-summary><div><div class=raffle-icon-winners><svg xmlns=http://www.w3.org/2000/svg width=20 height=20 viewBox=\"0 0 24 24\" fill=#ffffff><path d=\"M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z\"></path></svg></div></div><div><h2>Winners</h2><div class=download-link><a ng-click=\"downloadCSV(\'winners\')\">Download list </a><span> <?xml version=\"1.0\" encoding=\"UTF-8\"?> <svg width=10px height=7px viewBox=\"0 0 10 7\" version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink><g id=Admins stroke=none stroke-width=1 fill=none fill-rule=evenodd stroke-linecap=round><g id=PreviewAndPublish transform=\"translate(-232.000000, -797.000000)\" stroke=#DB006A stroke-width=1.5><g id=Group transform=\"translate(233.000000, 794.181818)\"><g id=arrow-copy-3 transform=\"translate(4.000000, 6.000000) scale(1, -1) rotate(-90.000000) translate(-4.000000, -6.000000) \"><path d=\"M0.181818182,3.81818182 L3.81324111,7.77973411 C3.99983732,7.9832936 4.316121,7.99704506 4.5196805,7.81044886 C4.53035885,7.80066037 4.54060677,7.79041245 4.55039525,7.77973411 L8.18181818,3.81818182 L8.18181818,3.81818182\" id=Path-2 transform=\"translate(4.181818, 6.000000) scale(-1, 1) rotate(90.000000) translate(-4.181818, -6.000000) \"></path></g></g></g></g></svg></span></div></div></div><div class=clear></div><div class=winners><div ng-repeat=\"winner in raffle.winners\"><h2>{{($index + 1) + \'. \' + winner.prizeTitle}}</h2><a href={{winner.winnerLink}}>{{winner.winnerName}}</a></div></div></div><div class=sold-tickets ng-if=\"posts && posts.length > 0\"><section class=event-section><h1 translate=RAFFLE_ACTIVITY></h1><p translate=RAFFLE_ACTIVITY_DESC></p><br><div><post-asset ng-repeat=\"p in posts\" post-content={{p}} post-context=HOME_VIEW class=enter user-avatar={{userAvatar}} comment-only=true user-id={{user.id}} user-role=user.role user-name={{userName}} post-events=events></post-asset></div></section></div></div></div></div></section>");
$templateCache.put("app/raffle/views/raffle-draft.html","<section class=raffle-dashboard><div class=\"page-view-header clearfix\" style=\"margin-bottom: -1px\"><div><div><div><a id=header-back-button style=\"float: left; margin-right: 10px; position: relative\" class=page-view-header__back ui-sref=raffle.list><span class=dripicons-arrow-thin-left></span></a></div></div></div></div><!-- RAFFLE IS PUBLISHED --><div class=page-container-header-from-top style=\"margin-top: 0 !important\"><div class=raffle-status-container><div><svg viewBox=\"0 0 37 27\" version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink><g id=Parents stroke=none stroke-width=1 fill=none fill-rule=evenodd stroke-linecap=square><g transform=\"translate(1.000000, 2.000000)\" stroke=#FFFFFF stroke-width=1.5><path d=\"M19.3454545,16 C19.3454545,14.343 20.7128727,13 22.4,13 L22.4,8 L0,8 L0,13 C1.68712727,13 3.05454545,14.343 3.05454545,16 C3.05454545,17.657 1.68712727,19 0,19 L0,24 L22.4,24 L22.4,19 C20.7128727,19 19.3454545,17.657 19.3454545,16 Z\" id=Path></path><line x1=7.2 y1=14 x2=15.2 y2=14 id=Path></line><line x1=7.2 y1=18 x2=15.2 y2=18 id=Path></line><polyline id=Path points=\"22.3146769 5.79372273 25.1384615 0 25.1384615 0 27.9622462 5.79372273 34.2769231 6.722717 29.7076923 11.2321329 30.7864877 17.6 25.1384615 14.5937227\"></polyline></g></g></svg></div><div><h4 translate=RAFFLE_IS_DRAFT></h4></div></div></div><div class=raffle-draft-section><div class=icon><svg width=69 height=48 viewBox=\"0 0 30 30\" version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink><g id=Parents stroke=none stroke-width=1 fill=none fill-rule=evenodd stroke-linecap=square><g transform=\"translate(1.000000, 2.000000)\" stroke=#627293 stroke-width=1.5><path d=\"M19.3454545,16 C19.3454545,14.343 20.7128727,13 22.4,13 L22.4,8 L0,8 L0,13 C1.68712727,13 3.05454545,14.343 3.05454545,16 C3.05454545,17.657 1.68712727,19 0,19 L0,24 L22.4,24 L22.4,19 C20.7128727,19 19.3454545,17.657 19.3454545,16 Z\" id=Path></path><line x1=7.2 y1=14 x2=15.2 y2=14 id=Path></line><line x1=7.2 y1=18 x2=15.2 y2=18 id=Path></line><polyline id=Path points=\"22.3146769 5.79372273 25.1384615 0 25.1384615 0 27.9622462 5.79372273 34.2769231 6.722717 29.7076923 11.2321329 30.7864877 17.6 25.1384615 14.5937227\"></polyline></g></g></svg></div><div class=title><h2>{{raffle.title}}</h2></div><div class=buttons><button ui-sref=\"raffle.setup({raffle_id: raffle.id})\" class=\"btn btn-primary\">Edit and Publish</button> <button ng-click=deleteRaffle() class=\"btn btn-ghost\">Delete</button></div></div></section>");
$templateCache.put("app/raffle/views/raffle-list.html","<div class=raffle-list-container><div class=\"page-view-header clearfix\"><div><strong class=page-view-header__title translate=RAFFLES_HEADER></strong> <button type=button class=\"btn btn-primary page-view-header__button\" id=cue-button-create ui-sref=raffle.create><span translate=CREATE_RAFFLE_BTN class=hidden-xs></span> <span translate=CREATE_BTN class=visible-xs></span></button></div></div><div class=page-container-header-from-top><!--Draft raffles--><div style=\"padding: 0 15px\" ng-if=\"draftRaffles && draftRaffles.length > 0\"><div><div class=raffle-section-title translate=DRAFT_RAFFLES></div></div><div class=raffle-list><div class=raffle-container><div ng-repeat=\"raffle in draftRaffles\"><!-- Raffle item --> <a ui-sref=\"raffle.draft({raffle_id: raffle.id})\"><div class=raffle-thumbnail><div class=upload-img style=\"background-image: url(\'{{raffle.image}}\'); \n									background-repeat: no-repeat\"></div></div></a><div class=raffle-title><a ui-sref=\"raffle.draft({raffle_id: raffle.id})\">{{raffle.title}}</a></div><!-- END raffle item --></div></div></div></div><!-- END Draft raffles--><!--Upcoming raffles--><div style=\"padding: 0 15px\" ng-if=\"upcomingRaffles && upcomingRaffles.length > 0\"><div><div class=raffle-section-title translate=UPCOMING_RAFFLES></div></div><div class=raffle-list><div class=raffle-container><div ng-repeat=\"raffle in upcomingRaffles\"><!-- Raffle item --> <a ng-if=raffle.owner ui-sref=\"raffle.dashboard({raffle_id: raffle.id})\"><div class=raffle-thumbnail><div class=upload-img style=\"background-image: url(\'{{raffle.image}}\'); background-repeat: no-repeat\"></div></div></a><a ng-if=!raffle.owner ui-sref=\"raffle.otherpreview({raffle_id: raffle.id})\"><div class=raffle-thumbnail><div class=upload-img style=\"background-image: url(\'{{raffle.image}}\'); background-repeat: no-repeat\"></div></div></a><div class=raffle-title><a ng-if=raffle.owner ui-sref=\"raffle.dashboard({raffle_id: raffle.id})\">{{raffle.title}} </a><a ng-if=!raffle.owner ui-sref=\"raffle.otherpreview({raffle_id: raffle.id})\">{{raffle.title}}</a></div><!-- END raffle item --></div></div></div></div><!-- END Draft raffles--><!--Past raffles--><div style=\"padding: 0 15px\" ng-if=\"pastRaffles && pastRaffles.length > 0\"><div><div class=raffle-section-title translate=PAST_RAFFLES></div></div><div class=raffle-list><div class=raffle-container><div ng-repeat=\"raffle in pastRaffles\"><!-- Raffle item --> <a ng-if=raffle.owner ui-sref=\"raffle.dashboard({raffle_id: raffle.id})\"><div class=raffle-thumbnail><div class=upload-img style=\"background-image: url(\'{{raffle.image}}\'); background-repeat: no-repeat\"></div></div></a><a ng-if=!raffle.owner ui-sref=\"raffle.otherpreview({raffle_id: raffle.id})\"><div class=raffle-thumbnail><div class=upload-img style=\"background-image: url(\'{{raffle.image}}\'); background-repeat: no-repeat\"></div></div></a><div class=raffle-title><a ng-if=raffle.owner ui-sref=\"raffle.dashboard({raffle_id: raffle.id})\">{{raffle.title}} </a><a ng-if=!raffle.owner ui-sref=\"raffle.otherpreview({raffle_id: raffle.id})\">{{raffle.title}}</a></div><!-- END raffle item --></div></div></div></div><!-- END Past raffles--></div></div>");
$templateCache.put("app/raffle/views/raffle-otherpreview.html","<section class=raffle-dashboard><div class=\"page-view-header clearfix\" style=\"margin-bottom: -1px\"><div><div><div><a id=header-back-button style=\"float: left; margin-right: 10px; position: relative\" class=page-view-header__back ui-sref=raffle.list><span class=dripicons-arrow-thin-left></span></a></div></div></div></div><div><!--HEADER--><div class=page-container-header-from-top style=\"margin-top: 0 !important\"><div class=raffle-status-container><div><svg viewBox=\"0 0 37 27\" version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink><g id=Parents stroke=none stroke-width=1 fill=none fill-rule=evenodd stroke-linecap=square><g transform=\"translate(1.000000, 2.000000)\" stroke=#FFFFFF stroke-width=1.5><path d=\"M19.3454545,16 C19.3454545,14.343 20.7128727,13 22.4,13 L22.4,8 L0,8 L0,13 C1.68712727,13 3.05454545,14.343 3.05454545,16 C3.05454545,17.657 1.68712727,19 0,19 L0,24 L22.4,24 L22.4,19 C20.7128727,19 19.3454545,17.657 19.3454545,16 Z\" id=Path></path><line x1=7.2 y1=14 x2=15.2 y2=14 id=Path></line><line x1=7.2 y1=18 x2=15.2 y2=18 id=Path></line><polyline id=Path points=\"22.3146769 5.79372273 25.1384615 0 25.1384615 0 27.9622462 5.79372273 34.2769231 6.722717 29.7076923 11.2321329 30.7864877 17.6 25.1384615 14.5937227\"></polyline></g></g></svg></div><div><h4 translate=OTHER_RAFFLE_IS_PUBLISHED ng-if=\"raffle.status === \'ACTIVE\'\"></h4><h4 translate=OTHER_RAFFLE_IS_ENDED ng-if=\"raffle.status === \'COMPLETED\'\"></h4><h4 translate=OTHER_RAFFLE_IS_CANCELLED ng-if=\"raffle.status === \'CANCELLED\'\"></h4></div></div></div><div class=raffle-dashboard-section><div class=raffle-menu-section><!-- Raffle Info --><div class=raffle-info-section><div class=star><svg xmlns=\"http://www.w3.org/2000/svg \" width=\"20 \" height=\"20 \" viewBox=\"0 0 24 24 \" fill=\"#E55700 \"><path d=\"M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z \"/></svg></div><div class=title>{{raffle.title}}</div></div></div><div class=clear></div><div class=raffle-detail-section style=margin-top:20px><div class=raffle-summary style=margin-top:10px><div><div class=raffle-icon><svg style=\"margin-top: -10px\" viewBox=\"0 0 37 27\" version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink><g id=Parents stroke=none stroke-width=1 fill=none fill-rule=evenodd stroke-linecap=square><g transform=\"translate(1.000000, 2.000000)\" stroke=#FFFFFF stroke-width=1.5><path d=\"M19.3454545,16 C19.3454545,14.343 20.7128727,13 22.4,13 L22.4,8 L0,8 L0,13 C1.68712727,13 3.05454545,14.343 3.05454545,16 C3.05454545,17.657 1.68712727,19 0,19 L0,24 L22.4,24 L22.4,19 C20.7128727,19 19.3454545,17.657 19.3454545,16 Z\" id=Path></path><line x1=7.2 y1=14 x2=15.2 y2=14 id=Path></line><line x1=7.2 y1=18 x2=15.2 y2=18 id=Path></line><polyline id=Path points=\"22.3146769 5.79372273 25.1384615 0 25.1384615 0 27.9622462 5.79372273 34.2769231 6.722717 29.7076923 11.2321329 30.7864877 17.6 25.1384615 14.5937227\"></polyline></g></g></svg></div></div><div><h2>Raffle summary</h2><div style=\"margin-top: 10px\" ng-if=!isStaff()><a ng-click=\"viewRaffle() \">View raffle from the parent side</a><svg style=\"margin-left: 10px\" width=\"6px \" height=\"10px \" viewBox=\"0 0 6 10 \" version=\"1.1 \" xmlns=\"http://www.w3.org/2000/svg \" xmlns:xlink=\"http://www.w3.org/1999/xlink \"><g id=\"Admins \" stroke=\"none \" stroke-width=\"1 \" fill=\"none \" fill-rule=\"evenodd \" stroke-linecap=\"round \"><g id=\"Group \" transform=\"translate(-1.000000, -0.818182) \" stroke=\"#DB006A \" stroke-width=\"1.5 \"><g id=\"arrow-copy-5 \" transform=\"translate(4.000000, 6.000000) scale(-1, 1) rotate(-180.000000) translate(-4.000000, -6.000000) \"><path d=\"M0.181818182,3.81818182 L3.81324111,7.77973411 C3.99983732,7.9832936 4.316121,7.99704506 4.5196805,7.81044886 C4.53035885,7.80066037 4.54060677,7.79041245 4.55039525,7.77973411 L8.18181818,3.81818182\n                            L8.18181818,3.81818182 \" id=\"Path-2 \" transform=\"translate(4.181818, 6.000000) scale(-1, 1) rotate(90.000000) translate(-4.181818, -6.000000) \"></path></g></g></g></svg></div></div></div><div class=clear></div><!-- start public share --><div class=sold-tickets><section class=event-section id=cue-event-sharing><h3 style=\"font-size: 18px\">Raffle sharing</h3><div><h3 style=\"overflow: hidden !important\"><span style=\"float: left; margin-right: 7px;  margin-left:0px; line-height: 30px\">Classlist members link</span></h3><p style=\"padding-bottom: 30px\">Share the event with your school parents on Classlist. It will take members to the event page on the Classlist app, helping them to check out faster.</p><div class=row style=\"overflow: auto; margin-top:10px\"><div class=col-md-4><div class=share-event ng-click=sharePrivateWhatsapp()><div style=\"background-color: #00a69d\" class=circle><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 48 48\"><g transform=\"translate(0, 0)\"><path fill=#ffffff d=\"M0.10739,48l3.37542-12.32542c-2.08204-3.60688-3.17763-7.69894-3.17592-11.89098 C0.31215,10.66928,10.98554,0,24.09976,0c6.36475,0.00253,12.33865,2.47971,16.83067,6.97547 c4.49214,4.49575,6.96465,10.47174,6.96218,16.82712c-0.00531,13.11432-10.67966,23.785-23.79253,23.785h-0.00006h-0.00974 c-3.98213-0.00164-7.89481-1.00024-11.36995-2.89505L0.10739,48z M13.30466,40.38635l0.72215,0.42849 c3.03621,1.80129,6.51666,2.7542,10.06511,2.75559h0.0081c10.89973,0,19.77101-8.8685,19.77545-19.76937 c0.00202-5.28238-2.053-10.2494-5.78667-13.98611c-3.73368-3.73672-8.69893-5.79578-13.98092-5.79781 c-10.90811,0-19.77946,8.86787-19.78382,19.76797c-0.00152,3.73532,1.04402,7.37333,3.02355,10.52097l0.47026,0.7479 l-1.99782,7.29512L13.30466,40.38635z\"></path><path data-color=color-2 fill-rule=evenodd clip-rule=evenodd fill=#ffffff d=\"M18.15336,13.84087 c-0.48253-1.1589-0.97266-1.0021-1.33759-1.02027c-0.34636-0.01724-0.74309-0.02088-1.13941-0.02088 s-1.04036,0.14873-1.5853,0.74366c-0.54492,0.59496-2.08067,2.03281-2.08067,4.958c0,2.92519,2.13022,5.7512,2.42748,6.14787 c0.29723,0.39667,4.19204,6.39961,10.15569,8.97392c1.41836,0.6123,2.52578,0.9779,3.38909,1.25194 c1.42423,0.45222,2.72022,0.38844,3.74456,0.23544c1.14216-0.17059,3.51729-1.43777,4.01272-2.82601 c0.49537-1.38824,0.49537-2.57817,0.34674-2.82608c-0.14856-0.24784-0.54491-0.3966-1.13937-0.69412 c-0.59452-0.29745-3.51734-1.73529-4.06233-1.93359c-0.54491-0.19831-0.9412-0.29746-1.33755,0.29751 c-0.39628,0.59491-1.5356,1.9336-1.88241,2.3302c-0.34674,0.39667-0.69355,0.44627-1.28801,0.14876 c-0.59453-0.29745-2.51008-0.92506-4.7808-2.94978c-1.76725-1.57578-2.96047-3.52215-3.30725-4.11712 c-0.34677-0.59496-0.03689-0.91665,0.26073-1.2129c0.26739-0.26626,0.59446-0.69412,0.89172-1.04118 c0.29723-0.34706,0.39632-0.59497,0.59446-0.99157c0.19818-0.39667,0.09909-0.74372-0.04955-1.04121 C19.83772,17.956,18.64879,15.03077,18.15336,13.84087z\"></path></g></svg></div><span class=title translate=SHARE_BY_WHAAPP style=\"font-size: 16px\"></span></div></div><div class=col-md-4><div class=share-event ng-click=sharePrivateFacebook()><div style=\"background-color: #3b5998\" class=circle><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 48 48\"><g transform=\"translate(0, 0)\"><path fill=#ffffff d=\"M19.32924,46V25.92955h-6.75413v-7.82187h6.75413v-5.76839C19.32924,5.64511,23.41782,2,29.38949,2 c2.86049,0,5.31894,0.21297,6.03539,0.30816v6.99581l-4.14167,0.00188c-3.24773,0-3.87657,1.54327-3.87657,3.80792v4.99391h7.74553 l-1.0085,7.82187h-6.73704V46H19.32924z\"></path></g></svg></div><span class=title translate=SHARE_BY_FACEBOOK style=\"font-size: 16px\"></span></div></div><div class=col-md-4><div class=share-event ng-click=copyPrivateLink();><div style=\"background-color: #cfc4ff\" class=circle><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 48 48\"><g transform=\"translate(0, 0)\"><path d=M19,37H14a13,13,0,0,1,0-26h5a2,2,0,0,1,0,4H14a9,9,0,0,0,0,18h5a2,2,0,0,1,0,4Z fill=#ffffff></path><path d=M34,37H29a2,2,0,0,1,0-4h5a9,9,0,0,0,0-18H29a2,2,0,0,1,0-4h5a13,13,0,0,1,0,26Z fill=#ffffff></path><path data-color=color-2 d=M34,26H14a2,2,0,0,1,0-4H34a2,2,0,0,1,0,4Z fill=#ffffff></path></g></svg></div><span class=title translate=SHARE_BY_LINK style=\"font-size: 16px\"></span></div></div></div></div><div style=\"border-bottom: 1px solid #e5e5e5; margin-top:30px;margin-bottom:30px\"></div><div><h3 style=\"overflow: hidden !important\"><span style=\"float: left; margin-right: 7px;  margin-left:0px; line-height: 30px\">Guest checkout browser link</span> <span style=\"float: left; margin-left:0px;margin-top:5px\" ng-click=openInfo() class=\"icon dripicons-information\"></span></h3><p style=\"padding-bottom: 30px\">Enable a public web link to share this raffle externally. Use it as a ‘guest checkout’ page for the public or to share with parents who haven\'t joined Classlist yet.</p><div class=row style=\"overflow: auto; margin-top:10px; {{!raffle.public ? \'opacity: .4;\' : \'\'}}\"><div class=col-md-4><div class=share-event ng-click=shareWhatsapp()><div style=\"background-color: #00a69d\" class=circle><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 48 48\"><g transform=\"translate(0, 0)\"><path fill=#ffffff d=\"M0.10739,48l3.37542-12.32542c-2.08204-3.60688-3.17763-7.69894-3.17592-11.89098 C0.31215,10.66928,10.98554,0,24.09976,0c6.36475,0.00253,12.33865,2.47971,16.83067,6.97547 c4.49214,4.49575,6.96465,10.47174,6.96218,16.82712c-0.00531,13.11432-10.67966,23.785-23.79253,23.785h-0.00006h-0.00974 c-3.98213-0.00164-7.89481-1.00024-11.36995-2.89505L0.10739,48z M13.30466,40.38635l0.72215,0.42849 c3.03621,1.80129,6.51666,2.7542,10.06511,2.75559h0.0081c10.89973,0,19.77101-8.8685,19.77545-19.76937 c0.00202-5.28238-2.053-10.2494-5.78667-13.98611c-3.73368-3.73672-8.69893-5.79578-13.98092-5.79781 c-10.90811,0-19.77946,8.86787-19.78382,19.76797c-0.00152,3.73532,1.04402,7.37333,3.02355,10.52097l0.47026,0.7479 l-1.99782,7.29512L13.30466,40.38635z\"></path><path data-color=color-2 fill-rule=evenodd clip-rule=evenodd fill=#ffffff d=\"M18.15336,13.84087 c-0.48253-1.1589-0.97266-1.0021-1.33759-1.02027c-0.34636-0.01724-0.74309-0.02088-1.13941-0.02088 s-1.04036,0.14873-1.5853,0.74366c-0.54492,0.59496-2.08067,2.03281-2.08067,4.958c0,2.92519,2.13022,5.7512,2.42748,6.14787 c0.29723,0.39667,4.19204,6.39961,10.15569,8.97392c1.41836,0.6123,2.52578,0.9779,3.38909,1.25194 c1.42423,0.45222,2.72022,0.38844,3.74456,0.23544c1.14216-0.17059,3.51729-1.43777,4.01272-2.82601 c0.49537-1.38824,0.49537-2.57817,0.34674-2.82608c-0.14856-0.24784-0.54491-0.3966-1.13937-0.69412 c-0.59452-0.29745-3.51734-1.73529-4.06233-1.93359c-0.54491-0.19831-0.9412-0.29746-1.33755,0.29751 c-0.39628,0.59491-1.5356,1.9336-1.88241,2.3302c-0.34674,0.39667-0.69355,0.44627-1.28801,0.14876 c-0.59453-0.29745-2.51008-0.92506-4.7808-2.94978c-1.76725-1.57578-2.96047-3.52215-3.30725-4.11712 c-0.34677-0.59496-0.03689-0.91665,0.26073-1.2129c0.26739-0.26626,0.59446-0.69412,0.89172-1.04118 c0.29723-0.34706,0.39632-0.59497,0.59446-0.99157c0.19818-0.39667,0.09909-0.74372-0.04955-1.04121 C19.83772,17.956,18.64879,15.03077,18.15336,13.84087z\"></path></g></svg></div><span class=title translate=SHARE_BY_WHAAPP style=\"font-size: 16px\"></span></div></div><div class=col-md-4><div class=share-event ng-click=shareFacebook()><div style=\"background-color: #3b5998\" class=circle><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 48 48\"><g transform=\"translate(0, 0)\"><path fill=#ffffff d=\"M19.32924,46V25.92955h-6.75413v-7.82187h6.75413v-5.76839C19.32924,5.64511,23.41782,2,29.38949,2 c2.86049,0,5.31894,0.21297,6.03539,0.30816v6.99581l-4.14167,0.00188c-3.24773,0-3.87657,1.54327-3.87657,3.80792v4.99391h7.74553 l-1.0085,7.82187h-6.73704V46H19.32924z\"></path></g></svg></div><span class=title translate=SHARE_BY_FACEBOOK style=\"font-size: 16px\"></span></div></div><div class=col-md-4><div class=share-event ng-click=copyLink();><div style=\"background-color: #cfc4ff\" class=circle><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=48px height=48px viewBox=\"0 0 48 48\"><g transform=\"translate(0, 0)\"><path d=M19,37H14a13,13,0,0,1,0-26h5a2,2,0,0,1,0,4H14a9,9,0,0,0,0,18h5a2,2,0,0,1,0,4Z fill=#ffffff></path><path d=M34,37H29a2,2,0,0,1,0-4h5a9,9,0,0,0,0-18H29a2,2,0,0,1,0-4h5a13,13,0,0,1,0,26Z fill=#ffffff></path><path data-color=color-2 d=M34,26H14a2,2,0,0,1,0-4H34a2,2,0,0,1,0,4Z fill=#ffffff></path></g></svg></div><span class=title translate=SHARE_BY_LINK style=\"font-size: 16px\"></span></div></div></div></div></section></div><!-- end --><div class=form-div><section class=setup-raffle-section style=\"padding-left:10px !important\"><h1 style=\"font-size: 18px\" translate=RAFFLE_OWNERS></h1><p style=color:#666666 ng-if=\"raffle.raffleOwners && raffle.raffleOwners.length == 1\" translate=OTHER_RAFFLE_OWNERS_TEXT_ALONE translate-values=\"{ ownerName: ownerName }\"></p><p style=color:#666666 ng-if=\"raffle.raffleOwners && raffle.raffleOwners.length == 2\" translate=OTHER_RAFFLE_OWNERS_TEXT_TWO translate-values=\"{ ownerName: ownerName, ownerCount: 1 }\"></p><p style=color:#666666 ng-if=\"raffle.raffleOwners && raffle.raffleOwners.length > 2\" translate=OTHER_RAFFLE_OWNERS_TEXT_MORE translate-values=\"{ ownerName: ownerName, ownerCount: raffle.raffleOwners.length - 1 }\"></p><div style=padding-top:10px><div><div class=raffle-owner-list><div ng-repeat=\"owner in raffle.raffleOwners\"><div class=own-picture><figure style=\"float: left; width: 46px; height: 46px; margin-right: 10px\"><avatar source={{owner.avatar}} name=\"{{ owner.firstName }} {{ owner.lastName }}\" width=46 height=46 my=false></avatar></figure></div><div class=own-name><div style=\"color: #627293\">{{ owner.firstName }}</div><div style=\"color: #627293\">{{ owner.lastName }}</div></div></div></div></div></div></section></div><div class=sold-tickets ng-if=\"posts && posts.length > 0\"><section class=event-section><h1 translate=RAFFLE_ACTIVITY></h1><p translate=RAFFLE_ACTIVITY_DESC></p><br><div><post-asset ng-repeat=\"p in posts\" post-content={{p}} post-context=HOME_VIEW class=enter user-avatar={{userAvatar}} comment-only=true user-id={{user.id}} user-role=user.role user-name={{userName}} post-events=events></post-asset></div></section></div></div></div></div></section>");
$templateCache.put("app/raffle/views/raffle-preview.html","<section class=\"raffle-preview raffle-setup\"><div class=\"page-view-header clearfix\"><div><div><div class=pull-left><a ui-sref=\"raffle.prizes({raffle_id: raffle_id})\" id=header-back-button class=page-view-header__back><div class=dripicons-arrow-thin-left style=\"float: left\"></div><span class=page-view-header__title translate=SETUP_RAFFLE style=\"color: #333; margin-left: 15px; float: left; padding-top: 12px\">Create a raffle</span></a></div></div></div></div><!-- Raffle Container START --><div class=raffle-preview-container><div class=title translate=SETUP_RAFFLE></div><div class=setup-steps>1. Set up > 2. Add prizes > <span>3. Preview & publish</span></div><!-- Raffle Info --><div class=raffle-prizes-container><div class=raffle-section><img ng-src={{raffle.imagePath}}></div></div><div class=raffle-info-section><div><svg xmlns=http://www.w3.org/2000/svg width=20 height=20 viewBox=\"0 0 24 24\" fill=#E55700><path d=\"M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z\"/></svg></div><div>{{raffle.title}}<br><span ng-bind-html=changeLinks(raffle.description)></span></div></div><div class=clear></div><div class=raffle-draw-section><div><span class=\"icons dripicons-hourglass\"></span></div><div>Draw will be held on<br><span>{{raffle.drawDate | date:\'EEEE, LLLL d, y hh:mm a\' : \'GMT\'}}</span></div></div><div class=clear></div><!-- Bundles section --><div style=\"width: 96%; margin: 0 auto; margin-top: 30px\"><div class=bundle-container-preview><div class=\"first-bundle bundles-preview\"><div class=box><div>{{raffle.tickets[0].count}}</div><div>TICKET{{raffle.tickets[0].count !== 1 ? \'S\' : \'\'}}</div></div><span ng-bind-html=\"raffle.tickets[0].currency + raffle.tickets[0].priceView\">£1</span></div><div class=\"second-bundle bundles-preview\"><div class=box><div>{{raffle.tickets[1].count}}</div><div>TICKET{{raffle.tickets[1].count !== 1 ? \'S\' : \'\'}}</div></div><span ng-bind-html=\"raffle.tickets[1].currency + raffle.tickets[1].priceView\">£10</span></div><div class=\"third-bundle bundles-preview\"><div class=box><div>{{raffle.tickets[2].count}}</div><div>TICKET{{raffle.tickets[2].count !== 1 ? \'S\' : \'\'}}</div></div><span ng-bind-html=\"raffle.tickets[2].currency + raffle.tickets[2].priceView\">£50</span></div></div><div class=text-link-section><span><svg width=6px height=10px viewBox=\"0 0 6 10\" version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink><g id=Admins stroke=none stroke-width=1 fill=none fill-rule=evenodd stroke-linecap=round><g id=PreviewAndPublish transform=\"translate(-25.000000, -602.000000)\" stroke=#DB006A stroke-width=1.5><g id=Group transform=\"translate(24.000000, 601.181818)\"><g id=arrow-copy-4 transform=\"translate(4.000000, 6.000000) rotate(-180.000000) translate(-4.000000, -6.000000)\"><path d=\"M0.181818182,3.81818182 L3.81324111,7.77973411 C3.99983732,7.9832936 4.316121,7.99704506 4.5196805,7.81044886 C4.53035885,7.80066037 4.54060677,7.79041245 4.55039525,7.77973411 L8.18181818,3.81818182 L8.18181818,3.81818182\" id=Path-2 transform=\"translate(4.181818, 6.000000) scale(-1, 1) rotate(90.000000) translate(-4.181818, -6.000000)\"></path></g></g></g></g></svg></span><a ui-sref=\"raffle.setup({raffle_id: raffle_id})\">Back to edit</a></div></div></div><!-- Prizes section --><div class=raffle-prizes-container><div class=title>Prizes</div><div class=prizes-section ng-repeat=\"prize in raffle.prizes\"><div><img ng-src={{prize.imagePath}}></div><div><h2>{{prize.title}}</h2><p ng-bind-html=changeLinks(prize.description)></p><a ng-show=!$last ng-click=moveDown(prize.id)>Move down</a> <span ng-show=!$last> <?xml version=\"1.0\" encoding=\"UTF-8\"?> <svg width=10px height=7px viewBox=\"0 0 10 7\" version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink><g id=Admins stroke=none stroke-width=1 fill=none fill-rule=evenodd stroke-linecap=round><g id=PreviewAndPublish transform=\"translate(-232.000000, -797.000000)\" stroke=#DB006A stroke-width=1.5><g id=Group transform=\"translate(233.000000, 794.181818)\"><g id=arrow-copy-3 transform=\"translate(4.000000, 6.000000) scale(1, -1) rotate(-90.000000) translate(-4.000000, -6.000000)\"><path d=\"M0.181818182,3.81818182 L3.81324111,7.77973411 C3.99983732,7.9832936 4.316121,7.99704506 4.5196805,7.81044886 C4.53035885,7.80066037 4.54060677,7.79041245 4.55039525,7.77973411 L8.18181818,3.81818182 L8.18181818,3.81818182\" id=Path-2 transform=\"translate(4.181818, 6.000000) scale(-1, 1) rotate(90.000000) translate(-4.181818, -6.000000)\"></path></g></g></g></g></svg> </span><a ng-show=!$first ng-style=\"{ \'margin-left\': !$last ? \'30px\' : \'0\'}\" ng-click=moveUp(prize.id)>Move up</a> <span ng-show=!$first><svg width=10px height=6px viewBox=\"0 0 10 6\" version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink><title>arrow copy</title><g id=Admins stroke=none stroke-width=1 fill=none fill-rule=evenodd stroke-linecap=round><g id=PreviewAndPublish transform=\"translate(-357.000000, -933.000000)\" stroke=#DB006A stroke-width=1.5><g id=Group transform=\"translate(358.000000, 930.181818)\"><g id=arrow-copy transform=\"translate(4.000000, 6.000000) rotate(-90.000000) translate(-4.000000, -6.000000)\"><path d=\"M0.181818182,3.81818182 L3.81324111,7.77973411 C3.99983732,7.9832936 4.316121,7.99704506 4.5196805,7.81044886 C4.53035885,7.80066037 4.54060677,7.79041245 4.55039525,7.77973411 L8.18181818,3.81818182 L8.18181818,3.81818182\" id=Path-2 transform=\"translate(4.181818, 6.000000) scale(-1, 1) rotate(90.000000) translate(-4.181818, -6.000000)\"></path></g></g></g></g></svg></span></div></div><div class=clear></div><div class=text-link-section style=\"border-bottom: 2px solid #e7e8f6; padding-bottom: 15px\"><span><svg width=6px height=10px viewBox=\"0 0 6 10\" version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink><g id=Admins stroke=none stroke-width=1 fill=none fill-rule=evenodd stroke-linecap=round><g id=PreviewAndPublish transform=\"translate(-25.000000, -602.000000)\" stroke=#DB006A stroke-width=1.5><g id=Group transform=\"translate(24.000000, 601.181818)\"><g id=arrow-copy-4 transform=\"translate(4.000000, 6.000000) rotate(-180.000000) translate(-4.000000, -6.000000)\"><path d=\"M0.181818182,3.81818182 L3.81324111,7.77973411 C3.99983732,7.9832936 4.316121,7.99704506 4.5196805,7.81044886 C4.53035885,7.80066037 4.54060677,7.79041245 4.55039525,7.77973411 L8.18181818,3.81818182 L8.18181818,3.81818182\" id=Path-2 transform=\"translate(4.181818, 6.000000) scale(-1, 1) rotate(90.000000) translate(-4.181818, -6.000000)\"></path></g></g></g></g></svg></span><a ui-sref=\"raffle.prizes({raffle_id: raffle_id})\">Back to edit</a></div><div class=button-section style=\"border-bottom: none\"><!--\n            <div class=\"publish-info\">\n                <input ng-model=\"commentsEnabled\" id=\"checkbox\" name=\"checkbox\" type=\"checkbox\"> <label for=\"checkbox\">Comments enabled </label>\n                <p>Publishing the raffle will post it to the whole school newsfeed and send notifications.</p>\n            </div>\n            --><div class=wording>Publish your raffle to display it on Classlist and send notifications.</div><div class=wording>After you publish it you can opt to enable a public web page to share this raffle externally.</div><br><button class=\"btn btn-primary first-button\" ng-if=\"raffle.status===\'DRAFT\'\" ng-disabled=loading ng-click=publishRaffle()>Publish</button> <button class=\"btn btn-primary first-button\" ng-if=\"raffle.status !==\'DRAFT\'\" ng-disabled=loading ng-click=save()>Save</button><!--<button class=\"btn btn-ghost second-button\">Save as a draft</button>--></div><div class=clear></div></div></section>");
$templateCache.put("app/raffle/views/raffle-prizes.html","<section class=\"raffle-view raffle-setup\"><div class=\"page-view-header clearfix\"><div><div><div class=pull-left><a id=header-back-button class=page-view-header__back ui-sref=\"raffle.setup({raffle_id: raffle_id})\"><div class=dripicons-arrow-thin-left style=\"float: left\"></div><span class=page-view-header__title translate=SETUP_RAFFLE style=\"color: #333; margin-left: 15px; float: left; padding-top: 12px\">Create a raffle</span></a></div></div></div></div><!-- Raffle Container START --><div class=setup-raffle-container><div class=title translate=SETUP_RAFFLE></div><div class=setup-steps>1. Set up > <span>2. Add prizes</span> > 3. Preview & publish</div><!-- Raffle Name --><div class=raffle-name-section><div><svg xmlns=http://www.w3.org/2000/svg width=20 height=20 viewBox=\"0 0 24 24\" fill=#E55700><path d=\"M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z\"/></svg></div><div>{{raffle.title}}</div></div><div class=clear></div><!-- Form START --><div class=add-prizes-section><!-- Prizes section --><div class=prizes-section ng-repeat=\"prize in prizes track by $index\" id={{prize.id}}><div><img style=\"height: 120px\" ng-src={{prize.imagePath}}></div><div><h2>{{prize.title}}</h2><p>{{prize.description}}</p><div><a ng-click=edit($index)>Edit this prize</a> <a ng-click=\"delete($index, prize.id)\" class=delete>Delete</a></div></div></div><div class=clear></div><!-- Prizes section END --><!-- If users added any prizes we will use this title --><div ng-show=\"prizes.length !== 0 && !editing\" class=title translate=ADD_ANOTHER_PRIZES></div><!-- If users didn\'t add any prizes we will use this title --><div ng-show=\"prizes.length === 0 && !editing\" class=title translate=ADD_PRIZES></div><!-- If editing we will use this title --><div ng-show=editing class=title translate=EDIT_PRIZES></div><form id=form><div class=form-div><label>Title of prize</label><input ng-model=currentPrize.title class=\"{{titleError ? \'error-input\' : \'\'}}\" maxlength=80 name=prizetitle placeholder=\"Give a name to your prize\"> <span class=error-span ng-show=titleError>Please enter the title</span><div class=counter>{{ 80 - currentPrize.title.length }}</div></div><div class=form-div><label>Brief description of the prize (optional)</label><textarea ng-model=currentPrize.description rows=2 maxlength=150 name=prize-description placeholder=\"Describe the item, thank the sponsor or mention how collection will be arranged.\"></textarea><div class=counter>{{ 150 - currentPrize.description.length }}</div></div><!-- Before adding raffle image --><div class=form-div ng-if=!currentPrize.imagePath><span class=\"icons dripicons-camera\"></span> <a ng-click=uploadImage()>Add or take photo</a></div><!-- After adding raffle image --><div class=form-div ng-if=currentPrize.imagePath><img ng-src={{currentPrize.imagePath}}><br><span class=\"icons dripicons-camera\"></span> <a ng-click=uploadImage()>Change photo</a></div><div class=\"form-div button-section-prizes\"><button class=\"btn btn-primary first-button\" ng-disabled=loading ng-click=savePrize()>Save prize</button> <button class=\"btn btn-ghost second-button\" ng-show=editing ng-disabled=loading ng-click=cancel()>Cancel</button></div><div style=\"margin-top: 50px\" class=button-section-prizes><button ui-sref=\"raffle.preview({raffle_id: raffle_id})\" ng-disabled=\"loading || prizes.length === 0\" class=\"btn btn-primary first-button\">Continue to preview</button> <button ui-sref=raffle.list ng-if=\"raffle.status === \'DRAFT\'\" ng-disabled=loading class=\"btn btn-ghost second-button\">Save as a draft</button></div></form></div></div></section>");
$templateCache.put("app/raffle/views/remove-owner-modal.html","<div><div class=modal-header><h3 translate=REMOVE_RAFFLE_OWNER_HEADER></h3></div><div class=modal-body><p translate=REMOVE_RAFFLE_OWNER_TEXT translate-values=\"{\'name\':fullname}\"></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=OK_BTN ng-disabled=removing ng-click=remove()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=cancel()></div></div>");
$templateCache.put("app/raffle/views/setup-raffle.html","<section class=\"raffle-view raffle-setup\"><div class=\"page-view-header clearfix\"><div><div><div class=pull-left><a id=header-back-button class=page-view-header__back ui-sref=raffle.create><div class=dripicons-arrow-thin-left style=\"float: left\"></div><span class=page-view-header__title translate=SETUP_RAFFLE style=\"color: #333; margin-left: 15px; float: left; padding-top: 12px\">Create a raffle</span></a></div></div></div></div><!-- Raffle Container START --><div class=setup-raffle-container><div class=title translate=SETUP_RAFFLE></div><div class=setup-steps><span>1. Set up</span> > 2. Add prizes > 3. Preview & publish</div><!-- Form START --><form><div class=form-div><label>Title of raffle</label><textarea id=title class=\"{{titleError ? \'error-input\' : \'\'}}\" ng-focus=\"titleError = false\" ng-model=raffle.title rows=2 maxlength=70 name=raffletitle placeholder=\"Give a name to your raffle\"></textarea><br><span class=error-span ng-show=titleError>Please enter the title</span><div class=counter>{{ 70 - raffle.title.length }}</div></div><div class=form-div><label>Description</label><textarea id=description ng-model=raffle.description rows=4 maxlength=500 name=description placeholder=\"Include the organisers’ names and addresses or society, especially if different to the name of your Classlist school community.\"></textarea><br><div class=counter>{{ 500 - raffle.description.length }}</div></div><!-- Before adding raffle image --><div ng-if=!raffleImage><span class=\"icons dripicons-camera\"></span> <a ng-click=uploadImage()>Add a cover image</a></div><!-- After adding raffle image --><div class=form-div ng-if=raffleImage><img src={{raffleImage}}><br><span class=\"icons dripicons-camera\"></span> <a ng-click=uploadImage()>Change the cover image</a></div><div class=form-div><label>Draw date and time</label><p>Note ticket sales will end 15 minutes before the draw. A reminder email and notification will be sent 1 day and 1 hour 15 minutes before to those without tickets.</p><div><div class=is-relative style=\"width: 50%; float: left\"><input id=date class=\"{{dateError ? \'error-input\' : \'\'}}\" ng-change=dateChange() ng-focus=\"dateError = false\" placeholder=\"Select date\" type=text style=\"width: 100%\" uib-datepicker-popup=\"EEE, dd MMM yyyy\" ng-model=date show-button-bar=false is-open=calendarOpened datepicker-options=dateOptions ng-required=true> <span class=\"select-arrow date-picker-icon\"><button type=button class=\"btn btn-default\" ng-click=openCalendar()><i class=\"glyphicon glyphicon-calendar icon-calendar\"></i></button> </span><span class=error-span ng-show=dateError>Please choose the date</span></div><div class=is-relative style=\"width: 43%; margin-left: 3%; float: left\"><select id=time style=\"width: 99%; padding-right: 1%\" ng-model=time ng-change=timeChange()><option ng-repeat=\"time in eventTimes\" value=\"{{ time.value }}\">{{ time.text }}</option></select><span class=\"dripicons-chevron-down select-arrow\"></span></div></div></div><div class=clear></div><div class=form-div><label>Tickets and pricing</label><div class=form-price style=\"margin-bottom: 20px\"><div><label class=bundle-label>Ticket price</label><input id=price ng-model=raffle.price ng-change=countChanged() class=\"{{priceError ? \'error-input\' : \'\'}}\" ng-focus=\"priceError = false\" type=text placeholder=\"{{ active_school.currency ? active_school.currency : \'GBP\' }}\" min=1> <span class=error-span ng-show=priceError>Please enter the price</span></div><div style=\"margin-top: 7px\">The price of a single entry in the draw<br><a href=https://help.classlist.com/hc/en-us/articles/360013424238-Running-a-raffle-competition-using-Classlist target=_blank>See our ticket pricing help and suggestions</a></div></div><div class=clear></div><p>Your customers will choose one of three options. Create bundles to suit different budgets.</p><p>Tip: <span>Customers often go for the middle option, so consider offering a range of options. There is no limit to the number of tickets you can sell.</span></p></div><div class=form-div style=\"width: 96%\"><p>EXAMPLE of how your ticket options will display:</p><div class=bundle-container-preview><div class=\"first-bundle bundles-preview\"><div class=box><div>1</div><div>TICKET</div></div><span>£1</span></div><div class=\"second-bundle bundles-preview\"><div class=box><div>20</div><div>TICKETS</div></div><span>£20</span></div><div class=\"third-bundle bundles-preview\"><div class=box><div>50</div><div>TICKETS</div></div><span>£50</span></div></div><div class=bundle-container-preview style=\"margin-top: 25px\"><div class=\"bundles-sold first-bundle\">Ticket option 1</div><div class=\"bundles-sold second-bundle\">Ticket option 2</div><div class=\"bundles-sold third-bundle\">Ticket option 3</div></div></div><div class=form-div><div class=bundle-title><svg width=20px height=15px viewBox=\"0 0 20 15\" version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink><g id=Admins stroke=none stroke-width=1 fill=none fill-rule=evenodd stroke-linecap=square><g id=CreateRaffle-SetUp-STRIPE transform=\"translate(-19.000000, -1092.000000)\" stroke=#627293 stroke-width=1.3><g id=Group transform=\"translate(20.000000, 1093.000000)\"><path d=\"M15.237013,6.5 C15.237013,5.1536875 16.3140292,4.0625 17.6428571,4.0625 L17.6428571,0 L0,0 L0,4.0625 C1.32882792,4.0625 2.40584416,5.1536875 2.40584416,6.5 C2.40584416,7.8463125 1.32882792,8.9375 0,8.9375 L0,13 L17.6428571,13 L17.6428571,8.9375 C16.3140292,8.9375 15.237013,7.8463125 15.237013,6.5 Z\" id=Path></path><line x1=5.51339286 y1=4.80434783 x2=11.578125 y2=4.80434783 id=Path></line><line x1=5.51339286 y1=8.19565217 x2=11.578125 y2=8.19565217 id=Path></line></g></g></g></svg> Ticket Option 1</div><div class=form-bundle><div style=\"width: 50%; float: left\"><label class=bundle-label>Entries per bundle</label><input id=count1 ng-model=ticket1.count ng-change=countChanged() class=\"{{count1Error ? \'error-input\' : \'\'}}\" ng-focus=\"count1Error = false\" type=text placeholder=\"e.g. 1\" min=1> <span class=error-span ng-show=count1Error translate=RAFFLE_COUNT_ERROR></span></div><div style=\"width: 50%; float: left\"><label class=bundle-label>Price</label><input disabled ng-model=ticket1.priceView class=\"{{price1Error ? \'error-input\' : \'\'}}\" ng-focus=\"price1Error = false\" placeholder=\"{{ active_school.currency ? active_school.currency : \'GBP\' }}\" min=0> <span class=error-span ng-show=price1Error>Please enter the price</span></div><div class=clear></div><p class=bundle>Enter 1 if you want to offer a single ticket option, or make it your smallest bundle with e.g. 5 or 10 tickets.</p></div><div class=bundle-title><svg width=20px height=15px viewBox=\"0 0 20 15\" version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink><g id=Admins stroke=none stroke-width=1 fill=none fill-rule=evenodd stroke-linecap=square><g id=CreateRaffle-SetUp-STRIPE transform=\"translate(-19.000000, -1092.000000)\" stroke=#627293 stroke-width=1.3><g id=Group transform=\"translate(20.000000, 1093.000000)\"><path d=\"M15.237013,6.5 C15.237013,5.1536875 16.3140292,4.0625 17.6428571,4.0625 L17.6428571,0 L0,0 L0,4.0625 C1.32882792,4.0625 2.40584416,5.1536875 2.40584416,6.5 C2.40584416,7.8463125 1.32882792,8.9375 0,8.9375 L0,13 L17.6428571,13 L17.6428571,8.9375 C16.3140292,8.9375 15.237013,7.8463125 15.237013,6.5 Z\" id=Path></path><line x1=5.51339286 y1=4.80434783 x2=11.578125 y2=4.80434783 id=Path></line><line x1=5.51339286 y1=8.19565217 x2=11.578125 y2=8.19565217 id=Path></line></g></g></g></svg> Ticket Option 2</div><div class=form-bundle><div style=\"width: 50%; float: left\"><label class=bundle-label>Entries per bundle</label><input id=count2 ng-model=ticket2.count ng-change=countChanged() class=\"{{count2Error ? \'error-input\' : \'\'}}\" ng-focus=\"count2Error = false\" type=text placeholder=\"e.g. 20\" min=1> <span class=error-span ng-show=count2Error translate=RAFFLE_COUNT_ERROR></span></div><div style=\"width: 50%; float: left\"><label class=bundle-label>Price</label><input disabled ng-model=ticket2.priceView class=\"{{price2Error ? \'error-input\' : \'\'}}\" ng-focus=\"price2Error = false\" placeholder=\"{{ active_school.currency ? active_school.currency : \'GBP\' }}\" min=0> <span class=error-span ng-show=price2Error>Please enter the price</span></div><div class=clear></div><p class=bundle>The middle bundle.</p></div></div><div class=bundle-title><svg width=20px height=15px viewBox=\"0 0 20 15\" version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink><g id=Admins stroke=none stroke-width=1 fill=none fill-rule=evenodd stroke-linecap=square><g id=CreateRaffle-SetUp-STRIPE transform=\"translate(-19.000000, -1092.000000)\" stroke=#627293 stroke-width=1.3><g id=Group transform=\"translate(20.000000, 1093.000000)\"><path d=\"M15.237013,6.5 C15.237013,5.1536875 16.3140292,4.0625 17.6428571,4.0625 L17.6428571,0 L0,0 L0,4.0625 C1.32882792,4.0625 2.40584416,5.1536875 2.40584416,6.5 C2.40584416,7.8463125 1.32882792,8.9375 0,8.9375 L0,13 L17.6428571,13 L17.6428571,8.9375 C16.3140292,8.9375 15.237013,7.8463125 15.237013,6.5 Z\" id=Path></path><line x1=5.51339286 y1=4.80434783 x2=11.578125 y2=4.80434783 id=Path></line><line x1=5.51339286 y1=8.19565217 x2=11.578125 y2=8.19565217 id=Path></line></g></g></g></svg> Ticket Option 3</div><div class=form-bundle><div style=\"width: 50%; float: left\"><label class=bundle-label>Entries per bundle</label><input id=count3 ng-model=ticket3.count ng-change=countChanged() class=\"{{count3Error ? \'error-input\' : \'\'}}\" ng-focus=\"count3Error = false\" type=text placeholder=\"e.g. 50\" min=1> <span class=error-span ng-show=count3Error translate=RAFFLE_COUNT_ERROR></span></div><div style=\"width: 50%; float: left\"><label class=bundle-label>Price</label><input disabled ng-model=ticket3.priceView class=\"{{price3Error ? \'error-input\' : \'\'}}\" ng-focus=\"price3Error = false\" placeholder=\"{{ active_school.currency ? active_school.currency : \'GBP\' }}\" min=0> <span class=error-span ng-show=price3Error>Please enter the price</span></div><div class=clear></div><p class=bundle>This is your largest ticket bundle.</p></div></form></div><!-- Linked Stripe Account START--><div class=stripe-section ng-if=raffle.stripeDisplayName><h2>Linked Stripe Account</h2><p>Name: {{raffle.stripeDisplayName}}</p><a href=http://dashboard.stripe.com target=_blank>Manage Stripe account</a> <span class=\"icons dripicons-exit\"></span><br><a ng-click=\"redirectStripe(\'update\')\">Switch it</a> <span class=\"icons dripicons-exit\"></span></div><!-- Linked Stripe Account END --><!-- Before users linked Stripe Account buttons --><div class=form-div><section class=setup-raffle-section><h1 translate=RAFFLE_OWNERS></h1><p ng-if=\"raffle.raffleOwners && raffle.raffleOwners.length == 1\" translate=RAFFLE_OWNERS_TEXT_ALONE></p><p ng-if=\"raffle.raffleOwners && raffle.raffleOwners.length > 1\" translate=RAFFLE_OWNERS_TEXT_MORE translate-values=\"{ ownerCount: raffle.raffleOwners.length - 1 }\"></p><br><div><div><div class=raffle-owner-list><div ng-repeat=\"owner in raffle.raffleOwners\"><div class=own-picture><figure style=\"float: left; width: 46px; height: 46px; margin-right: 10px\"><avatar source={{owner.avatar}} name=\"{{ owner.firstName }} {{ owner.lastName }}\" width=46 height=46 my=false></avatar></figure><div ng-if=\"owner.id != active_user.id\" ng-click=\"removeOwner(owner, $index)\" class=own-remove><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=24px height=24px viewBox=\"0 0 24 24\"><g transform=\"translate(0, 0)\"><polygon points=\"16.95 8.464 15.536 7.05 12 10.586 8.464 7.05 7.05 8.464 10.586 12 7.05 15.536 8.464 16.95 12 13.414 15.536 16.95 16.95 15.536 13.414 12 16.95 8.464\" fill=#444444></polygon></g></svg></div></div><div class=own-name><div>{{ owner.firstName }}</div><div>{{ owner.lastName }}</div></div></div></div></div><br><div ng-if=raffle_id><button ng-click=gotoAddOwner() type=button class=\"btn btn-ghost\"><span translate=ADD_ANOTHER_OWNER></span></button></div></div></section></div><div class=button-section style=\"margin-bottom: 30px\"><div class=stripe-warn ng-if=!raffle.stripeDisplayName>This could take a few moments</div><button ng-if=!raffle.stripeDisplayName class=\"btn btn-primary first-button\" ng-click=save() ng-disabled=loading>Save and connect Stripe<span class=\"icons dripicons-exit\"></span></button> <button ng-if=raffle.stripeDisplayName id=saveButton class=\"btn btn-primary first-button\" ng-click=save() ng-disabled=loading>Save and continue</button> <button ng-if=refresh class=\"btn btn-ghost second-button\" ng-click=refreshPage()>Refresh</button> <button ng-if=\"(!raffle_id || raffle.status === \'DRAFT\') && !refresh\" class=\"btn btn-ghost second-button\" ng-click=save(true) ng-disabled=loading>Save as a draft</button></div><!-- Form END --><!-- Raffle Container END --></section>");
$templateCache.put("app/raffle/views/wrapper.html","<div class=\"content-logged events\" photo-upload><div ui-view autoscroll=false></div></div>");
$templateCache.put("app/school/views/delete-pupils-modal.html","<div><form novalidate name=tn><div class=modal-body><p translate=PUPILS_DELETE_CONFIRMATION translate-values=\"{\'number\':arr.length}\" ng-if=\"arr.length === 1\"></p><p translate=PUPILS_DELETE_CONFIRMATION_PLURAL translate-values=\"{\'number\':arr.length}\" ng-if=\"arr.length > 1\"></p></div><div class=modal-footer><button class=\"btn btn-ghost pull-left\" type=button ng-click=cancel()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary pull-right\" type=button ng-click=delete()><span translate=DELETE_BTN></span></button></div></form></div>");
$templateCache.put("app/school/views/edit-tier-modal.html","<div><form novalidate name=tn><div class=modal-header><h3 translate=EDIT_TIER translate-values=\"{\'name\':tier.name}\"></h3></div><div class=modal-body><input type=text class=form-control ng-model=newName ng-minlength=2 ng-maxlength=30 maxlength=30 placeholder=\"{{ \'TYPE_NEW_NAME_PHOLDER\' | translate }}\" required></div><div ng-if=cannotDelete><span translate=CANNOT_DEL_BECAUSE_PUPILS style=\"color: red; padding: 15px; display: inline-block; padding-bottom: 0\"></span></div><div class=modal-footer><button class=\"btn btn-ghost pull-left\" type=button ng-click=delete()><span translate=DELETE_BTN></span></button> <small translate=PLEASE_MOVE_PUPILS class=\"pull-left edit-tier-dialog-footer-text\"></small> <button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary pull-right\" type=button ng-click=save() ng-disabled=tn.$invalid><span translate=SAVE_BTN></span></button></div></form></div>");
$templateCache.put("app/school/views/moving-pupils-question-modal.html","<div style=\"padding: 20px\"><div style=\"float: right; cursor: pointer; font-size: 24px\" ng-click=cross()><span class=\"icons dripicons-cross\"></span></div><div class=modal-header><h3 translate=MOVE_PUPILS_TITLE></h3></div><div class=modal-body><p><span translate=MOVE_PUPILS_DESC></span></p></div><div class=modal-footer><button style=margin-bottom:10px class=\"btn btn-primary\" type=button ng-click=confirm()><span translate=CONTINUE_MOVE_BTN></span></button><br><button class=\"btn btn-default\" style=\"margin-right: 0\" type=button ng-click=close()><span translate=RENAME_BTN></span></button></div></div>");
$templateCache.put("app/school/views/school-integration-structure.html","<section class=moveup ng-class=\"{\'is-visible\':true}\"><div class=page-view-header><div><div class=row><div class=col-xs-12><strong class=page-view-header__title translate=SCHOOL_STR_TITLE class=section-title></strong></div></div></div></div><script type=text/ng-template id=selectionTemplate.html><a>\n		<span style=\"font-size: 16px;\" ng-bind-html=\"match.model.firstName | uibTypeaheadHighlight:query\" ng-if=\"match.model.firstName\"></span>\n		<span style=\"font-size: 16px;\"  ng-bind-html=\"match.model.lastName | uibTypeaheadHighlight:query\" ng-if=\"match.model.lastName\"></span>\n		<span translate=\"PARENTHESES_OPEN\"></span>\n		<span ng-bind-html=\"match.model.tier1Name | uibTypeaheadHighlight:query\" ng-if=\"match.model.tier1Name\"></span>\n		<span translate=\"CHAR_SLASH\"  ng-if=\"match.model.tier2Name\"></span>\n		<span ng-bind-html=\"match.model.tier2Name | uibTypeaheadHighlight:query\" ng-if=\"match.model.tier2Name\"></span>\n		<span translate=\"PARENTHESES_CLOSE\">\n	</a></script><div><div class=row><div class=col-xs-12><div class=structure><div class=yellow-tooltip ng-if=\"unassignedPupilsCount > 0\"><p style=\"padding: 10px\" translate=MOVEUP_GUIDED_SETUP_TEXT_4></p></div><div class=structure-mobile-alert>Viewing and editing the school structure is not optimised for mobile just yet! It will work better if you\'re able to use a larger screen.</div><div class=guideline-text ng-if=integrationEnabled><p translate=INTEGRATION_MOVEUP_GUIDED_SETUP_TEXT_1></p><br><button ng-click=redirectToIntegration() type=button class=\"btn btn-primary\" translate=SWITCH_TO_SYNC style=\"float: left\" ng-hide=\"active_user.role !== \'STAFF\' || isStaffWithoutUserManagementPermission()\"></button></div><table class=\"table table-bordered\" style=\"background: #fff\"><tbody><thead></thead><!-- SELECTOR --><!-- GREY LABELS --><tr class=middle-row-labels><th class=table-col-1><span class=year-class-labels translate=YEAR_LABEL></span></th><th class=table-col-2><span class=year-class-labels translate=CLASS_LABEL></span></th><th class=table-col-3><div class=pupils-label><span class=pupils-label-counter translate=MOVEUP_PUPILS_LABEL_NUMBERS translate-values={n:pupilNumber}></span> <span translate=MOVEUP_PUPILS_LABEL></span> <span class=pupils-label-counter ng-if=\"topTierName != \'\' && subTierName == \'\'\" translate=MOVEUP_PUPILS_LABEL_TIER translate-values=\"{tier:topTierName, n:pupilNumber}\"></span> <span class=pupils-label-counter ng-if=\"subTierName != \'\'\" translate=MOVEUP_PUPILS_LABEL_TIER translate-values={tier:subTierName}></span></div><div class=\"pull-right pupil-search is-relative\"><input type=text ng-model=keyword placeholder=\"{{ \'FIND_A_PUPIL_PLACEHOLDER\' | translate }}\" uib-typeahead=\"r.field1 for r in queryPupils\" typeahead-wait-ms=300 typeahead-min-length=2 typeahead-on-select=pickPupil($item) typeahead-template-url=selectionTemplate.html class=form-control autocomplete=off> <span class=\"icon dripicons-search\"></span></div></th></tr><!-- LIST --><tr><td><aside><div id=toptier-item-id class=tier-item ng-repeat=\"t in tiers\" ng-click=\"showSubTiers(t); clearDraggables()\" ng-class=\"{\'active\': topActive === t.id}\" droppable events=droppablevents droptarget={{t}}><span class=tier-name>{{t.name}} <span ng-if=t.locked>({{getPupilsCount(t.pupils)}})</span></span></div></aside></td><td><aside><div id=tier-item-id class=tier-item ng-repeat=\"t in topTier.tiers\" ng-click=\"showPupils(t); clearDraggables()\" ng-class=\"{\'active\': subActive === t.id}\" droppable events=droppablevents droptarget={{t}}><span class=tier-name>{{t.name}} ({{getPupilsCount(t.pupils)}})</span></div></aside></td><td><aside><div class=delete-pupils-container><div ng-show=\"pupils.length > 0\" class=show-hide-options style=\"width: 100%\"><div class=structure-show-checkboxes-row style=\"display: flex; flex-wrap: wrap; gap: 16px\"><label class=structure-show-parents-checkbox style=\"cursor:pointer; display: flex; align-items: center; margin-bottom: 0; padding-right: 30px\"><input type=checkbox ng-model=showParents ng-change=showParent() style=\"margin-right:7px; width:20px; height:20px\"> <span translate=SCHOOL_STRUCTURE_SHOW_TEXT style=\"font-size: 13px\"></span></label><label class=structure-show-parents-checkbox style=\"cursor:pointer; display: flex; align-items: center; margin-bottom: 0;margin-left:auto; margin-right:5px\"><input type=checkbox ng-model=showDeactivatedPupils ng-change=showDeactivated() style=\"margin-right:7px; width:20px; height:20px\"> <span translate=SCHOOL_STRUCTURE_SHOW_DEACTIVATED style=\"font-size: 13px\"></span></label></div><div class=structure-key-row style=\"display: flex; align-items: center; justify-content: flex-end; margin-top: 10px; gap: 12px; font-size: 11px\"><span style=\"font-weight: 900; margin-right: 5px; font-size: 12px\">Key:</span> <span style=\"display: flex; align-items: center; margin-right: 7px\"><img src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid-active.svg alt=\"\" width=20 draggable=false> <span style=\"font-size: 12px; margin-left:5px\" translate=SCHOOL_STRUCTURE_PUPIL_ACTIVED>Activated</span> </span><span style=\"display: flex; align-items: center; margin-right: 7px\"><img src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid-deactive.svg alt=\"\" width=20 draggable=false> <span style=\"font-size: 12px; margin-left:5px\" translate=SCHOOL_STRUCTURE_PUPIL_DEACTIVED>Deactivated</span> </span><span style=\"display: flex; align-items: center; margin-right: 0\"><img src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid-pending.svg alt=\"\" width=18 draggable=false> <span style=\"font-size: 12px; margin-left:5px\" translate=SCHOOL_STRUCTURE_PUPIL_PENDING>Pending approval</span></span></div></div></div><div ng-repeat=\"p in pupils | orderBy : \'lastName\'\"><div ng-if=\"showDeactivatedPupils || p.status !== \'DISABLED\'\" class=pupil-parent-container ng-show=showParents><div class=pupil-parent-item ng-class=\"{\'pending-disabled-pupil\': p.status == \'UNAPPROVED\' || p.status == \'DISABLED\'}\" draggable dragtarget={{p.id}} dragname=\"{{p.firstName}} {{p.lastName}}\" draggender={{p.gender}}><figure class=\"avatar {{p.gender}}\" style=\"background: transparent\"><img src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid-active.svg alt=\"\" width=30 ng-if=\"p.status == \'APPROVED\'\" draggable=false style=margin:0> <img src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid-deactive.svg alt=\"\" width=30 ng-if=\"p.status == \'DISABLED\'\" draggable=false style=margin:0> <img src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid-pending.svg alt=\"\" width=30 ng-if=\"p.status == \'UNAPPROVED\'\" draggable=false style=margin:0></figure><div>{{p.firstName}} {{p.lastName}}</div></div><div class=parent-item><div><a ng-repeat=\"parent in p.parents\" class=parent-name ui-sref=\"users.parentdetail({\'id\': parent.id})\">{{parent.name}}<span ng-if=\"$index < p.parents.length-1\">, </span></a></div></div></div><div ng-if=\"showDeactivatedPupils || p.status !== \'DISABLED\'\" class=pupil-item ng-show=!showParents ng-class=\"{\'pending-disabled-pupil\': p.status == \'UNAPPROVED\' || p.status == \'DISABLED\'}\" draggable dragtarget={{p.id}} dragname=\"{{p.firstName}} {{p.lastName}}\" draggender={{p.gender}} style=\"height: auto;\n										min-height: 30px;\n										line-height: 20px;\n										padding:0 10px 0 38px;\n										position:relative;\n										margin: 0;\n										width: 100%;\n										border-bottom-right-radius: 20px;\n										border-top-right-radius: 20px;\n										padding-top: 5px;\n										padding-bottom: 5px;\n										margin-top: 5px\"><figure class=\"avatar {{p.gender}}\" style=\"background: transparent\"><img src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid-active.svg alt=\"\" width=30 ng-if=\"p.status == \'APPROVED\'\" draggable=false style=margin:0> <img src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid-deactive.svg alt=\"\" width=30 ng-if=\"p.status == \'DISABLED\'\" draggable=false style=margin:0> <img src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid-pending.svg alt=\"\" width=30 ng-if=\"p.status == \'UNAPPROVED\'\" draggable=false style=margin:0></figure><div style=\"display: flex; align-items: center; width: 100%\"><span style=\"flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; margin-right:10px\">{{p.firstName}} {{p.lastName}} </span><span style=\"font-size: 12px; min-width: 120px; text-align: left; color:black\"><span ng-if=\"p.status == \'UNAPPROVED\'\" translate=SCHOOL_STRUCTURE_PUPIL_PENDING></span> <span ng-if=\"p.status == \'DISABLED\'\" translate=SCHOOL_STRUCTURE_PUPIL_DEACTIVED></span></span></div></div></div><div class=\"pupil-item ng-scope ng-isolate-scope selected\" id=dragImage style=\"top:-6000px; left:-6000px\"><figure id=dragImagePupilImage class=\"avatar {{p.gender}}\"></figure><div id=dragImagePupilName></div><span class=\"pupil-number ng-binding\">{{multipleDraggables.length}}</span></div></aside></td></tr></tbody></table></div></div></div></div></section>");
$templateCache.put("app/school/views/school-structure.html","<section class=moveup ng-class=\"{\'is-visible\':true}\"><div class=page-view-header><div><div class=row><div class=col-xs-12><strong class=page-view-header__title translate=SCHOOL_STR_TITLE class=section-title></strong></div></div></div></div><script type=text/ng-template id=selectionTemplate.html><a>\n		<span style=\"font-size: 16px;\" ng-bind-html=\"match.model.firstName | uibTypeaheadHighlight:query\" ng-if=\"match.model.firstName\"></span>\n		<span style=\"font-size: 16px;\"  ng-bind-html=\"match.model.lastName | uibTypeaheadHighlight:query\" ng-if=\"match.model.lastName\"></span>\n		<span translate=\"PARENTHESES_OPEN\"></span>\n		<span ng-bind-html=\"match.model.tier1Name | uibTypeaheadHighlight:query\" ng-if=\"match.model.tier1Name\"></span>\n		<span translate=\"CHAR_SLASH\"  ng-if=\"match.model.tier2Name\"></span>\n		<span ng-bind-html=\"match.model.tier2Name | uibTypeaheadHighlight:query\" ng-if=\"match.model.tier2Name\"></span>\n		<span translate=\"PARENTHESES_CLOSE\">\n	</a></script><div><div class=row><div class=col-xs-12><div class=structure><div class=yellow-tooltip ng-if=\"unassignedPupilsCount > 0\"><p style=\"padding: 10px\" translate=MOVEUP_GUIDED_SETUP_TEXT_4></p></div><div class=structure-mobile-alert>Viewing and editing the school structure is not optimised for mobile just yet! It will work better if you\'re able to use a larger screen.</div><div class=guideline-text><p translate=MOVEUP_GUIDED_SETUP_TEXT_1></p><p translate=MOVEUP_GUIDED_SETUP_TEXT_2 style=\"margin-bottom: 6px\"></p><div class=moveup-subsection style=\"margin: 0 0 12px 20px\"><p translate=MOVEUP_AUTO_SYNC_TITLE style=\"margin-bottom: 4px\"></p><p translate=MOVEUP_AUTO_SYNC_DESC></p></div><div class=\"moveup-subsection moveup-accordion\" style=\"margin: 0 0 12px 20px\"><p translate=MOVEUP_MANUAL_TITLE style=\"margin-bottom: 4px\"></p><p style=\"margin-bottom: 4px\"><span translate=MOVEUP_MANUAL_DESC_PREFIX></span><span ng-click=\"manualTipsOpen = !manualTipsOpen\" style=\"cursor: pointer; user-select: none; color: #eb004e; font-weight: 600\"><span translate=MOVEUP_BELOW_LABEL style=\"text-decoration: underline\"></span> <span class=dripicons-chevron-down ng-if=!manualTipsOpen style=\"font-size: 12px; text-decoration: none; display: inline-block; vertical-align: middle; position: relative; top: 1px\"></span><span class=dripicons-chevron-up ng-if=manualTipsOpen style=\"font-size: 12px; text-decoration: none; display: inline-block; vertical-align: middle; position: relative; top: 1px\"></span></span></p><div ng-show=manualTipsOpen><ol><li translate=MOVEUP_MOVE_TEXT_1></li><li translate=MOVEUP_MOVE_TEXT_2></li><li translate=MOVEUP_MOVE_TEXT_3></li></ol><p class=you-can-move-text></p><p translate=MOVEUP_GUIDED_SETUP_TEXT_5></p><ul><li translate=MOVEUP_MOVE_TEXT_4></li><li translate=MOVEUP_MOVE_TEXT_5></li><li translate=MOVEUP_MOVE_TEXT_6></li><li translate=MOVEUP_MOVE_TEXT_7></li></ul><p></p></div></div></div><table class=\"table table-bordered\" style=\"background: #fff\"><tbody><thead></thead><!-- SELECTOR --><tr><td><form novalidate name=ay><p><strong translate=ADD_YEAR_TITLE></strong></p><div class=form-group><input type=text class=form-control ng-model=newYearName placeholder=\"{{ \'ADD_YEAD_PHOLDER\' | translate }}\" ng-minlength=2 ng-maxlength=40 maxlength=40 autocomplete=off required></div><button class=\"btn btn-primary pull-right\" translate=ADD_BTN ng-click=addYear(newYearName) ng-disabled=ay.$invalid style=\"float: left!important\"></button></form></td><td><form novalidate name=ac><p><strong translate=ADD_CLASS_TITLE></strong> <span class=dripicons-arrow-thin-right></span> <span ng-show=topTier.id>{{topTier.name}}</span> <span ng-show=!topTier.id translate=PICK_A_YEAR></span></p><div class=form-group><input type=text class=form-control ng-model=newClassName placeholder=\"{{ \'ADD_CLASS_PHOLDER\' | translate }}\" ng-minlength=2 ng-maxlength=40 maxlength=40 autocomplete=off required></div><span></span> <button class=\"btn btn-primary pull-right\" translate=ADD_BTN ng-click=addClass(newClassName) ng-disabled=\"ac.$invalid || !topTier.id\" style=\"float: left!important\"></button></form></td><td><div class=\"select-delete-pupils form-group\"><div class=select-labels><div><strong translate=MOVE_PUPILS_TITLE></strong></div><div class=select-pupils>{{ multipleDraggables.length }} <span translate=SELECTED_PUPILS></span></div></div><div class=form-group ng-show=\"pupils.length > 0 && multipleDraggables.length > 0\"><class-picker ng-model=newPupil.tier ng-if=\"pupils.length > 0\"></class-picker><div class=error-text-red ng-show=\"newPupil.tier === null && isClicked >= 1\"><p translate=ERR_PUPIL_TIER></p></div></div></div><div class=move-pupils style=\"min-width: 190px\"><button ng-disabled=\"selectAllDisabled == true\" translate=SELECT_ALL_LABEL class=\"btn btn-primary btn-sm\" ng-show=\"pupils.length > 0\" ng-click=selectAllPupils()></button> <button class=\"btn btn-primary move-btn\" translate=MOVE_BTN ng-show=\"pupils.length > 0\" ng-disabled=\"!newPupil.tier || multipleDraggables.length === 0\" ng-click=\"movePupils(p.id, newPupil.tier)\" style=\"margin-left: 5px\"></button></div></td></tr><!-- GREY LABELS --><tr class=middle-row-labels><th class=table-col-1><span class=year-class-labels translate=YEAR_LABEL></span></th><th class=table-col-2><span class=year-class-labels translate=CLASS_LABEL></span></th><th class=table-col-3><div class=pupils-label><span class=pupils-label-counter translate=MOVEUP_PUPILS_LABEL_NUMBERS translate-values={n:pupilNumber}></span> <span translate=MOVEUP_PUPILS_LABEL></span> <span class=pupils-label-counter ng-if=\"topTierName != \'\' && subTierName == \'\'\" translate=MOVEUP_PUPILS_LABEL_TIER translate-values=\"{tier:topTierName, n:pupilNumber}\"></span> <span class=pupils-label-counter ng-if=\"subTierName != \'\'\" translate=MOVEUP_PUPILS_LABEL_TIER translate-values={tier:subTierName}></span></div><div class=\"pull-right pupil-search is-relative\"><input type=text ng-model=keyword placeholder=\"{{ \'FIND_A_PUPIL_PLACEHOLDER\' | translate }}\" uib-typeahead=\"r.field1 for r in queryPupils\" typeahead-wait-ms=300 typeahead-min-length=2 typeahead-on-select=pickPupil($item) typeahead-template-url=selectionTemplate.html class=form-control autocomplete=off> <span class=\"icon dripicons-search\"></span></div></th></tr><!-- LIST --><tr><td><aside><div id=toptier-item-id class=tier-item ng-repeat=\"t in tiers\" ng-click=\"showSubTiers(t); clearDraggables()\" ng-class=\"{\'active\': topActive === t.id}\" droppable events=droppablevents droptarget={{t}}><span class=tier-name>{{t.name}} <span ng-if=t.locked>({{getPupilsCount(t.pupils)}})</span></span> <a id=edit-toptier-id class=edit-tier ng-if=!t.locked ng-click=editTier(t)><span class=dripicons-pencil></span></a></div></aside></td><td><aside><div id=tier-item-id class=tier-item ng-repeat=\"t in topTier.tiers\" ng-click=\"showPupils(t); clearDraggables()\" ng-class=\"{\'active\': subActive === t.id}\" droppable events=droppablevents droptarget={{t}}><span class=tier-name>{{t.name}} ({{getPupilsCount(t.pupils)}})</span> <a id=edit-tier-id class=edit-tier ng-if=!t.locked ng-click=editTier(t)><span class=dripicons-pencil></span></a></div></aside></td><td><aside><div class=delete-pupils-container><div ng-show=\"pupils.length > 0\" class=show-hide-options style=\"width: 100%\"><div class=structure-show-checkboxes-row style=\"display: flex; flex-wrap: wrap; gap: 16px\"><label class=structure-show-parents-checkbox style=\"cursor:pointer; display: flex; align-items: center; margin-bottom: 0; padding-right: 30px\"><input type=checkbox ng-model=showParents ng-change=showParent() style=\"margin-right:7px; width:20px; height:20px\"> <span translate=SCHOOL_STRUCTURE_SHOW_TEXT style=\"font-size: 13px\"></span></label><label class=structure-show-parents-checkbox style=\"cursor:pointer; display: flex; align-items: center; margin-bottom: 0;margin-left:auto; margin-right:5px\"><input type=checkbox ng-model=showDeactivatedPupils ng-change=showDeactivated() style=\"margin-right:7px; width:20px; height:20px\"> <span translate=SCHOOL_STRUCTURE_SHOW_DEACTIVATED style=\"font-size: 13px\"></span></label></div><div class=structure-key-row style=\"display: flex; align-items: center; justify-content: flex-end; margin-top: 10px; gap: 12px; font-size: 11px\"><span style=\"font-weight: 900; margin-right: 5px; font-size: 12px\">Key:</span> <span style=\"display: flex; align-items: center; margin-right: 7px\"><img src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid-active.svg alt=\"\" width=20 draggable=false> <span style=\"font-size: 12px; margin-left:5px\" translate=SCHOOL_STRUCTURE_PUPIL_ACTIVED>Activated</span> </span><span style=\"display: flex; align-items: center; margin-right: 7px\"><img src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid-deactive.svg alt=\"\" width=20 draggable=false> <span style=\"font-size: 12px; margin-left:5px\" translate=SCHOOL_STRUCTURE_PUPIL_DEACTIVED>Deactivated</span> </span><span style=\"display: flex; align-items: center; margin-right: 0\"><img src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid-pending.svg alt=\"\" width=18 draggable=false> <span style=\"font-size: 12px; margin-left:5px\" translate=SCHOOL_STRUCTURE_PUPIL_PENDING>Pending approval</span></span></div></div><div ng-show=\"multipleDraggables.length > 0\" class=\"delete-pupils pull-left\" style=\"margin-top: 15px\"><a ng-click=deletePupils(multipleDraggables)><span class=\"bin-icon dripicons-trash\"></span> <span class=delete-pupils-text translate=DELETE_SEL_PUPILS></span></a></div></div><div ng-repeat=\"p in pupils | orderBy : \'lastName\'\"><div ng-if=\"showDeactivatedPupils || p.status !== \'DISABLED\'\" class=pupil-parent-container ng-show=showParents><div class=pupil-parent-item ng-class=\"{\'pending-disabled-pupil\': p.status == \'UNAPPROVED\' || p.status == \'DISABLED\'}\" draggable dragtarget={{p.id}} dragname=\"{{p.firstName}} {{p.lastName}}\" draggender={{p.gender}}><figure class=\"avatar {{p.gender}}\" style=\"background: transparent\"><img src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid-active.svg alt=\"\" width=30 ng-if=\"p.status == \'APPROVED\'\" draggable=false style=margin:0> <img src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid-deactive.svg alt=\"\" width=30 ng-if=\"p.status == \'DISABLED\'\" draggable=false style=margin:0> <img src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid-pending.svg alt=\"\" width=30 ng-if=\"p.status == \'UNAPPROVED\'\" draggable=false style=margin:0></figure><div>{{p.firstName}} {{p.lastName}}</div></div><div class=parent-item><div><a ng-repeat=\"parent in p.parents\" class=parent-name ui-sref=\"users.parentdetail({\'id\': parent.id})\">{{parent.name}}<span ng-if=\"$index < p.parents.length-1\">, </span></a></div></div></div><div ng-if=\"showDeactivatedPupils || p.status !== \'DISABLED\'\" class=pupil-item ng-show=!showParents ng-class=\"{\'pending-disabled-pupil\': p.status == \'UNAPPROVED\' || p.status == \'DISABLED\'}\" draggable dragtarget={{p.id}} dragname=\"{{p.firstName}} {{p.lastName}}\" draggender={{p.gender}} style=\"height: auto;\n										min-height: 30px;\n										line-height: 20px;\n										padding:0 10px 0 38px;\n										position:relative;\n										margin: 0;\n										width: 100%;\n										border-bottom-right-radius: 20px;\n										border-top-right-radius: 20px;\n										padding-top: 5px;\n										padding-bottom: 5px;\n										margin-top: 5px\"><figure class=\"avatar {{p.gender}}\" style=\"background: transparent\"><img src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid-active.svg alt=\"\" width=30 ng-if=\"p.status == \'APPROVED\'\" draggable=false style=margin:0> <img src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid-deactive.svg alt=\"\" width=30 ng-if=\"p.status == \'DISABLED\'\" draggable=false style=margin:0> <img src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid-pending.svg alt=\"\" width=30 ng-if=\"p.status == \'UNAPPROVED\'\" draggable=false style=margin:0></figure><div style=\"display: flex; align-items: center; width: 100%\"><span style=\"flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; margin-right:10px\">{{p.firstName}} {{p.lastName}} </span><span style=\"font-size: 12px; min-width: 120px; text-align: left; color:black\"><span ng-if=\"p.status == \'UNAPPROVED\'\" translate=SCHOOL_STRUCTURE_PUPIL_PENDING></span> <span ng-if=\"p.status == \'DISABLED\'\" translate=SCHOOL_STRUCTURE_PUPIL_DEACTIVED></span></span></div></div></div><div class=\"pupil-item ng-scope ng-isolate-scope selected\" id=dragImage style=\"top:-6000px; left:-6000px\"><figure id=dragImagePupilImage class=\"avatar {{p.gender}}\"></figure><div id=dragImagePupilName></div><span class=\"pupil-number ng-binding\">{{multipleDraggables.length}}</span></div></aside></td></tr></tbody></table></div></div></div></div></section>");
$templateCache.put("app/school/views/wrapper.html","<div class=\"content-logged school\"><div ui-view></div></div>");
$templateCache.put("app/schoolpage/views/add-amba-modal.html","<div class=assign-parent-admin ng-class=\"{\'not-ready\':!viewState.isReady}\"><div class=modal-header><h3 translate=ADD_AMBASSADOR_TITLE></h3></div><div class=modal-body><p translate=ADD_AMBASSADOR_DESCR></p><form novalidate name=aa><div class=form-group><div class=row><div class=col-md-12><parents show-tiers=true school-id={{id_school}} allow-host-invite=true></parents></div><div class=col-md-12><input type=text placeholder=\"{{\'LABEL_AMBASSADOR_PHOLDER\' | translate}}\" class=form-control ng-model=ambassador.label maxlength=80></div></div></div></form></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary\" type=button ng-click=confirm() ng-disabled=!hasSelected><span translate=ADD_BTN></span></button></div></div>");
$templateCache.put("app/schoolpage/views/add-classrep-modal.html","<div class=assign-parent-admin ng-class=\"{\'not-ready\':!viewState.isReady}\"><div class=modal-header><h3 translate=ADD_CLASSREP_TITLE></h3></div><div class=modal-body><div class=row><div class=col-md-12><parents show-tiers=true school-id={{id_school}} allow-host-invite=true></parents></div><div class=col-md-12><input type=text maxlength=80 placeholder=\"{{\'LABEL_COMM_REP_PHOLDER\' | translate}}\" class=form-control ng-model=parent.label></div></div></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary\" type=button ng-click=confirm() ng-disabled=!hasSelected><span translate=ADD_BTN></span></button></div></div>");
$templateCache.put("app/schoolpage/views/add-community-modal.html","<div class=assign-parent-admin ng-class=\"{\'not-ready\':!viewState.isReady}\"><div class=modal-header><h3 translate=ADD_COMMUNITY_TITLE></h3></div><div class=modal-body><form novalidate name=aa><div class=form-group><div class=row><div class=col-md-12><parents show-tiers=true school-id={{id_school}} allow-host-invite=true></parents></div><div class=col-md-12><input type=text maxlength=80 placeholder=\"{{\'LABEL_COMM_REP_PHOLDER\' | translate}}\" class=form-control ng-model=parent.label></div></div></div></form></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary\" type=button ng-click=confirm() ng-disabled=!hasSelected><span translate=ADD_BTN></span></button></div></div>");
$templateCache.put("app/schoolpage/views/details-modal.html","<div class=assign-parent-admin ng-class=\"{\'not-ready\':!viewState.isReady}\"><div class=modal-header><h3 translate=EDIT_SCHOOL_TITLE></h3></div><div class=modal-body><form novalidate><label translate=ADDRESS class=modal-separator></label><div class=form-group><div class=row><div class=col-md-6><input type=text placeholder=\"{{\'STREETNAME_PHOLDER\' | translate}}\" class=form-control ng-model=school.streetAddress required></div><div class=col-md-6><input type=text placeholder=\"{{\'CITY_PHOLDER\' | translate}}\" class=form-control ng-model=school.city required></div></div></div><div class=form-group><div class=row><div class=col-md-6><input type=text placeholder=\"{{\'COUNTY_PHOLDER\' | translate}}\" class=form-control ng-model=school.stateCounty></div><div class=col-md-2><input type=text placeholder=\"{{\'POSTCODE_PHOLDER\' | translate}}\" class=form-control ng-model=school.postCode required maxlength=10></div><div class=col-md-4><div class=is-relative><countries ng-model=school.countryId is-required=true></countries><label class=select-placeholder translate=COUNTRY_PHOLDER ng-hide=\"school.countryId.length > 0\"></label><span class=\"dripicons-chevron-down select-arrow\"></span></div></div></div></div><div class=show-on-map-container><div translate=OPEN_IN_MAPS_TEXT translate-values=\"{\'link\': school.streetAddress + \' \' + school.postCode + \' \' + school.city + \' \' + getCountryName(school.countryId) }\"></div></div><label translate=CONTACTS class=modal-separator></label><div class=form-group><div class=\"row form-group\"><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=with-icon><input type=tel class=form-control placeholder=\"{{ \'PHONE_NUM_NON_REQ_PHOLDER\' | translate }}\" ng-model=school.phoneNumber name=phoneNumber ng-minlength=regexes.min.phone ng-maxlength=regexes.max.phone maxlength={{regexes.max.phone}} remove-space remove-chars=number></div></div></div></div><div class=form-group><div class=row><div class=col-md-12><input type=email placeholder=\"{{\'EMAIL_PHOLDER\' | translate}}\" class=form-control ng-model=school.email></div></div></div></form><div class=school-preview><span translate=EDIT_SCHOOL_NAME_APPEAR class=school-preview_text></span><div class=\"school-item school-preview_box\" style=\"margin-bottom: 20px\"><figure class=\"school-logo school-preview_logo\"><img ng-src={{school.logo}} alt=\"\" width=24 height=24 onerror=\"this.src=\'assets/icons/default-school-logo.png\'\"></figure><p class=\"school-name school-preview_name edit-school-preview\">{{school.name }}, {{school.city}}</p></div></div></div><div class=modal-footer><div class=info-box><span translate=EDIT_SCHOOL_INFO class=\"info-box_text pull-left\"></span></div><div class=buttons><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary save-btn\" type=button ng-click=confirm() ng-disabled=\"!school.streetAddress || !school.city || !school.postCode || !school.countryId\"><span translate=SAVE_BTN></span></button></div></div></div>");
$templateCache.put("app/schoolpage/views/help-modal.html","<div class=assign-parent-admin ng-class=\"{\'not-ready\':!viewState.isReady}\"><div class=modal-header><h3 translate=HELP_SCHOOL_TITLE></h3></div><div class=modal-body><form novalidate name=aa><div class=form-group><div class=row><div class=col-md-12><input type=text placeholder=\"{{\'HELP_SCHOOL_PHOLDER_1\' | translate}}\" class=form-control ng-model=help.helpTitle required></div></div></div><div class=form-group><div class=row><div class=col-md-12><summernote config=summernoteOptions editable=false ng-model=help.helpDescription placeholder=\"Write a note\"></summernote></div></div><div class=error-text-red ng-show=\"isClicked > 0 && !announcement.body\"><span translate=ERR_WRITE_ANNOUNCEMENT></span></div></div></form></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary\" type=button ng-click=confirm() ng-disabled=\"!help.helpTitle || !help.helpDescription\"><span translate=SAVE_BTN></span></button></div></div>");
$templateCache.put("app/schoolpage/views/invite-staff-modal.html","<div class=assign-parent-admin ng-class=\"{\'not-ready\':!viewState.isReady}\"><div class=modal-header><h3 translate=ADD_STAFF_TITLE></h3></div><div class=modal-body><p><span translate=ADD_STAFF_DESCR></span> <a href=# translate=ADD_STAFF_LINK></a></p><br><form novalidate name=aa><div class=form-group><div class=row><div class=col-md-6><input type=text placeholder=\"{{\'FIRST_NAME_PHOLDER\' | translate}}\" class=form-control ng-model=staff.firstName required><br></div><div class=col-md-6><input type=text placeholder=\"{{\'LAST_NAME_PHOLDER\' | translate}}\" class=form-control ng-model=staff.lastName required><br></div></div><div class=row><div class=col-md-6><input type=text placeholder=\"{{\'EMAIL_NAME_PHOLDER\' | translate}}\" class=form-control ng-model=staff.email required><br></div><div class=col-md-6><div class=form-group><div class=\"row form-group\"><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=with-icon><input type=tel class=form-control placeholder=\"{{ \'PHONE_NUM_NON_REQ_PHOLDER\' | translate }}\" ng-model=staff.phoneNumber name=phoneNumber ng-minlength=regexes.min.phone ng-maxlength=regexes.max.phone maxlength={{regexes.max.phone}} remove-space only-number-input=number></div></div></div></div><br></div></div><div class=row><div class=col-md-6><input type=text placeholder=\"{{\'LABEL_ADMIN_PHOLDER\' | translate}}\" class=form-control ng-model=staff.adminLabel required></div><div class=col-md-6></div></div></div></form><div><br><div><label style=\"cursor: pointer; line-height: 18px\"><input ng-model=confirmStaffInvite type=checkbox style=\"float: left; margin-bottom: 15px; margin-right: 10px\"> <span style=\"font-weight: 600; font-size: 13px\" translate=INVITE_STAFF_MODAL_TEXT_1></span></label></div><div class=staff-permission-text style=padding-top:10px><label style=\"cursor: pointer; line-height: 18px\"><input ng-model=staff.userManagementPermission type=checkbox style=\"float: left; margin-bottom: 80px; margin-right: 10px\"> <span style=\"font-weight: 600; font-size: 13px\" translate=INVITE_STAFF_MODAL_TEXT_2></span></label></div></div></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary\" type=button ng-click=confirm() ng-disabled=\"!staff.firstName || !staff.lastName || ! staff.adminLabel || !confirmStaffInvite\"><span translate=INVITE_BTN></span></button></div></div>");
$templateCache.put("app/schoolpage/views/link-modal.html","<div class=assign-parent-admin ng-class=\"{\'not-ready\':!viewState.isReady}\"><div class=modal-header><h3 ng-if=!link.title translate=NEW_LINK_TITLE></h3><h3 ng-if=link.title translate=EDIT_LINK_TITLE></h3></div><div class=modal-body><form novalidate name=aa><div class=form-group><div class=row><div class=col-md-12><input type=text placeholder=\"{{\'LINK_NAME_PHOLDER\' | translate}}\" class=form-control ng-model=link.text required></div></div></div><div class=form-group><div class=row><div class=col-md-12><input type=text placeholder=\"{{\'LINK_URL_PHOLDER\' | translate}}\" class=form-control ng-model=link.href required></div></div></div><div ng-if=link.id class=form-group><div class=row><div class=col-md-12><div class=delete-link ng-click=delete()><span class=\"icon dripicons-trash\"></span> <span translate=DELETE></span></div></div></div></div></form></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary\" type=button ng-click=confirm() ng-disabled=\"!link.text || !link.href\"><span translate=SAVE_BTN></span></button></div></div>");
$templateCache.put("app/schoolpage/views/name-modal.html","<div class=assign-parent-admin ng-class=\"{\'not-ready\':!viewState.isReady}\"><div class=modal-header><h3 translate=SCHOOL_NAME_TITLE></h3></div><div class=modal-body><form novalidate name=aa><div class=form-group><div class=row><div class=col-md-12><input type=text placeholder=\"{{\'NAME\' | translate}}\" class=form-control ng-model=school.schoolName required></div></div></div><div class=form-group><div class=row><div class=col-md-12><textarea type=text placeholder=\"{{\'DESCRIPTION\' | translate}}\" class=\"form-control bordered\" ng-model=school.schoolAbout required></textarea></div></div></div></form></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary\" type=button ng-click=confirm() ng-disabled=\"!school.schoolName || !school.schoolAbout\"><span translate=SAVE_BTN></span></button></div></div>");
$templateCache.put("app/schoolpage/views/parents-count-modal.html","<div class=assign-parent-admin ng-class=\"{\'not-ready\':!viewState.isReady}\"><div class=modal-header><h3 translate=PARENTS_COUNT></h3></div><div class=modal-body><form novalidate name=aa><div class=form-group><div class=row><div class=col-md-12><input type=text class=form-control placeholder=\"{{\'COUNT\' | translate}}\" ng-model=school.parentCount required></div></div></div></form></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary\" type=button ng-click=confirm() ng-disabled=!school.parentCount><span translate=SAVE_BTN></span></button></div></div>");
$templateCache.put("app/schoolpage/views/school-admins.html","<div class=\"content-logged schoolpage\" photo-upload ng-class=\"{\'not-ready\':!viewState.isReady}\"><div class=page-view-header style=\"margin-bottom: 20px\"><div><div class=row><div class=col-xs-12><strong class=page-view-header__title translate=REPS_AND_ADMINS_TITLE_BR class=section-title></strong></div></div></div></div><div><div class=row><div class=col-md-12><section class=no-margin><label><span translate=AMBASSADORS></span> <span ng-click=\"openInfo(\'\', 1)\" class=\"icon dripicons-information\" ng-if=editableSchool></span></label><div><div class=\"row small\" style=\"display: flex; flex-wrap: wrap\"><div class=\"ambasador-item col-md-3 col-sm-4 col-xs-6\" style=\"display: inline-flex\" ng-repeat=\"amba in _school.ambassadors\" ng-click=openUser(amba)><div class=thumb><figure class=comment-item-avatar style=\"width: 40px; height: 40px; float: left; margin-right: 10px\"><avatar source=\"{{ amba.avatar }}\" name=\"{{ amba.name }}\" width=60 height=60 my=false></avatar></figure></div><div><div class=a-name>{{ amba.name }}</div><div>{{amba.label}}</div></div></div></div><div ng-if=\"editableSchool && !isStaffWithoutUserManagementPermission()\" style=padding-top:5px><div class=\"btn btn-ghost\" ng-click=addAmbasador()>Assign</div></div></div></section><section class=\"no-margin no-label-margin\"><div><label><span translate=SCHOOL_COMMUNITY></span> <span ng-click=\"openInfo($event, 4)\" class=\"icon dripicons-information\" ng-if=editableSchool></span></label><div class=\"row small\" style=\"display: flex; flex-wrap: wrap\"><div class=\"ambasador-item col-md-3 col-sm-4 col-xs-6\" style=\"display: inline-flex\" ng-repeat=\"comm in _school.communityReps\" ng-click=openUser(comm)><div class=thumb><figure class=comment-item-avatar style=\"width: 40px; height: 40px; float: left; margin-right: 10px\"><avatar source=\"{{ comm.avatar }}\" name=\"{{ comm.name }}\" width=60 height=60 my=false></avatar></figure></div><div><div class=a-name>{{ comm.name }}</div><div>{{ comm.label }}</div></div></div></div><div ng-if=\"(editableSchool || editableComm) && !isStaffWithoutUserManagementPermission()\"><div class=\"btn btn-ghost\" ng-click=addCommunity()>Assign</div></div></div></section><section class=\"no-margin no-label-margin\"><div><label><span translate=SCHOOL_STAFF></span> <span ng-click=\"openInfo($event, 5)\" class=\"icon dripicons-information\" ng-if=editableSchool></span></label><div class=\"row small\" style=\"display: flex; flex-wrap: wrap\" ng-if=\"_school.schoolStuffWithoutPermission && _school.schoolStuffWithoutPermission.length > 0\"><div class=\"ambasador-item col-md-3 col-sm-4 col-xs-6\" style=\"display: inline-flex\" ng-repeat=\"staff in _school.schoolStuffWithoutPermission\" ng-click=\"openUser(staff, true)\"><div class=thumb><figure class=comment-item-avatar style=\"width: 40px; height: 40px; float: left; margin-right: 10px\"><avatar source=\"{{ staff.avatar }}\" name=\"{{ staff.name }}\" width=60 height=60 my=false></avatar></figure></div><div><div class=a-name>{{ staff.name }}</div><div>{{ staff.label }}</div></div></div></div><p style=\"padding-top:10px;padding-bottom: 10px; color:#333333\"><span style=font-size:16px><b>Staff Admin +</b></span><br>Staff Admin + users can also manage parent membership and assign admin users:</p><div class=\"row small\" style=\"padding-bottom: 10px; display: flex; flex-wrap: wrap\"><div class=\"ambasador-item col-md-3 col-sm-4 col-xs-6\" style=\"display: inline-flex\" ng-repeat=\"staff in _school.schoolStuff\" ng-click=\"openUser(staff, true)\"><div class=thumb><figure class=comment-item-avatar style=\"width: 40px; height: 40px; float: left; margin-right: 10px\"><avatar source=\"{{ staff.avatar }}\" name=\"{{ staff.name }}\" width=60 height=60 my=false></avatar></figure></div><div><div class=a-name>{{ staff.name }}</div><div>{{ staff.label }}</div></div></div></div><div ng-if=isStaffInvitePermission><div class=\"btn btn-ghost\" ng-click=addStaff()>Invite</div></div></div></section><section><div><label><span translate=CLASS_REPS></span> <span ng-click=\"openInfo($event, 3)\" class=\"icon dripicons-information\" ng-if=editableSchool></span></label><div ng-repeat=\"item in reps_list\" class=\"row rep-item\"><div ng-if=item.locked style=padding-top:20px></div><div ng-if=item.locked class=col-md-3 style=\"display: flex\" id=unassigned><span style=\"margin-right:5px; width: 80px\">{{item.name}}</span> <span ng-if=item.locked ng-click=openUnassignedGroupInfo() class=\"icon dripicons-information\"></span></div><div ng-if=!item.locked class=col-md-3><span>{{item.name}}</span></div><div class=\"col-md-9 padding-zero\"><div class=\"ambassador-list small\"><div ng-repeat=\"user in item.reps\" class=\"ambasador-item class-rep-item\" style=\"display: inline-flex\" ng-click=openUser(user)><div class=thumb><figure class=comment-item-avatar style=\"width: 40px; height: 40px; float: left; margin-right: 10px\"><avatar source=\"{{ user.avatar }}\" name=\"{{ user.name }}\" width=60 height=60 my=false></avatar></figure></div><div><div class=a-name>{{ user.name }}</div><div>{{ user.label }}</div></div></div></div><div ng-if=\"!item.locked && (editableSchool || editableClassRep) && !isStaffWithoutUserManagementPermission()\"><div class=\"btn btn-ghost\" ng-click=addClassRep(item) style=\"margin-left: 15px\">Assign</div></div></div></div></div></section></div></div></div></div>");
$templateCache.put("app/schoolpage/views/school-contacts-page.html","<div class=\"content-logged schoolcontacts\"><div class=\"page-view-header clearfix\"><div><div class=row><div class=col-md-12><a id=header-back-button class=page-view-header__back href=#/school/details><span class=dripicons-arrow-thin-left></span></a><div class=page-view-header__text><strong ng-if=\"type == \'classes\'\" class=\"page-view-header__title ng-scope\" translate=SCHOOL_BACK_CLASS_BUTTON></strong> <strong ng-if=\"type == \'years\'\" class=\"page-view-header__title ng-scope\" translate=SCHOOL_BACK_YEAR_BUTTON></strong></div></div></div></div></div><div><div ng-repeat=\"item in list\"><label>{{item.name}}</label><div class=\"ambassador-list small\"><div ng-repeat=\"user in item.reps\" class=ambasador-item ng-click=openUser(user)><div class=thumb><img class=\"avatar-placeholder ng-isolate-scope\" alt=\"\" ng-src=\"{{ user.avatar }}\" onerror=\"this.src=\'assets/icons/default-avatar.png\'\"></div><div><div class=a-name>{{ user.name }}</div><div>{{ user.label }}</div></div></div><div ng-if=\"editableSchool || editableClassRep\" ng-click=addClassRep(item) class=ambasador-add-item><div class=thumb><span class=\"icon dripicons-plus\"></span></div></div></div></div></div></div>");
$templateCache.put("app/schoolpage/views/school-page.html","<div class=\"content-logged schoolpage\" photo-upload ng-class=\"{\'not-ready\':!viewState.isReady}\"><div class=page-view-header style=\"margin-bottom: 20px\"><div><div class=row><div class=col-xs-12><strong class=page-view-header__title translate=SCHOOL_AND_ADMIN_PROFILE_BR class=section-title></strong></div></div></div></div><div><div class=row><div class=col-md-5 style=padding-right:0px><div class=hover-editable-title><div class=school-picture style=\"background: url({{_school.cover}}), url(\'assets/images/School-Page.svg\'); background-size: 100%\"><div class=\"edit-button no-margin\" ng-if=editableSchool ng-click=uploadCover()><span class=\"icon dripicons-camera\"></span></div><div><div class=\"school-logo hover-editable-title\" style=\"background: url({{school.logo}}), url(\'assets/icons/default-school-logo.png\');background-size: 100%;  background-position: center\"><div ng-if=editableSchool><img ng-src=\"{{getServingURL(_school.logo, 80, true)}}\" alt=\"\" onerror=\"this.src=\'assets/icons/default-school-logo.png\'\"></div></div><div class=\"edit-button no-margin edit-logo\" ng-if=editableSchool ng-click=uploadLogo()><span class=\"icon dripicons-camera\"></span></div></div></div></div><div class=hover-editable-title><div class=school-title><div style=\"min-height: 36px\"><div class=\"edit-button no-margin\" ng-if=editableSchool ng-click=editName(_school)><span class=\"icon dripicons-pencil\"></span> <span translate=EDIT></span></div></div><span class=name-margin>{{ _school.name }}</span></div><section class=border-top-none><span class=angular-with-newlines>{{ _school.descr }}</span></section></div><!-- CONNECT BUTTON --><section ng-if=\"(active_user.role == \'AMBASSADOR\' || active_user.role == \'STAFF\')\"><div><div translate=SET_DEFAULT_CURRENCY style=\"margin-bottom: 12px\"></div><div class=column><div><div class=\"is-relative select-form\"><select ng-change=onCurrencySelected() ng-model=selectedCurrency.text class=form-control><option ng-repeat=\"option in availableCurrencies\" value={{option.id}}>{{option.id}} ({{option.asciiSymbol}})</option></select><span class=\"dripicons-chevron-down select-arrow\"></span></div></div></div></div></section><!-- CONNECT BUTTON END --><section><label translate=DETAILS></label><div class=edit-button ng-if=editableSchool ng-click=editDetails(_school)><span class=\"icon dripicons-pencil\"></span> <span translate=EDIT></span></div><div><div class=contact-list><div ng-if=\"_school.address || _school.city\"><span class=\"dripicons-location contact-icon icon\"></span> <span>{{ _school.address ? (_school.address + \', \') : \'\' }} {{ _school.city ? (_school.city + \', \') : \'\' }} {{ _school.stateCounty ? (_school.stateCounty + \', \') : \'\' }} {{ _school.postCode ? (_school.postCode + \', \') : \'\' }} {{ _school.country ? (_school.country) : \'\' }}</span></div><div ng-if=_school.phoneNumber><span class=\"dripicons-phone contact-icon icon\"></span> <span>{{ _school.phoneNumber }}</span></div><div ng-if=_school.email><span class=\"dripicons-mail contact-icon icon\"></span> <span>{{ _school.email }}</span></div></div></div></section><section ng-if=\"school.parentPercentage > 50\" class=\"show-tablet hide-mobile\"><label translate=YOUR_COMMUNITY></label><div><div class=big-label-blue>{{_school.parentPercentage}}%</div><div class=row><div class=\"col-md-7 f-left\"><div class=progress-bar-blue><div style=\"width: {{_school.parentPercentage}}%\"></div></div><div translate=PARENTS_ON_CLASSLIST></div></div><div class=col-md-5><div class=invite-button><a class=\"btn btn-default graph-list_button\" translate=INVITE_PARENTS_BTN href=#/invite/add-invite-integration ng-if=integrationEnabled()></a> <a class=\"btn btn-default graph-list_button\" translate=INVITE_PARENTS_BTN href=#/invite/add-invite ng-if=!integrationEnabled()></a></div></div></div></div></section><section class=\"hide-mobile hide-tablet\"><label translate=SCHOOL_STRUCTURE></label><div class=edit-button ng-if=editableSchool ng-click=editStructure()><span class=\"icon dripicons-pencil\"></span> <span translate=EDIT></span></div><div class=inline-big-items><div><div>{{_school.yearsCount}}</div><span translate=YEARS></span></div><div><div>{{_school.classesCount}}</div><span translate=CLASSES></span></div></div></section><section ng-if=\"active_user.role == \'AMBASSADOR\' || active_user.role == \'STAFF\'\"><div><label style=\"width: 100%; margin-bottom: 5px\"><label translate=WSP_TEXT_1 style=\"font-size: 16px; margin-bottom:5px\"></label><br><span style=\"max-width: 86%; float: left; font-size: 14px; color: #333; font-weight: normal\" translate=WSP_TEXT_2></span><br><br><input ng-model=_school.settings.wholeSchoolPostEnabled type=checkbox style=\"float: left; margin-right: 10px\" ng-change=toggleWholeSchoolPost($event) ng-disabled=enablingWSP> <span style=\"max-width: 86%; float: left; font-size: 14px; color: #333; font-weight: normal\" translate=WSP_TEXT_3></span></label></div><div><label style=\"width: 100%; margin-bottom: 5px; margin-top:10px\"><label translate=WSP_TEXT_4 style=\"font-size: 16px; margin-bottom:5px\"></label><br><input ng-model=_school.settings.dailyDigestEnabled type=checkbox style=\"float: left; margin-right: 10px\" ng-change=toggleDailyDigest($event) ng-disabled=enablingWSP> <span style=\"max-width: 86%; float: left; font-size: 14px; color: #333; font-weight: normal\" translate=WSP_TEXT_5></span></label></div></section><!-- <section ng-if=\"active_user.role == \'AMBASSADOR\' || active_user.role == \'STAFF\'\">\n                    <label translate=\"ENABLE_RAFFLE_1\"></label>\n                    <p>Checking this box means ambassadors and staff admin can host a raffle on Classlist for your school community. Please see our raffle <a style=\"font-weight: 600;\" href=\"https://www.classlist.com/terms\" target=\"_blank\">Terms and Conditions.</a></p>\n                    <div>\n                        <label style=\"width: 100%; margin-bottom: 5px;\">\n							<input ng-model=\"_school.settings.raffleEnabled\" type=\"checkbox\" style=\"float: left; margin-right: 10px;\" ng-change=\"toggleRaffle($event)\" ng-disabled=\"enablingRaffle\" />\n							<span style=\"max-width: 86%; float: left; font-size: 14px; color: #333; font-weight: normal;\" translate=\"ENABLE_RAFFLE_2\"></span>\n						</label>\n                    </div>\n                </section> --><section ng-if=isThereASampleContent><label translate=CLEAN_SAMPLE_CONTENTS></label><div><div style=\"text-align: right\"><button class=\"btn btn-primary\" type=button ng-click=cleanSampleContents()><span translate=DELETE_BTN></span></button></div></div></section></div><div class=col-md-7><section ng-if=\"school.parentPercentage > 50\" class=\"hide-tablet hide-mobile\"><div><div class=big-label-blue>{{_school.parentPercentage}}%</div><div class=row><div class=col-md-7><div class=progress-bar-blue><div style=\"width: {{_school.parentPercentage}}%\"></div></div><div translate=PARENTS_ON_CLASSLIST></div></div><div class=col-md-5><div class=invite-button><a class=\"btn btn-default graph-list_button\" translate=INVITE_PARENTS_BTN href=#/invite/add-invite-integration ng-if=integrationEnabled()></a> <a class=\"btn btn-default graph-list_button\" translate=INVITE_PARENTS_BTN href=#/invite/add-invite ng-if=!integrationEnabled()></a></div></div></div></div></section><!-- RISED NUMBER--><section ng-if=\"active_user.role == \'AMBASSADOR\'\"><label translate=WELCOME_MESSAGE_PHOLDER></label><span id=welcome-help-icon ng-click=\"openInfo($event, 6)\" class=\"icon dripicons-information\"></span><div class=edit-button ng-if=welcomeMessageEnabled ng-click=editPersonalMessage(_school)><span class=\"icon dripicons-pencil\"></span> <span translate=EDIT></span></div><div ng-if=\"_school.ambassadorMessage && _school.ambassadorMessage.length > 0\"><div style=\"font-style: italic\">{{_school.ambassadorMessage}}</div><br><div><span translate=MESSAGE_FROM style=\"color: #000\"></span> {{_school.ambassadorMessageUpdatedByName}}</div></div><div ng-if=\"!_school.ambassadorMessage || _school.ambassadorMessage.length == 0\"><span translate=NO_MESSAGE style=\"color: #000\"></span></div></section><!-- RISED NUMBER END--><section><label>{{ _school.helpTitle }}</label><div class=edit-button ng-if=editableSchool ng-click=editHelp(_school)><span class=\"icon dripicons-pencil\"></span> <span translate=EDIT></span></div><div ng-bind-html=_school.helpDescription></div></section><section><label translate=HELPFUL_LINKS></label><div class=link-item ng-repeat=\"link in _school.links\"><a href={{createLink(link.href)}} ng-attr-target=\"{{isExternalLink(link.href) ? \'_blank\' : undefined}}\" class=link>{{ link.text }}</a> <span class=\"icon dripicons-pencil\" ng-if=editableSchool ng-click=\"editLink(link, $index)\"></span></div><div ng-if=editableSchool><div><br><div class=form-group><div class=row><div class=col-md-12><input type=text placeholder=\"{{\'LINK_NAME_PHOLDER\' | translate}}\" class=form-control ng-model=newlink.text ng-keyup=checkTitle() required></div><div ng-if=noTitleError class=\"col-md-12 error-text\" translate=NO_TITLE_ERROR></div></div></div><div class=form-group><div class=row><div class=col-md-12><input type=text placeholder=\"{{\'LINK_URL_PHOLDER\' | translate}}\" class=form-control ng-model=newlink.href ng-keyup=checkValidLink() required></div><div ng-if=linkNotValidError class=\"col-md-12 error-text\" translate=INVALID_LINK_ERROR></div></div></div></div><div style=\"text-align: right\"><button class=\"btn btn-primary\" type=button ng-click=insertLink() ng-disabled=\"!newlink.text || !validateLink(newlink.href)\"><span translate=ADD_BTN></span></button></div></div><div ng-if=showHelpfulLinkMessage class=error-text translate=HELPFUL_LINKS_MESSAGE></div></section></div></div></div></div>");
$templateCache.put("app/schoolpage/views/welcome-message-modal.html","<div class=assign-parent-admin ng-class=\"{\'not-ready\':!viewState.isReady}\"><div class=modal-header><h3 translate=MESSAGE_FROM_AMBASSADOR_TITLE></h3></div><div class=modal-body><div translate=MESSAGE_FROM_AMBASSADOR_DESC></div><br><form novalidate name=aa><div class=form-group><div class=row><div class=col-md-12><textarea type=text placeholder=\"{{\'WRITE_NOTE_PHOLDER\' | translate}}\" class=\"form-control bordered\" ng-model=message.body required></textarea></div></div></div></form></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary\" type=button ng-click=confirm() ng-disabled=!message.body><span translate=SAVE_BTN></span></button></div></div>");
$templateCache.put("app/users/views/add-label-modal.html","<div class=assign-parent-admin ng-class=\"{\'not-ready\':!viewState.isReady}\"><div class=modal-header><h3 translate=EDIT_LABEL_TITLE></h3></div><div class=modal-body><form novalidate name=aa><div class=form-group><div class=row><div class=col-md-12><input type=text maxlength=80 placeholder=\"{{\'LABEL_AMBASSADOR_PHOLDER\' | translate}}\" class=form-control ng-model=label.label></div></div></div></form></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary\" type=button ng-click=confirm()><span translate=ADD_BTN></span></button></div></div>");
$templateCache.put("app/users/views/add-nonmember-edit.html","<div class=edit-nonmember-modal><div class=modal-header><h3 class=modal-title translate=EDIT_NON_MEMBER_TITLE></h3></div><div class=modal-body><form novalidate name=aa><div class=form-group><div class=row><div class=col-md-12><class-picker ng-model=tier is-include=false></class-picker></div></div></div><div class=form-group><div class=row><div class=\"col-md-6 col-sm-6 col-xs-6\"><input type=text placeholder=\"{{\'FIRST_NAME_PHOLDER\' | translate}}\" class=form-control ng-model=firstName required><div class=error-text-red ng-show=\"!(lastNameError || namesError)\"><p translate=ERR_FIRSTNAME></p></div></div><div class=\"col-md-6 col-sm-6 col-xs-6\"><input type=text placeholder=\"{{\'LAST_NAME_PHOLDER\' | translate}}\" class=form-control ng-model=lastName required><div class=\"error-text-red name-error\" ng-show=\"!(firstNameError || namesError)\"><p translate=ERR_LASTNAME></p></div></div></div></div><div class=form-group><div class=row><div class=col-md-12><input type=email ng-pattern=/^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$/ placeholder=\"{{\'EMAIL_PHOLDER\' | translate}}\" class=form-control ng-model=email required><div class=error-text-red ng-show=!email><p translate=INVALID_EMAIL></p></div></div></div></div></form></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary\" type=button ng-click=save() ng-disabled=\"!firstNameError || !lastNameError || !email\"><span translate=SAVE_BTN></span></button></div></div>");
$templateCache.put("app/users/views/add-nonmember-modal.html","<div class=assign-parent-admin ng-class=\"{\'not-ready\':!viewState.isReady}\"><div class=modal-header><h3 translate=ADD_A_NONMEMBER_TO_THE_PARENT_LIST_TITLE></h3></div><div class=modal-body><p translate=ADD_A_NONMEMBER_TO_THE_PARENT_LIST_HELP></p><form novalidate name=aa><div class=form-group><div class=row><div class=col-md-12><class-picker ng-model=nonmember.tier is-include=false></class-picker></div></div></div><div class=form-group><div class=row><div class=\"col-md-6 col-sm-6 col-xs-6\"><input type=text placeholder=\"{{\'FIRST_NAME_PHOLDER\' | translate}}\" class=form-control ng-model=nonmember.firstName required></div><div class=\"col-md-6 col-sm-6 col-xs-6\"><input type=text placeholder=\"{{\'LAST_NAME_PHOLDER\' | translate}}\" class=form-control ng-model=nonmember.lastName required></div></div></div><div class=form-group><div class=row><div class=col-md-12><input type=email ng-pattern=/^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$/ placeholder=\"{{\'EMAIL_PHOLDER\' | translate}}\" class=form-control ng-model=nonmember.email required></div></div></div><div class=form-group><div class=row><div class=col-md-12><button type=button class=\"btn btn-ghost pull-right\" translate=ADD_BTN ng-click=add() ng-disabled=aa.$invalid></button> <button type=button class=\"btn btn-ghost pull-right\" translate=RESET_BTN ng-click=reset() ng-disabled=aa.$pristine></button></div></div></div></form><div class=row><ul class=\"col-md-12 basket\" ng-show=\"payload.nonMembers.length > 0\"><li ng-repeat=\"nm in payload.nonMembers\"><div><p><strong>{{nm.firstName}} {{nm.lastName}}</strong> - {{nm.tier.name}}<br><span>{{nm.email}}</span></p><a ng-click=delete(nm.uid)><span class=dripicons-cross></span></a></div></li></ul></div></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary\" type=button ng-click=save() ng-disabled=\"aa.$invalid || payload.nonMembers.length === 0\"><span translate=OK_BTN></span></button></div></div>");
$templateCache.put("app/users/views/approve-parents.html","<section class=user-list ng-class=\"{\'is-visible\': viewState.isReady}\"><div class=header-content-separator></div><div class=page-view-header><div><strong class=page-view-header__title translate=APPROVE_PARENTS_TITLE></strong></div></div><div style=\"padding: 0 10px\"><div><div><div><div class=accordion ng-class=\"{active: accordionParent[$index].open}\" ng-repeat=\"p in parents\"><div ui-sref-active=active class=accordion__trigger ng-click=\"toggleAccordion(accordionParent, $index)\"><strong>{{::p.firstName}} {{::p.lastName}}</strong> <span class=\"dripicons-chevron-down pull-right accordion__chevron\" ng-show=!accordionParent[$index].open></span> <span class=\"dripicons-chevron-up pull-right accordion__chevron\" ng-show=accordionParent[$index].open></span></div><div class=\"accordion__content row\" style=\"margin: 0\"><div class=\"parent-accordion-item clearfix col-sm-6\"><table><thead><tr><th><div style=\"line-height: 30px; border-bottom: 1px solid #ccc; margin-bottom: 8px\"><span translate=MANAGE_USERS_PUPILS_TITLE_MOBILE></span></div></th><th><div style=\"line-height: 30px; border-bottom: 1px solid #ccc; margin-bottom: 8px; padding-left: 10px\">&nbsp;</div></th></tr></thead><tbody><tr ng-repeat=\"pupil in p.pupils\"><td style=\"padding-top: 10px\"><span>{{pupil.firstName}} {{pupil.lastName}}</span></td><td style=\"font-style: italic; padding-left: 10px; line-height: 14px; padding-top: 10px\"><span>{{pupil.firstTier}} {{pupil.secondTier}}</span> <span ng-show=\"p.firstTier || p.secondTier\">{{p.firstTier}} <b>{{p.secondTier}}</b></span><br><span ng-if=pupil.suggestion style=\"font-size: 12px;\n												font-weight: bold;\n												color: #999\"><b translate=SUGGESTED_CLASS_TEXT></b></span></td></tr></tbody></table></div><div class=\"parent-accordion-item clearfix col-sm-6\"><strong style=\"line-height: 30px; border-bottom: 1px solid #ccc; margin-bottom: 8px\" class=sign-up-mobile translate=MANAGE_USERS_CONTACT_TITLE></strong><p ng-hide=\"active_user.role == \'CLASS_REP\'\" class=telephone ng-if=p.email><span class=\"dripicons-mail icon\"></span>{{::p.email}}</p><p class=address><span class=\"dripicons-location icon\" ng-if=p.address.city></span>{{::p.address.streetAddress}}<span ng-if=p.address.postCode><span translate=COMMA ng-if=\"p.address.streetAddress && p.address.postCode\"></span> {{::p.address.postCode}}</span><span ng-if=p.address.city><span translate=COMMA ng-if=\"p.address.city && p.address.postCode\"></span> {{::p.address.city}}</span></p></div><div class=\"parent-accordion-item clearfix col-sm-6\" ng-show=\"!p.approved && !p.disabled && !p.nonMember\"><strong style=\"line-height: 30px; border-bottom: 1px solid #ccc; margin-bottom: 8px\" class=sign-up-mobile class=sign-up-mobile translate=MANAGE_USERS_SIGN_UP_TITLE></strong> <strong ng-if=p.invitedDate translate=MANAGE_USERS_NON_MEMBER></strong> <span ng-if=p.invitedDate translate=MANAGE_USERS_INVITED_ON></span> <span ng-if=p.invitedDate class=\"invite-date nonMember-date\">{{::p.invitedDate | date:\'dd/MM/yyyy\'}}</span><br><strong class=join-date translate=\"JOINED_TITLE \"></strong><span class=join-date> {{::p.joinedDate | date:\'dd/MM/yyyy\'}}</span></div><div class=\"parent-accordion-item clearfix col-xs-12\" ng-show=\"!p.approved && !p.disabled && !p.nonMember\"><div class=pull-left><a class=delete-parent translate=DELETE_PARENT ng-click=\"deleteApplicantParent(p.id, p.firstName, p.lastName)\"></a></div><div class=\"pull-right parent-approve-button\"><button type=button class=\"btn btn-primary\" translate=CHECK_APPROVE_BTN ng-click=approve(p)></button></div></div></div></div></div></div></div><div class=\"row no-parents visible-md visible-lg visible-sm\" ng-if=noParents><div class=col-xs-12><h4 class=no-parent-title translate=NO_PARENTS_TO_APPROVE_TITLE></h4><p class=no-parent-title translate=NO_PARENTS_TO_APPROVE_TEXT></p><a ui-sref=invite.nonmemberlist><span class=\"dripicons-open-envelope icons-tips\"></span><p class=no-parent-tips translate=NO_PARENTS_TO_APPROVE_INVITE></p></a><a href=https://help.classlist.com/hc/en-us/articles/209890185-Topic-3-Invite-Parents target=_blank><span class=\"dripicons-lightbulb icons-tips\"></span><p class=no-parent-tips translate=NO_PARENTS_TO_APPROVE_TIPS></p></a><a href=https://help.classlist.com/hc/en-us/articles/210479025-Printable-Classlist-flyers target=_blank><span class=\"dripicons-print icons-tips\"></span><p class=no-parent-tips translate=NO_PARENTS_TO_APPROVE_PRINTABLE></p></a></div><div class=\"col-sm-2 no-parent-bottom\"></div></div><div class=\"row no-parents visible-xs\" ng-if=noParents><div class=col-xs-12><h4 translate=NO_PARENTS_TO_APPROVE_TITLE></h4></div></div></div><br><div class=page-sub-header ng-if=\"recentlyApproved.length > 0\" style=\"padding: 0 10px\"><div><div><div><strong class=page-sub-header__title translate=RECENTLY_APPROVED_TITLE></strong></div></div></div></div><div ng-if=\"recentlyApproved.length > 0\" style=\"padding: 0 10px\"><div><div><div><div class=accordion ng-class=\"{active: accordionRecentlyApproved[$index].open}\" ng-repeat=\"p in recentlyApproved\"><div ui-sref-active=active class=accordion__trigger ng-click=\"toggleAccordion(accordionRecentlyApproved, $index)\"><span ui-sref=\"users.parentdetail({\'id\':p.id })\"><a ui-sref=\"users.parentdetail({\'id\':p.id })\">{{::p.firstName}} {{::p.lastName}}</a> </span><span class=\"dripicons-chevron-down pull-right accordion__chevron\" ng-show=!accordionRecentlyApproved[$index].open></span> <span class=\"dripicons-chevron-up pull-right accordion__chevron\" ng-show=accordionRecentlyApproved[$index].open></span></div><div class=\"accordion__content row\" style=\"margin: 0\"><div class=\"parent-accordion-item clearfix col-sm-6\"><table><thead><tr><th><span class=sign-up-mobile translate=MANAGE_USERS_PUPILS_TITLE></span></th><th><span class=sign-up-mobile translate=MANAGE_USERS_Y_C_TITLE></span></th></tr></thead><tbody><tr ng-repeat=\"pupil in p.pupils\"><td><span>{{::pupil.firstName}} {{::pupil.lastName}}</span></td><td><span>{{::pupil.firstTier}} {{::pupil.secondTier}}</span> <span ng-show=\"p.firstTier || p.secondTier\">{{::p.firstTier}} {{::p.secondTier}}</span></td></tr></tbody></table></div><div class=\"parent-accordion-item clearfix col-sm-6\"><strong class=sign-up-mobile translate=MANAGE_USERS_CONTACT_TITLE></strong><p ng-hide=\"active_user.role == \'CLASS_REP\'\" class=telephone ng-if=p.email><span class=\"dripicons-mail icon\"></span>{{::p.email}}</p><p class=address><span class=\"dripicons-location icon\" ng-if=p.address.streetAddress></span>{{::p.address.streetAddress}}<span ng-if=p.address.postCode>, {{::p.address.postCode}}</span><span ng-if=p.adress.city>, {{::p.adress.city}}</span></p></div><div class=\"parent-accordion-item clearfix col-sm-6\"><p ng-if=\"user.role !== \'CLASS_REP\'\" ng-click=\"makeAdmin(p, \'APPROVE_PARENTS\')\"><a><span class=\"dripicons-gear icon\" style=\"font-size: 120%; margin: 0 5px 0 0\"></span><span translate=MAKE_ADMIN></span></a></p></div><div class=\"parent-accordion-item clearfix col-xs-4\"><strong class=sign-up-mobile class=join-date translate=JOINED_TITLE></strong><p>{{::p.joinedDate | date:\'dd/MM/yyyy\'}}</p></div><div class=\"parent-accordion-item clearfix col-xs-4\"><strong class=sign-up-mobile translate=APPROVED_BY_TITLE></strong><p>{{::p.approvedBy}}</p></div><div class=\"parent-accordion-item clearfix col-xs-4\"></div></div></div></div></div></div></div></section>");
$templateCache.put("app/users/views/assign-parent-admin-modal.html","<div class=assign-parent-admin><div class=modal-header><h3 translate=ASSIGN_TO_ADMIN></h3></div><div class=modal-body><p translate=ASSIGN_2_ADMIN_HELP translate-values=\"{firstName:user.firstName, lastName:user.lastName}\"></p><form novalidate name=aa ng-class=\"{\'not-ready\':!viewState.isReady}\"><div class=form-group><label class=\"control-label non-bold\"><input type=radio name=role ng-model=role value=AMBASSADOR> <span translate=AMBASSADOR></span></label><label class=\"control-label non-bold\"><input type=radio name=role ng-model=role value=PTA> <span translate=PTA></span></label><label class=\"control-label non-bold\"><input type=radio name=role ng-model=role value=CLASS_REP> <span translate=CLASS_REP></span></label><div class=form-group ng-show=\"role === \'PTA\' || role === \'CLASS_REP\'\"><class-picker ng-model=tier is-include=false></class-picker></div></div></form></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-default\" type=button ng-click=save() ng-disabled=\"aa.$pristine || (role === \'PTA\' || role === \'CLASS_REP\' ) && tier.id === \'\'\"><span translate=OK_BTN></span></button></div></div>");
$templateCache.put("app/users/views/cancel-invite-modal.html","<div><div class=modal-header><h3 translate=CANCEL_INVITE_HEADER></h3></div><div class=modal-body><p translate=CANCEL_INVITE_TEXT></p></div><div class=modal-footer><button type=button class=\"btn btn-primary pull-right\" translate=OK_BTN ng-click=confirm()><button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=close()></div></div>");
$templateCache.put("app/users/views/change-admin-modal.html","<div class=assign-parent-admin ng-class=\"{\'not-ready\':!viewState.isReady}\"><div class=modal-header><h3 ng-if=\"openedFrom === \'PARENT_DETAIL\'\" translate=CHANGE_ADMIN_TITLE></h3><h3 ng-if=\"openedFrom === \'APPROVE_PARENTS\'\" translate=MAKE_ADMIN></h3></div><div class=modal-body><p><span translate=CHANGE_ADMIN_DESCR translate-values=\"{\'name\':user.name}\"></span></p><div><div class=\"form-group admin-role-type\"><div ng-if=\"openedFrom === \'PARENT_DETAIL\'\"><input type=radio name=role ng-model=user.role value=REMOVE><label translate=CHANGE_ADMIN_ROLE_1></label></div><div><input type=radio name=role ng-model=user.role value=AMBASSADOR><label translate=CHANGE_ADMIN_ROLE_2></label></div><div><input type=radio name=role ng-model=user.role value=CLASS_REP><label translate=CHANGE_ADMIN_ROLE_3></label><div style=\"margin-left: 33px; margin-bottom: 15px\"><input type=text ng-model=tier placeholder=\"{{ \'START_TYPING_YEAR_OR_CLASS\' | translate }}\" uib-typeahead=\"r.field1 for r in getTiers($viewValue)\" {{tier.field1}} typeahead-wait-ms=300 typeahead-min-length=2 typeahead-on-select=pickTier($item) class=form-control></div></div><div><input type=radio name=role ng-model=user.role value=COMM_REP><label translate=CHANGE_ADMIN_ROLE_4></label></div></div></div></div><div class=modal-footer><button id=cancel-changestatus-parent-button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button id=confirm-changestatus-parent-button class=\"btn btn-default\" type=button ng-click=save() ng-disabled=!can_save><span translate=OK_BTN></span></button></div></div>");
$templateCache.put("app/users/views/check-approve-modal.html","<div class=assign-parent-admin style=\"padding: 20px\"><div class=modal-header><h3>{{ parent.firstName }} {{ parent.lastName }}</h3></div><div class=modal-body><br><div><div ng-repeat=\"pupil in parent.pupils\" style=\"margin-bottom: 30px\"><div style=\"overflow: auto\"><div style=\"background: #999; width: 10px; height: 10px; border-radius: 50%; margin-right: 10px; float: left; margin-top: 9px\"></div><div style=\"font-size: 16px; line-height: 30px\">{{ pupil.firstName }} ({{ pupil.firstTier }}<span ng-if=!pupil.secondTier>)</span><span ng-if=pupil.secondTier> / {{ pupil.secondTier }})</span></div></div><div style=\"margin-left: 20px\"><div style=\"font-size: 13px; color: #777\"><span ng-if=!pupil.suggestion><span translate=THIS_WILL_ADD_PUPIL></span> <span style=\"color: #333\">{{ getTierFromId(pupil.tierId).name }}</span> </span><span ng-if=pupil.suggestion><span translate=THIS_WILL_CREATE></span> <span style=\"color: #333\">{{ pupil.secondTier }}</span> <span translate=AND_ADD_PUPIL></span></span></div><div ng-if=!pupil.changeit><a ng-click=changeClass(pupil) translate=CHANGE_BTN></a></div><div ng-show=pupil.changeit class=is-relative><div class=is-relative><select ng-model=pupil.tierId ng-change=tierChange(pupil) class=form-control><option ng-repeat=\"year in flatStructure\" ng-value=year.id ng-disabled=year.hasClasses>{{ year.isClass == true ? \'&nbsp;&nbsp;\' : \'\' }} {{ year.name }}</option></select><span class=\"dripicons-chevron-down select-arrow\"></span></div></div></div></div></div><p style=\"color: #777; margin-bottom: 0\" translate=APPROVE_POPUP_TEXT_1></p></div><div class=modal-footer><button id=cancel-delete-parent-button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button id=confirm-delete-parent-button class=\"btn btn-primary\" type=button ng-disabled=\"pendingRequest || approving\" ng-click=confirm()><span translate=APPROVE_BTN></span></button></div></div>");
$templateCache.put("app/users/views/confirm-delete-parent-v2.html","<div class=assign-parent-admin ng-class=\"{\'not-ready\':!viewState.isReady}\"><div class=modal-header><h3 translate=DELETE_THIS_ACCOUNT></h3></div><div class=modal-body><p translate=DELETE_THIS_ACCOUNT_DESC ng-if=!user.integrationEnabled></p><p translate=DELETE_INTEGRATION_THIS_ACCOUNT_DESC ng-if=user.integrationEnabled></p></div><div class=modal-footer><button id=cancel-delete-parent-button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button id=confirm-delete-parent-button class=\"btn btn-primary\" type=button ng-click=delete()><span translate=DELETE_BTN></span></button></div></div>");
$templateCache.put("app/users/views/confirm-delete-parent.html","<div class=assign-parent-admin ng-class=\"{\'not-ready\':!viewState.isReady}\"><div class=modal-header><h3 translate=DELETE_FROM_CLASSLIST_TITLE translate-values=\"{name:user.name, school: user.school}\"></h3></div><div class=modal-body><p translate=DELETE_FROM_CLASSLIST_TEXT></p></div><div class=modal-footer><button id=cancel-delete-parent-button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button id=confirm-delete-parent-button class=\"btn btn-primary\" type=button ng-click=delete()><span translate=DELETE_BTN></span></button></div></div>");
$templateCache.put("app/users/views/confirm-delete-pupils.html","<div class=\"assign-parent-admin delete-pupils-modal\" ng-class=\"{\'not-ready\':!viewState.isReady}\"><div class=modal-header><h3 translate=DELETE_PUPILS_TITLE translate-values={name:user.name}></h3></div><div class=modal-body><p translate=DELETE_PUPILS_TEXT translate-values={name:user.name}></p><ul class=basket><li ng-repeat=\"pupil in user.pupils\"><div action=delete-pupil-sel index={{$index}} ng-click=\"pupil.checked=!pupil.checked\" ng-class=\"{selected: pupil.checked}\"><strong>{{pupil.name}}</strong> - {{pupil.tier}} <input type=checkbox class=pull-right ng-checked=pupil.checked style=\"margin: 0\"></div></li></ul></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button action=delete-pupil-but class=\"btn btn-primary\" type=button ng-click=delete() ng-disabled=!getSelectedPupils()><span translate=DELETE_BTN></span></button></div></div>");
$templateCache.put("app/users/views/confirm-disable-parent.html","<div class=assign-parent-admin><div class=modal-header><h3 translate=DISABLE_FROM_CLASSLIST_TITLE translate-values={name:user.name}></h3></div><div class=modal-body><p translate=DISABLE_FROM_CLASSLIST_TEXT translate-values=\"{name:user.name, school: active_school.name}\"></p></div><div class=modal-footer><button id=cancel-disable-parent-button class=\"btn btn-default\" type=button ng-click=cancel()><span translate=CANCEL_BTN></span></button> <button id=confirm-disable-parent-button style=\"padding-left: 16px !important; padding-right: 16px !important\" class=\"btn btn-primary\" type=button ng-click=confirm() ng-disabled=disabling><span translate=DEACTIVATE_BTN></span></button></div></div>");
$templateCache.put("app/users/views/confirm-enable-parent.html","<div class=assign-parent-admin><div class=modal-header><h3 translate=ENABLE_FROM_CLASSLIST_TITLE translate-values={name:user.name}></h3></div><div class=modal-body><p translate=ENABLE_FROM_CLASSLIST_TEXT translate-values=\"{name:user.name, school: active_school.name}\"></p></div><div class=modal-footer><button id=cancel-disable-parent-button class=\"btn btn-default\" type=button ng-click=cancel()><span translate=CANCEL_BTN></span></button> <button id=confirm-disable-parent-button class=\"btn btn-primary\" type=button ng-click=confirm() ng-disabled=disabling><span translate=ENABLE_BTN></span></button></div></div>");
$templateCache.put("app/users/views/confirm-unassign-role.html","<div class=assign-parent-admin ng-class=\"{\'not-ready\':!viewState.isReady}\"><div class=modal-header><h3 translate=CONFIRM_UNASSIGN_HEADER ng-if=\"repType !== \'COMM_REP\' && repType !== \'AMBASSADOR\'\"></h3><h3 translate=CONFIRM_UNASSIGN_COMM_HEADER ng-if=\"repType === \'COMM_REP\'\"></h3><h3 translate=CONFIRM_UNASSIGN_AMBASSADOR_HEADER ng-if=\"repType === \'AMBASSADOR\'\"></h3></div><div class=modal-body><p translate=CONFIRM_UNASSIGN_TEXT translate-values=\"{name:user.name, class: user.tier}\" ng-if=\"repType !== \'COMM_REP\' && repType !== \'AMBASSADOR\'\"></p><p translate=CONFIRM_UNASSIGN_COMM_TEXT translate-values={name:user.name} ng-if=\"repType === \'COMM_REP\'\"></p><p translate=CONFIRM_UNASSIGN_AMBASSADOR_TEXT translate-values={name:user.name} ng-if=\"repType === \'AMBASSADOR\'\"></p></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary\" type=button ng-click=confirm()><span translate=UNASSIGN></span></button></div></div>");
$templateCache.put("app/users/views/manage-parents.html","<section class=manage-users ng-class=\"{\'is-visible\':viewState.isReady}\"><div class=\"page-view-header clearfix\"><div><strong class=page-view-header__title translate=TOPNAV_MANAGE_USERS_PARENTS></strong> <span ng-if=integrationEnabled() ng-click=openInfo() class=\"icon dripicons-information\"></span> <button type=button class=\"btn btn-primary btn-sm\" ui-sref=invite.nonmemberlist translate=ADD_INVITE_BTN style=\"float: right; margin-top: 6px\"></button></div></div><div><div class=page-view-subheader style=\"margin-top: -1px; min-height: 62px\"><div class=row><div class=col-md-6><div class=\"is-relative page-view-header__search\"><input type=search class=form-control placeholder=\"{{ \'SEARCH_PHOLDER\' | translate }}\" ng-model=keyword style=\"border: 1px solid;\n						padding-left: 10px\"> <span class=\"icon dripicons-search\" style=\"right: 5px; position: absolute; top: 9px\"></span></div></div><div class=col-md-6><div class=form-group><filter-picker ngmodel=selectedTierId></filter-picker></div></div></div></div><div ng-if=\"parents && parents.length > 0\" style=\"padding: 5px 15px; background: #fff; border: 1px solid #d8d8d8\"><div class=accordion ng-repeat=\"p in parents\"><div ui-sref-active=active class=accordion__trigger ng-click=gotoDetail(p)><strong>{{::p.name}} <span ng-if=p.disabled style=\"padding-left:10px; font-weight: normal\" translate=DEACTIVATED></span></strong> <span class=\"dripicons-chevron-right pull-right accordion__chevron\"></span></div></div></div></div></section>");
$templateCache.put("app/users/views/non-parent-detail.html","<section class=user-detail ng-if=viewState.isReady><div class=page-view-header><div><div><div><a class=page-view-header__back ng-click=back() style=\"float: left; margin-right: 10px; position: relative\"><span class=dripicons-arrow-thin-left></span></a><div class=page-view-header__text style=\"padding-left: 0\"><strong class=page-view-header__title translate=BACK_BTN></strong><div class=pull-right><div translate=STATUS></div><div><div tooltip><div class=tltp translate=NON_MEMBER></div><span class=\"dripicons-archive icon-archive icon\" style=\"font-size: 20px;float: right\"></span></div></div></div></div></div></div></div></div><div class=page-container-header-from-top style=\"padding: 0 20px\"><div class=parent-sections><div style=\"overflow: auto\"><figure class=avatar><img width=40 height=40 alt=\"\" class=\"avatar-placeholder ng-isolate-scope\" alt=avatar onerror=\"this.src=\'assets/icons/default-avatar.png\'\" src={{user.avatar}}></figure><div class=parent-name style=\"margin: 27px 0\"><div>{{ user.firstName }} {{ user.lastName }} <span ng-if=user.unsubscribed translate=UNSUBSCRIBED_></span> <span ng-if=user.preapproved translate=PREAPPROVED></span></div><div translate=NON_MEMBER></div><br><div translate=INFO_NON_MEMBER></div></div></div><br><div><section><label translate=CONTACT></label><div><div class=contact-list><div><span class=\"dripicons-mail contact-icon icon\"></span> <span>{{ user.mail }}</span></div><div ng-if=user.phone><span class=\"dripicons-phone contact-icon icon\"></span> <span>{{user.phone}}</span></div><div ng-if=user.address.city><span class=\"dripicons-location contact-icon icon\"></span> <span>{{user.address.houseName}} {{user.address.streetAddress}} {{user.address.postCode}}, {{user.address.city}}</span></div></div></div></section></div><div><section class=bordered><div><span class=title translate=ADDED_BY></span> <a href=#/users/parent-detail/{{user.addedById}}>{{ user.addedBy }}</a>, <span>{{::user.addedAt | date: \'MMM dd, yyyy\'}}</span></div><br><br><div style=\"margin-bottom: 10px\"><div ng-click=openEdit(user) class=pointer action=open-edit><span class=\"dripicons-pencil big-icon icon-pink icon\"></span> <span translate=EDIT_PARENT></span></div></div><div ng-show=\"active_user.role == \'AMBASSADOR\' || active_user.role == \'STAFF\'\" action=delete-nonmember ng-click=\"deleteNonMember(user.id, user.firstName + \' \' + user.lastName)\" class=pointer><span class=\"dripicons-trash big-icon icon-red icon\"></span> <span translate=DELETE_PARENT></span></div></section><section ng-if=user.familyMembers><label translate=FAMILY></label><div ng-repeat=\"fam in user.familyMembers\"><div class=icon-large-height><span class=\"dripicons-heart icon\"></span><div class=fam-name>{{ fam.fullName }}</div><div>{{ nameRelation(fam.relationId) }}</div></div><div class=contact-list><div ng-if=fam.mail><span class=\"dripicons-mail contact-icon icon\"></span> <span>{{ fam.mail }}</span></div><div ng-if=fam.phone><span class=\"dripicons-phone contact-icon icon\"></span> <span>+{{fam.phone}}</span></div></div><br><br></div></section></div></div></div></section>");
$templateCache.put("app/users/views/parent-detail.html","<section class=user-detail ng-if=viewState.isReady><div class=page-view-header><div><div><div><a class=page-view-header__back ng-click=back() style=\"float: left; margin-right: 10px; position: relative\"><span class=dripicons-arrow-thin-left></span></a><div class=page-view-header__text style=\"padding-left: 0\"><strong class=page-view-header__title translate=BACK_BTN></strong><div class=pull-right style=\"margin-right: 10px\"><!-- <div ng-if=\"user.approved && user.access\" translate=\"STATUS\" class=\"status-title-active\"></div>\n								<div ng-if=\"!user.access\" translate=\"STATUS\" class=\"status-title-disabled\"></div> --><div class=pending tooltip ng-if=\"user.access && !user.approved\"><div class=tltp translate=PENDING_APPROVAL></div><span class=\"dripicons-loading icon-loading icon pending-icon\"></span></div><div ng-if=\"user.approved && user.access\"><div tooltip style=\"float: right; margin-top: 5px\" ng-hide=\"role == \'COMM_REP\' || role == \'CLASS_REP\' || isStaffWithoutUserManagementPermission()\"><div class=tltp style=\"float: left; margin-top: 26px\" translate=DEACTIVATE_BTN></div><button id=confirm-disable-parent-button class=\"btn btn-primary\" type=button ng-disabled=disabling><span ng-click=disable() translate=DEACTIVATE_BTN></span></button></div><!-- <span class=\"dripicons-checkmark icon-checkmark icon\" style=\"float: right; margin-right: 15px;\"></span> --></div><div ng-if=!user.access class=disabled-user-container style=\"float: right; margin-top: 5px\" ng-hide=\"role == \'COMM_REP\' || role == \'CLASS_REP\' || isStaffWithoutUserManagementPermission()\"><button style=margin-right:15px id=cancel-disable-parent-button class=\"btn btn-primary\" type=button ng-click=enable()><span translate=RE_ACTIVATE_BTN></span></button> <button id=delete-disable-parent-button class=\"btn btn-ghost\" style=\"height: 40px !important\" type=button ng-click=\"deleteParent(user.id, user.name, active_school.name, active_school.integrationEnabled)\"><span translate=DELETE_BTN style=\"padding-left:10px;padding-right: 10px; font-weight: 600\"></span></button></div></div></div></div></div></div></div><div style=\"padding: 20px 20px 0px 20px; display: flex\"><span class=\"dripicons-information contact-icon icon\" style=\"cursor: default; font-size: 20px\"></span> <span translate=MANAGE_PARENT_DESCRIPTION_TEXT></span></div><div style=\"padding: 0 20px\"><div style=\"overflow: auto\"><figure class=avatar><figure class=classlist-item-avatar style=\"width: 80px; height: 80px; float: left; margin-right: 12px\"><avatar source=\"{{ user.avatar }}\" width=40 height=40 name=\"{{ user.name }}\" my=false></avatar></figure></figure><div class=parent-name><div>{{ user.name }}</div><div ng-if=\"user.access && !user.approved\" translate=PENDING_APPROVAL></div><div style=\"font-size: 12px!important\" ng-if=user.schoolReps ng-repeat=\"r in user.schoolReps\"><span>{{r.label}}</span> <span translate={{r.role}} class=gray-label></span></div></div><div style=\"float: right;margin-top:5px\" ng-if=integrationEnabled><input type=text value=\"MIS ID : {{user.misId}}\" disabled style=\"text-align: center\"></div></div><div ng-if=!user.approved style=\"margin-bottom: 30px; margin-top: 10px\"><button type=button class=\"btn btn-primary\" ng-click=approve() ng-disabled=approving translate=CHECK_APPROVE_BTN></button></div><div class=parent-sections><div><section class=bordered style=\"margin-bottom: 20px\"><div class=contact-list><div ng-if=\"user.mail && active_user.role != \'CLASS_REP\'\"><span class=\"dripicons-mail contact-icon icon\"></span> <span>{{ user.mail }}</span></div><div ng-if=\"user.address && user.address.city && user.address.city.length > 0\" style=\"user-select: none\"><span class=\"dripicons-location contact-icon icon\"></span> <span>{{user.address.houseName}} {{user.address.streetAddress}} {{user.address.postCode}}, {{user.address.city}}</span></div></div></section><section class=bordered style=\"margin-bottom: 20px\"><div ng-if=\"user.approved && !user.access && (user.deactivatedBy || user.deactivatedAt)\" style=\"margin-bottom: 20px\"><div class=title translate=DEACTIVATED_BY></div><div ng-if=user.deactivatedBy>{{user.deactivatedBy}}</div><div ng-if=user.deactivatedAt>{{::user.deactivatedAt | date: \'MMM dd, yyyy\'}}</div></div><div ng-if=user.lastActiveDate style=\"margin-bottom: 20px\"><div class=title translate=LAST_ACTIVE></div><div>{{::user.lastActiveDate | date: \'MMM dd, yyyy\'}}</div></div><div ng-if=user.joinedAt><div class=title translate=JOINED></div><div>{{::user.joinedAt | date: \'MMM dd, yyyy\'}}</div></div><a ng-if=!user.approved class=delete-parent translate=DELETE_PARENT ng-click=\"deleteMember(user.id, user.name, active_school.name)\"></a><div ng-if=\"user.approvedBy !== \'Classlist \' && user.approved == true && !user.autoApproved\" style=\"margin-top: 20px\"><div class=title translate=APPROVED_BY></div><!-- approvedById 1 means auto approved by classlist --><div ng-if=\"user.approvedById !== \'1\' && user.approvedById !== \'-1\'\">{{ user.approvedBy }} <span ng-if=!user.invitationType>manually</span></div><div ng-if=\"user.approvedById === \'1\' || user.approvedById === \'-1\'\" translate=PRE_APPROVED_BY_CLASSLIST_TEXT></div><div>{{::user.approvedAt | date: \'MMM dd, yyyy\'}}</div></div><div ng-if=\"user.approvedBy !== \'Classlist \' && user.autoApproved\" style=\"margin-top: 20px\"><div class=title translate=APPROVED_BY></div><div>{{ user.approvedBy }} <span ng-if=\"user.invitationType == \'QRCODE\'\">via QR code link</span> <span ng-if=\"user.invitationType !== \'QRCODE\'\">via invitation</span></div><div>{{::user.approvedAt | date: \'MMM dd, yyyy\'}}</div></div><div ng-if=\"user.approvedBy === \'Classlist \' && user.approved === true\"><div class=title translate=APPROVED_BY></div>{{ user.approvedBy }}<div>{{::user.approvedAt | date: \'MMM dd, yyyy\'}}</div><div ng-if=\"user.approved === false\"><span class=title translate=NOT_APPROVED></span></div></div></section><section class=bordered ng-if=\"user.schoolReps || ((role == \'AMBASSADOR\' || (role == \'STAFF\' && !isStaffWithoutUserManagementPermission())) && user.approved)\"><div ng-show=\"(role == \'AMBASSADOR\' || (role == \'STAFF\' && !isStaffWithoutUserManagementPermission())) && user.approved\"><div class=pointer ng-click=\"changeMember(user, \'PARENT_DETAIL\')\"><span class=\"dripicons-gear big-icon icon-pink icon\"></span> <span translate=CHANGE_ADMIN_STATUS></span></div></div><div ng-if=user.schoolReps class=\"list double-rows\" style=\"padding-top: 6px\"><div ng-repeat=\"rep in user.schoolReps\"><div><span translate=\"{{rep.role | translate}}\" class=difference></span><br><a ng-if=rep.tier href=#/users/manage-parents/{{rep.tier}} class=\"list_link difference\">{{rep.tier}}</a> <span translate={{rep.label}}></span> <span ng-click=editLabel(rep) class=\"icon dripicons-pencil icon_edit difference\" ng-if=\"user.id == _user.id || role == \'AMBASSADOR\' || (role == \'STAFF\' && !isStaffWithoutUserManagementPermission())\" ng-click=\"editLabel(link, $index)\"></span> <a ng-if=\"rep.tier && (role == \'AMBASSADOR\' || (role == \'STAFF\' && !isStaffWithoutUserManagementPermission()))\" class=list_link ng-click=\"unassignRole(user.name,rep, user.schoolReps)\" translate=UNASSIGN>{{rep.tier}}</a> <a ng-if=\"(rep.role === \'COMM_REP\' || rep.role === \'AMBASSADOR\') && (role == \'AMBASSADOR\' || (role == \'STAFF\' && !isStaffWithoutUserManagementPermission()))\" class=list_link ng-click=\"unassignRole(user.name,rep, user.schoolReps)\" translate=UNASSIGN>{{rep.label}}</a></div></div></div></section><!-- No pupil --><section ng-if=\"!user.pupils || user.pupils.length == 0\" class=\"bordered no-pupil-container\" style=\"margin-bottom: 20px\"><label translate=PUPILS style=\"font-size: 16px; font-weight: 600\"></label><div><p translate=NO_PUPILS_HEADER style=\"font-size: 14px\"></p><p translate=NO_PUPILS_DESC style=\"font-size: 12px\"></p></div></section><!-- Has pupil --><section ng-if=\"user.pupils && user.pupils.length > 0\" class=bordered style=\"margin-bottom: 20px\"><label translate=PUPILS></label><div class=\"icon-large-height pupil pupil-container\" ng-repeat=\"pupil in user.pupils\"><span ng-hide=\"role == \'COMM_REP\' || role == \'CLASS_REP\' || integrationEnabled || isStaffWithoutUserManagementPermission()\" action=delete-pupil index={{$index}} ng-click=\"deletePupils(pupil.id, user.name, $index)\" class=\"pointer dripicons-trash big-icon icon-red icon\" style=\"margin-top: 10px\"></span><figure ng-if=\"pupil.gender == \'M\'\" class=\"avatar male\"><img src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid.svg alt=\"\" width=22></figure><figure ng-if=\"pupil.gender == \'F\'\" class=\"avatar female\"><img src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid.svg alt=\"\" width=22></figure><figure ng-if=\"pupil.gender == \'N\'\" class=\"avatar nonbinary\"><img src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid.svg alt=\"\" width=22></figure><figure ng-if=\"pupil.gender == \'P\'\" class=\"avatar notdefined\"><img src=https://storage.googleapis.com/classlist-branding/app-assets/icon-people-kid.svg alt=\"\" width=22></figure><figure ng-if=!pupil.gender class=\"avatar unspecified\"><img src=https://storage.googleapis.com/classlist-branding/app-assets/icon-pupil-no-data.svg alt=\"\" width=9></figure><div style=\"display: grid\"><div style=\"margin: 0px; padding: 0px\">{{pupil.relation}} of</div><div style=\"margin: 0px; padding: 0px\" class=name>{{pupil.name}}</div><div style=\"margin: 0px; padding: 0px\" class=name ng-if=integrationEnabled>MIS ID : {{pupil.misId}}</div></div><!-- <div ng-if=\"pupil.gender == \'M\'\" class=\"daughter\" translate=\"PUPIL_SON\">Son</div>\n							<div ng-if=\"pupil.gender == \'unspecified\'\" class=\"daughter\"></div>\n							<div ng-if=\"pupil.gender == \'F\'\" class=\"daughter\" translate=\"PUPIL_DAUGHTER\">Daughter</div>\n							<div ng-if=\"pupil.gender == \'N\' || pupil.gender == \'P\'\" class=\"daughter\" translate=\"PUPIL_CHILD\">Child</div> --><div style=\"margin-left:90px !important\" class=\"list {{ role == \'COMM_REP\' || role == \'CLASS_REP\' || isStaffWithoutUserManagementPermission() ? \'no-delete\' : \'\' }}\"><div><a class=list_link ng-if=\"role != \'COMM_REP\'\" href=#/users/manage-parents/{{pupil.tier}}>{{pupil.tier}}</a><p ng-if=\"role == \'COMM_REP\'\" href=#/users/manage-parents/{{pupil.tier}}>{{pupil.tier}}</p></div></div><div class=\"list {{ role == \'COMM_REP\' || role == \'CLASS_REP\' || isStaffWithoutUserManagementPermission() ? \'no-delete\' : \'\' }}\"><img ng-if=pupil.mob src=assets/icons/icon-birthday-cake.svg class=\"contact-icon cake-icon\" width=18 height=20 alt=\"\"> <span class=birth-month ng-if=\"pupil.mob === 1\" translate=PUPIL_JAN></span> <span class=birth-month ng-if=\"pupil.mob === 2\" translate=PUPIL_FEB></span> <span class=birth-month ng-if=\"pupil.mob === 3\" translate=PUPIL_MAR></span> <span class=birth-month ng-if=\"pupil.mob === 4\" translate=PUPIL_APR></span> <span class=birth-month ng-if=\"pupil.mob === 5\" translate=PUPIL_MAY></span> <span class=birth-month ng-if=\"pupil.mob === 6\" translate=PUPIL_JUN></span> <span class=birth-month ng-if=\"pupil.mob === 7\" translate=PUPIL_JUL></span> <span class=birth-month ng-if=\"pupil.mob === 8\" translate=PUPIL_AUG></span> <span class=birth-month ng-if=\"pupil.mob === 9\" translate=PUPIL_SEP></span> <span class=birth-month ng-if=\"pupil.mob === 10\" translate=PUPIL_OCT></span> <span class=birth-month ng-if=\"pupil.mob === 11\" translate=PUPIL_NOV></span> <span class=birth-month ng-if=\"pupil.mob === 12\" translate=PUPIL_DEC></span></div></div></section><section ng-if=user.familyMembers class=bordered style=\"margin-bottom: 20px\"><label translate=FAMILY></label><div ng-repeat=\"fam in user.familyMembers\"><div class=icon-large-height><span class=\"dripicons-heart icon\"></span><div class=fam-name>{{ fam.fullName }}</div><div>{{ nameRelation(fam.relationId) }}</div></div><div class=contact-list ng-if=\"fam.mail || fam.phone\"><div ng-if=fam.mail ng-if=\"fam.mail && fam.mail.length > 0\"><span class=\"dripicons-mail contact-icon icon\"></span> <span>{{ fam.mail }}</span></div><div ng-if=\"fam.phone && fam.phone.length > 4\"><span class=\"dripicons-phone contact-icon icon\"></span> <span>+{{fam.phone}}</span></div></div><br><br></div></section></div></div></div></section>");
$templateCache.put("app/users/views/staff-detail.html","<section class=user-detail ng-if=viewState.isReady><div class=page-view-header><div><div><div><a class=page-view-header__back ng-click=back() style=\"float: left; margin-right: 10px; position: relative\"><span class=dripicons-arrow-thin-left></span></a><div class=page-view-header__text style=\"padding-left: 0\"><strong class=page-view-header__title translate=BACK_BTN></strong></div></div></div></div></div><div class=page-container-header-from-top style=\"padding: 0 20px\"><div class=parent-sections><div style=\"overflow: auto\"><figure class=avatar><figure class=classlist-item-avatar style=\"width: 80px; height: 80px; float: left; margin-right: 12px\"><avatar source=\"{{ user.avatar }}\" width=40 height=40 name=\"{{ user.name }}\" my=false></avatar></figure></figure><div class=parent-name><div style=\"font-size: 16px\">{{ user.name }}</div><div><span ng-if=user.label>{{user.label}}</span> <span translate=SCHOOL_STAFF class=gray-label></span></div></div></div><br><div><section><label translate=CONTACT></label><div><div class=contact-list><div><span class=\"dripicons-mail contact-icon icon\"></span> <span>{{ user.mail }}</span></div><div ng-if=user.phone><span class=\"dripicons-phone contact-icon icon\"></span> <span>{{user.phone}}</span></div><div ng-if=user.address.city><span class=\"dripicons-location contact-icon icon\"></span> <span>{{user.address.houseName}} {{user.address.streetAddress}} {{user.address.postCode}}, {{user.address.city}}</span></div></div></div></section></div><div><section class=bordered><div style=\"display: flex\"><svg width=24 height=24 viewBox=\"0 0 24 24\" fill=none xmlns=http://www.w3.org/2000/svg><path d=\"M11.526 14.7a2.7 2.7 0 1 0 0-5.4 2.7 2.7 0 0 0 0 5.4z\" stroke=#E94880 stroke-width=1.5 stroke-miterlimit=10 stroke-linecap=square /><path d=\"M18.727 12a7.248 7.248 0 0 0-.17-1.542L21 8.608l-1.8-3.117-2.829 1.193a7.189 7.189 0 0 0-2.665-1.547l-.38-3.038h-3.6l-.38 3.038a7.189 7.189 0 0 0-2.665 1.547L3.852 5.491l-1.8 3.118 2.443 1.85a7.11 7.11 0 0 0 0 3.083l-2.443 1.85 1.8 3.117 2.829-1.193a7.189 7.189 0 0 0 2.665 1.547l.38 3.038h3.6l.38-3.038a7.189 7.189 0 0 0 2.665-1.547l2.829 1.193 1.8-3.118-2.443-1.85a7.248 7.248 0 0 0 .17-1.541v0z\" stroke=#E94880 stroke-width=1.5 stroke-miterlimit=10 stroke-linecap=square /></svg> <span class=title translate=STAFF_ADMIN_PERMISSION style=padding-left:10px></span></div><div style=\"margin-top: 10px; padding-left:35px; font-size: 12px\"><span translate=HAS_USERMANAGEMENT_PERMISSION ng-if=user.userManagementPermission></span> <span translate=DOESNT_HAVE_USERMANAGEMENT_PERMISSION ng-if=!user.userManagementPermission></span> <span translate=EDIT style=\"color:#eb004e; padding-left: 20px; font-weight: 600\" ng-click=changeStaffPermission() class=pointer ng-if=isStaffInvitePermission></span></div><div ng-if=user.joinedAt style=\"margin-top: 5px; padding-left:35px; font-size: 12px; display: flex\"><span ng-if=user.label>{{user.label}}</span> <span ng-if=!user.label translate=NO_LABEL></span> <span style=\"margin-left:8px;cursor: pointer\" ng-click=editLabel(user) class=\"icon_edit difference\" ng-if=\"user.id == _user.id || role == \'AMBASSADOR\' || (role == \'STAFF\' && !isStaffWithoutUserManagementPermission())\"><svg width=20 height=20 viewBox=\"0 0 20 20\" fill=none xmlns=http://www.w3.org/2000/svg><g clip-path=url(#clip0_3168_2335)><path d=\"M11.666 4.1665L15.8327 8.33317\" stroke=#EB004E stroke-width=1.5 stroke-miterlimit=10 /><path d=\"M7.49935 16.6665L1.66602 18.3332L3.33268 12.4999L13.6777 2.15487C14.3285 1.50404 15.3835 1.50404 16.0343 2.15487L17.8443 3.96487C18.4952 4.61571 18.4952 5.67071 17.8443 6.32154L7.49935 16.6665Z\" stroke=#EB004E stroke-width=1.5 stroke-miterlimit=10 stroke-linecap=square /></g><defs><clipPath id=clip0_3168_2335><rect width=20 height=20 fill=white /></clipPath></defs></svg></span></div></section></div><div><section class=bordered><div><span class=title translate=JOINED></span> <span>{{::user.joinedAt | date: \'MMM dd, yyyy\'}}</span></div><div ng-if=\"user.approvedBy !== \'Classlist \' && user.approved === true\"><span class=title translate=APPROVED_BY></span> <a href=#/users/parent-detail/{{user.approvedById}}>{{ user.approvedBy }}</a>, <span>{{::user.approvedAt | date: \'MMM dd, yyyy\'}}</span></div><div ng-if=\"user.approvedBy === \'Classlist \' && user.approved === true\"><span class=title translate=APPROVED_BY></span> {{ user.approvedBy }}, <span>{{::user.approvedAt | date: \'MMM dd, yyyy\'}}</span></div><div action=delete-parent ng-click=\"deleteMember(user.id, user.name, user.joinedAt && user.joinedAt !== \'\')\" class=pointer ng-hide=\"(role !== \'AMBASSADOR\' && role !== \'STAFF\') || isStaffWithoutUserManagementPermission()\" style=\"margin-top: 10px\"><span class=\"dripicons-trash big-icon icon-red icon\"></span> <span translate=DELETE_STAFF></span></div></section></div></div></div></section>");
$templateCache.put("app/users/views/update-staff-permissions.html","<div class=assign-parent-admin ng-class=\"{\'not-ready\':!viewState.isReady}\" style=padding:8px><div class=modal-header><h3 translate=UPDATE_STAFF_ADMIN_PERMISSION></h3></div><div class=modal-body><p translate=UPDATE_STAFF_ADMIN_PERMISSION_DESC translate-values=\"{name: user.name}\" style=\"font-size: 15px; color:#333333; font-weight: 600\"></p><div class=radio-options style=\"padding-left: 10px; padding-top:10px\"><label><input type=radio name=ticketOption ng-model=hasUserManagementPermission ng-value=true ng-change=onOptionChange()> <span><span style=\"padding-left: 10px; font-size: 15px\" translate=USERMANAGEMENT_PERMISSION></span> <span style=\"font-size: 13px;display: block; padding-left:31px\" translate=USERMANAGEMENT_PERMISSION_SUB_DESC></span></span></label><label style=padding-top:15px><input style=\"margin-top: -3px\" type=radio name=ticketOption ng-model=hasUserManagementPermission ng-value=false ng-change=onOptionChange()> <span style=\"padding-left: 10px; font-size: 15px\" translate=NO_USERMANAGEMENT_PERMISSION></span></label></div></div><div class=modal-footer><button id=cancel-delete-parent-button class=\"btn btn-default\" type=button ng-click=close()><span translate=CANCEL_BTN></span></button> <button id=confirm-delete-parent-button class=\"btn btn-primary\" type=button ng-click=changePermission()><span translate=SAVE_BTN></span></button></div></div>");
$templateCache.put("app/users/views/user-detail-modal.html","<div class=user-details><div class=modal-body><h3 class=details-header>{{::user.firstName }} {{::user.lastName }} <span ng-if=user.relationship>({{::user.relationship}})</span></h3><br><strong ng-hide=!user.phoneNumber translate=PHONE_TITLE></strong><p><span ng-show=::user.phoneNumber>+{{::user.phoneNumber}}</span></p><strong ng-hide=!user.email translate=EMAIL_TITLE></strong><p>{{::user.email}}</p><strong ng-hide=\"!(user.address.houseName && user.address.streetAddress && user.address.city && user.address.postCode)\" translate=ADDRESS_TITLE></strong><p>{{::user.address.houseName}} {{::user.address.streetAddress}} {{::user.address.city}} {{::user.address.postCode}}</p><p ng-if=\"user.approved === false\" translate=CREATED_BY_TITLE>{{::user.createdBy}} {{::user.createdOn | date: \'MMM dd, yyyy\'}}</p><strong ng-if=\"user.approved === true\" translate=JOINED_TITLE></strong><p>{{::user.joinedDate | date: \'MMM dd, yyyy\'}}</p><strong ng-if=\"user.approved === true\" translate=APPROVED_BY_TITLE></strong><p ng-if=\"user.approved === true\">{{::user.approvedBy}}, {{::user.approvedDate | date: \'MMM dd, yyyy\'}}</p></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()><span translate=OK_BTN></span></button></div></div>");
$templateCache.put("app/users/views/wrapper.html","<div class=\"content-logged users\"><div ui-view></div></div>");
$templateCache.put("app/website/views/comingsoon.html","<section class=\"raffle-view raffle-create\"><div class=page-view-header><div><div class=row><div class=col-xs-12><strong class=page-view-header__title class=section-title>Website</strong></div></div></div></div><div class=create-raffle-container style=\"margin: 4% auto\"><div class=title>Unlock your new PTA website</div><p>Coming soon: A public-facing website that you can control from your existing Classlist account as easily as the \"School Profile\" page. Find out more and <a href=https://www.classlist.com/pta-websites-from-classlist target=_blank style=\"font-weight: 700\">join our priority list.</a></p></div></section>");
$templateCache.put("app/website/views/edit-address-modal.html","<div class=assign-parent-admin><div class=modal-header><h3 translate=WEBSITE_EDIT_LOCATION></h3></div><div class=modal-body><form novalidate><label translate=ADDRESS class=modal-separator></label><div class=form-group><div class=row><div class=col-md-6><input type=text placeholder=\"{{\'STREETNAME_PHOLDER\' | translate}}\" class=form-control ng-model=settings.address.streetAddress required></div><div class=col-md-6><input type=text placeholder=\"{{\'CITY_PHOLDER\' | translate}}\" class=form-control ng-model=settings.address.city required></div></div></div><div class=form-group><div class=row><div class=col-md-6><input type=text placeholder=\"{{\'COUNTY_PHOLDER\' | translate}}\" class=form-control ng-model=settings.address.stateCounty></div><div class=col-md-2><input type=text placeholder=\"{{\'POSTCODE_PHOLDER\' | translate}}\" class=form-control ng-model=settings.address.postCode required maxlength=10></div><div class=col-md-4><div class=is-relative><countries ng-model=settings.address.countryId is-required=true></countries><label class=select-placeholder translate=COUNTRY_PHOLDER ng-hide=\"settings.address.countryId.length > 0\"></label><span class=\"dripicons-chevron-down select-arrow\"></span></div></div></div></div><div class=show-on-map-container><div translate=WEBSITE_OPEN_IN_MAPS_TEXT translate-values=\"{\'link\': settings.address.streetAddress + \' \' + settings.address.postCode + \' \' + settings.address.city + \' \' + getCountryName(settings.address.countryId) }\"></div></div></form></div><div class=modal-footer><div class=buttons><button class=\"btn btn-default\" type=button ng-click=cancel()><span translate=CANCEL_BTN></span></button> <button class=\"btn btn-primary save-btn\" type=button ng-click=continue() ng-disabled=\"!settings.address.streetAddress || !settings.address.city || !settings.address.postCode || !settings.address.countryId\"><span translate=SAVE_BTN></span></button></div></div></div>");
$templateCache.put("app/website/views/edit-domain-modal.html","<div style=\"padding: 15px\"><div class=modal-body><p translate=WEBSITE_EDIT_DOMAIN_1></p><p translate=WEBSITE_EDIT_DOMAIN_2></p></div><div class=modal-footer><button type=button class=\"btn btn-ghost pull-right\" ng-click=continue() translate=CONTINUE_BTN_2></button> <button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=cancel()></button></div></div>");
$templateCache.put("app/website/views/publish-warning-modal.html","<div style=\"padding: 15px\"><div class=modal-header><h3 translate=WEBSITE_PUBLISH_WARNING_TITLE></h3></div><div class=modal-body><ul><li translate=WEBSITE_PUBLISH_WARNING_DESCRIPTION_1></li><li translate=WEBSITE_PUBLISH_WARNING_DESCRIPTION_2></li><li translate=WEBSITE_PUBLISH_WARNING_DESCRIPTION_3></li><li translate=WEBSITE_PUBLISH_WARNING_DESCRIPTION_4></li><li translate=WEBSITE_PUBLISH_WARNING_DESCRIPTION_5></li></ul><p style=\"text-align: center\"><input id=checkbox type=checkbox ng-model=checked><label for=checkbox translate=WEBSITE_PUBLISH_WARNING_DESCRIPTION_6 style=\"vertical-align: super; margin-left: 10px\"></label></p></div><div class=modal-footer><button type=button class=\"btn btn-ghost pull-right\" ng-click=continue() translate=CONTINUE_BTN_2 ng-disabled=!checked></button> <button type=button class=\"btn btn-default pull-right\" translate=CANCEL_BTN ng-click=cancel()></button></div></div>");
$templateCache.put("app/website/views/published-modal.html","<div style=\"padding: 15px\"><div class=modal-body><p translate=WEBSITE_PUBLISHED_1></p><p translate=WEBSITE_PUBLISHED_2></p><p translate=WEBSITE_PUBLISHED_3></p></div><div class=modal-footer><button type=button class=\"btn btn-default pull-right\" translate=OK_BTN ng-click=cancel()></button></div></div>");
$templateCache.put("app/website/views/settings.html","<div class=page-view-header><div><div class=row><div class=col-xs-12><strong class=page-view-header__title class=section-title translate=WEBSITE></strong></div></div></div></div><div class=create-raffle-container ng-show=!settings.featureEnabled style=\"margin: 4% auto\"><div class=title translate=WEBSITE_DISABLED_TITLE></div><p translate=WEBSITE_DISABLED_DESCRIPTION></p></div><div class=website-container ng-show=settings.featureEnabled><h3 translate=WEBSITE_TITLE></h3><p translate=WEBSITE_DESCRIPTION></p><p translate=WEBSITE_DESCRIPTION_2></p><div class=status-container ng-if=settings.published><div><h4 translate=WEBSITE_STATUS_TITLE></h4><p><span translate=WEBSITE_URL translate-values=\"{websiteURL: websiteURL}\"></span> <span class=\"icons dripicons-duplicate\"></span> <a ng-click=copyURL() translate=COPY></a></p></div></div><div><button class=accordion ng-click=toggleFirstPanel()><span translate=WEBSITE_FIRST_PANEL_NAME></span> <span class=\"{{firstPanel ? \'dripicons-chevron-up\' : \'dripicons-chevron-down\'}} down-arrow\"></span></button><div class=panel ng-class=\"{active: firstPanel}\"><p translate=WEBSITE_FIRST_TEXT_DESCRIPTION></p><h3 translate=WEBSITE_FIRST_TEXT_HEADER></h3><div class=content-box><div><label for=firstTextTitle translate=WEBSITE_TITLE_INPUT_LABEL></label><label class=error-text>&nbsp;*</label></div><input type=text id=firstTextTitle ng-model=firstText.title maxlength=50 placeholder=\"{{\'WEBSITE_FIRST_TEXT_TITLE_PLACEHOLDER\' | translate}}\"> <span>{{firstText.title.length}}/50</span><div><label for=firstTextBody translate=WEBSITE_BODY_INPUT_LABEL></label><label class=error-text>&nbsp;*</label></div><textarea id=firstTextBody ng-model=firstText.body rows=5 maxlength=250 placeholder=\"{{\'WEBSITE_FIRST_TEXT_BODY_PLACEHOLDER\' | translate}}\"></textarea><span>{{firstText.body.length}}/250</span><p translate=WEBSITE_OPTIONAL_BUTTON_DESCRIPTION></p><div><label for=firstTextLabel translate=WEBSITE_LABEL_INPUT_LABEL></label></div><input type=text id=firstTextLabel ng-model=firstText.linkLabel maxlength=20 ng-focus=\"firstText.linkLabelError = false\"> <span>{{firstText.linkLabel.length}}/20</span><div><label for=firstTextLink translate=WEBSITE_LINK_INPUT_LABEL></label></div><input type=text id=firstTextLink ng-model=firstText.linkAddress ng-focus=\"firstText.linkAddressError = false\"><p ng-if=\"firstText.linkAddress.length !== 0 && !validateLink(firstText.linkAddress)\" class=error-text translate=INVALID_LINK_ERROR></p><p ng-if=firstText.linkAddressError class=error-text translate=WEBSITE_LINK_LABEL_ERROR></p><p ng-if=firstText.linkLabelError class=error-text translate=WEBSITE_LINK_ADDRESS_ERROR></p><p><button type=button class=\"btn btn-primary\" ng-disabled=\"isSectionSaveDisabled(firstText, settings.section1)\" ng-click=\"sectionSave(0, \'section1\', firstText)\" translate=SAVE_BTN></button></p></div><h3 translate=WEBSITE_SECOND_TEXT_HEADER></h3><div class=content-box><div><label for=secondTextTitle translate=WEBSITE_TITLE_INPUT_LABEL></label><label class=error-text>&nbsp;*</label></div><input type=text id=secondTextTitle ng-model=secondText.title maxlength=50 placeholder=\"{{\'WEBSITE_SECOND_TEXT_TITLE_PLACEHOLDER\' | translate}}\"> <span>{{secondText.title.length}}/50</span><div><label for=secondTextBody translate=WEBSITE_BODY_INPUT_LABEL></label><label class=error-text>&nbsp;*</label></div><textarea id=secondTextBody ng-model=secondText.body rows=5 maxlength=250 placeholder=\"{{\'WEBSITE_SECOND_TEXT_BODY_PLACEHOLDER\' | translate}}\"></textarea><span>{{secondText.body.length}}/250</span><p translate=WEBSITE_OPTIONAL_LINK_DESCRIPTION></p><div><label for=secondTextLabel translate=WEBSITE_LABEL_INPUT_LABEL></label></div><input type=text id=secondTextLabel ng-model=secondText.linkLabel maxlength=20 ng-focus=\"secondText.linkLabelError = false\"> <span>{{secondText.linkLabel.length}}/20</span><div><label for=secondTextLink translate=WEBSITE_LINK_INPUT_LABEL></label></div><input type=text id=secondTextLink ng-model=secondText.linkAddress ng-focus=\"secondText.linkAddressError = false\"><p ng-if=\"secondText.linkAddress.length !== 0 && !validateLink(secondText.linkAddress)\" class=error-text translate=INVALID_LINK_ERROR></p><p ng-if=secondText.linkAddressError class=error-text translate=WEBSITE_LINK_LABEL_ERROR></p><p ng-if=secondText.linkLabelError class=error-text translate=WEBSITE_LINK_ADDRESS_ERROR></p><p><button type=button class=\"btn btn-primary\" ng-disabled=\"isSectionSaveDisabled(secondText, settings.section2)\" ng-click=\"sectionSave(0, \'section2\', secondText)\" translate=SAVE_BTN></button></p></div><h3 translate=WEBSITE_LINKS_HEADER></h3><div class=content-box><p translate=WEBSITE_LINKS_DESCRIPTION></p><div class=links ng-if=\"links.length !== 0\"><ul><li ng-repeat=\"link in links\"><a ng-href={{link.href}} target=_blank>{{link.text}}</a> <span class=\"icons dripicons-trash\" ng-click=\"deleteLink(link, $index)\"></span></li></ul></div><div ng-if=\"links.length < 4\"><div><label for=linksTitle translate=WEBSITE_TITLE_INPUT_LABEL></label><label class=error-text>&nbsp;*</label></div><input type=text id=linksTitle maxlength=30 ng-model=link.text> <span>{{link.text.length}}/30</span><div><label for=linksURL translate=WEBSITE_URL_INPUT_LABEL></label><label class=error-text>&nbsp;*</label></div><input type=text id=linksURL ng-model=link.href><p ng-if=\"link.href.length !== 0 && !validateLink(link.href)\" class=error-text translate=INVALID_LINK_ERROR></p><p><button type=button class=\"btn btn-primary\" ng-disabled=disabledLink() ng-click=addLink() translate=ADD_BTN></button></p></div></div></div><button class=accordion ng-click=toggleSecondPanel()><span translate=WEBSITE_SECOND_PANEL_NAME></span> <span class=\"{{secondPanel ? \'dripicons-chevron-up\' : \'dripicons-chevron-down\'}} down-arrow\"></span></button><div class=panel ng-class=\"{active: secondPanel}\"><p translate=WEBSITE_EVENTS_DESCRIPTION_1></p><p translate=WEBSITE_EVENTS_DESCRIPTION_2></p><p translate=WEBSITE_EVENTS_DESCRIPTION_3></p><div class=content-box ng-repeat=\"e in events\" style=\"margin-bottom: 15px\"><div class=row id={{e.photo}}><div class=col-md-4><div class=cover-image><img ng-show=e.photoURL ng-src={{e.photoURL}}><br></div></div><div class=col-md-6><label translate=WEBSITE_EVENTS_DATE_LABEL></label><h4>{{e.title}}</h4><label translate=WEBSITE_TITLE_INPUT_LABEL></label><p>{{e.body}}</p><div><label ng-show=e.linkAddress translate=WEBSITE_EVENT_LINK></label></div><a ng-href={{e.linkAddress}} target=_blank>{{e.linkLabel}}</a></div><div class=col-md-2 style=float:right><button type=button class=\"btn btn-ghost\" ng-click=eventRemove($index) translate=DELETE_BTN></button></div></div></div><div ng-hide=\"events.length < 3\"><h3 translate=\"\"></h3><div class=content-box><label translate=WEBSITE_EVENT_ERROR></label></div></div><div ng-show=\"events.length < 3\"><h3 translate=WEBSITE_EVENT_ADD></h3><div class=content-box><div class=cover-image><img ng-show=event.photoURL ng-src={{event.photoURL}}><br><span class=\"icons dripicons-camera\"></span> <a ng-click=eventImageUpload() translate=WEBSITE_EVENTS_CHANGE_COVER></a></div><div><label for=eventDate translate=WEBSITE_EVENTS_DATE_LABEL></label><label class=error-text>&nbsp;*</label></div><input type=text id=eventDate ng-model=event.title maxlength=50 placeholder=\"{{\'WEBSITE_EVENTS_DATE_PLACEHOLDER\' | translate}}\"> <span>{{event.title.length}}/50</span><div><label for=eventTitle translate=WEBSITE_TITLE_INPUT_LABEL></label><label class=error-text>&nbsp;*</label></div><input type=text id=eventTitle ng-model=event.body maxlength=50 placeholder=\"{{\'WEBSITE_EVENTS_TITLE_PLACEHOLDER\' | translate}}\"> <span>{{event.body.length}}/50</span><p translate=WEBSITE_OPTIONAL_BUTTON_DESCRIPTION></p><div><label for=eventLabel translate=WEBSITE_LABEL_INPUT_LABEL></label></div><input type=text id=eventLabel ng-model=event.linkLabel maxlength=30 placeholder=\"{{\'WEBSITE_EVENTS_LINK_PLACEHOLDER\' | translate}}\" ng-focus=\"event.linkLabelError = false\"> <span>{{event.linkLabel.length}}/30</span><div><label for=eventLink translate=WEBSITE_EVENTS_LINK_LABEL></label></div><input type=text id=eventLink ng-model=event.linkAddress ng-focus=\"event.linkAddressError = false\"><p ng-if=\"event.linkAddress.length !== 0 && !validateLink(event.linkAddress)\" class=error-text translate=INVALID_LINK_ERROR></p><p ng-if=event.linkAddressError class=error-text translate=WEBSITE_LINK_LABEL_ERROR></p><p ng-if=event.linkLabelError class=error-text translate=WEBSITE_LINK_ADDRESS_ERROR></p><p><button type=button class=\"btn btn-primary\" ng-disabled=addEventDisabled() ng-click=eventSave() translate=SAVE_BTN></button></p></div></div></div><button class=accordion ng-click=toggleThirdPanel()><span translate=WEBSITE_THIRD_PANEL_NAME></span> <span class=\"{{thirdPanel ? \'dripicons-chevron-up\' : \'dripicons-chevron-down\'}} down-arrow\"></span></button><div class=panel ng-class=\"{active: thirdPanel}\"><p translate=WEBSITE_BRANDING_DESCRIPTION></p><h3 translate=WEBSITE_LOGO_TITLE></h3><div class=content-box><div class=row><div class=col-sm-2><div class=logo ng-show=\"logoType !== \'NO_LOGO\'\"><img ng-src={{logo}} width=45 height=45 alt=\"\"></div></div><div class=col-sm-10><div class=radio-container><input class=radio name=logo type=radio ng-model=logoType value=NO_LOGO> <span translate=WEBSITE_RADIO_NO_LOGO></span></div><div class=radio-container><input class=radio name=logo type=radio ng-disabled=!settings.defaultSchoolLogo ng-change=\"logo = settings.defaultSchoolLogo\" ng-model=logoType value=SCHOOL_LOGO> <span ng-class=\"{\'disabled\': !settings.defaultSchoolLogo}\" translate=WEBSITE_RADIO_SAME></span></div><div class=radio-container><input class=radio name=logo type=radio ng-change=\"logo = lastUploadedLogo.url || settings.defaultSchoolLogo\" ng-model=logoType value=PUBLIC_SCHOOL_LOGO> <span translate=WEBSITE_RADIO_DIFFERENT></span></div><div ng-show=\"logoType === \'PUBLIC_SCHOOL_LOGO\'\"><div class=cover-image><span class=\"icons dripicons-camera\"></span> <a ng-click=logoUpload() translate=WEBSITE_UPLOAD_PHOTO></a></div><div><span class=\"icons dripicons-information\"></span> <span translate=WEBSITE_UPLOAD_PHOTO_INFO_2></span></div></div></div></div><p><button type=button class=\"btn btn-primary\" ng-disabled=logoDisabled() ng-click=logoSave() translate=SAVE_BTN></button></p></div><h3 translate=WEBSITE_COVER_TITLE></h3><div class=content-box><div class=row><div class=col-sm-4><div class=cover-image ng-show=\"coverType !== \'NO_COVER\'\"><img ng-src={{coverURL}}></div></div><div class=col-sm-8><div class=radio-container><input class=radio name=photo type=radio ng-model=coverType value=NO_COVER> <span translate=WEBSITE_RADIO_NO_IMAGE></span></div><div class=radio-container><input class=radio name=photo type=radio ng-disabled=!settings.defaultSchoolCover ng-change=\"coverURL = settings.defaultSchoolCover\" ng-model=coverType value=SCHOOL_COVER> <span ng-class=\"{\'disabled\': !settings.defaultSchoolCover}\" translate=WEBSITE_RADIO_SAME></span></div><div class=radio-container><input class=radio name=photo type=radio ng-change=\"coverURL = lastUploadedCover.url || settings.defaultSchoolCover\" ng-model=coverType value=PUBLIC_SCHOOL_COVER> <span translate=WEBSITE_RADIO_DIFFERENT></span></div><div ng-show=\"coverType === \'PUBLIC_SCHOOL_COVER\'\"><div class=cover-image><span class=\"icons dripicons-camera\"></span> <a ng-click=coverUpload() translate=WEBSITE_UPLOAD_PHOTO></a></div><div><span class=\"icons dripicons-information\"></span> <span translate=WEBSITE_UPLOAD_PHOTO_INFO_1></span></div></div></div></div><p><button type=button class=\"btn btn-primary\" ng-disabled=coverDisabled() ng-click=coverSave() translate=SAVE_BTN></button></p></div><h3 translate=WEBSITE_ADDRESS_TITLE></h3><div class=content-box><div><span class=\"icons dripicons-location\"></span> <span>{{settings.address.plainAddress}}</span></div><p><button type=button class=\"btn btn-primary\" ng-click=editLocation()>Edit</button></p></div><h3 translate=WEBSITE_AMBASSADORS></h3><div class=content-box><div><span class=\"icons dripicons-information\"></span> <span translate=WEBSITE_AMBASSADORS_DESCRIPTION></span></div><div><label for=ambassadorsTitle translate=WEBSITE_TITLE_INPUT_LABEL></label><label class=error-text>&nbsp;*</label></div><input type=text id=ambassadorsTitle ng-model=ambassadorsTitle maxlength=50 placeholder=\"{{\'WEBSITE_AMBASSADORS_PLACEHOLDER\' | translate}}\"><div class=row><div class=\"col-sm-6 ambassadors\" ng-repeat=\"a in ambassadors\"><img ng-src={{a.avatar}} width=45 height=45><select ng-model=ambassadors[$index]><option value=\"\" translate=SELECT></option><option ng-repeat=\"ambassador in ambassadorList\" ng-value=ambassador ng-show=!isAmbassadorSelected(ambassador)>{{ ambassador.firstName }} {{ ambassador.lastName }} - {{ ambassador.label }} - {{ ambassador.role }}</option></select></div></div><p><button type=button class=\"btn btn-primary\" ng-disabled=disabledAmbassadors() ng-click=saveAmbassadors() translate=SAVE_BTN></button></p></div></div><button class=accordion ng-click=toggleFourthPanel()><span translate=WEBSITE_FOURTH_PANEL_NAME></span> <span class=\"{{fourthPanel ? \'dripicons-chevron-up\' : \'dripicons-chevron-down\'}} down-arrow\"></span></button><div class=panel ng-class=\"{active: fourthPanel}\"><p translate=WEBSITE_DOMAIN_DESCRIPTION_1></p><p><span translate=WEBSITE_DOMAIN_DESCRIPTION_2></span><ul><li translate=WEBSITE_DOMAIN_DESCRIPTION_3></li><li translate=WEBSITE_DOMAIN_DESCRIPTION_4></li></ul></p><div class=domain><div ng-show=domainEditing><span>https://web.classlist.com/ </span><input type=text ng-model=domain ng-change=checkDomain()> <button type=button class=\"btn btn-primary\" ng-disabled=disabledSaveDomain() ng-click=saveDomain() translate=SAVE_BTN></button></div><div ng-show=!domainEditing><span>https://web.classlist.com/{{domain}} </span><button type=button class=\"btn btn-ghost\" ng-click=editDomain() translate=EDIT_BTN></button></div></div><p ng-if=\"domain.length < 4 && domain.length > 0\" class=error-text translate=WEBSITE_DOMAIN_ERROR></p><div><span class=\"icons dripicons-information\"></span> <span translate=WEBSITE_DOMAIN_DESCRIPTION_5></span><ul><li translate=WEBSITE_DOMAIN_DESCRIPTION_6></li><li translate=WEBSITE_DOMAIN_DESCRIPTION_7></li><li translate=WEBSITE_DOMAIN_DESCRIPTION_8></li></ul></div></div><div class=publish><div><span class=\"icons dripicons-information\"></span> <span translate=WEBSITE_DOMAIN_DESCRIPTION_9></span><p class=error-text ng-bind-html=disabledPublishReason()></p></div><button type=button class=\"btn btn-ghost\" ng-disabled=disabledPublish() ng-click=beforePublish() translate=PUBLISH_BTN></button></div></div></div>");
$templateCache.put("app/website/views/wrapper.html","<div class=content-logged photo-upload><div ui-view></div></div>");}]);